(function() {
    'use strict';

    angular.module('vvs', ['ui.router', 'ui.bootstrap', 'ngLocale', 'ngSanitize', 'angular-loading-bar', 'ngMaterial']);
})();

(function() {
    'use strict';


    angular
        .module('vvs')
        .directive('vvsMoveLeg', vvsMoveLeg);

    vvsMoveLeg.$inject = [];

    function vvsMoveLeg() {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            templateUrl : 'app/vvs.components/trip/result/details/leg/transfer/moveleg/main.html',
            controller: function($scope, $attrs) {
                $scope.transferLegIndex = angular.copy($scope.$eval($attrs.transferLegIndex));
                $scope.transferLeg = angular.copy($scope.trip.legs()[$scope.transferLegIndex]);
            }
        };
    }

}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .controller('VVSMoveLegModalController', VVSMoveLegModalController);

    VVSMoveLegModalController.$inject = ['$rootScope', '$scope', '$state'];

    function VVSMoveLegModalController($rootScope, $scope, $state) {

        $scope.moveLeg = function(prev){
            var trip = angular.copy($scope.trip),
                legs = angular.copy(trip.legs()),
                transferLegIndex = angular.copy($scope.transferLegIndex),
                leg;

            if (prev) {
                leg = legs[transferLegIndex-1];
            } else {
                leg = legs[transferLegIndex+1];
            }

            $scope.journeyObj.service.moveLeg({
                'journey' : trip,
                'leg' : leg,
                'toPrevious' : prev
            }).then(function(res){
                if (res && res.length>0) {
                    $scope.updateTrip(angular.copy(res[0]));
                }
            });
        };

        $scope.revertMoveLeg = function(prev){
            var trip = angular.copy($scope.trip);

            var success = $scope.journeyObj.service.revertMoveLeg({
                    'journey' : trip
                });

            if (success && trip.previousJourney) {
                $scope.updateTrip(angular.copy(trip.previousJourney));
            }
        }


    }
}());

(function() {
    'use strict';
    angular
        .module('vvs')
        .controller('VVSModalsStopController', VVSModalsStopController);

    VVSModalsStopController.$inject = ['$scope', 'L', '$timeout', 'VVSConst',
        'mng-comm.MDVDownload', 'mng-comm.MDVDepartures', 'VVSPdfViewer'
    ];

    function VVSModalsStopController($scope, L, $timeout, VVSConst, MDVDownload, MDVDepartures, VVSPdfViewer) {
        $scope.departures = [];

        $scope.triggerSTTClick = function(lineId, stopId) {
            MDVDownload.search(MDVDownload.requestTypes.STOP_TIMETABLE, {
                    lineId: lineId,
                    stopId: stopId
                })
                .then(function(res) {
                    if (res.response) {
                        VVSPdfViewer.show(res.response);
                    }
                }).catch(function(err) {
                    console.log(err);
                });
        };

        $scope.openStopInformation = function(loc) {
           var coords = loc.parent().coord();
           var globalID = loc.parent().id();
           var link = 'https://livekarte.vvs.de/stops/'+globalID+'@'+coords[0]+','+coords[1]+','+'z18';
           window.open(link,'_blank');
        }

        $scope.triggerROPClick = function(stopId) {
            MDVDownload.search(MDVDownload.requestTypes.ROUTE_OPTION_PLAN, {
                    stopId: stopId
                })
                .then(function(res) {
                    if (res.response) {
                        VVSPdfViewer.show(res.response);
                    }
                }).catch(function(err) {
                    console.log(err);
                });
        };

        $scope.triggerDownloadSMClick = function(file) {
            VVSPdfViewer.show(file);
        };

        $scope.triggerDownloadSMMEClick = function(file) {
            VVSPdfViewer.show(file);
        };


        $scope.getDepartures = function(location) {
            var depService = new MDVDepartures();
            $scope.dmOptions = depService.getOptions();

            depService.updateLocation(location);
            $scope.dmOptions.dateTime.date = location.departureTime();
            $scope.dmOptions.dateTime.time = location.departureTime();
            depService.search().then(function() {
                $scope.departures = depService.getResults();
            });
        };
    }
}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .directive('vvsWalkingPathDescription', vvsWalkingPathDescription);

    vvsWalkingPathDescription.$inject = [];

    function vvsWalkingPathDescription() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                'pathdescription' : '='
            },
            templateUrl: 'app/vvs.components/trip/result/details/leg/it/pathdescription/main.html',
            controller: function($scope, VVSConst) {
                var descArr = $scope.pathdescription,
                    i;

                $scope.upVal = 0;
                $scope.downVal = 0;

                for(i=0; i<descArr.length; i++){
                    var descObj = descArr[i];
                    if((descObj.distanceUp > 0) || (descObj.dUp > 0)){
                        $scope.upVal = $scope.upVal + (descObj.distanceUp || descObj.dUp);
                        $scope.showDesc = true;
                    }

                    if((descObj.distanceDown > 0) || (descObj.dDown > 0)){
                        $scope.downVal = $scope.downVal + (descObj.distanceDown || descObj.dDown);
                        $scope.showDesc = true;
                    }
                }
            }
        };
    }

}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .controller('VVSTripResultDetailsLegTransferController', VVSTripResultDetailsLegTransferController);

    VVSTripResultDetailsLegTransferController.$inject = ['$scope', 'VVSConst'];

    function VVSTripResultDetailsLegTransferController($scope, VVSConst) {
        var self = this;

        $scope.getPreviousLeg = function() {
            var idx = angular.copy($scope.legIndex),
                trip = angular.copy($scope.trip),
                legs = angular.copy(trip.legs());

            if (idx === 0) {
                return null;
            }

            return legs[idx-1];
        };

        var previousLeg = $scope.getPreviousLeg();

        if (previousLeg && (previousLeg.origin().parent().id() === '5006056') && (previousLeg.destination().parent().id() === '5006056')) {
            $scope.isSpecialCase = true;
        }

        $scope.getNextLeg = function() {
            var idx = angular.copy($scope.legIndex),
                trip = angular.copy($scope.trip),
                legs = angular.copy(trip.legs());

            if (idx === (legs.length - 1)) {
                return null;
            }

            return legs[idx+1];
        };
    }
}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .controller('VVSTripResultDetailsLegPtController', VVSTripResultDetailsLegPtController);

    VVSTripResultDetailsLegPtController.$inject = ['$scope', 'VVSConst'];

    function VVSTripResultDetailsLegPtController($scope, VVSConst) {
        var self = this;

        $scope.isNextLegisTransfer = function(idx) {
            if (idx < $scope.trip.legs().length - 1) {
                return $scope.trip.legs()[idx+1].transportation().productIconId() === 99;
            }
            return false;
        }
        $scope.isNextLegisIT = function(idx) {
            var length = $scope.trip.legs().length;
            if (idx < length - 1) {
                return $scope.trip.legs()[idx+1].transportation().productIconId() === 99 || $scope.trip.legs()[idx+1].transportation().productIconId() === 100;
            }
            return false;
        }

        $scope.lastPTLeg = function(leg, idx) {
            var length = $scope.trip.legs().length;
            var mot = leg.transportation().productClass();
            var isNotIT = mot != '99' && mot !='100';
            if ((idx === length-2) &&  $scope.trip.legs()[length-1].transportation().productClass() == '100' && isNotIT) {
                return true;
            } else return false;
        }

        $scope.setTop = function(leg, idx) {
            if ($scope.SEARCH_OPTIONS.accessibility.stepFree && $scope.lastPTLeg(leg, idx) && leg.arrivalDelay() > 0) {
                return '4.5rem'
            }
            if ($scope.SEARCH_OPTIONS.accessibility.stepFree && $scope.lastPTLeg(leg, idx) && !leg.arrivalDelay() > 0) {
                return '2.6rem'
            }
            if ($scope.isNextLegisTransfer(idx)) {
                return '1.6rem';
            }
            return '1rem';
            // return '15px 0 0 3px';

        }

        $scope.setPadding = function(idx) {
            if (!$scope.isNextLegisIT(idx)) {
                return '15px 0 0 3px';
            }
            return '3px';

        }
        $scope.setMargin = function(idx) {
            if (!$scope.isNextLegisIT(idx)) {
                // return '10px';
                return '0';
            }
            return '0';
        }

        $scope.getPrevPreviousLeg = function() {
            // console.log('Object assign', Object.assign({}, $scope.trip) );
            var idx = $scope.legIndex,
            trip = $scope.trip,
            legs = trip.legs();
            // var idx = angular.copy($scope.legIndex),
            //     trip = angular.copy($scope.trip),
            //     legs = angular.copy(trip.legs());

            if (idx === 1) {
                return null;
            }

            return legs[idx-2];
        };

        $scope.getPreviousLeg = function() {
            var idx = $scope.legIndex,
                trip = $scope.trip,
                legs = trip.legs();

            // var idx = angular.copy($scope.legIndex),
            //     trip = angular.copy($scope.trip),
            //     legs = angular.copy(trip.legs());

            if (idx === 0) {
                return null;
            }

            return legs[idx-1];
        };

        var previousLeg = $scope.getPreviousLeg();

        if (previousLeg && (previousLeg.origin().parent().id() === '5006056') && (previousLeg.destination().parent().id() === '5006056')) {
            $scope.isSpecialCase = true;
        }

        $scope.getNextLeg = function() {
            var idx = $scope.legIndex,
            trip = $scope.trip,
            legs = trip.legs();
            // var idx = angular.copy($scope.legIndex),
            //     trip = angular.copy($scope.trip),
            //     legs = angular.copy(trip.legs());

            if (idx === (legs.length - 1)) {
                return null;
            }

            return legs[idx+1];
        };

        $scope.getNextNextLeg = function() {
            var idx = angular.copy($scope.legIndex),
                trip = angular.copy($scope.trip),
                legs = angular.copy(trip.legs());

            if (idx === (legs.length - 2)) {
                return null;
            }

            return legs[idx+2];
        };

        $scope.getNextNextLeg = function() {
            var idx = angular.copy($scope.legIndex),
                trip = angular.copy($scope.trip),
                legs = angular.copy(trip.legs());

            if (idx === (legs.length - 2)) {
                return null;
            }

            return legs[idx+2];
        };
    }
}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .directive('vvsTripResultLegLocation', vvsTripResultLegLocation);

    vvsTripResultLegLocation.$inject = [];

    function vvsTripResultLegLocation() {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            template: '<ng-include src="getTemplateUrl()"/>',
            controller: function($scope, $element, $attrs, VVSConst) {
                var baseUrlPrefix = VVSConst.baseUrl ? VVSConst.baseUrl : '';

                $scope.usage = angular.copy($attrs.usage);

                $scope.getTemplateUrl = function() {
                    $scope.location = ($attrs.usage === 'orig')?$scope.leg.origin():$scope.leg.destination();

                    if (($scope.location.type() === "stop") || ($scope.location.type() === "platform")){
                        return baseUrlPrefix.concat('trip/result/details/leg/location/stop/main.html');
                    } else {
                        return baseUrlPrefix.concat('trip/result/details/leg/location/address/main.html');
                    }
                };
            }
        };
    }

}());

(function() {
    'use strict';
    angular
        .module('vvs')
        .controller('VVSModalsLineController', VVSModalsLineController);

    VVSModalsLineController.$inject = ['$scope', 'mng-comm.MDVStopSeqRequester'];

    function VVSModalsLineController($scope, MDVStopSeqRequester) {

    }
}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .controller('VVSTripResultDetailsLegItController', VVSTripResultDetailsLegItController);

    VVSTripResultDetailsLegItController.$inject = ['$scope', 'VVSConst'];

    function VVSTripResultDetailsLegItController($scope, VVSConst) {

        $scope.getPreviousLeg = function() {
            // var idx = angular.copy($scope.legIndex),
            //     trip = angular.copy($scope.trip),
            //     legs = angular.copy(trip.legs());
            var idx = $scope.legIndex,
            trip = $scope.trip,
            legs = trip.legs();

            if (idx === 0) {
                return null;
            }

            return legs[idx-1];
        };

        var previousLeg = $scope.getPreviousLeg();

        if (previousLeg && (previousLeg.origin().parent().id() === '5006056') && (previousLeg.destination().parent().id() === '5006056')) {
            $scope.isSpecialCase = true;
        }

        $scope.getNextLeg = function() {
            // var idx = angular.copy($scope.legIndex),
            //     trip = angular.copy($scope.trip),
            //     legs = angular.copy(trip.legs());
            var idx = $scope.legIndex,
            trip = $scope.trip,
            legs = trip.legs();

            if (idx === (legs.length - 1)) {
                return null;
            }

            return legs[idx+1];
        };

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSTripResultDetailsPaginationController', VVSTripResultDetailsPaginationController);

    VVSTripResultDetailsPaginationController.$inject = ['$scope', '$state', '$stateParams'];

    function VVSTripResultDetailsPaginationController($scope, $state, $stateParams) {
        $scope.nextTrip = function(){
            var isFirst = false,
                isLast = false,
                index = 0;

            if($stateParams.isFirst){
                isFirst = false;
                isLast = false;
                index = 0;
            }else if($stateParams.isLast){
                index = 0;
                isFirst = true;
                isLast = false;
            }else if($stateParams.index === ($scope.journeyObj.service.getResults().length-1)){
                if ($scope.journeyObj.lastJourneys && $scope.journeyObj.lastJourneys.length>0) {
                    index = 0;
                    isFirst = false;
                    isLast = true;
                } else if ($scope.journeyObj.firstJourneys && $scope.journeyObj.firstJourneys.length>0){
                    index = 0;
                    isFirst = true;
                    isLast = false;
                } else {
                    index = 0;
                    isFirst = false;
                    isLast = false;
                }
            }else{
                isFirst = false;
                isLast = false;
                index = $stateParams.index + 1;
            }
            $state.go('vvs.trip.details', {'index': index, 'isFirst': isFirst, 'isLast': isLast}, {notify: true});
        };

        $scope.previousTrip = function(){
            var isFirst = false,
                isLast = false,
                index = 0;

            if($stateParams.isFirst){
                isFirst = false;
                isLast = true;
                index = 0;
            }else if($stateParams.isLast){
                index = $scope.journeyObj.service.getResults().length-1;
                isFirst = false;
                isLast = false;
            }else if($stateParams.index === 0){
                if ($scope.journeyObj.firstJourneys && $scope.journeyObj.firstJourneys.length>0){
                    index = 0;
                    isFirst = true;
                    isLast = false;
                } else if ($scope.journeyObj.lastJourneys && $scope.journeyObj.lastJourneys.length>0) {
                    index = 0;
                    isFirst = false;
                    isLast = true;
                } else {
                    index = $scope.journeyObj.service.getResults().length-1;
                    isFirst = false;
                    isLast = false;
                }
            }else{
                isFirst = false;
                isLast = false;
                index = $stateParams.index - 1;
            }
            $state.go('vvs.trip.details', {'index': index, 'isFirst': isFirst, 'isLast': isLast}, {notify: true});
        };
    }
}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .directive('vvsTripDetailsLeg', vvsTripDetailsLeg);

    vvsTripDetailsLeg.$inject = [];

    function vvsTripDetailsLeg() {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            template: '<ng-include src="getTemplateUrl()"/>',
            controller: function($scope, $attrs, VVSConst) {
                var baseUrlPrefix = VVSConst.baseUrl ? VVSConst.baseUrl : '';

                $scope.legIndex = angular.copy($scope.$eval($attrs.legIndex));
                $scope.isFirstLeg = angular.copy($scope.$eval($attrs.isFirstLeg));
                $scope.isLastLeg = angular.copy($scope.$eval($attrs.isLastLeg));
                $scope.isSpecialCase = false;

                $scope.getTemplateUrl = function() {
                    if ($scope.leg.transportation().productClass() < 97) {
                        return baseUrlPrefix.concat('trip/result/details/leg/pt/main.html');
                    } else if (($scope.leg.transportation().productClass() > 96) && ($scope.leg.transportation().productClass() < 100)) {
                        if ($scope.leg.transportation().productClass() === 99) {
                            if (($scope.leg.origin().parent().id() === '5006056') && ($scope.leg.destination().parent().id() === '5006056')) {
                                $scope.isSpecialCase = true;
                            }
                        }
                        return baseUrlPrefix.concat('trip/result/details/leg/transfer/main.html');
                    } else if ($scope.leg.transportation().productClass() > 99) {
                        return baseUrlPrefix.concat('trip/result/details/leg/it/main.html');
                    }
                };
            }
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSTripResultDetailsButtonsController', VVSTripResultDetailsButtonsController);

    VVSTripResultDetailsButtonsController.$inject = ['$scope', '$state', '$location', '$window',
        '$translate', '$browser', 'VVSDeepLinking', 'mng-common.MDVAddToIcsCalendar', 'mng-comm.MDVDownload', 'VVSPdfViewer'];

    function VVSTripResultDetailsButtonsController($scope, $state, $location, $window,
        $translate, $browser, VVSDeepLinking, MDVAddToIcsCalendar, MDVDownload, VVSPdfViewer) {


        function getMailUrl() {
            var fullUrl = $location.absUrl(),
                deeplink = VVSDeepLinking.getDeepLink();

            fullUrl = fullUrl.substring(0, fullUrl.indexOf('deeplink')+9);
            fullUrl += deeplink;

            fullUrl = fullUrl.replace(/&/g, '%26');
            fullUrl = fullUrl.replace(/#/g, '%23');
            fullUrl = fullUrl.replace(/\//g, '%2F');
            fullUrl = fullUrl.replace(/ /g, '%20');
            fullUrl = fullUrl.replace(/"/g, '**');

            return 'mailto:?subject=Empfohlene Fahrt&body='+fullUrl;
        }
        $scope.mailToUrl = getMailUrl();

        $scope.triggerAddToIcsCalendarClick = function(trip) {
            MDVAddToIcsCalendar.add(trip, 'www.vvs.de');
        };

        $scope.triggerCreateJourneyPdf = function(trip) {
            MDVDownload.search(MDVDownload.requestTypes.PRINT_TRIP,
                {
                    journeys : [trip],
                    efaParams : {
                        design : 'detail',
                        useUnifiedTickets : '1',
                        fontSizeNormal : '0',
                        serverInfo : '1'
                    }
                })
                .then(function(res) {
                    if (res.response) {
                        VVSPdfViewer.show(res.response);
                    }
                });
        };

        $scope.triggerReturnClick = function(trip) {
            var tmp = angular.copy($scope.inputLocations.orig);

            $scope.inputLocations.orig = angular.copy($scope.inputLocations.dest);
            $scope.inputLocations.dest = angular.copy(tmp);

            $scope.SEARCH_OPTIONS.dateTime.date = trip.arrivalTime().toDate();
            $scope.SEARCH_OPTIONS.dateTime.time = trip.arrivalTime().add('minutes', 1);

            $state.go('vvs.trip.init');
        };
    }
}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsTripOptionsSettingsStatus', vvsTripOptionsSettingsStatus);

    vvsTripOptionsSettingsStatus.$inject = ['$translate'];

    function vvsTripOptionsSettingsStatus($translate) {
        return {
            restrict : 'E',
            replace : true,
            scope : true,
            templateUrl : 'app/vvs.components/trip/options/settings/status/main.html',
            link : function($scope, elem, attrs) {
                $scope.isChanged = false;
                $scope.$watch('SEARCH_OPTIONS', function(newVal, oldVal) {
                    $scope.isChanged = false;
                    if ($scope.DEFAULT_SEARCH_OPTIONS.accessibility.showAccessibility !== $scope.SEARCH_OPTIONS.accessibility.showAccessibility) {
                        $scope.isChanged = true;
                    }
                    if ($scope.DEFAULT_SEARCH_OPTIONS.accessibility.visuallyImpaired !== $scope.SEARCH_OPTIONS.accessibility.visuallyImpaired) {
                        $scope.isChanged = true;
                    }

                    if ($scope.DEFAULT_SEARCH_OPTIONS.accessibility.stepFree !== $scope.SEARCH_OPTIONS.accessibility.stepFree) {
                        $scope.isChanged = true;
                    }
                    if ($scope.DEFAULT_SEARCH_OPTIONS.accessibility.accessibleVehiclesOnly !== $scope.SEARCH_OPTIONS.accessibility.accessibleVehiclesOnly) {
                        $scope.isChanged = true;
                    }

                    if ($scope.DEFAULT_SEARCH_OPTIONS.publicTransport.routingOptimization !== $scope.SEARCH_OPTIONS.publicTransport.routingOptimization) {
                        $scope.isChanged = true;
                    }
                    if ($scope.DEFAULT_SEARCH_OPTIONS.publicTransport.bikeTakeAlong !== $scope.SEARCH_OPTIONS.publicTransport.bikeTakeAlong) {
                        $scope.isChanged = true;
                    }
                    if ($scope.DEFAULT_SEARCH_OPTIONS.individualTransport.to.walkSpeed !== $scope.SEARCH_OPTIONS.individualTransport.to.walkSpeed) {
                        $scope.isChanged = true;
                    }
                    if ($scope.DEFAULT_SEARCH_OPTIONS.individualTransport.to.minutes !== $scope.SEARCH_OPTIONS.individualTransport.to.minutes) {
                        $scope.isChanged = true;
                    }
                    if ($scope.DEFAULT_SEARCH_OPTIONS.individualTransport.from.minutes !== $scope.SEARCH_OPTIONS.individualTransport.from.minutes) {
                        $scope.isChanged = true;
                    }
                    if ($scope.DEFAULT_SEARCH_OPTIONS.individualTransport.to.avoidElevation !== $scope.SEARCH_OPTIONS.individualTransport.to.avoidElevation) {
                        $scope.isChanged = true;
                    }
                    if ($scope.DEFAULT_SEARCH_OPTIONS.pdfOutput.elevationProfile !== $scope.SEARCH_OPTIONS.pdfOutput.elevationProfile) {
                        $scope.isChanged = true;
                    }
                    if ($scope.DEFAULT_SEARCH_OPTIONS.fare.avoidZones.length !== $scope.SEARCH_OPTIONS.fare.avoidZones.length) {
                        $scope.isChanged = true;
                    }

                    if ($scope.isChanged) {
                        $translate('angepasst').then(function(translation) {
                            $scope.changeSettingText = translation;
                        });
                    } else {
                        $translate('Standard').then(function(translation) {
                            $scope.changeSettingText = translation;
                        });
                    }

                }, true);
            }
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsTripOptionsSettingsDescription', vvsTripOptionsSettingsDescription);

    function vvsTripOptionsSettingsDescription(VVSConst) {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            templateUrl: 'app/vvs.components/trip/options/settings/description/main.html',
            link: function($scope){
                $scope.tariffZones = VVSConst.tariffZones || [];
            }
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsTripOptionsMeansOfTransportStatus', vvsTripOptionsMeansOfTransportStatus);

    vvsTripOptionsMeansOfTransportStatus.$inject = ['$translate'];

    function vvsTripOptionsMeansOfTransportStatus($translate) {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            templateUrl: 'app/vvs.components/trip/options/means-of-transport/status/main.html',
            link: function($scope, elem, attrs){
                $scope.isChanged = false;
                $scope.$watch('SEARCH_OPTIONS', function(newVal, oldVal){
                    $scope.isChanged = false;
                    for (var key in $scope.DEFAULT_SEARCH_OPTIONS.productRestrictions) {
                        if ($scope.DEFAULT_SEARCH_OPTIONS.productRestrictions.hasOwnProperty(key)) {
                            if ($scope.DEFAULT_SEARCH_OPTIONS.productRestrictions[key] !== $scope.SEARCH_OPTIONS.productRestrictions[key]) {
                                $scope.isChanged = true;
                                break;
                            }
                        }
                    }
                    if ($scope.isChanged) {
                        $translate('angepasst').then(function(translation){
                            $scope.changeMOTText = translation;
                        });
                    } else {
                        $translate('Standard').then(function(translation){
                            $scope.changeMOTText = translation;
                        });
                    }
                }, true);
            }
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsTripOptionsMeansOfTransportDescription', vvsTripOptionsMeansOfTransportDescription);

    function vvsTripOptionsMeansOfTransportDescription() {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            templateUrl: 'app/vvs.components/trip/options/means-of-transport/description/main.html'
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSTTBStopsLinesController', VVSTTBStopsLinesController);

    VVSTTBStopsLinesController.$inject = ['$scope', '$state', 'mng-comm.MDVDownload',
        'mng-comm.MDVTransportationRequester', 'VVSPdfViewer'];

    function VVSTTBStopsLinesController($scope, $state, MDVDownload,
        MDVTransportationRequester, VVSPdfViewer) {

        var self = this,
            _private = {};

        _private.initController = function() {
            console.log('VVSTTBStopsLinesController');
            var loc = angular.copy($scope.inputLocations.ttb),
                options = {
                    type : 'TTB',
                    efaParams : {
                        mergeDir : 1,
                        deleteAssignedStops : 1
                    }
                };

            if (!loc) {
                console.log('NOT LOC');
                $state.go('vvs.ttb.init');
                return;
            }

            MDVTransportationRequester.search(loc, options)
                .then(function(res) {
                    self.lineSelections = res.response;
                });
        };

        _private.initController();

        self.triggerFireTTBDownloadClick = function(line) {
            MDVDownload.search(MDVDownload.requestTypes.TIMETABLE, {
                lineId : line.id()
            }).then(function(res) {
                if (res.response) {
                    VVSPdfViewer.show(res.response);
                }
            });
        };

        self.triggerTTBResetClick = function() {
            $state.go('vvs.ttb.init', {lfp: 'false'}, {
                reload : true
            });
        };


    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsTripResultSummaryOptionsStatus', vvsTripResultSummaryOptionsStatus);

    vvsTripResultSummaryOptionsStatus.$inject = [];

    function vvsTripResultSummaryOptionsStatus() {
        return {
            restrict: 'E',
            template: ' <a href="javascript:void()" vvs-scroll-to-element element="vvs_trip_settings" ng-if="isChanged" class="modified">{{"angepasst"|translate}}</a><a href="javascript:void()" vvs-scroll-to-element element="vvs_trip_settings" ng-if="!isChanged" class="standard">{{"Standard"|translate}}</a>',
            link: function($scope, elem, attrs){
                for (var key in $scope.DEFAULT_SEARCH_OPTIONS.productRestrictions) {
                    if ($scope.DEFAULT_SEARCH_OPTIONS.productRestrictions.hasOwnProperty(key)) {
                        if ($scope.DEFAULT_SEARCH_OPTIONS.productRestrictions[key] !== $scope.SEARCH_OPTIONS.productRestrictions[key]) {
                            $scope.isChanged = true;
                            break;
                        }
                    }
                }

                if ($scope.DEFAULT_SEARCH_OPTIONS.accessibility.showAccessibility !== $scope.SEARCH_OPTIONS.accessibility.showAccessibility) {
                    $scope.isChanged = true;
                }
                if ($scope.DEFAULT_SEARCH_OPTIONS.accessibility.stepFree !== $scope.SEARCH_OPTIONS.accessibility.stepFree) {
                    $scope.isChanged = true;
                }
                if ($scope.DEFAULT_SEARCH_OPTIONS.accessibility.visuallyImpaired !== $scope.SEARCH_OPTIONS.accessibility.visuallyImpaired) {
                    $scope.isChanged = true;
                }
                if ($scope.DEFAULT_SEARCH_OPTIONS.accessibility.accessibleVehiclesOnly !== $scope.SEARCH_OPTIONS.accessibility.accessibleVehiclesOnly) {
                    $scope.isChanged = true;
                }
                if ($scope.DEFAULT_SEARCH_OPTIONS.accessibility.strictMode !== $scope.SEARCH_OPTIONS.accessibility.strictMode) {
                    $scope.isChanged = true;
                }
                if ($scope.DEFAULT_SEARCH_OPTIONS.publicTransport.routingOptimization !== $scope.SEARCH_OPTIONS.publicTransport.routingOptimization) {
                    $scope.isChanged = true;
                }
                if ($scope.DEFAULT_SEARCH_OPTIONS.publicTransport.bikeTakeAlong !== $scope.SEARCH_OPTIONS.publicTransport.bikeTakeAlong) {
                    $scope.isChanged = true;
                }
                if ($scope.DEFAULT_SEARCH_OPTIONS.individualTransport.to.walkSpeed !== $scope.SEARCH_OPTIONS.individualTransport.to.walkSpeed) {
                    $scope.isChanged = true;
                }
                if ($scope.DEFAULT_SEARCH_OPTIONS.individualTransport.to.minutes !== $scope.SEARCH_OPTIONS.individualTransport.to.minutes) {
                    $scope.isChanged = true;
                }
                if ($scope.DEFAULT_SEARCH_OPTIONS.individualTransport.from.minutes !== $scope.SEARCH_OPTIONS.individualTransport.from.minutes) {
                    $scope.isChanged = true;
                }
                if ($scope.DEFAULT_SEARCH_OPTIONS.individualTransport.to.avoidElevation !== $scope.SEARCH_OPTIONS.individualTransport.to.avoidElevation) {
                    $scope.isChanged = true;
                }
                if ($scope.DEFAULT_SEARCH_OPTIONS.pdfOutput.elevationProfile !== $scope.SEARCH_OPTIONS.pdfOutput.elevationProfile) {
                    $scope.isChanged = true;
                }
                if ($scope.DEFAULT_SEARCH_OPTIONS.fare.avoidZones.length !== $scope.SEARCH_OPTIONS.fare.avoidZones.length) {
                    $scope.isChanged = true;
                }

            }
        };
    }


}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .controller('VVSTripResultSummaryController', VVSTripResultSummaryController);

    VVSTripResultSummaryController.$inject = ['$scope', '$state', '$rootScope', 'mng-favorite.MDVOptionsFavorite'];

    function VVSTripResultSummaryController($scope, $state, $rootScope, MDVOptionsFavorite) {

        $scope.currentDate = new Date().toISOString();
        $scope.paramDate = $scope.SEARCH_OPTIONS.dateTime.date;
        $scope.date = $scope.currentDate;
        // $scope.date = ($scope.paramDate.isValid() && $scope.paramDate !== 'now') ? $scope.paramDate : $scope.currentDate;
        if ($scope.paramDate !== 'now') { // jetzt
            if ($scope.paramDate.isValid) {
                if ($scope.paramDate.isValid()) {
                    $scope.date = $scope.paramDate;
                }
            }
            else {
                $scope.date = $scope.currentDate;
            }
        }

        // click on 'change'
        $scope.triggerChangeTripRequestClick = function() {
            $state.go('vvs.trip.init');
        };

        $scope.triggerResetTripRequestClick = function() {
            var opts = {
                dropDB : true
            };
            MDVOptionsFavorite.remove(null, opts).then(function() {
                if ($rootScope.journeyObj && $rootScope.journeyObj.service) {
                    $rootScope.journeyObj.service.resetOptions();
                }
            });
            $state.go('vvs.trip.init', {}, {reload: true});
        };

        // click on 'refresh' with old time
        $scope.triggerRefreshWithSameTimeClick = function() {
            $scope.tripCtrl.triggerFireSearchClick();
        };

        // click on 'refresh' with current time
        $scope.triggerRefreshWithCurrentTimeClick = function() {
            $scope.SEARCH_OPTIONS.dateTime.date = moment().toDate();
            $scope.SEARCH_OPTIONS.dateTime.time = moment().toDate();
            $scope.tripCtrl.triggerFireSearchClick();
        };


        // click on 'echtzeit'
        $scope.triggerToggleRealTimeSearch = function() {
            $scope.SEARCH_OPTIONS.dateTime.useRealTime = !$scope.SEARCH_OPTIONS.dateTime.useRealTime;
            $scope.tripCtrl.triggerFireSearchClick();
        };


    }



}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSTripResultSettingsController', VVSTripResultSettingsController);

    VVSTripResultSettingsController.$inject = ['$scope', '$translate'];

    function VVSTripResultSettingsController($scope, $translate) {
    }


}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .controller('VVSTripResultPrintController', VVSTripResultPrintController);

    VVSTripResultPrintController.$inject = ['$scope', '$stateParams', '$state', '$window', 'mng-comm.MDVDownload', 'VVSPdfViewer'];

    function VVSTripResultPrintController($scope, $stateParams, $state, $window, MDVDownload, VVSPdfViewer) {

        if (!$stateParams.trips || ($stateParams.trips.length===0) || !$stateParams.SEARCH_OPTIONS) {
            $state.go('vvs.trip.init');
            return false;
        }


        function initData(){
            $scope.trips = $stateParams.trips;
            $scope.SEARCH_OPTIONS = $stateParams.SEARCH_OPTIONS;
            $scope.orig = ($scope.trips[0]).origin();
            $scope.dest = ($scope.trips[0]).destination();
            $scope.tripPrintSwitchers = initPrintSwitcher($scope.trips);
            $scope.allPrintSwitcher = true;
            $scope.printType = "overview";
        }

        initData();

        function initPrintSwitcher(trips) {
            var res = [];

            for (var i=0; i<trips.length; i++) {
                res.push(true);
            }
            return res;
        }

        $scope.triggerFirePrintTripsClick = function(){
            $window.print();
        };

        $scope.triggerDownloadClick = function() {
            var journeys = [];
            for (var i=0; i<$scope.tripPrintSwitchers.length; i++) {
                if ($scope.tripPrintSwitchers[i]) {
                    journeys.push($scope.trips[i]);
                }
            }

            MDVDownload.search(MDVDownload.requestTypes.PRINT_TRIP, {
                    journeys : journeys,
                    efaParams : {
                        design : $scope.printType,
                        useUnifiedTickets : '1',
                        fontSizeNormal: '0',
                        serverInfo : '1'
                    }
                })
                .then(function(res) {
                    if (res.response) {
                        VVSPdfViewer.show(res.response);
                    }
                });
        };

        $scope.switchAllPrintSwitcher = function(val){
            for(var i=0; i<$scope.tripPrintSwitchers.length; i++){
                $scope.tripPrintSwitchers[i] = val;
            }
        };

        $scope.switchTripPrint = function() {
            for(var i=0; i<$scope.tripPrintSwitchers.length; i++){
                if(!$scope.tripPrintSwitchers[i]){
                    $scope.allPrintSwitcher = false;
                    return;
                }
            }
            $scope.allPrintSwitcher = true;
        };

    }

}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .controller('VVSTripResultListController', VVSTripResultListController);

    VVSTripResultListController.$inject = ['$scope'];

    function VVSTripResultListController($scope) {
        $scope.triggerShowFirstAndLastTripClick = function() {
            // search for first journey
            $scope.journeyObj.service.first().then(function() {
                $scope.journeyObj.firstJourneys = [$scope.journeyObj.service.getFirst()];
            });


            // search for last journey
            $scope.journeyObj.service.last().then(function() {
                $scope.journeyObj.lastJourneys = [$scope.journeyObj.service.getLast()];
            });

        };
    }


    angular
        .module('vvs')
        .controller('VVSTripResultListItemController', VVSTripResultListItemController);

    VVSTripResultListItemController.$inject = ['$scope', '$filter'];

    function VVSTripResultListItemController($scope, $filter) {

        $scope.showNewDateInfo = function() {
            if($scope.$index===0){
                var depDate = $filter('VVSDateFormatter')($scope.trip.departureTime()),
                    sDate = $filter('VVSDateFormatter')(new Date());

                if(depDate !== sDate) {
                    return true;
                }
            } else {
                var depDate = $filter('VVSDateFormatter')($scope.trip.departureTime()),
                    prevDepDate = $filter('VVSDateFormatter')(($scope.journeyObj.service.getResults()[$scope.$index-1]).departureTime());

                if(depDate !== prevDepDate){
                    return true;
                }

            }
            return false;
        }
    }



}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsOcc', vvsOcc);

    vvsOcc.$inject = [];

    function vvsOcc() {
        return {
            restrict : 'E',
            replace : true,
            scope : {
                trip: '=',
                leg: '=',
                dm: '=',
                perlschnur: '='
            },
            templateUrl : 'app/vvs.components/trip/result/list/occ.html',
            controller: function($scope) {
                $scope.occ = '';
                var occupancyHierachy = ['MANY_SEATS', 'FEW_SEATS', 'STANDING_ONLY', 'FULL'];

                if ($scope.trip) {
                    var legs = $scope.trip.legs();
                    legs.map(function(leg) {
                        if (leg.origin().properties().occupancy && occupancyHierachy.includes(leg.origin().properties().occupancy)) {
                            var highestIndex;
                            var occ = leg.origin().properties().occupancy;
                            var findIndex = occupancyHierachy.indexOf(occ);
                            highestIndex = findIndex;
                            if (findIndex > highestIndex) {
                                highestIndex = findIndex;
                                $scope.occ = occupancyHierachy[highestIndex];
                            } else $scope.occ = occupancyHierachy[findIndex];
                        }
                    });
                }
                if ($scope.leg) {
                    if ($scope.leg.origin().properties().occupancy && occupancyHierachy.includes($scope.leg.origin().properties().occupancy)) {
                        $scope.occ = $scope.leg.origin().properties().occupancy;
                    }
                }
                if ($scope.dm) {
                    if ($scope.dm.occupancy && occupancyHierachy.includes($scope.dm.occupancy)) {
                        $scope.occ = $scope.dm.occupancy;
                    }
                }
                if ($scope.perlschnur) {
                    if ($scope.perlschnur.properties().occ && occupancyHierachy.includes($scope.perlschnur.properties().occ)) {
                        $scope.occ = $scope.perlschnur.properties().occ;
                    }
                }
                $scope.occupancyLow = ($scope.occ ===  'MANY_SEATS');
                $scope.occupancyMedium = ($scope.occ ===  'FEW_SEATS');
                $scope.occupancyHigh = ($scope.occ ===  'STANDING_ONLY');
            }
        };
    }
}());




(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsGraphicLeg', vvsGraphicLeg);

    vvsGraphicLeg.$inject = ['$compile', 'VVSConst'];

    function vvsGraphicLeg($compile, VVSConst) {
        var ptGraphicTemplate = '<vvs-graphic-pt-leg></vvs-graphic-pt-leg>',
            itGraphicTemplate = '<vvs-graphic-it-leg></vvs-graphic-it-leg>',
            html;
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            link: function(scope, elem, attrs) {
                if (attrs.motKey < 97) {
                    html = $compile(ptGraphicTemplate)(scope);
                } else if (attrs.motKey > 99){
                    html = $compile(itGraphicTemplate)(scope);
                }
                elem.append(html);
            }
        }
    }


    angular
        .module('vvs')
        .directive('vvsGraphicPtLeg', vvsGraphicPtLeg);

    vvsGraphicPtLeg.$inject = ['VVSConst'];

    function vvsGraphicPtLeg(VVSConst) {
        var iconProductIconIdMapper = VVSConst.iconProductIconIdMapper,
            baseUrlPrefix = VVSConst.baseUrl ? VVSConst.baseUrl : '';
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            templateUrl: 'app/vvs.components/trip/result/graph/pt-leg.html',
            link: function(scope, elem, attrs) {
                scope.iconName = iconProductIconIdMapper[scope.leg.transportation().productIconId()];
            }
        };
    }


    angular
        .module('vvs')
        .directive('vvsGraphicItLeg', vvsGraphicItLeg);

    function vvsGraphicItLeg(VVSConst) {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            templateUrl: 'app/vvs.components/trip/result/graph/it-leg.html'
        };
    }
}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .controller('VVSTripGraphicController', VVSTripGraphicController);

    VVSTripGraphicController.$inject = ['$scope'];

    function VVSTripGraphicController($scope) {

        // return the margin top of a graphic trip
        $scope.getGraphicTripMargin = function(idx, trips) {
            var maxMargin = 184;

            var defaultTop = 46,
                // get the departureTime of the first trip as t0
                t0 = trips[0].departureTime(),
                // get the departureTime of the trip
                tx = trips[idx].departureTime(),
                txDiff = tx.diff(t0, 'seconds'),
                tLast = trips[trips.length - 1].departureTime(),
                tLastDiff = tLast.diff(t0, 'seconds'),
                i, l;

            /*for (i = 0, l = trips.length; i < l; i += 1) {
                tDiffTotal += trips[i].departureTime().diff(t0, 'seconds');
            }*/

            var factor = ((maxMargin * txDiff) / tLastDiff) + defaultTop;

            return (factor) + 'px';
        }

        // return the className that defines the legs height
        $scope.getDurationClass = function(leg, trip) {
            var classNames = {
                    MIN: "min",
                    MED: "med",
                    MAX: "max"
                },
                legDuration = (leg.totalDuration() * 100) / trip.duration();

            if ((trip.legs().length === 1) || (trip.duration() <= 0)) {
                return classNames.MED;
            }

            if (legDuration < 20) {
                return classNames.MIN;
            } else if (legDuration < 40) {
                return classNames.MED;
            }
            return classNames.MAX;

        }
    }


    angular
        .module('vvs')
        .controller('VVSTripResultGraphItemController', VVSTripResultGraphItemController);

    VVSTripResultGraphItemController.$inject = ['$scope', '$filter'];

    function VVSTripResultGraphItemController($scope, $filter) {
        $scope.showNewDateInfo = function() {
            var depDate = $filter('VVSDateFormatter')($scope.trip.departureTime()),
                    sDate = $filter('VVSDateFormatter')(new Date());

            if(depDate !== sDate) {
                return true;
            }

            return false;
        };

        $scope.showBottomTripStop = function(idx) {
            var leg = $scope.trip.legs()[idx],
                nextLeg = ($scope.trip.legs().length>(idx+1))?$scope.trip.legs()[idx+1]:null;

            if(nextLeg) {
                if (nextLeg.transportation().productClass() > 99) {
                    return true;
                }
            }else{
                return true;
            }

            return false;
        };

    }

}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .controller('VVSTripDetailsController', VVSTripDetailsController);

    VVSTripDetailsController.$inject = ['$scope', '$state', '$stateParams', '$filter', 'mng-common.MDVAddToIcsCalendar', 'mng-comm.MDVDownload'];

    function VVSTripDetailsController($scope, $state, $stateParams, $filter, MDVAddToIcsCalendar, MDVDownload) {
        if (($scope.journeyObj.service.getResults().length === 0) || (!$scope.SEARCH_OPTIONS)) {
            $state.go('vvs.trip.init');
            return false;
        }

        function initData(){
            $scope.isFirst = $stateParams.isFirst;
            $scope.isLast = $stateParams.isLast;
            $scope.isMiddle = !($scope.isFirst) && !($scope.isLast);
            $scope.tripIndex = $stateParams.index || 0;

            if($scope.isFirst && $scope.journeyObj.firstJourneys && $scope.journeyObj.firstJourneys.length>0){
                $scope.trip = $scope.journeyObj.firstJourneys[0];
            }else if($scope.isLast && $scope.journeyObj.lastJourneys && $scope.journeyObj.lastJourneys.length>0){
                $scope.trip = $scope.journeyObj.lastJourneys[0];
            }else{
                $scope.trip = $scope.journeyObj.service.getResults()[$scope.tripIndex];
            }
        }

        initData();

        $scope.updateTrip = function(trip) {
            $scope.trip = angular.copy(trip);
        };

        $scope.showNewDateInfo = function() {
            var depDate = $filter('VVSDateFormatter')($scope.trip.departureTime()),
                    sDate = $filter('VVSDateFormatter')(new Date());

            return (depDate !== sDate);
        };
    }
}());

(function() {
    'use strict';
    angular
        .module('vvs')
        .controller('VVSTripOptionsSettingsModalController', VVSTripOptionsSettingsModalController);

    VVSTripOptionsSettingsModalController.$inject = ['$scope', 'VVSConst', 'mng-favorite.MDVOptionsFavorite'];

    function VVSTripOptionsSettingsModalController($scope, VVSConst, MDVOptionsFavorite) {
        var self = this;

        self.tariffZones = VVSConst.tariffZones || [];
        self.tariffZoneRadio = 't_alle';

        self.triggerTariffzoneClick = function(tariffzone) {
            if ($scope.SEARCH_OPTIONS.fare.avoidZones.indexOf(tariffzone) === -1) {
                $scope.SEARCH_OPTIONS.fare.avoidZones.push(tariffzone);
            } else {
                $scope.SEARCH_OPTIONS.fare.avoidZones = $scope.SEARCH_OPTIONS.fare.avoidZones
                    .filter(function(value) {
                        return value !== tariffzone;
                    });
            }
        };

        $scope.onAccessClick = function() {
            window.open('https://www.vvs.de/barrierefrei','_blank');
        }

        self.triggerResetOptionsClick = function() {
            console.log('trigger reset options');
            console.log('tripCtrl', $scope.tripCtrl);
            var opts = {
                dropDB : true
            };

            MDVOptionsFavorite.remove(null, opts).then(function() {
                $scope.tripCtrl.resetSearchOptions();
            });
        };

        self.triggerAvoidElevationChange = function() {
            $scope.SEARCH_OPTIONS.individualTransport.from.avoidElevation =
                $scope.SEARCH_OPTIONS.individualTransport.to.avoidElevation;
        };

        self.triggerTariffZoneChange = function() {
            if (self.tariffZoneRadio === 't_alle') {
                $scope.SEARCH_OPTIONS.fare.avoidZones=[];
            } else {
                $scope.SEARCH_OPTIONS.fare.avoidZones = self.tariffZones;
            }
        };

        self.triggerIndividualTransportChange = function() {
            $scope.SEARCH_OPTIONS.individualTransport.from.walkSpeed = $scope.SEARCH_OPTIONS.individualTransport.to.walkSpeed;
        };
        self.triggerVisuallyImpaired = function() {
            if ($scope.SEARCH_OPTIONS.accessibility.visuallyImpaired) {
                $scope.SEARCH_OPTIONS.individualTransport.to.walkSpeed = 'slow';
            } else {
                $scope.SEARCH_OPTIONS.individualTransport.to.walkSpeed = $scope.DEFAULT_SEARCH_OPTIONS.individualTransport.to.walkSpeed;
            }
        };
        self.triggerStepFree = function() {
            if ($scope.SEARCH_OPTIONS.accessibility.stepFree) {
                $scope.SEARCH_OPTIONS.individualTransport.to.walkSpeed = 'slow';
            } else {
                $scope.SEARCH_OPTIONS.individualTransport.to.walkSpeed = $scope.DEFAULT_SEARCH_OPTIONS.individualTransport.to.walkSpeed;
            }
        };

        self.errorMaxHeight = false;
        self.validateFieldMaxHeight = function(e) {
            var charCode = e.which ? e.which : e.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                self.errorMaxHeight = true;
                return false;
              }
              self.errorMaxHeight = false;
              return true;
        }

    }
}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSTripOptionsMeansOfTransportModalController',
            VVSTripOptionsMeansOfTransportModalController);

    VVSTripOptionsMeansOfTransportModalController.$inject = ['$scope', 'mng-favorite.MDVOptionsFavorite'];

    function VVSTripOptionsMeansOfTransportModalController($scope, MDVOptionsFavorite) {
        var self = this;

        self.initPtSwitcher = function() {
            self.enableAllPT = $scope.SEARCH_OPTIONS.productRestrictions.train &&
                $scope.SEARCH_OPTIONS.productRestrictions.commuter &&
                $scope.SEARCH_OPTIONS.productRestrictions.lightRail &&
                $scope.SEARCH_OPTIONS.productRestrictions.bus &&
                $scope.SEARCH_OPTIONS.productRestrictions.coach &&
                $scope.SEARCH_OPTIONS.productRestrictions.demandTaxi;
        };
        self.initPtSwitcher();

        self.triggerEnableAllPTChange = function() {
            $scope.SEARCH_OPTIONS.productRestrictions.train =
                    $scope.SEARCH_OPTIONS.productRestrictions.commuter =
                    $scope.SEARCH_OPTIONS.productRestrictions.lightRail =
                    $scope.SEARCH_OPTIONS.productRestrictions.bus =
                    $scope.SEARCH_OPTIONS.productRestrictions.coach =
                    $scope.SEARCH_OPTIONS.productRestrictions.demandTaxi = self.enableAllPT;
        };

        self.switchMultimodal = function() {
            if (!$scope.SEARCH_OPTIONS.sharing.enabled) {
                $scope.SEARCH_OPTIONS.publicTransport.bikeTakeAlong = false;
                $scope.SEARCH_OPTIONS.sharing.callabike = false;
                $scope.SEARCH_OPTIONS.sharing.nextbike = false;
                $scope.SEARCH_OPTIONS.sharing.car2go = false;
                $scope.SEARCH_OPTIONS.sharing.flinkster = false;
                $scope.SEARCH_OPTIONS.sharing.stadtmobil = false;
            }
        };

        self.triggerResetOptionsClick = function() {
            var opts = {
                dropDB : true
            };

            MDVOptionsFavorite.remove(null, opts).then(function() {
                $scope.tripCtrl.resetSearchOptions();
            });
        };

    }
}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSSTTStopsLinesController', VVSSTTStopsLinesController);

    VVSSTTStopsLinesController.$inject = ['$scope', '$state', '$stateParams',
        'mng-comm.MDVDownload', 'mng-comm.MDVTransportationRequester', 'VVSPdfViewer', 'VVSDeepLinking', '$rootScope', '$window'];

    function VVSSTTStopsLinesController($scope, $state, $stateParams,
            MDVDownload, MDVTransportationRequester, VVSPdfViewer, VVSDeepLinking, $rootScope, $window) {

        var self = this,
            _private = {};

        _private.initController = function() {
            $scope.showPDF = false;
            $scope.pdfError = false;
            $scope.currentDate = new Date().toISOString();
            var loc = angular.copy($scope.inputLocations.stt),
                options = {
                    type : 'STT',
                    efaParams : {
                        locationServerActive : 1,
                        deleteAssignedStops : 1,
                        mergeDir : 0

                    }
                };
            if (!loc) {
                console.log('not loc?');
                $state.go('vvs.stops.stt', {}, {
                    reload : true
                });
                // $state.go('vvs.stt.init');
                return;
            }

            $rootScope.sttLoc = angular.copy(loc);

            MDVTransportationRequester.search(loc, options)
            .then(function(res) {
                self.lineSelections = res.response;
            });


            var deeplinkOptions = VVSDeepLinking.generateOptionsFromDeeplink();

            if (deeplinkOptions) {
                $scope.inputLines.stt = deeplinkOptions.odvs.stt_line;
                if ($scope.inputLocations.stt) {
                    MDVDownload.search(MDVDownload.requestTypes.STOP_TIMETABLE, {
                        lineId : $scope.inputLines.stt,
                        stopId : $scope.inputLocations.stt.id()

                    }).then(function(res) {
                        if (res.response) {
                            VVSPdfViewer.show(res.response);
                        }
                    });
                }
            }
        };

        _private.initController();

        self.triggerFireSTTDownloadClick = function(line) {
            $scope.pdfError = false;
            MDVDownload.search(MDVDownload.requestTypes.STOP_TIMETABLE, {
                lineId : line.id(),
                stopId : $scope.inputLocations.stt.id()

            }).then(function(res) {
                if (res.response) {
                    $scope.pdfRes = res.response;
                    $scope.number = line.number();
                    $scope.line = angular.copy(line);
                    window.open($scope.pdfRes.url(), '_blank');
                }
            }).catch(function(err) {
                console.log('err', err);
                $scope.pdfError = true;
            });
            $scope.showPDF = true;
        };

        self.triggerSTTResetClick = function() {
            // vvs.stops.stt
            $state.go('vvs.stops.stt', {}, {
            // $state.go('vvs.stt.init', {}, {
                reload : true
            });
        };

        self.triggerSTTChangeClick = function() {
        }


    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSSTTLinesStopsController', VVSSTTLinesStopsController);

    VVSSTTLinesStopsController.$inject = ['$scope', '$state', 'mng-comm.MDVLocationRequester',
        'mng-comm.MDVDownload', 'VVSPdfViewer', 'VVSDeepLinking'];

    function VVSSTTLinesStopsController($scope, $state, MDVLocationRequester, MDVDownload, VVSPdfViewer, VVSDeepLinking) {

        var self = this,
            _private = {};

        _private.initController = function() {
            var line = angular.copy($scope.inputLines.stt);

            if (!line) {
                $state.go('vvs.stt.init');
                return;
            }

            MDVLocationRequester.search(line, {
                efaParams : {
                    lineReqType : 'STT'
                }
            })
                .then(function(res) {
                    if (res && res.response && res.response.length>0) {
                        self.stopSelections = angular.copy(res.response);
                    }
                });

            var deeplinkOptions = VVSDeepLinking.generateOptionsFromDeeplink();

            if (deeplinkOptions) {
                $scope.inputLocations.stt = deeplinkOptions.odvs.stt_stop;
                if ($scope.inputLocations.stt) {
                    MDVDownload.search(MDVDownload.requestTypes.STOP_TIMETABLE, {
                        lineId : $scope.inputLines.stt.id(),
                        stopId : $scope.inputLocations.stt

                    }).then(function(res) {
                        if (res.response) {
                            VVSPdfViewer.show(res.response);
                        }
                    });
                }
            }

        };
        _private.initController();


        self.triggerSTTResetClick = function() {
            $state.go('vvs.stt.stops', {}, {
                reload : true
            });
        };

        self.triggerFireSTTDownloadClick = function(location) {
            MDVDownload.search(MDVDownload.requestTypes.STOP_TIMETABLE, {
                lineId : $scope.inputLines.stt.id(),
                stopId : location.id()

            }).then(function(res) {
                if (res.response) {
                    VVSPdfViewer.show(res.response);
                }
            });
        };
    }

}());

(function() {
    'use strict';

    /**
     * The 'vvs-odv' directive is used to inject an odv Element-box:
     * 1) the odv controls
     * 2) the odv input element
     * 3) the odv result
     **/
    angular
        .module('vvs')
        .directive('vvsLocationOdv', vvsLocationOdv);

    vvsLocationOdv.$inject = [];

    function vvsLocationOdv() {
        return {
            restrict : 'E',
            replace : false,
            scope : true,
            templateUrl : 'app/vvs.components/odv/suggestion/location/odv.html',
            controller : 'VVSLocationOdvController',
            controllerAs : 'ctrl',
            link : function(scope, elem, attrs) {
                scope.usage = attrs.usage;
            }
        };
    }


    angular
        .module('vvs')
        .directive('vvsLocationAutoComplete', vvsLocationAutoComplete);

    vvsLocationAutoComplete.$inject = [];

    function vvsLocationAutoComplete() {
        return {
            restrict : 'E',
            templateUrl : 'app/vvs.components/odv/suggestion/location/auto-complete.html'
        };
    }

}());

(function() {
    'use strict';


    /**
     * The `VVSLocationOdvController` is bounded to the `odv\odv.html` template.
     * He listen to each user interaction with the odv input like : get browser location,
     * select a Stopfinder item
     **/
    angular
        .module('vvs')
        .controller('VVSLocationOdvController', VVSLocationOdvController);

    VVSLocationOdvController.$inject = ['$document', '$scope', '$filter', '$element', '$timeout', 'VVSBrowserUtilities', 'VVSConst', 'mng-comm.MDVLocationRequester',
        'mng-common.MDVCurrentPosition', 'mng-favorite.MDVLocationFavorite'];

    function VVSLocationOdvController($document, $scope, $filter, $element, $timeout, VVSBrowserUtilities, VVSConst, MDVLocationRequester, MDVCurrentPosition,
        MDVLocationFavorite) {

        var self = this;

        self.locations = [];
        self.resultHeight = '0px';


        self.noCache = false;
        self.querySearch = querySearch;
        self.triggerOdvCurrentPositionClick = triggerOdvCurrentPositionClick;
        self.triggerFocus = triggerFocus;
        self.triggerChange = triggerChange;
        self.triggerSelect = triggerSelect;
        self.triggerKeyDown = triggerKeyDown;

        if(VVSBrowserUtilities.getMobileOperatingSystem() === 'unknown') {
            self.modelOptions = {
                debounce : 250
            };
        } else {
            self.modelOptions = {
                debounce : 750
            };
        }

        $element.bind('click', function(e) {
            e.stopPropagation();
        });

        $document.bind('click', function() {
            reset();
        });


        function resetResultHeight() {
            if (self.locations.length<10) {
                self.resultHeight = (50 * self.locations.length) + 'px';
            } else {
                self.resultHeight = (8 * 50) + 'px';
            }
        }

        function reset() {
            self.locations.length = 0;
            $scope.$apply();
        }


        function triggerKeyDown(evt) {
            if ([13, 27].indexOf(evt.which) > -1) {
                self.locations.length = 0;
                resetResultHeight();
            }
        }

        function triggerFocus() {
            querySearch($scope.inputLocations[$scope.usage])
                .then(function(res) {
                    self.locations = res;
                    resetResultHeight();
                });
        }

        function triggerChange() {
            querySearch($scope.inputLocations[$scope.usage])
                .then(function(res) {
                    self.locations = res;
                    resetResultHeight();
                });
        }

        function triggerSelect(mdvLocation) {
            self.locations.length = 0;
            resetResultHeight();
            $scope.inputLocations[$scope.usage] = angular.copy(mdvLocation);
            MDVLocationFavorite.set(mdvLocation, $scope.usage);
            $element.find('input').blur();
        }

        function querySearch(inputVal) {
            if (!inputVal || (inputVal.length === 0)) {
                // get all history from DB
                return getPersistedLocations();
            } else {
                // merge history and fetched locations
                return getPersistedAndNewLocations(inputVal);
            }
        }

        /**
         * The `triggerOdvCurrentPositionClick` function is called when the user
         * want to choose his current position (browser position) as odv value.
         **/
        function triggerOdvCurrentPositionClick() {
            MDVCurrentPosition.get()
                .then(function(mdvLocation) {
                    $scope.currentPositionAlert = false;
                    assignMdvLocationByUsage(mdvLocation);
                })
                .catch(function() {
                    $scope.currentPositionAlert = true;
                });
        }

        $scope.resetODV = function() {
            console.log('reset');
            $scope.inputLocations[$scope.usage] = '';
        }

        /* ******************* PRIVATE METHODS ******************** */

        // get all history locations from DB
        function getPersistedLocations(inputVal) {
            return MDVLocationFavorite.get(null, $scope.usage).then(function(res) {
                if (inputVal && inputVal.length>0) {
                    // filter results
                    res = getFilteredPersistedLocations(inputVal, res);
                }
                // sort persisted locations
                res = $filter('orderBy')(res, '-persistence.modified');
                // add 'history' class name
                res = addLocationClassName(res, 'history');
                return addSuggestionIndex(res);
            });
        }

        // get unique list of best, history and new requested locations
        function getPersistedAndNewLocations(inputVal) {
            return getPersistedLocations(inputVal)
                .then(function(persistedLocations) {
                    return getNewLocations(inputVal, persistedLocations);
                })
                .catch(function() {
                    return getNewLocations(inputVal);
                });
        }

        function getNewLocations(inputVal, persistedLocations) {
            var result = persistedLocations || [],
                opts = {
                    efaParams : {}
                };

                if ($scope.usage === 'pers') {
                    opts.efaParams.anyObjFilter_sf=2;
                }

                return MDVLocationRequester.search(inputVal, opts)
                    .then(function(data) {

                        $scope.requestFailed = false;
                        // var bestMatchLocations = getBestMatchLocations(data.response),
                        var bestMatchLocations = data.response,
                            newLocations;

                        // add 'best' class name
                        bestMatchLocations = addLocationClassName(bestMatchLocations, 'best');
                        result = removeArrayFromArray(bestMatchLocations, result);
                        result = bestMatchLocations.concat(result);
                        newLocations = removeArrayFromArray(result, data.response);
                        // add 'new' class name
                        newLocations = addLocationClassName(newLocations, 'new');
                        result = result.concat(newLocations);

                        return addSuggestionIndex(result);
                    })
                    .catch(function(e) {
                        $scope.requestFailed= true;
                    });
        }

        // remove array from another array
        function removeArrayFromArray(arrTobeRemoved, arrTobeRemovedFrom) {
            var i,
                j,
                l,
                m;

            for (i=0, l=arrTobeRemovedFrom.length; i<l; i+=1) {
                for (j=0, m=arrTobeRemoved.length; j <m; j+=1) {
                    if (arrTobeRemovedFrom[i] && (arrTobeRemovedFrom[i].id() === arrTobeRemoved[j].id())) {
                        arrTobeRemovedFrom.splice(i, 1);
                    }
                }
            }
            return arrTobeRemovedFrom;
        }

        // return the list of best Matched locations
        function getBestMatchLocations(newLocations) {
            var best = [],
                i,
                l;

            for (i = 0, l = newLocations.length; i < l; i += 1) {
                if (newLocations[i].isBestMatch() || (newLocations.length === 1)) {
                    best.push(newLocations[i]);
                }
            }
            return best;
        }

        // remove not matched persisted locations
        function getFilteredPersistedLocations(matchStr, persistedLocations) {
            var re_str = new RegExp('^' + matchStr, 'gi'),
                filteredLocations = [],
                locationName,
                i,
                l;

            for (i = 0, l = persistedLocations.length; i < l; i += 1) {
                locationName = $filter('VVSLocationSuggestFormatter')(persistedLocations[i], true);

                if (re_str.test(locationName)) {
                    filteredLocations.push(persistedLocations[i]);
                }
            }
            return filteredLocations;
        }


        // Add selected mdvLocation to the father location buffer.
        function assignMdvLocationByUsage(mdvLocation) {
            //MDVLocationFavorite.set(mdvLocation, $scope.usage);
            $scope.inputLocations[$scope.usage] = mdvLocation;
        }

        function addSuggestionIndex(locs) {
            var i,
                l;

            for (i=0, l=locs.length; i<l; i+=1) {
                locs[i].suggestionIndex = i;
            }
            return locs;
        }

        function addLocationClassName(locationsArr, className) {
            angular.forEach(locationsArr, function(value) {
                value.className = className;
            });
            return locationsArr;
        }

    }


}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsLineOdv', vvsLineOdv);

    vvsLineOdv.$inject = [];

    function vvsLineOdv() {
        return {
            restrict: 'E',
            replace: false,
            scope: true,
            templateUrl: 'app/vvs.components/odv/suggestion/line/odv.html',
            controller: 'VVSLineOdvController',
            controllerAs: 'ctrl',
            link: function(scope, elem, attrs) {
                scope.usage = attrs.usage;
            }
        };
    }

}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .controller('VVSLineOdvController', VVSLineOdvController);

    VVSLineOdvController.$inject = ['$scope', '$filter', '$element', '$document', 'VVSConst', 'mng-comm.MDVTransportationRequester', 'mng-favorite.MDVTransportationFavorite'];

    function VVSLineOdvController($scope, $filter, $element, $document, VVSConst, MDVTransportationRequester, MDVTransportationFavorite) {


        var self = this;

        self.lines = [];

        self.noCache = true;
        self.querySearch = querySearch;
        self.triggerSelect = triggerSelect;
        self.triggerFocus = triggerFocus;
        self.triggerChange = triggerChange;
        self.triggerKeyDown = triggerKeyDown;


        $element.bind('click', function(e) {
            e.stopPropagation();
        });

        $document.bind('click', function() {
            reset();
        });


        function reset() {
            self.lines.length = 0;
            $scope.$apply();
        }


        function triggerKeyDown(evt) {
            if (evt.which === 27) {
                reset();
            }
        }

        function triggerFocus() {
            window.closeError = true;
            console.log('focus');
            // $scope.inputLines[$scope.usage] = '';
            querySearch($scope.inputLines[$scope.usage])
                .then(function(res) {
                    self.lines = res;
                });
        }

        function triggerChange() {
            querySearch($scope.inputLines[$scope.usage])
                .then(function(res) {
                    self.lines = res;
                });
        }


        function triggerSelect(mdvTransportation) {
            self.lines.length = 0;
            $scope.inputLines[$scope.usage] = angular.copy(mdvTransportation);
            MDVTransportationFavorite.set(mdvTransportation, $scope.usage);
            $element.find('input').blur();
        }

        function querySearch(val) {
            if(!val || (val.length === 0)){
                // get all history from DB
                return getPersistedLines();
            }else{
                // merge history and fetched lines
                return getPersistedAndNewLines(val);
            }
        }

        /************************  PRIVATE METHODS   *************************/

        function getPersistedLines(val) {
            return MDVTransportationFavorite.get(null, $scope.usage).then(function(res) {
                if (val && val.length>0) {
                    res = getFilteredPersistedLines(val, res);
                }

                res = $filter('orderBy')(res, '-persistence.modified');
                res = addLocationClassName(res, 'history');
                return addSuggestionIndex(res);
            });
        }


        function getPersistedAndNewLines(val) {
            var result = [],
                options = {
                    efaParams : {}
                };


            if ($scope.usage === 'rop') {
                options.type = 'ROP';
            } else if ($scope.usage === 'ttb') {
                options.type = 'TTB';
                options.efaParams.mergeDir = 1;
            } else if (($scope.usage === 'dm') || ($scope.usage === 'pers')) {
                if ($scope.usage === 'pers') {
                    options.efaParams.mergeDir = 0;
                }
                options.type = 'DM';
            } else if ($scope.usage === 'stt') {
                options.type = 'STT';
                options.efaParams.mergeDir = 0;
            }

            return getPersistedLines(val)
                .then(function(persistedLines) {
                    result = result.concat(persistedLines);
                    return MDVTransportationRequester.search(val, options)
                        .then(function(res) {
                            var newLocations;

                            newLocations = removeArrayFromArray(result, res.response);
                            newLocations = addLocationClassName(newLocations, 'new');
                            result = result.concat(newLocations);

                            return addSuggestionIndex(result);
                        });
                });
        }


        function addLocationClassName(locationsArr, className) {
            angular.forEach(locationsArr, function(value) {
                value.className = className;
            });

            return locationsArr;
        }


        function removeArrayFromArray(arrTobeRemoved, arrTobeRemovedFrom) {
            for (var i = 0; i < arrTobeRemovedFrom.length; i++) {
                for (var j = 0; j < arrTobeRemoved.length; j++) {
                    if(arrTobeRemovedFrom[i].id() === arrTobeRemoved[j].id()) {
                        arrTobeRemovedFrom.splice(i, 1);
                    }
                }
            }
            return arrTobeRemovedFrom;
        }

        function getFilteredPersistedLines(matchStr, persistedLines) {
            var filteredLines = [], i, l, re_str = new RegExp('' + matchStr, 'gi');
            for (i = 0, l = persistedLines.length; i < l; i += 1) {
                var lineName = persistedLines[i].number();
                if (re_str.test(lineName)){
                    filteredLines.push(persistedLines[i]);
                }
            }
            return filteredLines;
        }

        function addSuggestionIndex(lines) {
            for (var i=0; i<lines.length; i++) {
                lines[i].suggestionIndex = i;
            }
            return lines;
        }

    }


}());

/*!
 * @copyright Copyright (c) 2015 IcoMoon.io
 * @license   Licensed under MIT license
 *            See https://github.com/Keyamoon/svgxuse
 * @version   1.1.0
 */
/*jslint browser: true */
/*global XDomainRequest, MutationObserver, window */
(function () {
    'use strict';
    if (window && window.addEventListener) {
        var cache = Object.create(null); // holds xhr objects to prevent multiple requests
        var checkUseElems,
            tid; // timeout id
        var debouncedCheck = function () {
            clearTimeout(tid);
            tid = setTimeout(checkUseElems, 100);
        };
        var unobserveChanges = function () {
            return;
        };
        var observeChanges = function () {
            var observer;
            if (window.MutationObserver) {
                observer = new MutationObserver(debouncedCheck);
                observer.observe(document.body, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['xlink:href']
                });
                unobserveChanges = function () {
                    try {
                        observer.disconnect();
                    } catch (ignore) {}
                };
            } else {
                document.body.addEventListener('DOMSubtreeModified', debouncedCheck, false);
                unobserveChanges = function () {
                    document.body.removeEventListener('DOMSubtreeModified', debouncedCheck, false);
                };
            }
        };
        checkUseElems = function () {
            var base,
                bcr,
                fallback = '', // optional fallback URL in case no base path to SVG file was given and no symbol definition was found.
                hash,
                i,
                Request,
                inProgressCount = 0,
                url,
                uses,
                xhr;
            if (window.XMLHttpRequest) {
                Request = new XMLHttpRequest();
                if (Request.withCredentials !== undefined) {
                    Request = XMLHttpRequest;
                } else {
                    Request = XDomainRequest || undefined;
                }
            }
            if (Request === undefined) {
                return;
            }
            function observeIfDone() {
                // If done with making changes, start watching for chagnes in DOM again
                inProgressCount -= 1;
                if (inProgressCount === 0) { // if all xhrs were resolved
                    observeChanges(); // watch for changes to DOM
                }
            }
            function onload(xhr) {
                return function () {
                    var body = document.body,
                        x = document.createElement('x');
                    xhr.onload = null;
                    x.innerHTML = xhr.responseText;
                    body.insertBefore(x.firstChild, body.firstChild);
                    observeIfDone();
                };
            }
            function onErrorTimeout(xhr) {
                return function () {
                    xhr.onerror = null;
                    xhr.ontimeout = null;
                    observeIfDone();
                };
            }
            unobserveChanges(); // stop watching for changes to DOM
            // find all use elements
            uses = document.getElementsByTagName('use');
            for (i = 0; i < uses.length; i += 1) {
                try {
                    bcr = uses[i].getBoundingClientRect();
                } catch (e) {
                    // failed to get bounding rectangle of the use element
                    bcr = false;
                }
                url = uses[i].getAttribute('xlink:href').split('#');
                base = url[0];
                hash = url[1];
                if (bcr && bcr.width === 0 && bcr.height === 0) {
                    // the use element is empty
                    // if there is a reference to an external SVG, try to fetch it
                    // use the optional fallback URL if there is no reference to an external SVG
                    if (fallback && !base.length && hash && !document.getElementById(hash)) {
                        base = fallback;
                    }
                    if (base.length) {
                        xhr = cache[base];
                        if (xhr !== true) {
                            uses[i].setAttribute('xlink:href', '#' + hash);
                        }
                        if (xhr === undefined) {
                            xhr = new Request();
                            cache[base] = xhr;
                            xhr.onload = onload(xhr);
                            xhr.onerror = onErrorTimeout(xhr);
                            xhr.ontimeout = onErrorTimeout(xhr);
                            xhr.open('GET', base);
                            xhr.send();
                            inProgressCount += 1;
                        }
                    }
                } else {
                    // remember this URL if the use element was not empty and no request was sent
                    if (cache[base] === undefined) {
                        cache[base] = true;
                    }
                }
            }
            uses = '';
            inProgressCount += 1;
            observeIfDone();
        };
        // The load event fires when all resources have finished loading, which allows detecting whether SVG use elements are empty.
        window.addEventListener('load', function winLoad() {
            window.removeEventListener('load', winLoad, false); // to prevent memory leaks
            checkUseElems();
        }, false);
    }
}());


//    PouchDB localStorage plugin 5.1.0
//    Based on localstorage-down: https://github.com/No9/localstorage-down
//
//    (c) 2012-2015 Dale Harvey and the PouchDB team
//    PouchDB may be freely distributed under the Apache license, version 2.0.
//    For all details and documentation:
//    http://pouchdb.com
(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
'use strict';

module.exports = _dereq_(47);
},{"47":47}],2:[function(_dereq_,module,exports){
'use strict';

var createBlob = _dereq_(12);

module.exports = function createEmptyBlobOrBuffer(type) {
  return createBlob([''], {type: type});
};
},{"12":12}],3:[function(_dereq_,module,exports){
(function (process,Buffer){
'use strict';

var levelup = _dereq_(107);
var sublevel = _dereq_(80);
var through = _dereq_(158).obj;

var errors = _dereq_(24);
var clone = _dereq_(16);
var Changes = _dereq_(7);
var uuid = _dereq_(43);
var collections = _dereq_(145);
var filterChange = _dereq_(25);
var getArguments = _dereq_(48);
var safeJsonParse = _dereq_(40);
var safeJsonStringify = _dereq_(41);
var calculateWinningRev = _dereq_(35);
var traverseRevTree = _dereq_(34);
var compactTree = _dereq_(30);
var collectConflicts = _dereq_(28);
var isDeleted = _dereq_(17);
var isLocalId = _dereq_(18);
var parseDoc = _dereq_(19);
var processDocs = _dereq_(20);
var md5 = _dereq_(27);
var migrate = _dereq_(36);
var Deque = _dereq_(75);
var atob = _dereq_(9).atob;
var functionName = _dereq_(26);
var readAsBluffer = _dereq_(5);
var prepareAttachmentForStorage = _dereq_(4);
var createEmptyBluffer = _dereq_(2);
var Promise = _dereq_(39);

var binStringToBluffer =
  _dereq_(11);

var LevelTransaction = _dereq_(6);

var DOC_STORE = 'document-store';
var BY_SEQ_STORE = 'by-sequence';
var ATTACHMENT_STORE = 'attach-store';
var BINARY_STORE = 'attach-binary-store';
var LOCAL_STORE = 'local-store';
var META_STORE = 'meta-store';

// leveldb barks if we try to open a db multiple times
// so we cache opened connections here for initstore()
var dbStores = new collections.Map();

// store the value of update_seq in the by-sequence store the key name will
// never conflict, since the keys in the by-sequence store are integers
var UPDATE_SEQ_KEY = '_local_last_update_seq';
var DOC_COUNT_KEY = '_local_doc_count';
var UUID_KEY = '_local_uuid';

var MD5_PREFIX = 'md5-';

var safeJsonEncoding = {
  encode: safeJsonStringify,
  decode: safeJsonParse,
  buffer: false,
  type: 'cheap-json'
};

// require leveldown. provide verbose output on error as it is the default
// nodejs adapter, which we do not provide for the user
/* istanbul ignore next */
var requireLeveldown = function () {
  try {
    return _dereq_(49);
  } catch (err) {
    /*jshint -W022 */
    err = err || 'leveldown import error';
    if (err.code === 'MODULE_NOT_FOUND') {
      // handle leveldown not installed case
      return new Error([
        'the \'leveldown\' package is not available. install it, or,',
        'specify another storage backend using the \'db\' option'
      ].join(' '));
    } else if (err.message && err.message.match('Module version mismatch')) {
      // handle common user enviornment error
      return new Error([
        err.message,
        'This generally implies that leveldown was built with a different',
        'version of node than that which is running now.  You may try',
        'fully removing and reinstalling PouchDB or leveldown to resolve.'
      ].join(' '));
    }
    // handle general internal nodejs require error
    return new Error(err.toString() + ': unable to import leveldown');
  }
};

// winningRev and deleted are performance-killers, but
// in newer versions of PouchDB, they are cached on the metadata
function getWinningRev(metadata) {
  return 'winningRev' in metadata ?
    metadata.winningRev : calculateWinningRev(metadata);
}

function getIsDeleted(metadata, winningRev) {
  return 'deleted' in metadata ?
    metadata.deleted : isDeleted(metadata, winningRev);
}

function fetchAttachment(att, stores, opts) {
  var type = att.content_type;
  return new Promise(function (resolve, reject) {
    stores.binaryStore.get(att.digest, function (err, buffer) {
      var data;
      if (err) {
        /* istanbul ignore if */
        if (err.name !== 'NotFoundError') {
          return reject(err);
        } else {
          // empty
          if (!opts.binary) {
            data = '';
          } else {
            data = binStringToBluffer('', type);
          }
        }
      } else { // non-empty
        if (opts.binary) {
          data = readAsBluffer(buffer, type);
        } else {
          data = buffer.toString('base64');
        }
      }
      delete att.stub;
      delete att.length;
      att.data = data;
      resolve();
    });
  });
}

function fetchAttachments(results, stores, opts) {
  var atts = [];
  results.forEach(function (row) {
    if (!(row.doc && row.doc._attachments)) {
      return;
    }
    var attNames = Object.keys(row.doc._attachments);
    attNames.forEach(function (attName) {
      var att = row.doc._attachments[attName];
      if (!('data' in att)) {
        atts.push(att);
      }
    });
  });

  return Promise.all(atts.map(function (att) {
    return fetchAttachment(att, stores, opts);
  }));
}

function LevelPouch(opts, callback) {
  opts = clone(opts);
  var api = this;
  var instanceId;
  var stores = {};
  var db;
  var name = opts.name;
  if (typeof opts.createIfMissing === 'undefined') {
    opts.createIfMissing = true;
  }

  var leveldown = opts.db || requireLeveldown();
  /* istanbul ignore if */
  if (leveldown instanceof Error) {
    return callback(leveldown);
  }

  if (typeof leveldown.destroy !== 'function') {
    /* istanbul ignore next */
    leveldown.destroy = function (name, cb) { cb(); };
  }
  var dbStore;
  var leveldownName = functionName(leveldown);
  if (dbStores.has(leveldownName)) {
    dbStore = dbStores.get(leveldownName);
  } else {
    dbStore = new collections.Map();
    dbStores.set(leveldownName, dbStore);
  }
  if (dbStore.has(name)) {
    db = dbStore.get(name);
    afterDBCreated();
  } else {
    dbStore.set(name, sublevel(levelup(name, opts, function (err) {
      /* istanbul ignore if */
      if (err) {
        dbStore["delete"](name);
        return callback(err);
      }
      db = dbStore.get(name);
      db._docCount  = -1;
      db._queue = new Deque();
      if (opts.db || opts.noMigrate) {
        afterDBCreated();
      } else {
        migrate.toSublevel(name, db, afterDBCreated);
      }
    })));
  }

  function afterDBCreated() {
    stores.docStore = db.sublevel(DOC_STORE, {valueEncoding: safeJsonEncoding});
    stores.bySeqStore = db.sublevel(BY_SEQ_STORE, {valueEncoding: 'json'});
    stores.attachmentStore =
      db.sublevel(ATTACHMENT_STORE, {valueEncoding: 'json'});
    stores.binaryStore = db.sublevel(BINARY_STORE, {valueEncoding: 'binary'});
    stores.localStore = db.sublevel(LOCAL_STORE, {valueEncoding: 'json'});
    stores.metaStore = db.sublevel(META_STORE, {valueEncoding: 'json'});
    migrate.localAndMetaStores(db, stores, function () {
      stores.metaStore.get(UPDATE_SEQ_KEY, function (err, value) {
        if (typeof db._updateSeq === 'undefined') {
          db._updateSeq = value || 0;
        }
        stores.metaStore.get(DOC_COUNT_KEY, function (err, value) {
          db._docCount = !err ? value : 0;
          stores.metaStore.get(UUID_KEY, function (err, value) {
            instanceId = !err ? value : uuid();
            stores.metaStore.put(UUID_KEY, instanceId, function (err, value) {
              process.nextTick(function () {
                callback(null, api);
              });
            });
          });
        });
      });
    });
  }

  function countDocs(callback) {
    /* istanbul ignore if */
    if (db.isClosed()) {
      return callback(new Error('database is closed'));
    }
    return callback(null, db._docCount); // use cached value
  }

  api.type = function () {
    return 'leveldb';
  };

  api._id = function (callback) {
    callback(null, instanceId);
  };

  api._info = function (callback) {
    var res = {
      doc_count: db._docCount,
      update_seq: db._updateSeq,
      backend_adapter: functionName(leveldown)
    };
    return process.nextTick(function () {
      callback(null, res);
    });
  };

  function tryCode(fun, args) {
    try {
      fun.apply(null, args);
    } catch (err) {
      args[args.length - 1](err);
    }
  }

  function executeNext() {
    var firstTask = db._queue.peekFront();

    if (firstTask.type === 'read') {
      runReadOperation(firstTask);
    } else { // write, only do one at a time
      runWriteOperation(firstTask);
    }
  }

  function runReadOperation(firstTask) {
    // do multiple reads at once simultaneously, because it's safe

    var readTasks = [firstTask];
    var i = 1;
    var nextTask = db._queue.get(i);
    while (typeof nextTask !== 'undefined' && nextTask.type === 'read') {
      readTasks.push(nextTask);
      i++;
      nextTask = db._queue.get(i);
    }

    var numDone = 0;

    readTasks.forEach(function (readTask) {
      var args = readTask.args;
      var callback = args[args.length - 1];
      args[args.length - 1] = getArguments(function (cbArgs) {
        callback.apply(null, cbArgs);
        if (++numDone === readTasks.length) {
          process.nextTick(function () {
            // all read tasks have finished
            readTasks.forEach(function () {
              db._queue.shift();
            });
            if (db._queue.length) {
              executeNext();
            }
          });
        }
      });
      tryCode(readTask.fun, args);
    });
  }

  function runWriteOperation(firstTask) {
    var args = firstTask.args;
    var callback = args[args.length - 1];
    args[args.length - 1] = getArguments(function (cbArgs) {
      callback.apply(null, cbArgs);
      process.nextTick(function () {
        db._queue.shift();
        if (db._queue.length) {
          executeNext();
        }
      });
    });
    tryCode(firstTask.fun, args);
  }

  // all read/write operations to the database are done in a queue,
  // similar to how websql/idb works. this avoids problems such
  // as e.g. compaction needing to have a lock on the database while
  // it updates stuff. in the future we can revisit this.
  function writeLock(fun) {
    return getArguments(function (args) {
      db._queue.push({
        fun: fun,
        args: args,
        type: 'write'
      });

      if (db._queue.length === 1) {
        process.nextTick(executeNext);
      }
    });
  }

  // same as the writelock, but multiple can run at once
  function readLock(fun) {
    return getArguments(function (args) {
      db._queue.push({
        fun: fun,
        args: args,
        type: 'read'
      });

      if (db._queue.length === 1) {
        process.nextTick(executeNext);
      }
    });
  }

  function formatSeq(n) {
    return ('0000000000000000' + n).slice(-16);
  }

  function parseSeq(s) {
    return parseInt(s, 10);
  }

  api._get = readLock(function (id, opts, callback) {
    opts = clone(opts);

    stores.docStore.get(id, function (err, metadata) {

      if (err || !metadata) {
        return callback(errors.error(errors.MISSING_DOC, 'missing'));
      }

      var rev = getWinningRev(metadata);
      var deleted = getIsDeleted(metadata, rev);
      if (deleted && !opts.rev) {
        return callback(errors.error(errors.MISSING_DOC, "deleted"));
      }

      rev = opts.rev ? opts.rev : rev;

      var seq = metadata.rev_map[rev];

      stores.bySeqStore.get(formatSeq(seq), function (err, doc) {
        if (!doc) {
          return callback(errors.error(errors.MISSING_DOC));
        }
        /* istanbul ignore if */
        if ('_id' in doc && doc._id !== metadata.id) {
          // this failing implies something very wrong
          return callback(new Error('wrong doc returned'));
        }
        doc._id = metadata.id;
        if ('_rev' in doc) {
          /* istanbul ignore if */
          if (doc._rev !== rev) {
            // this failing implies something very wrong
            return callback(new Error('wrong doc returned'));
          }
        } else {
          // we didn't always store this
          doc._rev = rev;
        }
        return callback(null, {doc: doc, metadata: metadata});
      });
    });
  });

  // not technically part of the spec, but if putAttachment has its own
  // method...
  api._getAttachment = function (attachment, opts, callback) {
    var digest = attachment.digest;
    var type = attachment.content_type;

    stores.binaryStore.get(digest, function (err, attach) {
      if (err) {
        /* istanbul ignore if */
        if (err.name !== 'NotFoundError') {
          return callback(err);
        }
        // Empty attachment
        return callback(null, opts.binary ? createEmptyBluffer(type) : '');
      }

      if (opts.binary) {
        callback(null, readAsBluffer(attach, type));
      } else {
        callback(null, attach.toString('base64'));
      }
    });
  };

  api._bulkDocs = writeLock(function (req, opts, callback) {
    var newEdits = opts.new_edits;
    var results = new Array(req.docs.length);
    var fetchedDocs = new collections.Map();
    var txn = new LevelTransaction();
    var docCountDelta = 0;
    var newUpdateSeq = db._updateSeq;

    // parse the docs and give each a sequence number
    var userDocs = req.docs;
    var docInfos = userDocs.map(function (doc, i) {
      if (doc._id && isLocalId(doc._id)) {
        return doc;
      }
      var newDoc = parseDoc.parseDoc(doc, newEdits);

      if (newDoc.metadata && !newDoc.metadata.rev_map) {
        newDoc.metadata.rev_map = {};
      }

      return newDoc;
    });
    var infoErrors = docInfos.filter(function (doc) {
      return doc.error;
    });

    if (infoErrors.length) {
      return callback(infoErrors[0]);
    }

    // verify any stub attachments as a precondition test

    function verifyAttachment(digest, callback) {
      txn.get(stores.attachmentStore, digest, function (levelErr) {
        if (levelErr) {
          var err = errors.error(errors.MISSING_STUB,
                                'unknown stub attachment with digest ' +
                                digest);
          callback(err);
        } else {
          callback();
        }
      });
    }

    function verifyAttachments(finish) {
      var digests = [];
      userDocs.forEach(function (doc) {
        if (doc && doc._attachments) {
          Object.keys(doc._attachments).forEach(function (filename) {
            var att = doc._attachments[filename];
            if (att.stub) {
              digests.push(att.digest);
            }
          });
        }
      });
      if (!digests.length) {
        return finish();
      }
      var numDone = 0;
      var err;

      digests.forEach(function (digest) {
        verifyAttachment(digest, function (attErr) {
          if (attErr && !err) {
            err = attErr;
          }

          if (++numDone === digests.length) {
            finish(err);
          }
        });
      });
    }

    function fetchExistingDocs(finish) {
      var numDone = 0;
      var overallErr;
      function checkDone() {
        if (++numDone === userDocs.length) {
          return finish(overallErr);
        }
      }

      userDocs.forEach(function (doc) {
        if (doc._id && isLocalId(doc._id)) {
          // skip local docs
          return checkDone();
        }
        txn.get(stores.docStore, doc._id, function (err, info) {
          if (err) {
            /* istanbul ignore if */
            if (err.name !== 'NotFoundError') {
              overallErr = err;
            }
          } else {
            fetchedDocs.set(doc._id, info);
          }
          checkDone();
        });
      });
    }

    function autoCompact(callback) {

      var promise = Promise.resolve();

      fetchedDocs.forEach(function (metadata, docId) {
        // TODO: parallelize, for now need to be sequential to
        // pass orphaned attachment tests
        promise = promise.then(function () {
          return new Promise(function (resolve, reject) {
            var revs = compactTree(metadata);
            api._doCompactionNoLock(docId, revs, {ctx: txn}, function (err) {
              /* istanbul ignore if */
              if (err) {
                return reject(err);
              }
              resolve();
            });
          });
        });
      });

      promise.then(function () {
        callback();
      }, callback);
    }

    function finish() {
      if (api.auto_compaction) {
        return autoCompact(complete);
      }
      return complete();
    }

    function writeDoc(docInfo, winningRev, winningRevIsDeleted, newRevIsDeleted,
                      isUpdate, delta, resultsIdx, callback2) {
      docCountDelta += delta;

      var err = null;
      var recv = 0;

      docInfo.metadata.winningRev = winningRev;
      docInfo.metadata.deleted = winningRevIsDeleted;

      docInfo.data._id = docInfo.metadata.id;
      docInfo.data._rev = docInfo.metadata.rev;

      if (newRevIsDeleted) {
        docInfo.data._deleted = true;
      }

      var attachments = docInfo.data._attachments ?
        Object.keys(docInfo.data._attachments) :
        [];

      function attachmentSaved(attachmentErr) {
        recv++;
        if (!err) {
          /* istanbul ignore if */
          if (attachmentErr) {
            err = attachmentErr;
            callback2(err);
          } else if (recv === attachments.length) {
            finish();
          }
        }
      }

      function onMD5Load(doc, key, data, attachmentSaved) {
        return function (result) {
          saveAttachment(doc, MD5_PREFIX + result, key, data, attachmentSaved);
        };
      }

      function doMD5(doc, key, attachmentSaved) {
        return function (data) {
          md5(data).then(
            onMD5Load(doc, key, data, attachmentSaved)
          );
        };
      }

      for (var i = 0; i < attachments.length; i++) {
        var key = attachments[i];
        var att = docInfo.data._attachments[key];

        if (att.stub) {
          // still need to update the refs mapping
          var id = docInfo.data._id;
          var rev = docInfo.data._rev;
          saveAttachmentRefs(id, rev, att.digest, attachmentSaved);
          continue;
        }
        var data;
        if (typeof att.data === 'string') {
          try {
            data = atob(att.data);
          } catch (e) {
            callback(errors.error(errors.BAD_ARG,
                     'Attachments need to be base64 encoded'));
            return;
          }
          doMD5(docInfo, key, attachmentSaved)(data);
        } else {
          prepareAttachmentForStorage(att.data,
            doMD5(docInfo, key, attachmentSaved));
        }
      }

      function finish() {
        var seq = docInfo.metadata.rev_map[docInfo.metadata.rev];
        /* istanbul ignore if */
        if (seq) {
          // check that there aren't any existing revisions with the same
          // revision id, else we shouldn't do anything
          return callback2();
        }
        seq = ++newUpdateSeq;
        docInfo.metadata.rev_map[docInfo.metadata.rev] =
          docInfo.metadata.seq = seq;
        var seqKey = formatSeq(seq);
        var batch = [{
          key: seqKey,
          value: docInfo.data,
          prefix: stores.bySeqStore,
          type: 'put'
        }, {
          key: docInfo.metadata.id,
          value: docInfo.metadata,
          prefix: stores.docStore,
          type: 'put'
        }];
        txn.batch(batch);
        results[resultsIdx] = {
          ok: true,
          id: docInfo.metadata.id,
          rev: winningRev
        };
        fetchedDocs.set(docInfo.metadata.id, docInfo.metadata);
        callback2();
      }

      if (!attachments.length) {
        finish();
      }
    }

    // attachments are queued per-digest, otherwise the refs could be
    // overwritten by concurrent writes in the same bulkDocs session
    var attachmentQueues = {};

    function saveAttachmentRefs(id, rev, digest, callback) {

      function fetchAtt() {
        return new Promise(function (resolve, reject) {
          txn.get(stores.attachmentStore, digest, function (err, oldAtt) {
            /* istanbul ignore if */
            if (err && err.name !== 'NotFoundError') {
              return reject(err);
            }
            resolve(oldAtt);
          });
        });
      }

      function saveAtt(oldAtt) {
        var ref = [id, rev].join('@');
        var newAtt = {};

        if (oldAtt) {
          if (oldAtt.refs) {
            // only update references if this attachment already has them
            // since we cannot migrate old style attachments here without
            // doing a full db scan for references
            newAtt.refs = oldAtt.refs;
            newAtt.refs[ref] = true;
          }
        } else {
          newAtt.refs = {};
          newAtt.refs[ref] = true;
        }

        return new Promise(function (resolve, reject) {
          txn.batch([{
            type: 'put',
            prefix: stores.attachmentStore,
            key: digest,
            value: newAtt
          }]);
          resolve(!oldAtt);
        });
      }

      // put attachments in a per-digest queue, to avoid two docs with the same
      // attachment overwriting each other
      var queue = attachmentQueues[digest] || Promise.resolve();
      attachmentQueues[digest] = queue.then(function () {
        return fetchAtt().then(saveAtt).then(function (isNewAttachment) {
          callback(null, isNewAttachment);
        }, callback);
      });
    }

    function saveAttachment(docInfo, digest, key, data, callback) {
      var att = docInfo.data._attachments[key];
      delete att.data;
      att.digest = digest;
      att.length = data.length;
      var id = docInfo.metadata.id;
      var rev = docInfo.metadata.rev;

      saveAttachmentRefs(id, rev, digest, function (err, isNewAttachment) {
        /* istanbul ignore if */
        if (err) {
          return callback(err);
        }
        // do not try to store empty attachments
        if (data.length === 0) {
          return callback(err);
        }
        if (!isNewAttachment) {
          // small optimization - don't bother writing it again
          return callback(err);
        }
        txn.batch([{
          type: 'put',
          prefix: stores.binaryStore,
          key: digest,
          value: new Buffer(data, 'binary')
        }]);
        callback();
      });
    }

    function complete(err) {
      /* istanbul ignore if */
      if (err) {
        return process.nextTick(function () {
          callback(err);
        });
      }
      txn.batch([
        {
          prefix: stores.metaStore,
          type: 'put',
          key: UPDATE_SEQ_KEY,
          value: newUpdateSeq
        },
        {
          prefix: stores.metaStore,
          type: 'put',
          key: DOC_COUNT_KEY,
          value: db._docCount + docCountDelta
        }
      ]);
      txn.execute(db, function (err) {
        /* istanbul ignore if */
        if (err) {
          return callback(err);
        }
        db._docCount += docCountDelta;
        db._updateSeq = newUpdateSeq;
        LevelPouch.Changes.notify(name);
        process.nextTick(function () {
          callback(null, results);
        });
      });
    }

    if (!docInfos.length) {
      return callback(null, []);
    }

    verifyAttachments(function (err) {
      if (err) {
        return callback(err);
      }
      fetchExistingDocs(function (err) {
        /* istanbul ignore if */
        if (err) {
          return callback(err);
        }
        processDocs(docInfos, api, fetchedDocs, txn, results, writeDoc,
          opts, finish);
      });
    });
  });
  api._allDocs = readLock(function (opts, callback) {
    opts = clone(opts);
    countDocs(function (err, docCount) {
      /* istanbul ignore if */
      if (err) {
        return callback(err);
      }
      var readstreamOpts = {};
      var skip = opts.skip || 0;
      if (opts.startkey) {
        readstreamOpts.gte = opts.startkey;
      }
      if (opts.endkey) {
        readstreamOpts.lte = opts.endkey;
      }
      if (opts.key) {
        readstreamOpts.gte = readstreamOpts.lte = opts.key;
      }
      if (opts.descending) {
        readstreamOpts.reverse = true;
        // switch start and ends
        var tmp = readstreamOpts.lte;
        readstreamOpts.lte = readstreamOpts.gte;
        readstreamOpts.gte = tmp;
      }
      var limit;
      if (typeof opts.limit === 'number') {
        limit = opts.limit;
      }
      if (limit === 0 ||
          ('start' in readstreamOpts && 'end' in readstreamOpts &&
          readstreamOpts.start > readstreamOpts.end)) {
        // should return 0 results when start is greater than end.
        // normally level would "fix" this for us by reversing the order,
        // so short-circuit instead
        return callback(null, {
          total_rows: docCount,
          offset: opts.skip,
          rows: []
        });
      }
      var results = [];
      var docstream = stores.docStore.readStream(readstreamOpts);

      var throughStream = through(function (entry, _, next) {
        var metadata = entry.value;
        // winningRev and deleted are performance-killers, but
        // in newer versions of PouchDB, they are cached on the metadata
        var winningRev = getWinningRev(metadata);
        var deleted = getIsDeleted(metadata, winningRev);
        if (!deleted) {
          if (skip-- > 0) {
            next();
            return;
          } else if (typeof limit === 'number' && limit-- <= 0) {
            docstream.unpipe();
            docstream.destroy();
            next();
            return;
          }
        } else if (opts.deleted !== 'ok') {
          next();
          return;
        }
        function allDocsInner(data) {
          var doc = {
            id: metadata.id,
            key: metadata.id,
            value: {
              rev: winningRev
            }
          };
          if (opts.include_docs) {
            if (data) {
              doc.doc = data;
              doc.doc._rev = doc.value.rev;
              if (opts.conflicts) {
                doc.doc._conflicts = collectConflicts(metadata);
              }
              for (var att in doc.doc._attachments) {
                if (doc.doc._attachments.hasOwnProperty(att)) {
                  doc.doc._attachments[att].stub = true;
                }
              }
            }
          }
          if (opts.inclusive_end === false && metadata.id === opts.endkey) {
            return next();
          } else if (deleted) {
            if (opts.deleted === 'ok') {
              doc.value.deleted = true;
              doc.doc = null;
            } else {
              /* istanbul ignore next */
              return next();
            }
          }
          results.push(doc);
          next();
        }
        if (opts.include_docs) {
          var seq = metadata.rev_map[winningRev];
          stores.bySeqStore.get(formatSeq(seq), function (err, data) {
            allDocsInner(data);
          });
        }
        else {
          allDocsInner();
        }
      }, function (next) {
        Promise.resolve().then(function () {
          if (opts.include_docs && opts.attachments){
            return fetchAttachments(results, stores, opts);
          }
        }).then(function () {
          callback(null, {
            total_rows: docCount,
            offset: opts.skip,
            rows: results
          });
        }, callback);
        next();
      }).on('unpipe', function () {
        throughStream.end();
      });

      docstream.on('error', callback);

      docstream.pipe(throughStream);
    });
  });

  api._changes = function (opts) {
    opts = clone(opts);

    if (opts.continuous) {
      var id = name + ':' + uuid();
      LevelPouch.Changes.addListener(name, id, api, opts);
      LevelPouch.Changes.notify(name);
      return {
        cancel: function () {
          LevelPouch.Changes.removeListener(name, id);
        }
      };
    }

    var descending = opts.descending;
    var results = [];
    var lastSeq = opts.since || 0;
    var called = 0;
    var streamOpts = {
      reverse: descending
    };
    var limit;
    if ('limit' in opts && opts.limit > 0) {
      limit = opts.limit;
    }
    if (!streamOpts.reverse) {
      streamOpts.start = formatSeq(opts.since || 0);
    }

    var docIds = opts.doc_ids && new collections.Set(opts.doc_ids);
    var filter = filterChange(opts);
    var docIdsToMetadata = new collections.Map();

    var returnDocs;
    if ('return_docs' in opts) {
      returnDocs = opts.return_docs;
    } else if ('returnDocs' in opts) {
      // TODO: Remove 'returnDocs' in favor of 'return_docs' in a future release
      returnDocs = opts.returnDocs;
    } else {
      returnDocs = true;
    }

    function complete() {
      opts.done = true;
      if (returnDocs && opts.limit) {
        /* istanbul ignore if */
        if (opts.limit < results.length) {
          results.length = opts.limit;
        }
      }
      changeStream.unpipe(throughStream);
      changeStream.destroy();
      if (!opts.continuous && !opts.cancelled) {
        if (opts.include_docs && opts.attachments) {
          fetchAttachments(results, stores, opts).then(function () {
            opts.complete(null, {results: results, last_seq: lastSeq});
          });
        } else {
          opts.complete(null, {results: results, last_seq: lastSeq});
        }
      }
    }
    var changeStream = stores.bySeqStore.readStream(streamOpts);
    var throughStream = through(function (data, _, next) {
      if (limit && called >= limit) {
        complete();
        return next();
      }
      if (opts.cancelled || opts.done) {
        return next();
      }

      var seq = parseSeq(data.key);
      var doc = data.value;

      if (seq === opts.since && !descending) {
        // couchdb ignores `since` if descending=true
        return next();
      }

      if (docIds && !docIds.has(doc._id)) {
        return next();
      }

      var metadata;

      function onGetMetadata(metadata) {
        var winningRev = getWinningRev(metadata);

        function onGetWinningDoc(winningDoc) {

          var change = opts.processChange(winningDoc, metadata, opts);
          change.seq = metadata.seq;

          var filtered = filter(change);
          if (typeof filtered === 'object') {
            return opts.complete(filtered);
          }

          if (filtered) {
            called++;

            if (opts.attachments && opts.include_docs) {
              // fetch attachment immediately for the benefit
              // of live listeners
              fetchAttachments([change], stores, opts).then(function () {
                opts.onChange(change);
              });
            } else {
              opts.onChange(change);
            }

            if (returnDocs) {
              results.push(change);
            }
          }
          next();
        }

        if (metadata.seq !== seq) {
          // some other seq is later
          return next();
        }

        lastSeq = seq;

        if (winningRev === doc._rev) {
          return onGetWinningDoc(doc);
        }

        // fetch the winner

        var winningSeq = metadata.rev_map[winningRev];

        stores.bySeqStore.get(formatSeq(winningSeq), function (err, doc) {
          onGetWinningDoc(doc);
        });
      }

      metadata = docIdsToMetadata.get(doc._id);
      if (metadata) { // cached
        return onGetMetadata(metadata);
      }
      // metadata not cached, have to go fetch it
      stores.docStore.get(doc._id, function (err, metadata) {
        /* istanbul ignore if */
        if (opts.cancelled || opts.done || db.isClosed() ||
          isLocalId(metadata.id)) {
          return next();
        }
        docIdsToMetadata.set(doc._id, metadata);
        onGetMetadata(metadata);
      });
    }, function (next) {
      if (opts.cancelled) {
        return next();
      }
      if (returnDocs && opts.limit) {
        /* istanbul ignore if */
        if (opts.limit < results.length) {
          results.length = opts.limit;
        }
      }

      next();
    }).on('unpipe', function () {
      throughStream.end();
      complete();
    });
    changeStream.pipe(throughStream);
    return {
      cancel: function () {
        opts.cancelled = true;
        complete();
      }
    };
  };

  api._close = function (callback) {
    /* istanbul ignore if */
    if (db.isClosed()) {
      return callback(errors.error(errors.NOT_OPEN));
    }
    db.close(function (err) {
      /* istanbul ignore if */
      if (err) {
        callback(err);
      } else {
        dbStore["delete"](name);
        callback();
      }
    });
  };

  api._getRevisionTree = function (docId, callback) {
    stores.docStore.get(docId, function (err, metadata) {
      if (err) {
        callback(errors.error(errors.MISSING_DOC));
      } else {
        callback(null, metadata.rev_tree);
      }
    });
  };

  api._doCompaction = writeLock(function (docId, revs, opts, callback) {
    api._doCompactionNoLock(docId, revs, opts, callback);
  });

  // the NoLock version is for use by bulkDocs
  api._doCompactionNoLock = function (docId, revs, opts, callback) {
    if (typeof opts === 'function') {
      callback = opts;
      opts = {};
    }

    if (!revs.length) {
      return callback();
    }
    var txn = opts.ctx || new LevelTransaction();

    txn.get(stores.docStore, docId, function (err, metadata) {
      /* istanbul ignore if */
      if (err) {
        return callback(err);
      }
      var seqs = metadata.rev_map; // map from rev to seq
      traverseRevTree(metadata.rev_tree, function (isLeaf, pos,
                                                         revHash, ctx, opts) {
        var rev = pos + '-' + revHash;
        if (revs.indexOf(rev) !== -1) {
          opts.status = 'missing';
        }
      });
      var batch = [];
      batch.push({
        key: metadata.id,
        value: metadata,
        type: 'put',
        prefix: stores.docStore
      });

      var digestMap = {};
      var numDone = 0;
      var overallErr;
      function checkDone(err) {
        /* istanbul ignore if */
        if (err) {
          overallErr = err;
        }
        if (++numDone === revs.length) { // done
          /* istanbul ignore if */
          if (overallErr) {
            return callback(overallErr);
          }
          deleteOrphanedAttachments();
        }
      }

      function finish(err) {
        /* istanbul ignore if */
        if (err) {
          return callback(err);
        }
        txn.batch(batch);
        if (opts.ctx) {
          // don't execute immediately
          return callback();
        }
        txn.execute(db, callback);
      }

      function deleteOrphanedAttachments() {
        var possiblyOrphanedAttachments = Object.keys(digestMap);
        if (!possiblyOrphanedAttachments.length) {
          return finish();
        }
        var numDone = 0;
        var overallErr;
        function checkDone(err) {
          /* istanbul ignore if */
          if (err) {
            overallErr = err;
          }
          if (++numDone === possiblyOrphanedAttachments.length) {
            finish(overallErr);
          }
        }
        var refsToDelete = new collections.Map();
        revs.forEach(function (rev) {
          refsToDelete.set(docId + '@' + rev, true);
        });
        possiblyOrphanedAttachments.forEach(function (digest) {
          txn.get(stores.attachmentStore, digest, function (err, attData) {
            /* istanbul ignore if */
            if (err) {
              if (err.name === 'NotFoundError') {
                return checkDone();
              } else {
                return checkDone(err);
              }
            }
            var refs = Object.keys(attData.refs || {}).filter(function (ref) {
              return !refsToDelete.has(ref);
            });
            var newRefs = {};
            refs.forEach(function (ref) {
              newRefs[ref] = true;
            });
            if (refs.length) { // not orphaned
              batch.push({
                key: digest,
                type: 'put',
                value: {refs: newRefs},
                prefix: stores.attachmentStore
              });
            } else { // orphaned, can safely delete
              batch = batch.concat([{
                key: digest,
                type: 'del',
                prefix: stores.attachmentStore
              }, {
                key: digest,
                type: 'del',
                prefix: stores.binaryStore
              }]);
            }
            checkDone();
          });
        });
      }

      revs.forEach(function (rev) {
        var seq = seqs[rev];
        batch.push({
          key: formatSeq(seq),
          type: 'del',
          prefix: stores.bySeqStore
        });
        txn.get(stores.bySeqStore, formatSeq(seq), function (err, doc) {
          /* istanbul ignore if */
          if (err) {
            if (err.name === 'NotFoundError') {
              return checkDone();
            } else {
              return checkDone(err);
            }
          }
          var atts = Object.keys(doc._attachments || {});
          atts.forEach(function (attName) {
            var digest = doc._attachments[attName].digest;
            digestMap[digest] = true;
          });
          checkDone();
        });
      });
    });
  };

  api._getLocal = function (id, callback) {
    stores.localStore.get(id, function (err, doc) {
      if (err) {
        callback(errors.error(errors.MISSING_DOC));
      } else {
        callback(null, doc);
      }
    });
  };

  api._putLocal = function (doc, opts, callback) {
    if (typeof opts === 'function') {
      callback = opts;
      opts = {};
    }
    if (opts.ctx) {
      api._putLocalNoLock(doc, opts, callback);
    } else {
      api._putLocalWithLock(doc, opts, callback);
    }
  };

  api._putLocalWithLock = writeLock(function (doc, opts, callback) {
    api._putLocalNoLock(doc, opts, callback);
  });

  // the NoLock version is for use by bulkDocs
  api._putLocalNoLock = function (doc, opts, callback) {
    delete doc._revisions; // ignore this, trust the rev
    var oldRev = doc._rev;
    var id = doc._id;

    var txn = opts.ctx || new LevelTransaction();

    txn.get(stores.localStore, id, function (err, resp) {
      if (err && oldRev) {
        return callback(errors.error(errors.REV_CONFLICT));
      }
      if (resp && resp._rev !== oldRev) {
        return callback(errors.error(errors.REV_CONFLICT));
      }
      doc._rev =
          oldRev ? '0-' + (parseInt(oldRev.split('-')[1], 10) + 1) : '0-1';
      var batch = [
        {
          type: 'put',
          prefix: stores.localStore,
          key: id,
          value: doc
        }
      ];

      txn.batch(batch);
      var ret = {ok: true, id: doc._id, rev: doc._rev};

      if (opts.ctx) {
        // don't execute immediately
        return callback(null, ret);
      }
      txn.execute(db, function (err) {
        /* istanbul ignore if */
        if (err) {
          return callback(err);
        }
        callback(null, ret);
      });
    });
  };

  api._removeLocal = function (doc, opts, callback) {
    if (typeof opts === 'function') {
      callback = opts;
      opts = {};
    }
    if (opts.ctx) {
      api._removeLocalNoLock(doc, opts, callback);
    } else {
      api._removeLocalWithLock(doc, opts, callback);
    }
  };

  api._removeLocalWithLock = writeLock(function (doc, opts, callback) {
    api._removeLocalNoLock(doc, opts, callback);
  });

  // the NoLock version is for use by bulkDocs
  api._removeLocalNoLock = function (doc, opts, callback) {
    var txn = opts.ctx || new LevelTransaction();
    txn.get(stores.localStore, doc._id, function (err, resp) {
      if (err) {
        /* istanbul ignore if */
        if (err.name !== 'NotFoundError') {
          return callback(err);
        } else {
          return callback(errors.error(errors.MISSING_DOC));
        }
      }
      if (resp._rev !== doc._rev) {
        return callback(errors.error(errors.REV_CONFLICT));
      }
      txn.batch([{
        prefix: stores.localStore,
        type: 'del',
        key: doc._id
      }]);
      var ret = {ok: true, id: doc._id, rev: '0-0'};
      if (opts.ctx) {
        // don't execute immediately
        return callback(null, ret);
      }
      txn.execute(db, function (err) {
        /* istanbul ignore if */
        if (err) {
          return callback(err);
        }
        callback(null, ret);
      });
    });
  };

  // close and delete open leveldb stores
  api._destroy = function (opts, callback) {
    var dbStore;
    var leveldownName = functionName(leveldown);
    /* istanbul ignore else */
    if (dbStores.has(leveldownName)) {
      dbStore = dbStores.get(leveldownName);
    } else {
      return callDestroy(name, callback);
    }

    /* istanbul ignore else */
    if (dbStore.has(name)) {
      LevelPouch.Changes.removeAllListeners(name);

      dbStore.get(name).close(function () {
        dbStore["delete"](name);
        callDestroy(name, callback);
      });
    } else {
      callDestroy(name, callback);
    }
  };
  function callDestroy(name, cb) {
    /* istanbul ignore else */
    if (typeof leveldown.destroy === 'function') {
      leveldown.destroy(name, cb);
    } else {
      process.nextTick(cb);
    }
  }
}

LevelPouch.valid = function () {
  // this gets overriden by the *down-based browser adapters
  return true;
};

LevelPouch.use_prefix = false;

LevelPouch.Changes = new Changes();

module.exports = LevelPouch;

}).call(this,_dereq_(57),_dereq_(50).Buffer)
},{"107":107,"11":11,"145":145,"158":158,"16":16,"17":17,"18":18,"19":19,"2":2,"20":20,"24":24,"25":25,"26":26,"27":27,"28":28,"30":30,"34":34,"35":35,"36":36,"39":39,"4":4,"40":40,"41":41,"43":43,"48":48,"49":49,"5":5,"50":50,"57":57,"6":6,"7":7,"75":75,"80":80,"9":9}],4:[function(_dereq_,module,exports){
'use strict';

var readAsBinaryString = _dereq_(15);

// In the browser, we store a binary string
module.exports = function prepareAttachmentForStorage(attData, cb) {
  readAsBinaryString(attData, cb);
};
},{"15":15}],5:[function(_dereq_,module,exports){
'use strict';

var createBlob = _dereq_(12);

module.exports = function readAsBlobOrBuffer(storedObject, type) {
  // In the browser, we've stored a binary string. This now comes back as a
  // browserified Node-style Buffer, but we want a Blob instead.
  return createBlob([storedObject.toArrayBuffer()], {type: type});
};
},{"12":12}],6:[function(_dereq_,module,exports){
(function (process){
'use strict';

// similar to an idb or websql transaction object
// designed to be passed around. basically just caches
// things in-memory and then does a big batch() operation
// when you're done

var collections = _dereq_(145);

function getCacheFor(transaction, store) {
  var prefix = store.prefix()[0];
  var cache = transaction._cache;
  var subCache = cache.get(prefix);
  if (!subCache) {
    subCache = new collections.Map();
    cache.set(prefix, subCache);
  }
  return subCache;
}

function LevelTransaction() {
  this._batch = [];
  this._cache = new collections.Map();
}

LevelTransaction.prototype.get = function (store, key, callback) {
  var cache = getCacheFor(this, store);
  var exists = cache.get(key);
  if (exists) {
    return process.nextTick(function () {
      callback(null, exists);
    });
  } else if (exists === null) { // deleted marker
    /* istanbul ignore next */
    return process.nextTick(function () {
      callback({name: 'NotFoundError'});
    });
  }
  store.get(key, function (err, res) {
    if (err) {
      /* istanbul ignore else */
      if (err.name === 'NotFoundError') {
        cache.set(key, null);
      }
      return callback(err);
    }
    cache.set(key, res);
    callback(null, res);
  });
};

LevelTransaction.prototype.batch = function (batch) {
  for (var i = 0, len = batch.length; i < len; i++) {
    var operation = batch[i];

    var cache = getCacheFor(this, operation.prefix);

    if (operation.type === 'put') {
      cache.set(operation.key, operation.value);
    } else {
      cache.set(operation.key, null);
    }
  }
  this._batch = this._batch.concat(batch);
};

LevelTransaction.prototype.execute = function (db, callback) {

  var keys = new collections.Set();
  var uniqBatches = [];

  // remove duplicates; last one wins
  for (var i = this._batch.length - 1; i >= 0; i--) {
    var operation = this._batch[i];
    var lookupKey = operation.prefix.prefix()[0] + '\xff' + operation.key;
    if (keys.has(lookupKey)) {
      continue;
    }
    keys.add(lookupKey);
    uniqBatches.push(operation);
  }

  db.batch(uniqBatches, callback);
};

module.exports = LevelTransaction;

}).call(this,_dereq_(57))
},{"145":145,"57":57}],7:[function(_dereq_,module,exports){
'use strict';

var EventEmitter = _dereq_(54).EventEmitter;
var inherits = _dereq_(76);
var isChromeApp = _dereq_(23);
var hasLocalStorage = _dereq_(22);
var pick = _dereq_(38);

inherits(Changes, EventEmitter);

/* istanbul ignore next */
function attachBrowserEvents(self) {
  if (isChromeApp()) {
    chrome.storage.onChanged.addListener(function (e) {
      // make sure it's event addressed to us
      if (e.db_name != null) {
        //object only has oldValue, newValue members
        self.emit(e.dbName.newValue);
      }
    });
  } else if (hasLocalStorage()) {
    if (typeof addEventListener !== 'undefined') {
      addEventListener("storage", function (e) {
        self.emit(e.key);
      });
    } else { // old IE
      window.attachEvent("storage", function (e) {
        self.emit(e.key);
      });
    }
  }
}

function Changes() {
  EventEmitter.call(this);
  this._listeners = {};

  attachBrowserEvents(this);
}
Changes.prototype.addListener = function (dbName, id, db, opts) {
  /* istanbul ignore if */
  if (this._listeners[id]) {
    return;
  }
  var self = this;
  var inprogress = false;
  function eventFunction() {
    /* istanbul ignore if */
    if (!self._listeners[id]) {
      return;
    }
    if (inprogress) {
      inprogress = 'waiting';
      return;
    }
    inprogress = true;
    var changesOpts = pick(opts, [
      'style', 'include_docs', 'attachments', 'conflicts', 'filter',
      'doc_ids', 'view', 'since', 'query_params', 'binary'
    ]);

    db.changes(changesOpts).on('change', function (c) {
      if (c.seq > opts.since && !opts.cancelled) {
        opts.since = c.seq;
        opts.onChange(c);
      }
    }).on('complete', function () {
      if (inprogress === 'waiting') {
        setTimeout(function(){
          eventFunction();
        },0);
      }
      inprogress = false;
    }).on('error', function () {
      /* istanbul ignore next */
      inprogress = false;
    });
  }
  this._listeners[id] = eventFunction;
  this.on(dbName, eventFunction);
};

Changes.prototype.removeListener = function (dbName, id) {
  /* istanbul ignore if */
  if (!(id in this._listeners)) {
    return;
  }
  EventEmitter.prototype.removeListener.call(this, dbName,
    this._listeners[id]);
};


/* istanbul ignore next */
Changes.prototype.notifyLocalWindows = function (dbName) {
  //do a useless change on a storage thing
  //in order to get other windows's listeners to activate
  if (isChromeApp()) {
    chrome.storage.local.set({dbName: dbName});
  } else if (hasLocalStorage()) {
    localStorage[dbName] = (localStorage[dbName] === "a") ? "b" : "a";
  }
};

Changes.prototype.notify = function (dbName) {
  this.emit(dbName);
  this.notifyLocalWindows(dbName);
};

module.exports = Changes;

},{"22":22,"23":23,"38":38,"54":54,"76":76}],8:[function(_dereq_,module,exports){
'use strict';

//Can't find original post, but this is close
//http://stackoverflow.com/questions/6965107/ (continues on next line)
//converting-between-strings-and-arraybuffers
module.exports = function (buffer) {
  var binary = '';
  var bytes = new Uint8Array(buffer);
  var length = bytes.byteLength;
  for (var i = 0; i < length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return binary;
};
},{}],9:[function(_dereq_,module,exports){
'use strict';

exports.atob = function (str) {
  return atob(str);
};
exports.btoa = function (str) {
  return btoa(str);
};
},{}],10:[function(_dereq_,module,exports){
'use strict';

// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
module.exports = function (bin) {
  var length = bin.length;
  var buf = new ArrayBuffer(length);
  var arr = new Uint8Array(buf);
  for (var i = 0; i < length; i++) {
    arr[i] = bin.charCodeAt(i);
  }
  return buf;
};
},{}],11:[function(_dereq_,module,exports){
'use strict';

var createBlob = _dereq_(12);
var binaryStringToArrayBuffer = _dereq_(10);

module.exports = function (binString, type) {
  return createBlob([binaryStringToArrayBuffer(binString)], {type: type});
};
},{"10":10,"12":12}],12:[function(_dereq_,module,exports){
"use strict";

// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor (e.g.
// old QtWebKit versions, Android < 4.4).
function createBlob(parts, properties) {
  /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
  parts = parts || [];
  properties = properties || {};
  try {
    return new Blob(parts, properties);
  } catch (e) {
    if (e.name !== "TypeError") {
      throw e;
    }
    var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder :
                  typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder :
                  typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder :
                  WebKitBlobBuilder;
    var builder = new Builder();
    for (var i = 0; i < parts.length; i += 1) {
      builder.append(parts[i]);
    }
    return builder.getBlob(properties.type);
  }
}

module.exports = createBlob;


},{}],13:[function(_dereq_,module,exports){
'use strict';

function cloneArrayBuffer(buff) {
  if (typeof buff.slice === 'function') {
    return buff.slice(0);
  }
  // IE10-11 slice() polyfill
  var target = new ArrayBuffer(buff.byteLength);
  var targetArray = new Uint8Array(target);
  var sourceArray = new Uint8Array(buff);
  targetArray.set(sourceArray);
  return target;
}

module.exports = function cloneBinaryObject(object) {
  if (object instanceof ArrayBuffer) {
    return cloneArrayBuffer(object);
  }
  var size = object.size;
  var type = object.type;
  // Blob
  if (typeof object.slice === 'function') {
    return object.slice(0, size, type);
  }
  // PhantomJS slice() replacement
  return object.webkitSlice(0, size, type);
};

},{}],14:[function(_dereq_,module,exports){
'use strict';

module.exports = function isBinaryObject(object) {
  return object instanceof ArrayBuffer ||
    (typeof Blob !== 'undefined' && object instanceof Blob);
};
},{}],15:[function(_dereq_,module,exports){
'use strict';

var arrayBufferToBinaryString = _dereq_(8);

// shim for browsers that don't support it
module.exports = function (blob, callback) {
  if (typeof FileReader === 'undefined') {
    // fix for Firefox in a web worker
    // https://bugzilla.mozilla.org/show_bug.cgi?id=901097
    return callback(arrayBufferToBinaryString(
      new FileReaderSync().readAsArrayBuffer(blob)));
  }

  var reader = new FileReader();
  var hasBinaryString = typeof reader.readAsBinaryString === 'function';
  reader.onloadend = function (e) {
    var result = e.target.result || '';
    if (hasBinaryString) {
      return callback(result);
    }
    callback(arrayBufferToBinaryString(result));
  };
  if (hasBinaryString) {
    reader.readAsBinaryString(blob);
  } else {
    reader.readAsArrayBuffer(blob);
  }
};
},{"8":8}],16:[function(_dereq_,module,exports){
'use strict';

var isBinaryObject = _dereq_(14);
var cloneBinaryObject = _dereq_(13);

module.exports = function clone(object) {
  var newObject;
  var i;
  var len;

  if (!object || typeof object !== 'object') {
    return object;
  }

  if (Array.isArray(object)) {
    newObject = [];
    for (i = 0, len = object.length; i < len; i++) {
      newObject[i] = clone(object[i]);
    }
    return newObject;
  }

  // special case: to avoid inconsistencies between IndexedDB
  // and other backends, we automatically stringify Dates
  if (object instanceof Date) {
    return object.toISOString();
  }

  if (isBinaryObject(object)) {
    return cloneBinaryObject(object);
  }

  newObject = {};
  for (i in object) {
    if (Object.prototype.hasOwnProperty.call(object, i)) {
      var value = clone(object[i]);
      if (typeof value !== 'undefined') {
        newObject[i] = value;
      }
    }
  }
  return newObject;
};

},{"13":13,"14":14}],17:[function(_dereq_,module,exports){
'use strict';

var winningRev = _dereq_(35);

function getTrees(node) {
  return node.ids;
}

// check if a specific revision of a doc has been deleted
//  - metadata: the metadata object from the doc store
//  - rev: (optional) the revision to check. defaults to winning revision
function isDeleted(metadata, rev) {
  if (!rev) {
    rev = winningRev(metadata);
  }
  var id = rev.substring(rev.indexOf('-') + 1);
  var toVisit = metadata.rev_tree.map(getTrees);

  var tree;
  while ((tree = toVisit.pop())) {
    if (tree[0] === id) {
      return !!tree[1].deleted;
    }
    toVisit = toVisit.concat(tree[2]);
  }
}

module.exports = isDeleted;
},{"35":35}],18:[function(_dereq_,module,exports){
'use strict';

function isLocalId(id) {
  return (/^_local/).test(id);
}

module.exports = isLocalId;
},{}],19:[function(_dereq_,module,exports){
'use strict';

var errors = _dereq_(24);
var uuid = _dereq_(43);

function toObject(array) {
  return array.reduce(function (obj, item) {
    obj[item] = true;
    return obj;
  }, {});
}
// List of top level reserved words for doc
var reservedWords = toObject([
  '_id',
  '_rev',
  '_attachments',
  '_deleted',
  '_revisions',
  '_revs_info',
  '_conflicts',
  '_deleted_conflicts',
  '_local_seq',
  '_rev_tree',
  //replication documents
  '_replication_id',
  '_replication_state',
  '_replication_state_time',
  '_replication_state_reason',
  '_replication_stats',
  // Specific to Couchbase Sync Gateway
  '_removed'
]);

// List of reserved words that should end up the document
var dataWords = toObject([
  '_attachments',
  //replication documents
  '_replication_id',
  '_replication_state',
  '_replication_state_time',
  '_replication_state_reason',
  '_replication_stats'
]);

// Determine id an ID is valid
//   - invalid IDs begin with an underescore that does not begin '_design' or
//     '_local'
//   - any other string value is a valid id
// Returns the specific error object for each case
exports.invalidIdError = function (id) {
  var err;
  if (!id) {
    err = errors.error(errors.MISSING_ID);
  } else if (typeof id !== 'string') {
    err = errors.error(errors.INVALID_ID);
  } else if (/^_/.test(id) && !(/^_(design|local)/).test(id)) {
    err = errors.error(errors.RESERVED_ID);
  }
  if (err) {
    throw err;
  }
};

function parseRevisionInfo(rev) {
  if (!/^\d+\-./.test(rev)) {
    return errors.error(errors.INVALID_REV);
  }
  var idx = rev.indexOf('-');
  var left = rev.substring(0, idx);
  var right = rev.substring(idx + 1);
  return {
    prefix: parseInt(left, 10),
    id: right
  };
}

function makeRevTreeFromRevisions(revisions, opts) {
  var pos = revisions.start - revisions.ids.length + 1;

  var revisionIds = revisions.ids;
  var ids = [revisionIds[0], opts, []];

  for (var i = 1, len = revisionIds.length; i < len; i++) {
    ids = [revisionIds[i], {status: 'missing'}, [ids]];
  }

  return [{
    pos: pos,
    ids: ids
  }];
}

// Preprocess documents, parse their revisions, assign an id and a
// revision for new writes that are missing them, etc
exports.parseDoc = function (doc, newEdits) {

  var nRevNum;
  var newRevId;
  var revInfo;
  var opts = {status: 'available'};
  if (doc._deleted) {
    opts.deleted = true;
  }

  if (newEdits) {
    if (!doc._id) {
      doc._id = uuid();
    }
    newRevId = uuid(32, 16).toLowerCase();
    if (doc._rev) {
      revInfo = parseRevisionInfo(doc._rev);
      if (revInfo.error) {
        return revInfo;
      }
      doc._rev_tree = [{
        pos: revInfo.prefix,
        ids: [revInfo.id, {status: 'missing'}, [[newRevId, opts, []]]]
      }];
      nRevNum = revInfo.prefix + 1;
    } else {
      doc._rev_tree = [{
        pos: 1,
        ids : [newRevId, opts, []]
      }];
      nRevNum = 1;
    }
  } else {
    if (doc._revisions) {
      doc._rev_tree = makeRevTreeFromRevisions(doc._revisions, opts);
      nRevNum = doc._revisions.start;
      newRevId = doc._revisions.ids[0];
    }
    if (!doc._rev_tree) {
      revInfo = parseRevisionInfo(doc._rev);
      if (revInfo.error) {
        return revInfo;
      }
      nRevNum = revInfo.prefix;
      newRevId = revInfo.id;
      doc._rev_tree = [{
        pos: nRevNum,
        ids: [newRevId, opts, []]
      }];
    }
  }

  exports.invalidIdError(doc._id);

  doc._rev = nRevNum + '-' + newRevId;

  var result = {metadata : {}, data : {}};
  for (var key in doc) {
    /* istanbul ignore else */
    if (Object.prototype.hasOwnProperty.call(doc, key)) {
      var specialKey = key[0] === '_';
      if (specialKey && !reservedWords[key]) {
        var error = errors.error(errors.DOC_VALIDATION, key);
        error.message = errors.DOC_VALIDATION.message + ': ' + key;
        throw error;
      } else if (specialKey && !dataWords[key]) {
        result.metadata[key.slice(1)] = doc[key];
      } else {
        result.data[key] = doc[key];
      }
    }
  }
  return result;
};

},{"24":24,"43":43}],20:[function(_dereq_,module,exports){
'use strict';

var errors = _dereq_(24);
var updateDoc = _dereq_(21);
var isDeleted = _dereq_(17);
var isLocalId = _dereq_(18);
var calculateWinningRev = _dereq_(35);
var merge = _dereq_(31);
var collections = _dereq_(145);
var Map = collections.Map;

function processDocs(docInfos, api, fetchedDocs, tx, results, writeDoc, opts,
                     overallCallback) {

  function insertDoc(docInfo, resultsIdx, callback) {
    // Cant insert new deleted documents
    var winningRev = calculateWinningRev(docInfo.metadata);
    var deleted = isDeleted(docInfo.metadata, winningRev);
    if ('was_delete' in opts && deleted) {
      results[resultsIdx] = errors.error(errors.MISSING_DOC, 'deleted');
      return callback();
    }

    var delta = deleted ? 0 : 1;

    writeDoc(docInfo, winningRev, deleted, deleted, false,
      delta, resultsIdx, callback);
  }

  var newEdits = opts.new_edits;
  var idsToDocs = new Map();

  var docsDone = 0;
  var docsToDo = docInfos.length;

  function checkAllDocsDone() {
    if (++docsDone === docsToDo && overallCallback) {
      overallCallback();
    }
  }

  docInfos.forEach(function (currentDoc, resultsIdx) {

    if (currentDoc._id && isLocalId(currentDoc._id)) {
      var fun = currentDoc._deleted ? '_removeLocal' : '_putLocal';
      api[fun](currentDoc, {ctx: tx}, function (err, res) {
        results[resultsIdx] = err || res;
        checkAllDocsDone();
      });
      return;
    }

    var id = currentDoc.metadata.id;
    if (idsToDocs.has(id)) {
      docsToDo--; // duplicate
      idsToDocs.get(id).push([currentDoc, resultsIdx]);
    } else {
      idsToDocs.set(id, [[currentDoc, resultsIdx]]);
    }
  });

  // in the case of new_edits, the user can provide multiple docs
  // with the same id. these need to be processed sequentially
  idsToDocs.forEach(function (docs, id) {
    var numDone = 0;

    function docWritten() {
      if (++numDone < docs.length) {
        nextDoc();
      } else {
        checkAllDocsDone();
      }
    }
    function nextDoc() {
      var value = docs[numDone];
      var currentDoc = value[0];
      var resultsIdx = value[1];

      if (fetchedDocs.has(id)) {
        updateDoc(fetchedDocs.get(id), currentDoc, results,
          resultsIdx, docWritten, writeDoc, newEdits);
      } else {
        // Ensure stemming applies to new writes as well
        var merged = merge([], currentDoc.metadata.rev_tree[0], 1000);
        currentDoc.metadata.rev_tree = merged.tree;
        insertDoc(currentDoc, resultsIdx, docWritten);
      }
    }
    nextDoc();
  });
}

module.exports = processDocs;

},{"145":145,"17":17,"18":18,"21":21,"24":24,"31":31,"35":35}],21:[function(_dereq_,module,exports){
'use strict';

var errors = _dereq_(24);
var isDeleted = _dereq_(17);
var parseDoc = _dereq_(19).parseDoc;
var calculateWinningRev = _dereq_(35);
var merge = _dereq_(31);
var revExists = _dereq_(32);

function updateDoc(prev, docInfo, results, i, cb, writeDoc, newEdits) {

  if (revExists(prev.rev_tree, docInfo.metadata.rev)) {
    results[i] = docInfo;
    return cb();
  }

  // sometimes this is pre-calculated. historically not always
  var previousWinningRev = prev.winningRev || calculateWinningRev(prev);
  var previouslyDeleted = 'deleted' in prev ? prev.deleted :
    isDeleted(prev, previousWinningRev);
  var deleted = 'deleted' in docInfo.metadata ? docInfo.metadata.deleted :
    isDeleted(docInfo.metadata);
  var isRoot = /^1-/.test(docInfo.metadata.rev);

  if (previouslyDeleted && !deleted && newEdits && isRoot) {
    var newDoc = docInfo.data;
    newDoc._rev = previousWinningRev;
    newDoc._id = docInfo.metadata.id;
    docInfo = parseDoc(newDoc, newEdits);
  }

  var merged = merge(prev.rev_tree, docInfo.metadata.rev_tree[0], 1000);

  var inConflict = newEdits && (((previouslyDeleted && deleted) ||
    (!previouslyDeleted && merged.conflicts !== 'new_leaf') ||
    (previouslyDeleted && !deleted && merged.conflicts === 'new_branch')));

  if (inConflict) {
    var err = errors.error(errors.REV_CONFLICT);
    results[i] = err;
    return cb();
  }

  var newRev = docInfo.metadata.rev;
  docInfo.metadata.rev_tree = merged.tree;
  /* istanbul ignore else */
  if (prev.rev_map) {
    docInfo.metadata.rev_map = prev.rev_map; // used only by leveldb
  }

  // recalculate
  var winningRev = calculateWinningRev(docInfo.metadata);
  var winningRevIsDeleted = isDeleted(docInfo.metadata, winningRev);

  // calculate the total number of documents that were added/removed,
  // from the perspective of total_rows/doc_count
  var delta = (previouslyDeleted === winningRevIsDeleted) ? 0 :
    previouslyDeleted < winningRevIsDeleted ? -1 : 1;

  var newRevIsDeleted;
  if (newRev === winningRev) {
    // if the new rev is the same as the winning rev, we can reuse that value
    newRevIsDeleted = winningRevIsDeleted;
  } else {
    // if they're not the same, then we need to recalculate
    newRevIsDeleted = isDeleted(docInfo.metadata, newRev);
  }

  writeDoc(docInfo, winningRev, winningRevIsDeleted, newRevIsDeleted,
    true, delta, i, cb);
}

module.exports = updateDoc;
},{"17":17,"19":19,"24":24,"31":31,"32":32,"35":35}],22:[function(_dereq_,module,exports){
'use strict';

var isChromeApp = _dereq_(23);

var hasLocal;

if (isChromeApp()) {
  hasLocal = false;
} else {
  try {
    localStorage.setItem('_pouch_check_localstorage', 1);
    hasLocal = !!localStorage.getItem('_pouch_check_localstorage');
  } catch (e) {
    hasLocal = false;
  }
}

module.exports = function hasLocalStorage() {
  return hasLocal;
};
},{"23":23}],23:[function(_dereq_,module,exports){
'use strict';

module.exports = function isChromeApp() {
  return (typeof chrome !== "undefined" &&
    typeof chrome.storage !== "undefined" &&
    typeof chrome.storage.local !== "undefined");
};
},{}],24:[function(_dereq_,module,exports){
"use strict";

var inherits = _dereq_(76);
inherits(PouchError, Error);

function PouchError(opts) {
  Error.call(this, opts.reason);
  this.status = opts.status;
  this.name = opts.error;
  this.message = opts.reason;
  this.error = true;
}

PouchError.prototype.toString = function () {
  return JSON.stringify({
    status: this.status,
    name: this.name,
    message: this.message,
    reason: this.reason
  });
};

exports.UNAUTHORIZED = new PouchError({
  status: 401,
  error: 'unauthorized',
  reason: "Name or password is incorrect."
});

exports.MISSING_BULK_DOCS = new PouchError({
  status: 400,
  error: 'bad_request',
  reason: "Missing JSON list of 'docs'"
});

exports.MISSING_DOC = new PouchError({
  status: 404,
  error: 'not_found',
  reason: 'missing'
});

exports.REV_CONFLICT = new PouchError({
  status: 409,
  error: 'conflict',
  reason: 'Document update conflict'
});

exports.INVALID_ID = new PouchError({
  status: 400,
  error: 'invalid_id',
  reason: '_id field must contain a string'
});

exports.MISSING_ID = new PouchError({
  status: 412,
  error: 'missing_id',
  reason: '_id is required for puts'
});

exports.RESERVED_ID = new PouchError({
  status: 400,
  error: 'bad_request',
  reason: 'Only reserved document ids may start with underscore.'
});

exports.NOT_OPEN = new PouchError({
  status: 412,
  error: 'precondition_failed',
  reason: 'Database not open'
});

exports.UNKNOWN_ERROR = new PouchError({
  status: 500,
  error: 'unknown_error',
  reason: 'Database encountered an unknown error'
});

exports.BAD_ARG = new PouchError({
  status: 500,
  error: 'badarg',
  reason: 'Some query argument is invalid'
});

exports.INVALID_REQUEST = new PouchError({
  status: 400,
  error: 'invalid_request',
  reason: 'Request was invalid'
});

exports.QUERY_PARSE_ERROR = new PouchError({
  status: 400,
  error: 'query_parse_error',
  reason: 'Some query parameter is invalid'
});

exports.DOC_VALIDATION = new PouchError({
  status: 500,
  error: 'doc_validation',
  reason: 'Bad special document member'
});

exports.BAD_REQUEST = new PouchError({
  status: 400,
  error: 'bad_request',
  reason: 'Something wrong with the request'
});

exports.NOT_AN_OBJECT = new PouchError({
  status: 400,
  error: 'bad_request',
  reason: 'Document must be a JSON object'
});

exports.DB_MISSING = new PouchError({
  status: 404,
  error: 'not_found',
  reason: 'Database not found'
});

exports.IDB_ERROR = new PouchError({
  status: 500,
  error: 'indexed_db_went_bad',
  reason: 'unknown'
});

exports.WSQ_ERROR = new PouchError({
  status: 500,
  error: 'web_sql_went_bad',
  reason: 'unknown'
});

exports.LDB_ERROR = new PouchError({
  status: 500,
  error: 'levelDB_went_went_bad',
  reason: 'unknown'
});

exports.FORBIDDEN = new PouchError({
  status: 403,
  error: 'forbidden',
  reason: 'Forbidden by design doc validate_doc_update function'
});

exports.INVALID_REV = new PouchError({
  status: 400,
  error: 'bad_request',
  reason: 'Invalid rev format'
});

exports.FILE_EXISTS = new PouchError({
  status: 412,
  error: 'file_exists',
  reason: 'The database could not be created, the file already exists.'
});

exports.MISSING_STUB = new PouchError({
  status: 412,
  error: 'missing_stub'
});

exports.error = function (error, reason, name) {
  function CustomPouchError(reason) {
    // inherit error properties from our parent error manually
    // so as to allow proper JSON parsing.
    /* jshint ignore:start */
    for (var p in error) {
      if (typeof error[p] !== 'function') {
        this[p] = error[p];
      }
    }
    /* jshint ignore:end */
    if (name !== undefined) {
      this.name = name;
    }
    if (reason !== undefined) {
      this.reason = reason;
    }
  }
  CustomPouchError.prototype = PouchError.prototype;
  return new CustomPouchError(reason);
};

// Find one of the errors defined above based on the value
// of the specified property.
// If reason is provided prefer the error matching that reason.
// This is for differentiating between errors with the same name and status,
// eg, bad_request.
exports.getErrorTypeByProp = function (prop, value, reason) {
  var errors = exports;
  var keys = Object.keys(errors).filter(function (key) {
    var error = errors[key];
    return typeof error !== 'function' && error[prop] === value;
  });
  var key = reason && keys.filter(function (key) {
        var error = errors[key];
        return error.message === reason;
      })[0] || keys[0];
  return (key) ? errors[key] : null;
};

exports.generateErrorFromResponse = function (res) {
  var error, errName, errType, errMsg, errReason;
  var errors = exports;

  errName = (res.error === true && typeof res.name === 'string') ?
              res.name :
              res.error;
  errReason = res.reason;
  errType = errors.getErrorTypeByProp('name', errName, errReason);

  if (res.missing ||
      errReason === 'missing' ||
      errReason === 'deleted' ||
      errName === 'not_found') {
    errType = errors.MISSING_DOC;
  } else if (errName === 'doc_validation') {
    // doc validation needs special treatment since
    // res.reason depends on the validation error.
    // see utils.js
    errType = errors.DOC_VALIDATION;
    errMsg = errReason;
  } else if (errName === 'bad_request' && errType.message !== errReason) {
    // if bad_request error already found based on reason don't override.
    errType = errors.BAD_REQUEST;
  }

  // fallback to error by status or unknown error.
  if (!errType) {
    errType = errors.getErrorTypeByProp('status', res.status, errReason) ||
                errors.UNKNOWN_ERROR;
  }

  error = errors.error(errType, errReason, errName);

  // Keep custom message.
  if (errMsg) {
    error.message = errMsg;
  }

  // Keep helpful response data in our error messages.
  if (res.id) {
    error.id = res.id;
  }
  if (res.status) {
    error.status = res.status;
  }
  if (res.missing) {
    error.missing = res.missing;
  }

  return error;
};

},{"76":76}],25:[function(_dereq_,module,exports){
'use strict';

var errors = _dereq_(24);

function tryFilter(filter, doc, req) {
  try {
    return !filter(doc, req);
  } catch (err) {
    var msg = 'Filter function threw: ' + err.toString();
    return errors.error(errors.BAD_REQUEST, msg);
  }
}

module.exports = function filterChange(opts) {
  var req = {};
  var hasFilter = opts.filter && typeof opts.filter === 'function';
  req.query = opts.query_params;

  return function filter(change) {
    if (!change.doc) {
      // CSG sends events on the changes feed that don't have documents,
      // this hack makes a whole lot of existing code robust.
      change.doc = {};
    }

    var filterReturn = hasFilter && tryFilter(opts.filter, change.doc, req);

    if (typeof filterReturn === 'object') {
      return filterReturn;
    }

    if (filterReturn) {
      return false;
    }

    if (!opts.include_docs) {
      delete change.doc;
    } else if (!opts.attachments) {
      for (var att in change.doc._attachments) {
        /* istanbul ignore else */
        if (change.doc._attachments.hasOwnProperty(att)) {
          change.doc._attachments[att].stub = true;
        }
      }
    }
    return true;
  };
};
},{"24":24}],26:[function(_dereq_,module,exports){
'use strict';

// shim for Function.prototype.name,
// for browsers that don't support it like IE

// We dont run coverage in IE
/* istanbul ignore else */
if ((function f() {}).name) {
  module.exports = function (fun) {
    return fun.name;
  };
} else {
  module.exports = function (fun) {
    return fun.toString().match(/^\s*function\s*(\S*)\s*\(/)[1];
  };
}

},{}],27:[function(_dereq_,module,exports){
(function (global){
'use strict';

var toPromise = _dereq_(42);
var base64 = _dereq_(9);
var Md5 = _dereq_(146);
var setImmediateShim = global.setImmediate || global.setTimeout;
var MD5_CHUNK_SIZE = 32768;

// convert a 64-bit int to a binary string
function intToString(int) {
  return String.fromCharCode(int & 0xff) +
    String.fromCharCode((int >>> 8) & 0xff) +
    String.fromCharCode((int >>> 16) & 0xff) +
    String.fromCharCode((int >>> 24) & 0xff);
}

// convert an array of 64-bit ints into
// a base64-encoded string
function rawToBase64(raw) {
  var res = '';
  for (var i = 0, len = raw.length; i < len; i++) {
    res += intToString(raw[i]);
  }
  return base64.btoa(res);
}

function appendBuffer(buffer, data, start, end) {
  if (start > 0 || end < data.byteLength) {
    // only create a subarray if we really need to
    data = new Uint8Array(data, start,
      Math.min(end, data.byteLength) - start);
  }
  buffer.append(data);
}

function appendString(buffer, data, start, end) {
  if (start > 0 || end < data.length) {
    // only create a substring if we really need to
    data = data.substring(start, end);
  }
  buffer.appendBinary(data);
}

module.exports = toPromise(function (data, callback) {
  var inputIsString = typeof data === 'string';
  var len = inputIsString ? data.length : data.byteLength;
  var chunkSize = Math.min(MD5_CHUNK_SIZE, len);
  var chunks = Math.ceil(len / chunkSize);
  var currentChunk = 0;
  var buffer = inputIsString ? new Md5() : new Md5.ArrayBuffer();

  var append = inputIsString ? appendString : appendBuffer;

  function loadNextChunk() {
    var start = currentChunk * chunkSize;
    var end = start + chunkSize;
    currentChunk++;
    if (currentChunk < chunks) {
      append(buffer, data, start, end);
      setImmediateShim(loadNextChunk);
    } else {
      append(buffer, data, start, end);
      var raw = buffer.end(true);
      var base64 = rawToBase64(raw);
      callback(null, base64);
      buffer.destroy();
    }
  }
  loadNextChunk();
});

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"146":146,"42":42,"9":9}],28:[function(_dereq_,module,exports){
'use strict';

var winningRev = _dereq_(35);
var collectLeaves = _dereq_(29);

// returns revs of all conflicts that is leaves such that
// 1. are not deleted and
// 2. are different than winning revision
module.exports = function collectConflicts(metadata) {
  var win = winningRev(metadata);
  var leaves = collectLeaves(metadata.rev_tree);
  var conflicts = [];
  for (var i = 0, len = leaves.length; i < len; i++) {
    var leaf = leaves[i];
    if (leaf.rev !== win && !leaf.opts.deleted) {
      conflicts.push(leaf.rev);
    }
  }
  return conflicts;
};
},{"29":29,"35":35}],29:[function(_dereq_,module,exports){
'use strict';

var traverseRevTree = _dereq_(34);

function sortByPos(a, b) {
  return a.pos - b.pos;
}

module.exports = function collectLeaves(revs) {
  var leaves = [];
  traverseRevTree(revs, function (isLeaf, pos, id, acc, opts) {
    if (isLeaf) {
      leaves.push({rev: pos + "-" + id, pos: pos, opts: opts});
    }
  });
  leaves.sort(sortByPos).reverse();
  for (var i = 0, len = leaves.length; i < len; i++) {
    delete leaves[i].pos;
  }
  return leaves;
};
},{"34":34}],30:[function(_dereq_,module,exports){
'use strict';

var traverseRevTree = _dereq_(34);
// compact a tree by marking its non-leafs as missing,
// and return a list of revs to delete
module.exports = function compactTree(metadata) {
  var revs = [];
  traverseRevTree(metadata.rev_tree, function (isLeaf, pos,
                                               revHash, ctx, opts) {
    if (opts.status === 'available' && !isLeaf) {
      revs.push(pos + '-' + revHash);
      opts.status = 'missing';
    }
  });
  return revs;
};
},{"34":34}],31:[function(_dereq_,module,exports){
'use strict';

// for a better overview of what this is doing, read:
// https://github.com/apache/couchdb/blob/master/src/couchdb/couch_key_tree.erl
//
// But for a quick intro, CouchDB uses a revision tree to store a documents
// history, A -> B -> C, when a document has conflicts, that is a branch in the
// tree, A -> (B1 | B2 -> C), We store these as a nested array in the format
//
// KeyTree = [Path ... ]
// Path = {pos: position_from_root, ids: Tree}
// Tree = [Key, Opts, [Tree, ...]], in particular single node: [Key, []]

var rootToLeaf = _dereq_(33);

function sortByPos(a, b) {
  return a.pos - b.pos;
}

// classic binary search
function binarySearch(arr, item, comparator) {
  var low = 0;
  var high = arr.length;
  var mid;
  while (low < high) {
    mid = (low + high) >>> 1;
    if (comparator(arr[mid], item) < 0) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }
  return low;
}

// assuming the arr is sorted, insert the item in the proper place
function insertSorted(arr, item, comparator) {
  var idx = binarySearch(arr, item, comparator);
  arr.splice(idx, 0, item);
}

// Turn a path as a flat array into a tree with a single branch.
// If any should be stemmed from the beginning of the array, that's passed
// in as the second argument
function pathToTree(path, numStemmed) {
  var root;
  var leaf;
  for (var i = numStemmed, len = path.length; i < len; i++) {
    var node = path[i];
    var currentLeaf = [node.id, node.opts, []];
    if (leaf) {
      leaf[2].push(currentLeaf);
      leaf = currentLeaf;
    } else {
      root = leaf = currentLeaf;
    }
  }
  return root;
}

// compare the IDs of two trees
function compareTree(a, b) {
  return a[0] < b[0] ? -1 : 1;
}

// Merge two trees together
// The roots of tree1 and tree2 must be the same revision
function mergeTree(in_tree1, in_tree2) {
  var queue = [{tree1: in_tree1, tree2: in_tree2}];
  var conflicts = false;
  while (queue.length > 0) {
    var item = queue.pop();
    var tree1 = item.tree1;
    var tree2 = item.tree2;

    if (tree1[1].status || tree2[1].status) {
      tree1[1].status =
        (tree1[1].status ===  'available' ||
        tree2[1].status === 'available') ? 'available' : 'missing';
    }

    for (var i = 0; i < tree2[2].length; i++) {
      if (!tree1[2][0]) {
        conflicts = 'new_leaf';
        tree1[2][0] = tree2[2][i];
        continue;
      }

      var merged = false;
      for (var j = 0; j < tree1[2].length; j++) {
        if (tree1[2][j][0] === tree2[2][i][0]) {
          queue.push({tree1: tree1[2][j], tree2: tree2[2][i]});
          merged = true;
        }
      }
      if (!merged) {
        conflicts = 'new_branch';
        insertSorted(tree1[2], tree2[2][i], compareTree);
      }
    }
  }
  return {conflicts: conflicts, tree: in_tree1};
}

function doMerge(tree, path, dontExpand) {
  var restree = [];
  var conflicts = false;
  var merged = false;
  var res;

  if (!tree.length) {
    return {tree: [path], conflicts: 'new_leaf'};
  }

  for (var i = 0, len = tree.length; i < len; i++) {
    var branch = tree[i];
    if (branch.pos === path.pos && branch.ids[0] === path.ids[0]) {
      // Paths start at the same position and have the same root, so they need
      // merged
      res = mergeTree(branch.ids, path.ids);
      restree.push({pos: branch.pos, ids: res.tree});
      conflicts = conflicts || res.conflicts;
      merged = true;
    } else if (dontExpand !== true) {
      // The paths start at a different position, take the earliest path and
      // traverse up until it as at the same point from root as the path we
      // want to merge.  If the keys match we return the longer path with the
      // other merged After stemming we dont want to expand the trees

      var t1 = branch.pos < path.pos ? branch : path;
      var t2 = branch.pos < path.pos ? path : branch;
      var diff = t2.pos - t1.pos;

      var candidateParents = [];

      var trees = [];
      trees.push({ids: t1.ids, diff: diff, parent: null, parentIdx: null});
      while (trees.length > 0) {
        var item = trees.pop();
        if (item.diff === 0) {
          if (item.ids[0] === t2.ids[0]) {
            candidateParents.push(item);
          }
          continue;
        }
        var elements = item.ids[2];
        for (var j = 0, elementsLen = elements.length; j < elementsLen; j++) {
          trees.push({
            ids: elements[j],
            diff: item.diff - 1,
            parent: item.ids,
            parentIdx: j
          });
        }
      }

      var el = candidateParents[0];

      if (!el) {
        restree.push(branch);
      } else {
        res = mergeTree(el.ids, t2.ids);
        el.parent[2][el.parentIdx] = res.tree;
        restree.push({pos: t1.pos, ids: t1.ids});
        conflicts = conflicts || res.conflicts;
        merged = true;
      }
    } else {
      restree.push(branch);
    }
  }

  // We didnt find
  if (!merged) {
    restree.push(path);
  }

  restree.sort(sortByPos);

  return {
    tree: restree,
    conflicts: conflicts || 'internal_node'
  };
}

// To ensure we dont grow the revision tree infinitely, we stem old revisions
function stem(tree, depth) {
  // First we break out the tree into a complete list of root to leaf paths
  var paths = rootToLeaf(tree);
  var result;
  for (var i = 0, len = paths.length; i < len; i++) {
    // Then for each path, we cut off the start of the path based on the
    // `depth` to stem to, and generate a new set of flat trees
    var path = paths[i];
    var stemmed = path.ids;
    var numStemmed = Math.max(0, stemmed.length - depth);
    var stemmedNode = {
      pos: path.pos + numStemmed,
      ids: pathToTree(stemmed, numStemmed)
    };
    // Then we remerge all those flat trees together, ensuring that we dont
    // connect trees that would go beyond the depth limit
    if (result) {
      result = doMerge(result, stemmedNode, true).tree;
    } else {
      result = [stemmedNode];
    }
  }
  return result;
}

module.exports = function merge(tree, path, depth) {
  var newTree = doMerge(tree, path);
  return {
    tree: stem(newTree.tree, depth),
    conflicts: newTree.conflicts
  };
};
},{"33":33}],32:[function(_dereq_,module,exports){
'use strict';

// return true if a rev exists in the rev tree, false otherwise
module.exports = function revExists(revs, rev) {
  var toVisit = revs.slice();
  var splitRev = rev.split('-');
  var targetPos = parseInt(splitRev[0], 10);
  var targetId = splitRev[1];

  var node;
  while ((node = toVisit.pop())) {
    if (node.pos === targetPos && node.ids[0] === targetId) {
      return true;
    }
    var branches = node.ids[2];
    for (var i = 0, len = branches.length; i < len; i++) {
      toVisit.push({pos: node.pos + 1, ids: branches[i]});
    }
  }
  return false;
};
},{}],33:[function(_dereq_,module,exports){
'use strict';
// build up a list of all the paths to the leafs in this revision tree
module.exports = function rootToLeaf(revs) {
  var paths = [];
  var toVisit = revs.slice();
  var node;
  while ((node = toVisit.pop())) {
    var pos = node.pos;
    var tree = node.ids;
    var id = tree[0];
    var opts = tree[1];
    var branches = tree[2];
    var isLeaf = branches.length === 0;

    var history = node.history ? node.history.slice() : [];
    history.push({id: id, opts: opts});
    if (isLeaf) {
      paths.push({pos: (pos + 1 - history.length), ids: history});
    }
    for (var i = 0, len = branches.length; i < len; i++) {
      toVisit.push({pos: pos + 1, ids: branches[i], history: history});
    }
  }
  return paths.reverse();
};
},{}],34:[function(_dereq_,module,exports){
'use strict';

// Pretty much all below can be combined into a higher order function to
// traverse revisions
// The return value from the callback will be passed as context to all
// children of that node
module.exports = function traverseRevTree(revs, callback) {
  var toVisit = revs.slice();

  var node;
  while ((node = toVisit.pop())) {
    var pos = node.pos;
    var tree = node.ids;
    var branches = tree[2];
    var newCtx =
      callback(branches.length === 0, pos, tree[0], node.ctx, tree[1]);
    for (var i = 0, len = branches.length; i < len; i++) {
      toVisit.push({pos: pos + 1, ids: branches[i], ctx: newCtx});
    }
  }
};
},{}],35:[function(_dereq_,module,exports){
'use strict';

// We fetch all leafs of the revision tree, and sort them based on tree length
// and whether they were deleted, undeleted documents with the longest revision
// tree (most edits) win
// The final sort algorithm is slightly documented in a sidebar here:
// http://guide.couchdb.org/draft/conflicts.html
module.exports = function winningRev(metadata) {
  var winningId;
  var winningPos;
  var winningDeleted;
  var toVisit = metadata.rev_tree.slice();
  var node;
  while ((node = toVisit.pop())) {
    var tree = node.ids;
    var branches = tree[2];
    var pos = node.pos;
    if (branches.length) { // non-leaf
      for (var i = 0, len = branches.length; i < len; i++) {
        toVisit.push({pos: pos + 1, ids: branches[i]});
      }
      continue;
    }
    var deleted = !!tree[1].deleted;
    var id = tree[0];
    // sort by deleted, then pos, then id
    if (!winningId || (winningDeleted !== deleted ? winningDeleted :
        winningPos !== pos ? winningPos < pos : winningId < id)) {
      winningId = id;
      winningPos = pos;
      winningDeleted = deleted;
    }
  }

  return winningPos + '-' + winningId;
};
},{}],36:[function(_dereq_,module,exports){
(function (process){
'use strict';
// in the browser, LevelAlt doesn't need the
// pre-2.2.0 LevelDB-specific migrations
exports.toSublevel = function (name, db, callback) {
  process.nextTick(function () {
    callback();
  });
};

exports.localAndMetaStores = function (db, stores, callback) {
  process.nextTick(function () {
    callback();
  });
};
}).call(this,_dereq_(57))
},{"57":57}],37:[function(_dereq_,module,exports){
'use strict';

var getArguments = _dereq_(48);

function once(fun) {
  var called = false;
  return getArguments(function (args) {
    /* istanbul ignore if */
    if (called) {
      // this is a smoke test and should never actually happen
      throw new Error('once called more than once');
    } else {
      called = true;
      fun.apply(this, args);
    }
  });
}

module.exports = once;
},{"48":48}],38:[function(_dereq_,module,exports){
'use strict';

// like underscore/lodash _.pick()
module.exports = function pick(obj, arr) {
  var res = {};
  for (var i = 0, len = arr.length; i < len; i++) {
    var prop = arr[i];
    if (prop in obj) {
      res[prop] = obj[prop];
    }
  }
  return res;
};
},{}],39:[function(_dereq_,module,exports){
'use strict';
/* istanbul ignore next */
module.exports = typeof Promise === 'function' ? Promise : _dereq_(132);

},{"132":132}],40:[function(_dereq_,module,exports){
'use strict';

var vuvuzela = _dereq_(159);

module.exports = function safeJsonParse(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    /* istanbul ignore next */
    return vuvuzela.parse(str);
  }
};
},{"159":159}],41:[function(_dereq_,module,exports){
'use strict';

var vuvuzela = _dereq_(159);

module.exports = function safeJsonStringify(json) {
  try {
    return JSON.stringify(json);
  } catch (e) {
    /* istanbul ignore next */
    return vuvuzela.stringify(json);
  }
};
},{"159":159}],42:[function(_dereq_,module,exports){
(function (process){
'use strict';

var Promise = _dereq_(39);
var getArguments = _dereq_(48);
var clone = _dereq_(16);
var once = _dereq_(37);

function toPromise(func) {
  //create the function we will be returning
  return getArguments(function (args) {
    // Clone arguments
    args = clone(args);
    var self = this;
    var tempCB =
      (typeof args[args.length - 1] === 'function') ? args.pop() : false;
    // if the last argument is a function, assume its a callback
    var usedCB;
    if (tempCB) {
      // if it was a callback, create a new callback which calls it,
      // but do so async so we don't trap any errors
      usedCB = function (err, resp) {
        process.nextTick(function () {
          tempCB(err, resp);
        });
      };
    }
    var promise = new Promise(function (fulfill, reject) {
      var resp;
      try {
        var callback = once(function (err, mesg) {
          if (err) {
            reject(err);
          } else {
            fulfill(mesg);
          }
        });
        // create a callback for this invocation
        // apply the function in the orig context
        args.push(callback);
        resp = func.apply(self, args);
        if (resp && typeof resp.then === 'function') {
          fulfill(resp);
        }
      } catch (e) {
        reject(e);
      }
    });
    // if there is a callback, call it back
    if (usedCB) {
      promise.then(function (result) {
        usedCB(null, result);
      }, usedCB);
    }
    return promise;
  });
}

module.exports = toPromise;

}).call(this,_dereq_(57))
},{"16":16,"37":37,"39":39,"48":48,"57":57}],43:[function(_dereq_,module,exports){
"use strict";

// BEGIN Math.uuid.js

/*!
Math.uuid.js (v1.4)
http://www.broofa.com
mailto:robert@broofa.com

Copyright (c) 2010 Robert Kieffer
Dual licensed under the MIT and GPL licenses.
*/

/*
 * Generate a random uuid.
 *
 * USAGE: Math.uuid(length, radix)
 *   length - the desired number of characters
 *   radix  - the number of allowable values for each character.
 *
 * EXAMPLES:
 *   // No arguments  - returns RFC4122, version 4 ID
 *   >>> Math.uuid()
 *   "92329D39-6F5C-4520-ABFC-AAB64544E172"
 *
 *   // One argument - returns ID of the specified length
 *   >>> Math.uuid(15)     // 15 character ID (default base=62)
 *   "VcydxgltxrVZSTV"
 *
 *   // Two arguments - returns ID of the specified length, and radix.
 *   // (Radix must be <= 62)
 *   >>> Math.uuid(8, 2)  // 8 character ID (base=2)
 *   "01001010"
 *   >>> Math.uuid(8, 10) // 8 character ID (base=10)
 *   "47473046"
 *   >>> Math.uuid(8, 16) // 8 character ID (base=16)
 *   "098F4D35"
 */
var chars = (
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
  'abcdefghijklmnopqrstuvwxyz'
).split('');
function getValue(radix) {
  return 0 | Math.random() * radix;
}
function uuid(len, radix) {
  radix = radix || chars.length;
  var out = '';
  var i = -1;

  if (len) {
    // Compact form
    while (++i < len) {
      out += chars[getValue(radix)];
    }
    return out;
  }
    // rfc4122, version 4 form
    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
  while (++i < 36) {
    switch (i) {
      case 8:
      case 13:
      case 18:
      case 23:
        out += '-';
        break;
      case 19:
        out += chars[(getValue(16) & 0x3) | 0x8];
        break;
      default:
        out += chars[getValue(16)];
    }
  }

  return out;
}



module.exports = uuid;


},{}],44:[function(_dereq_,module,exports){
'use strict';
/* global PouchDB */

function pluginBase(adapterConfig, downAdapter) {
  var adapterName = adapterConfig.name;
  var adapter = _dereq_(45)(adapterConfig, downAdapter);
  // use global PouchDB if it's there (e.g. window.PouchDB)
  var PDB = (typeof PouchDB !== 'undefined') ? PouchDB : _dereq_("pouchdb");
  if (!PDB) {
    console.error(adapterConfig.name + ' adapter plugin error: ' +
      'Cannot find global "PouchDB" object! ' +
      'Did you remember to include pouchdb.js?');
  } else {
    PDB.adapter(adapterName, adapter, true);
  }
}

module.exports = pluginBase;
},{"45":45,"pouchdb":"pouchdb"}],45:[function(_dereq_,module,exports){
'use strict';

var LevelPouch = _dereq_(3);
var toPromise = _dereq_(42);
var extend = _dereq_(77).extend;

module.exports = altFactory;
function altFactory(adapterConfig, downAdapter) {

  function LevelPouchAlt(opts, callback) {
    var _opts = extend({
      db: downAdapter
    }, opts);

    LevelPouch.call(this, _opts, callback);
  }

  // overrides for normal LevelDB behavior on Node
  LevelPouchAlt.valid = function () {
    return adapterConfig.valid();
  };
  LevelPouchAlt.use_prefix = adapterConfig.use_prefix;

  LevelPouchAlt.destroy = toPromise(function (name, opts, callback) {
    if (typeof opts === 'function') {
      callback = opts;
      opts = {};
    }
    var _opts = extend({
      db: downAdapter
    }, opts);

    return LevelPouch.destroy(name, _opts, callback);
  });
  return LevelPouchAlt;

}

},{"3":3,"42":42,"77":77}],46:[function(_dereq_,module,exports){
'use strict';

module.exports = {
  name: 'localstorage',
  valid: function () {
    return typeof localStorage !== 'undefined';
  },
  use_prefix: true
};

},{}],47:[function(_dereq_,module,exports){
'use strict';

var pluginBase = _dereq_(44);
var adapterConfig = _dereq_(46);
var downAdapter = _dereq_(134);
pluginBase(adapterConfig, downAdapter);
},{"134":134,"44":44,"46":46}],48:[function(_dereq_,module,exports){
'use strict';

module.exports = argsArray;

function argsArray(fun) {
  return function () {
    var len = arguments.length;
    if (len) {
      var args = [];
      var i = -1;
      while (++i < len) {
        args[i] = arguments[i];
      }
      return fun.call(this, args);
    } else {
      return fun.call(this, []);
    }
  };
}
},{}],49:[function(_dereq_,module,exports){

},{}],50:[function(_dereq_,module,exports){
(function (global){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

var base64 = _dereq_(51)
var ieee754 = _dereq_(52)
var isArray = _dereq_(53)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50
Buffer.poolSize = 8192 // not used by this implementation

var rootParent = {}

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Safari 5-7 lacks support for changing the `Object.prototype.constructor` property
 *     on objects.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

function typedArraySupport () {
  function Bar () {}
  try {
    var arr = new Uint8Array(1)
    arr.foo = function () { return 42 }
    arr.constructor = Bar
    return arr.foo() === 42 && // typed array instances can be augmented
        arr.constructor === Bar && // constructor can be set
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

/**
 * Class: Buffer
 * =============
 *
 * The Buffer constructor returns instances of `Uint8Array` that are augmented
 * with function properties for all the node `Buffer` API functions. We use
 * `Uint8Array` so that square bracket notation works as expected -- it returns
 * a single octet.
 *
 * By augmenting the instances, we can avoid modifying the `Uint8Array`
 * prototype.
 */
function Buffer (arg) {
  if (!(this instanceof Buffer)) {
    // Avoid going through an ArgumentsAdaptorTrampoline in the common case.
    if (arguments.length > 1) return new Buffer(arg, arguments[1])
    return new Buffer(arg)
  }

  this.length = 0
  this.parent = undefined

  // Common case.
  if (typeof arg === 'number') {
    return fromNumber(this, arg)
  }

  // Slightly less common case.
  if (typeof arg === 'string') {
    return fromString(this, arg, arguments.length > 1 ? arguments[1] : 'utf8')
  }

  // Unusual.
  return fromObject(this, arg)
}

function fromNumber (that, length) {
  that = allocate(that, length < 0 ? 0 : checked(length) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < length; i++) {
      that[i] = 0
    }
  }
  return that
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8'

  // Assumption: byteLength() return value is always < kMaxLength.
  var length = byteLength(string, encoding) | 0
  that = allocate(that, length)

  that.write(string, encoding)
  return that
}

function fromObject (that, object) {
  if (Buffer.isBuffer(object)) return fromBuffer(that, object)

  if (isArray(object)) return fromArray(that, object)

  if (object == null) {
    throw new TypeError('must start with number, buffer, array or string')
  }

  if (typeof ArrayBuffer !== 'undefined') {
    if (object.buffer instanceof ArrayBuffer) {
      return fromTypedArray(that, object)
    }
    if (object instanceof ArrayBuffer) {
      return fromArrayBuffer(that, object)
    }
  }

  if (object.length) return fromArrayLike(that, object)

  return fromJsonObject(that, object)
}

function fromBuffer (that, buffer) {
  var length = checked(buffer.length) | 0
  that = allocate(that, length)
  buffer.copy(that, 0, 0, length)
  return that
}

function fromArray (that, array) {
  var length = checked(array.length) | 0
  that = allocate(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

// Duplicate of fromArray() to keep fromArray() monomorphic.
function fromTypedArray (that, array) {
  var length = checked(array.length) | 0
  that = allocate(that, length)
  // Truncating the elements is probably not what people expect from typed
  // arrays with BYTES_PER_ELEMENT > 1 but it's compatible with the behavior
  // of the old Buffer constructor.
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array) {
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    array.byteLength
    that = Buffer._augment(new Uint8Array(array))
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromTypedArray(that, new Uint8Array(array))
  }
  return that
}

function fromArrayLike (that, array) {
  var length = checked(array.length) | 0
  that = allocate(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

// Deserialize { type: 'Buffer', data: [1,2,3,...] } into a Buffer object.
// Returns a zero-length buffer for inputs that don't conform to the spec.
function fromJsonObject (that, object) {
  var array
  var length = 0

  if (object.type === 'Buffer' && isArray(object.data)) {
    array = object.data
    length = checked(array.length) | 0
  }
  that = allocate(that, length)

  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
}

function allocate (that, length) {
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = Buffer._augment(new Uint8Array(length))
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that.length = length
    that._isBuffer = true
  }

  var fromPool = length !== 0 && length <= Buffer.poolSize >>> 1
  if (fromPool) that.parent = rootParent

  return that
}

function checked (length) {
  // Note: cannot use `length < kMaxLength` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (subject, encoding) {
  if (!(this instanceof SlowBuffer)) return new SlowBuffer(subject, encoding)

  var buf = new Buffer(subject, encoding)
  delete buf.parent
  return buf
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  var i = 0
  var len = Math.min(x, y)
  while (i < len) {
    if (a[i] !== b[i]) break

    ++i
  }

  if (i !== len) {
    x = a[i]
    y = b[i]
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'binary':
    case 'base64':
    case 'raw':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) throw new TypeError('list argument must be an Array of Buffers.')

  if (list.length === 0) {
    return new Buffer(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; i++) {
      length += list[i].length
    }
  }

  var buf = new Buffer(length)
  var pos = 0
  for (i = 0; i < list.length; i++) {
    var item = list[i]
    item.copy(buf, pos)
    pos += item.length
  }
  return buf
}

function byteLength (string, encoding) {
  if (typeof string !== 'string') string = '' + string

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'binary':
      // Deprecated
      case 'raw':
      case 'raws':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

// pre-set for values that may exist in the future
Buffer.prototype.length = undefined
Buffer.prototype.parent = undefined

function slowToString (encoding, start, end) {
  var loweredCase = false

  start = start | 0
  end = end === undefined || end === Infinity ? this.length : end | 0

  if (!encoding) encoding = 'utf8'
  if (start < 0) start = 0
  if (end > this.length) end = this.length
  if (end <= start) return ''

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'binary':
        return binarySlice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return 0
  return Buffer.compare(this, b)
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset) {
  if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff
  else if (byteOffset < -0x80000000) byteOffset = -0x80000000
  byteOffset >>= 0

  if (this.length === 0) return -1
  if (byteOffset >= this.length) return -1

  // Negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = Math.max(this.length + byteOffset, 0)

  if (typeof val === 'string') {
    if (val.length === 0) return -1 // special case: looking for empty string always fails
    return String.prototype.indexOf.call(this, val, byteOffset)
  }
  if (Buffer.isBuffer(val)) {
    return arrayIndexOf(this, val, byteOffset)
  }
  if (typeof val === 'number') {
    if (Buffer.TYPED_ARRAY_SUPPORT && Uint8Array.prototype.indexOf === 'function') {
      return Uint8Array.prototype.indexOf.call(this, val, byteOffset)
    }
    return arrayIndexOf(this, [ val ], byteOffset)
  }

  function arrayIndexOf (arr, val, byteOffset) {
    var foundIndex = -1
    for (var i = 0; byteOffset + i < arr.length; i++) {
      if (arr[byteOffset + i] === val[foundIndex === -1 ? 0 : i - foundIndex]) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === val.length) return byteOffset + foundIndex
      } else {
        foundIndex = -1
      }
    }
    return -1
  }

  throw new TypeError('val must be string, number or Buffer')
}

// `get` is deprecated
Buffer.prototype.get = function get (offset) {
  console.log('.get() is deprecated. Access using array indexes instead.')
  return this.readUInt8(offset)
}

// `set` is deprecated
Buffer.prototype.set = function set (v, offset) {
  console.log('.set() is deprecated. Access using array indexes instead.')
  return this.writeUInt8(v, offset)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new Error('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; i++) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) throw new Error('Invalid hex string')
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function binaryWrite (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    var swap = encoding
    encoding = offset
    offset = length | 0
    length = swap
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'binary':
        return binaryWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function binarySlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; i++) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; i++) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = Buffer._augment(this.subarray(start, end))
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; i++) {
      newBuf[i] = this[i + start]
    }
  }

  if (newBuf.length) newBuf.parent = this.parent || this

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('buffer must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('value is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; i++) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; i++) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = value < 0 ? 1 : 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = value < 0 ? 1 : 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (value > max || value < min) throw new RangeError('value is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('index out of range')
  if (offset < 0) throw new RangeError('index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; i--) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; i++) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    target._set(this.subarray(start, start + len), targetStart)
  }

  return len
}

// fill(value, start=0, end=buffer.length)
Buffer.prototype.fill = function fill (value, start, end) {
  if (!value) value = 0
  if (!start) start = 0
  if (!end) end = this.length

  if (end < start) throw new RangeError('end < start')

  // Fill 0 bytes; we're done
  if (end === start) return
  if (this.length === 0) return

  if (start < 0 || start >= this.length) throw new RangeError('start out of bounds')
  if (end < 0 || end > this.length) throw new RangeError('end out of bounds')

  var i
  if (typeof value === 'number') {
    for (i = start; i < end; i++) {
      this[i] = value
    }
  } else {
    var bytes = utf8ToBytes(value.toString())
    var len = bytes.length
    for (i = start; i < end; i++) {
      this[i] = bytes[i % len]
    }
  }

  return this
}

/**
 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
 */
Buffer.prototype.toArrayBuffer = function toArrayBuffer () {
  if (typeof Uint8Array !== 'undefined') {
    if (Buffer.TYPED_ARRAY_SUPPORT) {
      return (new Buffer(this)).buffer
    } else {
      var buf = new Uint8Array(this.length)
      for (var i = 0, len = buf.length; i < len; i += 1) {
        buf[i] = this[i]
      }
      return buf.buffer
    }
  } else {
    throw new TypeError('Buffer.toArrayBuffer not supported in this browser')
  }
}

// HELPER FUNCTIONS
// ================

var BP = Buffer.prototype

/**
 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
 */
Buffer._augment = function _augment (arr) {
  arr.constructor = Buffer
  arr._isBuffer = true

  // save reference to original Uint8Array set method before overwriting
  arr._set = arr.set

  // deprecated
  arr.get = BP.get
  arr.set = BP.set

  arr.write = BP.write
  arr.toString = BP.toString
  arr.toLocaleString = BP.toString
  arr.toJSON = BP.toJSON
  arr.equals = BP.equals
  arr.compare = BP.compare
  arr.indexOf = BP.indexOf
  arr.copy = BP.copy
  arr.slice = BP.slice
  arr.readUIntLE = BP.readUIntLE
  arr.readUIntBE = BP.readUIntBE
  arr.readUInt8 = BP.readUInt8
  arr.readUInt16LE = BP.readUInt16LE
  arr.readUInt16BE = BP.readUInt16BE
  arr.readUInt32LE = BP.readUInt32LE
  arr.readUInt32BE = BP.readUInt32BE
  arr.readIntLE = BP.readIntLE
  arr.readIntBE = BP.readIntBE
  arr.readInt8 = BP.readInt8
  arr.readInt16LE = BP.readInt16LE
  arr.readInt16BE = BP.readInt16BE
  arr.readInt32LE = BP.readInt32LE
  arr.readInt32BE = BP.readInt32BE
  arr.readFloatLE = BP.readFloatLE
  arr.readFloatBE = BP.readFloatBE
  arr.readDoubleLE = BP.readDoubleLE
  arr.readDoubleBE = BP.readDoubleBE
  arr.writeUInt8 = BP.writeUInt8
  arr.writeUIntLE = BP.writeUIntLE
  arr.writeUIntBE = BP.writeUIntBE
  arr.writeUInt16LE = BP.writeUInt16LE
  arr.writeUInt16BE = BP.writeUInt16BE
  arr.writeUInt32LE = BP.writeUInt32LE
  arr.writeUInt32BE = BP.writeUInt32BE
  arr.writeIntLE = BP.writeIntLE
  arr.writeIntBE = BP.writeIntBE
  arr.writeInt8 = BP.writeInt8
  arr.writeInt16LE = BP.writeInt16LE
  arr.writeInt16BE = BP.writeInt16BE
  arr.writeInt32LE = BP.writeInt32LE
  arr.writeInt32BE = BP.writeInt32BE
  arr.writeFloatLE = BP.writeFloatLE
  arr.writeFloatBE = BP.writeFloatBE
  arr.writeDoubleLE = BP.writeDoubleLE
  arr.writeDoubleBE = BP.writeDoubleBE
  arr.fill = BP.fill
  arr.inspect = BP.inspect
  arr.toArrayBuffer = BP.toArrayBuffer

  return arr
}

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; i++) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00 | 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; i++) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; i++) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"51":51,"52":52,"53":53}],51:[function(_dereq_,module,exports){
var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

;(function (exports) {
	'use strict';

  var Arr = (typeof Uint8Array !== 'undefined')
    ? Uint8Array
    : Array

	var PLUS   = '+'.charCodeAt(0)
	var SLASH  = '/'.charCodeAt(0)
	var NUMBER = '0'.charCodeAt(0)
	var LOWER  = 'a'.charCodeAt(0)
	var UPPER  = 'A'.charCodeAt(0)
	var PLUS_URL_SAFE = '-'.charCodeAt(0)
	var SLASH_URL_SAFE = '_'.charCodeAt(0)

	function decode (elt) {
		var code = elt.charCodeAt(0)
		if (code === PLUS ||
		    code === PLUS_URL_SAFE)
			return 62 // '+'
		if (code === SLASH ||
		    code === SLASH_URL_SAFE)
			return 63 // '/'
		if (code < NUMBER)
			return -1 //no match
		if (code < NUMBER + 10)
			return code - NUMBER + 26 + 26
		if (code < UPPER + 26)
			return code - UPPER
		if (code < LOWER + 26)
			return code - LOWER + 26
	}

	function b64ToByteArray (b64) {
		var i, j, l, tmp, placeHolders, arr

		if (b64.length % 4 > 0) {
			throw new Error('Invalid string. Length must be a multiple of 4')
		}

		// the number of equal signs (place holders)
		// if there are two placeholders, than the two characters before it
		// represent one byte
		// if there is only one, then the three characters before it represent 2 bytes
		// this is just a cheap hack to not do indexOf twice
		var len = b64.length
		placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0

		// base64 is 4/3 + up to two characters of the original data
		arr = new Arr(b64.length * 3 / 4 - placeHolders)

		// if there are placeholders, only get up to the last complete 4 chars
		l = placeHolders > 0 ? b64.length - 4 : b64.length

		var L = 0

		function push (v) {
			arr[L++] = v
		}

		for (i = 0, j = 0; i < l; i += 4, j += 3) {
			tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
			push((tmp & 0xFF0000) >> 16)
			push((tmp & 0xFF00) >> 8)
			push(tmp & 0xFF)
		}

		if (placeHolders === 2) {
			tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
			push(tmp & 0xFF)
		} else if (placeHolders === 1) {
			tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
			push((tmp >> 8) & 0xFF)
			push(tmp & 0xFF)
		}

		return arr
	}

	function uint8ToBase64 (uint8) {
		var i,
			extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
			output = "",
			temp, length

		function encode (num) {
			return lookup.charAt(num)
		}

		function tripletToBase64 (num) {
			return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
		}

		// go through the array every three bytes, we'll deal with trailing stuff later
		for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
			temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
			output += tripletToBase64(temp)
		}

		// pad the end with zeros, but make sure to not forget the extra bytes
		switch (extraBytes) {
			case 1:
				temp = uint8[uint8.length - 1]
				output += encode(temp >> 2)
				output += encode((temp << 4) & 0x3F)
				output += '=='
				break
			case 2:
				temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
				output += encode(temp >> 10)
				output += encode((temp >> 4) & 0x3F)
				output += encode((temp << 2) & 0x3F)
				output += '='
				break
		}

		return output
	}

	exports.toByteArray = b64ToByteArray
	exports.fromByteArray = uint8ToBase64
}(typeof exports === 'undefined' ? (this.base64js = {}) : exports))

},{}],52:[function(_dereq_,module,exports){
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],53:[function(_dereq_,module,exports){

/**
 * isArray
 */

var isArray = Array.isArray;

/**
 * toString
 */

var str = Object.prototype.toString;

/**
 * Whether or not the given `val`
 * is an array.
 *
 * example:
 *
 *        isArray([]);
 *        // > true
 *        isArray(arguments);
 *        // > false
 *        isArray('');
 *        // > false
 *
 * @param {mixed} val
 * @return {bool}
 */

module.exports = isArray || function (val) {
  return !! val && '[object Array]' == str.call(val);
};

},{}],54:[function(_dereq_,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      }
      throw TypeError('Uncaught, unspecified "error" event.');
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}

},{}],55:[function(_dereq_,module,exports){
/**
 * Determine if an object is Buffer
 *
 * Author:   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * License:  MIT
 *
 * `npm install is-buffer`
 */

module.exports = function (obj) {
  return !!(obj != null &&
    (obj._isBuffer || // For Safari 5-7 (missing Object.prototype.constructor)
      (obj.constructor &&
      typeof obj.constructor.isBuffer === 'function' &&
      obj.constructor.isBuffer(obj))
    ))
}

},{}],56:[function(_dereq_,module,exports){
module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

},{}],57:[function(_dereq_,module,exports){
// shim for using process in browser

var process = module.exports = {};
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = setTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    clearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        setTimeout(drainQueue, 0);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],58:[function(_dereq_,module,exports){
module.exports = _dereq_(59)

},{"59":59}],59:[function(_dereq_,module,exports){
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}
/*</replacement>*/


module.exports = Duplex;

/*<replacement>*/
var processNextTick = _dereq_(65);
/*</replacement>*/



/*<replacement>*/
var util = _dereq_(64);
util.inherits = _dereq_(76);
/*</replacement>*/

var Readable = _dereq_(61);
var Writable = _dereq_(63);

util.inherits(Duplex, Readable);

var keys = objectKeys(Writable.prototype);
for (var v = 0; v < keys.length; v++) {
  var method = keys[v];
  if (!Duplex.prototype[method])
    Duplex.prototype[method] = Writable.prototype[method];
}

function Duplex(options) {
  if (!(this instanceof Duplex))
    return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false)
    this.readable = false;

  if (options && options.writable === false)
    this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false)
    this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended)
    return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  processNextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

function forEach (xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

},{"61":61,"63":63,"64":64,"65":65,"76":76}],60:[function(_dereq_,module,exports){
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;

var Transform = _dereq_(62);

/*<replacement>*/
var util = _dereq_(64);
util.inherits = _dereq_(76);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough))
    return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function(chunk, encoding, cb) {
  cb(null, chunk);
};

},{"62":62,"64":64,"76":76}],61:[function(_dereq_,module,exports){
(function (process){
'use strict';

module.exports = Readable;

/*<replacement>*/
var processNextTick = _dereq_(65);
/*</replacement>*/


/*<replacement>*/
var isArray = _dereq_(56);
/*</replacement>*/


/*<replacement>*/
var Buffer = _dereq_(50).Buffer;
/*</replacement>*/

Readable.ReadableState = ReadableState;

var EE = _dereq_(54);

/*<replacement>*/
var EElistenerCount = function(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/



/*<replacement>*/
var Stream;
(function (){try{
  Stream = _dereq_('st' + 'ream');
}catch(_){}finally{
  if (!Stream)
    Stream = _dereq_(54).EventEmitter;
}}())
/*</replacement>*/

var Buffer = _dereq_(50).Buffer;

/*<replacement>*/
var util = _dereq_(64);
util.inherits = _dereq_(76);
/*</replacement>*/



/*<replacement>*/
var debugUtil = _dereq_(49);
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var StringDecoder;

util.inherits(Readable, Stream);

function ReadableState(options, stream) {
  var Duplex = _dereq_(59);

  options = options || {};

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex)
    this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~~this.highWaterMark;

  this.buffer = [];
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // when piping, we only care about 'readable' events that happen
  // after read()ing all the bytes and not getting any pushback.
  this.ranOut = false;

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder)
      StringDecoder = _dereq_(72).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  var Duplex = _dereq_(59);

  if (!(this instanceof Readable))
    return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options && typeof options.read === 'function')
    this._read = options.read;

  Stream.call(this);
}

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
  var state = this._readableState;

  if (!state.objectMode && typeof chunk === 'string') {
    encoding = encoding || state.defaultEncoding;
    if (encoding !== state.encoding) {
      chunk = new Buffer(chunk, encoding);
      encoding = '';
    }
  }

  return readableAddChunk(this, state, chunk, encoding, false);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
  var state = this._readableState;
  return readableAddChunk(this, state, chunk, '', true);
};

Readable.prototype.isPaused = function() {
  return this._readableState.flowing === false;
};

function readableAddChunk(stream, state, chunk, encoding, addToFront) {
  var er = chunkInvalid(state, chunk);
  if (er) {
    stream.emit('error', er);
  } else if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else if (state.objectMode || chunk && chunk.length > 0) {
    if (state.ended && !addToFront) {
      var e = new Error('stream.push() after EOF');
      stream.emit('error', e);
    } else if (state.endEmitted && addToFront) {
      var e = new Error('stream.unshift() after end event');
      stream.emit('error', e);
    } else {
      if (state.decoder && !addToFront && !encoding)
        chunk = state.decoder.write(chunk);

      if (!addToFront)
        state.reading = false;

      // if we want the data now, just emit it.
      if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
      } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront)
          state.buffer.unshift(chunk);
        else
          state.buffer.push(chunk);

        if (state.needReadable)
          emitReadable(stream);
      }

      maybeReadMore(stream, state);
    }
  } else if (!addToFront) {
    state.reading = false;
  }

  return needMoreData(state);
}


// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended &&
         (state.needReadable ||
          state.length < state.highWaterMark ||
          state.length === 0);
}

// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
  if (!StringDecoder)
    StringDecoder = _dereq_(72).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

function howMuchToRead(n, state) {
  if (state.length === 0 && state.ended)
    return 0;

  if (state.objectMode)
    return n === 0 ? 0 : 1;

  if (n === null || isNaN(n)) {
    // only flow one buffer at a time
    if (state.flowing && state.buffer.length)
      return state.buffer[0].length;
    else
      return state.length;
  }

  if (n <= 0)
    return 0;

  // If we're asking for more than the target buffer level,
  // then raise the water mark.  Bump up to the next highest
  // power of 2, to prevent increasing it excessively in tiny
  // amounts.
  if (n > state.highWaterMark)
    state.highWaterMark = computeNewHighWaterMark(n);

  // don't have that much.  return null, unless we've ended.
  if (n > state.length) {
    if (!state.ended) {
      state.needReadable = true;
      return 0;
    } else {
      return state.length;
    }
  }

  return n;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
  debug('read', n);
  var state = this._readableState;
  var nOrig = n;

  if (typeof n !== 'number' || n > 0)
    state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 &&
      state.needReadable &&
      (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended)
      endReadable(this);
    else
      emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0)
      endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  }

  if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0)
      state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
  }

  // If _read pushed data synchronously, then `reading` will be false,
  // and we need to re-evaluate how much data we can return to the user.
  if (doRead && !state.reading)
    n = howMuchToRead(nOrig, state);

  var ret;
  if (n > 0)
    ret = fromList(n, state);
  else
    ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  }

  state.length -= n;

  // If we have nothing in the buffer, then we want to know
  // as soon as we *do* get something into the buffer.
  if (state.length === 0 && !state.ended)
    state.needReadable = true;

  // If we tried to read() past the EOF, then emit end on the next tick.
  if (nOrig !== n && state.ended && state.length === 0)
    endReadable(this);

  if (ret !== null)
    this.emit('data', ret);

  return ret;
};

function chunkInvalid(state, chunk) {
  var er = null;
  if (!(Buffer.isBuffer(chunk)) &&
      typeof chunk !== 'string' &&
      chunk !== null &&
      chunk !== undefined &&
      !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}


function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync)
      processNextTick(emitReadable_, stream);
    else
      emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}


// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    processNextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended &&
         state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
    else
      len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
  this.emit('error', new Error('not implemented'));
};

Readable.prototype.pipe = function(dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) &&
              dest !== process.stdout &&
              dest !== process.stderr;

  var endFn = doEnd ? onend : cleanup;
  if (state.endEmitted)
    processNextTick(endFn);
  else
    src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable) {
    debug('onunpipe');
    if (readable === src) {
      cleanup();
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', cleanup);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain &&
        (!dest._writableState || dest._writableState.needDrain))
      ondrain();
  }

  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    if (false === ret) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      if (state.pipesCount === 1 &&
          state.pipes[0] === dest &&
          src.listenerCount('data') === 1 &&
          !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0)
      dest.emit('error', er);
  }
  // This is a brutally ugly hack to make sure that our error handler
  // is attached before any userland ones.  NEVER DO THIS.
  if (!dest._events || !dest._events.error)
    dest.on('error', onerror);
  else if (isArray(dest._events.error))
    dest._events.error.unshift(onerror);
  else
    dest._events.error = [onerror, dest._events.error];


  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain)
      state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}


Readable.prototype.unpipe = function(dest) {
  var state = this._readableState;

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0)
    return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes)
      return this;

    if (!dest)
      dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest)
      dest.emit('unpipe', this);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++)
      dests[i].emit('unpipe', this);
    return this;
  }

  // try to find the right one.
  var i = indexOf(state.pipes, dest);
  if (i === -1)
    return this;

  state.pipes.splice(i, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1)
    state.pipes = state.pipes[0];

  dest.emit('unpipe', this);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  // If listening to data, and it has not explicitly been paused,
  // then call resume to start the flow of data on the next tick.
  if (ev === 'data' && false !== this._readableState.flowing) {
    this.resume();
  }

  if (ev === 'readable' && this.readable) {
    var state = this._readableState;
    if (!state.readableListening) {
      state.readableListening = true;
      state.emittedReadable = false;
      state.needReadable = true;
      if (!state.reading) {
        processNextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this, state);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    processNextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading)
    stream.read(0);
}

Readable.prototype.pause = function() {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  if (state.flowing) {
    do {
      var chunk = stream.read();
    } while (null !== chunk && state.flowing);
  }
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function() {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length)
        self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function(chunk) {
    debug('wrapped data');
    if (state.decoder)
      chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined))
      return;
    else if (!state.objectMode && (!chunk || !chunk.length))
      return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function(method) { return function() {
        return stream[method].apply(stream, arguments);
      }; }(i);
    }
  }

  // proxy certain important events.
  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
  forEach(events, function(ev) {
    stream.on(ev, self.emit.bind(self, ev));
  });

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function(n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};


// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
function fromList(n, state) {
  var list = state.buffer;
  var length = state.length;
  var stringMode = !!state.decoder;
  var objectMode = !!state.objectMode;
  var ret;

  // nothing in the list, definitely empty.
  if (list.length === 0)
    return null;

  if (length === 0)
    ret = null;
  else if (objectMode)
    ret = list.shift();
  else if (!n || n >= length) {
    // read it all, truncate the array.
    if (stringMode)
      ret = list.join('');
    else if (list.length === 1)
      ret = list[0];
    else
      ret = Buffer.concat(list, length);
    list.length = 0;
  } else {
    // read just some of it.
    if (n < list[0].length) {
      // just take a part of the first list item.
      // slice is the same for buffers and strings.
      var buf = list[0];
      ret = buf.slice(0, n);
      list[0] = buf.slice(n);
    } else if (n === list[0].length) {
      // first list is a perfect match
      ret = list.shift();
    } else {
      // complex case.
      // we have enough to cover it, but it spans past the first buffer.
      if (stringMode)
        ret = '';
      else
        ret = new Buffer(n);

      var c = 0;
      for (var i = 0, l = list.length; i < l && c < n; i++) {
        var buf = list[0];
        var cpy = Math.min(n - c, buf.length);

        if (stringMode)
          ret += buf.slice(0, cpy);
        else
          buf.copy(ret, c, 0, cpy);

        if (cpy < buf.length)
          list[0] = buf.slice(cpy);
        else
          list.shift();

        c += cpy;
      }
    }
  }

  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0)
    throw new Error('endReadable called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    processNextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function forEach (xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf (xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

}).call(this,_dereq_(57))
},{"49":49,"50":50,"54":54,"56":56,"57":57,"59":59,"64":64,"65":65,"72":72,"76":76}],62:[function(_dereq_,module,exports){
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;

var Duplex = _dereq_(59);

/*<replacement>*/
var util = _dereq_(64);
util.inherits = _dereq_(76);
/*</replacement>*/

util.inherits(Transform, Duplex);


function TransformState(stream) {
  this.afterTransform = function(er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb)
    return stream.emit('error', new Error('no writecb in Transform class'));

  ts.writechunk = null;
  ts.writecb = null;

  if (data !== null && data !== undefined)
    stream.push(data);

  if (cb)
    cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}


function Transform(options) {
  if (!(this instanceof Transform))
    return new Transform(options);

  Duplex.call(this, options);

  this._transformState = new TransformState(this);

  // when the writable side finishes, then flush out anything remaining.
  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function')
      this._transform = options.transform;

    if (typeof options.flush === 'function')
      this._flush = options.flush;
  }

  this.once('prefinish', function() {
    if (typeof this._flush === 'function')
      this._flush(function(er) {
        done(stream, er);
      });
    else
      done(stream);
  });
}

Transform.prototype.push = function(chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
  throw new Error('not implemented');
};

Transform.prototype._write = function(chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform ||
        rs.needReadable ||
        rs.length < rs.highWaterMark)
      this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};


function done(stream, er) {
  if (er)
    return stream.emit('error', er);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var ts = stream._transformState;

  if (ws.length)
    throw new Error('calling transform done when ws.length != 0');

  if (ts.transforming)
    throw new Error('calling transform done when still transforming');

  return stream.push(null);
}

},{"59":59,"64":64,"76":76}],63:[function(_dereq_,module,exports){
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

module.exports = Writable;

/*<replacement>*/
var processNextTick = _dereq_(65);
/*</replacement>*/


/*<replacement>*/
var Buffer = _dereq_(50).Buffer;
/*</replacement>*/

Writable.WritableState = WritableState;


/*<replacement>*/
var util = _dereq_(64);
util.inherits = _dereq_(76);
/*</replacement>*/


/*<replacement>*/
var internalUtil = {
  deprecate: _dereq_(66)
};
/*</replacement>*/



/*<replacement>*/
var Stream;
(function (){try{
  Stream = _dereq_('st' + 'ream');
}catch(_){}finally{
  if (!Stream)
    Stream = _dereq_(54).EventEmitter;
}}())
/*</replacement>*/

var Buffer = _dereq_(50).Buffer;

util.inherits(Writable, Stream);

function nop() {}

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

function WritableState(options, stream) {
  var Duplex = _dereq_(59);

  options = options || {};

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex)
    this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~~this.highWaterMark;

  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function(er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;
}

WritableState.prototype.getBuffer = function writableStateGetBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function (){try {
Object.defineProperty(WritableState.prototype, 'buffer', {
  get: internalUtil.deprecate(function() {
    return this.getBuffer();
  }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' +
     'instead.')
});
}catch(_){}}());


function Writable(options) {
  var Duplex = _dereq_(59);

  // Writable ctor is applied to Duplexes, though they're not
  // instanceof Writable, they're instanceof Readable.
  if (!(this instanceof Writable) && !(this instanceof Duplex))
    return new Writable(options);

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function')
      this._write = options.write;

    if (typeof options.writev === 'function')
      this._writev = options.writev;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
  this.emit('error', new Error('Cannot pipe. Not readable.'));
};


function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  processNextTick(cb, er);
}

// If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function validChunk(stream, state, chunk, cb) {
  var valid = true;

  if (!(Buffer.isBuffer(chunk)) &&
      typeof chunk !== 'string' &&
      chunk !== null &&
      chunk !== undefined &&
      !state.objectMode) {
    var er = new TypeError('Invalid non-string/buffer chunk');
    stream.emit('error', er);
    processNextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function(chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (Buffer.isBuffer(chunk))
    encoding = 'buffer';
  else if (!encoding)
    encoding = state.defaultEncoding;

  if (typeof cb !== 'function')
    cb = nop;

  if (state.ended)
    writeAfterEnd(this, cb);
  else if (validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function() {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function() {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing &&
        !state.corked &&
        !state.finished &&
        !state.bufferProcessing &&
        state.bufferedRequest)
      clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string')
    encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64',
'ucs2', 'ucs-2','utf16le', 'utf-16le', 'raw']
.indexOf((encoding + '').toLowerCase()) > -1))
    throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode &&
      state.decodeStrings !== false &&
      typeof chunk === 'string') {
    chunk = new Buffer(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, cb) {
  chunk = decodeChunk(state, chunk, encoding);

  if (Buffer.isBuffer(chunk))
    encoding = 'buffer';
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret)
    state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev)
    stream._writev(chunk, state.onwrite);
  else
    stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync)
    processNextTick(cb, er);
  else
    cb(er);

  stream._writableState.errorEmitted = true;
  stream.emit('error', er);
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er)
    onwriteError(stream, state, sync, er, cb);
  else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished &&
        !state.corked &&
        !state.bufferProcessing &&
        state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      processNextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished)
    onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}


// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var buffer = [];
    var cbs = [];
    while (entry) {
      cbs.push(entry.callback);
      buffer.push(entry);
      entry = entry.next;
    }

    // count the one we are adding, as well.
    // TODO(isaacs) clean this up
    state.pendingcb++;
    state.lastBufferedRequest = null;
    doWrite(stream, state, true, state.length, buffer, '', function(err) {
      for (var i = 0; i < cbs.length; i++) {
        state.pendingcb--;
        cbs[i](err);
      }
    });

    // Clear buffer
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null)
      state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function(chunk, encoding, cb) {
  cb(new Error('not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function(chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined)
    this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished)
    endWritable(this, state, cb);
};


function needFinish(state) {
  return (state.ending &&
          state.length === 0 &&
          state.bufferedRequest === null &&
          !state.finished &&
          !state.writing);
}

function prefinish(stream, state) {
  if (!state.prefinished) {
    state.prefinished = true;
    stream.emit('prefinish');
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    if (state.pendingcb === 0) {
      prefinish(stream, state);
      state.finished = true;
      stream.emit('finish');
    } else {
      prefinish(stream, state);
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished)
      processNextTick(cb);
    else
      stream.once('finish', cb);
  }
  state.ended = true;
}

},{"50":50,"54":54,"59":59,"64":64,"65":65,"66":66,"76":76}],64:[function(_dereq_,module,exports){
(function (Buffer){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

function isBuffer(arg) {
  return Buffer.isBuffer(arg);
}
exports.isBuffer = isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}
}).call(this,{"isBuffer":_dereq_(55)})
},{"55":55}],65:[function(_dereq_,module,exports){
(function (process){
'use strict';
module.exports = nextTick;

function nextTick(fn) {
  var args = new Array(arguments.length - 1);
  var i = 0;
  while (i < args.length) {
    args[i++] = arguments[i];
  }
  process.nextTick(function afterTick() {
    fn.apply(null, args);
  });
}

}).call(this,_dereq_(57))
},{"57":57}],66:[function(_dereq_,module,exports){
(function (global){

/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],67:[function(_dereq_,module,exports){
module.exports = _dereq_(60)

},{"60":60}],68:[function(_dereq_,module,exports){
var Stream = (function (){
  try {
    return _dereq_('st' + 'ream'); // hack to fix a circular dependency issue when used with browserify
  } catch(_){}
}());
exports = module.exports = _dereq_(61);
exports.Stream = Stream || exports;
exports.Readable = exports;
exports.Writable = _dereq_(63);
exports.Duplex = _dereq_(59);
exports.Transform = _dereq_(62);
exports.PassThrough = _dereq_(60);

},{"59":59,"60":60,"61":61,"62":62,"63":63}],69:[function(_dereq_,module,exports){
module.exports = _dereq_(62)

},{"62":62}],70:[function(_dereq_,module,exports){
module.exports = _dereq_(63)

},{"63":63}],71:[function(_dereq_,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = _dereq_(54).EventEmitter;
var inherits = _dereq_(76);

inherits(Stream, EE);
Stream.Readable = _dereq_(68);
Stream.Writable = _dereq_(70);
Stream.Duplex = _dereq_(58);
Stream.Transform = _dereq_(69);
Stream.PassThrough = _dereq_(67);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};

},{"54":54,"58":58,"67":67,"68":68,"69":69,"70":70,"76":76}],72:[function(_dereq_,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var Buffer = _dereq_(50).Buffer;

var isBufferEncoding = Buffer.isEncoding
  || function(encoding) {
       switch (encoding && encoding.toLowerCase()) {
         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
         default: return false;
       }
     }


function assertEncoding(encoding) {
  if (encoding && !isBufferEncoding(encoding)) {
    throw new Error('Unknown encoding: ' + encoding);
  }
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters. CESU-8 is handled as part of the UTF-8 encoding.
//
// @TODO Handling all encodings inside a single object makes it very difficult
// to reason about this code, so it should be split up in the future.
// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
// points as used by CESU-8.
var StringDecoder = exports.StringDecoder = function(encoding) {
  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
  assertEncoding(encoding);
  switch (this.encoding) {
    case 'utf8':
      // CESU-8 represents each of Surrogate Pair by 3-bytes
      this.surrogateSize = 3;
      break;
    case 'ucs2':
    case 'utf16le':
      // UTF-16 represents each of Surrogate Pair by 2-bytes
      this.surrogateSize = 2;
      this.detectIncompleteChar = utf16DetectIncompleteChar;
      break;
    case 'base64':
      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
      this.surrogateSize = 3;
      this.detectIncompleteChar = base64DetectIncompleteChar;
      break;
    default:
      this.write = passThroughWrite;
      return;
  }

  // Enough space to store all bytes of a single character. UTF-8 needs 4
  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
  this.charBuffer = new Buffer(6);
  // Number of bytes received for the current incomplete multi-byte character.
  this.charReceived = 0;
  // Number of bytes expected for the current incomplete multi-byte character.
  this.charLength = 0;
};


// write decodes the given buffer and returns it as JS string that is
// guaranteed to not contain any partial multi-byte characters. Any partial
// character found at the end of the buffer is buffered up, and will be
// returned when calling write again with the remaining bytes.
//
// Note: Converting a Buffer containing an orphan surrogate to a String
// currently works, but converting a String to a Buffer (via `new Buffer`, or
// Buffer#write) will replace incomplete surrogates with the unicode
// replacement character. See https://codereview.chromium.org/121173009/ .
StringDecoder.prototype.write = function(buffer) {
  var charStr = '';
  // if our last write ended with an incomplete multibyte character
  while (this.charLength) {
    // determine how many remaining bytes this buffer has to offer for this char
    var available = (buffer.length >= this.charLength - this.charReceived) ?
        this.charLength - this.charReceived :
        buffer.length;

    // add the new bytes to the char buffer
    buffer.copy(this.charBuffer, this.charReceived, 0, available);
    this.charReceived += available;

    if (this.charReceived < this.charLength) {
      // still not enough chars in this buffer? wait for more ...
      return '';
    }

    // remove bytes belonging to the current character from the buffer
    buffer = buffer.slice(available, buffer.length);

    // get the character that was split
    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    var charCode = charStr.charCodeAt(charStr.length - 1);
    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      this.charLength += this.surrogateSize;
      charStr = '';
      continue;
    }
    this.charReceived = this.charLength = 0;

    // if there are no more bytes in this buffer, just emit our char
    if (buffer.length === 0) {
      return charStr;
    }
    break;
  }

  // determine and set charLength / charReceived
  this.detectIncompleteChar(buffer);

  var end = buffer.length;
  if (this.charLength) {
    // buffer the incomplete character bytes we got
    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
    end -= this.charReceived;
  }

  charStr += buffer.toString(this.encoding, 0, end);

  var end = charStr.length - 1;
  var charCode = charStr.charCodeAt(end);
  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
    var size = this.surrogateSize;
    this.charLength += size;
    this.charReceived += size;
    this.charBuffer.copy(this.charBuffer, size, 0, size);
    buffer.copy(this.charBuffer, 0, 0, size);
    return charStr.substring(0, end);
  }

  // or just emit the charStr
  return charStr;
};

// detectIncompleteChar determines if there is an incomplete UTF-8 character at
// the end of the given buffer. If so, it sets this.charLength to the byte
// length that character, and sets this.charReceived to the number of bytes
// that are available for this character.
StringDecoder.prototype.detectIncompleteChar = function(buffer) {
  // determine how many bytes we have to check at the end of this buffer
  var i = (buffer.length >= 3) ? 3 : buffer.length;

  // Figure out if one of the last i bytes of our buffer announces an
  // incomplete char.
  for (; i > 0; i--) {
    var c = buffer[buffer.length - i];

    // See http://en.wikipedia.org/wiki/UTF-8#Description

    // 110XXXXX
    if (i == 1 && c >> 5 == 0x06) {
      this.charLength = 2;
      break;
    }

    // 1110XXXX
    if (i <= 2 && c >> 4 == 0x0E) {
      this.charLength = 3;
      break;
    }

    // 11110XXX
    if (i <= 3 && c >> 3 == 0x1E) {
      this.charLength = 4;
      break;
    }
  }
  this.charReceived = i;
};

StringDecoder.prototype.end = function(buffer) {
  var res = '';
  if (buffer && buffer.length)
    res = this.write(buffer);

  if (this.charReceived) {
    var cr = this.charReceived;
    var buf = this.charBuffer;
    var enc = this.encoding;
    res += buf.slice(0, cr).toString(enc);
  }

  return res;
};

function passThroughWrite(buffer) {
  return buffer.toString(this.encoding);
}

function utf16DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 2;
  this.charLength = this.charReceived ? 2 : 0;
}

function base64DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 3;
  this.charLength = this.charReceived ? 3 : 0;
}

},{"50":50}],73:[function(_dereq_,module,exports){
module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}
},{}],74:[function(_dereq_,module,exports){
(function (process,global){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = _dereq_(73);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = _dereq_(76);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

}).call(this,_dereq_(57),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"57":57,"73":73,"76":76}],75:[function(_dereq_,module,exports){
/**
 * Copyright (c) 2013 Petka Antonov
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:</p>
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
"use strict";
function Deque(capacity) {
    this._capacity = getCapacity(capacity);
    this._length = 0;
    this._front = 0;
    this._makeCapacity();
    if (isArray(capacity)) {
        var len = capacity.length;
        for (var i = 0; i < len; ++i) {
            this[i] = capacity[i];
        }
        this._length = len;
    }
}

Deque.prototype.toArray = function Deque$toArray() {
    var len = this._length;
    var ret = new Array(len);
    var front = this._front;
    var capacity = this._capacity;
    for (var j = 0; j < len; ++j) {
        ret[j] = this[(front + j) & (capacity - 1)];
    }
    return ret;
};

Deque.prototype.push = function Deque$push(item) {
    var argsLength = arguments.length;
    var length = this._length;
    if (argsLength > 1) {
        var capacity = this._capacity;
        if (length + argsLength > capacity) {
            for (var i = 0; i < argsLength; ++i) {
                this._checkCapacity(length + 1);
                var j = (this._front + length) & (this._capacity - 1);
                this[j] = arguments[i];
                length++;
                this._length = length;
            }
            return length;
        }
        else {
            var j = this._front;
            for (var i = 0; i < argsLength; ++i) {
                this[(j + length) & (capacity - 1)] = arguments[i];
                j++;
            }
            this._length = length + argsLength;
            return length + argsLength;
        }

    }

    if (argsLength === 0) return length;

    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = item;
    this._length = length + 1;
    return length + 1;
};

Deque.prototype.pop = function Deque$pop() {
    var length = this._length;
    if (length === 0) {
        return void 0;
    }
    var i = (this._front + length - 1) & (this._capacity - 1);
    var ret = this[i];
    this[i] = void 0;
    this._length = length - 1;
    return ret;
};

Deque.prototype.shift = function Deque$shift() {
    var length = this._length;
    if (length === 0) {
        return void 0;
    }
    var front = this._front;
    var ret = this[front];
    this[front] = void 0;
    this._front = (front + 1) & (this._capacity - 1);
    this._length = length - 1;
    return ret;
};

Deque.prototype.unshift = function Deque$unshift(item) {
    var length = this._length;
    var argsLength = arguments.length;


    if (argsLength > 1) {
        var capacity = this._capacity;
        if (length + argsLength > capacity) {
            for (var i = argsLength - 1; i >= 0; i--) {
                this._checkCapacity(length + 1);
                var capacity = this._capacity;
                var j = (((( this._front - 1 ) &
                    ( capacity - 1) ) ^ capacity ) - capacity );
                this[j] = arguments[i];
                length++;
                this._length = length;
                this._front = j;
            }
            return length;
        }
        else {
            var front = this._front;
            for (var i = argsLength - 1; i >= 0; i--) {
                var j = (((( front - 1 ) &
                    ( capacity - 1) ) ^ capacity ) - capacity );
                this[j] = arguments[i];
                front = j;
            }
            this._front = front;
            this._length = length + argsLength;
            return length + argsLength;
        }
    }

    if (argsLength === 0) return length;

    this._checkCapacity(length + 1);
    var capacity = this._capacity;
    var i = (((( this._front - 1 ) &
        ( capacity - 1) ) ^ capacity ) - capacity );
    this[i] = item;
    this._length = length + 1;
    this._front = i;
    return length + 1;
};

Deque.prototype.peekBack = function Deque$peekBack() {
    var length = this._length;
    if (length === 0) {
        return void 0;
    }
    var index = (this._front + length - 1) & (this._capacity - 1);
    return this[index];
};

Deque.prototype.peekFront = function Deque$peekFront() {
    if (this._length === 0) {
        return void 0;
    }
    return this[this._front];
};

Deque.prototype.get = function Deque$get(index) {
    var i = index;
    if ((i !== (i | 0))) {
        return void 0;
    }
    var len = this._length;
    if (i < 0) {
        i = i + len;
    }
    if (i < 0 || i >= len) {
        return void 0;
    }
    return this[(this._front + i) & (this._capacity - 1)];
};

Deque.prototype.isEmpty = function Deque$isEmpty() {
    return this._length === 0;
};

Deque.prototype.clear = function Deque$clear() {
    this._length = 0;
    this._front = 0;
    this._makeCapacity();
};

Deque.prototype.toString = function Deque$toString() {
    return this.toArray().toString();
};

Deque.prototype.valueOf = Deque.prototype.toString;
Deque.prototype.removeFront = Deque.prototype.shift;
Deque.prototype.removeBack = Deque.prototype.pop;
Deque.prototype.insertFront = Deque.prototype.unshift;
Deque.prototype.insertBack = Deque.prototype.push;
Deque.prototype.enqueue = Deque.prototype.push;
Deque.prototype.dequeue = Deque.prototype.shift;
Deque.prototype.toJSON = Deque.prototype.toArray;

Object.defineProperty(Deque.prototype, "length", {
    get: function() {
        return this._length;
    },
    set: function() {
        throw new RangeError("");
    }
});

Deque.prototype._makeCapacity = function Deque$_makeCapacity() {
    var len = this._capacity;
    for (var i = 0; i < len; ++i) {
        this[i] = void 0;
    }
};

Deque.prototype._checkCapacity = function Deque$_checkCapacity(size) {
    if (this._capacity < size) {
        this._resizeTo(getCapacity(this._capacity * 1.5 + 16));
    }
};

Deque.prototype._resizeTo = function Deque$_resizeTo(capacity) {
    var oldFront = this._front;
    var oldCapacity = this._capacity;
    var oldDeque = new Array(oldCapacity);
    var length = this._length;

    arrayCopy(this, 0, oldDeque, 0, oldCapacity);
    this._capacity = capacity;
    this._makeCapacity();
    this._front = 0;
    if (oldFront + length <= oldCapacity) {
        arrayCopy(oldDeque, oldFront, this, 0, length);
    } else {        var lengthBeforeWrapping =
            length - ((oldFront + length) & (oldCapacity - 1));

        arrayCopy(oldDeque, oldFront, this, 0, lengthBeforeWrapping);
        arrayCopy(oldDeque, 0, this, lengthBeforeWrapping,
            length - lengthBeforeWrapping);
    }
};


var isArray = Array.isArray;

function arrayCopy(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
    }
}

function pow2AtLeast(n) {
    n = n >>> 0;
    n = n - 1;
    n = n | (n >> 1);
    n = n | (n >> 2);
    n = n | (n >> 4);
    n = n | (n >> 8);
    n = n | (n >> 16);
    return n + 1;
}

function getCapacity(capacity) {
    if (typeof capacity !== "number") {
        if (isArray(capacity)) {
            capacity = capacity.length;
        }
        else {
            return 16;
        }
    }
    return pow2AtLeast(
        Math.min(
            Math.max(16, capacity), 1073741824)
    );
}

module.exports = Deque;

},{}],76:[function(_dereq_,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

},{}],77:[function(_dereq_,module,exports){
(function() {

  var slice   = Array.prototype.slice,
      each    = Array.prototype.forEach;

  var extend = function(obj) {
    if(typeof obj !== 'object') throw obj + ' is not an object' ;

    var sources = slice.call(arguments, 1);

    each.call(sources, function(source) {
      if(source) {
        for(var prop in source) {
          if(typeof source[prop] === 'object' && obj[prop]) {
            extend.call(obj, obj[prop], source[prop]);
          } else {
            obj[prop] = source[prop];
          }
        }
      }
    });

    return obj;
  }

  this.extend = extend;

}).call(this);
},{}],78:[function(_dereq_,module,exports){
module.exports = {
  encode: function (e) {
    var s = '';
    var prefix = e[0].slice()
    while(prefix.length) {
      s += '\xff' + prefix.shift().toString() + '\xff'
    }
    return s + (e[1] || '').toString()
  },
  decode: function (e) {
    var k = e.toString().split('\xff').filter(Boolean)
    var j = k.pop()
    return [k, j]
  },
  lowerBound: '\x00',
  upperBound: '\xff'
}


},{}],79:[function(_dereq_,module,exports){

var inRange = _dereq_(104)

module.exports = function (compare) {
  var hooks = []

  return {
    add: function (range, hook) {
      var m = {range: range, hook: hook}
      hooks.push(m)
      //call this to remove
      return function () {
        var i = hooks.indexOf(m)
        if(~i) return hooks.splice(i, 1)
      }

    },

    //remove all listeners within a range.
    //this will be used to close a sublevel.
    removeAll: function (range) {
      throw new Error('not implemented')
    },

    trigger: function (key, args) {
      for(var i = 0; i < hooks.length; i++) {
        var test = hooks[i]
        if(inRange(test.range, key, compare))
          test.hook.apply(this, args)
      }
    }
  }
}

},{"104":104}],80:[function(_dereq_,module,exports){
var nut   = _dereq_(102)
var shell = _dereq_(105) //the shell surrounds the nut
var codec = _dereq_(81)
var merge = _dereq_(101)

var ReadStream = _dereq_(84)

var precodec = _dereq_(78)

module.exports = function (db, opts) {

  opts = merge(db.options, opts)

  return shell ( nut ( db, precodec, codec ), [], ReadStream, db.options)

}


},{"101":101,"102":102,"105":105,"78":78,"81":81,"84":84}],81:[function(_dereq_,module,exports){
/* Copyright (c) 2012-2014 LevelUP contributors
 * See list at <https://github.com/rvagg/node-levelup#contributing>
 * MIT License
 * <https://github.com/rvagg/node-levelup/blob/master/LICENSE.md>
 */

var encodings = _dereq_(82)

function getKeyEncoder (options, op) {
  var type = ((op && op.keyEncoding) || options.keyEncoding) || 'utf8'
  return encodings[type] || type
}

function getValueEncoder (options, op) {
  var type = (((op && (op.valueEncoding || op.encoding))
      || options.valueEncoding || options.encoding)) || 'utf8'
  return encodings[type] || type
}

/*
  Encode a key.
  This method takes two options, because the leveldb instance
  has options, and this operation (a put, del, or batch)
  also has options that may override the leveldb's options.
*/

function encodeKey (key, options, op) {
  return getKeyEncoder(options, op).encode(key)
}

/*
  Encode a value.
  Takes 2 options, for the same reason as encodeKey
*/

function encodeValue (value, options, op) {
  return getValueEncoder(options, op).encode(value)
}

/*
  Decode an encoded key
*/

function decodeKey (key, options) {
  return getKeyEncoder(options).decode(key)
}

/*
  Decode an encoded value
*/

function decodeValue (value, options) {
  return getValueEncoder(options).decode(value)
}

/*
  check whether this value should be requested as a buffer
  (if false, then it will be a string)
  this allows an optimization in leveldown where leveldown
  retrives a string directly, and thus avoids a memory copy.
*/

function isValueAsBuffer (options, op) {
  return getValueEncoder(options, op).buffer
}

/*
  check whether a given key should be requested as a buffer.
*/

function isKeyAsBuffer (options, op) {
  return getKeyEncoder(options, op).buffer
}


module.exports = {
    encodeKey       : encodeKey
  , encodeValue     : encodeValue
  , isValueAsBuffer : isValueAsBuffer
  , isKeyAsBuffer   : isKeyAsBuffer
  , decodeValue     : decodeValue
  , decodeKey       : decodeKey
}

},{"82":82}],82:[function(_dereq_,module,exports){
(function (Buffer){
/* Copyright (c) 2012-2014 LevelUP contributors
 * See list at <https://github.com/rvagg/node-levelup#contributing>
 * MIT License
 * <https://github.com/rvagg/node-levelup/blob/master/LICENSE.md>
 */

var encodingNames = [
        'hex'
      , 'utf8'
      , 'utf-8'
      , 'ascii'
      , 'binary'
      , 'base64'
      , 'ucs2'
      , 'ucs-2'
      , 'utf16le'
      , 'utf-16le'
    ]

module.exports = (function () {
  function isBinary (data) {
    return data === undefined || data === null || Buffer.isBuffer(data)
  }

  var encodings = {}

  encodings.utf8 = encodings['utf-8'] = {
      encode : function (data) {
        return isBinary(data) ? data : String(data)
      }
    , decode : function (data) { return data }
    , buffer : false
    , type   : 'utf8'
  }

  encodings.json = {
      encode : JSON.stringify
    , decode : JSON.parse
    , buffer : false
    , type   : 'json'
  }

  encodings.binary = {
      encode : function (data) {
        return isBinary(data) ? data : new Buffer(data)
      }
    , decode : function (data) {
        return data
      }
    , buffer : true
    , type   : 'binary'
  }

  encodingNames.forEach(function (type) {
    if (encodings[type])
      return

    encodings[type] = {
        encode : function (data) {
          return isBinary(data) ? data : new Buffer(data, type)
        }
      , decode : function (buffer) {
          return buffer.toString(type)
        }
      , buffer : true
      , type   : type // useful for debugging purposes
    }
  })

  return encodings
})()


}).call(this,_dereq_(50).Buffer)
},{"50":50}],83:[function(_dereq_,module,exports){
/* Copyright (c) 2012-2014 LevelUP contributors
 * See list at <https://github.com/rvagg/node-levelup#contributing>
 * MIT License
 * <https://github.com/rvagg/node-levelup/blob/master/LICENSE.md>
 */

var createError   = _dereq_(87).create
  , LevelUPError  = createError('LevelUPError')
  , NotFoundError = createError('NotFoundError', LevelUPError)

NotFoundError.prototype.notFound = true
NotFoundError.prototype.status   = 404

module.exports = {
    LevelUPError        : LevelUPError
  , InitializationError : createError('InitializationError', LevelUPError)
  , OpenError           : createError('OpenError', LevelUPError)
  , ReadError           : createError('ReadError', LevelUPError)
  , WriteError          : createError('WriteError', LevelUPError)
  , NotFoundError       : NotFoundError
  , EncodingError       : createError('EncodingError', LevelUPError)
}

},{"87":87}],84:[function(_dereq_,module,exports){
/* Copyright (c) 2012-2014 LevelUP contributors
 * See list at <https://github.com/rvagg/node-levelup#contributing>
 * MIT License <https://github.com/rvagg/node-levelup/blob/master/LICENSE.md>
 */

// NOTE: we are fixed to readable-stream@1.0.x for now
// for pure Streams2 across Node versions
var Readable      = _dereq_(97).Readable
  , inherits      = _dereq_(74).inherits
  , extend        = _dereq_(98)
  , EncodingError = _dereq_(83).EncodingError
  , util          = _dereq_(85)



function ReadStream (options, makeData) {
  if (!(this instanceof ReadStream))
    return new ReadStream(options, makeData)

  Readable.call(this, { objectMode: true, highWaterMark: options.highWaterMark })

  // purely to keep `db` around until we're done so it's not GCed if the user doesn't keep a ref

  this._waiting = false
  this._options = options
  this._makeData = makeData
}

inherits(ReadStream, Readable)

ReadStream.prototype.setIterator = function (it) {
  var self = this
  this._iterator = it
  if(this._destroyed) return it.end(function () {})
  if(this._waiting) {
    this._waiting = false
    return this._read()
  }
  return this
}

ReadStream.prototype._read = function read () {
  var self = this
  if (self._destroyed)
    return
  if(!self._iterator)
    return this._waiting = true

  self._iterator.next(function(err, key, value) {
    if (err || (key === undefined && value === undefined)) {
      if (!err && !self._destroyed)
        self.push(null)
      return self._cleanup(err)
    }


    try {
      value = self._makeData(key, value)
    } catch (e) {
      return self._cleanup(new EncodingError(e))
    }
    if (!self._destroyed)
      self.push(value)
  })
}

ReadStream.prototype._cleanup = function (err) {
  if (this._destroyed)
    return

  this._destroyed = true

  var self = this
  if (err)
    self.emit('error', err)

  if (self._iterator) {
    self._iterator.end(function () {
      self._iterator = null
      self.emit('close')
    })
  } else {
    self.emit('close')
  }
}

ReadStream.prototype.destroy = function () {
  this._cleanup()
}

ReadStream.prototype.toString = function () {
  return 'LevelUP.ReadStream'
}


module.exports = ReadStream


},{"74":74,"83":83,"85":85,"97":97,"98":98}],85:[function(_dereq_,module,exports){
/* Copyright (c) 2012-2014 LevelUP contributors
 * See list at <https://github.com/rvagg/node-levelup#contributing>
 * MIT License
 * <https://github.com/rvagg/node-levelup/blob/master/LICENSE.md>
 */

var extend        = _dereq_(98)
  , LevelUPError  = _dereq_(83).LevelUPError
  , encodings     = _dereq_(82)
  , defaultOptions = {
        createIfMissing : true
      , errorIfExists   : false
      , keyEncoding     : 'utf8'
      , valueEncoding   : 'utf8'
      , compression     : true
    }

  , leveldown
  , encodingOpts = (function () {
      var eo = {}
      for(var e in encodings)
        eo[e] = {valueEncoding: encodings[e]}
      return eo
    }())

function copy (srcdb, dstdb, callback) {
  srcdb.readStream()
    .pipe(dstdb.writeStream())
    .on('close', callback ? callback : function () {})
    .on('error', callback ? callback : function (err) { throw err })
}

function getOptions (levelup, options) {
  var s = typeof options == 'string' // just an encoding
  if (!s && options && options.encoding && !options.valueEncoding)
    options.valueEncoding = options.encoding
  return extend(
      (levelup && levelup.options) || {}
    , s ? encodingOpts[options] || encodingOpts[defaultOptions.valueEncoding]
        : options
  )
}

function getLevelDOWN () {
  if (leveldown)
    return leveldown

  var requiredVersion       = _dereq_(99).devDependencies.leveldown
    , missingLevelDOWNError = 'Could not locate LevelDOWN, try `npm install leveldown`'
    , leveldownVersion

  try {
    leveldownVersion = _dereq_(49).version
  } catch (e) {
    throw new LevelUPError(missingLevelDOWNError)
  }

  if (!_dereq_(49).satisfies(leveldownVersion, requiredVersion)) {
    throw new LevelUPError(
        'Installed version of LevelDOWN ('
      + leveldownVersion
      + ') does not match required version ('
      + requiredVersion
      + ')'
    )
  }

  try {
    return leveldown = _dereq_(49)
  } catch (e) {
    throw new LevelUPError(missingLevelDOWNError)
  }
}

function dispatchError (levelup, error, callback) {
  return typeof callback == 'function'
    ? callback(error)
    : levelup.emit('error', error)
}

function isDefined (v) {
  return typeof v !== 'undefined'
}

module.exports = {
    defaultOptions  : defaultOptions
  , copy            : copy
  , getOptions      : getOptions
  , getLevelDOWN    : getLevelDOWN
  , dispatchError   : dispatchError
  , isDefined       : isDefined
}

},{"49":49,"82":82,"83":83,"98":98,"99":99}],86:[function(_dereq_,module,exports){
var prr = _dereq_(88)

function init (type, message, cause) {
  prr(this, {
      type    : type
    , name    : type
      // can be passed just a 'cause'
    , cause   : typeof message != 'string' ? message : cause
    , message : !!message && typeof message != 'string' ? message.message : message

  }, 'ewr')
}

// generic prototype, not intended to be actually used - helpful for `instanceof`
function CustomError (message, cause) {
  Error.call(this)
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, arguments.callee)
  init.call(this, 'CustomError', message, cause)
}

CustomError.prototype = new Error()

function createError (errno, type, proto) {
  var err = function (message, cause) {
    init.call(this, type, message, cause)
    //TODO: the specificity here is stupid, errno should be available everywhere
    if (type == 'FilesystemError') {
      this.code    = this.cause.code
      this.path    = this.cause.path
      this.errno   = this.cause.errno
      this.message =
        (errno.errno[this.cause.errno]
          ? errno.errno[this.cause.errno].description
          : this.cause.message)
        + (this.cause.path ? ' [' + this.cause.path + ']' : '')
    }
    Error.call(this)
    if (Error.captureStackTrace)
      Error.captureStackTrace(this, arguments.callee)
  }
  err.prototype = !!proto ? new proto() : new CustomError()
  return err
}

module.exports = function (errno) {
  var ce = function (type, proto) {
    return createError(errno, type, proto)
  }
  return {
      CustomError     : CustomError
    , FilesystemError : ce('FilesystemError')
    , createError     : ce
  }
}

},{"88":88}],87:[function(_dereq_,module,exports){
var all = module.exports.all = [
  {
    errno: -2,
    code: 'ENOENT',
    description: 'no such file or directory'
  },
  {
    errno: -1,
    code: 'UNKNOWN',
    description: 'unknown error'
  },
  {
    errno: 0,
    code: 'OK',
    description: 'success'
  },
  {
    errno: 1,
    code: 'EOF',
    description: 'end of file'
  },
  {
    errno: 2,
    code: 'EADDRINFO',
    description: 'getaddrinfo error'
  },
  {
    errno: 3,
    code: 'EACCES',
    description: 'permission denied'
  },
  {
    errno: 4,
    code: 'EAGAIN',
    description: 'resource temporarily unavailable'
  },
  {
    errno: 5,
    code: 'EADDRINUSE',
    description: 'address already in use'
  },
  {
    errno: 6,
    code: 'EADDRNOTAVAIL',
    description: 'address not available'
  },
  {
    errno: 7,
    code: 'EAFNOSUPPORT',
    description: 'address family not supported'
  },
  {
    errno: 8,
    code: 'EALREADY',
    description: 'connection already in progress'
  },
  {
    errno: 9,
    code: 'EBADF',
    description: 'bad file descriptor'
  },
  {
    errno: 10,
    code: 'EBUSY',
    description: 'resource busy or locked'
  },
  {
    errno: 11,
    code: 'ECONNABORTED',
    description: 'software caused connection abort'
  },
  {
    errno: 12,
    code: 'ECONNREFUSED',
    description: 'connection refused'
  },
  {
    errno: 13,
    code: 'ECONNRESET',
    description: 'connection reset by peer'
  },
  {
    errno: 14,
    code: 'EDESTADDRREQ',
    description: 'destination address required'
  },
  {
    errno: 15,
    code: 'EFAULT',
    description: 'bad address in system call argument'
  },
  {
    errno: 16,
    code: 'EHOSTUNREACH',
    description: 'host is unreachable'
  },
  {
    errno: 17,
    code: 'EINTR',
    description: 'interrupted system call'
  },
  {
    errno: 18,
    code: 'EINVAL',
    description: 'invalid argument'
  },
  {
    errno: 19,
    code: 'EISCONN',
    description: 'socket is already connected'
  },
  {
    errno: 20,
    code: 'EMFILE',
    description: 'too many open files'
  },
  {
    errno: 21,
    code: 'EMSGSIZE',
    description: 'message too long'
  },
  {
    errno: 22,
    code: 'ENETDOWN',
    description: 'network is down'
  },
  {
    errno: 23,
    code: 'ENETUNREACH',
    description: 'network is unreachable'
  },
  {
    errno: 24,
    code: 'ENFILE',
    description: 'file table overflow'
  },
  {
    errno: 25,
    code: 'ENOBUFS',
    description: 'no buffer space available'
  },
  {
    errno: 26,
    code: 'ENOMEM',
    description: 'not enough memory'
  },
  {
    errno: 27,
    code: 'ENOTDIR',
    description: 'not a directory'
  },
  {
    errno: 28,
    code: 'EISDIR',
    description: 'illegal operation on a directory'
  },
  {
    errno: 29,
    code: 'ENONET',
    description: 'machine is not on the network'
  },
  {
    errno: 31,
    code: 'ENOTCONN',
    description: 'socket is not connected'
  },
  {
    errno: 32,
    code: 'ENOTSOCK',
    description: 'socket operation on non-socket'
  },
  {
    errno: 33,
    code: 'ENOTSUP',
    description: 'operation not supported on socket'
  },
  {
    errno: 34,
    code: 'ENOENT',
    description: 'no such file or directory'
  },
  {
    errno: 35,
    code: 'ENOSYS',
    description: 'function not implemented'
  },
  {
    errno: 36,
    code: 'EPIPE',
    description: 'broken pipe'
  },
  {
    errno: 37,
    code: 'EPROTO',
    description: 'protocol error'
  },
  {
    errno: 38,
    code: 'EPROTONOSUPPORT',
    description: 'protocol not supported'
  },
  {
    errno: 39,
    code: 'EPROTOTYPE',
    description: 'protocol wrong type for socket'
  },
  {
    errno: 40,
    code: 'ETIMEDOUT',
    description: 'connection timed out'
  },
  {
    errno: 41,
    code: 'ECHARSET',
    description: 'invalid Unicode character'
  },
  {
    errno: 42,
    code: 'EAIFAMNOSUPPORT',
    description: 'address family for hostname not supported'
  },
  {
    errno: 44,
    code: 'EAISERVICE',
    description: 'servname not supported for ai_socktype'
  },
  {
    errno: 45,
    code: 'EAISOCKTYPE',
    description: 'ai_socktype not supported'
  },
  {
    errno: 46,
    code: 'ESHUTDOWN',
    description: 'cannot send after transport endpoint shutdown'
  },
  {
    errno: 47,
    code: 'EEXIST',
    description: 'file already exists'
  },
  {
    errno: 48,
    code: 'ESRCH',
    description: 'no such process'
  },
  {
    errno: 49,
    code: 'ENAMETOOLONG',
    description: 'name too long'
  },
  {
    errno: 50,
    code: 'EPERM',
    description: 'operation not permitted'
  },
  {
    errno: 51,
    code: 'ELOOP',
    description: 'too many symbolic links encountered'
  },
  {
    errno: 52,
    code: 'EXDEV',
    description: 'cross-device link not permitted'
  },
  {
    errno: 53,
    code: 'ENOTEMPTY',
    description: 'directory not empty'
  },
  {
    errno: 54,
    code: 'ENOSPC',
    description: 'no space left on device'
  },
  {
    errno: 55,
    code: 'EIO',
    description: 'i/o error'
  },
  {
    errno: 56,
    code: 'EROFS',
    description: 'read-only file system'
  },
  {
    errno: 57,
    code: 'ENODEV',
    description: 'no such device'
  },
  {
    errno: 58,
    code: 'ESPIPE',
    description: 'invalid seek'
  },
  {
    errno: 59,
    code: 'ECANCELED',
    description: 'operation canceled'
  }
]

module.exports.errno = {}
module.exports.code = {}

all.forEach(function (error) {
  module.exports.errno[error.errno] = error
  module.exports.code[error.code] = error
})

module.exports.custom = _dereq_(86)(module.exports)
module.exports.create = module.exports.custom.createError

},{"86":86}],88:[function(_dereq_,module,exports){
/*!
  * prr
  * (c) 2013 Rod Vagg <rod@vagg.org>
  * https://github.com/rvagg/prr
  * License: MIT
  */

(function (name, context, definition) {
  if (typeof module != 'undefined' && module.exports)
    module.exports = definition()
  else
    context[name] = definition()
})('prr', this, function() {

  var setProperty = typeof Object.defineProperty == 'function'
      ? function (obj, key, options) {
          Object.defineProperty(obj, key, options)
          return obj
        }
      : function (obj, key, options) { // < es5
          obj[key] = options.value
          return obj
        }

    , makeOptions = function (value, options) {
        var oo = typeof options == 'object'
          , os = !oo && typeof options == 'string'
          , op = function (p) {
              return oo
                ? !!options[p]
                : os
                  ? options.indexOf(p[0]) > -1
                  : false
            }

        return {
            enumerable   : op('enumerable')
          , configurable : op('configurable')
          , writable     : op('writable')
          , value        : value
        }
      }

    , prr = function (obj, key, value, options) {
        var k

        options = makeOptions(value, options)

        if (typeof key == 'object') {
          for (k in key) {
            if (Object.hasOwnProperty.call(key, k)) {
              options.value = key[k]
              setProperty(obj, k, options)
            }
          }
          return obj
        }

        return setProperty(obj, key, options)
      }

  return prr
})
},{}],89:[function(_dereq_,module,exports){
(function (process){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

module.exports = Duplex;

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}
/*</replacement>*/


/*<replacement>*/
var util = _dereq_(94);
util.inherits = _dereq_(76);
/*</replacement>*/

var Readable = _dereq_(91);
var Writable = _dereq_(93);

util.inherits(Duplex, Readable);

forEach(objectKeys(Writable.prototype), function(method) {
  if (!Duplex.prototype[method])
    Duplex.prototype[method] = Writable.prototype[method];
});

function Duplex(options) {
  if (!(this instanceof Duplex))
    return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false)
    this.readable = false;

  if (options && options.writable === false)
    this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false)
    this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended)
    return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(this.end.bind(this));
}

function forEach (xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

}).call(this,_dereq_(57))
},{"57":57,"76":76,"91":91,"93":93,"94":94}],90:[function(_dereq_,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

module.exports = PassThrough;

var Transform = _dereq_(92);

/*<replacement>*/
var util = _dereq_(94);
util.inherits = _dereq_(76);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough))
    return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function(chunk, encoding, cb) {
  cb(null, chunk);
};

},{"76":76,"92":92,"94":94}],91:[function(_dereq_,module,exports){
(function (process){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Readable;

/*<replacement>*/
var isArray = _dereq_(95);
/*</replacement>*/


/*<replacement>*/
var Buffer = _dereq_(50).Buffer;
/*</replacement>*/

Readable.ReadableState = ReadableState;

var EE = _dereq_(54).EventEmitter;

/*<replacement>*/
if (!EE.listenerCount) EE.listenerCount = function(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

var Stream = _dereq_(71);

/*<replacement>*/
var util = _dereq_(94);
util.inherits = _dereq_(76);
/*</replacement>*/

var StringDecoder;

util.inherits(Readable, Stream);

function ReadableState(options, stream) {
  options = options || {};

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  this.highWaterMark = (hwm || hwm === 0) ? hwm : 16 * 1024;

  // cast to ints.
  this.highWaterMark = ~~this.highWaterMark;

  this.buffer = [];
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = false;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // In streams that never have any data, and do push(null) right away,
  // the consumer can miss the 'end' event if they do some I/O before
  // consuming the stream.  So, we don't emit('end') until some reading
  // happens.
  this.calledRead = false;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, becuase any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;


  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // when piping, we only care about 'readable' events that happen
  // after read()ing all the bytes and not getting any pushback.
  this.ranOut = false;

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder)
      StringDecoder = _dereq_(96).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  if (!(this instanceof Readable))
    return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  Stream.call(this);
}

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
  var state = this._readableState;

  if (typeof chunk === 'string' && !state.objectMode) {
    encoding = encoding || state.defaultEncoding;
    if (encoding !== state.encoding) {
      chunk = new Buffer(chunk, encoding);
      encoding = '';
    }
  }

  return readableAddChunk(this, state, chunk, encoding, false);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
  var state = this._readableState;
  return readableAddChunk(this, state, chunk, '', true);
};

function readableAddChunk(stream, state, chunk, encoding, addToFront) {
  var er = chunkInvalid(state, chunk);
  if (er) {
    stream.emit('error', er);
  } else if (chunk === null || chunk === undefined) {
    state.reading = false;
    if (!state.ended)
      onEofChunk(stream, state);
  } else if (state.objectMode || chunk && chunk.length > 0) {
    if (state.ended && !addToFront) {
      var e = new Error('stream.push() after EOF');
      stream.emit('error', e);
    } else if (state.endEmitted && addToFront) {
      var e = new Error('stream.unshift() after end event');
      stream.emit('error', e);
    } else {
      if (state.decoder && !addToFront && !encoding)
        chunk = state.decoder.write(chunk);

      // update the buffer info.
      state.length += state.objectMode ? 1 : chunk.length;
      if (addToFront) {
        state.buffer.unshift(chunk);
      } else {
        state.reading = false;
        state.buffer.push(chunk);
      }

      if (state.needReadable)
        emitReadable(stream);

      maybeReadMore(stream, state);
    }
  } else if (!addToFront) {
    state.reading = false;
  }

  return needMoreData(state);
}



// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended &&
         (state.needReadable ||
          state.length < state.highWaterMark ||
          state.length === 0);
}

// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
  if (!StringDecoder)
    StringDecoder = _dereq_(96).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
};

// Don't raise the hwm > 128MB
var MAX_HWM = 0x800000;
function roundUpToNextPowerOf2(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2
    n--;
    for (var p = 1; p < 32; p <<= 1) n |= n >> p;
    n++;
  }
  return n;
}

function howMuchToRead(n, state) {
  if (state.length === 0 && state.ended)
    return 0;

  if (state.objectMode)
    return n === 0 ? 0 : 1;

  if (n === null || isNaN(n)) {
    // only flow one buffer at a time
    if (state.flowing && state.buffer.length)
      return state.buffer[0].length;
    else
      return state.length;
  }

  if (n <= 0)
    return 0;

  // If we're asking for more than the target buffer level,
  // then raise the water mark.  Bump up to the next highest
  // power of 2, to prevent increasing it excessively in tiny
  // amounts.
  if (n > state.highWaterMark)
    state.highWaterMark = roundUpToNextPowerOf2(n);

  // don't have that much.  return null, unless we've ended.
  if (n > state.length) {
    if (!state.ended) {
      state.needReadable = true;
      return 0;
    } else
      return state.length;
  }

  return n;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
  var state = this._readableState;
  state.calledRead = true;
  var nOrig = n;
  var ret;

  if (typeof n !== 'number' || n > 0)
    state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 &&
      state.needReadable &&
      (state.length >= state.highWaterMark || state.ended)) {
    emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    ret = null;

    // In cases where the decoder did not receive enough data
    // to produce a full chunk, then immediately received an
    // EOF, state.buffer will contain [<Buffer >, <Buffer 00 ...>].
    // howMuchToRead will see this and coerce the amount to
    // read to zero (because it's looking at the length of the
    // first <Buffer > in state.buffer), and we'll end up here.
    //
    // This can only happen via state.decoder -- no other venue
    // exists for pushing a zero-length chunk into state.buffer
    // and triggering this behavior. In this case, we return our
    // remaining data and end the stream, if appropriate.
    if (state.length > 0 && state.decoder) {
      ret = fromList(n, state);
      state.length -= ret.length;
    }

    if (state.length === 0)
      endReadable(this);

    return ret;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;

  // if we currently have less than the highWaterMark, then also read some
  if (state.length - n <= state.highWaterMark)
    doRead = true;

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading)
    doRead = false;

  if (doRead) {
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0)
      state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
  }

  // If _read called its callback synchronously, then `reading`
  // will be false, and we need to re-evaluate how much data we
  // can return to the user.
  if (doRead && !state.reading)
    n = howMuchToRead(nOrig, state);

  if (n > 0)
    ret = fromList(n, state);
  else
    ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  }

  state.length -= n;

  // If we have nothing in the buffer, then we want to know
  // as soon as we *do* get something into the buffer.
  if (state.length === 0 && !state.ended)
    state.needReadable = true;

  // If we happened to read() exactly the remaining amount in the
  // buffer, and the EOF has been seen at this point, then make sure
  // that we emit 'end' on the very next tick.
  if (state.ended && !state.endEmitted && state.length === 0)
    endReadable(this);

  return ret;
};

function chunkInvalid(state, chunk) {
  var er = null;
  if (!Buffer.isBuffer(chunk) &&
      'string' !== typeof chunk &&
      chunk !== null &&
      chunk !== undefined &&
      !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}


function onEofChunk(stream, state) {
  if (state.decoder && !state.ended) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // if we've ended and we have some data left, then emit
  // 'readable' now to make sure it gets picked up.
  if (state.length > 0)
    emitReadable(stream);
  else
    endReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (state.emittedReadable)
    return;

  state.emittedReadable = true;
  if (state.sync)
    process.nextTick(function() {
      emitReadable_(stream);
    });
  else
    emitReadable_(stream);
}

function emitReadable_(stream) {
  stream.emit('readable');
}


// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(function() {
      maybeReadMore_(stream, state);
    });
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended &&
         state.length < state.highWaterMark) {
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
    else
      len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
  this.emit('error', new Error('not implemented'));
};

Readable.prototype.pipe = function(dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;

  var doEnd = (!pipeOpts || pipeOpts.end !== false) &&
              dest !== process.stdout &&
              dest !== process.stderr;

  var endFn = doEnd ? onend : cleanup;
  if (state.endEmitted)
    process.nextTick(endFn);
  else
    src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable) {
    if (readable !== src) return;
    cleanup();
  }

  function onend() {
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  function cleanup() {
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', cleanup);

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (!dest._writableState || dest._writableState.needDrain)
      ondrain();
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    unpipe();
    dest.removeListener('error', onerror);
    if (EE.listenerCount(dest, 'error') === 0)
      dest.emit('error', er);
  }
  // This is a brutally ugly hack to make sure that our error handler
  // is attached before any userland ones.  NEVER DO THIS.
  if (!dest._events || !dest._events.error)
    dest.on('error', onerror);
  else if (isArray(dest._events.error))
    dest._events.error.unshift(onerror);
  else
    dest._events.error = [onerror, dest._events.error];



  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    // the handler that waits for readable events after all
    // the data gets sucked out in flow.
    // This would be easier to follow with a .once() handler
    // in flow(), but that is too slow.
    this.on('readable', pipeOnReadable);

    state.flowing = true;
    process.nextTick(function() {
      flow(src);
    });
  }

  return dest;
};

function pipeOnDrain(src) {
  return function() {
    var dest = this;
    var state = src._readableState;
    state.awaitDrain--;
    if (state.awaitDrain === 0)
      flow(src);
  };
}

function flow(src) {
  var state = src._readableState;
  var chunk;
  state.awaitDrain = 0;

  function write(dest, i, list) {
    var written = dest.write(chunk);
    if (false === written) {
      state.awaitDrain++;
    }
  }

  while (state.pipesCount && null !== (chunk = src.read())) {

    if (state.pipesCount === 1)
      write(state.pipes, 0, null);
    else
      forEach(state.pipes, write);

    src.emit('data', chunk);

    // if anyone needs a drain, then we have to wait for that.
    if (state.awaitDrain > 0)
      return;
  }

  // if every destination was unpiped, either before entering this
  // function, or in the while loop, then stop flowing.
  //
  // NB: This is a pretty rare edge case.
  if (state.pipesCount === 0) {
    state.flowing = false;

    // if there were data event listeners added, then switch to old mode.
    if (EE.listenerCount(src, 'data') > 0)
      emitDataEvents(src);
    return;
  }

  // at this point, no one needed a drain, so we just ran out of data
  // on the next readable event, start it over again.
  state.ranOut = true;
}

function pipeOnReadable() {
  if (this._readableState.ranOut) {
    this._readableState.ranOut = false;
    flow(this);
  }
}


Readable.prototype.unpipe = function(dest) {
  var state = this._readableState;

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0)
    return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes)
      return this;

    if (!dest)
      dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    this.removeListener('readable', pipeOnReadable);
    state.flowing = false;
    if (dest)
      dest.emit('unpipe', this);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    this.removeListener('readable', pipeOnReadable);
    state.flowing = false;

    for (var i = 0; i < len; i++)
      dests[i].emit('unpipe', this);
    return this;
  }

  // try to find the right one.
  var i = indexOf(state.pipes, dest);
  if (i === -1)
    return this;

  state.pipes.splice(i, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1)
    state.pipes = state.pipes[0];

  dest.emit('unpipe', this);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data' && !this._readableState.flowing)
    emitDataEvents(this);

  if (ev === 'readable' && this.readable) {
    var state = this._readableState;
    if (!state.readableListening) {
      state.readableListening = true;
      state.emittedReadable = false;
      state.needReadable = true;
      if (!state.reading) {
        this.read(0);
      } else if (state.length) {
        emitReadable(this, state);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
  emitDataEvents(this);
  this.read(0);
  this.emit('resume');
};

Readable.prototype.pause = function() {
  emitDataEvents(this, true);
  this.emit('pause');
};

function emitDataEvents(stream, startPaused) {
  var state = stream._readableState;

  if (state.flowing) {
    // https://github.com/isaacs/readable-stream/issues/16
    throw new Error('Cannot switch to old mode now.');
  }

  var paused = startPaused || false;
  var readable = false;

  // convert to an old-style stream.
  stream.readable = true;
  stream.pipe = Stream.prototype.pipe;
  stream.on = stream.addListener = Stream.prototype.on;

  stream.on('readable', function() {
    readable = true;

    var c;
    while (!paused && (null !== (c = stream.read())))
      stream.emit('data', c);

    if (c === null) {
      readable = false;
      stream._readableState.needReadable = true;
    }
  });

  stream.pause = function() {
    paused = true;
    this.emit('pause');
  };

  stream.resume = function() {
    paused = false;
    if (readable)
      process.nextTick(function() {
        stream.emit('readable');
      });
    else
      this.read(0);
    this.emit('resume');
  };

  // now make it start, just in case it hadn't already.
  stream.emit('readable');
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function() {
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length)
        self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function(chunk) {
    if (state.decoder)
      chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    //if (state.objectMode && util.isNullOrUndefined(chunk))
    if (state.objectMode && (chunk === null || chunk === undefined))
      return;
    else if (!state.objectMode && (!chunk || !chunk.length))
      return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (typeof stream[i] === 'function' &&
        typeof this[i] === 'undefined') {
      this[i] = function(method) { return function() {
        return stream[method].apply(stream, arguments);
      }}(i);
    }
  }

  // proxy certain important events.
  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
  forEach(events, function(ev) {
    stream.on(ev, self.emit.bind(self, ev));
  });

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function(n) {
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};



// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
function fromList(n, state) {
  var list = state.buffer;
  var length = state.length;
  var stringMode = !!state.decoder;
  var objectMode = !!state.objectMode;
  var ret;

  // nothing in the list, definitely empty.
  if (list.length === 0)
    return null;

  if (length === 0)
    ret = null;
  else if (objectMode)
    ret = list.shift();
  else if (!n || n >= length) {
    // read it all, truncate the array.
    if (stringMode)
      ret = list.join('');
    else
      ret = Buffer.concat(list, length);
    list.length = 0;
  } else {
    // read just some of it.
    if (n < list[0].length) {
      // just take a part of the first list item.
      // slice is the same for buffers and strings.
      var buf = list[0];
      ret = buf.slice(0, n);
      list[0] = buf.slice(n);
    } else if (n === list[0].length) {
      // first list is a perfect match
      ret = list.shift();
    } else {
      // complex case.
      // we have enough to cover it, but it spans past the first buffer.
      if (stringMode)
        ret = '';
      else
        ret = new Buffer(n);

      var c = 0;
      for (var i = 0, l = list.length; i < l && c < n; i++) {
        var buf = list[0];
        var cpy = Math.min(n - c, buf.length);

        if (stringMode)
          ret += buf.slice(0, cpy);
        else
          buf.copy(ret, c, 0, cpy);

        if (cpy < buf.length)
          list[0] = buf.slice(cpy);
        else
          list.shift();

        c += cpy;
      }
    }
  }

  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0)
    throw new Error('endReadable called on non-empty stream');

  if (!state.endEmitted && state.calledRead) {
    state.ended = true;
    process.nextTick(function() {
      // Check that we didn't get one last unshift.
      if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
      }
    });
  }
}

function forEach (xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf (xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

}).call(this,_dereq_(57))
},{"50":50,"54":54,"57":57,"71":71,"76":76,"94":94,"95":95,"96":96}],92:[function(_dereq_,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.


// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

module.exports = Transform;

var Duplex = _dereq_(89);

/*<replacement>*/
var util = _dereq_(94);
util.inherits = _dereq_(76);
/*</replacement>*/

util.inherits(Transform, Duplex);


function TransformState(options, stream) {
  this.afterTransform = function(er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb)
    return stream.emit('error', new Error('no writecb in Transform class'));

  ts.writechunk = null;
  ts.writecb = null;

  if (data !== null && data !== undefined)
    stream.push(data);

  if (cb)
    cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}


function Transform(options) {
  if (!(this instanceof Transform))
    return new Transform(options);

  Duplex.call(this, options);

  var ts = this._transformState = new TransformState(options, this);

  // when the writable side finishes, then flush out anything remaining.
  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  this.once('finish', function() {
    if ('function' === typeof this._flush)
      this._flush(function(er) {
        done(stream, er);
      });
    else
      done(stream);
  });
}

Transform.prototype.push = function(chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
  throw new Error('not implemented');
};

Transform.prototype._write = function(chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform ||
        rs.needReadable ||
        rs.length < rs.highWaterMark)
      this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};


function done(stream, er) {
  if (er)
    return stream.emit('error', er);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var rs = stream._readableState;
  var ts = stream._transformState;

  if (ws.length)
    throw new Error('calling transform done when ws.length != 0');

  if (ts.transforming)
    throw new Error('calling transform done when still transforming');

  return stream.push(null);
}

},{"76":76,"89":89,"94":94}],93:[function(_dereq_,module,exports){
(function (process){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, cb), and it'll handle all
// the drain event emission and buffering.

module.exports = Writable;

/*<replacement>*/
var Buffer = _dereq_(50).Buffer;
/*</replacement>*/

Writable.WritableState = WritableState;


/*<replacement>*/
var util = _dereq_(94);
util.inherits = _dereq_(76);
/*</replacement>*/

var Stream = _dereq_(71);

util.inherits(Writable, Stream);

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
}

function WritableState(options, stream) {
  options = options || {};

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  this.highWaterMark = (hwm || hwm === 0) ? hwm : 16 * 1024;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  // cast to ints.
  this.highWaterMark = ~~this.highWaterMark;

  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, becuase any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function(er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.buffer = [];

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;
}

function Writable(options) {
  var Duplex = _dereq_(89);

  // Writable ctor is applied to Duplexes, though they're not
  // instanceof Writable, they're instanceof Readable.
  if (!(this instanceof Writable) && !(this instanceof Duplex))
    return new Writable(options);

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
  this.emit('error', new Error('Cannot pipe. Not readable.'));
};


function writeAfterEnd(stream, state, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  process.nextTick(function() {
    cb(er);
  });
}

// If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  if (!Buffer.isBuffer(chunk) &&
      'string' !== typeof chunk &&
      chunk !== null &&
      chunk !== undefined &&
      !state.objectMode) {
    var er = new TypeError('Invalid non-string/buffer chunk');
    stream.emit('error', er);
    process.nextTick(function() {
      cb(er);
    });
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function(chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (Buffer.isBuffer(chunk))
    encoding = 'buffer';
  else if (!encoding)
    encoding = state.defaultEncoding;

  if (typeof cb !== 'function')
    cb = function() {};

  if (state.ended)
    writeAfterEnd(this, state, cb);
  else if (validChunk(this, state, chunk, cb))
    ret = writeOrBuffer(this, state, chunk, encoding, cb);

  return ret;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode &&
      state.decodeStrings !== false &&
      typeof chunk === 'string') {
    chunk = new Buffer(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, cb) {
  chunk = decodeChunk(state, chunk, encoding);
  if (Buffer.isBuffer(chunk))
    encoding = 'buffer';
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret)
    state.needDrain = true;

  if (state.writing)
    state.buffer.push(new WriteReq(chunk, encoding, cb));
  else
    doWrite(stream, state, len, chunk, encoding, cb);

  return ret;
}

function doWrite(stream, state, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  if (sync)
    process.nextTick(function() {
      cb(er);
    });
  else
    cb(er);

  stream._writableState.errorEmitted = true;
  stream.emit('error', er);
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er)
    onwriteError(stream, state, sync, er, cb);
  else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(stream, state);

    if (!finished && !state.bufferProcessing && state.buffer.length)
      clearBuffer(stream, state);

    if (sync) {
      process.nextTick(function() {
        afterWrite(stream, state, finished, cb);
      });
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished)
    onwriteDrain(stream, state);
  cb();
  if (finished)
    finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}


// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;

  for (var c = 0; c < state.buffer.length; c++) {
    var entry = state.buffer[c];
    var chunk = entry.chunk;
    var encoding = entry.encoding;
    var cb = entry.callback;
    var len = state.objectMode ? 1 : chunk.length;

    doWrite(stream, state, len, chunk, encoding, cb);

    // if we didn't call the onwrite immediately, then
    // it means that we need to wait until it does.
    // also, that means that the chunk and cb are currently
    // being processed, so move the buffer counter past them.
    if (state.writing) {
      c++;
      break;
    }
  }

  state.bufferProcessing = false;
  if (c < state.buffer.length)
    state.buffer = state.buffer.slice(c);
  else
    state.buffer.length = 0;
}

Writable.prototype._write = function(chunk, encoding, cb) {
  cb(new Error('not implemented'));
};

Writable.prototype.end = function(chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (typeof chunk !== 'undefined' && chunk !== null)
    this.write(chunk, encoding);

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished)
    endWritable(this, state, cb);
};


function needFinish(stream, state) {
  return (state.ending &&
          state.length === 0 &&
          !state.finished &&
          !state.writing);
}

function finishMaybe(stream, state) {
  var need = needFinish(stream, state);
  if (need) {
    state.finished = true;
    stream.emit('finish');
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished)
      process.nextTick(cb);
    else
      stream.once('finish', cb);
  }
  state.ended = true;
}

}).call(this,_dereq_(57))
},{"50":50,"57":57,"71":71,"76":76,"89":89,"94":94}],94:[function(_dereq_,module,exports){
(function (Buffer){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

function isBuffer(arg) {
  return Buffer.isBuffer(arg);
}
exports.isBuffer = isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}
}).call(this,{"isBuffer":_dereq_(55)})
},{"55":55}],95:[function(_dereq_,module,exports){
arguments[4][56][0].apply(exports,arguments)
},{"56":56}],96:[function(_dereq_,module,exports){
arguments[4][72][0].apply(exports,arguments)
},{"50":50,"72":72}],97:[function(_dereq_,module,exports){
var Stream = _dereq_(71); // hack to fix a circular dependency issue when used with browserify
exports = module.exports = _dereq_(91);
exports.Stream = Stream;
exports.Readable = exports;
exports.Writable = _dereq_(93);
exports.Duplex = _dereq_(89);
exports.Transform = _dereq_(92);
exports.PassThrough = _dereq_(90);

},{"71":71,"89":89,"90":90,"91":91,"92":92,"93":93}],98:[function(_dereq_,module,exports){
module.exports = extend

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}

},{}],99:[function(_dereq_,module,exports){
module.exports={
  "name": "levelup",
  "description": "Fast & simple storage - a Node.js-style LevelDB wrapper",
  "version": "0.19.0",
  "contributors": [
    {
      "name": "Rod Vagg",
      "email": "r@va.gg",
      "url": "https://github.com/rvagg"
    },
    {
      "name": "John Chesley",
      "email": "john@chesl.es",
      "url": "https://github.com/chesles/"
    },
    {
      "name": "Jake Verbaten",
      "email": "raynos2@gmail.com",
      "url": "https://github.com/raynos"
    },
    {
      "name": "Dominic Tarr",
      "email": "dominic.tarr@gmail.com",
      "url": "https://github.com/dominictarr"
    },
    {
      "name": "Max Ogden",
      "email": "max@maxogden.com",
      "url": "https://github.com/maxogden"
    },
    {
      "name": "Lars-Magnus Skog",
      "email": "lars.magnus.skog@gmail.com",
      "url": "https://github.com/ralphtheninja"
    },
    {
      "name": "David Björklund",
      "email": "david.bjorklund@gmail.com",
      "url": "https://github.com/kesla"
    },
    {
      "name": "Julian Gruber",
      "email": "julian@juliangruber.com",
      "url": "https://github.com/juliangruber"
    },
    {
      "name": "Paolo Fragomeni",
      "email": "paolo@async.ly",
      "url": "https://github.com/hij1nx"
    },
    {
      "name": "Anton Whalley",
      "email": "anton.whalley@nearform.com",
      "url": "https://github.com/No9"
    },
    {
      "name": "Matteo Collina",
      "email": "matteo.collina@gmail.com",
      "url": "https://github.com/mcollina"
    },
    {
      "name": "Pedro Teixeira",
      "email": "pedro.teixeira@gmail.com",
      "url": "https://github.com/pgte"
    },
    {
      "name": "James Halliday",
      "email": "mail@substack.net",
      "url": "https://github.com/substack"
    }
  ],
  "repository": {
    "type": "git",
    "url": "git+https://github.com/rvagg/node-levelup.git"
  },
  "homepage": "https://github.com/rvagg/node-levelup",
  "keywords": [
    "leveldb",
    "stream",
    "database",
    "db",
    "store",
    "storage",
    "json"
  ],
  "main": "lib/levelup.js",
  "dependencies": {
    "bl": "~0.8.1",
    "deferred-leveldown": "~0.2.0",
    "errno": "~0.1.1",
    "prr": "~0.0.0",
    "readable-stream": "~1.0.26",
    "semver": "~2.3.1",
    "xtend": "~3.0.0"
  },
  "devDependencies": {
    "leveldown": "~0.10.0",
    "bustermove": "*",
    "tap": "*",
    "referee": "*",
    "rimraf": "*",
    "async": "*",
    "fstream": "*",
    "tar": "*",
    "mkfiletree": "*",
    "readfiletree": "*",
    "slow-stream": ">=0.0.4",
    "delayed": "*",
    "boganipsum": "*",
    "du": "*",
    "memdown": "*",
    "msgpack-js": "*"
  },
  "browser": {
    "leveldown": false,
    "leveldown/package": false,
    "semver": false
  },
  "scripts": {
    "test": "tap test/*-test.js --stderr",
    "functionaltests": "node ./test/functional/fstream-test.js && node ./test/functional/binary-data-test.js && node ./test/functional/compat-test.js",
    "alltests": "npm test && npm run-script functionaltests"
  },
  "license": "MIT",
  "gitHead": "fb742b01990139b44b1816de87a6e1b2de629627",
  "bugs": {
    "url": "https://github.com/rvagg/node-levelup/issues"
  },
  "_id": "levelup@0.19.0",
  "_shasum": "f6b60a168c86c2fe5d5953476cbe9786ccf0a3f7",
  "_from": "levelup@>=0.19.0 <0.20.0",
  "_npmVersion": "1.4.23",
  "_npmUser": {
    "name": "rvagg",
    "email": "rod@vagg.org"
  },
  "maintainers": [
    {
      "name": "rvagg",
      "email": "rod@vagg.org"
    }
  ],
  "dist": {
    "shasum": "f6b60a168c86c2fe5d5953476cbe9786ccf0a3f7",
    "tarball": "http://registry.npmjs.org/levelup/-/levelup-0.19.0.tgz"
  },
  "directories": {},
  "_resolved": "https://registry.npmjs.org/levelup/-/levelup-0.19.0.tgz",
  "readme": "ERROR: No README data found!"
}

},{}],100:[function(_dereq_,module,exports){
(function (Buffer){

exports.compare = function (a, b) {

  if(Buffer.isBuffer(a)) {
    var l = Math.min(a.length, b.length)
    for(var i = 0; i < l; i++) {
      var cmp = a[i] - b[i]
      if(cmp) return cmp
    }
    return a.length - b.length
  }

  return a < b ? -1 : a > b ? 1 : 0
}

function has(obj, key) {
  return Object.hasOwnProperty.call(obj, key)
}

// to be compatible with the current abstract-leveldown tests
// nullish or empty strings.
// I could use !!val but I want to permit numbers and booleans,
// if possible.

function isDef (val) {
  return val !== undefined && val !== ''
}

function has (range, name) {
  return Object.hasOwnProperty.call(range, name)
}

function hasKey(range, name) {
  return Object.hasOwnProperty.call(range, name) && name
}

var lowerBoundKey = exports.lowerBoundKey = function (range) {
    return (
       hasKey(range, 'gt')
    || hasKey(range, 'gte')
    || hasKey(range, 'min')
    || (range.reverse ? hasKey(range, 'end') : hasKey(range, 'start'))
    || undefined
    )
}

var lowerBound = exports.lowerBound = function (range) {
  var k = lowerBoundKey(range)
  return k && range[k]
}

exports.lowerBoundInclusive = function (range) {
  return has(range, 'gt') ? false : true
}

exports.upperBoundInclusive =
  function (range) {
    return has(range, 'lt') || !range.minEx ? false : true
  }

var lowerBoundExclusive = exports.lowerBoundExclusive =
  function (range) {
    return has(range, 'gt') || range.minEx ? true : false
  }

var upperBoundExclusive = exports.upperBoundExclusive =
  function (range) {
    return has(range, 'lt') ? true : false
  }

var upperBoundKey = exports.upperBoundKey = function (range) {
    return (
       hasKey(range, 'lt')
    || hasKey(range, 'lte')
    || hasKey(range, 'max')
    || (range.reverse ? hasKey(range, 'start') : hasKey(range, 'end'))
    || undefined
    )
}

var upperBound = exports.upperBound = function (range) {
  var k = upperBoundKey(range)
  return k && range[k]
}

function id (e) { return e }

exports.toLtgt = function (range, _range, map, lower, upper) {
  _range = _range || {}
  map = map || id
  var defaults = arguments.length > 3
  var lb = exports.lowerBoundKey(range)
  var ub = exports.upperBoundKey(range)
  if(lb) {
    if(lb === 'gt') _range.gt = map(range.gt, false)
    else            _range.gte = map(range[lb], false)
  }
  else if(defaults)
    _range.gte = map(lower, false)

  if(ub) {
    if(ub === 'lt') _range.lt = map(range.lt, true)
    else            _range.lte = map(range[ub], true)
  }
  else if(defaults)
    _range.lte = map(upper, true)

  if(range.reverse != null)
    _range.reverse = !!range.reverse

  //if range was used mutably
  //(in level-sublevel it's part of an options object
  //that has more properties on it.)
  if(has(_range, 'max'))   delete _range.max
  if(has(_range, 'min'))   delete _range.min
  if(has(_range, 'start')) delete _range.start
  if(has(_range, 'end'))   delete _range.end

  return _range
}

exports.contains = function (range, key, compare) {
  compare = compare || exports.compare

  var lb = lowerBound(range)
  if(isDef(lb)) {
    var cmp = compare(key, lb)
    if(cmp < 0 || (cmp === 0 && lowerBoundExclusive(range)))
      return false
  }

  var ub = upperBound(range)
  if(isDef(ub)) {
    var cmp = compare(key, ub)
    if(cmp > 0 || (cmp === 0) && upperBoundExclusive(range))
      return false
  }

  return true
}

exports.filter = function (range, compare) {
  return function (key) {
    return exports.contains(range, key, compare)
  }
}

}).call(this,{"isBuffer":_dereq_(55)})
},{"55":55}],101:[function(_dereq_,module,exports){
module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}

},{}],102:[function(_dereq_,module,exports){
var hooks = _dereq_(79)
var ltgt = _dereq_(100)

function isFunction (f) {
  return 'function' === typeof f
}

function getPrefix (db) {
  if(db == null) return db
  if(isFunction(db.prefix)) return db.prefix()
  return db
}

function has(obj, name) {
  return Object.hasOwnProperty.call(obj, name)
}

function clone (_obj) {
  var obj = {}
  for(var k in _obj)
    obj[k] = _obj[k]
  return obj
}

module.exports = function (db, precodec, codec, compare) {
  var prehooks = hooks(compare)
  var posthooks = hooks(compare)
  var waiting = [], ready = false

  function encodePrefix(prefix, key, opts1, opts2) {
    return precodec.encode([ prefix, codec.encodeKey(key, opts1, opts2 ) ])
  }

  function decodePrefix(data) {
    return precodec.decode(data)
  }

  function addEncodings(op, prefix) {
    if(prefix && prefix.options) {
      op.keyEncoding =
        op.keyEncoding || prefix.options.keyEncoding
      op.valueEncoding =
        op.valueEncoding || prefix.options.valueEncoding
    }
    return op
  }

  function start () {
    ready = true
    while(waiting.length)
      waiting.shift()()
  }

  if(isFunction(db.isOpen)) {
    if(db.isOpen())
      ready = true
    else
      db.open(start)
  } else {
    db.open(start)
  }

  return {
    apply: function (ops, opts, cb) {
      //apply prehooks here.
      for(var i = 0; i < ops.length; i++) {
        var op = ops[i]

        function add(op) {
          if(op === false) return delete ops[i]
          ops.push(op)
        }

        addEncodings(op, op.prefix)
        op.prefix = getPrefix(op.prefix)
        prehooks.trigger([op.prefix, op.key], [op, add, ops])
      }

      opts = opts || {}

      if('object' !== typeof opts) throw new Error('opts must be object, was:'+ opts)

      if('function' === typeof opts) cb = opts, opts = {}

      if(ops.length)
        (db.db || db).batch(
          ops.map(function (op) {
            return {
              key: encodePrefix(op.prefix, op.key, opts, op),
              value:
                  op.type !== 'del'
                ? codec.encodeValue(
                    op.value,
                    opts,
                    op
                  )
                : undefined,
              type:
                op.type || (op.value === undefined ? 'del' : 'put')
            }
          }),
          opts,
          function (err) {
              if(err) return cb(err)
            ops.forEach(function (op) {
              posthooks.trigger([op.prefix, op.key], [op])
            })
            cb()
          }
        )
      else
        cb()
    },
    get: function (key, prefix, opts, cb) {
      opts.asBuffer = codec.isValueAsBuffer(opts)
      return (db.db || db).get(
        encodePrefix(prefix, key, opts),
        opts,
        function (err, value) {
          if(err) cb(err)
          else    cb(null, codec.decodeValue(value, opts))
        }
      )
    },
    pre: prehooks.add,
    post: posthooks.add,
    createDecoder: function (opts) {
      if(opts.keys !== false && opts.values !== false)
        return function (key, value) {
          return {
            key: codec.decodeKey(precodec.decode(key)[1], opts),
            value: codec.decodeValue(value, opts)
          }
        }
      if(opts.values !== false)
        return function (_, value) {
          return codec.decodeValue(value, opts)
        }
      if(opts.keys !== false)
        return function (key) {
          return codec.decodeKey(precodec.decode(key)[1], opts)
        }
      return function () {}
    },
    isOpen: function isOpen() {
      if (db.db && isFunction(db.db.isOpen))
        return db.db.isOpen()

      return db.isOpen()
    },
    isClosed: function isClosed() {
      if (db.db && isFunction(db.db.isClosed))
        return db.db.isClosed()

      return db.isClosed()
    },
    close: function close (cb) {
      return db.close(cb)
    },
    iterator: function (_opts, cb) {
      var opts = clone(_opts || {})
      var prefix = _opts.prefix || []

      function encodeKey(key) {
        return encodePrefix(prefix, key, opts, {})
      }

      ltgt.toLtgt(_opts, opts, encodeKey, precodec.lowerBound, precodec.upperBound)

      // if these legacy values are in the options, remove them

      opts.prefix = null

      //************************************************
      //hard coded defaults, for now...
      //TODO: pull defaults and encoding out of levelup.
      opts.keyAsBuffer = opts.valueAsBuffer = false
      //************************************************


      //this is vital, otherwise limit: undefined will
      //create an empty stream.
      if ('number' !== typeof opts.limit)
        opts.limit = -1

      opts.keyAsBuffer = precodec.buffer
      opts.valueAsBuffer = codec.isValueAsBuffer(opts)

      function wrapIterator (iterator) {
        return {
          next: function (cb) {
            return iterator.next(cb)
          },
          end: function (cb) {
            iterator.end(cb)
          }
        }
      }

      if(ready)
        return wrapIterator((db.db || db).iterator(opts))
      else
        waiting.push(function () {
          cb(null, wrapIterator((db.db || db).iterator(opts)))
        })

    }
  }

}

},{"100":100,"79":79}],103:[function(_dereq_,module,exports){
module.exports={
  "name": "level-sublevel",
  "description": "partition levelup databases",
  "version": "6.5.2",
  "homepage": "https://github.com/dominictarr/level-sublevel",
  "repository": {
    "type": "git",
    "url": "git://github.com/dominictarr/level-sublevel.git"
  },
  "dependencies": {
    "pull-stream": "~2.21.0",
    "ltgt": "~2.1.1",
    "levelup": "~0.19.0",
    "xtend": "~4.0.0",
    "bytewise": "~0.7.1",
    "typewiselite": "~1.0.0"
  },
  "devDependencies": {
    "level": "~0.18.0",
    "level-test": ">=1.5.1 <2",
    "monotonic-timestamp": "0.0.8",
    "pull-level": "~1.1.1",
    "rimraf": "~2.1.4",
    "shasum": "0.0.2",
    "stream-to-pull-stream": "~1.2.0",
    "tape": "~2.14.0",
    "through": "~2.3.4",
    "leveldown": "~1.0.1"
  },
  "scripts": {
    "test": "set -e; for t in test/*.js; do node $t; done"
  },
  "author": {
    "name": "Dominic Tarr",
    "email": "dominic.tarr@gmail.com",
    "url": "http://dominictarr.com"
  },
  "license": "MIT",
  "stability": "unstable",
  "testling": {
    "files": "test/*.js",
    "browsers": [
      "ie/8..latest",
      "firefox/17..latest",
      "firefox/nightly",
      "chrome/22..latest",
      "chrome/canary",
      "opera/12..latest",
      "opera/next",
      "safari/5.1..latest",
      "ipad/6.0..latest",
      "iphone/6.0..latest",
      "android-browser/4.2..latest"
    ]
  },
  "gitHead": "389e1329a5492daf9e4e53ef86f92779d2a56394",
  "bugs": {
    "url": "https://github.com/dominictarr/level-sublevel/issues"
  },
  "_id": "level-sublevel@6.5.2",
  "_shasum": "162df326861cecf29dc97387425e6269a972a89e",
  "_from": "level-sublevel@6.5.2",
  "_npmVersion": "3.3.1",
  "_nodeVersion": "2.3.1",
  "_npmUser": {
    "name": "dominictarr",
    "email": "dominic.tarr@gmail.com"
  },
  "maintainers": [
    {
      "name": "dominictarr",
      "email": "dominic.tarr@gmail.com"
    }
  ],
  "dist": {
    "shasum": "162df326861cecf29dc97387425e6269a972a89e",
    "tarball": "http://registry.npmjs.org/level-sublevel/-/level-sublevel-6.5.2.tgz"
  },
  "directories": {},
  "_resolved": "https://registry.npmjs.org/level-sublevel/-/level-sublevel-6.5.2.tgz",
  "readme": "ERROR: No README data found!"
}

},{}],104:[function(_dereq_,module,exports){
(function (Buffer){
var ltgt = _dereq_(100)

//compare two array items
function isArrayLike (a) {
  return Array.isArray(a) || Buffer.isBuffer(a)
}

function isPrimitive (a) {
  return 'string' === typeof a || 'number' === typeof a
}

function has(o, k) {
  return Object.hasOwnProperty.call(o, k)
}

function compare (a, b) {
  if(isArrayLike(a) && isArrayLike(b)) {
    var l = Math.min(a.length, b.length)
    for(var i = 0; i < l; i++) {
      var c = compare(a[i], b[i])
      if(c) return c
    }
    return a.length - b.length
  }
  if(isPrimitive(a) && isPrimitive(b))
    return a < b ? -1 : a > b ? 1 : 0

  throw new Error('items not comparable:'
    + JSON.stringify(a) + ' ' + JSON.stringify(b))
}

//this assumes that the prefix is of the form:
// [Array, string]

function prefix (a, b) {
  if(a.length > b.length) return false
  var l = a.length - 1
  var lastA = a[l]
  var lastB = b[l]

  if(typeof lastA !== typeof lastB)
    return false

  if('string' == typeof lastA
    && 0 != lastB.indexOf(lastA))
      return false

  //handle cas where there is no key prefix
  //(a hook on an entire sublevel)
  if(a.length == 1 && isArrayLike(lastA)) l ++

  while(l--) {
    if(compare(a[l], b[l])) return false
  }
  return true
}

exports = module.exports = function (range, key, _compare) {
  _compare = _compare || compare
  //handle prefix specially,
  //check that everything up to the last item is equal
  //then check the last item starts with
  if(isArrayLike(range)) return prefix(range, key)

  return ltgt.contains(range, key, _compare)
}

function addPrefix(prefix, range) {
  var o = ltgt.toLtgt(range, null, function (key) {
    return [prefix, key]
  })

  //if there where no ranges, then then just use a prefix.
  if(!has(o, 'gte') && !has(o, 'lte')) return [prefix]

  return o
}

exports.compare = compare
exports.prefix = prefix
exports.addPrefix = addPrefix

}).call(this,{"isBuffer":_dereq_(55)})
},{"100":100,"55":55}],105:[function(_dereq_,module,exports){
(function (process){
var EventEmitter = _dereq_(54).EventEmitter
var addpre = _dereq_(104).addPrefix

var errors = _dereq_(83)

function isFunction (f) {
  return 'function' === typeof f
}

function isString (s) {
  return 'string' === typeof s
}

function isObject (o) {
  return o && 'object' === typeof o
}

var version = _dereq_(103).version

var sublevel = module.exports = function (nut, prefix, createStream, options) {
  var emitter = new EventEmitter()
  emitter.sublevels = {}
  emitter.options = options

  emitter.version = version

  emitter.methods = {}
  prefix = prefix || []

  function errback (err) { if (err) emitter.emit('error', err) }

  createStream = createStream || function (e) { return e }

  function mergeOpts(opts) {
    var o = {}
    if(options)
      for(var k in options)
        if(options[k] != undefined)o[k] = options[k]
    if(opts)
      for(var k in opts)
        if(opts[k] != undefined) o[k] = opts[k]
    return o
  }

  emitter.put = function (key, value, opts, cb) {
    if('function' === typeof opts) cb = opts, opts = {}
    if(!cb) cb = errback

    nut.apply([{
      key: key, value: value,
      prefix: prefix.slice(), type: 'put'
    }], mergeOpts(opts), function (err) {
      if(!err) { emitter.emit('put', key, value); cb(null) }
      if(err) return cb(err)
    })
  }

  emitter.prefix = function () {
    return prefix.slice()
  }

  emitter.del = function (key, opts, cb) {
    if('function' === typeof opts) cb = opts, opts = {}
    if(!cb) cb = errback

    nut.apply([{
      key: key,
      prefix: prefix.slice(), type: 'del'
    }], mergeOpts(opts), function (err) {
      if(!err) { emitter.emit('del', key); cb(null) }
      if(err) return cb(err)
    })
  }

  emitter.batch = function (ops, opts, cb) {
    if('function' === typeof opts)
      cb = opts, opts = {}
    if(!cb) cb = errback

    ops = ops.map(function (op) {
      return {
        key:           op.key,
        value:         op.value,
        prefix:        op.prefix || prefix,
        keyEncoding:   op.keyEncoding,    // *
        valueEncoding: op.valueEncoding,  // * (TODO: encodings on sublevel)
        type:          op.type
      }
    })

    nut.apply(ops, mergeOpts(opts), function (err) {
      if(!err) { emitter.emit('batch', ops); cb(null) }
      if(err) return cb(err)
    })
  }

  emitter.get = function (key, opts, cb) {
    if('function' === typeof opts)
      cb = opts, opts = {}
    nut.get(key, prefix, mergeOpts(opts), function (err, value) {
      if(err) cb(new errors.NotFoundError('Key not found in database', err))
      else cb(null, value)
    })
  }

  emitter.clone = function(opts) {
    return sublevel(nut, prefix, createStream, mergeOpts(opts))
  }

  emitter.sublevel = function (name, opts) {
    return emitter.sublevels[name] =
      emitter.sublevels[name] || sublevel(nut, prefix.concat(name), createStream, mergeOpts(opts))
  }

  emitter.pre = function (key, hook) {
    if(isFunction(key)) return nut.pre([prefix], key)
    if(isString(key)) return nut.pre([prefix, key], hook)
    if(isObject(key)) return nut.pre(addpre(prefix, key), hook)

    throw new Error('not implemented yet')
  }

  emitter.post = function (key, hook) {
    if(isFunction(key)) return nut.post([prefix], key)
    if(isString(key))   return nut.post([prefix, key], hook)
    if(isObject(key))   return nut.post(addpre(prefix, key), hook)

    //TODO: handle ranges, needed for level-live-stream, etc.
    throw new Error('not implemented yet')
  }

  emitter.readStream =
  emitter.createReadStream = function (opts) {
    opts = mergeOpts(opts)
    opts.prefix = prefix
    var stream
    var it = nut.iterator(opts, function (err, it) {
      stream.setIterator(it)
    })

    stream = createStream(opts, nut.createDecoder(opts))
    if(it) stream.setIterator(it)

    return stream
  }

  emitter.valueStream =
  emitter.createValueStream = function (opts) {
    opts = opts || {}
    opts.values = true
    opts.keys = false
    return emitter.createReadStream(opts)
  }

  emitter.keyStream =
  emitter.createKeyStream = function (opts) {
    opts = opts || {}
    opts.values = false
    opts.keys = true
    return emitter.createReadStream(opts)
  }

  emitter.close = function (cb) {
    //TODO: deregister all hooks
    cb = cb || function () {}
    if (!prefix.length) nut.close(cb)
    else process.nextTick(cb)
  }

  emitter.isOpen = nut.isOpen
  emitter.isClosed = nut.isClosed

  return emitter
}

}).call(this,_dereq_(57))
},{"103":103,"104":104,"54":54,"57":57,"83":83}],106:[function(_dereq_,module,exports){
/* Copyright (c) 2012-2015 LevelUP contributors
 * See list at <https://github.com/level/levelup#contributing>
 * MIT License
 * <https://github.com/level/levelup/blob/master/LICENSE.md>
 */

var util          = _dereq_(108)
  , WriteError    = _dereq_(115).WriteError

  , getOptions    = util.getOptions
  , dispatchError = util.dispatchError

function Batch (levelup, codec) {
  this._levelup = levelup
  this._codec = codec
  this.batch = levelup.db.batch()
  this.ops = []
}

Batch.prototype.put = function (key_, value_, options) {
  options = getOptions(options)

  var key   = this._codec.encodeKey(key_, options)
    , value = this._codec.encodeValue(value_, options)

  try {
    this.batch.put(key, value)
  } catch (e) {
    throw new WriteError(e)
  }
  this.ops.push({ type : 'put', key : key, value : value })

  return this
}

Batch.prototype.del = function (key_, options) {
  options = getOptions(options)

  var key = this._codec.encodeKey(key_, options)

  try {
    this.batch.del(key)
  } catch (err) {
    throw new WriteError(err)
  }
  this.ops.push({ type : 'del', key : key })

  return this
}

Batch.prototype.clear = function () {
  try {
    this.batch.clear()
  } catch (err) {
    throw new WriteError(err)
  }

  this.ops = []
  return this
}

Batch.prototype.write = function (callback) {
  var levelup = this._levelup
    , ops     = this.ops

  try {
    this.batch.write(function (err) {
      if (err)
        return dispatchError(levelup, new WriteError(err), callback)
      levelup.emit('batch', ops)
      if (callback)
        callback()
    })
  } catch (err) {
    throw new WriteError(err)
  }
}

module.exports = Batch

},{"108":108,"115":115}],107:[function(_dereq_,module,exports){
(function (process){
/* Copyright (c) 2012-2015 LevelUP contributors
 * See list at <https://github.com/level/levelup#contributing>
 * MIT License
 * <https://github.com/level/levelup/blob/master/LICENSE.md>
 */

var EventEmitter        = _dereq_(54).EventEmitter
  , inherits            = _dereq_(74).inherits
  , deprecate           = _dereq_(74).deprecate
  , extend              = _dereq_(130)
  , prr                 = _dereq_(129)
  , DeferredLevelDOWN   = _dereq_(109)
  , IteratorStream      = _dereq_(119)

  , errors              = _dereq_(115)
  , WriteError          = errors.WriteError
  , ReadError           = errors.ReadError
  , NotFoundError       = errors.NotFoundError
  , OpenError           = errors.OpenError
  , EncodingError       = errors.EncodingError
  , InitializationError = errors.InitializationError

  , util                = _dereq_(108)
  , Batch               = _dereq_(106)
  , Codec               = _dereq_(113)

  , getOptions          = util.getOptions
  , defaultOptions      = util.defaultOptions
  , getLevelDOWN        = util.getLevelDOWN
  , dispatchError       = util.dispatchError
  , isDefined           = util.isDefined

function getCallback (options, callback) {
  return typeof options == 'function' ? options : callback
}

// Possible LevelUP#_status values:
//  - 'new'     - newly created, not opened or closed
//  - 'opening' - waiting for the database to be opened, post open()
//  - 'open'    - successfully opened the database, available for use
//  - 'closing' - waiting for the database to be closed, post close()
//  - 'closed'  - database has been successfully closed, should not be
//                 used except for another open() operation

function LevelUP (location, options, callback) {
  if (!(this instanceof LevelUP))
    return new LevelUP(location, options, callback)

  var error

  EventEmitter.call(this)
  this.setMaxListeners(Infinity)

  if (typeof location == 'function') {
    options = typeof options == 'object' ? options : {}
    options.db = location
    location = null
  } else if (typeof location == 'object' && typeof location.db == 'function') {
    options = location
    location = null
  }


  if (typeof options == 'function') {
    callback = options
    options  = {}
  }

  if ((!options || typeof options.db != 'function') && typeof location != 'string') {
    error = new InitializationError(
        'Must provide a location for the database')
    if (callback) {
      return process.nextTick(function () {
        callback(error)
      })
    }
    throw error
  }

  options      = getOptions(options)
  this.options = extend(defaultOptions, options)
  this._codec = new Codec(this.options)
  this._status = 'new'
  // set this.location as enumerable but not configurable or writable
  prr(this, 'location', location, 'e')

  this.open(callback)
}

inherits(LevelUP, EventEmitter)

LevelUP.prototype.open = function (callback) {
  var self = this
    , dbFactory
    , db

  if (this.isOpen()) {
    if (callback)
      process.nextTick(function () { callback(null, self) })
    return this
  }

  if (this._isOpening()) {
    return callback && this.once(
        'open'
      , function () { callback(null, self) }
    )
  }

  this.emit('opening')

  this._status = 'opening'
  this.db      = new DeferredLevelDOWN(this.location)
  dbFactory    = this.options.db || getLevelDOWN()
  db           = dbFactory(this.location)

  db.open(this.options, function (err) {
    if (err) {
      return dispatchError(self, new OpenError(err), callback)
    } else {
      self.db.setDb(db)
      self.db = db
      self._status = 'open'
      if (callback)
        callback(null, self)
      self.emit('open')
      self.emit('ready')
    }
  })
}

LevelUP.prototype.close = function (callback) {
  var self = this

  if (this.isOpen()) {
    this._status = 'closing'
    this.db.close(function () {
      self._status = 'closed'
      self.emit('closed')
      if (callback)
        callback.apply(null, arguments)
    })
    this.emit('closing')
    this.db = new DeferredLevelDOWN(this.location)
  } else if (this._status == 'closed' && callback) {
    return process.nextTick(callback)
  } else if (this._status == 'closing' && callback) {
    this.once('closed', callback)
  } else if (this._isOpening()) {
    this.once('open', function () {
      self.close(callback)
    })
  }
}

LevelUP.prototype.isOpen = function () {
  return this._status == 'open'
}

LevelUP.prototype._isOpening = function () {
  return this._status == 'opening'
}

LevelUP.prototype.isClosed = function () {
  return (/^clos/).test(this._status)
}

function maybeError(db, options, callback) {
  if (!db._isOpening() && !db.isOpen()) {
    dispatchError(
        db
      , new ReadError('Database is not open')
      , callback
    )
    return true
  }
}

function writeError (db, message, callback) {
  dispatchError(
      db
     , new WriteError(message)
     , callback
  )
}

function readError (db, message, callback) {
  dispatchError(
      db
     , new ReadError(message)
     , callback
  )
}


LevelUP.prototype.get = function (key_, options, callback) {
  var self = this
    , key

  callback = getCallback(options, callback)

  if (maybeError(this, options, callback))
    return

  if (key_ === null || key_ === undefined || 'function' !== typeof callback)
    return readError(this
      , 'get() requires key and callback arguments', callback)

  options = util.getOptions(options)
  key = this._codec.encodeKey(key_, options)

  options.asBuffer = this._codec.valueAsBuffer(options)

  this.db.get(key, options, function (err, value) {
    if (err) {
      if ((/notfound/i).test(err) || err.notFound) {
        err = new NotFoundError(
            'Key not found in database [' + key_ + ']', err)
      } else {
        err = new ReadError(err)
      }
      return dispatchError(self, err, callback)
    }
    if (callback) {
      try {
        value = self._codec.decodeValue(value, options)
      } catch (e) {
        return callback(new EncodingError(e))
      }
      callback(null, value)
    }
  })
}

LevelUP.prototype.put = function (key_, value_, options, callback) {
  var self = this
    , key
    , value

  callback = getCallback(options, callback)

  if (key_ === null || key_ === undefined)
    return writeError(this, 'put() requires a key argument', callback)

  if (maybeError(this, options, callback))
    return

  options = getOptions(options)
  key     = this._codec.encodeKey(key_, options)
  value   = this._codec.encodeValue(value_, options)

  this.db.put(key, value, options, function (err) {
    if (err) {
      return dispatchError(self, new WriteError(err), callback)
    } else {
      self.emit('put', key_, value_)
      if (callback)
        callback()
    }
  })
}

LevelUP.prototype.del = function (key_, options, callback) {
  var self = this
    , key

  callback = getCallback(options, callback)

  if (key_ === null || key_ === undefined)
    return writeError(this, 'del() requires a key argument', callback)

  if (maybeError(this, options, callback))
    return

  options = getOptions(options)
  key     = this._codec.encodeKey(key_, options)

  this.db.del(key, options, function (err) {
    if (err) {
      return dispatchError(self, new WriteError(err), callback)
    } else {
      self.emit('del', key_)
      if (callback)
        callback()
    }
  })
}

LevelUP.prototype.batch = function (arr_, options, callback) {
  var self = this
    , keyEnc
    , valueEnc
    , arr

  if (!arguments.length)
    return new Batch(this, this._codec)

  callback = getCallback(options, callback)

  if (!Array.isArray(arr_))
    return writeError(this, 'batch() requires an array argument', callback)

  if (maybeError(this, options, callback))
    return

  options  = getOptions(options)
  arr      = self._codec.encodeBatch(arr_, options)
  arr      = arr.map(function (op) {
    if (!op.type && op.key !== undefined && op.value !== undefined)
      op.type = 'put'
    return op
  })

  this.db.batch(arr, options, function (err) {
    if (err) {
      return dispatchError(self, new WriteError(err), callback)
    } else {
      self.emit('batch', arr_)
      if (callback)
        callback()
    }
  })
}

LevelUP.prototype.approximateSize = deprecate(function (start_, end_, options, callback) {
  var self = this
    , start
    , end

  callback = getCallback(options, callback)

  options = getOptions(options)

  if (start_ === null || start_ === undefined
        || end_ === null || end_ === undefined || 'function' !== typeof callback)
    return readError(this, 'approximateSize() requires start, end and callback arguments', callback)

  start = this._codec.encodeKey(start_, options)
  end   = this._codec.encodeKey(end_, options)

  this.db.approximateSize(start, end, function (err, size) {
    if (err) {
      return dispatchError(self, new OpenError(err), callback)
    } else if (callback) {
      callback(null, size)
    }
  })
}, 'db.approximateSize() is deprecated. Use db.db.approximateSize() instead')

LevelUP.prototype.readStream =
LevelUP.prototype.createReadStream = function (options) {
  options = extend( {keys: true, values: true}, this.options, options)

  options.keyEncoding   = options.keyEncoding
  options.valueEncoding = options.valueEncoding

  options = this._codec.encodeLtgt(options);
  options.keyAsBuffer   = this._codec.keyAsBuffer(options)
  options.valueAsBuffer = this._codec.valueAsBuffer(options)

  if ('number' !== typeof options.limit)
    options.limit = -1

  return new IteratorStream(this.db.iterator(options), extend(options, {
    decoder: this._codec.createStreamDecoder(options)
  }))
}

LevelUP.prototype.keyStream =
LevelUP.prototype.createKeyStream = function (options) {
  return this.createReadStream(extend(options, { keys: true, values: false }))
}

LevelUP.prototype.valueStream =
LevelUP.prototype.createValueStream = function (options) {
  return this.createReadStream(extend(options, { keys: false, values: true }))
}

LevelUP.prototype.toString = function () {
  return 'LevelUP'
}

function utilStatic (name) {
  return function (location, callback) {
    getLevelDOWN()[name](location, callback || function () {})
  }
}

module.exports         = LevelUP
module.exports.errors  = _dereq_(115)
module.exports.destroy = deprecate(
    utilStatic('destroy')
  , 'levelup.destroy() is deprecated. Use leveldown.destroy() instead'
)
module.exports.repair  = deprecate(
    utilStatic('repair')
  , 'levelup.repair() is deprecated. Use leveldown.repair() instead'
)


}).call(this,_dereq_(57))
},{"106":106,"108":108,"109":109,"113":113,"115":115,"119":119,"129":129,"130":130,"54":54,"57":57,"74":74}],108:[function(_dereq_,module,exports){
/* Copyright (c) 2012-2015 LevelUP contributors
 * See list at <https://github.com/level/levelup#contributing>
 * MIT License
 * <https://github.com/level/levelup/blob/master/LICENSE.md>
 */

var extend         = _dereq_(130)
  , LevelUPError   = _dereq_(115).LevelUPError
  , format         = _dereq_(74).format
  , defaultOptions = {
        createIfMissing : true
      , errorIfExists   : false
      , keyEncoding     : 'utf8'
      , valueEncoding   : 'utf8'
      , compression     : true
    }

  , leveldown

function getOptions (options) {
  if (typeof options == 'string')
    options = { valueEncoding: options }
  if (typeof options != 'object')
    options = {}
  return options
}

function getLevelDOWN () {
  if (leveldown)
    return leveldown

  var requiredVersion  = _dereq_(131).devDependencies.leveldown
    , leveldownVersion

  try {
    leveldownVersion = _dereq_(49).version
  } catch (e) {
    throw requireError(e)
  }

  if (!_dereq_(49).satisfies(leveldownVersion, requiredVersion)) {
    throw new LevelUPError(
        'Installed version of LevelDOWN ('
      + leveldownVersion
      + ') does not match required version ('
      + requiredVersion
      + ')'
    )
  }

  try {
    return leveldown = _dereq_(49)
  } catch (e) {
    throw requireError(e)
  }
}

function requireError (e) {
  var template = 'Failed to require LevelDOWN (%s). Try `npm install leveldown` if it\'s missing'
  return new LevelUPError(format(template, e.message))
}

function dispatchError (db, error, callback) {
  typeof callback == 'function' ? callback(error) : db.emit('error', error)
}

function isDefined (v) {
  return typeof v !== 'undefined'
}

module.exports = {
    defaultOptions  : defaultOptions
  , getOptions      : getOptions
  , getLevelDOWN    : getLevelDOWN
  , dispatchError   : dispatchError
  , isDefined       : isDefined
}

},{"115":115,"130":130,"131":131,"49":49,"74":74}],109:[function(_dereq_,module,exports){
(function (Buffer,process){
var util              = _dereq_(74)
  , AbstractLevelDOWN = _dereq_(112).AbstractLevelDOWN
  , AbstractIterator  = _dereq_(112).AbstractIterator

function DeferredLevelDOWN (location) {
  AbstractLevelDOWN.call(this, typeof location == 'string' ? location : '') // optional location, who cares?
  this._db         = undefined
  this._operations = []
  this._iterators  = []
}

util.inherits(DeferredLevelDOWN, AbstractLevelDOWN)

// called by LevelUP when we have a real DB to take its place
DeferredLevelDOWN.prototype.setDb = function (db) {
  this._db = db
  this._operations.forEach(function (op) {
    db[op.method].apply(db, op.args)
  })
  this._iterators.forEach(function (it) {
    it.setDb(db)
  })
}

DeferredLevelDOWN.prototype._open = function (options, callback) {
  return process.nextTick(callback)
}

// queue a new deferred operation
DeferredLevelDOWN.prototype._operation = function (method, args) {
  if (this._db)
    return this._db[method].apply(this._db, args)
  this._operations.push({ method: method, args: args })
}

// deferrables
'put get del batch approximateSize'.split(' ').forEach(function (m) {
  DeferredLevelDOWN.prototype['_' + m] = function () {
    this._operation(m, arguments)
  }
})

DeferredLevelDOWN.prototype._isBuffer = function (obj) {
  return Buffer.isBuffer(obj)
}

DeferredLevelDOWN.prototype._iterator = function (options) {
  var it = new Iterator(options)
  this._iterators.push(it)
  return it
}

function Iterator (options) {
  AbstractIterator.call(this, options)

  this._options = options
  this._iterator = null
  this._operations = []
}

util.inherits(Iterator, AbstractIterator)

Iterator.prototype.setDb = function (db) {
  var it = this._iterator = db.iterator(this._options)
  this._operations.forEach(function (op) {
    it[op.method].apply(it, op.args)
  })
}

Iterator.prototype._operation = function (method, args) {
  if (this._iterator)
    return this._iterator[method].apply(this._iterator, args)
  this._operations.push({ method: method, args: args })
}

'next end'.split(' ').forEach(function (m) {
  Iterator.prototype['_' + m] = function () {
    this._operation(m, arguments)
  }
})

module.exports = DeferredLevelDOWN


}).call(this,{"isBuffer":_dereq_(55)},_dereq_(57))
},{"112":112,"55":55,"57":57,"74":74}],110:[function(_dereq_,module,exports){
(function (process){
/* Copyright (c) 2013 Rod Vagg, MIT License */

function AbstractChainedBatch (db) {
  this._db         = db
  this._operations = []
  this._written    = false
}

AbstractChainedBatch.prototype._checkWritten = function () {
  if (this._written)
    throw new Error('write() already called on this batch')
}

AbstractChainedBatch.prototype.put = function (key, value) {
  this._checkWritten()

  var err = this._db._checkKey(key, 'key', this._db._isBuffer)
  if (err)
    throw err

  if (!this._db._isBuffer(key)) key = String(key)
  if (!this._db._isBuffer(value)) value = String(value)

  if (typeof this._put == 'function' )
    this._put(key, value)
  else
    this._operations.push({ type: 'put', key: key, value: value })

  return this
}

AbstractChainedBatch.prototype.del = function (key) {
  this._checkWritten()

  var err = this._db._checkKey(key, 'key', this._db._isBuffer)
  if (err) throw err

  if (!this._db._isBuffer(key)) key = String(key)

  if (typeof this._del == 'function' )
    this._del(key)
  else
    this._operations.push({ type: 'del', key: key })

  return this
}

AbstractChainedBatch.prototype.clear = function () {
  this._checkWritten()

  this._operations = []

  if (typeof this._clear == 'function' )
    this._clear()

  return this
}

AbstractChainedBatch.prototype.write = function (options, callback) {
  this._checkWritten()

  if (typeof options == 'function')
    callback = options
  if (typeof callback != 'function')
    throw new Error('write() requires a callback argument')
  if (typeof options != 'object')
    options = {}

  this._written = true

  if (typeof this._write == 'function' )
    return this._write(callback)

  if (typeof this._db._batch == 'function')
    return this._db._batch(this._operations, options, callback)

  process.nextTick(callback)
}

module.exports = AbstractChainedBatch
}).call(this,_dereq_(57))
},{"57":57}],111:[function(_dereq_,module,exports){
(function (process){
/* Copyright (c) 2013 Rod Vagg, MIT License */

function AbstractIterator (db) {
  this.db = db
  this._ended = false
  this._nexting = false
}

AbstractIterator.prototype.next = function (callback) {
  var self = this

  if (typeof callback != 'function')
    throw new Error('next() requires a callback argument')

  if (self._ended)
    return callback(new Error('cannot call next() after end()'))
  if (self._nexting)
    return callback(new Error('cannot call next() before previous next() has completed'))

  self._nexting = true
  if (typeof self._next == 'function') {
    return self._next(function () {
      self._nexting = false
      callback.apply(null, arguments)
    })
  }

  process.nextTick(function () {
    self._nexting = false
    callback()
  })
}

AbstractIterator.prototype.end = function (callback) {
  if (typeof callback != 'function')
    throw new Error('end() requires a callback argument')

  if (this._ended)
    return callback(new Error('end() already called on iterator'))

  this._ended = true

  if (typeof this._end == 'function')
    return this._end(callback)

  process.nextTick(callback)
}

module.exports = AbstractIterator

}).call(this,_dereq_(57))
},{"57":57}],112:[function(_dereq_,module,exports){
(function (Buffer,process){
/* Copyright (c) 2013 Rod Vagg, MIT License */

var xtend                = _dereq_(130)
  , AbstractIterator     = _dereq_(111)
  , AbstractChainedBatch = _dereq_(110)

function AbstractLevelDOWN (location) {
  if (!arguments.length || location === undefined)
    throw new Error('constructor requires at least a location argument')

  if (typeof location != 'string')
    throw new Error('constructor requires a location string argument')

  this.location = location
}

AbstractLevelDOWN.prototype.open = function (options, callback) {
  if (typeof options == 'function')
    callback = options

  if (typeof callback != 'function')
    throw new Error('open() requires a callback argument')

  if (typeof options != 'object')
    options = {}

  options.createIfMissing = options.createIfMissing != false
  options.errorIfExists = !!options.errorIfExists

  if (typeof this._open == 'function')
    return this._open(options, callback)

  process.nextTick(callback)
}

AbstractLevelDOWN.prototype.close = function (callback) {
  if (typeof callback != 'function')
    throw new Error('close() requires a callback argument')

  if (typeof this._close == 'function')
    return this._close(callback)

  process.nextTick(callback)
}

AbstractLevelDOWN.prototype.get = function (key, options, callback) {
  var err

  if (typeof options == 'function')
    callback = options

  if (typeof callback != 'function')
    throw new Error('get() requires a callback argument')

  if (err = this._checkKey(key, 'key', this._isBuffer))
    return callback(err)

  if (!this._isBuffer(key))
    key = String(key)

  if (typeof options != 'object')
    options = {}

  options.asBuffer = options.asBuffer != false

  if (typeof this._get == 'function')
    return this._get(key, options, callback)

  process.nextTick(function () { callback(new Error('NotFound')) })
}

AbstractLevelDOWN.prototype.put = function (key, value, options, callback) {
  var err

  if (typeof options == 'function')
    callback = options

  if (typeof callback != 'function')
    throw new Error('put() requires a callback argument')

  if (err = this._checkKey(key, 'key', this._isBuffer))
    return callback(err)

  if (!this._isBuffer(key))
    key = String(key)

  // coerce value to string in node, don't touch it in browser
  // (indexeddb can store any JS type)
  if (value != null && !this._isBuffer(value) && !process.browser)
    value = String(value)

  if (typeof options != 'object')
    options = {}

  if (typeof this._put == 'function')
    return this._put(key, value, options, callback)

  process.nextTick(callback)
}

AbstractLevelDOWN.prototype.del = function (key, options, callback) {
  var err

  if (typeof options == 'function')
    callback = options

  if (typeof callback != 'function')
    throw new Error('del() requires a callback argument')

  if (err = this._checkKey(key, 'key', this._isBuffer))
    return callback(err)

  if (!this._isBuffer(key))
    key = String(key)

  if (typeof options != 'object')
    options = {}

  if (typeof this._del == 'function')
    return this._del(key, options, callback)

  process.nextTick(callback)
}

AbstractLevelDOWN.prototype.batch = function (array, options, callback) {
  if (!arguments.length)
    return this._chainedBatch()

  if (typeof options == 'function')
    callback = options

  if (typeof array == 'function')
    callback = array

  if (typeof callback != 'function')
    throw new Error('batch(array) requires a callback argument')

  if (!Array.isArray(array))
    return callback(new Error('batch(array) requires an array argument'))

  if (!options || typeof options != 'object')
    options = {}

  var i = 0
    , l = array.length
    , e
    , err

  for (; i < l; i++) {
    e = array[i]
    if (typeof e != 'object')
      continue

    if (err = this._checkKey(e.type, 'type', this._isBuffer))
      return callback(err)

    if (err = this._checkKey(e.key, 'key', this._isBuffer))
      return callback(err)
  }

  if (typeof this._batch == 'function')
    return this._batch(array, options, callback)

  process.nextTick(callback)
}

//TODO: remove from here, not a necessary primitive
AbstractLevelDOWN.prototype.approximateSize = function (start, end, callback) {
  if (   start == null
      || end == null
      || typeof start == 'function'
      || typeof end == 'function') {
    throw new Error('approximateSize() requires valid `start`, `end` and `callback` arguments')
  }

  if (typeof callback != 'function')
    throw new Error('approximateSize() requires a callback argument')

  if (!this._isBuffer(start))
    start = String(start)

  if (!this._isBuffer(end))
    end = String(end)

  if (typeof this._approximateSize == 'function')
    return this._approximateSize(start, end, callback)

  process.nextTick(function () {
    callback(null, 0)
  })
}

AbstractLevelDOWN.prototype._setupIteratorOptions = function (options) {
  var self = this

  options = xtend(options)

  ;[ 'start', 'end', 'gt', 'gte', 'lt', 'lte' ].forEach(function (o) {
    if (options[o] && self._isBuffer(options[o]) && options[o].length === 0)
      delete options[o]
  })

  options.reverse = !!options.reverse
  options.keys = options.keys != false
  options.values = options.values != false
  options.limit = 'limit' in options ? options.limit : -1
  options.keyAsBuffer = options.keyAsBuffer != false
  options.valueAsBuffer = options.valueAsBuffer != false

  return options
}

AbstractLevelDOWN.prototype.iterator = function (options) {
  if (typeof options != 'object')
    options = {}

  options = this._setupIteratorOptions(options)

  if (typeof this._iterator == 'function')
    return this._iterator(options)

  return new AbstractIterator(this)
}

AbstractLevelDOWN.prototype._chainedBatch = function () {
  return new AbstractChainedBatch(this)
}

AbstractLevelDOWN.prototype._isBuffer = function (obj) {
  return Buffer.isBuffer(obj)
}

AbstractLevelDOWN.prototype._checkKey = function (obj, type) {

  if (obj === null || obj === undefined)
    return new Error(type + ' cannot be `null` or `undefined`')

  if (this._isBuffer(obj)) {
    if (obj.length === 0)
      return new Error(type + ' cannot be an empty Buffer')
  } else if (String(obj) === '')
    return new Error(type + ' cannot be an empty String')
}

module.exports.AbstractLevelDOWN    = AbstractLevelDOWN
module.exports.AbstractIterator     = AbstractIterator
module.exports.AbstractChainedBatch = AbstractChainedBatch

}).call(this,{"isBuffer":_dereq_(55)},_dereq_(57))
},{"110":110,"111":111,"130":130,"55":55,"57":57}],113:[function(_dereq_,module,exports){
var encodings = _dereq_(114);

module.exports = Codec;

function Codec(opts){
  this.opts = opts || {};
  this.encodings = encodings;
}

Codec.prototype._encoding = function(encoding){
  if (typeof encoding == 'string') encoding = encodings[encoding];
  if (!encoding) encoding = encodings.id;
  return encoding;
};

Codec.prototype._keyEncoding = function(opts, batchOpts){
  return this._encoding(batchOpts && batchOpts.keyEncoding
    || opts && opts.keyEncoding
    || this.opts.keyEncoding);
};

Codec.prototype._valueEncoding = function(opts, batchOpts){
  return this._encoding(batchOpts && batchOpts.valueEncoding
    || opts && opts.valueEncoding
    || this.opts.valueEncoding);
};

Codec.prototype.encodeKey = function(key, opts, batchOpts){
  return this._keyEncoding(opts, batchOpts).encode(key);
};

Codec.prototype.encodeValue = function(value, opts, batchOpts){
  return this._valueEncoding(opts, batchOpts).encode(value);
};

Codec.prototype.decodeKey = function(key, opts){
  return this._keyEncoding(opts).decode(key);
};

Codec.prototype.decodeValue = function(value, opts){
  return this._valueEncoding(opts).decode(value);
};

Codec.prototype.encodeBatch = function(ops, opts){
  var self = this;

  return ops.map(function(_op){
    var op = {
      type: _op.type,
      key: self.encodeKey(_op.key, opts, _op)
    };
    if (self.keyAsBuffer(opts, _op)) op.keyEncoding = 'binary';
    if (_op.prefix) op.prefix = _op.prefix;
    if ('value' in _op) {
      op.value = self.encodeValue(_op.value, opts, _op);
      if (self.valueAsBuffer(opts, _op)) op.valueEncoding = 'binary';
    }
    return op;
  });
};

var ltgtKeys = ['lt', 'gt', 'lte', 'gte', 'start', 'end'];

Codec.prototype.encodeLtgt = function(ltgt){
  var self = this;
  var ret = {};
  Object.keys(ltgt).forEach(function(key){
    ret[key] = ltgtKeys.indexOf(key) > -1
      ? self.encodeKey(ltgt[key], ltgt)
      : ltgt[key]
  });
  return ret;
};

Codec.prototype.createStreamDecoder = function(opts){
  var self = this;

  if (opts.keys && opts.values) {
    return function(key, value){
      return {
        key: self.decodeKey(key, opts),
        value: self.decodeValue(value, opts)
      };
    };
  } else if (opts.keys) {
    return function(key) {
      return self.decodeKey(key, opts);
    };
  } else if (opts.values) {
    return function(_, value){
      return self.decodeValue(value, opts);
    }
  } else {
    return function(){};
  }
};

Codec.prototype.keyAsBuffer = function(opts){
  return this._keyEncoding(opts).buffer;
};

Codec.prototype.valueAsBuffer = function(opts){
  return this._valueEncoding(opts).buffer;
};


},{"114":114}],114:[function(_dereq_,module,exports){
(function (Buffer){

exports.utf8 = exports['utf-8'] = {
  encode: function(data){
    return isBinary(data)
      ? data
      : String(data);
  },
  decode: identity,
  buffer: false,
  type: 'utf8'
};

exports.json = {
  encode: JSON.stringify,
  decode: JSON.parse,
  buffer: false,
  type: 'json'
};

exports.binary = {
  encode: function(data){
    return isBinary(data)
      ? data
      : new Buffer(data);
  },
  decode: identity,
  buffer: true,
  type: 'binary'
};

exports.id = {
  encode: function(data){
    return data;
  },
  decode: function(data){
    return data;
  },
  buffer: false,
  type: 'id'
};

var bufferEncodings = [
  'hex',
  'ascii',
  'base64',
  'ucs2',
  'ucs-2',
  'utf16le',
  'utf-16le'
];

bufferEncodings.forEach(function(type){
  exports[type] = {
    encode: function(data){
      return isBinary(data)
        ? data
        : new Buffer(data, type);
    },
    decode: function(buffer){
      return buffer.toString(type);
    },
    buffer: true,
    type: type
  };
});

function identity(value){
  return value;
}

function isBinary(data){
  return data === undefined
    || data === null
    || Buffer.isBuffer(data);
}


}).call(this,_dereq_(50).Buffer)
},{"50":50}],115:[function(_dereq_,module,exports){
/* Copyright (c) 2012-2015 LevelUP contributors
 * See list at <https://github.com/rvagg/node-levelup#contributing>
 * MIT License
 * <https://github.com/rvagg/node-levelup/blob/master/LICENSE.md>
 */

var createError   = _dereq_(117).create
  , LevelUPError  = createError('LevelUPError')
  , NotFoundError = createError('NotFoundError', LevelUPError)

NotFoundError.prototype.notFound = true
NotFoundError.prototype.status   = 404

module.exports = {
    LevelUPError        : LevelUPError
  , InitializationError : createError('InitializationError', LevelUPError)
  , OpenError           : createError('OpenError', LevelUPError)
  , ReadError           : createError('ReadError', LevelUPError)
  , WriteError          : createError('WriteError', LevelUPError)
  , NotFoundError       : NotFoundError
  , EncodingError       : createError('EncodingError', LevelUPError)
}

},{"117":117}],116:[function(_dereq_,module,exports){
arguments[4][86][0].apply(exports,arguments)
},{"118":118,"86":86}],117:[function(_dereq_,module,exports){
arguments[4][87][0].apply(exports,arguments)
},{"116":116,"87":87}],118:[function(_dereq_,module,exports){
arguments[4][88][0].apply(exports,arguments)
},{"88":88}],119:[function(_dereq_,module,exports){
var inherits = _dereq_(76);
var Readable = _dereq_(128).Readable;
var extend = _dereq_(130);
var EncodingError = _dereq_(115).EncodingError;

module.exports = ReadStream;
inherits(ReadStream, Readable);

function ReadStream(iterator, options){
  if (!(this instanceof ReadStream)) return new ReadStream(iterator, options);
  Readable.call(this, extend(options, {
    objectMode: true
  }));
  this._iterator = iterator;
  this._destroyed = false;
  this._decoder = null;
  if (options && options.decoder) this._decoder = options.decoder;
  this.on('end', this._cleanup.bind(this));
}

ReadStream.prototype._read = function(){
  var self = this;
  if (this._destroyed) return;

  this._iterator.next(function(err, key, value){
    if (self._destroyed) return;
    if (err) return self.emit('error', err);
    if (key === undefined && value === undefined) {
      self.push(null);
    } else {
      if (!self._decoder) return self.push({ key: key, value: value });

      try {
        var value = self._decoder(key, value);
      } catch (err) {
        self.emit('error', new EncodingError(err));
        self.push(null);
        return;
      }
      self.push(value);
    }
  });
};

ReadStream.prototype.destroy =
ReadStream.prototype._cleanup = function(){
  var self = this;
  if (this._destroyed) return;
  this._destroyed = true;

  this._iterator.end(function(err){
    if (err) return self.emit('error', err);
    self.emit('close');
  });
};


},{"115":115,"128":128,"130":130,"76":76}],120:[function(_dereq_,module,exports){
arguments[4][89][0].apply(exports,arguments)
},{"122":122,"124":124,"125":125,"57":57,"76":76,"89":89}],121:[function(_dereq_,module,exports){
arguments[4][90][0].apply(exports,arguments)
},{"123":123,"125":125,"76":76,"90":90}],122:[function(_dereq_,module,exports){
(function (process){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Readable;

/*<replacement>*/
var isArray = _dereq_(126);
/*</replacement>*/


/*<replacement>*/
var Buffer = _dereq_(50).Buffer;
/*</replacement>*/

Readable.ReadableState = ReadableState;

var EE = _dereq_(54).EventEmitter;

/*<replacement>*/
if (!EE.listenerCount) EE.listenerCount = function(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

var Stream = _dereq_(71);

/*<replacement>*/
var util = _dereq_(125);
util.inherits = _dereq_(76);
/*</replacement>*/

var StringDecoder;


/*<replacement>*/
var debug = _dereq_(49);
if (debug && debug.debuglog) {
  debug = debug.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/


util.inherits(Readable, Stream);

function ReadableState(options, stream) {
  var Duplex = _dereq_(120);

  options = options || {};

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~~this.highWaterMark;

  this.buffer = [];
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;


  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex)
    this.objectMode = this.objectMode || !!options.readableObjectMode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // when piping, we only care about 'readable' events that happen
  // after read()ing all the bytes and not getting any pushback.
  this.ranOut = false;

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder)
      StringDecoder = _dereq_(127).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  var Duplex = _dereq_(120);

  if (!(this instanceof Readable))
    return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  Stream.call(this);
}

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
  var state = this._readableState;

  if (util.isString(chunk) && !state.objectMode) {
    encoding = encoding || state.defaultEncoding;
    if (encoding !== state.encoding) {
      chunk = new Buffer(chunk, encoding);
      encoding = '';
    }
  }

  return readableAddChunk(this, state, chunk, encoding, false);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
  var state = this._readableState;
  return readableAddChunk(this, state, chunk, '', true);
};

function readableAddChunk(stream, state, chunk, encoding, addToFront) {
  var er = chunkInvalid(state, chunk);
  if (er) {
    stream.emit('error', er);
  } else if (util.isNullOrUndefined(chunk)) {
    state.reading = false;
    if (!state.ended)
      onEofChunk(stream, state);
  } else if (state.objectMode || chunk && chunk.length > 0) {
    if (state.ended && !addToFront) {
      var e = new Error('stream.push() after EOF');
      stream.emit('error', e);
    } else if (state.endEmitted && addToFront) {
      var e = new Error('stream.unshift() after end event');
      stream.emit('error', e);
    } else {
      if (state.decoder && !addToFront && !encoding)
        chunk = state.decoder.write(chunk);

      if (!addToFront)
        state.reading = false;

      // if we want the data now, just emit it.
      if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
      } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront)
          state.buffer.unshift(chunk);
        else
          state.buffer.push(chunk);

        if (state.needReadable)
          emitReadable(stream);
      }

      maybeReadMore(stream, state);
    }
  } else if (!addToFront) {
    state.reading = false;
  }

  return needMoreData(state);
}



// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended &&
         (state.needReadable ||
          state.length < state.highWaterMark ||
          state.length === 0);
}

// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
  if (!StringDecoder)
    StringDecoder = _dereq_(127).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 128MB
var MAX_HWM = 0x800000;
function roundUpToNextPowerOf2(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2
    n--;
    for (var p = 1; p < 32; p <<= 1) n |= n >> p;
    n++;
  }
  return n;
}

function howMuchToRead(n, state) {
  if (state.length === 0 && state.ended)
    return 0;

  if (state.objectMode)
    return n === 0 ? 0 : 1;

  if (isNaN(n) || util.isNull(n)) {
    // only flow one buffer at a time
    if (state.flowing && state.buffer.length)
      return state.buffer[0].length;
    else
      return state.length;
  }

  if (n <= 0)
    return 0;

  // If we're asking for more than the target buffer level,
  // then raise the water mark.  Bump up to the next highest
  // power of 2, to prevent increasing it excessively in tiny
  // amounts.
  if (n > state.highWaterMark)
    state.highWaterMark = roundUpToNextPowerOf2(n);

  // don't have that much.  return null, unless we've ended.
  if (n > state.length) {
    if (!state.ended) {
      state.needReadable = true;
      return 0;
    } else
      return state.length;
  }

  return n;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
  debug('read', n);
  var state = this._readableState;
  var nOrig = n;

  if (!util.isNumber(n) || n > 0)
    state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 &&
      state.needReadable &&
      (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended)
      endReadable(this);
    else
      emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0)
      endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  }

  if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0)
      state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
  }

  // If _read pushed data synchronously, then `reading` will be false,
  // and we need to re-evaluate how much data we can return to the user.
  if (doRead && !state.reading)
    n = howMuchToRead(nOrig, state);

  var ret;
  if (n > 0)
    ret = fromList(n, state);
  else
    ret = null;

  if (util.isNull(ret)) {
    state.needReadable = true;
    n = 0;
  }

  state.length -= n;

  // If we have nothing in the buffer, then we want to know
  // as soon as we *do* get something into the buffer.
  if (state.length === 0 && !state.ended)
    state.needReadable = true;

  // If we tried to read() past the EOF, then emit end on the next tick.
  if (nOrig !== n && state.ended && state.length === 0)
    endReadable(this);

  if (!util.isNull(ret))
    this.emit('data', ret);

  return ret;
};

function chunkInvalid(state, chunk) {
  var er = null;
  if (!util.isBuffer(chunk) &&
      !util.isString(chunk) &&
      !util.isNullOrUndefined(chunk) &&
      !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}


function onEofChunk(stream, state) {
  if (state.decoder && !state.ended) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync)
      process.nextTick(function() {
        emitReadable_(stream);
      });
    else
      emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}


// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(function() {
      maybeReadMore_(stream, state);
    });
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended &&
         state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
    else
      len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
  this.emit('error', new Error('not implemented'));
};

Readable.prototype.pipe = function(dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) &&
              dest !== process.stdout &&
              dest !== process.stderr;

  var endFn = doEnd ? onend : cleanup;
  if (state.endEmitted)
    process.nextTick(endFn);
  else
    src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable) {
    debug('onunpipe');
    if (readable === src) {
      cleanup();
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', cleanup);
    src.removeListener('data', ondata);

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain &&
        (!dest._writableState || dest._writableState.needDrain))
      ondrain();
  }

  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    if (false === ret) {
      debug('false write response, pause',
            src._readableState.awaitDrain);
      src._readableState.awaitDrain++;
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EE.listenerCount(dest, 'error') === 0)
      dest.emit('error', er);
  }
  // This is a brutally ugly hack to make sure that our error handler
  // is attached before any userland ones.  NEVER DO THIS.
  if (!dest._events || !dest._events.error)
    dest.on('error', onerror);
  else if (isArray(dest._events.error))
    dest._events.error.unshift(onerror);
  else
    dest._events.error = [onerror, dest._events.error];



  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain)
      state.awaitDrain--;
    if (state.awaitDrain === 0 && EE.listenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}


Readable.prototype.unpipe = function(dest) {
  var state = this._readableState;

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0)
    return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes)
      return this;

    if (!dest)
      dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest)
      dest.emit('unpipe', this);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++)
      dests[i].emit('unpipe', this);
    return this;
  }

  // try to find the right one.
  var i = indexOf(state.pipes, dest);
  if (i === -1)
    return this;

  state.pipes.splice(i, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1)
    state.pipes = state.pipes[0];

  dest.emit('unpipe', this);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  // If listening to data, and it has not explicitly been paused,
  // then call resume to start the flow of data on the next tick.
  if (ev === 'data' && false !== this._readableState.flowing) {
    this.resume();
  }

  if (ev === 'readable' && this.readable) {
    var state = this._readableState;
    if (!state.readableListening) {
      state.readableListening = true;
      state.emittedReadable = false;
      state.needReadable = true;
      if (!state.reading) {
        var self = this;
        process.nextTick(function() {
          debug('readable nexttick read 0');
          self.read(0);
        });
      } else if (state.length) {
        emitReadable(this, state);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    if (!state.reading) {
      debug('resume read 0');
      this.read(0);
    }
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(function() {
      resume_(stream, state);
    });
  }
}

function resume_(stream, state) {
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading)
    stream.read(0);
}

Readable.prototype.pause = function() {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  if (state.flowing) {
    do {
      var chunk = stream.read();
    } while (null !== chunk && state.flowing);
  }
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function() {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length)
        self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function(chunk) {
    debug('wrapped data');
    if (state.decoder)
      chunk = state.decoder.write(chunk);
    if (!chunk || !state.objectMode && !chunk.length)
      return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (util.isFunction(stream[i]) && util.isUndefined(this[i])) {
      this[i] = function(method) { return function() {
        return stream[method].apply(stream, arguments);
      }}(i);
    }
  }

  // proxy certain important events.
  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
  forEach(events, function(ev) {
    stream.on(ev, self.emit.bind(self, ev));
  });

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function(n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};



// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
function fromList(n, state) {
  var list = state.buffer;
  var length = state.length;
  var stringMode = !!state.decoder;
  var objectMode = !!state.objectMode;
  var ret;

  // nothing in the list, definitely empty.
  if (list.length === 0)
    return null;

  if (length === 0)
    ret = null;
  else if (objectMode)
    ret = list.shift();
  else if (!n || n >= length) {
    // read it all, truncate the array.
    if (stringMode)
      ret = list.join('');
    else
      ret = Buffer.concat(list, length);
    list.length = 0;
  } else {
    // read just some of it.
    if (n < list[0].length) {
      // just take a part of the first list item.
      // slice is the same for buffers and strings.
      var buf = list[0];
      ret = buf.slice(0, n);
      list[0] = buf.slice(n);
    } else if (n === list[0].length) {
      // first list is a perfect match
      ret = list.shift();
    } else {
      // complex case.
      // we have enough to cover it, but it spans past the first buffer.
      if (stringMode)
        ret = '';
      else
        ret = new Buffer(n);

      var c = 0;
      for (var i = 0, l = list.length; i < l && c < n; i++) {
        var buf = list[0];
        var cpy = Math.min(n - c, buf.length);

        if (stringMode)
          ret += buf.slice(0, cpy);
        else
          buf.copy(ret, c, 0, cpy);

        if (cpy < buf.length)
          list[0] = buf.slice(cpy);
        else
          list.shift();

        c += cpy;
      }
    }
  }

  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0)
    throw new Error('endReadable called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(function() {
      // Check that we didn't get one last unshift.
      if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
      }
    });
  }
}

function forEach (xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf (xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

}).call(this,_dereq_(57))
},{"120":120,"125":125,"126":126,"127":127,"49":49,"50":50,"54":54,"57":57,"71":71,"76":76}],123:[function(_dereq_,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.


// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

module.exports = Transform;

var Duplex = _dereq_(120);

/*<replacement>*/
var util = _dereq_(125);
util.inherits = _dereq_(76);
/*</replacement>*/

util.inherits(Transform, Duplex);


function TransformState(options, stream) {
  this.afterTransform = function(er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb)
    return stream.emit('error', new Error('no writecb in Transform class'));

  ts.writechunk = null;
  ts.writecb = null;

  if (!util.isNullOrUndefined(data))
    stream.push(data);

  if (cb)
    cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}


function Transform(options) {
  if (!(this instanceof Transform))
    return new Transform(options);

  Duplex.call(this, options);

  this._transformState = new TransformState(options, this);

  // when the writable side finishes, then flush out anything remaining.
  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  this.once('prefinish', function() {
    if (util.isFunction(this._flush))
      this._flush(function(er) {
        done(stream, er);
      });
    else
      done(stream);
  });
}

Transform.prototype.push = function(chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
  throw new Error('not implemented');
};

Transform.prototype._write = function(chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform ||
        rs.needReadable ||
        rs.length < rs.highWaterMark)
      this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
  var ts = this._transformState;

  if (!util.isNull(ts.writechunk) && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};


function done(stream, er) {
  if (er)
    return stream.emit('error', er);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var ts = stream._transformState;

  if (ws.length)
    throw new Error('calling transform done when ws.length != 0');

  if (ts.transforming)
    throw new Error('calling transform done when still transforming');

  return stream.push(null);
}

},{"120":120,"125":125,"76":76}],124:[function(_dereq_,module,exports){
(function (process){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, cb), and it'll handle all
// the drain event emission and buffering.

module.exports = Writable;

/*<replacement>*/
var Buffer = _dereq_(50).Buffer;
/*</replacement>*/

Writable.WritableState = WritableState;


/*<replacement>*/
var util = _dereq_(125);
util.inherits = _dereq_(76);
/*</replacement>*/

var Stream = _dereq_(71);

util.inherits(Writable, Stream);

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
}

function WritableState(options, stream) {
  var Duplex = _dereq_(120);

  options = options || {};

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex)
    this.objectMode = this.objectMode || !!options.writableObjectMode;

  // cast to ints.
  this.highWaterMark = ~~this.highWaterMark;

  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function(er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.buffer = [];

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;
}

function Writable(options) {
  var Duplex = _dereq_(120);

  // Writable ctor is applied to Duplexes, though they're not
  // instanceof Writable, they're instanceof Readable.
  if (!(this instanceof Writable) && !(this instanceof Duplex))
    return new Writable(options);

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
  this.emit('error', new Error('Cannot pipe. Not readable.'));
};


function writeAfterEnd(stream, state, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  process.nextTick(function() {
    cb(er);
  });
}

// If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  if (!util.isBuffer(chunk) &&
      !util.isString(chunk) &&
      !util.isNullOrUndefined(chunk) &&
      !state.objectMode) {
    var er = new TypeError('Invalid non-string/buffer chunk');
    stream.emit('error', er);
    process.nextTick(function() {
      cb(er);
    });
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function(chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  if (util.isFunction(encoding)) {
    cb = encoding;
    encoding = null;
  }

  if (util.isBuffer(chunk))
    encoding = 'buffer';
  else if (!encoding)
    encoding = state.defaultEncoding;

  if (!util.isFunction(cb))
    cb = function() {};

  if (state.ended)
    writeAfterEnd(this, state, cb);
  else if (validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function() {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function() {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing &&
        !state.corked &&
        !state.finished &&
        !state.bufferProcessing &&
        state.buffer.length)
      clearBuffer(this, state);
  }
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode &&
      state.decodeStrings !== false &&
      util.isString(chunk)) {
    chunk = new Buffer(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, cb) {
  chunk = decodeChunk(state, chunk, encoding);
  if (util.isBuffer(chunk))
    encoding = 'buffer';
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret)
    state.needDrain = true;

  if (state.writing || state.corked)
    state.buffer.push(new WriteReq(chunk, encoding, cb));
  else
    doWrite(stream, state, false, len, chunk, encoding, cb);

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev)
    stream._writev(chunk, state.onwrite);
  else
    stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  if (sync)
    process.nextTick(function() {
      state.pendingcb--;
      cb(er);
    });
  else {
    state.pendingcb--;
    cb(er);
  }

  stream._writableState.errorEmitted = true;
  stream.emit('error', er);
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er)
    onwriteError(stream, state, sync, er, cb);
  else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(stream, state);

    if (!finished &&
        !state.corked &&
        !state.bufferProcessing &&
        state.buffer.length) {
      clearBuffer(stream, state);
    }

    if (sync) {
      process.nextTick(function() {
        afterWrite(stream, state, finished, cb);
      });
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished)
    onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}


// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;

  if (stream._writev && state.buffer.length > 1) {
    // Fast case, write everything using _writev()
    var cbs = [];
    for (var c = 0; c < state.buffer.length; c++)
      cbs.push(state.buffer[c].callback);

    // count the one we are adding, as well.
    // TODO(isaacs) clean this up
    state.pendingcb++;
    doWrite(stream, state, true, state.length, state.buffer, '', function(err) {
      for (var i = 0; i < cbs.length; i++) {
        state.pendingcb--;
        cbs[i](err);
      }
    });

    // Clear buffer
    state.buffer = [];
  } else {
    // Slow case, write chunks one-by-one
    for (var c = 0; c < state.buffer.length; c++) {
      var entry = state.buffer[c];
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);

      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        c++;
        break;
      }
    }

    if (c < state.buffer.length)
      state.buffer = state.buffer.slice(c);
    else
      state.buffer.length = 0;
  }

  state.bufferProcessing = false;
}

Writable.prototype._write = function(chunk, encoding, cb) {
  cb(new Error('not implemented'));

};

Writable.prototype._writev = null;

Writable.prototype.end = function(chunk, encoding, cb) {
  var state = this._writableState;

  if (util.isFunction(chunk)) {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (util.isFunction(encoding)) {
    cb = encoding;
    encoding = null;
  }

  if (!util.isNullOrUndefined(chunk))
    this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished)
    endWritable(this, state, cb);
};


function needFinish(stream, state) {
  return (state.ending &&
          state.length === 0 &&
          !state.finished &&
          !state.writing);
}

function prefinish(stream, state) {
  if (!state.prefinished) {
    state.prefinished = true;
    stream.emit('prefinish');
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(stream, state);
  if (need) {
    if (state.pendingcb === 0) {
      prefinish(stream, state);
      state.finished = true;
      stream.emit('finish');
    } else
      prefinish(stream, state);
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished)
      process.nextTick(cb);
    else
      stream.once('finish', cb);
  }
  state.ended = true;
}

}).call(this,_dereq_(57))
},{"120":120,"125":125,"50":50,"57":57,"71":71,"76":76}],125:[function(_dereq_,module,exports){
arguments[4][94][0].apply(exports,arguments)
},{"55":55,"94":94}],126:[function(_dereq_,module,exports){
arguments[4][56][0].apply(exports,arguments)
},{"56":56}],127:[function(_dereq_,module,exports){
arguments[4][72][0].apply(exports,arguments)
},{"50":50,"72":72}],128:[function(_dereq_,module,exports){
exports = module.exports = _dereq_(122);
exports.Stream = _dereq_(71);
exports.Readable = exports;
exports.Writable = _dereq_(124);
exports.Duplex = _dereq_(120);
exports.Transform = _dereq_(123);
exports.PassThrough = _dereq_(121);

},{"120":120,"121":121,"122":122,"123":123,"124":124,"71":71}],129:[function(_dereq_,module,exports){
arguments[4][88][0].apply(exports,arguments)
},{"88":88}],130:[function(_dereq_,module,exports){
arguments[4][101][0].apply(exports,arguments)
},{"101":101}],131:[function(_dereq_,module,exports){
module.exports={
  "name": "levelup",
  "description": "Fast & simple storage - a Node.js-style LevelDB wrapper",
  "version": "1.2.1",
  "contributors": [
    {
      "name": "Rod Vagg",
      "email": "r@va.gg",
      "url": "https://github.com/rvagg"
    },
    {
      "name": "John Chesley",
      "email": "john@chesl.es",
      "url": "https://github.com/chesles/"
    },
    {
      "name": "Jake Verbaten",
      "email": "raynos2@gmail.com",
      "url": "https://github.com/raynos"
    },
    {
      "name": "Dominic Tarr",
      "email": "dominic.tarr@gmail.com",
      "url": "https://github.com/dominictarr"
    },
    {
      "name": "Max Ogden",
      "email": "max@maxogden.com",
      "url": "https://github.com/maxogden"
    },
    {
      "name": "Lars-Magnus Skog",
      "email": "ralphtheninja@riseup.net",
      "url": "https://github.com/ralphtheninja"
    },
    {
      "name": "David Björklund",
      "email": "david.bjorklund@gmail.com",
      "url": "https://github.com/kesla"
    },
    {
      "name": "Julian Gruber",
      "email": "julian@juliangruber.com",
      "url": "https://github.com/juliangruber"
    },
    {
      "name": "Paolo Fragomeni",
      "email": "paolo@async.ly",
      "url": "https://github.com/hij1nx"
    },
    {
      "name": "Anton Whalley",
      "email": "anton.whalley@nearform.com",
      "url": "https://github.com/No9"
    },
    {
      "name": "Matteo Collina",
      "email": "matteo.collina@gmail.com",
      "url": "https://github.com/mcollina"
    },
    {
      "name": "Pedro Teixeira",
      "email": "pedro.teixeira@gmail.com",
      "url": "https://github.com/pgte"
    },
    {
      "name": "James Halliday",
      "email": "mail@substack.net",
      "url": "https://github.com/substack"
    },
    {
      "name": "Jarrett Cruger",
      "email": "jcrugzz@gmail.com",
      "url": "https://github.com/jcrugzz"
    }
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/level/levelup.git"
  },
  "homepage": "https://github.com/level/levelup",
  "keywords": [
    "leveldb",
    "stream",
    "database",
    "db",
    "store",
    "storage",
    "json"
  ],
  "main": "lib/levelup.js",
  "dependencies": {
    "deferred-leveldown": "~1.0.0",
    "level-codec": "~6.0.0",
    "level-errors": "~1.0.3",
    "level-iterator-stream": "~1.3.0",
    "prr": "~1.0.1",
    "semver": "~4.3.3",
    "xtend": "~4.0.0"
  },
  "devDependencies": {
    "async": "~0.9.0",
    "bustermove": "~1.0.0",
    "delayed": "~1.0.1",
    "faucet": "~0.0.1",
    "leveldown": "^1.1.0",
    "memdown": "~1.0.0",
    "msgpack-js": "~0.3.0",
    "referee": "~1.1.1",
    "rimraf": "~2.3.2",
    "slow-stream": "0.0.4",
    "tape": "~4.0.0"
  },
  "browser": {
    "leveldown": false,
    "leveldown/package": false,
    "semver": false
  },
  "scripts": {
    "test": "tape test/*-test.js | faucet"
  },
  "license": "MIT",
  "gitHead": "8f442f77baea1cdb1b7af844e3374380c2bb015f",
  "bugs": {
    "url": "https://github.com/level/levelup/issues"
  },
  "_id": "levelup@1.2.1",
  "_shasum": "13b537deb4a7536c3aa6fbe008a1af4a0350dbd5",
  "_from": "levelup@1.2.1",
  "_npmVersion": "2.11.0",
  "_nodeVersion": "2.2.1",
  "_npmUser": {
    "name": "ralphtheninja",
    "email": "ralphtheninja@riseup.net"
  },
  "maintainers": [
    {
      "name": "rvagg",
      "email": "rod@vagg.org"
    },
    {
      "name": "ralphtheninja",
      "email": "ralphtheninja@riseup.net"
    },
    {
      "name": "juliangruber",
      "email": "julian@juliangruber.com"
    }
  ],
  "dist": {
    "shasum": "13b537deb4a7536c3aa6fbe008a1af4a0350dbd5",
    "tarball": "http://registry.npmjs.org/levelup/-/levelup-1.2.1.tgz"
  },
  "directories": {},
  "_resolved": "https://registry.npmjs.org/levelup/-/levelup-1.2.1.tgz"
}

},{}],132:[function(_dereq_,module,exports){
'use strict';
var immediate = _dereq_(133);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && typeof obj === 'object' && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

exports.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

exports.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

exports.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

exports.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"133":133}],133:[function(_dereq_,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],134:[function(_dereq_,module,exports){
(function (process,global,Buffer){
'use strict';

var inherits = _dereq_(76);
var AbstractLevelDOWN = _dereq_(139).AbstractLevelDOWN;
var AbstractIterator = _dereq_(139).AbstractIterator;

var LocalStorage = _dereq_(136).LocalStorage;
var LocalStorageCore = _dereq_(135);
var utils = _dereq_(144);

// see http://stackoverflow.com/a/15349865/680742
var nextTick = global.setImmediate || process.nextTick;

function LDIterator(db, options) {

  AbstractIterator.call(this, db);

  this._reverse = !!options.reverse;
  this._endkey     = options.end;
  this._startkey   = options.start;
  this._gt      = options.gt;
  this._gte     = options.gte;
  this._lt      = options.lt;
  this._lte     = options.lte;
  this._exclusiveStart = options.exclusiveStart;
  this._limit = options.limit;
  this._count = 0;

  this.onInitCompleteListeners = [];
}

inherits(LDIterator, AbstractIterator);

LDIterator.prototype._init = function (callback) {
  nextTick(function () {
    callback();
  });
};

LDIterator.prototype._next = function (callback) {
  var self = this;

  function onInitComplete() {
    if (self._pos === self._keys.length || self._pos < 0) { // done reading
      return callback();
    }

    var key = self._keys[self._pos];

    if (!!self._endkey && (self._reverse ? key < self._endkey : key > self._endkey)) {
      return callback();
    }

    if (!!self._limit && self._limit > 0 && self._count++ >= self._limit) {
      return callback();
    }

    if ((self._lt  && key >= self._lt) ||
      (self._lte && key > self._lte) ||
      (self._gt  && key <= self._gt) ||
      (self._gte && key < self._gte)) {
      return callback();
    }

    self._pos += self._reverse ? -1 : 1;
    self.db.container.getItem(key, function (err, value) {
      if (err) {
        if (err.message === 'NotFound') {
          return nextTick(function () {
            self._next(callback);
          });
        }
        return callback(err);
      }
      callback(null, key, value);
    });
  }
  if (!self.initStarted) {
    self.initStarted = true;
    self._init(function (err) {
      if (err) {
        return callback(err);
      }
      self.db.container.keys(function (err, keys) {
        if (err) {
          return callback(err);
        }
        self._keys = keys;
        if (self._startkey) {
          var index = utils.sortedIndexOf(self._keys, self._startkey);
          var startkey = (index >= self._keys.length || index < 0) ?
            undefined : self._keys[index];
          self._pos = index;
          if (self._reverse) {
            if (self._exclusiveStart || startkey !== self._startkey) {
              self._pos--;
            }
          } else if (self._exclusiveStart && startkey === self._startkey) {
            self._pos++;
          }
        } else {
          self._pos = self._reverse ? self._keys.length - 1 : 0;
        }
        onInitComplete();

        self.initCompleted = true;
        var i = -1;
        while (++i < self.onInitCompleteListeners) {
          nextTick(self.onInitCompleteListeners[i]);
        }
      });
    });
  } else if (!self.initCompleted) {
    self.onInitCompleteListeners.push(onInitComplete);
  } else {
    onInitComplete();
  }
};

function LD(location) {
  if (!(this instanceof LD)) {
    return new LD(location);
  }
  AbstractLevelDOWN.call(this, location);
  this.container = new LocalStorage(location);
}

inherits(LD, AbstractLevelDOWN);

LD.prototype._open = function (options, callback) {
  this.container.init(callback);
};

LD.prototype._put = function (key, value, options, callback) {

  var err = checkKeyValue(key, 'key');

  if (err) {
    return nextTick(function () {
      callback(err);
    });
  }

  err = checkKeyValue(value, 'value');

  if (err) {
    return nextTick(function () {
      callback(err);
    });
  }

  if (typeof value === 'object' && !Buffer.isBuffer(value) && value.buffer === undefined) {
    var obj = {};
    obj.storetype = "json";
    obj.data = value;
    value = JSON.stringify(obj);
  }

  this.container.setItem(key, value, callback);
};

LD.prototype._get = function (key, options, callback) {

  var err = checkKeyValue(key, 'key');

  if (err) {
    return nextTick(function () {
      callback(err);
    });
  }

  if (!Buffer.isBuffer(key)) {
    key = String(key);
  }
  this.container.getItem(key, function (err, value) {

    if (err) {
      return callback(err);
    }

    if (options.asBuffer !== false && !Buffer.isBuffer(value)) {
      value = new Buffer(value);
    }


    if (options.asBuffer === false) {
      if (value.indexOf("{\"storetype\":\"json\",\"data\"") > -1) {
        var res = JSON.parse(value);
        value = res.data;
      }
    }
    callback(null, value);
  });
};

LD.prototype._del = function (key, options, callback) {

  var err = checkKeyValue(key, 'key');

  if (err) {
    return nextTick(function () {
      callback(err);
    });
  }
  if (!Buffer.isBuffer(key)) {
    key = String(key);
  }

  this.container.removeItem(key, callback);
};

LD.prototype._batch = function (array, options, callback) {
  var self = this;
  nextTick(function () {
    var err;
    var key;
    var value;

    var numDone = 0;
    var overallErr;
    function checkDone() {
      if (++numDone === array.length) {
        callback(overallErr);
      }
    }

    if (Array.isArray(array) && array.length) {
      for (var i = 0; i < array.length; i++) {
        var task = array[i];
        if (task) {
          key = Buffer.isBuffer(task.key) ? task.key : String(task.key);
          err = checkKeyValue(key, 'key');
          if (err) {
            overallErr = err;
            checkDone();
          } else if (task.type === 'del') {
            self._del(task.key, options, checkDone);
          } else if (task.type === 'put') {
            value = Buffer.isBuffer(task.value) ? task.value : String(task.value);
            err = checkKeyValue(value, 'value');
            if (err) {
              overallErr = err;
              checkDone();
            } else {
              self._put(key, value, options, checkDone);
            }
          }
        } else {
          checkDone();
        }
      }
    } else {
      callback();
    }
  });
};

LD.prototype._iterator = function (options) {
  return new LDIterator(this, options);
};

LD.destroy = function (name, callback) {
  LocalStorageCore.destroy(name, callback);
};

function checkKeyValue(obj, type) {
  if (obj === null || obj === undefined) {
    return new Error(type + ' cannot be `null` or `undefined`');
  }
  if (obj === null || obj === undefined) {
    return new Error(type + ' cannot be `null` or `undefined`');
  }

  if (type === 'key') {

    if (obj instanceof Boolean) {
      return new Error(type + ' cannot be `null` or `undefined`');
    }
    if (obj === '') {
      return new Error(type + ' cannot be empty');
    }
  }
  if (obj.toString().indexOf("[object ArrayBuffer]") === 0) {
    if (obj.byteLength === 0 || obj.byteLength === undefined) {
      return new Error(type + ' cannot be an empty Buffer');
    }
  }

  if (Buffer.isBuffer(obj)) {
    if (obj.length === 0) {
      return new Error(type + ' cannot be an empty Buffer');
    }
  } else if (String(obj) === '') {
    return new Error(type + ' cannot be an empty String');
  }
}


module.exports = LD;

}).call(this,_dereq_(57),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},_dereq_(50).Buffer)
},{"135":135,"136":136,"139":139,"144":144,"50":50,"57":57,"76":76}],135:[function(_dereq_,module,exports){
(function (process,global){
'use strict';

//
// Class that should contain everything necessary to interact
// with localStorage as a generic key-value store.
// The idea is that authors who want to create an AbstractKeyValueDOWN
// module (e.g. on lawnchair, S3, whatever) will only have to
// reimplement this file.
//

// see http://stackoverflow.com/a/15349865/680742
var nextTick = global.setImmediate || process.nextTick;

function callbackify(callback, fun) {
  var val;
  var err;
  try {
    val = fun();
  } catch (e) {
    err = e;
  }
  nextTick(function () {
    callback(err, val);
  });
}

function createPrefix(dbname) {
  return dbname.replace(/!/g, '!!') + '!'; // escape bangs in dbname;
}

function LocalStorageCore(dbname) {
  this._prefix = createPrefix(dbname);
}

LocalStorageCore.prototype.getKeys = function (callback) {
  var self = this;
  callbackify(callback, function () {
    var keys = [];
    var prefixLen = self._prefix.length;
    var i = -1;
    var len = window.localStorage.length;
    while (++i < len) {
      var fullKey = window.localStorage.key(i);
      if (fullKey.substring(0, prefixLen) === self._prefix) {
        keys.push(fullKey.substring(prefixLen));
      }
    }
    keys.sort();
    return keys;
  });
};

LocalStorageCore.prototype.put = function (key, value, callback) {
  var self = this;
  callbackify(callback, function () {
    window.localStorage.setItem(self._prefix + key, value);
  });
};

LocalStorageCore.prototype.get = function (key, callback) {
  var self = this;
  callbackify(callback, function () {
    return window.localStorage.getItem(self._prefix + key);
  });
};

LocalStorageCore.prototype.remove = function (key, callback) {
  var self = this;
  callbackify(callback, function () {
    window.localStorage.removeItem(self._prefix + key);
  });
};

LocalStorageCore.destroy = function (dbname, callback) {
  var prefix = createPrefix(dbname);
  callbackify(callback, function () {
    Object.keys(localStorage).forEach(function (key) {
      if (key.substring(0, prefix.length) === prefix) {
        localStorage.removeItem(key);
      }
    });
  });
};

module.exports = LocalStorageCore;
}).call(this,_dereq_(57),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"57":57}],136:[function(_dereq_,module,exports){
(function (Buffer){
'use strict';

// ArrayBuffer/Uint8Array are old formats that date back to before we
// had a proper browserified buffer type. they may be removed later
var arrayBuffPrefix = 'ArrayBuffer:';
var arrayBuffRegex = new RegExp('^' + arrayBuffPrefix);
var uintPrefix = 'Uint8Array:';
var uintRegex = new RegExp('^' + uintPrefix);

// this is the new encoding format used going forward
var bufferPrefix = 'Buff:';
var bufferRegex = new RegExp('^' + bufferPrefix);

var utils = _dereq_(144);
var LocalStorageCore = _dereq_(135);
var TaskQueue = _dereq_(143);
var d64 = _dereq_(141);

function LocalStorage(dbname) {
  this._store = new LocalStorageCore(dbname);
  this._queue = new TaskQueue();
}

LocalStorage.prototype.sequentialize = function (callback, fun) {
  this._queue.add(fun, callback);
};

LocalStorage.prototype.init = function (callback) {
  var self = this;
  self.sequentialize(callback, function (callback) {
    self._store.getKeys(function (err, keys) {
      if (err) {
        return callback(err);
      }
      self._keys = keys;
      return callback();
    });
  });
};

LocalStorage.prototype.keys = function (callback) {
  var self = this;
  self.sequentialize(callback, function (callback) {
    callback(null, self._keys.slice());
  });
};

//setItem: Saves and item at the key provided.
LocalStorage.prototype.setItem = function (key, value, callback) {
  var self = this;
  self.sequentialize(callback, function (callback) {
    if (Buffer.isBuffer(value)) {
      value = bufferPrefix + d64.encode(value);
    }

    var idx = utils.sortedIndexOf(self._keys, key);
    if (self._keys[idx] !== key) {
      self._keys.splice(idx, 0, key);
    }
    self._store.put(key, value, callback);
  });
};

//getItem: Returns the item identified by it's key.
LocalStorage.prototype.getItem = function (key, callback) {
  var self = this;
  self.sequentialize(callback, function (callback) {
    self._store.get(key, function (err, retval) {
      if (err) {
        return callback(err);
      }
      if (typeof retval === 'undefined' || retval === null) {
        // 'NotFound' error, consistent with LevelDOWN API
        return callback(new Error('NotFound'));
      }
      if (typeof retval !== 'undefined') {
        if (bufferRegex.test(retval)) {
          retval = d64.decode(retval.substring(bufferPrefix.length));
        } else if (arrayBuffRegex.test(retval)) {
          // this type is kept for backwards
          // compatibility with older databases, but may be removed
          // after a major version bump
          retval = retval.substring(arrayBuffPrefix.length);
          retval = new ArrayBuffer(atob(retval).split('').map(function (c) {
            return c.charCodeAt(0);
          }));
        } else if (uintRegex.test(retval)) {
          // ditto
          retval = retval.substring(uintPrefix.length);
          retval = new Uint8Array(atob(retval).split('').map(function (c) {
            return c.charCodeAt(0);
          }));
        }
      }
      callback(null, retval);
    });
  });
};

//removeItem: Removes the item identified by it's key.
LocalStorage.prototype.removeItem = function (key, callback) {
  var self = this;
  self.sequentialize(callback, function (callback) {
    var idx = utils.sortedIndexOf(self._keys, key);
    if (self._keys[idx] === key) {
      self._keys.splice(idx, 1);
      self._store.remove(key, function (err) {
        if (err) {
          return callback(err);
        }
        callback();
      });
    } else {
      callback();
    }
  });
};

LocalStorage.prototype.length = function (callback) {
  var self = this;
  self.sequentialize(callback, function (callback) {
    callback(null, self._keys.length);
  });
};

exports.LocalStorage = LocalStorage;

}).call(this,{"isBuffer":_dereq_(55)})
},{"135":135,"141":141,"143":143,"144":144,"55":55}],137:[function(_dereq_,module,exports){
(function (process){
/* Copyright (c) 2013 Rod Vagg, MIT License */

function AbstractChainedBatch (db) {
  this._db         = db
  this._operations = []
  this._written    = false
}

AbstractChainedBatch.prototype._checkWritten = function () {
  if (this._written)
    throw new Error('write() already called on this batch')
}

AbstractChainedBatch.prototype.put = function (key, value) {
  this._checkWritten()

  var err = this._db._checkKeyValue(key, 'key', this._db._isBuffer)
  if (err) throw err
  err = this._db._checkKeyValue(value, 'value', this._db._isBuffer)
  if (err) throw err

  if (!this._db._isBuffer(key)) key = String(key)
  if (!this._db._isBuffer(value)) value = String(value)

  if (typeof this._put == 'function' )
    this._put(key, value)
  else
    this._operations.push({ type: 'put', key: key, value: value })

  return this
}

AbstractChainedBatch.prototype.del = function (key) {
  this._checkWritten()

  var err = this._db._checkKeyValue(key, 'key', this._db._isBuffer)
  if (err) throw err

  if (!this._db._isBuffer(key)) key = String(key)

  if (typeof this._del == 'function' )
    this._del(key)
  else
    this._operations.push({ type: 'del', key: key })

  return this
}

AbstractChainedBatch.prototype.clear = function () {
  this._checkWritten()

  this._operations = []

  if (typeof this._clear == 'function' )
    this._clear()

  return this
}

AbstractChainedBatch.prototype.write = function (options, callback) {
  this._checkWritten()

  if (typeof options == 'function')
    callback = options
  if (typeof callback != 'function')
    throw new Error('write() requires a callback argument')
  if (typeof options != 'object')
    options = {}

  this._written = true

  if (typeof this._write == 'function' )
    return this._write(callback)

  if (typeof this._db._batch == 'function')
    return this._db._batch(this._operations, options, callback)

  process.nextTick(callback)
}

module.exports = AbstractChainedBatch
}).call(this,_dereq_(57))
},{"57":57}],138:[function(_dereq_,module,exports){
arguments[4][111][0].apply(exports,arguments)
},{"111":111,"57":57}],139:[function(_dereq_,module,exports){
(function (Buffer,process){
/* Copyright (c) 2013 Rod Vagg, MIT License */

var xtend                = _dereq_(140)
  , AbstractIterator     = _dereq_(138)
  , AbstractChainedBatch = _dereq_(137)

function AbstractLevelDOWN (location) {
  if (!arguments.length || location === undefined)
    throw new Error('constructor requires at least a location argument')

  if (typeof location != 'string')
    throw new Error('constructor requires a location string argument')

  this.location = location
}

AbstractLevelDOWN.prototype.open = function (options, callback) {
  if (typeof options == 'function')
    callback = options

  if (typeof callback != 'function')
    throw new Error('open() requires a callback argument')

  if (typeof options != 'object')
    options = {}

  if (typeof this._open == 'function')
    return this._open(options, callback)

  process.nextTick(callback)
}

AbstractLevelDOWN.prototype.close = function (callback) {
  if (typeof callback != 'function')
    throw new Error('close() requires a callback argument')

  if (typeof this._close == 'function')
    return this._close(callback)

  process.nextTick(callback)
}

AbstractLevelDOWN.prototype.get = function (key, options, callback) {
  var err

  if (typeof options == 'function')
    callback = options

  if (typeof callback != 'function')
    throw new Error('get() requires a callback argument')

  if (err = this._checkKeyValue(key, 'key', this._isBuffer))
    return callback(err)

  if (!this._isBuffer(key))
    key = String(key)

  if (typeof options != 'object')
    options = {}

  if (typeof this._get == 'function')
    return this._get(key, options, callback)

  process.nextTick(function () { callback(new Error('NotFound')) })
}

AbstractLevelDOWN.prototype.put = function (key, value, options, callback) {
  var err

  if (typeof options == 'function')
    callback = options

  if (typeof callback != 'function')
    throw new Error('put() requires a callback argument')

  if (err = this._checkKeyValue(key, 'key', this._isBuffer))
    return callback(err)

  if (err = this._checkKeyValue(value, 'value', this._isBuffer))
    return callback(err)

  if (!this._isBuffer(key))
    key = String(key)

  // coerce value to string in node, don't touch it in browser
  // (indexeddb can store any JS type)
  if (!this._isBuffer(value) && !process.browser)
    value = String(value)

  if (typeof options != 'object')
    options = {}

  if (typeof this._put == 'function')
    return this._put(key, value, options, callback)

  process.nextTick(callback)
}

AbstractLevelDOWN.prototype.del = function (key, options, callback) {
  var err

  if (typeof options == 'function')
    callback = options

  if (typeof callback != 'function')
    throw new Error('del() requires a callback argument')

  if (err = this._checkKeyValue(key, 'key', this._isBuffer))
    return callback(err)

  if (!this._isBuffer(key))
    key = String(key)

  if (typeof options != 'object')
    options = {}

  if (typeof this._del == 'function')
    return this._del(key, options, callback)

  process.nextTick(callback)
}

AbstractLevelDOWN.prototype.batch = function (array, options, callback) {
  if (!arguments.length)
    return this._chainedBatch()

  if (typeof options == 'function')
    callback = options

  if (typeof callback != 'function')
    throw new Error('batch(array) requires a callback argument')

  if (!Array.isArray(array))
    return callback(new Error('batch(array) requires an array argument'))

  if (typeof options != 'object')
    options = {}

  var i = 0
    , l = array.length
    , e
    , err

  for (; i < l; i++) {
    e = array[i]
    if (typeof e != 'object')
      continue

    if (err = this._checkKeyValue(e.type, 'type', this._isBuffer))
      return callback(err)

    if (err = this._checkKeyValue(e.key, 'key', this._isBuffer))
      return callback(err)

    if (e.type == 'put') {
      if (err = this._checkKeyValue(e.value, 'value', this._isBuffer))
        return callback(err)
    }
  }

  if (typeof this._batch == 'function')
    return this._batch(array, options, callback)

  process.nextTick(callback)
}

//TODO: remove from here, not a necessary primitive
AbstractLevelDOWN.prototype.approximateSize = function (start, end, callback) {
  if (   start == null
      || end == null
      || typeof start == 'function'
      || typeof end == 'function') {
    throw new Error('approximateSize() requires valid `start`, `end` and `callback` arguments')
  }

  if (typeof callback != 'function')
    throw new Error('approximateSize() requires a callback argument')

  if (!this._isBuffer(start))
    start = String(start)

  if (!this._isBuffer(end))
    end = String(end)

  if (typeof this._approximateSize == 'function')
    return this._approximateSize(start, end, callback)

  process.nextTick(function () {
    callback(null, 0)
  })
}

AbstractLevelDOWN.prototype._setupIteratorOptions = function (options) {
  var self = this

  options = xtend(options)

  ;[ 'start', 'end', 'gt', 'gte', 'lt', 'lte' ].forEach(function (o) {
    if (options[o] && self._isBuffer(options[o]) && options[o].length === 0)
      delete options[o]
  })

  options.reverse = !!options.reverse

  // fix `start` so it takes into account gt, gte, lt, lte as appropriate
  if (options.reverse && options.lt)
    options.start = options.lt
  if (options.reverse && options.lte)
    options.start = options.lte
  if (!options.reverse && options.gt)
    options.start = options.gt
  if (!options.reverse && options.gte)
    options.start = options.gte

  if ((options.reverse && options.lt && !options.lte)
    || (!options.reverse && options.gt && !options.gte))
    options.exclusiveStart = true // start should *not* include matching key

  return options
}

AbstractLevelDOWN.prototype.iterator = function (options) {
  if (typeof options != 'object')
    options = {}

  options = this._setupIteratorOptions(options)

  if (typeof this._iterator == 'function')
    return this._iterator(options)

  return new AbstractIterator(this)
}

AbstractLevelDOWN.prototype._chainedBatch = function () {
  return new AbstractChainedBatch(this)
}

AbstractLevelDOWN.prototype._isBuffer = function (obj) {
  return Buffer.isBuffer(obj)
}

AbstractLevelDOWN.prototype._checkKeyValue = function (obj, type) {
  if (obj === null || obj === undefined)
    return new Error(type + ' cannot be `null` or `undefined`')

  if (obj === null || obj === undefined)
    return new Error(type + ' cannot be `null` or `undefined`')

  if (this._isBuffer(obj)) {
    if (obj.length === 0)
      return new Error(type + ' cannot be an empty Buffer')
  } else if (String(obj) === '')
    return new Error(type + ' cannot be an empty String')
}

module.exports.AbstractLevelDOWN    = AbstractLevelDOWN
module.exports.AbstractIterator     = AbstractIterator
module.exports.AbstractChainedBatch = AbstractChainedBatch

}).call(this,{"isBuffer":_dereq_(55)},_dereq_(57))
},{"137":137,"138":138,"140":140,"55":55,"57":57}],140:[function(_dereq_,module,exports){
arguments[4][98][0].apply(exports,arguments)
},{"98":98}],141:[function(_dereq_,module,exports){
var Buffer = _dereq_(50).Buffer

var CHARS = '.PYFGCRLAOEUIDHTNSQJKXBMWVZ_pyfgcrlaoeuidhtnsqjkxbmwvz1234567890'
  .split('').sort().join('')

module.exports = function (chars, exports) {
  chars = chars || CHARS
  exports = exports || {}
  if(chars.length !== 64) throw new Error('a base 64 encoding requires 64 chars')

  var codeToIndex = new Buffer(128)
  codeToIndex.fill()

  for(var i = 0; i < 64; i++) {
    var code = chars.charCodeAt(i)
    codeToIndex[code] = i
  }

  exports.encode = function (data) {
      var s = '', l = data.length, hang = 0
      for(var i = 0; i < l; i++) {
        var v = data[i]

        switch (i % 3) {
          case 0:
            s += chars[v >> 2]
            hang = (v & 3) << 4
          break;
          case 1:
            s += chars[hang | v >> 4]
            hang = (v & 0xf) << 2
          break;
          case 2:
            s += chars[hang | v >> 6]
            s += chars[v & 0x3f]
            hang = 0
          break;
        }

      }
      if(l%3) s += chars[hang]
      return s
    }
  exports.decode = function (str) {
      var l = str.length, j = 0
      var b = new Buffer(~~((l/4)*3)), hang = 0

      for(var i = 0; i < l; i++) {
        var v = codeToIndex[str.charCodeAt(i)]

        switch (i % 4) {
          case 0:
            hang = v << 2;
          break;
          case 1:
            b[j++] = hang | v >> 4
            hang = (v << 4) & 0xff
          break;
          case 2:
            b[j++] = hang | v >> 2
            hang = (v << 6) & 0xff
          break;
          case 3:
            b[j++] = hang | v
          break;
        }

      }
      return b
    }
  return exports
}

module.exports(CHARS, module.exports)


},{"50":50}],142:[function(_dereq_,module,exports){
'use strict';

// Simple FIFO queue implementation to avoid having to do shift()
// on an array, which is slow.

function Queue() {
  this.length = 0;
}

Queue.prototype.push = function (item) {
  var node = {item: item};
  if (this.last) {
    this.last = this.last.next = node;
  } else {
    this.last = this.first = node;
  }
  this.length++;
};

Queue.prototype.shift = function () {
  var node = this.first;
  if (node) {
    this.first = node.next;
    if (!(--this.length)) {
      this.last = undefined;
    }
    return node.item;
  }
};

Queue.prototype.slice = function (start, end) {
  start = typeof start === 'undefined' ? 0 : start;
  end = typeof end === 'undefined' ? Infinity : end;

  var output = [];

  var i = 0;
  for (var node = this.first; node; node = node.next) {
    if (--end < 0) {
      break;
    } else if (++i > start) {
      output.push(node.item);
    }
  }
  return output;
}

module.exports = Queue;

},{}],143:[function(_dereq_,module,exports){
(function (process,global){
'use strict';

var argsarray = _dereq_(48);
var Queue = _dereq_(142);

// see http://stackoverflow.com/a/15349865/680742
var nextTick = global.setImmediate || process.nextTick;

function TaskQueue() {
  this.queue = new Queue();
  this.running = false;
}

TaskQueue.prototype.add = function (fun, callback) {
  this.queue.push({fun: fun, callback: callback});
  this.processNext();
};

TaskQueue.prototype.processNext = function () {
  var self = this;
  if (self.running || !self.queue.length) {
    return;
  }
  self.running = true;

  var task = self.queue.shift();
  nextTick(function () {
    task.fun(argsarray(function (args) {
      task.callback.apply(null, args);
      self.running = false;
      self.processNext();
    }));
  });
};

module.exports = TaskQueue;

}).call(this,_dereq_(57),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"142":142,"48":48,"57":57}],144:[function(_dereq_,module,exports){
'use strict';
// taken from rvagg/memdown commit 2078b40
exports.sortedIndexOf = function(arr, item) {
  var low = 0;
  var high = arr.length;
  var mid;
  while (low < high) {
    mid = (low + high) >>> 1;
    if (arr[mid] < item) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }
  return low;
};

},{}],145:[function(_dereq_,module,exports){
'use strict';
exports.Map = LazyMap; // TODO: use ES6 map
exports.Set = LazySet; // TODO: use ES6 set
// based on https://github.com/montagejs/collections
function LazyMap() {
  this.store = {};
}
LazyMap.prototype.mangle = function (key) {
  if (typeof key !== "string") {
    throw new TypeError("key must be a string but Got " + key);
  }
  return '$' + key;
};
LazyMap.prototype.unmangle = function (key) {
  return key.substring(1);
};
LazyMap.prototype.get = function (key) {
  var mangled = this.mangle(key);
  if (mangled in this.store) {
    return this.store[mangled];
  }
  return void 0;
};
LazyMap.prototype.set = function (key, value) {
  var mangled = this.mangle(key);
  this.store[mangled] = value;
  return true;
};
LazyMap.prototype.has = function (key) {
  var mangled = this.mangle(key);
  return mangled in this.store;
};
LazyMap.prototype["delete"] = function (key) {
  var mangled = this.mangle(key);
  if (mangled in this.store) {
    delete this.store[mangled];
    return true;
  }
  return false;
};
LazyMap.prototype.forEach = function (cb) {
  var keys = Object.keys(this.store);
  for (var i = 0, len = keys.length; i < len; i++) {
    var key = keys[i];
    var value = this.store[key];
    key = this.unmangle(key);
    cb(value, key);
  }
};

function LazySet(array) {
  this.store = new LazyMap();

  // init with an array
  if (array && Array.isArray(array)) {
    for (var i = 0, len = array.length; i < len; i++) {
      this.add(array[i]);
    }
  }
}
LazySet.prototype.add = function (key) {
  return this.store.set(key, true);
};
LazySet.prototype.has = function (key) {
  return this.store.has(key);
};
LazySet.prototype["delete"] = function (key) {
  return this.store["delete"](key);
};

},{}],146:[function(_dereq_,module,exports){
(function (factory) {
    if (typeof exports === 'object') {
        // Node/CommonJS
        module.exports = factory();
    } else if (typeof define === 'function' && define.amd) {
        // AMD
        define(factory);
    } else {
        // Browser globals (with support for web workers)
        var glob;

        try {
            glob = window;
        } catch (e) {
            glob = self;
        }

        glob.SparkMD5 = factory();
    }
}(function (undefined) {

    'use strict';

    /*
     * Fastest md5 implementation around (JKM md5)
     * Credits: Joseph Myers
     *
     * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
     * @see http://jsperf.com/md5-shootout/7
     */

    /* this function is much faster,
      so if possible we use it. Some IEs
      are the only ones I know of that
      need the idiotic second function,
      generated by an if clause.  */
    var add32 = function (a, b) {
        return (a + b) & 0xFFFFFFFF;
    },
        hex_chr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];


    function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32((a << s) | (a >>> (32 - s)), b);
    }

    function ff(a, b, c, d, x, s, t) {
        return cmn((b & c) | ((~b) & d), a, b, x, s, t);
    }

    function gg(a, b, c, d, x, s, t) {
        return cmn((b & d) | (c & (~d)), a, b, x, s, t);
    }

    function hh(a, b, c, d, x, s, t) {
        return cmn(b ^ c ^ d, a, b, x, s, t);
    }

    function ii(a, b, c, d, x, s, t) {
        return cmn(c ^ (b | (~d)), a, b, x, s, t);
    }

    function md5cycle(x, k) {
        var a = x[0],
            b = x[1],
            c = x[2],
            d = x[3];

        a = ff(a, b, c, d, k[0], 7, -680876936);
        d = ff(d, a, b, c, k[1], 12, -389564586);
        c = ff(c, d, a, b, k[2], 17, 606105819);
        b = ff(b, c, d, a, k[3], 22, -1044525330);
        a = ff(a, b, c, d, k[4], 7, -176418897);
        d = ff(d, a, b, c, k[5], 12, 1200080426);
        c = ff(c, d, a, b, k[6], 17, -1473231341);
        b = ff(b, c, d, a, k[7], 22, -45705983);
        a = ff(a, b, c, d, k[8], 7, 1770035416);
        d = ff(d, a, b, c, k[9], 12, -1958414417);
        c = ff(c, d, a, b, k[10], 17, -42063);
        b = ff(b, c, d, a, k[11], 22, -1990404162);
        a = ff(a, b, c, d, k[12], 7, 1804603682);
        d = ff(d, a, b, c, k[13], 12, -40341101);
        c = ff(c, d, a, b, k[14], 17, -1502002290);
        b = ff(b, c, d, a, k[15], 22, 1236535329);

        a = gg(a, b, c, d, k[1], 5, -165796510);
        d = gg(d, a, b, c, k[6], 9, -1069501632);
        c = gg(c, d, a, b, k[11], 14, 643717713);
        b = gg(b, c, d, a, k[0], 20, -373897302);
        a = gg(a, b, c, d, k[5], 5, -701558691);
        d = gg(d, a, b, c, k[10], 9, 38016083);
        c = gg(c, d, a, b, k[15], 14, -660478335);
        b = gg(b, c, d, a, k[4], 20, -405537848);
        a = gg(a, b, c, d, k[9], 5, 568446438);
        d = gg(d, a, b, c, k[14], 9, -1019803690);
        c = gg(c, d, a, b, k[3], 14, -187363961);
        b = gg(b, c, d, a, k[8], 20, 1163531501);
        a = gg(a, b, c, d, k[13], 5, -1444681467);
        d = gg(d, a, b, c, k[2], 9, -51403784);
        c = gg(c, d, a, b, k[7], 14, 1735328473);
        b = gg(b, c, d, a, k[12], 20, -1926607734);

        a = hh(a, b, c, d, k[5], 4, -378558);
        d = hh(d, a, b, c, k[8], 11, -2022574463);
        c = hh(c, d, a, b, k[11], 16, 1839030562);
        b = hh(b, c, d, a, k[14], 23, -35309556);
        a = hh(a, b, c, d, k[1], 4, -1530992060);
        d = hh(d, a, b, c, k[4], 11, 1272893353);
        c = hh(c, d, a, b, k[7], 16, -155497632);
        b = hh(b, c, d, a, k[10], 23, -1094730640);
        a = hh(a, b, c, d, k[13], 4, 681279174);
        d = hh(d, a, b, c, k[0], 11, -358537222);
        c = hh(c, d, a, b, k[3], 16, -722521979);
        b = hh(b, c, d, a, k[6], 23, 76029189);
        a = hh(a, b, c, d, k[9], 4, -640364487);
        d = hh(d, a, b, c, k[12], 11, -421815835);
        c = hh(c, d, a, b, k[15], 16, 530742520);
        b = hh(b, c, d, a, k[2], 23, -995338651);

        a = ii(a, b, c, d, k[0], 6, -198630844);
        d = ii(d, a, b, c, k[7], 10, 1126891415);
        c = ii(c, d, a, b, k[14], 15, -1416354905);
        b = ii(b, c, d, a, k[5], 21, -57434055);
        a = ii(a, b, c, d, k[12], 6, 1700485571);
        d = ii(d, a, b, c, k[3], 10, -1894986606);
        c = ii(c, d, a, b, k[10], 15, -1051523);
        b = ii(b, c, d, a, k[1], 21, -2054922799);
        a = ii(a, b, c, d, k[8], 6, 1873313359);
        d = ii(d, a, b, c, k[15], 10, -30611744);
        c = ii(c, d, a, b, k[6], 15, -1560198380);
        b = ii(b, c, d, a, k[13], 21, 1309151649);
        a = ii(a, b, c, d, k[4], 6, -145523070);
        d = ii(d, a, b, c, k[11], 10, -1120210379);
        c = ii(c, d, a, b, k[2], 15, 718787259);
        b = ii(b, c, d, a, k[9], 21, -343485551);

        x[0] = add32(a, x[0]);
        x[1] = add32(b, x[1]);
        x[2] = add32(c, x[2]);
        x[3] = add32(d, x[3]);
    }

    function md5blk(s) {
        var md5blks = [],
            i; /* Andy King said do it this way. */

        for (i = 0; i < 64; i += 4) {
            md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        }
        return md5blks;
    }

    function md5blk_array(a) {
        var md5blks = [],
            i; /* Andy King said do it this way. */

        for (i = 0; i < 64; i += 4) {
            md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
        }
        return md5blks;
    }

    function md51(s) {
        var n = s.length,
            state = [1732584193, -271733879, -1732584194, 271733878],
            i,
            length,
            tail,
            tmp,
            lo,
            hi;

        for (i = 64; i <= n; i += 64) {
            md5cycle(state, md5blk(s.substring(i - 64, i)));
        }
        s = s.substring(i - 64);
        length = s.length;
        tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (i = 0; i < length; i += 1) {
            tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
        }
        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for (i = 0; i < 16; i += 1) {
                tail[i] = 0;
            }
        }

        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;

        tail[14] = lo;
        tail[15] = hi;

        md5cycle(state, tail);
        return state;
    }

    function md51_array(a) {
        var n = a.length,
            state = [1732584193, -271733879, -1732584194, 271733878],
            i,
            length,
            tail,
            tmp,
            lo,
            hi;

        for (i = 64; i <= n; i += 64) {
            md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
        }

        // Not sure if it is a bug, however IE10 will always produce a sub array of length 1
        // containing the last element of the parent array if the sub array specified starts
        // beyond the length of the parent array - weird.
        // https://connect.microsoft.com/IE/feedback/details/771452/typed-array-subarray-issue
        a = (i - 64) < n ? a.subarray(i - 64) : new Uint8Array(0);

        length = a.length;
        tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (i = 0; i < length; i += 1) {
            tail[i >> 2] |= a[i] << ((i % 4) << 3);
        }

        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for (i = 0; i < 16; i += 1) {
                tail[i] = 0;
            }
        }

        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;

        tail[14] = lo;
        tail[15] = hi;

        md5cycle(state, tail);

        return state;
    }

    function rhex(n) {
        var s = '',
            j;
        for (j = 0; j < 4; j += 1) {
            s += hex_chr[(n >> (j * 8 + 4)) & 0x0F] + hex_chr[(n >> (j * 8)) & 0x0F];
        }
        return s;
    }

    function hex(x) {
        var i;
        for (i = 0; i < x.length; i += 1) {
            x[i] = rhex(x[i]);
        }
        return x.join('');
    }

    // In some cases the fast add32 function cannot be used..
    if (hex(md51('hello')) !== '5d41402abc4b2a76b9719d911017c592') {
        add32 = function (x, y) {
            var lsw = (x & 0xFFFF) + (y & 0xFFFF),
                msw = (x >> 16) + (y >> 16) + (lsw >> 16);
            return (msw << 16) | (lsw & 0xFFFF);
        };
    }

    // ---------------------------------------------------

    function toUtf8(str) {
        if (/[\u0080-\uFFFF]/.test(str)) {
            str = unescape(encodeURIComponent(str));
        }

        return str;
    }

    function utf8Str2ArrayBuffer(str, returnUInt8Array) {
        var length = str.length,
           buff = new ArrayBuffer(length),
           arr = new Uint8Array(buff),
           i;

        for (i = 0; i < length; i++) {
            arr[i] = str.charCodeAt(i);
        }

        return returnUInt8Array ? arr : buff;
    }

    function arrayBuffer2Utf8Str(buff) {
        return String.fromCharCode.apply(null, new Uint8Array(buff));
    }

    function concatenateArrayBuffers(first, second, returnUInt8Array) {
        var result = new Uint8Array(first.byteLength + second.byteLength);

        result.set(new Uint8Array(first));
        result.set(new Uint8Array(second), first.byteLength);

        return returnUInt8Array ? result : result.buffer;
    }

    // ---------------------------------------------------

    /**
     * SparkMD5 OOP implementation.
     *
     * Use this class to perform an incremental md5, otherwise use the
     * static methods instead.
     */
    function SparkMD5() {
        // call reset to init the instance
        this.reset();
    }

    /**
     * Appends a string.
     * A conversion will be applied if an utf8 string is detected.
     *
     * @param {String} str The string to be appended
     *
     * @return {SparkMD5} The instance itself
     */
    SparkMD5.prototype.append = function (str) {
        // Converts the string to utf8 bytes if necessary
        // Then append as binary
        this.appendBinary(toUtf8(str));

        return this;
    };

    /**
     * Appends a binary string.
     *
     * @param {String} contents The binary string to be appended
     *
     * @return {SparkMD5} The instance itself
     */
    SparkMD5.prototype.appendBinary = function (contents) {
        this._buff += contents;
        this._length += contents.length;

        var length = this._buff.length,
            i;

        for (i = 64; i <= length; i += 64) {
            md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
        }

        this._buff = this._buff.substring(i - 64);

        return this;
    };

    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     * Use the raw parameter to obtain the raw result instead of the hex one.
     *
     * @param {Boolean} raw True to get the raw result, false to get the hex result
     *
     * @return {String|Array} The result
     */
    SparkMD5.prototype.end = function (raw) {
        var buff = this._buff,
            length = buff.length,
            i,
            tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            ret;

        for (i = 0; i < length; i += 1) {
            tail[i >> 2] |= buff.charCodeAt(i) << ((i % 4) << 3);
        }

        this._finish(tail, length);
        ret = !!raw ? this._hash : hex(this._hash);

        this.reset();

        return ret;
    };

    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5} The instance itself
     */
    SparkMD5.prototype.reset = function () {
        this._buff = '';
        this._length = 0;
        this._hash = [1732584193, -271733879, -1732584194, 271733878];

        return this;
    };

    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */
    SparkMD5.prototype.getState = function () {
        return {
            buff: this._buff,
            length: this._length,
            hash: this._hash
        };
    };

    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5} The instance itself
     */
    SparkMD5.prototype.setState = function (state) {
        this._buff = state.buff;
        this._length = state.length;
        this._hash = state.hash;

        return this;
    };

    /**
     * Releases memory used by the incremental buffer and other additional
     * resources. If you plan to use the instance again, use reset instead.
     */
    SparkMD5.prototype.destroy = function () {
        delete this._hash;
        delete this._buff;
        delete this._length;
    };

    /**
     * Finish the final calculation based on the tail.
     *
     * @param {Array}  tail   The tail (will be modified)
     * @param {Number} length The length of the remaining buffer
     */
    SparkMD5.prototype._finish = function (tail, length) {
        var i = length,
            tmp,
            lo,
            hi;

        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
        if (i > 55) {
            md5cycle(this._hash, tail);
            for (i = 0; i < 16; i += 1) {
                tail[i] = 0;
            }
        }

        // Do the final computation based on the tail and length
        // Beware that the final length may not fit in 32 bits so we take care of that
        tmp = this._length * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;

        tail[14] = lo;
        tail[15] = hi;
        md5cycle(this._hash, tail);
    };

    /**
     * Performs the md5 hash on a string.
     * A conversion will be applied if utf8 string is detected.
     *
     * @param {String}  str The string
     * @param {Boolean} raw True to get the raw result, false to get the hex result
     *
     * @return {String|Array} The result
     */
    SparkMD5.hash = function (str, raw) {
        // Converts the string to utf8 bytes if necessary
        // Then compute it using the binary function
        return SparkMD5.hashBinary(toUtf8(str), raw);
    };

    /**
     * Performs the md5 hash on a binary string.
     *
     * @param {String}  content The binary string
     * @param {Boolean} raw     True to get the raw result, false to get the hex result
     *
     * @return {String|Array} The result
     */
    SparkMD5.hashBinary = function (content, raw) {
        var hash = md51(content);

        return !!raw ? hash : hex(hash);
    };

    // ---------------------------------------------------

    /**
     * SparkMD5 OOP implementation for array buffers.
     *
     * Use this class to perform an incremental md5 ONLY for array buffers.
     */
    SparkMD5.ArrayBuffer = function () {
        // call reset to init the instance
        this.reset();
    };

    /**
     * Appends an array buffer.
     *
     * @param {ArrayBuffer} arr The array to be appended
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */
    SparkMD5.ArrayBuffer.prototype.append = function (arr) {
        var buff = concatenateArrayBuffers(this._buff.buffer, arr, true),
            length = buff.length,
            i;

        this._length += arr.byteLength;

        for (i = 64; i <= length; i += 64) {
            md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
        }

        // Avoids IE10 weirdness (documented above)
        this._buff = (i - 64) < length ? buff.subarray(i - 64) : new Uint8Array(0);

        return this;
    };

    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     * Use the raw parameter to obtain the raw result instead of the hex one.
     *
     * @param {Boolean} raw True to get the raw result, false to get the hex result
     *
     * @return {String|Array} The result
     */
    SparkMD5.ArrayBuffer.prototype.end = function (raw) {
        var buff = this._buff,
            length = buff.length,
            tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            i,
            ret;

        for (i = 0; i < length; i += 1) {
            tail[i >> 2] |= buff[i] << ((i % 4) << 3);
        }

        this._finish(tail, length);
        ret = !!raw ? this._hash : hex(this._hash);

        this.reset();

        return ret;
    };

    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */
    SparkMD5.ArrayBuffer.prototype.reset = function () {
        this._buff = new Uint8Array(0);
        this._length = 0;
        this._hash = [1732584193, -271733879, -1732584194, 271733878];

        return this;
    };

    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */
    SparkMD5.ArrayBuffer.prototype.getState = function () {
        var state = SparkMD5.prototype.getState.call(this);

        // Convert buffer to a string
        state.buff = arrayBuffer2Utf8Str(state.buff);

        return state;
    };

    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */
    SparkMD5.ArrayBuffer.prototype.setState = function (state) {
        // Convert string to buffer
        state.buff = utf8Str2ArrayBuffer(state.buff, true);

        return SparkMD5.prototype.setState.call(this, state);
    };

    SparkMD5.ArrayBuffer.prototype.destroy = SparkMD5.prototype.destroy;

    SparkMD5.ArrayBuffer.prototype._finish = SparkMD5.prototype._finish;

    /**
     * Performs the md5 hash on an array buffer.
     *
     * @param {ArrayBuffer} arr The array buffer
     * @param {Boolean}     raw True to get the raw result, false to get the hex result
     *
     * @return {String|Array} The result
     */
    SparkMD5.ArrayBuffer.hash = function (arr, raw) {
        var hash = md51_array(new Uint8Array(arr));

        return !!raw ? hash : hex(hash);
    };

    return SparkMD5;
}));

},{}],147:[function(_dereq_,module,exports){
arguments[4][59][0].apply(exports,arguments)
},{"148":148,"150":150,"151":151,"153":153,"59":59,"76":76}],148:[function(_dereq_,module,exports){
arguments[4][61][0].apply(exports,arguments)
},{"147":147,"151":151,"152":152,"153":153,"154":154,"49":49,"50":50,"54":54,"57":57,"61":61,"76":76}],149:[function(_dereq_,module,exports){
arguments[4][62][0].apply(exports,arguments)
},{"147":147,"151":151,"62":62,"76":76}],150:[function(_dereq_,module,exports){
arguments[4][63][0].apply(exports,arguments)
},{"147":147,"151":151,"153":153,"155":155,"50":50,"54":54,"63":63,"76":76}],151:[function(_dereq_,module,exports){
(function (Buffer){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

function isBuffer(arg) {
  return Buffer.isBuffer(arg);
}
exports.isBuffer = isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}
}).call(this,{"isBuffer":_dereq_(55)})
},{"55":55}],152:[function(_dereq_,module,exports){
arguments[4][56][0].apply(exports,arguments)
},{"56":56}],153:[function(_dereq_,module,exports){
arguments[4][65][0].apply(exports,arguments)
},{"57":57,"65":65}],154:[function(_dereq_,module,exports){
arguments[4][72][0].apply(exports,arguments)
},{"50":50,"72":72}],155:[function(_dereq_,module,exports){
arguments[4][66][0].apply(exports,arguments)
},{"66":66}],156:[function(_dereq_,module,exports){
arguments[4][69][0].apply(exports,arguments)
},{"149":149,"69":69}],157:[function(_dereq_,module,exports){
arguments[4][101][0].apply(exports,arguments)
},{"101":101}],158:[function(_dereq_,module,exports){
(function (process){
var Transform = _dereq_(156)
  , inherits  = _dereq_(74).inherits
  , xtend     = _dereq_(157)

function DestroyableTransform(opts) {
  Transform.call(this, opts)
  this._destroyed = false
}

inherits(DestroyableTransform, Transform)

DestroyableTransform.prototype.destroy = function(err) {
  if (this._destroyed) return
  this._destroyed = true

  var self = this
  process.nextTick(function() {
    if (err)
      self.emit('error', err)
    self.emit('close')
  })
}

// a noop _transform function
function noop (chunk, enc, callback) {
  callback(null, chunk)
}


// create a new export function, used by both the main export and
// the .ctor export, contains common logic for dealing with arguments
function through2 (construct) {
  return function (options, transform, flush) {
    if (typeof options == 'function') {
      flush     = transform
      transform = options
      options   = {}
    }

    if (typeof transform != 'function')
      transform = noop

    if (typeof flush != 'function')
      flush = null

    return construct(options, transform, flush)
  }
}


// main export, just make me a transform stream!
module.exports = through2(function (options, transform, flush) {
  var t2 = new DestroyableTransform(options)

  t2._transform = transform

  if (flush)
    t2._flush = flush

  return t2
})


// make me a reusable prototype that I can `new`, or implicitly `new`
// with a constructor call
module.exports.ctor = through2(function (options, transform, flush) {
  function Through2 (override) {
    if (!(this instanceof Through2))
      return new Through2(override)

    this.options = xtend(options, override)

    DestroyableTransform.call(this, this.options)
  }

  inherits(Through2, DestroyableTransform)

  Through2.prototype._transform = transform

  if (flush)
    Through2.prototype._flush = flush

  return Through2
})


module.exports.obj = through2(function (options, transform, flush) {
  var t2 = new DestroyableTransform(xtend({ objectMode: true, highWaterMark: 16 }, options))

  t2._transform = transform

  if (flush)
    t2._flush = flush

  return t2
})

}).call(this,_dereq_(57))
},{"156":156,"157":157,"57":57,"74":74}],159:[function(_dereq_,module,exports){
'use strict';

/**
 * Stringify/parse functions that don't operate
 * recursively, so they avoid call stack exceeded
 * errors.
 */
exports.stringify = function stringify(input) {
  var queue = [];
  queue.push({obj: input});

  var res = '';
  var next, obj, prefix, val, i, arrayPrefix, keys, k, key, value, objPrefix;
  while ((next = queue.pop())) {
    obj = next.obj;
    prefix = next.prefix || '';
    val = next.val || '';
    res += prefix;
    if (val) {
      res += val;
    } else if (typeof obj !== 'object') {
      res += typeof obj === 'undefined' ? null : JSON.stringify(obj);
    } else if (obj === null) {
      res += 'null';
    } else if (Array.isArray(obj)) {
      queue.push({val: ']'});
      for (i = obj.length - 1; i >= 0; i--) {
        arrayPrefix = i === 0 ? '' : ',';
        queue.push({obj: obj[i], prefix: arrayPrefix});
      }
      queue.push({val: '['});
    } else { // object
      keys = [];
      for (k in obj) {
        if (obj.hasOwnProperty(k)) {
          keys.push(k);
        }
      }
      queue.push({val: '}'});
      for (i = keys.length - 1; i >= 0; i--) {
        key = keys[i];
        value = obj[key];
        objPrefix = (i > 0 ? ',' : '');
        objPrefix += JSON.stringify(key) + ':';
        queue.push({obj: value, prefix: objPrefix});
      }
      queue.push({val: '{'});
    }
  }
  return res;
};

// Convenience function for the parse function.
// This pop function is basically copied from
// pouchCollate.parseIndexableString
function pop(obj, stack, metaStack) {
  var lastMetaElement = metaStack[metaStack.length - 1];
  if (obj === lastMetaElement.element) {
    // popping a meta-element, e.g. an object whose value is another object
    metaStack.pop();
    lastMetaElement = metaStack[metaStack.length - 1];
  }
  var element = lastMetaElement.element;
  var lastElementIndex = lastMetaElement.index;
  if (Array.isArray(element)) {
    element.push(obj);
  } else if (lastElementIndex === stack.length - 2) { // obj with key+value
    var key = stack.pop();
    element[key] = obj;
  } else {
    stack.push(obj); // obj with key only
  }
}

exports.parse = function (str) {
  var stack = [];
  var metaStack = []; // stack for arrays and objects
  var i = 0;
  var collationIndex,parsedNum,numChar;
  var parsedString,lastCh,numConsecutiveSlashes,ch;
  var arrayElement, objElement;
  while (true) {
    collationIndex = str[i++];
    if (collationIndex === '}' ||
        collationIndex === ']' ||
        typeof collationIndex === 'undefined') {
      if (stack.length === 1) {
        return stack.pop();
      } else {
        pop(stack.pop(), stack, metaStack);
        continue;
      }
    }
    switch (collationIndex) {
      case ' ':
      case '\t':
      case '\n':
      case ':':
      case ',':
        break;
      case 'n':
        i += 3; // 'ull'
        pop(null, stack, metaStack);
        break;
      case 't':
        i += 3; // 'rue'
        pop(true, stack, metaStack);
        break;
      case 'f':
        i += 4; // 'alse'
        pop(false, stack, metaStack);
        break;
      case '0':
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
      case '-':
        parsedNum = '';
        i--;
        while (true) {
          numChar = str[i++];
          if (/[\d\.\-e\+]/.test(numChar)) {
            parsedNum += numChar;
          } else {
            i--;
            break;
          }
        }
        pop(parseFloat(parsedNum), stack, metaStack);
        break;
      case '"':
        parsedString = '';
        lastCh = void 0;
        numConsecutiveSlashes = 0;
        while (true) {
          ch = str[i++];
          if (ch !== '"' || (lastCh === '\\' &&
              numConsecutiveSlashes % 2 === 1)) {
            parsedString += ch;
            lastCh = ch;
            if (lastCh === '\\') {
              numConsecutiveSlashes++;
            } else {
              numConsecutiveSlashes = 0;
            }
          } else {
            break;
          }
        }
        pop(JSON.parse('"' + parsedString + '"'), stack, metaStack);
        break;
      case '[':
        arrayElement = { element: [], index: stack.length };
        stack.push(arrayElement.element);
        metaStack.push(arrayElement);
        break;
      case '{':
        objElement = { element: {}, index: stack.length };
        stack.push(objElement.element);
        metaStack.push(objElement);
        break;
      default:
        throw new Error(
          'unexpectedly reached end of input: ' + collationIndex);
    }
  }
};

},{}]},{},[1]);

//! moment.js locale configuration
//! locale : german (de)
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire

(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[Morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[Gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

}));
(function() {
    'use strict';

    angular
        .module('vvs')
        .constant("VVSI18n", {
            "de": {
                "DATETIME_FORMATS": {
                    "AMPMS": [
                        "vorm.",
                        "nachm."
                    ],
                    "DAY": [
                        "Sonntag",
                        "Montag",
                        "Dienstag",
                        "Mittwoch",
                        "Donnerstag",
                        "Freitag",
                        "Samstag"
                    ],
                    "ERANAMES": [
                        "v. Chr.",
                        "n. Chr."
                    ],
                    "ERAS": [
                        "v. Chr.",
                        "n. Chr."
                    ],
                    "FIRSTDAYOFWEEK": 0,
                    "MONTH": [
                        "Januar",
                        "Februar",
                        "M\u00e4rz",
                        "April",
                        "Mai",
                        "Juni",
                        "Juli",
                        "August",
                        "September",
                        "Oktober",
                        "November",
                        "Dezember"
                    ],
                    "SHORTDAY": [
                        "So.",
                        "Mo.",
                        "Di.",
                        "Mi.",
                        "Do.",
                        "Fr.",
                        "Sa."
                    ],
                    "SHORTMONTH": [
                        "Jan.",
                        "Feb.",
                        "M\u00e4rz",
                        "Apr.",
                        "Mai",
                        "Juni",
                        "Juli",
                        "Aug.",
                        "Sep.",
                        "Okt.",
                        "Nov.",
                        "Dez."
                    ],
                    "STANDALONEMONTH": [
                        "Januar",
                        "Februar",
                        "M\u00e4rz",
                        "April",
                        "Mai",
                        "Juni",
                        "Juli",
                        "August",
                        "September",
                        "Oktober",
                        "November",
                        "Dezember"
                    ],
                    "WEEKENDRANGE": [
                        5,
                        6
                    ],
                    "fullDate": "EEEE, d. MMMM y",
                    "longDate": "d. MMMM y",
                    "medium": "dd.MM.y HH:mm:ss",
                    "mediumDate": "dd.MM.y",
                    "mediumTime": "HH:mm:ss",
                    "short": "dd.MM.yy HH:mm",
                    "shortDate": "dd.MM.yy",
                    "shortTime": "HH:mm"
                },
                "NUMBER_FORMATS": {
                    "CURRENCY_SYM": "\u20ac",
                    "DECIMAL_SEP": ",",
                    "GROUP_SEP": ".",
                    "PATTERNS": [{
                        "gSize": 3,
                        "lgSize": 3,
                        "maxFrac": 3,
                        "minFrac": 0,
                        "minInt": 1,
                        "negPre": "-",
                        "negSuf": "",
                        "posPre": "",
                        "posSuf": ""
                    }, {
                        "gSize": 3,
                        "lgSize": 3,
                        "maxFrac": 2,
                        "minFrac": 2,
                        "minInt": 1,
                        "negPre": "-",
                        "negSuf": "\u00a0\u00a4",
                        "posPre": "",
                        "posSuf": "\u00a0\u00a4"
                    }]
                },
                "id": "de-de",
                "localeID": "de_DE",
                "pluralCat": function(n) {
                    if (n == 1) {
                        return PLURAL_CATEGORY.ONE;
                    }
                    return PLURAL_CATEGORY.OTHER;
                }
            },

            "en": {
                "DATETIME_FORMATS": {
                    "AMPMS": [
                        "AM",
                        "PM"
                    ],
                    "DAY": [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ],
                    "ERANAMES": [
                        "Before Christ",
                        "Anno Domini"
                    ],
                    "ERAS": [
                        "BC",
                        "AD"
                    ],
                    "FIRSTDAYOFWEEK": 6,
                    "MONTH": [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ],
                    "SHORTDAY": [
                        "Sun",
                        "Mon",
                        "Tue",
                        "Wed",
                        "Thu",
                        "Fri",
                        "Sat"
                    ],
                    "SHORTMONTH": [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    "STANDALONEMONTH": [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ],
                    "WEEKENDRANGE": [
                        5,
                        6
                    ],
                    "fullDate": "EEEE, MMMM d, y",
                    "longDate": "MMMM d, y",
                    "medium": "MMM d, y h:mm:ss a",
                    "mediumDate": "MMM d, y",
                    "mediumTime": "h:mm:ss a",
                    "short": "M/d/yy h:mm a",
                    "shortDate": "M/d/yy",
                    "shortTime": "h:mm a"
                },
                "NUMBER_FORMATS": {
                    "CURRENCY_SYM": "$",
                    "DECIMAL_SEP": ".",
                    "GROUP_SEP": ",",
                    "PATTERNS": [{
                        "gSize": 3,
                        "lgSize": 3,
                        "maxFrac": 3,
                        "minFrac": 0,
                        "minInt": 1,
                        "negPre": "-",
                        "negSuf": "",
                        "posPre": "",
                        "posSuf": ""
                    }, {
                        "gSize": 3,
                        "lgSize": 3,
                        "maxFrac": 2,
                        "minFrac": 2,
                        "minInt": 1,
                        "negPre": "-\u00a4",
                        "negSuf": "",
                        "posPre": "\u00a4",
                        "posSuf": ""
                    }]
                },
                "id": "en-us",
                "localeID": "en_US",
                "pluralCat": function(n) {
                    if (n == 1) {
                        return PLURAL_CATEGORY.ONE;
                    }
                    return PLURAL_CATEGORY.OTHER;
                }
            }
        });
})();

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc overview
     * @name mng-util
     * @module mng-util
     *
     * @description
     * # mng-util (utility function collection)
     * Whereas each module can provide its own utility service, the mng-util module provides utility
     * functions that are needed within multiple modules. This ensures that utility functions can
     * be maintained at a single part in the code instead of maintaining them in each single module.
     *
     * ## General usage
     * ```js
     * // inject mng-util - components only
     * angular.module('your.module', ['mng-util']);
     * ```
     *
     * ## components
     * The following list gives a short overview of the available components within this module.
     * For further details, please refer to the components themselves.
     *
     * ### {@link mng-util.service:MDVUtil MDVUtil}
     * The `MDVUtil` service offers a collection of common utility functions that are used within
     * multiple modules in the mdv-components structure. This contains for example some simple
     * string format helper functions.
     *
     * ### {@link mng-util.service:MDVUtilCoords MDVUtilCoords}
     * The `MDVUtilCoords` service offers a collection of coord utility functions that are used
     * within multiple modules in the mdv-components structure. This contains for example some
     * simple conversion functions or functions to get the distance between two points.
     *
     */
    angular.module('mng-util', []);
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-util.service:MDVUtilCoords
     *
     * @description
     * The `MDVUtilCoords` service offers a collection of coord util functions that are used within
     * multiple modules in the mdv-components structure. This contains for example some simple
     * conversion functions or functions to get the distance between two points.
     */
    angular.module('mng-util')
        .service('mng-util.MDVUtilCoords', MDVUtilCoords);

    MDVUtilCoords.$inject = ['mng-util.MDVLog'];

    function MDVUtilCoords(MDVLog) {
        var log = MDVLog.register('mng-util.MDVUtilCoords'),
            util = {
                bearing : bearing,
                distance : distance
            };

        log.debug('initialize');

        // ////////////////////////////////

    //    /**
    //     * @ngdoc method
    //     * @name deg2rad
    //     * @description
    //     * The method converts the argument value to radians
    //     * @private
    //     * @methodOf mng-util.service:MDVUtilCoords
    //     * @param {float} deg degree value
    //     * @returns {float} radian value
    //     */
        function deg2rad(deg) {
            return deg * (Math.PI / 180);
        }
    //    /**
    //     * @ngdoc method
    //     * @name rad2deg
    //     * @description
    //     * The method converts the argument value to degree
    //     * @private
    //     * @methodOf mng-util.service:MDVUtilCoords
    //     * @param {float} rad radian value
    //     * @returns {float} degree value
    //     */
        function rad2deg(rad) {
            return rad * 180 / Math.PI;
        }

        function isInvalid(coord_part) {
            // 2147483647 = EFA intmax
            return !coord_part || parseInt(coord_part, 10) === 2147483647;
        }
        /**
         * @public
         * @ngdoc method
         * @methodOf mng-util.service:MDVUtilCoords
         * @name distance
         *
         * @description
         * The method calculates great-circle distances between the two coordinates
         *
         * @param {float} lat1 latitude coordinate 1
         * @param {float} lng1 longitude coordinate 1
         * @param {float} lat2 latitude coordinate 2
         * @param {float} lng2 longitude coordinate 2
         * @returns {float} distance between two coordinates in meter
         */
        function distance(lat1, lng1, lat2, lng2) {
            // invalid coord or identical coordinates
            if (isInvalid(lat1) || isInvalid(lng1) || isInvalid(lat2) || isInvalid(lng2) ||
                    (lat1 === lat2 && lng1 === lng2)) {
                return 0;
            }
            if (lat1 < 180 && lng1 < 180 && lat2 < 180 && lng2 < 180) {
                // assume coordinates are WGS84
                var R = 6371000,
                    dLat = deg2rad(lat2 - lat1),
                    dLng = deg2rad(lng2 - lng1),
                    a = (Math.sin(dLat / 2) * Math.sin(dLat / 2)) +
                        (Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
                        Math.sin(dLng / 2) * Math.sin(dLng / 2)),
                    c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)),
                    d = R * c;

                return d;
            }
            // assume coordinates are meter based
            return pythagoras(lat1, lng1, lat2, lng2);
        }

        function pythagoras(lat1, lng1, lat2, lng2) {
            var a = lat1 - lat2,
                b = lng1 - lng2;

            return Math.sqrt((a * a) + (b * b));
        }
        /**
         * @public
         * @ngdoc method
         * @methodOf mng-util.service:MDVUtilCoords
         * @name bearing
         *
         * @description
         * The method calculates the bearing between the two coordinates in direction coord1 to
         * coord2
         *
         * @param {float} lat1 latitude coordinate 1
         * @param {float} lng1 longitude coordinate 1
         * @param {float} lat2 latitude coordinate 2
         * @param {float} lng2 longitude coordinate 2
         * @returns {float} bearing [0-360] between two coordinates
         */
        function bearing(lat1, lng1, lat2, lng2) {
            if (!lat1 || !lng1 || !lat2 || !lng2) {
                return 0;
            }
            var dLng = deg2rad(lng2 - lng1),
                dlat1 = deg2rad(lat1),
                dlat2 = deg2rad(lat2),
                y = Math.sin(dLng) * Math.cos(dlat2),
                x = (Math.cos(dlat1) * Math.sin(dlat2)) -
                                               (Math.sin(dlat1) * Math.cos(dlat2) * Math.cos(dLng)),
                brng = rad2deg(Math.atan2(y, x));

            return (brng + 360) % 360;
        }

        return util;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-util.service:MDVUtil
     * @requires mng-util.service:MDVLog
     *
     * @description
     * The `MDVUtil` service offers a collection of commun util functions that are used within
     * multiple modules in the mdv-components structure. This contains for example some simple
     * string format helper functions.
     */
    angular.module('mng-util')
        .factory('mng-util.MDVUtil', MDVUtil);

    MDVUtil.$inject = ['$q', 'mng-util.MDVLog'];

    function MDVUtil($q, MDVLog) {
        var log = MDVLog.register('mng-util.MDVUtil'),
            util = {
                getSubValue : getSubValue,
                getRejectedDeferred : getRejectedDeferred,
                getResolvedDeferred : getResolvedDeferred,
                isValidCoordinate : isValidCoordinate,
                pad : pad,
                copy : copy
            };

        log.debug('initialize');

        // ////////////////////////////////

    //    /**
    //     * @private
    //     * @ngdoc method
    //     * @name getSubKeys
    //     * @description
    //     * Extract the first part of a given key and return the two parts.
    //     * Example : 'abc.def.ghi' -> ['abc', 'def.ghi']
    //     * @methodOf mng-util.service:MDVUtil
    //     * @param {String} key - Key in format 'abc.def.ghi'
    //     * @returns {String[]} Array with two elements, the extracted key and the rest of
    //     * the original key
    //     */
        function getSubKeys(key) {
            var curr_key,
                point_index = key.indexOf('.');

            if (point_index === -1) {
                // no subelements in key, use key directly for config search
                return [key, ''];
            }
            // subelement needed
            curr_key = key.slice(0, point_index);
            key = key.slice(point_index + 1);
            return [curr_key, key];
        }
        /**
         * @public
         * @ngdoc method
         * @methodOf mng-util.service:MDVUtil
         * @name getSubValue
         *
         * @description
         * Get a value / subtree out of a given tree. The tree describes a JavaScript object with
         * multiple hierarchy levels:
         *
         * ```js
         * {
         *    "main_level_A" : {
         *        "first_sublevel_A" : {
         *            "second_sublevel_A" : "mainA_subA_valueA",
         *            "second_sublevel_B" : "mainA_subA_valueB"
         *        },
         *        "first_sublevel_B" : {
         *            "second_sublevel_A" : "mainA_subB_valueA"
         *        }
         *    },
         *    ...
         * }
         * ```
         *
         * With this method you can access subtrees or values with a specific key value.
         *
         * @example
       <example module="getSubValueExample">
         <file name="script.js">
           angular.module('getSubValueExample', ['mng-util'])
             .controller('UtilController', ['$scope', 'mng-util.MDVUtil',
             function($scope, MDVUtil) {
               var tree = {
                   "mainA" : {
                       "subA" : {
                           "subsubA" : "mainA_subA_valueA",
                           "subsubB" : "mainA_subA_valueB"
                       },
                       "subB" : {
                           "subsubC" : "mainA_subB_valueC"
                       }
                   }
               };
               $scope.result = null;
               $scope.key = 'mainA.subA.subsubB';
               $scope.updateResult = function () {
                    // call utility function
                    $scope.result = MDVUtil.getSubValue($scope.key, tree);
               }
               // initial update
               $scope.updateResult();
             }]);
         </file>
         <file name="index.html">
           <div ng-controller="UtilController">
             <input type="text" ng-model="key" ng-change="updateResult()"/><br/>
             {{result}}
           </div>
         </file>
       </example>
         *
         * @param {String} key - Key for the subpart of the tree
         * @param {Object} subtree - Tree the subtree with the given key should be extracted
         * from
         * @returns {Object} the requested value/ subtree, or null if the key could not be
         * resolved correctly. whole subtree if empty string is passed as key
         */
        function getSubValue(key, subtree) {
            if (!key) {
                return subtree;
            }
            var keys = getSubKeys(key);

            if (!subtree.hasOwnProperty(keys[0])) {
                return null;
            }
            return getSubValue(keys[1], subtree[keys[0]]);
        }
        /**
         * @public
         * @ngdoc method
         * @methodOf mng-util.service:MDVUtil
         * @name pad
         *
         * @description
         * Pads value with leading zeros. Tries to coerce the value to a string if necessary.
         *
         * @example
       <example module="padExample">
         <file name="script.js">
           angular.module('padExample', ['mng-util'])
             .controller('UtilController', ['$scope', 'mng-util.MDVUtil',
             function($scope, MDVUtil) {
               $scope.result = null;
               $scope.input = '1';
               $scope.max = '2';
               $scope.updateResult = function () {
                    // call util function
                    $scope.result = MDVUtil.pad($scope.input, $scope.max);
               }
               // initial update
               $scope.updateResult();
             }]);
         </file>
         <file name="index.html">
           <div ng-controller="UtilController">
             <label>str: <input type="text" ng-model="input" ng-change="updateResult()"/></label>
             <label>max: <input type="text" ng-model="max" ng-change="updateResult()"/></label>
             {{result}}
           </div>
         </file>
       </example>
         *
         * @param {Integer|String} str The value to pad
         * @param {Integer} [max=2] The maximum length of the resulting string
         * @returns {String} The (padded) value
         */
        function pad(str, max) {
            var s = (typeof str === 'string') ? str : str.toString(),
                m = max || 2;

            return s.length < m ? pad('0' + s, m) : s;
        }

        /**
         * @public
         * @ngdoc method
         * @methodOf mng-util.service:MDVUtil
         * @name getRejectedDeferred
         * @param {Object} error Error object that should be added to the rejection
         * @returns {Deferred} a rejected deferred
         *
         * @description
         * Get a promise that is already rejected. This method can be used to return promises that
         * are not able to be rejected, as they are yet created, as preleading tests failed.
         *
         */
        function getRejectedDeferred(error) {
            var deferred = $q.defer();

            deferred.reject(error);
            return deferred.promise;
        }

        /**
         * @public
         * @ngdoc method
         * @methodOf mng-util.service:MDVUtil
         * @name getResolvedDeferred
         * @param {Object} data Data object the promise should be resolved with
         * @returns {Deferred} a resolved deferred
         *
         * @description
         * Get a promise that is already resolved. This method can be used to return cached data in
         * the usual deferred way.
         *
         */
        function getResolvedDeferred(data) {
            var deferred = $q.defer();

            deferred.resolve(data);
            return deferred.promise;
        }
        /**
         * @public
         * @ngdoc method
         * @methodOf mng-util.service:MDVUtil
         * @name copy
         * @param {Object} data Data object that should be copied. This object needs to be a plain
         * JSON object and must not contain functions.
         * @returns {Object} a deep copy of the passed object without references
         *
         * @description
         * Copy a passed element.
         *
         */
        function copy(data) {
            if (data === undefined) {
                return undefined;
            }
            if (data === null) {
                return null;
            }
            try {
                return JSON.parse(JSON.stringify(data));
            } catch (e) {
                log.error(e);
                // fallback to unperformant copy
                return angular.copy(data);
            }
        }
        /**
         * @public
         * @ngdoc method
         * @methodOf mng-util.service:MDVUtil
         * @name isValidCoordinate
         * @param {Object} input input to be checked
         * @returns {Boolean} true: input is a valid coordinate, false otherwise
         *
         * @description
         * Check if given input is a coordinate value.
         *
         */
        function isValidCoordinate(input) {
            return (input.lat && input.lng) ||
                (input.constructor === Array && input.length >= 2);
        }

        return util;
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-util.service:MDVLog
     * @requires $log
     *
     * @description
     * This `MDVLog` service extends AngularJs's {@link
     * https://docs.angularjs.org/api/ng/service/$log $log} service. This extension allows
     * different kind of log levels with a pre-defined log numbers.
     * Log level reference:
     * - **0 : debug** *($log.debug)*. Just about everything that doesn't make the "info" cut... any
     * message that is helpful in tracking the flow through the system and isolating
     * issues, especially during the development and QA phases. We use "debug" level
     * logs for entry/ exit of most non-trivial methods and marking interesting events
     * and decision points inside methods.
     * - **1 : information** *($log.info)*. Things we want to see at high volume in case we need to
     * forensically analyze an issue. System life cycle events (system start, stop) go
     * here. "Session" life cycle events (login, logout, etc.) go here. Significant
     * boundary events should be considered as well (e.g. database calls, remote API
     * calls). Typical business exceptions can go here (e.g. login failed due to bad
     * credentials). Any other event you think you'll need to see in production at high
     * volume goes here.
     * - **2 : warning** *($log.warn)*. an unexpected technical or business event happened, customers
     * may be affected, but probably no immediate human intervention is required. On
     * call people won't be called immediately, but support personnel will want to
     * review these issues asap to understand what the impact is. Basically any issue
     * that needs to be tracked but may not require immediate intervention.
     * - **3 : error** *error ($log.error)*. The system is in distress, customers are probably being
     * affected (or will soon be) and the fix probably requires human intervention. The "2AM
     * rule" applies here- if you're on call, do you want to be woken up at 2AM if this
     * condition happens? If yes, then log it as "error".
     *
     * The `MDVLog` also provides methods to enable/ disable logging and an additional cache of all
     * previous log messages up to a configured limit. Every module can register with a specific
     * name (module-name) to allow the logger to prefix all log messages with the registered name,
     * whenever the module logs messages.
     *
     * # General usage
     * The usual way to use the `MDVLog` is to register the module that uses the log instance with
     * the model name and use the provided {@mng-util.service:MDVLogObject MDVLogObject} to log
     * messages.
     *
     * ```js
     *   // register current module
     *   var log = MDVLog.register('documentation.Example');
     *   // logs (in warning color):
     *   // documentation.Example - this is a warning
     *   log.warn('this warning')
     * ```
     *
     * # Enable/ Disable logging
     * The logger can be enabled/ disabled. The best way to do so, is on startup of your
     * application. The logging is enabled per default.
     *
     * ```js
     *  angular.module('yourModule')
     *     .run(['mng-util.MDVLog', function (MDVLog) {
     *          // disable logging for the whole application.
     *          MDVLog.disable();
     *     }]);
     * ```
     *
     *
     * # Configuration
     *
     * **Note:** *The logger cannot be configured dynamically yet. Default settings only*
     *
     * This service cannot be configured by the {@link mng-config.service:MDVConfig MDVConfig}
     * service. The configuration needs to be set with setter functions instead.
     * The following configurations are available for the `MDVLog`-service.
     *
     * ## {Number} maxLength *(optional. default: 1000)*
     * Maximal length of the log-cache. Whenever the cache gets bigger than the maximal length, the
     * oldest log message is removed. This ensures that the cache does not cause memory leaks.
     *
     * ## {Boolean} enabled *(optional. default: true)*
     * Enable/ disable the log per default. The log can also be enabled/ disabled dynamically with
     * the use of the corresponding methods.
     *
     * ## {Boolean} consoleLog *(optional. default: true)*
     * Enable/ disable the logging to the console. Right now this is the only method to log messages,
     * so it is activated per default. When another method (server logs) is implemented, this option
     * might be disabled while the new method is enabled. Multiple methods should be possible, too.
     *
     * ## {Number} minType *(optional. default: 0)*
     * Minimum level that displays notification. All events with type >= minType are displayed.
     *
     * Example:
     *
     * minType = 0 -> all messages with type debug or higher are displayed
     *
     * @example
       <example module="logExample">
         <file name="script.js">
           angular.module('logExample', ['mng-util'])
             .controller('LogController', ['$scope', 'mng-util.MDVLog', function($scope, MDVLog) {
               $scope.logger = MDVLog.register('LogController');
               $scope.message = 'Hello World!';
             }]);
         </file>
         <file name="index.html">
           <div ng-controller="LogController">
             <p>Reload this page with open console, enter text and hit the log button...</p>
             <label>Message:
             <input type="text" ng-model="message" /></label>
             <button ng-click="logger.debug(message)">debug</button>
             <button ng-click="logger.warn(message)">warn</button>
             <button ng-click="logger.info(message)">info</button>
             <button ng-click="logger.error(message)">error</button>
           </div>
         </file>
       </example>
     */
    angular.module('mng-util')
        .factory('mng-util.MDVLog', MDVLog);

    MDVLog.$inject = ['$log', 'mng-util.log-config'];

    function MDVLog($log, config) {
        var logs = [],
            console_log_minType = config.level,
            maxLength = config.maxLength,
            log_active = config.enabled,
            console_log_active = config.consoleEnabled,
            throw_error_logs = config.throwErrorLogs;


        function cleanLog() {
            if (logs.length >= maxLength) {
                logs.splice(-1, 1);
            }
        }

        function addErrorLog(msg) {
            if (throw_error_logs) {
                throw msg;
            } else {
                $log.error(msg);
            }
        }
    //    /**
    //     * @private
    //     * @ngdoc method
    //     * @name addLog
    //     * @description
    //     * Add a log message to the internal log array.
    //     * @methodOf mng-util.service:MDVLog
    //     * @param {String} message Message that should be added to the log
    //     * @param {Integer} level Log level the message should be assigned to
    //     */
        function addLog(msg, level) {
            if (!msg) {
                return;
            }
            level = level || 0;  // default to debug
            logs.unshift({
                text : msg,
                lvl : level,
                time : new Date()
            });
            if (console_log_active && console_log_minType <= level) {
                if (level >= 3) {
                    addErrorLog(msg);
                } else if (level >= 2) {
                    $log.warn(msg);
                } else if (level >= 1) {
                    $log.info(msg);
                } else {
                    $log.debug(msg);
                }
            }
            cleanLog();
        }

        return {
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-util.service:MDVLog
             * @name register
             *
             * @description
             * Register a log-object that logs all messages with the provided name-space.
             *
             * @param {String} namespace Name-space that should be used for the logging
             * @returns {MDVLogObject} individual {@link mng-util.service:MDVLogObject
             * MDVLogObject} object that can be used for logging
             */
            register : function(namespace) {
                var prefix_val = '';

                if (namespace) {
                    prefix_val = namespace + ' - ';
                }
                /**
                 * @ngdoc object
                 * @name mng-util.service:MDVLogObject
                 *
                 * @description
                 * By registering at the {@link mng-util.service:MDVLog MDVLog}-service, a
                 * `MDVLogObject` is returned. This object provides all kind of normal log methods
                 * as known from AngularJs's {@link https://docs.angularjs.org/api/ng/service/$log
                 * $log}-service.
                 *
                 * # General usage
                 * Please refer to the {@link mng-util.service:MDVLog MDVLog}-service
                 * documentation for any further information.
                 */
                return {
                    prefix : prefix_val,
                    /**
                     * @public
                     * @ngdoc method
                     * @methodOf mng-util.service:MDVLogObject
                     * @name add
                     *
                     * @description
                     * Add a new log message with a certain log level
                     *
                     * @param {String} msg Message that should be logged
                     * @param {Number=} [level=0] Priority level. Defaults to debug level.
                     * @param {Boolean} [withoutPrefix=false] Log plain message without adding a
                     * prefix.
                     */
                    add : function(msg, level, withoutPrefix) {
                        if (log_active) {
                            if (withoutPrefix) {
                                addLog(msg, level || 0);
                            } else {
                                addLog(this.prefix + msg, level || 0);
                            }
                        }
                    },
                    /**
                     * @public
                     * @ngdoc method
                     * @methodOf mng-util.service:MDVLogObject
                     * @name debug
                     *
                     * @description
                     * Add a debug log message.
                     *
                     * @param {String} msg Message that should be logged
                     * @param {Boolean} plain Do not add any prefixes and log unstringified message
                     */
                    debug : function(msg, plain) {
                        this.add(msg, 0, plain);
                    },
                    /**
                     * @public
                     * @ngdoc method
                     * @methodOf mng-util.service:MDVLogObject
                     * @name info
                     *
                     * @description
                     * Add a info log message.
                     *
                     * @param {String} msg Message that should be logged
                     * @param {Boolean} plain Do not add any prefixes and log unstringified message
                     */
                    info : function(msg, plain) {
                        this.add(msg, 1, plain);
                    },
                    /**
                     * @public
                     * @ngdoc method
                     * @methodOf mng-util.service:MDVLogObject
                     * @name warn
                     *
                     * @description
                     * Add a warn log message.
                     *
                     * @param {String} msg Message that should be logged
                     * @param {Boolean} plain Do not add any prefixes and log unstringified message
                     */
                    warn : function(msg, plain) {
                        this.add(msg, 2, plain);
                    },
                    /**
                     * @public
                     * @ngdoc method
                     * @methodOf mng-util.service:MDVLogObject
                     * @name error
                     *
                     * @description
                     * Add a error log message.
                     *
                     * @param {String} msg Message that should be logged
                     * @param {Boolean} plain Do not add any prefixes and log unstringified message
                     */
                    error : function(msg, plain) {
                        this.add(msg, 3, plain);
                    }
                };
            },
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-util.service:MDVLog
             * @name get_all
             *
             * @description
             * Get all logs (latest first) that were added before.
             *
             * @returns {String[]} log messages
             */
            get_all : function() {
                return logs;
            },
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-util.service:MDVLog
             * @name enable
             * @param {Number} [logLevel=0] minimum log-level that should be logged in the console.
             * Range: 0 (debug) - 3 (error). passing values >= 4 equals disabling the whole logging.
             *
             * @description
             * Enable console logs. Logs are enabled per default. This method is only needed if the
             * logs were disabled.
             */
            enable : function(logLevel) {
                log_active = true;
                console_log_minType = logLevel;
                addLog('Logger enabled', 1);
            },
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-util.service:MDVLog
             * @name disable
             *
             * @description
             * Disable console logs. Prevent the logger from logging messages.
             */
            disable : function() {
                addLog('Logger disabled', 1);
                log_active = false;
            }
        };
    }
}());

(function() {
    'use strict';

    angular.module('mng-util')
        .directive('mngLogOutput', mngLog);

    mngLog.$inject = ['mng-util.MDVLog'];

    function mngLog(MDVLog) {
        return {
            restrict : 'E',
            // scope : {},
            template : '<table> ' +
                ' <thead> ' +
                '    <tr>' +
                '     <th>Time</th>' +
                '     <th>Level</th>' +
                '     <th>Message</th>' +
                '    </tr>' +
                ' </thead>' +
                ' <tbody>' +
                '    <tr ng-repeat="log in logs track by $index">' +
                '        <td>{{log.time | amDateFormat:"DD.MM.YYYY, HH:mm:ss"}}</td>' +
                '        <td>{{log.lvl}}</td>' +
                '        <td>{{log.text}}</td>' +
                '    </tr>' +
                ' </tbody>' +
                ' </table>',
            controller : function($scope) {
                $scope.logs = MDVLog.get_all();
            }
        };
    }
}());

(function() {
    'use strict';

    angular.module('mng-util')
        .constant('MDVExceptionConstants', {
            'MNG__USER' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG__USER$BROWSER_DOES_NOT_SUPPORT_GEOLOCATION
                 * @description
                 * Error when the browser does not support geolocation feature
                 */
                'BROWSER_DOES_NOT_SUPPORT_GEOLOCATION' : {
                    name : '_no_geolocation_',
                    code : 1250
                }
            },
            'MNG__PROGRAMM' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG__PROGRAMM$INVALID_ERROR_KEY
                 * @description
                 * Error when no or an invalid key for MDVExceptionConstants provided
                 */
                'INVALID_ERROR_KEY' : {
                    name : '_invalid_error_key_',
                    code : 1301
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG__PROGRAMM$NO_CONFIG
                 * @description
                 * Error when an error occurred in the configuration
                 */
                'NO_CONFIG' : {
                    name : '_no_config_',
                    code : 1302
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG__PROGRAMM$INVALID_CONFIG
                 * @description
                 * Error when an error occurred in the configuration
                 */
                'INVALID_CONFIG' : {
                    name : '_invalid_config_',
                    code : 1303
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG__PROGRAMM$INVALID_PARAMETERS
                 * @description
                 * Error when either no or an invalid parameters passed to an object constructor
                 */
                'INVALID_PARAMETERS' : {
                    name : '_invalid_parameters_',
                    code : 1320
                },
                'MISSING_PERSISTENCE_FUNCTIONALITY' : {
                    name : '_no_persistance_',
                    code : 1
                }
            },
            'MNG__REQUESTS' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG__REQUESTS$REQUEST_FAILED
                 * @description
                 * Error when request failed
                 */
                'REQUEST_FAILED' : {
                    name : '_request_failed_',
                    code : 1401
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG__REQUESTS$EMPTY_DATA
                 * @description
                 * Error when request was successful, but no data received
                 */
                'EMPTY_DATA' : {
                    name : '_empty_data_',
                    code : 1410
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG__REQUESTS$EMPTY_DATA
                 * @description
                 * Error when request was successful, but the data received was invalid
                 */
                'INVALID_DATA' : {
                    name : '_invalid_data_',
                    code : 1411
                }
            },
            'MNG_COMM__AST' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__AST$SERVICE_FAILED
                 * @description
                 * Information when the ast service return a non valid response or a response with
                 * error message.
                 */
                'SERVICE_FAILED' : {
                    name : '_services_failed_',
                    code : 2102
                }
            },
            'MNG_COMM__LS' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__LS$NO_SERVICE
                 * @description
                 * Error when no stop-finder service available to resolve a given input
                 */
                'NO_SERVICE' : {
                    name : '_no_service_',
                    code : 2101
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__LS$SERVICE_FAILED
                 * @description
                 * Information when all stop-finder services were not able to resolve given input
                 */
                'SERVICE_FAILED' : {
                    name : '_services_failed_',
                    code : 2102
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__LS$INVALID_INPUT
                 * @description
                 * Warning when the provided input has an invalid format
                 */
                'INVALID_INPUT' : {
                    name : '_invalid_input_',
                    code : 2111
                }
            },
            'MNG_COMM__DM' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__DM$NO_SERVICE
                 * @description
                 * Error when no departure service is available to fetch lists for a given location
                 */
                'NO_SERVICE' : {
                    name : '_no_service_',
                    code : 2201
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__DM$SERVICE_FAILED
                 * @description
                 * Information when all departure services weren't able to resolve given input
                 */
                'SERVICE_FAILED' : {
                    name : '_services_failed_',
                    code : 2202
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__DM$NO_INPUT
                 * @description
                 * Error when a search for departures is desired but with missing location
                 */
                'NO_INPUT' : {
                    name : '_no_input_',
                    code : 2210
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__DM$INVALID_INPUT
                 * @description
                 * Error when a search for departures is desired but the locationis missing
                 */
                'INVALID_INPUT' : {
                    name : '_input_invalid_',
                    code : 2211
                }
            },
            'MNG_COMM__JOURNEY' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__JOURNEY$NO_SERVICE
                 * @description
                 * Error when no journey service is available to fetch lists for a given location
                 */
                'NO_SERVICE' : {
                    name : '_no_service_',
                    code : 2301
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__JOURNEY$SERVICE_FAILED
                 * @description
                 * Information when no journey service was able to resolve the given input
                 */
                'SERVICE_FAILED' : {
                    name : '_services_failed_',
                    code : 2302
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__JOURNEY$NO_ORIGIN
                 * @description
                 * Error when the search for a journey is desired but with missing origin location
                 */
                'NO_ORIGIN' : {
                    name : '_no_origin_',
                    code : 2310
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__JOURNEY$NO_ORIGIN
                 * @description
                 * Error when the search for  journey is desired but with missing origin location
                 */
                'INVALID_ORIGIN' : {
                    name : '_invalid_origin_',
                    code : 2311
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__JOURNEY$NO_ORIGIN
                 * @description
                 * Error when the search for a journey is desired but with missing origin location
                 */
                'NO_DESTINATION' : {
                    name : '_no_destination_',
                    code : 2312
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__JOURNEY$NO_ORIGIN
                 * @description
                 * Error when the search for a journey is desired but with missing origin location
                 */
                'INVALID_DESTINATION' : {
                    name : '_invalid_destination_',
                    code : 2313
                }
            },
            'MNG_COMM__INFO' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__INFO$NO_SERVICE
                 * @description
                 * Error when no information service available to fetch lists of current information
                 */
                'NO_SERVICE' : {
                    name : '_no_service_',
                    code : 2401
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__INFO$SERVICE_FAILED
                 * @description
                 * Error when all information services were not able to fetch a list of information
                 */
                'SERVICE_FAILED' : {
                    name : '_services_failed_',
                    code : 2402
                }
            },
            'MNG_COMM__GEOLOC' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__GEOLOC$NO_SERVICE
                 * @description
                 * Error when no information service available to fetch lists of current information
                 */
                'NO_SERVICE' : {
                    name : '_no_service_',
                    code : 2501
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__GEOLOC$SERVICE_FAILED
                 * @description
                 * Error when all information services were not able to fetch a list of information
                 */
                'SERVICE_FAILED' : {
                    name : '_services_failed_',
                    code : 2502
                }
            },
            'MNG_COMM__TTB' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__TTB$NO_SERVICE
                 * @description
                 * Error when no TTB service available
                 */
                'NO_SERVICE' : {
                    name : '_no_service_',
                    code : 2601
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__TTB$SERVICE_FAILED
                 * @description
                 * Error when all TTB services were not able to fetch a STT file.
                 */
                'SERVICE_FAILED' : {
                    name : '_services_failed_',
                    code : 2602
                }
            },
            'MNG_COMM__ROP' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__ROP$NO_SERVICE
                 * @description
                 * Error when no ROP service available
                 */
                'NO_SERVICE' : {
                    name : '_no_service_',
                    code : 2701
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__ROP$SERVICE_FAILED
                 * @description
                 * Error when all ROP services were not able to fetch a ROP file.
                 */
                'SERVICE_FAILED' : {
                    name : '_services_failed_',
                    code : 2702
                }
            },
            'MNG_COMM__STT' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__STT$NO_SERVICE
                 * @description
                 * Error when no STT service available
                 */
                'NO_SERVICE' : {
                    name : '_no_service_',
                    code : 2801
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__STT$SERVICE_FAILED
                 * @description
                 * Error when all STT services were not able to fetch a STT file.
                 */
                'SERVICE_FAILED' : {
                    name : '_services_failed_',
                    code : 2802
                }
            },
            'MNG_COMM__PS' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__PS$NO_SERVICE
                 * @description
                 * Error when no PS service available
                 */
                'NO_SERVICE' : {
                    name : '_no_service_',
                    code : 2901
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__PS$SERVICE_FAILED
                 * @description
                 * Error when all PS services were not able to fetch a PS file.
                 */
                'SERVICE_FAILED' : {
                    name : '_services_failed_',
                    code : 2902
                }
            },
            'MNG_COMM__DOWNLOAD' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__DOWNLOAD$NO_SERVICE
                 * @description
                 * Error when no download service available for a specified downloadType
                 */
                'NO_SERVICE' : {
                    name : '_no_service_',
                    code : 3001
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__DOWNLOAD$SERVICE_FAILED
                 * @description
                 * Error when all downloads services were not able to fetch a file.
                 */
                'SERVICE_FAILED' : {
                    name : '_services_failed_',
                    code : 3002
                }
            },
            'MNG_COMM__LIVE_POSITIONS' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__LIVE_POSITIONS$NO_SERVICE
                 * @description
                 * Error when no livePosition service available to resolve a given input
                 */
                'NO_SERVICE' : {
                    name : '_no_service_',
                    code : 3101
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__LIVE_POSITIONS$SERVICE_FAILED
                 * @description
                 * Information when all livePositions services were not able to resolve given input
                 */
                'SERVICE_FAILED' : {
                    name : '_services_failed_',
                    code : 3102
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__LIVE_POSITIONS$INVALID_INPUT
                 * @description
                 * Warning when the provided input has an invalid format
                 */
                'INVALID_INPUT' : {
                    name : '_invalid_input_',
                    code : 3111
                }
            },
            'MNG_COMMON' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMMON$NO_DATA
                 * @description
                 * Error when journey object is missing in the derective declaration in HTML.
                 */
                'NO_DATA' : {
                    name : '_no_data_',
                    code : 3201
                }
            },
            'MNG_COMM__STOPSEQ' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__STOPSEQ$NO_SERVICE
                 * @description
                 * Error when no stopSeqCoord service available to fetch lists of stopSeq
                 */
                'NO_SERVICE' : {
                    name : '_no_service_',
                    code : 3201
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__STOPSEQ$SERVICE_FAILED
                 * @description
                 * Information when all stopSeqCoord services were not able to resolve given input
                 */
                'SERVICE_FAILED' : {
                    name : '_services_failed_',
                    code : 3202
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__STOPSEQ$NO_INPUT
                 * @description
                 * Error when a search for stopSeq is desired but with missing location/line
                 */
                'NO_INPUT' : {
                    name : '_no_input_',
                    code : 3210
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG_COMM__STOPSEQ$INVALID_INPUT
                 * @description
                 * Error when a search for stopSeq is desired but with invalid location/line
                 */
                'INVALID_INPUT' : {
                    name : '_input_invalid_',
                    code : 3211
                }
            },
            'MNG__PERSONALIZATION' : {
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG__PERSONALIZATION$NO_SERVICE
                 * @description
                 * Error when no personalization service available
                 */
                'NO_SERVICE' : {
                    name : '_no_service_',
                    code : 3301
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG__PERSONALIZATION$REGISTRATION_FAILED
                 * @description
                 * When for example the user try to register with already used Username
                 */
                'REGISTRATION_FAILED' : {
                    name : '_services_failed_',
                    code : 3302
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG__PERSONALIZATION$REGISTRATION_INVALID_INPUT
                 * @description
                 * Error when a registration is desired but with invalid data
                 */
                'REGISTRATION_INVALID_INPUT' : {
                    name : '_input_invalid_',
                    code : 3303
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG__PERSONALIZATION$LOGIN_INVALID_INPUT
                 * @description
                 * Error when a login is desired but with invalid data
                 */
                'LOGIN_INVALID_INPUT' : {
                    name : '_input_invalid_',
                    code : 3304
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG__PERSONALIZATION$PASSWORD_RESETTING_INVALID_INPUT
                 * @description
                 * Error when a Password-Reset is desired but with invalid data
                 */
                'PASSWORD_RESETTING_INVALID_INPUT' : {
                    name : '_input_invalid_',
                    code : 3305
                },
                /**
                 * @ngdoc property
                 * @propertyOf mng-util.object:MDVException
                 * @name MNG__PERSONALIZATION$PASSWORD_RESETTING_INVALID_INPUT
                 * @description
                 * Error when a Password-Reset is desired but with invalid data
                 */
                'PASSWORD_RESETTING_FAILED' : {
                    name : '_input_invalid_',
                    code : 3306
                }
            }
        });

}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @constructor
     * @ngdoc object
     * @name mng-util.object:MDVException
     * @requires MDVExceptionConstants
     * @requires mng-util.service:MDVLog
     * @requires mng-util.service:MDVUtil
     *
     * @description
     * The `MDVException` object describes an internal exception object, that will be shared
     * between all mdv-components. It ensures that every exception thrown by the mdv-components
     * behaves in the same way and provides the same information/ attributes in the same structure
     * instead of multiple event objects or error strings.
     *
     * In order to create your own MDVException refer to the exception keys, described as
     * properties below. Please note that the '$' sign needs to be replaced by a '.' in your code.
     *
     * ```js
     * // throw an exception if invalid parameters are passed to a constructor function
     * throw new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_PARAMETERS, {
     *     reason : 'you did it wrong'
     * });
     * ```
     *
     * The error shows up in the console, provides a call-stack and looks like this:
     * ```js
     * filename.js:linnumber Uncaught _invalid_parameters_: 1320 _invalid_parameters_
     * reason:you did it wrong
     * ```
     *
     * **Note:** *The list of exception codes is not yet finished, the exception codes can change in
     * the future without any notice in the documentation. To get the latest list of exception
     * definitions, refer to the mng-util/src/exception/mng.util.MDVExceptionConstants.js file,
     * use the constant called MDVExceptionConstants in the mng-util module or use a reference to
     * these constants via the key property of the MDVException factory as shown in the example
     * above.*
     *
     * @param {Object} notificationDef Normalized properties that describe the object
     * @param {Object} [data={}] Additional data that should be added to the notification object
     * @returns {mng-util.object:MDVException} Object instance or null if either no or an invalid
     * error key is passed.
     */
    angular.module('mng-util')
        .factory('mng-util.MDVException', MDVExceptionFactory);

    MDVExceptionFactory.$inject = ['MDVExceptionConstants', 'mng-util.MDVLog'];

    function MDVExceptionFactory(MDVExceptionConstants, MDVLog) {
        var log = MDVLog.register('mng-util.MDVException'),
            Intermediate;

        log.debug('initialize');
        // see http://stackoverflow.com/
        //          questions/8802845/inheriting-from-the-error-object-where-is-the-message-property
        function MDVException(notificationDef, notificationData) {
            if (!notificationDef) {
                return null;
            }

            var error_string = notificationDef.code + ' ' + notificationDef.name,
                tmp_error;

            if (notificationData) {
                error_string += ' ' + stringifyData(notificationData);
                this.data = notificationData;
            }

            tmp_error = Error.call(this, error_string);

            tmp_error.name = this.name = notificationDef.name;
            this.message = tmp_error.message;
            this.code = notificationDef.code;
            // add stack trace
            Object.defineProperty(this, 'stack', {
                get : function() {
                    return tmp_error.stack;
                }
            });

            function stringifyData(data) {
                if (typeof data === 'string') {
                    return data;
                }
                var key,
                    result = '';

                for (key in data) {
                    if (data.hasOwnProperty(key) && data[key]) {
                        result += key + ':' + data[key].toString() + ' ';
                    }
                }
                return result.trim();
            }
            return this;
        }

        Intermediate = function() {
            return this;
        };

        Intermediate.prototype = Error.prototype;
        MDVException.prototype = new Intermediate();
        MDVException.prototype.constructor = MDVException;

        // make keys available via constructor to avoid the need to inject MDVException and
        // MDVExceptionConstants each time an error is created within a service.
        MDVException.keys = MDVExceptionConstants;

        return MDVException;
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc overview
     * @name mng-favorite
     * @module mng-favorite
     * @requires pouchdb
     * @requires mng-persistence
     * @requires mng-util
     *
     * @description
     * # mng-favorite (favorite handling)
     * This module handles all kind of favorites and their additional functionality, as well as
     * store favorites by the use of the persistence module.
     *
     * ## General usage
     * ```js
     * // inject mng-favorite - components only
     * angular.module('your.module', ['mng-favorite']);
     * ```
     *
     * ## components
     * The following list gives a short overview of the available components within this module.
     * For further details, please refer to the components themselves.
     *
     * ### {@link mng-favorite.service:MDVLocationFavorite MDVLocationFavorite}
     * The `MDVLocationFavorite` is used to get/edit/add and remove the {@link mng-model.object:MDVLocation
     * MDVLocation} saved as Favorite in the Database.
     *
     * ### {@link mng-favorite.service:MDVJourneyFavorite MDVJourneyFavorite}
     *
     * The `MDVJourneyFavorite` is used to get/edit/add and remove the {@link mng-model.object:MDVJourney
     * MDVJourney} saved as Favorite in the Database.
     */
    angular.module('mng-favorite', ['mng-util', 'mng-persistence']);
}());

(function() {
    'use strict';

    angular.module('mng-favorite')
        .service('mng-favorite.MDVUserFavorite', MDVUserFavorite);

    MDVUserFavorite.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-persistence.MDVPersistenceBuffer', 'mng-favorite.MDVUser'
    ];

    function MDVUserFavorite(MDVLog, MDVConfig, MDVPersistenceBuffer, MDVUser) {
        var log = MDVLog.register('mng-favorite.MDVUserFavorite'),
            favDbConf = MDVConfig.getValue('mng-persistence.databases.favorites.user'),
            userFavoriteObj = {
                get : get,
                set : set,
                remove : remove
            };

        log.debug('initialize');


        function get() {
            return MDVPersistenceBuffer.get(favDbConf);
        }

        function set(userObj) {
            return remove().then(function() {
                return MDVPersistenceBuffer.set(favDbConf, [new MDVUser(userObj)]);
            });
        }

        function remove(mdvUserFavorites, options) {
            var mdvUserFavArr = [];

            if (angular.isArray(mdvUserFavorites) && mdvUserFavorites.length > 0) {
                mdvUserFavArr = mdvUserFavorites;
            } else if (mdvUserFavorites) {
                mdvUserFavArr.push(mdvUserFavorites);
            }

            return MDVPersistenceBuffer.remove(favDbConf, mdvUserFavArr, options);
        }

        return userFavoriteObj;
    }
}());

(function() {
    'use strict';

    angular.module('mng-favorite')
        .factory('mng-favorite.MDVUser', MDVUser);

    MDVUser.$inject = ['$base64', 'mng-util.MDVLog'];

    function MDVUser($base64, MDVLog) {
        var log = MDVLog.register('mng-favorite.MDVUser');

        log.debug('initialize');

        return function(properties) {
            this.userId = userId;
            this.userNotificationId = userNotificationId;
            this.username = username;
            this.token = token;
            this.tokenType = tokenType;
            this.authorization = authorization;
            this.lastLoggedIn = lastLoggedIn;

            properties.$class = 'mng-favorite.MDVUser';

            this.toJSON = toJSON;
            this.equals = equals;


            // ////////////////////////////////

            function userId() {
                return properties.userId;
            }

            function userNotificationId() {
                return properties.userNotificationId;
            }

            function username() {
                return properties.username;
            }

            function token() {
                return properties.token;
            }

            function tokenType() {
                return properties.tokenType;
            }

            function lastLoggedIn() {
                return properties.lastLoggedIn || Date.now();
            }

            function authorization() {
                var auth = tokenType.call(this) + ' ' + token.call(this);
                return auth;
            }

            // ////////////////////////////////


            function toJSON() {
                return properties;
            }

            function equals(u) {
                return u.username() === username.call(this);
            }


            return this;
        };
    }
}());

(function() {
    'use strict';

    angular.module('mng-favorite')
        .service('mng-favorite.MDVTransportationFavorite', MDVTransportationFavorite);

    MDVTransportationFavorite.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-config.MDVConfigFetcher', 'mng-persistence.MDVPersistenceBuffer',
        'mng-favorite.MDVTransportation'];

    function MDVTransportationFavorite(MDVLog, MDVConfig, MDVConfigFetcher, MDVPersistenceBuffer,
            MDVTransportation) {
        var log = MDVLog.register('mng-favorite.MDVTransortationFavorite'),
            favDbConf = MDVConfig.getValue('mng-persistence.databases.favorites.transportation'),
            transportationFavoriteObj = {
                get : get,
                set : set,
                remove : remove
            };

        log.debug('initialize');


        function get(persistenceIds, usage) {
            if (usage) {
                return getByUsage(persistenceIds, usage);
            }
            return MDVPersistenceBuffer.get(favDbConf, persistenceIds);
        }


        function set(mdvTransportations, usage) {
            var mdvTransportationsArr = [];

            if (angular.isArray(mdvTransportations) && mdvTransportations.length > 0) {
                mdvTransportationsArr = mdvTransportations;
            } else if (mdvTransportations) {
                mdvTransportationsArr.push(mdvTransportations);
            }
            return MDVPersistenceBuffer.set(favDbConf,
                convertToMdvTransportation(mdvTransportationsArr, usage));
        }


        function remove(mdvTransportations, usage, options) {
            var mdvTransportationsFavArr = [];

            if (angular.isArray(mdvTransportations) && mdvTransportations.length > 0) {
                mdvTransportationsFavArr = mdvTransportations;
            } else if (mdvTransportations) {
                mdvTransportationsFavArr.push(mdvTransportations);
            }
            if (usage) {
                return removeByUsage(mdvTransportationsFavArr, usage);
            }
            return MDVPersistenceBuffer.remove(favDbConf, mdvTransportationsFavArr, options);
        }


        // ********************* private methods ****************************//

        function getByUsage(persistenceIds, usage) {
            return MDVPersistenceBuffer.get(favDbConf, persistenceIds).then(function(response) {
                var res = [],
                    favObj,
                    i,
                    l;

                for (i=0, l=response.length; i<l; i+=1) {
                    favObj = response[i];
                    if (favObj.usage() === usage) {
                        res.push(favObj);
                    }
                }
                return res;
            });
        }

        function convertToMdvTransportation(transArr, usage) {
            var favoriteTrans = [],
                favProps,
                i,
                l;

            for (i = 0, l = transArr.length; i < l; i += 1) {
                favProps = transArr[i].toJSON();
                if (usage) {
                    favProps.usage = usage;
                }
                favoriteTrans.push(new MDVTransportation(favProps));
            }
            return favoriteTrans;
        }

        function removeByUsage(mdvTransFavArr, usage) {
            if (mdvTransFavArr.length === 0) {
                MDVPersistenceBuffer.get(favDbConf).then(function(response) {
                    mdvTransFavArr = filterFavTransByUsage(response, usage);
                    return MDVPersistenceBuffer.remove(favDbConf, mdvTransFavArr);
                });

            } else {
                mdvTransFavArr = filterFavTransByUsage(mdvTransFavArr, usage);
                return MDVPersistenceBuffer.remove(favDbConf, mdvTransFavArr);
            }
        }

        function filterFavTransByUsage(mdvTranssFavArr, usage) {
            var filteredFavs = [],
                i,
                l;

            for (i=0, l=mdvTranssFavArr.length; i<l; i+=1) {
                if (mdvTranssFavArr[i].usage() === usage) {
                    filteredFavs.push(mdvTranssFavArr[i]);
                }
            }
            return filteredFavs;
        }


        return transportationFavoriteObj;
    }
}());

(function() {
    'use strict';

    angular.module('mng-favorite')
        .factory('mng-favorite.MDVTransportation', MDVTransportation);

    MDVTransportation.$inject = ['mng-util.MDVLog', 'mng-model.MDVTransportation'];

    function MDVTransportation(MDVLog, MNGTransportation) {
        var log = MDVLog.register('mng-favorite.MDVTransportation');

        log.debug('initialize');

        return function(properties) {
            var transportation,
                originalToJSON,
                originalEquals;

            delete properties.periodFrom;
            delete properties.periodTo;

            transportation = new MNGTransportation(properties, true);

            originalToJSON = transportation.toJSON;
            originalEquals = transportation.equals;
            transportation.usage = usage;

            function usage() {
                return properties.usage || '';
            }

            if (transportation._private.$class !== 'mng-favorite.MDVTransportation') {
                transportation._private.$class = 'mng-favorite.MDVTransportation';
                transportation.toJSON = toJSON;
                transportation.equals = equals;
            }

            // ////////////////////////////////


            function toJSON() {
                var serialized = originalToJSON.call(this);

                serialized.usage = usage();
                return serialized;
            }

            function equals(loc) {
                var isOrigininalEquals = originalEquals.call(this, loc),
                    isNewEquals = (usage() === loc.usage());

                return isOrigininalEquals && isNewEquals;
            }

            return transportation;
        };
    }
}());

(function() {
    'use strict';

    angular.module('mng-favorite')
        .service('mng-favorite.MDVOptionsFavorite', MDVOptionsFavorite);

    MDVOptionsFavorite.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-persistence.MDVPersistenceBuffer', 'mng-favorite.MDVOptions'
    ];

    function MDVOptionsFavorite(MDVLog, MDVConfig, MDVPersistenceBuffer, MDVOptions) {
        var log = MDVLog.register('mng-favorite.MDVOptionsFavorite'),
            favDbConf = MDVConfig.getValue('mng-persistence.databases.favorites.options'),
            optionFavoriteObj = {
                get : get,
                set : set,
                remove : remove,
                updateOptionsReference : updateOptionsReference
            };

        log.debug('initialize');

        function updateOptionsReference(refOptions, persistedOptions) {
            var cleanPersistedJson = persistedOptions;

            if (persistedOptions && persistedOptions.hasOwnProperty('toJSON')) {
                cleanPersistedJson = persistedOptions.toJSON();
            }

            angular.extend(refOptions, cleanPersistedJson);
        }

        function get(persistenceIds) {
            return MDVPersistenceBuffer.get(favDbConf, persistenceIds);
        }

        function set(jsonOptionsObj) {
            return MDVPersistenceBuffer.remove(favDbConf)
                .then(function() {
                    return MDVPersistenceBuffer.set(favDbConf, [new MDVOptions(jsonOptionsObj)]);
                });
        }

        function remove(optionFavorites, options) {
            var optionFavArr = [];

            if (angular.isArray(optionFavorites) && optionFavorites.length > 0) {
                optionFavArr = optionFavorites;
            } else if (optionFavorites) {
                optionFavArr.push(optionFavorites);
            }
            return MDVPersistenceBuffer.remove(favDbConf, optionFavArr, options);
        }

        return optionFavoriteObj;
    }
}());

(function() {
    'use strict';


    angular.module('mng-favorite')
        .factory('mng-favorite.MDVOptions', MDVOptions);

    MDVOptions.$inject = ['mng-util.MDVLog', 'mng-util.MDVException'];

    function MDVOptions(MDVLog, MDVException) {
        var log = MDVLog.register('mng-favorite.MDVOptions'),
            VERSION = 1;

        log.debug('initialize');

        return function(props) {
            // delete unuseful options
            delete props.dateTime;
            delete props.via;
            delete props.efaParams;

            props.$version = VERSION;
            props.$class = 'mng-favorite.MDVOptions';
            var properties = angular.copy(props);

            if (!properties) {
                throw new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_PARAMETERS, {
                    object : 'mng-favorite.MDVOptions',
                    reason : 'Missing options!',
                    params : properties
                });
            }

            properties.toJSON = toJSON;
            properties.equals = equals;

            // ////////////////////////////////


            function toJSON() {
                return props;
            }

            function equals(mdvOptions) {
                if (JSON.stringify(properties.accessibility)
                        !== JSON.stringify(mdvOptions.accessibility)) {
                    return false;
                }
                if (JSON.stringify(properties.fare)
                        !== JSON.stringify(mdvOptions.fare)) {
                    return false;
                }
                if (JSON.stringify(properties.individualTransport)
                        !== JSON.stringify(mdvOptions.individualTransport)) {
                    return false;
                }
                if (JSON.stringify(properties.modeRestrictions)
                        !== JSON.stringify(mdvOptions.modeRestrictions)) {
                    return false;
                }
                if (JSON.stringify(properties.publicTransport)
                        !== JSON.stringify(mdvOptions.publicTransport)) {
                    return false;
                }
                return true;
            }


            return properties;
        };
    }
}());

(function() {
    'use strict';

    angular.module('mng-favorite')
        .service('mng-favorite.MDVOdvFavorite', MDVOdvFavorite);

    MDVOdvFavorite.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-persistence.MDVPersistenceBuffer', 'mng-favorite.MDVOdv'
    ];

    function MDVOdvFavorite(MDVLog, MDVConfig, MDVPersistenceBuffer, MDVOdv) {
        var log = MDVLog.register('mng-favorite.MDVOdvFavorite'),
            favDbConf = MDVConfig.getValue('mng-persistence.databases.favorites.odv'),
            odvFavoriteObj = {
                get : get,
                set : set,
                remove : remove
            };

        log.debug('initialize');


        function get(persistenceIds) {
            return MDVPersistenceBuffer.get(favDbConf, persistenceIds);
        }

        function set(orig, dest, vias) {
            var odvObj = {
                'origin' : orig,
                'destination' : dest,
                'vias' : vias
            };

            return MDVPersistenceBuffer.set(favDbConf, [new MDVOdv(odvObj)]);
        }

        function remove(mdvOdvFavorites, options) {
            var mdvOdvsFavArr = [];

            if (angular.isArray(mdvOdvFavorites) && mdvOdvFavorites.length > 0) {
                mdvOdvsFavArr = mdvOdvFavorites;
            } else if (mdvOdvFavorites) {
                mdvOdvsFavArr.push(mdvOdvFavorites);
            }

            return MDVPersistenceBuffer.remove(favDbConf, mdvOdvsFavArr, options);
        }

        return odvFavoriteObj;
    }
}());

(function() {
    'use strict';


    angular.module('mng-favorite')
        .factory('mng-favorite.MDVOdv', MDVOdv);

    MDVOdv.$inject = ['mng-util.MDVLog', 'mng-util.MDVException', 'mng-model.MDVLocation'];

    function MDVOdv(MDVLog, MDVException, MDVLocation) {
        var log = MDVLog.register('mng-favorite.MDVOdv'),
            VERSION = 1;

        log.debug('initialize');

        return function(props) {
            var _private = {
                prepareProperties : prepareProperties,
                props : prepareProperties(props)
            };

            this.destination = destination;
            this.properties = properties;
            this.origin = origin;
            this.vias = vias;
            this.toJSON = toJSON;
            this.equals = equals;

            // ////////////////////////////////

            function prepareProperties(extProperties) {
                var propsToReturn,
                    i,
                    l,
                    res;

                if (!extProperties) {
                    extProperties = {};
                }
                if (extProperties.$version) {
                    if (extProperties.$version < VERSION) {
                        // convert values to current version
                    } else {
                        if (!extProperties.origin || !extProperties.destination) {
                            throw new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_PARAMETERS, {
                                object : 'mng-favorite.MDVOdv',
                                reason : 'Origin or destination are missing!',
                                params : extProperties
                            });
                        }
                        extProperties.origin = new MDVLocation(extProperties.origin);
                        extProperties.destination = new MDVLocation(extProperties.destination);
                        if (extProperties.vias) {
                            res = [];

                            for (i = 0, l = extProperties.vias.length; i < l; i += 1) {
                                res.push(new MDVLocation(extProperties.vias[i]));
                            }
                            extProperties.vias = res;
                        }
                    }
                }


                propsToReturn = angular.copy(extProperties);
                delete propsToReturn.raw;
                propsToReturn.$version = VERSION;
                propsToReturn.$class = 'mng-favorite.MDVOdv';
                return propsToReturn;
            }


            function destination() {
                return _private.props.destination;
            }

            function origin() {
                return _private.props.origin;
            }

            function vias() {
                return _private.props.vias || [];
            }

            function properties() {
                return _private.props.properties || {};
            }

            function toJSON() {
                var obj_copy = angular.copy(_private.props),
                    orig = _private.props.origin,
                    dest = _private.props.destination,
                    viaArr = _private.props.vias || [],
                    new_vias = [],
                    i,
                    l;

                obj_copy.origin = orig ? orig.toJSON() : null;
                obj_copy.destination = dest ? dest.toJSON() : null;

                for (i = 0, l = viaArr.length; i < l; i += 1) {
                    new_vias.push(viaArr[i].toJSON());
                }
                obj_copy.vias = new_vias;

                return obj_copy;
            }

            function equals(mdvOdv) {
                if (!origin.call(this).equals(mdvOdv.origin())) {
                    return false;
                }
                if (!destination.call(this).equals(mdvOdv.destination())) {
                    return false;
                }
                if (vias.call(this).length !== mdvOdv.vias().length) {
                    return false;
                }

                var i,
                    l;

                for (i = 0, l = vias.call(this).length; i < l; i += 1) {
                    if (!vias.call(this)[i].equals(mdvOdv.vias()[i])) {
                        return false;
                    }
                }
                return true;
            }


            return this;
        };
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-favorite.service:MDVLocationFavorite
     * @module mng-favorite
     * @description
     * The ´MDVLocationFavorite´ is used to get/edit/add and remove the {@link mng-model.object:MDVLocation
     * MDVLocation} saved as Favorite in the Database.
     */
    angular.module('mng-favorite')
        .service('mng-favorite.MDVLocationFavorite', MDVLocationFavorite);

    MDVLocationFavorite.$inject = ['$filter', 'mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-config.MDVConfigFetcher', 'mng-persistence.MDVPersistenceBuffer', 'mng-favorite.MDVLocation'
    ];

    function MDVLocationFavorite($filter, MDVLog, MDVConfig, MDVConfigFetcher, MDVPersistenceBuffer,
            MDVLocation) {
        var log = MDVLog.register('mng-favorite.MDVLocationFavorite'),
            favDbConf = MDVConfig.getValue('mng-persistence.databases.favorites.location'),
            locationFavoriteObj = {
                get : get,
                set : set,
                remove : remove
            };

        log.debug('initialize');


        /**
         * @public
         * @ngdoc method
         * @name get
         * @methodOf mng-favorite.service:MDVLocationFavorite
         * @description get one/multiple or all MDVLocation from Buffer.
         *   <pre>MDVLocationFavorite.get() // return all MDVLocations</pre>
         *   <pre>MDVLocationFavorite.get('1') // return MDVLocation with id '1'</pre>
         *   <pre>MDVLocationFavorite.get(['1', '2']) // return MDVLocation with id '1' and '2'</pre>
         * @param {Object} persistenceIds can be a document Id,
         * @param {String} usage location usage
         * an array of documents Ids or null.
         * @returns {Object} promise containing the database response or error.
         **/
        function get(persistenceIds, usage) {
            if (usage) {
                return getByUsage(persistenceIds, usage);
            }
            return MDVPersistenceBuffer.get(favDbConf, persistenceIds);
        }


        /**
         * @public
         * @ngdoc method
         * @name set
         * @methodOf mng-favorite.service:MDVLocationFavorite
         * @description add/update one or multiple MDVLocations.
         *   <pre>MDVLocationFavorite.set({'_id':'1'}) // add/update one
         * MDVLocation with id '1'</pre>
         *   <pre>MDVLocationFavorite.get([{'_id':'1'}, {'_id':'2'}]) // add/update
         * MDVLocations with id '1' and '2'</pre>
         * @param {Object} mdvLocations can be one or multiple MDVLocations.
         * @param {String} usage location usage
         * @returns {Object} promise containing the database response or error.
         **/
        function set(mdvLocations, usage) {
            var mdvLocationsArr = [];

            if (angular.isArray(mdvLocations) && mdvLocations.length > 0) {
                mdvLocationsArr = mdvLocations;
            } else if (mdvLocations) {
                mdvLocationsArr.push(mdvLocations);
            }
            return MDVPersistenceBuffer.set(favDbConf, convertToMdvLocations(mdvLocationsArr, usage))
                .then(function() {
                    if (usage) {
                        checkDBMaxLocationsLimitByUsage(usage);
                    }
                });
        }

        /**
         * @public
         * @ngdoc method
         * @name remove
         * @methodOf mng-favorite.service:MDVLocationFavorite
         * @description remove one/multiple or all MDVLocation.
         *   <pre>MDVLocationFavorite.remove() // remove all MDVLocations</pre>
         *   <pre>MDVLocationFavorite.remove({'_id':'1'}) // remove MDVLocation with id '1'</pre>
         *   <pre>MDVLocationFavorite.remove([{'_id':'1'}, {'_id':'2'}]) // remove
         * MDVLocations with id '1' and '2'</pre>
         * @param {Object} mdvLocationFavorites can be one or multiple MDVLocation.
         * @param {String} usage location usage
         * @param {Object} options db options
         * @returns {Object} promise.
         **/
        function remove(mdvLocationFavorites, usage, options) {
            var mdvLocationsFavArr = [];

            if (angular.isArray(mdvLocationFavorites) && mdvLocationFavorites.length > 0) {
                mdvLocationsFavArr = mdvLocationFavorites;
            } else if (mdvLocationFavorites) {
                mdvLocationsFavArr.push(mdvLocationFavorites);
            }
            if (usage) {
                return removeByUsage(mdvLocationsFavArr, usage);
            }
            return MDVPersistenceBuffer.remove(favDbConf, mdvLocationsFavArr, options);
        }


        // ********************* private methods ****************************//

        function checkDBMaxLocationsLimitByUsage(usage) {
            if (!favDbConf || !favDbConf.hasOwnProperty('limit')
                || !favDbConf.hasOwnProperty('containUsage') || !favDbConf.containUsage) {
                return;
            }

            var limit = favDbConf.limit;

            get(null, usage)
                .then(function(res) {
                    if (res.length>limit) {
                        res = $filter('orderBy')(res, '-persistence.modified');
                        var toRemove = res.slice(limit, res.length);

                        remove(toRemove, usage);
                    }
                });
        }

        function convertToMdvLocations(locationsArr, usage) {
            var favoriteLocations = [],
                favProps,
                i,
                l;

            for (i = 0, l = locationsArr.length; i < l; i += 1) {
                favProps = locationsArr[i].toJSON();
                if (usage) {
                    favProps.usage = usage;
                }
                favoriteLocations.push(new MDVLocation(favProps));
            }
            return favoriteLocations;
        }


        function getByUsage(persistenceIds, usage) {
            return MDVPersistenceBuffer.get(favDbConf, persistenceIds).then(function(response) {
                var res = [],
                    favObj,
                    i,
                    l;

                for (i=0, l=response.length; i<l; i+=1) {
                    favObj = response[i];
                    if (favObj.usage() === usage) {
                        res.push(favObj);
                    }
                }
                return res;
            });
        }


        function removeByUsage(mdvLocationsFavArr, usage) {
            if (mdvLocationsFavArr.length === 0) {
                MDVPersistenceBuffer.get(favDbConf).then(function(response) {
                    mdvLocationsFavArr = filterFavLocationsByUsage(response, usage);
                    return MDVPersistenceBuffer.remove(favDbConf, mdvLocationsFavArr);
                });

            } else {
                mdvLocationsFavArr = filterFavLocationsByUsage(mdvLocationsFavArr, usage);
                return MDVPersistenceBuffer.remove(favDbConf, mdvLocationsFavArr);
            }
        }


        function filterFavLocationsByUsage(mdvLocationsFavArr, usage) {
            var filteredFavs = [],
                i,
                l;

            for (i=0, l=mdvLocationsFavArr.length; i<l; i+=1) {
                if (mdvLocationsFavArr[i].usage() === usage) {
                    filteredFavs.push(mdvLocationsFavArr[i]);
                }
            }
            return filteredFavs;
        }

        return locationFavoriteObj;
    }
}());

(function() {
    'use strict';

    angular.module('mng-favorite')
        .factory('mng-favorite.MDVLocation', MDVLocation);

    MDVLocation.$inject = ['mng-util.MDVLog', 'mng-model.MDVLocation'];

    function MDVLocation(MDVLog, MNGLocation) {
        var log = MDVLog.register('mng-favorite.MDVLocation');

        log.debug('initialize');

        return function(properties) {
            var location,
                originalToJSON,
                originalEquals;

            location = new MNGLocation(properties, true);

            originalToJSON = location.toJSON;
            originalEquals = location.equals;
            location.usage = usage;

            if (location._private.$class !== 'mng-favorite.MDVLocation') {
                location._private.$class = 'mng-favorite.MDVLocation';
                location.toJSON = toJSON;
                location.equals = equals;
            }

            // ////////////////////////////////

            function usage() {
                return properties.usage || '';
            }

            function toJSON() {
                var serialized = originalToJSON.call(this);

                serialized.usage = usage();
                return serialized;
            }

            function equals(loc) {
                var isOrigininalEquals = originalEquals.call(this, loc),
                    isNewEquals = (usage() === loc.usage());

                return isOrigininalEquals && isNewEquals;
            }

            return location;
        };
    }
}());

(function(window) {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc overview
     * @name mng-common
     * @module mng-common
     *
     * @description
     * # mng-common (Common module)
     * The mng-common module contains some common components that can be used
     * from different application modules.
     *
     * ## General usage
     * ```js
     * // inject mng-common-components only
     * angular.module('your.module', ['mng-common']);
     * ```
     *
     * ## components
     * The following list gives a short overview of the available components within this module.
     * For further details, please refer to the components themselves.
     *
     * ### {@link mng-common.service:MDVUriParams MDVUriParams}
     * Service that handles the URL. Changes the URL whenever a search parameter or a state has
     * changed. This can be used to provide a sharable link that results in the same state the
     * single page application is in.
     *
     * ### {@link mng-common.service:MDVAddToIcsCalendar MDVAddToIcsCalendar}
     * Service to create an ics entry for a specific journey
     *
     * ### {@link mng-common.service:MDVCurrentPosition MDVCurrentPosition}
     * Helper service to resolve the current position retrieved from the browser to a MDVLocation
     * object.
     */
    angular.module('mng-common', ['mng-util', 'mng-comm'])
        .constant('downloadJs', window.downloadJs || null);
}(window));

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc filter
     * @name mng-common.filter:mdvWidgetParamToAngularFilter
     *
     * @description
     */
    angular.module('mng-common')
        .filter('mdvWidgetParamToAngularFilter', mdvWidgetParamToAngularFilter);

    mdvWidgetParamToAngularFilter.$inject = ['mng-util.MDVLog'];

    function mdvWidgetParamToAngularFilter(MDVLog) {
        var log = MDVLog.register('mng-common.mdvWidgetParamToAngularFilter'),
            date = {};

        log.debug('initialize');

        return function(old_params) {
            var new_params = angular.copy(old_params),
                transform = {
                    name_origin : 'orig',
                    name_destination : 'dest',
                    name_via : 'via',
                    name_dm : 'dm',

                    nameInfo_origin : 'orig',
                    nameInfo_destination : 'dest',
                    nameInfo_via : 'via',
                    nameInfo_dm : 'dm',

                    lineRestriction : 'restriction',

                    line : 'line',
                    itdTime : function(value, params) {
                        var timelist = /([\d]{2})\D*([\d]{2})/g.exec(value);

                        // Does not recognize 'PM'
                        if (timelist && timelist.length === 3) {
                            params.time = timelist[1] + ':' + timelist[2];
                        }
                    },
                    itdDate : function(value, params) {
                        var datelist = /([\d]{2})\D*([\d]{2})\D*([\d]{4})/g.exec(value);

                        if (datelist && datelist.length === 4) {
                            params.date = datelist[1] + '.' + datelist[2] + '.' + datelist[3];
                        }
                    },
                    itdDateDay : function(value) {
                        date.day = value;
                    },
                    itdDateMonth : function(value) {
                        date.month = value;
                    },
                    itdDateYear : function(value) {
                        date.year = value;
                    },
                    itdTripDateTimeDepArr : function(value, params) {
                        if (value === 'dep') {
                            params.isDeparture = 'true';
                        } else {
                            params.isDeparture = 'false';
                        }
                    },
                    maxChanges : 'maxInterchanges',
                    trITDepMOTvalue : 'individualTransportDuration',
                    trITArrMOTvalue : 'individualTransportDuration',
                    changeSpeed : 'individualTransportWalkSpeed',
                    useProxFootSearch : 'publicTransportUseProxFootSearch'
                };

            // Private Functions to do the Job

            function transformParams() {
                angular.forEach(new_params, updateLocalParams);
            }

            // Transform
            function updateLocalParams(value, key) {
                if (transform[key]) {
                    delete new_params[key];
                    if (angular.isFunction(transform[key])) {
                        transform[key].call(this, value, new_params);
                    } else {
                        new_params[transform[key]] = value;
                    }
                }
            }

            transformParams();

            if (date.day && date.month && date.year) {
                new_params.date = [date.day, date.month, date.year].join('.');
            }

            return new_params;

        };
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc directive
     * @name mng-odv.directive:mdvUrlParser
     *
     */
    angular.module('mng-common')
        .directive('mdvUrlParser', mdvUrlParserDirective);

    mdvUrlParserDirective.$inject = ['$filter',
        'mng-util.MDVLog', 'mng-common.MDVUriParams', '$location'];

    function mdvUrlParserDirective($filter, MDVLog, uriParamService, $location) {
        var mdvUrlParser = {
            // only attribute directive
            restrict : 'A',
            // scope : {
            //     result : '='
            // },
            link : function(scope, elem, attrs) {
                var search = $location.search(),
                    log = MDVLog.register('mng-odv.uriParseController');

                log.debug('initialize');

                function updateURI(value, name) {
                    // If a value is set, save if, otherwise delete parameter
                    if (value) {
                        updateParameter(name, value);
                    } else {
                        deleteParameter(name);
                    }

                    $location.search(search);
                }

                function updateParameter(name, value) {
                    search[name] = value;
                }

                function deleteParameter(name) {
                    delete search[name];
                }

                function ignore() {
                    return false;
                }

                function provideSearchParam(value, key) {
                    uriParamService.set(key, value);
                }

                // Handling Filter like a fortune
                if (angular.isDefined(attrs.widgetFilter)) {
                    search = $filter('mdvWidgetParamToAngularFilter')(search);
                    // Update new params to URL --> This directive is in Charge now
                    $location.search(search);
                }

                angular.forEach(search, provideSearchParam);

                function readNotification(notify) {
                    updateURI(notify[0], notify[1]);
                }

                uriParamService.getNotificationPromise().then(ignore, ignore, readNotification);
            }
        };

        return mdvUrlParser;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-common.service:MDVUriParams
     * @requires $q
     * @requires mng-util.service:MDVLog
     *
     * @description
     * This Module can be used as an interface to currently used parameter in URI.
     * It's `get` function provides an object of the current set parameters. The returned object has
     * no binding to the internal parameter object, so when updated this module won't realise the
     * change. This is neccessary, as all stored parameters must be parsed into an String before
     * passing them to URI, otherwise only hashes may be stored.
     * This module also notifies about valid changes by using the notify of `promise`.
     *
     * To update an option, you can use the modules `set` function. it uses the parameters name and
     * the value which sould be stored. After storing a valid option, the promise will be notified.
     * All connected modules will be provied name and new value as arguments in the promises notify
     * function.
     *
     *
     * ```js
     *   // Simple Parameter Handling
     *   var currentOptions = MDVUriParams.get();

     *   MDVUriParams.getNotification().then(function() {
     *      // Promise is successfully closed
     *   }, function() {
     *      // Promise has been rejected
     *   }, function(key, val) {
     *      // Option 'key' has been changed, new Value is 'val'.
     *      // Does update concern me?
     *      // If yes, do sth.
     *   });
     *
     *   // This sets value. If successful, promise will be called. If value is already set,
     *   // nothing will happen.
     *   MDVUriParams.set('orig', 'MENTZ');
     * ```
     */
    angular.module('mng-common')
        .factory('mng-common.MDVUriParams', MDVUriParams);

    MDVUriParams.$inject = ['$q', 'mng-util.MDVLog'];

    function MDVUriParams($q, MDVLog) {
        var log = MDVLog.register('mng-common.MDVUriParams'),
            defer = $q.defer(),
            searchParams = {};

        log.debug('init');

        /**
         * @public
         * @name clear
         * @ngdoc method
         * @methodOf mng-common.service:MDVUriParams
         * @param {String} key Name of URI Parameter in which the value should be deleted
         *
         * @description
         * Reset the parsed parameters.
         * This Method can be used before calling the browser back function to avoid an infinite
         * Deeplink-call.
        */
        function clear(key) {
            if (key) {
                if (searchParams && searchParams.hasOwnProperty(key)) {
                    delete searchParams[key];
                } else {
                    return;
                }
            } else {
                searchParams = {};
            }
        }


        /**
         * @public
         * @name get
         * @ngdoc method
         * @methodOf mng-common.service:MDVUriParams
         * @param {String} key Name of URI Parameter in which the value should be fetched
         *
         * @description
         * Getter of internal Object. Returned Object is a copy of the internal object, this secures
         * access to internal object. When you're interested in changes on this object, use
         * `getNotification` Method.
         *
         *@returns {Object} Copy of currently known search params.
         */
        function get(key) {
            if (key) {
                if (searchParams && searchParams.hasOwnProperty(key)) {
                    return angular.copy(searchParams[key]);
                } else {
                    return null;
                }
            }
            return angular.copy(searchParams);
        }


        /**
         * @public
         * @name getNotification
         * @ngdoc method
         * @methodOf mng-common.service:MDVUriParams
         *
         * @description
         * Getter for monitoring `promise` - Object. The Promises `notify` will be triggered, when
         * an option is updated.
         *
         *@returns {Object} Copy of currently known search params.
         */
        function getNotificationPromise() {
            return defer.promise;
        }

        /**
         * @private
         * @name isNoUpdate
         * @ngdoc method
         * @methodOf mng-common.service:MDVUriParams
         * @param {String} key Name of URI Parameter in which the value should be stored
         * @param {String} value Stringified option value which should be checked.
         *
         * @description
         * Checks if value is already set for given key. If so, returns true, as no update needs to
         * be done.
         *
         *@returns {Boolen} Flag if value has already been set for given key
         */
        function isNoUpdate(key, value) {
            return searchParams[key] && searchParams[key] === value;
        }

        /**
         * @private
         * @name isKeyValid
         * @ngdoc method
         * @methodOf mng-common.service:MDVUriParams
         * @param {String} key Name of URI Parameter in which the value should be stored
         *
         * @description
         * Checks if given key can be used as object property
         *
         *@returns {Boolen} Flag if key is valid
         */
        function isKeyValid(key) {
            return angular.isString(key) && Boolean(key);
        }

        /**
         * @private
         * @name isValueValid
         * @ngdoc method
         * @methodOf mng-common.service:MDVUriParams
         * @param {String} value Stringified option value which should be stored
         *
         * @description
         * Checks if value can be stored to $location.search()
         *
         *@returns {Boolen} Flag if value is valid
         */
        function isValueValid(value) {
            return angular.isString(value) && Boolean(value);
        }

        /**
         * @private
         * @name notify
         * @ngdoc method
         * @methodOf mng-common.service:MDVUriParams
         * @param {String | Object} value Updated Option
         * @param {String} name Parameter name which has changed
         *
         * @description
         * Notifiys registered Modules about changed Search value using a shared promise.
         */
        function notify(value, name) {
            defer.notify([value, name]);
        }


        /**
         * @private
         * @name parseValueToString
         * @ngdoc method
         * @methodOf mng-common.service:MDVUriParams
         * @param {String | Object} value Option value which should be stringified.
         *
         * @description
         * Parses given Option into string, if rules are known, otherwise returns emtpy string.
         *
         * @returns {String} Stringified value, Empty string if parsing failed.
         */
        function parseValueToString(value) {
            // already is String, deal with it!
            if (angular.isString(value)) {
                return value;
            }
            if (angular.isObject(value)) {
                return angular.toJson(value);
            }
            return '';
        }

        /**
         * @public
         * @name set
         * @ngdoc method
         * @methodOf mng-common.service:MDVUriParams
         * @param {String} key name of URI Parameter in which the value should be stored.
         * if this parameter has already been set, it will be rewritten. To store Multiple
         * parameters sharing the same name, please use pre-/postfixes. Neccessary because order of
         * parameters cannot be ensured when storing the parameters to URI.
         * @param {String | Object} value Value which should be set to URI Parameter
         * @returns {mng-common.service.MDVUriParams} Returns the reference to called service. This
         * way chained requests are possible
         *
         * @description
         * Sets an parameter which is supposed to be stored to URI. It only maintains the image of
         * pages search parameters. Sync between the Script object and URI Parameters must be
         * handled elsewhere. Updating the object must be done by using this function. This way the
         * service will take care of storing your parameters.
         * When the parameter has been set, all `Clients` will receive a notification.
         */
        function set(key, value) {
            if (isKeyValid(key)) {
                setValidKeyParam(key, value);
            }
            return this;
        }


        /**
         * @private
         * @name setValidKeyParam
         * @ngdoc method
         * @methodOf mng-common.service:MDVUriParams
         * @param {String} key Validated name of URI Parameter in which the value should be stored.
         * @param {String | Object} value Option value which should be stringified.
         *
         * @description
         * Setting routine for value, after the key has been verified.
         * Parameter will only be set, if value can be parsed to String and does not equal currently
         * set value. This sould prevent looping Errors, as they may occour when firing change on
         * on changed Parameters, if calling Module does not recognize the change.
         */
        function setValidKeyParam(key, value) {
            var stringValue = parseValueToString(value);

            if (isNoUpdate(key, stringValue)) {
                return;
            }

            if (isValueValid(stringValue)) {
                searchParams[key] = stringValue;
                notify(value, key);
            }
        }

        return {
            get : get,
            getNotificationPromise : getNotificationPromise,
            set : set,
            clear : clear
        };
    }

}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-common.service:MDVCurrentPosition
     * @requires $q
     * @requires $window
     * @requires $injector
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.service:MDVLocationRequester
     * @requires mng-util.object:MDVException
     * @require mng-model.object:MDVOptions
     *
     * @description
     * The `MDVCurrentPosition` service is a helper service to get the current position of the
     * device.
     * If the device browser supports the 'navigator.geolocation' feature, the service fetches the
     * browser's coords
     * using the {@link mng-comm.service:MDVLocationRequester MDVLocationRequester} service he
     * returns a deferred
     * object resolved with a {@link mng-model.object:MDVLocation MDVLocation}.
     * @example
<example module="MDVCurrentPositionExample">
<file name="index.html">
  <div ng-controller="CurrentPositionController">
    <div>
        <input type="button" ng-click="getBrowserLocation()" value="get Browser location" />
       <p ng-show="location">your current location is : <b>{{location.description()}}</b></p>
       <p style="color:red;">{{error}}</p>
    </div>
  </div>
</file>
<file name="script.js">
  angular.module('MDVCurrentPositionExample', ['mng-logger', 'mng-common', 'mng-comm',
        'mng-comm.itd.xmljson', 'mng-comm.itd', 'mng-model'])
    .constant('moment', moment)
    .controller('CurrentPositionController', CurrentPositionController);

    CurrentPositionController.$inject = ['$scope', 'mng-common.MDVCurrentPosition',
                                'mng-config.MDVConfig'];

  function CurrentPositionController($scope, MDVCurrentPosition, MDVConfig) {

    MDVConfig.setValue('EFA', {
          'url' : '/mngnsw',
          'XMLJSON' : {
              defParams: {
                  outputFormat: 'json'
              },
              SF: {
                    url: '/XML_STOPFINDER_REQUEST?'
                }
          }
    });

     MDVConfig.setValue('MDVLocationRequester', {
        'cache' : true,
        'subservices' : ['mng-comm.itd.xmljson.MDVEFAStopfinder']
    });

     $scope.getBrowserLocation = function(){
        MDVCurrentPosition.get()
            .then(function(mdvLocation){
                $scope.location = mdvLocation;
            }).catch(function(err){
                $scope.error = err;
            });
      }
  };
</file>
</example>
     *
     */
    angular.module('mng-common')
        .factory('mng-common.MDVCurrentPosition', MDVCurrentPosition);

    MDVCurrentPosition.$inject = ['$q', '$window', 'mng-util.MDVLog',
        'mng-util.MDVException', 'mng-comm.MDVLocationRequester'
    ];

    function MDVCurrentPosition($q, $window, MDVLog, MDVException, MDVLocationRequester) {
        var log = MDVLog.register('mng-common.MDVCurrentPosition');

        log.debug('init');

        return {
            get : get
        };

        /**
         * @public
         * @ngdoc method
         * @name get
         * @methodOf mng-common.service:MDVCurrentPosition
         * @returns {Deferred} Deferred, that is resolved to a {@link
         * mdv.model.object:MDVLocation MDVLocation}
         * @param {Object=} [options={}] Options object to change the service to request in its
         * default way.
         *
         * @description
         * Using the javascript 'navigator.geolocation', this method tries to get the current
         * position of the device ({latitude, longitude}) and convert it into an internal
         * {@link mdv.model.object:MDVLocation MDVLocation} using the
         * {@link mng-comm.service:MDVLocationRequester MDVLocationRequester} service.
         */
        function get(options) {
            var deferred = $q.defer();

            if ($window.navigator.geolocation) {
                $window.navigator.geolocation.getCurrentPosition(
                    function(position) {
                        if (!position || !position.coords ||
                            !position.coords.latitude || !position.coords.longitude) {
                            deferred.reject(
                                MDVException.keys.MNG__USER.BROWSER_DOES_NOT_SUPPORT_GEOLOCATION);
                            throw new MDVException(
                                MDVException.keys.MNG__USER.BROWSER_DOES_NOT_SUPPORT_GEOLOCATION);
                        }
                        getMDVLocationFromCoord(position.coords, options)
                            .then(function(res) {
                                if (res.response && res.response.length > 0) {
                                    deferred.resolve(res.response[0]);
                                } else {
                                    throw new MDVException(
                                    MDVException.keys.MNG__USER.BROWSER_DOES_NOT_SUPPORT_GEOLOCATION);
                                }
                            })
                            .catch(function(err) {
                                deferred.reject(err);
                                throw new MDVException(
                                    MDVException.keys.MNG__USER.BROWSER_DOES_NOT_SUPPORT_GEOLOCATION);
                            });
                    },
                    function(err) {
                        deferred.reject(err);
                    });
            } else {
                deferred.reject(MDVException.keys.MNG__USER.BROWSER_DOES_NOT_SUPPORT_GEOLOCATION);
                throw new MDVException(
                    MDVException.keys.MNG__USER.BROWSER_DOES_NOT_SUPPORT_GEOLOCATION
                );
            }

            return deferred.promise;
        }

        // /**
        //  * Return a {@link mdv.model.object:MDVLocation MDVLocation} Object
        //  * for a giving coords object.
        //  */
        function getMDVLocationFromCoord(coords, options) {
            return MDVLocationRequester.search([coords.latitude, coords.longitude], options);
        }

    }


}());

(function() {
    'use strict';
        /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-common.service:MDVAddToIcsCalendar
     * @requires downloadJs
     * @requires mng-util.service:MDVLog
     * @requires mng-util.object:MDVException
     *
     * @description
     * The `MDVAddToIcsCalendar` service is a helper service to generate an ics calendar file.
     * The service offer only one method that need a {@link mng-model.object:MDVJourney MDVJourney}
     * as parameter.
     * After generating the ics template, the service fire the download using the
     * {@link http://danml.com/download.html download.js} library.
     **/
    angular.module('mng-common')
        .factory('mng-common.MDVAddToIcsCalendar', MDVAddToIcsCalendar);

    MDVAddToIcsCalendar.$inject = ['downloadJs', 'mng-util.MDVLog', 'mng-util.MDVException'];

    function MDVAddToIcsCalendar(downloadJs, MDVLog, MDVException) {
        var log = MDVLog.register('mng-common.MDVAddToIcsCalendar'),
            journey,
            origin,
            destination,
            prodId,
            UTF8 = {
                encode : function(s) {
                    return unescape(encodeURIComponent(s));
                },
                decode : function(s) {
                    return decodeURIComponent(escape(s));
                }
            };

        log.debug('init');

        return {
            add : add
        };

        function add(journeyObj, prodID) {
            journey = journeyObj;
            prodId = prodID;
            origin = journey.origin();
            destination = journey.destination();
            if (!journey || !origin || !destination) {
                throw new MDVException(MDVException.keys.MNG_COMMON.NO_DATA);
            }
            return downloadIcs();
        }

        // ////////////// PRIVATE METHODS ////////////////

        function downloadIcs() {
            var fileName = getFileName(),
                icsTemplate = getIcsTemplate();

            if (downloadJs) {
                downloadJs(UTF8.encode(icsTemplate), fileName, 'application/octet-stream;charset=utf-8');
            } else {
                log.warn('missing downloadJs dependency');
                log.warn('unable to download ics calender file with name ' + fileName);
            }

            return UTF8.encode(icsTemplate);
        }


        function fillTemplateWithData(template) {
            var regex = new RegExp('<(PRODID|DTSTART|DTEND|DTSTAMP|SUMMARY|DESCRIPTIONSUMMARY|DESCRIPTIONDATE|DESCRIPTION)>', 'g');

            template = template.replace(regex, replaceIcalToken);
            regex = new RegExp('<(TRIP|DATE|DETAIL|FOOTER|FOOTPATH_IT|FOOTPATH_PT|FOOTPATH_97|FOOTPATH_98|UIDIdentifier)>', 'g');
            template = template.replace(regex, replaceTranslToken);
            return template;
        }


        function replaceIcalToken(m) {
            switch (m) {
            case '<PRODID>':
                return 'http://' + prodId;
            case '<DTSTART>':
                // return formatDate(origin.departureTimePlanned());
                return formatDTSTART(origin.departureTimePlanned());
            case '<DTEND>':
                return formatDate(destination.arrivalTimePlanned());
            case '<DTSTAMP>':
                // return formatTime(new Date());
                return formatSTAMPTime(new Date());
            case '<SUMMARY>':
            case '<DESCRIPTIONSUMMARY>':
                return origin.name() + ' - ' + destination.name();
            case '<DESCRIPTIONDATE>':
                return formatDate(origin.departureTimePlanned(), true);
            case '<DESCRIPTION>':
                return getLegsDescription();
            default:
                return 'n/a';
            }

        }


        function formatDate(date, flag) {
            try {
                if (flag) {
                    return moment(date).format('DD.MM.YYYY HH:mm');
                }
                return moment(date).format('YYYYMMDDTHHmm00');
            } catch (e) {
                return ' ';
            }
        }
        function formatDTSTART(date) { // DTSTART
            try {
                return moment(date).format('YYYYMMDDTHHmmss');
            } catch (e) {
                return ' ';
            }
        }

        function formatTime(date) {
            return moment(date).format();
            // return moment(date).format('HH:mm');
        }

        function formatDescriprionTime(date) {
            return moment(date).format('HH:mm');
        }

        function formatSTAMPTime(date) { // DTSTART/DTSTAMP Time
            return moment(date).format('YYYYMMDDTHHmmss');
        }


        function replaceTranslToken(m) {
            // @todo add Translation
            switch (m) {
            case '<TRIP>':
                return 'Fahrt';
            case '<DATE>':
                return 'Datum';
            case '<DETAIL>':
                return 'Details';
            case '<FOOTER>':
                return 'Alle Angaben ohne Gewähr (' + prodId + ')';
            case '<FOOTPATH_IT>':
                return 'Fußweg';
            case '<FOOTPATH_PT>':
                return 'Umstieg';
            case '<FOOTPATH_97>':
                return 'Weiterfahrt im selben Fahrzeug möglich';
            case '<FOOTPATH_98>':
                return 'Anschluss wird in der Regel abgewartet';
            case '<UIDIdentifier>':
                return (new Date().getTime() + '@' + prodId);
            default:
                return 'n/a';
            }
        }


        function getLegsDescription() {
            var i,
                l,
                orig,
                dest,
                productName,
                toReturn = '',
                productClass;

            for (i = 0, l = journey.legs().length; i < l; i += 1) {
                orig = getLocationDescription(journey.legs()[i].origin(), true, true);
                dest = getLocationDescription(journey.legs()[i].destination(), false, true);
                productName = journey.legs()[i].transportation().name();

                if (productName) {
                    productClass = journey.legs()[i].transportation().productClass();

                    if (productClass === 97) {
                        productName = '<FOOTPATH_97>';
                    } else if (productClass === 98) {
                        productName = '<FOOTPATH_98>';
                    } else if (productClass === 99) {
                        productName = '<FOOTPATH_PT>';
                    } else if (productClass === 100) {
                        productName = '<FOOTPATH_IT>';
                    } else {
                        productName = productName + ' (' + journey.legs()[i].transportation().destination().name() + ')';
                    }
                }
                toReturn += '\\n\\n' + [orig, productName, dest].join(' - ');
            }
            return toReturn;
        }


        function getLocationDescription(loc, isOrig, withTime) {
            if (isOrig) {
                return formatDescriprionTime(loc.departureTimePlanned(), withTime) + ' ' + loc.name();
            }
            return formatDescriprionTime(loc.arrivalTimePlanned(), withTime) + ' ' + loc.name();
        }

        function getIcsTemplate() {
            var tmp = [
                'BEGIN:VCALENDAR',
                'X-LOTUS-CHARSET:UTF-8',
                'VERSION:2.0',
                'PRODID:<PRODID>',
                'METHOD:PUBLISH',
                'BEGIN:VTIMEZONE',
                'TZID:Europe/Berlin',
                'X-LIC-LOCATION:Europe/Berlin',
                'BEGIN:DAYLIGHT',
                'TZOFFSETFROM:+0100',
                'TZOFFSETTO:+0200',
                'TZNAME:CEST',
                'DTSTART:19700329T020000',
                'RRULE:FREQ=YEARLY;INTERVAL=1;BYDAY=-1SU;BYMONTH=3',
                'END:DAYLIGHT',
                'BEGIN:STANDARD',
                'TZOFFSETFROM:+0200',
                'TZOFFSETTO:+0100',
                'TZNAME:CET',
                'DTSTART:19701025T030000',
                'RRULE:FREQ=YEARLY;INTERVAL=1;BYDAY=-1SU;BYMONTH=10',
                'END:STANDARD',
                'END:VTIMEZONE',
                'BEGIN:VEVENT',
                'UID:<UIDIdentifier>',
                'CLASS:PUBLIC',
                'SUMMARY:<SUMMARY>',
                'DTSTART;TZID=Europe/Berlin:<DTSTART>',
                'DTEND;TZID=Europe/Berlin:<DTEND>',
                'DTSTAMP:<DTSTAMP>',
                'DESCRIPTION: <TRIP> <DESCRIPTIONSUMMARY>\\n\\n<DATE> <DESCRIPTIONDATE>'
                    .concat('\\n\\n<DETAIL>\\n\\n<DESCRIPTION>\\n\\n\\n<FOOTER>'),
                'BEGIN:VALARM',
                'TRIGGER:-PT30M',
                'ACTION:DISPLAY',
                'DESCRIPTION:Reminder',
                'END:VALARM',
                'END:VEVENT',
                'END:VCALENDAR'
            ].join('\r\n');

            tmp = fillTemplateWithData(tmp);

            return tmp;
        }

        function getFileName() {
            return origin.name()
                .concat('_')
                .concat(destination.name())
                .concat('_')
                .concat(formatDate(origin.departureTime(), true))
                .concat('_')
                .concat(formatDate(destination.arrivalTime(), true))
                .concat('_')
                .replace(new RegExp(' ', 'g'), '_')
                .concat('.ics');
        }

    }


}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc overview
     * @name mng-comm.itd.xmljson
     * @module mng-comm.itd.xmljson
     * @requires mng-comm.itd
     * @requires mng-model
     * @requires mng-util
     *
     * @description
     * # mng-comm.itd.xmljson (main EFA communication module via the old xml json interface)
     * This module provides the communication to the EFA interface and the
     * corresponding parser methods to convert the EFA responses to the abstract model.
     *
     * ## General usage
     * ```js
     * // inject mng-comm.itd.xmljson - components only
     * angular.module('your.module', ['mng-comm.itd.xmljson']);
     * ```
     *
     * The following list gives a short overview of the available components within this module.
     * For further details, please refer to the components themselves.
     *
     * ## parser services
     * These services take care of parsing EFA responses to the {@link mng-model model} objects.
     *
     * ### {@link mng-comm.itd.xmljson.service:MDVEFAUtil MDVEFAUtil}
     * The `MDVEFAUtil` offers a collection of EFA communication-specific utility functions that do
     * not care about formatting (this is handled in the {@link mng-comm.itd.service:MDVEFAFormatter
     * MDVEFAFormatter}).
     *
     * ### {@link mng-comm.itd.xmljson.service:MDVLocationParser MDVLocationParser}
     * The `MDVLocationParser` parses given EFA information of a location (EFA-point-object) to a
     * {@link mng-model.object:MDVLocation MDVLocation}.
     *
     * ### {@link mng-comm.itd.xmljson.service:MDVEFAStopfinderParser MDVEFAStopfinderParser}
     * The `MDVEFAStopfinderParser` parses given EFA information of a XML_STOPFINDER_REQUEST response to a
     * list of {@link mng-model.object:MDVLocation MDVLocations}.
     *
     *
     *
     *
     *
     * ## request services
     * These kind of services care about requesting the correct data from the EFA back-end and
     * passing the response to the corresponding parser before the response is returned.
     *
     * ### {@link mng-comm.itd.xmljson.service:MDVEFAStopfinder MDVEFAStopfinder}
     * The `MDVEFAStopfinder` service implements the interface for {@link
     * mng-comm.service:MDVLocationRequester MDVLocationRequester} and uses the MENTZ-EFA
     * interface to resolve a given name to a list of {@link mng-model.object:MDVLocation
     * MDVLocations}.
     *
     *
     *
     */
    angular.module('mng-comm.itd.xmljson', ['mng-comm.itd', 'mng-model', 'mng-util']);
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFATTBParser', MDVEFATTBParser);

    MDVEFATTBParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.xmljson.MDVFileParser',
                                'mng-comm.itd.xmljson.MDVTransportationParser',
                                'mng-comm.itd.MDVEFAFormatter'];

    function MDVEFATTBParser(MDVLog, MDVFileParser, MDVTransportationParser, MDVEFAFormatter) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFATTBParser'),
            ttbp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////


        function parse(response, lineID) {
            var efaLines,
                lines = [],
                fileProps,
                genAttrsObj,
                serverInfo;

            if (response && response.itdDownload && response.itdDownload.itdDownloadFile &&
                response.itdDownload.itdDownloadFile.src) {
                fileProps = {
                    input : 'TTB_' + lineID,
                    url : response.itdDownload.itdDownloadFile.src,
                    size : convert_to_int(response.itdDownload.itdDownloadFile.size),
                    stream : response.stream,
                    raw : response
                };
                genAttrsObj = MDVEFAFormatter.parseGenAttrs(response.parameters);
                if (genAttrsObj.hasOwnProperty('serverID')) {
                    serverInfo = {
                        serverID : genAttrsObj.serverID
                    };
                }

                return MDVFileParser.parse(fileProps, serverInfo);
            } else if (response && response.servingLines && response.servingLines.lines) {
                efaLines = response.servingLines.lines;

                angular.forEach(efaLines, function(efaLine) {
                    lines.push(MDVTransportationParser.parse(efaLine, 'DMline'));
                });
                return lines;
            }
        }


        function convert_to_int(str) {
            var nbr = parseInt(str, 10);

            if (!nbr) {
                return 0;
            }
            return nbr;
        }

        return ttbp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFATTB', MDVEFATTB);

    MDVEFATTB.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.xmljson.MDVEFATTBParser', 'mng-util.MDVException', 'mng-util.MDVUtil'];


    function MDVEFATTB(MDVLog, MDVConfig, MDVEFARequester, MDVEFATTBParser, MDVException, MDVUtil) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFATTB',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            ttbRequester,
            ttb = {
                search : search,
                searchLines : searchLines
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                params;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            params = addSearchParams(options);

            _private.running_xhr = ttbRequester.request(params)
                .then(function(response) {
                    if (!response || response.length === 0 ||
                            !response.itdDownload || !response.itdDownload.itdDownloadFile ||
                            !response.itdDownload.itdDownloadFile.src) {

                        throw new MDVException(MDVException.keys.MNG_COMM__TTB.SERVICE_FAILED, {
                            input : options,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;

                    return MDVEFATTBParser.parse(response, options.lineId);
                });
            return _private.running_xhr;
        }

        function searchLines(input, options, type) {
            if (type && type!=='TTB') {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                        input : input,
                        reason : 'invalid type'
                    })
                );
            }
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var params = options && options.efaParams;

            if (!params) {
                params = {};
            }

            if (typeof input === 'object' && input.hasOwnProperty('id')) {
                // location
                params.mode = 'odv';
                params.type_ttb = 'any';
                params.name_ttb = input.id();
            } else {
                params.lineName = input;
                params.mode = 'line';
            }

            _private.running_xhr = ttbRequester.request(params)
                .then(function(response) {
                    if (!response || response.length === 0 ||
                        !response.servingLines || !response.servingLines.lines) {
                        throw new MDVException(MDVException.keys.MNG_COMM__ROP.SERVICE_FAILED, {
                            args : input,
                            service : 'mng-comm.itd.xmljson.MDVEFAROP',
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;

                    return MDVEFATTBParser.parse(response);
                });
            return _private.running_xhr;
        }


        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_TTB_REQUEST?',
                defaultParams : {
                    command : 'direct'
                },
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function isReady(options) {
            var reasons = [];

            if (!options.lineId) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                    reason : 'lineId missing'
                }));
            }

            return reasons;
        }

        function addSearchParams(options) {
            var params = options.efaParams || {};

            params.line = options.lineId;

            if (options.lineVer) {
                params.lineVer = options.lineVer;
            }

            params.command = 'direct';

            return params;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                ttb._private = _private;
            }
        });

        // create customized requester object
        ttbRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFATTB',
            _private.getDefaultConfigOption());

        return ttb;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVEFATripParser
     * @requires mng-util.service:MDVLog
     * @requires mng-model.object:MDVLocation
     * @requires mng-comm.itd.xmljson.service:MDVDepartureParser
     * @description
     *
     * Parser service for the response of an EFA Trip request. It converts EFA styled objects to the
     * unified Journey object.
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFATripParser', MDVEFATripParser);

    MDVEFATripParser.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFAFormatter', 'mng-model.MDVJourney', 'mng-model.MDVJourneyLeg',
        'mng-model.MDVFile', 'mng-model.MDVMessage', 'mng-comm.itd.xmljson.MDVEFAFareParser',
        'mng-comm.itd.xmljson.MDVJourneyLegParser'];

    function MDVEFATripParser(MDVLog, MDVUtil, MDVConfig, MDVEFAFormatter, MDVJourney, MDVJourneyLeg,
            MDVFile, MDVMessage, MDVEFAFareParser, MDVJourneyLegParser) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFATripParser'),
            options,
            isReady = false,
            tripp = {
                parse : parse
            };

        log.debug('initialize');

        MDVConfig.ready(function() {
            options = MDVConfig.getValue('mng-comm-itd-xmljson.MDVEFATrip.parser') || {};

            if (!options.hasOwnProperty('combineWalkLegs')) {
                // combine two consecutive walk legs to one walk leg
                options.combineWalkLegs = true;
            }

            if (!options.hasOwnProperty('ignoreODVInfos')) {
                // ignore infos that are provided in the odv header of a trip response
                options.ignoreODVInfos = false;
            }

            if (!options.hasOwnProperty('maxPTDistance')) {
                // do not use calculated pt footpath distances that are greater/equal to the passed value
                options.maxPTDistance = 1000;
            }

            if (!options.hasOwnProperty('mergePTtoITInstructions')) {
                // combine it and pt instructions as good as possible if both are provided in a single leg
                options.mergePTtoITInstructions = true;
            }

            if (!options.hasOwnProperty('downwardCompatible')) {
                // parse it and pt footpath instructions in the way they were passed before
                options.downwardCompatible = true;
            }

            isReady = true;
        });
        // ////////////////////////////////

        function addAdditionalInfo(point, odv) {
            if (!odv) {
                return point;
            }
            point.additionalInformation = odv;
            if (options.ignoreODVInfos) {
                point.additionalInformation.infos = [];
            }
            return point;
        }

        function parseLegs(efa_trip, serverInfos) {
            var efa_legs = efa_trip.legs,
                legs = [],
                curr_leg,
                wait_leg,
                last_arrival,
                i,
                l;

            if (efa_legs.leg) {
                efa_legs = [efa_legs.leg];
            }

            efa_legs[0].points[0] = addAdditionalInfo(efa_legs[0].points[0], efa_trip.origin);
            efa_legs[efa_legs.length - 1].points[1] =
                addAdditionalInfo(efa_legs[efa_legs.length - 1].points[1], efa_trip.destination);

            for (i = 0, l = efa_legs.length; i < l; i += 1) {
                // normal leg
                curr_leg = MDVJourneyLegParser.parse(efa_legs, i, serverInfos, options);
                if (last_arrival && last_arrival.isBefore(curr_leg.departureTime())) {
                    // fill time between legs with wait-legs
                    wait_leg = null;
                    wait_leg = MDVJourneyLegParser.parseWaitLeg(efa_legs, i, serverInfos, options);
                    if (wait_leg) {
                        legs.push(wait_leg);
                    }
                }
                if (curr_leg) {
                    curr_leg.legIndex = legs.length;
                    legs.push(curr_leg);
                    last_arrival = curr_leg.arrivalTime();
                }
                // treat interchanges as extra leg
                curr_leg = null;
                if ((efa_legs[i].interchange)
                    || (efa_legs[i].footpath &&
                        (efa_legs[i].mode.type !== '99') &&
                        (efa_legs[i].mode.type !== '100'))) {
                    curr_leg = MDVJourneyLegParser.parseInterchange(efa_legs, i, serverInfos, options);
                }
                if (curr_leg) {
                    legs.push(curr_leg);
                    last_arrival = curr_leg.arrivalTime();
                }
            }
            return legs;
        }

        function parseAdditional(efa_trip) {
            if (!efa_trip.optValue) {
                return false;
            }
            if (parseInt(efa_trip.optValue, 10) >= 0) {
                return false;
            }
            return true;
        }

        function parseBookings(efa_bookings, map) {
            if (!efa_bookings) {
                return [];
            }

            var bookingsArr = [],
                bookingObj,
                res = [],
                i,
                l;

            if (efa_bookings && efa_bookings.hasOwnProperty('booking')) {
                bookingsArr.push(efa_bookings.booking);
            } else if (efa_bookings instanceof Array) {
                bookingsArr = efa_bookings;
            }

            for (i=0, l=bookingsArr.length; i<l; i+=1) {
                bookingObj = {
                    legRange : getLegRange(bookingsArr[i], map),
                    file : new MDVFile({
                        url : bookingsArr[i].serverAddress
                    })
                };
                res.push(bookingObj);
            }

            return res;
        }

        function getLegRange(obj, map) {
            var from = parseInt(obj.prFrom, 10),
                to = parseInt(obj.prTo, 10),
                result = [];

            for (; from <= to; from += 1) {
                result.push(map[from]);
            }
            return result;
        }


        function assignFaresToLegs(legs, fares) {
            var curr_range,
                i,
                j,
                k,
                l;

            for (i = 0, l = fares.tickets.length; i < l; i += 1) {
                curr_range = fares.tickets[i].legRange();
                for (j = 0, k = curr_range.length; j < k; j += 1) {
                    // leg.isPublicTransportation() &&
                    if (legs.length > curr_range[j]) {
                        legs[curr_range[j]].pushTicket(fares.tickets[i]);
                    }
                }
            }

            return legs;
        }

        function assignBookingsToLegs(legs, bookings) {
            var curr_range,
                i,
                j,
                k,
                l;

            for (i = 0, l = bookings.length; i < l; i += 1) {
                curr_range = bookings[i].legRange;
                for (j = 0, k = curr_range.length; j < k; j += 1) {
                    // leg.isPublicTransportation() &&
                    if (legs.length > curr_range[j]) {
                        legs[curr_range[j]].pushBooking(bookings[i]);
                    }
                }
            }
            return legs;
        }

        function getLegIndices(legs) {
            var i,
                l,
                map = [];

            for (i = 0, l = legs.length; i < l; i += 1) {
                if (legs[i].legIndex || legs[i].legIndex === 0) {
                    map.push(i);
                }
            }
            return map;
        }

        function parseTrip(efa_trip, systemMessages, serverInfos) {
            var raw = null,
                legs,
                fares,
                bookings,
                map;

            if (!efa_trip.legs || !efa_trip.legs.length) {
                // only parse trips with at least one leg
                return null;
            }

            if (!isReady) {
                log.error('configuration is not yet read. please try again later.');
                return null;
            }

            if (options.keepRaw) {
                raw = MDVUtil.copy(efa_trip);
            }

            legs = parseLegs(efa_trip, serverInfos, options);
            map = getLegIndices(legs);
            fares = MDVEFAFareParser.parse(efa_trip.itdFare, map);
            bookings = parseBookings(efa_trip.bookings, map);
            assignFaresToLegs(legs, fares);
            assignBookingsToLegs(legs, bookings);

            if (options.combineWalkLegs) {
                legs = MDVEFAFormatter.combineWalkLegs(legs, MDVJourneyLeg);
            }

            return new MDVJourney({
                isAdditional : parseAdditional(efa_trip),
                numberOfTransfers : parseInt(efa_trip.interchange, 10),
                duration : MDVEFAFormatter.strDuration2Minutes(efa_trip.duration) * 60,
                distance : parseInt(efa_trip.distance, 10),
                fare : fares,
                bookings : bookings,
                properties : MDVEFAFormatter.parseGenAttrs(efa_trip.attrs),
                legs : legs,
                systemMessages : systemMessages,
                raw : raw
            });
        }

        function isInvalidResponse(response) {
            return !response.trips;
        }

        function parseSystemMessage(message) {
            var i, l, curr,
                data = {};

            for (i = 0, l = message.length; i < l; i += 1) {
                curr = message[i];

                if (curr.name === 'code') {
                    data.id = curr.value;
                } else if (curr.name === 'error') {
                    data.content = curr.value;
                } else if (curr.name === 'type') {
                    data.type = curr.value;
                } else if (curr.name === 'module') {
                    data.properties = {
                        module : curr.value
                    };
                }
            }

            return data;
        }

        function parseServerInfos(data) {
            var genAttrsObj = MDVEFAFormatter.parseGenAttrs(data.parameters);

            if (genAttrsObj.hasOwnProperty('serverID')) {
                return {
                    serverID : genAttrsObj.serverID
                };
            }
            return null;
        }

        function parseSystemMessages(data) {
            var messageList = data.messageList || [],
                result = [],
                i, l, curr, message;

            if (messageList.message) {
                messageList = [messageList];
            }

            for (i = 0, l = messageList.length; i < l; i += 1) {
                curr = messageList[i];

                if (curr.message) {
                    message = new MDVMessage(parseSystemMessage(curr.message));
                    if (message) {
                        result.push(message);
                    }
                }
            }

            // add datetime message as EFA does not add it to systemmessages
            if (data.dateTime && data.dateTime.message && data.dateTime.message.length) {
                message = parseSystemMessage(data.dateTime.message);
                if (message && !message.type) {
                    message.type = 'error';
                }
                message = new MDVMessage(message);
                if (message) {
                    result.push(message);
                }
            }

            return result;
        }

        function parse(response) {
            var trips = [],
                data = MDVUtil.copy(response),
                curr_trip,
                origin,
                destination,
                systemMessages,
                serverInfo,
                i,
                l;

            if (isInvalidResponse(data)) {
                return {
                    systemMessages : parseSystemMessages(data),
                    trips : trips
                };
            }
            systemMessages = parseSystemMessages(data);

            serverInfo = parseServerInfos(data);

            if (data.trips.hasOwnProperty('trip')) {
                data.trips = [data.trips.trip];
            }
            if (data.origin && data.origin.points && data.origin.points.point) {
                origin = data.origin.points.point;
            }
            if (data.destination && data.destination.points && data.destination.points.point) {
                destination = data.destination.points.point;
            }

            for (i = 0, l = data.trips.length; i < l; i += 1) {
                curr_trip = data.trips[i];
                if (origin) {
                    curr_trip.origin = origin;
                }
                if (destination) {
                    curr_trip.destination = destination;
                }

                curr_trip = parseTrip(curr_trip, systemMessages, serverInfo);

                if (curr_trip) {
                    // store original response as overallResponse
                    curr_trip.overallResponse = response;
                    trips.push(curr_trip);
                }
            }

            return {
                trips : trips,
                systemMessages : systemMessages
            };
        }

        return tripp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVEFATrip
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.xmljson.service:MDVEFARequester
     * @requires mng-comm.itd.xmljson.service:MDVEFATripParser
     * @description
     *
     * Main Service to get lists of journeys for a specific origin and destination.
     *
     * This service registers a {@link mng-comm.itd.service:MDVEFARequester MDVEFARequest} for
     * TRIP-purposes. This requester is used whenever the search method is called.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd-xmljson.MDVEFATrip`.
     *
     * As the `MDVEFATrip` service does not support any special parameters, please refer
     * to the {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester} service for detailed
     * configuration description.
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFATrip', MDVEFATrip);

    MDVEFATrip.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.xmljson.MDVEFATripParser', 'mng-comm.itd.MDVEFAOptionsParser'];

    function MDVEFATrip(MDVLog, MDVConfig, MDVEFARequester, MDVEFATripParser,
            MDVEFAOptionsParser) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFATrip'
            },
            log = MDVLog.register(_private.namespace),
            tripRequester,
            trip = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name search
         * @methodOf mng-comm.itd.xmljson.service:MDVEFATrip
         * @param {MDVLocation} origin {@link mng-model.object:MDVLocation MDVLocation} object
         * the journey should start at
         * @param {MDVLocation} destination {@link mng-model.object:MDVLocation MDVLocation} object
         * the journey should end at
         * @param {Object} options Additional options for the journey request
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVJourney MDVJourneys}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVJourneys MDVJourneys} service. It triggers a
         * XML_TRIP_REQUEST2 with the given locations and passes the response to the {@link
         * mng-comm.itd.xmljson.service:MDVEFATripParser MDVEFATripParser} to ensure that
         * a unified list of {@link mng-comm.service:MDVJourney MDVJourneys} is returned.
         */
        function search(origin, destination, options) {
            if (!origin.id() || !destination.id()) {
                return null;
            }
            var efa_opts = MDVEFAOptionsParser.parse(options);

            // assure that fares are in unifiedTicket format
            efa_opts.useUT = 1;

            // append origin/ destination
            efa_opts.name_destination = destination.id();
            efa_opts.name_origin = origin.id();
            efa_opts.type_destination = 'any';
            efa_opts.type_origin = 'any';

            return tripRequester.request(efa_opts)
                .then(function(response) {
                    return MDVEFATripParser.parse(response);
                });
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_TRIP_REQUEST2?',
                defaultParams : {},
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                trip._private = _private;
            }
        });


        // create customized requester object
        tripRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFATrip',
            _private.getDefaultConfigOption());

        return trip;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVEFAFareParser
     * @requires mng-util.service:MDVLog
     * @description
     *
     * Main Service to parse given EFA fare structures to a MDVFare model.
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAFareParser', MDVEFAFareParser);

    MDVEFAFareParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.MDVEFAFormatter',
        'mng-comm.itd.xmljson.MDVEFAUtil', 'mng-model.MDVTicket'];

    function MDVEFAFareParser(MDVLog, MDVEFAFormatter, MDVEFAUtil, MDVTicket) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFAFareParser'),
            farep = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function getPrice(efa_fare) {
            var price = MDVEFAUtil.getAttr(efa_fare.attrs, 'priceTotalFare');

            if (price) {
                return parseFloat(price);
            }
            if (efa_fare.priceBrutto !== '0.00') {
                return parseFloat(efa_fare.priceBrutto);
            }
            return parseFloat(efa_fare.priceNetto);
        }

        function getLegRange(fare, map) {
            var from = parseInt(fare.fromPR, 10),
                to = parseInt(fare.toPR, 10),
                result = [];

            for (; from <= to; from += 1) {
                result.push(map[from]);
            }
            return result;
        }

        function parseTicket(efa_fare, map) {
            var props = {
                id : efa_fare.id,
                price : getPrice(efa_fare),
                name : efa_fare.name,
                unit : efa_fare.currency,
                priceLevel : efa_fare.priceLevel,
                legRange : getLegRange(efa_fare, map),
                network : efa_fare.net,
                person : efa_fare.person,
                travellerClass : efa_fare.travellerClass,
                type : efa_fare.timeValidity,
                validity : {
                    area : efa_fare.nameValidityArea,
                    duration : parseInt(efa_fare.validMinutes, 10),
                    interchanges : parseInt(efa_fare.numberOfInterchanges, 10),
                    oneJourneyOnly : efa_fare.validForOneJourneyOnly,
                    oneOperatorOnly : efa_fare.validForOneOperatoryOnly,
                    returnsAllowed : efa_fare.returnsAllowed
                },
                distance : {
                    exact : parseInt(efa_fare.distExact, 10),
                    rounded : parseInt(efa_fare.distRounded, 10),
                    kmPrice : parseFloat(efa_fare.pricePerKM),
                    basicPrice : parseFloat(efa_fare.priceBasic)
                },
                properties : MDVEFAFormatter.parseGenAttrs(efa_fare.attrs)
            };

            return new MDVTicket(props);
        }
        function parseTickets(efa_fares, map) {
            var tickets = [],
                curr_ticket,
                i,
                l;

            if (!efa_fares || !efa_fares.fares) {
                return tickets;
            }
            if (efa_fares.fares.fare) {
                efa_fares.fares = [efa_fares.fares.fare];
            }
            if (efa_fares.fares) {
                for (i = 0, l = efa_fares.fares.length; i < l; i += 1) {
                    curr_ticket = parseTicket(efa_fares.fares[i], map);
                    if (curr_ticket) {
                        tickets.push(curr_ticket);
                    }
                }
            }
            return tickets;
        }
        function parseMultipleZones(zoneElems) {
            var i, l,
                zoneList = [];

            for (i = 0, l = zoneElems.length; i < l; i += 1) {
                if (zoneElems[i].hasOwnProperty('zone')) {
                    zoneList.push(zoneElems[i].zone);
                }
            }

            return zoneList;
        }
        function parseZoneList(zones) {
            var result = [],
                i, l;

            if (!zones) {
                return result;
            }
            if (zones.hasOwnProperty('zone')) {
                zones = [zones.zone];
            }
            for (i = 0, l = zones.length; i < l; i += 1) {
                if (zones[i].hasOwnProperty('zoneElems')) {
                    if (zones[i].zoneElems.hasOwnProperty('zoneElem')) {
                        zones[i].zoneElems = [zones[i].zoneElems.zoneElem];
                    }
                    result.push(parseMultipleZones(zones[i].zoneElems));
                }
            }
            return result;
        }
        function parseZone(efa_zone, map) {
            var zone = {
                isNeutralZone : efa_zone.neutralZone || false,
                network : efa_zone.net,
                legRange : getLegRange(efa_zone, map),
                zones : parseZoneList(efa_zone.zones)
            };

            if (efa_zone.itdCombinedTariffzones) {
                zone.combinedZones = parseZoneList(efa_zone.itdCombinedTariffzones.zones);
            }

            return zone;
        }
        function parseZones(efa_fares, map) {
            var zones = [],
                curr_zone,
                i,
                l;

            if (!efa_fares || !efa_fares.tariffZones) {
                return zones;
            }
            if (efa_fares.tariffZones.tariffZone) {
                efa_fares.tariffZones = [efa_fares.tariffZones.tariffZone];
            }
            for (i = 0, l = efa_fares.tariffZones.length; i < l; i += 1) {
                curr_zone = parseZone(efa_fares.tariffZones[i], map);
                if (curr_zone) {
                    zones.push(curr_zone);
                }
            }
            return zones;
        }

        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.xmljson.service:MDVEFAFareParser
         * @param {Object} efa_fares Fare object received in an EFA response
         * @param {Number[]} map mapping array that maps from efa-leg index to leg index including
         * transfer legs
         * @returns {Object} Object that contains a list of {@link mng-model.object:MDVTicket
         * MDVTickets} and a list of {@link mng-model.object:MDVTariffZones MDVTariffZones}
         *
         * @description
         * This method parses a given efa fare structure to a list of {@link
         * mng-model.object:MDVTicket MDVTickets} and a list of {@link
         * mng-model.object:MDVTariffZones MDVTariffZones}.
         */
        function parse(efa_fares, map) {
            return {
                tickets : parseTickets(efa_fares, map),
                zones : parseZones(efa_fares, map)
            };
        }

        return farep;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFASTTParser', MDVEFASTTParser);

    MDVEFASTTParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.xmljson.MDVFileParser',
        'mng-comm.itd.MDVEFAFormatter'];

    function MDVEFASTTParser(MDVLog, MDVFileParser, MDVEFAFormatter) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFASTTParser'),
            sttp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response, lineID, stopID) {
            var fileProps = {
                    input : get_input(lineID, stopID),
                    url : response.itdDownload.itdDownloadFile.src,
                    size : convert_to_int(response.itdDownload.itdDownloadFile.size),
                    stream : response.stream,
                    raw : response
                },
                genAttrsObj = MDVEFAFormatter.parseGenAttrs(response.parameters),
                serverInfo;

            if (genAttrsObj.hasOwnProperty('serverID')) {
                serverInfo = {
                    serverID : genAttrsObj.serverID
                };
            }

            return MDVFileParser.parse(fileProps, serverInfo);
        }

        function get_input(lineID, stopID) {
            return 'STT_'.concat(lineID || '').concat(stopID || '');
        }

        function convert_to_int(str) {
            var nbr = parseInt(str, 10);

            if (!nbr) {
                return 0;
            }
            return nbr;
        }

        return sttp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFASTT', MDVEFASTT);

    MDVEFASTT.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-comm.itd.xmljson.MDVEFASTTParser',
        'mng-util.MDVException', 'mng-comm.itd.MDVEFAOptionsParser'];


    function MDVEFASTT(MDVLog, MDVUtil, MDVConfig, MDVEFARequester, MDVEFASTTParser, MDVException,
            MDVEFAOptionsParser) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFASTT',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            sttRequester,
            stt = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                params;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            params = MDVEFAOptionsParser.parse(options);
            if (!params) {
                params = {};
            }
            params = angular.extend({}, params, addSearchParams(options), true);

            _private.running_xhr = sttRequester.request(params)
                .then(function(response) {
                    if (!response || response.length === 0 ||
                            !response.itdDownload || !response.itdDownload.itdDownloadFile ||
                            !response.itdDownload.itdDownloadFile.src) {

                        throw new MDVException(MDVException.keys.MNG_COMM__STT.SERVICE_FAILED, {
                            input : options,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;
                    var result = MDVEFASTTParser.parse(response, options.lineId, options.stopId);

                    return result;
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_STT_REQUEST?',
                defaultParams : {
                    mode : 'direct',
                    allStopInfo : 1
                },
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function addSearchParams(options) {
            var params = options.efaParams || {};

            params.line = options.lineId;
            params.name_stt = options.stopId;
            params.type_stt = 'stopID';
            params.mode = 'direct';

            return params;
        }

        function isReady(options) {
            var reasons = [];

            if (!options.lineId) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__STT.INVALID_INPUT, {
                    reason : 'lineId missing'
                }));
            }
            if (!options.stopId) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__STT.INVALID_INPUT, {
                    reason : 'stopId missing'
                }));
            }

            return reasons;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                stt._private = _private;
            }
        });

        // create customized requester object
        sttRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFASTT',
            _private.getDefaultConfigOption());

        return stt;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAStopSeqCoordParser', MDVEFAStopSeqCoordParser);

    MDVEFAStopSeqCoordParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.xmljson.MDVLocationParser'];

    function MDVEFAStopSeqCoordParser(MDVLog, MDVLocationParser) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFAROPParser'),
            ropParser = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response, location) {
            var efaStopSeqArr = [],
                prevStopSeq = [],
                onwardStopSeq = [],
                i,
                stopSeqLoc,
                depDiff;


            if (response && response.stopSeqCoords && response.stopSeqCoords.params &&
                    response.stopSeqCoords.params.stopSeq) {

                efaStopSeqArr = response.stopSeqCoords.params.stopSeq;

                for (i=0; i<efaStopSeqArr.length; i += 1) {
                    stopSeqLoc = MDVLocationParser.parse(efaStopSeqArr[i], 'stopseq');
                    depDiff = location.departureTime().diff(stopSeqLoc.departureTime(), 'seconds');

                    if (depDiff > 0) {
                        prevStopSeq.push(stopSeqLoc);
                    } else {
                        onwardStopSeq.push(stopSeqLoc);
                    }
                }

            }

            return {
                prevStopSeq : prevStopSeq,
                onwardStopSeq : onwardStopSeq
            };
        }

        return ropParser;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAStopSeqCoord', MDVEFAStopSeqCoord);

    MDVEFAStopSeqCoord.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-comm.itd.xmljson.MDVEFAStopSeqCoordParser',
            'mng-util.MDVException', 'mng-util.MDVUtil', 'mng-comm.itd.MDVEFAOptionsParser'];


    function MDVEFAStopSeqCoord(MDVLog, MDVConfig, MDVEFARequester, MDVEFAStopSeqCoordParser,
            MDVException, MDVUtil, MDVEFAOptionsParser) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFAStopSeqCoord',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            sscRequester,
            ssc = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(location, transportation, options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(location, transportation),
                efa_opts,
                params;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            efa_opts = MDVEFAOptionsParser.parse(options);

            params = addSearchParams(location, transportation, efa_opts);

            _private.running_xhr = sscRequester.request(params)
                .then(function(response) {
                    if (!response || response.length === 0 ||
                            !response.stopSeqCoords || !response.stopSeqCoords.params ||
                            !response.stopSeqCoords.params.stopSeq ||
                            !response.stopSeqCoords.params.stopSeq.length === 0) {
                        throw new MDVException(MDVException.keys.MNG_COMM__STOPSEQCOORD.SERVICE_FAILED, {
                            args : [location, transportation, options],
                            service : 'mng-comm.itd.xmljson.MDVEFAStopSeqCoord',
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;
                    var result = MDVEFAStopSeqCoordParser.parse(response, location);

                    return result;
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_STOPSEQCOORD_REQUEST?',
                defaultParams : {},
                cache : true
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function isReady(location, transportation) {
            var reasons = [];

            if (!location || !location.id()) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__STOPSEQCOORD.INVALID_INPUT, {
                    reason : 'locationId missing'
                }));
            }

            if (!transportation || !transportation.id()) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__STOPSEQCOORD.INVALID_INPUT, {
                    reason : 'lineId missing'
                }));
            }

            return reasons;
        }

        function addSearchParams(location, transportation, options) {
            var params = (options && options.efaParams)?options.efaParams:{};

            params = MDVEFAOptionsParser.parse(options);

            params.line = transportation.id();
            params.stop = location.id();
            params.tripCode = transportation.properties().tripCode;
            params.time = options.itdTime;
            params.date = options.itdDate;

            return params;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                ssc._private = _private;
            }
        });

        // create customized requester object
        sscRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFAStopSeqCoord',
            _private.getDefaultConfigOption());

        return ssc;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVEFAStopfinderParser
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.xmljson.service:MDVLocationParser
     *
     * @description
     * The `MDVEFAStopfinderParser` parses given EFA information of a XML_STOPFINDER_REQUEST
     * response to a list of {@link mng-model.object:MDVLocation MDVLocations}.
     *
     * This parser is used by the {@link mng-comm.itd.xmljson.service:MDVEFAStopfinder MDVEFAStopfinder}
     * service to parse the returned http-response to a normalized list.
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAStopfinderParser', MDVEFAStopfinderParser);

    MDVEFAStopfinderParser.$inject = ['mng-util.MDVLog',
        'mng-comm.itd.xmljson.MDVLocationParser'];

    function MDVEFAStopfinderParser(MDVLog, MDVLocationParser) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFAStopfinderParser'),
            sfp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.xmljson.service:MDVEFAStopfinderParser
         *
         * @description
         * Parse a XML_STOPFINDER_REQUEST-response object to a list of point objects. This is done
         * by extracting the point information and passing it to the parse function of the {@link
         * mng-comm.itd.xmljson.service:MDVLocationParser MDVLocationParser}.
         *
         * @param {Object} response Json formatted response provided by a XML_STOPFINDER_REQUEST.
         * @returns {MDVLocation[]} List of all parsed {@link mng-model.object:MDVLocation
         * MDVLocation} objects provided by the EFA.
         */
        function parse(response) {
            var result = [],
                type;

            if (response && response.stopFinder && response.stopFinder.points) {
                type = 'sf';
                if (response.stopFinder.points.point) {
                    response.stopFinder.points = [response.stopFinder.points.point];
                }
            } else if (response && response.stopFinder && response.stopFinder.pois) {
                type = 'poi';
                if (response.stopFinder.pois.poi) {
                    response.stopFinder.points = [response.stopFinder.pois.poi];
                } else {
                    response.stopFinder.points = response.stopFinder.pois;
                }
            } else {
                log.debug('no points or pois to parse found in response object');
                return result;
            }

            // for more than one point
            angular.forEach(response.stopFinder.points, function(point) {
                point.searchValue = response.stopFinder.input.input;
                result.push(MDVLocationParser.parse(point, type));
            });

            return result;
        }

        return sfp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVEFAStopfinder
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFARequester
     * @requires mng-comm.itd.xmljson.service:MDVEFAStopfinderParser
     * @requires mng-util.object:MDVException
     *
     * @description
     * The `MDVEFAStopfinder` service implements the interface for {@link
     * mng-comm.service:MDVLocationRequester MDVLocationRequester} and uses the MENTZ-EFA
     * interface to resolve a given name to a list of {@link mng-model.object:MDVLocation
     * MDVLocations}.
     *
     * This service registers a {@link mng-comm.itd.service:MDVEFARequester MDVEFARequest} for
     * stop-finder purposes. This requester is used whenever the search method is called.
     *
     * ```js
     *   // Simple search request
     *   MDVEFAStopfinder
     *      .search('main')
     *      .then(function successCallback(response) {
     *          // this callback will be called asynchronously
     *          // when the response is available
     *     }, function errorCallback(response) {
     *          // called asynchronously if an error occurs
     *          // or server returns response with an error status.
     *     });
     * ```
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd-xmljson.MDVEFAStopfinder`.
     *
     * As the `MDVEFAStopfinder` service does not support any special parameters, please refer
     * to the {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester} service for detailed
     * configuration description.
     *
     *
     *  @example
<example module="MDVEFAStopfinderExample">
<file name="index.html">
  <div ng-controller="MDVEFAStopfinderController">
    <label>
        <input ng-model="sugValue" placeholder="type name"/>
    </label>

    <div ng-show="suggestions && suggestions.length > 0">
        Suggestions found for input "{{sugValue}}":
       <ul><li ng-repeat="point in suggestions track by $index">{{point.name()}}</li></ul>
    </div>
  </div>
</file>
<file name="script.js">
  angular.module('MDVEFAStopfinderExample', ['angularMoment', 'mng-config', 'mng-comm.itd.xmljson'])
    .run(['mng-config.MDVConfig', function(MDVConfig) {
        MDVConfig.setValue('mng-comm-itd.MDVEFARequester', {
            'url' : '/mngnsw'
        });
        MDVConfig.setValue('mng-comm-itd-xmljson.MDVEFAStopfinder', {
              url: '/XML_STOPFINDER_REQUEST?',
              defaultParams: {
                  outputFormat: 'json',
                  coordOutputFormat: 'EPSG:4326',
                  anyObjFilter_sf: 2,
                  odvSuggestMacro: 'beg',
                  locationServerActive: 1,
                  prMinQu: 1,
                  type_sf: 'any',
                  w_prefStModesAm: [3, 1],
                  w_regPrefAl: 1
              }
        });
    }])
    .controller('MDVEFAStopfinderController', ['$scope', 'mng-comm.itd.xmljson.MDVEFAStopfinder',
            function ($scope, MDVEFAStopfinder) {
                $scope.sugValue = 'town';
                $scope.suggestions = [];

                $scope.$watch('sugValue', function () {
                    MDVEFAStopfinder.search($scope.sugValue)
                        .then(function (response) {
                            // received list. append it to scope.
                            // please note that this response is a single list, whereas the
                            // response of the MDVLocationRequester service is an object that contains
                            // a list property with the same information.
                            $scope.suggestions = response;
                        })
                        .catch(function (response) {
                            // something went wrong
                            $scope.suggestions = [];
                        })
                });
            }]);
</file>
</example>
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAStopfinder', MDVEFAStopfinder);

    MDVEFAStopfinder.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-util.MDVUtil',
        'mng-comm.itd.MDVEFARequester', 'mng-comm.itd.MDVEFAFormatter',
        'mng-comm.itd.xmljson.MDVEFAStopfinderParser', 'mng-util.MDVException'];

    function MDVEFAStopfinder(MDVLog, MDVConfig, MDVUtil, MDVEFARequester, MDVEFAFormatter,
            MDVEFAStopfinderParser, MDVException) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFAStopfinder',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            sfRequester,
            sf = {
                searchByName : searchByName,
                searchByCoordinate : searchByCoordinate
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name search
         * @methodOf mng-comm.itd.xmljson.service:MDVEFAStopfinder
         * @param {String|Number[]} input Name that should be resolved to a suggestion list. It is
         * also possible to pass a coordinate (Format: [lat, lng]). Please refer to the
         * options.coordFormat for further detail on the coordinate input. The provided
         * input is directly passed to the sub-service's implementation of `search(input)`.
         * @param {Object=} [options={}] Options object to change the service to request in its
         * default way.
         * @param {String=} options.coordFormat format-code the given coordinate is passed with. If
         * no coordFormat is passed, the plugin assumes that the coordinate format is EPSG:4326
         * (WGS84).
         * @param {Object=} options.parameters Options that should be used for this request.
         * Needs to be in the same format the internal {@link mng-config.service:MDVConfig
         * MDVConfig}. See the
         * configuration that is loaded in the {@link mng-config.service:MDVConfig MDVConfigFetcher}
         * for further details on structuring. This options override the default configuration for
         * this single search request, but leave the default configuration untouched.
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVLocation MDVLocations}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVLocationRequester MDVLocationRequester} service. It triggers a
         * XML_STOPFINDER_REQUEST with the given input and passes the response to the {@link
         * mng-comm.itd.xmljson.service:MDVEFAStopfinderParser MDVEFAStopfinderParser} to ensure
         * that a unified list of {@link mng-model.object:MDVLocation MDVLocations} is returned in
         * the response object.
         */
        function search(input, options) {
            if (!isValidInput(input)) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG_COMM__LS.INVALID_INPUT, {
                        input : input,
                        reason : 'invalid input format'
                    })
                );
            }
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            if (!options) {
                options = {};
            }
            var params = addSearchParams(input, options);

            if (!params.name_sf) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG_COMM__LS.INVALID_INPUT, {
                        input : input,
                        reason : 'unable to parse input'
                    })
                );
            }
            _private.running_xhr = sfRequester.request(params, getDefParamsKey(params))
                .then(function(response) {
                    _private.running_xhr = null;
                    return MDVEFAStopfinderParser.parse(response);
                });
            return _private.running_xhr;
        }

        function searchByName(input, options) {
            return search(input, options);
        }

        function searchByCoordinate(input, options) {
            return search(input, options);
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_STOPFINDER_REQUEST?',
                defaultParams : {},
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }
        function raiseTypeOverrideWarning(passedValue) {
            if (passedValue) {
                passedValue = 'override given type_sf="' + passedValue + '"';
            } else {
                passedValue = 'changed type_sf';
            }
            log.warn(passedValue +
                        ' parameter to type_sf="coord" as passed input is a coordinate ' +
                        'instead of a string input');
        }
        function addSearchParams(input, options) {
            var coord_str,
                params = MDVUtil.copy(options.efaParams || {});

            if (typeof input === 'string') {
                // might do a string check if it is a coordinatestring here

                // normal input name
                params.name_sf = input;
                if (!params.type_sf) {
                    params.type_sf = 'any';
                }
                return params;
            }

            // assume input is a coordinate
            coord_str = MDVEFAFormatter.latlng2string(input, options.coordFormat);
            if (coord_str !== '') {
                params.name_sf = 'coord:' + coord_str;
                if (!params.type_sf || params.type_sf !== 'any') {
                    raiseTypeOverrideWarning(params.type_sf);
                    params.type_sf = 'any';
                }
            }
            return params;
        }
        function getDefParamsKey(params) {
            if (!params || !params.type_sf || (params.type_sf === 'any')) {
                return '';
            }
            return params.type_sf;
        }

        function isValidInput(input) {
            // invalid if no string or not convertable to a coordinate
            return ((typeof input !== 'string' && !(input instanceof String)) ||
                (MDVEFAFormatter.latlng2string(input) === ''));

        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                sf._private = _private;
            }
        });

        // create customized requester object
        sfRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFAStopfinder',
            _private.getDefaultConfigOption());

        return sf;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFASELTTParser', MDVEFASELTTParser);

    MDVEFASELTTParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.xmljson.MDVTransportationParser'];

    function MDVEFASELTTParser(MDVLog, MDVTransportationParser) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFASELTTParser'),
            selttp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////


        function parseLines(efaLines) {
            var lines = [];

            angular.forEach(efaLines, function(efaLine) {
                lines.push(MDVTransportationParser.parse(efaLine.mode, 'seltt'));
            });

            return lines;
        }

        function parse(response) {
            return parseLines(response.modes);
        }

        return selttp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFASELTT', MDVEFASELTT);

    MDVEFASELTT.$inject = ['$q', 'mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-model.MDVLocation',
        'mng-comm.itd.xmljson.MDVEFAUtil', 'mng-comm.itd.xmljson.MDVEFASELTTParser',
        'mng-comm.itd.MDVEFAOptionsParser', 'mng-util.MDVUtil', 'mng-util.MDVException'];


    function MDVEFASELTT($q, MDVLog, MDVConfig, MDVEFARequester, MDVLocation, MDVEFAUtil,
                        MDVEFASELTTParser, MDVEFAOptionsParser, MDVUtil, MDVException) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFASELTT'
            },
            log = MDVLog.register(_private.namespace),
            selttRequester,
            seltt = {
                searchLines : searchLines
            };

        log.debug('initialize');

        // ////////////////////////////////

        function searchLines(input, options) {
            if (options.type === 'STT' || options.type === 'DM') {
                options.efaParams.mergeDir = 0;
                if (options.type === 'STT') {
                    options.efaParams.depArrBoth = 'departures';
                }
            }
            var reasons = isReady(input, options);

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            return request(input, options)
                .then(function(response) {
                    response.map(function(el) {
                        el.isSTTLine = options.type === 'STT' ? true : false;
                        return el;
                    });
                    return response;
                });
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_SELTT_REQUEST?',
                defaultParams : {
                    mode : 'line',
                    mergeProj : 0
                },
                cache : true
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function getReqType(outputType) {
            outputType = outputType.toUpperCase();

            if (outputType === 'DM') {
                return 1;
            }
            if (outputType === 'STT') {
                return 2;
            }
            if (outputType === 'TTB') {
                return 4;
            }
            if (outputType === 'ROP') {
                return 8;
            }
            if (outputType === 'ZOB') {
                return 16;
            }
            log.warn('invalid outputType passed: ' + outputType +
                                                    '. Valid types are: DM, STT, TTB, ROP and ZOB');
            return 0;
        }


        function addSearchParams(params, input, options) {
            var reqType = 0,
                i,
                l;

            if (input instanceof MDVLocation) {
                params.name_seltt = input.id();
                params.type_seltt = 'any';
            } else if (typeof input === 'string') {
                params.lineName = input;
            } // else if operater input is needed

            if (options && options.type) {
                if (options.type.constructor === Array) {
                    for (i = 0, l = options.type.length; i < l; i += 1) {
                        reqType += getReqType(options.type[i]);
                    }
                } else {
                    reqType = getReqType(options.type);
                }
                if (reqType) {
                    params.lineReqType = reqType;
                }
            }

            return params;
        }

        function request(input, options) {
            var efa_opts = MDVEFAOptionsParser.parse(options);

            efa_opts = addSearchParams(efa_opts, input, options);

            // send new request
            return selttRequester.request(efa_opts)
                .then(function(response) {
                    return MDVEFASELTTParser.parse(response);
                });
        }

        function isReady(input) {
            var reasons = [];

            if (!input) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.NO_INPUT, {
                    reason : 'no element passed to the search method'
                }));
            } else if (typeof input !== 'string' && !(input instanceof MDVLocation)) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.NO_INPUT, {
                    input : input,
                    reason : 'invalid type. expected string or MDVLocation'
                }));
            }
            return reasons;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                seltt._private = _private;
            }
        });

        // create customized requester object
        selttRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFASELTT',
            _private.getDefaultConfigOption());

        return seltt;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAROPParser', MDVEFAROPParser);

    MDVEFAROPParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.xmljson.MDVFileParser',
                                'mng-comm.itd.xmljson.MDVTransportationParser',
                                'mng-comm.itd.MDVEFAFormatter'];

    function MDVEFAROPParser(MDVLog, MDVFileParser, MDVTransportationParser, MDVEFAFormatter) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFAROPParser'),
            ropParser = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response, opts) {
            var efaLines,
                lines = [],
                fileProps,
                genAttrsObj,
                serverInfo;

            if (response && response.itdDownload && response.itdDownload.itdDownloadFile) {
                fileProps = {
                    input : 'ROP_' + (opts.lineId || opts.stopId),
                    url : response.itdDownload.itdDownloadFile.src,
                    size : convert_to_int(response.itdDownload.itdDownloadFile.size),
                    stream : response.stream,
                    raw : response
                };
                genAttrsObj = MDVEFAFormatter.parseGenAttrs(response.parameters);

                if (genAttrsObj.hasOwnProperty('serverID')) {
                    serverInfo = {
                        serverID : genAttrsObj.serverID
                    };
                }

                return MDVFileParser.parse(fileProps, serverInfo);
            } else if (response && response.servingLines && response.servingLines.lines) {
                efaLines = response.servingLines.lines;
                angular.forEach(efaLines, function(efaLine) {
                    lines.push(MDVTransportationParser.parse(efaLine, 'DMline'));
                });
                return lines;
            }
        }


        function convert_to_int(str) {
            var nbr = parseInt(str, 10);

            if (!nbr) {
                return 0;
            }
            return nbr;
        }

        return ropParser;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAROP', MDVEFAROP);

    MDVEFAROP.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-comm.itd.MDVEFARequester',
                        'mng-comm.itd.xmljson.MDVEFAROPParser', 'mng-util.MDVException',
                        'mng-util.MDVUtil'];


    function MDVEFAROP(MDVLog, MDVConfig, MDVEFARequester, MDVEFAROPParser, MDVException, MDVUtil) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFAROP',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            ropRequester,
            rop = {
                search : search,
                searchLines : searchLines
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                params;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            params = addSearchParams(options);

            _private.running_xhr = ropRequester.request(params)
                .then(function(response) {
                    if (!response || response.length === 0 ||
                            !response.itdDownload || !response.itdDownload.itdDownloadFile ||
                            !response.itdDownload.itdDownloadFile.src) {
                        throw new MDVException(MDVException.keys.MNG_COMM__ROP.SERVICE_FAILED, {
                            args : options,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;
                    var result = MDVEFAROPParser.parse(response, options);

                    return result;
                });
            return _private.running_xhr;
        }

        function searchLines(input, options, type) {
            if (type && type!=='ROP') {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG_COMM__ROP.INVALID_INPUT, {
                        input : input,
                        reason : 'invalid type'
                    })
                );
            }
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var params = options && options.efaParams;

            if (!params) {
                params = {};
            }

            if (typeof input === 'object' && input.hasOwnProperty('id')) {
                // location
                params.mode = 'odv';
                params.type_rop = 'any';
                params.name_rop = input.id();
            } else {
                params.lineName = input;
                params.mode = 'line';
            }

            _private.running_xhr = ropRequester.request(params)
                .then(function(response) {
                    if (!response || response.length === 0 ||
                        !response.servingLines || !response.servingLines.lines) {
                        throw new MDVException(MDVException.keys.MNG_COMM__ROP.SERVICE_FAILED, {
                            args : input,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;
                    var result = MDVEFAROPParser.parse(response);

                    return result;
                });
            return _private.running_xhr;
        }


        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_ROP_REQUEST?',
                defaultParams : {

                },
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function isReady(options) {
            var reasons = [];

            if (!options.lineId && !options.stopId) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__ROP.INVALID_INPUT, {
                    reason : 'lineId/stopId missing'
                }));
            }

            return reasons;
        }

        function addSearchParams(options) {
            var params = options.efaParams || {};

            if (options.lineId) {
                params.line = options.lineId;
                params.command = 'direct';
            } else if (options.stopId) {
                params.mode='odv';
                params.reqType = 'spa';
                params.type_rop = 'any';
                params.placeInfo_rop = 'invalid';
                params.nameValue_rop = options.stopId;
            }

            return params;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                rop._private = _private;
            }
        });

        // create customized requester object
        ropRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFAROP',
            _private.getDefaultConfigOption());

        return rop;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAPSParser', MDVEFAPSParser);

    MDVEFAPSParser.$inject = ['mng-util.MDVLog', 'mng-model.MDVFile'];

    function MDVEFAPSParser(MDVLog, MDVFile) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFAPSParser'),
            psp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response, origin, destination) {
            var fileProps = {
                input : get_file_input(origin, destination),
                url : response.printControl.itdDownload.itdDownloadFile.src,
                size : convert_to_int(response.printControl.itdDownload.itdDownloadFile.size),
                stream : response.printControl.stream,
                raw : response
            };

            return new MDVFile(fileProps);
        }


        function convert_to_int(str) {
            var nbr = parseInt(str, 10);

            if (!nbr) {
                return 0;
            }
            return nbr;
        }

        function get_file_input(origin, destination) {
            return ('PS_')
                .concat(origin.name())
                .concat(' # ')
                .concat(destination.name());
        }

        return psp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAPS', MDVEFAPS);

    MDVEFAPS.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-util.MDVUtil',
        'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.xmljson.MDVEFAPSParser', 'mng-util.MDVException',
        'mng-comm.itd.MDVEFAOptionsParser'];


    function MDVEFAPS(MDVLog, MDVConfig, MDVUtil, MDVEFARequester, MDVEFAPSParser, MDVException,
            MDVEFAOptionsParser) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFAPS',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            psRequester,
            ps = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                params;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            params = MDVEFAOptionsParser.parse(options);

            if (!params) {
                params = {};
            }
            params = addSearchParams(options.origin, options.destination, params);

            _private.running_xhr = psRequester.request(params)
                .then(function(response) {
                    if (!response || response.length === 0 ||
                            !response.printControl || !response.printControl.itdDownload ||
                            !response.printControl.itdDownload.itdDownloadFile ||
                            !response.printControl.stream ||
                            response.printControl.stream.length === 0) {

                        throw new MDVException(MDVException.keys.MNG_COMM__PS.SERVICE_FAILED, {
                            args : options,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;
                    var result = MDVEFAPSParser.parse(response, options.origin, options.destination);

                    return result;
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_PS_REQUEST2?',
                defaultParams : {

                },
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function reject_xhr(xhr) {
            if (xhr &&
                xhr._httpTimeout &&
                xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function addSearchParams(origin, destination, params) {
            params.nameInfo_origin = origin.id();
            params.nameInfo_destination = destination.id();
            params.name_origin = origin.name();
            params.name_destination = destination.name();
            params.type_origin = 'any';
            params.type_destination = 'any';

            return params;
        }

        function isReady(options) {
            var reasons = [];

            if (!options.origin) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__JOURNEY.NO_ORIGIN));
            }
            if (!options.destination) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__JOURNEY.NO_DESTINATION));
            }

            return reasons;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                ps._private = _private;
            }
        });

        // create customized requester object
        psRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFAPS',
            _private.getDefaultConfigOption());

        return ps;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAPrintTripParser', MDVEFAPrintTripParser);

    MDVEFAPrintTripParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.xmljson.MDVFileParser',
        'mng-comm.itd.MDVEFAFormatter'];

    function MDVEFAPrintTripParser(MDVLog, MDVFileParser, MDVEFAFormatter) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFAPrintTripParser'),
            ptParser = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response, id) {
            if (!response || !response.trip || !response.trip.itdDownload ||
                !response.trip.itdDownload.itdDownloadFile ||
                !response.trip.itdDownload.itdDownloadFile.src) {
                return null;
            }

            var fileProps = {
                    input : 'PRINT_TRIP_' + (id?id:Date.now()),
                    stream : response.trip.stream,
                    url : response.trip.itdDownload.itdDownloadFile.src,
                    size : response.trip.itdDownload.itdDownloadFile.size,
                    type : 'PS'
                },
                genAttrsObj = MDVEFAFormatter.parseGenAttrs(response.parameters),
                serverInfo;

            if (genAttrsObj.hasOwnProperty('serverID')) {
                serverInfo = {
                    serverID : genAttrsObj.serverID
                };
            }

            return MDVFileParser.parse(fileProps, serverInfo);
        }

        return ptParser;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAPrintTrip', MDVEFAPrintTrip);

    MDVEFAPrintTrip.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-util.MDVUtil',
        'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.xmljson.MDVEFAPrintTripParser', 'mng-util.MDVException'];


    function MDVEFAPrintTrip(MDVLog, MDVConfig, MDVUtil, MDVEFARequester, MDVEFAPrintTripParser,
            MDVException) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFAPrintTrip',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            prRequester,
            mr = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                postObj;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            postObj = getPostObj(options);

            _private.running_xhr = prRequester.request(postObj)
                .then(function(response) {
                    if (!response ||
                            !response.trip ||
                            !response.trip.itdDownload ||
                            !response.trip.itdDownload.itdDownloadFile ||
                            !response.trip.itdDownload.itdDownloadFile.src) {

                        throw new MDVException(MDVException.keys.MNG_COMM__TTB.SERVICE_FAILED, {
                            options : options,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;

                    return MDVEFAPrintTripParser.parse(response);
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/JSON_TRIPRELATION_REQUEST?',
                defaultParams : {},
                cache : false,
                // do not override
                requestType : 'post'
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function getPostObj(options) {
            var i,
                obj = {},
                trips = [];

            if (options.hasOwnProperty('journey')) {
                obj = options.journey.overallResponse;
                trips = [options.journey.raw()];
            } else if (options.hasOwnProperty('journeys')) {
                obj = options.journeys[0].overallResponse;
                for (i=0; i<options.journeys.length; i+=1) {
                    trips.push(options.journeys[i].raw());
                }
            }

            obj.trips = trips;

            obj.params = options.efaParams || {};

            if (!obj.params.design) {
                obj.params.design = 'detail';  // 'overview'
            }

            return obj;
        }

        function isReady(options) {
            var reasons = [];

            if (!options.journey && !options.journeys) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                    reason : 'journey(s) missing'
                }));
            }
            return reasons;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                mr._private = _private;
            }
        });

        // create customized requester object
        prRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFAPrintTrip',
            _private.getDefaultConfigOption());

        return mr;
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVTransportationParser
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-model.object:MDVTransportation
     * @requires 'mng-comm.itd.xmljson.service:MDVLocationParser
     * @description
     *
     * Parse EFA response information of Lines to a EFAMOT object
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVTransportationParser', MDVTransportationParser);

    MDVTransportationParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.MDVEFAFormatter',
        'mng-model.MDVTransportation', 'mng-model.MDVLocation',
        'mng-comm.itd.xmljson.MDVLocationParser', 'mng-comm.itd.xmljson.MDVEFAUtil'];

    function MDVTransportationParser(MDVLog, MDVEFAFormatter, MDVTransportation, MDVLocation,
            MDVLocationParser, MDVEFAUtil) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVTransportationParser'),
            motp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////
        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.xmljson.service:MDVTransportationParser
         * @param {Object} efaMOT the efa 'line' object
         * @param {String} formatType a key for line type that can have one of the following values
         * ['DMdep', 'DMarr', 'DMline', 'TRIPleg']
         * @returns {MDVTransportation} MDVTransportation new parsed {@link mng-model.object:MDVTransportation
         * MDVTransportation} object
         *
         * @description
         * Depending on the line formatType, this method uses the corresponding helper method to parse
         * the EFA line object to {@link mng-model.object:MDVTransportation MDVTransportation}
         */
        function parse(efaMOT, formatType) {
            var props;

            if (!efaMOT) {
                return null;
            }

            if (formatType === 'DMdep' || formatType === 'DMarr') {
                props = parseDMDepProperties(efaMOT);
            } else if (formatType === 'DMline') {
                props = parseDMLineProperties(efaMOT.mode);
            } else if (formatType === 'TRIPleg') {
                props = parseTripLegProperties(efaMOT);
            } else if (formatType === 'geo') {
                props = parseGeoProperties(efaMOT);
            } else if (formatType === 'geoselline') {
                props = parseGeoSelLineProperties(efaMOT);
            } else if (formatType === 'seltt') {
                props = parseSELTTProperties(efaMOT);
            } else if (formatType === 'LP') {
                props = parseLivePositionProperties(efaMOT);
            } else {
                // props = parseMOTProperties(efaMOT);
                props = null;
            }
            if (props) {
                props.raw = efaMOT;
                return new MDVTransportation(props);
            }
            return null;
        }

        // /**
        //  * @ngdoc method
        //  * @name parseDMdDpProperties
        //  * @description
        //  * Parse MOT Properties out of an DM-DepartureList ServingLine EFA response
        //  * object.
        //  * @private
        //  * @methodOf mng-comm.itd.xmljson.service:MDVTransportationParser
        //  * @param {Object} mot - EFA response object containing the MOT information
        //  * @returns {Object} A normalized parameter object that can be passed on to a
        //  * MDVTransportation object
        //  */
        function parseDMDepProperties(mode) {
            var props = {
                origin : new MDVLocation({
                    name : mode.directionFrom,
                    type : MDVLocation.LOCATIONTYPES.STOP
                }),
                destination : new MDVLocation({
                    name : mode.direction,
                    id : mode.destID,
                    type : MDVLocation.LOCATIONTYPES.STOP
                }),
                id : mode.stateless,
                iconId : parseInt(mode.productId, 10),
                name : mode.symbol,
                number : mode.number,
                routeDescription : mode.desc,
                product : {
                    'class' : parseInt(mode.motType, 10),
                    name : mode.name,
                    iconId : parseInt(mode.code, 10)
                },
                hints : mode.hints,
                properties : {
                    tripCode : mode.tripCode,
                    network : mode.network,
                    trainType : mode.trainType
                }
            };

            if (mode.operator) {
                props.operator = {
                    name : mode.operator.name,
                    id : mode.operator.code
                };
            }
            if (mode.delay && mode.delay === '-9999') {
                props.isCancelled = true;
            }

            return props;
        }

        function parseSELTTProperties(mode) {
            var props = {
                destination : new MDVLocation({
                    name : mode.destination,
                    id : mode.destID,
                    type : MDVLocation.LOCATIONTYPES.STOP
                }),
                id : mode.diva.stateless,

                name : mode.name,
                number : mode.number,
                routeDescription : mode.desc,
                product : {
                    'class' : parseInt(mode.type, 10),
                    name : mode.product,
                    iconId : parseInt(mode.code, 10)
                },
                periodFrom : MDVEFAFormatter.date2moment(mode.diva.vF, 'YYYYMMDD', true),
                periodTo : MDVEFAFormatter.date2moment(mode.diva.vTo, 'YYYYMMDD', true),
                properties : {
                    // tripCode : mode.tripCode,
                    // trainType : mode.trainType,
                    network : mode.diva.network,
                    timetablePeriod : mode.timetablePeriod,
                    lineVersion : mode.diva.spTr,
                    ttb: mode.diva.isTTB
                }
            };

            if (mode.diva.operator && mode.diva.opCode) {
                props.operator = {
                    name : mode.diva.operator,
                    id : mode.diva.opCode
                };
            }
            return props;
        }

        function parseLivePositionProperties(mode) {
            return {
                origin : new MDVLocation({
                    id : cleanLivePositionId(mode.CurrentStop),
                    type : MDVLocation.LOCATIONTYPES.STOP,
                    coord : MDVEFAFormatter.str2latlng(
                            cleanCoords(mode.XPrevious) +','+ cleanCoords(mode.YPrevious))
                }),
                destination : new MDVLocation({
                    name : mode.DirectionText,
                    id : cleanLivePositionId(mode.NextStop),
                    type : MDVLocation.LOCATIONTYPES.STOP,
                    coord : MDVEFAFormatter.str2latlng(
                            cleanCoords(mode.X) +','+ cleanCoords(mode.Y))
                }),
                id : mode.ID,
                iconId : mode.ProductIdentifier,
                name : mode.LineText,
                // number : mode.number,
                routeDescription : mode.DirectionText,
                product : {
                    'class' : parseInt(mode.MOTCode, 10),
                    name : mode.LineText
                    // iconId : parseInt(mode.motType, 10)
                },
                operator : {
                    name : mode.Operator
                },
                properties : {
                    tripCode : mode.JourneyIdentifier,
                    delay : mode.Delay || 0,
                    realtimeAvailable : (mode.RealtimeAvailable === 1),
                    IsAtStop : (mode.IsAtStop)? mode.IsAtStop : false
                    // network : mode.network
                }
            };
        }

        function cleanLivePositionId(lpId) {
            if (!lpId) {
                return;
            }

            return lpId.split('#')[0];
        }

        function cleanCoords(coord) {
            if (!coord) {
                return null;
            }
            return coord.replace(',', '.');
        }

        function getRelvantServingLines(id, lines) {
            if (!lines) {
                return [];
            }

            var servingLines = [];

            lines.forEach(function(line) {
                var origin = line.origin();

                if (origin && origin.id() === id) {
                    servingLines.push(line);
                }
            });

            return servingLines;
        }

        function parseLocationSequence(points, servingLines) {
            var list = [],
                i,
                l,
                curr;

            if (!points) {
                return list;
            }

            for (i = 0, l = points.length; i < l; i += 1) {
                points[i].transportations = getRelvantServingLines(points[i].ref.id, servingLines);

                curr = MDVLocationParser.parse(points[i], 'geo');
                if (curr) {
                    list.push(curr);
                }
            }

            return list;
        }

        function parseGeoCoords(coordPaths) {
              // efaMOT.paths.path "x,y x,y"
            var i,
                l,
                paths = [],
                curr;

            for (i = 0, l = coordPaths.length; i < l; i += 1) {
                if (coordPaths[i].path) {
                    curr = MDVEFAFormatter.str2latlngPath(coordPaths[i].path);
                    paths.push(curr);
                }
            }

            return paths;
        }
        // /**
        //  * @ngdoc method
        //  * @name parseDMdDpProperties
        //  * @description
        //  * Parse MOT Properties out of an DM-DepartureList ServingLine EFA response
        //  * object.
        //  * @private
        //  * @methodOf mng-comm.itd.xmljson.service:MDVTransportationParser
        //  * @param {Object} mot - EFA response object containing the MOT information
        //  * @returns {Object} A normalized parameter object that can be passed on to a
        //  * MDVTransportation object
        //  */
        function parseGeoProperties(efaMOT) {
            var mode = efaMOT.mode,
                locSeq = parseLocationSequence(efaMOT.points, efaMOT.servingLines),
                origin = (locSeq.length >=2) ? locSeq[0] : null,
                destination = (locSeq.length >=2) ? locSeq[locSeq.length - 1] : null;

            if (!origin && mode.directionFrom) {
                origin = new MDVLocation({
                    name : mode.directionFrom,
                    type : MDVLocation.LOCATIONTYPES.STOP
                });
            }
            if (!destination && mode.destination) {
                destination = new MDVLocation({
                    name : mode.destination,
                    id : mode.destID,
                    type : MDVLocation.LOCATIONTYPES.STOP
                });
            }

            return {
                allCoords : parseGeoCoords(efaMOT.paths),
                origin : origin,
                destination : destination,
                id : mode.diva.stateless,
                iconId : parseInt(mode.productId, 10) || null,
                locationSequence : locSeq,
                name : mode.name,
                number : mode.number,
                routeDescription : mode.desc,
                product : {
                    'class' : parseInt(mode.code, 10),
                    name : mode.product,
                    iconId : parseInt(mode.type, 10)
                },
                operator : {
                    name : mode.diva.operator,
                    id : mode.diva.opCode
                },
                properties : {
                    network : mode.diva.network
                }
            };
        }

        function parseGeoSelLineProperties(efaMOT) {
            var mode = efaMOT.mode,
                origin = new MDVLocation({
                    id : efaMOT.assignedStopID,
                    name : efaMOT.assignedStop,
                    type : MDVLocation.LOCATIONTYPES.STOP
                }),
                destination = null;

            if (mode.destination) {
                destination = new MDVLocation({
                    name : mode.destination,
                    id : mode.destID,
                    type : MDVLocation.LOCATIONTYPES.STOP
                });
            }

            return {
                // allCoords : parseGeoCoords(efaMOT.paths),
                origin : origin,
                destination : destination,
                id : mode.diva.stateless,
                iconId : parseInt(mode.productId, 10) || null,
                // locationSequence : locSeq,
                name : mode.name,
                number : mode.number,
                routeDescription : mode.desc,
                product : {
                    // warning, switched...
                    'class' : parseInt(mode.type, 10),
                    name : mode.product,
                    iconId : parseInt(mode.code, 10)
                },
                operator : {
                    name : mode.diva.operator,
                    id : mode.diva.opCode
                },
                properties : {
                    network : mode.diva.network,
                    isTTB : Boolean(parseInt(mode.diva.isTTB, 10)),
                    isSTT : Boolean(parseInt(mode.diva.isSTT, 10)),
                    isROP : Boolean(parseInt(mode.diva.isROP, 10))
                }
            };
        }
        // /**
        //  * @ngdoc method
        //  * @name parseDMArrProperties
        //  * @description
        //  * Parse MOT Properties out of a DM-ArrivalList ServingLine EFA response
        //  * object.
        //  * @private
        //  * @methodOf mng-comm.itd.xmljson.service:MDVTransportationParser
        //  * @param {Object} mot - EFA response object containing the MOT information
        //  * @returns {Object} A normalized parameter object that can be passed to a
        //  * MDVTransportation object
        //  */
        // function parseDMArrProperties(mode) {
        //     return {
        //         origin : new MDVLocation({
        //             name : mode.directionFrom,
        //             type : MDVLocation.LOCATIONTYPES.STOP
        //         }),
        //         destination : new MDVLocation({
        //             name : mode.direction,
        //             id : mode.destID,
        //             type : MDVLocation.LOCATIONTYPES.STOP
        //         }),
        //         id : mode.stateless,
        //         iconId : parseInt(mode.productId, 10),
        //         name : mode.symbol,
        //         number : mode.number,
        //         routeDescription : mode.desc,
        //         product : {
        //             'class' : parseInt(mode.motType, 10),
        //             name : mode.name,
        //             iconId : parseInt(mode.code, 10)
        //         },
        //         operator : mode.operator,
        //         properties : {
        //             tripCode : mode.tripCode,
        //             network : mode.network
        //         }
        //     };
        // }

        // /**
        //  * @ngdoc method
        //  * @name parseDMLineProperties
        //  * @description
        //  * Parse MOT Properties out of a DM-DepartureList ServingLine EFA response
        //  * object.
        //  * @private
        //  * @methodOf mng-comm.itd.xmljson.service:MDVTransportationParser
        //  * @param {Object} mot - EFA response object containing the MOT information
        //  * @returns {Object} A normalized parameter object that can be passed to a
        //  * MDVTransportation object
        //  */
        function parseDMLineProperties(mot) {
            return {
                id : mot.diva.stateless,
                network : mot.diva.network,
                iconId : parseInt(mot.productId, 10),
                name : mot.name,
                number : mot.number,
                routeDescription : mot.desc,
                product : {
                    'class' : parseInt(mot.type, 10),
                    name : mot.product,
                    iconId : parseInt(mot.code, 10)
                },
                periodFrom : MDVEFAFormatter.date2moment(mot.diva.vF, 'YYYYMMDD', true),
                periodTo : MDVEFAFormatter.date2moment(mot.diva.vTo, 'YYYYMMDD', true),
                operator : {
                    code : mot.diva.opCode,
                    name : mot.diva.operator
                },
                properties : {
                    network : mot.diva.network,
                    trainType : mot.trainType
                },
                destination : new MDVLocation({
                    name : mot.destination,
                    id : mot.destID,
                    type : MDVLocation.LOCATIONTYPES.STOP
                })
            };
        }
        // /**
        //  * @ngdoc method
        //  * @name parseTripLegProperties
        //  * @description
        //  * Parse MOT Properties out of a trip leg EFA response object.
        //  * @private
        //  * @methodOf mng-comm.itd.xmljson.service:MDVTransportationParser
        //  * @param {Object} mode - EFA response object containing the mode information
        //  * @returns {Object} A normalized parameter object that can be passed on to a
        //  * MDVTransportation object
        //  */
        function parseTripLegProperties(efa_leg) {
            var mode = efa_leg.mode,
                force_name,
                result;

            if (mode.type === '100') {
                force_name = MDVEFAFormatter.translate('FOOTPATH');
            }
            if (mode.type === '99' || mode.type === '98') {
                force_name = MDVEFAFormatter.translate('TRANSFER');
            }
            if (force_name) {
                mode.product = force_name;
                mode.diva.stateless = force_name;
            }
            result = {
                id : mode.diva.stateless,
                infos : MDVEFAUtil.parseInfos(efa_leg.infos, 'transportation'),
                iconId : parseInt(mode.productId, 10),
                name : mode.name,
                number : mode.number,
                disassembledName : mode.symbol,
                routeDescription : mode.desc,
                product : {
                    'class' : parseInt(mode.code, 10),
                    name : mode.product,
                    iconId : parseInt(mode.type, 10)
                },
                operator : {
                    code : mode.diva.opCode,
                    name : mode.diva.operator
                },
                properties : {
                    network : mode.diva.network,
                    trainName : mode.trainName,
                    trainType : mode.trainType,
                    isTTB : Boolean(parseInt(mode.diva.isTTB, 10)),
                    isSTT : Boolean(parseInt(mode.diva.isSTT, 10)),
                    isROP : Boolean(parseInt(mode.diva.isROP, 10))
                }
            };
            if (mode.diva.trainName) {
                result.properties.trainName = mode.diva.trainName;
            }
            if (mode.diva.line) {
                result.properties.line = mode.diva.line;
            }
            if (mode.diva.trainType) {
                result.properties.trainType = mode.diva.trainType;
            }
            if (mode.diva.key) {
                result.properties.tripKey = mode.diva.key;
            }
            if (mode.diva.tripCode) {
                result.properties.tripCode = mode.diva.tripCode;
            }
            if (result.product.name !== force_name) {
                result.destination = new MDVLocation({
                    name : mode.destination,
                    id : mode.destID,
                    type : MDVLocation.LOCATIONTYPES.STOP
                });
            }
            return result;
        }

        return motp;
    }
}());

/* eslint max-lines: ["warn", 1000]*/
(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVLocationParser
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-model.object:MDVLocation
     *
     * @description
     * The `MDVLocationParser` parses given EFA information of a location (EFA-point-object) to a
     * {@link mng-model.object:MDVLocation MDVLocation}.
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVLocationParser', MDVLocationParser);

    MDVLocationParser.$inject = ['moment', 'mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFAFormatter', 'mng-model.MDVLocation', 'mng-model.MDVSearchLocation',
        'mng-model.MDVJourneyLocation', 'mng-comm.itd.xmljson.MDVEFAUtil', 'mng-model.MDVAssignedLocation',
        'mng-comm.itd.xmljson.MDVFileParser'];

    function MDVLocationParser(moment, MDVLog, MDVConfig, MDVEFAFormatter, MDVLocation, MDVSearchLocation,
            MDVJourneyLocation, MDVEFAUtil, MDVAssignedLocation, MDVFileParser) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVLocationParser'),
            // mind if you change this regex that it needs to match MDVLocation.LOCATIONTYPES
            passThroughTypeRegEx = /^(stop|poi|poiarea|address|street|crossing)$/,
            forbidEarlierDeparture = false,  // make configurable via MDVConfig if needed
            pp = {
                parse : parse
            };

        log.debug('initialize');

        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.xmljson.service:MDVLocationParser
         * @param {Object} efaPoint Point object provided by the EFA
         * @param {String} [formatType='default'] Type of the request the point is from.
         * This can be 'geo', 'ptrip' or 'default'.
         * @param {Object=} serverInfos information about the server the response is from. This
         * property is needed for building static stateless links to pdf downloads.
         * @returns {MDVLocation} normalized {@link mng-model.object:MDVLocation MDVLocation} object
         *
         * @description
         * Parse a given EFA Point object to a normalized MDVLocation object.
         */
        function parse(efaPoint, formatType, serverInfos) {
            var props,
                Constructor;

            if (!formatType) {
                log.error('no formatType passed to parse function. returned null.');
                return null;
            }

            Constructor = getConstructorMethod(formatType);
            props = getParsedProperties(efaPoint, formatType, serverInfos);

            if (props && Constructor) {
                props.raw = efaPoint;
                return new Constructor(props);
            }
            return null;
        }

        function getParsedProperties(efaPoint, formatType, serverInfos) {
            if (formatType === 'sf') {
                return parseSFPointProperties(efaPoint);
            }
            if (formatType === 'poi') {
                return parseSFPoiProperties(efaPoint);
            }
            if (formatType === 'TRIPlegArr') {
                return parseTripPointProperties(efaPoint, false, serverInfos);

            }
            if (formatType === 'TRIPlegIntArr') {
                var props = parseTripPointProperties(efaPoint, false, serverInfos);

                if (props.arrivalTimeEstimated) {
                    props.arrivalTimeEstimated = props.arrivalTimePlanned.clone();
                }
                return props;
            }
            if (formatType === 'TRIPlegDep') {
                return parseTripPointProperties(efaPoint, true, serverInfos);
            }
            if (formatType === 'stopseq') {
                return parseStopSeqPointProperties(efaPoint, serverInfos);
            }
            if (formatType === 'coord') {
                return parseCoordPointProperties(efaPoint);
            }
            if (formatType === 'as') {
                return parseAssignedStopProperties(efaPoint);
            }
            if (formatType === 'geo') {
                return parseGeoProperties(efaPoint, serverInfos);
            }
            // fallback to normal point
            return parsePointProperties(efaPoint);
        }

        function getConstructorMethod(formatType) {
            if (formatType === 'sf' || formatType === 'poi') {
                return MDVSearchLocation;
            }
            if (formatType.indexOf('TRIP') >= 0 ||
                    // formatType === 'geo' ||
                    formatType === 'stopseq') {
                return MDVJourneyLocation;
            }
            if (formatType === 'as') {
                return MDVAssignedLocation;
            }
            return MDVLocation;
        }

        function parseLinks(efaLinks, serverInfos) {
            var links = [],
                i,
                l;

            if (!efaLinks) {
                return links;
            }
            for (i = 0, l = efaLinks.length; i < l; i += 1) {
                links.push(MDVFileParser.parse(efaLinks[i], serverInfos));
            }
            return links;
        }

        function parseModes(modes) {
            if (!modes || (!(modes instanceof String) && (typeof modes !== 'string'))) {
                return [];
            }
            var mode_list = modes.split(','),
                tmp_list = [],
                i,
                l;

            for (i = 0, l = mode_list.length; i < l; i += 1) {
                tmp_list.push(parseInt(mode_list[i], 10));
            }
            return tmp_list;
        }
    //    /**
    //     * @private
    //     * @ngdoc method
    //     * @name parsePointProperties
    //     * @description
    //     * Parse point properties to a parameter object that can be passed on to MDVLocation
    //     * @methodOf mng-comm.itd.xmljson.service:MDVLocationParser
    //     * @param {Object} point - Default point object provided by the EFA
    //     * @returns {Object} normalized MDVLocation properties
    //     */
        function parsePointProperties(point) {
            var result = {
                buildingNumber : point.buildingNumber,
                coord : MDVEFAFormatter.str2latlng(point.ref.coords),
                id : point.stateless,
                productClasses : parseModes(point.modes),
                name : point.name,
                properties : MDVEFAFormatter.parseGenAttrs(point.ref.attrs),
                type : getType(point.anyType || point.type),
                infos : MDVEFAUtil.parseInfos(point.infos, 'location')
            };

            if (point.object) {
                result.disassembledName = point.object;
            }
            if (result.type !== MDVLocation.LOCATIONTYPES.LOCALITY && point.ref.omc) {
                result.parent = new MDVLocation({
                    id : point.ref.omc + '|' + point.ref.placeID,
                    name : point.ref.place || '',
                    type : MDVLocation.LOCATIONTYPES.LOCALITY
                });
            }
            return result;
        }
        function getQuality(point) {
            var quality = parseInt(point.quality, 10);

            if (!quality) {
                return 0;
            }
            // hack to fix EFA-bug on client side
            // reason: EFA returns quality > 1001 when type_sf=stop
            while (quality > 1001) {
                quality /= 10;
            }
            return Math.round(quality);
        }
        function getType(anyType) {
            if (!anyType) {
                return MDVLocation.LOCATIONTYPES.UNKNOWN;
            }
            anyType = anyType.toLowerCase();
            // normal types, pass through
            if (anyType.match(passThroughTypeRegEx)) {
                return anyType;
            }
            // types with special handling needed
            if (anyType === 'loc') {
                // parsed element is a DISTRICT with a locality parent in most of the cases...
                // should be changed if needed
                return MDVLocation.LOCATIONTYPES.LOCALITY;
            }
            if (anyType === 'buildingname' || anyType === 'singlehouse' || anyType === 'coord') {
                return MDVLocation.LOCATIONTYPES.ADDRESS;
            }
            if (anyType === 'postcode') {
                return MDVLocation.LOCATIONTYPES.DISTRICT;
            }
            if (anyType === 'bus_point') {
                return MDVLocation.LOCATIONTYPES.STOP_POINT;
            }
            if ((anyType === 'poi_point') || (anyType === 'poi_area')) {
                return MDVLocation.LOCATIONTYPES.POI;
            }

            return MDVLocation.LOCATIONTYPES.UNKNOWN;
        }
    //    /**
    //     * @private
    //     * @ngdoc method
    //     * @name parsePointProperties
    //     * @description
    //     * Parse point properties to a parameter object that can be passed to MDVLocation
    //     * @methodOf mng-comm.itd.xmljson.service:MDVLocationParser
    //     * @param {Object} point - Default point object provided by the EFA
    //     * @returns {Object} normalized MDVLocation properties
    //     */
        function parseSFPointProperties(point) {
            var result = {
                buildingNumber : point.buildingNumber,
                coord : MDVEFAFormatter.str2latlng(point.ref.coords),
                id : point.stateless,
                isBestMatch : (parseInt(point.best, 10) === 1),
                matchQuality : getQuality(point),
                productClasses : parseModes(point.modes),
                name : point.name,
                properties : MDVEFAFormatter.parseGenAttrs(point.ref.attrs),
                searchValue : point.searchValue,
                type : getType(point.anyType || point.type),
                infos : MDVEFAUtil.parseInfos(point.infos, 'location')
            };

            result.name = MDVEFAFormatter.translate(result.name, 'placeholder');

            if (point.object) {
                result.disassembledName = MDVEFAFormatter.translate(point.object, 'placeholder');
            }

            if (point.usage) {
                result.properties.usage = point.usage;
            }

            if (point.postcode) {
                result.properties.postcode = point.postcode;
            }

            if (point.ref && point.ref.gid) {
                result.properties.stopId = result.id;
                result.id = point.ref.gid;
                result.isGlobalId = true;
            }

            if (result.type !== MDVLocation.LOCATIONTYPES.LOCALITY && point.ref.omc) {
                result.parent = new MDVLocation({
                    id : point.ref.omc + '|' + point.ref.placeID,
                    name : point.ref.place || '',
                    type : MDVLocation.LOCATIONTYPES.LOCALITY
                });
            }
            if (point.tariffZones) {
                result.properties.tariffZones = point.tariffZones;
            }

            return result;
        }
            //    /**
    //     * @private
    //     * @ngdoc method
    //     * @name parseSFPoiProperties
    //     * @description
    //     * Parse point properties to a parameter object that can be passed on to MDVLocation
    //     * @methodOf mng-comm.itd.xmljson.service:MDVLocationParser
    //     * @param {Object} poi - An poi efa point or poi efa category
    //     * @returns {Object} normalized MDVLocation properties
    //     */
        function parseSFPoiProperties(poi) {
            var props = {
                id : poi.stateless || poi.hierarchy,
                name : poi.name || poi.hierarchyText,
                searchValue : poi.searchValue,
                coord : MDVEFAFormatter.str2latlng(poi.coords) || [],
                type : MDVLocation.LOCATIONTYPES.POI
            };

            if (poi.locality) {
                props.parent = new MDVLocation({
                    id : poi.stateless || poi.hierarchy || poi.omc + '|' + poi.placeID,
                    name : poi.locality,
                    type : MDVLocation.LOCATIONTYPES.LOCALITY
                });
            }
            return props;
        }

        function parseAdditionalPointProperties(props, point) {
            // merge additional Information in
            if (point.additionalInformation) {
                if (!props.infos) {
                    props.infos = [];
                }
                props.infos = props.infos.concat(
                    MDVEFAUtil.parseInfos(point.additionalInformation.infos, 'location'));

                props.infos = MDVEFAUtil.removeDuplicatesInfos(props.infos);

                if (props.id === '99999997' || props.id === '99999998') {
                    if (point.additionalInformation.stateless || point.additionalInformation.ref.id) {
                        props.id = point.additionalInformation.stateless ||
                                                                 point.additionalInformation.ref.id;
                    }
                    if (!point.type) {
                        if (point.additionalInformation.anyType) {
                            props.type = getType(point.additionalInformation.anyType);
                        } else {
                            props.type = getType(point.additionalInformation.type);
                        }
                    }
                    // check for place name here
                }
            }
            return props;
        }

        function handleDownloads(props, point, serverInfos) {
            var dl_links = parseLinks(point.links, serverInfos);

            if (dl_links && dl_links.length > 0) {
                props.properties.downloads = dl_links;
            }
            return props;
        }

        function addIdsToProperties(props, point, stopId) {
            if (point.ref.area) {
                props.properties.areaId = point.ref.area;
            }
            if (point.ref.platform) {
                // remove platform and only keep platformId to be consistent to areaId
                props.properties.platform = point.ref.platform;
                props.properties.platformId = point.ref.platform;
            }

            if (!point.platformName && point.ref.pointGid) {
                props.properties.stopPointId = point.ref.pointGid;
            }

            if (point.ref.id && point.ref.gid) {
                props.properties.stopId = stopId;
            }
            return props;
        }

        function parseLocality(point) {
            if (point.omc) {
                return new MDVLocation({
                    id : point.omc + '|' + point.placeID,
                    name : point.place,
                    type : MDVLocation.LOCATIONTYPES.LOCALITY
                });
            }
            return null;
        }

        function parseTripPlatformProps(props, point) {
            var stopId = point.ref.id,
                stopName = point.nameWO,
                fullName = point.name,
                stopParent;

            props.id = point.ref.pointGid || stopId;
            if (point.ref.pointGid) {
                props.isGlobalId = true;
                props.properties.stopId = stopId;
            }
            props.name = fullName || point.platformName;
            props.disassembledName = point.platformName;
            props.type = MDVLocation.LOCATIONTYPES.STOP_POINT;

            // stop is parent
            stopParent = {
                id : point.ref.gid || stopId,
                name : fullName || stopName,
                disassembledName : stopName,
                type : MDVLocation.LOCATIONTYPES.STOP,
                parent : parseLocality(point)
            };
            if (point.ref.gid) {
                stopParent.isGlobalId = true;
            }
            props.parent = new MDVLocation(stopParent);

            return props;
        }

        function parseRawTripPointProperties(point, serverInfos) {
            var props = {
                    coord : MDVEFAFormatter.str2latlng(point.ref.coords),
                    properties : MDVEFAFormatter.parseGenAttrs(point.ref.attrs),
                    infos : MDVEFAUtil.parseInfos(point.infos, 'location')
                },
                stopId = point.ref.id;


            if (point.ref.zone) {
                props.properties.zone = (point.ref.zone).split(';');
            }

            if (point.ref.fK) {
                props.properties.fk = (point.ref.fK);
            }

            if (point.usage) {
                props.properties.usage = point.usage;
            }

            if (point.platformName) {
                // platform
                props = parseTripPlatformProps(props, point);
            } else {
                // TODO mind via points here
                // assume point is a stop stop
                props.id = point.ref.gid || stopId;
                if (point.ref.gid) {
                    props.isGlobalId = true;
                    props.properties.stopId = stopId;
                }
                props.name = point.name;

                props.type = MDVLocation.LOCATIONTYPES.STOP;
                props.parent = parseLocality(point);
            }
            if (point.realtimeStatus) {
                props.realtimeStatus = point.realtimeStatus;
            }
            props = handleDownloads(props, point, serverInfos);
            props = addIdsToProperties(props, point, stopId);

            props = parseAdditionalPointProperties(props, point);
            return props;
        }

    //    /**
    //     * @private
    //     * @ngdoc method
    //     * @name parseTripPointProperties
    //     * @description
    //     * Parse point properties to a parameter object that can be passed to MDVLocation
    //     * @methodOf mng-comm.itd.xmljson.service:MDVLocationParser
    //     * @param {Object} point - Default point object provided by a EFA Trip request
    //     * @returns {Object} normalized MDVLocation properties
    //     */
        function parseTripPointProperties(point, is_departing_point, serverInfos) {
            var props,
                dateTime,
                dateTimeReal;

            // if (point.additionalInformation) {
                // additional information contains more info than normal point
                // props = parsePointProperties(point.additionalInformation);
            // } else {
            props = parseRawTripPointProperties(point, serverInfos);
            // }

            // props.properties.fullName = point.name;
            if (point.nameWithPlace) {
                props.properties.alternativeName = point.nameWithPlace;
            }
            // date/ time handling
            if (point.dateTime && point.dateTime.time && point.dateTime.date) {
                dateTime = MDVEFAFormatter.dateTime2moment({
                    time : point.dateTime.time,
                    date : point.dateTime.date
                });
            }
            if (point.dateTime && point.dateTime.rtTime && point.dateTime.rtDate) {
                dateTimeReal = MDVEFAFormatter.dateTime2moment({
                    time : point.dateTime.rtTime,
                    date : point.dateTime.rtDate
                });
            }

            if (is_departing_point) {
                if (forbidEarlierDeparture && dateTimeReal && dateTimeReal.isBefore(dateTime)) {
                    // departure at planned time instead of real
                    props.departureTimePlanned = dateTime;
                    props.departureTimeEstimated = dateTime.clone();
                } else {
                    // normal
                    props.departureTimePlanned = dateTime;
                    props.departureTimeEstimated = dateTimeReal;
                }
            } else {
                props.arrivalTimePlanned = dateTime;
                props.arrivalTimeEstimated = dateTimeReal;
            }
            props.isRealtimeControlled = point.isControlled || false;
            return props;
        }

        function parseStopSeqPointProperties(point, serverInfos) {
            // avoid errors with missing ref
            var props = parseRawTripPointProperties(point, serverInfos);

            // props.properties.fullName = point.name;
            if (point.nameWithPlace) {
                props.properties.alternativeName = point.nameWithPlace;
            }
            // date/ time handling

            if (point.ref.depDateTime) {
                // departure point
                props.departureTimePlanned = moment(point.ref.depDateTime, 'YYYYMMDD HH:mm');
                if (props.departureTimePlanned && point.ref.arrValid !== '0' && point.ref.depDelay) {
                    props.departureTimeEstimated = props.departureTimePlanned.clone();
                    props.departureTimeEstimated.add(parseInt(point.ref.depDelay, 10), 'minutes');
                }
                if (point.ref.arrValid !== '0' && point.ref.arrDelay) {
                    props.arrivalDelay = parseInt(point.ref.arrDelay, 10);
                }
            }
            if (point.ref.arrDateTime) {
                // arrival point
                // props.arrivalTimePlanned = moment(point.ref.arrDateTime, 'YYYYMMDD HH:mm');
                // if (props.arrivalTimePlanned && point.ref.arrValid !== '0' && point.ref.arrDelay) {
                //     props.arrivalTimeEstimated = props.arrivalTimePlanned.clone();
                //     props.arrivalTimeEstimated.add(parseInt(point.ref.depDelay, 10), 'minutes');
                //     console.log('ar est', props.arrivalTimeEstimated.add(parseInt(point.ref.depDelay, 10), 'minutes'));
                // }
                // if (point.ref.depValid !== '0' && point.ref.depDelay) {
                //     props.departureDelay = parseInt(point.ref.depDelay, 10);
                // }
                // test
                props.arrivalTimePlanned = moment(point.ref.arrDateTime, 'YYYYMMDD HH:mm');
                if (props.arrivalTimePlanned && point.ref.arrValid !== '0' && point.ref.arrDelay) {
                    props.arrivalTimeEstimated = props.arrivalTimePlanned.clone();
                    props.arrivalTimeEstimated.add(parseInt(point.ref.arrDelay, 10), 'minutes');
                }
                if (point.ref.depValid !== '0' && point.ref.depDelay) {
                    props.departureDelay = parseInt(point.ref.depDelay, 10);
                }
            }
            if (forbidEarlierDeparture && props.departureTimeEstimated &&
                    props.departureTimeEstimated.isBefore(props.departureTimePlanned)) {
                // departure at planned time instead of real
                props.departureTimeEstimated = props.departureTimePlanned.clone();
            }
            if (point.realtimeStatus) {
                props.realtimeStatus = point.realtimeStatus;
            }
            props.isRealtimeControlled = point.isControlled;
            return props;
        }

        function convertToPlatformProps(props) {
            // add additional platform layer
            var new_props = {
                    id : props.id,
                    name : props.name,
                    type : props.type,
                    coord : props.coords,
                    properties : props.properties
                },
                parent_props = {
                    parent : props.parent,
                    type : MDVLocation.LOCATIONTYPES.STOP,
                    id : props.id.split('-')[0],
                    name : props.name
                };

            // parse platform  properties
            if (new_props.properties.IDENTIFIER) {
                new_props.name = new_props.properties.IDENTIFIER;
                delete new_props.properties.IDENTIFIER;
            }
            if (new_props.properties.STOPPOINT_GLOBAL_ID) {
                new_props.id = new_props.properties.STOPPOINT_GLOBAL_ID;
                delete new_props.properties.STOPPOINT_GLOBAL_ID;
            }
            if (new_props.properties.STOP_POINT_REFERED_NAMEWITHPLACE) {
                new_props.properties = {
                    fullName : new_props.properties.STOP_POINT_REFERED_NAMEWITHPLACE
                };
            }
            // remove unneeded properties
            if (new_props.properties.STOP_POINT_CHARACTERISTICS) {
                delete new_props.properties.STOP_POINT_CHARACTERISTICS;
            }
            if (new_props.properties.STOP_AREA_NAME) {
                delete new_props.properties.STOP_AREA_NAME;
            }

            // parse stop properties
            if (new_props.properties.STOP_POINT_REFERED_NAME) {
                parent_props.name = new_props.properties.STOP_POINT_REFERED_NAME;
                delete new_props.properties.STOP_POINT_REFERED_NAME;
            }


            new_props.parent = new MDVLocation(parent_props);
            return new_props;
        }

        function parseCoordPointProperties(point) {
            var props = {
                id : point.stateless || point.id,
                name : point.desc,
                type : getType(point.type),
                properties : MDVEFAFormatter.parseGenAttrs(point.attrs),
                coord : MDVEFAFormatter.str2latlng(point.coords)
            };


            props.properties.distance = parseInt(point.distance, 10);

            if (point.id) {
                props.properties.stopId = point.id;
            }

            if (point.locality && point.omc) {
                props.parent = new MDVLocation({
                    id : point.omc + '|' + point.placeID,
                    name : point.locality,
                    type : MDVLocation.LOCATIONTYPES.LOCALITY
                });
            }

            if (props.type === MDVLocation.LOCATIONTYPES.STOP_POINT) {
                props = convertToPlatformProps(props);
            }

            if (props.properties.modes) {
                props.productClasses = props.properties.modes;
            }

            if (point.coordInfoDetails) {
                props.properties.coordInfoDetails = point.coordInfoDetails;
                props.type = MDVLocation.LOCATIONTYPES.SHARING;
                props.subType = point.type;
                if (!props.name) {
                    props.name = point.coordInfoDetails.plate;
                }
            }

            return props;
        }

        function parseAssignedStopProperties(point) {
            var props = {
                name : point.nameWithPlace || point.name,
                assignedLocation : point.stopID,
                connectingMode : parseInt(point.vm, 10),
                duration : parseInt(point.distanceTime, 10),
                distance : parseInt(point.distance, 10),
                id : point.stopID,
                alternativeName : point.nameWithPlace,
                coord : MDVEFAFormatter.str2latlng(point.x + ',' + point.y),
                infos : MDVEFAUtil.parseInfos(point.infos, 'location'),
                type : getType(point.anyType || point.type),
                properties : {
                    stopId : point.stopID
                }
            };

            return props;
        }

        function parseStopMeansList(stopMeans) {
            var productClasses = [],
                currBinary = 524288,
                currProductClass = 19;

            stopMeans = parseInt(stopMeans, 10);

            for (; currProductClass >= 0; currProductClass -= 1) {
                if (stopMeans - currBinary >= 0) {
                    stopMeans -= currBinary;
                    productClasses.push(currProductClass);
                }
                currBinary /= 2;
            }

            return productClasses.reverse();
        }

        function parseGeoProperties(point, serverInfos) {
            var props = parseRawTripPointProperties(point, serverInfos);

            if (point.transportations) {
                props.transportations = point.transportations;
            }

            if (props.properties && props.properties.STOP_MEANS) {
                props.productClasses = parseStopMeansList(props.properties.STOP_MEANS);
                delete props.properties.STOP_MEANS;
            }
            if (props.properties && props.properties.ASSIGNED_STOP_MEANS) {
                props.properties.ASSIGNED_STOP_MEANS =
                    parseStopMeansList(props.properties.ASSIGNED_STOP_MEANS);
            }

            return props;
        }

        return pp;
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVJourneyLegParser
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-model.object:MDVTransportation
     * @requires 'mng-comm.itd.xmljson.service:MDVLocationParser
     * @description
     *
     * Parse EFA response information of journey legs to a MDVJourneyLeg object
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVJourneyLegParser', MDVJourneyLegParser);

    MDVJourneyLegParser.$inject = ['moment', 'mng-util.MDVLog', 'mng-util.MDVUtilCoords',
        'mng-comm.itd.MDVEFAFormatter', 'mng-model.MDVJourneyLeg', 'mng-model.MDVTransportation',
        'mng-comm.itd.xmljson.MDVTransportationParser', 'mng-comm.itd.xmljson.MDVLocationParser',
        'mng-comm.itd.xmljson.MDVEFAUtil'];

    function MDVJourneyLegParser(moment, MDVLog, MDVUtilCoords, MDVEFAFormatter, MDVJourneyLeg,
             MDVTransportation, MDVTransportationParser, MDVLocationParser, MDVEFAUtil) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVJourneyLegParser'),
            legp = {
                parse : parse,
                parseInterchange : parseInterchange,
                parseWaitLeg : parseWaitLeg
            };

        log.debug('initialize');


        function getInterchangePoint(efa_legs, curr_index, isOrig, serverInfos) {
            var point,
                leg;

            if (isOrig) {
                if (curr_index === 0) {
                    // return current leg's origin if no leg is before
                    leg = efa_legs[0];
                    point = leg.points[0];
                } else {
                    // return previous leg's destination
                    leg = efa_legs[curr_index - 1];
                    point = leg.points[1];
                }
            } else if (curr_index + 1 >= efa_legs.length) {
                // return current leg's destination if no leg follows
                leg = efa_legs[curr_index];
                point = leg.points[1];
            } else {
                // return next leg's origin
                leg = efa_legs[curr_index + 1];
                point = leg.points[0];
            }
            if (leg.infos) {
                if (leg.infos.info) {
                    leg.infos = [leg.infos.info];
                }
                point.infos = (point.infos || []).concat(leg.infos);
            }
            point.isControlled = false;
            return MDVLocationParser.parse(point, isOrig ? 'TRIPlegDep' : 'TRIPlegArr', serverInfos);
        }

        function getFootpathDistance(curr_elem, options) {
            var distance = MDVUtilCoords.distance(curr_elem.orig.x, curr_elem.orig.y,
                        curr_elem.dest.x, curr_elem.dest.y);

            distance = Math.floor(distance);

            if (distance < options.maxPTDistance && distance >= 0) {
                return distance;
            }

            // fallback to 0 to avoid invalid distances
            return 0;
        }
        function getFootpathDuration(footpaths) {
            if (footpaths && footpaths.length) {
                return parseInt(footpaths[0].duration, 10) * 60;
            }
            return 0;
        }

        function parseFootpaths(result, footpaths, options) {
            var i,
                l,
                elems,
                curr_elem,
                curr_dist,
                cum_dist = 0,
                overallDuration,
                distanceOffset = 0,
                durationOffset = 0;

            if (footpaths.length > 1) {
                log.error('unable to parse multiple footpath elems, just parsed first elem.' +
                    'Please contact MENTZ');
            }

            overallDuration = getFootpathDuration(footpaths);
            elems = footpaths[0].footpathElem;

            if (!elems || elems.length === 0 || (elems.length === 1 && !elems[0].orig)) {
                return result;
            }

            if (result.length > 0) {
                curr_elem = result[result.length - 1];
                distanceOffset = curr_elem.cumDistance;
                durationOffset = curr_elem.cumDuration;
            }

            for (i = 0, l = elems.length; i < l; i += 1) {
                curr_elem = elems[i];

                curr_dist = getFootpathDistance(curr_elem, options);
                cum_dist += curr_dist;

                result.push({
                    origin : {
                        coord : MDVEFAFormatter.str2latlng(curr_elem.orig.x + ',' + curr_elem.orig.y),
                        id : curr_elem.orig.stopID,
                        type : 'stop'
                    },
                    destination : {
                        coord : MDVEFAFormatter.str2latlng(curr_elem.dest.x + ',' + curr_elem.dest.y),
                        id : curr_elem.dest.stopID,
                        type : 'stop'
                    },
                    manoeuvre : curr_elem.type,
                    turnDirection : curr_elem.level,
                    name : curr_elem.description,
                    // distance of origin/destination might be taken into account here, too
                    duration : overallDuration / l,
                    distance : curr_dist,
                    cumDistance : cum_dist + distanceOffset,
                    cumDuration : (overallDuration * ((i + 1) / l)) + durationOffset,
                    properties : MDVEFAFormatter.parseGenAttrs(curr_elem.attrs),
                    skyDirection : getSkydirection(curr_elem.orig, curr_elem.dest)
                });
            }

            return result;
        }

        function getSkydirection(orig, dest) {
            var dir = MDVUtilCoords.bearing(orig.y, orig.x, dest.y, dest.x);

            while (dir >= 360) {
                dir -= 360;
            }
            return Math.floor(dir);
        }

        function parseTurnInstr(turn_instr, durationOffset, distanceOffset) {
            if (!turn_instr.hasOwnProperty('turnDirection') &&
                    !turn_instr.hasOwnProperty('manoeuvre')) {
                // assure that valid turn instruction is passed
                return null;
            }
            var instr = {
                    coord : MDVEFAFormatter.str2latlng(turn_instr.coords),
                    cumDistance : parseInt(turn_instr.cDis, 10) + (distanceOffset || 0),
                    cumDuration : parseInt(turn_instr.ctTime, 10) + (durationOffset || 0),
                    distance : parseInt(turn_instr.dis, 10),
                    duration : parseInt(turn_instr.tTime, 10),
                    fromCoordsIndex : parseInt(turn_instr.fPCIdx, 10),
                    manoeuvre : turn_instr.manoeuvre,
                    name : turn_instr.name,
                    skyDirection : parseInt(turn_instr.skyDir, 10),
                    toCoordsIndex : parseInt(turn_instr.tPCIdx, 10),
                    turnDirection : turn_instr.dir,
                    dDown : parseInt(turn_instr.dDown || 0, 10),
                    dUp : parseInt(turn_instr.dUp || 0, 10)
                    // guidanceSign : curr_instr.guidanceSign,
                    // distanceUp : curr_instr.distanceUp,
                    // distanceDown : curr_instr.distanceDown
                },
                properties = MDVEFAFormatter.parseGenAttrs(turn_instr.attrs);

            if (!angular.equals({}, properties)) {
                // properties not empty, add them to instr
                instr.properties = properties;
            }
            return instr;

        }

        function parseStopSequence(stop_sequence, controlled) {
            var sequence = [],
                curr_loc,
                i,
                l;

            if (!stop_sequence || stop_sequence.length === 0) {
                return sequence;
            }
            for (i = 0, l = stop_sequence.length; i < l; i += 1) {
                // stop_sequence[i].anyType = 'stop';
                stop_sequence[i].isControlled = controlled;
                curr_loc = MDVLocationParser.parse(stop_sequence[i], 'stopseq');
                sequence.push(curr_loc);
            }
            return sequence;
        }

        function parseTurnInstrs(result, turn_instrs) {
            var i,
                l,
                curr_instr,
                distanceOffset = 0,
                durationOffset = 0;

            if (result.length > 0) {
                curr_instr = result[result.length - 1];
                distanceOffset = curr_instr.cumDistance;
                durationOffset = curr_instr.cumDuration;
            }
            for (i = 0, l = turn_instrs.length; i < l; i += 1) {
                curr_instr = parseTurnInstr(turn_instrs[i], durationOffset, distanceOffset);
                if (curr_instr) {
                    result.push(curr_instr);
                }
            }
            return result;
        }

        function getOldMergedPathDescription(hasFootpaths, hasTurnInst, footpaths, turn_instrs,
                isFirst, options) {
            var directions = [];

            if ((hasFootpaths && footpaths[0].position === 'BEFORE') ||
                    (!isFirst && hasFootpaths && footpaths[0].position === 'IDEST')) {
                directions = parseFootpaths(directions, footpaths, options);
            }

            if (hasTurnInst) {
                directions = parseTurnInstrs(directions, turn_instrs);
            }

            if ((hasFootpaths && footpaths[0].position === 'AFTER') ||
                    (isFirst && hasFootpaths && footpaths[0].position === 'IDEST')) {
                directions = parseFootpaths(directions, footpaths, options);
            }

            return directions;
        }

        function getMergedPathDescription(hasFootpaths, hasTurnInst, footpaths, turn_instrs,
                isFirst, options) {
            var directions = [];

            if (options.downwardCompatible) {
                return getOldMergedPathDescription(hasFootpaths, hasTurnInst, footpaths,
                    turn_instrs, isFirst, options);
            }
            if (options.mergePTtoITInstructions) {
                if (hasFootpaths && !isFirst && (footpaths[0].position !== 'IDEST' || !hasTurnInst)) {
                    // prepend PT footpaths to IT if it is last IT,
                    // but only if it is not IDEST including a TurnInstruction
                    directions = parseFootpaths(directions, footpaths, options);
                }

                if (hasTurnInst) {
                    directions = parseTurnInstrs(directions, turn_instrs);
                }

                if (hasFootpaths && isFirst && (footpaths[0].position !== 'IDEST' || !hasTurnInst)) {
                    // append PT footpaths to IT if it is first IT
                    // but only if it is not IDEST including a TurnInstruction
                    directions = parseFootpaths(directions, footpaths, options);
                }
            } else if (hasTurnInst) {
                directions = parseTurnInstrs(directions, turn_instrs);
            } else {
                directions = parseFootpaths(directions, turn_instrs, options);
            }
            return directions;
        }

        function getPathDescription(efa_leg, isFirst, options) {
            var turn_instrs = efa_leg.turnInst,
                footpaths = efa_leg.footpath,
                parsedFootpaths = [],
                hasTurnInst = turn_instrs && turn_instrs.length > 0,
                hasFootpaths = footpaths && footpaths.length > 0,
                directions = [];

            if (!hasTurnInst && !hasFootpaths) {
                // no information available at all
                return directions;
            }

            if (parseInt(efa_leg.mode.type, 10) === 100) {
                // only merge it and pt footpath for 100-legs
                directions = getMergedPathDescription(hasFootpaths, hasTurnInst, footpaths,
                                                                      turn_instrs, isFirst, options);
            // else: pt footpath provides correct time, but "bad" turnInstructions
            } else if (hasTurnInst) {
                // use turn instructions if available and set footpath duration
                directions = parseTurnInstrs(directions, turn_instrs);
                if (directions.length && hasFootpaths) {
                    // update turnInstruction duration if footpaths available
                    parsedFootpaths = parseFootpaths([], footpaths, options);
                    if (parsedFootpaths.length) {
                        directions[directions.length - 1].cumDuration =
                            parsedFootpaths[parsedFootpaths.length - 1].cumDuration;
                    }
                }

            } else if (hasFootpaths) {
                // no turn instructions, only footpaths available
                directions = parseFootpaths(directions, footpaths, options);
            }

            return directions;
        }

        function parseITTransportation(origin, destination, efa_mode, type) {
            var ittype = efa_mode ? efa_mode.type : type,
                modeProperties = {},
                name = MDVEFAFormatter.translate(
                    (parseInt(ittype, 10) === 99 || parseInt(ittype, 10) === 98) ? 'TRANSFER' : ittype
                );

            if (!efa_mode) {
                efa_mode = {
                    diva : {}
                };
            }

            return new MDVTransportation({
                id : name + '#' + origin.id() + '#' + destination.id(),
                origin : origin,
                destination : destination,
                name : name,
                number : efa_mode.number,
                routeDescription : efa_mode.desc,
                product : {
                    'class' : parseInt(ittype, 10),
                    name : name,
                    iconId : parseInt(ittype, 10)
                },
                operator : {
                    code : efa_mode.diva.opCode,
                    name : efa_mode.diva.operator
                },
                iconId : parseInt(ittype, 10),
                properties : modeProperties
            });
        }

        function getLegPath(efa_leg) {
            if (efa_leg.path) {
                return efa_leg.path;
            }
            // fallback: sky direction
            if (efa_leg.points && efa_leg.points.length === 2 &&
                    efa_leg.points[0].ref && efa_leg.points[1].ref) {
                return efa_leg.points[0].ref.coords + ' ' + efa_leg.points[1].ref.coords;
            }
            return null;
        }
        function getDuration(origin, destination) {
            return destination.arrivalTime().diff(origin.departureTime(), 'seconds');
        }

        function getStandBy(origin, destination, duration) {
            var standby = getDuration(origin, destination) - duration;

            return (standby>0)?standby:0;
        }

        function prepareEfaLeg(efa_leg, isControlled) {
            efa_leg.points[0].isControlled = isControlled;
            efa_leg.points[1].isControlled = isControlled;

            if (efa_leg.infos) {
                if (efa_leg.infos.info) {
                    efa_leg.infos = [efa_leg.infos.info];
                }
                efa_leg.points[0].infos = (efa_leg.points[0].infos || []).concat(efa_leg.infos);
                efa_leg.points[1].infos = (efa_leg.points[1].infos || []).concat(efa_leg.infos);
            }
            efa_leg.mode.passedStops = efa_leg.passedStops;
            efa_leg.mode.path = efa_leg.path;
            efa_leg.mode.elevationData = efa_leg.elevationData;

            return efa_leg;
        }

        function getLegProperties(efa_legs, curr_index, serverInfos, options) {
            var efa_leg = efa_legs[curr_index],
                origin,
                destination,
                path = MDVEFAFormatter.str2latlngPath(getLegPath(efa_leg)),
                transportation,
                result,
                path_desc,
                duration = MDVEFAFormatter.strDuration2Minutes(efa_leg.timeMinute) * 60,
                standby = 0,
                controlled = Boolean(efa_leg.controlled);

            // special case
            // when the first/last leg is 99 treat it as normal footpath
            if ((efa_leg.mode.type === '99') &&
                    (curr_index === 0 || curr_index === (efa_legs.length - 1))) {
                efa_leg.mode.type = '100';
            }

            if (efa_leg.mode.type === '99' || efa_leg.mode.type === '98') {
                // interchange
                origin = getInterchangePoint(efa_legs, curr_index, true, serverInfos);
                destination = getInterchangePoint(efa_legs, curr_index, false, serverInfos);
                standby = getStandBy(origin, destination, duration);
                transportation = parseITTransportation(origin, destination, efa_leg.mode);

            } else {
                // normal leg
                efa_leg = prepareEfaLeg(efa_leg, controlled);

                origin = MDVLocationParser.parse(efa_leg.points[0], 'TRIPlegDep', serverInfos);
                destination = MDVLocationParser.parse(efa_leg.points[1], 'TRIPlegArr', serverInfos);

                if (efa_leg.mode.type >= 97) {
                    transportation = parseITTransportation(origin, destination, efa_leg.mode);
                } else {
                    transportation = MDVTransportationParser.parse(efa_leg, 'TRIPleg');
                }
            }

            result = {
                coords : path,
                origin : origin,
                destination : destination,
                transportation : transportation,
                duration : duration,
                standby : standby,
                hints : MDVEFAUtil.parseHints(efa_leg.hints),
                infos : MDVEFAUtil.parseInfos(efa_leg.infos, 'leg'),
                isRealtimeControlled : controlled,
                locationSequence : parseStopSequence(efa_leg.stopSeq, controlled),
                properties : MDVEFAFormatter.parseGenAttrs(efa_leg.attrs),
                tickets : efa_leg.tickets
            };

            if (efa_leg.vAI && efa_leg.vAI.vA) {
                result.properties.vehicleAccess = [efa_leg.vAI.vA];
            }

            if (efa_leg.mode.type >= 97) {
                path_desc = getPathDescription(efa_leg, curr_index === 0, options);
                if (path_desc && path_desc.length > 0) {
                    result.pathDescription = path_desc;
                    result.distance = path_desc[path_desc.length - 1].cumDistance;
                    // result.duration = path_desc[path_desc.length - 1].cumDuration;
                    result.standby = getStandBy(origin, destination, result.duration);
                }
            }

            return result;
        }
        function getInterchangeProperties(efa_legs, currLegIndex, serverInfos, options) {
            var currLeg = efa_legs[currLegIndex],
                leg = {
                    origin : getInterchangePoint(efa_legs, currLegIndex + 1, true, serverInfos),
                    destination : getInterchangePoint(efa_legs, currLegIndex, false, serverInfos)
                },
                path_desc = getPathDescription(currLeg, currLegIndex === 0, options);

            leg.coords = (currLeg.interchange) ? currLeg.interchange.path : currLeg.path;
            leg.coords = MDVEFAFormatter.str2latlngPath(leg.coords);

            leg.transportation = parseITTransportation(leg.origin, leg.destination, null, '99');

            leg.properties = MDVEFAFormatter.parseGenAttrs(currLeg.attrs);

            if (currLeg.vAI && currLeg.vAI.vA) {
                leg.properties.vehicleAccess = [currLeg.vAI.vA];
            }

            if (path_desc && path_desc.length > 0) {
                leg.pathDescription = path_desc;
                leg.distance = path_desc[path_desc.length - 1].cumDistance;
                leg.duration = path_desc[path_desc.length - 1].cumDuration;
            }

            if (currLeg.footpath && currLeg.footpath.length > 0 && currLeg.footpath[0].duration) {
                leg.duration = parseInt(currLeg.footpath[0].duration, 10) * 60;
            }

            if (leg.duration) {
                leg.standby = getStandBy(leg.origin, leg.destination, leg.duration);
            } else {
                // fallback to complete duration as transportation
                leg.duration = getDuration(leg.origin, leg.destination);
                leg.standby = 0;
            }
            return leg;
        }
        function getWaitProperties(efa_legs, currLegIndex, serverInfos) {
            var leg = {
                origin : getInterchangePoint(efa_legs, currLegIndex, true, serverInfos),
                destination : getInterchangePoint(efa_legs, currLegIndex - 1, false, serverInfos),
                coords : []
            };

            if (leg.origin.equals(leg.destination, true)) {
                // wait is standby, no transportation duration
                leg.duration = 0;
                leg.standby = getStandBy(leg.origin, leg.destination, 0);
            } else {
                // origin !== destination -> transfer time.
                // problem: as there's no information how long the transfer time actually is, the
                // transfer time value may be way to long.
                // alternative would be to not parse duration and standby time, but totalDuration only.
                // leg.totalDuration = getDuration(leg.origin, leg.destination);
                leg.duration = getDuration(leg.origin, leg.destination);
                leg.standby = 0;
            }

            leg.transportation = parseITTransportation(leg.origin, leg.destination, null, '99');

            return leg;
        }

        function parseInterchange(efa_legs, curr_index, serverInfos, options) {
            if (!efa_legs || efa_legs.length === 0 || efa_legs.length <= curr_index) {
                return null;
            }
            var props = getInterchangeProperties(efa_legs, curr_index, serverInfos, options),
                leg;

            if (props) {
                leg = new MDVJourneyLeg(props);
                leg.efaIndex = curr_index;
                return leg;
            }
            return null;
        }

        function parseWaitLeg(efa_legs, curr_index, serverInfos) {
            if (!efa_legs || efa_legs.length === 0 || efa_legs.length <= curr_index) {
                return null;
            }
            var props = getWaitProperties(efa_legs, curr_index, serverInfos),
                leg;

            if (props) {
                leg = new MDVJourneyLeg(props);
                leg.efaIndex = curr_index;
                return leg;
            }
            return null;
        }

        function parse(efa_legs, curr_index, serverInfos, options) {
            if (!efa_legs || efa_legs.length === 0 || efa_legs.length <= curr_index) {
                return null;
            }
            var props,
                leg;

            props = getLegProperties(efa_legs, curr_index, serverInfos, options);

            if (props) {
                props.raw = efa_legs[curr_index];
                leg = new MDVJourneyLeg(props);
                leg.efaIndex = curr_index;
                return leg;
            }
            return null;
        }

        return legp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVFileParser', MDVFileParser);

    MDVFileParser.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-model.MDVFile'];

    function MDVFileParser(MDVLog, MDVConfig, MDVFile) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVFileParser'),
            serverMappingObj,
            pp = {
                parse : parse
            };

        MDVConfig.ready(function() {
            serverMappingObj = MDVConfig.getValue('mng-comm-itd.ServerMapping') || null;
        });

        log.debug('initialize');


        function parse(efaObj, serverInfos) {
            var efaUrl = efaObj.href || efaObj.src || efaObj.url,
                props = {
                    input : efaObj.input,
                    type : parseDownloadType(efaObj.type, efaUrl),
                    size : efaObj.size,
                    stream : efaObj.stream,
                    raw : efaObj,
                    url : parseDownloadUrl(efaUrl, efaObj.type, serverInfos)
                };

            return new MDVFile(props);
        }

        function parseDownloadUrl(efaUrl, fileType, serverInfos) {
            var prefixMapping,
                urlMapping,
                prefix;

            if (serverMappingObj) {
                if (serverMappingObj.hasOwnProperty('urlMapping')) {
                    urlMapping = serverMappingObj.urlMapping;
                }
                if (serverMappingObj.hasOwnProperty('prefixMapping')) {
                    prefixMapping = serverMappingObj.prefixMapping;
                }
            }

            if (urlMapping && serverInfos && serverInfos.hasOwnProperty('serverID')
                && urlMapping.hasOwnProperty(serverInfos.serverID)) {

                prefix = urlMapping[serverInfos.serverID] + '/';

                if (prefixMapping && prefixMapping.hasOwnProperty(fileType)) {
                    prefix = prefix + prefixMapping[fileType] + '/';
                }

                return prefix + efaUrl;
            }
            return efaUrl;
        }

        function parseDownloadType(type, fileUrl) {
            // special case
            if ((type === 'SM') && fileUrl && (fileUrl.indexOf('ME_')>-1)) {
                return 'SM_ME';
            }
            return type;
        }

        return pp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVDepartureParser
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-comm.itd.xmljson.service:MDVTransportationParser
     * @requires mng-model.object:MDVDeparture
     * @requires mng-model.object:MDVArrival
     * @requires mng-model.object:MDVLocation
     * @description
     *
     * Parse a given departure object provided in an EFA response
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVDepartureParser', MDVDepartureParser);

    MDVDepartureParser.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-comm.itd.MDVEFAFormatter',
        'mng-comm.itd.xmljson.MDVTransportationParser', 'mng-model.MDVDeparture',
        'mng-model.MDVArrival', 'mng-model.MDVLocation', 'mng-comm.itd.xmljson.MDVLocationParser',
        'mng-comm.itd.xmljson.MDVEFAUtil'];

    function MDVDepartureParser(MDVLog, MDVConfig, MDVEFAFormatter, MDVTransportationParser,
            MDVDeparture, MDVArrival, MDVLocation, MDVLocationParser, MDVEFAUtil) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVDepartureParser'),
            dp = {
                parseDeparture : parseDeparture,
                parseArrival : parseArrival,
                parseLine : parseLine
            };

        log.debug('initialize');

        function parseDepartureStopInfos(efaDeparture) {
            if (!efaDeparture.hasOwnProperty('stopInfos') || efaDeparture.stopInfos === null) {
                return [];
            }
            if (efaDeparture.stopInfos.hasOwnProperty('stopInfo')) {
                efaDeparture.stopInfos = [efaDeparture.stopInfos.stopInfo];
            }
            return MDVEFAUtil.parseInfos(efaDeparture.stopInfos);
        }

        function parseDisassembledName(efaDeparture) {
            if (efaDeparture.platformName) {
                return efaDeparture.platformName;
            }
            if (MDVConfig.isReady() &&
                    MDVConfig.getValue('mng-comm-itd-xmljson.MDVEFADM.parser.fallbackToPlatformId')) {
                return efaDeparture.platform;
            }
            return '';
        }

        function parseDepartureLocation(efaDeparture) {
            if (efaDeparture.platform && efaDeparture.area) {
                // point is platform
                return new MDVLocation({
                    id : efaDeparture.stopID + ':' + efaDeparture.area + ':' + efaDeparture.platform,
                    name : efaDeparture.stopName,
                    disassembledName : parseDisassembledName(efaDeparture),
                    coord : [parseFloat(efaDeparture.y), parseFloat(efaDeparture.x)],
                    parent : new MDVLocation({
                        id : efaDeparture.stopID,
                        name : efaDeparture.stopName,
                        disassembledName : efaDeparture.nameWO,
                        coord : [parseFloat(efaDeparture.y), parseFloat(efaDeparture.x)],
                        type : MDVLocation.LOCATIONTYPES.STOP
                    }),
                    infos : getParseDepartureInfos(efaDeparture),
                    type : MDVLocation.LOCATIONTYPES.STOP_POINT,
                    properties : {
                        platformId : efaDeparture.platformName,
                        areaId : efaDeparture.area,
                        platecode : efaDeparture.platecode,
                        nameWo : efaDeparture.nameWO
                    }
                });
            }
            // point is stop
            return new MDVLocation({
                id : efaDeparture.stopID,
                name : efaDeparture.stopName,
                disassembledName : parseDisassembledName(efaDeparture),
                coord : [parseFloat(efaDeparture.y), parseFloat(efaDeparture.x)],
                infos : MDVEFAUtil.parseInfos(efaDeparture.stopInfos),
                type : MDVLocation.LOCATIONTYPES.STOP,
                properties : {
                    platecode : efaDeparture.platecode,
                    nameWo : efaDeparture.nameWO
                }
            });
        }

        function getParseDepartureInfos(efaDeparture) {
            // if (efaDeparture.hasOwnProperty('lineInfos') && efaDeparture.lineInfos !== null) {
            //     return parseDepartureLineInfos(efaDeparture);
            // }
            if (efaDeparture.hasOwnProperty('stopInfos') && efaDeparture.stopInfos !== null) {
                return parseDepartureLineInfos(efaDeparture);
            }
            if (efaDeparture.hasOwnProperty('tripInfos') && efaDeparture.tripInfos !== null) {
                return parseDepartureTripInfos(efaDeparture);
            }
            return [];
        }

        function parseDepartureLineInfos(efaDeparture) {
            if (!efaDeparture.hasOwnProperty('lineInfos') || efaDeparture.lineInfos === null) {
                return [];
            }
            if (efaDeparture.lineInfos.hasOwnProperty('lineInfo')) {
                efaDeparture.lineInfos = [efaDeparture.lineInfos.lineInfo];
            }
            return MDVEFAUtil.parseInfos(efaDeparture.lineInfos);
        }
        function parseDepartureTripInfos(efaDeparture) {
            if (!efaDeparture.hasOwnProperty('tripInfos') || efaDeparture.tripInfos === null) {
                return [];
            }
            if (efaDeparture.tripInfos.hasOwnProperty('tripInfo')) {
                efaDeparture.tripInfos = [efaDeparture.tripInfos.tripInfo];
            }
            return MDVEFAUtil.parseInfos(efaDeparture.tripInfos);
        }

        function parseDepartureProperties(efaDeparture, type) {
            var props = {
                dateTimeEstimated : MDVEFAFormatter.dateTime2moment(efaDeparture.realDateTime),
                dateTimePlanned : MDVEFAFormatter.dateTime2moment(efaDeparture.dateTime),
                isRealtimeControlled : parseInt(efaDeparture.servingLine.realtime, 10) === 1,
                location : parseDepartureLocation(efaDeparture),
                infos : parseDepartureLineInfos(efaDeparture),
                onwardStopSeq : parseStopSeq(efaDeparture, 'onwardStopSeq'),
                prevStopSeq : parseStopSeq(efaDeparture, 'prevStopSeq'),
                properties : {},
                raw : efaDeparture
            };

            if (efaDeparture.operator) {
                efaDeparture.servingLine.operator = {
                    code : efaDeparture.operator.publicCode || efaDeparture.operator.code,
                    name : efaDeparture.operator.name
                };
            }
            if (efaDeparture.servingLine.key) {
                efaDeparture.servingLine.tripCode = parseInt(efaDeparture.servingLine.key, 10);
            }

            props.transportation = MDVTransportationParser.parse(efaDeparture.servingLine, type);
            return props;
        }

        /**
         * @public
         * @ngdoc method
         * @name parseDeparture
         * @methodOf mng-comm.itd.xmljson.service:MDVDepartureParser
         * @param {Object} efaDeparture the efa 'departure' object
         * @returns {MDVDeparture} MDVDeparture new parsed {@link mng-model.object:MDVDeparture
         * MDVDeparture} object
         *
         * @description
         * using a helper method, this method parses an EFA departure object to
         * {@link mng-model.object:MDVDeparture MDVDeparture}
         */
        function parseDeparture(efaDeparture) {
            return new MDVDeparture(parseDepartureProperties(efaDeparture, 'DMdep'));
        }

        /**
         * @public
         * @ngdoc method
         * @name parseArrival
         * @methodOf mng-comm.itd.xmljson.service:MDVDepartureParser
         * @param {Object} efaArrival the efa 'arrival' object
         * @returns {MDVArrival} MDVArrival new parsed {@link mng-model.object:MDVArrival
         * MDVArrival} object
         *
         * @description
         * using a helper method, this method parses an EFA arrival object to
         * {@link mng-model.object:MDVArrival MDVArrival}
         */
        function parseArrival(efaArrival) {
            return new MDVArrival(parseDepartureProperties(efaArrival, 'DMarr'));
        }


        /**
         * @public
         * @ngdoc method
         * @name parseLine
         * @methodOf mng-comm.itd.xmljson.service:MDVDepartureParser
         * @param {Object} efaServingLine the efa 'line' object
         * @returns {MDVTransportation} MDVTransportation new parsed {@link
         * mng-model.object:MDVTransportation MDVTransportation} object
         *
         * @description
         * using a helper method, this method parses an EFA line object to
         * {@link mng-model.object:MDVTransportation MDVTransportation}
         */
        function parseLine(efaServingLine) {
            return MDVTransportationParser.parse(efaServingLine, 'DMline');
        }

        function parseStopSeq(efaDeparture, stopSeqType) {
            if (efaDeparture.hasOwnProperty(stopSeqType) &&
                    efaDeparture[stopSeqType] &&
                    efaDeparture[stopSeqType].length>0) {
                var i,
                    l,
                    stopSeqArr = [];

                for (i = 0, l = efaDeparture[stopSeqType].length; i < l; i += 1) {
                    stopSeqArr.push(MDVLocationParser.parse(efaDeparture[stopSeqType][i], 'stopseq'));
                }
                return stopSeqArr;
            }
            return [];
        }

        return dp;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAParkObjectParser', MDVEFAParkObjectParser);

    MDVEFAParkObjectParser.$inject = ['mng-util.MDVLog'];

    function MDVEFAParkObjectParser(MDVLog) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFAParkObjectParser'),
            poParser = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response) {
            var i,
                res = [];

            if (response && response.addOdv) {
                res.push(response.addOdv);
            }

            if (response && response.addOdvs) {
                res.push(response.addOdvs);
            }

            return res;
        }

        return poParser;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAParkObject', MDVEFParkObject);

    MDVEFParkObject.$inject = ['$q', 'mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-comm.itd.xmljson.MDVEFAUtil',
        'mng-comm.itd.xmljson.MDVEFAParkObjectParser'];


    function MDVEFParkObject($q, MDVLog, MDVConfig, MDVEFARequester, MDVEFAUtil, MDVEFAParkObjectParser) {

        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFParkObject',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            parkRequester,
            info = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }

            _private.running_xhr = parkRequester.request(options)
                .then(function(response) {
                    _private.running_xhr = null;
                    return MDVEFAParkObjectParser.parse(response);
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_PARKOBJECT_REQUEST?',
                defaultParams : {},
                // cache : true
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                info._private = _private;
            }
        });

        // create customized requester object
        parkRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFAParkObject',
            _private.getDefaultConfigOption());

        return info;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAMoveTripParser', MDVEFAMoveTripParser);

    MDVEFAMoveTripParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.xmljson.MDVEFATripParser'];

    function MDVEFAMoveTripParser(MDVLog, MDVEFATripParser) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFAMoveTripParser'),
            mrp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response, originalJourney) {
            var parsed = MDVEFATripParser.parse(response).trips,
                i, l;

            for (i = 0, l = parsed.length; i < l; i += 1) {
                parsed[i].overallResponse = originalJourney.overallResponse;
                parsed[i].previousJourney = originalJourney;
            }
            return parsed;
        }

        return mrp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAMoveTrip', MDVEFAMoveTrip);

    MDVEFAMoveTrip.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-util.MDVUtil',
        'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.xmljson.MDVEFAMoveTripParser', 'mng-util.MDVException'];


    function MDVEFAMoveTrip(MDVLog, MDVConfig, MDVUtil, MDVEFARequester, MDVEFAMoveTripParser,
            MDVException) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFAMoveTrip',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            mrRequester,
            mr = {
                moveJourney : moveJourney
            };

        log.debug('initialize');

        // ////////////////////////////////

        function moveJourney(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                postObj;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            postObj = getPostObj(options);

            _private.running_xhr = mrRequester.request(postObj)
                .then(function(response) {
                    if (!response) {

                        throw new MDVException(MDVException.keys.MNG_COMM__TTB.SERVICE_FAILED, {
                            options : options,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;

                    return MDVEFAMoveTripParser.parse(response, options.journey);
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/JSON_MOVETRIP_REQUEST?',
                defaultParams : {},
                cache : false,
                // do not override
                requestType : 'post'
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function getPostObj(options) {
            var obj = options.journey.overallResponse,
                leg = options.leg,
                hasLegIndex,
                index;

            obj.trips = [options.journey.raw()];

            hasLegIndex = leg.efaIndex || leg.efaIndex === 0;

            if (!hasLegIndex) {
                log.error('leg.efaIndex not defined. Fallback to leg index 0, which can be wrong!');
            }
            index = leg.efaIndex? leg.efaIndex : 0;
            index += 1;

            obj.params = {
                coordOutputFormat : 'EPSG:4326',
                partialTrip : index.toString(),
                command : options.toPrevious? 'prevPartialTrip' : 'nextPartialTrip',
                useUnifiedTickets : '1'
            };
            log.debug(obj.trips[0], true);
            log.debug('leg-index: ' + obj.params.partialTrip + ', ' + obj.params.partialTrip);

            return obj;
        }

        function isReady(options) {
            var reasons = [];

            if (!options.journey) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                    reason : 'journey missing'
                }));
            }
            if (!options.leg) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                    reason : 'leg missing'
                }));
            }
            return reasons;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                mr._private = _private;
            }
        });

        // create customized requester object
        mrRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFAMoveTrip',
            _private.getDefaultConfigOption());

        return mr;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAMapRouteParser', MDVEFAMapRouteParser);

    MDVEFAMapRouteParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.xmljson.MDVFileParser',
        'mng-comm.itd.MDVEFAFormatter'];

    function MDVEFAMapRouteParser(MDVLog, MDVFileParser, MDVEFAFormatter) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFAMapRouteParser'),
            mrp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response, options) {
            if (response.mapRoute.length === 0) {
                return null;
            }
            var firstFile = response.mapRoute[0],
                fileProps,
                genAttrsObj,
                serverInfo;

            if (!firstFile || !firstFile.itdDownload || !firstFile.itdDownload ||
                !firstFile.itdDownload.itdDownloadFile || !firstFile.itdDownload.itdDownloadFile.src) {
                return null;
            }
            fileProps = {
                input : 'MAP_ROUTE_' + getFileName(options),
                stream : firstFile.stream,
                url : firstFile.itdDownload.itdDownloadFile.src,
                size : firstFile.itdDownload.itdDownloadFile.size
            };

            genAttrsObj = MDVEFAFormatter.parseGenAttrs(response.parameters);

            if (genAttrsObj.hasOwnProperty('serverID')) {
                serverInfo = {
                    serverID : genAttrsObj.serverID
                };
            }

            return MDVFileParser.parse(fileProps, serverInfo);
        }

        function getFileName(opts) {
            if (opts && opts.location) {
                return cleanFilename(opts.location.name());
            } else if (opts.journey) {
                return cleanFilename(opts.journey.origin().name()+'-'+opts.journey.destination().name());
            }
            return cleanFilename(new Date().toString());
        }

        function cleanFilename(str) {
            return str.replace(/ /g, '_').replace(/,/g, '');
        }

        return mrp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAMapRoute', MDVEFAMapRoute);

    MDVEFAMapRoute.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-util.MDVUtil',
        'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.xmljson.MDVEFAMapRouteParser', 'mng-util.MDVException'];


    function MDVEFAMapRoute(MDVLog, MDVConfig, MDVUtil, MDVEFARequester, MDVEFAMapRouteParser,
            MDVException) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFAMapRoute',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            mrRequester,
            mr = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////


        function search(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                postObj;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            postObj = getPostObj(options);

            _private.running_xhr = mrRequester.request(postObj)
                .then(function(response) {
                    if (!response || !response.mapRoute || response.mapRoute.length === 0) {

                        throw new MDVException(MDVException.keys.MNG_COMM__TTB.SERVICE_FAILED, {
                            options : options,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;

                    return MDVEFAMapRouteParser.parse(response, options);
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/JSON_MAPROUTE_REQUEST?',
                cache : false,
                // do not override
                requestType : 'post'
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function getPostObj(options) {
            var obj = options.journey.overallResponse,
                raw = options.journey.raw(),
                leg = options.leg,
                location = options.location,
                hasLegIndex,
                useOrig = true,
                index;

            obj.trips = [raw];

            if (leg && location) {
                hasLegIndex = leg.efaIndex || leg.efaIndex === 0;

                if (!hasLegIndex) {
                    log.error('leg.efaIndex not defined. Fallback to leg index 0, which can be wrong!');
                }
                index = leg.efaIndex? leg.efaIndex : 0;
                index += 1;  // MAPROUTE index starts with 1

                var lastLeg = options.journey.legs()[options.journey.legs().length-1];

                if (location.equals(lastLeg.destination())) {
                    useOrig = false;
                }

                if (leg.transportation().productClass() === 99) {
                    // use origin of next leg
                    if (Object.keys(leg.raw()).length === 0) {
                        // this leg is generated by the modules
                        index = index + 1;
                    } else {
                        // this interchange leg is generated by backend
                        index = leg.efaIndex + 1;
                    }
                    useOrig = true;
                }

                obj.params = {
                    route_index : '1',
                    partial_route_index : index.toString(),
                    point_index : (useOrig)? 'orig' : 'dest',
                    imageFormat : 'pdf',
                    language : 'de'
                };
                log.debug(obj.trips[0], true);
                log.debug('leg-index: ' + obj.params.partial_route_index + ', ' + obj.params.point_index);
            } else {
                obj.params = {
                    route_index : '1',
                    partial_route_index : '1',
                    point_index : 'overview',
                    imageFormat : 'pdf',
                    language : 'de'
                };
            }

            if (options.efaParams) {
                obj.params = angular.merge({}, obj.params, options.efaParams);
            }

            return obj;
        }

        function isReady(options) {
            var reasons = [];

            if (!options.journey) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                    reason : 'journey missing'
                }));
            }
            // if (!options.leg) {
            //     reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
            //         reason : 'leg missing'
            //     }));
            // }
            // if (!options.location) {
            //     reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
            //         reason : 'location missing'
            //     }));
            // }
            return reasons;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                mr._private = _private;
            }
        });

        // create customized requester object
        mrRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFAMapRoute',
            _private.getDefaultConfigOption());

        return mr;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFALivePositionsParser', MDVEFALivePositionsParser);

    MDVEFALivePositionsParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.xmljson.MDVTransportationParser'];

    function MDVEFALivePositionsParser(MDVLog, MDVTransportationParser) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFALivePositionsParser'),
            lpParser = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response) {
            var i,
                res = [],
                efaMot;

            for (i=0; i<response.length; i+=1) {
                efaMot = response[i];
                res.push(MDVTransportationParser.parse(efaMot, 'LP'));
            }
            return res;
        }

        return lpParser;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFALivePositions', MDVEFALivePositions);

    MDVEFALivePositions.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.MDVEFAOptionsParser', 'mng-comm.itd.xmljson.MDVEFALivePositionsParser',
        'mng-util.MDVException', 'mng-util.MDVUtil', 'mng-model.MDVTransportation'];


    function MDVEFALivePositions(MDVLog, MDVConfig, MDVEFARequester, MDVEFAOptionsParser,
            MDVEFALivePositionsParser, MDVException, MDVUtil, MDVTransportation) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFALivePositions',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            lpRequester,
            lp = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(inputa, inputb, options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(inputa, inputb),
                params;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            params = addSearchParams(inputa, inputb, options);

            _private.running_xhr = lpRequester.request(params)
                .then(function(response) {
                    if (!response) {
                        throw new MDVException(MDVException.keys.MNG_COMM__LIVE_POSITIONS.SERVICE_FAILED, {
                            args : [inputa, inputb, options],
                            service : _private.namespace,
                            reason : 'no response'
                        });
                    }
                    _private.running_xhr = null;
                    var result = MDVEFALivePositionsParser.parse(response);

                    return result;
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/VELOC?',
                defaultParams : {},
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function isReady(inputa, inputb) {
            var reasons = [],
                i, l;

            if (inputa && inputa.constructor === Array) {
                for (i=0, l=inputa.length; i<l; i+=1) {
                    if (!inputa[i] || !(inputa[i] instanceof MDVTransportation)) {
                        reasons.push(new MDVException(MDVException.keys.MNG_COMM__LIVE_POSITIONS.NO_INPUT, {
                            reason : 'Invalid Transportations array'
                        }));
                        return reasons;
                    }
                }
                return reasons;
            }

            if (inputa && inputa instanceof MDVTransportation) {
                return reasons;
            }

            if (!inputa || !inputb) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__LIVE_POSITIONS.NO_INPUT, {
                    reason : 'Missing coordinates'
                }));
            }

            if (!MDVUtil.isValidCoordinate(inputa) || !MDVUtil.isValidCoordinate(inputb)) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__LIVE_POSITIONS.INVALID_INPUT, {
                    reason : 'Invalid coordinates'
                }));
            }

            return reasons;
        }

        function parseLineId(transportations) {
            if (transportations && transportations instanceof MDVTransportation) {
                transportations = [transportations];
            }

            var result = [],
                transportation,
                i, l,
                j, m,
                idArr;

            for (i=0, l=transportations.length; i<l; i+=1) {
                transportation = transportations[i];
                idArr = transportation.id().split(':');
                if (transportation.isPublicTransportation()) {
                    if (idArr.length<5) {
                        throw new MDVException(MDVException.keys.MNG_COMM__LIVE_POSITIONS.SERVICE_FAILED, {
                            args : [transportation],
                            service : _private.namespace,
                            reason : 'invalid transportation id'
                        });
                    }

                    for (j=0, m=idArr.length; j<m; j+=1) {
                        idArr[j] = idArr[j].trim();
                    }

                    result.push(idArr[4] + ':' + idArr[0] + ':' + idArr[1] + ':' + idArr[3] + ':' + idArr[2]);
                }
            }

            return result;
        }

        function addSearchParams(inputa, inputb, options) {
            if (inputa && inputa.constructor === Array) {
                return {
                    LineID : parseLineId(inputa)
                };
            }

            if (inputa && inputa instanceof MDVTransportation) {
                return {
                    LineID : parseLineId(inputa)
                };
            }
            if (options && options.productRestrictions) {
                // enable veloc parsing
                options.productRestrictions.velocMode = true;
            }

            if (options.transportations) {
                if (!options.efaParams) {
                    options.efaParams = {};
                }
                options.efaParams.LineID = parseLineId(options.transportations);
            }

            var params = MDVEFAOptionsParser.parse(options);

            if (!params.MOTCode) {
                params.MOTCode = 999;
            }

            params.MinX = inputa.lng.toString();
            params.MinY = inputa.lat.toString();
            params.MaxX = inputb.lng.toString();
            params.MaxY = inputb.lat.toString();
            params.ts = new Date().getTime();

            return params;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                lp._private = _private;
            }
        });

        // create customized requester object
        lpRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFALivePositions',
            _private.getDefaultConfigOption());

        return lp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVEFAGeoObjectParser
     * @requires moment
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.xmljson.service:MDVTransportationParser
     * @description
     *
     * Parse a given geoobject response object provided by the EFA and parse it to a list of {@link
     * mng-model.object:MDVTransportation MDVTransportations}.
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAGeoObjectParser', MDVEFAGeoObjectParser);

    MDVEFAGeoObjectParser.$inject = ['moment', 'mng-util.MDVLog',
        'mng-comm.itd.xmljson.MDVTransportationParser'];

    function MDVEFAGeoObjectParser(moment, MDVLog, MDVTransportationParser) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFAGeoObjectParser'),
            cp = {
                parse : parse
            };

        log.debug('initialize');

        function isInvalidResponse(response) {
            return !response || !response.geoObjects || !response.geoObjects.params ||
                !response.geoObjects.items || !response.geoObjects.items.length ||
                !response.geoObjects.params.modes || !response.geoObjects.params.modes.length;
        }

        function parseServingLines(servinglines) {
            var lines = [];

            servinglines.forEach(function(line) {
                var parsed = MDVTransportationParser.parse(line, 'geoselline');

                if (parsed) {
                    lines.push(parsed);
                }
            });

            return lines;
        }

        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.xmljson.service:MDVEFAGeoObjectParser
         * @param {Object} response the efa response object
         * @returns {Object} normalized information object
         *
         * @description
         * convert a given set of infos to a list of normalized information objects
         */
        function parse(response) {
            var additional = {},
                lines = [],
                servingLines,
                curr = {},
                i,
                l;

            if (isInvalidResponse(response)) {
                return lines;
            }

            for (i = 0, l = response.geoObjects.params.modes.length; i < l; i += 1) {
                if (response.geoObjects.params.modes[i].mode) {
                    curr = response.geoObjects.params.modes[i].mode;
                    if (curr && curr.diva && curr.diva.stateless) {
                        additional[curr.diva.stateless] = curr;
                    }
                }
            }
            if (response.geoObjects.servingLines && response.geoObjects.servingLines.lines) {
                servingLines = parseServingLines(response.geoObjects.servingLines.lines);
            }

            for (i = 0, l = response.geoObjects.items.length; i < l; i += 1) {
                if (response.geoObjects.items[i].item) {
                    curr = response.geoObjects.items[i].item;
                    if (curr && curr.mode && curr.mode.diva &&
                            additional.hasOwnProperty(curr.mode.diva.stateless)) {
                        curr.mode = additional[curr.mode.diva.stateless];
                    }

                    if (servingLines) {
                        curr.servingLines = servingLines;
                    }

                    curr = MDVTransportationParser.parse(curr, 'geo');

                    lines.push(curr);
                }
            }
            return lines;
        }
        return cp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVEFAGeoObject
     * @requires $q
     * @requires mng-util.service:MDVLog
     * @requires mng-util.service:MDVUtil
     * @requires mng-util.service:MDVException
     * @requires mng-comm.itd.service:MDVEFARequester
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-comm.itd.xmljson.service:MDVEFAUtil
     * @requires mng-comm.itd.xmljson.service:MDVEFAGeoObjectParser
     * @requires mng-model.service:MDVTransportation
     * @description
     *
     * Main Service to get lists of {@link mng-model.object:MDVTransportation MDVTransportations}
     * that provide additional information for a certain transportation id, like coordinates or
     * passed stops.
     *
     * This service registers a {@link mng-comm.itd.service:MDVEFARequester MDVEFARequest} for
     * GEOOBJECT-purposes. This requester is used whenever the search method is called.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd-xmljson.MDVEFAGeoObject`.
     *
     * As the `MDVEFAGeoObject` service does not support any special parameters, please refer
     * to the {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester} service for detailed a
     * configuration description.
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAGeoObject', MDVEFAGeoObject);

    MDVEFAGeoObject.$inject = ['$q', 'mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-util.MDVException',
        'mng-util.MDVUtil', 'mng-comm.itd.MDVEFARequester', 'mng-model.MDVTransportation',
        'mng-comm.itd.MDVEFAFormatter', 'mng-comm.itd.MDVEFAOptionsParser',
        'mng-comm.itd.xmljson.MDVEFAUtil', 'mng-comm.itd.xmljson.MDVEFAGeoObjectParser'];


    function MDVEFAGeoObject($q, MDVLog, MDVConfig, MDVException, MDVUtil, MDVEFARequester,
            MDVTransportation, MDVEFAFormatter, MDVEFAOptionsParser, MDVEFAUtil,
            MDVEFAGeoObjectParser) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFAGeoObject',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            geoRequester,
            info = {
                searchLines : searchLines
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name searchLines
         * @methodOf mng-comm.itd.xmljson.service:MDVEFAGeoObject
         * @param {Transportation | Transportation[]} transportations A single transportation or a
         * list of transportation objects.
         * @param {Object} options additional options that should be used for this search only
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVTransportation MDVTransportations}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVTransportationRequester MDVTransportationRequester} service. It
         * triggers a
         * XML_GEOOBJECT_REQUEST with the given input and passes the response to the {@link
         * mng-comm.itd.xmljson.service:MDVEFAGeoObjectParser MDVEFAGeoObjectParser} to ensure
         * that a unified list of {@link mng-model.object:MDVTransportation MDVTransportations} is
         * returned in
         * the response object.
         */
        function searchLines(transportations, options) {
            if (!isReady(transportations)) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                        input : transportations,
                        reason : 'invalid type. expected MDVTransportation or MDVTransportation[]'
                    })
                );
            }
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            if (!options) {
                options = {};
            }
            var params = getSearchParams(transportations, options);

            _private.running_xhr = geoRequester.request(params)
                .then(function(response) {
                    _private.running_xhr = null;
                    return MDVEFAGeoObjectParser.parse(response);
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_GEOOBJECT_REQUEST?',
                defaultParams : {},
                cache : true
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function isReady(input) {
            // test if input array consists of MDVTransportation elements might be useful here
            return input && ((input instanceof MDVTransportation) || input.constructor === Array);
        }

    //    /**
    //     * @private
    //     * @ngdoc method
    //     * @name reject_xhr
    //     * @methodOf mng-comm.itd.xmljson.service:MDVEFAStopfinder
    //     * @param {xhr} xhr Xhr that should be rejected.
    //     *
    //     * @description
    //     * reject a given xhr and broadcast a 'COM.NEW_REQUEST'-Event
    //     */
        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function getSearchParams(transportations, options) {
            var params = MDVUtil.copy(options.efaParams || {}),
                lines = [],
                i,
                l,
                date;

            if (transportations.constructor !== Array) {
                transportations = [transportations];
            }

            for (i = 0, l = transportations.length; i < l; i += 1) {
                if (transportations[i] instanceof MDVTransportation) {
                    lines.push(transportations[i].id());
                }
            }

            params.line = lines;

            if (options && options.dateTime && options.dateTime.date) {
                date = MDVEFAOptionsParser._handleDate(options.dateTime.date,
                                                        options.dateTime.dateFormat);
                if (date) {
                    params.filterDate = date;
                }
            }

            return params;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                info._private = _private;
            }
        });

        // create customized requester object
        geoRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFAGeoObject',
            _private.getDefaultConfigOption());

        return info;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAExtensionTicketParser', MDVEFAExtensionTicketParser);

    MDVEFAExtensionTicketParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.xmljson.MDVEFAFareParser'];

    function MDVEFAExtensionTicketParser(MDVLog, MDVEFAFareParser) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFAExtensionTicketParser'),
            mrp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////
        function isInvalidResponse(response) {
            return !response.itdFare;
        }

        function getLegIndices(legs) {
            var i,
                l,
                map = [];

            for (i = 0, l = legs.length; i < l; i += 1) {
                if (legs[i].legIndex || legs[i].legIndex === 0) {
                    map.push(i);
                }
            }
            return map;
        }

        function parse(response, journey) {
            if (isInvalidResponse(response)) {
                log.error('no valid response');
                return [];
            }

            var map = getLegIndices(journey.legs()),
                tickets = MDVEFAFareParser.parse(response.itdFare, map);

            return tickets.tickets;
        }

        return mrp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAExtensionTicket', MDVEFAExtensionTicket);

    MDVEFAExtensionTicket.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-util.MDVUtil',
        'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.xmljson.MDVEFAExtensionTicketParser', 'mng-util.MDVException'];


    function MDVEFAExtensionTicket(MDVLog, MDVConfig, MDVUtil, MDVEFARequester,
            MDVEFAExtensionTicketParser, MDVException) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFAExtensionTicket',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            mrRequester,
            mr = {
                requestExtensionTickets : requestExtensionTickets
            };

        log.debug('initialize');

        // ////////////////////////////////

        function requestExtensionTickets(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                efa_opts;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            efa_opts = getOptions(options);

            _private.running_xhr = mrRequester.request(efa_opts)
                .then((function(originalJourney) {
                    return function(response) {
                        if (!response) {

                            throw new MDVException(MDVException.keys.MNG_COMM__TTB.SERVICE_FAILED, {
                                options : options,
                                service : 'mng-comm.itd.xmljson.MDVEFAMoveTrip',
                                reason : 'no results'
                            });
                        }
                        _private.running_xhr = null;

                        return MDVEFAExtensionTicketParser.parse(response, originalJourney);
                    };
                }(options.journey)));
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_ADDFARES2TRIP_REQUEST?',
                defaultParams : {
                    useUT : 1
                },
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function getLocationId(location) {
            if (location.properties().stopId) {
                return location.properties().stopId;
            }
            return location.id();
        }

        function getOptions(options) {
            var obj = {},
                counter = 1;

            if (options.zones) {
                obj.zone = options.zones;
            }
            if (options.network) {
                obj.network = options.network;
            }

            options.journey.legs().forEach(function(leg) {
                if (!leg.isPublicTransportation()) {
                    return;
                }
                var origin = leg.origin(),
                    destination = leg.destination(),
                    locationSequence = leg.locationSequence(),
                    line = leg.transportation(),
                    stopSeqCount = 1;

                obj['pr' + counter + 'tC'] = line.properties().tripCode;

                obj['pr' + counter + 'OID'] = getLocationId(origin);
                obj['pr' + counter + 'OArea'] = origin.properties().areaId;
                obj['pr' + counter + 'OPlatform'] = origin.properties().platform;
                obj['pr' + counter + 'ODate'] = origin.departureTimePlanned().format('YYYYMMDD');
                obj['pr' + counter + 'OTime'] = origin.departureTimePlanned().format('HHmm');

                obj['pr' + counter + 'DID'] = getLocationId(destination);
                obj['pr' + counter + 'DArea'] = destination.properties().areaId;
                obj['pr' + counter + 'DPlatform'] = destination.properties().platform;
                obj['pr' + counter + 'DDate'] = destination.arrivalTimePlanned().format('YYYYMMDD');
                obj['pr' + counter + 'DTime'] = destination.arrivalTimePlanned().format('HHmm');

                obj['pr' + counter + 'L'] = line.id();

                locationSequence.forEach(function(location) {
                    obj['pr' + counter + 'sS' + stopSeqCount + 'ID'] = getLocationId(location);
                    obj['pr' + counter + 'sS' + stopSeqCount + 'Area'] = location.properties().areaId;
                    obj['pr' + counter + 'sS' + stopSeqCount + 'Platform'] = location.properties().platform;
                    if (location.departureTimePlanned()) {
                        obj['pr' + counter + 'sS' + stopSeqCount + 'DepDate'] =
                                                location.departureTimePlanned().format('YYYYMMDD');
                        obj['pr' + counter + 'sS' + stopSeqCount + 'DepTime'] =
                                                    location.departureTimePlanned().format('HHmm');
                    }
                    if (location.arrivalTimePlanned()) {
                        obj['pr' + counter + 'sS' + stopSeqCount + 'ArrDate'] =
                                                    location.arrivalTimePlanned().format('YYYYMMDD');
                        obj['pr' + counter + 'sS' + stopSeqCount + 'ArrTime'] =
                                                location.arrivalTimePlanned().format('HHmm');
                    }
                    stopSeqCount += 1;
                });
                counter += 1;
            });

            log.debug(obj, true);

            return obj;
        }

        function isReady(options) {
            var reasons = [];

            if (!options.journey) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                    reason : 'journey missing'
                }));
            }
            return reasons;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                mr._private = _private;
            }
        });

        // create customized requester object
        mrRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFAExtensionTicket',
            _private.getDefaultConfigOption());

        return mr;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVEFADMParser
     * @requires mng-util.service:MDVLog
     * @requires mng-model.object:MDVLocation
     * @requires mng-comm.itd.xmljson.service:MDVDepartureParser
     * @description
     *
     * Parse Object for the response of an EFA Departure Monitor request. It handles the
     * delegation of the objects to parse.
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFADMParser', MDVEFADMParser);

    MDVEFADMParser.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.xmljson.MDVLocationParser', 'mng-comm.itd.xmljson.MDVDepartureParser'
    ];

    function MDVEFADMParser(MDVLog, MDVConfig, MDVLocationParser, MDVDepartureParser) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFADMParser'),
            dmp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        // /**
        // * Check the EFA response validity and iterate over all the departures
        // * to parse them.
        // **/
        function parseDepartures(efaDepartures, assignedStopLocation) {
            var departures = [];

            if (efaDepartures) {
                if (efaDepartures.departure) {
                    efaDepartures = [efaDepartures.departure];
                }
                angular.forEach(efaDepartures, function(departure) {
                    if (!assignedStopLocation) {
                        departures.push(MDVDepartureParser.parseDeparture(departure));
                    } else if (departure.stopID === assignedStopLocation.id()) {
                        departures.push(MDVDepartureParser.parseDeparture(departure));
                    }
                });
            }
            return departures;
        }

        // /**
        // * Check the EFA response validity and iterate over all the arrivals
        // * to parse them.
        // **/
        function parseArrivals(efaArrivals, assignedStopLocation) {
            var arrivals = [];

            if (efaArrivals) {
                if (efaArrivals.arrival) {
                    efaArrivals = [efaArrivals.arrival];
                }
                angular.forEach(efaArrivals, function(arrival) {
                    if (!assignedStopLocation) {
                        arrivals.push(MDVDepartureParser.parseArrival(arrival));
                    } else if (arrival.stopID === assignedStopLocation.id()) {
                        arrivals.push(MDVDepartureParser.parseArrival(arrival));
                    }
                });
            }
            return arrivals;
        }

        // /**
        // * Check the EFA response validity and iterate over all the serving lines
        // * to parse them.
        // **/
        function parseLines(efaLines, assignedStopLocation) {
            var result = [];

            if (!efaLines || !efaLines.lines) {
                return result;
            }
            if (efaLines.lines.line) {
                efaLines.lines = [efaLines.lines.line];
            }

            angular.forEach(efaLines.lines, function(line) {
                if (!line) {
                    return;
                }
                if (!assignedStopLocation) {
                    result.push(MDVDepartureParser.parseLine(line));
                } else if (line.assignedStopID === assignedStopLocation.id()) {
                    result.push(MDVDepartureParser.parseLine(line));
                }
            });
            return result;
        }

        function getGroupConfig() {
            if (MDVConfig.isReady()) {
                return MDVConfig.getValue('mng-comm-itd-xmljson.MDVEFADM.grouped') || {};
            }
            return {};
        }

        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.xmljson.service:MDVEFADMParser
         * @param {Object} response A Javascript object containing the json Efa response for
         * a DM request.
         * @returns {Object} object An object that contains the following three attributes :<br>
         * {<br>
                departures : [{@link mng-model.object:MDVDeparture MDVDeparture}],<br>
                arrivals : [{@link mng-model.object:MDVArrival MDVArrival}],<br>
                lines : [{@link mng-model.object:MDVTransportation MDVTransportation}]<br>
         }
         * @description
         * this method is responsible for parsing any type of the EFA DM response.
         * depending on the response, the method calls a specific helper method that parses the
         * corresponding response.
         */
        function parse(response) {
            if (response) {

                var groupConfig = getGroupConfig(),
                    assignedStops = [],
                    departures = [],
                    arrivals = [],
                    lines = [];

                if (response.dm.itdOdvAssignedStops instanceof Array) {
                    assignedStops = response.dm.itdOdvAssignedStops;
                } else if (response.dm.itdOdvAssignedStops) {
                    assignedStops = [response.dm.itdOdvAssignedStops];
                }


                if (assignedStops && assignedStops.length && groupConfig.departures) {
                    angular.forEach(assignedStops, function(assignedStop) {
                        var assignedStopLocation = MDVLocationParser.parse(assignedStop, 'as'),
                            deps = parseDepartures(response.departureList, assignedStopLocation);

                        departures.push({
                            'assignedLocation' : assignedStopLocation,
                            'departures' : deps
                        });
                    });
                } else {
                    departures = parseDepartures(response.departureList);
                }


                if (assignedStops && assignedStops.length && groupConfig.arrivals) {
                    angular.forEach(assignedStops, function(assignedStop) {
                        var assignedStopLocation = MDVLocationParser.parse(assignedStop, 'as'),
                            arrs = parseArrivals(response.arrivalList, assignedStopLocation);

                        arrivals.push({
                            'assignedLocation' : assignedStopLocation,
                            'arrivals' : arrs
                        });
                    });
                } else {
                    arrivals = parseArrivals(response.arrivalList);
                }


                if (assignedStops && assignedStops.length && groupConfig.lines) {
                    angular.forEach(assignedStops, function(assignedStop) {
                        var assignedStopLocation = MDVLocationParser.parse(assignedStop, 'as'),
                            sl = parseLines(response.servingLines, assignedStopLocation);

                        lines.push({
                            'assignedLocation' : assignedStopLocation,
                            'lines' : sl
                        });
                    });
                } else {
                    lines = parseLines(response.servingLines);
                }

            }

            return {
                departures : departures,
                arrivals : arrivals,
                lines : lines
            };
        }

        return dmp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVEFADM
     * @requires $q
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.xmljson.service:MDVEFARequester
     * @requires mng-comm.itd.xmljson.service:MDVEFADMParser
     * @requires mng-comm.itd.xmljson.service:MDVEFAOptionsParser
     * @description
     *
     * Main Service to get lists of departures/arrivals or a list of serving lines for a specific stop.
     *
     * This service registers a {@link mng-comm.itd.service:MDVEFARequester MDVEFARequest} for
     * DM-purposes. This requester is used whenever the search method is called.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd-xmljson.MDVEFADM`.
     *
     * As the `MDVEFADM` service does not support any special parameters, please refer
     * to the {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester} service for detailed a
     * configuration description.
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFADM', MDVEFADM);

    MDVEFADM.$inject = ['$q', 'mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-model.MDVLocation',
        'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.xmljson.MDVEFAUtil', 'mng-comm.itd.xmljson.MDVEFADMParser',
        'mng-comm.itd.MDVEFAOptionsParser', 'mng-util.MDVException', 'mng-util.MDVUtil'];


    function MDVEFADM($q, MDVLog, MDVConfig, MDVLocation, MDVEFARequester, MDVEFAUtil, MDVEFADMParser,
            MDVEFAOptionsParser, MDVException, MDVUtil) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFADM'
            },
            log = MDVLog.register(_private.namespace),
            dmRequester,
            dm = {
                searchLines : searchLines,
                searchArrivals : searchArrivals,
                searchDepartures : searchDepartures
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name searchDepartures
         * @methodOf mng-comm.itd.xmljson.service:MDVEFADM
         * @param {MDVLocation} location {@link mng-model.object:MDVLocation MDVLocation} object
         * the departures should be searched for
         * @param {Object} options Additional options for the departure search, like date or time.
         * Please note that dateTime.isDeparture is overridden with true and has no effect.
         * @param {Transportation[]} options.transportations List of transportations that should be
         * used for the arrival request
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVDeparture MDVDepartures}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVDepartures MDVDepartures} service. It triggers a
         * XML_DM_REQUEST with the given location (and a default option {'itdDateTimeDepArr':'dep'})
         * and passes the response to the {@link mng-comm.itd.xmljson.service:MDVEFADMParser
         * MDVEFADMParser} to ensure that an unified list of {@link mng-model.object:MDVDeparture
         * MDVDepartures} is returned in the response object.
         */
        function searchDepartures(location, options) {
            return request(location, options)
                .then(function(response) {
                    return response;
                });
        }

        /**
         * @public
         * @ngdoc method
         * @name searchArrivals
         * @methodOf mng-comm.itd.xmljson.service:MDVEFADM
         * @param {MDVLocation} location {@link mng-model.object:MDVLocation MDVLocation} object
         * the arrivals should be searched for
         * @param {Object} options Additional options for the arrival search, like date or time.
         * Please note that dateTime.isDeparture is overridden with false and has no effect.
         * @param {Transportation[]} options.transportations List of transportations that should be
         * used for the arrival request
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVArrival MDVArrivals}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVArrivals MDVArrivals} service. It triggers a
         * XML_DM_REQUEST with the given location (and a default option {'itdDateTimeDepArr':'arr'})
         * and passes the response to the {@link mng-comm.itd.xmljson.service:MDVEFADMParser
         * MDVEFADMParser} to ensure that a unified list of {@link mng-model.object:MDVArrival
         * MDVArrivals} is returned in the response object.
         */
        function searchArrivals(location, options) {
            return request(location, options)
                .then(function(response) {
                    return response;
                });
        }

        /**
         * @public
         * @ngdoc method
         * @name searchLines
         * @methodOf mng-comm.itd.xmljson.service:MDVEFADM
         * @param {MDVLocation} location {@link mng-model.object:MDVLocation MDVLocation} object
         * the departures should be searched for
         * @param {Object} options Additional options for the line search
         * @param {String} type type of lines that should be fetched.
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVDeparture MDVDepartures}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVServingLines MDVServingLines} service. It triggers a
         * XML_DM_REQUEST with the given location and passes the response to the {@link
         * mng-comm.itd.xmljson.service:MDVEFADMParser MDVEFADMParser} to ensure that
         * a unified list of lines is returned in the response object.
         */
        function searchLines(location, options, type) {
            if ((type && type!=='DM') || !isLocation(location)) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG_COMM__DM.INVALID_INPUT, {
                        args : [location],
                        service : _private.namespace,
                        reason : 'INVALID_INPUT'
                    })
                );
            }
            return request(location, options)
                .then(function(response) {
                    return response;
                });
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_DM_REQUEST?',
                defaultParams : {},
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function request(location, options) {
            var id = location.id(),
                efa_opts = MDVEFAOptionsParser.parse(options) ||{};

            efa_opts.name_dm = id;
            efa_opts = addTransportations(options, efa_opts);

            // send new request
            return dmRequester.request(efa_opts)
                .then(function(response) {
                    return MDVEFADMParser.parse(response);
                });
        }

        function isLocation(location) {
            return (location) && location instanceof MDVLocation;
        }

        function addTransportations(options, efaOptions) {
            if (!options || !options.hasOwnProperty('transportations')) {
                return efaOptions;
            }
            var transportations = options.transportations,
                i,
                l,
                lines = [];

            if (transportations && transportations.length > 0) {
                for (i = 0, l = transportations.length; i < l; i += 1) {
                    lines.push(transportations[i].id());
                }
                efaOptions.line = lines;

            }
            return efaOptions;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                dm._private = _private;
            }
        });

        // create customized requester object
        dmRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFADM',
            _private.getDefaultConfigOption());

        return dm;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVEFACoordParser
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-comm.itd.xmljson.service:MDVTransportationParser
     * @requires mng-model.object:MDVDeparture
     * @requires mng-model.object:MDVArrival
     * @requires mng-model.object:MDVLocation
     * @description
     *
     * Parse a given coord response object provided in an EFA and parse it to a list of {@link
     * mng-model.object:MDVLocation MDVLocations}.
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFACoordParser', MDVEFACoordParser);

    MDVEFACoordParser.$inject = ['moment', 'mng-util.MDVLog',
        'mng-comm.itd.xmljson.MDVLocationParser'];

    function MDVEFACoordParser(moment, MDVLog, MDVLocationParser) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFACoordParser'),
            cp = {
                parse : parse
            };

        log.debug('initialize');

        function isInvalidResponse(response) {
            return !response || !response.pins || !response.pins.length;
        }
        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.xmljson.service:MDVEFACoordParser
         * @param {Object} response the efa response object
         * @returns {Object} normalized information object
         *
         * @description
         * convert a given set of infos to a list of normalized information objects
         */
        function parse(response) {
            var location_list = [],
                i,
                l;

            if (isInvalidResponse(response)) {
                return location_list;
            }

            for (i = 0, l = response.pins.length; i < l; i += 1) {
                location_list.push(MDVLocationParser.parse(response.pins[i], 'coord'));
            }
            return location_list;
        }
        return cp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVEFACoord
     * @requires $q
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.xmljson.service:MDVEFARequester
     * @requires mng-comm.itd.xmljson.service:MDVEFADMParser
     * @requires mng-comm.itd.xmljson.service:MDVEFAOptionsParser
     * @description
     *
     * Main Service to get lists of {@link mng-model.object:MDVLocation MDVLocation} that are
     * within a specific geographical region.
     *
     * This service registers a {@link mng-comm.itd.service:MDVEFARequester MDVEFARequest} for
     * COORD-purposes. This requester is used whenever the search method is called.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd-xmljson.MDVEFACoord`.
     *
     * As the `MDVEFACoord` service does not support any special parameters, please refer
     * to the {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester} service for detailed a
     * configuration description.
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFACoord', MDVEFACoord);

    MDVEFACoord.$inject = ['$q', 'mng-util.MDVLog', 'mng-util.MDVUtil', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.MDVEFAFormatter', 'mng-comm.itd.xmljson.MDVEFAUtil',
        'mng-comm.itd.xmljson.MDVEFACoordParser'];


    function MDVEFACoord($q, MDVLog, MDVUtil, MDVConfig, MDVEFARequester, MDVEFAFormatter, MDVEFAUtil,
            MDVEFACoordParser) {
        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFACoord',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            coordRequester,
            info = {
                searchByRadius : searchByRadius,
                searchByBoundingBox : searchByBoundingBox,
                searchBySharingRefId : searchBySharingRefId
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name searchByRadius
         * @methodOf mng-comm.itd.xmljson.service:MDVEFACoord
         * @param {Number[]} latLng Coordinate
         * @param {Number|Number[]} radius or Radius in meter or another coordinate that describes
         * a bounding box.
         * @param {Object} options additional options that should be used for this search only
         * @param {String[]} options.types List of types that should be requested.
         * available types: 'platform', 'stop', 'poi' (points of interest), 'aoi' (areas of
         * interest), 'gis_area' (areas in GIS data), 'gis_point' (points in GIS data)         *
         * @param {String=} options.coordFormat format-code the given coordinate is passed with. If
         * no coordFormat is passed, the plugin assumes that the coordinate format is EPSG:4326
         * (WGS84).
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVLocation MDVLocations}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVLocationRequester MDVLocationRequester} service. It triggers a
         * XML_STOPFINDER_REQUEST with the given input and passes the response to the {@link
         * mng-comm.itd.xmljson.service:MDVEFAStopfinderParser MDVEFAStopfinderParser} to ensure
         * that a unified list of {@link mng-model.object:MDVLocation MDVLocations} is returned in
         * the response object.
         */
        function search(latLng, radius, options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            if (!options) {
                options = {};
            }
            if (!options.types || options.types.length === 0) {
                options.types = ['stop'];
            }
            var params = getSearchParams(latLng, radius, options);

            _private.running_xhr = coordRequester.request(params)
                .then(function(response) {
                    _private.running_xhr = null;
                    return MDVEFACoordParser.parse(response);
                });
            return _private.running_xhr;
        }

        function searchByRadius(latlng, radius, options) {
            return search(latlng, radius, options);
        }

        /**
         * @public
         * @ngdoc method
         * @name searchByRadius
         * @methodOf mng-comm.itd.xmljson.service:MDVEFACoord
         * @param {Number[]} latlng1 Coordinate
         * @param {Number|Number[]} latlng2 or Radius in meter or another coordinate that describes
         * a bounding box.
         * @param {Object} options additional options that should be used for this search only
         * @param {Object} options.parameters additional key-value parameters that should be sent to
         * the backend.
         * @param {String[]} options.types List of types that should be requested.
         * available types: 'platform', 'stop', 'poi' (points of interest), 'aoi' (areas of
         * interest), 'gis_area' (areas in GIS data), 'gis_point' (points in GIS data)         *
         * @param {String=} options.coordFormat format-code the given coordinate is passed with. If
         * no coordFormat is passed, the plugin assumes that the coordinate format is EPSG:4326
         * (WGS84).
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVLocation MDVLocations}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVLocationRequester MDVLocationRequester} service. It triggers a
         * XML_STOPFINDER_REQUEST with the given input and passes the response to the {@link
         * mng-comm.itd.xmljson.service:MDVEFAStopfinderParser MDVEFAStopfinderParser} to ensure
         * that a unified list of {@link mng-model.object:MDVLocation MDVLocations} is returned in
         * the response object.
         */
        function searchByBoundingBox(latlng1, latlng2, options) {
            return search(latlng1, latlng2, options);
        }


        function searchBySharingRefId(sharingRefId, options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            if (!options) {
                options = {};
            }
            var params = getSearchParams(sharingRefId, null, options);

            _private.running_xhr = coordRequester.request(params)
                .then(function(response) {
                    _private.running_xhr = null;
                    return MDVEFACoordParser.parse(response);
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_COORD_REQUEST?',
                defaultParams : {},
                cache : true
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

    //    /**
    //     * @private
    //     * @ngdoc method
    //     * @name reject_xhr
    //     * @methodOf mng-comm.itd.xmljson.service:MDVEFAStopfinder
    //     * @param {xhr} xhr Xhr that should be rejected.
    //     *
    //     * @description
    //     * reject a given xhr and broadcast a 'COM.NEW_REQUEST'-Event
    //     */
        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function parseType(type) {
            var efaTranslationMap = {
                // coordinfo properties
                'stop' : 'STOP',
                'platform' : 'BUS_POINT',
                'poi' : 'POI_POINT',
                'aoi' : 'POI_AREA',
                'callabike' : 'CALL_A_BIKE',
                'gis_area' : 'GIS_AREA',
                'gis_point' : 'GIS_POINT',
                'any' : 'ANY'
            };

            if (!type || !efaTranslationMap.hasOwnProperty(type)) {
                log.warn('unable to map type for coord-request. Received "' + type + '", expected' +
                    ' "stop", "platform", "poi", "aoi", "gis_area" or "gis_point".');
                return null;
            }
            return efaTranslationMap[type];
        }

        function addTypeParams(params, options, radius) {
            var i,
                l,
                curr_type,
                type_options,
                curr_index = 1,
                types = options.types;

            // activate filter for types
            params.inclFilter = 1;

            for (i = 0, l = types.length; i < l; i += 1) {
                curr_type = parseType(types[i]);
                if (options.hasOwnProperty(types[i])) {
                    type_options = options[types[i]];
                } else {
                    type_options = {};
                }

                if (curr_type) {
                    params['type_' + curr_index] = curr_type;
                    if (radius) {
                        params['radius_' + curr_index] = radius;
                    }

                    if (type_options.filters && type_options.filters.include) {
                        params['inclDrawClasses_' + curr_index] = type_options.filters.include;
                    }
                    if (type_options.filters && type_options.filters.exclude) {
                        params['exclLayers_' + curr_index] = type_options.filters.exclude;
                    }

                    curr_index += 1;
                }
            }
            return params;
        }

        function getSearchParams(latLng, radius, options) {
            var params = MDVUtil.copy(options.efaParams || {}),
                coord1 = MDVEFAFormatter.latlng2string(latLng, options.coordFormat),
                coord2 = MDVEFAFormatter.latlng2string(radius, options.coordFormat);

            if (coord1 === '' && coord2 === '') {
                // request sharingRefId
                params.SharingRefId = latLng;
                return params;
            } else if (coord2 === '') {
                // request radius
                params.coord = coord1;
                params = addTypeParams(params, options, radius);
            } else {
                // request bounds
                params.boundingBox = 1;
                params.boundingBoxLU = coord1;
                params.boundingBoxRL = coord2;
                params = addTypeParams(params, options);
            }

            return params;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                info._private = _private;
            }
        });

        // create customized requester object
        coordRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFACoord',
            _private.getDefaultConfigOption());

        return info;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVEFAAddInfoParser
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-comm.itd.xmljson.service:MDVTransportationParser
     * @requires mng-model.object:MDVDeparture
     * @requires mng-model.object:MDVArrival
     * @requires mng-model.object:MDVLocation
     * @description
     *
     * Parse a given departure object provided in an EFA response
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAAddInfoParser', MDVEFAAddInfoParser);

    MDVEFAAddInfoParser.$inject = ['moment', 'mng-util.MDVLog', 'mng-comm.itd.MDVEFAFormatter',
        'mng-model.MDVLocation', 'mng-model.MDVTransportation', 'mng-model.MDVMessage'];

    function MDVEFAAddInfoParser(moment, MDVLog, MDVEFAFormatter, MDVLocation, MDVTransportation,
            MDVMessage) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFAAddInfoParser'),
            ip = {
                parse : parse
            },
            duplexProperties = /(creationTime|lastModificationTime|priority|infoID|seqID)/;

        log.debug('initialize');


        function getTime(itdDateTime) {
            var time;

            if (!itdDateTime.itdDate || !itdDateTime.itdTime) {
                return null;
            }
            time = moment(itdDateTime.itdDate.day + '.' + itdDateTime.itdDate.month + '.' +
                    itdDateTime.itdDate.year + '#' +
                    itdDateTime.itdTime.hour + ':' + itdDateTime.itdTime.minute,
                    'DD.MM.YYYY#HH:mm');
            if (time.isValid()) {
                return time;
            }
            return null;
        }

        function getSource(efaInfo) {
            var source = {};

            if (efaInfo.providerCode) {
                source.provider = efaInfo.providerCode;
            }
            if (efaInfo.sourceSystem) {
                source.system = {};
                if (efaInfo.sourceSystem.systemName) {
                    source.system.name = efaInfo.sourceSystem.systemName;
                }
                if (efaInfo.sourceSystem.systemID) {
                    source.system.id = efaInfo.sourceSystem.systemID;
                }
                if (efaInfo.sourceSystem.systemType) {
                    source.system.type = efaInfo.sourceSystem.systemType;
                }
            }
            return source;
        }

        function handleParamList(info, efaInfo) {
            var i,
                l,
                curr_elem;

            if (efaInfo.infoLink.paramList) {
                for (i = 0, l = efaInfo.infoLink.paramList.length; i < l; i += 1) {
                    curr_elem = efaInfo.infoLink.paramList[i];
                    if (curr_elem.name && !curr_elem.name.match(duplexProperties) &&
                            curr_elem.value) {
                        if (curr_elem.name === 'stopIDglobalID') {
                            info.properties.stopPlatformMap =
                                MDVEFAFormatter.getStopGlobalMap(curr_elem.value);
                        } else {
                            info.properties[curr_elem.name] = curr_elem.value;
                        }
                    }
                }
            }
            return info;
        }

        function handleAdditionalLinks(info, efaInfo) {
            var i,
                l,
                curr_elem,
                additionalLinks = [];

            if (efaInfo.infoLink.additionalLinks) {
                for (i = 0, l = efaInfo.infoLink.additionalLinks.length; i < l; i += 1) {
                    curr_elem = efaInfo.infoLink.additionalLinks[i];
                    additionalLinks.push(new MDVMessage(parseInfo({
                        id : curr_elem.ID,
                        url : curr_elem.linkURL,
                        urlText : curr_elem.linkText,
                        smsText: curr_elem,
                        subtitle : curr_elem.linkTextShort,
                        properties : {
                            linkTarget : curr_elem.linkTarget
                        }
                    })));
                }
            }
            info.additionalLinks = additionalLinks;
            return info;
        }

        function parseInfoLinks(info, efaInfo) {
            if (efaInfo.infoLink.subject) {
                info.title = efaInfo.infoLink.subject;
            }
            if (efaInfo.infoLink.subtitle) {
                info.subtitle = efaInfo.infoLink.subtitle;
            }
            if (efaInfo.infoLink.additionalText) {
                info.text = efaInfo.infoLink.additionalText;
            }
            if (efaInfo.infoLink.content) {
                info.content = efaInfo.infoLink.content;
            }
            if (efaInfo.infoLink.infoLinkURL) {
                info.url = efaInfo.infoLink.infoLinkURL;
            }
            if (efaInfo.infoLink.infoLinkText) {
                info.urlText = efaInfo.infoLink.infoLinkText;
            }
            // speechText and more?

            info = handleParamList(info, efaInfo);
            info = handleAdditionalLinks(info, efaInfo);
            return info;
        }

        function handleValidity(info, efaInfo) {
            var i,
                l,
                curr_elem;

            if (efaInfo.validityPeriod) {
                info.timestamps.validity = [];
                for (i = 0, l = efaInfo.validityPeriod.length; i < l; i += 1) {
                    curr_elem = efaInfo.validityPeriod[i];
                    if (curr_elem &&
                            curr_elem.itdDateTime_To &&
                            curr_elem.itdDateTime_From) {
                        info.timestamps.validity.push({
                            from : getTime(curr_elem.itdDateTime_From),
                            to : getTime(curr_elem.itdDateTime_To)
                        });
                    }
                }
            }
            return info;
        }

        function handlePublication(info, efaInfo) {
            if (efaInfo.publicationDuration && efaInfo.publicationDuration.itdDateTime_From &&
                    efaInfo.publicationDuration.itdDateTime_To) {
                info.timestamps.availability = [{
                    from : getTime(efaInfo.publicationDuration.itdDateTime_From),
                    to : getTime(efaInfo.publicationDuration.itdDateTime_To)
                }];
            }
            return info;
        }

        function parseTimes(info, efaInfo) {
            if (!info.properties.hasOwnProperty('timestamps')) {
                info.timestamps = {};
            }

            if (efaInfo.creationTime) {
                info.timestamps.creation = getTime(efaInfo.creationTime);
            }
            if (efaInfo.expirationDateTime) {
                info.timestamps.expiration = getTime(efaInfo.expirationDateTime);
            }
            if (efaInfo.lastModificationTime) {
                info.timestamps.lastModification = getTime(efaInfo.lastModificationTime);
            }
            info = handlePublication(info, efaInfo);
            info = handleValidity(info, efaInfo);
            return info;
        }

        function parseLocalities(localityList) {
            if (!localityList) {
                return [];
            }
            var localities = [],
                i, l, id;

            for (i = 0, l = localityList.length; i < l; i += 1) {
                if (localityList[i].OMC && localityList[i].placeID) {
                    id = localityList[i].OMC + '|' + localityList[i].placeID;

                    localities.push(new MDVLocation({
                        type : MDVLocation.LOCATIONTYPES.LOCALITY,
                        name : localityList[i].placeName,
                        id : id
                    }));
                }
            }

            return localities;
        }

        function getAffectedLines(efaInfo) {
            var i,
                l,
                curr_elem,
                lines = [];

            if (efaInfo.concernedLines) {
                for (i = 0, l = efaInfo.concernedLines.length; i < l; i += 1) {
                    curr_elem = efaInfo.concernedLines[i];

                    lines.push(new MDVTransportation({
                        id : curr_elem.partialNet + ':' + curr_elem.selected + ':' +
                            curr_elem.supplement + ':' + curr_elem.direction + ':',
                        destination : new MDVLocation({
                            name : curr_elem.directionName
                        }),
                        name : curr_elem.name,
                        number : curr_elem.number,
                        localitySequence : parseLocalities(curr_elem.places),
                        product : {
                            'class' : parseInt(curr_elem.motType, 10),
                            iconId : parseInt(curr_elem.motClass || curr_elem.motCode, 10)
                        },
                        iconId : parseInt(curr_elem.productId, 10)
                    }));
                }
            }

            return lines;
        }

        function getAffectedStops(efaInfo) {
            var i,
                l,
                curr_elem,
                stops = [],
                stop_props;

            if (efaInfo.concernedStops) {
                for (i = 0, l = efaInfo.concernedStops.length; i < l; i += 1) {
                    curr_elem = efaInfo.concernedStops[i];
                    stop_props = {
                        id : curr_elem.stopID,
                        name : curr_elem.name
                    };
                    if (curr_elem.place) {
                        stop_props.parent = new MDVLocation({
                            id : curr_elem.place.OMC,
                            name : curr_elem.place.placeName
                        });
                    } else if (curr_elem.locality) {
                        stop_props.parent = new MDVLocation({
                            name : curr_elem.locality
                        });
                    }
                    stops.push(new MDVLocation(stop_props));
                }
            }
            return stops;
        }

        function getTrafficDetails(efaInfo) {
            var details = [],
            affectedRoads = efaInfo.itIncident.affectedRoads,
            i, l, curr_el;
            if(affectedRoads) {
                for (i = 0, l = affectedRoads.length; i<l; i++ ){
                    curr_el = affectedRoads[i];
                    details.push(curr_el);
                }
            }
            return details;
        }
        function getCoord(efaInfo) {
            var trafficDetails = getTrafficDetails(efaInfo);
            var details = [],
            i, l, curr_el;
            if(trafficDetails) {
                for (i = 0, l = trafficDetails.length; i<l; i++ ){
                    curr_el = trafficDetails[i].symbol.coord;
                    details.push(curr_el);
                }
            }
            return details;
        }
        function getType(efaInfo) {
            var trafficDetails = getTrafficDetails(efaInfo);
            var i, l, type;
            if(trafficDetails) {
                for (i = 0, l = trafficDetails.length; i<l; i++ ){
                    type = trafficDetails[i].symbol.symbolType;
                    // details.push(curr_el);
                }
            }
            return type;
        }
        function getMessageID(efaInfo) {
            var trafficDetails = getTrafficDetails(efaInfo);
            var i, l, id;
            if(trafficDetails) {
                for (i = 0, l = trafficDetails.length; i<l; i++ ){
                    id = trafficDetails[i].ID;
                    // details.push(curr_el);
                }
            }
            return id;
        }
        function getInfoLink(efaInfo) {
            return efaInfo.infoLink;
        }
        function getCreationTime(efaInfo) {
            return efaInfo.creationTime;
        }
        function getPublicationDuration(efaInfo) {
            return efaInfo.publicationDuration;
        }


        function parseInfo(efaInfo) {
            var info = {
                    id : efaInfo.infoID,
                    version : efaInfo.seqID,
                    type : getType(efaInfo),
                    // type : efaInfo.type,
                    priority : efaInfo.priority || 'unknown',
                    properties : {
                        source : getSource(efaInfo)
                    },
                    affectedElements : {
                        lines : getAffectedLines(efaInfo),
                        stops : getAffectedStops(efaInfo)
                    },
                    raw : efaInfo,
                    trafficDetails: getTrafficDetails(efaInfo),
                    coord: getCoord(efaInfo),
                    messageID: getMessageID(efaInfo),
                    infoLink: getInfoLink(efaInfo),
                    creationTime: getCreationTime(efaInfo),
                    publicationDuration: getPublicationDuration(efaInfo),
                },
                curr_elem,
                i,
                l;

            if (efaInfo.infoLink) {
                info = parseInfoLinks(info, efaInfo);
            }

            info = parseTimes(info, efaInfo);

            if (efaInfo.paramList) {
                for (i = 0, l = efaInfo.paramList.length; i < l; i += 1) {
                    curr_elem = efaInfo.paramList[i];
                    if (curr_elem.name && curr_elem.value) {
                        info.properties[curr_elem.name] = curr_elem.value;
                    }
                }
            }

            return info;
        }

        function isInvalidResponse(response) {
            return !response || !response.additionalInformation ||
                !response.additionalInformation.travelInformations ||
                !response.additionalInformation.travelInformations.travelInformation;
        }

        function getTimestamp(response) {
            var time;

            if (!response.additionalInformation.date || !response.additionalInformation.time) {
                return null;
            }
            time = moment(response.additionalInformation.date + '#' +
                    response.additionalInformation.time, 'DD.MM.YYYY#HH:mm');
            if (time.isValid()) {
                return time;
            }
            return null;
        }

        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.xmljson.service:MDVEFAAddInfoParser
         * @param {Object} response the efa 'info' object
         * @returns {Object} normalized information object
         *
         * @description
         * convert a given set of infos to a list of normalized information objects
         */
        function parse(response) {
            var parsed_infos = [],
                efaInfos,
                i,
                l;

            if (isInvalidResponse(response)) {
                return {
                    timestamp : null,
                    infos : parsed_infos
                };
            }
            efaInfos = response.additionalInformation.travelInformations.travelInformation;

            for (i = 0, l = efaInfos.length; i < l; i += 1) {
                parsed_infos.push(new MDVMessage(parseInfo(efaInfos[i])));
            }
            return {
                infos : parsed_infos,
                timestamp : getTimestamp(response)
            };
        }
        return ip;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVEFAAddInfo
     * @requires $q
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.xmljson.service:MDVEFARequester
     * @requires mng-comm.itd.xmljson.service:MDVEFADMParser
     * @requires mng-comm.itd.xmljson.service:MDVEFAOptionsParser
     * @description
     *
     * Main Service to get lists of departures/arrivals or a list of serving lines for a specific stop.
     *
     * This service registers a {@link mng-comm.itd.service:MDVEFARequester MDVEFARequest} for
     * DM-purposes. This requester is used whenever the search method is called.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd-xmljson.MDVEFADM`.
     *
     * As the `MDVEFADM` service does not support any special parameters, please refer
     * to the {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester} service for detailed a
     * configuration description.
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAAddInfo', MDVEFAAddInfo);

    MDVEFAAddInfo.$inject = ['$q', 'mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-comm.itd.xmljson.MDVEFAUtil',
        'mng-comm.itd.xmljson.MDVEFAAddInfoParser', 'mng-comm.itd.MDVEFAOptionsParser'];


    function MDVEFAAddInfo($q, MDVLog, MDVConfig, MDVEFARequester, MDVEFAUtil, MDVEFAAddInfoParser,
            MDVEFAOptionsParser) {

        var _private = {
                namespace : 'mng-comm-itd-xmljson.MDVEFAAddInfo',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            infoRequester,
            info = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name search
         * @methodOf mng-comm.itd.xmljson.service:MDVEFAAddInfo
         * @param {Object} options additional options for the search
         * @param {Object} options.parameters additional key-value parameters that should be sent to
         * the backend.
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVLocation MDVLocations}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVLocationRequester MDVLocationRequester} service. It triggers a
         * XML_STOPFINDER_REQUEST with the given input and passes the response to the {@link
         * mng-comm.itd.xmljson.service:MDVEFAStopfinderParser MDVEFAStopfinderParser} to ensure
         * that a unified list of {@link mng-model.object:MDVLocation MDVLocations} is returned in
         * the response object.
         */
        function search(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }

            _private.running_xhr = infoRequester.request(MDVEFAOptionsParser.parse(options))
                .then(function(response) {
                    _private.running_xhr = null;
                    return MDVEFAAddInfoParser.parse(response);
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_ADDINFO_REQUEST?',
                defaultParams : {},
                cache : true
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

    //    /**
    //     * @private
    //     * @ngdoc method
    //     * @name reject_xhr
    //     * @methodOf mng-comm.itd.xmljson.service:MDVEFAAddInfo
    //     * @param {xhr} xhr Xhr that should be rejected.
    //     *
    //     * @description
    //     * reject a given xhr and broadcast a 'COM.NEW_REQUEST'-Event
    //     */
        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                info._private = _private;
            }
        });

        // create customized requester object
        infoRequester = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFAAddInfo',
            _private.getDefaultConfigOption());

        return info;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc overview
     * @name mng-comm.itd.json
     * @module mng-comm.itd.json
     * @requires mng-comm.itd
     * @requires mng-model
     * @requires mng-util
     *
     * @description
     * # mng-comm.itd.json (main EFA communication module via the json interface)
     * This module provides the communication to the EFA interface and the
     * corresponding parser methods to convert the EFA responses to the abstract model.
     *
     * ## General usage
     * ```js
     * // inject mng-comm.itd.json - components only
     * angular.module('your.module', ['mng-comm.itd.json']);
     * ```
     *
     * The following list gives a short overview of the available components within this module.
     * For further details, please refer to the components themselves.
     *
     * ## parser services
     * These services take care of parsing EFA responses to the {@link mng-model model} objects.
     *
     * ### {@link mng-comm.itd.json.service:MDVEFAUtil MDVEFAUtil}
     * The `MDVEFAUtil` offers a collection of EFA communication-specific utility functions that do
     * not care about formatting (this is handled in the {@link mng-comm.itd.service:MDVEFAFormatter
     * MDVEFAFormatter}).
     *
     * ### {@link mng-comm.itd.json.service:MDVLocationParser MDVLocationParser}
     * The `MDVLocationParser` parses given EFA information of a location (EFA-point-object) to a
     * {@link mng-model.object:MDVLocation MDVLocation}.
     *
     * ### {@link mng-comm.itd.json.service:MDVEFAStopfinderParser MDVEFAStopfinderParser}
     * The `MDVEFAStopfinderParser` parses given EFA information of a XML_STOPFINDER_REQUEST response to a
     * list of {@link mng-model.object:MDVLocation MDVLocations}.
     *
     *
     *
     *
     *
     * ## request services
     * These kind of services care about requesting the correct data from the EFA back-end and
     * passing the response to the corresponding parser before the response is returned.
     *
     * ### {@link mng-comm.itd.json.service:MDVEFAStopfinder MDVEFAStopfinder}
     * The `MDVEFAStopfinder` service implements the interface for {@link
     * mng-comm.service:MDVLocationRequester MDVLocationRequester} and uses the MENTZ-EFA
     * interface to resolve a given name to a list of {@link mng-model.object:MDVLocation
     * MDVLocations}.
     *
     *
     *
     */
    angular.module('mng-comm.itd.json', ['mng-comm.itd', 'mng-model', 'mng-util']);
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFATTBParser', MDVEFATTBParser);

    MDVEFATTBParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.json.MDVFileParser'];

    function MDVEFATTBParser(MDVLog, MDVFileParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFATTBParser'),
            _private = {},
            ttbParser = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response, requestOptions) {
            var fileProps;

            if (response && response.download && response.download.url) {
                fileProps = {
                    input : _private.getFileName(response, requestOptions),
                    type : 'TTB',
                    url : response.download.url,
                    size : response.download.size
                };

                return MDVFileParser.parse(fileProps, response.serverInfo);
            } else {
                log.error('invalid return structure');
            }
        }

        _private.getFileName = function(response, options) {
            var fileName = 'TTB';

            if (response.servingLines && response.servingLines.length>0 && response.servingLines[0].name) {
                return fileName + ' - ' + response.servingLines[0].name;
            }

            if (options && options.lineId) {
                return fileName + ' - ' + options.lineId;
            }

            return fileName + '_' + Date.now();
        };

        return ttbParser;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFATTB', MDVEFATTB);

    MDVEFATTB.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-comm.itd.MDVEFARequester',
                        'mng-comm.itd.json.MDVEFATTBParser', 'mng-util.MDVException',
                        'mng-util.MDVUtil'];


    function MDVEFATTB(MDVLog, MDVConfig, MDVEFARequester, MDVEFATTBParser, MDVException, MDVUtil) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFATTB',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            ttbRequester,
            ttb = {
                search : search,
                searchLines : searchLines
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                params;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            params = addSearchParams(options);

            _private.running_xhr = ttbRequester.request(params)
                .then(function(response) {
                    if (!response || !response.download || !response.download.url) {

                        throw new MDVException(MDVException.keys.MNG_COMM__TTB.SERVICE_FAILED, {
                            input : options,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;

                    return MDVEFATTBParser.parse(response, options);
                });
            return _private.running_xhr;
        }

        function searchLines(input, options, type) {
            if (type && type!=='TTB') {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                        input : input,
                        reason : 'invalid type'
                    })
                );
            }
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var params = options && options.efaParams;

            if (!params) {
                params = {};
            }

            if (typeof input === 'object' && input.hasOwnProperty('id')) {
                // location
                params.mode = 'odv';
                params.type_ttb = 'any';
                params.name_ttb = input.id();
            } else {
                params.lineName = input;
                params.mode = 'line';
            }

            _private.running_xhr = ttbRequester.request(params)
                .then(function(response) {
                    if (!response || response.length === 0 ||
                        !response.servingLines || !response.servingLines.lines) {
                        throw new MDVException(MDVException.keys.MNG_COMM__ROP.SERVICE_FAILED, {
                            args : input,
                            service : 'mng-comm.itd.json.MDVEFAROP',
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;

                    return MDVEFATTBParser.parse(response);
                });
            return _private.running_xhr;
        }


        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_TTB_REQUEST?',
                defaultParams : {
                    command : 'direct'
                },
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function isReady(options) {
            var reasons = [];

            if (!options.lineId) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                    reason : 'lineId missing'
                }));
            }

            return reasons;
        }

        function addSearchParams(options) {
            var params = options.efaParams || {};

            params.line = options.lineId;
            if (options.useFolderPdfFile) {
                params.useFolderPdfFile = options.useFolderPdfFile;
            }

            if (options.lineVer) {
                params.lineVer = options.lineVer;
            }

            params.command = 'direct';

            return params;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                ttb._private = _private;
            }
        });

        // create customized requester object
        ttbRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFATTB',
            _private.getDefaultConfigOption());

        return ttb;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFATripCompositionParser', MDVEFATripCompositionParser);

    MDVEFATripCompositionParser.$inject = ['mng-util.MDVLog', 'mng-util.MDVException'];

    function MDVEFATripCompositionParser(MDVLog, MDVException) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFATripCompositionParser'),
            icp = {
                parse : parse
            };

        log.debug('initialize');

        function parse(res) {
            // if (res && res.tripInformation && res.tripInformation[0].parts) {
            //     return res.tripInformation[0].parts;
            // }
            if (res && res.tripInformation) {
                return res.tripInformation;
            }
            return res;
        }
        return icp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFATripComposition', MDVEFATripComposition);

    MDVEFATripComposition.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-comm.itd.json.MDVEFATripCompositionParser',
        'mng-util.MDVException', 'mng-util.MDVUtil'];


    function MDVEFATripComposition(MDVLog, MDVConfig, MDVEFARequester,
        MDVEFATripCompositionParser, MDVException, MDVUtil) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFATripComposition',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            icRequester,
            lp = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                result;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }
            _private.running_xhr = icRequester.request(options)
                .then(function(response) {
                    if (!response) {
                        throw new MDVException(MDVException.keys.MNG_COMM__TRIPCOMPOSITION.SERVICE_FAILED, {
                            args : [options],
                            service : _private.namespace,
                            reason : 'no response'
                        });
                    }
                    _private.running_xhr = null;
                    result = MDVEFATripCompositionParser.parse(response);
                    return result;
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_TRIP_COMPOSITION_REQUEST?',
                defaultParams : {},
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);
            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function isReady(options) {
            var reasons = [];

            if (!MDVConfig.isReady()) {
                reasons.push(new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                    reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                        'without a valid configuration.'
                }));
            }

            if (!options) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TRIPCOMPOSITION.NO_OPTIONS, {
                    reason : 'Missing options'
                }));
            }

            return reasons;
        }

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                lp._private = _private;
            }
        });

        // create customized requester object
        icRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFATripComposition',
            _private.getDefaultConfigOption());

        return lp;
    }
}());

(function() {
    'use strict';
    
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFATripStopTimesParser', MDVEFATripStopTimesParser);

    MDVEFATripStopTimesParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.json.MDVLocationParser'];

    function MDVEFATripStopTimesParser( MDVLog, MDVLocationParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFATripStopTimesParser'),
            cp = {
                parse : parse
            };

        log.debug('initialize');

        function isInvalidResponse(response) {
            return !response || !response.transportation || !response.stopSequence;
        }

       
        function parse(response) {
            var stops = [],
                curr = null,
                stopSequence = [],
                i,
                l;

            if (isInvalidResponse(response)) {
                return stops;
            }

            stopSequence = response.stopSequence || [];

            for (i = 0, l = stopSequence.length; i < l; i += 1) {
                curr = MDVLocationParser.parse(stopSequence[i], 'stopseq');
                if (curr) {
                    stops.push(curr);
                }
            }
            return stops;
        }

        return cp;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFATripStopTimes', MDVEFATripStopTimes);

        MDVEFATripStopTimes.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-util.MDVException',
        'mng-util.MDVUtil', 'mng-comm.itd.MDVEFARequester', 'mng-model.MDVTransportation',
        'mng-comm.itd.MDVEFAOptionsParser', 'mng-comm.itd.json.MDVEFATripStopTimesParser'];


    function MDVEFATripStopTimes(MDVLog, MDVConfig, MDVException, MDVUtil, MDVEFARequester,
            MDVTransportation, MDVEFAOptionsParser,
            MDVEFATripStopTimesParser) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFATripStopTimes',
                version : '10.2.10.139',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            tripStopTimesRequester,
            tripStopTimes = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////


        function search(transportation, options) {
            if (!isReady(transportation)) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                        input : transportation,
                        reason : 'invalid type. expected MDVTransportation or MDVTransportation[]'
                    })
                );
            }
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            if (!options) {
                options = {};
            }
            var params = getSearchParams(transportation, options);

            _private.running_xhr = tripStopTimesRequester.request(params)
                .then(function(response) {
                    _private.running_xhr = null;
                    return MDVEFATripStopTimesParser.parse(response);
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_TRIPSTOPTIMES_REQUEST?',
                defaultParams : {},
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function isReady(input) {
            // test if input array consists of MDVTransportation elements might be useful here
            return input && (input instanceof MDVTransportation);
        }

    //    /**
    //     * @private
    //     * @ngdoc method
    //     * @name reject_xhr
    //     * @methodOf mng-comm.itd.json.service:MDVEFAStopfinder
    //     * @param {xhr} xhr Xhr that should be rejected.
    //     *
    //     * @description
    //     * reject a given xhr and broadcast a 'COM.NEW_REQUEST'-Event
    //     */
        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function getSearchParams(transportation, options) {
            var params = MDVUtil.copy(options.efaParams || {}),
                date,
                time;

            params.line = transportation.id();
            // params.stopID = transportation.destination().id();
            params.stopID = options.stopId;
            params.tripCode = transportation.properties().tripCode;

            if (options && options.dateTime && options.dateTime.date && options.dateTime.time) {
                date = MDVEFAOptionsParser._handleDate(options.dateTime.date,
                                                        options.dateTime.dateFormat);

                time = MDVEFAOptionsParser._handleTime(options.dateTime.time,
                    options.dateTime.timeFormat);

                if (date) {
                    params.date = date;
                }
                if (time) {
                    params.time = time;
                }
            }
            params.version = _private.version;

            return params;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                tripStopTimes._private = _private;
            }
        });

        // create customized requester object
        tripStopTimesRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFATripStopTimes',
            _private.getDefaultConfigOption());

        return tripStopTimes;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFATripParser
     * @requires mng-util.service:MDVLog
     * @requires mng-model.object:MDVLocation
     * @requires mng-comm.itd.json.service:MDVDepartureParser
     * @description
     *
     * Parser service for the response of aa EFA Trip request. It converts EFA styled objects to the
     * unified Journey object.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFATripParser', MDVEFATripParser);

    MDVEFATripParser.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFAFormatter', 'mng-model.MDVJourney', 'mng-model.MDVJourneyLeg',
        'mng-model.MDVMessage', 'mng-model.MDVFile', 'mng-comm.itd.json.MDVEFAUtil',
        'mng-comm.itd.json.MDVJourneyLegParser', 'mng-comm.itd.json.MDVEFAFareParser'];

    function MDVEFATripParser(MDVLog, MDVUtil, MDVConfig, MDVEFAFormatter, MDVJourney, MDVJourneyLeg,
            MDVMessage, MDVFile, MDVCommUtil, MDVJourneyLegParser, MDVEFAFareParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFATripParser'),
            options = {},
            tripp = {
                parse : parse
            };

        log.debug('initialize');

        MDVConfig.ready(function() {
            options = MDVConfig.getValue('mng-comm-itd-json.MDVEFATrip.parser') || {};
        });

        // ////////////////////////////////

        function parseLegs(efa_trip, serverInfos) {
            var efa_legs = efa_trip.legs,
                legs = [],
                curr_leg,
                wait_leg,
                last_arrival,
                i,
                l;

            for (i = 0, l = efa_legs.length; i < l; i += 1) {
                // normal leg
                curr_leg = MDVJourneyLegParser.parse(efa_legs, i, serverInfos);
                if (last_arrival && last_arrival.isBefore(curr_leg.departureTime())) {
                    // fill time between legs with wait-legs
                    wait_leg = null;
                    wait_leg = MDVJourneyLegParser.parseWaitLeg(efa_legs, i, serverInfos);
                    if (wait_leg) {
                        legs.push(wait_leg);
                    }
                }
                if (curr_leg) {
                    curr_leg.legIndex = legs.length;
                    legs.push(curr_leg);
                    last_arrival = curr_leg.arrivalTime();
                }
                // treat interchanges as extra leg
                curr_leg = null;
                if (efa_legs[i].interchange) {
                    curr_leg = MDVJourneyLegParser.parseInterchange(efa_legs, i, serverInfos);
                }
                if (curr_leg) {
                    legs.push(curr_leg);
                    last_arrival = curr_leg.arrivalTime();
                }
            }
            return legs;
        }


        function assignFaresToLegs(legs, fares) {
            var curr_range,
                i,
                j,
                k,
                l;

            for (i = 0, l = fares.tickets.length; i < l; i += 1) {
                curr_range = fares.tickets[i].legRange();
                for (j = 0, k = curr_range.length; j < k; j += 1) {
                    if (legs.length > curr_range[j]) {
                        legs[curr_range[j]].pushTicket(fares.tickets[i]);
                    }
                }
            }

            return legs;
        }

        function getLegIndices(legs) {
            var i,
                l,
                map = [];

            for (i = 0, l = legs.length; i < l; i += 1) {
                if (legs[i].legIndex || legs[i].legIndex === 0) {
                    map.push(i);
                }
            }
            return map;
        }

        function parseTrip(efa_trip, systemMessages, serverInfos) {
            var legs,
                fares,
                bookings,
                map,
                legs_final,
                props = {};

            if (!efa_trip.legs) {
                return null;
            }

            if (options.keepRaw) {
                props.raw = MDVUtil.copy(efa_trip);
            }

            legs = parseLegs(efa_trip, serverInfos);
            map = getLegIndices(legs);
            fares = MDVEFAFareParser.parse(efa_trip.fare, map);
            bookings = parseBookings(efa_trip.booking, map);
            assignFaresToLegs(legs, fares);
            assignBookingsToLegs(legs, bookings);

            if (options.combineWalkLegs) {
                legs_final = MDVEFAFormatter.combineWalkLegs(legs, MDVJourneyLeg);
            } else {
                legs_final = legs;
            }

            props.rating = efa_trip.rating;
            props.isAdditional = efa_trip.isAdditional;
            props.numberOfTransfers = efa_trip.interchanges;
            props.fare = fares;
            props.properties = efa_trip.properties;
            props.bookings = bookings;
            props.legs = legs_final;
            props.systemMessages = systemMessages;

            if (!props.properties) {
                props.properties = {};
            }

            props.properties.realtimeExplanationIdx = efa_trip.realtimeExplanationIdx;
            props.properties.explainedByIdx = efa_trip.explainedByIdx;

            return new MDVJourney(props);

        }

        function isInvalidResponse(response) {
            return !response.journeys || (response.journeys.length === 0);
        }


        function parse(response) {
            var trips = [],
                data = response,  // angular.copy(response),
                curr_trip,
                // origin,
                // destination,
                systemMessages,
                i,
                l;

            if (isInvalidResponse(data)) {
                return {
                    systemMessages : MDVCommUtil.parseSystemMessages(data.systemMessages),
                    trips : trips
                };
            }
            systemMessages = MDVCommUtil.parseSystemMessages(data.systemMessages);

            // origin = data.journeys[0].legs[0].origin;
            // destination = data.journeys[0].legs[data.journeys[0].legs.length - 1].destination;

            for (i = 0, l = data.journeys.length; i < l; i += 1) {
                curr_trip = data.journeys[i];
                // curr_trip.origin = origin;
                // curr_trip.destination = destination;

                curr_trip = parseTrip(curr_trip, systemMessages, data.serverInfo);

                if (curr_trip) {
                    curr_trip.overallResponse = response;
                    trips.push(curr_trip);
                }
            }
            return {
                trips : trips,
                systemMessages : systemMessages
            };
        }

        function parseBookings(efa_bookings, map) {
            if (!efa_bookings) {
                return [];
            }

            var bookingsArr = [],
                bookingObj,
                res = [],
                i,
                l;

            if (efa_bookings && efa_bookings.hasOwnProperty('booking')) {
                bookingsArr.push(efa_bookings.booking);
            } else if (efa_bookings instanceof Array) {
                bookingsArr = efa_bookings;
            }

            for (i=0, l=bookingsArr.length; i<l; i+=1) {
                bookingObj = {
                    legRange : getLegRange(bookingsArr[i], map),
                    file : new MDVFile({
                        type : bookingsArr[i].commType,
                        url : bookingsArr[i].serverAddress
                    })
                };
                res.push(bookingObj);
            }

            return res;
        }

        function getLegRange(obj, map) {
            var from = parseInt(obj.fromLeg, 10),
                to = parseInt(obj.toLeg, 10),
                result = [];

            for (; from <= to; from += 1) {
                result.push(map[from]);
            }
            return result;
        }

        function assignBookingsToLegs(legs, bookings) {
            var curr_range,
                i,
                j,
                k,
                l;

            for (i = 0, l = bookings.length; i < l; i += 1) {
                curr_range = bookings[i].legRange;
                for (j = 0, k = curr_range.length; j < k; j += 1) {
                    // TODO leg.isPublicTransportation() &&
                    if (legs.length > curr_range[j]) {
                        legs[curr_range[j]].pushBooking(bookings[i]);
                    }
                }
            }
            return legs;
        }

        return tripp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFATrip
     * @requires $q
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.json.service:MDVEFARequester
     * @requires mng-comm.itd.json.service:MDVEFATripParser
     * @description
     *
     * Main Service to get lists of journeys for a specific origin and destination.
     *
     * This service registers a {@link mng-comm.itd.service:MDVEFARequester MDVEFARequest} for
     * TRIP-purposes. This requester is used whenever the search method is called.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd-json.MDVEFATrip`.
     *
     * As the `MDVEFATrip` service does not support any special parameters, please refer
     * to the {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester} service for detailed
     * configuration description.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFATrip', MDVEFATrip);

    MDVEFATrip.$inject = ['$q', 'mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.json.MDVEFATripParser', 'mng-comm.itd.MDVEFAOptionsParser'];

    function MDVEFATrip($q, MDVLog, MDVConfig, MDVEFARequester, MDVEFATripParser, MDVEFAOptionsParser) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFATrip',
                version : '10.2.10.139'
            },
            log = MDVLog.register(_private.namespace),
            tripRequester,
            trip = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name search
         * @methodOf mng-comm.itd.json.service:MDVEFATrip
         * @param {MDVLocation} origin {@link mng-model.object:MDVLocation MDVLocation} object
         * the journey should start at
         * @param {MDVLocation} destination {@link mng-model.object:MDVLocation MDVLocation} object
         * the journey should end at
         * @param {Object} options Additional options for the journey request
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVJourney MDVJourneys}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVJourneys MDVJourneys} service. It triggers a
         * XML_TRIP_REQUEST2 with the given locations and passes the response to the {@link
         * mng-comm.itd.json.service:MDVEFATripParser MDVEFATripParser} to ensure that
         * a unified list of {@link mng-comm.service:MDVJourney MDVJourneys} is returned.
         */
        function search(origin, destination, options) {
            if (!origin.id() || !destination.id()) {
                return null;
            }
            var efa_opts = MDVEFAOptionsParser.parse(options);

            // assure that fares are in unifiedTicket format
            efa_opts.useUT = 1;

            efa_opts.name_destination = destination.id();
            efa_opts.name_origin = origin.id();
            efa_opts.type_destination = 'any';
            efa_opts.type_origin = 'any';
            efa_opts.version = _private.version;

            return tripRequester.request(efa_opts)
                .then(function(response) {
                    return MDVEFATripParser.parse(response);
                });
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_TRIP_REQUEST2?',
                defaultParams : {},
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                trip._private = _private;
            }
        });

        // create customized requester object
        tripRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFATrip',
            _private.getDefaultConfigOption());

        return trip;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVEFAFareParser
     * @requires mng-util.service:MDVLog
     * @description
     *
     * Main Service to parse given EFA fare structures to a MDVFare model.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAFareParser', MDVEFAFareParser);

    MDVEFAFareParser.$inject = ['mng-util.MDVLog', 'mng-model.MDVTicket'];

    function MDVEFAFareParser(MDVLog, MDVTicket) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFAFareParser'),
            farep = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////
        function getPrice(efa_fare) {
            var price = efa_fare.properties.priceTotalFare;

            if (price) {
                return parseFloat(price);
            }
            if (efa_fare.priceBrutto !== 0) {
                return parseFloat(efa_fare.priceBrutto);
            }
            return parseFloat(efa_fare.priceNetto);
        }

        function getLegRange(fare, map) {
            var from = fare.fromLeg,
                to = fare.toLeg,
                result = [];

            for (; from <= to; from += 1) {
                if (map.length > from) {
                    result.push(map[from]);
                } else {
                    log.warn('ignored ticket with invalid leg range. ticket provides a (zero based)' +
                        ' leg index ' + from + ', but there are/is only ' + map.length + ' leg(s) available');
                }
            }
            return result;
        }
        function parseTicket(efa_fare, map) {
            var props;

            if (!efa_fare.properties) {
                efa_fare.properties = {};
            }
            props = {
                id : efa_fare.id,
                price : getPrice(efa_fare),
                name : efa_fare.name,
                unit : efa_fare.currency,
                legRange : getLegRange(efa_fare, map),
                network : efa_fare.net,
                person : efa_fare.person,
                priceLevel : efa_fare.priceLevel,
                travellerClass : efa_fare.travellerClass,
                type : efa_fare.timeValidity,
                validity : {
                    area : efa_fare.nameValidityArea,
                    duration : efa_fare.validMinutes,
                    interchanges : efa_fare.numberOfChanges,
                    oneJourneyOnly : efa_fare.validForOneJourneyOnly,
                    oneOperatorOnly : efa_fare.validForOneOperatoryOnly,
                    returnsAllowed : efa_fare.returnsAllowed
                },
                properties : efa_fare.properties || {}
            };

            return new MDVTicket(props);
        }
        function parseTickets(efa_fares, map) {
            var tickets = [],
                curr_ticket,
                i,
                l;

            if (!efa_fares || !efa_fares.tickets) {
                return tickets;
            }

            if (efa_fares.tickets) {
                for (i = 0, l = efa_fares.tickets.length; i < l; i += 1) {
                    curr_ticket = parseTicket(efa_fares.tickets[i], map);
                    if (curr_ticket) {
                        tickets.push(curr_ticket);
                    }
                }
            }
            return tickets;
        }
        function parseZone(efa_zone, map) {
            return {
                isNeutralZone : efa_zone.neutralZone || false,
                network : efa_zone.net,
                legRange : getLegRange(efa_zone, map),
                zones : efa_zone.zones
            };
        }
        function parseZones(efa_fares, map) {
            var zones = [],
                curr_zone,
                i,
                l;

            if (!efa_fares || !efa_fares.zones) {
                return zones;
            }

            for (i = 0, l = efa_fares.zones.length; i < l; i += 1) {
                curr_zone = parseZone(efa_fares.zones[i], map);
                if (curr_zone) {
                    zones.push(curr_zone);
                }
            }
            return zones;
        }

        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.xmljson.service:MDVEFAFareParser
         * @param {Object} efa_fares Fare object received in an EFA response
         * @param {Number[]} map mapping array that maps from efa-leg index to leg index including
         * transfer legs
         * @returns {Object} Object that contains a list of {@link mng-model.object:MDVTicket
         * MDVTickets} and a list of zone objects.
         *
         * @description
         * This method parses a given efa fare structure to a list of {@link
         * mng-model.object:MDVTicket MDVTickets} and a list of zone objects.
         */
        function parse(efa_fares, map) {
            return {
                tickets : parseTickets(efa_fares, map),
                zones : parseZones(efa_fares, map)
            };
        }

        return farep;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFASTTParser', MDVEFASTTParser);

    MDVEFASTTParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.json.MDVFileParser'];

    function MDVEFASTTParser(MDVLog, MDVFileParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFASTTParser'),
            _private = {},
            sttParser = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response, requestOptions) {
            var fileProps;

            if (response && response.download && response.download.url) {
                fileProps = {
                    input : _private.getFileName(response, requestOptions),
                    type : 'STT',
                    url : response.download.url,
                    size : response.download.size
                };

                return MDVFileParser.parse(fileProps, response.serverInfo);
            } else {
                log.error('invalid return structure');
            }
        }

        _private.getFileName = function(response, options) {
            var fileName = 'STT';

            if (response.location && response.location.length>0 && response.location[0].name) {
                fileName += ' - ' + response.location[0].name;
                if (response.servingLines && response.servingLines.length>0 &&
                    response.servingLines[0].name) {
                    fileName += ' - ' + response.servingLines[0].name;
                }
                return fileName;
            }

            if (options && options.stopId) {
                fileName += ' - ' + options.stopId;
                if (options && options.lineId) {
                    fileName += ' - ' + options.lineId;
                }
                return fileName;
            }

            return fileName + '_' + Date.now();
        };

        return sttParser;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFASTT', MDVEFASTT);

    MDVEFASTT.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-comm.itd.json.MDVEFASTTParser',
        'mng-util.MDVException', 'mng-comm.itd.MDVEFAOptionsParser'];


    function MDVEFASTT(MDVLog, MDVUtil, MDVConfig, MDVEFARequester, MDVEFASTTParser, MDVException,
            MDVEFAOptionsParser) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFASTT',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            sttRequester,
            stt = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                params;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            params = MDVEFAOptionsParser.parse(options);
            if (!params) {
                params = {};
            }
            params = angular.extend({}, params, addSearchParams(options), true);

            _private.running_xhr = sttRequester.request(params)
                .then(function(response) {
                    if (!response || !response.download ||
                            !response.download.url) {
                        throw new MDVException(MDVException.keys.MNG_COMM__STT.SERVICE_FAILED, {
                            input : options,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;
                    var result = MDVEFASTTParser.parse(response, options);

                    return result;
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_STT_REQUEST?',
                defaultParams : {
                    mode : 'direct',
                    allStopInfo : 1
                },
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function addSearchParams(options) {
            var params = options.efaParams || {};

            params.line = options.lineId;
            params.name_stt = options.stopId;
            params.type_stt = 'stopID';
            params.mode = 'direct';

            return params;
        }

        function isReady(options) {
            var reasons = [];

            if (!options.lineId) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__STT.INVALID_INPUT, {
                    reason : 'lineId missing'
                }));
            }
            if (!options.stopId) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__STT.INVALID_INPUT, {
                    reason : 'stopId missing'
                }));
            }

            return reasons;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                stt._private = _private;
            }
        });

        // create customized requester object
        sttRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFASTT',
            _private.getDefaultConfigOption());

        return stt;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFAStopStructureParser
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.json.service:MDVLocationParser
     * @description
     *
     * Parse a given stopstructure response object provided by the EFA and parse it to a list of
     * {@link mng-model.object:MDVLocation MDVLocations}.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAStopStructureParser', MDVEFAStopStructureParser);

    MDVEFAStopStructureParser.$inject = ['mng-util.MDVLog',
        'mng-comm.itd.json.MDVLocationParser'];

    function MDVEFAStopStructureParser(MDVLog, MDVLocationParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFAStopStructureParser'),
            cp = {
                parse : parse
            };

        log.debug('initialize');

        function isInvalidResponse(response) {
            return !response || !response.stop;
        }

        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.json.service:MDVEFAStopStructureParser
         * @param {Object} response the efa response object
         * @returns {Object} normalized information object
         *
         * @description
         * convert a given set of infos to a list of normalized information objects
         */
        function parse(response) {
            var result = {
                    areas : [],
                    platforms : []
                },
                curr = null,
                i,
                l;

            if (isInvalidResponse(response)) {
                return result;
            }

            if (response.stop.areas) {
                for (i = 0, l = response.stop.areas.length; i < l; i += 1) {
                    curr = MDVLocationParser.parse(response.stop.areas[i]);
                    if (curr) {
                        result.areas.push(curr);
                    }
                }
            }
            if (response.stop.platforms) {
                for (i = 0, l = response.stop.platforms.length; i < l; i += 1) {
                    curr = MDVLocationParser.parse(response.stop.platforms[i]);
                    if (curr) {
                        result.platforms.push(curr);
                    }
                }
            }
            return result;
        }
        return cp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFAStopStructure
     * @requires $q
     * @requires mng-util.service:MDVLog
     * @requires mng-util.service:MDVUtil
     * @requires mng-util.service:MDVException
     * @requires mng-comm.itd.service:MDVEFARequester
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-comm.itd.json.service:MDVEFAUtil
     * @requires mng-comm.itd.json.service:MDVEFAStopStructureParser
     * @requires mng-model.service:MDVTransportation
     * @description
     *
     * Main Service to get lists of {@link mng-model.object:MDVTransportation MDVTransportations}
     * that provide additional information for a certain transportation id, like coordinates or
     * passed stops.
     *
     * This service registers a {@link mng-comm.itd.service:MDVEFARequester MDVEFARequest} for
     * GEOOBJECT-purposes. This requester is used whenever the search method is called.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd-json.MDVEFAStopStructure`.
     *
     * As the `MDVEFAStopStructure` service does not support any special parameters, please refer
     * to the {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester} service for detailed a
     * configuration description.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAStopStructure', MDVEFAStopStructure);

    MDVEFAStopStructure.$inject = ['$q', 'mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-util.MDVException',
        'mng-util.MDVUtil', 'mng-comm.itd.MDVEFARequester', 'mng-model.MDVLocation',
        'mng-comm.itd.MDVEFAFormatter', 'mng-comm.itd.json.MDVEFAUtil',
        'mng-comm.itd.json.MDVEFAStopStructureParser'];


    function MDVEFAStopStructure($q, MDVLog, MDVConfig, MDVException, MDVUtil, MDVEFARequester,
            MDVLocation, MDVEFAFormatter, MDVEFAUtil, MDVEFAStopStructureParser) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFAStopStructure',
                version : '10.2.10.139',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            geoRequester,
            info = {
                search : search,
                searchForStructure : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name search
         * @methodOf mng-comm.itd.json.service:MDVEFAStopStructure
         * @param {MDVLocation} location The stop structure should be determined of.
         * @param {Object} options additional options that should be used for this search only
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVTransportation MDVTransportations}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVLocationRequester MDVLocationRequester} service. It triggers a
         * XML_STOPSTRUCTURE_REQUEST with the given input and passes the response to the {@link
         * mng-comm.itd.json.service:MDVEFAStopStructureParser MDVEFAStopStructureParser} to ensure
         * that a unified list of {@link mng-model.object:MDVLocation MDVLocations} is
         * returned in the response object.
         */
        function search(location, options) {
            if (!isReady(location)) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                        input : location,
                        reason : 'invalid type. expected MDVLocation'
                    })
                );
            }
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            if (!options) {
                options = {};
            }
            var params = getSearchParams(location, options);

            _private.running_xhr = geoRequester.request(params)
                .then(function(response) {
                    _private.running_xhr = null;
                    return MDVEFAStopStructureParser.parse(response);
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_STOPSTRUCTURE_REQUEST?',
                defaultParams : {},
                cache : true
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function isReady(input) {
            return input && (input instanceof MDVLocation);
        }

    //    /**
    //     * @private
    //     * @ngdoc method
    //     * @name reject_xhr
    //     * @methodOf mng-comm.itd.json.service:MDVEFAStopfinder
    //     * @param {xhr} xhr Xhr that should be rejected.
    //     *
    //     * @description
    //     * reject a given xhr and broadcast a 'COM.NEW_REQUEST'-Event
    //     */
        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function getSearchParams(location, options) {
            var params = MDVUtil.copy(options.efaParams || {}),
                stopId;

            if (location.type() === MDVLocation.LOCATIONTYPES.STOP_POINT) {
                stopId = location.parent().id();
            } else {
                stopId = location.id();
            }

            params.sSStopNr = stopId;
            params.sSInclSP = 1;

            params.version = _private.version;

            return params;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                info._private = _private;
            }
        });

        // create customized requester object
        geoRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFAStopStructure',
            _private.getDefaultConfigOption());

        return info;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAStopSeqCoordParser', MDVEFAStopSeqCoordParser);

    MDVEFAStopSeqCoordParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.json.MDVTransportationParser'];

    function MDVEFAStopSeqCoordParser(MDVLog, MDVTransportationParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFAStopSeqCoordParser'),
            sscParser = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response, location) {
            var transportation = null,
                prevStopSeq = [],
                onwardStopSeq = [],
                i, l,
                stopSeq,
                depDiff;

            if (response && response.transportation) {
                transportation = MDVTransportationParser.parse(response.transportation, 'stopseq');
            }

            if (!transportation || !location || !location.departureTime || !location.departureTime()) {
                return {
                    transportation : transportation
                };
            }

            stopSeq = transportation.locationSequence();

            for (i = 0, l = stopSeq.length; i < l; i += 1) {
                depDiff = location.departureTime().diff(stopSeq[i].departureTime(), 'seconds');

                if (depDiff > 0) {
                    prevStopSeq.push(stopSeq[i]);
                } else {
                    onwardStopSeq.push(stopSeq[i]);
                }
            }

            return {
                transportation : transportation,
                prevStopSeq : prevStopSeq,
                onwardStopSeq : onwardStopSeq
            };
        }

        return sscParser;
    }
}());

(function() {
    'use strict';
/**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFAStopSeqCoord
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFARequester
     * @requires mng-comm.itd.json.service:MDVEFAStopfinderParser
     * @requires mng-util.object:MDVException
     *
     * @description
     * The `MDVEFAStopSeqCoord` service implements the interface for {@link
     * mng-comm.service:MDVTransportationRequester MDVTransportationRequester} and uses the
     * MENTZ-EFA interface to fetch a list of {@link mng-model.object:MDVLocation
     * MDVLocations} a certain {@link mng-model.object:MDVTransportation MDVTransportation} passes
     * during a ride from a certain {@link mng-model.object:MDVLocation MDVLocation}.
     *
     * This service registers a {@link mng-comm.itd.service:MDVEFARequester MDVEFARequest} for
     * stopseqcoord purposes. This requester is used whenever the search method is called.
     *
     * ```js
     *   // Simple search request
     *   MDVEFAStopfinder
     *      .search(new MDVLocation({
     *              id : '10101116'
     *          }), {
     *              transportation : new MDVTransportation({
     *                  id : 'nsw:71N90: :R:sj2',
     *                  properties : {
     *                      tripCode : 2
     *                  }
     *              }),
     *              isDeparture : true,
     *              dateTime : {
     *                  date : moment()
     *              }
     *          }))
     *      .then(function successCallback(response) {
     *          // this callback will be called asynchronously
     *          // when the response is available
     *     }, function errorCallback(response) {
     *          // called asynchronously if an error occurs
     *          // or server returns response with an error status.
     *     });
     * ```
     *
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd-json.MDVEFAStopfinder`.
     *
     * As the `MDVEFAStopSeqCoord` service does not support any special parameters, please refer
     * to the {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester} service for detailed
     * configuration description.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAStopSeqCoord', MDVEFAStopSeqCoord);

    MDVEFAStopSeqCoord.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-comm.itd.json.MDVEFAStopSeqCoordParser',
        'mng-util.MDVException', 'mng-util.MDVUtil', 'mng-comm.itd.MDVEFAOptionsParser'];


    function MDVEFAStopSeqCoord(MDVLog, MDVConfig, MDVEFARequester, MDVEFAStopSeqCoordParser,
            MDVException, MDVUtil, MDVEFAOptionsParser) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFAStopSeqCoord',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            sscRequester,
            ssc = {
                search : search,
                searchLines : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(location, options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(location, options),
                params;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            params = addSearchParams(location, options.transportation, options);

            _private.running_xhr = sscRequester.request(params)
                .then(function(response) {
                    if (!response || !response.transportation) {
                        throw new MDVException(MDVException.keys.MNG_COMM__STOPSEQ.SERVICE_FAILED, {
                            args : [location, options.transportation, options],
                            service : 'mng-comm.itd.json.MDVEFAStopSeqCoord',
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;
                    var result = MDVEFAStopSeqCoordParser.parse(response, location);

                    return result;
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_STOPSEQCOORD_REQUEST?',
                defaultParams : {},
                cache : true
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function isReady(location, options) {
            var reasons = [];

            if (!location || !location.id()) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__STOPSEQ.INVALID_INPUT, {
                    reason : 'locationId missing'
                }));
            }

            if (!options || !options.transportation) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__STOPSEQ.INVALID_INPUT, {
                    reason : 'transportation object missing'
                }));
            }

            if (!options.transportation.id) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__STOPSEQ.INVALID_INPUT, {
                    reason : 'transportation.id is missing'
                }));
            }

            if (!options.transportation.properties || !options.transportation.properties.tripCode) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__STOPSEQ.INVALID_INPUT, {
                    reason : 'transportation.properties.tripCode is missing'
                }));
            }

            return reasons;
        }

        function addSearchParams(location, transportation, options) {
            var params,
                tstottype = 'ALL';

            if (options.hasOwnProperty('isDeparture')) {
                if (options.isDeparture) {
                    tstottype = 'NEXT';
                } else {
                    tstottype = 'PREVIOUS';
                }
            }

            params = MDVEFAOptionsParser.parse(options);

            params.tStOTType = tstottype;
            params.stop = location.id();
            params.line = transportation.id;
            params.tripCode = transportation.properties.tripCode;

            if (params.itdTime) {
                params.time = params.itdTime;
                delete params.itdTime;
            }
            if (params.itdDate) {
                params.date = params.itdDate;
                delete params.itdDate;
            } else {
                // provide fallback if date is not set
                params.date = moment().format('YYYYMMDD');
            }

            return params;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                ssc._private = _private;
            }
        });

        // create customized requester object
        sscRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFAStopSeqCoord',
            _private.getDefaultConfigOption());

        return ssc;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFAStopfinderParser
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.json.service:MDVLocationParser
     *
     * @description
     * The `MDVEFAStopfinderParser` parses given EFA information of a XML_STOPFINDER_REQUEST
     * response to a list of {@link mng-model.object:MDVLocation MDVLocations}.
     *
     * This parser is used by the {@link mng-comm.itd.json.service:MDVEFAStopfinder MDVEFAStopfinder}
     * service to parse the returned http-response to a normalized list.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAStopfinderParser', MDVEFAStopfinderParser);

    MDVEFAStopfinderParser.$inject = ['mng-util.MDVLog',
        'mng-comm.itd.json.MDVLocationParser'];

    function MDVEFAStopfinderParser(MDVLog, MDVLocationParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFAStopfinderParser'),
            sfp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.json.service:MDVEFAStopfinderParser
         * @param {Object} input Input value that was used for the provided response
         * @param {Object} response Json formatted response provided by a XML_STOPFINDER_REQUEST.
         * @returns {MDVLocation[]} List of all parsed {@link mng-model.object:MDVLocation
         * MDVLocation} objects provided by the EFA.
         *
         * @description
         * Parse a XML_STOPFINDER_REQUEST-response object to a list of point objects. This is done
         * by extracting the point information and passing it to the parse function of the {@link
         * mng-comm.itd.json.service:MDVLocationParser MDVLocationParser}.
         */
        function parse(input, response) {
            var result = [];

            if (!response || !response.locations) {
                log.debug('no points to parse found in response object');
                return result;
            }
            angular.forEach(response.locations, function(point) {
                result.push(MDVLocationParser.parse(point, 'sf', input));
            });

            return result;
        }

        return sfp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFAStopfinder
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFARequester
     * @requires mng-comm.itd.json.service:MDVEFAStopfinderParser
     * @requires mng-util.object:MDVException
     *
     * @description
     * The `MDVEFAStopfinder` service implements the interface for {@link
     * mng-comm.service:MDVLocationRequester MDVLocationRequester} and uses the MENTZ-EFA
     * interface to resolve a given name to a list of {@link mng-model.object:MDVLocation
     * MDVLocations}.
     *
     * This service registers a {@link mng-comm.itd.service:MDVEFARequester MDVEFARequest} for
     * stop-finder purposes. This requester is used whenever the search method is called.
     *
     * ```js
     *   // Simple search request
     *   MDVEFAStopfinder
     *      .search('main')
     *      .then(function successCallback(response) {
     *          // this callback will be called asynchronously
     *          // when the response is available
     *     }, function errorCallback(response) {
     *          // called asynchronously if an error occurs
     *          // or server returns response with an error status.
     *     });
     * ```
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd-json.MDVEFAStopfinder`.
     *
     * As the `MDVEFAStopfinder` service does not support any special parameters, please refer
     * to the {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester} service for detailed
     * configuration description.
     *
     *
     *  @example
<example module="MDVEFAStopfinderExample">
<file name="index.html">
  <div ng-controller="MDVEFAStopfinderController">
    <label>
        <input ng-model="sugValue" placeholder="type name"/>
    </label>

    <div ng-show="suggestions && suggestions.length > 0">
        Suggestions found for input "{{sugValue}}":
       <ul><li ng-repeat="point in suggestions track by $index">{{point.name()}}</li></ul>
    </div>
  </div>
</file>
<file name="script.js">
  angular.module('MDVEFAStopfinderExample', ['angularMoment', 'mng-config', 'mng-comm.itd.json'])
    .run(['mng-config.MDVConfig', function(MDVConfig) {
        MDVConfig.setValue('mng-comm-itd.MDVEFARequester', {
            'url' : '/mngnsw'
        });
        MDVConfig.setValue('mng-comm-itd-json.MDVEFAStopfinder', {
              url: '/XML_STOPFINDER_REQUEST?',
              defaultParams: {
                  outputFormat: 'json',
                  coordOutputFormat: 'EPSG:4326',
                  anyObjFilter_sf: 2,
                  odvSuggestMacro: 'beg',
                  locationServerActive: 1,
                  prMinQu: 1,
                  type_sf: 'any',
                  w_prefStModesAm: [3, 1],
                  w_regPrefAl: 1
              }
        });
    }])
    .controller('MDVEFAStopfinderController', ['$scope', 'mng-comm.itd.json.MDVEFAStopfinder',
            function ($scope, MDVEFAStopfinder) {
                $scope.sugValue = 'town';
                $scope.suggestions = [];

                $scope.$watch('sugValue', function () {
                    MDVEFAStopfinder.search($scope.sugValue)
                        .then(function (response) {
                            // received list. append it to scope.
                            // please note that this response is a single list, whereas the
                            // response of the MDVLocationRequester service is an object that contains
                            // a list property with the same information.
                            $scope.suggestions = response;
                        })
                        .catch(function (response) {
                            // something went wrong
                            $scope.suggestions = [];
                        })
                });
            }]);
</file>
</example>
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAStopfinder', MDVEFAStopfinder);

    MDVEFAStopfinder.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-comm.itd.MDVEFAFormatter',
        'mng-comm.itd.json.MDVEFAStopfinderParser', 'mng-util.MDVException'];

    function MDVEFAStopfinder(MDVLog, MDVUtil, MDVConfig, MDVEFARequester, MDVEFAFormatter,
            MDVEFAStopfinderParser, MDVException) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFAStopfinder',
                version : '10.2.10.139',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            sfRequester,
            sf = {
                search : search,
                searchByName : searchByName,
                searchByCoordinate : searchByCoordinate
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name search
         * @methodOf mng-comm.itd.json.service:MDVEFAStopfinder
         * @param {String} input Name that should be used for the suggestion list or coordinate
         * @param {Object} options additional options for the search
         * @param {String} options.coordFormat coord format the input is about
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVLocation MDVLocations}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVLocationRequester MDVLocationRequester} service. It triggers a
         * XML_STOPFINDER_REQUEST with the given input and passes the response to the {@link
         * mng-comm.itd.json.service:MDVEFAStopfinderParser MDVEFAStopfinderParser} to ensure
         * that a unified list of {@link mng-model.object:MDVLocation MDVLocations} is returned in
         * the response object.
         */
        function search(input, options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            if (!options) {
                options = {};
            }
            var params = addSearchParams(input, options);

            if (!params.name_sf) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG_COMM__LS.INVALID_INPUT, {
                        input : input,
                        reason : 'unable to parse input'
                    })
                );
            }
            params.version = _private.version;

            _private.running_xhr = sfRequester.request(params, getDefParamsKey(params))
                .then(function(response) {
                    _private.running_xhr = null;
                    return MDVEFAStopfinderParser.parse(input, response);
                });
            return _private.running_xhr;
        }

        function searchByName(input, options) {
            return search(input, options);
        }
        function searchByCoordinate(input, options) {
            return search(input, options);
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_STOPFINDER_REQUEST?',
                defaultParams : {},
                cache : true
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


    //    /**
    //     * @private
    //     * @ngdoc method
    //     * @name reject_xhr
    //     * @methodOf mng-comm.itd.json.service:MDVEFAStopfinder
    //     * @param {xhr} xhr Xhr that should be rejected.
    //     *
    //     * @description
    //     * reject a given xhr and broadcast a 'COM.NEW_REQUEST'-Event
    //     */
        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }
        function raiseTypeOverrideWarning(passedValue) {
            if (passedValue) {
                passedValue = 'override given type_sf="' + passedValue + '"';
            } else {
                passedValue = 'changed type_sf';
            }
            log.warn(passedValue +
                        ' parameter to type_sf="coord" as passed input is a coordinate ' +
                        'instead of a string input');
        }

        function addSearchParams(input, options) {
            var coord_str,
                params = MDVUtil.copy(options.efaParams || {});

            if (typeof input === 'string') {
                // might do a string check if it is a coordinatestring here

                // normal input name
                params.name_sf = input;
                if (!params.type_sf) {
                    params.type_sf = 'any';
                }
                return params;
            }
            // assume input is a coordinate
            coord_str = MDVEFAFormatter.latlng2string(input, options.coordFormat);
            if (coord_str !== '') {
                params.name_sf = 'coord:' + coord_str;
                if (!params.type_sf || params.type_sf !== 'any') {
                    raiseTypeOverrideWarning(params.type_sf);
                    params.type_sf = 'any';
                }
            }
            return params;
        }
        function getDefParamsKey(params) {
            if (!params || !params.type_sf || (params.type_sf === 'any')) {
                return '';
            }
            return params.type_sf;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                sf._private = _private;
            }
        });

        // create customized requester object
        sfRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFAStopfinder',
            _private.getDefaultConfigOption());

        return sf;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAServingLinesParser', MDVEFAServingLinesParser);

    MDVEFAServingLinesParser.$inject = ['mng-util.MDVLog',
        'mng-comm.itd.json.MDVTransportationParser'];

    function MDVEFAServingLinesParser(MDVLog, MDVTransportationParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFAServingLinesParser'),
            selttp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////


        function parseLines(efaLines) {
            var lines = [];

            angular.forEach(efaLines, function(efaLine) {
                lines.push(MDVTransportationParser.parse(efaLine));
            });

            return lines;
        }

        function parse(response) {
            return parseLines(response.lines || response.servingLines);
        }

        return selttp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAServingLines', MDVEFAServingLines);

    MDVEFAServingLines.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-model.MDVLocation',
        'mng-comm.itd.json.MDVEFAUtil', 'mng-comm.itd.json.MDVEFAServingLinesParser',
        'mng-comm.itd.MDVEFAOptionsParser', 'mng-util.MDVUtil', 'mng-util.MDVException'];


    function MDVEFAServingLines(MDVLog, MDVConfig, MDVEFARequester, MDVLocation, MDVEFAUtil,
                        MDVEFAServingLinesParser, MDVEFAOptionsParser, MDVUtil, MDVException) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFAServingLines',
                version : '10.2.10.139'
            },
            log = MDVLog.register(_private.namespace),
            slRequester,
            sl = {
                searchLines : searchLines
            };

        log.debug('initialize');

        // ////////////////////////////////

        function searchLines(input, options) {
            var reasons = isReady(input, options);

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            return request(input, options)
                .then(function(response) {
                    return response;
                });
        }
        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_SERVINGLINES_REQUEST?',
                defaultParams : {

                },
                cache : true
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function getReqType(outputType) {
            outputType = outputType.toUpperCase();

            if (outputType === 'DM') {
                return 1;
            }
            if (outputType === 'STT') {
                return 2;
            }
            if (outputType === 'TTB') {
                return 4;
            }
            if (outputType === 'ROP') {
                return 8;
            }
            if (outputType === 'ZOB') {
                return 16;
            }
            log.warn('invalid outputType passed: ' + outputType +
                                                    '. Valid types are: DM, STT, TTB, ROP and ZOB');
            return 0;
        }


        function addSearchParams(params, input, options) {
            var reqType = 0,
                i,
                l;

            if (input instanceof MDVLocation) {
                params.name_sl = input.id();
                params.type_sl = 'stopID';
                params.mode = 'odv';
            } else if (typeof input === 'string') {
                params.lineName = input;
                params.mode = 'line';
            }  // else: allow operator input?

            if (options && options.type) {
                if (options.type.constructor === Array) {
                    for (i = 0, l = options.type.length; i < l; i += 1) {
                        reqType += getReqType(options.type[i]);
                    }
                } else {
                    reqType = getReqType(options.type);
                }
                if (reqType) {
                    params.lineReqType = reqType;
                }
            }

            return params;
        }

        function request(input, options) {
            var efa_opts = MDVEFAOptionsParser.parse(options);

            efa_opts = addSearchParams(efa_opts, input, options);

            efa_opts.version = _private.version;

            // send new request
            return slRequester.request(efa_opts)
                .then(function(response) {
                    return MDVEFAServingLinesParser.parse(response);
                });
        }

        function isReady(input) {
            var reasons = [];

            if (!input) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.NO_INPUT, {
                    reason : 'no element passed to the search method'
                }));
            } else if (typeof input !== 'string' && !(input instanceof MDVLocation)) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.NO_INPUT, {
                    input : input,
                    reason : 'invalid type. expected string or MDVLocation'
                }));
            }
            return reasons;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                sl._private = _private;
            }
        });

        // create customized requester object
        slRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFAServingLines',
            _private.getDefaultConfigOption());

        return sl;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFASELTTParser', MDVEFASELTTParser);

    MDVEFASELTTParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.json.MDVTransportationParser'];

    function MDVEFASELTTParser(MDVLog, MDVTransportationParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFASELTTParser'),
            selttp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////


        function parseLines(efaLines) {
            var lines = [];

            angular.forEach(efaLines, function(efaLine) {
                lines.push(MDVTransportationParser.parse(efaLine));
            });

            return lines;
        }

        function parse(response) {
            return parseLines(response.servingLines);
        }

        return selttp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFASELTT', MDVEFASELTT);

    MDVEFASELTT.$inject = ['$q', 'mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-model.MDVLocation',
        'mng-comm.itd.json.MDVEFAUtil', 'mng-comm.itd.json.MDVEFASELTTParser',
        'mng-comm.itd.MDVEFAOptionsParser', 'mng-util.MDVUtil', 'mng-util.MDVException'];


    function MDVEFASELTT($q, MDVLog, MDVConfig, MDVEFARequester, MDVLocation, MDVEFAUtil,
                        MDVEFASELTTParser, MDVEFAOptionsParser, MDVUtil, MDVException) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFASELTT',
                version : '10.2.10.139'
            },
            log = MDVLog.register(_private.namespace),
            selttRequester,
            seltt = {
                searchLines : searchLines
            };

        log.debug('initialize');

        // ////////////////////////////////


        function searchLines(input, options) {
            var reasons = isReady(input, options);

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            return request(input, options)
                .then(function(response) {
                    return response;
                });
        }
        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_SELTT_REQUEST?',
                defaultParams : {
                    mode : 'line',
                    mergeProj : 0
                },
                cache : true
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function getReqType(outputType) {
            outputType = outputType.toUpperCase();

            if (outputType === 'DM') {
                return 1;
            }
            if (outputType === 'STT') {
                return 2;
            }
            if (outputType === 'TTB') {
                return 4;
            }
            if (outputType === 'ROP') {
                return 8;
            }
            if (outputType === 'ZOB') {
                return 16;
            }
            log.warn('invalid outputType passed: ' + outputType +
                                                    '. Valid types are: DM, STT, TTB, ROP and ZOB');
            return 0;
        }


        function addSearchParams(params, input, options) {
            var reqType = 0,
                i,
                l;

            if (input instanceof MDVLocation) {
                params.name_seltt = input.id();
                params.type_seltt = 'any';
            } else if (typeof input === 'string') {
                if ((input.match(/:/g) || []).length > 3) {
                    // workaround for TfNSW
                    log.warn('the use of SELTT is depreciated and should not be used for ' +
                        'id->transportation resolution. use mng-comm.itd.json.MDVEFAServingLines ' +
                        'instead.');
                    log.warn('linePreSel parameter does not work as expected.');
                    // linePreSel should not be used for the resolution of id to transportation as
                    // it does not work in the way as it is expected to do.
                    params.linePreSel = input;
                } else {
                    // normal search string
                    params.lineName = input;
                }
            }  // else: allow operator input?

            if (options && options.type) {
                if (options.type.constructor === Array) {
                    for (i = 0, l = options.type.length; i < l; i += 1) {
                        reqType += getReqType(options.type[i]);
                    }
                } else {
                    reqType = getReqType(options.type);
                }
                if (reqType) {
                    params.lineReqType = reqType;
                }
            }

            return params;
        }

        function request(input, options) {
            var efa_opts = MDVEFAOptionsParser.parse(options);

            efa_opts = addSearchParams(efa_opts, input, options);

            efa_opts.version = _private.version;

            // send new request
            return selttRequester.request(efa_opts)
                .then(function(response) {
                    return MDVEFASELTTParser.parse(response);
                });
        }

        function isReady(input) {
            var reasons = [];

            if (!input) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.NO_INPUT, {
                    reason : 'no element passed to the search method'
                }));
            } else if (typeof input !== 'string' && !(input instanceof MDVLocation)) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.NO_INPUT, {
                    input : input,
                    reason : 'invalid type. expected string or MDVLocation'
                }));
            }
            return reasons;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                seltt._private = _private;
            }
        });

        // create customized requester object
        selttRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFASELTT',
            _private.getDefaultConfigOption());

        return seltt;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAROPParser', MDVEFAROPParser);

    MDVEFAROPParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.json.MDVFileParser'];

    function MDVEFAROPParser(MDVLog, MDVFileParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFAROPParser'),
            _private = {},
            ropParser = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response, requestOptions) {
            var fileProps, fileType = 'ROP';

            if (requestOptions && requestOptions.stopId) {
                fileType = 'ROP_STOP';
            } else if (requestOptions && requestOptions.lineId) {
                fileType = 'ROP_LINE';
            }

            if (response && response.download && response.download.url) {
                fileProps = {
                    input : _private.getFileName(response, requestOptions),
                    type : fileType,
                    url : response.download.url,
                    size : response.download.size
                };

                return MDVFileParser.parse(fileProps, response.serverInfo);
            } else {
                log.error('invalid return structure');
            }
        }

        _private.getFileName = function(response, options) {
            var fileName = 'ROP';

            if (response.location && response.location.length>0 && response.location[0].name) {
                fileName += ' - ' + response.location[0].name;
                return fileName;
            }

            if (options && options.lineId) {
                return fileName + ' - ' + options.lineId;
            } else if (options && options.stopId) {
                return fileName + ' - ' + options.stopId;
            }
            return fileName + '_' + Date.now();
        };

        return ropParser;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAROP', MDVEFAROP);

    MDVEFAROP.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-comm.itd.MDVEFARequester',
                        'mng-comm.itd.json.MDVEFAROPParser', 'mng-util.MDVException',
                        'mng-util.MDVUtil'];


    function MDVEFAROP(MDVLog, MDVConfig, MDVEFARequester, MDVEFAROPParser, MDVException, MDVUtil) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFAROP',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            ropRequester,
            rop = {
                search : search,
                searchLines : searchLines
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                params;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            params = addSearchParams(options);

            _private.running_xhr = ropRequester.request(params)
                .then(function(response) {
                    if (!response || response.length === 0 ||
                            !response.download || !response.download.url) {
                        throw new MDVException(MDVException.keys.MNG_COMM__ROP.SERVICE_FAILED, {
                            args : options,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;
                    var result = MDVEFAROPParser.parse(response, options);

                    return result;
                });
            return _private.running_xhr;
        }

        function searchLines(input, options, type) {
            if (type && type!=='ROP') {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG_COMM__ROP.INVALID_INPUT, {
                        input : input,
                        reason : 'invalid type'
                    })
                );
            }
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var params = options && options.efaParams;

            if (!params) {
                params = {};
            }

            if (typeof input === 'object' && input.hasOwnProperty('id')) {
                // location
                params.mode = 'odv';
                params.type_rop = 'any';
                params.name_rop = input.id();
            } else {
                params.lineName = input;
                params.mode = 'line';
            }

            _private.running_xhr = ropRequester.request(params)
                .then(function(response) {
                    if (!response || response.length === 0 ||
                        !response.servingLines || !response.servingLines.lines) {
                        throw new MDVException(MDVException.keys.MNG_COMM__ROP.SERVICE_FAILED, {
                            args : input,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;
                    var result = MDVEFAROPParser.parse(response);

                    return result;
                });
            return _private.running_xhr;
        }


        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_ROP_REQUEST?',
                defaultParams : {

                },
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function isReady(options) {
            var reasons = [];

            if (!options.lineId && !options.stopId) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__ROP.INVALID_INPUT, {
                    reason : 'lineId/stopId missing'
                }));
            }

            return reasons;
        }

        function addSearchParams(options) {
            var params = options.efaParams || {};

            if (options.lineId) {
                params.line = options.lineId;
                params.command = 'direct';
            } else if (options.stopId) {
                params.mode='odv';
                params.reqType = 'spa';
                params.type_rop = 'any';
                //params.placeInfo_rop = 'invalid';
                params.name_rop = options.stopId;
            }

            return params;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                rop._private = _private;
            }
        });

        // create customized requester object
        ropRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFAROP',
            _private.getDefaultConfigOption());

        return rop;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAPrintTripParser', MDVEFAPrintTripParser);

    MDVEFAPrintTripParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.json.MDVFileParser'];

    function MDVEFAPrintTripParser(MDVLog, MDVFileParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFAPrintTripParser'),
            _private = {},
            ptParser = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response, requestOptions) {
            var fileProps;

            if (response && response.download && response.download.url) {
                fileProps = {
                    input : _private.getFileName(requestOptions),
                    type : 'PS',
                    url : response.download.url,
                    size : response.download.size
                };
                return MDVFileParser.parse(fileProps, response.serverInfo);
            } else {
                log.error('invalid return structure');
            }
        }

        _private.getFileName = function(options) {
            if (options && options.journeys && options.journeys.length>0) {
                return options.journeys[0].origin().name() + ' - ' + options.journeys[0].destination().name();
            }
            return 'PRINT_TRIP_' + Date.now();
        };

        return ptParser;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAPrintTrip', MDVEFAPrintTrip);

    MDVEFAPrintTrip.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-util.MDVUtil',
        'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.json.MDVEFAPrintTripParser', 'mng-util.MDVException'];


    function MDVEFAPrintTrip(MDVLog, MDVConfig, MDVUtil, MDVEFARequester, MDVEFAPrintTripParser,
            MDVException) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFAPrintTrip',
                version : '10.2.10.139',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            // create customized requester object
            prRequester,
            mr = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                postObj;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            postObj = getPostObj(options);

            _private.running_xhr = prRequester.request(postObj)
                .then(function(response) {
                    if (!response || !response.download) {
                        throw new MDVException(MDVException.keys.MNG_COMM__TTB.SERVICE_FAILED, {
                            options : options,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;

                    return MDVEFAPrintTripParser.parse(response, options);
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/RJSON_TRIPRELATION_REQUEST?',
                defaultParams : {},
                cache : true,
                // do not override requestType. Skip this parameter in documentation
                requestType : 'post'
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function getPostObj(options) {
            var i,
                obj = {},
                trips = [];

            if (options.hasOwnProperty('journey')) {
                obj = options.journey.overallResponse;
                trips = [options.journey.raw()];
            } else if (options.hasOwnProperty('journeys')) {
                obj = options.journeys[0].overallResponse;
                for (i=0; i<options.journeys.length; i+=1) {
                    trips.push(options.journeys[i].raw());
                }
            }

            obj.journeys = trips;

            obj.params = options.efaParams || {};

            if (!obj.params.design) {
                obj.params.design = 'detail'; // 'overview'
            }

            return obj;
        }

        function isReady(options) {
            var reasons = [];

            if (!options.journey && !options.journeys) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                    reason : 'journey(s) missing'
                }));
            }
            return reasons;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                mr._private = _private;
            }
        });

        // create customized requester object
        prRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFAPrintTrip',
            _private.getDefaultConfigOption());

        return mr;
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVTransportationParser
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-model.object:MDVTransportation
     * @requires 'mng-comm.itd.json.service:MDVLocationParser
     * @description
     *
     * Parse EFA response information of Lines to a EFAMOT object
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVTransportationParser', MDVTransportationParser);

    MDVTransportationParser.$inject = ['moment', 'mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-comm.itd.MDVEFAFormatter', 'mng-model.MDVTransportation', 'mng-model.MDVLocation',
        'mng-comm.itd.json.MDVLocationParser', 'mng-comm.itd.json.MDVEFAUtil'];

    function MDVTransportationParser(moment, MDVLog, MDVUtil, MDVEFAFormatter, MDVTransportation,
            MDVLocation, MDVLocationParser, MDVEFAUtil) {
        var log = MDVLog.register('mng-comm.itd.json.MDVTransportationParser'),
            motp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////
        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.json.service:MDVTransportationParser
         * @param {Object} efaMOT the efa 'line' object
         * @param {String} type type of the efaMOT input
         * @returns {MDVTransportation} MDVTransportation new parsed {@link
         * mng-model.object:MDVTransportation MDVTransportation} object
         *
         * @description
         * Depending on the line formatType, this method uses the corresponding helper method to
         * parse the EFA line object to {@link mng-model.object:MDVTransportation MDVTransportation}
         */
        function parse(efaMOT, type) {
            var props = parseTransportationProps(MDVUtil.copy(efaMOT), type);

            if (props) {
                props.raw = efaMOT;
                return new MDVTransportation(props);
            }
            return null;
        }

        function parseLocationSequence(locs, type) {
            var result = [],
                i, l, curr;

            for (i = 0, l = locs.length; i < l; i += 1) {
                curr = MDVLocationParser.parse(locs[i], type);
                if (curr) {
                    result.push(curr);
                }
            }
            return result;
        }

        function parseTransportationProps(props, type) {
            if (props.origin) {
                props.origin = MDVLocationParser.parse(props.origin);
            }
            if (props.destination) {
                props.destination = MDVLocationParser.parse(props.destination);
            }
            if (props.description) {
                props.routeDescription = props.description;
                delete props.description;
            }
            if (props.locationSequence) {
                props.locationSequence = parseLocationSequence(props.locationSequence, type);
            }

            if (props.properties && props.properties.validity) {
                if (props.properties.validity.from) {
                    props.periodFrom = moment(props.properties.validity.from);
                }
                if (props.properties.validity.to) {
                    props.periodTo = moment(props.properties.validity.to);
                }

            }

            if (props.infos) {
                props.infos = MDVEFAUtil.parseInfos(props.infos);
            }

            return props;
        }
        return motp;
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVLocationParser
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-model.object:MDVLocation
     *
     * @description
     * The `MDVLocationParser` parses given EFA information of a location (EFA-point-object) to a
     * {@link mng-model.object:MDVLocation MDVLocation}.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVLocationParser', MDVLocationParser);

    MDVLocationParser.$inject = ['$injector', 'moment', 'mng-util.MDVLog', 'mng-comm.itd.MDVEFAFormatter',
        'mng-model.MDVLocation', 'mng-model.MDVSearchLocation', 'mng-model.MDVJourneyLocation',
        'mng-model.MDVAssignedLocation', 'mng-comm.itd.json.MDVFileParser', 'mng-comm.itd.json.MDVEFAUtil'];

    function MDVLocationParser($injector, moment, MDVLog, MDVEFAFormatter, MDVLocation, MDVSearchLocation,
        MDVJourneyLocation, MDVAssignedLocation, MDVFileParser, MDVEFAUtil) {
        var log = MDVLog.register('mng-comm.itd.json.MDVLocationParser'),
            forbidEarlierDeparture = false,  // make available via MDVConfig if needed
            locationTypeMap = getLocationTypeMap(),
            MDVTransportationParser,  // cannot be imported directly due tu circular dependency
            pp = {
                parse : parse
            };

        log.debug('initialize');

        // reverse MDVLocation.LOCATIONTYPES to get faster access during parsing
        function getLocationTypeMap() {
            var map = {},
                key;

            for (key in MDVLocation.LOCATIONTYPES) {
                if (MDVLocation.LOCATIONTYPES.hasOwnProperty(key)) {
                    map[MDVLocation.LOCATIONTYPES[key]] = key;
                }
            }
            return map;
        }

        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.json.service:MDVLocationParser
         *
         * @description
         * Parse a given EFA Point object to a normalized MDVLocation object.
         *
         * @param {Object} efaPoint Point object provided by the EFA
         * @param {String} [formatType='default'] Type of the request the point is from.
         * Possible values: sf, as, TRIPlegArr, TRIPlegDep, TRIPlegIntArr, stopseq, coord
         * @param {Object=} input Input that was used to gather the efaPoint result
         * @param {Object=} serverInfos information about the server the response is from. This
         * property is needed for building static stateless links to pdf downloads.
         * @returns {MDVLocation} normalized {@link mng-model.object:MDVLocation MDVLocation} object
         */
        function parse(efaPoint, formatType, input, serverInfos) {
            var props,
                Constructor;

            if (formatType === 'sf') {
                props = parseSFPointProperties(input, efaPoint, serverInfos);
                Constructor = MDVSearchLocation;
            } else if (formatType === 'as') {
                props = parseASPointProperties(input, efaPoint, serverInfos);
                Constructor = MDVLocation;
            } else if (formatType === 'TRIPlegArr' ||
                    formatType === 'stopseq' ||
                    formatType === 'locseq' ||
                    formatType === 'TRIPlegDep') {
                props = parseTripPointProperties(efaPoint, serverInfos);
                Constructor = MDVJourneyLocation;
            } else if (formatType === 'TRIPlegIntArr') {
                props = parseTripPointProperties(efaPoint, serverInfos);
                if (props.arrivalTimeEstimated) {
                    props.arrivalTimeEstimated = props.arrivalTimePlanned.clone();
                }
                Constructor = MDVJourneyLocation;
            } else if (formatType === 'coord') {
                props = parseCoordPointProperties(efaPoint, serverInfos);
                Constructor = MDVLocation;
            } else {
                props = parsePointProperties(efaPoint, serverInfos);
                Constructor = MDVLocation;
            }

            if (props && Constructor) {
                props.raw = efaPoint;
                return new Constructor(props);
            }
            return null;
        }

        function parseParent(data) {
            if (data.parent) {
                data.parent = parseParent(data.parent);
            }

            return new MDVLocation(data);
        }

        function parseTransportations(transportations) {
            var i,
                l,
                res = [];

            if (!transportations) {
                return res;
            }

            if (!MDVTransportationParser) {
                // avoid "circular dependency error" by injecting this service after startup
                MDVTransportationParser = $injector.get('mng-comm.itd.json.MDVTransportationParser');
            }

            for (i = 0, l = transportations.length; i < l; i += 1) {
                res.push(MDVTransportationParser.parse(transportations[i]));
            }
            return res;
        }

        function parseDownloads(point, serverInfos) {
            var i,
                l,
                downloads,
                dl = [];

            if (point.properties && point.properties.downloads) {
                downloads = point.properties.downloads;
            } else if (point.downloads) {
                downloads = point.downloads;
            }

            if (downloads) {
                for (i = 0, l = downloads.length; i < l; i += 1) {
                    dl.push(MDVFileParser.parse(downloads[i], serverInfos));
                }
            }
            return dl;
        }

        function parsePointType(type) {
            // check normal cases
            if (locationTypeMap.hasOwnProperty(type)) {
                return MDVLocation.LOCATIONTYPES[locationTypeMap[type]];
            }
            // fallback to unknown
            return MDVLocation.LOCATIONTYPES.UNKNOWN;
        }

        function parsePointProperties(point, serverInfos) {
            var downloads = parseDownloads(point, serverInfos),
                result = {
                    id : point.id,
                    name : point.name,
                    disassembledName : point.disassembledName,
                    coord : point.coord,
                    properties : point.properties || {},
                    infos : MDVEFAUtil.parseInfos(point.infos),
                    type : parsePointType(point.type),
                    buildingNumber : point.buildingNumber,
                    streetName : point.streetName,
                    productClasses : point.modes || [],
                    assignedStops : parseAssignedStops(point.id, point.assignedStops),
                    connectingMode : point.connectingMode
                };

            if (downloads && downloads.length > 0) {
                result.properties.downloads = downloads;
            } else {
                delete result.properties.downloads;
            }

            if (point.pointType) {
                result.properties.pointType = point.pointType;
            }

            if (point.parent) {
                result.parent = parseParent(point.parent);
            }

            if (point.transportations) {
                result.transportations = parseTransportations(point.transportations);
            }

            if (result.properties.ASSIGNED_STOP_MEANS) {
                result.properties.ASSIGNED_STOP_MEANS =
                    parseStopMeansList(result.properties.ASSIGNED_STOP_MEANS);
            }

            return result;
        }

        function parseStopMeansList(stopMeans) {
            var productClasses = [],
                currBinary = 524288,
                currProductClass = 19;

            stopMeans = parseInt(stopMeans, 10);

            for (; currProductClass >= 0; currProductClass -= 1) {
                if (stopMeans - currBinary >= 0) {
                    stopMeans -= currBinary;
                    productClasses.push(currProductClass);
                }
                currBinary /= 2;
            }

            return productClasses.reverse();
        }

        function parseModes(modes) {
            if (!modes || (!(modes instanceof String) && (typeof modes !== 'string'))) {
                return [];
            }
            var mode_list = modes.split(','),
                tmp_list = [],
                i,
                l;

            for (i = 0, l = mode_list.length; i < l; i += 1) {
                tmp_list.push(parseInt(mode_list[i], 10));
            }
            return tmp_list;
        }

        function parseCoordPointProperties(point, serverInfos) {
            if (point.properties.STOP_MEANS_LIST) {
                point.modes = parseModes(point.properties.STOP_MEANS_LIST);
                delete point.properties.STOP_MEANS_LIST;
            }
            var props = parsePointProperties(point, serverInfos);

            if (props.type === MDVLocation.LOCATIONTYPES.STOP_POINT && props.parent) {
                props.id = props.parent.id();
                delete props.disassembledName;
            }

            if (props.type === MDVLocation.LOCATIONTYPES.STOP) {
                if (props.properties.STOP_GLOBAL_ID) {
                    props.properties.stopId = props.id;
                    props.id = props.properties.STOP_GLOBAL_ID;
                    delete props.properties.STOP_GLOBAL_ID;
                }
            }

            return props;
        }

        function parseAssignedStops(input, assignedStops) {
            var assignedLocations = [];

            if (!assignedStops) {
                return assignedLocations;
            }
            angular.forEach(assignedStops, function(assignedStop) {
                assignedLocations.push(parse(assignedStop, 'as', input));
            });

            return assignedLocations;
        }


        //    /**
        //     * @private
        //     * @ngdoc method
        //     * @name parsePointProperties
        //     * @description
        //     * Parse point properties to a parameter object that can be passed to MDVLocation
        //     * @methodOf mng-comm.itd.json.service:MDVLocationParser
        //     * @param {Object} point - Default point object provided by the EFA
        //     * @returns {Object} normalized MDVLocation properties
        //     */
        function parseSFPointProperties(input, point, serverInfos) {
            var result = parsePointProperties(point, serverInfos);

            result.searchValue = input;
            result.isBestMatch = point.isBest || false;
            result.matchQuality = point.matchQuality || 0;

            if (point.parent) {
                result.parent = parseParent(point.parent);
            }
            return result;
        }

        function parseASPointProperties(input, point, serverInfos) {
            var result = parsePointProperties(point, serverInfos);

            result.assignedLocation = input;
            result.duration = point.duration;
            result.distance = point.distance;

            return result;
        }

        //    /**
        //     * @private
        //     * @ngdoc method
        //     * @name parseTripPointProperties
        //     * @description
        //     * Parse point properties to a parameter object that can be passed to MDVLocation
        //     * @methodOf mng-comm.itd.json.service:MDVLocationParser
        //     * @param {Object} point - Default point object provided by a EFA Trip request
        //     * @returns {Object} normalized MDVLocation properties
        //     */
        function parseTripPointProperties(point, serverInfos) {
            var props = parsePointProperties(point, serverInfos);

            // date/ time handling
            if (point.departureTimePlanned) {
                props.departureTimePlanned = moment(point.departureTimePlanned);
            }
            if (point.departureTimeEstimated) {
                props.departureTimeEstimated = moment(point.departureTimeEstimated);
            }
            if (point.arrivalTimePlanned) {
                props.arrivalTimePlanned = moment(point.arrivalTimePlanned);
            }
            if (point.arrivalTimeEstimated) {
                props.arrivalTimeEstimated = moment(point.arrivalTimeEstimated);
            }
            if (forbidEarlierDeparture &&
                    props.departureTimePlanned.isValid() &&
                    props.departureTimeEstimated.isValid() &&
                    props.departureTimeEstimated.isBefore(props.departureTimePlanned)) {
                props.departureTimeEstimated = props.departureTimePlanned.clone();
            }
            props.isRealtimeControlled = point.isRealtimeControlled || false;


            if (point.properties && point.properties.realtimeStatus
                && (point.properties.realtimeStatus.length > 0)) {
                props.isCancelled = point.properties.realtimeStatus;
                delete props.properties.realtimeStatus;
            }

            return props;
        }


        return pp;
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVJourneyLegParser
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-model.object:MDVTransportation
     * @requires 'mng-comm.itd.json.service:MDVLocationParser
     * @description
     *
     * Parse EFA response information of journey legs to a MDVJourneyLeg object
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVJourneyLegParser', MDVJourneyLegParser);

    MDVJourneyLegParser.$inject = ['moment', 'mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-util.MDVUtilCoords',
        'mng-comm.itd.MDVEFAFormatter', 'mng-model.MDVJourneyLeg', 'mng-model.MDVTransportation',
        'mng-model.MDVMessage', 'mng-comm.itd.json.MDVTransportationParser',
        'mng-comm.itd.json.MDVEFAUtil', 'mng-comm.itd.json.MDVLocationParser'];

    function MDVJourneyLegParser(moment, MDVLog, MDVUtil, MDVUtilCoords, MDVEFAFormatter, MDVJourneyLeg,
            MDVTransportation, MDVMessage, MDVTransportationParser, MDVEFAUtil, MDVLocationParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVJourneyLegParser'),
            legp = {
                parse : parse,
                parseInterchange : parseInterchange,
                parseWaitLeg : parseWaitLeg
            };

        log.debug('initialize');

        // ////////////////////////////////

        function swapDepartureArrival(point, isOrig) {
            if (isOrig) {
                point.arrivalTimePlanned = point.departureTimePlanned;
                point.arrivalTimeEstimated = point.departureTimeEstimated;
                delete point.departureTimePlanned;
                delete point.departureTimeEstimated;
            } else {
                point.departureTimePlanned = point.arrivalTimePlanned;
                point.departureTimeEstimated = point.arrivalTimeEstimated;
                delete point.arrivalTimePlanned;
                delete point.arrivalTimeEstimated;
            }
            return point;
        }

        function getInterchangePoint(efa_legs, curr_index, isOrig) {
            var point;

            if (isOrig) {
                if (curr_index === 0) {
                    // return current leg's origin if no leg is before
                    point = efa_legs[0].origin;
                } else {
                    // return previous leg's destination
                    point = MDVUtil.copy(efa_legs[curr_index - 1].destination);
                    point = swapDepartureArrival(point, false);
                }
            } else if (curr_index + 1 >= efa_legs.length) {
                // return current leg's destination if no leg follows
                point = efa_legs[curr_index].destination;
            } else {

                // return next leg's origin
                point = MDVUtil.copy(efa_legs[curr_index + 1].origin);
                point = swapDepartureArrival(point, true);
            }

            return MDVLocationParser.parse(point, isOrig ? 'TRIPlegDep' : 'TRIPlegArr');
        }
        function parseFootpathInfo(result, footpaths) {
            var i,
                l,
                elems,
                curr_elem,
                curr_dist,
                cum_dist = 0,
                overallDuration,
                distanceOffset = 0,
                durationOffset = 0;

            if (footpaths.length > 1) {
                log.warn('unable to parse multiple footpath elems, just parsed first elem');
            }

            overallDuration = footpaths[0].duration;
            elems = footpaths[0].footPathElem;

            if (result.length > 0) {
                curr_elem = result[result.length - 1];
                distanceOffset = curr_elem.cumDistance;
                durationOffset = curr_elem.cumDuration;
            }

            if (!elems || elems.length === 0 || (elems.length === 1 && !elems[0].orig)) {
                // try to get as much information as possible
                if (overallDuration) {
                    result.push({
                        duration : overallDuration,
                        cumDuration : overallDuration + durationOffset,
                        cumDistance : distanceOffset,
                        distance : 0
                    });
                }
                return result;
            }


            for (i = 0, l = elems.length; i < l; i += 1) {
                curr_elem = elems[i];
                curr_dist = MDVUtilCoords.distance(curr_elem.origin.location.coord[0],
                    curr_elem.origin.location.coord[1],
                    curr_elem.destination.location.coord[0],
                    curr_elem.destination.location.coord[1]);
                curr_dist = Math.floor(curr_dist);
                cum_dist += curr_dist;

                result.push({
                    origin : curr_elem.origin.location,
                    destination : curr_elem.destination.location,
                    manoeuvre : curr_elem.type,
                    turnDirection : curr_elem.level,
                    name : curr_elem.description,
                    // distance of origin/destination might be taken into account here, too
                    duration : overallDuration / l,
                    distance : curr_dist,
                    cumDistance : cum_dist + distanceOffset,
                    cumDuration : (overallDuration * ((i + 1) / l)) + durationOffset,
                    properties : curr_elem.properties || {},
                    skyDirection : curr_elem.skyDirection ||
                        getSkydirection(curr_elem.origin.location, curr_elem.destination.location)
                });
            }

            return result;
        }

        function parseStopSequence(stop_sequence, infos, controlled) {
            var sequence = [],
                curr_loc,
                i,
                l;

            if (!stop_sequence || stop_sequence.length === 0) {
                return sequence;
            }
            for (i = 0, l = stop_sequence.length; i < l; i += 1) {
                // stop_sequence[i].type = 'stop';
                stop_sequence[i].isRealtimeControlled = controlled;
                curr_loc = MDVLocationParser.parse(stop_sequence[i], 'stopseq');
                curr_loc._bindInfos(MDVEFAUtil.parseInfos(infos, curr_loc));
                sequence.push(curr_loc);
            }
            return sequence;
        }

        function getSkydirection(curr, next) {
            var dir = MDVUtilCoords.bearing(curr.coord[0], curr.coord[1], next.coord[0],
                                                                                     next.coord[1]);

            while (dir >= 360) {
                dir -= 360;
            }
            return Math.floor(dir);
        }

        function preparePathDescriptions(result, pathDescriptions) {
            var i,
                l,
                curr_elem,
                distanceOffset = 0,
                durationOffset = 0;

            if (!pathDescriptions) {
                return result;
            }
            if (result.length > 0) {
                curr_elem = result[result.length - 1];
                distanceOffset = curr_elem.cumDistance;
                durationOffset = curr_elem.cumDuration;
            }

            for (i = 0, l = pathDescriptions.length; i < l; i += 1) {
                curr_elem = pathDescriptions[i];
                if (!curr_elem.skyDirection && curr_elem.skyDirection !== 0 &&
                        i + 1 < l) {
                    curr_elem.skyDirection = getSkydirection(curr_elem, pathDescriptions[i+1]);
                } // skydirection of last element cannot be calculated

                // fix invalid EFA output
                if (i === 0 && curr_elem.cumDistance && curr_elem.distance === 0) {
                    curr_elem.cumDistance = 0;
                }
                if (i === 0 && curr_elem.cumDuration && curr_elem.duration === 0) {
                    curr_elem.cumDuration = 0;
                }

                curr_elem.cumDistance += distanceOffset;
                curr_elem.cumDuration += durationOffset;

                result.push(curr_elem);
            }

            return result;
        }

        function getCombinedPathDescription(efaleg, isFirst) {
            var turn_instrs = efaleg.pathDescriptions,
                footpaths = efaleg.footPathInfo,
                hasTurnInst = turn_instrs && turn_instrs.length > 0,
                hasFootpaths = footpaths && footpaths.length > 0,
                directions = [];

            if (!hasTurnInst && !hasFootpaths) {
                // no information available at all
                return directions;
            }

            if ((hasFootpaths && footpaths[0].position === 'BEFORE') ||
                    (!isFirst && hasFootpaths && footpaths[0].position === 'IDEST')) {
                directions = parseFootpathInfo(directions, footpaths);
            }

            if (hasTurnInst) {
                directions = preparePathDescriptions(directions, turn_instrs);
            }

            if ((hasFootpaths && footpaths[0].position === 'AFTER') ||
                    (isFirst && hasFootpaths && footpaths[0].position === 'IDEST')) {
                directions = parseFootpathInfo(directions, footpaths);
            }

            return directions;
        }
        function getSeparatePathDescriptions(efaleg) {
            var turn_instrs = efaleg.pathDescriptions,
                footpaths = efaleg.footPathInfo,
                hasTurnInst = turn_instrs && turn_instrs.length > 0,
                hasFootpaths = footpaths && footpaths.length > 0,
                directions = {
                    it : [],
                    pt : []
                };

            if (hasTurnInst) {
                directions.it = preparePathDescriptions([], turn_instrs);
            }
            if (hasFootpaths) {
                directions.pt = parseFootpathInfo([], footpaths);
            }

            return directions;
        }

        function parseITTransportation(origin, destination, type) {
            var name = MDVEFAFormatter.translate((type === 99) ? 'TRANSFER' : type);

            return new MDVTransportation({
                id : name + '#' + origin.id() + '#' + destination.id(),
                origin : origin,
                destination : destination,
                product : {
                    'class' : parseInt(type, 10),
                    name : name,
                    iconId : parseInt(type, 10)
                },
                iconId : parseInt(type, 10),
                name : name
            });
        }

        function getLegPath(efa_leg) {
            if (efa_leg.coords) {
                return efa_leg.coords;
            }
            // fallback: sky direction
            if (efa_leg.origin.coord && efa_leg.destination.coord) {
                var coords = [];

                coords.push(efa_leg.origin.coord);
                coords.push(efa_leg.destination.coord);
                return coords;
            }
            return null;
        }
        function getDuration(origin, destination) {
            return destination.arrivalTime().diff(origin.departureTime(), 'seconds');
        }

        function assignSeparateProperties(result, path_desc) {
            if (path_desc.it.length && path_desc.pt.length) {
                // two separate path descriptions
                result.pathDescription = path_desc.it;
                if (!result.properties) {
                    result.properties = {};
                }
                result.properties.alternativePathDescription = path_desc.pt;

                result.distance = path_desc.it[path_desc.it.length - 1].cumDistance;
                result.duration = path_desc.pt[path_desc.pt.length - 1].cumDuration;
                result.standby = getDuration(result.origin, result.destination) - result.duration;
            } else if (!path_desc.it.length && path_desc.pt.length) {
                // only pt info available
                result.pathDescription = path_desc.pt;

                result.distance = path_desc.pt[path_desc.pt.length - 1].cumDistance;
                result.duration = path_desc.pt[path_desc.pt.length - 1].cumDuration;
                result.standby = getDuration(result.origin, result.destination) - result.duration;
            } else if (path_desc.it.length && !path_desc.pt.length) {
                // only it info available
                result.pathDescription = path_desc.it;

                result.distance = path_desc.it[path_desc.it.length - 1].cumDistance;
                result.duration = path_desc.it[path_desc.it.length - 1].cumDuration;
                result.standby = getDuration(result.origin, result.destination) - result.duration;
            } // else: none of both available, do not assign anything
            return result;
        }

        function handlePathDescriptions(result, efa_leg, curr_index) {
            var path_desc;

            if (efa_leg.transportation.product.iconId === 100) {
                path_desc = getCombinedPathDescription(efa_leg, curr_index === 0);
            } else {
                path_desc = getSeparatePathDescriptions(efa_leg);
            }

            if (path_desc) {
                if (path_desc.it && path_desc.pt) {
                    result = assignSeparateProperties(result, path_desc);
                } else if (path_desc.length > 0) {
                    // combined path descriptions
                    result.pathDescription = path_desc;
                    // this overrides every distance, even the passed one. as the passed one often
                    // differs to this value, it is necessary to do so, to keep data consistent.
                    result.distance = path_desc[path_desc.length - 1].cumDistance;
                    // keep the duration that was given in the leg level
                    // result.duration = path_desc[path_desc.length - 1].cumDuration;
                    result.standby = getDuration(result.origin, result.destination) - result.duration;
                }
            }

            if (efa_leg.interchange && efa_leg.interchange.coords) {
                result.coords = efa_leg.interchange.coords;
            }

            return result;
        }

        function getLegProperties(efa_legs, curr_index, serverInfos) {
            var efa_leg = efa_legs[curr_index],
                origin,
                destination,
                duration = efa_leg.duration,
                result,
                controlled = Boolean(efa_leg.isRealtimeControlled),
                standby = 0;

            // cannot have an interchange leg as last leg => correct that
            if ((efa_leg.transportation.product.iconId === 99) && ((efa_legs.length - 1) === curr_index)) {
                efa_leg.transportation.product.iconId = 100;
                efa_leg.transportation.product.class = 100;
            }


            // if (efa_leg.transportation.product['class'] === 99) {
            if (efa_leg.transportation.product && (efa_leg.transportation.product.iconId === 99)) {
                // interchange
                origin = getInterchangePoint(efa_legs, curr_index, true);
                destination = getInterchangePoint(efa_legs, curr_index, false);
            } else {
                // normal leg
                efa_leg.origin.isRealtimeControlled = controlled;
                efa_leg.destination.isRealtimeControlled = controlled;

                origin = MDVLocationParser.parse(efa_leg.origin, 'TRIPlegDep', null, serverInfos);
                destination = MDVLocationParser.parse(efa_leg.destination, 'TRIPlegArr', null, serverInfos);
            }

            // bind stop specific information to the stops
            origin._bindInfos(MDVEFAUtil.parseInfos(efa_leg.infos, origin));
            destination._bindInfos(MDVEFAUtil.parseInfos(efa_leg.infos, null, destination));

            result = {
                origin : origin,
                destination : destination,
                duration : duration,
                distance : efa_leg.distance,
                hints : MDVEFAUtil.parseHints(efa_leg.hints),
                infos : MDVEFAUtil.parseInfos(efa_leg.infos, origin, destination),
                isRealtimeControlled : controlled,
                coords : getLegPath(efa_leg),
                locationSequence : parseStopSequence(efa_leg.stopSequence, efa_leg.infos, controlled),
                properties : efa_leg.properties,
                standby : standby,
                vehicleAccess : efa_leg.vehicleAccess
            };

            // AST Reservation details expiresAfter
            if (result.properties && result.properties.reservationDetails
                && result.properties.reservationDetails.expiresAfter) {
                result.properties.reservationDetails.expiresAfter =
                    moment(result.properties.reservationDetails.expiresAfter);
            }

            // if (efa_leg.transportation.product['class'] >= 97) {
            if (efa_leg.transportation.product && (efa_leg.transportation.product.iconId >= 97)) {
                result.transportation = parseITTransportation(origin, destination,
                                                           // efa_leg.transportation.product['class']);
                                                           efa_leg.transportation.product.iconId);
                result = handlePathDescriptions(result, efa_leg, curr_index);
            } else {
                result.transportation = MDVTransportationParser.parse(efa_leg.transportation);
            }

            return result;
        }
        function getInterchangeProperties(efa_legs, currLegIndex) {
            var currLeg = efa_legs[currLegIndex],
                leg = {
                    origin : getInterchangePoint(efa_legs, currLegIndex + 1, true),
                    destination : getInterchangePoint(efa_legs, currLegIndex, false)
                },
                path_desc = getSeparatePathDescriptions(currLeg, currLegIndex === 0);

            leg.transportation = parseITTransportation(leg.origin, leg.destination, '99');
            leg.properties = currLeg.properties;

            // leg.duration = getDuration(leg.origin, leg.destination);
            if ((path_desc.it && path_desc.it.length > 0) ||
                    (path_desc.pt && path_desc.pt.length > 0)) {
                leg = assignSeparateProperties(leg, path_desc);
            } else {
                leg.duration = getDuration(leg.origin, leg.destination);
                leg.standby = 0;
            }
            if (currLeg.interchange && currLeg.interchange.coords) {
                leg.coords = currLeg.interchange.coords;
            } else {
                leg.coords = currLeg.coords;
            }

            return leg;
        }


        function getWaitProperties(efa_legs, currLegIndex) {
            var leg = {
                origin : getInterchangePoint(efa_legs, currLegIndex, true),
                destination : getInterchangePoint(efa_legs, currLegIndex - 1, false),
                coords : []
            };

            // wait is standby, no transportation duration
            leg.duration = 0;
            leg.standby = getDuration(leg.origin, leg.destination);

            leg.transportation = parseITTransportation(leg.origin, leg.destination, '99');

            return leg;
        }

        function parseInterchange(efa_legs, curr_index) {
            if (!efa_legs || efa_legs.length === 0 || efa_legs.length <= curr_index) {
                return null;
            }
            var props = getInterchangeProperties(efa_legs, curr_index, true);

            if (props) {
                return new MDVJourneyLeg(props);
            }
            return null;
        }


        function parseWaitLeg(efa_legs, curr_index) {
            if (!efa_legs || efa_legs.length === 0 || efa_legs.length <= curr_index) {
                return null;
            }
            var props = getWaitProperties(efa_legs, curr_index);

            if (props) {
                return new MDVJourneyLeg(props);
            }
            return null;
        }

        function parse(efa_legs, curr_index, serverInfos) {
            if (!efa_legs || efa_legs.length === 0 || efa_legs.length <= curr_index) {
                return null;
            }
            var props = getLegProperties(efa_legs, curr_index, serverInfos),
                leg;

            if (props) {
                props.raw = efa_legs[curr_index];
                leg = new MDVJourneyLeg(props);
                leg.efaIndex = curr_index;
                return leg;
            }
            return null;
        }

        return legp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVFileParser', MDVFileParser);

    MDVFileParser.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-model.MDVFile'];

    function MDVFileParser(MDVLog, MDVConfig, MDVFile) {
        var log = MDVLog.register('mng-comm.itd.json.MDVFileParser'),
            serverMappingObj,
            pp = {
                parse : parse
            };

        MDVConfig.ready(function() {
            serverMappingObj = MDVConfig.getValue('mng-comm-itd.ServerMapping') || null;
        });

        log.debug('initialize');


        function parse(efaObj, serverInfos) {
            var efaUrl = efaObj.href || efaObj.src || efaObj.url,
                props = {
                    input : efaObj.input,
                    type : parseDownloadType(efaObj.type, efaUrl),
                    size : efaObj.size,
                    stream : efaObj.stream,
                    raw : efaObj,
                    url : parseDownloadUrl(efaUrl, efaObj.type, serverInfos)
                };

            return new MDVFile(props);
        }

        function parseDownloadUrl(efaUrl, fileType, serverInfos) {
            var prefixMapping,
                urlMapping,
                prefix;

            if (serverMappingObj) {
                if (serverMappingObj.hasOwnProperty('urlMapping')) {
                    urlMapping = serverMappingObj.urlMapping;
                }
                if (serverMappingObj.hasOwnProperty('prefixMapping')) {
                    prefixMapping = serverMappingObj.prefixMapping;
                }
            }

            if (urlMapping && serverInfos && serverInfos.hasOwnProperty('serverID')
                && urlMapping.hasOwnProperty(serverInfos.serverID)) {

                prefix = urlMapping[serverInfos.serverID] + '/';

                if (prefixMapping && prefixMapping.hasOwnProperty(fileType)) {
                    prefix = prefix + prefixMapping[fileType] + '/';
                }

                return prefix + efaUrl;
            }
            return efaUrl;

        }

        function parseDownloadType(type, fileUrl) {
            // special case
            if ((type === 'SM') && fileUrl && (fileUrl.indexOf('ME_')>-1)) {
                return 'SM_ME';
            }
            return type;
        }

        return pp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVDepartureParser
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-comm.itd.json.service:MDVTransportationParser
     * @requires mng-model.object:MDVDeparture
     * @requires mng-model.object:MDVArrival
     * @requires mng-model.object:MDVLocation
     * @description
     *
     * Parse a given departure object provided in an EFA response
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVDepartureParser', MDVDepartureParser);

    MDVDepartureParser.$inject = ['moment', 'mng-util.MDVLog', 'mng-comm.itd.MDVEFAFormatter',
        'mng-comm.itd.json.MDVTransportationParser', 'mng-comm.itd.json.MDVLocationParser',
        'mng-comm.itd.json.MDVEFAUtil', 'mng-model.MDVDeparture', 'mng-model.MDVArrival'
    ];

    function MDVDepartureParser(moment, MDVLog, MDVEFAFormatter, MDVTransportationParser,
            MDVLocationParser, MDVEFAUtil, MDVDeparture, MDVArrival) {
        var log = MDVLog.register('mng-comm.itd.json.MDVDepartureParser'),
            dp = {
                parseDeparture : parseDeparture,
                parseArrival : parseArrival
            };

        log.debug('initialize');

        function parseStopSeq(efaDeparture, stopSeqType) {
            if (!efaDeparture.hasOwnProperty(stopSeqType) || !efaDeparture[stopSeqType] ||
                    !efaDeparture[stopSeqType].length) {
                return [];
            }
            var i, l, curr,
                stopSeqArr = [];

            for (i = 0, l = efaDeparture[stopSeqType].length; i < l; i += 1) {
                curr = MDVLocationParser.parse(efaDeparture[stopSeqType][i], 'stopseq');
                if (curr) {
                    stopSeqArr.push(curr);
                }
            }

            return stopSeqArr;
        }

        function parseDepartureProperties(efaDeparture, location, type) {
            var props = {
                location : MDVLocationParser.parse(efaDeparture.location),
                transportation : MDVTransportationParser.parse(efaDeparture.transportation),
                isRealtimeControlled : Boolean(efaDeparture.isRealtimeControlled),
                isCancelled : Boolean(efaDeparture.isCancelled),
                infos : MDVEFAUtil.parseInfos(efaDeparture.infos),
                hints : MDVEFAUtil.parseHints(efaDeparture.hints),
                onwardStopSeq : parseStopSeq(efaDeparture, 'onwardLocations'),
                prevStopSeq : parseStopSeq(efaDeparture, 'previousLocations'),
                properties : efaDeparture.properties || {},
                raw : {
                    stopEvent : efaDeparture,
                    location : location
                }
            };

            if (type === 'DMdep') {
                if (efaDeparture.departureTimeEstimated) {
                    props.dateTimeEstimated = moment(efaDeparture.departureTimeEstimated);
                }
                props.dateTimePlanned = moment(efaDeparture.departureTimePlanned);
            } else {
                if (efaDeparture.arrivalTimeEstimated || efaDeparture.departureTimeEstimated) {
                    props.dateTimeEstimated =
                        moment(efaDeparture.arrivalTimeEstimated || efaDeparture.departureTimeEstimated);
                }
                props.dateTimePlanned =
                    moment(efaDeparture.arrivalTimePlanned || efaDeparture.departureTimePlanned);
            }

            // add concelation reasons
            // if (efaDeparture.realtimeStatus && (efaDeparture.realtimeStatus.length > 0)) {
            if (Boolean(efaDeparture.isCancelled) && efaDeparture.realtimeStatus && (efaDeparture.realtimeStatus.length > 0)) {
                props.isCancelled = efaDeparture.realtimeStatus;
            }

            return props;
        }

        function parseDeparture(departure, location) {
            return new MDVDeparture(parseDepartureProperties(departure, location, 'DMdep'));
        }

        function parseArrival(arrival, location) {
            return new MDVArrival(parseDepartureProperties(arrival, location, 'DMarr'));
        }

        return dp;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAMoveTripParser', MDVEFAMoveTripParser);

    MDVEFAMoveTripParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.json.MDVEFATripParser'];

    function MDVEFAMoveTripParser(MDVLog, MDVEFATripParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFAMoveTripParser'),
            mrp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response, originalJourney) {
            if (response && response.journey) {
                response.journeys = [response.journey];
                delete response.journey;
            }
            var parsed = MDVEFATripParser.parse(response).trips,
                i, l;

            for (i = 0, l = parsed.length; i < l; i += 1) {
                parsed[i].overallResponse = originalJourney.overallResponse;
                parsed[i].previousJourney = originalJourney;
            }
            return parsed;
        }

        return mrp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAMoveTrip', MDVEFAMoveTrip);

    MDVEFAMoveTrip.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-util.MDVUtil',
        'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.json.MDVEFAMoveTripParser', 'mng-util.MDVException'];


    function MDVEFAMoveTrip(MDVLog, MDVConfig, MDVUtil, MDVEFARequester, MDVEFAMoveTripParser,
            MDVException) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFAMoveTrip',
                version : '10.2.10.139',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            mrRequester,
            mr = {
                moveJourney : moveJourney
            };

        log.debug('initialize');

        // ////////////////////////////////

        function moveJourney(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                postObj;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            postObj = getPostObj(options);

            _private.running_xhr = mrRequester.request(postObj)
                .then(function(response) {
                    if (!response) {

                        throw new MDVException(MDVException.keys.MNG_COMM__TTB.SERVICE_FAILED, {
                            options : options,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;

                    return MDVEFAMoveTripParser.parse(response, options.journey);
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/RJSON_MOVETRIP_REQUEST?',
                defaultParams : {},
                cache : true,
                // do not override requestType. Skip this parameter in documentation
                requestType : 'post'
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function getPostObj(options) {
            var obj = options.journey.overallResponse,
                leg = options.leg,
                hasLegIndex,
                index;

            obj.version = _private.version;
            obj.journeys = [options.journey.raw()];

            hasLegIndex = leg.efaIndex || leg.efaIndex === 0;

            if (!hasLegIndex) {
                log.error('leg.efaIndex not defined. Fallback to leg index 0, which can be wrong!');
            }
            index = leg.efaIndex? leg.efaIndex : 0;
            index += 1;

            obj.params = {
                coordOutputFormat : 'EPSG:4326',
                partialTrip : index.toString(),
                command : options.toPrevious? 'prevPartialTrip' : 'nextPartialTrip',
                useUnifiedTickets : '1'
            };
            log.debug(obj.journeys[0], true);
            log.debug('leg-index: ' + obj.params.partialTrip + ', ' + obj.params.partialTrip);

            return obj;
        }

        function isReady(options) {
            var reasons = [];

            if (!options.journey) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                    reason : 'journey missing'
                }));
            }
            if (!options.leg) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                    reason : 'leg missing'
                }));
            }
            return reasons;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                mr._private = _private;
            }
        });

        // create customized requester object
        mrRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFAMoveTrip',
            _private.getDefaultConfigOption());

        return mr;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAMapRouteParser', MDVEFAMapRouteParser);

    MDVEFAMapRouteParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.json.MDVFileParser'];

    function MDVEFAMapRouteParser(MDVLog, MDVFileParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFAMapRouteParser'),
            mrp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response, requestOptions) {
            var fileProps;

            if (response.download && response.download.url) {
                fileProps = {
                    input : getFileName(response, requestOptions),
                    type : 'MAPROUTE',
                    url : response.download.url,
                    size : response.download.size
                };

                return MDVFileParser.parse(fileProps, response.serverInfo);
            } else {
                log.error('invalid return structure');
            }

        }

        function getFileName(response, options) {
            var fileName = 'MAPROUTE';

            if (options && options.location) {
                return fileName + ' - ' + options.location.name();
            } else if (options.journey) {
                return fileName + ' - ' + options.journey.origin().name() + ' - ' +
                    options.journey.destination().name();
            }
            return fileName + new Date().toString();
        }

        return mrp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAMapRoute', MDVEFAMapRoute);

    MDVEFAMapRoute.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-util.MDVUtil',
        'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.json.MDVEFAMapRouteParser', 'mng-util.MDVException'];


    function MDVEFAMapRoute(MDVLog, MDVConfig, MDVUtil, MDVEFARequester, MDVEFAMapRouteParser,
            MDVException) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFAMapRoute',
                version : '10.2.10.139',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            // create customized requester object
            mrRequester,
            mr = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                postObj;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            postObj = getPostObj(options);

            _private.running_xhr = mrRequester.request(postObj)
                .then(function(response) {
                    if (!response || !response.download || !response.download.url) {
                        throw new MDVException(MDVException.keys.MNG_COMM__TTB.SERVICE_FAILED, {
                            options : options,
                            service : 'mng-comm.itd.json.MDVEFAMapRoute',
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;

                    return MDVEFAMapRouteParser.parse(response, options);
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/RJSON_MAPROUTE_REQUEST?',
                defaultParams : {},
                cache : true,
                // do not override requestType. Skip this parameter in documentation
                requestType : 'post'
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function getPostObj(options) {
            var obj = options.journey.overallResponse,
                leg = options.leg,
                location = options.location,
                hasLegIndex,
                useOrig = true,
                index;

            obj.journeys = [options.journey.raw()];

            if (leg && location) {
                hasLegIndex = leg.efaIndex || leg.efaIndex === 0;

                if (!hasLegIndex) {
                    log.error('leg.efaIndex not defined. Fallback to leg index 0, which can be wrong!');
                }
                index = leg.efaIndex? leg.efaIndex : 0;
                index += 1;  // MAPROUTE index starts with 1

                if (location.equals(leg.destination())) {
                    useOrig = false;
                }
                if (leg.transportation().productClass() === 99) {
                    if (useOrig) {
                        // use destination of previous leg (index already correct)
                        useOrig = false;
                    } else {
                        // use origin of next leg
                        index += 1;
                        useOrig = true;
                    }
                }

                obj.params = {
                    route_index : '1',
                    partial_route_index : index.toString(),
                    point_index : (useOrig)? 'orig' : 'dest',
                    serverInfo : '1',
                    imageFormat : 'pdf',
                    language : 'de'
                };
                log.debug(obj.journeys[0], true);
                log.debug('leg-index: ' + obj.params.partial_route_index + ', ' + obj.params.point_index);
            } else {
                obj.params = {
                    route_index : '1',
                    partial_route_index : '1',
                    point_index : 'overview',
                    serverInfo : '1',
                    imageFormat : 'pdf',
                    language : 'de'
                };
            }

            return obj;
        }

        function isReady(options) {
            var reasons = [];

            if (!options.journey) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                    reason : 'journey missing'
                }));
            }
            // if (!options.leg) {
            //     reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
            //         reason : 'leg missing'
            //     }));
            // }
            // if (!options.location) {
            //     reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
            //         reason : 'location missing'
            //     }));
            // }
            return reasons;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                mr._private = _private;
            }
        });

        // create customized requester object
        mrRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFAMapRoute',
            _private.getDefaultConfigOption());

        return mr;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFALivePositionsParser', MDVEFALivePositionsParser);

    MDVEFALivePositionsParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.MDVEFAFormatter',
        'mng-model.MDVTransportation', 'mng-model.MDVLocation'];

    function MDVEFALivePositionsParser(MDVLog, MDVEFAFormatter, MDVTransportation, MDVLocation) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFALivePositionsParser'),
            lpParser = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parse(response) {
            var i,
                res = [],
                efaMot;

            for (i=0; i<response.length; i+=1) {
                efaMot = response[i];
                res.push(parseLivePositionProperties(efaMot));
            }
            return res;
        }


        function parseLivePositionProperties(mode) {
            var origLong = cleanCoords(mode.XPrevious),
                origLat = cleanCoords(mode.YPrevious),
                destLong = cleanCoords(mode.X),
                destLat = cleanCoords(mode.Y),
                origCoord,
                destCoord,
                props;

            if (origLong && origLat) {
                origCoord = MDVEFAFormatter.str2latlng(origLong +','+ origLat);
            }

            if (destLong && destLat) {
                destCoord = MDVEFAFormatter.str2latlng(destLong +','+ destLat);
            }

            props = {
                origin : new MDVLocation({
                    id : cleanLivePositionId(mode, 'orig'),
                    type : MDVLocation.LOCATIONTYPES.STOP,
                    coord : origCoord
                }),
                destination : new MDVLocation({
                    name : mode.DirectionText,
                    id : cleanLivePositionId(mode, 'dest'),
                    type : MDVLocation.LOCATIONTYPES.STOP,
                    coord : destCoord
                }),
                id : mode.ID,
                iconId : mode.ProductIdentifier,
                name : mode.LineText,
                // number : mode.number,
                routeDescription : mode.DirectionText,
                product : {
                    'class' : parseInt(mode.MOTCode, 10),
                    name : mode.LineText
                    // iconId : parseInt(mode.motType, 10)
                },
                operator : {
                    name : mode.Operator
                },
                properties : {
                    tripCode : mode.JourneyIdentifier,
                    delay : mode.Delay || 0,
                    realtimeAvailable : (mode.RealtimeAvailable === 1),
                    IsAtStop : (mode.IsAtStop)?mode.IsAtStop:false,
                    NextStop : mode.NextStop,
                    CurrentStop : mode.CurrentStop
                    // network : mode.network
                }
            };

            props.raw = mode;
            return new MDVTransportation(props);
        }

        function cleanCoords(coord) {
            if (!coord) {
                return null;
            }
            return coord.replace(',', '.');
        }

        function cleanLivePositionId(mode, usage) {
            if (!mode) {
                return;
            }

            return mode.ID+'_'+usage;
        }

        return lpParser;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFALivePositions', MDVEFALivePositions);

    MDVEFALivePositions.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.MDVEFAOptionsParser', 'mng-comm.itd.json.MDVEFALivePositionsParser',
        'mng-util.MDVException', 'mng-util.MDVUtil', 'mng-model.MDVTransportation'];


    function MDVEFALivePositions(MDVLog, MDVConfig, MDVEFARequester, MDVEFAOptionsParser,
            MDVEFALivePositionsParser, MDVException, MDVUtil, MDVTransportation) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFALivePositions',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            lpRequester,
            lp = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(inputa, inputb, options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(inputa, inputb),
                params,
                result;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            params = addSearchParams(inputa, inputb, options);

            _private.running_xhr = lpRequester.request(params)
                .then(function(response) {
                    if (!response) {
                        throw new MDVException(MDVException.keys.MNG_COMM__LIVE_POSITIONS.SERVICE_FAILED, {
                            args : [inputa, inputb, options],
                            service : _private.namespace,
                            reason : 'no response'
                        });
                    }
                    _private.running_xhr = null;
                    result = MDVEFALivePositionsParser.parse(response);

                    return result;
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/DDIP_VMI?',
                defaultParams : {},
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function isReady(inputa, inputb) {
            var reasons = [],
                i, l;

            if (inputa && inputa.constructor === Array) {
                for (i=0, l=inputa.length; i<l; i+=1) {
                    if (!inputa[i] || !(inputa[i] instanceof MDVTransportation)) {
                        reasons.push(new MDVException(MDVException.keys.MNG_COMM__LIVE_POSITIONS.NO_INPUT, {
                            reason : 'Invalid Transportations array'
                        }));
                        return reasons;
                    }
                }
                return reasons;
            }

            if (inputa && inputa instanceof MDVTransportation) {
                return reasons;
            }

            if (!inputa || !inputb) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__LIVE_POSITIONS.NO_INPUT, {
                    reason : 'Missing coordinates'
                }));
            }

            if (!MDVUtil.isValidCoordinate(inputa) || !MDVUtil.isValidCoordinate(inputb)) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__LIVE_POSITIONS.INVALID_INPUT, {
                    reason : 'Invalid coordinates'
                }));
            }

            return reasons;
        }

        function parseLineId(transportations) {
            if (transportations && transportations instanceof MDVTransportation) {
                transportations = [transportations];
            }

            var result = [],
                transportation,
                i, l,
                j, m,
                idArr;

            for (i=0, l=transportations.length; i<l; i+=1) {
                transportation = transportations[i];
                idArr = transportation.id().split(':');

                if (transportation.isPublicTransportation()) {
                    if (idArr.length<5) {
                        throw new MDVException(MDVException.keys.MNG_COMM__LIVE_POSITIONS.SERVICE_FAILED, {
                            args : [transportation],
                            service : _private.namespace,
                            reason : 'invalid transportation id'
                        });
                    }

                    for (j=0, m=idArr.length; j<m; j+=1) {
                        idArr[j] = idArr[j].trim();
                    }

                    result.push(idArr[4] + ':' + idArr[0] + ':' + idArr[1] + ':' + idArr[3] + ':' + idArr[2]);
                }
            }

            return result;
        }

        function addSearchParams(inputa, inputb, options) {
            if (inputa && inputa.constructor === Array) {
                return {
                    LineID : parseLineId(inputa)
                };
            }

            if (inputa && inputa instanceof MDVTransportation) {
                return {
                    LineID : parseLineId(inputa)
                };
            }
            if (options && options.productRestrictions) {
                // enable veloc parsing
                options.productRestrictions.velocMode = true;
            }

            if (options.transportations) {
                if (!options.efaParams) {
                    options.efaParams = {};
                }
                options.efaParams.LineID = parseLineId(options.transportations);
            }

            var params = MDVEFAOptionsParser.parse(options);

            if (!params.MOTCode) {
                params.MOTCode = 999;
            }

            params.MinX = inputa.lng.toString();
            params.MinY = inputa.lat.toString();
            params.MaxX = inputb.lng.toString();
            params.MaxY = inputb.lat.toString();
            params.ts = new Date().getTime();

            return params;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                lp._private = _private;
            }
        });

        // create customized requester object
        lpRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFALivePositions',
            _private.getDefaultConfigOption());

        return lp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFAGeoObjectParser
     * @requires moment
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.json.service:MDVTransportationParser
     * @description
     *
     * Parse a given geoobject response object provided by the EFA and parse it to a list of {@link
     * mng-model.object:MDVTransportation MDVTransportations}.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAGeoObjectParser', MDVEFAGeoObjectParser);

    MDVEFAGeoObjectParser.$inject = ['moment', 'mng-util.MDVLog',
        'mng-comm.itd.json.MDVTransportationParser'];

    function MDVEFAGeoObjectParser(moment, MDVLog, MDVTransportationParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFAGeoObjectParser'),
            cp = {
                parse : parse
            };

        log.debug('initialize');

        function isInvalidResponse(response) {
            return !response || !response.transportations;
        }

        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.json.service:MDVEFAGeoObjectParser
         * @param {Object} response the efa response object
         * @returns {Object} normalized information object
         *
         * @description
         * convert a given set of infos to a list of normalized information objects
         */
        function parse(response) {
            var lines = [],
                curr = null,
                transportations = [],
                i,
                l;

            if (isInvalidResponse(response)) {
                return lines;
            }
            transportations = response.transportations;

            if (response.transfers && response.transfers.length) {
                addTransfersToLocationSequence(transportations, response.transfers);
            }

            for (i = 0, l = transportations.length; i < l; i += 1) {
                curr = MDVTransportationParser.parse(transportations[i]);
                if (curr) {
                    lines.push(curr);
                }
            }
            return lines;
        }

        function addTransfersToLocationSequence(transportations, transfers) {
            var i, l,
                j, m,
                k, n,
                parentId,
                location;

            // check all assigned stops of all transportations and append corresponding transfer objects
            for (i = 0, l = transfers.length; i < l; i += 1) {
                for (j = 0, m = transportations.length; j < m; j += 1) {
                    for (k = 0, n = transportations[j].locationSequence.length; k < n; k += 1) {
                        parentId = transportations[j].locationSequence[k].parent.id;
                        if (String(transfers[i].assignedStopID) === parentId) {
                            fireAdding(transportations[j], transfers[i]);
                        }
                    }
                }
            }

            function fireAdding(transportation, transfer) {
                location = transportation.locationSequence[k];
                if (!location.hasOwnProperty('transportations')) {
                    transportation.locationSequence[k].transportations = [];
                }
                transportation.locationSequence[k].transportations.push(transfer);
            }


            return true;
        }

        return cp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFAGeoObject
     * @requires $q
     * @requires mng-util.service:MDVLog
     * @requires mng-util.service:MDVUtil
     * @requires mng-util.service:MDVException
     * @requires mng-comm.itd.service:MDVEFARequester
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-comm.itd.json.service:MDVEFAUtil
     * @requires mng-comm.itd.json.service:MDVEFAGeoObjectParser
     * @requires mng-model.service:MDVTransportation
     * @description
     *
     * Main Service to get lists of {@link mng-model.object:MDVTransportation MDVTransportations}
     * that provide additional information for a certain transportation id, like coordinates or
     * passed stops.
     *
     * This service registers a {@link mng-comm.itd.service:MDVEFARequester MDVEFARequest} for
     * GEOOBJECT-purposes. This requester is used whenever the search method is called.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd-json.MDVEFAGeoObject`.
     *
     * As the `MDVEFAGeoObject` service does not support any special parameters, please refer
     * to the {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester} service for detailed a
     * configuration description.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAGeoObject', MDVEFAGeoObject);

    MDVEFAGeoObject.$inject = ['$q', 'mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-util.MDVException',
        'mng-util.MDVUtil', 'mng-comm.itd.MDVEFARequester', 'mng-model.MDVTransportation',
        'mng-comm.itd.MDVEFAFormatter', 'mng-comm.itd.MDVEFAOptionsParser',
        'mng-comm.itd.json.MDVEFAUtil', 'mng-comm.itd.json.MDVEFAGeoObjectParser'];


    function MDVEFAGeoObject($q, MDVLog, MDVConfig, MDVException, MDVUtil, MDVEFARequester,
            MDVTransportation, MDVEFAFormatter, MDVEFAOptionsParser, MDVEFAUtil,
            MDVEFAGeoObjectParser) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFAGeoObject',
                version : '10.2.10.139',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            geoRequester,
            info = {
                searchLines : searchLines
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name searchLines
         * @methodOf mng-comm.itd.json.service:MDVEFAGeoObject
         * @param {Transportation | Transportation[]} transportations A single transportation or a
         * list of transportation objects.
         * @param {Object} options additional options that should be used for this search only
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVTransportation MDVTransportations}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVTransportationRequester MDVTransportationRequester} service. It
         * triggers a
         * XML_GEOOBJECT_REQUEST with the given input and passes the response to the {@link
         * mng-comm.itd.json.service:MDVEFAGeoObjectParser MDVEFAGeoObjectParser} to ensure
         * that a unified list of {@link mng-model.object:MDVTransportation MDVTransportations} is
         * returned in
         * the response object.
         */
        function searchLines(transportations, options) {
            if (!isReady(transportations)) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG_COMM__TTB.INVALID_INPUT, {
                        input : transportations,
                        reason : 'invalid type. expected MDVTransportation or MDVTransportation[]'
                    })
                );
            }
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            if (!options) {
                options = {};
            }
            var params = getSearchParams(transportations, options);

            _private.running_xhr = geoRequester.request(params)
                .then(function(response) {
                    _private.running_xhr = null;
                    return MDVEFAGeoObjectParser.parse(response);
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_GEOOBJECT_REQUEST?',
                defaultParams : {},
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function isReady(input) {
            // test if input array consists of MDVTransportation elements might be useful here
            return input && ((input instanceof MDVTransportation) || input.constructor === Array);
        }

    //    /**
    //     * @private
    //     * @ngdoc method
    //     * @name reject_xhr
    //     * @methodOf mng-comm.itd.json.service:MDVEFAStopfinder
    //     * @param {xhr} xhr Xhr that should be rejected.
    //     *
    //     * @description
    //     * reject a given xhr and broadcast a 'COM.NEW_REQUEST'-Event
    //     */
        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function getSearchParams(transportations, options) {
            var params = MDVUtil.copy(options.efaParams || {}),
                lines = [],
                i,
                l,
                date;

            if (transportations.constructor !== Array) {
                transportations = [transportations];
            }

            for (i = 0, l = transportations.length; i < l; i += 1) {
                if (transportations[i] instanceof MDVTransportation) {
                    lines.push(transportations[i].id());
                }
            }

            params.line = lines;

            if (options && options.dateTime && options.dateTime.date) {
                date = MDVEFAOptionsParser._handleDate(options.dateTime.date,
                                                        options.dateTime.dateFormat);
                if (date) {
                    params.filterDate = date;
                }
            }

            params.version = _private.version;

            return params;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                info._private = _private;
            }
        });

        // create customized requester object
        geoRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFAGeoObject',
            _private.getDefaultConfigOption());

        return info;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAStopSequenceParser', MDVEFAStopSequenceParser);

    MDVEFAStopSequenceParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.json.MDVLocationParser'];

    function MDVEFAStopSequenceParser(MDVLog, MDVLocationParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFAStopSequenceParser'),
            selttp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////


        function parseLines(stopList) {
            var stops = [];

            angular.forEach(stopList, function(stop) {
                stops.push(MDVLocationParser.parse(stop));
            });

            return stops;
        }

        function parse(response) {
            return parseLines(response.locationSequence);
        }

        return selttp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAStopSequence', MDVEFAStopSequence);

    MDVEFAStopSequence.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-model.MDVTransportation',
        'mng-comm.itd.json.MDVEFAUtil', 'mng-comm.itd.json.MDVEFAStopSequenceParser',
        'mng-comm.itd.MDVEFAOptionsParser', 'mng-util.MDVUtil', 'mng-util.MDVException'];


    function MDVEFAStopSequence(MDVLog, MDVConfig, MDVEFARequester, MDVTransportation, MDVEFAUtil,
                        MDVEFAStopSequenceParser, MDVEFAOptionsParser, MDVUtil, MDVException) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFAStopSequence',
                version : '10.2.10.139'
            },
            log = MDVLog.register(_private.namespace),
            stopSeqRequester,
            stopseq = {
                searchForStopOvers : searchForStopOvers
            };

        log.debug('initialize');

        // ////////////////////////////////


        function searchForStopOvers(input, options) {
            var reasons = isReady(input, options);

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            return request(input, options)
                .then(function(response) {
                    return response;
                });
        }
        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_LINESTOP_REQUEST?',
                defaultParams : {

                },
                cache : true
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function addSearchParams(params, input) {
            if (input instanceof MDVTransportation) {
                params.line = input.id();
            }

            return params;
        }

        function request(input, options) {
            var efa_opts = MDVEFAOptionsParser.parse(options);

            efa_opts = addSearchParams(efa_opts, input);

            efa_opts.version = _private.version;

            // send new request
            return stopSeqRequester.request(efa_opts)
                .then(function(response) {
                    return MDVEFAStopSequenceParser.parse(response);
                });
        }

        function isReady(input) {
            var reasons = [];

            if (!input) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.NO_INPUT, {
                    reason : 'no element passed to the search method'
                }));
            } else if (typeof input !== 'string' && !(input instanceof MDVTransportation)) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.NO_INPUT, {
                    input : input,
                    reason : 'invalid type. expected string or MDVTransportation'
                }));
            }
            return reasons;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                stopseq._private = _private;
            }
        });

        // create customized requester object
        stopSeqRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFAStopSequence',
            _private.getDefaultConfigOption());

        return stopseq;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFALineListParser', MDVEFALineListParser);

    MDVEFALineListParser.$inject = ['mng-util.MDVLog',
        'mng-comm.itd.json.MDVTransportationParser'];

    function MDVEFALineListParser(MDVLog, MDVTransportationParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFALineListParser'),
            selttp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////


        function parseLines(efaLines) {
            var lines = [];

            angular.forEach(efaLines, function(efaLine) {
                lines.push(MDVTransportationParser.parse(efaLine));
            });

            return lines;
        }

        function parse(response) {
            return parseLines(response.transportations);
        }

        return selttp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFALineList', MDVEFALineList);

    MDVEFALineList.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-model.MDVLocation',
        'mng-comm.itd.json.MDVEFAUtil', 'mng-comm.itd.json.MDVEFALineListParser',
        'mng-comm.itd.MDVEFAOptionsParser', 'mng-util.MDVUtil', 'mng-util.MDVException'];


    function MDVEFALineList(MDVLog, MDVConfig, MDVEFARequester, MDVLocation, MDVEFAUtil,
                        MDVEFALineListParser, MDVEFAOptionsParser, MDVUtil, MDVException) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFALineList',
                version : '10.2.10.139'
            },
            log = MDVLog.register(_private.namespace),
            llRequester,
            ll = {
                searchLines : searchLines
            };

        log.debug('initialize');

        // ////////////////////////////////

        function searchLines(input, options) {
            var reasons = isReady(input, options);

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            return request(input, options)
                .then(function(response) {
                    return response;
                });
        }
        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_LINELIST_REQUEST?',
                defaultParams : {

                },
                cache : true
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function addSearchParams(params, input, options) {
            var reqType = 0,
                i,
                l;

            if (input instanceof MDVLocation) {
                //params.name_sl = input.id();
                //params.type_sl = 'stopID';
                //params.mode = 'odv';
            } else if (typeof input === 'string') {
                //params.lineName = input;
                //params.mode = 'line';
            }  // else: allow operator input?

            if (options && options.codes) {
                params.lineListBranchCode = options.codes;
            }

            return params;
        }

        function request(input, options) {
            var efa_opts = MDVEFAOptionsParser.parse(options);

            efa_opts = addSearchParams(efa_opts, input, options);

            efa_opts.version = _private.version;

            // send new request
            return llRequester.request(efa_opts)
                .then(function(response) {
                    return MDVEFALineListParser.parse(response);
                });
        }

        function isReady(input) {
            var reasons = [];

            if (!input) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.NO_INPUT, {
                    reason : 'no element passed to the search method'
                }));
            } else if (typeof input !== 'string' && !(input instanceof MDVLocation)) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TTB.NO_INPUT, {
                    input : input,
                    reason : 'invalid type. expected string or MDVLocation'
                }));
            }
            return reasons;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                ll._private = _private;
            }
        });

        // create customized requester object
        llRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFALineList',
            _private.getDefaultConfigOption());

        return ll;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAInterchangeParser', MDVEFAInterchangeParser);

    MDVEFAInterchangeParser.$inject = ['mng-util.MDVLog', 'mng-util.MDVException'];

    function MDVEFAInterchangeParser(MDVLog, MDVException) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFAInterchangeParser'),
            icp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////


        function parseInterchanges(footpaths) {
            var interchanges = [];

            if (!footpaths) {
                return interchanges;
            }

            angular.forEach(footpaths, function(footpath) {
                var interchange = [];

                angular.forEach(footpath.pathDescription, function(pathDescription) {
                    if (interchange.indexOf(pathDescription.type) === -1) {
                        interchange.push(pathDescription.type);
                    }
                });

                if (interchange.length > 0) {
                    interchanges.push(interchange);
                }
            });

            return interchanges;
        }

        function parse(response) {
            if (response && response.properties && response.properties.noInterchangeDataForStop) {
                throw new MDVException(MDVException.keys.MNG_COMM__INTERCHANGE.SERVICE_FAILED, {
                    args : [response],
                    reason : 'noInterchangeDataForStop'
                });
            }

            return parseInterchanges(response.footpaths);
        }

        return icp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAInterchange', MDVEFAInterchange);

    MDVEFAInterchange.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.MDVEFAOptionsParser', 'mng-comm.itd.json.MDVEFAInterchangeParser',
        'mng-util.MDVException', 'mng-util.MDVUtil', 'mng-model.MDVLocation'];


    function MDVEFAInterchange(MDVLog, MDVConfig, MDVEFARequester, MDVEFAOptionsParser,
            MDVEFAInterchangeParser, MDVException, MDVUtil, MDVLocation) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFAInterchange',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            icRequester,
            lp = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(inputa, inputb, options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(inputa, inputb),
                params,
                result;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            params = addSearchParams(inputa, inputb, options);

            _private.running_xhr = icRequester.request(params)
                .then(function(response) {
                    if (!response) {
                        throw new MDVException(MDVException.keys.MNG_COMM__INTERCHANGE.SERVICE_FAILED, {
                            args : [inputa, inputb, options],
                            service : _private.namespace,
                            reason : 'no response'
                        });
                    }
                    _private.running_xhr = null;
                    result = MDVEFAInterchangeParser.parse(response);

                    return result;
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_INTERCHANGE_REQUEST?',
                defaultParams : {},
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function isReady(inputa, inputb) {
            var reasons = [];

            if (!MDVConfig.isReady()) {
                reasons.push(new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                    reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                        'without a valid configuration.'
                }));
            }

            if (inputa) {
                if (!(inputa instanceof MDVLocation)) {
                    reasons.push(new MDVException(MDVException.keys.MNG_COMM__INTERCHANGE.NO_INPUT, {
                        reason : 'Invalid MDVLocation'
                    }));
                    return reasons;
                }
            }


            if (inputb) {
                if (!(inputb instanceof MDVLocation)) {
                    reasons.push(new MDVException(MDVException.keys.MNG_COMM__INTERCHANGE.NO_INPUT, {
                        reason : 'Invalid MDVLocation'
                    }));
                    return reasons;
                }
            }

            if (!inputa && !inputb) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__INTERCHANGE.NO_INPUT, {
                    reason : 'Missing input'
                }));
            }

            // datetime in past should be rejected, too

            return reasons;
        }


        function addSearchParams(orig, dest, options) {
            var params = MDVEFAOptionsParser.parse(options);

            if (orig && !dest) {
                params.name_origin = orig.id();
                params.name_destination = orig.parent().id();
            } else if (!orig && dest) {
                params.name_origin = dest.parent().id();
                params.name_destination = dest.id();
            } else if (orig && dest) {
                params.name_origin = orig.id();
                params.name_destination = dest.id();
            }

            params.anyEntranceOrig = 1;
            params.scenario = 127;

            return params;
        }


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                lp._private = _private;
            }
        });

        // create customized requester object
        icRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFAInterchange',
            _private.getDefaultConfigOption());

        return lp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAFormationsParser', MDVEFAFormationsParser);

        MDVEFAFormationsParser.$inject = ['mng-util.MDVLog', 'mng-util.MDVException'];

    function MDVEFAFormationsParser(MDVLog, MDVException) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFAFormationsParser'),
            icp = {
                parse : parse
            };

        log.debug('initialize');

        function parse(res) {
            if (res && res.formations) {
                return res.formations;
            }
            return res;
        }
        return icp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAFormations', MDVEFAFormations);

        MDVEFAFormations.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-comm.itd.json.MDVEFAFormationsParser',
        'mng-util.MDVException', 'mng-util.MDVUtil'];


    function MDVEFAFormations(MDVLog, MDVConfig, MDVEFARequester,
        MDVEFAFormationsParser, MDVException, MDVUtil) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFAFormations',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            icRequester,
            lp = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function search(options) {
            if (_private.running_xhr) {
                reject_xhr(_private.running_xhr);
            }
            var reasons = isReady(options),
                result;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }
            _private.running_xhr = icRequester.request(options)
                .then(function(response) {
                    if (!response) {
                        throw new MDVException(MDVException.keys.MNG_COMM__FORMATIONS.SERVICE_FAILED, {
                            args : [options],
                            service : _private.namespace,
                            reason : 'no response'
                        });
                    }
                    _private.running_xhr = null;
                    result = MDVEFAFormationsParser.parse(response);
                    return result;
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_FORMATIONS_REQUEST?',
                defaultParams : {},
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);
            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function reject_xhr(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        }

        function isReady(options) {
            var reasons = [];

            if (!MDVConfig.isReady()) {
                reasons.push(new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                    reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                        'without a valid configuration.'
                }));
            }

            if (!options) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__FORMATIONS.NO_OPTIONS, {
                    reason : 'Missing options'
                }));
            }

            return reasons;
        }

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                lp._private = _private;
            }
        });

        // create customized requester object
        icRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFAFormations',
            _private.getDefaultConfigOption());

        return lp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFADestForStopParser
     * @requires mng-util.service:MDVLog
     * @requires mng-model.object:MDVLocation
     * @requires mng-comm.itd.json.service:MDVDepartureParser
     * @description
     *
     * Parse Object for the response of an EFA Departure Monitor request. It handles the
     * delegation of the objects to parse.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFADestForStopParser', MDVEFADestForStopParser);

    MDVEFADestForStopParser.$inject = ['mng-config.MDVConfig', 'mng-util.MDVLog',
        'mng-comm.itd.json.MDVEFAUtil', 'mng-comm.itd.json.MDVLocationParser'
    ];

    function MDVEFADestForStopParser(MDVConfig, MDVLog, MDVCommUtil, MDVLocationParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFADestForStopParser'),
            dmp = {
                parse : parse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parseList(result, type) {
            var i, l, curr,
                response = [];

            for (i = 0, l = result[type].length; i < l; i += 1) {
                curr = MDVLocationParser.parse(result[type][i], null, null, result.serverInfo);

                if (curr) {
                    response.push(curr);
                }
            }

            return response;
        }

        // /**
        // * Check the EFA response and iterate over all the locations to parse them.
        // **/
        function parse(result) {
            var response = {
                stops : [],
                localities : []
            };

            if (!result) {
                return response;
            }
            if (result.stops) {
                response.stops = parseList(result, 'stops');
            }
            if (result.localities) {
                response.localities = parseList(result, 'localities');
            }

            response.systemMessages = MDVCommUtil.parseSystemMessages(result.systemMessages);
            return response;
        }

        return dmp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFADestForStop
     * @requires $q
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.json.service:MDVEFARequester
     * @requires mng-comm.itd.json.service:MDVEFADMParser
     * @requires mng-comm.itd.json.service:MDVEFAOptionsParser
     * @description
     *
     * Main Service to get lists of departures/arrivals or a list of serving lines for a specific stop.
     *
     * This service registers a {@link mng-comm.itd.service:MDVEFARequester MDVEFARequest} for
     * DM-purposes. This requester is used whenever the search method is called.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd-json.MDVEFADestForStop`.
     *
     * As the `MDVEFADestForStop` service does not support any special parameters, please refer
     * to the {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester} service for detailed a
     * configuration description.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFADestForStop', MDVEFADestForStop);

    MDVEFADestForStop.$inject = ['$q', 'mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-comm.itd.json.MDVEFAUtil',
        'mng-comm.itd.json.MDVEFADestForStopParser', 'mng-comm.itd.MDVEFAOptionsParser'];


    function MDVEFADestForStop($q, MDVLog, MDVConfig, MDVEFARequester, MDVEFAUtil, MDVEFADestForStopParser,
            MDVEFAOptionsParser) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFADestForStop',
                version : '10.2.10.139'
            },
            log = MDVLog.register(_private.namespave),
            dmRequester,
            dm = {
                searchForDestinations : searchForDestinations
            };

        log.debug('initialize');

        // ////////////////////////////////


        /**
         * @public
         * @ngdoc method
         * @name searchForDestinations
         * @methodOf mng-comm.itd.json.service:MDVEFADestForStop
         * @param {MDVLocation} location {@link mng-model.object:MDVLocation MDVLocation} object
         * the destinations should be searched for
         * @param {Object} options Additional options for the departure search, like date or time.
         * @returns {Deferred} Deferred, that is resolved to an object with a stops and localities
         * list containing {@link mng-model.object:MDVLocation MDVLocations} that are in reach of
         * the passed location.
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVLocationRequester MDVLocationRequester} service. It triggers a
         * XML_DEPARTURESFROMSTOP_REQUEST with the given location
         * and passes the response to the {@link mng-comm.itd.json.service:MDVEFADestForStopParser
         * MDVEFADestForStop} to ensure that an unified response with
         * {@link mng-model.object:MDVLocation MDVLocations}  is returned in the response object.
         */
        function searchForDestinations(location, options) {
            return request(location, options)
                .then(function(response) {
                    return MDVEFADestForStopParser.parse(response);
                });
        }


        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_DESTINATIONSFROMSTOP_REQUEST?',
                defaultParams : {},
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        function request(location, options) {
            var id = location.id(),
                efa_opts = MDVEFAOptionsParser.parse(options);

            efa_opts.name_dfs = id;
            efa_opts.type_dfs = 'any';
            efa_opts.version = _private.version;

            return dmRequester.request(efa_opts);
        }

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                dm._private = _private;
            }
        });

        // create customized requester object
        dmRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFADestForStop',
            _private.getDefaultConfigOption());

        return dm;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFADMParser
     * @requires mng-util.service:MDVLog
     * @requires mng-model.object:MDVLocation
     * @requires mng-comm.itd.json.service:MDVDepartureParser
     * @description
     *
     * Parse Object for the response of an EFA Departure Monitor request. It handles the
     * delegation of the objects to parse.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFADMParser', MDVEFADMParser);

    MDVEFADMParser.$inject = ['mng-config.MDVConfig', 'mng-util.MDVLog', 'mng-model.MDVLocation',
        'mng-comm.itd.json.MDVEFAUtil',
        'mng-comm.itd.json.MDVDepartureParser', 'mng-comm.itd.json.MDVLocationParser'
    ];

    function MDVEFADMParser(MDVConfig, MDVLog, MDVLocation, MDVCommUtil, MDVDepartureParser,
            MDVLocationParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFADMParser'),
            dmp = {
                parseDepartures : parseDepartures,
                parseArrivals : parseArrivals
            };

        log.debug('initialize');

        // ////////////////////////////////


        function getGroupConfig(type) {
            if (MDVConfig.isReady()) {
                var groupObj = MDVConfig.getValue('mng-comm-itd-json.MDVEFADM.grouped');

                return groupObj && groupObj.hasOwnProperty(type) && groupObj[type];
            }
            return false;
        }

        // /**
        // * Check the EFA response validity and iterate over all the departures
        // * to parse them.
        // **/
        function parseDepartures(result) {
            var response = {},
                departures = [],
                location = null,
                toBeGrouped = getGroupConfig('departures');

            if (result) {
                if (toBeGrouped && result.locations && (result.locations.length > 0) &&
                        result.locations[0].assignedStops &&
                        result.locations[0].assignedStops.length > 0) {
                    angular.forEach(result.locations[0].assignedStops, function(assignedStop) {
                        var deps = [];

                        angular.forEach(result.stopEvents, function(departure) {
                            if (assignedStop.id === departure.location.parent.id) {
                                deps.push(
                                    MDVDepartureParser.parseDeparture(departure, result.locations[0]));
                            }
                        });
                        departures.push({
                            'assignedLocation' :
                                MDVLocationParser.parse(assignedStop, 'as', null, result.serverInfo),
                            'departures' : deps
                        });
                    });
                } else {
                    angular.forEach(result.stopEvents, function(departure) {
                        departures.push(MDVDepartureParser.parseDeparture(departure, result.locations[0]));
                    });
                }
                if (result.locations && result.locations.length>0) {
                    location = MDVLocationParser.parse(result.locations[0], null, null, result.serverInfo);
                }

            }

            response.systemMessages = MDVCommUtil.parseSystemMessages(result.systemMessages);
            response.departures = departures;
            response.location = location;
            return response;
        }

        // /**
        // * Check the EFA response validity and iterate over all the arrivals
        // * to parse them.
        // **/
        function parseArrivals(result) {
            var response = {},
                arrivals = [],
                location = null,
                toBeGrouped = getGroupConfig('arrivals');

            if (result) {
                if (toBeGrouped && result.locations && (result.locations.length > 0) &&
                        result.locations[0].assignedStops &&
                        result.locations[0].assignedStops.length > 0) {
                    angular.forEach(result.locations[0].assignedStops, function(assignedStop) {
                        var arrs = [];

                        angular.forEach(result.stopEvents, function(arrival) {
                            if (assignedStop.id === arrival.location.parent.id) {
                                arrs.push(MDVDepartureParser.parseArrival(arrival, result.locations[0]));
                            }
                        });
                        arrivals.push({
                            'assignedLocation' :
                                MDVLocationParser.parse(assignedStop, 'as', null, result.serverInfo),
                            'arrivals' : arrs
                        });
                    });
                } else {
                    angular.forEach(result.stopEvents, function(arrival) {
                        arrivals.push(MDVDepartureParser.parseArrival(arrival, result.locations[0]));
                    });
                }
                if (result.locations && result.locations.length>0) {
                    location = MDVLocationParser.parse(result.locations[0], null, null, result.serverInfo);
                }
            }
            response.systemMessages = MDVCommUtil.parseSystemMessages(result.systemMessages);
            response.arrivals = arrivals;
            response.location = location;
            return response;
        }

        return dmp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFADM
     * @requires $q
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.json.service:MDVEFARequester
     * @requires mng-comm.itd.json.service:MDVEFADMParser
     * @requires mng-comm.itd.json.service:MDVEFAOptionsParser
     * @description
     *
     * Main Service to get lists of departures/arrivals or a list of serving lines for a specific stop.
     *
     * This service registers a {@link mng-comm.itd.service:MDVEFARequester MDVEFARequest} for
     * DM-purposes. This requester is used whenever the search method is called.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd-xmljson.MDVEFADM`.
     *
     * As the `MDVEFADM` service does not support any special parameters, please refer
     * to the {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester} service for detailed a
     * configuration description.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFADM', MDVEFADM);

    MDVEFADM.$inject = ['$q', 'mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.json.MDVEFAUtil', 'mng-comm.itd.json.MDVEFADMParser',
        'mng-comm.itd.MDVEFAOptionsParser', 'mng-model.MDVLocation'];


    function MDVEFADM($q, MDVLog, MDVConfig, MDVEFARequester, MDVEFAUtil, MDVEFADMParser,
            MDVEFAOptionsParser, MDVLocation) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFADM',
                version : '10.2.10.139'
            },
            log = MDVLog.register(_private.namespave),
            dmRequester,
            dm = {
                searchArrivals : searchArrivals,
                searchDepartures : searchDepartures
            };

        log.debug('initialize');

        // ////////////////////////////////


        /**
         * @public
         * @ngdoc method
         * @name searchDepartures
         * @methodOf mng-comm.itd.json.service:MDVEFADM
         * @param {MDVLocation} location {@link mng-model.object:MDVLocation MDVLocation} object
         * the departures should be searched for
         * @param {Object} options Additional options for the departure search, like date or time.
         * Please note that dateTime.isDeparture is overridden with true and has no effect.
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVDeparture MDVDepartures}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVDepartures MDVDepartures} service. It triggers a
         * XML_DM_REQUEST with the given location (and a default option {'itdDateTimeDepArr':'dep'})
         * and passes the response to the {@link mng-comm.itd.json.service:MDVEFADMParser
         * MDVEFADMParser} to ensure that an unified list of {@link mng-model.object:MDVDeparture
         * MDVDepartures} is returned in the response object.
         */
        function searchDepartures(location, options) {
            return request(location, options)
                .then(function(response) {
                    return MDVEFADMParser.parseDepartures(response);
                });
        }

        /**
         * @public
         * @ngdoc method
         * @name searchArrivals
         * @methodOf mng-comm.itd.json.service:MDVEFADM
         * @param {MDVLocation} location {@link mng-model.object:MDVLocation MDVLocation} object
         * the arrivals should be searched for
         * @param {Object} options Additional options for the arrival search, like date or time.
         * Please note that dateTime.isDeparture is overridden with false and has no effect.
         * @param {MDVLocation[]} options.destinations List of destinations that should be used as
         * filter. Only departures that pass this destination will be returned.
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVArrival MDVArrivals}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVArrivals MDVArrivals} service. It triggers a
         * XML_DM_REQUEST with the given location (and a default option {'itdDateTimeDepArr':'arr'})
         * and passes the response to the {@link mng-comm.itd.json.service:MDVEFADMParser
         * MDVEFADMParser} to ensure that a unified list of {@link mng-model.object:MDVArrival
         * MDVArrivals} is returned in the response object.
         */
        function searchArrivals(location, options) {
            return request(location, options)
                .then(function(response) {
                    return MDVEFADMParser.parseArrivals(response);
                });
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_DM_REQUEST?',
                defaultParams : {},
                grouped : {},
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.parseDestinationStops = function(efa_opts) {
            var i, l,
                dests = [],
                globalDests = [];

            for (i = 0, l = efa_opts.destinationStops.length; i < l; i += 1) {
                if (efa_opts.destinationStops[i] instanceof MDVLocation) {
                    dests.push(efa_opts.destinationStops[i].id());
                } else {
                    log.warn('invalid destination option skipped:');
                    log.warn(efa_opts.destinationStops[i], true);
                }
            }
            if (dests.length) {
                efa_opts.destStopFilter = dests;
            }
            if (globalDests.length) {
                efa_opts.destGlobalStopFilter = globalDests;
            }

            return efa_opts;
        };

        _private.parseDestinationLocalities = function(efa_opts) {
            var i, l,
                dests = [];

            for (i = 0, l = efa_opts.destinationLocalities.length; i < l; i += 1) {
                if (efa_opts.destinationLocalities[i] instanceof MDVLocation) {
                    dests.push(efa_opts.destinationLocalities[i].id());
                } else {
                    log.warn('invalid destination option skipped:');
                    log.warn(efa_opts.destinationLocalities[i], true);
                }
            }
            if (dests.length) {
                efa_opts.destLocalityFilter = dests;
            }

            return efa_opts;
        };
    //    /**
    //    * Fire the DM request for a specific {@link mng-model.object:MDVLocation
    //    * MDVLocationId}
    //    */
        function request(location, options) {
            var id = location.id(),
                efa_opts = MDVEFAOptionsParser.parse(options);

            efa_opts.name_dm = id;
            efa_opts.version = _private.version;

            if (options.destinationStops && options.destinationStops.constructor === Array) {
                efa_opts = _private.parseDestinationStops(efa_opts);
            }
            if (options.destinationLocalities && options.destinationLocalities.constructor === Array) {
                efa_opts = _private.parseDestinationLocalities(efa_opts);
            }
            if (options.destinationPrevious) {
                efa_opts.routeFilterPrevious = true;
            }

            return dmRequester.request(efa_opts);
        }

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                dm._private = _private;
            }
        });

        // create customized requester object
        dmRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFADM',
            _private.getDefaultConfigOption());

        return dm;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFACoordParser
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-comm.itd.json.service:MDVTransportationParser
     * @requires mng-model.object:MDVDeparture
     * @requires mng-model.object:MDVArrival
     * @requires mng-model.object:MDVLocation
     * @description
     *
     * Parse a given coord response object provided in an EFA and parse it to a list of {@link
     * mng-model.object:MDVLocation MDVLocations}.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFACoordParser', MDVEFACoordParser);

    MDVEFACoordParser.$inject = ['moment', 'mng-util.MDVLog',
        'mng-comm.itd.json.MDVLocationParser'];

    function MDVEFACoordParser(moment, MDVLog, MDVLocationParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFACoordParser'),
            cp = {
                parse : parse
            };

        log.debug('initialize');

        function isInvalidResponse(response) {
            return !response || !response.locations;
        }
        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.json.service:MDVEFACoordParser
         * @param {Object} response the efa response object
         * @returns {Object} normalized information object
         *
         * @description
         * convert a given set of infos to a list of normalized information objects
         */
        function parse(response) {
            var location_list = [],
                i,
                l;

            if (isInvalidResponse(response)) {
                return location_list;
            }

            for (i = 0, l = response.locations.length; i < l; i += 1) {
                location_list.push(MDVLocationParser.parse(response.locations[i], 'coord'));
            }
            return location_list;
        }
        return cp;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFACoord
     * @requires mng-util.service:MDVLog
     * @requires mng-config.service:MDVConfig
     * @requires mng-comm.itd.json.service:MDVEFARequester
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-comm.itd.json.service:MDVEFACoordParser
     * @description
     *
     * Main Service to get lists of {@link mng-model.object:MDVLocation MDVLocation} that are
     * within a specific geographical region.
     *
     * This service registers a {@link mng-comm.itd.service:MDVEFARequester MDVEFARequest} for
     * COORD-purposes. This requester is used whenever the search method is called.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd-xmljson.MDVEFACoord`.
     *
     * As the `MDVEFACoord` service does not support any special parameters, please refer
     * to the {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester} service for detailed a
     * configuration description.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFACoord', MDVEFACoord);

    MDVEFACoord.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFARequester', 'mng-comm.itd.MDVEFAFormatter',
        'mng-comm.itd.json.MDVEFACoordParser'];

    function MDVEFACoord(MDVLog, MDVUtil, MDVConfig, MDVEFARequester, MDVEFAFormatter,
            MDVEFACoordParser) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFACoord',
                version : '10.2.10.139',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            coordRequester,
            info = {
                searchByRadius : searchByRadius,
                searchByBoundingBox : searchByBoundingBox
            };

        log.debug('initialize');

        /**
         * @public
         * @ngdoc method
         * @name searchByRadius
         * @methodOf mng-comm.itd.json.service:MDVEFACoord
         * @param {Number[]} latlng Coordinate
         * @param {Number} radius Radius in meter that describes a circle around the coordinate.
         * @param {Object} options additional options that should be used for this search only
         * @param {String[]} options.types List of types that should be requested.
         * available types: 'platform', 'stop', 'poi' (points of interest), 'aoi' (areas of
         * interest), 'gis_area' (areas in GIS data), 'gis_point' (points in GIS data)         *
         * @param {String=} options.coordFormat format-code the given coordinate is passed with. If
         * no coordFormat is passed, the plugin assumes that the coordinate format is EPSG:4326
         * (WGS84).
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVLocation MDVLocations}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVLocationRequester MDVLocationRequester} service. It triggers a
         * XML_COORDINFO_REQUEST with the given input and passes the response to the {@link
         * mng-comm.itd.json.service:MDVEFACoordParser MDVEFACoordParser} to ensure
         * that a unified list of {@link mng-model.object:MDVLocation MDVLocations} is returned in
         * the response object.
         */
        function searchByRadius(latlng, radius, options) {
            return _private.search(latlng, radius, options);
        }

        /**
         * @public
         * @ngdoc method
         * @name searchByBoundingBox
         * @methodOf mng-comm.itd.json.service:MDVEFACoord
         * @param {Number[]} latlng1 Coordinate
         * @param {Number[]} latlng2 another coordinate that describes the bounding box.
         * @param {Object} options additional options that should be used for this search only
         * @param {Object} options.parameters additional key-value parameters that should be sent to
         * the backend.
         * @param {String[]} options.types List of types that should be requested.
         * available types: 'platform', 'stop', 'poi' (points of interest), 'aoi' (areas of
         * interest), 'gis_area' (areas in GIS data), 'gis_point' (points in GIS data)         *
         * @param {String=} options.coordFormat format-code the given coordinate is passed with. If
         * no coordFormat is passed, the plugin assumes that the coordinate format is EPSG:4326
         * (WGS84).
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVLocation MDVLocations}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVLocationRequester MDVLocationRequester} service. It triggers a
         * XML_COORDINFO_REQUEST with the given input and passes the response to the {@link
         * mng-comm.itd.json.service:MDVEFACoordParser MDVEFACoordParser} to ensure
         * that a unified list of {@link mng-model.object:MDVLocation MDVLocations} is returned in
         * the response object.
         */
        function searchByBoundingBox(latlng1, latlng2, options) {
            return _private.search(latlng1, latlng2, options);
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_COORD_REQUEST?',
                defaultParams : {},
                cache : true
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.reject_xhr = function(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        };

        _private.parseType = function(type) {
            var efaTranslationMap = {
                // coordinfo properties
                'stop' : 'STOP',
                'platform' : 'BUS_POINT',
                'poi' : 'POI_POINT',
                'aoi' : 'POI_AREA',
                'callabike' : 'CALL_A_BIKE',
                'gis_area' : 'GIS_AREA',
                'gis_point' : 'GIS_POINT'
            };

            if (!type || !efaTranslationMap.hasOwnProperty(type)) {
                log.warn('unable to map type for coord-request. Received "' + type + '", expected' +
                    ' "stop", "platform", "poi", "aoi", "callabike", "gis_area" or "gis_point".');
                return null;
            }
            return efaTranslationMap[type];
        };

        _private.addTypeParams = function(params, options, radius) {
            var i,
                l,
                curr_type,
                type_options,
                curr_index = 1,
                types = options.types;

            // activate filter for types
            params.inclFilter = 1;

            for (i = 0, l = types.length; i < l; i += 1) {
                curr_type = _private.parseType(types[i]);
                if (options.hasOwnProperty(types[i])) {
                    type_options = options[types[i]];
                } else {
                    type_options = {};
                }

                if (curr_type) {
                    params['type_' + curr_index] = curr_type;
                    if (radius) {
                        params['radius_' + curr_index] = radius;
                    }

                    if (type_options.filters && type_options.filters.include) {
                        params['inclDrawClasses_' + curr_index] = type_options.filters.include;
                    }
                    if (type_options.filters && type_options.filters.exclude) {
                        params['exclLayers_' + curr_index] = type_options.filters.exclude;
                    }

                    curr_index += 1;
                }
            }
            return params;
        };

        _private.getSearchParams = function(latLng, radius, options) {
            var params = MDVUtil.copy(options.efaParams || {}),
                coord1 = MDVEFAFormatter.latlng2string(latLng, options.coordFormat),
                coord2 = MDVEFAFormatter.latlng2string(radius, options.coordFormat);

            if (coord2 === '') {
                // request radius
                params.coord = coord1;
                params = _private.addTypeParams(params, options, radius);
            } else {
                // request bounds
                params.boundingBox = 1;
                params.boundingBoxLU = coord1;
                params.boundingBoxRL = coord2;
                params = _private.addTypeParams(params, options);
            }

            params.version = _private.version;

            return params;
        };

        _private.search = function(latLng, radius, options) {
            if (_private.running_xhr) {
                _private.reject_xhr(_private.running_xhr);
            }
            if (!options) {
                options = {};
            }
            if (!options.types || options.types.length === 0) {
                options.types = ['stop'];
            }
            var params = _private.getSearchParams(latLng, radius, options);

            _private.running_xhr = coordRequester.request(params)
                .then(function(response) {
                    _private.running_xhr = null;
                    return MDVEFACoordParser.parse(response);
                });
            return _private.running_xhr;
        };

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                info._private = _private;
            }
        });

        // create customized requester object
        coordRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFACoord',
            _private.getDefaultConfigOption());

        return info;
    }
}());

(function() {
    'use strict';


    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAAstParser', MDVEFAAstParser);

    MDVEFAAstParser.$inject = ['mng-util.MDVLog', 'mng-comm.itd.json.MDVEFATripParser',
            'mng-comm.itd.json.MDVJourneyLegParser'];

    function MDVEFAAstParser(MDVLog, MDVEFATripParser, MDVJourneyLegParser) {
        var log = MDVLog.register('mng-comm.itd.json.MDVEFAAstParser'),
            mrp = {
                parseAvailabilityResponse : parseAvailabilityResponse,
                parseUpdateResponse : parseUpdateResponse
            };

        log.debug('initialize');

        // ////////////////////////////////

        function parseAvailabilityResponse(response) {
            if (!response || !response.trip) {
                return response;
            }
            var toParse = {
                    journeys : [response.trip]
                },
                parsed = MDVEFATripParser.parse(toParse).trips;

            return parsed;
        }

        function parseUpdateResponse(response) {
            if (!response || !response.legs) {
                return response;
            }

            var toParse = [response.legs],
                parsed = MDVJourneyLegParser.parse([response.legs], 0);


            return parsed;
        }

        return mrp;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAAst', MDVEFAAst);

    MDVEFAAst.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-comm.itd.MDVEFARequester',
        'mng-util.MDVUtil', 'mng-util.MDVException', 'mng-comm.itd.json.MDVEFAAstParser'];

    function MDVEFAAst(MDVLog, MDVConfig, MDVEFARequester, MDVUtil, MDVException, MDVEFAAstParser) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFAAst',
                version : '10.2.10.139',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            astRequester,
            ast = {
                checkAvailability : checkAvailability,
                book : book,
                cancel : cancel,
                update : update
            };

        log.debug('initialize');

        // ////////////////////////////////


        function update(reservationCode, options) {
            if (_private.running_xhr) {
                _private.reject_xhr(_private.running_xhr);
            }

            var reasons = _private.isUpdateReady(reservationCode),
                postObj;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            postObj = _private.getUpdatePostObj(reservationCode);

            _private.running_xhr = astRequester.request(postObj)
                .then(function(response) {
                    if (!response || !response.updateResponse) {
                        throw new MDVException(MDVException.keys.MNG_COMM_ITD_JSON__AST.SERVICE_FAILED, {
                            options : reservationCode,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;
                    return MDVEFAAstParser.parseUpdateResponse(response.updateResponse);
                });

            return _private.running_xhr;
        }

        function cancel(reservationCode, options) {
            if (_private.running_xhr) {
                _private.reject_xhr(_private.running_xhr);
            }

            var reasons = _private.isCancelReady(reservationCode),
                postObj;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            postObj = _private.getCancelPostObj(reservationCode);

            _private.running_xhr = astRequester.request(postObj)
                .then(function(response) {
                    if (!response || !response.cancelationResponse) {
                        throw new MDVException(MDVException.keys.MNG_COMM_ITD_JSON__AST.SERVICE_FAILED, {
                            options : reservationCode,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;
                    return response;
                });

            return _private.running_xhr;
        }

        function book(reservationCode, options) {
            if (_private.running_xhr) {
                _private.reject_xhr(_private.running_xhr);
            }

            var reasons = _private.isBookReady(reservationCode),
                postObj;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            postObj = _private.getBookPostObj(reservationCode);

            _private.running_xhr = astRequester.request(postObj)
                .then(function(response) {
                    if (!response || !response.bookingReservationResponse) {
                        throw new MDVException(MDVException.keys.MNG_COMM_ITD_JSON__AST.SERVICE_FAILED, {
                            options : reservationCode,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;
                    return response;
                });

            return _private.running_xhr;
        }

        function checkAvailability(journey, options) {
            if (_private.running_xhr) {
                _private.reject_xhr(_private.running_xhr);
            }

            var reasons = _private.isCheckAvailabilityReady(journey, options),
                postObj;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }

            postObj = _private.getAvailabilityPostObj(journey, options.user);

            _private.running_xhr = astRequester.request(postObj)
                .then(function(response) {
                    if (!response || !response.availabilityResponse || response.availabilityResponse.errorMessage) {
                        throw new MDVException(MDVException.keys.MNG_COMM__AST.SERVICE_FAILED, {
                            options : options,
                            response : response,
                            service : _private.namespace,
                            reason : 'no results'
                        });
                    }
                    _private.running_xhr = null;

                    return MDVEFAAstParser.parseAvailabilityResponse(response.availabilityResponse);
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.reject_xhr = function(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        };

        _private.getBookPostObj = function(reservationCode) {
            var obj = {
                bookingReservationRequest : {
                    reservationDetails : {
                        reservationCode : reservationCode
                    }
                }
            };
            return obj;
        };

        _private.getCancelPostObj = function(reservationCode) {
            var obj = {
                cancelationRequest : {
                    reservationDetails : {
                        reservationCode : reservationCode
                    }
                }
            };

            return obj;
        };

        _private.getUpdatePostObj = function(reservationCode) {
            var obj = {
                updateRequest : {
                    reservationDetails : {
                        reservationCode : reservationCode
                    }
                }
            };
            return obj;
        };

        _private.getAvailabilityPostObj = function(journey, user) {
            var userInfos = [],
                userInfo,
                i, l;

            for (i=0, l=user.PassengerNumber; i<l; i += 1) {
                userInfo = {
                    wheelchair : (user.WheelChairNumber>i),
                    walkingFrame : false,
                    walkingStick : false,
                    walkingImpaired : false,
                    pram : false,
                    visuallyImpaired : false,
                    hearingImpaired : false,
                    bikeTransport : false,
                    readingImpaired : false,
                    boardingAssistance : false,
                    alightingAssistance : false
                };

                userInfos.push(userInfo);
            }

            var obj = {
                availabilityRequest : {
                    trip : journey.raw(),
                    userInfo : userInfos,
                    minMaxTimeBandGroup : {
                        earliestDepartureTime : _private.getEarliestDepartureTime(journey),
                        latestArrivalTime : _private.getLatestArrivalTime(journey)
                    },
                    customerDetail : {
                        userRef : user.ID,
                        systemRef : 'MENTZ',
                        name : ((user.LastName)?user.LastName:'') + ((user.FirstName)?', '+user.FirstName:''),
                        mobilePhone : user.Phone,
                        emailAddress : user.Email,
                        source : user.source
                    }
                }
            };

            return obj;
        };


        _private.getEarliestDepartureTime = function(journey) {
            var astIdx = -1,
                astLeg,
                i, l;

            for (i=0, l=journey.legs().length; i<l; i += 1) {
                if (journey.legs()[i].isAstTransportation()) {
                    astIdx = i;
                    astLeg = journey.legs()[i];
                }
            }

            for (i=0, l=astIdx; i<l; i += 1) {
                if (journey.legs()[i].isPublicTransportation()) {
                    return astLeg.departureTime().toDate();
                }
            }

            return astLeg.departureTime().add(-5, 'minutes')
                .toDate();
        };

        _private.getLatestArrivalTime = function(journey) {
            var astIdx = -1,
                astLeg,
                i, l;

            for (i=0, l=journey.legs().length; i<l; i += 1) {
                if (journey.legs()[i].isAstTransportation()) {
                    astIdx = i;
                    astLeg = journey.legs()[i];
                }
            }

            for (i=astIdx+1, l=journey.legs().length; i<l; i += 1) {
                if (journey.legs()[i].isPublicTransportation()) {
                    return astLeg.arrivalTime().toDate();
                }
            }

            return astLeg.arrivalTime().add(5, 'minutes')
                .toDate();
        };

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/AST?',
                defaultParams : {},
                cache : false,
                requestType : 'post'
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.isCheckAvailabilityReady = function(journey, options) {
            var reasons = [];

            if (!journey || !options || !options.user || !options.user.ID) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM_ITD_JSON__AST.INVALID_INPUT, {
                    reason : 'journey missing'
                }));
            }

            return reasons;
        };

        _private.isBookReady = function(reservationCode) {
            var reasons = [];

            if (!reservationCode) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM_ITD_JSON__AST.INVALID_INPUT, {
                    reason : 'reservationCode missing'
                }));
            }

            return reasons;
        };

        _private.isCancelReady = function(reservationCode) {
            var reasons = [];

            if (!reservationCode) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM_ITD_JSON__AST.INVALID_INPUT, {
                    reason : 'reservationCode missing'
                }));
            }

            return reasons;
        };

        _private.isUpdateReady = function(reservationCode) {
            var reasons = [];

            if (!reservationCode) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM_ITD_JSON__AST.INVALID_INPUT, {
                    reason : 'reservationCode missing'
                }));
            }

            return reasons;
        };


        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                ast._private = _private;
            }
        });

        // create customized requester object
        astRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFAAst',
            _private.getDefaultConfigOption());

        return ast;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFAAddInfoParser
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-comm.itd.json.service:MDVTransportationParser
     * @requires mng-model.object:MDVDeparture
     * @requires mng-model.object:MDVArrival
     * @requires mng-model.object:MDVLocation
     * @description
     *
     * Parse a given departure object provided in an EFA response
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAAddInfoParser', MDVEFAAddInfoParser);

    MDVEFAAddInfoParser.$inject = ['moment', 'mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.itd.MDVEFAFormatter', 'mng-comm.itd.json.MDVLocationParser',
        'mng-comm.itd.json.MDVTransportationParser', 'mng-model.MDVMessage'];

    function MDVEFAAddInfoParser(moment, MDVLog, MDVConfig, MDVEFAFormatter, MDVLocationParser,
            MDVTransportationParser, MDVMessage) {
        var log = MDVLog.register('mng-comm-itd-json.MDVEFAAddInfoParser'),
            ip = {
                parse : parse
            },
            _private = {};

        log.debug('initialize');

        MDVConfig.ready(function() {
            if (MDVConfig.getValue('mng-comm-itd-json.MDVEFAAddInfo.parser.privateMode')) {
                ip._private = _private;
            }
        });

        // ////////////////////////////////

        _private.getTime = function(isoString) {
            var time = moment(isoString);

            if (time.isValid()) {
                return time;
            }
            return null;
        };

        _private.handleValidity = function(info, efaInfo) {
            var i,
                l,
                curr_elem;

            if (efaInfo.timestamps.validity) {
                info.timestamps.validity = [];
                for (i = 0, l = efaInfo.timestamps.validity.length; i < l; i += 1) {
                    curr_elem = efaInfo.timestamps.validity[i];
                    if (curr_elem && curr_elem.to && curr_elem.from) {
                        info.timestamps.validity.push({
                            from : _private.getTime(curr_elem.from),
                            to : _private.getTime(curr_elem.to)
                        });
                    }
                }
            }
            return info;
        };

        _private.handlePublication = function(info, efaInfo) {
            // change availability to array structure like validity whenever efa does not provide it
            // as array
            if (efaInfo.timestamps.availability && efaInfo.timestamps.availability.from &&
                    efaInfo.timestamps.availability.to) {
                info.timestamps.availability = [{
                    from : _private.getTime(efaInfo.timestamps.availability.from),
                    to : _private.getTime(efaInfo.timestamps.availability.to)
                }];
            }
            return info;
        };

        _private.parseTimestamps = function(info, efaInfo) {
            if (!info.properties.hasOwnProperty('timestamps')) {
                info.timestamps = {};
            }

            if (efaInfo.timestamps.creation) {
                info.timestamps.creation = _private.getTime(efaInfo.timestamps.creation);
            }
            if (efaInfo.timestamps.expiration) {
                info.timestamps.expiration = _private.getTime(efaInfo.expiration);
            }
            if (efaInfo.timestamps.lastModification) {
                info.timestamps.lastModification = _private.getTime(efaInfo.timestamps.lastModification);
            }
            info = _private.handlePublication(info, efaInfo);
            info = _private.handleValidity(info, efaInfo);
            return info;
        };

        _private.getAffectedLines = function(efaInfo) {
            var i,
                l,
                curr_elem,
                parsed,
                lines = [];

            if (efaInfo.affected && efaInfo.affected.lines && efaInfo.affected.lines.length > 0) {
                for (i = 0, l = efaInfo.affected.lines.length; i < l; i += 1) {
                    curr_elem = efaInfo.affected.lines[i];
                    parsed = MDVTransportationParser.parse(curr_elem);
                    if (parsed) {
                        lines.push(parsed);
                    }
                }
            }
            return lines;
        };

        _private.getAffectedStops = function(efaInfo) {
            var i,
                l,
                curr_elem,
                parsed,
                stops = [];

            if (efaInfo.affected && efaInfo.affected.stops && efaInfo.affected.stops.length > 0) {
                for (i = 0, l = efaInfo.affected.stops.length; i < l; i += 1) {
                    curr_elem = efaInfo.affected.stops[i];
                    parsed = MDVLocationParser.parse(curr_elem);
                    if (parsed) {
                        stops.push(parsed);
                    }
                }
            }
            return stops;
        };


        _private.parseInfo = function(efaInfo) {
            if (!efaInfo) {
                return null;
            }

            var info = {
                id : efaInfo.id,
                version : efaInfo.version.toString(),
                type : efaInfo.type,
                priority : efaInfo.priority || 'unknown',
                title : efaInfo.title || efaInfo.subject,
                subtitle : efaInfo.subtitle,
                content : efaInfo.content,
                text : efaInfo.additionalText,
                url : efaInfo.url,
                urlText : efaInfo.urlText,
                properties : efaInfo.properties || {},
                affectedElements : {
                    lines : _private.getAffectedLines(efaInfo),
                    stops : _private.getAffectedStops(efaInfo)
                },
                raw : efaInfo
            };

            if (efaInfo.hasOwnProperty('stopIDglobalID')) {
                info.properties.stopPlatformMap =
                                        MDVEFAFormatter.getStopGlobalMap(efaInfo.stopIDglobalID);
            }

            info = _private.parseTimestamps(info, efaInfo);

            return new MDVMessage(info);
        };

        _private.isInvalidResponse = function(response) {
            return !response || !response.infos ||
                !response.infos.current;
        };

        _private.getTimestamp = function(response) {
            if (!response || !response.timestamp) {
                return null;
            }
            return _private.getTime(response.timestamp);
        };

        /**
         * @public
         * @ngdoc method
         * @name parse
         * @methodOf mng-comm.itd.json.service:MDVEFAAddInfoParser
         * @param {Object} response the efa 'info' object
         * @returns {Object} normalized information object
         *
         * @description
         * convert a given set of infos to a list of normalized information objects
         */
        function parse(response) {
            var parsed_infos = [],
                efaInfos,
                curr,
                i,
                l;

            if (_private.isInvalidResponse(response)) {
                return {
                    timestamp : _private.getTimestamp(response),
                    infos : parsed_infos
                };
            }
            efaInfos = response.infos.current;

            for (i = 0, l = efaInfos.length; i < l; i += 1) {
                curr = _private.parseInfo(efaInfos[i]);
                if (curr) {
                    parsed_infos.push(curr);
                }
            }
            return {
                infos : parsed_infos,
                timestamp : _private.getTimestamp(response)
            };
        }
        return ip;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFAAddInfo
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.json.service:MDVEFARequester
     * @requires mng-comm.itd.json.service:MDVEFADMParser
     * @requires mng-comm.itd.json.service:MDVEFAOptionsParser
     * @description
     *
     * Main Service to get lists of departures/arrivals or a list of serving lines for a specific stop.
     *
     * This service registers a {@link mng-comm.itd.service:MDVEFARequester MDVEFARequest} for
     * DM-purposes. This requester is used whenever the search method is called.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd-xmljson.MDVEFADM`.
     *
     * As the `MDVEFADM` service does not support any special parameters, please refer
     * to the {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester} service for detailed a
     * configuration description.
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAAddInfo', MDVEFAAddInfo);

    MDVEFAAddInfo.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-comm.itd.MDVEFARequester',
        'mng-comm.itd.json.MDVEFAAddInfoParser', 'mng-comm.itd.MDVEFAOptionsParser'];


    function MDVEFAAddInfo(MDVLog, MDVConfig, MDVEFARequester, MDVEFAAddInfoParser, MDVEFAOptionsParser) {
        var _private = {
                namespace : 'mng-comm-itd-json.MDVEFAAddInfo',
                version : '10.2.10.139',
                running_xhr : null
            },
            log = MDVLog.register(_private.namespace),
            infoRequester,
            info = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name search
         * @methodOf mng-comm.itd.json.service:MDVEFAAddInfo
         * @param {Object} options additional options for the search
         * @param {Object} options.parameters additional key-value parameters that should be sent to
         * the backend.
         * @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mng-model.object:MDVLocation MDVLocations}
         *
         * @description
         * This method implements the interface that is needed to be used by the {@link
         * mng-comm.service:MDVLocationRequester MDVLocationRequester} service. It triggers a
         * XML_STOPFINDER_REQUEST with the given input and passes the response to the {@link
         * mng-comm.itd.json.service:MDVEFAStopfinderParser MDVEFAStopfinderParser} to ensure
         * that a unified list of {@link mng-model.object:MDVLocation MDVLocations} is returned in
         * the response object.
         */
        function search(options) {
            if (_private.running_xhr) {
                _private.reject_xhr(_private.running_xhr);
            }
            var params = MDVEFAOptionsParser.parse(options);
            // var params = options && options.parameters;
            // if (!params) {
            //     params = {};
            // }
            // params = addSearchParams(params);

            params.version = _private.version;

            _private.running_xhr = infoRequester.request(params)
                .then(function(response) {
                    _private.running_xhr = null;
                    var result = MDVEFAAddInfoParser.parse(response);

                    // addToCache(result);
                    return result;
                });
            return _private.running_xhr;
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                url : '/XML_ADDINFO_REQUEST?',
                defaultParams : {},
                cache : true
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

    //    /**
    //     * @private
    //     * @ngdoc method
    //     * @name reject_xhr
    //     * @methodOf mng-comm.itd.json.service:MDVEFAAddInfo
    //     * @param {xhr} xhr Xhr that should be rejected.
    //     *
    //     * @description
    //     * reject a given xhr and broadcast a 'COM.NEW_REQUEST'-Event
    //     */
        _private.reject_xhr = function(xhr) {
            if (xhr &&
                    xhr._httpTimeout &&
                    xhr._httpTimeout.resolve) {
                xhr._httpTimeout.resolve();
            }
        };

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode')) {
                info._private = _private;
            }
        });

        infoRequester = new MDVEFARequester('mng-comm-itd-json', 'MDVEFAAddInfo',
            _private.getDefaultConfigOption());

        return info;
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc overview
     * @name mng-comm
     * @module mng-comm
     * @requires mng-config
     * @requires mng-model
     * @requires mng-util
     *
     * @description
     * # mng-comm (main communication module)
     * This module describes an abstract interface to all back-end
     * communication. It offers a unique interface that combines all different back-end request
     * services and cares about caching.
     *
     * ## General usage
     * ```js
     * // inject mng-comm - components only
     * angular.module('your.module', ['mng-comm']);
     * ```
     *
     * ## Services
     * The following list gives a short overview of the available components within this module.
     * For further details, please refer to the components themselves. The services are split up in
     * requester services and requester factories. Whereas the requester services provide an active
     * communication with the backend services (via subservices), the requester factories provide
     * interaction with the backend services in a more abstract way, providing two way data binding.
     *
     * ### Requester services
     * Requester services describe an abstract service layer, that provide a search method to
     * actively trigger specifc requests.
     *
     * #### {@link mng-comm.service:MDVMessageRequester MDVMessageRequester}
     * The `MDVMessageRequester` service is a basic MDV service that provides a list of
     * {@link mng-model.object:MDVMessage MDVMessages}.
     *
     * #### {@link mng-comm.service:MDVLocationRequester MDVLocationRequester}
     * The `MDVLocationRequester` service is a basic MDV service that provides a list of
     * {@link mng-model.object:MDVLocation MDVLocation} - suggestions for a given input name.
     *
     * #### {@link mng-comm.service:MDVTransportationRequester MDVTransportationRequester}
     * The `MDVTransportationRequester` service is a basic MDV service that provides a list of
     * {@link mng-model.object:MDVTransportation MDVTransportations} - suggestions for a given
     * stop point or input name.
     *
     * #### {@link mng-comm.service:MDVDepartureRequester MDVDepartureRequester}
     * The `MDVDepartureRequester` service is a basic MDV service that provides a list of
     * {@link mng-model.object:MDVDeparture MDVDepartures} for a given {@link
     * mng-model.object:MDVLocation MDVLocation}.
     *
     * #### {@link mng-comm.service:MDVJourneyRequester MDVJourneyRequester}
     * The `MDVJourneyRequester` service is a basic MDV service that provides a list of
     * {@link mng-model.object:MDVJourney MDVJourneys} for a given {@link
     * mng-model.object:MDVLocation origin} and {@link mng-model.object:MDVLocation destination}.
     *
     * ### Requester factories
     * The following factories provide a more abstract usage of the backend services. These
     * factories use the requester services and build up more logic to provide two way data binding.
     *
     * #### {@link mng-comm.object:MDVDepartures MDVDepartures}
     * The `MDVDepartures` service provides a list of {@link mng-model.object:MDVDeparture
     * MDVDepartures} for a specific stop {@link mng-model.object:MDVLocation location}.
     *
     * #### {@link mng-comm.object:MDVArrivals MDVArrivals}
     * The `MDVArrivals` service provides a list of {@link mng-model.object:MDVArrival
     * MDVArrivals} for a specific stop {@link mng-model.object:MDVLocation location}.
     *
     * #### {@link mng-comm.object:MDVJourneys MDVJourneys}
     * The `MDVJourneys` service is a basic MDV service that provides a list of
     * {@link mng-model.object:MDVJourney MDVJourneys} for a specific setting including
     * {@link mng-model.object:MDVLocation origin and destination} and a specific departure/ arrival
     * time.
     *
     * #### {@link mng-comm.service:MDVJourneyList MDVJourneyList}
     * The `MDVJourneyList` service provides a set of {@link mng-comm.object:MDVJourneys
     * MDVJourneys} that describe the same journey, but with different forced settings that cannot
     * be changed by the user.
     *
     */
    angular.module('mng-comm', ['mng-config', 'mng-model', 'mng-util']);
}());

(function() {
    'use strict';

    angular.module('mng-comm')
        .factory('mng-comm.MDVTripStopTimesRequester', MDVTripStopTimesRequester);

        MDVTripStopTimesRequester.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil', 'mng-config.MDVConfig',
        'mng-comm.MDVUtil', 'mng-util.MDVException'];

    function MDVTripStopTimesRequester(MDVLog, MDVUtil, MDVConfig, MDVCommUtil, MDVException) {
        var _private = {
                namespace : 'mng-comm.MDVTripStopTimesRequester',
                options : {},
                lastUpdate : null
            },
            log = MDVLog.register(_private.namespace),
            tripStopTimes = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        
        function search(transportation, options) {
            var tmp_obj = MDVUtil.copy(_private.options);
            
            if (!MDVConfig.isReady()) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'Configuration has not yet loaded correctly. Cannot start ' +
                            'requests without a valid configuration.'
                    }));
            }

            return _private.request.call(this, transportation, MDVCommUtil.mergeObjects(tmp_obj, options));
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                subservices : ['mng-comm.itd.json.MDVEFATripStopTimes']
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.isValidSubservice = function(subservice) {
            return subservice.hasOwnProperty('search');
        };

        _private.getSubserviceConfig = function() {
            return _private.getConfigOption('subservices');
        };

        _private.request = function(transportation, options, prio) {
            var subservices = _private.getSubserviceConfig(),
                subservice;
            
            subservice = MDVCommUtil.getSubservice(subservices, prio,
                           _private.isValidSubservice.bind(this), MDVException.keys.MNG_COMM__INFO);

            return subservice.search(transportation, MDVUtil.copy(options))
                .then(function(response) {
                    if (!response) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__LS.SERVICE_FAILED, {
                            args : [options],
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }

                    return _private.modifyResponse(response, [options]);
                })
                .catch(function() {
                    // resend request with lower priority
                    return _private.request(options, prio ? prio + 1 : 1);
                });
        };

        _private.modifyResponse = function(resultObj, arglist) {
            _private.lastUpdate = resultObj.timestamp;

            return {
                timestamp : _private.lastUpdate,
                response : resultObj,
                input : arglist
            };
        };

        // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
        // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                info._private = _private;
            }
        });

        return tripStopTimes;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm')
        .factory('mng-comm.MDVTripCompositionRequester', MDVTripCompositionRequester);

        MDVTripCompositionRequester.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-util.MDVException', 'mng-config.MDVConfig', 'mng-comm.MDVUtil'];

    function MDVTripCompositionRequester(MDVLog, MDVUtil, MDVException, MDVConfig,
        MDVCommUtil) {

        var _private = {
                namespace : 'mng-comm.MDVTripCompositionRequester',
                options : {}
            },
            log = MDVLog.register(_private.namespace),
            tr = {
                isReady : isReady,
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function isReady(options) {
            var reasons = [];

            if (!MDVConfig.isReady()) {
                reasons.push(new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                    reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                        'without a valid configuration.'
                }));
            }

            if (options) {
                // console.log('check validity of all options');
                // console.log('create the interface of the options objects'); // compare with interchnage Requester service
            }

            if (!options) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__TRIPCOMPOSITION.NO_OPTIONS, {
                    reason : 'Missing request options'
                }));
            }
            return reasons;
        }


        function search(options) {
            var reasons = isReady(options);

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }
            return _private.request.call(this, options);
        }

        _private.modifyResponse = function(response, arglist) {
            return {
                input : arglist,
                response : response
            };
        };

        _private.getDefaultConfigOption = function(key) {
            switch (key) {
            case 'subservices' :
                return ['mng-comm.itd.json.MDVEFATripComposition'];
            case 'options' :
                return {};
            default :
                return null;
            }
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);
            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        _private.isValidSubservice = function(subservice) {
            console.log('subservice', subservice);
            return subservice.hasOwnProperty('search');
        };

        _private.getSubserviceConfig = function() {
            return _private.getConfigOption('subservices');
        };

        _private.request = function(options, prio) {
            console.log('prio', prio);
            var subservice;

            try {
                subservice = MDVCommUtil.getSubservice(_private.getSubserviceConfig(), prio, null,
                    MDVException.keys.MNG_COMM__TRIPCOMPOSITION);
            } catch (e) {
                if (prio) {
                    console.log('e', e);
                    throw e;
                }
                return MDVUtil.getRejectedDeferred(e);
            }

            return subservice.search(angular.copy(options))
                .then(function(response) {
                    // console.log('request search response', response);
                    if (!response) {
                        response = [];
                        //!!!! resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__TRIPCOMPOSITION.SERVICE_FAILED, {
                            args : [options],
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }
                    return _private.modifyResponse(response, [options]);
                })
                .catch(function(e) {
                    console.log('e', e);
                    // resend request with lower priority
                    // return _private.request(options, prio ? prio + 1 : 1);
                });
        };

        MDVConfig.ready(function() {
            _private.options = MDVCommUtil.gatherOptions(_private.getConfigOption('options'));
        });

        return tr;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.service:MDVStopSeqRequester
     *
     * @description
     * **Note:** *The `MDVStopSeqRequester` service is depreciated and will be removed soon. Use
     * {@linkmng-comm.service:MDVTransportationRequester MDVTransportationRequester} instead.*
     *
     */

    angular.module('mng-comm')
        .factory('mng-comm.MDVStopSeqRequester', MDVStopSeqRequester);


    MDVStopSeqRequester.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-util.MDVException', 'mng-config.MDVConfig', 'mng-comm.MDVUtil'];

    function MDVStopSeqRequester(MDVLog, MDVUtil, MDVException, MDVConfig, MDVCommUtil) {

        var _private = {
                namespace : 'mng-comm.MDVStopSeqRequester'
            },
            log = MDVLog.register(_private.namespace),
            tr = {
                isReady : isReady,
                search : search
            };

        log.warn('initialize');
        log.warn('The use of mng-comm.MDVStopSeqRequester is depreciated since version 1.0.0. Use ' +
            'mng-comm.MDVTransportationRequester.getStopSequence(location, options) instead. Mind ' +
            'the different parameter structure (transportation passed in options) than it is ' +
            'used with the search(location, transportation, options) call.');

        // ////////////////////////////////

        function isReady(transportation) {
            var reasons = [];

            if (!transportation || !transportation.id()) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__STOPSEQ.NO_INPUT, {
                    reason : 'Missing transportation'
                }));
            }


            return reasons;
        }


        function search(location, transportation, options) {
            var reasons = isReady(transportation),
                mergedOptions;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }
            mergedOptions = getMergedOptions(_private.options, options);

            return _private.request.call(this, location, transportation, mergedOptions);
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            switch (key) {
            case 'subservices' :
                return ['mng-comm.itd.json.MDVEFAStopSeqCoord'];
            case 'options':
                return {
                    dateTime : true
                };
            default :
                return null;
            }
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        function getMergedOptions(privateOptions, optionsObj) {
            return angular.extend({}, privateOptions, optionsObj, true);
        }


        _private.modifyResponse = function(response, arglist) {
            return {
                input : arglist,
                response : response
            };
        };


        _private.isValidSubservice = function(subservice) {
            return subservice.hasOwnProperty('search');
        };

        _private.getSubserviceConfig = function() {
            return _private.getConfigOption('subservices');
        };

        _private.request = function(location, transportation, options, prio) {
            var subservice;

            try {
                subservice = MDVCommUtil.getSubservice(_private.getSubserviceConfig(), prio, null,
                    MDVException.keys.MNG_COMM__STOPSEQ);
            } catch (e) {
                if (prio) {
                    throw e;
                }
                return MDVUtil.getRejectedDeferred(e);
            }
            // extra check as multiple subservice types are possible
            if (!_private.isValidSubservice(subservice)) {
                return _private.request(location, transportation, options, prio ? prio + 1 : 1);
            }

            return subservice.search(angular.copy(location), angular.copy(transportation),
                        MDVUtil.copy(options))
                .then(function(response) {
                    if (!response) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__STOPSEQ.SERVICE_FAILED, {
                            args : [location, transportation, options],
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }

                    return _private.modifyResponse(response, [location, transportation, options]);
                })
                .catch(function() {
                    // resend request with lower priority
                    return _private.request(location, transportation, options, prio ? prio + 1 : 1);
                });
        };


        MDVConfig.ready(function() {
            _private.options = MDVCommUtil.gatherOptions(_private.getConfigOption('options'));
        });

        return tr;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm')
        .factory('mng-comm.MDVParkObjectRequester', MDVParkObjectRequester);

    MDVParkObjectRequester.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil', 'mng-config.MDVConfig',
        'mng-comm.MDVUtil', 'mng-util.MDVException'];

    function MDVParkObjectRequester(MDVLog, MDVUtil, MDVConfig, MDVCommUtil, MDVException) {
        var _private = {
                namespace : 'mng-comm.MDVParkObjectRequester',
                options : {},
                lastUpdate : null
            },
            log = MDVLog.register(_private.namespace),
            info = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        
        function search(options) {
            var tmp_obj = MDVUtil.copy(_private.options);

            if (!MDVConfig.isReady()) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'Configuration has not yet loaded correctly. Cannot start ' +
                            'requests without a valid configuration.'
                    }));
            }

            return _private.request.call(this, MDVCommUtil.mergeObjects(tmp_obj, options));
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                subservices : ['mng-comm.itd.xmljson.MDVEFAParkObject']
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.isValidSubservice = function(subservice) {
            return subservice.hasOwnProperty('search');
        };

        _private.getSubserviceConfig = function() {
            return _private.getConfigOption('subservices');
        };

        _private.request = function(options, prio) {
            var subservices = _private.getSubserviceConfig(),
                subservice;

            subservice = MDVCommUtil.getSubservice(subservices, prio,
                           _private.isValidSubservice.bind(this), MDVException.keys.MNG_COMM__INFO);

            return subservice.search(MDVUtil.copy(options))
                .then(function(response) {
                    if (!response) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__LS.SERVICE_FAILED, {
                            args : [options],
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }

                    return _private.modifyResponse(response, [options]);
                })
                .catch(function() {
                    // resend request with lower priority
                    return _private.request(options, prio ? prio + 1 : 1);
                });
        };

        _private.modifyResponse = function(resultObj, arglist) {
            _private.lastUpdate = resultObj.timestamp;

            return {
                timestamp : _private.lastUpdate,
                response : resultObj,
                input : arglist
            };
        };

        // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
        // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                info._private = _private;
            }
        });

        return info;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm')
        .factory('mng-comm.MDVLivePositionsRequester', MDVLivePositionsRequester);

    MDVLivePositionsRequester.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-util.MDVException', 'mng-config.MDVConfig', 'mng-comm.MDVUtil',
        'mng-model.MDVTransportation'];

    function MDVLivePositionsRequester(MDVLog, MDVUtil, MDVException, MDVConfig,
        MDVCommUtil, MDVTransportation) {

        var _private = {
                namespace : 'mng-comm.MDVLivePositionsRequester',
                options : {}
            },
            log = MDVLog.register(_private.namespace),
            tr = {
                isReady : isReady,
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function isReady(inputa, inputb) {
            var i, l,
                reasons = [];

            if (!MDVConfig.isReady()) {
                reasons.push(new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                    reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                        'without a valid configuration.'
                }));
            }

            if (inputa && inputa.constructor === Array) {
                for (i=0, l=inputa.length; i<l; i+=1) {
                    if (!inputa[i] || !(inputa[i] instanceof MDVTransportation)) {
                        reasons.push(new MDVException(MDVException.keys.MNG_COMM__LIVE_POSITIONS.NO_INPUT, {
                            reason : 'Invalid Transportations array'
                        }));
                        return reasons;
                    }
                }
                return reasons;
            }

            if (inputa && inputa instanceof MDVTransportation) {
                return reasons;
            }

            if (!inputa || !inputb) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__LIVE_POSITIONS.NO_INPUT, {
                    reason : 'Missing coordinates'
                }));
            }

            if (!MDVUtil.isValidCoordinate(inputa) || !MDVUtil.isValidCoordinate(inputb)) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__LIVE_POSITIONS.INVALID_INPUT, {
                    reason : 'Invalid coordinates'
                }));
            }

            // datetime in past should be rejected, too

            return reasons;
        }


        function search(inputa, inputb, options) {
            var reasons = isReady(inputa, inputb),
                mergedOptions;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }
            mergedOptions = getMergedOptions(_private.options, options);

            return _private.request.call(this, inputa, inputb, mergedOptions);
        }

        // ////////////////////////////////

        function getMergedOptions(privateOptions, optionsObj) {
            return angular.extend({}, privateOptions, optionsObj, true);
        }

        _private.getDefaultConfigOption = function(key) {
            switch (key) {
            case 'subservices' :
                return ['mng-comm.itd.xmljson.MDVEFALivePositions'];
            case 'options' :
                return {};
            default :
                return null;
            }
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.modifyResponse = function(response, arglist) {
            return {
                input : arglist,
                response : response
            };
        };


        _private.isValidSubservice = function(subservice) {
            return subservice.hasOwnProperty('search');
        };

        _private.getSubserviceConfig = function() {
            return _private.getConfigOption('subservices');
        };

        _private.request = function(inputa, inputb, options, prio) {
            var subservice;

            try {
                subservice = MDVCommUtil.getSubservice(_private.getSubserviceConfig(), prio, null,
                    MDVException.keys.MNG_COMM__LIVE_POSITIONS);
            } catch (e) {
                if (prio) {
                    throw e;
                }
                return MDVUtil.getRejectedDeferred(e);
            }
            // extra check as multiple subservice types are possible
            if (!_private.isValidSubservice(subservice)) {
                return _private.request(inputa, inputb, options, prio ? prio + 1 : 1);
            }

            return subservice.search(angular.copy(inputa), angular.copy(inputb),
                        angular.copy(options))
                .then(function(response) {
                    if (!response) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__LIVE_POSITIONS.SERVICE_FAILED, {
                            args : [inputa, inputb, options],
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }

                    return _private.modifyResponse(response, [inputa, inputb, options]);
                })
                .catch(function() {
                    // resend request with lower priority
                    return _private.request(inputa, inputb, options, prio ? prio + 1 : 1);
                });
        };

        MDVConfig.ready(function() {
            _private.options = MDVCommUtil.gatherOptions(_private.getConfigOption('options'));
        });

        return tr;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.object:MDVJourneys
     * @requires $q
     * @requires moment
     * @requires mng-util.object:MDVException
     * @requires mng-util.service:MDVLog
     * @requires mng-util.object:MDVUtil
     * @requires mng-config.service:MDVConfig
     * @requires mng-comm.object:MDVUtil
     * @requires mng-comm.service:MDVJourneyRequester
     * @requires mng-model.object:MDVLocation
     *
     * @description
     * The `MDVJourneys` factory is a basic MDV service that provides a list of
     * {@link mng-model.object:MDVJourney MDVJourneys} for a specific setting including
     * {@link mng-model.object:MDVLocation origin}, {@link mng-model.object:MDVLocation
     * destination} and {@link mng-comm.object:MDVOptions options} that might be modified by the
     * user.
     *
     * This service depends on sub-services that provide a specific interface. Which sub-service is
     * used and how this sub-service is configured is defined in the
     * {@link mng-config.service:MDVConfig Configuration}. The sub-service is responsible for
     * fetching the journey lists and parsing them to the {@link mng-model.object:MDVJourney
     * MDVJourney} format.
     *
     * The MDVJourneys API is based on the {@link https://docs.angularjs.org/api/ng/service/$q
     * deferred/ promise APIs} exposed by the $q service. While for simple usage patterns this
     * doesn't matter, for advanced usage it is important to familiarize yourself with these
     * APIs and the guarantees they provide.
     *
     * # General usage
     * The `MDVJourneys` factory creates objects with their own {@link mng-model.object:MDVLocation
     * origin}, {@link mng-model.object:MDVLocation destination}, result list of {@link
     * mng-model.object:MDVJourney MDVJourneys} and {@link mng-comm.object:MDVOptions options}. By
     * public methods the state of each object can be modified (like `updateOrign(`{@link
     * mng-model.object:MDVLocation location}`)`) or triggered to send requests (like `search()`).
     * As result the internal {@link mng-model.object:MDVJourney MDVJourneys} list is updated. This
     * list should be referenced outside of the object to display the results. This ensures the use
     * of two-way data-binding and therefore automatic updates whenever the object updates.
     *
     * ```js
     *   // Simple journey search request from Main Station to Central Station
     *   var journeys = new MDVJourneys(),
     *       results = journeys.getResults();
     *
     *   journeys.updateOrigin(new MDVLocation({
     *          name : 'Main Station',
     *          id : '123456789'
     *      }));
     *   journeys.updateDestination(new MDVLocation({
     *          name : 'Central Station',
     *          id : '123456780'
     *      }));
     *
     *   journeys.search();  // updates the internal and results list after the request has finished
     *   journeys.next();  // updates the internal and results list after the request has finished
     * ```
     *
     * # Sub-services
     * As `MDVJourneys` does not fetch the result itself, it uses a defined interface for
     * sub-services. These services provide a `search(`{@link mng-model.object:MDVLocation
     * origin}, {@link mng-model.object:MDVLocation destination}, {@link mng-comm.object:MDVOptions
     * options}`)` function that resolves the given {@link mng-model.object:MDVLocation origin},
     * {@link mng-model.object:MDVLocation destination} and an optional set of additional options
     * to a plain list of {@link mng-model.object:MDVJourney MDVJourneys}. Each service uses a
     * different kind of source for this resolution.
     * Each sub-service needs to implement the following interface structure to assure that it can
     * be attached to this service.
     *
     * ```js
     *   // {MDVLocation} origin, {MDVLocation} destination, {Object} options
     *   subservice.search = function (origin, destination, options) {
     *      // returns deferred that is resolved to a list of MDVJourneys.
     *   }
     * ```
     *
     * See the {@link mng-comm.itd.xmljson.service:MDVEFATrip MDVEFATrip} service that provides
     * suggestions from an EFA interface.
     *
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm.MDVJourneys` and interprets the following sub-keys:
     *
     * ## {String[]} subservices
     *
     * Service the departure object should use to get the lists. Right now, only the
     * sub-service-key 'mng-comm.itd.xmljson.MDVEFATrip' is supported. In the future more
     * MDVJourneys sources can be implemented. The array describes a fall back procedure.
     * If the first element in the array does not provide an appropriate response, the next
     * sub-service is used to get a better result.
     *
     * The sub-service key needs to be exactly the name the service is assigned to. To resolve the
     * given name, AngularJs's {@link https://docs.angularjs.org/api/auto/service/$injector
     * $injector} service is used.
     *
     * ## {Object} options
     * Options that should be available to the controllers in order to modify the requests by
     * front-end controls or inputs. Please refer to {@link mng-comm.object:MDVOptions
     * MDVOptions} for further details, to see how the options should be configured/ changed.
     *
     * ## Example:
     * ```js
     *   // configuration object
     *   ...
     *   "MDVJourneys" : {
     *      "subservices" : ["mng-comm.itd.xmljson.MDVEFATrip"], // only use EFA sub-service,
     *      "options" : {
     *          dateTime: true  // use global date/time settings.
     *      }
     *   },
     *   ...
     * ```
     *
     * @example
<example module="MDVJourneysExample">
<file name="index.html">
  <div ng-controller="JourneyController">
    <div ng-show="journey_results.length > 0">
        <h3>Journey Results:</h3>
        <div ng-repeat="journey in journey_results track by $index">
           <h4>{{getPrefix(journey)}} Journey ({{journey.duration()/60}} Min, legs: {{journey.legs().length}})</h4>
        </div>
    </div>
  </div>
</file>
<file name="script.js">
  // mng-comm.itd needs to be included to find mng-comm.itd.xmljson.MDVEFAStopfinder
  angular.module('MDVJourneysExample', ['angularMoment', 'mng-comm', 'mng-comm.itd.xmljson', 'mng-model'])
    .controller('JourneyController', JourneyController);

  // mng-config.MDVConfig normally needs not to be injected as the configuration is loaded by the
  // mng-config.MDVConfigFetcher
  JourneyController.$inject = ['$scope', 'mng-comm.MDVJourneys', 'mng-config.MDVConfig',
    'mng-model.MDVLocation'];

  function JourneyController($scope, MDVJourneys, MDVConfig, MDVLocation) {
      // set configuration. this is normally done by loading the Config with the
      // mng-config.MDVConfigFetcher
      MDVConfig.setValue('mng-comm-itd.MDVEFARequester', {
          'url' : '/mngnsw'
      });
      MDVConfig.setValue('mng-comm-itd-xmljson', {
          defaultParams: {
              outputFormat: 'json'
          },
          'MDVEFATrip' : {
              'url': '/XML_TRIP_REQUEST2?',
              defaultParams: {}
          }
      });
      MDVConfig.setValue('mng-comm.MDVJourneys', {
          'subservices' : ['mng-comm.itd.xmljson.MDVEFATrip']
      });
      // end of configuration

      var journeys = new MDVJourneys();
      $scope.journey_results = journeys.getResults();
      $scope.getPrefix = function (journey) {
          if (journey.isNew) {
            return 'New';
          }
          return 'Old';
      };

      journeys.updateOrigin(new MDVLocation({
             name : 'Manly Wharf',
             id : '10102027'
         }));
      journeys.updateDestination(new MDVLocation({
             name : 'Circular Quay',
             id : '10101103'
         }));
      journeys.search();
      setTimeout(function() {
          journeys.next()
             .then(function (results) {
                 var result_list = $scope.journey_results,
                     i, j, k, l;

                 for (i = 0, l = results.length; i < l; i += 1) {
                     for (j = 0, k = result_list.length; j < k; j += 1) {
                         if (result_list[j].equals(results[i])) {
                             result_list[j].isNew = true;
                         }
                     }
                 }
             });
      }, 10000)
  };
</file>
</example>
     *
     */
    angular.module('mng-comm')
        .factory('mng-comm.MDVJourneys', MDVJourneys);

    MDVJourneys.$inject = ['$q', 'moment', 'mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-config.MDVConfig', 'mng-util.MDVException', 'mng-comm.MDVUtil',
        'mng-model.MDVLocation', 'mng-comm.MDVJourneyRequester'];

    function MDVJourneys($q, moment, MDVLog, MDVUtil, MDVConfig, MDVException, MDVCommUtil,
            MDVLocation, MDVJourneyRequester) {
        var namespace = 'mng-comm.MDVJourneys',
            log = MDVLog.register(namespace);

        log.debug('initialize');

        return function(/* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var _private = {
                namespace : namespace,
                odvs : {
                    origin : new MDVLocation(),
                    destination : new MDVLocation(),
                    vias : []
                },
                result : [],
                options : {}
            };

            if (includePrivate === true) {
                this._private = _private;
            }

            this.clearResults = clearResults;
            this.first = first;
            this.getDestination = getDestination;
            this.getFirst = getFirst;
            this.getLast = getLast;
            this.getOptions = getOptions;
            this.getOrigin = getOrigin;
            this.getResults = getResults;
            this.getVias = getVias;
            this.isHappy = isHappy;
            this.isReady = isHappy;
            this.last = last;
            this.moveLeg = moveLeg;
            this.next = next;
            this.previous = previous;
            this.requestExtensionTickets = requestExtensionTickets;
            this.reset = reset;
            this.resetOptions = resetOptions;
            this.revertMoveLeg = revertMoveLeg;
            this.search = search;
            this.swap = swap;
            this.updateOrigin = updateOrigin;
            this.updateDestination = updateDestination;

            // ////////////////////////////////

            /**
             * @public
             * @ngdoc method
             * @name clearResults
             * @methodOf mng-comm.object:MDVJourneys
             *
             * @description
             * Remove all results that are stored in the internal result list
             */
            function clearResults() {
                _private.result.length = 0;
                _private.firstJourney = null;
                _private.lastJourney = null;
            }
            /**
             * @public
             * @ngdoc method
             * @name getResults
             * @methodOf mng-comm.object:MDVJourneys
             * @returns {MDVJourney[]} Reference to the internal {@link mdv.model.object:MDVJourney
             * MDVJourneys} list.
             *
             * @description
             * Get a reference to the {@link mng-model.object:MDVJourney MDVJourneys} list. This
             * list is filled by the 'search', 'previous' and 'next' method.
             */
            function getResults() {
                var results = _private.result;
                // var sortByDateArr = results.sort(function(a, b) {
                //     return a.departureTime().valueOf() - b.departureTime().valueOf();
                // });
                return results;
            }
            /**
             * @public
             * @ngdoc method
             * @name getFirst
             * @methodOf mng-comm.object:MDVJourneys
             * @returns {MDVJourney|null} First {@link mdv.model.object:MDVJourney
             * MDVJourney} of the day.
             *
             * @description
             * Get the first {@link mdv.model.object:MDVJourney MDVJourney} of the day
             */
            function getFirst() {
                return _private.firstJourney || null;
            }
            /**
             * @public
             * @ngdoc method
             * @name getLast
             * @methodOf mng-comm.object:MDVJourneys
             * @returns {MDVJourney|null} Last {@link mdv.model.object:MDVJourney
             * MDVJourney} of the day.
             *
             * @description
             * Get the last {@link mdv.model.object:MDVJourney MDVJourney} of the day
             */
            function getLast() {
                return _private.lastJourney || null;
            }
            /**
             * @public
             * @ngdoc method
             * @name getOrigin
             * @methodOf mng-comm.object:MDVJourneys
             * @returns {Object} Reference to the internal origin object that is used for
             * requesting journeys
             *
             * @description
             * Get a reference to the origin that is used for this journey request.
             */
            function getOrigin() {
                return _private.odvs.origin;
            }
            /**
             * @public
             * @ngdoc method
             * @name getDestination
             * @methodOf mng-comm.object:MDVJourneys
             * @returns {Object} Reference to the internal destination object that is used for
             * requesting journeys
             *
             * @description
             * Get a reference to the destination that is used for this journey request.
             */
            function getDestination() {
                return _private.odvs.destination;
            }
            /**
             * @public
             * @ngdoc method
             * @name getOptions
             * @methodOf mng-comm.object:MDVJourneys
             * @returns {Object} Reference to the internal options that are used for requesting the
             * journeys
             *
             * @description
             * Get a reference to the Options that are used for this journey request.
             */
            function getOptions() {
                return _private.options;
            }

            /**
             * @public
             * @ngdoc method
             * @name next
             * @methodOf mng-comm.object:MDVJourneys
             * @param {Number} index Internally used parameter. If no parameter is passed, the next
             * journeys for the last non-additional element in the result list are requested.
             * @returns {Deferred} Deferred, that is resolved to a list of {@link
             * mdv.model.object:MDVJourney MDVJourneys}
             *
             * @description
             * Update the internal {@link mdv.model.object:MDVJourney MDVJourneys} list by
             * append more {@link mdv.model.object:MDVJourney MDVJourneys} at the end of the
             * {@link mdv.model.object:MDVJourney MDVJourneys} list.
             * The request-result, the deferred is resolved with, may be different to the internal
             * result-list as it describes the request-results only, without the already loaded
             * {@link mdv.model.object:MDVJourney MDVJourneys}.
             *
             * The best way to use the results is to get a reference to the internal result list
             * (by the 'getResults' method) and use the two-way data binding. The request-result,
             * the deferred is resolved with, should only be used for additional functionality, like
             * highlighting the latest updates.
             */
            function next(index) {
                if (_private.result.length === 0 || (index && index < 0)) {
                    log.warn('next() called, but no previous results available (or only ' +
                        'alternative results). send initial request instead.');
                    return this.search();
                }
                if (!index && index !== 0) {
                    index = _private.result.length - 1;
                }
                var journey = _private.result[index];

                if (journey.isMonomodal()) {
                    log.debug('skip monomodal journey at index ' + index);
                    return this.next(index - 1);
                }
                return MDVJourneyRequester.search(_private.odvs.origin, _private.odvs.destination,
                        MDVCommUtil.mergeObjects(_private.options,
                            _private.getPrevNextOptions(journey.origin(), true)))
                    .then(nextSuccess.bind(this));
            }
            /**
             * @public
             * @ngdoc method
             * @name previous
             * @methodOf mng-comm.object:MDVJourneys
             * @param {Number} index Internally used parameter. If no parameter is passed, the next
             * journeys for the last non-additional element in the result list are requested.
             * @returns {Deferred} Deferred, that is resolved to a list of {@link
             * mdv.model.object:MDVJourney MDVJourneys}
             *
             * @description
             * Update the internal {@link mdv.model.object:MDVJourney MDVJourneys} list by
             * prepend more {@link mdv.model.object:MDVJourney MDVJourneys} at the beginning of
             * the {@link mdv.model.object:MDVJourney MDVJourneys} list.
             * The request-result, the deferred is resolved with, may be different to the internal
             * result-list as it describes the request-results only, without the already loaded
             * {@link mdv.model.object:MDVJourney MDVJourneys}.
             *
             * The best way to use the results is to get a reference to the internal result list
             * (by the 'getResults' method) and use the two-way data binding. The request-result,
             * the deferred is resolved with, should only be used for additional functionality, like
             * highlighting the latest updates.
             */
            function previous(index) {
                if (_private.result.length === 0 || (index && index < 0)) {
                    log.warn('previous() called, but no previous results available (or only ' +
                        'alternative results). send initial request instead.');
                    return this.search.call();
                }
                if (!index && index !== 0) {
                    index = 0;
                }
                var journey = _private.result[index];

                if (journey.isMonomodal()) {
                    log.debug('skip monomodal journey at index ' + index);
                    return this.previous(index + 1);
                }
                return MDVJourneyRequester.search(_private.odvs.origin, _private.odvs.destination,
                        MDVCommUtil.mergeObjects(_private.options,
                                        _private.getPrevNextOptions(journey.destination(), false)))
                    .then(previousSuccess.bind(this));
            }
            /**
             * @public
             * @ngdoc method
             * @name isReady
             * @methodOf mng-comm.object:MDVJourneys
             * @returns {MDVException[]} List of exceptions that describe, why the journey-request
             * cannot yet be sent. Empty list, when everything is fine.
             *
             * @description
             * Determine whether the journey-request can be sent or not.
             */
            function isHappy() {
                var reasons = [];

                if (!MDVConfig.isReady()) {
                    reasons.push(new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                            'without a valid configuration.'
                    }));
                }
                if (!_private.odvs.origin.id()) {
                    reasons.push(new MDVException(MDVException.keys.MNG_COMM__JOURNEY.NO_ORIGIN));
                }
                if (!_private.odvs.destination.id()) {
                    reasons.push(new MDVException(MDVException.keys.MNG_COMM__JOURNEY.NO_DESTINATION));
                }
                // might check if origin.id === destination.id?
                return reasons;
            }

            /**
             * @public
             * @ngdoc method
             * @name first
             * @methodOf mng-comm.object:MDVJourneys
             * @returns {Deferred} Deferred, that is resolved to the first {@link
             * mdv.model.object:MDVJourney MDVJourney} object
             *
             * @description
             * Get the first journey of the configured day.
             */
            function first() {
                if (_private.result.length === 0) {
                    log.warn('first() called, but no results available (or only ' +
                        'alternative results). send initial request instead.');
                    return this.search();
                }

                if (_private.firstJourney) {
                    return _private.getDeferredResponse(_private.firstJourney);
                }

                var first_result = _private.result[0];

                return MDVJourneyRequester.search(_private.odvs.origin, _private.odvs.destination,
                        MDVCommUtil.mergeObjects(_private.options,
                                        _private.getCutTimeOptions(first_result.origin(), true)))
                    .then(firstSuccess.bind(this));
            }

            /**
             * @public
             * @ngdoc method
             * @name last
             * @methodOf mng-comm.object:MDVJourneys
             * @returns {Deferred} Deferred, that is resolved to the last {@link
             * mdv.model.object:MDVJourney MDVJourney} object
             *
             * @description
             * Get the last journey of the configured day.
             */
            function last() {
                if (_private.result.length === 0) {
                    log.warn('last() called, but no results available (or only ' +
                        'alternative results). send initial request instead.');
                    return this.search();
                }

                if (_private.lastJourney) {
                    return _private.getDeferredResponse(_private.lastJourney);
                }

                var last_result = _private.result[_private.result.length - 1];

                return MDVJourneyRequester.search(_private.odvs.origin, _private.odvs.destination,
                        MDVCommUtil.mergeObjects(_private.options,
                                       _private.getCutTimeOptions(last_result.destination(), false)))
                    .then(lastSuccess.bind(this));
            }


            _private.getDeferredResponse = function(objToReturn) {
                var deferred = $q.defer();

                if (objToReturn) {
                    deferred.resolve(objToReturn);
                } else {
                    deferred.reject(objToReturn);
                }
                return deferred.promise;
            };

            _private.getJourneyIndex = function(journey) {
                if (!journey) {
                    return -1;
                }

                var i, l;

                for (i = 0, l = _private.result.length; i < l; i += 1) {
                    if (_private.result[i].equals(journey)) {
                        return i;
                    }
                }
                return -1;
            };

            /**
             * @public
             * @ngdoc method
             * @name moveLeg
             * @methodOf mng-comm.object:MDVJourneys
             * @param {Object} options Set of options
             * @param {MDVJourney} options.journey journey that should be moved. This journey needs
             * to be within the result list.
             * @param {MDVJourneyLeg} options.journey leg that should be moved. This leg needs to be
             * within the given journey object
             * @param {Boolean} options.toPrevious flag whether to move the given leg to a previous
             * option or to move it to the next option.
             * @returns {Deferred} Deferred that is resolved whenever the move-request has finished.
             *
             * @description
             * Change a given journey by moving a given leg to a given direction. The whole journey
             * will be replaced.
             */
            function moveLeg(options) {
                if (!options || !options.journey) {
                    return MDVUtil.getRejectedDeferred(new MDVException(MDVException
                        .keys.MNG__PROGRAMM.INVALID_CONFIG, {
                            reason : 'no journey passed that should be moved'
                        }));
                }
                var journeyIdx = _private.getJourneyIndex(options.journey);

                if (journeyIdx === -1) {
                    return MDVUtil.getRejectedDeferred(new MDVException(MDVException
                        .keys.MNG__PROGRAMM.INVALID_CONFIG, {
                            reason : 'passed journey is not in journeys result list.'
                        }));
                }
                return MDVJourneyRequester.moveJourney(options)
                    .then(function(result) {
                        if (result.response.length) {
                            _private.result[journeyIdx] = result.response[0];
                            return result.response;
                        }
                        throw new MDVException(MDVException.keys.MNG_COMM__JOURNEY.SERVICE_FAILED, {
                            reason : 'no result on movetrip'
                        });
                    });
            }

            /**
             * @public
             * @ngdoc method
             * @name requestExtensionTickets
             * @methodOf mng-comm.object:MDVJourneys
             * @param {Object} options Set of options
             * @param {MDVJourney} options.journey journey the extension tickets should be requested
             * for
             * @param {String} options.network name of the network the provided zones are in
             * @param {String[]} options.zones list of zone names tickets are available for
             * @returns {Deferred} Deferred that is resolved whenever the conjunction ticket
             * request has finished.
             *
             * @description
             * Request a set of conjunction tickets for a given journey
             */
            function requestExtensionTickets(options) {
                if (!options || !options.journey) {
                    return MDVUtil.getRejectedDeferred(new MDVException(MDVException
                        .keys.MNG__PROGRAMM.INVALID_CONFIG, {
                            reason : 'no journey passed to request conjunction tickets'
                        }));
                }

                return MDVJourneyRequester.requestExtensionTickets(options)
                    .then(function(result) {
                        if (!result.response.length) {
                            throw new MDVException(MDVException.keys.MNG_COMM__JOURNEY.SERVICE_FAILED, {
                                reason : 'no result on conjunction tickets request'
                            });
                        }
                        return result.response;
                    });

            }
            /**
             * @public
             * @ngdoc method
             * @name revertMoveLeg
             * @methodOf mng-comm.object:MDVJourneys
             * @param {Object} options Set of options
             * @param {MDVJourney} options.journey journey that should be moved. This journey needs
             * to be within the result list.
             * @returns {Boolean} Whether the reversion was successful (true) or not (false)
             *
             * @description
             * Undo a previous moveLeg call by replacing the moveLeg result with the original
             * journey.
             */
            function revertMoveLeg(options) {
                if (!options || !options.journey || !options.journey.previousJourney) {
                    return false;
                }
                var journeyIdx = _private.getJourneyIndex(options.journey);

                _private.result[journeyIdx] = options.journey.previousJourney;

                return true;
            }
            /**
             * @public
             * @ngdoc method
             * @name reset
             * @methodOf mng-comm.object:MDVJourneys
             *
             * @description
             * Reset origin, destination, options and remove all requested journeys.
             */
            function reset() {
                _private.odvs.origin.reset();
                _private.odvs.destination.reset();
                // handle vias here

                this.resetOptions();
                this.clearResults();
            }
            /**
             * @public
             * @ngdoc method
             * @name resetOptions
             * @methodOf mng-comm.object:MDVJourneys
             *
             * @description
             * Reset options to default.
             */
            function resetOptions() {
                if (!MDVConfig.isReady()) {
                    return;
                }
                var config = MDVConfig.getValue('mng-comm.MDVJourneys.options');

                MDVCommUtil.resetOptions(config, _private.options);
            }

            /**
             * @public
             * @ngdoc method
             * @name swap
             * @methodOf mng-comm.object:MDVJourneys
             *
             * @description
             * Swap {@link mng-model.object:MDVLocation origin} and {@link
             * mng-model.object:MDVLocation destination}. This is done by changing properties only.
             *
             * **Note:** *The references to the {@link mng-model.object:MDVLocation origin} and
             * {@link mng-model.object:MDVLocation destination} stays the same. Only the properties
             * of the {@link mng-model.object:MDVLocation locations} change.*
             */
            function swap() {
                var tmp_dest = _private.odvs.destination.toJSON();

                this.updateDestination(_private.odvs.origin.toJSON());
                this.updateOrigin(tmp_dest);
            }

            /**
             * @public
             * @ngdoc method
             * @name search
             * @methodOf mng-comm.object:MDVJourneys
             * @param {Object} add_options Abstract {@link mng-comm.object:MDVOptions options} that
             * should override the normal, internal {@link mng-comm.object:MDVOptions options}.
             *
             * **Note:** This options parameter should not be used for setting {@link
             * mng-comm.object:MDVOptions options} for journey-requests. Use the two-way
             * data-binding instead. This parameter should only be used to override user settings
             * for alternative journeys with different settings (like the use of car sharing
             * providers). See {@link mng-comm.service:MDVJourneyList MDVJourneyList} for further
             * details.
             * @returns {Deferred} Deferred, that is resolved to a list of {@link
             * mdv.model.object:MDVJourney MDVJourneys}
             *
             * @description
             * This method implements the abstract interface that is implemented by the configured
             * sub-service.
             *
             * Update the internal list of {@link mdv.model.object:MDVJourney MDVJourneys} for the
             * current state of {@link mng-model.object:MDVLocation origin}, {@link
             * mng-model.object:MDVLocation destination} and {@link mng-comm.object:MDVOptions
             * options}.
             *
             * The request-result, the deferred is resolved with, may be different to the internal
             * result-list as it describes the request-results only, without the already loaded
             * {@link mdv.model.object:MDVJourney MDVJourneys}.
             *
             * The best way to use the results is to get a reference to the internal result list
             * (by the 'getResults' method) and use the two-way data binding. The request-result,
             * the deferred is resolved with, should only be used for additional functionality, like
             * highlighting the latest updates.
             */
            function search(add_options) {
                var reasons = this.isReady();

                if (reasons.length > 0) {
                    return MDVUtil.getRejectedDeferred(reasons[0]);
                }
                return MDVJourneyRequester.search(angular.copy(_private.odvs.origin),
                     angular.copy(_private.odvs.destination),
                        MDVCommUtil.mergeObjects(_private.options, add_options))
                    .then(_private.searchSuccess.bind(this));
            }
            /**
             * @public
             * @ngdoc method
             * @name updateDestination
             * @methodOf mng-comm.object:MDVJourneys
             * @param {MDVLocation} location Location object that should be used as destination for
             * the journey requests.
             * @returns {Boolean} True: successfully updated location, false otherwise
             *
             * @description
             * Update the location the journeys should end. Please note that only the properties
             * of the location are updated. The reference to the location stays the same to ensure
             * two way data binding.
             */
            function updateDestination(location) {
                var success = MDVCommUtil.updateLocation(_private.odvs.destination, location);

                if (_private.isBoolTrue(success)) {
                    _private.updateOptionsOdvs(location.id(), 'dest');
                }
                return success;
            }
            /**
             * @public
             * @ngdoc method
             * @name updateOrigin
             * @methodOf mng-comm.object:MDVJourneys
             * @param {MDVLocation} location Location object that should be used as origin for
             * the journey requests.
             * @returns {Boolean} True: successfully updated location, false otherwise
             *
             * @description
             * Update the location the journeys should start. Please note that only the properties
             * of the location are updated. The reference to the location stays the same to ensure
             * two way data binding.
             */
            function updateOrigin(location) {
                var success = MDVCommUtil.updateLocation(_private.odvs.origin, location);

                if (_private.isBoolTrue(success)) {
                    _private.updateOptionsOdvs(location.id(), 'orig');
                }
                return success;
            }
            /**
             * @public
             * @ngdoc method
             * @name getVias
             * @methodOf mng-comm.object:MDVJourneys
             * @returns {MDVLocation[]} internal list of via location
             *
             * @description
             * Get the location the journeys should pass.
             *
             * **Note:** *Vias are not yet implemented*
             */
            function getVias() {
                return _private.odvs.vias;
            }

            // ////////////////////////////////

            _private.isBoolTrue = function(value) {
                return value && (typeof value === 'boolean');
            };

            _private.updateOptionsOdvs = function(locId, usage) {
                if (!_private.options) {
                    return false;
                }
                if (!_private.options.odvs) {
                    _private.options.odvs = {};
                }
                _private.options.odvs[usage] = locId;
            };

            _private.getDefaultConfigOption = function(key) {
                var defConfig = {
                    subservices : ['mng-comm.itd.json.MDVEFATrip'],
                    rejectEmptyResponses : false,
                    options : {
                        dateTime : true,
                        productRestrictions : true,
                        individualTransport : true,
                        publicTransport : true
                    }
                };

                if (!key) {
                    return defConfig;
                }
                if (defConfig.hasOwnProperty(key)) {
                    return defConfig[key];
                }
                return null;
            };

            _private.getConfigOption = function(key) {
                var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

                if (!configVal) {
                    return _private.getDefaultConfigOption(key);
                }
                return configVal;
            };

            _private.getPrevNextOptions = function(location, isDeparture) {
                var datetime = location.time().clone();  // avoid changes to original time object

                if (isDeparture) {
                    datetime.add(1, 'minutes');
                } else {
                    datetime.subtract(1, 'minutes');
                }
                return {
                    dateTime : {
                        date : datetime,
                        time : datetime,
                        dateFormat : null,
                        timeFormat : null,
                        isDeparture : isDeparture
                    },
                    efaParams : {
                        calcMonoTrip : 0,
                        calcOneDirection : 1
                    }
                };
            };

            _private.getCutTimeOptions = function(location, isDeparture) {
                var timeCut = _private.options.dateTime.timeCut,
                    timeCutInterval = (_private.options.dateTime.timeCutInterval === 0)? 0 : 1,
                    date;

                if (!timeCut || timeCut.length !== 2) {
                    throw new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG);
                }
                if (!location) {
                    return {};
                }
                timeCut = isDeparture ? timeCut[0] : timeCut[1];
                date = location.time().clone();

                if (!isDeparture) {
                    date = date.add(timeCutInterval, 'days');

                }

                return {
                    dateTime : {
                        date : date, // Same date as first/last journey in the list
                        time : moment(timeCut, 'HH:mm'),
                        dateFormat : null,
                        timeFormat : null,
                        isDeparture : isDeparture,
                        isFirstLast : true
                    }
                };
            };

            _private.searchSuccess = function(results) {
                var i,
                    l;

                _private.result.length = 0;

                for (i = 0, l = results.response.length; i < l; i += 1) {
                    _private.result.push(results.response[i]);
                }
                return results.response;
            };

            function previousSuccess(results) {
                var i,
                    to_delete = [];

                for (i = results.response.length - 1; i >= 0; i -= 1) {
                    if (results.response[i].isMonomodal()) {
                        log.info('ignored monomodal journey');
                        log.info(results.response[i], true);
                    } else if (MDVCommUtil.isNewResult(_private.result, results.response[i])) {
                        _private.result.unshift(results.response[i]);
                    } else {
                        log.info('ignored duplicate response');
                        log.info(results.response[i], true);
                        to_delete.push(i);
                    }
                }
                for (i = to_delete.length - 1; i >= 0; i -= 1) {
                    results.response.splice(to_delete[i], 1);
                }
                return results.response;
            }
            function nextSuccess(results) {
                var i,
                    l,
                    footpath,
                    to_delete = [];

                // check if footpath is shown
                if (_private.result[_private.result.length - 1].isMonomodal()) {
                    footpath = _private.result.pop();
                }

                for (i = 0, l = results.response.length; i < l; i += 1) {
                    if (results.response[i].isMonomodal()) {
                        log.info('ignored monomodal journey');
                        log.info(results.response[i], true);
                    } else if (MDVCommUtil.isNewResult(_private.result, results.response[i])) {
                        if (_private.result[_private.result.length - 1].isAdditional()) {
                            _private.result.splice(_private.result.length - 1, 0, results.response[i]);
                        } else {
                            _private.result.push(results.response[i]);
                        }
                    } else {
                        log.info('ignored duplicate response');
                        log.info(results.response[i], true);
                        to_delete.push(i);
                    }
                }
                for (i = to_delete.length - 1; i >= 0; i -= 1) {
                    results.response.splice(to_delete[i], 1);
                }

                // append original footpath
                if (footpath) {
                    _private.result.push(footpath);
                }

                return results.response;
            }

            function firstSuccess(results) {
                // sometimes EFA provides alternative routes even when "calcNumberOfTrips=1" is passed
                if (results.response.length === 0) {
                    log.warn('invalid results for first() : results number == 0');
                    return;
                }
                _private.firstJourney = angular.copy(results.response[0]);
                return _private.firstJourney;
            }

            function lastSuccess(results) {
                // sometimes EFA provides alternative routes even when "calcNumberOfTrips=1" is passed
                if (results.response.length === 0) {
                    log.warn('invalid results for last() : results number === 0');
                    return;
                }
                _private.lastJourney = angular.copy(results.response[results.response.length - 1]);
                return _private.lastJourney;
            }

            MDVConfig.ready(function() {
                _private.options = MDVCommUtil.gatherOptions(_private.getConfigOption('options'));
            });

            return this;
        };
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.service:MDVJourneyRequester
     * @requires mng-util.service:MDVLog
     * @requires mng-config.service:MDVConfig
     * @requires mng-util.object:MDVException
     * @requires mng-comm.object:MDVUtil
     * @requires mng-model.object:MDVLocation
     *
     * @description
     * The `MDVJourneyRequester` service is a basic MDV service that provides a list of
     * {@link mng-model.object:MDVJourney MDVJourneys} for a specific input, including
     * {@link mng-model.object:MDVLocation origin}, {@link mng-model.object:MDVLocation
     * destination} and {@link mng-comm.object:MDVOptions options}.
     *
     * This service depends on sub-services that provide a specific interface. Which sub-service is
     * used and how this sub-service is configured is defined in the
     * {@link mng-config.service:MDVConfig Configuration}. The sub-service is responsible for
     * fetching the journey lists and parsing them to the {@link mng-model.object:MDVJourney
     * MDVJourney} format.
     *
     * # General usage
     * The `MDVJourneyRequester` service abstracts the communication to the bottom layers.
     *
     * ```js
     *   // Simple journey search request from Main Station to Central Station
     *   MDVJourneyRequester.search(new MDVLocation({
     *          name : 'Main Station',
     *          id : '123456789'
     *      }), new MDVLocation({
     *          name : 'Central Station',
     *          id : '123456780'
     *      }));
     * ```
     *
     * # Sub-services
     * As `MDVJourneyRequester` does not fetch the result itself, it uses a defined interface for
     * sub-services. These services provide a `search(`{@link mng-model.object:MDVLocation
     * origin}, {@link mng-model.object:MDVLocation destination}, {@link mng-comm.object:MDVOptions
     * options}`)` function that resolves the given {@link mng-model.object:MDVLocation origin},
     * {@link mng-model.object:MDVLocation destination} and an optional set of additional options
     * to a plain list of {@link mng-model.object:MDVJourney MDVJourneys}. Each service uses a
     * different kind of source for this resolution.
     * Each sub-service needs to implement the following interface structure to assure that it can
     * be attached to this service.
     *
     * ```js
     *   // {MDVLocation} origin, {MDVLocation} destination, {Object} options
     *   subservice.search = function (origin, destination, options) {
     *      // returns deferred that is resolved to a list of MDVJourneys.
     *   }
     * ```
     *
     * See the {@link mng-comm.itd.xmljson.service:MDVEFATrip MDVEFATrip} service that provides
     * suggestions from an EFA interface.
     *
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm.MDVJourneyRequester` and interprets the following sub-keys:
     *
     * ## {String[]} subservices
     *
     * Service the departure object should use to get the lists. Right now, only the
     * sub-service-key 'mng-comm.itd.xmljson.MDVEFATrip' is supported. In the future more
     * MDVJourneys sources can be implemented. The array describes a fall back procedure.
     * If the first element in the array does not provide an appropriate response, the next
     * sub-service is used to get a better result.
     *
     * The sub-service key needs to be exactly the name the service is assigned to. To resolve the
     * given name, AngularJs's {@link https://docs.angularjs.org/api/auto/service/$injector
     * $injector} service is used.
     *
     * ## {Object} options
     * Options that should be available to the controllers in order to modify the requests by
     * front-end controls or inputs. Please refer to {@link mng-comm.object:MDVOptions
     * MDVOptions} for further details, to see how the options should be configured/ changed.
     *
     * ## Example:
     * ```js
     *   // configuration object
     *   ...
     *   "MDVJourneys" : {
     *      "subservices" : ["mng-comm.itd.xmljson.MDVEFATrip"], // only use EFA sub-service,
     *      "options" : {
     *          dateTime: true  // use global date/time settings.
     *      }
     *   },
     *   ...
     * ```
     *
     */
    angular.module('mng-comm')
        .factory('mng-comm.MDVJourneyRequester', MDVJourneyRequester);

    MDVJourneyRequester.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-config.MDVConfig', 'mng-util.MDVException', 'mng-comm.MDVUtil',
        'mng-model.MDVLocation'];

    function MDVJourneyRequester(MDVLog, MDVUtil, MDVConfig, MDVException, MDVCommUtil,
            MDVLocation) {
        var _private = {
                namespace : 'mng-comm.MDVJourneyRequester'
            },
            log = MDVLog.register(_private.namespace),
            jr = {
                isReady : isReady,
                requestExtensionTickets : requestExtensionTickets,
                search : search,
                moveJourney : moveJourney
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name isReady
         * @methodOf mng-comm.service:MDVJourneyRequester
         * @param {MDVLocation} origin Origin that should be used for the trip request
         * @param {MDVLocation} destination Destination that should be used for the trip request
         *
         * @returns {MDVException[]} List of exceptions that describe, why the journey-request
         * cannot yet be sent. Empty list, when everything is fine.
         *
         * @description
         * Determine whether the journey-request can be sent or not.
         */
        function isReady(origin, destination) {
            var reasons = [];

            if (!MDVConfig.isReady()) {
                reasons.push(new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                    reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                        'without a valid configuration.'
                }));
            }

            if (!(origin instanceof MDVLocation) || !origin.id()) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__JOURNEY.NO_ORIGIN));
            }
            if (!(destination instanceof MDVLocation) || !destination.id()) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__JOURNEY.NO_DESTINATION));
            }

            return reasons;
        }


        /**
         * @public
         * @ngdoc method
         * @name moveJourney
         * @methodOf mng-comm.service:MDVJourneyRequester
         * @param {Object} options Set of options
         * @param {MDVJourney} options.journey journey that should be moved. This journey needs
         * to be within the result list.
         * @param {MDVJourneyLeg} options.journey leg that should be moved. This leg needs to be
         * within the given journey object
         * @param {Boolean} options.toPrevious flag whether to move the given leg to a previous
         * option or to move it to the next option.
         * @returns {Deferred} Deferred that is resolved whenever the move-request has finished.
         *
         * @description
         * Move a leg within a certain journey to previous suggestion or to next suggestion.
         */
        function moveJourney(options) {
            return _private.requestMove.call(this, options);
        }

        /**
         * @public
         * @ngdoc method
         * @name requestExtensionTickets
         * @methodOf mng-comm.service:MDVJourneyRequester
         * @param {Object} options Set of options
         * @param {MDVJourney} options.journey journey extension tickets should be requested for.
         * @param {String} options.network name of the network the provided zones are in
         * @param {String[]} options.zones list of zone names tickets are available for
         * @returns {Deferred} Deferred that is resolved whenever the move-request has finished.
         *
         * @description
         * Get a list of tickets that are needed to cover the complete provided journey when a
         * ticket for provided zones are already available.
         */
        function requestExtensionTickets(options) {
            return _private.requestExtensionTickets.call(this, options);
        }

        /**
         * @public
         * @ngdoc method
         * @name search
         * @methodOf mng-comm.service:MDVJourneyRequester
         * @param {MDVLocation} origin Origin that should be used for the trip request
         * @param {MDVLocation} destination Destination that should be used for the trip request
         * @param {Object} options Abstract {@link mng-comm.object:MDVOptions options} that
         * should override the normal, internal {@link mng-comm.object:MDVOptions options}.
         *
         * @returns {Deferred} Deferred, that will be resolved to response object when the
         * transportation list is available
         * or an error occurred. The response has the following parameters:
         * - input: {Object[]} list of inputs that were used for requesting the response.
         * - response: {{@link mdv.model.object:MDVJourney MDVJourneys}} list of MDVJourneys.
         *
         * @description
         * This method implements the abstract interface that is implemented by the configured
         * sub-service.
         *
         * Update the internal list of {@link mdv.model.object:MDVJourney MDVJourneys} for the
         * current state of {@link mng-model.object:MDVLocation origin}, {@link
         * mng-model.object:MDVLocation destination} and {@link mng-comm.object:MDVOptions
         * options}.
         *
         * The request-result, the deferred is resolved with, may be different to the internal
         * result-list as it describes the request-results only, without the already loaded
         * {@link mdv.model.object:MDVJourney MDVJourneys}.
         *
         * The best way to use the results is to get a reference to the internal result list
         * (by the 'getResults' method) and use the two-way data binding. The request-result,
         * the deferred is resolved with, should only be used for additional functionality, like
         * highlighting the latest updates.
         */
        function search(origin, destination, options) {
            var reasons = isReady(origin, destination, options);

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }
            return _private.request.call(this, origin, destination, options);
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                subservices : ['mng-comm.itd.json.MDVEFATrip'],
                rejectEmptyResponses : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.isValidExtensionTicketSubservice = function(subservice) {
            return subservice.hasOwnProperty('requestExtensionTickets');
        };

        _private.isValidMoveSubservice = function(subservice) {
            return subservice.hasOwnProperty('moveJourney');
        };

        _private.isValidSubservice = function(subservice) {
            return subservice.hasOwnProperty('search');
        };

        _private.getSubserviceConfig = function() {
            return _private.getConfigOption('subservices');
        };

        _private.modifyResponse = function(response, arglist) {
            return {
                input : arglist,
                response : response
            };
        };

        _private.request = function(origin, destination, options, prio, prevError) {
            var subservices = _private.getSubserviceConfig(),
                subservice,
                exception;

            try {
                subservice = MDVCommUtil.getSubservice(subservices, prio, null,
                    MDVException.keys.MNG_COMM__JOURNEY);
            } catch (e) {
                if (prio && prio >= subservices.length && prevError) {
                    throw prevError;
                }
                if (prio) {
                    throw e;
                }
                return MDVUtil.getRejectedDeferred(e);
            }

            if (!_private.isValidSubservice(subservice)) {
                if (!_private.isValidMoveSubservice(subservice) &&
                        !_private.isValidExtensionTicketSubservice(subservice)) {
                    exception = new MDVException(MDVException.keys.MNG_COMM__DM.NO_SERVICE, {
                        reason : 'configured service does not match interface definition of this service'
                    });
                    if (prio) {
                        throw exception;
                    }
                    return MDVUtil.getRejectedDeferred(exception);
                }
                return _private.request(origin, destination, options, prio ? prio + 1 : 1, prevError);
            }

            return subservice.search(angular.copy(origin), angular.copy(destination),
                    MDVUtil.copy(options))
                .then(function(response) {
                    if (!response || (!response.trips && !response.systemMessages)) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__LS.SERVICE_FAILED, {
                            args : [options, origin, destination],
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }

                    if (_private.getConfigOption('rejectEmptyResponses') &&
                            !response.trips.length && response.systemMessages.length) {
                        // no trips, but system messages -> throw exception with messages
                        throw new MDVException(MDVException.keys.MNG_COMM__LS.SERVICE_FAILED, {
                            args : [options, origin, destination],
                            service : subservice.name,
                            reason : 'no results due to backend errors',
                            data : response.systemMessages
                        });
                    }

                    return _private.modifyResponse(response.trips, [options, origin, destination]);
                })
                .catch(function(error) {
                    // resend request with lower priority
                    return _private.request(origin, destination, options, prio ? prio + 1 : 1, error);
                });
        };

        _private.requestMove = function(options, prio) {
            var subservices = _private.getSubserviceConfig(),
                subservice;

            try {
                subservice = MDVCommUtil.getSubservice(subservices, prio, null,
                    MDVException.keys.MNG_COMM__JOURNEY);
            } catch (e) {
                if (prio) {
                    throw e;
                }
                return _private.requestMove(options, 1);
            }

            if (!_private.isValidMoveSubservice(subservice)) {
                return _private.requestMove(options, prio ? prio + 1 : 1);
            }

            return subservice.moveJourney(options)
                .then(function(response) {
                    if (!response) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__LS.SERVICE_FAILED, {
                            args : options,
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }

                    return _private.modifyResponse(response, options);
                })
                .catch(function() {
                    // resend request with lower priority
                    return _private.requestMove(options, prio ? prio + 1 : 1);
                });
        };

        _private.requestExtensionTickets = function(options, prio) {
            var subservices = _private.getSubserviceConfig(),
                subservice;

            try {
                subservice = MDVCommUtil.getSubservice(subservices, prio, null,
                    MDVException.keys.MNG_COMM__JOURNEY);
            } catch (e) {
                if (prio) {
                    throw e;
                }
                return _private.requestMove(options, 1);
            }

            if (!_private.isValidExtensionTicketSubservice(subservice)) {
                return _private.requestExtensionTickets(options, prio ? prio + 1 : 1);
            }

            return subservice.requestExtensionTickets(options)
                .then(function(response) {
                    if (!response) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__LS.SERVICE_FAILED, {
                            args : options,
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }

                    return _private.modifyResponse(response, options);
                })
                .catch(function() {
                    // resend request with lower priority
                    return _private.requestExtensionTickets(options, prio ? prio + 1 : 1);
                });
        };

        // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
        // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                jr._private = _private;
            }
        });

        return jr;

    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.service:MDVJourneyList
     * @requires $q
     * @requires $injector
     * @requires mng-util.service:MDVLog
     * @requires mng-config.service:MDVConfig
     * @requires mng-util.object:MDVException
     * @requires mng-comm.service:MDVJourneys
     *
     * @description
     * The `MDVJourneyList` service is a basic MDV service that provides a list of
     * {@link mng-comm.object:MDVJourneys MDVJourneysObjects} for a specific setting including
     * {@link mng-model.object:MDVLocation origin} and {@link mng-model.object:MDVLocation
     * destination}.
     *
     * The MDVJourneys API is based on the {@link https://docs.angularjs.org/api/ng/service/$q
     * deferred/ promise APIs} exposed by the $q service. While for simple usage patterns this
     * doesn't matter, for advanced usage it is important to familiarize yourself with these
     * APIs and the guarantees they provide.
     *
     * # General usage
     * The `MDVJourneyList` service is used to combine multiple, similar journey requests. All these
     * requests use the same {@link mng-model.object:MDVLocation origin} and {@link
     * mng-model.object:MDVLocation destination}. The only difference of these requests is, that
     * there are some specific settings forced to provide alternative journeys for the user.
     *
     * **Note:** *Do not mix up the alternative journeys provided by a sub-service with this kind of
     * alternative journeys. This journeys force specific options, defined in the MDVConfig, whereas
     * the alternative journeys provided by the sub-service are provided by the back-end service as
     * these alternatives are equal to the requested ones. The journeys provided by this service may
     * not be equal and even worse than the original requested ones.*
     *
     * An example for one of these alternative journeys might be a separate journey that offers car
     * sharing providers only. This allows the user to decide whether to use the original journey
     * results, or use one of the alternatives. The alternatives are defined in the {@link
     * mng-config.service:MDVConfig MDVConfig}.
     *
     *
     * The `MDVJourneyList` service creates {@link mng-comm.object:MDVJourneys MDVJourneysObjects}
     * for every key provided in the configuration and stores them in an internal dictionary that
     * can be referenced by the `getJourneys()` method.
     *
     * Instead of updating and triggering every single journey request, this service allows to
     * communicate with all {@link mng-comm.object:MDVJourneys MDVJourneys} at once by a set of
     * methods.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm.MDVJourneyList` and interprets every single sub-key as key for a {@link
     * mng-comm.object:MDVJourneys MDVJourneyObjects}. Each sub-key needs to contain an `options`
     * property that defines which options need to be overridden.
     *
     * ## {Object} options
     * The options property describes abstract {@link mng-comm.object:MDVOptions MDVOptions},
     * that should be overridden for the specific {@link mng-comm.object:MDVJourneys MDVJourneys
     * Object}. The property needs to provide the {@link mng-comm.object:MDVOptions MDVOption Group}
     * key, followed by all abstract options that should be set static for every request, regardless
     * what the user has configured in the user interface.
     *
     * ```js
     *   // configuration object
     *   ...
     *   MDVJourneyList : {
     *       normal: {
     *           options : {}  // do not override options for normal journey requests
     *       },
     *       noCommuter : {   // provide an alternative journey request that restricts commuter
     *           options : {  // trains whenever a journey is requested
     *               modeRestrictions : {  // override modeRestriction option group
     *                   commuter : false  // override commuter with false for every request
     *               }
     *           }
     *       }
     *   },
     *   ...
     * ```
     */
    angular.module('mng-comm')
        .factory('mng-comm.MDVJourneyList', MDVJourneyList);

    MDVJourneyList.$inject = ['$q', 'mng-util.MDVLog', 'mng-util.MDVUtil', 'mng-config.MDVConfig',
        'mng-util.MDVException', 'mng-comm.MDVJourneys'];

    function MDVJourneyList($q, MDVLog, MDVUtil, MDVConfig, MDVException, MDVJourneys) {
        var _private = {
                namespace : 'mng-comm.MDVJourneyList',
                journeys : {}
            },
            log = MDVLog.register(_private.namespace),
            jl = {
                clearResults : clearResults,
                getJourneys : getJourneys,
                getResults : getResults,
                next : next,
                previous : previous,
                reset : reset,
                resetOptions : resetOptions,
                toggleByKey : toggleByKey,
                search : search,
                updateDestination : updateDestination,
                updateOrigin : updateOrigin
            };

        log.debug('initialize');


        MDVConfig.ready(function() {
            var key,
                count = 0;

            _private.config = MDVConfig.getValue(_private.namespace) || {};

            if (_private.config.privateMode === true) {
                jl._private = _private;
            }
            delete _private.config.privateMode;
            // fill list and update options
            for (key in _private.config) {
                if (_private.config.hasOwnProperty(key)) {
                    _private.journeys[key] = new MDVJourneys();
                    count += 1;
                }
            }
            if (count === 0) {
                throw new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                    reason : 'No keys defined for MDVJourneyList. Please configure at least ' +
                    'one Journey Instance that should be added to the MDVJourneyList.'
                });
            }
        });

        /**
         * @public
         * @ngdoc method
         * @name clearResults
         * @methodOf mng-comm.service:MDVJourneyList
         * @param {String} [journeyKey=null] Clear results of a specific journeylist-element. If no
         * key is passed, all results of all journeylist-elements are cleared.
         * @returns {Object} undefined
         *
         * @description
         * Clear the results for one or all initialized journeys.
         */
        function clearResults(journeyKey) {
            if (journeyKey) {
                return _private.one('clearResults', journeyKey);
            }
            return _private.all('clearResults');
        }

        /**
         * @public
         * @ngdoc method
         * @name reset
         * @methodOf mng-comm.service:MDVJourneyList
         * @returns {Object} undefined
         *
         * @description
         * call the reset function of all journey services.
         */
        function reset() {
            return _private.all('reset');
        }
        /**
         * @public
         * @ngdoc method
         * @name resetOptions
         * @methodOf mng-comm.service:MDVJourneyList
         * @returns {Object} undefined
         *
         * @description
         * call the resetOptions function of all journey services.
         */
        function resetOptions() {
            return _private.all('resetOptions');
        }
        /**
         * @public
         * @ngdoc method
         * @name updateDestination
         * @methodOf mng-comm.service:MDVJourneyList
         * @param {MDVLocation} location Location object that should be used as destination for all
         * journey requests.
         * @returns {Object} undefined
         *
         * @description
         * Update the location all journeys should end at. Please note that only the properties
         * of the location are updated. The reference to the location stays the same to ensure
         * two way data binding.
         */
        function updateDestination(location) {
            return _private.all('updateDestination', location);
        }
        /**
         * @public
         * @ngdoc method
         * @name updateOrigin
         * @methodOf mng-comm.service:MDVJourneyList
         * @param {MDVLocation} location Location object that should be used as origin for
         * all journey requests.
         * @returns {Object} undefined
         *
         * @description
         * Update the location all journeys should start at. Please note that only the properties
         * of the location are updated. The reference to the location stays the same to ensure
         * two way data binding.
         */
        function updateOrigin(location) {
            return _private.all('updateOrigin', location);
        }
        /**
         * @public
         * @ngdoc method
         * @name getJourneys
         * @methodOf mng-comm.service:MDVJourneyList
         * @param {String} [journeyKey=null] Optional journeylist-element key to get a specific
         * journeylist-element. if no key is passed, all journeylist-elements are returned.
         * @returns {Object} Reference to the internal object that contains all {@link
         * mdv.model.object:MDVJourneys MDVJourneys}, accessible by the key, configured in the
         * MDVConfig.
         *
         * @description
         * Get a reference to the internal object that contains all {@link
         * mng-model.object:MDVJourney MDVJourneys}.
         */
        function getJourneys(journeyKey) {
            if (journeyKey) {
                return _private.journeys[journeyKey] || null;
            }
            return _private.journeys;
        }
        /**
         * @public
         * @ngdoc method
         * @name getResults
         * @methodOf mng-comm.service:MDVJourneyList
         * @returns {MDVJourney[]} Array that contains all {@link
         * mdv.model.object:MDVJourney MDVJourneys}
         *
         * @description
         * Get all the {@link mng-model.object:MDVJourney MDVJourneys}
         */
        function getResults() {
            var result=[],
                journeyKey;

            for (journeyKey in _private.journeys) {
                if (_private.journeys.hasOwnProperty(journeyKey)) {
                    result = result.concat(_private.journeys[journeyKey].getResults());
                }
            }
            return result;
        }

        function toggleByKey(journeyKey) {
            if (_private.journeys.hasOwnProperty(journeyKey) && !_private.config.hasOwnProperty(journeyKey)) {
                _private.config[journeyKey].disabled = true;
                return _private.one('clearResults', journeyKey);
            } else {
                _private.config[journeyKey].disabled = false;
                return search(journeyKey);
            }
        }

        /**
         * @public
         * @ngdoc method
         * @name search
         * @methodOf mng-comm.service:MDVJourneyList
         * @returns {Deferred} Deferred that is resolved when all {@link
         * mdv.model.object:MDVJourneys MDVJourneys} are finished
         *
         * @description
         * Trigger the search methods of all configured {@link mdv.model.object:MDVJourneys
         * MDVJourneys} to allow them to update with the latest values.
         *
         * This service adds the regarding configured, static options to each request to assure that
         * the static values override the user-configured ones.
         */
        function search(journeyKey) {
            if (!MDVConfig.isReady()) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'Configuration has not yet loaded correctly. Cannot start ' +
                            'requests without a valid configuration.'
                    }));
            }

            var key,
                count = 0,
                resolved = 0,
                deferred = $q.defer(),
                success_cb = function() {
                    resolved += 1;
                    if (count === resolved) {
                        deferred.resolve();
                    }
                },
                error_cb = function(e) {
                    deferred.reject();
                },
                fireSearch = function(k) {
                    if (_private.journeys.hasOwnProperty(k) && !_private.config[k].disabled) {
                        count += 1;
                        _private.journeys[k].search(_private.config[k].options)
                            .then(success_cb)
                            .catch(error_cb);
                    }
                };

            if (journeyKey) {
                fireSearch(journeyKey);
            } else {
                for (key in _private.journeys) {
                    fireSearch(key);
                }
            }

            return deferred.promise;
        }
        /**
         * @public
         * @ngdoc method
         * @name next
         * @methodOf mng-comm.service:MDVJourneyList
         * @param {String} [journeyKey=null] Optional journeylist-element key to request the next
         * journeys for a specifc journeylist-element. if no key is passed, all journeylist-elements
         * request their next results.
         * @returns {Deferred} Deferred that is resolved when all {@link
         * mdv.model.object:MDVJourneys MDVJourneys} are finished
         *
         * @description
         * Trigger the next methods of all configured {@link mdv.model.object:MDVJourneys
         * MDVJourneys} to allow them to update with the latest values.
         */
        function next(journeyKey) {
            if (journeyKey) {
                return _private.one('next', journeyKey);
            }
            return _private.all('next');
        }
        /**
         * @public
         * @ngdoc method
         * @name previous
         * @methodOf mng-comm.service:MDVJourneyList
         * @param {String} [journeyKey=null] Optional journeylist-element key to request the
         * previous journeys for a specifc journeylist-element. if no key is passed, all
         * journeylist-elements request their previous results.
         * @returns {Deferred} Deferred that is resolved when all {@link
         * mdv.model.object:MDVJourneys MDVJourneys} are finished
         *
         * @description
         * Trigger the previous methods of all configured {@link mdv.model.object:MDVJourneys
         * MDVJourneys} to allow them to update with the latest values.
         */
        function previous(journeyKey) {
            if (journeyKey) {
                return _private.one('previous', journeyKey);
            }
            return _private.all('previous');
        }


        _private.all = function(method, parameter1, parameter2) {
            var journeyKey;

            for (journeyKey in _private.journeys) {
                if (_private.journeys.hasOwnProperty(journeyKey)) {
                    _private.journeys[journeyKey][method](parameter1, parameter2);
                }
            }
        };

        _private.one = function(method, journeyKey, parameter1, parameter2) {
            if (_private.journeys.hasOwnProperty(journeyKey)) {
                return _private.journeys[journeyKey][method](parameter1, parameter2);
            }
            log.warn('tried to call ' + method + ' for unknown key: ' + journeyKey +
                '. call ' + method + ' for all instead, by leaving the journeyKey');

        };

        return jl;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm')
        .factory('mng-comm.MDVInterchangeRequester', MDVInterchangeRequester);

    MDVInterchangeRequester.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-util.MDVException', 'mng-config.MDVConfig', 'mng-comm.MDVUtil',
        'mng-model.MDVLocation'];

    function MDVInterchangeRequester(MDVLog, MDVUtil, MDVException, MDVConfig,
        MDVCommUtil, MDVLocation) {

        var _private = {
                namespace : 'mng-comm.MDVInterchangeRequester',
                options : {}
            },
            log = MDVLog.register(_private.namespace),
            tr = {
                isReady : isReady,
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function isReady(inputa, inputb) {
            var reasons = [];

            if (!MDVConfig.isReady()) {
                reasons.push(new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                    reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                        'without a valid configuration.'
                }));
            }

            if (inputa) {
                if (!(inputa instanceof MDVLocation)) {
                    reasons.push(new MDVException(MDVException.keys.MNG_COMM__INTERCHANGE.NO_INPUT, {
                        reason : 'Invalid MDVLocation'
                    }));
                    return reasons;
                }
            }


            if (inputb) {
                if (!(inputb instanceof MDVLocation)) {
                    reasons.push(new MDVException(MDVException.keys.MNG_COMM__INTERCHANGE.NO_INPUT, {
                        reason : 'Invalid MDVLocation'
                    }));
                    return reasons;
                }
            }

            if (!inputa && !inputb) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__INTERCHANGE.NO_INPUT, {
                    reason : 'Missing input'
                }));
            }

            // datetime in past should be rejected, too

            return reasons;
        }


        function search(inputa, inputb, options) {
            var reasons = isReady(inputa, inputb),
                mergedOptions;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }
            mergedOptions = getMergedOptions(_private.options, options);

            return _private.request.call(this, inputa, inputb, mergedOptions);
        }

        // ////////////////////////////////

        function getMergedOptions(privateOptions, optionsObj) {
            return angular.extend({}, privateOptions, optionsObj, true);
        }

        _private.getDefaultConfigOption = function(key) {
            switch (key) {
            case 'subservices' :
                return ['mng-comm.itd.json.MDVEFAInterchange'];
            case 'options' :
                return {};
            default :
                return null;
            }
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.modifyResponse = function(response, arglist) {
            return {
                input : arglist,
                response : response
            };
        };


        _private.isValidSubservice = function(subservice) {
            return subservice.hasOwnProperty('search');
        };

        _private.getSubserviceConfig = function() {
            return _private.getConfigOption('subservices');
        };

        _private.request = function(inputa, inputb, options, prio) {
            var subservice;

            try {
                subservice = MDVCommUtil.getSubservice(_private.getSubserviceConfig(), prio, null,
                    MDVException.keys.MNG_COMM__INTERCHANGE);
            } catch (e) {
                if (prio) {
                    throw e;
                }
                return MDVUtil.getRejectedDeferred(e);
            }
            // extra check as multiple subservice types are possible
            if (!_private.isValidSubservice(subservice)) {
                return _private.request(inputa, inputb, options, prio ? prio + 1 : 1);
            }

            return subservice.search(angular.copy(inputa), angular.copy(inputb),
                        angular.copy(options))
                .then(function(response) {
                    if (!response) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__INTERCHANGE.SERVICE_FAILED, {
                            args : [inputa, inputb, options],
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }

                    return _private.modifyResponse(response, [inputa, inputb, options]);
                })
                .catch(function() {
                    // resend request with lower priority
                    return _private.request(inputa, inputb, options, prio ? prio + 1 : 1);
                });
        };

        MDVConfig.ready(function() {
            _private.options = MDVCommUtil.gatherOptions(_private.getConfigOption('options'));
        });

        return tr;
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.service:MDVMessageRequester
     * @requires mng-config.service:MDVConfig
     * @requires mng-util.service:MDVLog
     * @requires mng-util.object:MDVException
     * @requires mng-util.service:MDVUtil
     *
     * @description
     * The `MDVMessageRequester` service is a basic MDV service that provides a list of
     * {@link mng-model.object:MDVMessage MDVMessage}.
     *
     * This service depends on sub-services that provide a specific interface. Which sub-service is
     * used and how this sub-service is configured is defined in the
     * {@link mng-config.service:MDVConfig Configuration}. The sub-service is responsible for
     * fetching the suggestions and parsing them to the {@link mng-model.object:MDVMessage
     * MDVMessage} format.
     * This service cares about caching results and providing a fix interface how the suggestions
     * are returned.
     *
     * The `MDVMessageRequester` API is based on the
     * {@link https://docs.angularjs.org/api/ng/service/$q deferred/ promise APIs} exposed by the $q
     * service. While for simple usage patterns this doesn't matter, for advanced usage it is
     * important to familiarize yourself with these APIs and the guarantees they provide.
     *
     * # General usage
     * The `MDVMessageRequester` service provides a single search function that returns a promise
     * that is resolved to an object that contains a list of {@link mng-model.object:MDVMessage
     * MDVMessage}.
     *
     * ```js
     *   // Simple search request
     *   MDVMessageRequester
     *      .search(options)
     *      .then(function successCallback(response) {
     *          // this callback will be called asynchronously
     *          // when the response is available
     *     }, function errorCallback(response) {
     *          // called asynchronously if an error occurs
     *          // or server returns response with an error status.
     *     });
     * ```
     *
     */
    angular.module('mng-comm')
        .factory('mng-comm.MDVMessageRequester', MDVMessageRequester);

    MDVMessageRequester.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil', 'mng-config.MDVConfig',
        'mng-comm.MDVUtil', 'mng-util.MDVException'];

    function MDVMessageRequester(MDVLog, MDVUtil, MDVConfig, MDVCommUtil, MDVException) {
        var _private = {
                namespace : 'mng-comm.MDVMessageRequester',
                options : MDVCommUtil.gatherOptions({information : false}), // {}
                lastUpdate : null
            },
            log = MDVLog.register(_private.namespace),
            info = {
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name search
         * @methodOf mng-comm.service:MDVMessageRequester
         * @param {Object=} options Additional options that modify the search for information.
         * @returns {Deferred} Deferred, that will be resolved to response object when the
         * transportation list is available
         * or an error occurred. The response has the following parameters:
         * - input: {Object[]} list of inputs that were used for requesting the response.
         * - response: {MDVMessages} list of {@link mng-model.object:MDVMessage MDVMessages}
         * - timestamp: {moment} timestamp when the response was received
         *
         * @description
         * This method implements the abstract interface that is implemented by the configured
         * sub-service. This method is the main method to request MDVMessageRequesters.
         */
        function search(options) {
            var tmp_obj = MDVUtil.copy(_private.options);

            if (!MDVConfig.isReady()) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'Configuration has not yet loaded correctly. Cannot start ' +
                            'requests without a valid configuration.'
                    }));
            }

            return _private.request.call(this, MDVCommUtil.mergeObjects(tmp_obj, options));
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                subservices : ['mng-comm.itd.json.MDVEFAAddInfo']
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);
            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal; //mng-comm.itd.xmljson.MDVEFAAddInfo
        };

        _private.isValidSubservice = function(subservice) {
            return subservice.hasOwnProperty('search');
        };

        _private.getSubserviceConfig = function() {
            return _private.getConfigOption('subservices');
        };

        _private.modifyResponse = function(resultObj, arglist) {
            _private.lastUpdate = resultObj.timestamp;

            return {
                timestamp : _private.lastUpdate,
                response : resultObj.infos,
                input : arglist
            };
        };

        _private.request = function(options, prio) {
            var subservices = _private.getSubserviceConfig(),
                subservice;

            subservice = MDVCommUtil.getSubservice(subservices, prio,
                _private.isValidSubservice.bind(this), MDVException.keys.MNG_COMM__INFO);


            return subservice.search(MDVUtil.copy(options))
                .then(function(response) {
                    if (!response || !response.infos) {
                        throw new MDVException(MDVException.keys.MNG_COMM__LS.SERVICE_FAILED, {
                            args : [options],
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }
                    return _private.modifyResponse(response, [options]);
                })
                .catch(function() {
                    // resend request with lower priority
                    return _private.request(options, prio ? prio + 1 : 1);
                });
        };

        // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
        // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                info._private = _private;
            }
        });

        return info;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm')
        .factory('mng-comm.MDVFormationsRequester', MDVFormationsRequester);

        MDVFormationsRequester.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-util.MDVException', 'mng-config.MDVConfig', 'mng-comm.MDVUtil'];

    function MDVFormationsRequester(MDVLog, MDVUtil, MDVException, MDVConfig,
        MDVCommUtil) {

        var _private = {
                namespace : 'mng-comm.MDVFormationsRequester',
                options : {}
            },
            log = MDVLog.register(_private.namespace),
            tr = {
                isReady : isReady,
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        function isReady(options) {
            var reasons = [];

            if (!MDVConfig.isReady()) {
                reasons.push(new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                    reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                        'without a valid configuration.'
                }));
            }

            if (options) {
                // console.log('check validity of all options');
                // console.log('create the interface of the options objects'); // compare with interchnage Requester service
            }

            if (!options) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__FORMATIONS.NO_OPTIONS, {
                    reason : 'Missing request options'
                }));
            }
            return reasons;
        }


        function search(options) {
            var reasons = isReady(options);

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }
            return _private.request.call(this, options);
        }

        _private.modifyResponse = function(response, arglist) {
            return {
                input : arglist,
                response : response
            };
        };

        _private.getDefaultConfigOption = function(key) {
            switch (key) {
            case 'subservices' :
                return ['mng-comm.itd.json.MDVEFAFormations'];
            case 'options' :
                return {};
            default :
                return null;
            }
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);
            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };


        _private.isValidSubservice = function(subservice) {
            console.log('subservice', subservice);
            return subservice.hasOwnProperty('search');
        };

        _private.getSubserviceConfig = function() {
            return _private.getConfigOption('subservices');
        };

        _private.request = function(options, prio) {
            var subservice;

            try {
                subservice = MDVCommUtil.getSubservice(_private.getSubserviceConfig(), prio, null,
                    MDVException.keys.MNG_COMM__FORMATIONS);
            } catch (e) {
                if (prio) {
                    console.log('e', e);
                    throw e;
                }
                return MDVUtil.getRejectedDeferred(e);
            }

            return subservice.search(angular.copy(options))
                .then(function(response) {
                    if (!response) {
                        response = [];
                        //!!!! resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__FORMATIONS.SERVICE_FAILED, {
                            args : [options],
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }
                    return _private.modifyResponse(response, [options]);
                })
                .catch(function(e) {
                    console.log('e', e);
                    // resend request with lower priority
                    // return _private.request(options, prio ? prio + 1 : 1);
                });
        };

        MDVConfig.ready(function() {
            _private.options = MDVCommUtil.gatherOptions(_private.getConfigOption('options'));
        });

        return tr;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.object:MDVDownload
     * @requires $q
     * @requires $injector
     * @requires mng-util.service:MDVLog
     * @requires mng-config.service:MDVConfig
     * @requires mng-util.object:MDVException
     * @require mng-model.object:MDVOptions
     * @require mng-util.object:MDVUtil
     * @require mng-comm.object:MDVUtil
     * @require mng-model.object:MDVLocation
     *
     *
     *
     * @description
     * The `MDVDownload` service is a basic MDV service that provides a
     * {@link mng-model.object:MDVFile MDVFile} for giving request type.
     *
     * This service depends on sub-services that provide a specific interface. Which sub-service is
     * used and how this sub-service is configured is defined in the
     * {@link mng-config.service:MDVConfig Configuration}. The sub-service is responsible for
     * fetching the file stream and parsing it to the {@link mng-model.object:MDVFile
     * MDVFile} format.
     *
     * The MDVDownload API is based on the {@link https://docs.angularjs.org/api/ng/service/$q
     * deferred/ promise APIs} exposed by the $q service. While for simple usage patterns this
     * doesn't matter, for advanced usage it is important to familiarize yourself with these
     * APIs and the guarantees they provide.
     *
     * # General usage
     * The `MDVDownload` allow to fetch one of the following presentations :
     * - 'TTB' : The TimeTable Booklet for a giving {@link mng-model.object:MDVTransportation
     *     MDVTransportation}.
     * - 'STT' : The Stop Timetable Request for a giving {@link mng-model.object:MDVLocation
     *     MDVLocation} and a specific {@link mng-model.object:MDVTransportation MDVTransportation}.
     * - 'ROP' : The Route Option Plan for a giving {@link mng-model.object:MDVTransportation
     *     MDVTransportation}.
     * - 'PS' : The Personal Schedule for a origin {@link mng-model.object:MDVLocation
     *     origin} and {@link mng-model.object:MDVLocation destination}.
     * - 'MAPROUTE' : The trip overview for  {@link mng-model.object:MDVJourneyLeg
     *     MDVJourneyLeg} or {@link mng-model.object:MDVJourney MDVJourney}.
     *
     *
     * # Sub-services
     * As `MDVDownload` does not fetch the result itself, it uses a defined interface for
     * sub-services. These services provide a `search(downloadType, options)`
     * function that resolves the given {@link mng-model.object:MDVLocation
     * MDVLocation}/{@link mng-model.object:MDVTransportation
     * MDVTransportation} to a {@link mng-model.object:MDVFile MDVFile}.
     * Each service uses a different kind of source for this resolution.
     * Each sub-service needs to implement the following interface structure to assure that it can
     * be attached to this service.
     *  ```js
     *   subservice.search = function (downloadType, options) {
     *      // returns deferred that is resolved to an MDVFile
     *   }
     * ```
     */
    angular.module('mng-comm')
        .factory('mng-comm.MDVDownload', MDVDownload);

    MDVDownload.$inject = ['$q', '$injector', 'mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-config.MDVConfig', 'mng-util.MDVException', 'mng-comm.MDVUtil', 'mng-model.MDVLocation'];

    function MDVDownload($q, $injector, MDVLog, MDVUtil, MDVConfig, MDVException, MDVCommUtil,
            MDVLocation) {
        var log = MDVLog.register('mng-comm.MDVDownload'),
            cache = {},
            _private = {
                odvs : {
                    origin : new MDVLocation(),
                    destination : new MDVLocation()
                },
                ready : false
            },
            downloadObj = {
                search : search,
                updateOrigin : updateOrigin,
                updateDestination : updateDestination,
                requestTypes : getRequestTypesObj(),
                getOptionsByType : getOptionsByType,
                resetByType : resetByType,
                resetOptionsByType : resetOptionsByType
            };

        log.debug('initialize');

        MDVConfig.ready(function() {
            _private.options = MDVCommUtil.gatherOptions(MDVConfig.getValue('mng-comm.MDVDownload.options'));
            _private.ready = true;
        });

        /**
         * @public
         * @ngdoc method
         * @name search
         * @methodOf mng-comm.object:MDVDownload
         * @returns {Deferred} Deferred, that is resolved to a {@link
         * mdv.model.object:MDVFile MDVFile}
         *
         * @param {String} downloadType one of the following presentation files that can be fetched
         * using these services : ['TTB', 'STT', 'ROP', 'PS', 'MAPROUTE']
         *
         * @param {Object} options set of options for the search request
         * @param {String} options.lineId the line id to search for (STT, ROP, TTB).
         * @param {String} options.stopId the stop id to search for (STT, ROP, TTB).
         * @param {MDVJourney} options.journey the {@link mng-model.object:MDVJourney MDVJourney}
         * to search for (MAPROUTE).
         * @param {MDVJourneyLeg} options.leg the {@link mng-model.object:MDVJourneyLeg MDVJourneyLeg}
         * to search for (MAPROUTE).
         *
         * @description
         * This method implements the abstract interface that is implemented by the configured
         * sub-service.
         * It get the corresponding subservice from the giving downloadType and fire his 'search' method
         * to fetch the file.
         *
         *  @returns {Deferred} Deferred, that is resolved to a list of {@link
         * mdv.model.object:MDVFile MDVFile}
         */
        function search(downloadType, options) {
            if (!_private.ready) {
                log.error('Missing config. Fill config first, before you request downloads.');
                return null;
            }
            if (!downloadType) {
                log.error('Missing downloadType : please specify which file you wish to fetch.');
                return null;
            }
            if (!_private.isDownloadTypeValid(downloadType)) {
                log.error('Wrong downloadType : please choose a request type from the list.');
                return null;
            }

            var cacheActive = _private.isCacheActive(downloadType),
                mergedOptions;

            if (!cacheActive) {
                cache = {};
            }
            if (!options) {
                options = {};
            }

            mergedOptions = _private.getMergedOptions(getOptionsByType(downloadType), options);

            if (_private.hasCache(downloadType, mergedOptions)) {
                return _private.getCachedDeferred(downloadType, mergedOptions);
            }

            return _private.request(downloadType, mergedOptions);
        }
        /**
         * @public
         * @ngdoc method
         * @name updateOrigin
         * @methodOf mng-comm.object:MDVDownload
         * @param {MDVLocation} location Location object that should be used as origin for
         * the journey requests.
         * @returns {Boolean} True: successfully updated location, false otherwise
         *
         * @description
         * Update the location the ps-request should start. Please note that only the properties
         * of the location are updated. The reference to the location stays the same to ensure
         * two way data binding.
         * **Note:** *This method is used only for the downloadType = 'PS'.*
         */
        function updateOrigin(location) {
            return MDVCommUtil.updateLocation(_private.odvs.origin, location);
        }
        /**
         * @public
         * @ngdoc method
         * @name updateDestination
         * @methodOf mng-comm.object:MDVDownload
         * @param {MDVLocation} location Location object that should be used as origin for
         * the journey requests.
         * @returns {Boolean} True: successfully updated location, false otherwise
         *
         * @description
         * Update the location the ps-request should end. Please note that only the properties
         * of the location are updated. The reference to the location stays the same to ensure
         * two way data binding.
         * **Note:** *This method is used only for the downloadType = 'PS'.*
         */
        function updateDestination(location) {
            return MDVCommUtil.updateLocation(_private.odvs.destination, location);
        }
        /**
         * @public
         * @ngdoc method
         * @name getRequestTypesObj
         * @methodOf mng-comm.object:MDVDownload
         * @returns {Object} Mapping of downloadTypes
         *
         * @description
         * Get the available download types that can be fetched with this service
         */
        function getRequestTypesObj() {
            return {
                MAPROUTE : 'MapRoute',
                TIMETABLE : 'TTB',
                STOP_TIMETABLE : 'STT',
                ROUTE_OPTION_PLAN : 'ROP',
                PERSONAL_SCHEDULE : 'PS',
                PRINT_TRIP : 'PrintTrip'
            };
        }
        /**
         * @public
         * @ngdoc method
         * @name getOptionsByType
         * @methodOf mng-comm.object:MDVDownload
         * @returns {Object} options
         * @param {String} downloadType one of the following presentation files that can be fetched
         * using these services : ['TTB', 'STT', 'ROP', 'PS', 'MAPROUTE']
         *
         * @description
         * Get the options for a specific downloadType.
         */
        function getOptionsByType(downloadType) {
            if (!_private.isDownloadTypeValid(downloadType)) {
                log.error('Wrong downloadType : please choose a request type from the list.');
                return {};
            }

            if (!_private.options.hasOwnProperty(downloadType)) {
                _private.options[downloadType] =
                                 MDVCommUtil.gatherOptions(_private.getOptionsConfig(downloadType));
            }
            if (downloadType === 'PS') {
                _private.options[downloadType].origin = _private.odvs.origin;
                _private.options[downloadType].destination = _private.odvs.destination;
            }
            return _private.options[downloadType];
        }
        /**
         * @public
         * @ngdoc method
         * @name resetByType
         * @methodOf mng-comm.object:MDVDownload
         * @returns {Boolean}  True: successfully reseted, false otherwise
         * @param {String} downloadType one of the following presentation files that can be fetched
         * using these services : ['TTB', 'STT', 'ROP', 'PS', 'MAPROUTE']
         *
         * @description
         * Reset options, origin, destination for a giving downloadType
         */
        function resetByType(downloadType) {
            if (!_private.isDownloadTypeValid(downloadType)) {
                log.error('Wrong downloadType : please choose a request type from the list.');
                return false;
            }
            resetOptionsByType(downloadType);
            _private.odvs.origin.reset();
            _private.odvs.destination.reset();
        }
        /**
         * @public
         * @ngdoc method
         * @name resetOptionsByType
         * @methodOf mng-comm.object:MDVDownload
         * @param {String} downloadType one of the following presentation files that can be fetched
         * using these services : ['TTB', 'STT', 'ROP', 'PS', 'MAPROUTE']
         * @description
         * Reset only the options for a giving downloadType
         */
        function resetOptionsByType(downloadType) {
            var config = _private.getOptionsConfig(downloadType),
                options = getOptionsByType(downloadType);

            MDVCommUtil.resetOptions(config, options);
        }

        // ////////////////////////////////

        _private.getTypeConfig = function(downloadType) {
            var config = MDVConfig.getValue('mng-comm.MDVDownloads');

            if (!config || !config.hasOwnProperty(downloadType)) {
                return _private.getTypeConfigDefault(downloadType);
            }
            return config[downloadType];
        };

        _private.getTypeConfigDefault = function(downloadType) {
            if (downloadType === 'TTB') {
                return {
                    subservices : ['mng-comm.itd.xmljson.MDVEFATTB'],
                    cache : true
                };
            }
            if (downloadType === 'MapRoute') {
                return {
                    subservices : ['mng-comm.itd.xmljson.MDVEFAMapRoute'],
                    cache : true
                };
            }
            if (downloadType === 'PrintTrip') {
                return {
                    subservices : ['mng-comm.itd.xmljson.MDVEFAPrintTrip'],
                    cache : true
                };
            }
            if (downloadType === 'STT') {
                return {
                    subservices : ['mng-comm.itd.xmljson.MDVEFASTT'],
                    cache : false
                };
            }
            if (downloadType === 'ROP') {
                return {
                    subservices : ['mng-comm.itd.xmljson.MDVEFAROP'],
                    cache : true
                };
            }
            // ps is kind of special request - should be moved to separate requester
            if (downloadType === 'PS') {
                return {
                    subservices : ['mng-comm.itd.xmljson.MDVEFAPS'],
                    cache : true
                };
            }
            return {};
        };

        _private.getSubserviceConfig = function(downloadType) {
            var conf = _private.getTypeConfig(downloadType).subservices;

            if (!conf) {
                conf = [];
            }
            return conf;
        };

        _private.getOptionsConfig = function(downloadType) {
            var conf = _private.getTypeConfig(downloadType).options;

            if (!conf) {
                conf = {};
            }
            return conf;
        };

        _private.modifyResponse = function(response, downloadType, options) {
            return {
                input : options,
                downloadType : downloadType,
                response : response
            };
        };
        _private.isValidSubservice = function(subservice) {
            return subservice.hasOwnProperty('search');
        };

        _private.request = function(downloadType, options, prio) {
            var subservice = MDVCommUtil.getSubservice(_private.getSubserviceConfig(downloadType),
                    prio, _private.isValidSubservice, MDVException.keys.MNG_COMM__DOWNLOAD);

            // delete options.journey.raw;

            return subservice.search(angular.merge({}, getOptionsByType(downloadType), options))
                .then(function(response) {
                    if (!response) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__DOWNLOAD.SERVICE_FAILED, {
                            input : options,
                            downloadType : downloadType,
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }
                    if (_private.isCacheActive(downloadType)) {
                        _private.addCache(response, downloadType, options);
                    }

                    return _private.modifyResponse(response, downloadType, options);
                })
                .catch(function() {
                    // resend request with lower priority
                    return _private.request(downloadType, options, prio ? prio + 1 : 1);
                });
        };

        _private.isCacheActive = function(downloadType) {
            return _private.getTypeConfig(downloadType).cache;
        };

        _private.getCacheKey = function(downloadType, options) {
            var lineId = options.lineId,
                stopId = options.stopId,
                legId = options.leg && options.leg.id(),
                locationId = options.location && options.location.id(),
                journey = options.journey;

            return downloadType.concat(JSON.stringify(lineId) || '')
                    .concat(JSON.stringify(stopId) || '')
                    .concat(JSON.stringify(legId) || '')
                    .concat(JSON.stringify(locationId) || '')
                    .concat(JSON.stringify(getOptionsByType(downloadType)))
                    .concat(_private.odvs.origin.name() || '')
                    .concat(_private.odvs.destination.name() || '')
                    .concat(JSON.stringify(journey) || '');
        };

        _private.addCache = function(response, downloadType, options) {
            if (_private.isCacheActive(downloadType)) {
                cache[_private.getCacheKey(downloadType, options)] = response;
            }
        };

        _private.getCache = function(downloadType, options) {
            return cache[_private.getCacheKey(downloadType, options)];
        };

        _private.hasCache = function(downloadType, options) {
            return cache.hasOwnProperty(_private.getCacheKey(downloadType, options));
        };


        _private.getCachedDeferred = function(downloadType, options) {
            var result = _private.getCache(downloadType, options);

            log.debug('used cached response for downloadType : "' + downloadType +
                          '", line : "' + options.lineId + '" and stop : "' + options.stopId + '"');

            return MDVUtil.getResolvedDeferred(
                                            _private.modifyResponse(result, downloadType, options));
        };

        _private.getMergedOptions = function(privateOptions, optionsObj) {
            return angular.extend({}, privateOptions, optionsObj, true);
        };

        _private.isDownloadTypeValid = function(downloadType) {
            var valid = false;

            angular.forEach(getRequestTypesObj(), function(value) {
                if (value === downloadType || value === downloadType.toUpperCase()) {
                    valid = true;
                }
            });
            return valid;
        };

        return downloadObj;
    }

}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.service:MDVTransportationRequester
     * @requires mng-util.service:MDVLog
     * @requires mng-util.service:MDVUtil
     * @requires mng-util.object:MDVException
     * @requires mng-config.service:MDVConfig
     * @requires mng-model.object:MDVTransportation
     * @requires mng-model.object:MDVLocation
     *
     * @description
     * The `MDVTransportationRequester` service is a basic MDV service that provides a list of
     * {@link mng-model.object:MDVTransportation MDVTransportations} for specific needs. This
     * includes:
     *
     * 1) a specific stop id to get departures.
     *
     * 2) a specific line name to get a cooresponding {@link mng-model.object:MDVTransportation
     * MDVTransportation}
     *
     * 3) a specific {@link mng-model.object:MDVTransportation MDVTransportation} object to get more
     * information like coord or stop sequence.
     *
     * If you use the 'search' method, you have to pass the correct input type for the case you want.
     *
     * For a better interface, every case (and more cases) can be requested directly by the specific
     * methods (see below).
     *
     * **Note** *It might be needed to include the correct sub-services for a special call. If no
     * or an invalid sub-service is configured, the methods may not work as expected.*
     *
     * This service depends on sub-services that provide a specific interface. Which sub-service is
     * used and how this sub-service is configured is defined in the
     * {@link mng-config.service:MDVConfig Configuration}. The sub-service is responsible for
     * fetching the lists and parsing them to the {@link mng-model.object:MDVTransportation
     * MDVTransportation} format.
     *
     * The MDVTransportationRequester API is based on the {@link https://docs.angularjs.org/api/ng/service/$q
     * deferred/ promise APIs} exposed by the $q service. While for simple usage patterns this
     * doesn't matter, for advanced usage it is important to familiarize yourself with these
     * APIs and the guarantees they provide.
     *
     */
    angular.module('mng-comm')
        .factory('mng-comm.MDVTransportationRequester', MDVTransportationRequester);

    MDVTransportationRequester.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-util.MDVException', 'mng-model.MDVTransportation', 'mng-model.MDVLocation',
        'mng-config.MDVConfig', 'mng-comm.MDVUtil'];

    function MDVTransportationRequester(MDVLog, MDVUtil, MDVException, MDVTransportation,
            MDVLocation, MDVConfig, MDVCommUtil) {

        var _private = {
                namespace : 'mng-comm.MDVTransportationRequester'
            },
            log = MDVLog.register(_private.namespace),
            tr = {
                isReady : isReady,
                search : search,
                getDepartures : getDepartures,
                getServingLines : getServingLines,
                getStopSequence : getStopSequence,
                getLine : getLine,
                getLineGeometry : getLineGeometry,
                getSelTT : getSelTT,
                getLineList: getLineList
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name isReady
         * @methodOf mng-comm.service:MDVTransportationRequester
         * @param {Object} obj MDVLocation or String(lineId) :
         * element that should be used for the request
         * @returns {MDVException[]} List of exceptions that describe, why the departure-request
         * cannot yet be sent. Empty list, when everything is fine.
         *
         * @description
         * Determine whether the departure-request can be sent or not.
         */
        function isReady(obj) {
            var reasons = [];

            if (!MDVConfig.isReady()) {
                reasons.push(new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                    reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                        'without a valid configuration.'
                }));
            }

            if (!obj) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__DM.NO_INPUT, {
                    reason : 'no element passed to the search method'
                }));
            } else if (typeof obj !== 'string' && !(obj instanceof MDVLocation) &&
                    !(obj instanceof MDVTransportation) && obj.constructor !== Array &&
                    !(obj.origin && obj.origin instanceof MDVLocation &&
                        obj.destination && obj.destination instanceof MDVLocation)) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__DM.NO_INPUT, {
                    input : obj,
                    reason : 'invalid input type. expected "string", Array, MDVLocation,' +
                        ' MDVTransportation or object (with origin and destination location) instead'
                }));
            }

            return reasons;
        }

        /**
         * @public
         * @ngdoc method
         * @name search
         * @methodOf mng-comm.service:MDVTransportationRequester
         * @param {Object} obj MDVLocation or lineId that the transportations should be requested for
         * @param {Object} options Additional options to modify the request
         * @param {String} options.type the request type (not required)
         * @returns {Deferred} Deferred, that will be resolved to response object when the
         * transportation list is available
         * or an error occurred. The response has the following parameters:
         * - input: {Object[]} list of inputs that were used for requesting the response.
         * - response: {@link mdv.model.object:MDVTransportation MDVTransportations}} list of
         * MDVTransportations objects.
         *
         * @description
         * This method implements the abstract interface that is implemented by the configured
         * sub-service.
         */
        function search(obj, options) {
            var reasons = isReady(obj, options),
                type = options && options.type;

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }
            return _private.request.call(this, obj, options, type);
        }

        function getDepartures(input, options) {
            return _private.directRequest('MDVEFADM', input, options);
        }

        function getLine(input, options) {
            if (MDVCommUtil.getDirectSubservice('MDVEFAServingLines')) {
                return _private.directRequest('MDVEFAServingLines', input, options);
            }
            return _private.directRequest('MDVEFASELTT', input, options);
        }

        function getLineList(input, options) {
            if (MDVCommUtil.getDirectSubservice('MDVEFALineList')) {
                return _private.directRequest('MDVEFALineList', input, options);
            }
            return _private.directRequest('MDVEFALineList', input, options);
        }

        function getLineGeometry(input, options) {
            return _private.directRequest('MDVEFAGeoObject', input, options);
        }

        function getServingLines(input, options) {
            return _private.directRequest('MDVEFAServingLines', input, options);
        }

        /**
         * @public
         * @ngdoc method
         * @name getStopSequence
         * @methodOf mng-comm.service:MDVTransportationRequester
         * @param {Object} input MDVLocation the stop sequence starts/ends
         * @param {Object} options Additional options to modify the request
         * @param {MDVTransportation} options.transportation the transportation the stop sequence
         * should be requested for. This transportation needs to provide a 'properties/tripCode'
         * value to define the specific route of the transportation. (required)
         * @param {Boolean} options.isDeparture flag if the follow up stop sequence (true) or the
         * previous stop sequence (false) should be requested. if this property is not set
         * (default), the complete stop sequence for the whole transportation is requested.
         * @param {Object} options.dateTime departure/arrival date/time of the transportation at the
         * specified stop. If no dateTime is passed, it defaults to the current date and no time.
         *
         * @returns {Deferred} Deferred, that will be resolved to a response object when the
         * stop sequence list is available. The response contains the following parameters:
         * - transportation: {MDVTransportation} transportation object containing a coordinate list
         * describing the route of the transportation and containing a list of MDVLocation objects
         * in locationSequence. Please note, that both properties may not describe the information
         * of the complete transportation, depending on the input-parameter "isDepartrure". The
         * properties are filled by previous/onward locations only if "isDeparture" is set.
         * - prevStopSeq: {@link mdv.model.object:MDVLocation MDVLocations}} list of
         * MDVLocation objects that are passed by the transportation before the given location.
         * - onwardStopSeq: {@link mdv.model.object:MDVLocation MDVLocations}} list of
         * MDVLocation objects that are passed by the transportation after the given location
         * (including the given location).
         *
         * Please note that prevStopSeq and onwardStopSeq are only filled if the passed location
         * provides a departureTime.
         *
         * @description
         * Request all stops that are passed and the coordinate sequence of the route of a given
         * transportation.
         */
        function getStopSequence(input, options) {
            return _private.directRequest('MDVEFAStopSeqCoord', input, options);
        }

        function getSelTT(input, options) {
            log.warn('SELTT is depreciated and should not be used anymore. use SERVINGLINES instead.');
            return _private.directRequest('MDVEFASELTT', input, options);
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                subservices : ['mng-comm.itd.json.MDVEFAServingLines',
                    'mng-comm.itd.json.MDVEFAGeoObject',
                    'mng-comm.itd.json.MDVEFALineList']
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.modifyResponse = function(response, arglist) {
            return {
                input : arglist,
                response : response
            };
        };


        _private.isValidSubservice = function(subservice) {
            return subservice.hasOwnProperty('searchLines');
        };

        _private.getSubserviceConfig = function() {
            var conf = _private.getConfigOption('subservices');

            if (!conf) {
                conf = ['mng-comm.itd.json.MDVEFADM',  // by stop
                    'mng-comm.itd.xmljson.MDVEFASELTT',  // by name
                    'mng-comm.itd.xmljson.MDVEFAGeoObject'];  // by transportation (to get coords)
            }
            return conf;
        };

        _private.sendRequest = function(subservice, obj, options, type) {
            return subservice.searchLines(angular.copy(obj), MDVUtil.copy(options), type)
                .then(function(response) {
                    if (!response) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__LS.SERVICE_FAILED, {
                            args : [options, obj, type],
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }

                    return _private.modifyResponse(response, [options, obj, type]);
                });
        };

        _private.request = function(obj, options, type, prio) {
            var subservice;

            try {
                subservice = MDVCommUtil.getSubservice(_private.getSubserviceConfig(), prio, null,
                    MDVException.keys.MNG_COMM__DM);
            } catch (e) {
                if (prio) {
                    throw e;
                }
                return MDVUtil.getRejectedDeferred(e);
            }
            // extra check as multiple subservice types are possible
            if (!_private.isValidSubservice(subservice)) {
                return _private.request(obj, options, type, prio ? prio + 1 : 1);
            }

            return _private.sendRequest(subservice, obj, options, type)
                .catch(function() {
                    // resend request with lower priority
                    return _private.request(obj, options, type, prio ? prio + 1 : 1);
                });
        };

        // convenient functions for direct subservice-requests
        _private.directRequest = function(subserviceName, input, options, type) {
            var subservice = MDVCommUtil.getDirectSubservice(subserviceName);

            if (!subservice) {
                return MDVUtil.getRejectedDeferred('no subservice found for ' + subserviceName);
            }
            return _private.sendRequest(subservice, input, options, type);
        };

        // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
        // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                tr._private = _private;
            }
        });

        return tr;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.object:MDVDepartures
     * @requires $q
     * @requires $injector
     * @requires mng-config.service:MDVConfig
     * @requires mng-util.service:MDVLog
     * @requires mng-util.object:MDVException
     * @requires mng-model.object:MDVLocation
     * @requires mng-comm.service:MDVUtil
     * @requires mng-comm.service:MDVDepartureRequester
     *
     * @description
     * The `MDVDepartures` service is a basic MDV service that provides a list of
     * {@link mng-model.object:MDVDeparture MDVDepartures} for a specific stop
     * {@link mng-model.object:MDVLocation location}.
     *
     * This service depends on sub-services that provide a specific interface. Which sub-service is
     * used and how this sub-service is configured is defined in the
     * {@link mng-config.service:MDVConfig Configuration}. The sub-service is responsible for
     * fetching the lists and parsing them to the {@link mng-model.object:MDVDeparture
     * MDVDeparture} format.
     *
     * The MDVDepartures API is based on the {@link https://docs.angularjs.org/api/ng/service/$q
     * deferred/ promise APIs} exposed by the $q service. While for simple usage patterns this
     * doesn't matter, for advanced usage it is important to familiarize yourself with these
     * APIs and the guarantees they provide.
     *
     * # General usage
     * The `MDVDepartures` object provides a three trigger functions to start departure requests:
     * - `search()`
     * This function describes the initial departure request to fill the internal {@link
     * mng-model.object:MDVDeparture MDVDeparture} list.
     * - `previous()`
     * This function adds {@link mng-model.object:MDVDeparture MDVDepartures} that are before the
     * internal referenced {@link mng-model.object:MDVDeparture MDVDepartures}.
     * - `next()`
     * This function adds new {@link mng-model.object:MDVDeparture MDVDepartures} that are after the
     * internal referenced {@link mng-model.object:MDVDeparture MDVDepartures}.
     *
     * All results of these three functions are added to an internal result list of {@link
     * mng-model.object:MDVDeparture MDVDepartures} for a given {@link mng-model.object:MDVLocation
     * MDVLocation}.
     *
     * ```js
     *   // Simple search departures request
     *   var departures = MDVDepartures.getResults();
     *   MDVDepartures.updateLocation(new MDVLocation({
     *      name : 'Main Station',
     *      id : '123456789'
     *   })
     *   MDVDepartures.search();  // fill the internal results list
     *   MDVDepartures.next();  // request the next departures and append them to the internal list
     * ```
     *
     * # Sub-services
     * As `MDVDepartures` does not fetch the result itself, it uses a defined interface for
     * sub-services. These services provide a `searchDepartures({@link mng-model.object:MDVLocation
     * MDVLocation})` function that resolves the given {@link mng-model.object:MDVLocation
     * MDVLocation} to a plain list of {@link mng-model.object:MDVDeparture MDVDepartures}.
     * Each service uses a different kind of source for this resolution.
     * Each sub-service needs to implement the following interface structure to assure that it can
     * be attached to this service.
     *
     * ```js
     *   subservice.searchDepartures = function (location) {  // {MDVLocation} location
     *      // returns deferred that is resolved to a list of MDVDepartures.
     *   }
     * ```
     *
     * See the {@link mng-comm.itd.xmljson.service:MDVEFADM MDVEFADM} service that provides
     * suggestions from an EFA interface.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm.MDVDepartures` and interprets the following sub-keys:
     *
     * ## {String[]} subservices
     * Service the departure object should use to get the lists. Right now, only the
     * sub-service-key 'mng-comm.itd.xmljson.MDVEFADM' is supported. In the future more
     * MDVDepartures sources can be implemented. The array describes a fall back procedure.
     * If the first element in the array does not provide an appropriate response, the next
     * sub-service is used to get a better result.
     *
     * The sub-service key needs to be exactly the name the service is assigned to. To resolve the
     * given name, AngularJs's {@link https://docs.angularjs.org/api/auto/service/$injector
     * $injector} service is used.
     *
     * ## {Object} options
     * Options that should be available to the controllers in order to modify the requests by
     * front-end controls or inputs. Please refer to {@link mng-comm.object:MDVOptions
     * MDVOptions} for further details, to see how the options should be configured/ changed.
     *
     * ## Example:
     * ```js
     *   // configuration object
     *   ...
     *   "MDVDepartures" : {
     *      "subservices" : ["mng-comm.itd.xmljson.MDVEFADM"], // only use EFA sub-service,
     *      "options" : {
     *          dateTime: true  // use global date/time settings. Please note that the "isDeparture"
     *                          // option has no effect as it is set internally to "true"
     *      }
     *   },
     *   ...
     * ```
     *
     * @example
<example module="MDVDeparturesExample">
<file name="index.html">
  <div ng-controller="DepartureController">
    <div ng-show="departures && departures.length > 0">
        Departures:
        <ul><li ng-repeat="departure in departures track by $index">{{departure.dateTime() |
        amDateFormat : 'hh:mm'}} from {{departure.location().name()}} with
        line {{departure.transportation().name()}}.</li></ul>
    </div>
  </div>
</file>
<file name="script.js">
    // mng-comm.itd needs to be included to find mng-comm.itd.xmljson.MDVEFAStopfinder
    angular.module('MDVDeparturesExample', ['angularMoment', 'mng-comm',
      'mng-comm.itd.xmljson','mng-comm.itd', 'mng-model'])
      .controller('DepartureController', DepartureController);

    // mng-config.MDVConfig normally needs not to be injected as the configuration is loaded by the
    // mng-config.MDVConfigFetcher
    DepartureController.$inject = ['$scope', 'mng-comm.MDVDepartures', 'mng-config.MDVConfig',
      'mng-model.MDVLocation'];

    function DepartureController($scope, MDVDepartures, MDVConfig, MDVLocation) {
        // set configuration. this is normally done by loading the Config with the
        // mng-config.MDVConfigFetcher
        MDVConfig.setValue('mng-comm.MDVDepartures', {
            subservices : ['mng-comm.itd.xmljson.MDVEFADM']
        });

        MDVConfig.setValue('mng-comm-itd.MDVEFARequester', {
            'url' : '/mngnsw'
        });
        MDVConfig.setValue('mng-comm-itd-xmljson', {
            defaultParams: {
                outputFormat: 'json'
            },
            'MDVEFADM' : {
                'url': '/XML_DM_REQUEST?',
                defaultParams: {
                    mode: 'direct',
                    type_dm: 'any',
                    limit: '10'
                }
            }
        });


        var mdvDepartures = new MDVDepartures();
        // bind results to scope
        $scope.departures = mdvDepartures.getResults();

        // set location for departures
        mdvDepartures.updateLocation(new MDVLocation({
            id : '10101100',
            name : 'location'
        }));

        // search for departures
        mdvDepartures.search();

        // append some more departures after 15 seconds
        setTimeout(function() {
            mdvDepartures.next();
        }, 15000);
    }
</file>
</example>
     *
     */
    angular.module('mng-comm')
        .factory('mng-comm.MDVDepartures', MDVDepartures);

    MDVDepartures.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-model.MDVLocation', 'mng-util.MDVException', 'mng-comm.MDVUtil',
        'mng-comm.MDVDepartureRequester'];

    function MDVDepartures(MDVLog, MDVConfig, MDVLocation, MDVException, MDVUtil,
            MDVDepartureRequester) {
        var namespace = 'mng-comm.MDVDepartures',
            log = MDVLog.register(namespace);

        log.debug('initialize');

        return function(/* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var dep = {
                    // public methods
                    clearResults : clearResults,
                    getResults : getResults,
                    getOptions : getOptions,
                    next : next,
                    reset : reset,
                    resetOptions : resetOptions,
                    search : search,
                    updateLocation : updateLocation,
                    getLocation : getLocation,
                    addTransportation : addTransportation,
                    removeTransportation : removeTransportation
                    // previous : previous,  // not yet available via EFA interface
                },
                _private = {
                    // private methods that need to be public to allow MDVArrivals and
                    // MDVServingLines to override them for their needs
                    namespace : namespace,
                    getConfigOption : getConfigOption,
                    getDefaultConfigOption : getDefaultConfigOption,
                    getTimeOptions : getTimeOptions,
                    options : {},
                    loc : new MDVLocation(),
                    result : [],
                    transportations : []
                };

            // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate === true) {
                dep._private = _private;
            }

            MDVConfig.ready(function() {
                _private.options = MDVUtil.gatherOptions(_private.getConfigOption('options'));
            });

            function getDefaultConfigOption(key) {
                var defConfig = {
                    options : {
                        dateTime : true
                    }
                };

                if (!key) {
                    return defConfig;
                }
                if (defConfig.hasOwnProperty(key)) {
                    return defConfig[key];
                }
                return null;
            }

            function getConfigOption(key) {
                var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

                if (!configVal) {
                    return _private.getDefaultConfigOption(key);
                }
                return configVal;
            }

            /**
             * @public
             * @ngdoc method
             * @name addTransportation
             * @methodOf mng-comm.object:MDVDepartures
             * @param {MDVTransportation} transportation Transportation object
             * that should be added to the internal transportations list.
             *
             * @description
             * Add one transportation to the internal transportations list.
             */
            function addTransportation(transportation) {
                if (!transportation) {
                    return; // @todo
                }
                var transportationIdx = hasTransportation(transportation);

                if (transportationIdx === -1) {
                    _private.transportations.push(transportation);
                }

            }

            /**
             * @public
             * @ngdoc method
             * @name removeTransportation
             * @methodOf mng-comm.object:MDVDepartures
             * @param {MDVTransportation} transportation Transportation object
             * that should be removed from the internal transportations list.
             *
             * @description
             * Remove one or all transportation from the internal transportations list.
             */
            function removeTransportation(transportation) {
                if (!transportation) {
                    _private.transportations.length = 0;
                    return;
                }

                var transportationIdx = hasTransportation(transportation);

                if (transportationIdx > -1) {
                    _private.transportations.splice(transportationIdx, 1);
                }
            }

            /**
             * @public
             * @ngdoc method
             * @name clearResults
             * @methodOf mng-comm.object:MDVDepartures
             *
             * @description
             * Remove all results that are stored in the internal result list
             */
            function clearResults() {
                _private.result.length = 0;
                _private.transportations.length = 0;
            }
            /**
             * @public
             * @ngdoc method
             * @name getResults
             * @methodOf mng-comm.object:MDVDepartures
             * @returns {MDVDepartures[]} reference to the {@link mdv.model.object:MDVDeparture
             * MDVDepartures} list.
             *
             * @description
             * Get a reference to the {@link mng-model.object:MDVDeparture MDVDepartures} list. This
             * list is filled by the 'search', 'previous' and 'next' method.
             */
            function getResults() {
                return _private.result;
            }
            /**
             * @public
             * @ngdoc method
             * @name getOptions
             * @methodOf mng-comm.object:MDVDepartures
             * @returns {Object} Reference to the options that are used for requesting the
             * departures.
             *
             * @description
             * Get a reference to the Options that are used for departure requests.
             */
            function getOptions() {
                return _private.options;
            }


            function getTimeOptions(time, isDeparture) {
                var datetime = time.clone();  // avoid changes to original time object

                if (isDeparture) {
                    datetime.add(1, 'minutes');
                } else {
                    datetime.subtract(1, 'minutes');
                }
                return {
                    dateTime : {
                        date : datetime,
                        time : datetime,
                        dateFormat : null,
                        timeFormat : null,
                        isDeparture : isDeparture
                    }
                };
            }

            /**
             * @public
             * @ngdoc method
             * @name next
             * @methodOf mng-comm.object:MDVDepartures
             * @returns {Deferred} Deferred, that is resolved to a list of {@link
             * mdv.model.object:MDVDeparture MDVDepartures}
             *
             * @description
             * Update the internal {@link mdv.model.object:MDVDeparture MDVDepartures} list by
             * appending more {@link mdv.model.object:MDVDeparture MDVDepartures} at the end of the
             * {@link mdv.model.object:MDVDeparture MDVDepartures} list.
             * The request-result the deferred is resolved with may be different to the internal
             * result-list as it describes the request-results only, without the already loaded
             * {@link mdv.model.object:MDVDeparture MDVDepartures}.
             * The best way to use the results is to get a reference to the internal result list
             * (by the 'getResults' method) and use the two-way data binding. The request-result,
             * the deferred is resolved with, should only be used for additional functionality, like
             * highlighting the latest updates.
             */
            function next() {
                if (_private.result.length === 0) {
                    log.warn('next() called, but no previous results available (or only ' +
                        'alternative results). send initial request instead.');
                    return search();
                }

                var mergedOptions = MDVUtil.mergeObjects(_private.options,
                    _private.getTimeOptions(_private.result[_private.result.length - 1].dateTime(), true));

                // add transportations
                mergedOptions.transportations = _private.transportations;

                return MDVDepartureRequester.search(angular.copy(_private.loc), mergedOptions)
                    .then(_private.nextSuccess.bind(this));
            }

            /**
             * @public
             * @ngdoc method
             * @name reset
             * @methodOf mng-comm.object:MDVDepartures
             *
             * @description
             * Reset location and remove all requested journeys.
             */
            function reset() {
                _private.loc.reset();
                dep.clearResults();
                dep.resetOptions();
            }
            /**
             * @public
             * @ngdoc method
             * @name resetOptions
             * @methodOf mng-comm.object:MDVDepartures
             *
             * @description
             * Reset Options to the default values.
             */
            function resetOptions() {
                if (!MDVConfig.isReady()) {
                    return;
                }
                var config = _private.getConfigOption('options');

                MDVUtil.resetOptions(config, _private.options);
            }
            /**
             * @public
             * @ngdoc method
             * @name search
             * @methodOf mng-comm.object:MDVDepartures
             * @param {Object} options optional options to modify the default configured options
             * @returns {Deferred} Deferred, that is resolved to a list of {@link
             * mdv.model.object:MDVDeparture MDVDepartures}
             *
             * @description
             * This method implements the abstract interface that is implemented by the configured
             * sub-service.
             * It updates the internal result list and resolves the deferred with the result of the
             * request. This request-result may be different to the internal result-list as it
             * returns the request-results only.
             *
             * The best way to use the results is to get a reference to the internal result list
             * (by the 'getResults' method) and use the two-way data binding. The request-result,
             * the deferred is resolved with, should only be used for additional functionality, like
             * highlighting the latest updates.
             */
            function search(options) {
                if (!_private.loc.id()) {
                    throw new MDVException(MDVException.keys.MNG_COMM__DM.NO_INPUT);
                }
                var mergedOptions = MDVUtil.mergeObjects(_private.options, options || {});

                // clear results
                _private.result.length = 0;
                // add transportations
                mergedOptions.transportations = _private.transportations;
                return MDVDepartureRequester.search(angular.copy(_private.loc), mergedOptions)
                    .then(searchSuccess.bind(this));
            }

            /**
             * @public
             * @ngdoc method
             * @name updateLocation
             * @methodOf mng-comm.object:MDVDepartures
             * @param {MDVLocation} location Location object that should be the new location for the
             * departures
             * @returns {Boolean} True: successfully updated location, false otherwise
             *
             * @description
             * Update the location the departures are at. Please note that only the properties of
             * the location are updated. The reference to the location stays the same to ensure
             * two way data binding.
             */
            function updateLocation(location) {
                var success = MDVUtil.updateLocation(_private.loc, location);

                if (isBoolTrue(success)) {
                    _private.options.odvs = {};
                    _private.options.odvs.dm = location.id();
                }
                return success;
            }

            function isBoolTrue(value) {
                return value && (typeof value === 'boolean');
            }

            /**
             * @public
             * @ngdoc method
             * @name getLocation
             * @methodOf mng-comm.object:MDVDepartures
             * @returns {MDVLocation} location Location object.
             *
             * @description
             * Get the location object used to fetch the Departures.
             */
            function getLocation() {
                return _private.loc;
            }

            function searchSuccess(results) {
                var i,
                    l;

                if (results.response) {
                    for (i = 0, l = results.response.length; i < l; i += 1) {
                        _private.result.push(results.response[i]);
                    }
                }
                return results;
            }
            _private.nextSuccess = function(results) {
                var i,
                    l,
                    to_delete = [];

                for (i = 0, l = results.response.length; i < l; i += 1) {
                    if (MDVUtil.isNewResult(_private.result, results.response[i])) {
                        _private.result.push(results.response[i]);
                    } else {
                        log.info('ignored duplicate response');
                        log.info(results.response[i], true);
                        to_delete.push(i);
                    }
                }
                for (i = to_delete.length - 1; i >= 0; i -= 1) {
                    results.response.splice(to_delete[i], 1);
                }

                return results;
            };

            function hasTransportation(transportation) {
                var i,
                    l;

                for (i = 0, l = _private.transportations.length; i < l; i += 1) {
                    if (transportation.equals(_private.transportations[i])) {
                        return i;
                    }
                }
                return -1;
            }

            return dep;
        };
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.service:MDVDepartureRequester
     * @requires mng-util.object:MDVException
     * @requires mng-util.service:MDVLog
     * @requires mng-util.service:MDVUtil
     * @requires mng-config.service:MDVConfig
     * @requires mng-comm.service:MDVUtil
     * @requires mng-model.object:MDVLocation
     *
     * @description
     * The `MDVDepartureRequester` service is a basic MDV service that provides a list of
     * {@link mng-model.object:MDVDeparture MDVDepartures} for a specific stop
     * {@link mng-model.object:MDVLocation location} and a set of {@link mng-comm.object:MDVOptions
     * options}.
     *
     * This service depends on sub-services that provide a specific interface. Which sub-service is
     * used and how this sub-service is configured is defined in the
     * {@link mng-config.service:MDVConfig Configuration}. The sub-service is responsible for
     * fetching the lists and parsing them to the {@link mng-model.object:MDVDeparture
     * MDVDeparture} format.
     *
     * The MDVDepartures API is based on the {@link https://docs.angularjs.org/api/ng/service/$q
     * deferred/ promise APIs} exposed by the $q service. While for simple usage patterns this
     * doesn't matter, for advanced usage it is important to familiarize yourself with these
     * APIs and the guarantees they provide.
     *
     */
    angular.module('mng-comm')
        .factory('mng-comm.MDVDepartureRequester', MDVDepartureRequester);

    MDVDepartureRequester.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil', 'mng-config.MDVConfig',
        'mng-model.MDVLocation', 'mng-util.MDVException', 'mng-comm.MDVUtil'];

    function MDVDepartureRequester(MDVLog, MDVUtil, MDVConfig, MDVLocation, MDVException, MDVCommUtil) {
        var _private = {
                namespace : 'mng-comm.MDVDepartureRequester'
            },
            log = MDVLog.register(_private.namespace),
            dr = {
                isReady : isReady,
                search : search
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name isReady
         * @methodOf mng-comm.service:MDVDepartureRequester
         * @param {MDVLocation} location Location the departures should be requested for
         * @returns {MDVException[]} List of exceptions that describe, why the departure-request
         * cannot yet be sent. Empty list, when everything is fine.
         *
         * @description
         * Determine whether the departure-request can be sent or not.
         */
        function isReady(location) {
            var reasons = [];

            if (!MDVConfig.isReady()) {
                reasons.push(new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                    reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                        'without a valid configuration.'
                }));
            }

            if (!location) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__DM.NO_INPUT, {
                    reason : 'no element passed to the search method'
                }));
            } else if (!(location instanceof MDVLocation)) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__DM.NO_INPUT, {
                    input : location,
                    reason : 'invalid input type. expected MDVLocation'
                }));
            }

            return reasons;
        }

        /**
         * @public
         * @ngdoc method
         * @name search
         * @methodOf mng-comm.service:MDVDepartureRequester
         * @param {MDVLocation} location Location the departures should be requested for
         * @param {Object} options Additional options to modify the request
         * @returns {Deferred} Deferred, that will be resolved to response object when the
         * transportation list is available
         * or an error occurred. The response has the following parameters:
         * - input: {Object[]} list of inputs that were used for requesting the response.
         * - response: {{@link mdv.model.object:MDVDeparture MDVDepartures}} list of
         * MDVDeparture objects.
         *
         * @description
         * This method implements the abstract interface that is implemented by the configured
         * sub-service.
         * It updates the internal result list and resolves the deferred with the result of the
         * request. This request-result may be different to the internal result-list as it
         * returns the request-results only.
         *
         * The best way to use the results is to get a reference to the internal result list
         * (by the 'getResults' method) and use the two-way data binding. The request-result,
         * the deferred is resolved with, should only be used for additional functionality, like
         * highlighting the latest updates.
         */
        function search(location, options) {
            var reasons = isReady(location, options);

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }
            if (options.dateTime && options.dateTime.isDeparture === false) {
                return _private.request.call(this, location, options, false);
            }
            return _private.request.call(this, location, options, true);
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                subservices : ['mng-comm.itd.json.MDVEFADM'],
                rejectEmptyResponses : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.getSubserviceConfig = function() {
            return _private.getConfigOption('subservices') || [];
        };

        _private.isValidSubservice = function(subservice, isDeparture) {
            if (isDeparture) {
                return subservice.hasOwnProperty('searchDepartures');
            }
            return subservice.hasOwnProperty('searchArrivals');
        };

        _private.modifyResponse = function(response, arglist) {
            return {
                input : arglist,
                systemMessages : response.systemMessages,
                response : response.departures || response.arrivals,
                location : response.location,
                lines : response.lines
            };
        };

        _private.request = function(location, options, isDeparture, prio, prevError) {
            var subservices = _private.getSubserviceConfig(isDeparture),
                subservice,
                method = isDeparture? 'searchDepartures' : 'searchArrivals',
                invalidInterfaceException;

            try {
                subservice = MDVCommUtil.getSubservice(subservices,
                    prio, null, MDVException.keys.MNG_COMM__DM);
            } catch (e) {
                if (prio && prio >= subservices.length && prevError) {
                    throw prevError;
                }
                if (prio) {
                    throw e;
                }
                return MDVUtil.getRejectedDeferred(e);
            }

            if (!_private.isValidSubservice(subservice, isDeparture)) {
                invalidInterfaceException = new MDVException(MDVException.keys.MNG_COMM__DM.NO_SERVICE, {
                    reason : 'configured service does not match interface definition of this service'
                });
            }
            if (invalidInterfaceException && prio) {
                // already in fallback deferred, throw exception
                throw invalidInterfaceException;
            }
            if (invalidInterfaceException) {
                // initial call, reject deferred
                return MDVUtil.getRejectedDeferred(invalidInterfaceException);
            }

            return subservice[method](angular.copy(location), angular.copy(options))
                .then(function(response) {
                    if (!response) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__DM.SERVICE_FAILED, {
                            args : [options, location],
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }
                    if (_private.getConfigOption('rejectEmptyResponses') &&
                            ((response.departures && !response.departures.length) ||
                                (response.arrivals && !response.arrivals.length)) &&
                            response.systemMessages.length) {
                        // no trips, but system messages -> throw exception with messages
                        throw new MDVException(MDVException.keys.MNG_COMM__LS.SERVICE_FAILED, {
                            args : [options, location],
                            service : subservice.name,
                            reason : 'no results due to backend errors',
                            data : response.systemMessages
                        });
                    }

                    return _private.modifyResponse(response, [options, location]);
                })
                .catch(function(error) {
                    // resend request with lower priority
                    return _private.request(location, options, isDeparture, prio ? prio + 1 : 1, error);
                });
        };

        // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
        // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
        MDVConfig.ready(function() {
            if (MDVConfig.getValue('mng-comm.MDVDepartureRequester.privateMode') === true) {
                dr._private = _private;
            }
        });

        return dr;
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.object:MDVArrivals
     * @requires mng-util.service:MDVLog
     * @requires mng-config.service:MDVConfig
     * @requires mng-comm.service:MDVUtil
     * @requires mng-com.service:MDVDepartureRequester
     * @requires mng-com.object:MDVDepartures
     *
     * @description
     * The `MDVArrivals` service is a basic MDV service that provides a list of
     * {@link mng-model.object:MDVArrival MDVArrivals} for a specific stop
     * {@link mng-model.object:MDVLocation location}. `MDVArrivals` bases on the
     * {@link mng-comm.service:MDVDepartures MDVDepartures} factory and includes all methods of it,
     * excpet 'next'. Please see the documentation of {@link mng-comm.service:MDVDepartures
     * MDVDepartures} for the inherited methods.
     *
     * This service depends on sub-services that provide a specific interface. Which sub-service is
     * used and how this sub-service is configured is defined in the
     * {@link mng-config.service:MDVConfig Configuration}. The sub-service is responsible for
     * fetching the lists and parsing them to the {@link mng-model.object:MDVArrival
     * MDVArrival} format.
     *
     * The MDVArrivals API is based on the {@link https://docs.angularjs.org/api/ng/service/$q
     * deferred/ promise APIs} exposed by the $q service. While for simple usage patterns this
     * doesn't matter, for advanced usage it is important to familiarize yourself with these
     * APIs and the guarantees they provide.
     *
     * # General usage
     * The `MDVArrivals` object provides a three trigger functions to start arrival requests:
     * - search()
     * This function describes the initial arrival request to fill the internal {@link
     * mng-model.object:MDVArrival MDVArrival} list.
     * - previous()
     * This function adds {@link mng-model.object:MDVArrival MDVArrivals} that are before the
     * internal {@link mng-model.object:MDVArrival MDVArrivals}.
     * - next()
     * This function adds new {@link mng-model.object:MDVArrival MDVArrivals} that are after the
     * internal {@link mng-model.object:MDVArrival MDVArrivals}.
     *
     * All results of these three functions are added to an internal result list of {@link
     * mng-model.object:MDVArrival MDVArrivals} for a given {@link mng-model.object:MDVLocation
     * MDVLocation}.
     *
     * ```js
     *   // Simple search arrivals request
     *   var arrivals = MDVArrivals.getResults();
     *   MDVArrivals.updateLocation(new MDVLocation({
     *      name : 'Main Station',
     *      id : '123456789'
     *   })
     *   MDVArrivals.search();  // request arrivals for the updated location
     *   MDVArrivals.previous();  // get arrivals previous to the list that was already requested
     * ```
     *
     * # Sub-services
     * As `MDVArrivals` does not fetch the result itself, it uses a defined interface for
     * sub-services. These services provide a `searchArrivals(MDVLocation)`
     * function that resolves the given {@link mng-model.object:MDVLocation
     * MDVLocation} to a plain list of {@link mng-model.object:MDVArrival MDVArrivals}.
     * Each service uses a different kind of source for this resolution.
     * Each sub-service needs to implement the following interface structure to assure that it can
     * be attached to this service.
     *
     * ```js
     *   subservice.searchArrivals = function (location) {  // {MDVLocation} location
     *      // returns deferred that is resolved to a list of MDVArrivals.
     *   }
     * ```
     *
     * See the {@link mng-comm.itd.xmljson.service:MDVEFADM MDVEFADM} service that provides
     * suggestions from an EFA interface.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm.MDVArrivals` and interprets the following sub-keys:
     *
     * ## {String[]} subservices
     * Service the arrival object should use to get the lists. Right now, only the
     * sub-service-key 'mng-comm.itd.xmljson.MDVEFADM' is supported. In the future more
     * MDVArrivals sources can be implemented. The array describes a fall back procedure.
     * If the first element in the array does not provide an appropriate response, the next
     * sub-service is used to get a better result.
     *
     * The sub-service key needs to be exactly the name the service is assigned to. To resolve the
     * given name, AngularJs's {@link https://docs.angularjs.org/api/auto/service/$injector
     * $injector} service is used.
     *
     * ## {Object} options
     * Options that should be available to the controllers in order to modify the requests by
     * front-end controls or inputs. Please refer to {@link mng-comm.object:MDVOptions
     * MDVOptions} for further details, to see how the options should be configured/ changed.
     *
     * ## Example:
     * ```js
     *   // configuration object
     *   ...
     *   "MDVArrivals" : {
     *      "subservices" : ["mng-comm.itd.xmljson.MDVEFADM"], // only use EFA sub-service,
     *      "options" : {
     *          dateTime: true  // use global date/time settings. Please note that the "isDeparture"
     *                          // option has no effect as it is set internally to "false"
     *      }
     *   },
     *   ...
     * ```
     *
     * @example
<example module="MDVArrivalsExample">
<file name="index.html">
  <div ng-controller="ArrivalController">
    <div ng-show="arrivals && arrivals.length > 0">
        Arrivals:
        <ul><li ng-repeat="arrival in arrivals track by $index">{{arrival.dateTime() |
        amDateFormat : 'hh:mm'}} at {{arrival.location().name()}} with
        line {{arrival.transportation().name()}}.</li></ul>
    </div>
  </div>
</file>
<file name="script.js">
    // mng-comm.itd needs to be included to find mng-comm.itd.xmljson.MDVEFAStopfinder
    angular.module('MDVArrivalsExample', ['angularMoment', 'mng-comm',
      'mng-comm.itd.xmljson','mng-comm.itd', 'mng-model'])
      .controller('ArrivalController', ArrivalController);

    // mng-config.MDVConfig normally needs not to be injected as the configuration is loaded by the
    // mng-config.MDVConfigFetcher
    ArrivalController.$inject = ['$scope', 'mng-comm.MDVArrivals', 'mng-config.MDVConfig',
      'mng-model.MDVLocation'];

    function ArrivalController($scope, MDVArrivals, MDVConfig, MDVLocation) {
        // set configuration. this is normally done by loading the Config with the
        // mng-config.MDVConfigFetcher
        MDVConfig.setValue('mng-comm.MDVArrivals', {
            subservices : ['mng-comm.itd.xmljson.MDVEFADM']
        });

        MDVConfig.setValue('mng-comm-itd.MDVEFARequester', {
            'url' : '/mngnsw'
        });
        MDVConfig.setValue('mng-comm-itd-xmljson', {
            defaultParams: {
                outputFormat: 'json'
            },
            'MDVEFADM' : {
                'url': '/XML_DM_REQUEST?',
                defaultParams: {
                    mode: 'direct',
                    type_dm: 'any',
                    limit: '10'
                }
            }
        });


        var mdvArrivals = new MDVArrivals();
        // bind results to scope
        $scope.arrivals = mdvArrivals.getResults();

        // set location for arrivals
        mdvArrivals.updateLocation(new MDVLocation({
            id : '10101100',
            name : 'location'
        }));

        // search for arrivals
        mdvArrivals.search();

        // prepend some more arrivals after 15 seconds
        // setTimeout(function() {
            // mdvArrivals.previous();
        // }, 15000);
    }
</file>
</example>
     *
     */
    angular.module('mng-comm')
        .factory('mng-comm.MDVArrivals', MDVArrivals);

    MDVArrivals.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-comm.MDVUtil',
        'mng-comm.MDVDepartureRequester', 'mng-comm.MDVDepartures'];

    function MDVArrivals(MDVLog, MDVConfig, MDVUtil, MDVDepartureRequester, MDVDepartures) {
        var log = MDVLog.register('mng-comm.MDVArrivals'),
            constructor = function() {
                var dep = new MDVDepartures(true);

                dep._private.namespace = 'mng-comm.MDVArrivals';

                MDVConfig.ready(function() {
                    dep._private.options =
                        MDVUtil.gatherOptions(dep._private.getConfigOption('options'));
                    dep._private.options.odvs = {};
                });

                // override methods
                dep._private.addOptions = {
                    dateTime : {
                        isDeparture : false
                    }
                };
                dep.next = undefined;  // next not yet available via EFA interface

                // new methods
                dep.previous = previous;

                /**
                 * @public
                 * @ngdoc method
                 * @name previous
                 * @methodOf mng-comm.object:MDVArrivals
                 * @returns {Deferred} Deferred, that is resolved to a list of {@link
                 * mdv.model.object:MDVArrival MDVArrivals}
                 *
                 * @description
                 * Update the internal {@link mdv.model.object:MDVArrival MDVArrivals} list by
                 * prepending more {@link mdv.model.object:MDVArrival MDVArrivals} at the beginning
                 * of the {@link mdv.model.object:MDVArrival MDVArrivals} list.
                 * The request-result the deferred is resolved with may be different to the internal
                 * result-list as it describes the request-results only, without the already loaded
                 * {@link mdv.model.object:MDVArrival MDVArrivals}.
                 *
                 * The best way to use the results is to get a reference to the internal result list
                 * (by the 'getResults' method) and use the two-way data binding. The request-result
                 * the deferred is resolved with should only be used for additional functionality, like
                 * highlighting the latest updates.
                 */
                function previous() {
                    if (dep._private.result.length === 0) {
                        log.warn('previous() called, but no previous results available (or only ' +
                            'alternative results). send initial request instead.');
                        return dep.search.call(this);
                    }
                    return MDVDepartureRequester.search(angular.copy(dep._private.loc),
                            dep._private.getTimeOptions(dep._private.result[0].dateTime(), false))
                        .then(dep._private.previousSuccess.bind(this));
                }

                // ////////////////////////////////

                dep._private.previousSuccess = function(results) {
                    var i,
                        to_delete = [];

                    for (i = results.length - 1; i >= 0; i -= 1) {
                        if (MDVUtil.isNewResult(dep._private.result, results[i])) {
                            dep._private.result.unshift(results[i]);
                        } else {
                            log.info('ignored duplicate response');
                            log.info(results[i], true);
                            to_delete.push(i);
                        }
                    }
                    for (i = to_delete.length - 1; i >= 0; i -= 1) {
                        results.splice(to_delete[i], 1);
                    }
                    return results;
                };

                return dep;
            };

        log.debug('initialize');

        return constructor;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm')
        .factory('mng-comm.MDVAstRequester', MDVAstRequester);

    MDVAstRequester.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-config.MDVConfig', 'mng-util.MDVException', 'mng-comm.MDVUtil',
        'mng-model.MDVJourney'];

    function MDVAstRequester(MDVLog, MDVUtil, MDVConfig, MDVException, MDVCommUtil,
            MDVJourney) {
        var _private = {
                namespace : 'mng-comm.MDVAstRequester'
            },
            log = MDVLog.register(_private.namespace),
            astRequester = {
                isReady : isReady,
                checkAvailability : checkAvailability,
                book : book,
                cancel : cancel,
                update : update
            };

        log.debug('initialize');

        // ////////////////////////////////


        function isReady(journey, options) {
            var reasons = [];

            if (!MDVConfig.isReady()) {
                reasons.push(new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                    reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                        'without a valid configuration.'
                }));
            }

            if (!(journey instanceof MDVJourney)) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__AST.NO_JOURNEY));
            }

            if (!options || !options.user || !options.user.ID) {
                reasons.push(new MDVException(MDVException.keys.MNG_COMM__AST.MISSIN_USER));
            }

            return reasons;
        }


        function checkAvailability(journey, options) {
            var reasons = isReady(journey, options);

            if (reasons.length > 0) {
                return MDVUtil.getRejectedDeferred(reasons[0]);
            }
            return _private.checkAvailabilityRequest.call(this, journey, options);
        }

        function book(reservationCode, options) {
            return _private.bookRequest.call(this, reservationCode, options);
        }

        function cancel(reservationCode, options) {
            return _private.cancelRequest.call(this, reservationCode, options);
        }

        function update(reservationCode, options) {
            return _private.updateRequest.call(this, reservationCode, options);
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                subservices : ['mng-comm.itd.json.MDVEFAAst'],
                rejectEmptyResponses : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.isValidBookSubservice = function(subservice) {
            return subservice.hasOwnProperty('book');
        };

        _private.isValidCancelSubservice = function(subservice) {
            return subservice.hasOwnProperty('cancel');
        };

        _private.isValidUpdateSubservice = function(subservice) {
            return subservice.hasOwnProperty('update');
        };

        _private.isValidCheckAvailabilitySubservice = function(subservice) {
            return subservice.hasOwnProperty('checkAvailability');
        };

        _private.getSubserviceConfig = function() {
            return _private.getConfigOption('subservices');
        };

        _private.modifyResponse = function(response, arglist) {
            return {
                input : arglist,
                response : response
            };
        };

        _private.checkAvailabilityRequest = function(journey, options, prio, prevError) {
            var subservices = _private.getSubserviceConfig(),
                subservice,
                exception;

            try {
                subservice = MDVCommUtil.getSubservice(subservices, prio, null,
                    MDVException.keys.MNG_COMM__AST);
            } catch (e) {
                if (prio && prio >= subservices.length && prevError) {
                    throw prevError;
                }
                if (prio) {
                    throw e;
                }
                return MDVUtil.getRejectedDeferred(e);
            }

            if (!_private.isValidCheckAvailabilitySubservice(subservice)) {
                exception = new MDVException(MDVException.keys.MNG_COMM__AST.NO_SERVICE, {
                    reason : 'configured service does not match interface definition of this service'
                });
                if (prio) {
                    throw exception;
                }
                return MDVUtil.getRejectedDeferred(exception);
            }

            return subservice.checkAvailability(angular.copy(journey), MDVUtil.copy(options))
                .then(function(response) {
                    if (!response || (response.length === 0)) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__AST.SERVICE_FAILED, {
                            args : [options, journey],
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }

                    return response[0];
                })
                .catch(function(error) {
                    // resend request with lower priority
                    return _private.checkAvailabilityRequest(journey, options, prio ? prio + 1 : 1, error);
                });
        };


        _private.bookRequest = function(reservationCode, options, prio, prevError) {
            var subservices = _private.getSubserviceConfig(),
                subservice,
                exception;

            try {
                subservice = MDVCommUtil.getSubservice(subservices, prio, null,
                    MDVException.keys.MNG_COMM__AST);
            } catch (e) {
                if (prio && prio >= subservices.length && prevError) {
                    throw prevError;
                }
                if (prio) {
                    throw e;
                }
                return MDVUtil.getRejectedDeferred(e);
            }

            if (!_private.isValidBookSubservice(subservice)) {
                exception = new MDVException(MDVException.keys.MNG_COMM__AST.NO_SERVICE, {
                    reason : 'configured service does not match interface definition of this service'
                });
                if (prio) {
                    throw exception;
                }
                return MDVUtil.getRejectedDeferred(exception);
            }

            return subservice.book(angular.copy(reservationCode), MDVUtil.copy(options))
                .then(function(response) {
                    if (!response || !response.bookingReservationResponse) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__AST.SERVICE_FAILED, {
                            args : [options, reservationCode],
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }

                    return response.bookingReservationResponse;
                })
                .catch(function(error) {
                    // resend request with lower priority
                    return _private.bookRequest(reservationCode, options, prio ? prio + 1 : 1, error);
                });
        };



        _private.cancelRequest = function(reservationCode, options, prio, prevError) {
            var subservices = _private.getSubserviceConfig(),
                subservice,
                exception;

            try {
                subservice = MDVCommUtil.getSubservice(subservices, prio, null,
                    MDVException.keys.MNG_COMM__AST);
            } catch (e) {
                if (prio && prio >= subservices.length && prevError) {
                    throw prevError;
                }
                if (prio) {
                    throw e;
                }
                return MDVUtil.getRejectedDeferred(e);
            }

            if (!_private.isValidCancelSubservice(subservice)) {
                exception = new MDVException(MDVException.keys.MNG_COMM__AST.NO_SERVICE, {
                    reason : 'configured service does not match interface definition of this service'
                });
                if (prio) {
                    throw exception;
                }
                return MDVUtil.getRejectedDeferred(exception);
            }

            return subservice.cancel(angular.copy(reservationCode), MDVUtil.copy(options))
                .then(function(response) {
                    if (!response || !response.cancelationResponse) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__AST.SERVICE_FAILED, {
                            args : [options, reservationCode],
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }

                    return response.cancelationResponse;
                })
                .catch(function(error) {
                    // resend request with lower priority
                    return _private.cancelRequest(reservationCode, options, prio ? prio + 1 : 1, error);
                });
        };

        _private.updateRequest = function(reservationCode, options, prio, prevError) {
            var subservices = _private.getSubserviceConfig(),
                subservice,
                exception;

            try {
                subservice = MDVCommUtil.getSubservice(subservices, prio, null,
                    MDVException.keys.MNG_COMM__AST);
            } catch (e) {
                if (prio && prio >= subservices.length && prevError) {
                    throw prevError;
                }
                if (prio) {
                    throw e;
                }
                return MDVUtil.getRejectedDeferred(e);
            }

            if (!_private.isValidUpdateSubservice(subservice)) {
                exception = new MDVException(MDVException.keys.MNG_COMM__AST.NO_SERVICE, {
                    reason : 'configured service does not match interface definition of this service'
                });
                if (prio) {
                    throw exception;
                }
                return MDVUtil.getRejectedDeferred(exception);
            }

            return subservice.update(angular.copy(reservationCode), MDVUtil.copy(options))
                .then(function(response) {
                    if (!response) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__AST.SERVICE_FAILED, {
                            args : [options, reservationCode],
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }

                    return response;
                })
                .catch(function(error) {
                    // resend request with lower priority
                    return _private.updateRequest(reservationCode, options, prio ? prio + 1 : 1, error);
                });
        };




        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                astRequester._private = _private;
            }
        });

        return astRequester;
    }
}());

(function() {
    'use strict';

    angular.module('mng-comm')
        .factory('mng-comm.MDVAst', MDVAst);

    MDVAst.$inject = ['$q', 'mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-config.MDVConfig', 'mng-util.MDVException', 'mng-comm.MDVUtil',
        'mng-comm.MDVAstRequester'];

    function MDVAst($q, MDVLog, MDVUtil, MDVConfig, MDVException, MDVCommUtil,
            MDVAstRequester) {
        var namespace = 'mng-comm.MDVAst',
            log = MDVLog.register(namespace);

        log.debug('initialize');

        return function(/* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var _private = {
                namespace : namespace,
                journey : null,
                bookingCode: null,
                availableJourney : null,
                options : {}
            };

            if (includePrivate === true) {
                this._private = _private;
            }

            this.updateJourney = updateJourney;
            this.checkAvailability = checkAvailability;
            this.book = book;
            this.cancel = cancel;
            this.update = update;
            this.isReady = isHappy;
            this.reset = reset;

            // ////////////////////////////////

            function isHappy() {
                var reasons = [];

                if (!MDVConfig.isReady()) {
                    reasons.push(new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                            'without a valid configuration.'
                    }));
                }
                if (!_private.journey) {
                    reasons.push(new MDVException(MDVException.keys.MNG_COMM__AST.NO_JOURNEY));
                }
                return reasons;
            }

            function updateJourney(newJourney) {
                _private.journey = angular.copy(newJourney);
            }

            function reset() {
                _private.journey = null;
                _private.availableJourney = null;
                _private.bookingCode = null;
                this.resetOptions();
            }

            function resetOptions() {
                if (!MDVConfig.isReady()) {
                    return;
                }
                var config = MDVConfig.getValue('mng-comm.MDVAST.options');

                MDVCommUtil.resetOptions(config, _private.options);
            }

            function checkAvailability(add_options) {
                var reasons = this.isReady();

                if (reasons.length > 0) {
                    return MDVUtil.getRejectedDeferred(reasons[0]);
                }
                return MDVAstRequester.checkAvailability(angular.copy(_private.journey),
                        MDVCommUtil.mergeObjects(_private.options, add_options))
                    .then(_private.checkAvailabilitySuccess.bind(this));
            }

            function book(reservationCode, add_options) {
                if (!reservationCode) {
                    return MDVUtil.getRejectedDeferred();
                }
                return MDVAstRequester.book(angular.copy(reservationCode),
                        MDVCommUtil.mergeObjects(_private.options, add_options))
                    .then(_private.bookSuccess.bind(this));
            }

            function cancel(reservationCode, add_options) {
                if (!reservationCode) {
                    return MDVUtil.getRejectedDeferred();
                }
                return MDVAstRequester.cancel(angular.copy(reservationCode),
                        MDVCommUtil.mergeObjects(_private.options, add_options))
                    .then(_private.cancelSuccess.bind(this));
            }

            function update(reservationCode, add_options) {
                if (!reservationCode) {
                    return MDVUtil.getRejectedDeferred();
                }
                return MDVAstRequester.update(angular.copy(reservationCode),
                        MDVCommUtil.mergeObjects(_private.options, add_options))
                    .then(_private.updateSuccess.bind(this));
            }

            // ////////////////////////////////

            _private.getDefaultConfigOption = function(key) {
                var defConfig = {
                    subservices : ['mng-comm.itd.json.MDVAst'],
                    rejectEmptyResponses : false
                };

                if (!key) {
                    return defConfig;
                }
                if (defConfig.hasOwnProperty(key)) {
                    return defConfig[key];
                }
                return null;
            };

            _private.getConfigOption = function(key) {
                var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

                if (!configVal) {
                    return _private.getDefaultConfigOption(key);
                }
                return configVal;
            };

            _private.checkAvailabilitySuccess = function(result) {
                return result;
            };

            _private.bookSuccess = function(result) {
                return result;
            };

            _private.cancelSuccess = function(result) {
                return result;
            };

            _private.updateSuccess = function(result) {
                return result;
            };

            MDVConfig.ready(function() {
                _private.options = MDVCommUtil.gatherOptions(_private.getConfigOption('options'));
            });

            return this;
        };
    }
}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSTTBStopsController', VVSTTBStopsController);

    VVSTTBStopsController.$inject = ['$scope', '$q', '$state', '$stateParams', 'mng-comm.MDVDownload',
        'mng-comm.MDVLocationRequester', 'mng-model.MDVLocation', 'mng-favorite.MDVLocationFavorite'];

    function VVSTTBStopsController($scope, $q, $state, $stateParams, MDVDownload, MDVLocationRequester,
            MDVLocation, MDVLocationFavorite) {
        $scope.lfp =  $stateParams.lfp;

        var self = this,
            _private = {};

        self.triggerFireTTBClick = function() {
            self.ttbAlert = false;
            var userInputs = {},
                promises = [],
                key;

            userInputs.ttb = angular.copy($scope.inputLocations.ttb || $scope.inputLocationsValues.ttb);

            if (!userInputs.ttb) {
                self.ttbAlert = true;
                return false;
            }

            for (key in userInputs) {
                if (userInputs.hasOwnProperty(key) && (typeof userInputs[key] === 'string')) {
                    promises.push(verifyOdv(key).promise);
                } else if ((typeof userInputs[key] === 'object') &&
                            (userInputs[key].type() !== MDVLocation.LOCATIONTYPES.STOP)) {
                    userInputs[key] = userInputs[key].id();
                    promises.push(verifyOdv(key).promise);
                }
            }

            function verifyOdv(usage) {
                return MDVLocationRequester.search(userInputs[usage])
                        .then(function(result) {
                            if (result.response.length>0) {
                                $scope.inputLocations[usage] = angular.copy(result.response[0]);
                                userInputs[usage] = angular.copy(result.response[0]);
                            }
                            tryFireSearch();
                        }, function() {
                            tryFireSearch();
                        });
            }

            if (promises.length === 0) {
                // we dont need to verify odvs
                fireSearch();
            }

            function tryFireSearch() {
                promises.pop();
                if (promises.length === 0) {
                    fireSearch();
                }
            }

            function fireSearch() {
                var assignedStops = userInputs.ttb.assignedStops();

                if (assignedStops.length <= 1) {
                    // ask for assigned stops
                    MDVLocationRequester.search(userInputs.ttb.id())
                        .then(function(result) {
                            if (result.response.length>0) {
                                MDVLocationFavorite.set(result.response[0], 'ttb');
                                $scope.inputLocations['ttb'] = angular.copy(result.response[0]);
                                userInputs['ttb'] = angular.copy(result.response[0]);

                                assignedStops = userInputs.ttb.assignedStops();
                                if (assignedStops.length<=1) {
                                    // $state.go('vvs.ttb.lines');
                                    $state.go('vvs.ttb.lines', {lfp:$scope.lfp});
                                }
                            }
                        });
                }
            }
        };

        self.triggerSelectStopClick = function(loc) {
            $scope.inputLocations['ttb'] = angular.copy(loc);
            // $state.go('vvs.ttb.lines');
            $state.go('vvs.ttb.lines', {lfp:$scope.lfp});
        };

        _private.initController = function() {
        };
        _private.initController();

        $scope.triggerSelectAssignedStopClick = function(location) {
            $scope.inputLocations.ttb = angular.copy(location);
            $state.go('vvs.ttb.lines', {lfp:$scope.lfp});
            MDVLocationFavorite.set(location, 'ttb');
        };

    }


}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSTTBLinesController', VVSTTBLinesController);

    VVSTTBLinesController.$inject = ['$scope', 'mng-comm.MDVTransportationRequester',
     'mng-model.MDVTransportation', 'mng-comm.MDVDownload', 'VVSPdfViewer', 'VVSDeepLinking', '$stateParams'];

    function VVSTTBLinesController($scope, MDVTransportationRequester, MDVTransportation, MDVDownload, VVSPdfViewer, VVSDeepLinking, $stateParams) {
        var self = this,
            _private = {};

        $scope.isLFP = $stateParams.lfp;

        $scope.closeError =window.closeError;

        _private.fireSearch = function(line) {

            if ($scope.isLFP === true) {
                var options = {
                    lineId : line.id(),
                    useFolderPdfFile: 1
                }
            } else {
                var options = {
                    lineId : line.id()
                }
            }
            MDVDownload.search(MDVDownload.requestTypes.TIMETABLE, options).then(function(res) {
                if (res.response) {
                    $scope.showPDF = true;
                    $scope.pdfRes = res.response;
                    window.open($scope.pdfRes.url(), '_blank');
                    // VVSPdfViewer.show(res.response);
                }
            }).catch(function(err) {
                console.log(err);
                $scope.pdfError = true;
            });
        };


        self.triggerFireTTBClick = function() {
            $scope.pdfError = false;
            self.ttbAlert = false;

            var line = angular.copy($scope.inputLines['ttb'] || $scope.inputLinesValues['ttb']),
                options;
            $scope.line = angular.copy(line);
            if (line && (line instanceof MDVTransportation)) {
                _private.fireSearch(line);
            }
            else if (line && line.length>0 && (typeof line === 'string')) {
                options = {
                    type : 'TTB'
                };

                MDVTransportationRequester.search(line, options)
                    .then(function(res) {
                        if (res && res.response && res.response.length>0) {
                            $scope.inputLines['ttb'] = angular.copy(res.response[0]);
                            _private.fireSearch(angular.copy($scope.inputLines['ttb']));
                        } else {
                            self.ttbAlert = true;
                        }
                    });
            } else {
                self.ttbAlert = true;
            }
        };

        _private.initController = function() {
            $scope.inputLines = {};
            $scope.inputLinesValues = {};
            $scope.showPDF = false;

            var deeplinkOptions = VVSDeepLinking.generateOptionsFromDeeplink();

            if (deeplinkOptions) {
                $scope.inputLines.ttb = deeplinkOptions.odvs.ttb_line;
                if ($scope.inputLines.ttb) {
                    self.triggerFireTTBClick(true);
                }
            }
        };

        _private.initController();

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSTTBInitController', VVSTTBInitController);

    VVSTTBInitController.$inject = ['$scope', '$state', '$stateParams', 'mng-common.MDVUriParams'];

    function VVSTTBInitController($scope, $state, $stateParams, MDVUriParams) {
        var self = this,
            _private = {};
        $scope.lfp =  $stateParams.lfp;

        _private.initDeepLinkParam = function() {
            for (var key in $stateParams) {
                if ($scope.inputLocations && $stateParams.hasOwnProperty(key) && !isObjEmpty($stateParams[key])) {
                    $scope.inputLocations[key] = $stateParams[key];
                }
            }

            function isObjEmpty(obj) {
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) {
                        return false;
                    }
                }
                return JSON.stringify(obj) === JSON.stringify({});
            }
        };

        _private.initController = function() {
            if (!$scope.lfp) { // reset deepLinkParam for Linienfahrplan
                _private.initDeepLinkParam();
            } else {
                $state.go(".", {}, {inherit: false});
                MDVUriParams.clear('deeplink'); // clear deepLink for lfp
            }
        };

        _private.initController();
    }

}());

(function() {
    'use strict';


angular
        .module('vvs')
        .filter('VVSTicketsCleaner', VVSTicketsCleaner);

    VVSTicketsCleaner.$inject = ['VVSConst', '$filter']

    function VVSTicketsCleaner(VVSConst, $filter) {
        return function(tickets) {
            if (!tickets) {
                return [];
            }
            var mappingObj = VVSConst.ticketsMapping;

            if (hasFeinstaubTicket(tickets)) {
                for (var i=0; i<tickets.length; i++) {
                    if ((mappingObj.hasOwnProperty('EinzelTicket Erwachsene') && (mappingObj['EinzelTicket Erwachsene'].ids.indexOf(tickets[i].id())>-1)) ||
                        (mappingObj.hasOwnProperty('EinzelTicket Erwachsene (HandyTicket)') && (mappingObj['EinzelTicket Erwachsene (HandyTicket)'].ids.indexOf(tickets[i].id())>-1))) {

                        tickets.splice(i, 1);
                    }
                }
            }

            function hasFeinstaubTicket(tkts) {
                for (var i=0; i<tkts.length; i++) {
                    if (mappingObj.hasOwnProperty('Feinstaubticket') &&
                        (mappingObj['Feinstaubticket'].ids.indexOf(tkts[i].id()) > -1)) {
                        return true;
                    }

                    if (mappingObj.hasOwnProperty('Feinstaubticket mobil') &&
                        (mappingObj['Feinstaubticket mobil'].ids.indexOf(tkts[i].id()) > -1)) {
                        return true;
                    }

                }
                return false;
            }

            var sortedTickets = [];

            for (var key in mappingObj) {
                if (mappingObj.hasOwnProperty(key)) {
                    for (var i=0; i<tickets.length; i++) {
                        var name = $filter('VVSTicketNameFormatter')(tickets[i]);
                        if (key === name) {
                            sortedTickets.push(tickets[i]);
                            break;
                        }
                    }
                }
            }

            return sortedTickets;
        };
    }


    angular
        .module('vvs')
        .filter('VVSTicketNameFormatter', VVSTicketNameFormatter);

    VVSTicketNameFormatter.$inject = ['VVSConst'];

    function VVSTicketNameFormatter(VVSConst) {
        return function(ticket) {
            if (!ticket) {
                return "";
            }

            var mappingObj = VVSConst.ticketsMapping;

            var idCore = ticket.id().split('_')[0];
            for (var key in mappingObj) {
                if (mappingObj.hasOwnProperty(key)) {
                    if (mappingObj[key].ids.includes(idCore)) {
                        return key;
                    }
                }
            }
            return ticket.name();
        };
    }

    // setting name of the ticket from the backend, not to destroy built algorithm
    angular
        .module('vvs')
        .filter('VVSTicketNameFormatterUpdate', VVSTicketNameFormatterUpdate);
    function VVSTicketNameFormatterUpdate(VVSConst) {
        return function(ticket) {
            if (!ticket) {
                return "";
            }
            var idCore = ticket.id().split('_')[0];

            var name = ticket.name();
            var mappingObj = VVSConst.ticketsMapping;

            for (var key in mappingObj) {
                if (mappingObj[key].ids.includes(idCore)) {
                    return mappingObj[key].takeBackendName ? name : key;
                }
            }
            return name;
        };
    }


     angular
        .module('vvs')
        .filter('VVSTicketGoeNameFormatter', VVSTicketGoeNameFormatter);

    VVSTicketGoeNameFormatter.$inject = ['VVSConst'];

    function VVSTicketGoeNameFormatter(VVSConst) {
        return function(ticket) {
            if (!ticket) {
                return "";
            }

            var name = ticket.name();

            if (name === 'SparBus SaSo') {
                if (ticket.person() === 'ADULT') {
                    return 'Einzelfahrt';
                } else if (ticket.person() === 'CHILD') {
                    return 'Einzelfahrt Kind';
                }
            }


            return name;
        };
    }


}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsTripTickets', vvsTripTickets);

    vvsTripTickets.$inject = [];

    function vvsTripTickets() {
        return {
            restrict : 'E',
            replace : true,
            scope : {
                trip: '='
            },
            templateUrl : 'app/vvs.components/trip/tickets/main.html',
            controller: function($scope) {
                if ($scope.trip && $scope.trip.adultSingleTicket()) {
                    var network = $scope.trip.adultSingleTicket().network();

                    if (['goe Bus', 'goe Schiene', 'goe Bus+Schiene'].indexOf(network)>-1) {
                        $scope.isGoe = true;
                    }
                    if (network === "hnv") {
                        $scope.isHNV = true;
                    }
                }
            }
        };
    }
}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSTripTicketsModalsController', VVSTripTicketsModalsController);

    VVSTripTicketsModalsController.$inject = ['$scope', '$filter', 'VVSConst'];

    function VVSTripTicketsModalsController($scope, $filter, VVSConst) {

        if ($scope.trip && $scope.trip.adultSingleTicket()) {
            var network = $scope.trip.adultSingleTicket().network();

            if (['goe Schiene', 'goe Bus+Schiene'].indexOf(network)>-1) {
                $scope.isGoe = true;
            }
            if (network === "hnv") {
                $scope.isHNV = true;
            }
        }

        if ($scope.trip) {
            if ($scope.isGoe) {
                $scope.allTickets = angular.copy($scope.trip.allTickets());
            } else {
                $scope.allTickets = $filter('VVSTicketsCleaner')(angular.copy($scope.trip.allTickets()));
            }

            $scope.zones = getZones($scope.trip);
            $scope.zones = $scope.zones.filter(function(el, i) {
                return $scope.zones.indexOf(el) === i;
            });

            $scope.hasNineEuroTicket = false;
            $scope.allTickets.map(function(el) {
                if (el.name() === '9-Euro-Ticket') {
                    $scope.hasNineEuroTicket = true;
                }
            });

            if (!$scope.hasNineEuroTicket) {
                $scope.monthWeekTicketsToHide = []
            } else {
                $scope.monthWeekTicketsToHide = ['WochenTicket Jedermann', 'MonatsTicket Jedermann', 'StudiTicket'];
            }

        }

        $scope.getTicketShopUrl = function(ticket, key) {
            // key - desctop oder mobile
            const deutschlandTicketGroupIds = ['165199', '160199', '160399', '160299'];
            var mappingObj = VVSConst.ticketsMapping,
            ticketName = null;

            for (var k in mappingObj) {
                if (mappingObj.hasOwnProperty(k)) {
                    if ((mappingObj[k].ids.indexOf(ticket.id())>-1) && (mappingObj[k][key])) {
                        if (mappingObj[k].shoppingName) {
                            ticketName = mappingObj[k].shoppingName;
                        } else {
                            ticketName = k;
                        }
                        break;
                    }
                }
            }

            if ($scope.isGoe) {
                return null;
            }

            if (!ticketName) {
                return null;
            }

            if (mappingObj.hasOwnProperty(ticketName) && mappingObj[ticketName].hasOwnProperty('urlName')) {
                ticketName = mappingObj[ticketName]['urlName'];
            } else {
                ticketName = ticket.name();
            }

            var karte = ticketName,
                bereich = ticket.priceLevel() || '1-2',
                zones = getZones($scope.trip),
                orig = $scope.trip.origin().id(),
                gueltig = getGueltigkeitsbeginn($scope.trip);

            if (karte && bereich && zones && gueltig) {
                if (deutschlandTicketGroupIds.includes(ticket.id())) {
                    return 'https://www.ssb-ag.de/tickets/abo/bestellung/#bestellung/abonnement';
                }
                return 'https://tickets.ssb-ag.de/fahrplanauskunft?karte='+karte+'&bereich='+bereich+((bereich==='1')?' zone':' zonen')+'&zones='+zones+'&gueltig='+gueltig;
            }

            return null;
        };

        $scope.getDesktopVersion = function(ticket) {
            var mappingObj = VVSConst.ticketsMapping,
                ticketObj,
                i,
                t;

            for (var key in mappingObj) {
                if (mappingObj.hasOwnProperty(key)) {
                    if (mappingObj[key].ids.indexOf(ticket.id())>-1) {
                        ticketObj = mappingObj[key];
                    }
                }
            }

            if (!ticketObj || !ticketObj.desktopVersion) {
                return null;
            }

            var desktopTicketObj = mappingObj[ticketObj.desktopVersion];

            for (i=0; i<$scope.trip.allTickets().length; i+=1) {
                t = $scope.trip.allTickets()[i];
                if (desktopTicketObj.ids.indexOf(t.id())>-1) {
                    return t;
                }
            }
            return null;
        };

        $scope.getTimeTicket = function(trip) {
            for (var i=0; i<$scope.allTickets.length; i++) {
                if (['WochenTicket', 'MonatsTicket', 'Wochenkarte', 'Monatskarte'].indexOf($scope.allTickets[i].name()) >-1 ) {
                    return $scope.allTickets[i];
                }
            }
            return trip.adultSingleTicket();
        };

        function getGueltigkeitsbeginn(trip) {
            return trip.departureTime().format('YYYY-M-D');
        }


        function getZones(trip) {
            var res = [],
                zoneObj,
                i;

            for (i=0; i<trip.allZones().length; i+=1) {
                zoneObj = trip.allZones()[i];
                res = res.concat(zoneObj.zones);
            }
            return res;
        }
    }


}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSTripResultController', VVSTripResultController);

    VVSTripResultController.$inject = ['$scope', '$state', 'VVSDeepLinking', 'VVSGoogleDeepLinking'];

    function VVSTripResultController($scope, $state, VVSDeepLinking, VVSGoogleDeepLinking) {

        if (($scope.journeyObj.service.getResults().length === 0) || (!$scope.SEARCH_OPTIONS)) {
            $state.go('vvs.trip.init');
            return false;
        }


        VVSDeepLinking.generateDeeplinkFromOptions(angular.copy($scope.SEARCH_OPTIONS));
        VVSGoogleDeepLinking.generateOptionsFromDeeplink(angular.copy($scope.SEARCH_OPTIONS));

        var googleDeeplinkOptions = VVSGoogleDeepLinking.generateOptionsFromDeeplink();
        if (googleDeeplinkOptions) {
            $state.go('vvs.trip.details');
        }


        // trigger "print trips" click
        $scope.triggerTripPrintClick = function(){
            $state.go('vvs.trip.print', {
                'trips': angular.copy($scope.journeyObj.service.getResults()),
                'SEARCH_OPTIONS' : angular.copy($scope.SEARCH_OPTIONS)
            });
        };

        $scope.triggerNextClick = function() {
            $scope.journeyObj.service.next();
        };

        $scope.triggerPreviousClick = function() {
            $scope.journeyObj.service.previous();
        };

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSTripInitController', VVSTripInitController);

    VVSTripInitController.$inject = ['$scope', '$stateParams'];

    function VVSTripInitController($scope, $stateParams) {

        for (var key in $stateParams) {
            if ($stateParams.hasOwnProperty(key) && !isObjEmpty($stateParams[key])) {
                $scope.inputLocations[key] = $stateParams[key];
            }
        }

        function isObjEmpty(obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    return false;
                }
            }
            return JSON.stringify(obj) === JSON.stringify({});
        }
    }
}());

(function() {
  'use strict';

  angular
      .module('vvs')
      .directive('vvsAccessIcons', vvsAccessIcons);

      vvsAccessIcons.$inject = [];

  function vvsAccessIcons() {
      return {
          restrict : 'E',
          replace : true,
          scope : {
            data: '@'
          },
          templateUrl : 'app/vvs.components/trip/directives/acc.html',
          controller: function($scope) {
            var data = JSON.parse($scope.data);
            var properties = data.properties;
            var accessArray = properties.accessArray;
            var stoppointAccess = accessArray[0].stoppointAccess;
            $scope.attributes = stoppointAccess ? stoppointAccess.attributes : null;
            $scope.widthAvail = stoppointAccess ? stoppointAccess.widthAvail : null;
            $scope.stepFromStreet = stoppointAccess ? stoppointAccess.stepFromStreet : null;
            $scope.barrierFreeAccess = stoppointAccess ? stoppointAccess.heightDifference2VehicleAllowed : null;
          }
      };
  }
}());




(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSSTTStopsController', VVSSTTStopsController);

    VVSSTTStopsController.$inject = ['$scope', '$q', '$state', '$stateParams', 'mng-comm.MDVDownload',
        'mng-comm.MDVLocationRequester', 'mng-model.MDVLocation', 'mng-favorite.MDVLocationFavorite', 'VVSDeepLinking'];

    function VVSSTTStopsController($scope, $q, $state, $stateParams, MDVDownload, MDVLocationRequester,
            MDVLocation, MDVLocationFavorite, VVSDeepLinking) {
        var self = this;

        self.triggerFireSTTClick = function(deeplink) {
            self.sttAlert = false;
            var userInputs = {},
                promises = [],
                key;

            userInputs.stt = angular.copy($scope.inputLocations.stt || $scope.inputLocationsValues.stt);

            if (!userInputs.stt) {
                self.sttAlert = true;
                return false;
            }

            for (key in userInputs) {
                if (userInputs.hasOwnProperty(key) && (typeof userInputs[key] === 'string')) {
                    promises.push(verifyOdv(key).promise);
                } else if ((typeof userInputs[key] === 'object') &&
                            (userInputs[key].type() !== MDVLocation.LOCATIONTYPES.STOP)) {
                    userInputs[key] = userInputs[key].id();
                    promises.push(verifyOdv(key).promise);
                }
            }

            function verifyOdv(usage) {
                return MDVLocationRequester.search(userInputs[usage])
                        .then(function(result) {
                            if (result.response.length>0) {
                                $scope.inputLocations[usage] = angular.copy(result.response[0]);
                                userInputs[usage] = angular.copy(result.response[0]);
                            }
                            tryFireSearch();
                        }, function() {
                            tryFireSearch();
                        });
            }

            if (promises.length === 0) {
                // we dont need to verify odvs
                fireSearch();
            }

            function tryFireSearch() {
                promises.pop();
                if (promises.length === 0) {
                    fireSearch();
                }
            }

            function fireSearch() {
                var assignedStops = userInputs.stt.assignedStops();

                if (assignedStops.length <= 1) {
                    // ask for assigned stops
                    MDVLocationRequester.search(userInputs.stt.id())
                        .then(function(result) {
                            if (result.response.length>0) {
                                $scope.inputLocations['stt'] = angular.copy(result.response[0]);
                                userInputs['stt'] = angular.copy(result.response[0]);

                                assignedStops = userInputs.stt.assignedStops();
                                if (assignedStops.length<=1) {
                                    $state.go('vvs.stops.sttlines');
                                    // $state.go('vvs.stt.lines');
                                }
                            }
                        });
                }
            }
        };

        $scope.triggerSelectAssignedStopClick = function(location) {
            console.log('STT triggerSelectAssignedStopClick');
            $scope.inputLocations.stt = angular.copy(location);
            $state.go('vvs.stt.lines');
            MDVLocationFavorite.set(location, 'stt');
        };

        function initController() {
            var deeplinkOptions = VVSDeepLinking.generateOptionsFromDeeplink();

            if (deeplinkOptions) {
                $scope.inputLocations.stt = deeplinkOptions.odvs.stt_stop;
                if ($scope.inputLocations.stt) {
                    self.triggerFireSTTClick(true);
                }
            }
        }

        initController();

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSSTTLinesController', VVSSTTLinesController);

    VVSSTTLinesController.$inject = ['$scope', '$state', 'mng-model.MDVTransportation', 'mng-comm.MDVTransportationRequester', 'VVSDeepLinking'];

    function VVSSTTLinesController($scope, $state, MDVTransportation, MDVTransportationRequester, VVSDeepLinking) {
        var self = this,
            _private = {};

        _private.fireSearch = function(line) {
            $scope.inputLines['stt'] = angular.copy(line);
            $state.go('vvs.stt.stops');
        };

        self.triggerFireSTTClick = function() {
            console.log('stt fire click');
            self.sttAlert = false;

            var line = angular.copy($scope.inputLines['stt'] || $scope.inputLinesValues['stt']),
                options;

            if (line && (line instanceof MDVTransportation)) {
                _private.fireSearch(line);
            } else if (line && line.length>0 && (typeof line === 'string')) {
                options = {
                    type : 'STT',
                    efaParams : {
                        mergeDir : 0
                    }
                };

                MDVTransportationRequester.search(line, options)
                    .then(function(res) {
                        if (res && res.response && res.response.length>0) {
                            _private.fireSearch(angular.copy(res.response[0]));
                        } else {
                            self.sttAlert = true;
                        }
                    });
            } else {
                self.sttAlert = true;
            }
        };

        function initController() {
            var deeplinkOptions = VVSDeepLinking.generateOptionsFromDeeplink();

            if (deeplinkOptions) {
                $scope.inputLines.stt = deeplinkOptions.odvs.stt_line;
                if ($scope.inputLines.stt) {
                    self.triggerFireSTTClick(true);
                }
            }
        }

        initController();
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSSTTInitController', VVSSTTInitController);

    VVSSTTInitController.$inject = ['$scope', '$state', '$stateParams'];

    function VVSSTTInitController($scope, $state, $stateParams) {
        var self = this,
            _private = {};

        _private.initDeepLinkParam = function() {
            for (var key in $stateParams) {
                if ($stateParams.hasOwnProperty(key) && !isObjEmpty($stateParams[key])) {
                    $scope.inputLocations[key] = $stateParams[key];
                }
            }

            function isObjEmpty(obj) {
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) {
                        return false;
                    }
                }
                return JSON.stringify(obj) === JSON.stringify({});
            }
        };

        _private.initController = function() {
            _private.initDeepLinkParam();
        };

        _private.initController();
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSROPStopController', VVSROPStopController);

    VVSROPStopController.$inject = ['$scope', '$q', '$state', 'mng-comm.MDVDownload', 'mng-comm.MDVLocationRequester', 'mng-model.MDVLocation', 'VVSPdfViewer', 'VVSDeepLinking'];

    function VVSROPStopController($scope, $q, $state, MDVDownload, MDVLocationRequester, MDVLocation, VVSPdfViewer, VVSDeepLinking) {

        var _private = {};

        _private.fireSearch = function(location) {
            MDVDownload.search(MDVDownload.requestTypes.ROUTE_OPTION_PLAN, {
                    stopId : location.id()
                })
                .then(function(res) {
                    if(res.response){
                        $scope.showPDF = true;
                        $scope.pdfRes = res.response;
                        $scope.number = location.number ? location.number() : location.name();
                        $scope.line = angular.copy(location);
                        window.open($scope.pdfRes.url(), '_blank');
                        // VVSPdfViewer.show(res.response);
                    }
                }).catch(function(err) {
                    console.log(err);
                    $scope.pdfError = true;
                });

        };

        $scope.triggerROPResetClick = function() {
            $scope.showPDF = false;
            $state.go('vvs.stops.rop', {}, {
                reload : true
            });
        }

        $scope.triggerFireROPClick = function() {
            $scope.pdfError = false;
            var loc,
                promises = [],
                key;

            $scope.ropAlert = false;

            loc = angular.copy($scope.inputLocations.rop || $scope.inputLocationsValues.rop);

            if (!loc) {
                $scope.ropAlert = true;
                return false;
            }

            if (loc instanceof MDVLocation) {
                _private.fireSearch(loc);
            } else {
                MDVLocationRequester.search(loc)
                    .then(function(result) {
                        if (result.response.length>0) {
                            $scope.inputLocations['rop'] = loc = result.response[0];
                            _private.fireSearch(loc);
                        }
                    });
            }
            // $scope.inputLocations['rop'] = '';

        };

        initController();

        function initController() {
            $scope.showPDF = false;
            $scope.pdfError = false;
            $scope.inputLocationsValues = {};
            $scope.inputLocations = {};
            $scope.ropObj = {};

            var deeplinkOptions = VVSDeepLinking.generateOptionsFromDeeplink();

            if (deeplinkOptions) {
                $scope.inputLocations.rop = deeplinkOptions.odvs.rop_stop;
                if ($scope.inputLocations.rop) {
                    $scope.triggerFireROPClick(true);
                }
            }
        }

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSROPLineController', VVSROPLineController);

    VVSROPLineController.$inject = ['$scope', '$rootScope', 'VVSDeepLinking', '$timeout', '$state'];

    function VVSROPLineController($scope, $rootScope, VVSDeepLinking, $timeout, $state) {
        var url = window.location.href;

        $scope.$on('LINES', function(events, args){
            $scope.tabIndex = args;
        });

        initController();
        $scope.selectedLine;
        $scope.showMap = true;
        $scope.btnClick = function() {
            $scope.showMap = !$scope.showMap;
        }
        $scope.triggerROPClick = function() {
            $rootScope.line = $scope.inputLines['rop'];
             $state.go('vvs.lines.ropresult');
        }


        $scope.selectedLine = $rootScope.line ? $rootScope.line : {};

        $scope.currentDate = new Date();

        function initController() {
            $scope.inputLines = {};
            $scope.inputLinesValues = {};
            var deeplinkOptions = VVSDeepLinking.generateOptionsFromDeeplink();

            if (deeplinkOptions) {
                if (deeplinkOptions.odvs) {
                    if (deeplinkOptions.odvs.rop_line) {
                        $scope.inputLines['rop'] = deeplinkOptions.odvs.rop_line;
                        $timeout(function() {
                            angular.element(document.querySelector('#vvs_rop_lines_submit')).triggerHandler('click');
                        }, 0);
                    }
                }
            }

            if (url.includes('ROP')) {
                $scope.tabIndex = 0;
            } else if (url.includes('TTB') && (!url.includes('lfp=true'))) {
                $scope.tabIndex = 1;
            } else if (url.includes('TTB') && (url.includes('lfp=true'))) {
                $scope.tabIndex = 2;
            }
        }
        $scope.fireSearch = function() {
            self.selectedLine = angular.copy($scope.inputLines['rop']);
        };
        $scope.startSearch = function() {
            var line = angular.copy($scope.inputLines['rop'] || $scope.inputLinesValues['rop']),
                options;
            if (line && (line instanceof MDVTransportation)) {
                $scope.fireSearch();
            } else if (line && line.length>0 && (typeof line === 'string')) {
                options = {
                    type : 'ROP'
                };

                MDVTransportationRequester.search(line, options)
                    .then(function(res) {
                        if (res && res.response && res.response.length>0) {
                            $scope.inputLines['rop'] = angular.copy(res.response[0]);
                            $scope.fireSearch();
                        }
                    });
            }
        };
        $scope.startSearch();

        $scope.triggerROPResetClick = function() {
            $state.go('vvs.lines.rop');
        }
        $scope.triggerROPUpdate = function() {
        };

    }


    angular
        .module('vvs')
        .controller('VVSROPLineModalController', VVSROPLineModalController);

    VVSROPLineModalController.$inject = ['$scope', '$interval', 'mng-model.MDVTransportation', 'mng-comm.MDVTransportationRequester'];

    function VVSROPLineModalController($scope, $interval, MDVTransportation, MDVTransportationRequester) {
        var self = this,
            _private = {};

        self.currentDate = new Date();

        var tick = function() {
            self.currentDate = new Date();
        };
        _private.tickInterval = $interval(tick, 1000);

        $scope.modalInstance.closed
            .then(function() {
                $interval.cancel(_private.tickInterval);
            });

        _private.fireSearch = function() {
            self.selectedLine = angular.copy($scope.inputLines['rop']);
        };

        _private.startSearch = function() {
            $scope.VVSROPLineCtrl.ropAlert = false;
            var line = angular.copy($scope.inputLines['rop'] || $scope.inputLinesValues['rop']),
                options;

            if (line && (line instanceof MDVTransportation)) {
                _private.fireSearch();
            } else if (line && line.length>0 && (typeof line === 'string')) {
                options = {
                    type : 'ROP'
                };

                MDVTransportationRequester.search(line, options)
                    .then(function(res) {
                        if (res && res.response && res.response.length>0) {
                            $scope.inputLines['rop'] = angular.copy(res.response[0]);
                            _private.fireSearch();
                        } else {
                            $scope.VVSROPLineCtrl.ropAlert = true;
                        }
                    });
            } else {
                $scope.dismissModal();
                $scope.VVSROPLineCtrl.ropAlert = true;
            }
        };
        _private.startSearch();
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSPersonalizationVerificationController', VVSPersonalizationVerificationController);

    VVSPersonalizationVerificationController.$inject = ['$scope', '$state',
        'mng-personalization.MDVPersonalizationHelper', 'mng-common.MDVUriParams'];

    function VVSPersonalizationVerificationController($scope, $state, MDVPersonalizationHelper, MDVUriParams) {


        initController();

        function initController() {
            var identId = MDVUriParams.get('identId')
                || MDVUriParams.get('identID')
                || MDVUriParams.get('identid');
            console.log('identId', identId);
            if (identId) {
                MDVPersonalizationHelper.activate(identId)
                    .then(function(res) {
                        if (res && res.Succeeded) {
                            $scope.success = true;
                        } else {
                            $scope.success = false;
                        }
                    })
                    .catch(function(e){
                        $scope.success = false;
                    });
            } else {
                $scope.success = false;
            }
        }

    }



}());



(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSPersonalizationRegistrationController', VVSPersonalizationRegistrationController);

    VVSPersonalizationRegistrationController.$inject = ['$scope', '$state',
        'mng-personalization.MDVPersonalizationHelper'];

    function VVSPersonalizationRegistrationController($scope, $state, MDVPersonalizationHelper) {

        initController();

        inputFocus();

        $scope.profileIsDeleted = window.profileIsDeleted;



        $scope.savedUsername = angular.element(document.querySelector('#nickname')).val();

        function initController() {
            redirectIfIsLoggedIn();
        }

        function inputFocus(){
            document.getElementById('nickname').focus();
        }

        function redirectIfIsLoggedIn() {
            MDVPersonalizationHelper.isLoggedIn()
                .then(function(res) {
                    if (res) {
                        $state.go('vvs.personalization.init');
                    }
                });
        }


        $scope.submitRegistrationForm = function() {

            hideAlerts();
            if ($scope.registrationForm.$valid) {

                $scope.savedUsername = $scope.user.Username;

                var user = {
                    Name : $scope.user.Username,
                    Password : $scope.user.Password,
                    Client : 'vvs',
                    Profile : {
                        Gender : 'x',
                        Locality : 'de',
                        Email : $scope.user.Profile && $scope.user.Profile.Email || $scope.user.Username,
                        FirstName : $scope.user.Profile && $scope.user.Profile.FirstName || "",
                        LastName : $scope.user.Profile && $scope.user.Profile.LastName || "",
                        Phone : $scope.user.Profile && $scope.user.Profile.Phone || ""
                        // Notification : true
                    }
                };

                MDVPersonalizationHelper.register(user)
                    .then(function(res) {
                        if (res.Succeeded) {
                            $state.go('vvs.personalization.confirmregistration');
                        } else {
                            for (var key in res) {
                                console.log('RES: ', res);
                                if (res.hasOwnProperty(key)) {
                                    if (res[key] === true) {
                                        $scope.personalizationMessage = key;
                                        if (key === 'HasExistingUsername') {
                                            key = 'There already exists an user with the same username.';
                                        }
                                    }
                                }
                            }
                        }
                    })
                    .catch(function(e) {
                        $scope.personalizationServiceFailedAlert = true;
                    });
            }
        };

        $scope.resendActivationCode = function() {
            console.log('reset activation code');
            console.log('$scope.savedUsername', $scope.savedUsername);

            hideAlerts();
            var user = {
                Name : $scope.savedUsername,
                Client : 'vvs',
            };

            MDVPersonalizationHelper.reactivate(user)
            .then(function(res) {
                console.log('res deactivate ctrl', res);
                $scope.reactivationLink = true;
            })
            .catch(function(e) {
                console.log('e', e);
                $scope.invalidReactivationLink = true;
            });
            // $state.go('vvs.personalization.confirmregistration');
        }

        function hideAlerts() {
            $scope.personalizationMessage = false;
            $scope.personalizationServiceFailedAlert = false;
            $scope.reactivationLink = false;
        }

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSPersonalizationLinesController', VVSPersonalizationLinesController);

    VVSPersonalizationLinesController.$inject = ['$scope', '$rootScope', '$state', '$q', '$timeout', 'mng-comm.MDVTransportationRequester',
        'mng-personalization.MDVPersonalizationHelper', 'mng-favorite.MDVTransportationFavorite', ];

    function VVSPersonalizationLinesController($scope, $rootScope, $state, $q, $timeout, MDVTransportationRequester,
        MDVPersonalizationHelper, MDVTransportationFavorite) {

           var self = this;

            $scope.sbahnCodeArr = [10];
            $scope.rbahnCodeArr = [11,12];
            $scope.ubahnCodeArr = [20,21];
            $scope.busCodeArr = [30,31,33,34,35, 50,51,52,53,61,70,71,76,77,81]; // hier drin Ruftaxi, LinienTaxi 62 - Museumstraßenbahn ist entfernt

        initController();

        function initController() {
            $scope.lineSelections = [];
            $scope.inputLinesValues = {};
            $scope.inputLines = {};
        }

        function resetController() {
            $scope.persError = false;
            $scope.persAlert = false;
            $scope.alreadySubscribed = false;
        }

        function cleanId(id) {
            var res = id,
                arr = id.split(':');

            // if (arr.length>3) {
            //     res = arr[0]+':'+arr[1]+':'+arr[3];
            // }
            res = arr[0]+':'+arr[1];

            return res;
        }

        function alreadySubscribed(transportation) {
            var found = false;
            for (var i=0; i<$scope.lines.length; i++) {
                if ($scope.lines[i].Key === cleanId(transportation.id())) {
                    found = true;
                    break;
                }
            }
            return found;
        }


        $scope.triggerSubscribeToLineClick = function() {
            resetController();

            var line = angular.copy($scope.inputLines.pers),
                options;

            if (line && (typeof line === 'object')) {
                fireSubscription(line);
            } else if (line && line.length>0 && (typeof line === 'string')) {
                options = {
                    type : 'ROP'
                };
                MDVTransportationRequester.search(line, options)
                    .then(function(res) {
                        if (res && res.response && (res.response.length>0)) {
                            var transportation = res.response[0];
                            fireSubscription(transportation);
                        }

                    });
            } else {
                $scope.persAlert = true;
            }

            function fireSubscription(transportation) {

                if (alreadySubscribed(transportation)) {
                    $scope.alreadySubscribed = true;
                    return;
                }
                $scope.lineSelections.length = 0;
                $scope.lineSelections.push(transportation);

                MDVTransportationFavorite.set(transportation, 'pers');
                MDVPersonalizationHelper.setTransportation(transportation)
                .then(function() {
                    $scope.getLines();
                    initController();
                });
            }
        };

        $scope.removeLine = function(lineId, refresh) {
            resetController();
            return MDVPersonalizationHelper.removeTransportation(lineId)
                    .then(function() {
                        if (refresh) {
                            $scope.getLines();
                        }
                    })
                    .catch(function() {
                        $scope.persError = true;
                    });
        };


         function fireSubscriptionLine(transportation, noRefresh) {

            $scope.lineSelections.length = 0;
            $scope.lineSelections.push(transportation);

           return MDVPersonalizationHelper.setTransportation(transportation)
            .then(function() {
                if (noRefresh) {
                    initController();
                }
                else {
                    $scope.getLines();
                    initController();
                }
            });
        }

        $scope.isAboLine = function(line) { // get long Id from Database
            var id;
            $scope.lines.map(function(l) {
                var lineId = cleanId(line.id());
                if (lineId === l.Key && line.routeDescription() === l.Description) {
                    id = l.Id;
                    $scope.abonatedId = id;
                }
            });
        }

        $scope.switchSubscribeLine = function(code, line, flag, noRefresh) {
            $scope.isAboLine(line);
            resetController();
            if (flag) {
                if (code === 'sbahn') {
                    $scope.switchAll.flagSbahn = false;
                }
                if (code === 'rbahn') {
                    $scope.switchAll.flagRbahn = false;
                }
                if (code === 'ubahn') {
                    $scope.switchAll.flagUbahn = false;
                }
                if (code === 'bus') {
                    $scope.switchAll.flagBus = false;
                }
                if (noRefresh) {
                    return fireSubscriptionLine(line, noRefresh);
                } else {
                    return fireSubscriptionLine(line);
                }
            } else {
                if (code === 'sbahn') {
                    $scope.switchAll.flagSbahn = false;
                }
                if (code === 'rbahn') {
                    $scope.switchAll.flagRbahn = false;
                }
                if (code === 'ubahn') {
                    $scope.switchAll.flagUbahn = false;
                }
                if (code === 'bus') {
                    $scope.switchAll.flagBus = false;
                }
                $scope.removeLine($scope.abonatedId, true);
            }

        };


        $scope.switchAll = {
            flagSbahn: false,
            // flagRbahn: false,
            // flagUbahn: false,
            // flagBus: false
        };
        $scope.switchSubscribeAllLines = function(flag, code) {
            $scope.isLoading = true;

            resetController();
            var promises = [];

            if (flag && code=="sbahn"){
                $scope.switchAll.flagSbahn = true;
            }
            if (flag && code=="rbahn"){
                $scope.switchAll.flagRbahn = true;
            }
            if (flag && code=="ubahn"){
                $scope.switchAll.flagUbahn = true;
            }
            if (flag && code=="bus"){ // schalter auf true setzen
                $scope.switchAll.flagBus = true;
            }

            if (flag) {
                if (code === "sbahn") {
                    $scope.switchAll.flagSbahn = true;
                    console.log('$scope.sbahnLines', $scope.sbahnLines);
                    $scope.sbahnLines = $scope.sbahnLines.map(function(line) {
                        if (line.isAbonated) {
                           return line;
                        }
                        line.isAbonated = true;
                        promises.push($scope.switchSubscribeLine(code, line, flag, true));
                        return line;
                    });
                    console.log('promises subscr all', promises);
                    $q.all(promises).then(function() {
                        $scope.getLines();
                    });
                };
                if (code === "rbahn") {
                    $scope.switchAll.flagRbahn = flag;
                    $scope.rbahnLines = $scope.rbahnLines.map(function(line) {
                        if (line.isAbonated) {
                           return line;
                        }
                        line.isAbonated = true;
                        promises.push($scope.switchSubscribeLine(code, line, flag, true));
                        return line;
                    });
                    console.log('promises subscr all', promises);
                    $q.all(promises).then(function() {
                        $scope.getLines();
                    });
                };
                if (code === "ubahn") {
                    $scope.switchAll.flagUbahn = flag;
                    $scope.ubahnLines = $scope.ubahnLines.map(function(line) {
                        if (line.isAbonated) {
                           return line;
                        }
                        line.isAbonated = true;
                        promises.push($scope.switchSubscribeLine(code, line, flag, true));
                        return line;
                    });
                    console.log('promises subscr all', promises);
                    $q.all(promises).then(function() {
                        $scope.getLines();
                    });
                };
                if (code === "bus") {
                    $scope.switchAll.flagBus = true;
                    $scope.busLines = $scope.busLines.map(function(line) {
                        if (line.isAbonated) {
                           return line;
                        }
                        line.isAbonated = true;
                        promises.push($scope.switchSubscribeLine(code, line, flag, true));
                        return line;
                    });
                    console.log('promises subscr all', promises);
                    $q.all(promises).then(function() {
                        $scope.getLines();
                    });
                };

            } else {
                if (code === 'sbahn') {
                    // $scope.switchAll.flagSbahn = false;
                    $scope.removeAllLines(code);
                }
                if (code === 'rbahn') {
                    // $scope.switchAll.flagRbahn = false;
                    $scope.removeAllLines(code);
                }
                if (code === 'ubahn') {
                    // $scope.switchAll.flagUbahn = false;
                    $scope.removeAllLines(code);
                }
                if (code === 'bus') {
                    // $scope.switchAll.flagBus = false;
                    $scope.removeAllLines(code);
                }
            }
        };

        $scope.removeAllLines = function(code, lineId) {
            $scope.isLoading = true;
            if (code === 'sbahn') {
                $scope.sbahnLines = $scope.sbahnLines.map(function(line) {
                    line.isAbonated = false;
                    return line;
                });
                resetController();
                if (!$scope.lines) {
                    return;
                }
                var promises = [];

                for (var i=0; i<$scope.lines.length; i++) {
                    console.log('$scope.lines[i].MeansOfTransport', $scope.lines[i].MeansOfTransport);
                    if ($scope.lines[i].MeansOfTransport === 2) {
                        promises.push($scope.removeLine($scope.lines[i].Id));
                    }
                };
                console.log('promises', promises);
                $q.all(promises).then(function() {
                    $scope.getLines();
                });
            }
            if (code === 'rbahn') {
                $scope.rbahnLines = $scope.rbahnLines.map(function(line) {
                    line.isAbonated = false;
                    return line;
                });
                resetController();
                if (!$scope.lines) {
                    return;
                }
                var promises = [];

                for (var i=0; i<$scope.lines.length; i++) {
                    if ($scope.lines[i].MeansOfTransport === 6) {
                        promises.push($scope.removeLine($scope.lines[i].Id));
                    }
                };
                $q.all(promises).then(function() {
                    $scope.getLines();
                }).finally(function() {
                    $scope.isLoading = false;
                });
            }
            if (code === 'ubahn') {
                $scope.ubahnLines = $scope.ubahnLines.map(function(line) {
                    line.isAbonated = false;
                    return line;
                });
                resetController();
                if (!$scope.lines) {
                    return;
                }
                var promises = [];

                for (var i=0; i<$scope.lines.length; i++) {
                    if ($scope.lines[i].MeansOfTransport === 9 || $scope.lines[i].MeansOfTransport === 1 || $scope.lines[i].MeansOfTransport === 11) {
                        promises.push($scope.removeLine($scope.lines[i].Id));
                    }
                };
                $q.all(promises).then(function() {
                    $timeout(function(){
                        $scope.getLines();
                    }, 100);
                });
            }
            if (code === 'bus') {
                $scope.busLines = $scope.busLines.map(function(line) {
                    line.isAbonated = false;
                    return line;
                });
                resetController();
                if (!$scope.lines) {
                    return;
                }
                var promises = [];

                for (var i=0; i<$scope.lines.length; i++) {
                    if ($scope.lines[i].MeansOfTransport === 3 || $scope.lines[i].MeansOfTransport === 13 || $scope.lines[i].MeansOfTransport === 8) {
                        promises.push($scope.removeLine($scope.lines[i].Id));
                    }
                };
                $q.all(promises).then(function() {
                    $timeout(function(){
                        $scope.getLines();
                    }, 100);
                });
            }

        };

        $scope.getLines = function() {
            resetController();
            $scope.lines = [];

            MDVPersonalizationHelper.getTransportation(
                {
                    '$filter' : 'Usage eq 7',                 // 7 - Monitored Service  // 1 - Monitored Service
                    '$orderby' : 'Name'
                })
                .then(function(res) {
                    $scope.lines = res;
                    console.log('SUBSCRIBED LINES', $scope.lines);

                    $scope.sbahnLines = $scope.sbahnLines.map(function(line) {
                        $scope.lines.map(function(item){
                            var lineId = cleanId(line.id());
                            if (item.Key === lineId) {
                                line.isAbonated = true;
                            }
                            return item;
                        });
                        return line;
                    });

                    $scope.rbahnLines = $scope.rbahnLines.map(function(line) {
                        $scope.lines.map(function(item){
                            var lineId = cleanId(line.id());
                            if (item.Key === lineId) {
                                line.isAbonated = true;
                            }
                            return item;
                        });
                        return line;
                    });

                    $scope.ubahnLines = $scope.ubahnLines.map(function(line) {
                        $scope.lines.map(function(item){
                            var lineId = cleanId(line.id());
                            if (item.Key === lineId) {
                                line.isAbonated = true;
                            }
                            return item;
                        });
                        return line;
                    });

                    $scope.busLines = $scope.busLines.map(function(line) {
                        $scope.lines.map(function(item){
                            var lineId = cleanId(line.id());
                            if (item.Key === lineId) {
                                line.isAbonated = true;
                            }
                            return item;
                        });
                        return line;
                    });

                    var flag = true; // sbahn
                    var flagRbahn = true;
                    var ubahnFlag = true;
                    var busFlag = true;
                    $scope.sbahnLines.map(function(line) {
                        if (!line.isAbonated) {
                            flag = false;
                        }
                        return line;
                    });
                    $scope.switchAll.flagSbahn = flag;

                    $scope.rbahnLines.map(function(line) {
                        if (!line.isAbonated) {
                            flagRbahn = false;
                        }
                        return line;
                    });
                    $scope.switchAll.flagRbahn = flagRbahn;
                    $scope.ubahnLines.map(function(line) {
                        if (!line.isAbonated) {
                            ubahnFlag = false;
                        }
                        return line;
                    });
                    $scope.switchAll.flagUbahn = ubahnFlag;


                    $scope.busLines.map(function(line) {
                        if (!line.isAbonated) {
                            busFlag = false;
                        }
                        return line;
                    });
                    $scope.switchAll.flagBus = busFlag;


                })
                .catch(function(err) {
                    // console.log('error', err);
                    $scope.persError = true;
                }).finally(function() {
                    $scope.isLoading = false;
                });

        };
        $scope.getLines();


        $scope.getLineList = function(codesArr) {
            MDVTransportationRequester.getLineList('TEST', { codes: codesArr})
            .then(function(res) {
                $scope.getLines();
                if (codesArr === $scope.sbahnCodeArr) {
                    $scope.sbahnLines = res.response;
                    console.log('SBAHN', $scope.sbahnLines);
                } else if (codesArr === $scope.rbahnCodeArr){
                    $scope.rbahnLines = res.response;
                    $scope.rbahnLines = res.response;
                } else if(codesArr === $scope.ubahnCodeArr){
                    $scope.ubahnLines = res.response;
                    $scope.ubahnLines = res.response;
                }
                else if(codesArr === $scope.busCodeArr){
                    $scope.busLines = res.response;
                    console.log('Busse', $scope.busLines);
                    $scope.busLines = $scope.busLines.filter(function(el) {
                        if (el.id().split(':')[2] !== 'a' && el.id().split(':')[2] !== 'e')
                            return el;
                    });
                    console.log('Busse filtered', $scope.busLines);
                }
            });
        }

        $scope.filter = {  };
        $scope.filterData = function(value) {
            $scope.filter.searchValue = value;
            $scope.filteredSbahnData = $scope.sbahnLines.filter(function(item) {
                if (item.number().toLowerCase().includes($scope.filter.searchValue.toLowerCase())) {
                    return item;
                }
            });
            $scope.filteredRbahnData = $scope.rbahnLines.filter(function(item) {
                if (item.number().toLowerCase().includes($scope.filter.searchValue.toLowerCase())) {
                    return item;
                }
            });
            $scope.filteredUbahnData = $scope.ubahnLines.filter(function(item) {
                if (item.number().toLowerCase().includes($scope.filter.searchValue.toLowerCase())) {
                    return item;
                }
            });
            $scope.filteredBusData = $scope.busLines.filter(function(item) {
                if (item.number().toLowerCase().includes($scope.filter.searchValue.toLowerCase())) {
                    return item;
                }
            });

        }

        $scope.getLineList($scope.sbahnCodeArr);
        $scope.getLineList($scope.rbahnCodeArr);
        $scope.getLineList($scope.ubahnCodeArr);
        $scope.getLineList($scope.busCodeArr);

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .filter('VVSPersonalisationTripSupplementSort', VVSPersonalisationTripSupplementSort);

    VVSPersonalisationTripSupplementSort.$inject = ['$filter', 'mng-comm.itd.json.MDVEFATripParser'];

    function VVSPersonalisationTripSupplementSort($filter, MDVEFATripParser) {
        return function(response) {
            var res = [], i, l;

            function parseTrip(trip) {
                return MDVEFATripParser.parse({
                    journeys : [JSON.parse(trip)]
                }).trips[0];
            }

            function compare(a,b) {
                if (a.Trip.departureTime() < b.Trip.departureTime()) {
                    return -1;
                }
                if (a.Trip.departureTime() > b.Trip.departureTime()) {
                    return 1;
                }

                return 0;
            }

            for (i=0, l=response.length; i<l; i++) {
                var tripObj = {
                    Id : response[i].Id,
                    TripId : response[i].TripId,
                    Trip : parseTrip(response[i].Data),
                    TripRaw : response[i].Data
                };

                res.push(tripObj);
            }

            return res.sort(compare);
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSPersonalizationTripsController', VVSPersonalizationTripsController);

    VVSPersonalizationTripsController.$inject = ['$scope', '$state', '$filter', 'mng-personalization.MDVPersonalizationHelper',
        'mng-comm.itd.json.MDVEFATripParser', 'mng-comm.MDVAst', 'mng-comm.MDVDownload', 'mng-common.MDVAddToIcsCalendar', 'VVSPdfViewer'];

    function VVSPersonalizationTripsController($scope, $state, $filter, MDVPersonalizationHelper, MDVEFATripParser, MDVAst, MDVDownload, MDVAddToIcsCalendar, VVSPdfViewer) {
        var self = this;

        function resetController() {
            $scope.bookSuccess = false;
            $scope.updateSuccess = false;
            $scope.cancelSuccess = false;
            $scope.saveSuccess = false;
            $scope.deleteSuccess = false;
            $scope.bookError = false;
            $scope.updateError = false;
            $scope.cancelError = false;
            $scope.saveError = false;
            $scope.deleteError = false;
            $scope.persError = false;

            $scope.departureUpdated = false;
            $scope.arrivalUpdated = false;

            $scope.filterError = false;
        }



        $scope.delete = function(trip, cancel) {
            resetController();

            MDVPersonalizationHelper.removeTrip(trip.TripId)
                    .then(function() {
                        $scope.deleteSuccess = true;
                        $scope.getTrips();
                    })
                    .catch(function() {
                        $scope.deleteError = true;
                    });

            if (cancel) {
                var raw = JSON.parse(trip.TripRaw),
                    i, l;

                for (i=0, l=raw.legs.length; i<l; i++) {
                    if (raw.legs[i].properties &&
                        ((raw.legs[i].properties.bookingDetails && raw.legs[i].properties.bookingDetails.reservationCode) ||
                        (raw.legs[i].properties.reservationDetails && raw.legs[i].properties.reservationDetails.reservationCode))) {
                        var reservationCode;

                        if (raw.legs[i].properties.reservationDetails) {
                            reservationCode = raw.legs[i].properties.reservationDetails.reservationCode;
                        } else {
                            reservationCode = raw.legs[i].properties.bookingDetails.reservationCode;
                        }

                        return self.astService.cancel(reservationCode)
                            .then(function(res) {
                                if (res && res.ErrorMessage && (res.ErrorMessage === 'CANCELLATION_OK')) {
                                    $scope.cancelSuccess = true;
                                } else {
                                    $scope.cancelError = true;
                                }
                            })
                            .catch(function(e) {
                                $scope.cancelError = true;
                            });
                        break;
                    }
                }

            }

        };


        $scope.book = function(trip) {
            resetController();
            var raw = JSON.parse(trip.TripRaw),
                i, l;

                for (i=0, l=raw.legs.length; i<l; i++) {
                    if (raw.legs[i].properties && raw.legs[i].properties.reservationDetails && raw.legs[i].properties.reservationDetails.reservationCode) {
                        self.astService.book(raw.legs[i].properties.reservationDetails.reservationCode)
                            .then(function(response) {
                                if (response && response.ErrorMessage && (response.ErrorMessage === 'BOOKING_OK')) {
                                    $scope.bookSuccess = true;
                                    raw.legs[i].properties.bookingDetails = raw.legs[i].properties.reservationDetails;
                                    raw.legs[i].properties.bookingDetails.bookingTimestamp = response.reservationDetails.bookingTimestamp;

                                    delete raw.legs[i].properties.reservationDetails;

                                    MDVPersonalizationHelper.removeTrip(trip.TripId)
                                        .then(function() {
                                            MDVPersonalizationHelper.setTrip(MDVEFATripParser.parse({
                                                journeys : [raw]
                                            }).trips[0]
                                            ).then(function() {
                                                $scope.saveSuccess = true;
                                                $scope.getTrips();
                                            })
                                            .catch(function(e) {
                                                $scope.saveError = true;
                                            });
                                        })
                                        .catch(function(e) {
                                            $scope.saveError = true;
                                        });
                                } else {
                                    $scope.bookError = true;
                                }
                            })
                            .catch(function(e) {
                                $scope.bookError = true;
                            });
                        break;
                    }
                }
        };


        $scope.cancel = function(trip) {
            resetController();
            var raw = JSON.parse(trip.TripRaw),
                i, l;

            for (i=0, l=raw.legs.length; i<l; i++) {
                if (raw.legs[i].properties && raw.legs[i].properties.bookingDetails && raw.legs[i].properties.bookingDetails.reservationCode) {
                    self.astService.cancel(raw.legs[i].properties.bookingDetails.reservationCode)
                        .then(function(res) {
                            if (res && res.ErrorMessage && (res.ErrorMessage === 'CANCELLATION_OK')) {
                                $scope.cancelSuccess = true;
                                raw.legs[i].properties.cancelationDetails = raw.legs[i].properties.bookingDetails;
                                raw.legs[i].properties.cancelationDetails.cancelationTimestamp = res.reservationDetails.cancelationTimestamp;
                                delete raw.legs[i].properties.bookingDetails;

                                MDVPersonalizationHelper.removeTrip(trip.TripId)
                                    .then(function() {
                                        MDVPersonalizationHelper.setTrip(MDVEFATripParser.parse({
                                                journeys : [raw]
                                            }).trips[0]
                                        ).then(function() {
                                            $scope.saveSuccess = true;
                                            $scope.getTrips();
                                        })
                                        .catch(function(e) {
                                            $scope.saveError = true;
                                        });
                                    })
                                    .catch(function(e) {
                                        $scope.saveError = true;
                                    });
                            } else {
                                $scope.cancelError = true;
                            }
                        })
                        .catch(function(e) {
                            $scope.cancelError = true;
                        });
                    break;
                }
            }
        };

        $scope.update = function(tripObj) {
            resetController();
            var tripRaw = JSON.parse(tripObj.TripRaw),
                i, l;

            for (i=0, l=tripRaw.legs.length; i<l; i++) {
                if (tripRaw.legs[i].properties) {
                    var reservationCode,
                        oldLegRaw = tripRaw.legs[i];

                    if (tripRaw.legs[i].properties.bookingDetails && tripRaw.legs[i].properties.bookingDetails.reservationCode) {
                        reservationCode = tripRaw.legs[i].properties.bookingDetails.reservationCode;
                    } else if (tripRaw.legs[i].properties.reservationDetails && tripRaw.legs[i].properties.reservationDetails.reservationCode) {
                        reservationCode = tripRaw.legs[i].properties.reservationDetails.reservationCode;
                    }

                    if (reservationCode) {
                        var astIdx = i;
                        self.astService.update(reservationCode)
                            .then(function(res) {
                                var newLegRaw = res.toJSON();

                                $scope.departureUpdated = !moment(oldLegRaw.origin.departureTimePlanned).isSame(moment(newLegRaw.origin.departureTimePlanned));
                                $scope.arrivalUpdated = !moment(oldLegRaw.destination.arrivalTimePlanned).isSame(moment(newLegRaw.destination.arrivalTimePlanned));

                                if ($scope.departureUpdated || $scope.arrivalUpdated) {
                                    if ($scope.departureUpdated) {
                                        oldLegRaw.origin.departureTimePlanned = newLegRaw.origin.departureTimePlanned;
                                        oldLegRaw.origin.departureTimeEstimated = newLegRaw.origin.departureTimeEstimated;
                                    }
                                    if ($scope.arrivalUpdated) {
                                        oldLegRaw.destination.arrivalTimePlanned = newLegRaw.destination.arrivalTimePlanned;
                                        oldLegRaw.destination.arrivalTimeEstimated = newLegRaw.destination.arrivalTimeEstimated;
                                    }
                                    tripRaw[astIdx] = oldLegRaw;

                                    MDVPersonalizationHelper.removeTrip(tripObj.TripId)
                                        .then(function() {
                                            MDVPersonalizationHelper.setTrip(MDVEFATripParser.parse({
                                                    journeys : [tripRaw]
                                                }).trips[0]
                                            ).then(function() {
                                                $scope.saveSuccess = true;
                                                $scope.getTrips();
                                            })
                                            .catch(function(e) {
                                                $scope.saveError = true;
                                            });
                                        })
                                        .catch(function(e) {
                                            $scope.saveError = true;
                                        });
                                } else {
                                    $scope.updateSuccess = true;
                                }
                            })
                            .catch(function(e) {
                                $scope.updateError = true;
                            });
                        break;
                    } else {
                        $scope.updateError = true;
                    }
                }
            }
        };

        $scope.getTrips = function() {
            $scope.tripsObjects = [];

            MDVPersonalizationHelper.getTripSupplement({
                    //'$expand' : 'TripSupplement',
                    //'$filter' : 'Usage eq 5'
                    //'$orderby' : 'Name'
                })
                .then(function(res) {
                    $scope.tripsObjects = $filter('VVSPersonalisationTripSupplementSort')(res);
                })
                .catch(function() {
                    $scope.persError = true;
                });
        };

        $scope.fireFilter = function() {
            var emailFilter = $scope.filter.email,
                nameFilter = $scope.filter.name,
                departureDateFilter = $scope.filter.departureDate,
                filter = '';

            if (emailFilter) {
                filter = 'indexof(Data, \'"EMailAddress":"'+emailFilter+'\') gt -1';
            } else if (nameFilter) {
                filter = 'indexof(Data, \'"Name":"'+nameFilter+'\') gt -1';
            } else if (departureDateFilter) {
                departureDateFilter = moment(departureDateFilter).format('YYYY-MM-DD');
                filter = 'indexof(Data, \'"departureTimePlanned":"'+departureDateFilter+'\') gt -1';
            } else {
                $scope.getTrips();
                return;
            }

            MDVPersonalizationHelper.getTripSupplement({
                    //'$expand' : 'TripSupplement',
                    '$filter' : filter
                    //'$orderby' : 'Name'
                })
                .then(function(res) {
                    if (res.length === 0) {
                        $scope.tripsObjects = [];
                        $scope.filterError = true;
                    } else {
                        $scope.tripsObjects = $filter('VVSPersonalisationTripSupplementSort')(res);
                    }
                })
                .catch(function() {
                    $scope.tripsObjects = [];
                    $scope.filterError = true;
                });

        };

        $scope.triggerAddToIcsCalendarClick = function(trip) {
            MDVAddToIcsCalendar.add(trip, 'www.vvs.de');
        };

        $scope.triggerCreateJourneyPdf = function(trip) {
            MDVDownload.search(MDVDownload.requestTypes.PRINT_TRIP,
                {
                    journeys : [trip],
                    efaParams : {
                        design : 'detail',
                        useUnifiedTickets : '1',
                        fontSizeNormal : '0',
                        serverInfo : '1'
                    }
                })
                .then(function(res) {
                    if (res.response) {
                        VVSPdfViewer.show(res.response);
                    }
                });
        };

        $scope.resetFilter = function() {
            resetController();
            initController();
        };

        $scope.isFrozen = function(date) {
            if (date) {
                date = moment(date).add(1, 'minutes');
                return moment().isAfter(date);
            }
            return false;
        };

        function initController() {
            self.astService = new MDVAst();
            $scope.filter = {};
            $scope.getTrips();
        }
        initController();

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSPersonalizationStopsController', VVSPersonalizationStopsController);

    VVSPersonalizationStopsController.$inject = ['$scope', '$state', 'mng-comm.MDVLocationRequester',
        'mng-model.MDVLocation', 'mng-personalization.MDVPersonalizationHelper'];

    function VVSPersonalizationStopsController($scope, $state, MDVLocationRequester, MDVLocation,
            MDVPersonalizationHelper) {


        initController();

        function initController() {
            $scope.inputLocations = {
                'pers' : ''
            };
        }

        function resetController() {
            $scope.persAlert = false;
            $scope.persError = false;
            $scope.alreadySubscribed = false;
        }

        function alreadySubscribed(location) {
            var found = false;

            for (var i=0; i<$scope.stops.length; i++) {
                if ($scope.stops[i].Key === location.id()) {
                    found = true;
                    break;
                }
            }
            return found;
        }

        $scope.triggerSubscribeToStopClick = function() {
            resetController();
            var userInputs = {},
                promises = [],
                key;

            userInputs.pers = angular.copy($scope.inputLocations.pers);

            if (!userInputs.pers) {
                $scope.persAlert = true;
                return false;
            }

            for (key in userInputs) {
                if (userInputs.hasOwnProperty(key) && (typeof userInputs[key] === 'string')) {
                    promises.push(verifyOdv(key).promise);
                } else if ((typeof userInputs[key] === 'object') &&
                            (userInputs[key].type() !== MDVLocation.LOCATIONTYPES.STOP)) {
                    userInputs[key] = userInputs[key].id();
                    promises.push(verifyOdv(key).promise);
                }
            }

            function verifyOdv(usage) {
                return MDVLocationRequester.search(userInputs[usage])
                        .then(function(result) {
                            if (result.response.length>0) {
                                $scope.inputLocations[usage] = angular.copy(result.response[0]);
                                userInputs[usage] = angular.copy(result.response[0]);
                            }
                            tryFireSearch();
                        }, function() {
                            tryFireSearch();
                        });
            }

            if (promises.length === 0) {
                // we dont need to verify odvs
                fireSearch();
            }

            function tryFireSearch() {
                promises.pop();
                if (promises.length === 0) {
                    fireSearch();
                }
            }

            function fireSearch() {
                $scope.inputLocations.pers = null;

                var location = userInputs.pers;

                if (alreadySubscribed(location)) {
                    $scope.alreadySubscribed = true;
                    return;
                }

                MDVPersonalizationHelper.setLocation(location)
                    .then(function() {
                        $scope.getStops();
                    })
                    .catch(function() {
                        $scope.persError = true;
                    });
            }
        };

        $scope.removeStop = function(stopId) {
            resetController();
            MDVPersonalizationHelper.removeLocation(stopId)
                .then(function() {
                    $scope.getStops();
                })
                .catch(function() {
                    $scope.persError = true;
                });
        };


        $scope.getStops = function() {
            resetController();
            MDVPersonalizationHelper.getLocation({
                '$filter' : 'Usage eq 7',
                '$orderby' : 'Position'

            })
                .then(function(res) {
                    $scope.stops = res;
                })
                .catch(function() {
                    $scope.persError = true;
                });
        };
        $scope.getStops();

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSPersonalizationProfileController', VVSPersonalizationProfileController);

    VVSPersonalizationProfileController.$inject = ['$scope', '$state', '$timeout',
        'mng-personalization.MDVPersonalizationHelper'];

    function VVSPersonalizationProfileController($scope, $state, $timeout, MDVPersonalizationHelper) {


        initController();

        $scope.setPass = false;

        function initController() {
            $scope.personalData = {

            };

            getPersonalData();
        }

        function getPersonalData() {
            MDVPersonalizationHelper.getProfile()
                .then(function(res) {
                    $scope.personalData = res;
                    MDVPersonalizationHelper.isLoggedIn()
                        .then(function(user) {
                            $scope.name = user.username();
                            // $scope.personalData.name = user.username();
                        });
                })
                .catch(function() {
                    MDVPersonalizationHelper.logout()
                        .then(function() {
                            $state.go('vvs.personalization.login');
                        });
                });
        }

        $scope.goBack = function() {
            window.history.back();
        }

        $scope.triggerLogoutClick = function() {
            MDVPersonalizationHelper.logout()
                .then(function() {
                    $scope.loggedInUser = null;
                    $state.go('vvs.personalization.login');
                });
        };

        function hideAlerts() {
            $scope.personalDataChangedAlert = false;
            $scope.personalDataChangedError = false;
            $scope.emailChangedAlert = false;
            $scope.falsePassword = false;
        }

        $scope.submitPersonalDataForm = function() {
            hideAlerts();
            if ($scope.personalDataForm.$valid) {
                var data = angular.copy($scope.personalData);

                if ($scope.personalData.Password && ($scope.personalData.Password.length>0)) {
                    data = {
                        Password : $scope.personalData.Password,
                        NewPassword : $scope.personalData.NewPassword
                    };

                    MDVPersonalizationHelper.changePassword(data)
                        .then(function(res) {
                            if (res.Succeeded) {
                                $scope.personalDataChangedAlert = true;
                            } else {
                                $scope.personalDataChangedError = true;
                                $scope.personalDataChangedAlert = false;
                            }

                        })
                        .catch(function() {
                            $scope.personalDataChangedError = true;
                        });

                }
            }
        };

        $scope.resetInput = function() {
            if ($scope.personalData && $scope.personalData.Password) {
                $scope.personalData.Password = '';
            }
            if ($scope.falsePassword) {
                $scope.falsePassword = false;
            }
        }

        $scope.submitDeleteProfileForm = function(pass) {

            var options = {
                Name : $scope.name,
                Password: pass
            };

            MDVPersonalizationHelper.deactivate(options)
                .then(function(res) {
                    if (res.Deleted) {
                        MDVPersonalizationHelper.logout()
                        .then(function() {
                            window.profileIsDeleted = true;
                            $state.go('vvs.personalization.registration');
                        });
                    } else {
                        $scope.falsePassword = true;
                    }

                })
                .catch(function() {
                    $scope.invalidLoginInputsAlert = true;
                });
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSPersonalizationLogoutController', VVSPersonalizationLogoutController);

    VVSPersonalizationLogoutController.$inject = ['$scope', '$state',
        'mng-personalization.MDVPersonalizationHelper'];

    function VVSPersonalizationLogoutController($scope, $state, MDVPersonalizationHelper) {


        initController();

        function initController() {
            logout();
        }

        function logout() {
            MDVPersonalizationHelper.logout()
                .then(function() {
                    $state.go('vvs.personalization.login');
                });
        }

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSPersonalizationLoginController', VVSPersonalizationLoginController);

    VVSPersonalizationLoginController.$inject = ['$scope', '$state',
        'mng-personalization.MDVPersonalizationHelper'];

    function VVSPersonalizationLoginController($scope, $state, MDVPersonalizationHelper) {

        $scope.passwordIsSent = window.passwordIsSent;
        $scope.passwordIsSentFirst = window.passwordIsSentFirst;
        $scope.passwordIsSentSecond = window.passwordIsSentSecond;
        $scope.logoutAlert = window.logoutAlert;

        initController();

        inputFocus();

        function initController() {
            redirectIfIsLoggedIn();

        }

        function inputFocus(){
            document.getElementById('nickname').focus();
        }

        function redirectIfIsLoggedIn() {
            MDVPersonalizationHelper.isLoggedIn()
                .then(function(res) {
                    if (res) {
                        $state.go('vvs.personalization.init');
                    }
                });
        }

        $scope.submitLoginForm = function() {
            hideAlerts();
            if ($scope.loginForm.$valid) {
                var user = angular.copy($scope.user);
                var options = {
                    Name: user.Username,
                    Password: user.Password,
                    Client: 'vvs',
                    RememberLogin: $scope.user.isRemembered ? true:false
                };

                MDVPersonalizationHelper.login(options)
                    .then(function(res) {
                        if (res) {
                            $state.go('vvs.personalization.init');
                        } else {
                            $scope.invalidLoginInputsAlert = true;
                        }
                    })
                    .catch(function(err) {
                        console.log(err);
                        $scope.invalidLoginInputsAlert = true;
                    });
            }
        };

        function hideAlerts() {
            $scope.invalidLoginInputsAlert = false;
            window.passwordIsSent = false;
            window.passwordIsSentFirst = false;
            window.passwordIsSentSecond = false;
            $scope.logoutAlert = false;
        }

 var rmCheck = document.getElementById("rememberMe");

     $scope.isRememberMe = function() {
         if (rmCheck.checked) {
             $scope.user.isRemembered = true;
            //  localStorage.checkbox = rmCheck.value;
         } else {
            $scope.user.isRemembered = "";
            // localStorage.checkbox = "";
         }
     }


    }

}());

(function () {
    "use strict";

    angular
        .module("vvs")
        .controller(
            "VVSPersonalizationInitController",
            VVSPersonalizationInitController
        );

    VVSPersonalizationInitController.$inject = [
        "$scope",
        "$state",
        "$element",
        "mng-personalization.MDVPersonalizationHelper",
        "mng-comm.MDVTransportationRequester",
        "mng-favorite.MDVLocationFavorite",
        "mng-comm.MDVLocationRequester",
        "VVSBrowserUtilities",
        "mng-model.MDVLocation",
    ];

    function VVSPersonalizationInitController(
        $scope,
        $state,
        $element,
        MDVPersonalizationHelper,
        MDVTransportationRequester,
        MDVLocationFavorite,
        MDVLocationRequester,
        VVSBrowserUtilities,
        MDVLocation
    ) {
        var self = this;

        $scope.locations = [];
        $scope.resultHeight = "0px";
        $scope.showAssignedBlock = true;

        self.noCache = false;
        self.querySearch = querySearch;
        self.triggerKeyDown = triggerKeyDown;

        $scope.sbahnCodeArr = [10];
        $scope.rbahnCodeArr = [11, 12];
        $scope.ubahnCodeArr = [20, 21];
        $scope.busCodeArr = [
            30,
            31,
            33,
            34,
            50,
            51,
            52,
            53,
            61,
            62,
            70,
            71,
            76,
            77,
            81
        ]; // : 50 -Ruftaxi, LinienTaxi

        $scope.selectedSbahnLines = $scope.allSbahnLinesSubscribed ?
            "" :
            $scope.selectedSbahnLines;
        $scope.selectedRbahnLines = $scope.allRbahnLinesSubscribed ?
            "" :
            $scope.selectedRbahnLines;
        $scope.selectedUbahnLines = $scope.allUbahnLinesSubscribed ?
            "" :
            $scope.selectedUbahnLines;
        $scope.selectedBusLines = $scope.allBusLinesSubscribed ?
            "" :
            $scope.selectedBusLines;

        var _private = {
            efaParams: null,
        };

        if (VVSBrowserUtilities.getMobileOperatingSystem() === "unknown") {
            self.modelOptions = {
                debounce: 250,
            };
        } else {
            self.modelOptions = {
                debounce: 750,
            };
        }

        initController();

        function resetController() {
            $scope.persAlert = false;
            $scope.persError = false;
            $scope.alreadySubscribed = false;
        }

        function initController() {
            $scope.persError = false;
            $scope.notification = {
                Active: false,
                GenericMessages: false,
            };
            getProfile();

            $scope.inputLocations = {};
        }

        function alreadySubscribed(location) {
            var found = false;

            for (var i = 0; i < $scope.stops.length; i++) {
                if ($scope.stops[i].Key === location.properties().stopId) {
                    // if ($scope.stops[i].Key === location.id()) { // old version with global id as key
                    found = true;
                    break;
                }
            }
            return found;
        }

        $scope.getLines = function () {
            $scope.result = [];
            $scope.selectedLines = [];
            $scope.selectedSbahnLines = [];
            $scope.selectedRbahnLines = [];
            $scope.selectedUbahnLines = [];
            $scope.selectedBusLines = [];

            MDVPersonalizationHelper.getTransportation({
                    $filter: "Usage eq 7",
                    $orderby: "Name",
                })
                .then(function (res) {
                    $scope.result = res;
                    $scope.result.map(function (el) {
                        $scope.selectedLines.push(el.Name);
                    });

                    $scope.selectedSbahnLines = $scope.selectedLines
                        .filter(function (line) {
                            if (line.includes("S-Bahn")) {
                                return line;
                            }
                        })
                        .map(function (el) {
                            return el.split(" ").slice(-1).pop();
                        });
                    $scope.sbahnlength = $scope.selectedSbahnLines.length;
                    $scope.selectedSbahnLines = $scope.selectedSbahnLines.toString();

                    $scope.selectedRbahnLines = $scope.selectedLines
                        .filter(function (line) {
                            if (line.includes("R-Bahn")) {
                                return line;
                            }
                        })
                        .map(function (el) {
                            return el.split(" ").slice(-1).pop();
                        });
                    $scope.rbahnlength = $scope.selectedRbahnLines.length;
                    $scope.selectedRbahnLines = $scope.selectedRbahnLines.toString();

                    $scope.selectedUbahnLines = $scope.selectedLines
                        .filter(function (line) {
                            if (
                                line.includes("U-Bahn") ||
                                line.includes("Stadtbahn") ||
                                line.includes("Zahnradbahn") ||
                                line.includes("Seilbahn")
                            ) {
                                return line;
                            }
                        })
                        .map(function (el) {
                            return el.split(" ").slice(-1).pop();
                        });
                    $scope.ubahnlength = $scope.selectedUbahnLines.length;
                    $scope.selectedUbahnLines = $scope.selectedUbahnLines.toString();

                    $scope.selectedBusLines = $scope.selectedLines
                        .filter(function (line) {
                            if (
                                line.includes("Bus") ||
                                line.includes("Museumsverkehr") ||
                                line.includes("Ruftaxi") ||
                                line.includes("Linientaxi")
                            ) {
                                return line;
                            }
                        })
                        .map(function (el) {
                            return el.split(" ").slice(-1).pop();
                        });
                    $scope.buslength = $scope.selectedBusLines.length;
                    $scope.selectedBusLines = $scope.selectedBusLines.toString();
                })
                .catch(function (err) {
                    console.log("err", err);
                });
        };
        $scope.getLines();
        //////////////////////////////

        function getProfile() {
            MDVPersonalizationHelper.getProfile()
                .then(function (res) {
                    $scope.profile = res;
                    getNotification();
                })
                .catch(function () {
                    MDVPersonalizationHelper.logout().then(function () {
                        $state.go("vvs.personalization.login");
                    });
                });
        }

        $scope.getLineList = function (code) {
            // MDVTransportationRequester.getLineList(code);
            if (code === $scope.sbahnCodeArr) {
                $state.go("vvs.personalization.sbahnLines");
            } else if (code === $scope.rbahnCodeArr) {
                $state.go("vvs.personalization.rbahnLines");
            } else if (code === $scope.ubahnCodeArr) {
                $state.go("vvs.personalization.ubahnLines");
            } else if (code === $scope.busCodeArr) {
                $state.go("vvs.personalization.busLines");
            }
        };

        $scope.getAllLines = function (codesArr) {
            MDVTransportationRequester.getLineList("TEST", {
                codes: codesArr,
            }).then(function (res) {
                // $scope.getLines(); !!!!!
                if (codesArr === $scope.sbahnCodeArr) {
                    var sbahnlength = res.response.length;
                    if (sbahnlength === $scope.sbahnlength) {
                        $scope.allSbahnLinesSubscribed = true;
                    }
                    console.log("SBAHN", res.response);
                } else if (codesArr === $scope.rbahnCodeArr) {
                    var rbahnlength = res.response.length;
                    if (rbahnlength === $scope.rbahnlength) {
                        $scope.allRbahnLinesSubscribed = true;
                    }
                } else if (codesArr === $scope.ubahnCodeArr) {
                    var ubahnlength = res.response.length;
                    if (ubahnlength === $scope.ubahnlength) {
                        $scope.allUbahnLinesSubscribed = true;
                    }
                } else if (codesArr === $scope.busCodeArr) {
                    var buslength = res.response.length;
                    if (buslength === $scope.buslength) {
                        $scope.allBusLinesSubscribed = true;
                    }
                }
            });
        };

        $scope.getAllLines($scope.sbahnCodeArr);
        $scope.getAllLines($scope.rbahnCodeArr);
        $scope.getAllLines($scope.ubahnCodeArr);
        $scope.getAllLines($scope.busCodeArr);

        function getNotification() {
            MDVPersonalizationHelper.getNotification().then(function (res) {
                if (res === null) {
                    $scope.notification = {
                        Active: true,
                        GenericMessages: true,
                    };

                    $scope.submitProfileForm();
                } else {
                    $scope.notification = res;
                }
            });
            // .catch(function() {
            //     MDVPersonalizationHelper.logout()
            //         .then(function() {
            //             // $state.go('vvs.personalization.login');
            //         });
            // });
        }

        $scope.submitProfileForm = function () {
            $scope.profileChangedAlert = false;

            if ($scope.notification.Id) {
                console.log("if -> has Id");
                MDVPersonalizationHelper.updateNotification(
                        $scope.notification.Id, {
                            Active: $scope.notification.Active,
                            GenericMessages: $scope.notification.GenericMessages,
                        }
                    )
                    .then(function () {
                        $scope.profileChangedAlert = true;
                    })
                    .catch(function () {
                        MDVPersonalizationHelper.logout().then(function () {
                            $state.go("vvs.personalization.login");
                        });
                    });
            } else {
                console.log("else -> No Id");
                // Changed data for new endpoint (EFAF-9488)
                var subscriptionData = {
                    // UserId: $scope.profile.Id,
                    Reference: $scope.profile.Email,
                    Active: $scope.notification.Active,
                    Type: 6,
                };

                MDVPersonalizationHelper.subscribeByEmail(subscriptionData, "email").then(function (res) {
                    $scope.notification = res;
                })
            }
        };

        // Abmelden
        $scope.triggerLogoutClick = function () {
            MDVPersonalizationHelper.logout()
                .then(function () {
                    $scope.loggedInUser = null;
                    $state.go("vvs.personalization.login");
                    // $state.go('vvs.personalization.logout');
                    window.logoutAlert = true;
                })
                .catch(function (e) { 
                    $state.go("vvs.personalization.login");
                });
        };

        /************* STOPFINDER BLOCK *************/

        function triggerKeyDown(evt) {
            if ([13, 27].indexOf(evt.which) > -1) {
                $scope.locations.length = 0;
                resetResultHeight();
            }
        }

        $scope.filter = {};
        $scope.triggerFocus = function () {
            $scope.filter.searchValue = '';
            $scope.alreadySubscribed = false;
            querySearch($scope.filter.searchValue).then(function (res) {
                $scope.locations = res;
                console.log("RES", res);
                resetResultHeight();
            });
        };

        $scope.triggerChange = function () {
            querySearch($scope.filter.searchValue).then(function (res) {
                $scope.locations = res;
                resetResultHeight();
            });
        };

        function querySearch(inputVal) {
            if (!inputVal) {
                // get all history from DB
                return getPersistedLocations();
            } else {
                // merge history and fetched locations
                return getPersistedAndNewLocations(inputVal);
            }
        }

        function resetResultHeight() {
            if ($scope.locations.length < 10) {
                $scope.resultHeight = 50 * $scope.locations.length + "px";
            } else {
                $scope.resultHeight = 8 * 50 + "px";
            }
        }

        // get all history locations from DB
        function getPersistedLocations(inputVal) {
            return MDVLocationFavorite.get(null, "pers").then(function (res) {
                if (inputVal && inputVal.length > 0) {
                    // filter results
                    res = getFilteredPersistedLocations(inputVal, res);
                }
                // sort persisted locations
                res = $filter("orderBy")(res, "-persistence.modified");
                // add 'history' class name
                res = addLocationClassName(res, "history");
                return addSuggestionIndex(res);
            });
        }

        // remove not matched persisted locations
        function getFilteredPersistedLocations(matchStr, persistedLocations) {
            var re_str = new RegExp("^" + matchStr, "gi"),
                filteredLocations = [],
                locationName,
                i,
                l;

            for (i = 0, l = persistedLocations.length; i < l; i += 1) {
                locationName = $filter("VVSLocationSuggestFormatter")(
                    persistedLocations[i],
                    true
                );

                if (re_str.test(locationName)) {
                    filteredLocations.push(persistedLocations[i]);
                }
            }
            return filteredLocations;
        }

        function addSuggestionIndex(locs) {
            var i, l;

            for (i = 0, l = locs.length; i < l; i += 1) {
                locs[i].suggestionIndex = i;
            }
            return locs;
        }

        function addLocationClassName(locationsArr, className) {
            angular.forEach(locationsArr, function (value) {
                value.className = className;
            });
            return locationsArr;
        }

        // get unique list of best, history and new requested locations
        function getPersistedAndNewLocations(inputVal) {
            return getPersistedLocations(inputVal)
                .then(function (persistedLocations) {
                    return getNewLocations(inputVal, persistedLocations);
                })
                .catch(function () {
                    return getNewLocations(inputVal);
                });
        }

        function getNewLocations(inputVal, persistedLocations) {
            var result = persistedLocations || [],
                opts = {
                    efaParams: {},
                };

            // if ($scope.usage === 'pers') {
            opts.efaParams.anyObjFilter_sf = 2;
            // }

            return MDVLocationRequester.search(inputVal, opts)
                .then(function (data) {
                    $scope.requestFailed = false;
                    var bestMatchLocations = getBestMatchLocations(
                            data.response
                        ),
                        newLocations;

                    // add 'best' class name
                    bestMatchLocations = addLocationClassName(
                        bestMatchLocations,
                        "best"
                    );
                    result = removeArrayFromArray(bestMatchLocations, result);
                    result = bestMatchLocations.concat(result);
                    newLocations = removeArrayFromArray(result, data.response);
                    // add 'new' class name
                    newLocations = addLocationClassName(newLocations, "new");
                    result = result.concat(newLocations);

                    return addSuggestionIndex(result);
                })
                .catch(function (e) {
                    $scope.requestFailed = true;
                });
        }

        // return the list of best Matched locations
        function getBestMatchLocations(newLocations) {
            var best = [],
                i,
                l;

            for (i = 0, l = newLocations.length; i < l; i += 1) {
                if (
                    newLocations[i].isBestMatch() ||
                    newLocations.length === 1
                ) {
                    best.push(newLocations[i]);
                }
            }
            return best;
        }

        // remove array from another array
        function removeArrayFromArray(arrTobeRemoved, arrTobeRemovedFrom) {
            var i, j, l, m;

            for (i = 0, l = arrTobeRemovedFrom.length; i < l; i += 1) {
                for (j = 0, m = arrTobeRemoved.length; j < m; j += 1) {
                    if (
                        arrTobeRemovedFrom[i] &&
                        arrTobeRemovedFrom[i].id() === arrTobeRemoved[j].id()
                    ) {
                        arrTobeRemovedFrom.splice(i, 1);
                    }
                }
            }
            return arrTobeRemovedFrom;
        }

        $scope.triggerStopSelect = function (mdvLocation) {
            $scope.locations.length = 0;
            $scope.inputLocations.dm = [];
            $scope.showAssignedBlock = true;
            resetResultHeight();
            $scope.filter.searchValue = angular.copy(mdvLocation);
            MDVLocationFavorite.set(mdvLocation, "pers");
            $element.find("input").blur();
            $scope.assignedStops = mdvLocation.assignedStops();

            $scope.triggerSubscribeToStopClick();
        };

        $scope.abo = {
            stop: false,
        };

        // trigger subscribe to the stop
        $scope.triggerSubscribeToStopClick = function () {
            resetController();
            var userInputs = {},
                promises = [],
                key;

            userInputs.pers = angular.copy($scope.filter.searchValue);

            userInputs.dm = angular.copy($scope.filter.searchValue);

            if (!userInputs.pers) {
                $scope.persAlert = true;
                return false;
            }

            for (key in userInputs) {
                if (
                    userInputs.hasOwnProperty(key) &&
                    typeof userInputs[key] === "string"
                ) {
                    promises.push(verifyOdv(key).promise);
                } else if (
                    typeof userInputs[key] === "object" &&
                    userInputs[key].type() !== MDVLocation.LOCATIONTYPES.STOP
                ) {
                    userInputs[key] = userInputs[key].id();
                    promises.push(verifyOdv(key).promise);
                }
            }

            function verifyOdv(usage) {
                return MDVLocationRequester.search(userInputs[usage]).then(
                    function (result) {
                        if (result.response.length > 0) {
                            $scope.filter.searchValue = angular.copy(
                                result.response[0]
                            );
                            $scope.inputLocations[usage] = angular.copy(
                                result.response[0]
                            );
                            console.log(
                                "userInputs[usage]",
                                usage,
                                userInputs[usage]
                            );
                        }
                        tryFireSearch();
                    },
                    function () {
                        tryFireSearch();
                    }
                );
            }

            if (promises.length === 0) {
                // we dont need to verify odvs
                fireSearch();
            }

            function tryFireSearch() {
                promises.pop();
                if (promises.length === 0) {
                    fireSearch();
                }
            }

            function fireSearch() {
                console.log("gesendet id - dm.properties().stopId)", userInputs.dm.properties().stopId);
                MDVLocationRequester.search(userInputs.dm.properties().stopId, {
                        efaParams: _private.efaParams,
                    })
                    // MDVLocationRequester.search(userInputs.dm.id(), {efaParams: _private.efaParams})
                    .then(function (result) {
                        // result.response[0].assignedStops().map(function(el) {
                        //     if (result.response[0].id() === el.id()) {
                        //         el.name() = result.response[0].name();
                        //         return el;
                        //     }
                        // })

                        if (result.response.length > 0) {
                            $scope.inputLocations.dm = angular.copy(
                                result.response[0]
                            );
                            userInputs.dm = angular.copy(result.response[0]);

                            // TEST
                            $scope.filter.searchValue = null;

                            var location = userInputs.pers;

                            var assigns = $scope.inputLocations.dm.assignedStops();
                            assigns = assigns.map(function (el) {
                            // assigns = assigns.map(function (el) {
                                if (alreadySubscribed(el)) {
                                    el.abo = true;
                                }
                                return el;
                            });


                            if ($scope.inputLocations.dm.assignedStops().length <= 1) {
                                if (alreadySubscribed(location)) {
                                    $scope.alreadySubscribed = true;
                                    return;
                                }
                                MDVPersonalizationHelper.setLocationWithoutGlID(location)
                                    .then(function () {
                                        $scope.getStops();
                                    })
                                    .catch(function () {
                                        $scope.persError = true;
                                    });
                            }

                        }
                    }).catch(function(e) {
                        console.log('e', e);
                    });
            }
        };



        $scope.triggerSelectAssignedStopClick = function (location, flag) {
            location.asName =  (location.disassembledName() && location.parent().name() !== location.disassembledName()) ? location.parent().name() + ', ' + location.disassembledName() : location.name();

            $scope.locations.length = 0;
            resetResultHeight();
            $scope.filter.searchValue = angular.copy(location);
            MDVLocationFavorite.set(location, "pers");
            $element.find("input").blur();

            $scope.stops.map(function (el) {
                if (el.Key === location.id()) {
                    location.Id = el.Id;
                }
                return el;
            });

            if (flag) {
                if (alreadySubscribed(location)) {
                    $scope.alreadySubscribed = true;
                    $scope.abo = true;
                    return;
                }
                $scope.triggerSubscribeToStopClick();
                MDVPersonalizationHelper.setLocationWithoutGlID(location)
                    .then(function () {
                        $scope.getStops();
                    })
                    .catch(function () {
                        $scope.persError = true;
                    });
            } else {
                // 1 map variant
                $scope.stops.map(function (el) {
                    if (el.Key === location.properties().stopId) {
                        $scope.removeStop(el.Id);
                    }
                });
                // 2 find variant
                /* var stop = $scope.stops.find(function(el) {
                    return el.Key === location.properties().stopId;
                });
                console.log('stop', stop);
                $scope.removeStop(stop.Id); */

            }

            // $scope.triggerSubscribeToStopClick();
        };

        $scope.removeStop = function (stopId) {
            resetController();
            MDVPersonalizationHelper.removeLocation(stopId)
                .then(function () {
                    $scope.getStops();
                })
                .catch(function () {
                    $scope.persError = true;
                });
        };

        $scope.getStops = function () {
            resetController();
            MDVPersonalizationHelper.getLocation({
                    $filter: "Usage eq 7",
                    $orderby: "Position",
                })
                .then(function (res) {
                    res = res.map(function(stop) {
                        stop.Name = stop.Name.split(', ').reverse().join(', ');
                        return stop;
                    });

                    // sortierung Haltestellen
                    res = res.sort(function(a, b){
                        // if(a.Name.split(' ')[0].replace(/,/g, '') < b.Name.split(' ')[0].replace(/,/g, '')) { return -1; }
                        // if(a.Name.split(' ')[0].replace(/,/g, '') < b.Name.split(' ')[0].replace(/,/g, '')) { return 1; }
                        if (b.Name < a.Name) {
                            return 1;
                          } else if (b.Name > a.Name) {
                            return -1
                          } else {
                            return 0;
                          }
                    })
                    $scope.stops = res;

                    console.log("STOPS", res);

                })
                .catch(function () {
                    $scope.persError = true;
                });
        };
        $scope.getStops();

        $scope.closeAssignedStops = function () {
            $scope.showAssignedBlock = false;
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSPersonalizationForgottenFirstController', VVSPersonalizationForgottenFirstController);

    VVSPersonalizationForgottenFirstController.$inject = ['$scope', '$state',
        'mng-personalization.MDVPersonalizationHelper', 'mng-common.MDVUriParams', '$location'];

    function VVSPersonalizationForgottenFirstController($scope, $state, MDVPersonalizationHelper, MDVUriParams, $location) {

        console.log('VVSPersonalizationForgottenFirstController');

        var fullUrl = $location.absUrl();
        console.log('fullUrl', fullUrl);


        initController();

        function initController() {
            redirectIfIsLoggedIn();
            inputFocus();
        }

        function redirectIfIsLoggedIn() {
            MDVPersonalizationHelper.isLoggedIn()
                .then(function(res) {
                    if (res) {
                        $state.go('vvs.personalization.init');
                    }
                });
        }

        function inputFocus() {
            // passwort forgotten or submit new passwort
            return fullUrl.includes('forgottenFirst') ? document.getElementById('nickname').focus() : document.getElementById('passwort').focus();
        }

        $scope.submitForgottenForm = function() {
            hideAlerts();
            if ($scope.forgottenForm.$valid) {
                var user = $scope.user;
                user.Client = 'vvs';
                user.Email = user.Username;
                console.log('User', user);

                MDVPersonalizationHelper.initiatePasswordReset(user)
                    .then(function(res) {
                        window.passwordIsSentFirst = true;
                        // $state.go('vvs.personalization.confirmforgottenFirst');
                        $state.go('vvs.personalization.login');
                    })
                    .catch(function(e) {
                        console.log('Error: ', e);
                        $scope.invalidPasswordResettingInputsAlert = true;
                    });
            }
        };
        $scope.submitResetPasswordForm = function() {
            console.log('submit reset password');
            hideAlerts();
            // var code = MDVUriParams.get('code');
            var code = MDVUriParams.get('code'); // als TEST
            // var code = MDVUriParams.get('code') || 'CQAAAAAAAQC_7Cdn'; // als TEST

            if (code && $scope.resetPasswordForm.$valid) {
                var user = {
                    NewPassword : $scope.user.NewPassword,
                    ConfirmationCode: code
                };

                MDVPersonalizationHelper.passwordReset(user)
                    .then(function(res) {
                        console.log('RES', res);
                        window.passwordIsSentSecond = true;
                        $state.go('vvs.personalization.login');
                    })
                    .catch(function() {
                        console.log('Error: ', e);
                        $scope.invalidPasswordResettingInputsAlert = true;
                    });
            }
        };



/*         $scope.submitForgottenForm = function() {
            hideAlerts();
            if ($scope.forgottenForm.$valid) {
                var user = $scope.user;

                MDVPersonalizationHelper.resetPasswordByUsername(user)
                    .then(function() {
                        window.passwordIsSent = true;
                        //$state.go('vvs.personalization.confirmforgottenFirst');
                        $state.go('vvs.personalization.login');
                    })
                    .catch(function() {
                        $scope.invalidPasswordResettingInputsAlert = true;
                    });
            }
        }; */

        function hideAlerts() {
            $scope.invalidPasswordResettingInputsAlert = false;
        }

    }


    angular
        .module('vvs')
        .controller('VVSPersonalizationForgottenSecondController',
                VVSPersonalizationForgottenSecondController);

    VVSPersonalizationForgottenSecondController.$inject = ['$scope', '$state',
        'mng-personalization.MDVPersonalizationHelper'];

    function VVSPersonalizationForgottenSecondController($scope, $state, MDVPersonalizationHelper) {


        initController();

        function initController() {
            redirectIfIsLoggedIn();
        }

        function redirectIfIsLoggedIn() {
            MDVPersonalizationHelper.isLoggedIn()
                .then(function(res) {
                    if (res) {
                        $state.go('vvs.personalization.init');
                    }
                });
        }

        $scope.submitForgottenForm = function() {
            hideAlerts();

            if ($scope.forgottenForm.$valid) {
                var user = angular.copy($scope.user);

                MDVPersonalizationHelper.resetPasswordByMail(user)
                    .then(function() {
                        $state.go('vvs.personalization.confirmforgottenSecond');
                    });
            }
        };
        $scope.submitResetPasswordForm = function() {
            hideAlerts();

            if ($scope.resetPasswordForm.$valid) {
                var user = angular.copy($scope.user);

                // MDVPersonalizationHelper.resetPasswordByMail(user)
                //     .then(function() {
                //         $state.go('vvs.personalization.confirmforgottenSecond');
                //     });
            }
        };

        function hideAlerts() {
            $scope.invalidPasswordResettingInputsAlert = false;
        }

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsTimePicker', vvsTimePicker);

    vvsTimePicker.$inject = ['$filter'];

    function vvsTimePicker($filter) {
        return {
            restrict : 'A',
            require : 'ngModel',
            replace : false,
            scope : true,
            controller : 'VVSOdvTimePickerController',
            controllerAs : 'VVSOdvTimePickerCtrl'
        };
    }

}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .controller('VVSOdvTimePickerController', VVSOdvTimePickerController);

    VVSOdvTimePickerController.$inject = ['$scope', '$filter', 'moment', 'VVSConst'];

    function VVSOdvTimePickerController($scope, $filter, moment, VVSConst) {
        var self = this;

        if ($scope.SEARCH_OPTIONS.dateTime.time === 'now') {
            $scope.SEARCH_OPTIONS.dateTime.time = moment();
        } else if ($scope.SEARCH_OPTIONS.dateTime.time._isAMomentObject) {
            // nothing to do
        } else {
            $scope.SEARCH_OPTIONS.dateTime.time = moment($scope.SEARCH_OPTIONS.dateTime.time, VVSConst.timePickerFormat);
        }

        self.timeModel = $scope.SEARCH_OPTIONS.dateTime.time.format(VVSConst.timePickerFormat);

        self.triggerKeyDown = function(evt) {
            if (evt.which === 13) {
                self.timeChanged();
            }
        }

        self.timeChanged = function() {
            if (self.timeModel) {
                self.timeModel = self.timeModel.replace('.', ':');
            }

            if (self.timeModel && (self.timeModel.indexOf(':') < 0)) {
                switch(self.timeModel.length) {
                case 1:
                    self.timeModel = '0' + self.timeModel + ':00';
                    break;
                case 2:
                    self.timeModel = self.timeModel + ':00';
                    break;
                case 3:
                    self.timeModel = '0' + self.timeModel[0] + ':' + self.timeModel[1] + self.timeModel[2];
                    break;
                case 4:
                    self.timeModel = self.timeModel[0] + self.timeModel[1] + ':' + self.timeModel[2] + self.timeModel[3];
                    break;
                case 5:
                    self.timeModel = self.timeModel[0] + self.timeModel[1] + ':' + self.timeModel[3] + self.timeModel[4];
                    break;
                default:
                    self.timeModel = moment().format(VVSConst.timePickerFormat);
                    break;
                }
            }

            $scope.SEARCH_OPTIONS.dateTime.time = moment(self.timeModel, VVSConst.timePickerFormat);
            if (!$scope.SEARCH_OPTIONS.dateTime.time.isValid()) {
                $scope.SEARCH_OPTIONS.dateTime.time = moment();
                self.timeModel = $scope.SEARCH_OPTIONS.dateTime.time.format(VVSConst.timePickerFormat);
            }
        };
        self.timeChanged();
    }
}());

(function() {
    'use strict';

    /**
     * The `VVSDatePickerController` is bounded to the `odv\date-picker.hmtl` template
     * to interact with the angular bootstrap datepicker.
     * @TODO use 'moment'
     **/
    angular
        .module('vvs')
        .controller('VVSOdvDatePickerWebController', VVSOdvDatePickerWebController);

    VVSOdvDatePickerWebController.$inject = ['$scope', '$filter', '$mdDateLocale', 'moment', 'VVSConst'];

    function VVSOdvDatePickerWebController($scope, $filter, $mdDateLocale, moment, VVSConst) {
        var self = this;

        $mdDateLocale.parseDate = function(dateString) {
            var m = moment(dateString, VVSConst.dateFormat);

            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        if (typeof $scope.SEARCH_OPTIONS.dateTime.date === 'string') {
            if ($scope.SEARCH_OPTIONS.dateTime.date === 'now') {
                $scope.SEARCH_OPTIONS.dateTime.date = new Date();
            } else {
                $scope.SEARCH_OPTIONS.dateTime.date = moment($scope.SEARCH_OPTIONS.dateTime.date, VVSConst.dateFormat).toDate();
            }
        } else if ($scope.SEARCH_OPTIONS.dateTime.date._isAMomentObject) {
            $scope.SEARCH_OPTIONS.dateTime.date = $scope.SEARCH_OPTIONS.dateTime.date.toDate();
        }

        self.dateChanged = function() {
            $scope.SEARCH_OPTIONS.dateTime.date = moment($scope.SEARCH_OPTIONS.dateTime.date);
        };
        self.dateChanged();

        // function to increment the current date
        self.incDay = function() {
            $scope.SEARCH_OPTIONS.dateTime.date = moment($scope.SEARCH_OPTIONS.dateTime.date).add(1, 'day').toDate();
            self.dateChanged();
        };

        // function to decrement the current date
        self.decDay = function() {
            $scope.SEARCH_OPTIONS.dateTime.date = moment($scope.SEARCH_OPTIONS.dateTime.date).add(-1, 'day').toDate();
            self.dateChanged();
        };
    }


    angular
        .module('vvs')
        .controller('VVSOdvDatePickerMobileController', VVSOdvDatePickerMobileController);

    VVSOdvDatePickerMobileController.$inject = ['$scope', 'moment', 'VVSConst'];

    function VVSOdvDatePickerMobileController($scope, moment, VVSConst) {

    }


}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsMapPopover', vvsMapPopover);

    vvsMapPopover.$inject = ['mng-model.MDVLocation'];

    function vvsMapPopover(MDVLocation) {
        return {
            restrict : 'E',
            scope : {
                hideDm : '=',
                marker : '=',
                usage : '=',
                type : '=',
                location : '=',
                trans : '='
            },
            controller : 'VVSMapPopoversController',
            templateUrl : function(elem, attrs) {
                if (attrs.type === 'currentPosition') {
                    return 'app/vvs.components/map/popovers/currentPosition.html';
                } else if (attrs.type === 'livePosition') {
                    return 'app/vvs.components/map/popovers/livePosition.html';
                } else if ((attrs.type === MDVLocation.LOCATIONTYPES.POI_AREA) || (attrs.type === MDVLocation.LOCATIONTYPES.POI) || (attrs.type === MDVLocation.LOCATIONTYPES.SHARING)) {
                    return 'app/vvs.components/map/popovers/poi.html';
                } else if (attrs.type === MDVLocation.LOCATIONTYPES.STOP) {
                    return 'app/vvs.components/map/popovers/stop.html';
                } else {
                    return 'app/vvs.components/map/popovers/unknown.html';
                }
            }
        };
    }


}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSMapPopoversController', VVSMapPopoversController);

    VVSMapPopoversController.$inject = ['$scope', '$state', '$timeout', 'VVSConst', 'mng-comm.MDVDepartures'];

    function VVSMapPopoversController($scope, $state, $timeout, VVSConst, MDVDepartures) {

        $scope.getDepartures = function() {
            var depService = new MDVDepartures(),
                dmOptions = depService.getOptions();

            dmOptions.efaParams = {
                limit : 5
            };
            depService.updateLocation($scope.location);
            depService.search().then(function() {
                $scope.departures = depService.getResults();
                /*$timeout(function() {
                    $scope.marker._popup.update();
                }, 500);*/

            });
        };

        function getPoiHierarchyKey(val) {
            if (Array.isArray(val)) {
                if (val.length > 0) {
                    if (val.length === 1) {
                        return val[0];
                    } else {
                        var i, l;

                        for (i=0, l=val.length; i<l; i++) {
                            if (val[i].length === 1) {
                                return val[i];
                            }
                        }
                    }
                }
            }
            return val;
        }

        $scope.getPoiIconName = function() {
            var hierarchyKey,
                i, l;

            if ($scope.location.properties().hasOwnProperty('POI_HIERARCHY_KEY')) {
                hierarchyKey = getPoiHierarchyKey($scope.location.properties().POI_HIERARCHY_KEY);
            } else if ($scope.location.type() === 'sharingProvider') {
                hierarchyKey = 'M';
            }

            if (hierarchyKey) {
                for (i = 0, l = VVSConst.poiCategories.length; i < l; i += 1) {
                    if (hierarchyKey === VVSConst.poiCategories[i].key) {
                        return VVSConst.poiCategories[i].icon;
                    }
                }
            }

            return 'poi';
        };

        $scope.assignPopoverLocation = function(location, usage) {
            if (usage === 'orig') {
                $state.go('vvs.trip.init', {'orig' : location}, {
                    notify : true
                });
            } else if (usage === 'dest') {
                $state.go('vvs.trip.init', {'dest' : location}, {
                    notify : true
                });
            } else if (usage === 'dm') {
                $state.go('vvs.dm.init', {'dm' : location}, {
                    notify : true
                });
            } else if (usage === 'rop') {
                $state.go('vvs.rop.stops', {'rop' : location}, {
                    notify : true
                });
            } else if (usage === 'ttb') {
                $state.go('vvs.ttb.init', {'ttb' : location});
            } else if (usage === 'stt') {
                $state.go('vvs.stt.init', {'stt' : location});
            }
        };
    }

}());


(function() {
    'use strict';


    angular
        .module('vvs')
        .controller('VVSMapConfigController', VVSMapConfigController);

    VVSMapConfigController.$inject = ['$scope'];

    function VVSMapConfigController($scope) {

        var self = this;

        self.triggerShowStopsChange = triggerShowStopsChange;
        self.triggerStopTypesChange = triggerStopTypesChange;
        self.triggerShowPositionsChange = triggerShowPositionsChange;
        self.triggerPositionsTypesChange = triggerPositionsTypesChange;
        self.triggerShowPoisChange = triggerShowPoisChange;
        self.triggerPoisTypesChange = triggerPoisTypesChange;
        self.triggerShowSharingChange = triggerShowSharingChange;
        self.triggerSharingTypesChange = triggerSharingTypesChange;


        function triggerShowStopsChange() {
            $scope.MAP_OPTIONS.stops.regionalBus =
            $scope.MAP_OPTIONS.stops.commuter =
            $scope.MAP_OPTIONS.stops.bus =
            $scope.MAP_OPTIONS.stops.subway =
            $scope.MAP_OPTIONS.stops.enable;
        }

        function triggerStopTypesChange() {
            if ($scope.MAP_OPTIONS.stops.commuter && $scope.MAP_OPTIONS.stops.subway &&
                $scope.MAP_OPTIONS.stops.bus && $scope.MAP_OPTIONS.stops.regionalBus) {
                $scope.MAP_OPTIONS.stops.enable = true;
            } else {
                $scope.MAP_OPTIONS.stops.enable = false;
            }
        }

        function triggerShowPositionsChange() {
            $scope.MAP_OPTIONS.positions.productRestrictions.train =
            $scope.MAP_OPTIONS.positions.productRestrictions.commuter =
            $scope.MAP_OPTIONS.positions.productRestrictions.lightRail =
            $scope.MAP_OPTIONS.positions.productRestrictions.bus =
            $scope.MAP_OPTIONS.positions.enable;
        }

        function triggerPositionsTypesChange() {
            if (!$scope.MAP_OPTIONS.positions.productRestrictions.commuter &&
                !$scope.MAP_OPTIONS.positions.productRestrictions.lightRail &&
                !$scope.MAP_OPTIONS.positions.productRestrictions.bus &&
                !$scope.MAP_OPTIONS.positions.productRestrictions.train) {
                $scope.MAP_OPTIONS.positions.enable = false;
            } else {
                $scope.MAP_OPTIONS.positions.enable = true;
            }
            $scope.VVSMapCtrl.triggerLivePositionUpdate();
            $scope.MAP_OPTIONS.positions.changed = true;
        }

        function triggerShowPoisChange() {
            $scope.MAP_OPTIONS.pois.A =
            $scope.MAP_OPTIONS.pois.B =
            $scope.MAP_OPTIONS.pois.C =
            $scope.MAP_OPTIONS.pois.D =
            $scope.MAP_OPTIONS.pois.E =
            $scope.MAP_OPTIONS.pois.F =
            $scope.MAP_OPTIONS.pois.G =
            $scope.MAP_OPTIONS.pois.H =
            $scope.MAP_OPTIONS.pois.I =
            $scope.MAP_OPTIONS.pois.J =
            $scope.MAP_OPTIONS.pois.K =
            $scope.MAP_OPTIONS.pois.L =
            $scope.MAP_OPTIONS.pois.M =
            $scope.MAP_OPTIONS.pois.N =
            $scope.MAP_OPTIONS.pois.sharingProvider =
            $scope.MAP_OPTIONS.pois.enable;
        }

        function triggerPoisTypesChange() {
            if ($scope.MAP_OPTIONS.pois.A && $scope.MAP_OPTIONS.pois.B &&
                $scope.MAP_OPTIONS.pois.C && $scope.MAP_OPTIONS.pois.D &&
                $scope.MAP_OPTIONS.pois.E && $scope.MAP_OPTIONS.pois.F &&
                $scope.MAP_OPTIONS.pois.G && $scope.MAP_OPTIONS.pois.H &&
                $scope.MAP_OPTIONS.pois.I && $scope.MAP_OPTIONS.pois.J &&
                $scope.MAP_OPTIONS.pois.K && $scope.MAP_OPTIONS.pois.L &&
                $scope.MAP_OPTIONS.pois.M && $scope.MAP_OPTIONS.pois.N) {
                $scope.MAP_OPTIONS.pois.enable = true;
            } else {
                $scope.MAP_OPTIONS.pois.enable = false;
            }
        }

        function triggerShowSharingChange() {
            $scope.MAP_OPTIONS.sharing.callabike =
            $scope.MAP_OPTIONS.sharing.nextbike =
            $scope.MAP_OPTIONS.sharing.car2go =
            $scope.MAP_OPTIONS.sharing.flinkster =
            $scope.MAP_OPTIONS.sharing.stadtmobil =
            $scope.MAP_OPTIONS.sharing.enable;
        }

        function triggerSharingTypesChange() {
            if (!$scope.MAP_OPTIONS.sharing.callabike && !$scope.MAP_OPTIONS.sharing.nextbike &&
                !$scope.MAP_OPTIONS.sharing.car2go && !$scope.MAP_OPTIONS.sharing.flinkster &&
                !$scope.MAP_OPTIONS.sharing.stadtmobil) {
                $scope.MAP_OPTIONS.sharing.enable = false;
            } else {
                $scope.MAP_OPTIONS.sharing.enable = true;
            }
        }

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSInfoTimetableChangeController', VVSInfoTimetableChangeController);

    VVSInfoTimetableChangeController.$inject = ['$scope', '$filter', '$state', 'mng-comm.MDVMessageRequester'];

    function VVSInfoTimetableChangeController($scope, $filter, $state, MDVMessageRequester) {

        $scope.triggerFilterBtnClick = function(key) {
            var actual,
                future,
                k;


            for (k in $scope.filterObj) {
                if ($scope.filterObj.hasOwnProperty(k)) {
                    $scope.filterObj[k] = false;
                }
            }
            $scope.filterObj[key] = true;

            if (key === 'All') {
                $scope.infos = angular.copy($scope.infosBuffer);
            } else {
                $scope.infos = {};
                actual = angular.copy($scope.infosBuffer.actual);
                future = angular.copy($scope.infosBuffer.future);

                $scope.infos.actual = angular.copy($filter('VVSInfoFilterByLineProductIconId')(actual, key));
                $scope.infos.future = angular.copy($filter('VVSInfoFilterByLineProductIconId')(future, key));
            }
        };

        $scope.openDetailsView = function(info) {
            $state.go('vvs.info.timetableChangeDetails', {'info': info});
        };

        $scope.triggerFilterByLineNameClick = function() {
            if ($scope.filterByLineName && $scope.filterByLineName.length>0) {
                var byName = angular.copy($scope.filterByLineName),
                    buf = angular.copy($scope.infosBuffer);

                $scope.infos = angular.copy($filter('VVSInfoFilterByLineName')(buf, byName));
            }
        };

        initController();

        function initController() {
            $scope.infosBuffer = {};
            $scope.filterObj = {
                'All' : true,
                'S-Bahn' : false,
                'R-Bahn' : false,
                'U-Bahn' : false,
                'Ruftaxi' : false,
                'Zacke' : false,
                'Seilbahn' : false,
                'Bus' : false
            };

            MDVMessageRequester.search({
                information : {

                },
                efaParams : {
                    filterMessageSubtype : 'timetableChange'
                }
            }).then(function(res) {
                if (res && res.response) {
                    $scope.infos = angular.copy($filter('VVSInfoTimeTableChangeFilter')(res.response));
                    $scope.infosBuffer = angular.copy($scope.infos);
                }
            });
        }

    }


    angular
        .module('vvs')
        .controller('VVSInfoTimetableChangeDetailsController', VVSInfoTimetableChangeDetailsController);

    VVSInfoTimetableChangeDetailsController.$inject = ['$scope', '$state', '$stateParams'];

    function VVSInfoTimetableChangeDetailsController($scope, $state, $stateParams) {

        initController();

        function initController() {
            if ((Object.keys($stateParams.info).length === 0) && ($stateParams.info.constructor === Object)) {
                $state.go('vvs.info.timetableChange');
            }

            $scope.info = angular.copy($stateParams.info);
        }

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSInfoSpecialTrafficController', VVSInfoSpecialTrafficController);

    VVSInfoSpecialTrafficController.$inject = ['$filter', '$scope', 'mng-comm.MDVMessageRequester'];

    function VVSInfoSpecialTrafficController($filter, $scope, MDVMessageRequester) {

        initController();

        function initController() {
            getInfos();
        }

        function getInfos() {
            MDVMessageRequester.search({
                information : {
                    filter : {
                        informationSubTypes : ['lineInfo:specialTraffic']
                    }
                }
            }).then(function(res) {
                if (res && res.response) {
                    $scope.infos = $filter('VVSInfoSpecialTrafficFilter')(angular.copy(res.response));
                }
            });
        }

    }


    angular
        .module('vvs')
        .controller('VVSInfoSpecialTrafficDetailsController', VVSInfoSpecialTrafficDetailsController);

    VVSInfoSpecialTrafficDetailsController.$inject = ['$scope', '$state', '$stateParams'];

    function VVSInfoSpecialTrafficDetailsController($scope, $state, $stateParams) {

        initController();

        function initController() {
            if ((Object.keys($stateParams.info).length === 0) && ($stateParams.info.constructor === Object)) {
                $state.go('vvs.info.specialTraffic');
            }

            $scope.info = angular.copy($stateParams.info);
        }

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSInfoNewsController', VVSInfoNewsController);

    VVSInfoNewsController.$inject = ['$scope', '$http'];

    function VVSInfoNewsController($scope, $http) {

        initController();

        function initController() {
            getNews();
        }

        function getNews() {
            var articlesUrl = '/mngvvsnews/index.php?id=2528';

            $http.get(articlesUrl)
                .success(function(data) {
                    $scope.infos = data.articles;
                });
        }

    }


    angular
        .module('vvs')
        .controller('VVSInfoNewsDetailsController', VVSInfoNewsDetailsController);

    VVSInfoNewsDetailsController.$inject = ['$scope', '$state', '$stateParams'];

    function VVSInfoNewsDetailsController($scope, $state, $stateParams) {

        initController();

        function initController() {
            if ((Object.keys($stateParams.info).length === 0) && ($stateParams.info.constructor === Object)) {
                $state.go('vvs.info.news');
            }

            $scope.info = angular.copy($stateParams.info);
        }

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSInfoInitController', VVSInfoInitController);

    VVSInfoInitController.$inject = [];

    function VVSInfoInitController() {

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSInfoGeneralController', VVSInfoGeneralController);

    VVSInfoGeneralController.$inject = ['$scope', '$filter', 'mng-comm.MDVMessageRequester'];

    function VVSInfoGeneralController($scope, $filter, MDVMessageRequester) {

        initController();

        function initController() {
            getInfos();
        }

        function getInfos() {
            MDVMessageRequester.search({
                information : {
                    filter : {
                        informationSubTypes : ['disruption:common']
                    }
                }
            }).then(function(res) {
                if (res && res.response) {
                    $scope.infos = $filter('VVSInfoDisruptionFilter')(res.response);
                }
            });
        }

    }


    angular
        .module('vvs')
        .controller('VVSInfoGeneralDetailsController', VVSInfoGeneralDetailsController);

    VVSInfoGeneralDetailsController.$inject = ['$scope', '$state', '$stateParams'];

    function VVSInfoGeneralDetailsController($scope, $state, $stateParams) {

        initController();

        function initController() {
            if ((Object.keys($stateParams.info).length === 0) && ($stateParams.info.constructor === Object)) {
                $state.go('vvs.info.general');
            }

            $scope.info = angular.copy($stateParams.info);
        }

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSInfoEscalatorElevatorController', VVSInfoEscalatorElevatorController);

    VVSInfoEscalatorElevatorController.$inject = ['$filter', '$scope', 'mng-comm.MDVMessageRequester'];

    function VVSInfoEscalatorElevatorController($filter, $scope, MDVMessageRequester) {

        initController();

        function initController() {
            getInfos();
        }

        function getInfos() {
            MDVMessageRequester.search({
                information : {
                    filter : {
                        informationSubTypes : ['stopInfo:escalator_elevator']
                    }
                }
            }).then(function(res) {
                if (res && res.response) {
                    $scope.infos = $filter('VVSInfoEscalatorElevatorFilter')(angular.copy(res.response));
                }
            });
        }

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSInfoDisruptionController', VVSInfoDisruptionController);

    VVSInfoDisruptionController.$inject = ['$scope', '$filter', 'mng-comm.MDVMessageRequester'];

    function VVSInfoDisruptionController($scope, $filter, MDVMessageRequester) {

        initController();

        function initController() {
            getInfos();
        }

        function getInfos() {
            MDVMessageRequester.search({
                information : {
                    filter : {
                        informationSubTypes : ['disruption:lines', 'disruption:stops']
                    }
                }
            }).then(function(res) {
                if (res && res.response) {
                    $scope.infos = $filter('VVSInfoDisruptionFilter')(res.response);
                }
            });
        }

    }


    angular
        .module('vvs')
        .controller('VVSInfoDisruptionDetailsController', VVSInfoDisruptionDetailsController);

    VVSInfoDisruptionDetailsController.$inject = ['$scope', '$state', '$stateParams'];

    function VVSInfoDisruptionDetailsController($scope, $state, $stateParams) {

        initController();

        function initController() {
            if ((Object.keys($stateParams.info).length === 0) && ($stateParams.info.constructor === Object)) {
                $state.go('vvs.info.disruption');
            }

            $scope.info = angular.copy($stateParams.info);
        }

    }

}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .controller('VVSDMModalsFilterController', VVSDMModalsFilterController);

    VVSDMModalsFilterController.$inject = ['$scope'];

    function VVSDMModalsFilterController($scope) {

        $scope.allLines = true;

        $scope.triggerSwitchAllLines = function(allLines) {
            var categoryKey,
                lineKey;

            for (categoryKey in $scope.dmObj.linesFilter) {
                if ($scope.dmObj.linesFilter.hasOwnProperty(categoryKey)) {
                    $scope.dmObj.linesFilter[categoryKey].enabled = allLines;
                    for (lineKey in $scope.dmObj.linesFilter[categoryKey].lines) {
                        if ($scope.dmObj.linesFilter[categoryKey].lines.hasOwnProperty(lineKey)) {
                            $scope.dmObj.linesFilter[categoryKey].lines[lineKey].enabled = allLines;
                        }
                    }
                }
            }
        };

        $scope.triggerSwitchLinesCategory = function(key) {
            var lines = $scope.dmObj.linesFilter[key].lines,
                k;

            for (k in lines) {
                if (lines.hasOwnProperty(k)) {
                    lines[k].enabled = $scope.dmObj.linesFilter[key].enabled;
                }
            }
        };

        $scope.triggerSwitchLine = function(key) {
            var existsOneActiveLine = false,
                lines = $scope.dmObj.linesFilter[key].lines,
                k;

            for (k in lines) {
                if (lines.hasOwnProperty(k)) {
                    if (lines[k].enabled) {
                        existsOneActiveLine = true;
                        break;
                    }
                }
            }
            $scope.dmObj.linesFilter[key].enabled = existsOneActiveLine;
        };
    }


    angular
        .module('vvs')
        .controller('VVSDMModalsLinesController', VVSDMModalsLinesController);

    VVSDMModalsLinesController.$inject = ['$scope', '$interval'];

    function VVSDMModalsLinesController($scope, $interval) {
        var self = this,
            _private = {};

        self.currentDate = new Date();

        var tick = function() {
            self.currentDate = new Date();
        };
        _private.tickInterval = $interval(tick, 1000);

        $scope.modalInstance.closed
            .then(function() {
                $interval.cancel(_private.tickInterval);
            });
    }


    angular
        .module('vvs')
        .controller('VVSDMModalsStopController', VVSDMModalsStopController);

    VVSDMModalsStopController.$inject = ['$scope', '$state',
     'mng-comm.MDVDownload', 'VVSPdfViewer'];

    function VVSDMModalsStopController($scope, $state, MDVDownload, VVSPdfViewer) {
        $scope.openStopInformation = function(stop) {
            var coords = stop.coord();
            var globalID = stop.id();
            var link = 'https://livekarte.vvs.de/stops/'+globalID+'@'+coords[0]+','+coords[1]+','+'z18';
            window.open(link,'_blank');
         }

        function getFileByType(location, name, UrlMatch) {
            var files = location.downloads(),
                res = null,
                i;

            for (i=0; i<files.length; i++) {
                if (files[i].name === name) {
                    if (UrlMatch) {
                        if ((files[i].url.indexOf(UrlMatch)>-1)) {
                            return files[i];
                        }
                    } else {
                        return files[i];
                    }
                }
            }
            return res;
        }

        $scope.triggerDownloadROPClick = function(location) {
            MDVDownload.search(MDVDownload.requestTypes.ROUTE_OPTION_PLAN, {
                    stopId : location.id()
                })
                .then(function(res) {
                    if(res.response){
                        VVSPdfViewer.show(res.response);
                    }
                });
        };

        $scope.triggerDownloadSMClick = function(file) {
            VVSPdfViewer.show(file);
        };

        $scope.triggerDownloadSMMEClick = function(file) {
            VVSPdfViewer.show(file);
        };


        $scope.triggerSelectAsTripOrig = function(location) {
            $state.go('vvs.trip.init', {'orig' : location});
        };

        $scope.triggerDownloadROPClick = function(location) {
            MDVDownload.search(MDVDownload.requestTypes.ROUTE_OPTION_PLAN, {
                stopId : location.id()
            }).then(function(res) {
                if (res.response) {
                    VVSPdfViewer.show(res.response);
                }
            });
        };
    }


    angular
        .module('vvs')
        .controller('VVSDMModalsRefreshController', VVSDMModalsRefreshController);

    function VVSDMModalsRefreshController($scope) {

        $scope.triggerRefreshWithSameTimeClick = function() {
            $scope.dmObj.service.search().then(function(res) {
                $scope.dmObj.depArrs = res.response;
            });
        };

        $scope.triggerRefreshWithCurrentTimeClick = function() {
            $scope.SEARCH_OPTIONS.dateTime.date = moment().toDate();
            $scope.SEARCH_OPTIONS.dateTime.time = moment().toDate();
            $scope.dmObj.service.search().then(function(res) {
                $scope.dmObj.depArrs = res.response;
            });
        };
    }
    angular
        .module('vvs')
        .controller('VVSDMModalsLineFilterController', VVSDMModalsLineFilterController);

    VVSDMModalsLineFilterController.$inject = ['$scope', 'VVSConst'];

    function VVSDMModalsLineFilterController($scope, VVSConst) {
        var grouping = VVSConst.iconProductIconIdGrouping,
        departures = $scope.dmObj.depArrs;
        $scope.groupedDepartures = [];

        const groupBy = function(array, key){
            return array.reduce(function(result, currentValue){
              (result[currentValue.transportation().productIconId()] = result[currentValue.transportation().productIconId()] || []).push(
                currentValue
              );
              return result;
            }, {});
          };

        const result = groupBy(departures);

        for (var k in result) {
            for (var key in grouping) {
                if (grouping[key].includes(+k)) {
                    result[key] = result[k];
                    delete result[k];
                }
            }
        }

        var output = {};

        for (var k in result) {
            var uniqParams = [];
            var unique = result[k].filter(function(el) {
            var isDuplicate = uniqParams.includes(el.transportation().number() + el.transportation().destination().name().replace('.', ''));

            if (!isDuplicate) {
                uniqParams.push(el.transportation().number() + el.transportation().destination().name().replace('.', ''));
                return true;
            }
            return false;
            });
            unique.forEach(function(line) {
                line.isAbonated = true;
            });
            output[k] = unique;
        }

        // for (var k in output) {
        //     if (!$scope.filter.allLines)
        //     output[k].forEach(function(el) {
        //         el.isAbonated = false;
        //     });
        // }

        $scope.filteredRes = angular.copy(output);


        $scope.groupedDepartures = result;

        var linesFilter = $scope.dmObj.linesFilter;

        $scope.filter = {
            allLines: true
        }

        $scope.triggerSelectAllLInes = function() {
            for (var k in output) {
                if (!$scope.filter.allLines) {
                    output[k].map(function(el) {
                        el.isAbonated = false;
                        return el
                    });
                } else {
                    output[k].map(function(el) {
                        el.isAbonated = true;
                        return el
                    });
                }
            }
            console.log('output', output);
            $scope.filteredRes = angular.copy(output);
        };
        $scope.triggerSelectLine = function(line) {
            $scope.dmObj.depArrs.map(function(el) {
                if(el.transportation().number() === line.transportation().number()) {
                    if (el.transportation().destination().name().replace('.', '') === line.transportation().destination().name().replace('.', '')) {
                        el.isAbonated = line.isAbonated;
                        if(!line.isAbonated) {
                            $scope.allLines = false;
                        }
                    }
                }
                return el;
            });
            var check = !!$scope.dmObj.depArrs.find(function(el) { // check if some lines are not abonated
                return el.isAbonated === false;
            });
            if (check) {
                $scope.filter.allLines = false;
            } else {
                $scope.filter.allLines = true;
            }
        };

    }
    angular
        .module('vvs')
        .controller('VVSSTTModalsRefreshController', VVSSTTModalsRefreshController);

    function VVSSTTModalsRefreshController($scope) {

        $scope.triggerRefreshWithSameTimeClick = function() {
            console.log('refersh with the same time click')
            // $scope.dmObj.service.search().then(function(res) {
            //     $scope.dmObj.depArrs = res.response;
            // });
        };

        $scope.triggerRefreshWithCurrentTimeClick = function() {
            $scope.SEARCH_OPTIONS.dateTime.date = moment().toDate();
            $scope.SEARCH_OPTIONS.dateTime.time = moment().toDate();
            console.log('refersh with the current time click')
            // $scope.dmObj.service.search().then(function(res) {
            //     $scope.dmObj.depArrs = res.response;
            // });
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSDMLinesController', VVSDMLinesController);

    VVSDMLinesController.$inject = ['$scope', '$state', '$filter', 'VVSDeepLinking', 'VVSConst'];

    function VVSDMLinesController($scope, $state, $filter, VVSDeepLinking, VVSConst) {

        if ((!$scope.inputLocations) || (!$scope.inputLocations.dm) || (typeof $scope.inputLocations.dm !== 'object')) {
            $state.go('vvs.stops.init');
            // $state.go('vvs.dm.init');
            return false;
        }

        var grouping = VVSConst.iconProductIconIdGrouping; // grouped VM according to the productIconID

        $scope.dmObj.service.updateLocation($scope.inputLocations.dm);
        $scope.dmObj.service.search().then(function(res) {
            $scope.dmObj.depArrs = res.response;
            $scope.vmAll = [];
            var uniqueNumbers = [];
            var departures = res.response;
            departures.map(function(dep) {
                $scope.vmAll.push(
                    {
                        'productId': dep.transportation().productIconId(),
                        'number': dep.transportation().number()
                    }
                );
            });
            // delete duplications
            $scope.vm  = $scope.vmAll.filter(function(el) {
                var isDuplicate = uniqueNumbers.includes(el.number);
                if (!isDuplicate) {
                  uniqueNumbers.push(el.number);
                  return true;
                }
                return false;
              }).reduce(function(r, a) {
                r[a.productId] =  r[a.productId] || [];
                r[a.productId].push(a);
                return r;
             }, Object.create(null));


        $scope.sortedResult = {
            'S-Bahn': [],
            'R-Bahn': [],
            'U-Bahn': [],
            'Bus': [],
            'Ruftaxi': []
        }

        // sorted result according to the grouping (VM) Object
        for (var k in $scope.vm) {
            // debugger;
            for (var key in grouping) {

                if (grouping[key].includes(+k)) {
                     // numeric sort
                    $scope.vm[k].sort(function(a, b) {
                        if (a.number.match(/\d+/) && b.number.match(/\d+/)) {
                            return (a.number.match(/\d+/)[0])  - (b.number.match(/\d+/)[0]);
                        }
                    });
                    // alhabet sorting
                    $scope.vm[k].sort(function(a, b) {
                     if(a.number < b.number) { return -1; }
                     if(a.number > b.number) { return 1; }
                        return 0;
                    });
                    $scope.sortedResult[key] = $scope.vm[k];
                }
            }
        }

        $scope.inputLocations.dm = angular.copy(res.location)
        initLinesFilter(true);

        VVSDeepLinking.generateDeeplinkFromOptions(angular.copy($scope.SEARCH_OPTIONS));

        }).catch(function(err){
            if (err && err.data && err.data.data && (err.data.data.length>0)) {
                $scope.errorMessages = err.data.data;
            }
        })

        $scope.triggerDMChangeClick = function() {
            $scope.inputLocations.dm = '';
            // $state.go('vvs.stops.init', {}, {
            //     reload : true
            // });
            $state.go('vvs.stops.init');
        };

        $scope.triggerDMResetClick = function() {
            // $state.go('vvs.dm.init', {}, {
            $state.go('vvs.stops.init', {}, {
                reload : true
            });
        };

        $scope.triggerDMNextClick = function() {
            $scope.dmObj.service.next().then(function(res) {
                $scope.dmObj.depArrs = $scope.dmObj.depArrs.concat(res.response);
                initLinesFilter();
            });
        };

        $scope.triggerDMPreviousClick = function() {
            $scope.dmObj.service.previous().then(function(res) {
                $scope.dmObj.depArrs = res.response.concat(angular.copy($scope.dmObj.depArrs));
                initLinesFilter();
            });
        };

        function initLinesFilter(reset) {
            if (reset) {
                $scope.dmObj.linesFilter = {};
            }
            var groupedLines = $filter('VVSDMGroupedDepArrs')($scope.dmObj.depArrs),
                key,
                i;

            for (key in groupedLines) {
                if (groupedLines.hasOwnProperty(key)) {
                    $scope.dmObj.linesFilter[key] = ($scope.dmObj.linesFilter[key])?($scope.dmObj.linesFilter[key]):{enabled : true};
                    for (i=0; i<groupedLines[key].length; i++) {
                        if (!$scope.dmObj.linesFilter[key].hasOwnProperty('lines')) {
                            $scope.dmObj.linesFilter[key].lines = {};
                        }
                        $scope.dmObj.linesFilter[key].lines[(groupedLines[key][i]).transportation().id()] =
                            ($scope.dmObj.linesFilter[key].lines[(groupedLines[key][i]).transportation().id()])?$scope.dmObj.linesFilter[key].lines[(groupedLines[key][i]).transportation().id()]:{enabled : true};
                    }
                }
            }
        }

    }

}());


(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSDMInitController', VVSDMInitController);

    VVSDMInitController.$inject = ['$scope', '$rootScope', '$stateParams'];

    function VVSDMInitController($scope, $rootScope, $stateParams) {
        $rootScope.tabIndex = 0;
        for (var key in $stateParams) {
            if ($stateParams.hasOwnProperty(key) && !isObjEmpty($stateParams[key])) {
                $scope.inputLocations[key] = $stateParams[key];
            }
        }

        function isObjEmpty(obj) {
            for(var prop in obj) {
                if(obj.hasOwnProperty(prop)) {
                    return false;
                }
            }
            return JSON.stringify(obj) === JSON.stringify({});
        }
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsVm', vvsVm);

    vvsVm.$inject = [];

    function vvsVm() {
        return {
            restrict : 'E',
            replace : true,
            scope : {
                source: '=',
                stt: '='
            },
            templateUrl : 'app/vvs.components/common/vm/main.html',
            controller: function($scope) {
                $scope.vmAll = [];
                var uniqueNumbers = [];
                if ($scope.stt && $scope.source) {
                    $scope.source.map(function(dep) {
                        $scope.vmAll.push(
                            {
                                'productId': dep.productIconId(),
                                'number': dep.number()
                            }
                        );
                    });
                }
                $scope.highVMCount = false;
                $scope.vm  = $scope.vmAll.filter(function(el) {
                    var isDuplicate = uniqueNumbers.includes(el.number);
                    if (!isDuplicate) {
                    uniqueNumbers.push(el.number);
                    return true;
                    }
                    return false;
                }).reduce(function(r, a) {
                    r[a.productId] =  r[a.productId] || [];
                    r[a.productId].push(a);
                    return r;
                }, Object.create(null));
                $scope.vmView = {};
                for (var k in $scope.vm) {
                    $scope.vmView[k] = [];
                    if ($scope.vm[k].length > 9) {
                        $scope.highVMCount = true;
                    }
                    $scope.vm[k].forEach(function(el) {
                        $scope.vmView[k].push(el.number);
                    });
                }
            }
        };
    }
}());
(function() {
    'use strict';


    angular
        .module('vvs')
        .directive('vvsRecommendedStop', vvsRecommendedStop);

    vvsRecommendedStop.$inject = [];

    function vvsRecommendedStop() {
        return {
            restrict : 'E',
            replace : true,
            scope : {
                mode : '=',
                trip : '=',
                leg : '=',
                origin : '=',
                destination : '=',
                usage : '=',
                isFirstLeg : '=',
                isLastLeg : '='
            },
            template : '<span><span ng-show="showSymbol">#)</span><span ng-show="showFooter">#) {{\'Empfohlene Haltestelle\'|translate}}</span></span>',
            controller : function($scope, $attrs, VVSConst) {
                return;
                if ($scope.mode === 'footer' && $scope.trip) {
                    $scope.showFooter = (($scope.origin.properties().stopId !== $scope.trip.origin().parent().id())
                        || ($scope.destination.properties().stopId !== $scope.trip.destination().parent().id()));
                } else {
                    if (!$scope.isFirstLeg && !$scope.isLastLeg) {
                        $scope.showSymbol = false;
                    }

                    if ($scope.isFirstLeg && ($scope.usage === 'orig')) {
                        if ($scope.trip.origin().type() !== $scope.trip.origin().LOCATIONTYPES.STOP) {
                            $scope.showSymbol = false;
                        } else {
                            $scope.showSymbol = ($scope.origin.properties().stopId !== $scope.trip.origin().parent().id());
                        }
                    }

                    if ($scope.isLastLeg && ($scope.usage === 'dest')) {
                        if ($scope.trip.destination().type() !== $scope.trip.destination().LOCATIONTYPES.STOP) {
                            $scope.showSymbol = false;
                        } else {
                            $scope.showSymbol = ($scope.destination.properties().stopId !== $scope.trip.destination().parent().id());
                        }
                    }
                }

            }
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsRealTimeIcon', vvsRealTimeIcon);

    function vvsRealTimeIcon() {
        return {
            restrict : 'E',
            replace : true,
            scope : {
                'trip' : '=',
                'leg' : '=',
                'depArr' : '=',
                'mode' : '=',
                'location' : '=',
                'usage' : '='
            },
            templateUrl : 'app/vvs.components/common/realtime-icon/main.html',
            link : function ($scope, element, attrs) {
                var mode = $scope.mode;

                $scope.hasRealtime = false;

                if (mode === 'trip') {
                    var trip = $scope.trip,
                        i;

                    for (i=0; i<trip.legs().length; i++) {
                        if ((trip.legs()[i]).isRealtimeControlled()){
                            $scope.hasRealtime = true;
                            break;
                        }
                    }
                } else if (mode === 'leg') {
                    var leg = $scope.leg,
                        usage = $scope.usage || 'arr';

                  $scope.hasRealtime = (leg.isRealtimeControlled());
                } else if (mode === 'depArr') {
                    var depArr = $scope.depArr;

                    $scope.hasRealtime = (depArr.isRealtimeControlled());
                } else if (mode === 'location') {
                    var location = $scope.location,
                        usage = $scope.usage || 'dep';

                    $scope.hasRealtime = (location.isRealtimeControlled());
                }
            }
        };
    }
}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsPoi', vvsPoi);

    function vvsPoi() {
        return {
            restrict : 'E',
            replace : false,
            scope : true,
            templateUrl : function() {
                return 'app/vvs.components/common/poi/main.html';
            }
        };
    }
}());

(function() {
    'use strict';

    /**
     * The 'VVSPoiController' should be bounded to the `modals\poi.html` overlay.
     * the first categories of the pois are static, and fetched from the application constant.
     * Once the user choose to get deeper into the pois, the `VVSPoiController` call for
     * each new clicked category the `MDVLocationRequester` and get the result from his local buffer
     * if the category is already choosed before.
     **/
    angular
        .module('vvs')
        .controller('VVSPoiController', VVSPoiController);

    VVSPoiController.$inject = ['$scope', '$filter', 'mng-comm.MDVLocationRequester', 'VVSConst'];

    function VVSPoiController($scope, $filter, MDVLocationRequester, VVSConst) {
        // get the first level of categories from the application constant
        var defaultPoiCategories = VVSConst.poiCategories || [],
            prevHierarchies = [],
            // init the local buffer
            poiCategoriesBuffer = {};

        // add the first level categories to the local buffer with 'null' as buffer key
        $scope.poiCategories = poiCategoriesBuffer[null] = cleanConstCategories(defaultPoiCategories);
        // hide the 'back' button
        $scope.showBackBtn = false;
        prevHierarchies.push(null);

        function cleanConstCategories(categories) {
            angular.forEach(categories, function(value, key) {
                value.id = function() {
                    return value.key;
                };
                value.name = function() {
                    return value.description;
                };
            });

            return categories;
        }


        $scope.assignPoiByUsage = function(poi) {
            $scope.inputLocations[$scope.usage] = poi;
            $scope.mdvLocations = [];
            $scope.dismissModal();
        };

        /**
         * This function is called when the user select a categorie.
         * She check if the clicked category is already in
         **/
        $scope.triggerMenuClick = function(poiHierarchy, back) {
            $scope.animate = true;
            if (poiHierarchy) {
                prevHierarchies.push(poiHierarchy);
            } else {
                prevHierarchies = new Array(null);
            }

            $scope.backClicked = back;

            $scope.prevHierarchy = prevHierarchies[(prevHierarchies.indexOf(poiHierarchy) > -1) ?
                (prevHierarchies.indexOf(poiHierarchy) - 1) : (prevHierarchies.length - 2)];

            if (poiCategoriesBuffer.hasOwnProperty(poiHierarchy)) {
                $scope.poiCategories = poiCategoriesBuffer[poiHierarchy];
                showBackBtn();
                return true;
            }

            // prepare the options that will be sended with the StopFinder request
            var options = {
                    efaParams: {
                        'type_sf': 'poi',
                        'placeInfo_sf': '-1:-1',
                        'nameHierarchy_sf': 'poiHierarchy:'.concat(poiHierarchy),
                        'nameInfo_sf': 'poiHierarchy:'.concat(poiHierarchy)
                    }
                },
                value = poiHierarchy; // dummy value, should we keep that?

            // fetch subcategories from efa
            MDVLocationRequester.search(value, options)
                .then(function(result) {
                    poiCategoriesBuffer[poiHierarchy] = result.response;
                    $scope.poiCategories = result.response;
                    showBackBtn();
                })
                .catch(function() {
                    $scope.poiCategories = defaultPoiCategories;
                    $scope.prevHierarchy = null;
                    $scope.showBackBtn = false;
                });

            function showBackBtn() {
                if (poiHierarchy) {
                    $scope.showBackBtn = true;
                } else {
                    $scope.showBackBtn = false;
                }
            }
        }
    }
}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .directive('vvsPlaceHolder', vvsPlaceHolder);

    vvsPlaceHolder.$inject = ['VVSConst'];

    function vvsPlaceHolder(VVSConst) {
        return {
            restrict : 'E',
            replace : true,
            scope : false,
            templateUrl : VVSConst.baseUrl+'common/place-holder/main.html',
            controller : 'VVSPlaceHolderController',
            controllerAs : 'VVSPlaceHolderCtrl'
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSPlaceHolderController', VVSPlaceHolderController);

    VVSPlaceHolderController.$inject = ['$scope', '$http', 'VVSConst'];

    function VVSPlaceHolderController($scope, $http, VVSConst) {
        var self = this,
            urls = VVSConst.placeHolderUrls,
            i,
            l;

        self.images = [];

        for (i=0, l=urls.length; i<l; i=+1) {
            var bannerUrl = '/mngvvsbanner' + urls[i];

            $http.get(bannerUrl)
                .then(function(res) {
                    if (res.data) {
                        self.images.push(res.data);
                    }
                })
                .catch(function(e) {
                    self.images = null;
                });

        }


    }

}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .filter('VVSPerlschnurGrouping', VVSPerlschnurGrouping);

    VVSPerlschnurGrouping.$inject = ['$filter'];

    function VVSPerlschnurGrouping($filter) {
        return function(locationSequences, lineId) {
            var sortedArrToReturn = [],
                newZone,
                lastZone,
                loc,
                i;

            for (i=0; i<locationSequences.length; i++) {
                loc = locationSequences[i];
                newZone = loc.properties().zone;
                if (!newZone) {
                    if (sortedArrToReturn.length) {
                        sortedArrToReturn[sortedArrToReturn.length-1].locations.push(loc);
                    }
                    else {
                        sortedArrToReturn.push({
                            'zone' : newZone,
                            'locations' : [loc]
                        });
                    }
                } else {
                    if (sortedArrToReturn.length) {
                        lastZone = sortedArrToReturn[sortedArrToReturn.length-1].zone;

                        if (newZone === lastZone) {
                            sortedArrToReturn[sortedArrToReturn.length-1].locations.push(loc);
                        } else {
                            sortedArrToReturn.push({
                                'zone' : newZone,
                                'locations' : [loc]
                            });
                        }
                    } else {
                        sortedArrToReturn.push({
                            'zone' : newZone,
                            'locations' : [loc]
                        });
                    }
                }
            }


            for (i=0; i<sortedArrToReturn.length; i+=1) {
                sortedArrToReturn[i].locations = $filter('VVSPerschnurLocationsCleaner')(sortedArrToReturn[i].locations, lineId);
            }

            sortedArrToReturn = $filter('VVSPerschnurGroupedLocationsSorter')(sortedArrToReturn);
            return sortedArrToReturn;
        };
    }


    angular
        .module('vvs')
        .filter('VVSPerschnurLocationsCleaner', VVSPerschnurLocationsCleaner);

    VVSPerschnurLocationsCleaner.$inject = ['$filter', 'mng-model.MDVJourneyLocation'];

    function VVSPerschnurLocationsCleaner($filter, MDVJourneyLocation) {
        return function(locations, lineId) {
            if (!locations || locations.length === 1) {
                return locations;
            }

            var i,
                l,
                predLocation,
                currLocation;

            for (i=0, l=locations.length; i<l; i+=1) {
                if (i===0) {
                    continue;
                }
                predLocation = locations[i-1];
                currLocation = locations[i];

                if (predLocation.parent().id() === currLocation.parent().id()) {
                    mergeLocations(locations[i-1], locations[i]);
                    locations.splice(i, 1);
                    i-=1;
                    l-=1;
                }
            }

            for (i=0, l=locations.length; i<l; i+=1) {
                locations[i] = $filter('VVSPerschnurTransportationsCleaner')(locations[i], lineId);
            }

            function mergeLocations(toMergeIn, toMergeFrom) {
                var jsObj = toMergeIn.toJSON();

                if (!jsObj.productClasses) {
                    jsObj.productClasses = [];
                }

                if (!jsObj.transportations) {
                    jsObj.transportations = [];
                }

                if (!jsObj.properties.ASSIGNED_STOP_MEANS) {
                    jsObj.properties.ASSIGNED_STOP_MEANS = [];
                }

                if (!toMergeFrom.properties().ASSIGNED_STOP_MEANS) {
                    toMergeFrom.properties().ASSIGNED_STOP_MEANS = [];
                }

                jsObj.productClasses = jsObj.productClasses.concat(toMergeFrom.productClasses());
                jsObj.properties.ASSIGNED_STOP_MEANS = jsObj.properties.ASSIGNED_STOP_MEANS.concat(toMergeFrom.properties().ASSIGNED_STOP_MEANS);
                jsObj.transportations = jsObj.transportations.concat(toMergeFrom.transportations());

                toMergeIn = new MDVJourneyLocation(jsObj);
                return true;
            }

            locations = $filter('VVSPerschnurLocationsSorter')(locations);

            return locations;
        };
    }


    angular
        .module('vvs')
        .filter('VVSPerschnurTransportationsCleaner', VVSPerschnurTransportationsCleaner);

    VVSPerschnurTransportationsCleaner.$inject = ['$filter', 'VVSConst', 'mng-model.MDVJourneyLocation'];

    function VVSPerschnurTransportationsCleaner($filter, VVSConst, MDVJourneyLocation) {
        return function(location, lineId) {
            var i,
                l,
                key,
                trans = [],
                jsObj = location.toJSON(),
                rawInfo = location.raw(),
                productClasses = [];

            for (i=0, l=location.transportations().length; i<l; i+=1) {
                if (removeDirectionFromLineId(location.transportations()[i].id()) !== removeDirectionFromLineId(lineId)) {
                    trans.push(location.transportations()[i]);

                    for (key in VVSConst.iconProductIconIdGrouping) {
                        if (VVSConst.iconProductIconIdGrouping.hasOwnProperty(key)) {
                            if (VVSConst.iconProductIconIdGrouping[key].indexOf(location.transportations()[i].productIconId())>-1) {
                                productClasses = productClasses.concat(VVSConst.iconProductClassGrouping[key]);
                            }
                        }
                    }
                    // productClasses.push(location.transportations()[i].productClass());
                }
            }

            productClasses.push(rawInfo.productClasses);

            function removeDirectionFromLineId(id) {
                var splittedId = id.split(':');

                return splittedId[0]+':'+splittedId[1];
            }

            jsObj.transportations = trans;
            // jsObj.productClasses = productClasses;
            if (jsObj.properties.ASSIGNED_STOP_MEANS) {
                jsObj.productClasses = productClasses.concat(jsObj.properties.ASSIGNED_STOP_MEANS);
            } else {
                jsObj.productClasses = productClasses;
            }
            return new MDVJourneyLocation(jsObj);
        };
    }




    angular
        .module('vvs')
        .filter('VVSPerschnurLocationsSorter', VVSPerschnurLocationsSorter);

    VVSPerschnurLocationsSorter.$inject = [];

    function VVSPerschnurLocationsSorter() {
        return function(locations) {
            locations = locations.sort(function(a, b) {
                var aTime = a.departureTime() || a.arrivalTime(),
                    bTime = b.departureTime() || b.departureTime();

                    if (aTime && !bTime) {
                        return -1;
                    } else if (!aTime && bTime) {
                        return 1;
                    } else if (aTime && bTime) {
                        return aTime.unix() > bTime.unix();
                    }

                    return 0;
                });

            return locations;
        };
    }



    angular
        .module('vvs')
        .filter('VVSPerschnurGroupedLocationsSorter', VVSPerschnurGroupedLocationsSorter);

    VVSPerschnurGroupedLocationsSorter.$inject = [];

    function VVSPerschnurGroupedLocationsSorter() {
        return function(groupedLocations) {
            groupedLocations = groupedLocations.sort(function(a, b) {


                    try{
                        var aTime,
                            bTime;

                        for (var i=0, l=a.locations.length; i<l; i++) {
                            var t = a.locations[i].departureTime() || a.locations[i].arrivalTime();

                            if (t && aTime) {
                                if (t.unix() < aTime.unix()) {
                                    aTime = t;
                                }
                            } else if (t) {
                                aTime = t;
                            }
                        }

                        for (var i=0, l=b.locations.length; i<l; i++) {
                            var t = b.locations[i].departureTime() || b.locations[i].arrivalTime();

                            if (t && bTime) {
                                if (t.unix() < bTime.unix()) {
                                    bTime = t;
                                }
                            } else if (t) {
                                bTime = t;
                            }
                        }

                        if (aTime && !bTime) {
                            return -1;
                        } else if (!aTime && bTime) {
                            return 1;
                        } else if (aTime && bTime) {
                            return aTime.unix() > bTime.unix();
                        }

                        return 0;
                    } catch(e) {
                        return 0;
                    }

                });

            return groupedLocations;
        };
    }



}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsPerlschnur', vvsPerlschnur);

    function vvsPerlschnur() {
        return {
            restrict : 'E',
            replace : true,
            scope : {
                'transportation' : '=',
                'leg' : '=', // from the trip request
                'date' : '='
            },
            controller : 'VVSPerlschnurController',
            controllerAs : 'VVSPerlschnurCtrl',
            templateUrl : function() {
                return 'app/vvs.components/common/perlschnur/main.html';
            }
        };
    }
}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .controller('VVSPerlschnurController', VVSPerlschnurController);

    VVSPerlschnurController.$inject = ['$scope', '$rootScope', '$filter', '$interval', 'mng-comm.MDVTransportationRequester',
        'mng-model.MDVJourneyLocation', 'mng-comm.MDVLivePositionsRequester', 'VVSConst'
    ];

    function VVSPerlschnurController($scope, $rootScope, $filter, $interval, MDVTransportationRequester,
        MDVJourneyLocation, MDVLivePositionsRequester, VVSConst) {
        var leg = $scope.leg;
        if (leg) {
            var locSeq = leg.locationSequence();
        }

        var self = this;

        self.hasUsedStops = hasUsedStops;

        self.showNotUsedStops = false;
        self.groupedLocationSequences = {};
        self.transportation = null;
        self.livePositionsInterval = null;

        if($scope.$parent.modalInstance && $scope.$parent.modalInstance.closed) {
            $scope.$parent.modalInstance.closed.then(function() {
                $interval.cancel(self.livePositionsInterval);
            });
        }


        function hasUsedStops(locs) {
            var i,
                l;

            for (i = 0, l = locs.length; i < l; i += 1) {
                if (locs[i].properties().usedstop) {
                    return true;
                }
            }
            return false;
        }

        function initController() {
            var transportation = angular.copy($scope.transportation),
                leg = angular.copy($scope.leg),
                date = angular.copy($scope.date),
                locationSequences = [],
                opts;

            if (leg) {
                transportation = leg.transportation();
            }

            self.transportation = transportation;

            if (date && date._isAMomentObject) {
                opts = {
                    efaParams : {
                        filterDate : date.format("YYYYMMDD")
                    }
                };
            }

            MDVTransportationRequester.search(transportation, opts)
                .then(function(res) {
                    $scope.productClass = res.response[0].productClass();
                    $scope.productIconId = res.response[0].productIconId();
                    $scope.locSeqRaw = [];
                    $scope.lS = res.response[0].locationSequence();
                    $scope.lS.map(function(el) {
                        $scope.locSeqRaw.push(el.raw());
                    })
                    if (res && res.response && res.response.length > 0) {
                        locationSequences = angular.copy(res.response[0].locationSequence()); // ohne Filter - firekt aus dem Backend

                        $scope.originLocSeq = mergeLocationSequence(locationSequences, false);
                        $scope.resultSeqtoShow = $filter('VVSPerlschnurGrouping')($scope.originLocSeq, res.response[0].id());
                        if (leg) {
                            self.isLegMode = true;
                            locationSequences = mergeLocationSequence(res.response[0].locationSequence(), leg);
                        } else {
                            self.showNotUsedStops = true;
                        }

                        self.groupedLocationSequences = $filter('VVSPerlschnurGrouping')(locationSequences, res.response[0].id());

                        $scope.resultSequences = $scope.resultSeqtoShow.map(function(el) {
                            el.locations.map(function(element) {
                                locSeq.map(function(seq) {
                                    if (element.name() === seq.name()) {
                                        element.properties().occ = seq.properties().occupancy;
                                    }
                                    return element;
                                });
                                self.groupedLocationSequences.map(function(i) {

                                    i.locations.map(function(loc) {
                                        locSeq.map(function(seq) {
                                            if (loc.name() === seq.name()) {
                                                loc.properties().occ = seq.properties().occupancy;
                                            }
                                            return loc;
                                        });
                                        if (loc.properties().usedstop) {
                                            if (loc.departureTime) {
                                                if (element.name() === loc.name()) {
                                                    if (element.departureTime && !element.departureTime() || element.departureTime && element.departureTime()) {
                                                        element['addedDepartureTime'] = loc.departureTime();
                                                        element['addedDepartureDelay'] = loc.departureDelay();
                                                    }
                                                }
                                            }
                                            if (loc.arrivalTime && loc.departureTime() == null) {
                                                if (element.name() === loc.name()) {
                                                    if (element.arrivalTime && !element.arrivalTime()) {
                                                        element['addedArrivalTime'] = loc.arrivalTime();
                                                        element['addedArrivalDelay'] = loc.arrivalDelay();
                                                    }
                                                }
                                            }
                                        }
                                        if (loc.isCancelled()) {
                                            if (element.name() === loc.name()) {
                                                element.cancelled = loc.isCancelled();
                                            }
                                        }
                                    });
                                });
                                return element;
                            });
                            return el;
                        });

                        startLivePosition();

                    }
                });

        }
        initController();

        function mergeLocationSequence(locationSequences, leg) {
            var i,
                loc,
                result = [],
                duplicates = {};

            for (i = 0; i < locationSequences.length; i++) {
                if (leg) {
                    loc = getLocById(locationSequences[i], leg);
                    if (loc && duplicates.hasOwnProperty(loc.parent().id())) {
                        continue;
                    }
                    if (loc) {
                        result.push(loc);
                        duplicates[loc.parent().id()] = loc;
                    } else {
                        result.push(locationSequences[i]);
                    }
                } else {
                    if (duplicates.hasOwnProperty(locationSequences[i].parent().id())) {
                        continue;
                    } else {
                        result.push(locationSequences[i]);
                        duplicates[locationSequences[i].parent().id()] = locationSequences[i];
                    }
                }
            }
            return result;
        }

        function getLocById(loc, leg) {
            var i,
                jsObj,
                journeyLocation,
                locs = leg.locationSequence();

            for (i=0; i < locs.length; i++) {
                if (locs[i].parent().id() === loc.parent().id()) {
                    jsObj = locs[i].toJSON();
                    if (!jsObj.productClasses) {
                        jsObj.productClasses = [];
                    }
                    jsObj.productClasses = jsObj.productClasses.concat(loc.productClasses());
                    jsObj.isRealtimeControlled = leg.isRealtimeControlled();
                    jsObj.properties = loc.properties();
                    jsObj.properties.usedstop = true;

                    journeyLocation = new MDVJourneyLocation(jsObj);

                    return journeyLocation;
                }
            }
            return null;
        }

        function startLivePosition() {
            var groupedLocationSequences = angular.copy(self.groupedLocationSequences);

            fireLivePosition();
            self.livePositionsInterval = $interval(function() {
                fireLivePosition();
            }, 10000);

            function fireLivePosition() {
                MDVLivePositionsRequester.search(self.transportation)
                .then(function(res) {
                    var i, j, k,
                        l, m, n,
                        liveTransportation;

                    self.groupedLocationSequences = angular.copy(groupedLocationSequences);

                    if (res && res.response && res.response.length>0) {
                        self.liveTransportations = res.response;

                        for (i=0, l=self.liveTransportations.length; i<l; i+=1) {
                            liveTransportation = self.liveTransportations[i];
                            $scope.delay = liveTransportation.properties().delay;
                            $scope.currentSt = liveTransportation.properties().CurrentStop;

                            for (j=0, m=self.groupedLocationSequences.length; j<m; j+=1) {
                                for (k=0, n=self.groupedLocationSequences[j].locations.length; k<n; k+=1) {
                                    if (liveTransportation.properties().CurrentStop.startsWith(self.groupedLocationSequences[j].locations[k].parent().id())) {
                                        self.groupedLocationSequences[j].locations[k].lpClass = 'ps-pos-' + VVSConst.iconProductClassMapper[liveTransportation.productClass()];
                                        self.groupedLocationSequences[j].locations[k].lpDelay = liveTransportation.properties().delay;
                                    }
                                }
                            }
                        }

                    }
                });
            }
        }


    }
}());

(function() {
    'use strict';


    angular.module('vvs')
        .factory('VVSPdfViewer', VVSPdfViewer);

    VVSPdfViewer.$inject = ['$rootScope', '$uibModal', 'VVSBrowserUtilities'];

    function VVSPdfViewer($rootScope, $uibModal, VVSBrowserUtilities) {
        var constructor = {
            show : show
        };

        function show(file) {

            if(VVSBrowserUtilities.isIEBrowser()){
                //window.open(file.url());
                //return;
            }

            var modalInstance = $uibModal.open({
                templateUrl: 'app/vvs.components/common/pdf-viewer/modal.html',
                controller: 'VVSPdfViewerController',
                size: 'md',
                animation: true,
                resolve: {
                    file: function() {
                        return file;
                    }
                }
            });
        }

        return constructor;
    }
}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSPdfViewerController', VVSPdfViewerController);

    VVSPdfViewerController.$inject = ['$rootScope', '$scope', '$window', 'file', '$uibModalInstance', '$sce', 'VVSBrowserUtilities', '$stateParams', '$location'];

    function VVSPdfViewerController($rootScope, $scope, $window, file, $uibModalInstance, $sce, VVSBrowserUtilities, $stateParams, $location) {
        $scope.file = file;

        $scope.isLFP = $stateParams.lfp;

        var absURL = $location.absUrl();

        var browserName = VVSBrowserUtilities.getBrowserName(),
            mos = VVSBrowserUtilities.getMobileOperatingSystem(),
            isIEBrowser = VVSBrowserUtilities.isIEBrowser();

        $scope.isAndroid = (mos === 'Android');
        $scope.isWindows = (isIEBrowser || (['Windows'].indexOf(mos) > -1));
        $scope.isFireFox = (browserName === 'Firefox');

        $scope.trustSrc = function(src, withViewer) {
            if (withViewer) {
                src = '//docs.google.com/gview?embedded=true&url=' + src;
            }
            return $sce.trustAsResourceUrl(src);
        };

        $scope.dismissModal = function() {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.openFile = function(fileUrl) {
            $window.open(fileUrl, '_blank', 'heigth=600,width=600');
            $scope.dismissModal();
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsPdf', vvsPdf);

    vvsPdf.$inject = ['VVSBrowserUtilities', '$location'];

    function vvsPdf(VVSBrowserUtilities, $location) {
        var browserName = VVSBrowserUtilities.getBrowserName(),
        mos = VVSBrowserUtilities.getMobileOperatingSystem(),
        isIEBrowser = VVSBrowserUtilities.isIEBrowser();

        return {
            restrict : 'E',
            replace : true,
            scope : {
                type: '=',
                file: '=',
                line: '=',
                lfp:'='
            },
            templateUrl : 'app/vvs.components/common/pdf/main.html',
            controller: function($scope) {
                console.log('file', $scope.file);
                console.log('file', $scope.file.input());
                $scope.isAndroid = (mos === 'Android');
                $scope.isWindows = (isIEBrowser || (['Windows'].indexOf(mos) > -1));
                $scope.isFireFox = (browserName === 'Firefox');
            }
        };
    }
}());
(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsNavBlock', vvsNavBlock);

    function vvsNavBlock() {
        return {
            restrict : 'E',
            replace : true,
            scope : {
                title: '@'
            },
            controller : 'VVSNavBlockController',
            controllerAs : 'VVSNavBlockController',
            templateUrl : 'app/vvs.components/common/nav-block/main.html'
        };
    }
}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSNavBlockController', VVSNavBlockController);

        VVSNavBlockController.$inject = ['$scope', '$state', 'mng-personalization.MDVPersonalizationHelper'];

    function VVSNavBlockController($scope, $state, MDVPersonalizationHelper) {
        var self = this;

        $scope.goBack = function() {
            window.history.back();
        }

        $scope.triggerLogoutClick = function() {
            MDVPersonalizationHelper.logout()
                .then(function() {
                    $scope.loggedInUser = null;
                    $state.go('vvs.personalization.login');
                    // $state.go('vvs.personalization.logout');
                });
        };

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsModal', vvsModal);

    vvsModal.$inject = ['$uibModal', 'VVSConst', 'VVSGoogleDeepLinking', '$window'];

    function vvsModal($uibModal, VVSConst, VVSGoogleDeepLinking, $window) {
         var baseUrl = VVSConst.baseUrl;

        return {
            restrict : 'A',
            link : function($scope, $elem, $attrs) {
                var ignore = $scope.$eval($attrs.vvsModalIgnore),
                modalUrl = baseUrl + $attrs.vvsModalTemplate,
                modalSize = $attrs.vvsModalSize;

                var googleDeeplinkOptions = VVSGoogleDeepLinking.generateOptionsFromDeeplink();

                if (googleDeeplinkOptions) {
                    if ($elem.hasClass('ticketsModal')) {
                        $scope.modalInstance = $uibModal.open({
                            templateUrl : modalUrl,
                            scope : $scope.$new(),
                            controller : 'VVSModalInstanceController',
                            size : modalSize,
                            animation : true
                        });
                    }
                }

                angular.element($elem).on('click', function(e) {
                    e.preventDefault();
                    if (ignore) {
                        return;
                    }

                    $scope.modalInstance = $uibModal.open({
                        templateUrl : modalUrl,
                        scope : $scope.$new(),
                        controller : 'VVSModalInstanceController',
                        size : modalSize,
                        animation : true,
                        resolve: {
                            data: function () {
                                return modalUrl;
                            }
                        }
                    });
                    $scope.modalInstance.then(closedCallback(), dismissedCallback);

                    function closedCallback() {
                        console.log('closedCallback');
                    };
                    function dismissedCallback() {
                        console.log('dismissedCallback');
                    };
                // return instance;
                });
            }
        };
    }
}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSModalInstanceController', VVSModalInstanceController);

    VVSModalInstanceController.$inject = ['$scope', '$window', '$uibModalInstance', 'VVSGoogleDeepLinking', '$location', '$uibModalStack'];

    function VVSModalInstanceController($scope, $window, $uibModalInstance, VVSGoogleDeepLinking, $location, $uibModalStack) {
        initController();

        function initController() {
        }

        $scope.dismissModal = function() {
            // $uibModalInstance.dismiss('cancel');
            $uibModalStack.dismissAll('closing');
            if(VVSGoogleDeepLinking.generateOptionsFromDeeplink()) {
                $location.url($location.path());
            }
            VVSGoogleDeepLinking.clearGoogleDeeplink();
        };

        $window.onhashchange = function() {
            console.log('onhaschange');
            $scope.dismissModal();
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsLogout', vvsLogout);

    function vvsLogout() {
        return {
            restrict : 'E',
            replace : true,
            scope : true,
            controller : 'VVSLogoutController',
            templateUrl : function() {
                return 'app/vvs.components/common/logout/main.html';
            }
        };
    }
}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSLogoutController', VVSLogoutController);

    VVSLogoutController.$inject = ['$rootScope', '$scope', '$state', 'mng-personalization.MDVPersonalizationHelper'];

    function VVSLogoutController($rootScope, $scope, $state, MDVPersonalizationHelper) {

        function getLoggedInUser() {
            MDVPersonalizationHelper.isLoggedIn()
                .then(function(user) {
                    $scope.loggedInUser = user;
                })
                .catch(function() {
                    $scope.loggedInUser = null;
                });
        }
        getLoggedInUser();

        MDVPersonalizationHelper.waitForLogin()
            .then(null, null, function(user) {
                $scope.loggedInUser = user;
            });

        MDVPersonalizationHelper.waitForLogout()
            .then(null, null, function() {
                $scope.loggedInUser = null;
            });

        /*$rootScope.$on('$stateChangeStart', function(evt, to, params) {
            getLoggedInUser();
        });*/

        $scope.triggerLogoutClick = function() {
            MDVPersonalizationHelper.logout()
                .then(function() {
                    $scope.loggedInUser = null;
                    $state.go('vvs.personalization.login');
                    // $state.go('vvs.personalization.logout');
                });
        };

        $scope.triggerLoginClick = function() {
            hideAlerts();
            if ($scope.loginForm.$valid) {
                var user = angular.copy($scope.loggedOutUser);

                MDVPersonalizationHelper.login({
                    Name: user.Username,
                    Password: user.Password,
                    Client: 'vvs'
                })
                    .then(function(res) {
                        if (res) {
                            $scope.loggedInUser = res;
                            $scope.loggedOutUser = null;
                        } else {
                            $scope.invalidLoginInputsAlert = true;
                        }
                    })
                    .catch(function(e) {
                        $scope.invalidLoginInputsAlert = true;
                    });
            }
        };

        function hideAlerts() {
            $scope.invalidLoginInputsAlert = false;
        }
    }

}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .directive('vvsLanguageSwitcher', vvsLanguageSwitcher);

    vvsLanguageSwitcher.$inject = ['$rootScope', '$translate', '$locale', '$mdDateLocale', 'VVSConst', 'VVSI18n', 'mng-common.MDVUriParams'];

    function vvsLanguageSwitcher($rootScope, $translateProvider, $locale, $mdDateLocale, VVSConst, VVSI18n, MDVUriParams) {
        return {
            restrict : 'AE',
            templateUrl : function($elem, $attrs){

                var mode = angular.copy($attrs.mode) || 'web';

                if (mode === 'web') {
                    return 'app/vvs.components/common/language-switcher/web.html';
                }
                return 'app/vvs.components/common/language-switcher/mobile.html';
            },
            controller: translationSwitcherController,
            controllerAs: 'tsctrl',
            bindToController: true
        };

        function translationSwitcherController($scope, $attrs) {
            $scope.class = angular.copy($attrs.class)
            // get available languages from config
            this.availableLanguages = VVSConst.language.available;

            // get deeplink language
            var deeplinkLanguage = MDVUriParams.get('language'),
                defaultLang;
            if (this.availableLanguages.indexOf(deeplinkLanguage)>-1) {
                defaultLang = deeplinkLanguage;
            } else {
                // get already configured application language
                defaultLang = $translateProvider.preferredLanguage();
            }
            // set default language variable
            $scope.currentLanguage = defaultLang;
            MDVUriParams.set('language', defaultLang);
            // set Datepicker language to default language
            $translateProvider.use($scope.currentLanguage);
            angular.copy(VVSI18n[defaultLang], $locale);

            $mdDateLocale.formatDate = function(date) {
               return moment(date).format(VVSConst.datePickerFormat);
            };

            $rootScope.sharedData.currentLanguage = $scope.currentLanguage;

            // switch the application language
            this.switchLanguage = function(newLang) {
                $scope.currentLanguage = newLang;
                // switch the application language
                $translateProvider.use(newLang);
                // switch datepicker locale
                angular.copy(VVSI18n[newLang], $locale);
                MDVUriParams.set('language', newLang);
                $rootScope.sharedData.currentLanguage = newLang;
            };

        }
    }

}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .filter('VVSSortGroupedInfos', VVSSortGroupedInfos);

    VVSSortGroupedInfos.$inject = []

    function VVSSortGroupedInfos() {
        return function(groupedInfos) {
            var sorting = ['stoerung', 'meldungen', 'aufzug', 'other'],
                result = {};

            sorting.forEach(function(key) {
                if (groupedInfos.hasOwnProperty(key)) {
                    result[key] = groupedInfos[key];
                }
            }) ;

            return result;
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsInfos', vvsInfos);

    function vvsInfos() {
        return {
            restrict : 'E',
            replace : true,
            scope : {
                mode : '@mode',
                trip : '=',
                leg : '=',
                location : '=',
                depArr : '=',
                transportation : '='
            },
            controller : 'VVSInfosController',
            controllerAs : 'VVSInfosCtrl',
            templateUrl : function(elem, attrs) {
                if (attrs.mode === 'summary') {
                    return 'app/vvs.components/common/infos/summary.html';
                } else if (attrs.mode === 'details') {
                    return 'app/vvs.components/common/infos/details.html';
                } else if (attrs.mode === 'dm') {
                    return 'app/vvs.components/common/infos/dm.html';
                }
            }
        };
    }
}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSInfosController', VVSInfosController);

    VVSInfosController.$inject = ['$scope', '$attrs', 'VVSConst'];

    function VVSInfosController($scope, $attrs, VVSConst) {
        var self = this,
            mode = angular.copy($scope.mode),
            iconsMapper = VVSConst.iconAddInfoSubtypeMapper[mode],
            i,
            l;

        if ($scope.trip) {
            self.infos = $scope.trip.infos();
        } else if ($scope.leg) {
            self.infos = $scope.leg.infos();
        } else if ($scope.transportation) {
            self.infos = $scope.transportation.infos();
        } else if ($scope.location) {
            self.infos = $scope.location.infos();
        } else if ($scope.depArr) {
            self.infos = $scope.depArr.infos();
        }

        self.iconNames = [];
        self.hideInfo = false;

        for (i=0, l=self.infos.length; i<l; i+=1) {
            var info = self.infos[i],
                mappingKey = getMappingKey(info);

            if (mappingKey && (self.iconNames.indexOf(mappingKey) === -1)) {
                self.iconNames.push(mappingKey);
            }
        }

        if (self.iconNames.length===0) {
            self.hideInfo = true;
        } else if ((self.iconNames.length>1) && ((mode === 'summary')||(mode === 'dm'))) {
            self.iconNames = getSummaryIcon(angular.copy(self.iconNames));
        }

        function getSummaryIcon(iconsArr) {
            if (iconsArr.indexOf('stoerung')>-1) {
                return ['stoerung'];
            } else if (iconsArr.indexOf('meldungen')>-1) {
                return ['meldungen'];
            }
            return [iconsArr[0]];
        }

        function getMappingKey(info) {
            var infoType = info.properties().addInfoParam?info.properties().addInfoParam.infoType: null,
                messageSubType = info.properties().messageSubType,
                key,
                iconKey;


            if (!infoType) {
                infoType = info.properties().infoType;
                messageSubType = info.properties();
            }

            if (!infoType) {
                return;
            }

            for (key in messageSubType) {
                if (messageSubType.hasOwnProperty(key)) {
                    iconKey = infoType.concat('#').concat(key).concat('#').concat(messageSubType[key]);

                    if (iconsMapper.hasOwnProperty(iconKey)) {
                        return iconsMapper[iconKey];
                    }
                }
            }

            if (iconsMapper.hasOwnProperty(infoType)) {
                return iconsMapper[infoType];
            }
        }
    }


    angular
        .module('vvs')
        .controller('VVSModalsInfosController', VVSModalsInfosController);

    VVSModalsInfosController.$inject = ['$filter', '$scope', 'VVSConst', 'mng-comm.MDVMessageRequester'];

    function VVSModalsInfosController($filter, $scope, VVSConst, MDVMessageRequester) {
        var self = this;

        if ($scope.trip) {
            self.infos = $scope.trip.infos();
        } else if ($scope.leg) {
            self.infos = $scope.leg.infos();
        } else if ($scope.transportation) {
            self.infos = $scope.transportation.infos();
        } else if ($scope.location) {
            self.infos = $scope.location.infos();
        } else if ($scope.depArr) {
            self.infos = $scope.depArr.infos();
        }


        self.sortedGroupedInfos = {};


        getsortedGroupedInfos(self.infos);

        function getsortedGroupedInfos() {
            var infosIds = getInfosIds(self.infos),
                iconMapper = VVSConst.iconAddInfoSubtypeMapper['modal'];

            MDVMessageRequester.search({
                information : {
                    filter : {
                        ids : infosIds
                    }
                }
            }).then(function(res) {
                var infos = res.response;

                for (var i = 0; i < infos.length; i++) {
                    var info = infos[i],
                        infoType = info.type() || info.properties().infoType,
                        found = false,
                        infoIcon;

                    for (var key in info.properties()) {
                        if (info.properties().hasOwnProperty(key)) {
                            var iconKey = infoType.concat('#').concat(key).concat('#').concat(info.properties()[key]);

                            if (iconMapper.hasOwnProperty(iconKey)) {

                                if (!self.sortedGroupedInfos.hasOwnProperty(iconMapper[iconKey])) {
                                    self.sortedGroupedInfos[iconMapper[iconKey]] = [];
                                }
                                self.sortedGroupedInfos[iconMapper[iconKey]].push(info);
                                found = true;
                            }
                        }
                    }

                    if (!found) {
                        if (!self.sortedGroupedInfos.hasOwnProperty('other')) {
                            self.sortedGroupedInfos['other'] = [];
                        }
                        self.sortedGroupedInfos['other'].push(info);
                    }

                }

                self.sortedGroupedInfos = $filter('VVSSortGroupedInfos')(angular.copy(self.sortedGroupedInfos));
            });

        }

        function getInfosIds(infos) {
            var ids = [],
                i;

            for (i=0; i<infos.length; i+=1) {
                ids.push(infos[i].id());
            }
            return ids;
        }
    }



}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsHistory', vvsHistory);

    function vvsHistory() {
        return {
            restrict : 'E',
            replace : true,
            scope : true,
            controller : 'VVSHistoryController',
            controllerAs : 'VVSHistoryCtrl',
            templateUrl : function(elem, attrs) {
                var mode = angular.copy(attrs.mode);

                if (mode === 'odv') {
                    return 'app/vvs.components/common/history/odv.html';
                } else if (mode === 'line') {
                    return 'app/vvs.components/common/history/line.html';
                } else if (mode === 'location') {
                    return 'app/vvs.components/common/history/location.html';
                }
            }
        };
    }
}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSHistoryController', VVSHistoryController);

    VVSHistoryController.$inject = ['$scope', '$attrs', '$location', '$anchorScroll',
        'mng-favorite.MDVOdvFavorite', 'mng-favorite.MDVTransportationFavorite',
        'mng-favorite.MDVLocationFavorite'];

    function VVSHistoryController($scope, $attrs, $location, $anchorScroll, MDVOdvFavorite,
        MDVTransportationFavorite, MDVLocationFavorite) {

        var self = this,
            mode = angular.copy($attrs.mode),
            usage = angular.copy($attrs.usage);

        self.historyMode = mode;
        self.historyUsage = usage;
        self.triggerHistoryItemClick = triggerHistoryItemClick;
        self.triggerClearFavoritesClick = triggerClearFavoritesClick;

        initController();

        function initController() {
            if (mode === 'odv') {
                MDVOdvFavorite.get().then(function(res) {
                    self.favorites = res;
                });
            } else if (mode === 'location' && usage) {
                MDVLocationFavorite.get(null, usage).then(function(res) {
                    self.favorites = res;
                });
            } else if (mode === 'line' && usage) {
                MDVTransportationFavorite.get(null, usage).then(function(res) {
                    self.favorites = res;
                });
            }
        }

        function triggerHistoryItemClick(obj) {
            if (mode === 'odv') {
                $scope.inputLocations.orig = obj.origin();
                $scope.inputLocations.dest = obj.destination();
                if (obj.vias().length > 0) {
                    $scope.inputLocations.via = obj.vias()[0];
                    if (!$scope.showVia) {
                        $scope.tripCtrl.triggerToggleViaClick();
                    }
                } else {
                    $scope.inputLocations.via = null;
                    if ($scope.showVia) {
                        $scope.tripCtrl.triggerToggleViaClick();
                    }
                }
            } else if (mode === 'location') {
                $scope.inputLocations[usage] = obj;
            } else if (mode === 'line') {
                $scope.inputLines[usage] = obj;
            }
            $location.hash('vvs_body');
            $anchorScroll();
        }

        function triggerClearFavoritesClick() {
            var opts = {
                dropDB : true
            };

            if (mode === 'odv') {
                MDVOdvFavorite.remove(null, opts);
                MDVLocationFavorite.remove(null, 'orig', opts);
                MDVLocationFavorite.remove(null, 'dest', opts);
                MDVLocationFavorite.remove(null, 'via', opts);
            } else if (mode === 'location') {
                MDVLocationFavorite.remove(null, usage, opts);
            } else if (mode === 'line') {
                MDVTransportationFavorite.remove(null, usage, opts);
            }

            self.favorites.length = 0;

        }
    }

}());

(function() {
    'use strict';

    angular.module('vvs')
        .factory('VVSGoogleDeepLinking', VVSGoogleDeepLinking);

    VVSGoogleDeepLinking.$inject = ['mng-common.MDVUriParams', 'VVSBrowserUtilities', 'VVSConst', '$location'];

    function VVSGoogleDeepLinking(MDVUriParams, VVSBrowserUtilities, VVSConst, $location) {
        var googleOptions = {
            dateTime: {
                date: null,
                time: null,
                isDeparture: true
            },
            odvs: {
                from: null,
                to: null
            }
        };

        var triggerGoogleLink = true;

        var queryString = $location.search();
        var isGoogleLink = isGoogleDeepLink();

        console.log('UPDATE', new Date().toLocaleDateString());
        console.log('Stand 14.03.23');

        function isGoogleDeepLink() {
            var url = window.location.href;
            var checkArr = ['boarding_time', 'from_ticketing_stop_time_id', 'to_ticketing_stop_time_id'];
            var check = checkArr.every(function(el) {
                return url.indexOf(el) >=0;
            });
            if (queryString.hasOwnProperty('boarding_time')) {
                return check;
            }
            return false;
        }
        if (queryString && isGoogleLink) {
            // var dateTime = queryString['boarding_time'];
            var dateTime = queryString['boarding_time'].replace(/[\[\]'"{}]+/g,'').replace(' 00:00', '').replace('+00:00', '');
            var orig = queryString['from_ticketing_stop_time_id'].replace(/[\[\]'"{}]+/g,'');
            var dest = queryString['to_ticketing_stop_time_id'].replace(/[\[\]'"{}]+/g,'');
        }

        function getOrigin(orig) {
            var arr = orig.split(',');
            if (arr.length === 1) {
                return orig;
            }
            return arr[0];
        }
        function getDest(dest) {
            var arr = dest.split(',');
            if (arr.length === 1) {
                return dest;
            }
            return arr[arr.length-1];
        }
        function getDatetime(time) {
            var arr = time.split(',');
            if (arr.length === 1) {
                return time;
            }
            return arr[0];
        }

        return {
            generateOptionsFromDeeplink : generateOptionsFromDeeplink,
            clearGoogleDeeplink: clearGoogleDeeplink
        };

        function clearGoogleDeeplink() {
            triggerGoogleLink = false;
        }

        function generateOptionsFromDeeplink() {
            if (!isReady() || !triggerGoogleLink) {
                return null;
            }
            //simulation url
            // var deeplinkgoogle = "https://ticket.vvs.de/?arrival_time=%5B%222022-04-07T14:56:00+00:00%22%7D&boarding_time=%5B%222022-04-07T14:17:00+00:00%22%7D&from_ticketing_stop_time_id=%5B%22de:08116:7801:3:6%22%7D&service_date=%5B%2220220325%22%7D&ticketing_trip_id=%5B%22de:vvs:vvs-31-122::1-T0-26%22%7D&to_ticketing_stop_time_id=%5B%22de:08116:2103:3:2%22%7D&source=maps&ei=n7M9Ys3WEuqL9u8P-r-BEA&usg=AOvVaw15ypml6HVAwaGJy_DYN4bN&ved=0ahUKEwiNosbwn-H2AhXqhf0HHfpfAAIQ-CQIOCgG";

            if (isGoogleLink) {
            if (orig) {
                googleOptions.odvs.from = getOrigin(orig);
            }
            if (dest) {
                googleOptions.odvs.to = getDest(dest);
            }
            if (dateTime) {
                // var date = moment(googleOptions.dateTime, VVSConst.datePickerFormat).toDate();
                var date = moment(getDatetime(dateTime), 'YYYY-MM-DD');
                // var date = moment(googleOptions.dateTime, 'YYYY-MM-DD').toDate();
                var time = moment(getDatetime(dateTime)).format(VVSConst.timePickerFormat);
                if (date) {
                    googleOptions.dateTime['date'] = date;
                }
                if (time) {
                    googleOptions.dateTime['time'] = time;
                } else {
                    googleOptions.dateTime['time'] = moment('now');
                }
            }
                return googleOptions;
            }

            return null;
        }

        function isReady() {
            return true;
        }
    }


}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .directive('vvsFeedback', vvsFeedback);

    function vvsFeedback() {
        return {
            restrict : 'E',
            replace : true,
            scope : false,
            templateUrl : 'app/vvs.components/common/feedback/main.html'
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSFeedbackController', VVSFeedbackController);

    VVSFeedbackController.$inject = ['$location', '$scope', 'mng-personalization.MDVPersonalizationHelper'];

    function VVSFeedbackController($location, $scope, MDVPersonalizationHelper) {
        var self = this;

        self.submitFeedbackForm = submitFeedbackForm;

        function submitFeedbackForm() {
            self.feedbackSuccess = false;
            if (self.feedbackForm.$valid) {
                var form = angular.copy(self.form);

                form.FeedbackLink = $location.absUrl();
                form.feedbackEmailAddress = 'EFALabAddress';

                MDVPersonalizationHelper.sendFeedback(form)
                    .then(function(res) {
                        self.form = null;
                        self.feedbackSuccess = true;
                        //debugger;
                    })
                    .catch(function(e) {
                        //debugger;
                    });
            }
        }

        /*
        function getFeedbackLink() {
            var search = $location.search(),
                res = '';

                for (var key in search) {
                    if (search.hasOwnProperty(key)) {
                        res = res + '&' + key + '=' + search[key];
                    }
                }
            return res;
        }
         */

    }

}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .directive('vvsDevTools', vvsDevTools);

    function vvsDevTools() {
        return {
            restrict : 'E',
            replace : true,
            scope : false,
            templateUrl : 'app/vvs.components/common/dev-tools/main.html'
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSDevToolsController', VVSDevToolsController);

    VVSDevToolsController.$inject = ['$scope'];

    function VVSDevToolsController($scope) {
        var self = this;

        window.addEventListener('message', function (e) {
            if (e && (e.data === 'closeIframe')) {
                $scope.dismissModal();
            }
        });

    }

}());

(function() {
    'use strict';

    angular.module('vvs')
        .factory('VVSDeepLinking', VVSDeepLinking);

    VVSDeepLinking.$inject = ['mng-common.MDVUriParams', 'VVSBrowserUtilities', 'VVSConst'];

    function VVSDeepLinking(MDVUriParams, VVSBrowserUtilities, VVSConst) {

        return {
            generateDeeplinkFromOptions : generateDeeplinkFromOptions,
            generateOptionsFromDeeplink : generateOptionsFromDeeplink,
            getDeepLink : getDeepLink
        };

        function getDeepLink() {
            return MDVUriParams.get('deeplink');
        }

        function generateDeeplinkFromOptions(options) {
            if (!options || !isReady()) {
                return;
            }

            if (options.dateTime && options.dateTime.date && (typeof options.dateTime.date === 'object')) {
                options.dateTime.date = moment(options.dateTime.date).format(VVSConst.datePickerFormat);
            }

            if (options.dateTime && options.dateTime.time && (typeof options.dateTime.time === 'object')) {
                options.dateTime.time = moment(options.dateTime.time).format(VVSConst.timePickerFormat);
            }
            options = reduceObject(options);

            var deeplink = JSON.stringify(options);

            MDVUriParams.set('deeplink', deeplink);
            return deeplink;
        }

        function generateOptionsFromDeeplink() {
            if (!isReady()) {
                return null;
            }

            var deeplink = MDVUriParams.get('deeplink'),
                qr = MDVUriParams.get('qr');

            if (deeplink) {
                deeplink = deeplink.replace(/\*\*/g, '"');
                deeplink = JSON.parse(deeplink);

                try {
                    if (deeplink && deeplink.dateTime && deeplink.dateTime.date && deeplink.dateTime.date!=='now') {
                        if (deeplink.dateTime.date) {
                            deeplink.dateTime.date = moment(deeplink.dateTime.date, VVSConst.datePickerFormat);
                        } else {
                            deeplink.dateTime.date = moment('now');
                        }
                    }

                    if (deeplink && deeplink.dateTime && deeplink.dateTime.time && deeplink.dateTime.time!=='now') {
                        if (deeplink.dateTime.time) {
                            deeplink.dateTime.time = moment(deeplink.dateTime.time, VVSConst.timePickerFormat);
                        } else {
                            deeplink.dateTime.time = moment('now');
                        }
                    }
                }
                catch(e) {
                    return null;
                }
                return deeplink;
            }

            else if (qr == '1') {
                var deeplink = {
                        'efaParams': {
                            "qr": 1
                        },
                        'odvs': {},
                        'dateTime': {
                            'date': 'now',
                            'dateFormat': '',
                            'time': 'now',
                            'timeFormat': '',
                            'useRealTime': true,
                            'isDeparture': true,
                            'timeCut': [
                                '01:00',
                                '04:00'
                            ],
                            'timeCutInterval': '1'
                        }
                    },
                    nameDm = MDVUriParams.get('name_dm'),
                    line = MDVUriParams.get('line'),
                    sId = MDVUriParams.get('sID');

                if (nameDm) {
                    deeplink.odvs.dm = nameDm;
                }
                if (line) {
                    deeplink.efaParams.line = line;
                }
                if (sId) {
                    deeplink.efaParams.sID = sId;
                }
                MDVUriParams.set('qr', '0');
                return deeplink;
            }

            return null;
        }

        function isReady() {
            return true;
        }

        function reduceObject(options) {
            // ["accessibility", "dateTime", "productRestrictions", "individualTransport", "publicTransport", "via", "fare", "sharing", "pdfOutput", "odvs", "$version", "$class", "persistence", "_id", "_rev"]

            delete options['accessibility'];
            delete options['productRestrictions'];
            delete options['individualTransport'];
            delete options['publicTransport'];
            delete options['fare'];
            delete options['sharing'];
            delete options['pdfOutput'];
            delete options['$version'];
            delete options['$class'];
            delete options['persistence'];
            delete options['_id'];
            delete options['_rev'];

            return options;
        }
    }


}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .directive('vvsBookTaxi', vvsBookTaxi);

    function vvsBookTaxi() {
        return {
            restrict : 'E',
            replace : true,
            scope : {
                'leg' : '='
            },
            templateUrl : 'app/vvs.components/common/book-taxi/main.html',
            controller : function($scope) {
                
            }
        };
    }

}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .directive('vvsBookAst', vvsBookAst);

    function vvsBookAst() {
        return {
            restrict : 'E',
            replace : true,
            scope : true,
            templateUrl : 'app/vvs.components/common/book-ast/main.html',
            controller : 'VVSBookAstController',
            controllerAs : 'VVSBookAstCtrl'
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSBookAstController', VVSBookAstController);

    VVSBookAstController.$inject = ['$scope', '$uibModal', 'mng-comm.MDVAst', 'mng-personalization.MDVPersonalizationHelper',
        'mng-comm.itd.json.MDVEFATripParser'];

    function VVSBookAstController($scope, $uibModal, MDVAst, MDVPersonalizationHelper, MDVEFATripParser) {
        var self = this,
            _private = {};

        self.astService = new MDVAst();
        self.trip = angular.copy($scope.trip);


        MDVPersonalizationHelper.isLoggedIn()
            .then(function(user) {
                self.isLoggedIn = user;
            });

        MDVPersonalizationHelper.waitForLogin()
            .then(null, null, function(user) {
                self.isLoggedIn = user;
            });

        MDVPersonalizationHelper.waitForLogout()
            .then(null, null, function() {
                self.isLoggedIn = null;
            });

        self.openAvailabilityModal = function() {
            var modalInstance = $uibModal.open({
                templateUrl : 'app/vvs.components/common/book-ast/availability-modal.html',
                controller : 'VVSASTAvailabilityController',
                controllerAs : 'VVSASTAvailabilityCtrl',
                animation : true
            });

            modalInstance.result.then(function(response) {
                if (response && response.user) {
                    self.checkAvailability(response.user);
                }
            });
        };

        self.checkAvailability = function(user) {
            self.trip = angular.copy($scope.trip);

            self.astService.updateJourney(angular.copy(self.trip));
            self.astService.checkAvailability({
                user : user
            })
                .then(function(response) {
                    if (response) {
                        self.trip = angular.copy(response);

                        self.reservationSuccess = false;

                        var i, l,
                            bookedLegIndex,
                            raw = self.trip.raw();

                        for (i=0, l=raw.legs.length; i<l; i++) {
                            if (raw.legs[i].properties && raw.legs[i].properties.reservationDetails && raw.legs[i].properties.reservationDetails.reservationCode) {
                                self.reservationSuccess = true;
                                bookedLegIndex = i;
                                break;
                            }
                        }

                        if (self.reservationSuccess) {
                            MDVPersonalizationHelper.setTrip(self.trip)
                                .then(function(res) {
                                    if (res && res.ID) {
                                        self.savingSuccess = true;
                                        raw.legs[bookedLegIndex].properties.reservationDetails['savedTripId'] = res.ID;

                                        var parsedTrips = MDVEFATripParser.parse({
                                            journeys : [raw]
                                        }).trips;

                                        if (parsedTrips.length>0) {
                                            self.trip = angular.copy(parsedTrips[0]);
                                            $scope.updateTrip(self.trip);
                                        }
                                    } else {
                                        self.savingError = true;
                                    }
                                })
                                .catch(function(e) {
                                    self.savingError = e;
                                });
                        }
                    } else {
                        self.reservationError = response;
                    }
                }).catch(function(e) {
                    if (e && e.data && e.data.response && e.data.response.availabilityResponse && e.data.response.availabilityResponse.errorMessage) {
                        self.reservationError = e.data.response.availabilityResponse.errorMessage;
                    } else {
                        self.reservationError = 'UNKOWN';
                    }
                });
        };

        self.book = function(reservationCode, savedTripId) {
            self.astService.book(reservationCode)
                .then(function(response) {
                    if (response && response.ErrorMessage && (response.ErrorMessage === 'BOOKING_OK')) {
                        self.bookingSuccess = response;
                        // replace reservationDetails with bookingDetails
                        var raw = self.trip.raw(),
                            i, l;

                        for (i=0, l=raw.legs.length; i<l; i++) {
                            if (raw.legs[i].properties && raw.legs[i].properties.reservationDetails) {
                                raw.legs[i].properties.bookingDetails = raw.legs[i].properties.reservationDetails;
                                raw.legs[i].properties.bookingDetails.bookingTimestamp = response.reservationDetails.bookingTimestamp;
                                delete raw.legs[i].properties.reservationDetails;
                            }
                        }

                        var parsedTrips = MDVEFATripParser.parse({
                            journeys : [raw]
                        }).trips;

                        if (parsedTrips.length>0) {
                            self.trip = parsedTrips[0];
                            $scope.updateTrip(self.trip);
                            MDVPersonalizationHelper.removeTrip(savedTripId)
                                .then(function() {
                                    MDVPersonalizationHelper.setTrip(angular.copy(self.trip))
                                        .then(function(res) {
                                            if (res && res.ID) {
                                                self.savingSuccess = true;
                                                savedTripId = res.ID;
                                            } else {
                                                self.savingError = true;
                                            }
                                        })
                                        .catch(function(e) {
                                            self.savingError = e;
                                        });
                                });
                        }
                    } else {
                        self.bookingError = response;
                    }
                })
                .catch(function(e) {
                    self.bookingError = e;
                });
        };
    }


    angular
        .module('vvs')
        .controller('VVSASTLoginController', VVSASTLoginController);

    VVSASTLoginController.$inject = ['$scope', '$uibModal', 'mng-personalization.MDVPersonalizationHelper'];

    function VVSASTLoginController($scope, $uibModal, MDVPersonalizationHelper) {
        var self = this,
            _private = {};

        self.submitLoginForm = function() {
            _private.hideAlerts();
            if ($scope.loginForm.$valid) {
                var user = angular.copy($scope.user);

                MDVPersonalizationHelper.login({
                    Name: user.UserName,
                    Password: user.Password,
                    Client: 'vvs'
                })
                    .then(function(res) {
                        if (res) {
                            $scope.dismissModal();

                            var modalInstance = $uibModal.open({
                                templateUrl: 'app/vvs.components/common/book-ast/availability-modal.html',
                                controller: 'VVSASTAvailabilityController',
                                controllerAs: 'VVSASTAvailabilityCtrl',
                                animation: true
                            });

                            modalInstance.result.then(function(response) {
                                if (response && response.user) {
                                    $scope.VVSBookAstCtrl.checkAvailability(response.user);
                                }
                            });
                        } else {
                            self.invalidLoginInputsAlert = true;
                        }
                    })
                    .catch(function() {
                        self.invalidLoginInputsAlert = true;
                    });
            }
        };

        _private.hideAlerts = function() {
            self.invalidLoginInputsAlert = false;
        };

    }


    angular
        .module('vvs')
        .controller('VVSASTAvailabilityController', VVSASTAvailabilityController);

    VVSASTAvailabilityController.$inject = ['$scope', '$uibModalInstance', 'mng-personalization.MDVPersonalizationHelper'];

    function VVSASTAvailabilityController($scope, $uibModalInstance, MDVPersonalizationHelper) {
        var self = this,
            _private = {};


        function fillForm() {
            MDVPersonalizationHelper.getProfile()
                .then(function(user) {
                    $scope.user = angular.copy(user);
                    self.isCallCenter = (['jochen.scholz.gp@googlemail.com', 'reallabor@tellur.de'].indexOf($scope.user.Email) > -1);
                    if (self.isCallCenter) {
                        $scope.user.FirstName = '';
                        $scope.user.LastName = null;
                        $scope.user.source = 'CALL_CENTER';
                    }
                    $scope.user.Phone = null;
                });
        }
        fillForm();

        self.submitAvailabilityForm = function() {
            _private.hideAlerts();
            if ($scope.availabilityForm.$valid) {
                var user = angular.copy($scope.user);

                if (!user.Phone || (user.Phone.length === 0)) {
                    user.Phone = '1234';
                }

                $uibModalInstance.close({
                    user : user
                });

                //$scope.VVSBookAstCtrl.checkAvailability(user);
                //$scope.VVSASTLoginCtrl.dismissModal();
            } else {
                $scope.invalidAvailabilityInputsAlert = true;
            }
        };

        _private.hideAlerts = function() {
            $scope.invalidAvailabilityInputsAlert = false;
        };

        self.dismissModal= function() {
            $uibModalInstance.close();
        };

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsAssignedStops', vvsAssignedStops);

    function vvsAssignedStops() {
        return {
            restrict : 'E',
            replace : true,
            scope : true,
            controller : 'VVSAssignedStopsController',
            controllerAs : 'VVSAssignedStopsCtrl',
            templateUrl : 'app/vvs.components/common/assigned-stops/main.html'
        };
    }
}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSAssignedStopsController', VVSAssignedStopsController);

    VVSAssignedStopsController.$inject = ['$scope', '$attrs'];

    function VVSAssignedStopsController($scope, $attrs) {
        var self = this;

        self.getAllProductClasses = getAllProductClasses;
        self.triggerSelectAssignedStopClick = triggerSelectAssignedStopClick;
        self.closeAssignedStops = closeAssignedStops;

        self.location = angular.copy($scope.$eval($attrs.location));

        self.usage = angular.copy($scope.$eval($attrs.usage));


        function getAllProductClasses(loc) {
            var res = [],
                as,
                i;

            if (!loc) {
                return [];
            }

            for (i=0; i<loc.assignedStops().length; i+=1) {
                as = loc.assignedStops()[i];
                res = res.concat(as.productClasses());
            }
            return res;
        }

        function triggerSelectAssignedStopClick() {
            //debugger;
        }
        function closeAssignedStops() {
            //debugger;
        }


    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .directive('vvsAlert', vvsAlert);

    function vvsAlert() {
        return {
            restrict : 'E',
            replace : true,
            scope : {
                'html' : '=',
                'text' : '=',
                'messages' : '='
            },
            templateUrl : 'app/vvs.components/common/alerts/main.html'
        };
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc overview
     * @name mng-util
     *
     * constants to define the default behavior of mng-util.MDVLog.
     */
    angular.module('mng-util')
        .constant('mng-util.log-config', {
            // write log to console whenever a message is logged. This flag differs from the global
            // 'enabled' flag, as this flag only affects the console logging. The log-cache is still
            // filled if this flag is disabled.
            consoleEnabled : true,
            // enable logging per default. This is the global log enable/disable switch. If disabled,
            // logs are also not stored in the internal log-cache. It also disables the console log.
            enabled : true,
            // default log level is warning to avoid flooding the console. The flag can also be set
            // via MDVLog.enable(X), where x is the log level
            level : 2,
            // maximal logs that are stored in the log-cache. If more than this logs are
            // logged, the oldest one is removed. Log cache can be used to show the logs within the
            // webpage, which is very useful for hybrid apps for example.
            maxLength : 1000,
            // throw error logs instead of logging an error.
            throwErrorLogs : false
        });
}());

(function() {
    'use strict';

    /**
     * // TODO
     */
    angular.module('mng-personalization', ['mng-util', 'mng-comm.itd', 'mng-config', 'mng-model',
        'mng-persistence', 'mng-favorite']);
}());

(function() {
    'use strict';

    angular.module('mng-personalization')
        .factory('mng-personalization.MDVPersonalizationTrip', MDVPersonalizationTrip);

    MDVPersonalizationTrip.$inject = ['mng-util.MDVLog', 'mng-util.MDVException',
        'mng-config.MDVConfig', 'mng-personalization.MDVPersonalizationRequester'];

    function MDVPersonalizationTrip(MDVLog, MDVException, MDVConfig, MDVPersonalizationRequester) {
        var _private = {
                namespace : 'mng-personalization.MDVPersonalizationTrip'
            },
            MAX_NAME_LENGTH = 50,
            log = MDVLog.register(_private.namespace),
            pt = {
                get : get,
                set : set,
                remove : remove,
                getSupplement : getSupplement
            };

        log.debug('init');

        // ///////////////////////////////////////////////////

        function set(userId, trip) {
            if (!trip) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.TRANSPORTATION_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            var tripSupp = {
                    Name : 'TRIP_RAW',
                    Data : JSON.stringify(trip.raw())
                },
                data = {
                    UserId: userId,
                    Name : trip.origin().name() + ' - ' + trip.destination().name(),
                    TripOption : [],
                    Point : [],
                    Usage : 5,
                    TripSupplement : [tripSupp]
                };

            if (data.Name && (data.Name.length>MAX_NAME_LENGTH)) {
                data.Name = data.Name.substring(0, MAX_NAME_LENGTH-1);
            }

            log.debug('start adding Trip');

            return MDVPersonalizationRequester
                .request('/Personalization/OData/Trip', 'post', null, data)
                .then(function(response) {
                    return response;
                });
        }


        function get(params) {
            log.debug('start getting Trips');

            return MDVPersonalizationRequester
                .request('/Personalization/OData/Trip', 'get', null, params)
                .then(function(response) {
                    if (!response || !response.value) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.TRANSPORTATION_FAILED, {
                            reason : 'problem on getting trips'
                        });
                    }

                    return response.value;
                });
        }

        function remove(tripId) {
            if (!tripId) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.TRANSPORTATION_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            log.debug('start removing Trip');

            return MDVPersonalizationRequester
                .request('/Personalization/OData/Trip('+tripId+')', 'delete', null)
                .then(function(response) {
                    return response;
                });
        }


        function getSupplement(params) {
            log.debug('start getting TripSupplement');

            return MDVPersonalizationRequester
                .request('/Personalization/OData/TripSupplement', 'get', null, params)
                .then(function(response) {
                    if (!response || !response.value) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.TRANSPORTATION_FAILED, {
                            reason : 'problem on getting trips'
                        });
                    }

                    return response.value;
                });
        }


        // ///////////////////////////////////////////////////

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.getDefaultConfigOption = function() {
            return null;
        };

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                pt._private = _private;
            }
        });


        return pt;
    }


}());

(function() {
    'use strict';

    angular.module('mng-personalization')
        .factory('mng-personalization.MDVPersonalizationTransportation', MDVPersonalizationTransportation);

    MDVPersonalizationTransportation.$inject = ['mng-util.MDVLog', 'mng-util.MDVException',
        'mng-config.MDVConfig', 'mng-personalization.MDVPersonalizationRequester'];

    function MDVPersonalizationTransportation(MDVLog, MDVException, MDVConfig, MDVPersonalizationRequester) {
        var _private = {
                namespace : 'mng-personalization.MDVPersonalizationTransportation'
            },
            log = MDVLog.register(_private.namespace),
            pt = {
                get : get,
                set : set,
                remove : remove
            };

        log.debug('init');

        // ///////////////////////////////////////////////////

        function set(userId, userNotificationId, transportation) {
            if (!transportation) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.TRANSPORTATION_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            var data = [{
                // UserId: userId,
                // UserNotificationId: userNotificationId,
                Description : transportation.routeDescription(),
                Name : transportation.name(),
                Key : _private.cleanIdWithoutDir(transportation.id()),
                // Key : _private.cleanId(transportation.id()),
                MeansOfTransport : String(transportation.productIconId()),
                Type : 7
            }];

            log.debug('start adding Transportation');

            // Changed endpoint (EFAF-9488)
            return MDVPersonalizationRequester
                .request('/pushService/Subscription/email/Service', 'post', null, data);
        }

        function get(params) {
            log.debug('start getting lines');

            return MDVPersonalizationRequester
                .request('/Personalization/OData/Service', 'get', null, params)
                .then(function(response) {
                    if (!response || !response.value) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.TRANSPORTATION_FAILED, {
                            reason : 'problem on getting transportations'
                        });
                    }

                    return response.value;
                });
        }

        function remove(lineId) {
            if (!lineId) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.TRANSPORTATION_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            log.debug('start removing lines');

            // Changed endpoint (EFAF-9488)
            return MDVPersonalizationRequester
                .request('/pushService/Subscription/email/Service', 'delete', null, [lineId])
                .then(function(response) {
                    return response;
                });
        }
        // ///////////////////////////////////////////////////

        _private.cleanId = function(id) {
            var res = id,
                arr = id.split(':');

            if (arr.length>3) {
                res = arr[0]+':'+arr[1]+':'+arr[3];
            }
            // res = arr[0]+':'+arr[1];
            return res;
        };
        _private.cleanIdWithoutDir = function(id) {
            var res = id,
                arr = id.split(':');
            res = arr[0]+':'+arr[1];
            return res;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.getDefaultConfigOption = function() {
            return null;
        };

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                pt._private = _private;
            }
        });


        return pt;
    }


}());

(function() {
    'use strict';

    angular.module('mng-personalization')
        .factory('mng-personalization.MDVPersonalizationRequester', MDVPersonalizationRequester);

    MDVPersonalizationRequester.$inject = ['mng-util.MDVLog', 'mng-util.MDVException',
        'mng-config.MDVConfig', 'mng-comm.itd.MDVEFARequester'];

    function MDVPersonalizationRequester(MDVLog, MDVException, MDVConfig, MDVEFARequester) {
        var _private = {
                namespace : 'mng-personalization.MDVPersonalizationRequester'
            },
            log = MDVLog.register(_private.namespace),
            pr = {
                request : request
            };

        log.debug('init');

        // ///////////////////////////////////////////////////

        function request(url, requestType, authorization, params, efa, addContentType) {
            var prefix = efa?'MDVEFAGeneral':'MDVPush',
                requester = new MDVEFARequester('mng-comm-itd', prefix, {
                    url : url,
                    requestType : requestType
                }),
                requestConfig = _private.getRequestConfig(authorization, addContentType);

            if (!params) {
                params = {};
            }

            return requester.request(params, null, requestConfig);
        }


        // ///////////////////////////////////////////////////

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.getDefaultConfigOption = function() {
            return null;
        };

        _private.getRequestConfig = function(auth, addContentType) {
            var obj = {
                headers : {
                    'Accept' : 'application/json;odata.metadata=none;IEEE754Compatible=true;charset=utf-8'
                }
            };

            if (addContentType || true) {
                obj.headers['Content-type'] = ' application/json;odata.metadata=none;IEEE754Compatible=true;charset=utf-8';
            }

            if (auth) {
                obj.headers.Authorization = auth;
            }
            return obj;
        };

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                pr._private = _private;
            }
        });


        return pr;
    }


}());

(function() {
    'use strict';

    angular.module('mng-personalization')
        .factory('mng-personalization.MDVPersonalizationRegistration', MDVPersonalizationRegistration);

    MDVPersonalizationRegistration.$inject = ['mng-util.MDVLog', 'mng-util.MDVException',
        'mng-config.MDVConfig', 'mng-personalization.MDVPersonalizationRequester'];

    function MDVPersonalizationRegistration(MDVLog, MDVException, MDVConfig, MDVPersonalizationRequester) {
        var _private = {
                namespace : 'mng-personalization.MDVPersonalizationRegistration',
                registerRequester : null
            },
            log = MDVLog.register(_private.namespace),
            pr = {
                register : register
            };

        log.debug('init');

        // ///////////////////////////////////////////////////

        function register(options) {
            if (!_private.isValidRegistrationInput(options)) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.REGISTRATION_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            log.debug('start register request');

            return MDVPersonalizationRequester
                .request('/Identity/Registry/Register', 'post', null, options)
                .then(function(res) {
                    return res;
                });
        }


        // ///////////////////////////////////////////////////

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.getDefaultConfigOption = function() {
            return null;
        };

        _private.isValidRegistrationInput = function(input) {
            window.savedUser = input;
            console.log('RegistrationInput', input);
            if (!input) {
                return false;
            }
            if (!input.Client) {
                return false;
            }
            if (!input.Name) {
                return false;
            }
            if (!input.Password) {
                return false;
            }
            if (!input.Profile) {
                return false;
            }
            // if (!input.Profile.Email) {
            //     return false;
            // }

            return true;
        };

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                pr._private = _private;
            }
        });

        return pr;
    }


}());

(function() {
    'use strict';

    angular.module('mng-personalization')
        .factory('mng-personalization.MDVPersonalizationProfile', MDVPersonalizationProfile);

    MDVPersonalizationProfile.$inject = ['mng-util.MDVLog', 'mng-util.MDVException',
        'mng-config.MDVConfig', 'mng-personalization.MDVPersonalizationRequester'];

    function MDVPersonalizationProfile(MDVLog, MDVException, MDVConfig, MDVPersonalizationRequester) {
        var _private = {
                namespace : 'mng-personalization.MDVPersonalizationProfile',
                profileRequester : null
            },
            log = MDVLog.register(_private.namespace),
            pp = {
                get : get,
                update : update
            };

        log.debug('init');

        // ///////////////////////////////////////////////////

        function get() {
            log.debug('start getting profile request');

            return MDVPersonalizationRequester
                .request('/Identity/OData/UserProfile', 'get')
                .then(function(response) {
                    if (!response) {
                    // if (!response || !response.value || (response.value.length === 0)) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.NO_SERVICE, {
                            reason : 'Problem on getting profile.'
                        });
                    }
                    return response.value[0];
                });
        }

        function update(options) {
            // if (!profileId) {
            //     throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.PROFILE_INVALID_INPUT, {
            //         reason : 'Invalid Input'
            //     });
            // }

            options = {
                Email: options.NewUsername,
                FirstName : options.FirstName,
                LastName : options.LastName,
                Gender : options.Gender,
                Phone : options.Phone
            };

            log.debug('start update profile request');

            return MDVPersonalizationRequester
                .request('/Identity/OData/UserProfile', 'patch', null, options)
                // .request('/Identity/OData/UserProfile', 'patch', null, options)
                .then(function(response) {
                    if (response && response.error) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.PROFILE_FAILED, {
                            reason : 'Problem on updating profile.'
                        });
                    }
                    return response;
                });
        }


        // ///////////////////////////////////////////////////

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.getDefaultConfigOption = function() {
            return null;
        };

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                pp._private = _private;
            }
        });

        return pp;
    }


}());

(function() {
    'use strict';

    angular.module('mng-personalization')
        .factory('mng-personalization.MDVPersonalizationNotification', MDVPersonalizationNotification);

    MDVPersonalizationNotification.$inject = ['mng-util.MDVLog', 'mng-util.MDVException',
        'mng-config.MDVConfig', 'mng-personalization.MDVPersonalizationRequester'];

    function MDVPersonalizationNotification(MDVLog, MDVException, MDVConfig, MDVPersonalizationRequester) {
        var _private = {
                namespace : 'mng-personalization.MDVPersonalizationNotification',
                profileRequester : null
            },
            log = MDVLog.register(_private.namespace),
            pp = {
                get : get,
                update : update
            };

        log.debug('init');

        // ///////////////////////////////////////////////////

        function get() {
            log.debug('start getting notification request');

            return MDVPersonalizationRequester
                .request('/Personalization/OData/UserNotification', 'get', null, null)
                .then(function(response) {
                    if (!response || !response.value || (response.value.length === 0)) {
                        return null;
                    }
                    return response.value[0];
                });
        }

        function update(profileId, options) {
            if (!profileId) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.PROFILE_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            options = {
                Active : options.Active,
                GenericMessages: options.GenericMessages
            };

            log.debug('start update profile request');

            // Changed endpoint (EFAF-9488)
            return MDVPersonalizationRequester
                .request('/pushService/Registration/email/Profile', 'patch', null, options)
                .then(function(response) {
                    if (response && response.error) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.PROFILE_FAILED, {
                            reason : 'Problem on updating notification.'
                        });
                    }
                    return response;
                });
        }


        // ///////////////////////////////////////////////////

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.getDefaultConfigOption = function() {
            return null;
        };

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                pp._private = _private;
            }
        });

        return pp;
    }


}());

(function() {
    'use strict';

    angular.module('mng-personalization')
        .factory('mng-personalization.MDVPersonalizationLogout', MDVPersonalizationLogout);

    MDVPersonalizationLogout.$inject = ['mng-util.MDVLog', 'mng-util.MDVException',
        'mng-config.MDVConfig', 'mng-personalization.MDVPersonalizationRequester'];

    function MDVPersonalizationLogout(MDVLog, MDVException, MDVConfig, MDVPersonalizationRequester) {
        var _private = {
                namespace : 'mng-personalization.MDVPersonalizationLogout',
                logoutRequester : null
            },
            log = MDVLog.register(_private.namespace),
            pl = {
                logout : logout
            };

        log.debug('init');

        // ///////////////////////////////////////////////////

        function logout() {
            log.debug('start logout request');

            return MDVPersonalizationRequester
                .request('/Identity/Authentication/SignOut', 'post', null)
                .then(function(res) {
                    return res;
                });
        }


        // ///////////////////////////////////////////////////

        _private.isValidRegistrationInput = function(input) {
            if (!input) {
                return false;
            }
            if (!input.Client) {
                return false;
            }
            if (!input.Name) {
                return false;
            }
            if (!input.Password) {
                return false;
            }

            return true;
        };


        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.getDefaultConfigOption = function() {
            return null;
        };

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                pl._private = _private;
            }
        });

        return pl;
    }


}());

(function() {
    'use strict';

    angular.module('mng-personalization')
        .factory('mng-personalization.MDVPersonalizationLogin', MDVPersonalizationLogin);

    MDVPersonalizationLogin.$inject = ['mng-util.MDVLog', 'mng-util.MDVException',
        'mng-config.MDVConfig', 'mng-personalization.MDVPersonalizationRequester'];

    function MDVPersonalizationLogin(MDVLog, MDVException, MDVConfig, MDVPersonalizationRequester) {
        var _private = {
                namespace : 'mng-personalization.MDVPersonalizationLogin',
                loginRequester : null
            },
            log = MDVLog.register(_private.namespace),
            pl = {
                login : login
            };

        log.debug('init');

        // ///////////////////////////////////////////////////

        function login(options) {
            if (!_private.isValidRegistrationInput(options)) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.LOGIN_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            log.debug('start login request');

            return MDVPersonalizationRequester
                .request('/Identity/Authentication/LogIn', 'post', null, options)
                .then(function(res) {
                    return res;
                });
        }


        // ///////////////////////////////////////////////////

        _private.isValidRegistrationInput = function(input) {
            if (!input) {
                return false;
            }
            if (!input.Client) {
                return false;
            }
            if (!input.Name) {
                return false;
            }
            if (!input.Password) {
                return false;
            }

            return true;
        };


        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.getDefaultConfigOption = function() {
            return null;
        };

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                pl._private = _private;
            }
        });

        return pl;
    }


}());

(function() {
    'use strict';

    angular.module('mng-personalization')
        .factory('mng-personalization.MDVPersonalizationLocation', MDVPersonalizationLocation);

    MDVPersonalizationLocation.$inject = ['mng-util.MDVLog', 'mng-util.MDVException',
        'mng-config.MDVConfig', 'mng-personalization.MDVPersonalizationRequester'];

    function MDVPersonalizationLocation(MDVLog, MDVException, MDVConfig, MDVPersonalizationRequester) {
        var _private = {
                namespace : 'mng-personalization.MDVPersonalizationLocation'
            },
            log = MDVLog.register(_private.namespace),
            pl = {
                get : get,
                set : set,
                setWithoutGlID : setWithoutGlID,
                remove : remove
            };

        log.debug('init');

        // ///////////////////////////////////////////////////

        function set(userId, userNotificationId, location) {
            if (!location) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.LOCATION_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }
            // EFAF-9488: change data for use of new endpoint
            var data = [{
                // UserId : userId,
                // UserNotificationId : userNotificationId,
                Name : location.name(),
                Key : location.id(),
                // Usage : '7'
                Type : 7
            }];

            log.debug('start adding Locations');

            // EFAF-9488: Use new endpoint
            return MDVPersonalizationRequester
                .request('/pushService/Subscription/email/Stop', 'post', null, data)
                .then(function(response) {
                    return response;
                });
        }
        // ///////////////////////////////////////////////////

        function setWithoutGlID(userId, userNotificationId, location) {
            if (!location) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.LOCATION_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            // EFAF-9488: change data for use of new endpoint
            var data = [{
                // UserId : userId,
                // UserNotificationId : userNotificationId,
                // Name : location.name(),
                Name : location.asName ? location.asName : location.name(),
                Key : location.properties().stopId,
                // Key : location.id(),
                // Usage : '7'
                Type : 7
            }];

            log.debug('start adding Locations');

            // EFAF-9488: Use new endpoint
            return MDVPersonalizationRequester
                .request('/pushService/Subscription/email/Stop', 'post', null, data)
                .then(function(response) {
                    return response;
                });
        }

        function get(params) {
            log.debug('start getting Locations');

            return MDVPersonalizationRequester
                .request('/Personalization/OData/Point', 'get', null, params)
                .then(function(response) {
                    if (!response || !response.value) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.LOCATION_FAILED, {
                            reason : 'problem on getting locations'
                        });
                    }
                    return response.value;
                });
        }

        function remove(locationId) {
            if (!locationId) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.LOCATION_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            log.debug('start removing Locations');

            return MDVPersonalizationRequester
                .request('/pushService/Subscription/email/Stop', 'delete', null, [locationId])
                .then(function(response) {
                    return response;
                });
        }


        // ///////////////////////////////////////////////////

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.getDefaultConfigOption = function() {
            return null;
        };

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                pl._private = _private;
            }
        });


        return pl;
    }


}());

(function() {
    'use strict';

    angular.module('mng-personalization')
        .factory('mng-personalization.MDVPersonalizationHelper', MDVPersonalizationHelper);

    MDVPersonalizationHelper.$inject = ['$injector', '$q', 'mng-favorite.MDVUserFavorite',
        'mng-favorite.MDVUser', 'mng-util.MDVLog', 'mng-util.MDVException'];

    function MDVPersonalizationHelper($injector, $q, MDVUserFavorite, MDVUser, MDVLog, MDVException) {
        var log = MDVLog.register('mng-common.MDVPersonalizationHelper'),
            _private = {
                user : null,
                loginDeferred : $q.defer(),
                logoutDeferred : $q.defer()
            };

        log.debug('init');


        // TODO add injectors Buffer

        this.login = login;
        this.logout = logout;
        this.register = register;
        this.isLoggedIn = isLoggedIn;
        this.waitForLogin = waitForLogin;
        this.waitForLogout = waitForLogout;
        this.getProfile = getProfile;
        this.updateProfile = updateProfile;
        this.getNotification = getNotification;
        this.updateNotification = updateNotification;
        this.changePassword = changePassword;
        this.sendFeedback = sendFeedback;
        this.activate = activate;
        this.reactivate = reactivate;
        this.deactivate = deactivate;
        this.subscribeByEmail = subscribeByEmail;
        this.getTrip = getTrip;
        this.getTripSupplement = getTripSupplement;
        this.setTrip = setTrip;
        this.removeTrip = removeTrip;
        this.getLocation = getLocation;
        this.setLocation = setLocation;
        this.setLocationWithoutGlID = setLocationWithoutGlID;
        this.removeLocation = removeLocation;
        this.getTransportation = getTransportation;
        this.setTransportation = setTransportation;
        this.removeTransportation = removeTransportation;
        this.resetPasswordByMail = resetPasswordByMail;
        this.resetPasswordByUsername = resetPasswordByUsername;
        this.initiatePasswordReset = initiatePasswordReset;
        this.passwordReset = passwordReset;

        function login(options) {
            if (!options || ((!options.Name || !options.Password || !options.Client))) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason: 'Invalid Input'
                });
            }

            var LoginFactory = $injector.get('mng-personalization.MDVPersonalizationLogin'),
                userObj,
                user;

            return LoginFactory
                .login(options)
                .then(function(res) {
                    if (res.Succeeded) {
                        return getProfile()
                            .then(function(tokenObj) {
                                userObj = {
                                    userId : tokenObj ? tokenObj.Id : res.SubjectId,
                                    username : options.Name,
                                    tokenType : tokenObj ? tokenObj.token_type : '',
                                    isRemembered : options.isRemembered || ''
                                };
                                user = new MDVUser(userObj);

                                return MDVUserFavorite.remove()
                                    .then(function() {
                                        if (options.isRemembered) {
                                            return MDVUserFavorite.set(userObj)
                                                .then(function() {
                                                    _private.loginDeferred.notify(user);
                                                    return user;
                                                });
                                        } else {
                                            return MDVUserFavorite.set(userObj)
                                                .then(function() {
                                                    _private.loginDeferred.notify(user);
                                                    return user;
                                                });
                                        }
                                    });
                            });
                    }
                    console.log('no token', options);
                    return null;
                });
        }

        function register(options) {
            if (!options || !options.Name || !options.Password || !options.Client  ||
                !options.Profile || !options.Profile.Email ) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            var RegisterFactory = $injector.get('mng-personalization.MDVPersonalizationRegistration');

            return RegisterFactory.register(options);
        }

        function waitForLogin() {
            return _private.loginDeferred.promise;
        }

        function waitForLogout() {
            return _private.logoutDeferred.promise;
        }

        function isLoggedIn() {
            return MDVUserFavorite.get()
                .then(function(res) {
                    if (res && (res.length>0)) {
                        return res[0];
                    } else {
                        throw new MDVException(
                            MDVException.keys.MNG__PERSONALIZATION.LOGGED_IN_USER_NOT_FOUND, {
                                reason : 'Invalid Input'
                            });
                    }
                });
            }

        function resetPasswordByUsername(options) {
            if (!options || !options.Name) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            var ForgottenFactory = $injector.get('mng-personalization.MDVPersonalizationForgotten');

            return ForgottenFactory.resetByUsername(options);
        }

        function resetPasswordByMail(options) {
            if (!options || !options.Email) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            var ForgottenFactory = $injector.get('mng-personalization.MDVPersonalizationForgotten');

            return ForgottenFactory.resetByMail(options);
        }

        function initiatePasswordReset(options) {
            if (!options || !options.Email || !options.Client) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            var ForgottenFactory = $injector.get('mng-personalization.MDVPersonalizationForgotten');

            return ForgottenFactory.initiatePasswordReset(options);
        }

        function passwordReset(options) {
            if (!options || !options.ConfirmationCode || !options.NewPassword) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            var ForgottenFactory = $injector.get('mng-personalization.MDVPersonalizationForgotten');

            return ForgottenFactory.passwordReset(options);
        }

        function sendFeedback(options) {
            if (!options || !options.Email || !options.Feedback) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            var ForgottenFactory = $injector.get('mng-personalization.MDVPersonalizationForgotten');

            return ForgottenFactory.sendFeedback(options);
        }

        function logout() {
            return MDVUserFavorite.remove()
                .then(function(res) {
                    var LogoutFactory = $injector.get('mng-personalization.MDVPersonalizationLogout');
                    _private.logoutDeferred.notify(res);
                    _private.user = null;
                    return LogoutFactory.logout();
                });

        }

        function getProfile() {
            var ProfileFactory = $injector.get('mng-personalization.MDVPersonalizationProfile');
            return ProfileFactory.get();
        }

        function updateProfile(options) {
            // if (!profileId) {
            //     throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
            //         reason : 'Invalid Input'
            //     });
            // }
            return isLoggedIn()
                .then(function(user) {
                    var ProfileFactory = $injector.get('mng-personalization.MDVPersonalizationProfile');

                    return ProfileFactory.update(options);
                });

        }

        function getNotification() {
            return isLoggedIn()
                .then(function(user) {
                    var NotificationFactory = $injector.get('mng-personalization.MDVPersonalizationNotification');

                    return NotificationFactory.get()
                            .then(function(userNotification) {
                                var userObj = user.toJSON();

                                userObj.userNotificationId = userNotification.Id;

                                return MDVUserFavorite.remove()
                                    .then(function() {
                                        return MDVUserFavorite.set(userObj)
                                            .then(function() {
                                                return userNotification;
                                            });
                                    });
                            });
                });
        }

        function updateNotification(profileId, options) {
            if (!profileId) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }
            return isLoggedIn()
                .then(function(user) {
                    var NotificationFactory = $injector.get('mng-personalization.MDVPersonalizationNotification');

                    return NotificationFactory.update(profileId, options);
                });

        }

        function changePassword(options) {
            if (!options || !options.Password || !options.NewPassword) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            return isLoggedIn()
                .then(function(user) {
                    var ForgottenFactory = $injector.get('mng-personalization.MDVPersonalizationForgotten');

                    options.Name = user.username();
                    return ForgottenFactory.changePassword(options);
                });

        }

        // ///////////////////////////////////////////////////
        function activate(token) {
            if (!token) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }
            var ActivateFactory = $injector.get('mng-personalization.MDVPersonalizationActivate');

            return ActivateFactory.activate(token);
        }

        function reactivate(options) {
            if (!options || !options.Name){
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            var ActivateFactory = $injector.get('mng-personalization.MDVPersonalizationActivate');
            return ActivateFactory.reactivate(options)
        }

        function deactivate(options) {
            if (!options || !options.Name || !options.Password) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }
            return isLoggedIn()
                .then(function() {
                    var ActivateFactory = $injector.get('mng-personalization.MDVPersonalizationActivate');

                    return ActivateFactory.deactivate(options);
                });
        }

        // ///////////////////////////////////////////////////
        function subscribeByEmail(options, channelName) {
            if (!options || !channelName) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            return isLoggedIn()
                .then(function(user) {
                    var ForgottenFactory = $injector.get('mng-personalization.MDVPersonalizationForgotten');

                    return ForgottenFactory.subscribeByEmail(options, channelName);
                });

        }

        function getLocation(options) {
            return isLoggedIn()
                .then(function(user) {
                    var LocationFactory = $injector.get('mng-personalization.MDVPersonalizationLocation');

                    return LocationFactory.get(options);
                });
        }

        // ///////////////////////////////////////////////////
        function setLocation(location) {
            if (!location) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }
            return isLoggedIn()
                .then(function(user) {
                    var LocationFactory = $injector.get('mng-personalization.MDVPersonalizationLocation');

                    return LocationFactory.set(user.userId(), user.userNotificationId(), location);
                });
        }
        // ///////////////////////////////////////////////////
        function setLocationWithoutGlID(location) {
            if (!location) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }
            return isLoggedIn()
                .then(function(user) {
                    var LocationFactory = $injector.get('mng-personalization.MDVPersonalizationLocation');

                    return LocationFactory.setWithoutGlID(user.userId(), user.userNotificationId(), location);
                });
        }

        // ///////////////////////////////////////////////////
        function removeLocation(locationId) {
            if (!locationId) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }
            return isLoggedIn()
                .then(function(user) {
                    var LocationFactory = $injector.get('mng-personalization.MDVPersonalizationLocation');

                    return LocationFactory.remove(locationId);
                });
        }


        // ///////////////////////////////////////////////////
        function getTrip(options) {
            return isLoggedIn()
                .then(function(user) {
                    var TripFactory = $injector.get('mng-personalization.MDVPersonalizationTrip');

                    return TripFactory.get(options);
                });
        }

        function getTripSupplement(options) {
            return isLoggedIn()
                .then(function(user) {
                    var TripFactory = $injector.get('mng-personalization.MDVPersonalizationTrip');

                    return TripFactory.getSupplement(options);
                });
        }

        // ///////////////////////////////////////////////////
        function setTrip(trip) {
            if (!trip) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }
            return isLoggedIn()
                .then(function(user) {
                    var TripFactory = $injector.get('mng-personalization.MDVPersonalizationTrip');

                    return TripFactory.set(user.userId(), trip);
                });
        }

        // ///////////////////////////////////////////////////
        function removeTrip(tripId) {
            if (!tripId) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }
            return isLoggedIn()
                .then(function(user) {
                    var TripFactory = $injector.get('mng-personalization.MDVPersonalizationTrip');

                    return TripFactory.remove(tripId);
                });
        }

        // ///////////////////////////////////////////////////
        function getTransportation(options) {
            if (!options) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }
            return isLoggedIn()
                .then(function(user) {
                    var TransportationFactory =
                        $injector.get('mng-personalization.MDVPersonalizationTransportation');

                    return TransportationFactory.get(options);
                });
        }
        // ///////////////////////////////////////////////////
        function setTransportation(transportation) {
            if (!transportation) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }
            return isLoggedIn()
                .then(function(user) {
                    var TransportationFactory =
                        $injector.get('mng-personalization.MDVPersonalizationTransportation');

                    return TransportationFactory.set(user.userId(), user.userNotificationId(), transportation);
                });
        }

        // ///////////////////////////////////////////////////
        function removeTransportation(lineId) {
            if (!lineId) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.HELPER_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }
            return isLoggedIn()
                .then(function(user) {
                    var TransportationFactory =
                        $injector.get('mng-personalization.MDVPersonalizationTransportation');
                    return TransportationFactory.remove(lineId);
                });
        }

        return this;
    }
}());

(function() {
    'use strict';

    angular.module('mng-personalization')
        .factory('mng-personalization.MDVPersonalizationForgotten', MDVPersonalizationForgotten);

    MDVPersonalizationForgotten.$inject = ['$base64', 'mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-util.MDVException', 'mng-personalization.MDVPersonalizationRequester'];

    function MDVPersonalizationForgotten($base64, MDVLog, MDVConfig, MDVException,
            MDVPersonalizationRequester) {
        var _private = {
                forgottenRequester : null,
                namespace : 'mng-personalization.MDVPersonalizationForgotten'
            },
            log = MDVLog.register(_private.namespace),
            pf = {
                resetByUsername : resetByUsername,
                resetByMail : resetByMail,
                changePassword : changePassword,
                sendFeedback : sendFeedback,
                subscribeByEmail : subscribeByEmail,
                initiatePasswordReset: initiatePasswordReset,
                passwordReset: passwordReset
            };

        log.debug('init');

        // ///////////////////////////////////////////////////
        function subscribeByEmail(options, channelName) {
            if (!options) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.PASSWORD_CHANGE_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            log.debug('start password change request');

            return MDVPersonalizationRequester
                .request('/Personalization/OData/NotificationChannel', 'get', null)
                .then(function(response) {
                    if (!response || !response.value) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.NO_SERVICE, {
                            reason : 'Problem on changing password.'
                        });
                    }

                    var filteredChannels = response.value.filter(function(ch) {
                        return ch.ChannelName === channelName;
                    });

                    if (filteredChannels.length === 0) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.NO_SERVICE, {
                            reason : 'Problem on changing password.'
                        });
                    }
                    // Changed endpoint (EFAF-9488)
                    return MDVPersonalizationRequester
                        .request('/pushService/Registration/email/Profile', 'post', null, options)
                        .then(function(response2) {
                            if (!response2) {
                                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.NO_SERVICE, {
                                    reason : 'Problem on changing password.'
                                });
                            }
                            return MDVPersonalizationRequester
                                .request('/pushService/Registration/email/Profile', 'get', null, options)
                                .then(function(response3) {
                                    if (!response3) {
                                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.NO_SERVICE, {
                                            reason : 'Problem on changing password.'
                                        });
                                    }
                                    return response3;
                                });
                        });
                });
        }

        // ///////////////////////////////////////////////////
        function changePassword(options) {
            if (!options || !options.Password || !options.NewPassword) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.PASSWORD_CHANGE_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            log.debug('start password change request');

            return MDVPersonalizationRequester
                .request('/Identity/Registry/ChangePassword', 'post', null, options)
                .then(function(response) {
                    if (!response || response.StatusCode) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.NO_SERVICE, {
                            reason : 'Problem on changing password.'
                        });
                    }

                    return response;
                });
        }

        // ///////////////////////////////////////////////////
        function initiatePasswordReset(options) {
            if (!options || !options.Email || !options.Client) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.PASSWORD_CHANGE_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            log.debug('start initiate password reset');

            return MDVPersonalizationRequester
                .request('/Identity/Registry/InitiatePasswordReset', 'post', null, options);
        }

        // ///////////////////////////////////////////////////
        function passwordReset(options) {
            if (!options || !options.ConfirmationCode || !options.NewPassword) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.PASSWORD_CHANGE_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            log.debug('start initiate password reset');

            return MDVPersonalizationRequester
                .request('/Identity/Registry/PasswordReset', 'post', null, options);
        }


        // ///////////////////////////////////////////////////
        function resetByUsername(options) {
            if (!_private.isValidForgottenInput(options)) {
                throw new MDVException(
                    MDVException.keys.MNG__PERSONALIZATION.PASSWORD_RESETTING_INVALID_INPUT, {
                        reason : 'Invalid Input'
                    });
            }

            log.debug('start password reset request');

            return MDVPersonalizationRequester
                .request('/Identity/Registry/SendPassword', 'get', null, options)
                .then(function(response) {
                    if (!response) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.NO_SERVICE, {
                            reason : 'Problem on resetting password.'
                        });
                    }
                    return response;
                });
        }


        // ///////////////////////////////////////////////////
        function resetByMail(options) {
            if (!options || !options.Email) {
                throw new MDVException(
                    MDVException.keys.MNG__PERSONALIZATION.PASSWORD_RESETTING_INVALID_INPUT, {
                        reason : 'Problem on resetting password.'
                    });
            }

            var opts = {
                outputFormat : 'json',
                itdMPxx_Email : options.Email,
                command : 'feedbackMail',
                feedbackType : 'FeedbackEmailAddress',
                mailId : 1,
                emailSubject : 'Von Formular Benutzername und Passwort vergessen'
            };

            if (options.FirstName) {
                opts.itdMPxx_Vorname = options.FirstName;
            }

            if (options.Name) {
                opts.itdMPxx_Nachname = options.Name;
            }

            return MDVPersonalizationRequester.request('/XML_REQUEST', 'get', null, opts, true)
                .then(function(response) {
                    if (!response) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.NO_SERVICE, {
                            reason : 'Problem on resetting by email.'
                        });
                    }

                    return response;
                });
        }

        // ///////////////////////////////////////////////////
        function sendFeedback(options) {
            if (!options || !options.Email || !options.Feedback) {
                throw new MDVException(
                    MDVException.keys.MNG__PERSONALIZATION.PASSWORD_RESETTING_INVALID_INPUT, {
                        reason : 'Problem on sending feedback.'
                    });
            }

            var opts = {
                command : 'feedbackMail',
                // URLMailAFriend : 'JourneyPLannerURL|...',
                feedbackLink : $base64.encode(options.FeedbackLink),
                itdMPxx_1 : 'Email+Address|' + options.Email,
                itdMPxx_4 : 'Problem|' + options.Feedback,
                emailSubject : 'Von Formular Problem Melden'
            };

            if (options.feedbackEmailAddress) {
                opts.feedbackEmailAddress = options.feedbackEmailAddress;
            }

            return MDVPersonalizationRequester
                .request('/XML_REQUEST', 'get', null, opts, true)
                .then(function(response) {
                    if (!response) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.NO_SERVICE, {
                            reason : 'Problem on sending Feedback.'
                        });
                    }

                    return response;
                });
        }


        // ///////////////////////////////////////////////////

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.getDefaultConfigOption = function() {
            return null;
        };

        _private.isValidForgottenInput = function(input, isChangePassword) {
            if (!input) {
                return false;
            }

            if (!input.Name) {
                return false;
            }

            if (isChangePassword && !input.NewPassword) {
                return false;
            }

            if (isChangePassword && !input.OldPassword) {
                return false;
            }


            return true;
        };

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                pf._private = _private;
            }
        });

        return pf;
    }


}());

(function() {
    'use strict';

    angular.module('mng-personalization')
        .factory('mng-personalization.MDVPersonalizationActivate', MDVPersonalizationActivate);

    MDVPersonalizationActivate.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-util.MDVException',
        'mng-personalization.MDVPersonalizationRequester'];

    function MDVPersonalizationActivate(MDVLog, MDVConfig, MDVException, MDVPersonalizationRequester) {
        var _private = {
                namespace : 'mng-personalization.MDVPersonalizationActivate',
                activateRequester : null
            },
            log = MDVLog.register(_private.namespace),
            pa = {
                activate : activate,
                deactivate : deactivate,
                reactivate : reactivate,
            };

        log.debug('init');

        // ///////////////////////////////////////////////////
        // !!!! NOT TESTED YET
        function activate(token) {
            if (!_private.isValidActivationToken(token)) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.ACTIVATION_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            log.debug('start activation request');

            return MDVPersonalizationRequester
                .request('/Identity/Registry/Activate', 'post', null, {
                    'ConfirmationCode': token
                })
                .then(function(response) {
                    if (!response) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.ACTIVATION_FAILED, {
                            reason : 'Problem on activating profile.'
                        });
                    }
                    return response;
                });
        }
        function reactivate(options) {

            log.debug('start activation request');

            return MDVPersonalizationRequester
                .request('/Identity/Registry/RequestActivationCode', 'post', null, options)
                .then(function(response) {
                    if (!response) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.REACTIVATION_FAILED, {
                            reason : 'Problem on reactivating profile.'
                        });
                    }
                    return response;
                });
        }

        function deactivate(options) {
            if (!options || !options.Name || !options.Password) {
                throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.ACTIVATION_INVALID_INPUT, {
                    reason : 'Invalid Input'
                });
            }

            log.debug('start activation request');

            return MDVPersonalizationRequester
                .request('/Identity/Registry/Delete', 'post', null, options)
                .then(function(response) {
                    if (!response || response.StatusCode) {
                        throw new MDVException(MDVException.keys.MNG__PERSONALIZATION.DEACTIVATION_FAILED, {
                            reason : 'Problem on deactivating profile.'
                        });
                    }

                    return response;
                });
        }
        // ///////////////////////////////////////////////////

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.getDefaultConfigOption = function() {
            return null;
        };

        _private.isValidActivationToken = function(input) {
            // TODO what kind of token is it ?
            if (!input) {
                return false;
            }

            return true;
        };

        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                pa._private = _private;
            }
        });

        return pa;
    }


}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc overview
     * @name mng-persistence
     * @module mng-persistence
     * @requires pouchdb (<a href="https://github.com/angular-pouchdb/angular-pouchdb"
     * target="_blanck">angular-pouchdb</a>)
     * @requires mng-config
     * @requires mng-util
     *
     * @description
     * # mng-persistence (event handling)
     * This module describes an interface to persist json files to a pouchdb database.
     *
     * ## General usage
     * ```js
     * // inject mng-persistence - components only
     * angular.module('your.module', ['mng-persistence']);
     * ```
     *
     * ## components
     * The following list gives a short overview of the available components within this module.
     * For further details, please refer to the components themselves.
     *
     * ### {@link mng-persistence.service:MDVPersistenceHandler MDVPersistenceHandler}
     * The `MDVPersistenceHandler` is a wrapper for the PouchDb library used to manage user data
     * in client-side.
     * For a database given on his instantiation, this Service wrap almost all the pouchDb
     * functionalities.
     * <p class="info">Note that `MDVPersistenceHandler` is an asynchronous Service supporting
     * <a href="https://www.promisejs.org/">promises</a>.</p>
     *
     * ### {@link mng-persistence.service:MDVPersistenceBuffer MDVPersistenceBuffer}
     * This singleton service is used as temporary buffer for the data loaded from the Database
     *
     * ### {@link mng-persistence.factory:MDVPersistenceFactory MDVPersistenceFactory}
     *  This Factory returns an object containing the additional informations needed to create
     * a Persistence object.
    */
    angular.module('mng-persistence', ['pouchdb', 'mng-util', 'mng-config']);
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc object
     * @name mng-persistence.factory:MDVPersistenceFactory
     * @module mng-persistence
     * @requires mng-util.service:MDVLog
     * @description
     * This Factory returns an object containing the additional informations needed to create a
     * Persistence object.
     * It returns a list of propertys that will be merged to an internal MDV-Model (like MDVLocation)
     * then simply saved to the Database.
     * <p class="info">Usually this object will be packed to the '<i>persistence</i>' properperty
     * of the Model.</p>
     **/

    angular.module('mng-persistence')
        .factory('mng-persistence.MDVPersistenceFactory', MDVPersistenceFactory);

    MDVPersistenceFactory.$inject = ['mng-util.MDVLog', 'mng-util.MDVException'];

    function MDVPersistenceFactory(MDVLog, MDVException) {
        var log = MDVLog.register('mng-persistence.MDVPersistenceFactory'),
            vm = this,

            constructor = function(dbName) {
                return {
                    _id : createMdvDocId(dbName),
                    created : created(),
                    modified : modified(),
                    isPersisted : isPersisted()
                };
            };

        log.debug('initialize');

        function isPersisted() {
            return true;
        }

        /**
          * @private
          * @ngdoc method
          * @name createMdvDocId
          * @methodOf mng-persistence.factory:MDVPersistenceFactory
          * @param {String} dbName database name
          * @description Create a new and unique ID for the new saved document.
          * we create our own ID due to the benefits coming from using the primary Index :
          * should sufficient for sorting and searching in the hole database.
          * <p class="info">The ID is a concatenation between the current Database name and the current timestamp.</p>
          * @returns {String} a unique ID used to save the document.
        **/
        function createMdvDocId(dbName) {
            if (!dbName || dbName.length===0) {
                throw new MDVException('Database Name is Missing');
            }
            return dbName.concat('_').concat(Date.now());
        }
        /**
          * @private
          * @ngdoc method
          * @name created
          * @methodOf mng-persistence.factory:MDVPersistenceFactory
          * @description Initialize the object with the current time
          * @returns {Timestamp} the current timestamp.
        **/
        function created() {
            return (vm.created) ? vm.created : Date.now();
        }
        /**
          * @private
          * @ngdoc method
          * @name modified
          * @methodOf mng-persistence.factory:MDVPersistenceFactory
          * @description Initialize the object with the current time
          * @returns {Timestamp} the current timestamp.
        **/
        function modified() {
            return (vm.modified) ? vm.modified : Date.now();
        }

        return constructor;
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-persistence.service:MDVPersistenceHandler
     * @module mng-persistence
     * @requires mng-util.service:MDVLog
     * @requires mng-config.service:MDVConfig
     * @requires pouchDb (<a href="https://github.com/angular-pouchdb/angular-pouchdb"
     * target="_blanck">angular-pouchdb</a>)
     * @description
     * This service is used to communicate with the <a href="http://pouchdb.com/api.html#overview"
     * target="_blank">PouchDB</a> library using a short AngularJs wrapper named
     * <a href="https://github.com/angular-pouchdb/angular-pouchdb" target="_blank">angular-pouchdb</a>.
     * As a wrapper for this library, this service provide the possibility to create/destroy a database,
     * add/edit/remove a document, add/remove an attachment... as well as managing remote databases,
     * sync them, replicate ...
     * <p><a class="official" href="http://pouchdb.com/api.html#overview"
     * target="_blanck">Please check the official documentation for the PouchDB API</a></p>
     * <b>Notes:</b>
     * <ul>
     *  <li>In IndexedDB and WebSQL, PouchDB will use <span class="warning">_ _pouch_ _</span>
     * to prefix the internal database names.
     * Do not manually create databases with the same prefix.</li>
     *  <li>In the browser, PouchDB prefers IndexedDB, and falls back to WebSQL if IndexedDB is not available.
     * As of 2015, the browser support looks like this:</li>
     *  <img src="/docs/pouchdb_browser_support.png" width="100%" height="100%" />
     * </ul>
     * @example
           <example module="persistenceExample">
            <file name="script.js">
               var myApp = angular.module('persistenceExample', ['mng-persistence']);
                myApp.controller('persistenceCtrl', persistenceCtrl);
                persistenceCtrl.$inject = ['$scope', 'mng-persistence.MDVPersistenceHandler'];
                function persistenceCtrl ($scope, MDVPersistenceHandler) {
                  var dbHandler = MDVPersistenceHandler('persistence_handler_example'),
                      exampleMdvLocation = {
                        "id" : "100523",
                        "type" : "singlehouse",
                        "name" : "Brentwood Dr"
                      };
                  // db infos
                  var getCurrentDbInfos = function () {
                    dbHandler.currentDbInfos.then(function(res){
                      $scope.dbInfos = res;
                    });
                  };
                  getCurrentDbInfos();

                  // all docs
                  var getAllDocs = function () {
                    dbHandler.get().then(function (result) {
                      $scope.allDocs = result.rows;
                      if ($scope.allDocs && $scope.allDocs.length>0){
                        $scope.mdvLocation = $scope.allDocs[0].doc;
                      }else{
                        $scope.mdvLocation = exampleMdvLocation;
                      }
                    }).catch(function (err) {
                      $scope.infos = err;
                    });
                  };
                  getAllDocs();

                  // create/open db connection
                  $scope.createDB = function () {
                    dbHandler = MDVPersistenceHandler($scope.newDbName);
                    getCurrentDbInfos();
                  };

                  // create Update Doc
                  $scope.createUpdateDoc = function () {
                    if(!$scope.mdvLocation._id) {
-                      $scope.mdvLocation._id = $scope.dbInfos.db_name.concat(Date.now());
-                    }
                    dbHandler.set($scope.mdvLocation).then(function (response) {
                      $scope.infos = response;
                      $scope.mdvLocation = dbHandler.get(response.id);
                      getAllDocs();
                      getCurrentDbInfos();
                    }).catch(function (err) {
                      $scope.infos = err;
                    });
                  };

                  // remove doc
                  $scope.removeDoc = function () {
                    dbHandler.remove($scope.mdvLocation).then(function (response) {
                      getAllDocs();
                      getCurrentDbInfos();
                    }).catch(function (err) {
                      $scope.infos = err;
                    });
                  };

                };
             </file>
             <file name="index.html">
                <div ng-controller="persistenceCtrl">
                  <table width="100%">
                    <tr>
                      <td>
                        <div class="currentDbInfos">
                          <h1>Current DB infos</h1>
                          <p>Current DB name : {{dbInfos.db_name}}</p>
                          <p>Current DB docs number : {{dbInfos.doc_count}}</p>
                          <p>Current DB sequence number : {{dbInfos.update_seq}}</p>
                        </div>
                      </td>
                      <td style="color: red;">
                        {{infos}}
                      </td>
                    </tr>
                    <tr>
                      <ul ng-show="allDocs">
                        <li ng-repeat="doc in allDocs">{{doc}}</li>
                      </ul>
                    </tr>
                  </table>

                  <table width="100%">
                    <!-- *****************  Create DB  ***************** -->
                    <tr>
                      <td>
                        <small>Create DB</small>
                      </td>
                      <td>
                        <input type="text" placeholder="dbname" ng-model="newDbName"/>
                      </td>
                      <td>
                        <input type="button" value="create DB" ng-disabled="!newDbName" ng-click="createDB()"/>
                      </td>
                    </tr>
                    <!-- *****************  Put / Update DOC  ***************** -->
                    <tr>
                      <td>
                        <small>Put / Update MDVLocation</small>
                      </td>
                      <td>
                        {
                        <table width="100%">
                          <tr>
                            <td>
                              <p>MDVLocation.id</p>
                            </td>
                            <td>
                              <input type="text" ng-model="mdvLocation.id" placeholder="value" />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>MDVLocation.type</p>
                            </td>
                            <td>
                              <input type="text" ng-model="mdvLocation.type" placeholder="value" />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>MDVLocation.name</p>
                            </td>
                            <td>
                              <input type="text" ng-model="mdvLocation.name" placeholder="value" />
                            </td>
                          </tr>
                        </table>
                        }
                      </td>
                      <td>
                        <input type="button" value="Create/ Update MDVLocation" ng-click="createUpdateDoc()"/>
                        <br/>
                        <br/>
                        <input type="button" value="remove MDVLocation" ng-disabled="!mdvLocation._id ||
                         !mdvLocation._rev" ng-click="removeDoc()"/>
                      </td>
                    </tr>
                  </table>
                </div>
             </file>
             <file name="styles.css">
              table {
                    text-align : center;
                  }
                  td , .currentDbInfos {
                    border: 2px solid #fff;
                    vertical-align: middle;
                    padding: 5px;
                  }
                  ul {
                    background: #fff;
                  }
                  ul li {
                    padding : 5px;
                  }
             </file>
           </example>
     */
    angular.module('mng-persistence')
        .service('mng-persistence.MDVPersistenceHandler', MDVPersistenceHandler);

    MDVPersistenceHandler.$inject = ['pouchDB', 'mng-util.MDVLog', 'mng-config.MDVConfig',
                'mng-util.MDVException'];

    function MDVPersistenceHandler(pouchDB, MDVLog, MDVConfig, MDVException) {
        var log = MDVLog.register('mng-persistence.MDVPersistenceHandler'),
            db,
            persistenceObj = {
                get : get,
                set : set,
                remove : remove
            };

        log.debug('initialize');

          /**
          * @public
          * @ngdoc method
          * @name get
          * @methodOf mng-persistence.service:MDVPersistenceHandler
          * @description get one/multiple or all documents
          *   <pre>persistenceHandler.get() // return all documents</pre>
          *   <pre>persistenceHandler.get('1') // return document with id '1'</pre>
          *   <pre>persistenceHandler.get(['1', '2']) // return documents with id '1' and '2'</pre>
          * @param {String} dbName database name,
          * @param {Object} persistenceObjectsIds can be a document Id,
          * an array of documents Ids or null.
          * @param {Object} options the options needed to overwrite the default method options.
          * @returns {Object} promise.
          **/
        function get(dbName, persistenceObjectsIds, options) {
            // create a database or open an existing one
            db = createDb(dbName, options);
            // 1) we check if we want to fetch multiple documents
            if (angular.isArray(persistenceObjectsIds) && persistenceObjectsIds.length>0) {
              // add the searched keys to the options
                options.keys = persistenceObjectsIds;
            // 2) we check if we want to fetch only one document
            } else if (persistenceObjectsIds && (typeof persistenceObjectsIds === 'string')) {
              // we have one ID as String
                options.keys = [].push(persistenceObjectsIds);
            }
            // 3) persistenceObjectsIds is empty => get all documents
            return getAllDocs(dbName, options);
        }

          /**
          * @public
          * @ngdoc method
          * @name set
          * @methodOf mng-persistence.service:MDVPersistenceHandler
          * @description add/update one or multiple documents to/from the Database.
          *   <pre>persistenceHandler.set({'_id':'1'}) // add/update document with id '1'</pre>
          *   <pre>persistenceHandler.get([{'_id':'1'}, {'_id':'2'}]) // add/update documents with id '1' and '2'</pre>
          * @param {String} dbName database name,
          * @param {Object} persistenceObjects can be one or multiple documents.
          * @param {Object} options the options needed to overwrite the default method options.
          * @returns {Object} promise.
          **/
        function set(dbName, persistenceObjects, options) {
            // create a database or open an existing one
            db = createDb(dbName, options);
            var toSaveArr = [],
                idIsMissing = false;

            if (angular.isArray(persistenceObjects) && persistenceObjects.length>0) {
                toSaveArr = persistenceObjects;
            } else if (persistenceObjects) {
                toSaveArr.push(persistenceObjects);
            }

            // we dont allow pouchDb to generate our document ids
            // check if one document id is missing, yes? throw error
            angular.forEach(toSaveArr, function(persistenceObject) {
                if (!persistenceObject._id || (persistenceObject._id === '')) {
                    idIsMissing = true;
                }
            });

            if (idIsMissing) {
                throw new MDVException('One Document Id was missing.');
            }

            return bulkDocs(toSaveArr, options);
        }

          /**
          * @public
          * @ngdoc method
          * @name remove
          * @methodOf mng-persistence.service:MDVPersistenceHandler
          * @description remove one/multiple or all documents from the database.
          *   <pre>persistenceHandler.remove() // remove all documents</pre>
          *   <pre>persistenceHandler.remove({'_id':'1'}) // remove document with id '1'</pre>
          *   <pre>persistenceHandler.remove([{'_id':'1'}, {'_id':'2'}]) // remove documents with id '1' and '2'</pre>
          * @param {String} dbName database name,
          * @param {Object} persistenceObjects can be one or multiple documents.
          * @param {Object} options the options needed to overwrite the default method options.
          * @returns {Object} promise.
          **/
        function remove(dbName, persistenceObjects, options) {
            // create a database or open an existing one
            db = createDb(dbName, options);
            var toRemoveArr = [],
                idIsMissing = false;

            if (angular.isArray(persistenceObjects) && persistenceObjects.length>0) {
                toRemoveArr = persistenceObjects;
            } else if (persistenceObjects && (typeof persistenceObjects === 'string')) {
                toRemoveArr.push(persistenceObjects);
            } else {
                if (options && options.dropDB) {
                    return db.destroy();

                }
                return getAllDocs(dbName).then(function(result) {
                    if (result.rows && result.rows.length>0) {
                        angular.forEach(result.rows, function(row) {
                            toRemoveArr.push(row.doc);
                        });
                        return bulkDocs(toRemoveArr, true, options);
                    }
                });
            }

            // we dont allow pouchDb to generate our document ids
            // check if one document id is missing, yes? throw error
            angular.forEach(toRemoveArr, function(persistenceObject) {
                if (!persistenceObject._id || (persistenceObject._id === '')) {
                    idIsMissing = true;
                }
            });

            if (idIsMissing) {
                throw new MDVException('One Document Id was missing.');
            }

              // remove only some documents
            return bulkDocs(toRemoveArr, true, options);
        }


          /** ************************* PouchDb Methods : private methods ****************************/


          /**
          * @private
          * @name createMdvDocId
          * @description Create a new and unique ID for the new saved document.
          * we create our own ID due to the benefits coming from using the primary Index :
          * should sufficient for sorting and searching in the hole database.
          * <p class="warning">Note that this function should not be called hier: the DocumentId should be
          * created with his own document.</p>
          * <p class="info">The ID is a concatenation between the current Database name and the current timestamp.</p>
          * @param {String} dbName database name.
          * @returns {String} a unique ID used to save the document.
          **/
        //  function createMdvDocId(dbName) {
        //      return dbName.concat('_').concat(Date.now());
        //  }

          /**
          * @private
          * @name updateOptions
          * @description Overwrite the default Options coming from the Config.
          * @param {Object} configOptions the default options.
          * @param {Object} newOptions new options.
          * @returns {Object} merged options object.
          **/
        function updateOptions(configOptions, newOptions) {
            if (!configOptions && !newOptions) {
                return {};
            }
            if (!newOptions) {
                return configOptions;
            }
            if (!configOptions) {
                return newOptions;
            }
            return angular.extend(configOptions, newOptions);
        }


        /**
          * @private
          * @name createDb
          * @description This method creates a database or opens an existing one.
          * <a class="official" href="http://pouchdb.com/api.html#create_database"
          * target="_blank">Official Documentation</a>
          *
          * @param {String} dbName the name of the database to create/open.
          * @param {Object} options the options needed to overwrite the default method options.
          * @param {Boolean} options.auto_compaction This turns on auto compaction (@see compactDb).
          * @param {String} options.adapter specify an adapter to use
          * ['idb', 'leveldb', 'websql', 'http'] default is 'idb'.
          * @param {Integer} options.revs_limit Specify how many old revisions we keep track.
          * @param {String} options.storage Specifies whether you want to use 'persistent'
          * or 'temporary' storage. (Only for Indexed-DB Storage).
          * @returns {Object} a new PouchDb instance.
          **/
        function createDb(dbName, options) {
            options = updateOptions(MDVConfig.getValue('mng-persistence.options.createDb'), options);
            db = pouchDB(dbName, options);
            return db;
        }
          /**
          * @private
          * @name destroyDb
          * @description Delete the database
          * <a class="official" href="http://pouchdb.com/api.html#delete_database"
          * target="_blank">Official Documentation</a>
          * <p class="warning">Note that this has no impact on other replicated databases.</p>
          * @param {String} dbName the name of the database to destroy.
          * @param {Object} options the options needed to overwrite the default method options.
          * @returns {Object} promise.
          **/
        //  function destroyDb(dbName, options) {
        //      return pouchDB(dbName).destroy(options);
        //  }
          /**
          * @private
          * @name createUpdateDoc
          *
          * @description Create a new document, or update an existing one.
          * <a class="official" href="http://pouchdb.com/api.html#create_document"
          * target="_blank">Official Documentation</a>
          * this method use 'PouchDB.put()'-Method to edit an existing doc,
          * or to create a new one after injecting a new unique ID.
          * <p class="warning">If the document already exists, you must specify its revision _rev,
          * otherwise a conflict will occur.</p>
          * Please check your doc attributes names :
          * <a href="http://wiki.apache.org/couchdb/HTTP_Document_API#Special_Fields" target="_blank">
          * restrictions on valid property names of the documents</a>
          * @param {Object} doc the object to create / edit.
          * @param {Object} options the options needed to overwrite the default method options.
          * @returns {Object} promise.
          **/
        //  function createUpdateDoc(doc, options) {
        //      if (!doc._id) {
        //          // we dont have _id => create new mdvDocId
        //          doc._id = createMdvDocId();
        //          return db.put(doc, options);
        //        }
        //      // the doc have _id => we can update the doc
        //      return db.put(doc, options);
        //  }
          /**
          * @private
          * @name getDoc
          *
          * @description Fetch a document specified by documentId
          * <a class="official" href="http://pouchdb.com/api.html#fetch_document"
          * target="_blank">Official Documentation</a>
          * @param {String} documentId the ID of the document to fetch.
          * @param {Object} options the options needed to overwrite the default method options.
          * @returns {Object} promise.
          **/
        //  function getDoc(documentId, options) {
        //      options = updateOptions(MDVConfig.getValue('mng-persistence.options.getDoc'), options);
        //      return db.get(documentId, options);
        //  }
          /**
          * @private
          * @name removeDoc
          *
          * @description Delete a document
          * <a class="official" href="http://pouchdb.com/api.html#delete_document"
          * target="_blank">Official Documentation</a>
          * @param {Object} doc the document to delete.
          * <p class="warning">doc is required to be a document with at least an _id and a _rev property.</p>
          * @param {Object} options the options needed to overwrite the default method options.
          * @returns {Object} promise.
          **/
        //  function removeDoc(doc, options) {
        //      return db.remove(doc, options);
        //  }

          /**
          * @private
          * @name bulkDocs
          * @methodOf mng-persistence.service:MDVPersistenceHandler
          * @description Create, update or delete multiple documents.
          * <a class="official" href="http://pouchdb.com/api.html#batch_create"
          * target="_blank">Official Documentation</a>
          * <ul>
          * <li><p class="warning">Note that bulkDocs() is not transactional,
          * and that you may get back a mixed array of errors/non-errors.</p></li>
          * <li><p class="warning">To update existing docs the _id and _rev are required.</p></li>
          * </ul>
          * @param {Object[]} docs is an array of documents.
          * @param {Boolean} toDelete is a boolean to tell if we want delete all docs.
          * @param {Object} options the options needed to overwrite the default method options.
          * @param {Boolean} options.include_docs Include the document itself in each row in the doc field.
          * @returns {Object} promise.
          **/
        function bulkDocs(docs, toDelete, options) {
            if (toDelete) {
                for (var i=0; i<docs.length; i += 1) {
                    docs[i]._deleted = true;
                }
            }
            return db.bulkDocs(docs, options);
        }
          /**
          * @private
          * @name getAllDocs
          *
          * @description Fetch multiple documents, indexed and sorted by the _id
          * (will be useful if we create our own ids).
          * <a class="official" href="http://pouchdb.com/api.html#batch_fetch"
          * target="_blank">Official Documentation</a>
          * <p class="info">We have to specifie the prefix to get only the document object, and ignore
          * the saved secondary index view.</p>
          * @param {String} dbName database name
          * @param {Object} options the options needed to overwrite the default method options.
          * @param {Boolean} options.include_docs Include the document itself in each row in the doc field.
          * @param {Integer} options.limit Maximum number of documents to return.
          * @param {String} options.key Only return documents with IDs matching this string key.
          * @param {String[]} options.keys Array of string keys to fetch in a single shot.
          * @returns {Object} promise.
          **/
        function getAllDocs(dbName, options) {
            options = updateOptions(MDVConfig.getValue('mng-persistence.options.getAllDocs'), options);
            if (!options) {
                options = {};
            }
            options.startkey = dbName;
            options.endkey = dbName.concat('\uffff');
            return db.allDocs(options);
        }
          // *
          // * @private
          // * @name getDbChanges
          // *
          // * @description Listen to current database changes.
          // * <a class="official" href="http://pouchdb.com/api.html#changes"
          // * target="_blank">Official Documentation</a>
          // * @param {Object} options the options needed to overwrite the default method options.
          // * @param {Boolean} options.live Will emit change events for all future changes until cancelled.
          // * @returns {Object} an object with the method cancel(), which you call if you don’t
          // * want to listen to new changes anymore.
          // *
        //  function getDbChanges(options) {
        //      options = updateOptions(MDVConfig.getValue('mng-persistence.options.getDbChanges'), options);
        //      return db.changes(options);
        //  }
          // *
          // * @private
          // * @name putAttachment
          // *
          // * @description Attaches a binary object to a document.
          // * <a class="official" href="http://pouchdb.com/api.html#save_attachment"
          // * target="_blank">Official Documentation</a>
          // * @param {String} docId the document to save the attachement in.
          // * @param {String} attachmentId the attachment that should be changed.
          // * @param {Object} attachment the attachment object
          // * @param {String} type the type of the attachment (Example: 'text/plain')
          // * @returns {Object} promise.
          // *
        //  function putAttachment(docId, attachmentId, attachment, type) {
        //      return db.putAttachment(docId, attachmentId, attachment, type);
        //  }

          // *
          // * @private
          // * @name getAttachment
          // *
          // * @description Get attachment data.
          // * <a class="official" href="http://pouchdb.com/api.html#get_attachment"
          // * target="_blank">Official Documentation</a>
          // * @param {String} docId the document that contains the attachment.
          // * @param {String} attachmentId the attachment searched for.
          // * @param {Object} options the options needed to overwrite the default method options.
          // * @returns {Object} promise.
          // *
        //  function getAttachment(docId, attachmentId, options) {
        //      options = updateOptions(MDVConfig.getValue('mng-persistence.options.getAttachment'), options);
        //      return db.getAttachment(docId, attachmentId, options);
        //  }

          // *
          // * @private
          // * @name removeAttachment
          // *
          // * @description Delete an attachment from a doc. You must supply the _rev of the existing doc.
          // * <a class="official" href="http://pouchdb.com/api.html#delete_attachment"
          // * target="_blank">Official Documentation</a>
          // * @param {String} docId the document that contains the attachment.
          // * @param {String} attachmentId the attachment that should be removed.
          // * @param {String} rev the desired document revesion that should be updated.
          // * @param {Object} options the options needed to overwrite the default method options.
          // * @returns {Object} promise.
          // *
        //  function removeAttachment(doc, attachmentId, options) {
        //      return db.removeAttachment(doc._id, attachmentId, doc._rev);
        //  }


          // *
          // * @private
          // * @name getDbInfos
          // *
          // * @description Get current database informations.
          // * <a class="official" href="http://pouchdb.com/api.html#database_information"
          // * target="_blank">Official Documentation</a>
          // * @returns {Object} promise.
          // *
        //  function getDbInfos() {
        //      return db.info();
        //  }

          // *
          // * @private
          // * @name replicateDb
          // *
          // * @description Replicate data from source to target.
          // * <a class="official" href="http://pouchdb.com/api.html#replication"
          // * target="_blank">Official Documentation</a>
          // * <p class="info">Both the source and target can be a PouchDB instance or a string
          // * representing a CouchDB database URL or the name of a local PouchDB database.</p>
          // * @param {Object} source pouchDb-instance, db-url.. to replicate from.
          // * @param {Object} target pouchDb-instance, db-url.. to replicate to.
          // * @param {Object} options the options needed to overwrite the default method options.
          // * @param {Boolean} fromCurrent indicate if i want to replicate from current DB to target.
          // * @param {Boolean} toCurrent indicate if i want to replicate from target to the current DB.
          // *
        //  function replicateDb(source, target, options, fromCurrent, toCurrent) {
        //      options = updateOptions(MDVConfig.getValue('mng-persistence.options.replicateDb'), options);
        //      if (fromCurrent) {
        //          return db.replicate.to(target, options);
        //      } else if (toCurrent) {
        //          return db.replicate.from(target, options);
        //      }
        //      return db.replicate(source, target, options);
        //  }

          // *
          // * @private
          // * @name syncDb
          // *
          // * @description Sync data of current db with another one.
          // * This is a convenience method for bidirectional data replication.
          // * <a class="official" href="http://pouchdb.com/api.html#sync" target="_blank">Official Documentation</a>
          // * @param {Object} db pouchDb-instance, db-url.. to sync with.
          // * @param {Object} options the options needed to overwrite the default method options.
          // *
        //  function syncDb(db, options) {
        //      options = updateOptions(MDVConfig.getValue('mng-persistence.options.syncDb'), options);
        //      return db.sync(db, options);
        //  }

          // *
          // * @private
          // * @name compactDb
          // *
          // * @description Compact the current database.
          // * Triggers a compaction operation in the current database.
          // * This reduces the database’s size by removing unused and old data.
          // * <a class="official" href="http://pouchdb.com/api.html#compaction"
          // * target="_blank">Official Documentation</a>
          // * @param {Object} options the options needed to overwrite the default method options.
          // * @returns {Object} promise.
          // *
        //  function compactDb(options) {
        //      options = updateOptions(MDVConfig.getValue('mng-persistence.options.compactDb'), options);
        //      return db.compact(options);
        //  }
          // *
          // * @private
          // * @name queryDb
          // *
          // * @description Invoke a map/reduce function, which allows you to perform
          // * more complex queries on PouchDB than what you get with allDocs().
          // * <a class="official" href="http://pouchdb.com/api.html#query_database"
          // * target="_blank">Official Documentation</a>
          // * @param {Object} fn Map/reduce function, which can be one of the following:
          // *                     <ul>
          // *                       <li>A full CouchDB-style map/reduce view: {map : ..., reduce: ...}.</li>
          // *                       <li>A map function by itself (no reduce).</li>
          // *                       <li>The name of a view in an existing design document</li>
          // *                     </ul>
          // * @param {Object} options the options needed to overwrite the default method options.
          // * @returns {Object} promise.
          // *
        //  function queryDb(fn, options) {
        //      options = updateOptions(MDVConfig.getValue('mng-persistence.options.queryDb'), options);
        //      return db.query(fn, options);
        //  }
          // *
          // * @private
          // * @name createIndexByFieldName
          // *
          // * @description Return a view object, used to create a secondary index for a specified field.
          // * @param {String} fieldName the field name that should be indexed.
          // * @returns {Object} index object.
          // *
        /*  function createIndexByFieldName(fieldName) {
            var indexName = fieldName.concat('_index'),
                index = {}, views = {};

            index['_id'] = '_design/'+fieldName+'_index';
            views[indexName] =
            {
                map : function mapFun(doc, emit) {
                    if (doc.hasOwnProperty(fieldName)) {
                        emit(doc[fieldName]);
                    }
                }.toString()
            };
            index['views'] = views;
            return {
                'index' : index,
                'indexName' : indexName
            };
        }*/
          // *
          // * @private
          // * @name addDbIndex
          // *
          // * @description Add an index to the database.
          // * <p class="warning">Note that the index view is saved as document in the database.</p>
          // * @param {Object} index the index object that contain the map function for the indexed field.
          // * @returns {Object} promise.
          // *
        //  function addDbIndex(index) {
        //      return db.put(index);
        //  }

          // *
          // * @ignore
          // * @private
          // * @name getMatchFieldMapFunction
          // *
          // * @description Return a Map Function used to match a giving Field with a giving value.
          // * <p class="info">Note that this function use case insensitive to match the searched string.</p>
          // * @param {String} fieldName the name of the Database-Object property.
          // * @param {String} matchStr the searched value.
          // * @returns {Object} Map function.
          // *
        //  function getMatchFieldMapFunction(fieldName, matchStr) {
        //      return function(doc, emit) {
        //          if (doc.hasOwnProperty(fieldName) && doc[fieldName].match(new RegExp(matchStr, 'i'))) {
        //              emit(doc);
        //         }
        //      };
        //  }

        return persistenceObj;


    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-persistence.service:MDVPersistenceBuffer
     * @module mng-persistence
     * @description
     * This singleton service is used as temporary buffer for the data loaded from the Database.
     * To avoid reading each time from the database, and notifying other Listener about
     * Database changes, this service provide get, set and remove methods to manipulate the buffer.
     **/
    angular.module('mng-persistence')
        .service('mng-persistence.MDVPersistenceBuffer', MDVPersistenceBuffer);

    MDVPersistenceBuffer.$inject = ['$injector', '$q', '$filter', 'mng-util.MDVLog',
        'mng-persistence.MDVPersistenceHandler', 'mng-persistence.MDVPersistenceFactory'
    ];

    function MDVPersistenceBuffer($injector, $q, $filter, MDVLog, MDVPersistenceHandler,
        MDVPersistenceFactory) {
        var log = MDVLog.register('mng-persistence.MDVPersistenceBuffer'),
            vm = this,
            persistenceBufferObj = {
                get : get,
                set : set,
                remove : remove
            };

        log.debug('initialize');

        vm.buffer = {};

        /**
         * @public
         * @ngdoc method
         * @name get
         * @methodOf mng-persistence.service:MDVPersistenceBuffer
         * @description get one/multiple or all documents from the buffer.
         *   <pre>MDVPersistenceBuffer.get() // return all documents</pre>
         *   <pre>MDVPersistenceBuffer.get('1') // return document with id '1'</pre>
         *   <pre>MDVPersistenceBuffer.get(['1', '2']) // return documents with id '1' and '2'</pre>
         * @param {Object} dbConf database configuration
         * @param {Object} persistenceObjIds can be a document Id,
         * an array of documents Ids or null.
         * @param {Object} options the options needed to overwrite the default method options.
         * @returns {Object} promise.
         **/
        function get(dbConf, persistenceObjIds, options) {
            var dbName = getFromConf(dbConf, 'name');

            if (vm.buffer.hasOwnProperty(dbName)) {
                return getFromBuffer(dbConf, persistenceObjIds);
            } else {
                return getFromDB(dbConf, persistenceObjIds, options);
            }
        }


        /**
         * @public
         * @ngdoc method
         * @name set
         * @methodOf mng-persistence.service:MDVPersistenceBuffer
         * @description add/update one or multiple documents to/from the Database, and
         * updating the documents in the buffer.
         *   <pre>MDVPersistenceBuffer.set({'_id':'1'}) // add/update document with id '1'</pre>
         *   <pre>MDVPersistenceBuffer.get([{'_id':'1'}, {'_id':'2'}]) // add/update
         * documents with id '1' and '2'</pre>
         * @param {Object} dbConf database configuration
         * @param {Object} persistenceObjs can be one or multiple documents.
         * @param {Object} options the options needed to overwrite the default method options.
         * @returns {Object} promise.
         **/
        function set(dbConf, persistenceObjs, options) {
            var dbName = getFromConf(dbConf, 'name');

            if (vm.buffer.hasOwnProperty(dbName)) {
                return fireSet(dbConf, persistenceObjs, options);
            } else {
                // buffer is not filled yet => fill buffer with all DB Data
                return get(dbConf).then(function() {
                    return fireSet(dbConf, persistenceObjs, options);
                });
            }
        }


        function fireSet(dbConf, persistenceObjs, options) {
            var dbName = getFromConf(dbConf, 'name'),
                toAddEditArr = [];

            angular.forEach(persistenceObjs, function(persistenceObj) {
                // we check if the persistenceObj is already in the local Buffer.
                var duplicate = getDuplicate(dbName, persistenceObj),
                    jsonPersistenceObj = objectToJson(persistenceObj);

                if (duplicate) {
                    // update old persistenceObj
                    duplicate.persistence.modified = Date.now();
                    jsonPersistenceObj = addPersistenceInfos(jsonPersistenceObj, duplicate.persistence);
                } else {
                    // this persistenceObj does not exists in our local buffer => new object
                    jsonPersistenceObj = addPersistenceInfos(jsonPersistenceObj,
                                            new MDVPersistenceFactory(dbName));
                }
                toAddEditArr.push(jsonPersistenceObj);
            });
            return MDVPersistenceHandler.set(dbName, toAddEditArr, options)
                .then(function(response) {
                    toAddEditArr = updateRevision(toAddEditArr, response);
                    updateBuffer(dbName, toAddEditArr);
                    checkBufferLimit(dbConf);
                });
        }


        /**
         * @public
         * @ngdoc method
         * @name remove
         * @methodOf mng-persistence.service:MDVPersistenceBuffer
         * @description remove one/multiple or all documents from the database & buffer.
         *   <pre>MDVPersistenceBuffer.remove() // remove all documents</pre>
         *   <pre>MDVPersistenceBuffer.remove({'_id':'1'}) // remove document with id '1'</pre>
         *   <pre>MDVPersistenceBuffer.remove([{'_id':'1'}, {'_id':'2'}]) // remove documents with id '1' and '2'</pre>
         * @param {Object} dbConf database configuration.
         * @param {Object} persistenceObjs can be one or multiple documents.
         * @param {Object} options the options needed to overwrite the default method options.
         * @returns {Object} promise.
         **/
        function remove(dbConf, persistenceObjs, options) {
            var dbName = getFromConf(dbConf, 'name'),
                toRemoveArr = [];

            angular.forEach(persistenceObjs, function(persistenceObj) {
                var jsonObj = objectToJson(persistenceObj);

                jsonObj._id = persistenceObj._id;
                jsonObj._rev = persistenceObj._rev;
                toRemoveArr.push(jsonObj);
            });

            return MDVPersistenceHandler.remove(dbName, toRemoveArr, options)
                .then(function() {
                    if (!vm.buffer.hasOwnProperty(dbName)) {
                        vm.buffer[dbName] = [];
                    }
                    if (!toRemoveArr || toRemoveArr.length === 0) {
                        vm.buffer[dbName].splice(0, vm.buffer[dbName].length);
                    } else {
                        var i,
                            l,
                            buffered;

                        angular.forEach(toRemoveArr, function(toRemove) {
                            for (i = 0, l = vm.buffer[dbName].length; i < l; i += 1) {
                                buffered = vm.buffer[dbName][i];
                                if (toRemove._id === buffered._id) {
                                    vm.buffer[dbName].splice(i, 1);
                                    break;
                                }
                            }
                        });
                    }
                });
        }

        /** ************************* private methods ****************************/

        function getFromConf(dbConf, key) {
            if (dbConf && (typeof dbConf === 'string')) {
                return dbConf;
            }
            if (dbConf && key && dbConf.hasOwnProperty(key)) {
                return dbConf[key];
            }
        }

        function checkBufferLimit(dbConf) {
            if (!dbConf || !dbConf.hasOwnProperty('limit') ||
                (dbConf.hasOwnProperty('containUsage') && dbConf.containUsage)) {
                return;
            }
            var dbName = dbConf.name,
                limit = dbConf.limit,
                toRemove;

            if (vm.buffer.hasOwnProperty(dbName) && vm.buffer[dbName].length>limit) {
                vm.buffer[dbName] = $filter('orderBy')(vm.buffer[dbName], '-persistence.modified');
                toRemove = vm.buffer[dbName].slice(limit, vm.buffer[dbName].length);

                remove(dbConf, toRemove);
            }
        }

        function addPersistenceInfos(persistedObj, persistenceInfos) {
            persistedObj.persistence = persistenceInfos;
            if (persistenceInfos._id) {
                persistedObj._id = persistenceInfos._id;
            }
            if (persistenceInfos._rev) {
                persistedObj._rev = persistenceInfos._rev;
            }
            return persistedObj;
        }

        function jsonToObject(persistedJson) {
            if (!persistedJson || !persistedJson.$class) {
                return null;
            }
            var PersistenceObj = $injector.get(persistedJson.$class),
                toReturn = new PersistenceObj(persistedJson);

            persistedJson.persistence._rev = persistedJson._rev;
            toReturn = addPersistenceInfos(toReturn, persistedJson.persistence);
            return toReturn;
        }

        function objectToJson(persistedObj) {
            // @TODO
            return persistedObj.toJSON();
        }


        //  /**
        //   * First thing to do is to fill the buffer with all database documents.
        //   * This method get all the documents from the database, and push them into
        //   * the local buffer.
        //   **/
        function getFromDB(dbConf, persistenceObjIds, options) {
            var dbName = getFromConf(dbConf, 'name');

            return MDVPersistenceHandler.get(dbName, persistenceObjIds, options)
                .then(function(response) {
                    var i,
                        curr;

                    vm.buffer[dbName] = [];

                    for (i = 0; i < response.rows.length; i += 1) {
                        curr = jsonToObject(response.rows[i].doc);
                        if (curr) {
                            vm.buffer[dbName].push(curr);
                        }
                    }
                    return vm.buffer[dbName];
                });
        }


        function getFromBuffer(dbConf, persistenceObjIds) {
            var dbName = getFromConf(dbConf, 'name'),
                toReturnArr = [],
                deferred = $q.defer();

            if (!persistenceObjIds || persistenceObjIds.length === 0) {
                toReturnArr = toReturnArr.concat(vm.buffer[dbName]);
            } else {
                angular.forEach(persistenceObjIds, function(toReturn) {
                    angular.forEach(vm.buffer[dbName], function(buffered) {
                        if (toReturn._id === buffered._id) {
                            toReturnArr.push(buffered);
                        }
                    });
                });
            }
            deferred.resolve(toReturnArr);
            return deferred.promise;
        }


        //  /**
        //   * Before adding a new document to the Bufffer, we need to ckeck if a document
        //   * already exists with the same unique properties.
        //   * This method iterate over all the documents added to the buffer, and
        //   * check if an object exists already with the same properties as the new one.
        //   **/
        function getDuplicate(dbName, obj) {
            var i,
                l,
                buffered;

            if (!vm.buffer.hasOwnProperty(dbName)) {
                vm.buffer[dbName] = [];
            }
            for (i = 0, l = vm.buffer[dbName].length; i < l; i += 1) {
                buffered = vm.buffer[dbName][i];

                if (buffered.equals(obj)) {
                    return buffered;
                }
            }

            return false;
        }

        //  /**
        //   * After adding or editing an object in the Database, we get a new revision
        //   * that should be added to our local saved documents (in the Buffer).
        //   **/
        function updateRevision(toAddEditArr, result) {
            angular.forEach(result, function(res) {
                angular.forEach(toAddEditArr, function(toAddEdit) {
                    if (toAddEdit._id === res.id) {
                        toAddEdit._rev = res.rev;
                    }
                });
            });
            return toAddEditArr;
        }

        //  /**
        //   * Replacing an existing document with same persistenceID, or adding a new
        //   * object to the buffer.
        //   **/
        function updateBuffer(dbName, persistenceObjs) {
            angular.forEach(persistenceObjs, function(toEdit) {
                var index = -1,
                    i,
                    l,
                    buffered;

                for (i = 0, l = vm.buffer[dbName].length; i < l; i += 1) {
                    buffered = vm.buffer[dbName][i];
                    if (toEdit.persistence._id === buffered._id) {
                        index = i;
                        break;
                    }
                }
                toEdit = jsonToObject(toEdit);

                if (toEdit) {
                    if (index > -1) {
                        vm.buffer[dbName][index] = toEdit;
                    } else {
                        vm.buffer[dbName].push(toEdit);
                    }
                }
            });
        }


        return persistenceBufferObj;


    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc overview
     * @name mng-model
     * @module mng-model
     * @requires mng-config
     * @requires mng-util
     *
     * @description
     * # mng-model (normalized objects)
     * This module defines the basic model objects. All communication services need to parse their
     * gathered information into this model to ensure a unique handling in the upper levels in the
     * layout architecture. As the model describes a fix interface the upper levels do not need to
     * handle backend-specific specialities and can rely on the fix interface that is defined.
     *
     * ## General usage
     * ```js
     * // inject mng-model - components only
     * angular.module('your.module', ['mng-model]);
     * ```
     *
     * ## model objects
     * The following list gives a short overview of the available components within this module.
     * For further details, please refer to the components themselve.
     *
     * ### {@link mng-model.object:MDVLocation MDVLocation}
     * The `MDVLocation` object is an abstract description of a stop, coordinate, point of interest
     * (POI)/landmark or location.
     *
     * ### {@link mng-model.object:MDVSearchLocation MDVSearchLocation}
     * The `MDVSearchLocation` object extends the {@link mng-model.object:MDVLocation MDVLocation}
     * object with search specific properties like quality or best marker.
     *
     * ### {@link mng-model.object:MDVJourneyLocation MDVJourneyLocation}
     * The `MDVJourneyLocation` object extends the {@link mng-model.object:MDVLocation MDVLocation}
     * object with journey specific properties like departure or arrival time.
     *
     * ### {@link mng-model.object:MDVArrival MDVArrival}
     * The `MDVArrival` object describes an arrival of a {@link mng-model.object:MDVTransportation
     * line} at a specific stop and a specific time.
     *
     * ### {@link mng-model.object:MDVDeparture MDVDeparture}
     * The `MDVDeparture` object describes a departure of a {@link mng-model.object:MDVTransportation
     * line} at a specific stop and a specific time.
     *
     * ### {@link mng-model.object:MDVMessage MDVMessage}
     * The `MDVMessageRequester` object describes an information that concerns a {@link
     * mng-model.object:MDVTransportation line} or a {@link
     * mng-model.object:MDVLocation stop}. This can be a disruption message, or additional
     * information like announcements.
     *
     * ### {@link mng-model.object:MDVTransportation MDVTransportation}
     * The `MDVTransportation` object describes a transportation type. This can be public
     * transportation like train or bus, but also an individual transportation like walking or
     * driving.
     *
     */
    angular.module('mng-model', ['mng-config', 'mng-util']);
}());

(function() {
    'use strict';

    angular.module('mng-model')
        .factory('mng-model.MDVUtil', MDVModelUtil);

    MDVModelUtil.$inject = ['$http', '$injector', 'moment', /* 'tv4', */ 'mng-util.MDVLog',
        'mng-util.MDVUtil', 'mng-config.MDVConfig'];

    function MDVModelUtil($http, $injector, moment, /* tv4, */ MDVLog, MDVUtil, MDVConfig) {
        var log = MDVLog.register('mng-model.MDVUtil'),
            _private = {
                cache : {}
            },
            util = {
                check : check,
                getStandardJSON : getStandardJSON,
                parseModel : parseModel,
                parseModels : parseModels,
                parseMoment : parseMoment,
                parseMomentRange : parseMomentRange,
                setJSONValue : setJSONValue,
                setValue : setJSONValue,
                toJSONArray : toJSONArray,
                toJSONRange : toJSONRange
            };

        log.debug('initialized');

        // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
        // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
        MDVConfig.ready(function() {
            if (MDVConfig.getValue('mng-model.MDVUtil.privateMode') === true) {
                util._private = _private;
            }
        });

        // ////////////////////////////////

        function getStandardJSON(className, version, standardKeys) {
            if (!className || !version) {
                return {};
            }
            var i, l,
                serialized = {
                    $class : className,
                    $version : version
                };

            if (!standardKeys) {
                standardKeys = [];
            }
            for (i = 0, l = standardKeys.length; i < l; i += 1) {
                serialized = util.setJSONValue.call(this, standardKeys[i], serialized);
            }

            return serialized;
        }

        function parseModel(element) {
            var model = null,
                ModelConstructor;

            if (element && element.hasOwnProperty('$class') && $injector.has(element.$class)) {
                ModelConstructor = $injector.get(element.$class);
            } else {
                return element || null;
            }
            if (ModelConstructor) {
                model = new ModelConstructor(element);
            }

            return model;
        }

        function parseModels(values) {
            var i, l, elem,
                result = [];

            if (!values) {
                return result;
            }

            for (i = 0, l = values.length; i < l; i += 1) {
                elem = util.parseModel(values[i]);

                if (elem) {
                    result.push(elem);
                }
            }

            return result;
        }

        function parseMoment(element) {
            if (!element) {
                return null;
            }
            var parsed = moment(element);

            if (parsed.isValid()) {
                return parsed;
            }
            return null;
        }

        function parseMomentRange(values) {
            var i, l, elem,
                result = [];

            if (!values) {
                return result;
            }

            for (i = 0, l = values.length; i < l; i += 1) {
                elem = null;

                if (values[i].hasOwnProperty('from') && values[i].hasOwnProperty('to')) {
                    elem = {
                        from : util.parseMoment(values[i].from),
                        to : util.parseMoment(values[i].to)
                    };
                }

                if (elem) {
                    result.push(elem);
                }
            }

            return result;
        }

        function toJSONArray(values) {
            var i, l, elem,
                result = [];

            if (!values) {
                return result;
            }

            for (i = 0, l = values.length; i < l; i += 1) {
                elem = values[i].toJSON();
                if (elem) {
                    result.push(elem);
                }
            }

            return result;
        }

        function toJSONRange(values) {
            var i, l, elem,
                result = [];

            if (!values) {
                return result;
            }

            for (i = 0, l = values.length; i < l; i += 1) {
                if (values[i].hasOwnProperty('from') && values[i].hasOwnProperty('to')) {
                    elem = {
                        from : values[i].from.format(),
                        to : values[i].to.format()
                    };
                }
                if (elem) {
                    result.push(elem);
                }
            }

            return result;
        }

        function isEmptyObject(value) {
            if (value.constructor === Object) {
                var prop;

                for (prop in value) {
                    if (value.hasOwnProperty(prop)) {
                        return false;
                    }
                }
                return true;
            }
            return false;
        }

        function setJSONValue(key, destination, modification) {
            var value = null;

            if (key && this.hasOwnProperty(key)) {
                if (typeof this[key] === 'function') {
                    // getter function
                    value = this[key]();
                } else {
                    // normal value
                    value = this[key];
                }
            }
            if ((value || value === false) &&
                    !(value.constructor === Array && value.length === 0) &&
                    !(isEmptyObject(value))) {
                if (modification) {
                    value = modification(value);
                }
                if (value || value === false) {
                    destination[key] = value;
                }
            }
            return destination;
        }

            // transportation_schema = {
            //     destination : 'location',
            //     iconId : 'number',
            //     id : 'string',
            //     name : 'string',
            //     origin : 'location',
            //     operator : {
            //         code : 'string',
            //         name : 'string'
            //     },
            //     product : {
            //         'class' : 'number',
            //         iconId : 'number',
            //         name : 'string'
            //     },
            //     routeDescription : 'string'
            // };

        function check(object, schema/* , version */) {
            if (!object || !schema) {
                return false;
            }
            return true;
            // var clean_obj = angular.copy(object),
            //     to_delete = [],
            //     i,
            //     l,
            //     key;

            // for (key in clean_obj) {
            //     if (clean_obj.hasOwnProperty(key)) {
            //         if (clean_obj[key] === undefined || clean_obj[key] === null) {
            //             to_delete.push(key);
            //         }
            //     }
            // }
            // for (i = 0, l = to_delete.length; i < l; i += 1) {
            //     delete clean_obj[to_delete[i]];
            // }


            // return _private.loadSchema(schema, version).then(function(result) {
            //     return _private.modifyResponse(tv4.validate(clean_obj, result.data, null, false),
            //                                                                              clean_obj);
            // });
        }

        _private.loadSchema = function(schema, version) {
            var url = _private.getSchemaPath(schema, version);

            if (_private.cache.hasOwnProperty(url)) {
                return MDVUtil.getResolvedDeferred(_private.cache[url]);
            }
            return $http.get(url).then(function(response) {
                _private.cache[url] = response;
                return response;
            });
        };

        _private.modifyResponse = function(tv4_response, object) {
            if (tv4_response === false) {
                log.error(object, true);
                // return tv4.error;
            }
            return true;
        };

        _private.getSchemaPath = function(schema, version) {
            return '/app/mdv.components/mng-model/src/schemas/' + schema + '/' +
                                                               (version || 'latest') + '.mock.json';
        };

        return util;
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @constructor
     * @ngdoc object
     * @name mng-model.object:MDVTransportation
     * @requires mng-util.service:MDVLog
     * @requires mng-util.service:MDVUtil
     * @requires mng-model.service:MDVUtil
     *
     * @description
     * The `MDVTransportation` object is an abstract description of a line with a specific direction.
     *
     * As this object provides an uniform interface, services and controllers can interact with it in
     * an uniform way, no matter where the information about this departure comes from - as long as
     * the information is parsed to this object.
     *
     * ## General usage
     * To create a `MDVTransportation` object, the constructor needs to be called with a set of
     * properties that describe the object.
     *
     * ```js
     *   // creation of a new MDVTransportation
     *   var mdv_line_dir = new MDVTransportation({
     *       id : 'nsw:01243: :H:sj2',
     *       name: 'Train 243'
     *   });
     * ```
     *
     * Every `MDVTransportation` has getter methods to access its properties. Please refer to the
     * method documentation for a detailed description of the according attribute.
     *
     * ```js
     *   // get name of the MDVTransportation
     *   console.log(mdv_line_dir.name());  // 'NSW TrainLink Train 243'
     * ```
     *
     * ## Persistence
     * In order to persist this object and recreate it anytime in the future, you should use the
     * persist function. This function returns you all individual parameters needed, including a
     * version number that states in which format the data was persisted.
     *
     * This object ran through the following versions:
     * ### Version 2
     * Introduced in mng-model version 0.8.2 (04. October 2016)
     *<table>
     * <tr>     <th>key</th>       <th>type</th>  <th>default</th>      <th>example</th></tr>
     * <tr><td>$version</td>      <td>Number</td> <td>2</td>     <td></td></tr>
     * <tr><td>$class</td>     <td>String</td> <td>'mng-model.MDVTransportation'</td> <td></td></tr>
     * <tr><td></td>   <td></td> <td></td>    <td></td></tr>
     * <tr><td>coords</td>  <td>Number[][]</td> <td>[]</td><td>[[11.4,49.3],[11.5,49.2]]</td></tr>
     * <tr><td>destination</td>  <td>Object</td> <td>null</td>  <td>see MDVLocation version 2</td></tr>
     * <tr><td>disassembledName</td>  <td>String</td> <td>''</td><td>'ET 243'</td></tr>
     * <tr><td>iconId</td>  <td>Number</td> <td>null</td><td>2</td></tr>
     * <tr><td>id</td>  <td>String</td> <td>''</td><td>'nsw:01243: :H:sj2'</td></tr>
     * <tr><td>localitySequence</td> <td>Object[]</td> <td>[]</td> <td>see MDVLocation version 2</td></tr>
     * <tr><td>locationSequence</td> <td>Object[]</td> <td>[]</td> <td>see MDVLocation version 2</td></tr>
     * <tr><td>name</td>  <td>String</td> <td>''</td>  <td>'ExpressTrain ET 243'</td></tr>
     * <tr><td>number</td>  <td>String</td> <td>''</td>  <td>'243'</td></tr>
     * <tr><td>periodFrom</td>   <td>String</td> <td>''</td> <td>'20161021'</td></tr>
     * <tr><td>periodTo</td>   <td>String</td> <td>''</td> <td>'20181021'</td></tr>
     * <tr><td>product</td> <td>Object</td> <td>{}</td>  <td>{class:5, iconId:12, name:'expressbus'}
     * <tr><td>properties</td> <td>Object</td> <td>{}</td>  <td>set of key value pairs</td></tr>
     * <tr><td>routeDescription</td> <td>String</td> <td>''</td>  <td>'from A via B to C'</td></tr>
     * <tr><td>operator</td> <td>Object</td> <td>{}</td> <td>{id:'xprs', name:'xprs tours'}</td></tr>
     * <tr><td>origin</td>  <td>Object</td> <td>null</td>  <td>see MDVLocation version 2</td></tr>
     * </td></tr>
     * </table>
     *
     * ### Version 1
     * **Note:** *Version 1 of this object is not supported any more.*
     *
     */

    angular.module('mng-model')
        .factory('mng-model.MDVTransportation', MDVTransportation);

    MDVTransportation.$inject = ['$injector', 'mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-model.MDVUtil'];

    function MDVTransportation($injector, MDVLog, MDVUtil, MDVModelUtil) {
        var namespace = 'mng-model.MDVTransportation',
            log = MDVLog.register(namespace),
            VERSION = 2;

        log.debug('initialize');

        return function(props, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var _private = {
                prepareProperties : prepareProperties,
                selectProperties : selectProperties,
                updatePropertyVersion : updatePropertyVersion,
                raw : (props && props.raw) ? props.raw : {},
                $class : namespace,
                $version : VERSION,
                standardProperties : [
                    'allCoords',
                    'coords',
                    'disassembledName',
                    'iconId',
                    'hints',
                    'id',
                    'isCancelled',
                    'name',
                    'number',
                    'periodFrom',
                    'periodTo',
                    'routeDescription'
                ]
            };

            // assure raw is loaded correctly, before it is removed from props
            _private.props = prepareProperties(props);

            // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate === true) {
                this._private = _private;
            }

            this.allCoords = allCoords;
            this.coords = coords;
            this.destination = destination;
            this.disassembledName = disassembledName;
            this.equals = equals;
            this.hints = hints;
            this.iconId = iconId;
            this.id = id;
            this.infos = infos;
            this.isCancelled = isCancelled;
            this.isPublicTransportation = isPublicTransportation;
            this.isWalk = isWalk;
            this.locationSequence = locationSequence;
            this.localitySequence = localitySequence;
            this.name = name;
            this.network = network;
            this.number = number;
            this.operator = operator;
            this.operatorCode = operatorCode;
            this.operatorId = operatorId;
            this.operatorName = operatorName;
            this.origin = origin;
            this.periodFrom = periodFrom;
            this.periodTo = periodTo;
            this.product = product;
            this.productClass = productClass;
            this.productIconId = productIconId;
            this.productName = productName;
            this.properties = properties;
            this.raw = raw;
            this.routeDescription = routeDescription;
            this.toJSON = toJSON;

            // ////////////////////////////////

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name allCoords
             * @returns {Array} List of coordinate lists. Please note, that this response differs to
             * the usual coords getter return value, as a transportation can consist of different
             * coord-sequences. Whereas the normal coords method return a list of coord-arrays,
             * like [[lat, lng], [lat, lng]], this method returns a list of list of coord-arrays,
             * like [[[lat, lng], [lat, lng]], [[lat, lng], [lat, lng]]].
             *
             * @description
             * Get a list of all coordinate sequences of this transportation.
             */
            function allCoords() {
                return _private.props.allCoords || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name coords
             * @returns {Array} List of coordinates. Please note, that this response differs to
             * the allCoords getter return value, as a transportation can consist of different
             * coord-sequences. Whereas the normal coords methods return a list of coord-arrays,
             * like [[lat, lng], [lat, lng]], the allCoords method returns a list of list of coord-arrays,
             * like [[[lat, lng], [lat, lng]], [[lat, lng], [lat, lng]]].
             *
             * **NOTE:** *if multiple coord-sequences are available, this getter method returns the
             * first one. This coord-sequence does not necessary have to be the best available.*
             *
             * @description
             * Get the coordinate-sequence of this transportation.
             */
            function coords() {
                if (_private.props.coords && _private.props.coords.length > 0) {
                    return _private.props.coords;
                }
                if (_private.props.allCoords && _private.props.allCoords.length > 0) {
                    return _private.props.allCoords[0];
                }
                return [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name destination
             * @returns {MDVLocation} destination point
             *
             * @description
             * Get a location that describes the transportation end location.
             * This string can be useful in case of departures.
             */
            function destination() {
                return _private.props.destination || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name periodFrom
             * @returns {moment} moment object for the line timetable validity begin.
             *
             * @description
             * Get the begin date of the Line Timetable validity period.
             */
            function periodFrom() {
                return _private.props.periodFrom || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name periodTo
             * @returns {moment} moment object for the line timetable validity end.
             *
             * @description
             * Get the end date of the Line Timetable validity period.
             */
            function periodTo() {
                return _private.props.periodTo || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name network
             * @returns {String} network name.
             *
             * @description
             * Get the line network name.
             */
            function network() {
                return _private.props.network || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name disassembledName
             * @returns {String} short name of this transportation
             *
             * @description
             * Get the short name of this transportation. If no short name is available, the normal
             * name is returned.
             */
            function disassembledName() {
                return _private.props.disassembledName || name();
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name equals
             * @param {MDVTransportation} transportation object that should be compared with this leg.
             * @returns {Boolean} true: transportation is the same, false otherwise.
             *
             * @description
             * Check if a given transportation object equals this transportation.
             * Two transportation are the same if they share the same id.
             */
            function equals(transportation) {
                if (!transportation) {
                    return false;
                }
                return id.call(this) === transportation.id();
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name iconId
             * @returns {Number} the transportation's key
             *
             * @description
             * Get the most specific icon id for this transportation.
             */
            function iconId() {
                var id_val = _private.props.iconId;

                if (!id_val && id_val !== 0) {
                    return null;
                }
                return id_val;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name hints
             * @returns {String[]} the transportation's hints
             *
             * @description
             * Get the hints for this transportation.
             */
            function hints() {
                return _private.props.hints || [];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name id
             * @returns {String} unique ID
             *
             * @description
             * Get the transportation's unique ID.
             */
            function id() {
                return _private.props.id || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name infos
             * @returns {Object[]} List of additional information the leg has.
             *
             * @description
             * Get the list of additional information the transportation has.
             */
            function infos() {
                return _private.props.infos || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name isCancelled
             * @returns {Boolean} true: Transportation is cancelled, false: transportation drives as planned.
             *
             * @description
             * Determine whether this transportation is cancelled or not.
             */
            function isCancelled() {
                return _private.props.isCancelled || false;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name isPublicTransportation
             * @returns {Boolean} true: Transportation is public transportation, false: individual
             * transport.
             *
             * @description
             * Determine whether this transportation is public or individual.
             */
            function isPublicTransportation() {
                var mot = productClass();

                if (!mot && mot !== 0) {
                    return false;
                }

                return mot < 97;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name isPublicTransportation
             * @returns {Boolean} true: Transportation is walking, false: public transportation or
             * other individual transport.
             *
             * @description
             * Determine whether this transportation is public or individual.
             */
            function isWalk() {
                var mot = productClass();

                return Boolean(mot && (mot === 99 || mot === 100));
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name localitySequence
             * @returns {MDVLocation[]} list of all localities, this transportation passes
             *
             * @description
             * Get a list of all localities, this transportation passes. This getter differs from
             * the locationSequence getter, as it just returns localities instead of all stops the
             * transportation passes.
             */
            function localitySequence() {
                return _private.props.localitySequence || [];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name locationSequence
             * @returns {MDVLocation[]} list of all locations, this transportation passes
             *
             * @description
             * Get a list of all locations, this transportation passes
             */
            function locationSequence() {
                return _private.props.locationSequence || [];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name transportationName
             * @returns {String} the transportation's name
             *
             * @description
             * Get the name of the general transportation description.
             * Do not mix up the **productName** with the more basic **transportationName**.
             * The productName can comply with the transportationName, but it can also be more specific.
             *
             * Example: transportationName = 'bus', productName = 'express bus'
             */
            function name() {
                return _private.props.name || '';
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name number
             * @returns {String} the transportation's number
             *
             * @description
             * Get the number that is assigned to this transportation.
            **/
            function number() {
                return _private.props.number || '';
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name operatorCode
             * @returns {Object} Operator information
             *
             * @description
             * Get the operator information of this transportation.
             */
            function operator() {
                return _private.props.operator || {};
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name operatorId
             * @returns {String} Id of the transportation's operator
             *
             * @description
             * Get the id the operator this transportation has.
             */
            function operatorId() {
                return operator.call(this).id || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name operatorCode
             * @returns {String} Code of the transportation's operator
             *
             * @description
             * Get the code the operator this transportation has.
             */
            function operatorCode() {
                log.warn('operatorCode is decpreciated. use operatorId instead');
                return operator.call(this).id || operator.call(this).code || '';
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name operatorName
             * @returns {String} Name of the transportation's operator
             *
             * @description
             * Get the name the operator this transportation has.
             */
            function operatorName() {
                return operator.call(this).name || '';
            }


            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name origin
             * @returns {MDVLocation} origin point
             *
             * @description
             * Get a location that describes the transportation start location.
             * This string can be useful in case of arrivals.
             */
            function origin() {
                return _private.props.origin || null;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name product
             * @returns {MDVLocation} product of the transportation
             *
             * @description
             * Get a product description of  the transportation.
             *
             * The product describes a more generalized transportation, like "bus" or "train".
             * The product object can contain three properties:
             * - name: name of the product populated in diva. *Sydney Trains*
             * - class: MOT value *5*
             * - iconId: more specific value, that can differ to the class. (e.g. express bus)
             *
             * **NOTE:** *This getter is depreciated and should not be used any more. Use the
             * specific getters to get the specific values.*
             */
            function product() {
                return _private.props.product || {};
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name productClass
             * @returns {Number} the transportation's mode key
             *
             * @description
             * Get the general class of the transportation's product.
             */
            function productClass() {
                var class_val = product()['class'];

                if (!class_val && class_val !== 0) {
                    return null;
                }
                return class_val;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name productIconId
             * @returns {Number} the transportation's mot key
             *
             * @description
             * Get an id that can be used to show the product's icon.
             */
            function productIconId() {
                var id_val = product().iconId;

                if (!id_val && id_val !== 0) {
                    return null;
                }
                return id_val;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name productName
             * @returns {String} the transportation's mode name
             *
             * @description
             * Get the name of the transportation's product description.
             * Do not mix up the **productName** with the more basic **transportationName**.
             * The productName can comply with the transportationName, but it can also be more specific.
             *
             * Example: transportationName = 'bus', productName = 'express bus'
             */
            function productName() {
                return product().name || '';
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name properties
             * @returns {Object} Properties object with additional properties as key-value pairs
             *
             * @description
             * Get additional properties that may describe this transportation in more detail. These
             * properties are optional and may not be available with every transportation object.
             */
            function properties() {
                return _private.props.properties || {};
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name raw
             * @returns {Object} raw object the data of this model is from
             *
             * @description
             * Get the original response object the data of this model is from.
             *
             * **NOTE:** *This is an internal method for debug purposes and should not be used in
             * production websites! It will be removed in the future.*
             */
            function raw() {
                return _private.raw || {};
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name routeDescription
             * @returns {String} the transportation's description
             *
             * @description
             * Get the description of the transportation. This is usually filled in the data with
             * origin and destination and some important stopovers.
             */
            function routeDescription() {
                return _private.props.routeDescription || '';
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTransportation
             * @name toJSON
             * @returns {Object} object with all necessary properties to reconstruct this object.
             *
             * @description
             * Get all properties of this object to reconstruct it later on. This method should be
             * used for persisting favorites or logging purposes. The returned object also provides
             * an version number, which allows the program to determine which interface version was
             * used for this formatting.
             */
            function toJSON() {
                var serialized = MDVModelUtil.getStandardJSON
                        .call(this, _private.$class, _private.$version, _private.standardProperties);

                MDVModelUtil.setValue
                    .call(this, 'destination', serialized, function(value) {
                        return value.toJSON();
                    });

                MDVModelUtil.setValue
                    .call(this, 'infos', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });

                MDVModelUtil.setValue
                    .call(this, 'localitySequence', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });

                MDVModelUtil.setValue
                    .call(this, 'locationSequence', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });

                MDVModelUtil.setValue
                    .call(this, 'operator', serialized, function(value) {
                        // assure operator object is proper JSON
                        return JSON.parse(JSON.stringify(value));
                    });

                MDVModelUtil.setValue
                    .call(this, 'origin', serialized, function(value) {
                        return value.toJSON();
                    });

                MDVModelUtil.setValue
                    .call(this, 'product', serialized, function(value) {
                        // assure product object is proper JSON
                        return JSON.parse(JSON.stringify(value));
                    });

                MDVModelUtil.setValue
                    .call(this, 'properties', serialized, function(value) {
                        // assure properties are proper JSON
                        return JSON.parse(JSON.stringify(value));
                    });

                // do not return duplicated name if no own disassembled name is provided
                if (serialized.name === serialized.disassembledName) {
                    delete serialized.disassembledName;
                }

                return serialized;
            }

            // ////////////////////////////////

            function prepareProperties(propertiesObj) {
                if (!propertiesObj) {
                    propertiesObj = {};
                }
                propertiesObj = _private.updatePropertyVersion(propertiesObj);

                // schema check
                // if (validateActive) {
                //     MDVValidator.check(properties, 'location').then(function(result) {
                //         if (result !== true) {
                //             log.error(result, true);
                //         }
                //     });
                // }

                return _private.selectProperties(propertiesObj);
            }

            function selectProperties(propertiesObj) {
                // set standard values
                var prepProps = MDVModelUtil.getStandardJSON
                    .call(propertiesObj, _private.$class, _private.$version,
                                                                    _private.standardProperties);

                // set complex properties

                MDVModelUtil.setValue
                    .call(propertiesObj, 'destination', prepProps, function(value) {
                        return MDVModelUtil.parseModel(value);
                    });

                MDVModelUtil.setValue
                    .call(propertiesObj, 'infos', prepProps, function(value) {
                        return MDVModelUtil.parseModel(value);
                    });

                MDVModelUtil.setValue
                    .call(propertiesObj, 'affectedElements', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });

                MDVModelUtil.setValue
                    .call(propertiesObj, 'localitySequence', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });

                MDVModelUtil.setValue
                    .call(propertiesObj, 'locationSequence', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });

                MDVModelUtil.setValue.call(propertiesObj, 'operator', prepProps);

                MDVModelUtil.setValue
                    .call(propertiesObj, 'origin', prepProps, function(value) {
                        return MDVModelUtil.parseModel(value);
                    });

                MDVModelUtil.setValue.call(propertiesObj, 'product', prepProps);
                MDVModelUtil.setValue.call(propertiesObj, 'properties', prepProps);
                MDVModelUtil.setValue.call(propertiesObj, 'routeDescription', prepProps);

                return prepProps;
            }

            function updatePropertyVersion(propertiesObj) {
                if (propertiesObj.hasOwnProperty('VERSION')) {
                    log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                        'please delete all old versions to avoid data loss or incorrect behavior');
                    return {};
                }
                // version check
                if (propertiesObj.$version && propertiesObj.$version !== _private.$version) {
                    if (propertiesObj.$version > VERSION) {
                        log.error('unknown version: ' + propertiesObj.$version +
                            '. Highest available version: ' + _private.$version);

                        return {};
                    }
                    // convert values to current version
                    // if (propertiesObj.$version === 2) {
                    //     propertiesObj.xy = propertiesObj.oldValue;
                    // }

                    // all other unsupported/ unknown versions
                    if (propertiesObj.$version === 1) {
                        log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                            'please delete all old versions to avoid data loss or incorrect behavior');
                        return {};
                    } else {
                        // all others
                        log.error('unknown version: ' + propertiesObj.$version +
                            '. Lowest available version: 1');

                        return {};
                    }
                }
                return propertiesObj;
            }

            return this;
        };
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @constructor
     * @ngdoc object
     * @name mng-model.object:MDVTicket
     * @requires mng-util.service:MDVLog
     * @requires mng-model.service:MDVUtil
     *
     * @description
     * The `MDVTicket` object is an abstract description of a ticket element.
     * As this object provides an uniform interface, services and controllers can interact with it in
     * an uniform way, no matter where the information about this journey comes from - as long as
     * the information is parsed to this object.
     *
     * ## Persistence
     * In order to persist this object and recreate it anytime in the future, you should use the
     * persist function. This function returns you all individual parameters needed, including a
     * version number that states in which format the data was persisted.
     *
     * This object ran through the following versions:
     * ### Version 2
     * Introduced in mng-model version 0.8.2 (04. October 2016)
     *<table>
     * <tr>     <th>key</th>       <th>type</th>  <th>default</th>      <th>example</th></tr>
     * <tr><td>$version</td>      <td>Number</td> <td>2</td>     <td></td></tr>
     * <tr><td>$class</td>      <td>String</td> <td>'mng-model.MDVTicket'</td> <td></td></tr>
     * <tr><td></td>   <td></td> <td></td>    <td></td></tr>
     * <tr><td>id</td>  <td>String</td> <td>''</td><td>'SINGLE_TICKET'</td></tr>
     * <tr><td>legRange</td> <td>Number[]</td> <td>[]</td>  <td>[1, 2]</td></tr>
     * <tr><td>name</td>  <td>String</td> <td>''</td>  <td>'Single ticket'</td></tr>
     * <tr><td>network</td>  <td>String</td> <td>''</td>  <td>'nsw'</td></tr>
     * <tr><td>person</td>       <td>String</td> <td>''</td> <td>'ADULT'</td></tr>
     * <tr><td>price</td>  <td>Number</td> <td>0</td>  <td>1.2</td></tr>
     * <tr><td>priceLevel</td>  <td>String</td> <td>''</td>  <td>'SINGLE'</td></tr>
     * <tr><td>properties</td> <td>Object</td> <td>{}</td>  <td>set of key value pairs</td></tr>
     * <tr><td>travellerClass</td> <td>String</td> <td>''</td>  <td>'2'</td></tr>
     * <tr><td>type</td> <td>String</td> <td>''</td>  <td>'SINGLE'</td></tr>
     * <tr><td>unit</td> <td>String</td> <td>''</td>  <td>'EUR'</td></tr>
     * <tr><td>validity</td> <td>Object</td> <td>{}</td>  <td>{area:'', duration:-1, interchanges:-1
     * ,oneJourneyOnly:'UNKNOWN',oneOperatorOnly:'UNKNOWN',returnAllowed:'NO'}</td></tr>
     * <tr><td>distance</td> <td>Object</td> <td>{}</td>  <td>{exact:2.5, rounded:3, kmPrice:0.20,
     * basicPrice:0.80}</td></tr>
     * </table>
     *
     * ### Version 1
     * **Note:** *Version 1 of this object is not supported any more.*
     *
     */
    angular.module('mng-model')
        .factory('mng-model.MDVTicket', MDVTicket);

    MDVTicket.$inject = ['mng-util.MDVLog', 'mng-model.MDVUtil'];

    function MDVTicket(MDVLog, MDVModelUtil) {
        var namespace = 'mng-model.MDVTicket',
            log = MDVLog.register(namespace),
            VERSION = 2;

        log.debug('initialize');

        return function(props, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var _private = {
                prepareProperties : prepareProperties,
                selectProperties : selectProperties,
                updatePropertyVersion : updatePropertyVersion,
                raw : (props && props.raw) ? props.raw : {},
                $class : namespace,
                $version : VERSION,
                standardProperties : [
                    'id',
                    'legRange',
                    'name',
                    'unit',
                    'network',
                    'person',
                    'price',
                    'travellerClass',
                    'type',
                    'priceLevel'
                ]
            };

            // assure raw is loaded correctly, before it is removed from props
            _private.props = prepareProperties(props);

            // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate === true) {
                this._private = _private;
            }

            this._decreaseRange = _decreaseRange;

            this.id = id;
            this.legRange = legRange;
            this.name = name;
            this.unit = unit;
            this.network = network;
            this.person = person;
            this.price = price;
            this.properties = properties;
            this.raw = raw;
            this.toJSON = toJSON;
            this.travellerClass = travellerClass;
            this.type = type;
            this.priceLevel = priceLevel;
            this.validity = validity;
            this.validityArea = validityArea;
            this.validityDuration = validityDuration;
            this.validityInterchanges = validityInterchanges;
            this.validityOneJourneyOnly = validityOneJourneyOnly;
            this.validityOneOperatorOnly = validityOneOperatorOnly;
            this.validityReturnsAllowed = validityReturnsAllowed;
            this.distance = distance;
            this.distanceExact = distanceExact;
            this.distanceRounded = distanceRounded;
            this.distanceKmPrice = distanceKmPrice;
            this.distanceBasicPrice = distanceBasicPrice;


            function _decreaseRange() {
                var i,
                    l;

                for (i = 0, l = _private.props.legRange.length; i < l; i += 1) {
                    _private.props.legRange[i] -= 1;
                }
                if (_private.props.legRange[0] === -1) {
                    _private.props.legRange = _private.props.legRange.slice(1);
                }
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name raw
             * @returns {Object} raw object the data of this model is from
             *
             * @description
             * Get the original response object the data of this model is from.
             */
            function raw() {
                return _private.raw || {};
            }

            /**
            * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name id
             * @returns {String} id of this ticket
             *
             * @description
             * Get the id of this ticket.
             */
            function id() {
                return _private.props.id || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name toJSON
             * @returns {Object} object with all necessary properties to reconstruct this object.
             *
             * @description
             * Get all properties of this object to reconstruct it later on. This method should be
             * used for persisting favorites or logging purposes. The returned object also provides
             * an version number, which allows the program to determine which interface version was
             * used for this formatting.
             */
            function toJSON() {
                var serialized = MDVModelUtil.getStandardJSON
                        .call(this, _private.$class, _private.$version, _private.standardProperties);

                MDVModelUtil.setValue
                    .call(this, 'properties', serialized, function(value) {
                        // assure properties are propert JSON
                        return JSON.parse(JSON.stringify(value));
                    });

                MDVModelUtil.setValue
                    .call(this, 'validity', serialized, function(value) {
                        // assure properties are propert JSON
                        return JSON.parse(JSON.stringify(value));
                    });

                MDVModelUtil.setValue
                    .call(this, 'distance', serialized, function(value) {
                        // assure properties are propert JSON
                        return JSON.parse(JSON.stringify(value));
                    });

                return serialized;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name price
             * @returns {Number} price of this ticket
             *
             * @description
             * Get the price of this ticket.
             */
            function price() {
                return _private.props.price || 0;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name legRange
             * @returns {Number[]} list of leg indices the fare is valid for
             *
             * @description
             * Get the list of leg indices the fare is valid for
             */
            function legRange() {
                return _private.props.legRange || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name name
             * @returns {String} Name of this ticket
             *
             * @description
             * Get the name of this ticket.
             */
            function name() {
                return _private.props.name || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name unit
             * @returns {String} unit of the ticket
             *
             * @description
             * Get the unit of this ticket.
             */
            function unit() {
                return _private.props.unit || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name network
             * @returns {String} Network the ticket is in
             *
             * @description
             * Get the network this ticket is in.
             */
            function network() {
                return _private.props.network || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name person
             * @returns {String} Key for the person
             *
             * @description
             * Get the key of the person this ticket is about.
             */
            function person() {
                return _private.props.person || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name properties
             * @returns {Object} additional properties for this ticket
             *
             * @description
             * Get additional properties for this ticket.
             */
            function properties() {
                return _private.props.properties || {};
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name travellerClass
             * @returns {String} traveller class of this ticket
             *
             * @description
             * Get the traveller class of this ticket.
             */
            function travellerClass() {
                return _private.props.travellerClass || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name type
             * @returns {String} type of this ticket
             *
             * @description
             * Get the type of this ticket.
             */
            function type() {
                return _private.props.type || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name priceLevel
             * @returns {String} priceLevel of this ticket
             *
             * @description
             * Get the type of this ticket.
             */
            function priceLevel() {
                return _private.props.priceLevel || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name validity
             * @returns {Object} validity values
             *
             * @description
             * Get a set of validity values regarding this ticket.
             */
            function validity() {
                return _private.props.validity || {};
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name validityArea
             * @returns {String|null} area the ticket is valid in
             *
             * @description
             * Area the ticket is valid in.
             */
            function validityArea() {
                return validity().area || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name validityDuration
             * @returns {Number|null} duration the ticket is valid in. null if value is invalid or
             * not defined.
             *
             * @description
             * Duration the ticket is valid in.
             */
            function validityDuration() {
                if (!validity().duration || validity().duration === -1) {
                    return null;
                }
                return validity().duration;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name validityInterchanges
             * @returns {Number|null} interchanges the ticket is valid for. null if value is invalid
             * or not defined.
             *
             * @description
             * Amount of interchanges the ticket is valid for.
             */
            function validityInterchanges() {
                if (!validity().interchanges || validity().interchanges === -1) {
                    return null;
                }
                return validity().interchanges;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name validityOneJourneyOnly
             * @returns {Boolean|null} true: ticket is for one journey only, false otherwise. null
             * if value is invalid or not defined.
             *
             * @description
             * Determine whether the ticket is valid for only one journey.
             */
            function validityOneJourneyOnly() {
                if (!validity().oneJourneyOnly || validity().oneJourneyOnly === 'UNKNOWN') {
                    return null;
                }
                return validity().oneJourneyOnly;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name validityOneOperatorOnly
             * @returns {Boolean|null} true: ticket is for one operator only, false otherwise. null
             * if value is invalid or not defined.
             *
             * @description
             * Determine whether the ticket is valid for only one operator.
             */
            function validityOneOperatorOnly() {
                if (!validity().oneOperatorOnly || validity().oneOperatorOnly === 'UNKNOWN') {
                    return null;
                }
                return validity().oneOperatorOnly;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name validityReturnsAllowed
             * @returns {Boolean|null} true: this ticket allows a return journey, false otherwise.
             * null if value is invalid or not defined.
             *
             * @description
             * Determine whether the ticket allows return journeys or not.
             */
            function validityReturnsAllowed() {
                if (!validity().returnsAllowed) {
                    return null;
                }
                if (validity().returnsAllowed === 'NO') {
                    return false;
                }
                return true;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name distance
             * @returns {Object} distance values
             *
             * @description
             * Get a set of distance values regarding this ticket.
             */
            function distance() {
                return _private.props.distance || {};
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name distanceExact
             * @returns {Number|null} exact distance.
             *
             * @description
             * Get the exact value of the distance in meter for the distance-ticket.
             */
            function distanceExact() {
                if (!distance().exact || distance().exact === -1) {
                    return null;
                }
                return distance().exact;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name distanceRounded
             * @returns {Number|null} rounded distance.
             *
             * @description
             * Get the rounded value of the distance in meter for the distance-ticket.
             */
            function distanceRounded() {
                if (!distance().rounded || distance().rounded === -1) {
                    return null;
                }
                return distance().rounded;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name distanceKmPrice
             * @returns {Number|null} the price of a klm.
             *
             * @description
             * Get the price of one klm for the distance-ticket.
             */
            function distanceKmPrice() {
                if (!distance().kmPrice || distance().kmPrice === -1) {
                    return null;
                }
                return distance().kmPrice;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVTicket
             * @name distanceBasicPrice
             * @returns {Number|null} basic price.
             *
             * @description
             * Get the basic price of the distance-ticket.
             */
            function distanceBasicPrice() {
                if (!distance().basicPrice || distance().basicPrice === -1) {
                    return null;
                }
                return distance().basicPrice;
            }

            // ////////////////////////////////

            function prepareProperties(propertiesObj) {
                if (!propertiesObj) {
                    propertiesObj = {};
                }
                propertiesObj = _private.updatePropertyVersion(propertiesObj);

                // schema check
                // if (validateActive) {
                //     MDVValidator.check(properties, 'location').then(function(result) {
                //         if (result !== true) {
                //             log.error(result, true);
                //         }
                //     });
                // }

                return _private.selectProperties(propertiesObj);
            }

            function selectProperties(propertiesObj) {
                // set standard values
                var prepProps = MDVModelUtil.getStandardJSON
                    .call(propertiesObj, _private.$class, _private.$version,
                                                                    _private.standardProperties);

                // set complex properties
                MDVModelUtil.setValue.call(propertiesObj, 'properties', prepProps);
                MDVModelUtil.setValue.call(propertiesObj, 'validity', prepProps);
                MDVModelUtil.setValue.call(propertiesObj, 'distance', prepProps);

                return prepProps;
            }

            function updatePropertyVersion(propertiesObj) {
                if (propertiesObj.hasOwnProperty('VERSION')) {
                    log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                        'please delete all old versions to avoid data loss or incorrect behavior');
                    return {};
                }
                // version check
                if (propertiesObj.$version && propertiesObj.$version !== _private.$version) {
                    if (propertiesObj.$version > VERSION) {
                        log.error('unknown version: ' + propertiesObj.$version +
                            '. Highest available version: ' + _private.$version);

                        return {};
                    }
                    // convert values to current version
                    // if (propertiesObj.$version === 2) {
                    //     propertiesObj.xy = propertiesObj.oldValue;
                    // }

                    // all other unsupported/ unknown versions
                    if (propertiesObj.$version === 1) {
                        log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                            'please delete all old versions to avoid data loss or incorrect behavior');
                        return {};
                    } else {
                        // all others
                        log.error('unknown version: ' + propertiesObj.$version +
                            '. Lowest available version: 1');

                        return {};
                    }
                }
                return propertiesObj;
            }

            return this;
        };
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @constructor
     * @ngdoc object
     * @name mng-model.object:MDVSearchLocation
     * @requires mng-util.service:MDVLog
     * @requires mng-model.object:MDVLocation
     *
     * @description
     * The `MDVSearchLocation` object is an extension of a {@link mng-model.object:MDVLocation
     * MDVLocation} to provide additional information.
     *
     * ## General usage
     * To create a `MDVSearchLocation` object, the constructor needs to be called with a set of
     * properties that describe the object.
     *
     * ```js
     *   // creation of a new MDVSearchLocation
     *   var search_location = new MDVSearchLocation({
     *      id : '10102027',
     *      coord : [-33.79931, 151.28432],
     *      name : 'Manly Wharf',
     *      searchInput : 'manly',
     *      matchQuality : 1000,
     *      isBestMatch : true
     *   });
     * ```
     *
     * Every `MDVSearchLocation` has getter methods to access its properties. Please refer to the
     * method documentation for a detailed description
     * of the according attribute. Only `MDVSearchLocation` specific properties
     * are described. All other properties are described in the {@link mng-model.object:MDVLocation
     * MDVLocation} documentation.
     *
     * ```js
     *   // get the match quality of a MDVSearchLocation
     *   console.log(search_location.matchQuality());  // 1000
     * ```
     *
     * ## Persistence
     * In order to persist this object and recreate it anytime in the future, you should use the
     * persist function. This function returns you all individual parameters needed, including a
     * version number that states in which format the data was persisted.
     *
     * This object ran through the following versions:
     * ### Version 2
     * Introduced in mng-model version 0.8.2 (04. October 2016)
     *
     * **NOTE:** *This table only includes all additional properties the persisted location has.
     * It also includes all properties a {@link mng-model.object:MDVLocation MDVLocation} with the
     * same version number provides.*
     *
     *<table>
     * <tr>     <th>key</th>       <th>type</th>  <th>default</th>      <th>example</th></tr>
     * <tr><td>$version</td>      <td>Number</td> <td>2</td>     <td></td></tr>
     * <tr><td>$class</td>      <td>String</td> <td>'mng-model.MDVSearchLocation'</td> <td></td></tr>
     * <tr><td></td>   <td></td> <td></td>    <td></td></tr>
     * <tr><td>isBestMatch</td>     <td>Boolean</td> <td>false</td>     <td></td></tr>
     * <tr><td>matchQuality</td>    <td>Number</td>  <td>0</td>         <td>940</td></tr>
     * <tr><td>searchValue</td>     <td>String</td>  <td>''</td>        <td>'manly'</td></tr>
     * </table>
     *
     * ### Version 1
     * **Note:** *Version 1 of locations is still supported by the modules, but data loss and
     * unexpected behavior can occur. It is hardly recommended to delete all instances with
     * version 1 or older (instances without version attribute or with VERSION instead of $version).
     * Using these old versions will log a warning to the console.*
     *
     */
//      * Please refer to the example below for further details.
//      *
//      * @example
// <example module="MDVSearchLocationExample">
// <file name="index.html">
//   <div ng-controller="SearchLocationController" style="min-height:45em;">
//         <div>Properties the MDVSearchLocation is initialized with:</div>
//         <textarea style="width:100%;height:20em;" ng-model="locationParameters" ng-change="onInputChange()"></textarea>
//         <div ng-show="hint">{{hint}}</div>
//         <div ng-show="location">
//           <div>Result:</div>
//           <table style="text-align:left !important;">
//             <tr><th style="width:15em;">function</th><th>value</th></tr>
//             <tr><td colspan="2"><b>Standard MDVLocation parameters:</b></td></tr>
//             <tr><td>MDVSearchLocation.buildingNumber()</td><td>{{location.buildingNumber()}}</td></tr>
//             <tr><td>MDVSearchLocation.coordLatLng()</td><td>{{location.coordLatLng()}}</td></tr>
//             <tr><td>MDVSearchLocation.coordString()</td><td>{{location.coordString()}}</td></tr>
//             <tr><td>MDVSearchLocation.description()</td><td>{{location.description()}}</td></tr>
//             <tr><td>MDVSearchLocation.id()</td><td>{{location.id()}}</td></tr>
//             <tr><td>MDVSearchLocation.hasCoords()</td><td>{{location.hasCoords()}}</td></tr>
//             <tr><td>MDVSearchLocation.modes()</td><td>{{location.modes()}}</td></tr>
//             <tr><td>MDVSearchLocation.name()</td><td>{{location.name()}}</td></tr>
//             <tr><td>MDVSearchLocation.type()</td><td>{{location.type()}}</td></tr>
//             <tr><td colspan="2"><b>Additional parameters:</b></td></tr>
//             <tr><td>MDVSearchLocation.isBestMatch()</td><td>{{location.isBestMatch()}}</td></tr>
//             <tr><td>MDVSearchLocation.matchQuality()</td><td>{{location.matchQuality()}}</td></tr>
//             <tr><td>MDVSearchLocation.searchValue()</td><td>{{location.searchValue()}}</td></tr>
//           </table>
//         </div>
//     </div>
// </file>
// <file name="script.js">
//   angular.module('MDVSearchLocationExample', ['mng-model'])
//     .controller('SearchLocationController', ['$scope', 'mng-model.MDVSearchLocation',
//     function ($scope, MDVSearchLocation) {
//         var example = {
//               "description" : "25 Brentwood Dr, Clarence Town",
//               "id" : "streetID:38920:25:95317004:-1:Brentwood Dr:Clarence Town:Brentwood Dr:nsw",
//               "type" : "singlehouse",
//               "name" : "Brentwood Dr",
//               "buildingNumber" : "25",
//               "coord" : [151.75752,-32.59597],
//               "matchQuality" : 234,
//               "isBestMatch" : true,
//               "searchValue" : "brentwood"
//             };

//         // format json
//         $scope.locationParameters = JSON.stringify(example)
//             .replace(/,"/g, ',\n"')
//             .replace('{', '{\n')
//             .replace('}', '\n}');

//         $scope.onInputChange = function () {
//             var params = {};
//             // validate json
//             try {
//                 params = JSON.parse($scope.locationParameters);
//                 // create MDVSearchLocation element
//                 $scope.location = new MDVSearchLocation(params);
//                 $scope.hint = '';
//             } catch (e) {
//                 if (e.description) {
//                     $scope.hint = e.description + ((e.data && e.data.reason) ? ': ' + e.data.reason : '');
//                 } else {
//                     $scope.hint = 'Invalid JSON format';
//                 }
//                 $scope.location = null;
//             }
//         };
//         // initial run
//         $scope.onInputChange();
//     }]);
// </file>
// </example>
    angular.module('mng-model')
        .factory('mng-model.MDVSearchLocation', MDVSearchLocation);

    MDVSearchLocation.$inject = ['mng-util.MDVLog', 'mng-model.MDVUtil', 'mng-model.MDVLocation'];

    function MDVSearchLocation(MDVLog, MDVModelUtil, MDVLocation) {
        var namespace = 'mng-model.MDVSearchLocation',
            log = MDVLog.register(namespace);

        log.debug('initialize');

        return function(properties, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var _private,
                location;

            location = new MDVLocation(properties, true);
            _private = location._private;

            _private.$class = namespace;

            // add additional properties
            _private.prepareOwnProperties = prepareOwnProperties;
            _private.selectProperties = selectProperties;
            _private.updatePropertyVersion = updatePropertyVersion;

            _private.prepareOwnProperties(properties);

            // keep private functions in global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate !== true) {
                location._private = undefined;
            }

            // override methods
            _private.originalToJSON = location.toJSON;
            location.toJSON = toJSON.bind(location);

            // additional public methods
            location.isBestMatch = isBestMatch;
            location.matchQuality = matchQuality;
            location.searchValue = searchValue;

            // ////////////////////////////////

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVSearchLocation
             * @name isBestMatch
             * @returns {Boolean} true if location is best search result, false otherwise
             *
             * @description
             * Check if this location is the best search result in comparison to all other search
             * results available for the given searchValue. This information is provided by the
             * back-end to allow sorting and depends on server-side configuration.
             */
            function isBestMatch() {
                return _private.props.isBestMatch || false;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVSearchLocation
             * @name matchQuality
             * @returns {Number} quality the match has. 0 if no quality is provided.
             *
             * @description
             * Get the search quality of the location with respect to the given searchValue.
             * This quality is provided by the back-end to allow sorting.
             */
            function matchQuality() {
                return _private.props.matchQuality || 0;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVSearchLocation
             * @name searchValue
             * @returns {String} value the search was about and all parameters refer to.
             *
             * @description
             * Get the value of the location search. As the values can change
             * whenever the searchValue changes, this parameter is a required reference.
             */
            function searchValue() {
                return _private.props.searchValue || '';
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVSearchLocation
             * @name toJSON
             * @returns {Object} object with all necessary properties to reconstruct this object.
             *
             * @description
             * Get all properties of this object to reconstruct it later on. This method should be
             * used for persisting favorites or logging purposes. The returned object also provides
             * an version number, which allows the program to determine which interface version was
             * used for this formatting.
             *
             * **Note:** *This method is overridden in this class to extend the default
             * toJSON-output of a {@link mng-model.object:MDVLocation MDVLocation} with specific
             * properties that are available in this class.*
             */
            function toJSON() {
                var serialized = _private.originalToJSON.call(this);

                serialized = MDVModelUtil.setJSONValue.call(this, 'isBestMatch', serialized);
                serialized = MDVModelUtil.setJSONValue.call(this, 'matchQuality', serialized);
                serialized = MDVModelUtil.setJSONValue.call(this, 'searchValue', serialized);

                return serialized;
            }
            // //////////////////////////////////////

            function prepareOwnProperties(props) {
                if (!props) {
                    props = {};
                }
                props = _private.updatePropertyVersion(props);

                _private.selectProperties(props);
            }

            function selectProperties(props) {
                MDVModelUtil.setJSONValue.call(props, 'isBestMatch', location._private.props);
                MDVModelUtil.setJSONValue.call(props, 'matchQuality', location._private.props);
                MDVModelUtil.setJSONValue.call(props, 'searchValue', location._private.props);
            }

            function updatePropertyVersion(props) {
                return props;
            }


            return location;
        };
    }
}());

(function() {
    'use strict';

    /**
     * @constructor
     * @ngdoc object
     * @name mng-model.object:MDVMessage
     * @requires moment
     * @requires mng-util.service:MDVLog
     * @requires mng-config.service:MDVConfig
     * @requires mng-model.service:MDVUtil
     *
     * @description
     * The `MDVMessage` object is an abstract description of an information object. This object
     * describes disruptions, informations, or announcements for lines or stops.
     *
     * As this object provides an uniform interface, services and controllers can interact with it
     * in an uniform way, no matter where the information about this arrival comes from - as long as
     * the information is parsed to this object.
     *
     * ## Persistence
     * In order to persist this object and recreate it anytime in the future, you should use the
     * persist function. This function returns you all individual parameters needed, including a
     * version number that states in which format the data was persisted.
     *
     * This object ran through the following versions:
     * ### Version 2
     * Introduced in mng-model version 0.9.4 (04. October 2016)
     *
     * **NOTE:** *up to 0.8.5 affectedElements.lines was filled incorrectly (with stops).
     * This may cause issues. It is heavily recommended to remove
     * all old instances of MDVMessages that were created with older versions to avoid data loss
     * or incorrect behavior.*
     *
     *<table>
     * <tr>     <th>key</th>       <th>type</th>  <th>default</th>      <th>example</th></tr>
     * <tr><td>$version</td>      <td>Number</td> <td>2</td>     <td></td></tr>
     * <tr><td>$class</td>      <td>String</td> <td>'mng-model.MDVMessage'</td> <td></td></tr>
     * <tr><td></td>   <td></td> <td></td>    <td></td></tr>
     * <tr><td>affectedElements</td>  <td>Object</td> <td>{lines: [], stops : []}</td>
     * <td>see MDVLocation and MDVTransportation version 2.<br/><b>NOTE:</b><i>up to 0.8.5 lines
     * were filled wrongly (with stops). This may cause issues. It is heavily recommended to remove
     * all old instances of MDVMessages that were created with older versions to avoid data loss
     * or incorrect behavior.</i></td></tr>
     * <tr><td>content</td> <td>String</td> <td>''</td>  <td>'message content'</td></tr>
     * <tr><td>id</td>  <td>String</td> <td>''</td>  <td>'1231'</td></tr>
     * <tr><td>priority</td>  <td>String</td> <td>''</td>  <td>'high'</td></tr>
     * <tr><td>properties</td> <td>Object</td> <td>{}</td>  <td>set of key value pairs</td></tr>
     * <tr><td>subtitle</td>  <td>String</td> <td>''</td>  <td>'subtitle'</td></tr>
     * <tr><td>timestamps</td> <td>Object</td> <td>{}</td>  <td>{
     * availability : [{from: UTC, to: UTC}], creation: UTC, expiration: UTC, lastModification: UTC,
     * validity: [{from: UTC, to: UTC}]
     *}</td></tr>
     * <tr><td>title</td>  <td>String</td> <td>''</td>  <td>'title'</td></tr>
     * <tr><td>type</td>  <td>String</td> <td>''</td>  <td>'lineInfo'</td></tr>
     * <tr><td>url</td> <td>String</td> <td>''</td>  <td>'http://more.info'</td></tr>
     * <tr><td>urlText</td> <td>String</td> <td>''</td>  <td>'click here'</td></tr>
     * <tr><td>version</td> <td>Number</td> <td>0</td>  <td>1</td></tr>
     * </table>
     *
     * ### Version 1
     * **Note:** *Version 1 of this object is not supported any more.*
     *
     */


    angular.module('mng-model')
        .factory('mng-model.MDVMessage', MDVMessage);

    MDVMessage.$inject = ['moment', 'mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-model.MDVUtil'];

    function MDVMessage(moment, MDVLog, MDVConfig, MDVModelUtil) {
        var namespace = 'mng-model.MDVMessage',
            log = MDVLog.register(namespace),
            VERSION = 2,
            Constructor;

        log.debug('initialize');

        Constructor = function(props, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var _private = {
                prepareProperties : prepareProperties,
                selectProperties : selectProperties,
                updatePropertyVersion : updatePropertyVersion,
                raw : (props && props.raw) ? props.raw : {},
                $class : namespace,
                $version : VERSION,
                standardProperties : [
                    'content',
                    'id',
                    'priority',
                    'subtitle',
                    'title',
                    'type',
                    'url',
                    'urlText',
                    'version',
                    'additionalLinks',
                    'smsText',
                    'trafficDetails',
                    'coord',
                    'messageID',
                    'infoLink',
                    'creationTime',
                    'publicationDuration'
                ]
            };

            // assure raw is loaded correctly, before it is removed from props
            _private.props = prepareProperties(props);

            // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate === true) {
                this._private = _private;
            }

            // public
            this.additionalLinks = additionalLinks;
            this.affectedElements = affectedElements;
            this.affectedLines = affectedLines;
            this.affectedStops = affectedStops;
            this.availability = availability;
            this.availabilityFrom = availabilityFrom;
            this.availabilityTo = availabilityTo;
            this.content = content;
            this.creation = creation;
            this.equals = equals;
            this.expiration = expiration;
            this.id = id;
            this.isAvailable = isAvailable;
            this.isExpired = isExpired;
            this.isValid = isValid;
            this.lastModification = lastModification;
            this.priority = priority;
            this.properties = properties;
            this.raw = raw;
            this.subtitle = subtitle;
            this.timestamps = timestamps;
            this.title = title;
            this.toJSON = toJSON;
            this.type = type;
            this.url = url;
            this.urlText = urlText;
            this.smsText = smsText;
            this.validity = validity;
            this.validityFrom = validityFrom;
            this.validityTo = validityTo;
            this.version = version;
            this.trafficDetails = trafficDetails;
            this.coord = coord;
            this.messageID = messageID;
            this.infoLink = infoLink;
            this.creationTime = creationTime;
            this.publicationDuration = publicationDuration;

            // ////////////////////////////////

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name raw
             * @returns {Object} raw object the data of this model is from
             *
             * @description
             * Get the original response object the data of this model is from.
             */
            function raw() {
                return _private.raw || {};
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name equals
             * @param {MDVMessage} info Information object this object should be compared to
             * @returns {Boolean} true: information is the same, false otherwise.
             *
             * @description
             * Check if a given information object equals this information. Two informations are the
             * same if they share the same id.
             */
            function equals(info) {
                if (info) {
                    return id() === info.id();
                }
                return false;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name toJSON
             * @returns {Object} object with all necessary properties to reconstruct this object.
             *
             * @description
             * Get all properties of this object to reconstruct it later on. This method should be
             * used for persisting favorites or logging purposes. The returned object also provides
             * an version number, which allows the program to determine which interface version was
             * used for this formatting.
             */
            function toJSON() {
                var serialized = MDVModelUtil.getStandardJSON
                        .call(this, _private.$class, _private.$version, _private.standardProperties);

                MDVModelUtil.setValue
                    .call(this, 'affectedElements', serialized, function(value) {
                        return {
                            stops : MDVModelUtil.toJSONArray(value.stops),
                            lines : MDVModelUtil.toJSONArray(value.lines)
                        };
                    });
                MDVModelUtil.setValue
                    .call(this, 'properties', serialized, function(value) {
                        // assure properties are propert JSON
                        return JSON.parse(JSON.stringify(value));
                    });
                MDVModelUtil.setValue
                    .call(this, 'timestamps', serialized, function(value) {
                        var timestampObj = {};

                        if (value.availability) {
                            timestampObj.availability = MDVModelUtil.toJSONRange(value.availability);
                        }
                        if (value.creation) {
                            timestampObj.creation = value.creation.format();
                        }
                        if (value.expiration) {
                            timestampObj.expiration = value.expiration.format();
                        }
                        if (value.lastModification) {
                            timestampObj.lastModification = value.lastModification.format();
                        }
                        if (value.validity) {
                            timestampObj.validity = MDVModelUtil.toJSONRange(value.validity);
                        }
                        return timestampObj;
                    });

                return serialized;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name id
             * @returns {String} unique id of this version
             *
             * @description
             * Get the unique id of this information
             */
            function id() {
                return _private.props.id || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name type
             * @returns {String} type of this information
             *
             * @description
             * Get the type of this information
             */
            function type() {
                return _private.props.type || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name title
             * @returns {String} title of this information
             *
             * @description
             * Get the title of this information
             */
            function title() {
                return _private.getText.call(this, 'title');
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name subtitle
             * @returns {String} subtitle of this information
             *
             * @description
             * Get the subtitle of this information
             */
            function subtitle() {
                return _private.getText.call(this, 'subtitle');
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name content
             * @returns {String} content of this information
             *
             * @description
             * Get the main content of this information
             */
            function content() {
                return _private.getText.call(this, 'content') || _private.getText.call(this, 'text');
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name url
             * @returns {String} url of this information
             *
             * @description
             * Get the url of this information
             */
            function url() {
                return _private.getText.call(this, 'url');
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name urlText
             * @returns {String} urlText of this information
             *
             * @description
             * Get the urlText of this information
             */
            function urlText() {
                return _private.getText.call(this, 'urlText');
            }
            function smsText() {
                return _private.getText.call(this, 'smsText');
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name version
             * @returns {String} version of this information
             *
             * @description
             * Get the version of this information. If this information is updated, the version is
             * incremented by the server automatically.
             */
            function version() {
                return _private.props.version || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name priority
             * @returns {String} priority of this information
             *
             * @description
             * Get the priority of this information
             */
            function priority() {
                return _private.props.priority || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name properties
             * @returns {Object} Set of key-value properties
             *
             * @description
             * Get additional properties for this information.
             */
            function properties() {
                return _private.props.properties || {};
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name additionalLinks
             * @returns {MDVMessage[]} {@link mng-model.object:MDVMessage Message} List of additional
             * links the message has.
             *
             * @description
             * Get additional links for this message.
             */
            function additionalLinks() {
                return _private.props.additionalLinks || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name affectedElements
             * @returns {Object} Object that contains a "lines" and a "stops" parameter with a list
             * of {@link mng-model.object:MDVTransportation transportations} or {@link
             * mng-model.object:MDVLocation locations} that are affected by this information.
             *
             * @description
             * Get a list of {@link mng-model.object:MDVTransportation transportations} or {@link
             * mng-model.object:MDVLocation locations} that are affected by this information.
             */
            function affectedElements() {
                return _private.props.affectedElements || {
                    stops : [],
                    lines : []
                };
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name trafficDetails
             * @returns {Array} Set of key-value trafficDetails
             *
             * @description
             * Get additional properties for this information.
             */
             function trafficDetails() {
                return _private.props.trafficDetails || [];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name coord
             * @returns {Array} Set of key-value coords
             *
             * @description
             * Get additional properties for this information.
             */
             function coord() {
                return _private.props.coord || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name messageID
             * @returns {string} Set of key-value messageID
             *
             * @description
             * Get additional properties for this information.
             */
             function messageID() {
                return _private.props.messageID || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name infoLink
             * @returns {Array} Set of key-value infoLink
             *
             * @description
             * Get additional properties for this information.
             */
             function infoLink() {
                return _private.props.infoLink || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name creationTime
             * @returns {Object} Set of key-value creationTime
             *
             * @description
             * Get additional properties for this information.
             */
             function creationTime() {
                return _private.props.creationTime || {};
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name publicationDuration
             * @returns {Object} Set of key-value publicationDuration
             *
             * @description
             * Get additional properties for this information.
             */
             function publicationDuration() {
                return _private.props.publicationDuration || {};
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name affectedLines
             * @returns {MDVTransportation[]} List of {@link mng-model.object:MDVTransportation
             * transportations} that are affected by this information.
             *
             * @description
             * Get a list of {@link mng-model.object:MDVTransportation transportations}
             * that are affected by this information.
             */
            function affectedLines() {
                var elems = affectedElements(),
                    result;

                if (elems) {
                    result = elems.lines;
                }
                return result || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name affectedStops
             * @returns {MDVLocation[]} List of {@link mng-model.object:MDVLocation
             * locations} that are affected by this information.
             *
             * @description
             * Get a list of {@link mng-model.object:MDVLocation stops}
             * that are affected by this information.
             */
            function affectedStops() {
                var elems = affectedElements(),
                    result;

                if (elems) {
                    result = elems.stops;
                }
                return result || [];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name timestamps
             * @returns {Object} Object with moment objects for every timestamp available for this
             * information
             *
             * @description
             * Get a set of timestamps that are available for this information.
             */
            function timestamps() {
                return _private.props.timestamps || {};
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name expiration
             * @returns {Moment|null} Time when this information expires, null if no timestamp
             * is available.
             *
             * @description
             * Get a timestamps of the expiration time of this information.
             */
            function expiration() {
                return timestamps().expiration || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name creation
             * @returns {Moment|null} Time when this information is created, null if no timestamp
             * is available.
             *
             * @description
             * Get a timestamps of the creation time of this information.
             */
            function creation() {
                return timestamps().creation || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name timestamps
             * @param {Moment} [currentDate='now'] date that should be used for the expiration check
             * @returns {Boolean} True: information is expired, false: information is not expired.
             *
             * @description
             * Get a flag whether this information is expired or not.
             */
            function isExpired(currentDate) {
                var timestamp = expiration();

                if (!timestamp) {
                    return false;
                }
                if (!currentDate) {
                    currentDate = moment();
                }

                return timestamp.isBefore(currentDate);
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name lastModification
             * @returns {Moment|null} Time when this information was modified, null if no timestamp
             * is available.
             *
             * @description
             * Get a timestamps of the last modification time of this information on server side.
             */
            function lastModification() {
                return timestamps().lastModification || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name availability
             * @returns {Object[]} List of objects with to and from property with moment objects.
             *
             * @description
             * Get a list of timestamp-sets that describe when this information is supposed to be
             * available for public.
             */
            function availability() {
                return timestamps().availability || [];
            }

            function getRange(key, time) {
                var ranges = timestamps()[key] || [],
                    i,
                    l;

                for (i = 0, l = ranges.length; i < l; i += 1) {
                    if (time.isBefore(ranges[i].to)) {
                        return ranges[i];
                    }
                }
                return null;
            }
            function getRangeTimestamp(key, subkey, startDate) {
                var range = getRange(key, startDate || moment());

                if (range && range.hasOwnProperty(subkey)) {
                    return range[subkey];
                }
                return null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name availabilityFrom
             * @param {Moment} [startDate=moment()] optional start date to search for the next
             * period
             * @returns {Moment|null} Time when this information is supposed to be available for
             * public, null if no timestamp is available.
             *
             * @description
             * Get a timestamps from when this information should be available for public.
             *
             * **Note:** *It might be possible that more than one availability-range is provided by
             * the server. This method returns the timestamp of the range that comes up next,
             * compared to 'now'. To get all froms, please use the availability() function.*
             */
            function availabilityFrom(startDate) {
                return getRangeTimestamp('availability', 'from', startDate);
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name availabilityTo
             * @param {Moment} [startDate=moment()] optional start date to search for the next
             * period
             * @returns {Moment|null} Time when this information is supposed to be available for
             * public, null if no timestamp is available.
             *
             * @description
             * Get a timestamp until when this information should be available for public.
             *
             * **Note:** *It might be possible that more than one availability-range is provided by
             * the server. This method returns the timestamp of the range that comes up next,
             * compared to 'now'. To get all froms, please use the availability() function.*
             */
            function availabilityTo(startDate) {
                return getRangeTimestamp('availability', 'to', startDate);
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name isAvailable
             * @param {Moment} [currentDate=moment()] optional date to search for the next
             * period of availabilty
             * @returns {Boolean|null} True: this information should be available for the public,
             * false if it should not. null if no availability information is available.
             *
             * @description
             * Check whether this information is available for a passed time (or current time) or
             * not
             */
            function isAvailable(currentDate) {
                if (!currentDate) {
                    currentDate = moment();
                }
                var range = getRange('availability', currentDate);

                if (range) {
                    return range.from.isBefore(currentDate) && currentDate.isBefore(range.to);
                }
                return null;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name validity
             * @returns {Object[]} List of objects with to and from property with moment objects.
             *
             * @description
             * Get a list of timestamp-sets that describe when this information is valid.
             */
            function validity() {
                return timestamps().validity || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name validityFrom
             * @param {Moment} [startDate=moment()] optional start date to search for the next
             * period
             * @returns {Moment|null} Time when this information is valid,
             * null if no timestamp is available.
             *
             * @description
             * Get a timestamps from when this information is valid.
             *
             * **Note:** *It might be possible that more than one availability-range is provided by
             * the server. This method returns the timestamp of the range that comes up next,
             * compared to 'now' (or the passed date). To get all froms, please use the
             * validity() function.*
             */
            function validityFrom(startDate) {
                return getRangeTimestamp('validity', 'from', startDate);
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name validityTo
             * @param {Moment} [startDate=moment()] optional start date to search for the next
             * period
             * @returns {Moment|null} Time when this information is supposed to be valid,
             * null if no timestamp is available.
             *
             * @description
             * Get a timestamp until when this information is valid.
             *
             * **Note:** *It might be possible that more than one validity-range is provided by
             * the server. This method returns the timestamp of the range that comes up next,
             * compared to 'now' (or the passed date). To get all froms, please use the validity()
             * function.*
             */
            function validityTo(startDate) {
                return getRangeTimestamp('validity', 'to', startDate);
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVMessage
             * @name isValid
             * @param {Moment} [currentDate=moment()] optional date to search for the next
             * period of validity
             * @returns {Boolean|null} True: this information is valid for the current date,
             * false if it is not. null if no validity information is available.
             *
             * @description
             * Check if this message is valid for the given time (or current time), or not.
             */
            function isValid(currentDate) {
                if (!currentDate) {
                    currentDate = moment();
                }
                var range = getRange('validity', currentDate);

                if (range) {
                    return range.from.isBefore(currentDate) && currentDate.isBefore(range.to);
                }
                return null;
            }

            // ////////////////////////////////

            _private.getText = function(key) {
                var textMap = MDVConfig.getValue('mng-comm-model.MDVMessage.textMapping') || {},
                    altKey;

                if (textMap.hasOwnProperty(key)) {
                    altKey = textMap[key];
                }
                if (altKey) {
                    if (this.hasOwnProperty(altKey)) {
                        return this[altKey]();
                    }
                    if (this.properties()[altKey]) {
                        return this.properties()[altKey];
                    }
                }
                return _private.props[key] || '';
            };


            function prepareProperties(propertiesObj) {
                if (!propertiesObj) {
                    propertiesObj = {};
                }
                propertiesObj = _private.updatePropertyVersion(propertiesObj);

                // schema check
                // if (validateActive) {
                //     MDVValidator.check(properties, 'location').then(function(result) {
                //         if (result !== true) {
                //             log.error(result, true);
                //         }
                //     });
                // }

                return _private.selectProperties(propertiesObj);
            }

            function selectProperties(propertiesObj) {
                // set standard values
                var prepProps = MDVModelUtil.getStandardJSON
                    .call(propertiesObj, _private.$class, _private.$version,
                                                                    _private.standardProperties);

                // set complex properties
                MDVModelUtil.setValue
                    .call(propertiesObj, 'affectedElements', prepProps, function(value) {
                        return {
                            stops : MDVModelUtil.parseModels(value.stops),
                            lines : MDVModelUtil.parseModels(value.lines)
                        };
                    });

                MDVModelUtil.setValue.call(propertiesObj, 'properties', prepProps);

                MDVModelUtil.setValue
                    .call(propertiesObj, 'timestamps', prepProps, function(value) {
                        var elem,
                            result = {};

                        elem = MDVModelUtil.parseMoment(value.creation);
                        if (elem) {
                            result.creation = elem;
                        }
                        elem = MDVModelUtil.parseMoment(value.expiration);
                        if (elem) {
                            result.expiration = elem;
                        }
                        elem = MDVModelUtil.parseMoment(value.lastModification);
                        if (elem) {
                            result.lastModification = elem;
                        }
                        elem = MDVModelUtil.parseMomentRange(value.availability);
                        if (elem && elem.length) {
                            result.availability = elem;
                        }
                        elem = MDVModelUtil.parseMomentRange(value.validity);
                        if (elem && elem.length) {
                            result.validity = elem;
                        }

                        return result;
                    });

                return prepProps;
            }

            function updatePropertyVersion(propertiesObj) {
                if (propertiesObj.hasOwnProperty('VERSION')) {
                    log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                        'please delete all old versions to avoid data loss or incorrect behavior');
                    return {};
                }
                // version check
                if (propertiesObj.$version && propertiesObj.$version !== _private.$version) {
                    if (propertiesObj.$version > VERSION) {
                        log.error('unknown version: ' + propertiesObj.$version +
                            '. Highest available version: ' + _private.$version);

                        return {};
                    }
                    // convert values to current version
                    // if (propertiesObj.$version === 2) {
                    //     propertiesObj.xy = propertiesObj.oldValue;
                    // }

                    // all other unsupported/ unknown versions
                    if (propertiesObj.$version === 1) {
                        log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                            'please delete all old versions to avoid data loss or incorrect behavior');
                        return {};
                    } else {
                        // all others
                        log.error('unknown version: ' + propertiesObj.$version +
                            '. Lowest available version: 1');

                        return {};
                    }
                }
                return propertiesObj;
            }

            return this;
        };

        return Constructor;
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @constructor
     * @ngdoc object
     * @name mng-model.object:MDVLocation
     * @requires mng-util.service:MDVLog
     *
     * @description
     * The `MDVLocation` object is an abstract description of a stop, coordinate, point of interest
     * (POI) or location.
     * As this object provides an uniform interface, services and controllers can interact with it
     * in an uniform way, no matter where the information about this location comes from - as long
     * as the information is parsed to this object.
     *
     * A `MDVLocation` describes any kind of verified point in the EFA. This can include several
     * types, like stops, point of interests or even addresses, or even crossings.
     * The most interesting location is a stop, or a platform (stop point). These locations are
     * explicitly constructed in the DIVA system.
     *
     * The most interesting location is a stop, or a platform (stop point). These locations are
     * explicitly constructed in the DIVA system.
     * General stop (as it is supposed to be constructed):
     *
     * stop or stop group      - Central Station
     *
     * stop area               - Central Station, Main hall, Central Station platform 1&2 (if both
     * are accessible via one way)
     *
     * stop point ("platform") - Central Station platform 1
     *
     * As stop area is not interesting for routing (and no end-user understands the concept of areas
     * without explicit explanation), it is not supposed to be modeled in the EFA response.
     *
     * This construct leads to "funny" transfer legs from one stop point to another stop point,
     * although they are both part of one stop. So if you display not enough information it seems
     * strange to have a transfer leg from Central Station to Central Station (which is for example
     * Platform 5 to Platform 1)
     *
     * We tried to model this construct with a parent hierarchy:
     *
     * platform.parent() = stop
     * stop.parent() = locality
     *
     * There are plenty of options how to add names to a stop/platform in DIVA. You can even specify
     * the name of a platform regarding to the departing transportation (think of "Central Station
     * Platform 1" for city-trains and "Central Station Regional Departure Platform" for regional
     * trains, not sure if you have this kind of stuff)
     *
     * A stop name with place information (Central Station, Sydney) and a stop name without place
     * information (Central Station) can be specified. This is often used to avoid funny constructs
     * like "Munich Central Station, Munich", so the name with place field in DIVA can be populated
     * with "Munich Central Station".
     *
     * As there is so much flexibility in DIVA inputs, so are the EFA outputs, so it is impossible
     * for the modules to capture all specialities (except they start string parsing and even then
     * it is quite impossible). So the EFA output always heavily depends to the regarding DIVA input
     * and model, how the whole network is implemented.
     *
     * The modules rely on the default behavior, which means:
     *
     * location.name() is the name attribute provided by EFA (which is supposed to be the best
     * fitting name for this specific element)
     * location.disassembledName() is the name without place information
     *
     * Due to the introduced hiearchy described above, the transmitted "platform" information is
     * available in location.disassembledName(), if the localitiy is a platform. location.name() is
     * the best fitting name, so it can also include stop and locality name.
     *
     * addresses, localities, crossings, ...  dont have a stop as parent (this would mean that at
     * every point in the world a complete stop is available)
     *
     * ## General usage
     * To create a `MDVLocation` object, the constructor needs to be called with a set of properties
     * that describe the object.
     *
     * ```js
     *   // creation of a new MDVLocation
     *   var mdv_location = new MDVLocation({
     *      id : '10102027',
     *      coord : [-33.79931, 151.28432],
     *      name : 'Manly Wharf'
     *   });
     * ```
     *
     * Every `MDVLocation` has getter methods to access its properties. Please refer to the
     * method documentation for a detailed description of the according attribute.
     *
     * ```js
     *   // get id of a MDVLocation
     *   console.log(mdv_location.id());  // '10102027'
     * ```
     *
     * ## Persistence
     * In order to persist this object and recreate it anytime in the future, you should use the
     * persist function. This function returns you all individual parameters needed, including a
     * version number that states in which format the data was persisted.
     *
     * This object ran through the following versions:
     * ### Version 2
     * Introduced in mng-model version 0.8.2 (04. October 2016)
     *<table>
     * <tr>     <th>key</th>       <th>type</th>  <th>default</th>      <th>example</th></tr>
     * <tr><td>$version</td>      <td>Number</td> <td>2</td>     <td></td></tr>
     * <tr><td>$class</td>      <td>String</td> <td>'mng-model.MDVLocation'</td> <td></td></tr>
     * <tr><td></td>   <td></td> <td></td>    <td></td></tr>
     * <tr><td>assignedStops</td><td>Object[]</td> <td>[]</td>   <td>List of MDVLocation Version 2</td></tr>
     * <tr><td>buildingNumber</td><td>String</td> <td>''</td>    <td>'25'</td></tr>
     * <tr><td>coord</td>       <td>Number[]</td> <td>null</td>  <td>[-33.79931,151.28432]</td></tr>
     * <tr><td>disassembledName</td> <td>String</td> <td>''</td>  <td>'Brentwood Dr'</td></tr>
     * <tr><td>downloads</td> <td>Object[]</td> <td>[]</td>  <td>[{url: '/example.pdf', name: 'ex'}]</td></tr>
     * <tr><td>id</td>            <td>String</td> <td>''</td>    <td>'streetID:38927::953'</td></tr>
     * <tr><td>infos</td>       <td>Object[]</td> <td>[]</td>    <td>List of info objects.</td></tr>
     * <tr><td>name</td>          <td>String</td> <td>''</td>    <td>'Sydney, Brentwood Dr'</td></tr>
     * <tr><td>parent</td>        <td>Object</td> <td>{}</td>    <td>MDVLocation version 2</td></tr>
     * <tr><td>productClasses</td>       <td>Number[]</td> <td>[]</td>    <td>[0, 3, 5]</td></tr>
     * <tr><td>properties</td>   <td>Object</td> <td>{}</td>     <td>key-value pairs of additional
     * properties. Downloads are available here, too.</td></tr>
     * <tr><td>type</td>   <td>String</td> <td>'unknown'</td>    <td>Possible values: 'crossing', 'locality',
     * 'district' (= previous 'suburb'), 'poi', 'address', stop', 'platform', 'street' or 'unknown'</td></tr>
     * </table>
     *
     * ### Version 1
     * **Note:** *Version 1 of locations is still supported by the modules, but data loss and
     * unexpected behavior can occur. It is hardly recommended to delete all instances with
     * version 1 or older (instances without version attribute or with VERSION instead of $version).
     * Using these old versions will log a warning to the console.*
     *
     */
     // * Please refer to the example below for further details.
//      * @example
// <example module="MDVLocationExample">
// <file name="index.html">
//   <div ng-controller="LocationController" style="min-height:45em;">
//         <div>Properties the MDVLocation is initialized with:</div>
//         <textarea style="width:100%;height:20em;" ng-model="locationParameters" ng-change="onInputChange()"></textarea>
//         <div ng-show="hint">{{hint}}</div>
//         <div ng-show="location">
//           <div>Result:</div>
//           <table style="text-align:left !important;">
//             <tr><th style="width:15em;">function</th><th>value</th></tr>
//             <tr><td>MDVLocation.buildingNumber()</td><td>{{location.buildingNumber()}}</td></tr>
//             <tr><td>MDVLocation.coordLatLng()</td><td>{{location.coordLatLng()}}</td></tr>
//             <tr><td>MDVLocation.coordString()</td><td>{{location.coordString()}}</td></tr>
//             <tr><td>MDVLocation.id()</td><td>{{location.id()}}</td></tr>
//             <tr><td>MDVLocation.hasCoords()</td><td>{{location.hasCoords()}}</td></tr>
//             <tr><td>MDVLocation.modes()</td><td>{{location.modes()}}</td></tr>
//             <tr><td>MDVLocation.name()</td><td>{{location.name()}}</td></tr>
//             <tr><td>MDVLocation.type()</td><td>{{location.type()}}</td></tr>
//           </table>
//         </div>
//     </div>
// </file>
// <file name="script.js">
//   angular.module('MDVLocationExample', ['mng-model'])
//     .controller('LocationController', ['$scope', 'mng-model.MDVLocation',
//     function ($scope, MDVLocation) {
//         var example = {
//               "id" : "streetID:38920:25:95317004:-1:Brentwood Dr:Clarence Town:Brentwood Dr:nsw",
//               "type" : "singlehouse",
//               "name" : "Brentwood Dr",
//               "buildingNumber" : "25",
//               "name" : "Clarence Town",
//               "coord" : [151.75752,-32.59597]
//             };

//         // format json
//         $scope.locationParameters = JSON.stringify(example)
//             .replace(/,"/g, ',\n"')
//             .replace('{', '{\n')
//             .replace('}', '\n}');

//         $scope.onInputChange = function () {
//             var params = {};
//             // validate json
//             try {
//                 params = JSON.parse($scope.locationParameters);
//                 // create MDVLocation element
//                 $scope.location = new MDVLocation(params);
//                 $scope.hint = '';
//             } catch (e) {
//                 if (e.description) {
//                     $scope.hint = e.description + ((e.data && e.data.reason) ? ': ' + e.data.reason : '');
//                 } else {
//                     $scope.hint = 'Invalid JSON format';
//                 }
//                 $scope.location = null;
//             }
//         };
//         // initial run
//         $scope.onInputChange();
//     }]);
// </file>
// </example>
    /**
     * @ngdoc property
     * @name mng-model.object:MDVLocation#LOCATIONTYPES
     * @propertyOf mng-model.object:MDVLocation
     *
     * @description
     * **Object**
     *
     * This set of types offers a mapping from abstract enumeration values to actual string
     * descriptions. This set provides all available types a {@link mng-model.object:MDVLocation
     * MDVLocation} can have. It contains the following values:
     * - LOCATIONTYPES.ADDRESS    ('address' ) a specific address
     * - LOCATIONTYPES.STOP_AREA  ('area' )    a stop area within a stop
     * **NOTE:** *This type is only used for stop structure request. In order to keep the data
     * model simple, all other locations consist of a platform and a stop, skipping the area level*
     * - LOCATIONTYPES.CROSSING   ('crossing') crossing of two streets
     * - LOCATIONTYPES.SUBURB     ('suburb') part of a locality, usually separated by postcode.
     * - LOCATIONTYPES.GIS        ('gis'     ) point defined in the lowlevel gis
     * - LOCATIONTYPES.LOCALITY   ('locality') locality
     * - LOCATIONTYPES.PARKING    ('parking' ) parking lot
     * - LOCATIONTYPES.POI        ('poi'     ) point of interest/ landmark
     * - LOCATIONTYPES.POI_AREA   ('aoi'     ) area of interest/ landmark
     * - LOCATIONTYPES.SHARING    ('sharing' ) sharing provider like car2go or callAbike
     * - LOCATIONTYPES.STOP       ('stop'    ) stop, a combination of platforms
     * - LOCATIONTYPES.STOP_POINT ('platform') a platform within a stop
     * - LOCATIONTYPES.STREET     ('street'  ) complete street
     * - (default) LOCATIONTYPES.UNKNOWN ('unknown') the type of the location is not known
     */
    angular.module('mng-model')
        .factory('mng-model.MDVLocation', MDVLocation);

    MDVLocation.$inject = ['mng-util.MDVLog', 'mng-util.MDVUtil', 'mng-model.MDVUtil'];

    function MDVLocation(MDVLog, MDVUtil, MDVModelUtil) {
        var namespace = 'mng-model.MDVLocation',
            log = MDVLog.register(namespace),
            // validateActive = false,
            VERSION = 2,
            // mind parser if assigned strings change for Enumeration keys
            types = {
                ADDRESS : 'address',
                CROSSING : 'crossing',
                GIS : 'gis',
                LOCALITY : 'locality',
                PARKING : 'parking',
                POI : 'poi',
                POI_AREA : 'aoi',
                SHARING : 'sharingProvider',
                STOP : 'stop',
                STOP_AREA : 'area',
                STOP_POINT : 'platform',
                STREET : 'street',
                SUBURB : 'suburb',
                UNKNOWN : 'unknown'
            },
            Constructor;

        log.debug('initialize');

        Constructor = function(props, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var _private = {
                prepareProperties : prepareProperties,
                selectProperties : selectProperties,
                updatePropertyVersion : updatePropertyVersion,
                raw : (props && props.raw) ? props.raw : {},
                standardProperties : [
                    'buildingNumber',
                    'coord',
                    'disassembledName',
                    'downloads',
                    'id',
                    'name',
                    'productClasses',
                    'type',
                    'subType'
                ],
                $version : VERSION,
                $class : namespace
            };

            // assure raw is loaded correctly, before it is removed from props
            _private.props = _private.prepareProperties(props);

            // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate === true) {
                this._private = _private;
            }

            // private functions with no chance to make fully them private.
            // FOR MODULE INTERNAL USAGE ONLY
            this._updateProperty = _updateProperty;
            this._bindInfos = _bindInfos;

            // public

            this.assignedStops = assignedStops;
            this.buildingNumber = buildingNumber;
            this.coord = coordLatLng;
            this.coordLatLng = coordLatLng;
            this.coordString = coordString;
            this.disassembledName = disassembledName;
            this.downloads = downloads;
            this.equals = equals;
            this.hasCoords = hasCoords;
            this.id = id;
            this.infos = infos;
            this.isValid = isValid;
            this.name = name;
            this.parent = parent;
            this.productClasses = productClasses;
            this.properties = getProperties;
            this.raw = raw;
            this.subType = subType;
            this.reset = reset;
            this.transportations = transportations;
            this.toJSON = toJSON;
            this.type = type;

            this.LOCATIONTYPES = MDVUtil.copy(types);  // avoid modification from outside

            // ////////////////////////////////

            // update internal property object.
            // for module usage only. do not use this method outside of the modules!
            function _updateProperty(key, value) {
                if (key !== '$version' && key !== '$class') {
                    if (_private.props.hasOwnProperty(key)) {
                        log.info('override existing property: ' + key);
                    }
                    // assure values are parsed as expected
                    var updateProps = {};

                    updateProps[key] = value;
                    updateProps = _private.selectProperties(updateProps);

                    _private.props[key] = updateProps[key];
                }
            }

            // bind infos to the location after creation
            function _bindInfos(infoList) {
                if (!infoList) {
                    return;
                }
                _private.props.infos = infoList;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name assignedStops
             * @returns {MDVLocation[]} List of {@link mng-model.object:MDVAssignedLocation
             * assigned locations}, empty list, if no stop is assigned, or no information is
             * available.
             *
             * @description
             * Get a list of assigned stops. Assigned stops are stops that are in a close range to
             * this location and also used for routing.
             */
            function assignedStops() {
                return _private.props.assignedStops || [];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name buildingNumber
             * @returns {String} building number of the location. Empty string if not available.
             *
             * @description
             * Get the building number of the location.
             */
            function buildingNumber() {
                return _private.props.buildingNumber || '';
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name coord
             * @returns {Number[]|null} Coordinates, e.g. [-33.79931, 151.28432]. null if not available.
             *
             * @description
             * Get the coordinates the location is at in valid {@link
             * http://leafletjs.com/reference.html#latlng Leaflet LatLng} (array) format.
             */
             // coord method is just a reference to the coordLatLng method.
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name coordLatLng
             * @returns {Number[]|null} Coordinates, e.g. [-33.79931, 151.28432]. null if not available.
             *
             * @description
             * Get the coordinates the location is at in valid {@link
             * http://leafletjs.com/reference.html#latlng Leaflet LatLng} (array) format.
             */
            function coordLatLng() {
                return _private.props.coord || null;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name coordString
             * @returns {String} Coordinates, e.g. '-33.79931,151.28432'. Empty string if not available.
             *
             * @description
             * Get the coordinates the location is at in string format.
             */
            function coordString() {
                if (!_private.props.coord || _private.props.coord.length !== 2) {
                    return '';
                }
                return _private.props.coord[0] + ',' + _private.props.coord[1];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name disassembledName
             * @param {Boolean} [doNotFallbackToName=false] if set to true, it disables the fallback
             * to name and returns an empty string if no disassembledName is available.
             * @returns {String} location name
             *
             * @description
             * Get the name of the location. This name is populated in diva and supposed to describe
             * the location without locality information.
             */
            function disassembledName(doNotFallbackToName) {
                if (doNotFallbackToName) {
                    return _private.props.disassembledName || '';
                }
                return _private.props.disassembledName || this.name();
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name downloads
             * @returns {Object[]} the list of available downloadable files of a location (station plan...).
             * @description
             * Get the list of downloadable files of a location (station plan...)
             */
            function downloads() {
                if (_private.props.downloads) {
                    return _private.props.downloads;
                }
                if (_private.props.properties && _private.props.properties.downloads) {
                    return _private.props.properties.downloads;
                }
                return _private.props.downloads || [];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name equals
             * @param {MDVLocation} location object that should be compared with this leg.
             * @returns {Boolean} true: location is the same, false otherwise.
             *
             * @description
             * Check if a given location object equals this location.
             * Two location are the same if they share the same id.
             */
            function equals(location) {
                // might also check if passed location is location, but id check should be enough
                if (!location || !location.id) {
                    return false;
                }
                return id.call(this) === location.id();
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name properties
             * @returns {Object} Additional properties that are bound to this location
             *
             * @description
             * Get additional properties of this location.
             */
            function getProperties() {
                return _private.props.properties || {};
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name hasCoords
             * @returns {Boolean} true: has coordinate information, false otherwise.
             *
             * @description
             * Determine whether this location has coordinate information or not.
             */
            function hasCoords() {
                return _private.props.hasOwnProperty('coord') && Boolean(_private.props.coord);
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name id
             * @returns {String} unique ID
             *
             * @description
             * Get the location's unique ID string the location can be referred to.
             *
             * Example: *'streetID:38927::95317004:-1:Duke:Clarence Town:nsw'*
             *
             * The {@link mng-comm.itd.service:MDVLocationParser MDVLocationParser} uses the EFA
             * stateless-ID, as this ID is unique throughout the complete architecture. This ID is
             * also used for further requests to the EFA back-end.
             */
            function id() {
                if (_private.props.id !== '-1') {
                    return _private.props.id || '';
                }
                return '';
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name infos
             * @returns {MDVMessage[]} list of information objects
             *
             * @description
             * Get informations that are bound to this location.
             */
            function infos() {
                return _private.props.infos || [];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name isValid
             * @returns {Boolean} True: valid object, false otherwise.
             *
             * @description
             * Determine whether the current object is valid and able to perform requests or not.
             */
            function isValid() {
                // check for required properties
                if (!this.id()) {
                    return false;
                }
                return true;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name productClasses
             * @returns {Number[]} list of productClasses
             *
             * @description
             * Get the information of all means of transport that arrive/ depart from this location.
             */
            function productClasses() {
                return _private.props.productClasses || [];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name name
             * @returns {String} location name
             *
             * @description
             * Get the name of the location. This name is supposed to be the most detailed name for
             * this location, populated in diva. To get a less descriptive name of the location, use
             * the disassembledName getter function.
             */
            function name() {
                return _private.props.name || '';
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name parent
             * @returns {MDVLocation|null} parent of this location, null if no parent is available
             *
             * @description
             * Get the parent of this location. As the parent is again an
             * {@link mng-model.object:MDVLocation
             * MDVLocation}, the parent can contain another parent and so on. This allows a complex
             * structure that provides all containing parents.
             */
            function parent() {
                return _private.props.parent || null;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name raw
             * @returns {Object} raw object the data of this model is from
             *
             * @description
             * Get the original response object the data of this model is from.
             *
             * **Note:** *The raw method should not be used to retrieve information out of this
             * object. All necessary information should be available through getter functions. If
             * there is some information missing, it is likely to be a parser issue. This method
             * is for debug purposes only and should not be used in production code.*
             */
            function raw() {
                return _private.raw;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name subType
             * @returns {String} Description of the {@link mng-model.object:MDVLocation#LOCATIONTYPES
             * location subType}.
             *
             * @description
             * Get the subType of the location. All possible types are available via the constructor
             * (MDVLocation.{@link mng-model.object:MDVLocation#LOCATIONTYPES LOCATIONTYPES}) or via
             * an instance (locationInstance.{@link mng-model.object:MDVLocation#LOCATIONTYPES
             * LOCATIONTYPES}).
             * In order to check whether a {@link mng-model.object:MDVLocation MDVLocation} has a
             * specific subType or not, use these LOCATIONTYPEs. This assures that the actual strings
             * used for the type description are not hard-coded in production code.
             */
            function subType() {
                return _private.props.subType || types.UNKNOWN;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name reset
             *
             * @description
             * Remove all properties of this location.
             *
             * **Note:** *This action is irreversible.*
             */
            function reset() {
                _private.props = _private.prepareProperties();
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name toJSON
             * @returns {Object} object with all necessary properties to reconstruct this object.
             *
             * @description
             * Get all properties of this object to reconstruct it later on. This method should be
             * used for persisting favorites or logging purposes. The returned object also provides
             * an version number, which allows the program to determine which interface version was
             * used for this formatting.
             */
            function toJSON() {
                var serialized = MDVModelUtil.getStandardJSON
                       .call(this, _private.$class, _private.$version, _private.standardProperties);

                serialized = MDVModelUtil.setJSONValue
                    .call(this, 'parent', serialized, function(value) {
                        return value.toJSON();
                    });

                serialized = MDVModelUtil.setJSONValue
                    .call(this, 'assignedStops', serialized, function(value) {
                        var i, l,
                            result = [];

                        for (i = 0, l = value.length; i < l; i += 1) {
                            result.push(value[i].toJSON());
                        }

                        return result;
                    });


                serialized = MDVModelUtil.setJSONValue
                    .call(this, 'infos', serialized, function(value) {
                        var i, l,
                            result = [];

                        for (i = 0, l = value.length; i < l; i += 1) {
                            result.push(value[i].toJSON());
                        }

                        return result;
                    });

                serialized = MDVModelUtil.setJSONValue
                    .call(this, 'properties', serialized, function(value) {
                        // assure properties are pure json
                        return JSON.parse(JSON.stringify(value));
                    });

                serialized = MDVModelUtil.setJSONValue
                    .call(this, 'transportations', serialized, function(value) {
                        var i, l,
                            result = [];

                        for (i = 0, l = value.length; i < l; i += 1) {
                            result.push(value[i].toJSON());
                        }

                        return result;
                    });

                // do not return duplicated name if no own disassembled name is provided
                if (serialized.name === serialized.disassembledName) {
                    delete serialized.disassembledName;
                }

                return serialized;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name transportations
             * @returns {MDVTransportation[]} List of transportations that depart from this location
             *
             * @description
             * Get a list of {@link mng-model.object:MDVTransportation transportations} that depart
             * from this location.
             *
             * **NOTE:** *This field is usually not filled per default.*
             */
            function transportations() {
                return _private.props.transportations || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVLocation
             * @name type
             * @returns {String} Description of the {@link mng-model.object:MDVLocation#LOCATIONTYPES
             * location type}.
             *
             * @description
             * Get the type of the location. All possible types are available via the constructor
             * (MDVLocation.{@link mng-model.object:MDVLocation#LOCATIONTYPES LOCATIONTYPES}) or via
             * an instance (locationInstance.{@link mng-model.object:MDVLocation#LOCATIONTYPES
             * LOCATIONTYPES}).
             * In order to check whether a {@link mng-model.object:MDVLocation MDVLocation} has a
             * specific type or not, use these LOCATIONTYPEs. This assures that the actual strings
             * used for the type description are not hard-coded in production code.
             */
            function type() {
                return _private.props.type || types.UNKNOWN;
            }


            // ////////////////////////////////

            function prepareProperties(properties) {
                if (!properties) {
                    properties = {};
                }
                properties = _private.updatePropertyVersion(properties);

                // schema check
                // if (validateActive) {
                //     MDVValidator.check(properties, 'location').then(function(result) {
                //         if (result !== true) {
                //             log.error(result, true);
                //         }
                //     });
                // }

                return _private.selectProperties(properties);
            }

            function selectProperties(properties) {
                // set standard values
                var prepProps = MDVModelUtil.getStandardJSON
                    .call(properties, _private.$class, _private.$version,
                                                                    _private.standardProperties);

                // set complex properties
                prepProps = MDVModelUtil.setJSONValue
                    .call(properties, 'assignedStops', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });

                prepProps = MDVModelUtil.setJSONValue.call(properties, 'properties', prepProps);

                prepProps = MDVModelUtil.setJSONValue
                    .call(properties, 'parent', prepProps, function(value) {
                        return MDVModelUtil.parseModel(value);
                    });

                prepProps = MDVModelUtil.setJSONValue
                    .call(properties, 'infos', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });

                prepProps = MDVModelUtil.setJSONValue
                    .call(properties, 'transportations', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });

                prepProps = MDVModelUtil.setJSONValue
                    .call(properties, 'downloads', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });

                return prepProps;
            }

            function updatePropertyVersion(properties) {
                if (properties.hasOwnProperty('VERSION')) {
                    log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                        'please delete all old versions to avoid data loss or incorrect behavior');
                    return {};
                }
                // version check
                if (properties.$version && properties.$version !== _private.$version) {
                    if (properties.$version > VERSION) {
                        log.error('unknown version: ' + properties.$version +
                            '. Highest available version: ' + _private.$version);

                        return {};
                    }
                    // convert values to current version
                    // if (properties.$version === 2) {
                    //     properties.xy = properties.oldValue;
                    // }

                    // all other unsupported/ unknown versions
                    if (properties.$version === 1) {
                        log.warn('depreciated version. Version 1 is no longer supported by the ' +
                            'modules. In order to assure a correct workflow and to prevent data ' +
                            'loss, please delete all old versions.');

                        // cut support version 1 and older
                        return {};
                    } else {
                        // all others
                        log.error('unknown version: ' + properties.$version +
                            '. Lowest supported version: 2');

                        return {};
                    }
                }
                return properties;
            }

            return this;
        };

        Constructor.LOCATIONTYPES = MDVUtil.copy(types);  // avoid modification from outside
        return Constructor;
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @constructor
     * @ngdoc object
     * @name mng-model.object:MDVJourneyLocation
     * @requires mng-util.service:MDVLog
     * @requires mng-util.object:MDVException
     * @requires mng-model.object:MDVLocation
     *
     * @description
     * The `MDVJourneyLocation` object is an extension of a {@link mng-model.object:MDVLocation
     * MDVLocation} to provide additional information for locations that are used for journey
     * description.
     *
     * ## General usage
     * To create a `MDVJourneyLocation` object, the constructor needs to be called with a set of
     * properties that describe the object.
     *
     * ```js
     *   // creation of a new MDVJourneyLocation
     *   var journey_location = new MDVJourneyLocation({
     *      id : '10102027',
     *      coord : [-33.79931, 151.28432],
     *      name : 'Manly Wharf',
     *      departureTimePlanned: moment()
     *   });
     * ```
     *
     * Every `MDVJourneyLocation` has getter methods to access its properties. Please refer to the
     * method documentation for a detailed description
     * of the according attribute. Only `MDVJourneyLocation` specific properties
     * are described. All other properties are described in the {@link mng-model.object:MDVLocation
     * MDVLocation} documentation.
     *
     * ```js
     *   // get the time of departure of a MDVJourneyLocation
     *   console.log(journey_location.departureTime().format('HH:mm'));  // 12:19
     * ```
     *
     * ## Persistence
     * In order to persist this object and recreate it anytime in the future, you should use the
     * persist function. This function returns you all individual parameters needed, including a
     * version number that states in which format the data was persisted.
     *
     * This object ran through the following versions:
     * ### Version 2
     * Introduced in mng-model version 0.8.2 (04. October 2016)
     *
     * **NOTE:** *This table only includes all additional properties the persisted location has.
     * It also includes all properties a {@link mng-model.object:MDVLocation MDVLocation} with the
     * same version number provides.*
     *
     *<table>
     * <tr>     <th>key</th>       <th>type</th>  <th>default</th>      <th>example</th></tr>
     * <tr><td>$version</td>      <td>Number</td> <td>2</td>     <td></td></tr>
     * <tr><td>$class</td>      <td>String</td> <td>'mng-model.MDVJourneyLocation'</td> <td></td></tr>
     * <tr><td></td>   <td></td> <td></td>    <td></td></tr>
     * <tr><td></td>   <td></td> <td></td>    <td></td></tr>
     * <tr><td>arrivalTimePlanned</td>   <td>String</td> <td>''</td> <td>ISO date/time string</td></tr>
     * <tr><td>arrivalTimeEstimated</td>  <td>String</td> <td>''</td> <td>ISO date/time string</td></tr>
     * <tr><td>departureTimePlanned</td>  <td>String</td> <td>''</td> <td>ISO date/time string</td></tr>
     * <tr><td>departureTimeEstimated</td><td>String</td> <td>''</td> <td>ISO date/time string</td></tr>
     * <tr><td>isRealtimeControlled</td><td>Boolean</td> <td>undefined</td> <td>true</td></tr>
     * <tr><td>isCancelled</td><td>Boolean || string[]</td> <td>undefined</td> <td>true</td></tr>
     * </table>
     *
     * ### Version 1
     * **Note:** *Version 1 of locations is still supported by the modules, but data loss and
     * unexpected behavior can occur. It is hardly recommended to delete all instances with
     * version 1 or older (instances without version attribute or with VERSION instead of $version).
     * Using these old versions will log a warning to the console.*
     *
     */
//      * Please refer to the example below for further details.
//      *
//      * @example
// <example module="MDVJourneyLocationExample">
// <file name="index.html">
//   <div ng-controller="JourneyLocationController" style="min-height:45em;">
//         <div>Properties the MDVJourneyLocation is initialized with:</div>
//         <textarea style="width:100%;height:20em;" ng-model="locationParameters"
//             ng-change="onInputChange()"></textarea>
//         <div ng-show="hint">{{hint}}</div>
//         <div ng-show="location">
//           <div>Result:</div>
//           <table style="text-align:left !important;">
//             <tr><th style="width:15em;">function</th><th>value</th></tr>
//             <tr><td colspan="2"><b>Standard MDVLocation parameters:</b></td><td></td></tr>
//             <tr><td>MDVJourneyLocation.buildingNumber()</td><td>{{location.buildingNumber()}}</td></tr>
//             <tr><td>MDVJourneyLocation.coordLatLng()</td><td>{{location.coordLatLng()}}</td></tr>
//             <tr><td>MDVJourneyLocation.coordString()</td><td>{{location.coordString()}}</td></tr>
//             <tr><td>MDVJourneyLocation.description()</td><td>{{location.description()}}</td></tr>
//             <tr><td>MDVJourneyLocation.id()</td><td>{{location.id()}}</td></tr>
//             <tr><td>MDVJourneyLocation.hasCoords()</td><td>{{location.hasCoords()}}</td></tr>
//             <tr><td>MDVJourneyLocation.modes()</td><td>{{location.modes()}}</td></tr>
//             <tr><td>MDVJourneyLocation.name()</td><td>{{location.name()}}</td></tr>
//             <tr><td>MDVJourneyLocation.type()</td><td>{{location.type()}}</td></tr>
//             <tr><td colspan="2"><b>Additional parameters (delays are left out as no moment objects are
//                 available):</b></td></tr>
//             <tr><td>MDVJourneyLocation.departureTime()</td><td>{{location.departureTime()}}</td></tr>
//             <tr><td>MDVJourneyLocation.departureTimeEstimated()</td><td>{{location.departureTimeEstimated()}}</td></tr>
//             <tr><td>MDVJourneyLocation.departureTimePlanned()</td><td>{{location.departureTimePlanned()}}</td></tr>
//             <tr><td>MDVJourneyLocation.arrivalTime()</td><td>{{location.arrivalTime()}}</td></tr>
//             <tr><td>MDVJourneyLocation.arrivalTimeEstimated()</td><td>{{location.arrivalTimeEstimated()}}</td></tr>
//             <tr><td>MDVJourneyLocation.arrivalTimePlanned()</td><td>{{location.arrivalTimePlanned()}}</td></tr>
//             <tr><td>MDVJourneyLocation.time()</td><td>{{location.time()}}</td></tr>
//             <tr><td>MDVJourneyLocation.timeEstimated()</td><td>{{location.timeEstimated()}}</td></tr>
//             <tr><td>MDVJourneyLocation.timePlanned()</td><td>{{location.timePlanned()}}</td></tr>
//             <tr><td>MDVJourneyLocation.hasRealtime()</td><td>{{location.hasRealtime()}}</td></tr>
//           </table>
//         </div>
//     </div>
// </file>
// <file name="script.js">
//   angular.module('MDVJourneyLocationExample', ['mng-model'])
//     .controller('JourneyLocationController', ['$scope', 'mng-model.MDVLocation',
//         'mng-model.MDVJourneyLocation',
//     function ($scope, MDVJourneyLocation) {
//         var example = {
//               "description" : "25 Brentwood Dr, Clarence Town",
//               "id" : "streetID:38920:25:95317004:-1:Brentwood Dr:Clarence Town:Brentwood Dr:nsw",
//               "type" : "singlehouse",
//               "name" : "Brentwood Dr",
//               "buildingNumber" : "25",
//               "coord" : [151.75752,-32.59597],
//               "departureTimeEstimated" : "momentObjectdepartureTimeEstimated",
//               "departureTimePlanned" : "momentObjectdepartureTimePlanned",
//               "arrivalTimeEstimated" : "momentObjectarrivalTimeEstimated",
//               "arrivalTimePlanned" : "momentObjectarrivalTimePlanned",
//             };

//         // format json
//         $scope.locationParameters = JSON.stringify(example)
//             .replace(/,"/g, ',\n"')
//             .replace('{', '{\n')
//             .replace('}', '\n}');

//         $scope.onInputChange = function () {
//             var params = {};
//             // validate json
//             try {
//                 params = JSON.parse($scope.locationParameters);
//                 // create MDVJourneyLocation element
//                 $scope.location = new MDVJourneyLocation(params);
//                 $scope.hint = '';
//             } catch (e) {
//                 if (e.description) {
//                     $scope.hint = e.description + ((e.data && e.data.reason) ? ': ' + e.data.reason : '');
//                 } else {
//                     $scope.hint = 'Invalid JSON format';
//                 }
//                 $scope.location = null;
//             }
//         };
//         // initial run
//         $scope.onInputChange();
//     }]);
// </file>
// </example>

    angular.module('mng-model')
        .factory('mng-model.MDVJourneyLocation', MDVJourneyLocation);

    MDVJourneyLocation.$inject = ['mng-util.MDVLog', 'mng-util.MDVException',
        'mng-model.MDVLocation', 'mng-model.MDVUtil'];

    function MDVJourneyLocation(MDVLog, MDVException, MDVLocation, MDVModelUtil) {
        var namespace = 'mng-model.MDVJourneyLocation',
            log = MDVLog.register(namespace);

        log.debug('initialize');

        return function(properties, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var _private,
                location;

            location = new MDVLocation(properties, true);
            _private = location._private;
            _private.$class = namespace;


            // add additional properties
            _private.addMoment = addMoment;
            _private.prepareOwnProperties = prepareOwnProperties;
            _private.selectProperties = selectProperties;
            _private.updatePropertyVersion = updatePropertyVersion;

            _private.prepareOwnProperties(properties);

            // keep private functions in global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate !== true) {
                location._private = undefined;
            }

            // override methods
            _private.originalEquals = location.equals;
            location.equals = equals;
            _private.originalToJSON = location.toJSON;
            location.toJSON = toJSON.bind(location);

            // additional public methods
            location.arrivalTime = arrivalTime;
            location.arrivalDelay = arrivalDelay;
            location.arrivalTimeEstimated = arrivalTimeEstimated;
            location.arrivalTimePlanned = arrivalTimePlanned;
            location.delay = delay;
            location.departureDelay = departureDelay;
            location.departureTime = departureTime;
            location.departureTimeEstimated = departureTimeEstimated;
            location.departureTimePlanned = departureTimePlanned;
            location.hasRealtime = hasRealtime;
            location.hasTime = hasTime;
            location.isRealtimeControlled = isRealtimeControlled;
            location.isCancelled = isCancelled;
            location.realtimeStatus = realtimeStatus;
            location.isStopover = hasTime;
            location.time = time;
            location.timeEstimated = timeEstimated;
            location.timePlanned = timePlanned;

            // ////////////////////////////////

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name arrivalTime
             * @returns {moment} moment object that describes the actual arrival date/ time.
             *
             * @description
             * Get the arrival date/ time of this point. The return value depends on real-time
             * availability. If real-time is available, the arrivalTimeEstimated returned,
             * arrivalTimePlanned otherwise. This function should be used to show the actual
             * arrival time at this location.
             */
            function arrivalTime() {
                if (hasRealtime.call(this) && arrivalTimeEstimated.call(this)) {
                    return arrivalTimeEstimated.call(this);
                }
                return arrivalTimePlanned.call(this);
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name arrivalDelay
             * @returns {Number|null} seconds the arrival is delayed. null if no real-time is available.
             *
             * @description
             * Get the delay of the arrival. The return value depends on real-time
             * availability. If real-time is available, the difference of arrivalTimeEstimated and
             * arrivalTimePlanned is returned, null otherwise.
             */
            function arrivalDelay() {
                if (isRealtimeControlled.call(this) && arrivalTimeEstimated.call(this)) {
                    return (arrivalTimeEstimated.call(this) - arrivalTimePlanned.call(this)) / 1000;
                }
                return null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name arrivalTimeEstimated
             * @returns {moment|null} moment object that describes the actual arrival date/ time,
             * null if no real-time is available.
             *
             * @description
             * Get the actual arrival date/ time of this point. This value is only available if
             * real-time information is provided. Use **arrival()** to get a arrival date/ time with
             * scheduled time as fallback.
             */
            function arrivalTimeEstimated() {
                return _private.props.arrivalTimeEstimated || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name arrivalTimePlanned
             * @returns {moment|null} moment object that describes the scheduled arrival date/ time,
             * or null if no arrivalTimePlanned is available
             *
             * @description
             * Get the scheduled arrival date/ time of this point. This value is not influenced by
             * real-time information. Use **arrival()** to get the actual arrival date/ time with
             * real-time influence if available.
             */
            function arrivalTimePlanned() {
                return _private.props.arrivalTimePlanned || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name delay
             * @returns {Number|null} minutes the location departure/ arrival is delayed. null if no
             * real-time is available.
             *
             * @description
             * Get the delay of the departure/ arrival. The return value depends on real-time
             * availability. If real-time is available, the difference of timeEstimated and
             * timePlanned is returned, null otherwise.
             *
             * **Note:** *This is a convenience getter method as it determines whether departure or
             * arrival delay is available. If both values are available, the departure delay is
             * returned.*
             */
            function delay() {
                var depDelay = departureDelay.call(this);

                if (!depDelay && depDelay !== 0) {
                    return arrivalDelay.call(this);
                }
                return depDelay;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name departureTime
             * @returns {moment} moment object that describes the actual departure date/ time.
             *
             * @description
             * Get the departure date/ time this point. The return value depends on real-time
             * availability. If real-time is available, the departureTimeEstimated returned,
             * departureTimePlanned otherwise. This function should be used to show the actual
             * departure time of this location.
             */
            function departureTime() {
                if (hasRealtime.call(this) && departureTimeEstimated.call(this)) {
                    return departureTimeEstimated.call(this);
                }
                return departureTimePlanned.call(this);
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name departureDelay
             * @returns {Number|null} seconds the departure is delayed. null if no real-time available.
             *
             * @description
             * Get the delay of the departure. The return value depends on real-time
             * availability. If real-time is available, the difference of departureTimeEstimated and
             * departureTimePlanned is returned, null otherwise.
             */
            function departureDelay() {
                if (isRealtimeControlled.call(this) && departureTimeEstimated.call(this)) {
                    return (departureTimeEstimated.call(this) - departureTimePlanned.call(this)) / 1000;
                }
                return null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name departureTimeEstimated
             * @returns {moment|null} moment object that describes the actual departure date/ time,
             * null if no real-time is available.
             *
             * @description
             * Get the actual departure date/ time of this point. This value is only available if
             * real-time information is provided. Use **departureTime()** to get a departure date/
             * time with scheduled time as fallback.
             */
            function departureTimeEstimated() {
                return _private.props.departureTimeEstimated || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name departureTimePlanned
             * @returns {moment|null} moment object that describes the scheduled departure date/
             * time, or null if no departureTimePlanned is available.
             *
             * @description
             * Get the scheduled departure date/ time of this point. This value is not influenced by
             * real-time information. Use **departureTime()** to get the actual departure date/ time
             * with real-time influence if available.
             */
            function departureTimePlanned() {
                return _private.props.departureTimePlanned || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name equals
             * @param {MDVLocation} compareLocation object that should be compared with this leg.
             * @param {Boolean} [tolerant=false] Flag to allow Locations without or with different
             * time values (true) or not (false).
             * @returns {Boolean} true: compareLocation is the same, false otherwise.
             *
             * @description
             * Check if a given location object equals this location.
             * Two location are the same if they share the same id.
             */
            function equals(compareLocation, tolerant) {
                if (!_private.originalEquals(compareLocation)) {
                    return false;
                }

                if (tolerant && !compareLocation.timePlanned) {
                    // compareLocation is no JourneyLocation. Be tolerant!
                    return true;
                }

                if ((!this.timePlanned() && compareLocation.timePlanned()) ||
                        (this.timePlanned() && !compareLocation.timePlanned())) {
                    return false;
                }

                return this.timePlanned().isSame(compareLocation.timePlanned());
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name hasRealtime
             * @returns {Boolean} true: real-time value available, false otherwise
             *
             * @description
             * Determine whether real-time information is available or not. This getter does not
             * determine whether the real-time information is provided by a real-time controlled
             * vehicle. Use isRealtimeControlled() instead.
             */
            function hasRealtime() {
                return (Boolean((_private.props.hasOwnProperty('departureTimeEstimated') &&
                    _private.props.departureTimeEstimated)) ||
                    Boolean((_private.props.hasOwnProperty('arrivalTimeEstimated') &&
                        _private.props.arrivalTimeEstimated)));
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name isRealtimeControlled
             * @returns {Boolean} true: real-time is provided by a controlled vehicle.
             *
             * @description
             * Determine whether the real-time information is provided by a controlled vehicle or
             * not.
             */
            function isRealtimeControlled() {
                return _private.props.isRealtimeControlled || false;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name realtimeStatus
             * @returns {string|null} z.b:  NO_CALL_AT_STOP - stop is cancelled
             *
             * @description
             * Check with the realtimeStatus if the stopSeq is cancelled
             */
            function realtimeStatus() {
                return _private.props.realtimeStatus || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name isCancelled
             * @returns {Boolean|string[]} true: stop is cancelled, string[]: cancellation
             * reasons if available, false: stop drives as planned.
             *
             * @description
             * Determine whether this stop is cancelled or not.
             */
            function isCancelled() {
                return _private.props.isCancelled || false;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name isStopover
             * @returns {Boolean} true: location has a time value, false otherwise.
             *
             * @description
             * **Note:** *This method is just another synonym for the hasTime() method. It simulates
             * a functionality that is not explicitly covered by the modules, as there is no other
             * way to determine whether this location is a stopover point or not. If there might be
             * an option to check this in the future, the synonym might be resolved to a more
             * concrete method. This method may also return unreasonable results for starting/
             * endpoints of legs, as they are also marked as stopover location, although they might
             * be no stop at all (for individual transportation legs). You have been warned...*
             *
             * Check if this location has at least one describing time for arrival or departure.
             */
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name hasTime
             * @returns {Boolean} true: location has a time value, false otherwise.
             *
             * @description
             * Check if this location has at least one describing time for arrival or departure.
             */
            function hasTime() {
                if (!this.time()) {
                    return false;
                }
                return true;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name timePlanned
             * @returns {moment|null} moment object that describes the scheduled date/ time,
             * or null if no departureTimePlanned or arrivalTimePlanned is available.
             *
             * @description
             * Get the scheduled date/ time of this point. This value is not influenced by
             * real-time information. Use **time()** to get the actual date/ time with
             * real-time influence if available.
             *
             * **Note:** *This is a convenience getter method as it determines whether departure or
             * arrival time is available. If both values are available, the departure time is
             * returned.*
             */
            function timePlanned() {
                var depTime = departureTimePlanned.call(this);

                if (!depTime) {
                    return arrivalTimePlanned.call(this);
                }
                return depTime;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name timeEstimated
             * @returns {moment|null} moment object that describes the actual date/ time, null
             * if no real-time is available.
             *
             * @description
             * Get the actual date/ time of this point. This value is only available if
             * real-time information is provided. Use **time()** to get a date/ time with
             * scheduled time as fallback.
             *
             * **Note:** *This is a convenience getter method as it determines whether departure or
             * arrival time is available. If both values are available, the departure time is
             * returned.*
             */
            function timeEstimated() {
                var depTime = departureTimeEstimated.call(this);

                if (!depTime) {
                    return arrivalTimeEstimated.call(this);
                }
                return depTime;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name time
             * @returns {moment|null} moment object that describes the actual date/ time, null
             * if no real-time is available.
             *
             * @description
             * Get the actual date/ time of this point. The return value depends on real-time
             * availability. If real-time is available, the timeEstimated returned,
             * timePlanned otherwise. This function should be used to show the actual
             * time at this location.
             *
             * **Note:** *This is a convenience getter method as it determines whether departure or
             * arrival time is available. If both values are available, the departure time is
             * returned.*
             */
            function time() {
                if (hasRealtime.call(this) && departureTimeEstimated.call(this)) {
                    return departureTimeEstimated.call(this);
                }
                if (hasRealtime.call(this) && arrivalTimeEstimated.call(this)) {
                    return arrivalTimeEstimated.call(this);
                }
                return timePlanned.call(this);
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLocation
             * @name toJSON
             * @returns {Object} object with all necessary properties to reconstruct this object.
             *
             * @description
             * Get all properties of this object to reconstruct it later on. This method should be
             * used for persisting favorites or logging purposes. The returned object also provides
             * an version number, which allows the program to determine which interface version was
             * used for this formatting.
             *
             * **Note:** *This method is overridden in this class to extend the default
             * toJSON-output of a {@link mng-model.object:MDVLocation MDVLocation} with specific
             * properties that are available in this class.*
             */
            function toJSON() {
                var serialized = _private.originalToJSON.call(this),
                    formatMoment = function(value) {
                        return value.format();
                    };

                serialized = MDVModelUtil.setJSONValue
                    .call(this, 'arrivalTimeEstimated', serialized, formatMoment);

                serialized = MDVModelUtil.setJSONValue
                    .call(this, 'arrivalTimePlanned', serialized, formatMoment);

                serialized = MDVModelUtil.setJSONValue
                    .call(this, 'departureTimeEstimated', serialized, formatMoment);

                serialized = MDVModelUtil.setJSONValue
                    .call(this, 'departureTimePlanned', serialized, formatMoment);

                serialized = MDVModelUtil.setJSONValue
                    .call(this, 'isRealtimeControlled', serialized);

                serialized = MDVModelUtil.setJSONValue
                    .call(this, 'realtimeStatus', serialized);

                serialized = MDVModelUtil.setJSONValue
                    .call(this, 'isCancelled', serialized);

                return serialized;
            }

            // //////////////////////////////////////

            function addMoment(key, props) {
                var elem = MDVModelUtil.parseMoment(props[key]);

                if (elem) {
                    _private.props[key] = elem;
                }
            }

            function prepareOwnProperties(props) {
                if (!props) {
                    props = {};
                }
                props = _private.updatePropertyVersion(props);

                _private.selectProperties(props);
            }

            function selectProperties(props) {
                _private.addMoment('arrivalTimeEstimated', props);
                _private.addMoment('arrivalTimePlanned', props);
                _private.addMoment('departureTimeEstimated', props);
                _private.addMoment('departureTimePlanned', props);
                MDVModelUtil.setJSONValue.call(props, 'isRealtimeControlled', _private.props);
                MDVModelUtil.setJSONValue.call(props, 'realtimeStatus', _private.props); // extended MDVLOcation with realtimeStatus
                MDVModelUtil.setJSONValue.call(props, 'isCancelled', _private.props);
            }

            function updatePropertyVersion(props) {
                return props;
            }

            return location;
        };
    }
}());

(function() {
    'use strict';

    /**
     * @constructor
     * @ngdoc object
     * @name mng-model.object:MDVJourneyLeg
     * @requires mng-util.service:MDVLog
     * @requires mng-model.service:MDVUtil
     *
     * @description
     * The `MDVJourneyLeg` object is an abstract description of a single part of a journey that is
     * done with a single transportation type.
     * As this object provides an uniform interface, services and controllers can interact with it in
     * an uniform way, no matter where the information about this journey comes from - as long as
     * the information is parsed to this object.
     *
     * ## General usage
     * To create a `MDVJourneyLeg` object, the constructor needs to be called with a set of
     * properties that describe the object.
     *
     * ```js
     *   // creation of a new MDVJourneyLeg
     *   var mdv_journey_leg = new MDVJourneyLeg({
     *      origin : new MDVJourneyLocation({
     *          name : 'Central Station',
     *          id : '10101100',
     *          departureSchedule: moment()
     *      }),
     *      destination : new MDVJourneyLocation({
     *          name : 'Main Station',
     *          id : '123456789',
     *          arrivalSchedule: moment().add(20, 'minutes')
     *      })
     *   });
     * ```
     *
     * Every `MDVJourneyLeg` has getter methods to access its properties. Please refer to the
     * properties documentation as well as the method documentation for a detailed description
     * (including an example) of the according attribute.
     *
     * ```js
     *   // get origin of the MDVJourneyLeg
     *   console.log(mdv_journey_leg.origin().name());  // 'Central Station'
     * ```
     *
     * ## Persistence
     * In order to persist this object and recreate it anytime in the future, you should use the
     * persist function. This function returns you all individual parameters needed, including a
     * version number that states in which format the data was persisted.
     *
     * This object ran through the following versions:
     * ### Version 2
     * Introduced in mng-model version 0.9.4 (04. October 2016)
     *<table>
     * <tr>     <th>key</th>       <th>type</th>  <th>default</th>      <th>example</th></tr>
     * <tr><td>$version</td>      <td>Number</td> <td>2</td>     <td></td></tr>
     * <tr><td>$class</td>      <td>String</td> <td>'mng-model.MDVJourneyLeg'</td> <td></td></tr>
     * <tr><td></td>   <td></td> <td></td>    <td></td></tr>
     * <tr><td>coords</td>  <td>Number[]</td> <td>null</td><td>[11.2312, 49.1231]</td></tr>
     * <tr><td>destination</td> <td>Object</td> <td>null</td>  <td>see MDVLocation version 2</td></tr>
     * <tr><td>distance</td>  <td>Number</td> <td>0</td>  <td>1231</td></tr>
     * <tr><td>duration</td>  <td>Number</td> <td>0</td>  <td>120</td></tr>
     * <tr><td>fare</td>       <td>Object</td> <td>{tickets: null, zones:null}</td>
     * <td>See MDVTicket version 2, {isNeutralZone: false, network: 'nsw', legRange: [1, 2], zones:
     * ['13', ['23', '24']]}</td></tr>
     * <tr><td>hints</td>  <td>Object[]</td> <td>[]</td>  <td>see MDVMessage version 2</td></tr>
     * <tr><td>infos</td>  <td>Object[]</td> <td>[]</td>  <td>see MDVMessage version 2</td></tr>
     * <tr><td>isRealtimeControlled</td> <td>Boolean</td> <td>null</td>  <td>true</td></tr>
     * <tr><td>locationSequence</td> <td>Object[]</td> <td>[]</td>  <td>see MDVLocation version 2</td></tr>
     * <tr><td>pathDescription</td> <td>Object[]</td> <td>[]</td>  <td>TODO</td></tr>
     * <tr><td>properties</td> <td>Object</td> <td>{}</td>  <td>set of key value pairs</td></tr>
     * <tr><td>standby</td> <td>Number</td> <td>0</td>  <td>180</td></tr>
     * <tr><td>origin</td> <td>Object</td> <td>null</td>  <td>see MDVLocation version 2</td></tr>
     * <tr><td>transportation</td> <td>Object</td> <td>null</td> <td>see MDVTransportation version 2</td></tr>
     * <tr><td>vehicleAccess</td> <td>String[]</td> <td>[]</td>  <td>TODO</td></tr>
     * </table>
     *
     * ### Version 1
     * **Note:** *Version 1 of this object is not supported any more.*
     *
     */
//      * Please refer to the example below for further details.
//      *
//      * @example
// <example module="MDVJourneyLegExample">
// <file name="index.html">
//     <div ng-controller="JourneyController">
//         My leg departs at {{journeyLeg.departureTime() | amDateFormat : 'hh:mm'}} from
//         {{journeyLeg.origin().name()}} and arrives at {{journeyLeg.arrivalTime() |
//         amDateFormat : 'hh:mm'}} at {{journeyLeg.destination().name()}}.
//     </div>
// </file>
// <file name="script.js">
//   angular.module('MDVJourneyLegExample', ['angularMoment', 'mng-model'])
//     .controller('JourneyController', ['$scope', 'moment', 'mng-model.MDVJourneyLocation',
//         'mng-model.MDVJourneyLeg',
//     function ($scope, moment, MDVJourneyLocation, MDVJourneyLeg) {
//         $scope.journeyLeg = new MDVJourneyLeg({
//            origin : new MDVJourneyLocation({
//                name : 'Central Station',
//                id : '10101100',
//                departureTimePlanned: moment()
//            }),
//            destination : new MDVJourneyLocation({
//                name : 'Main Station',
//                id : '123456789',
//                arrivalTimePlanned: moment().add(20, 'minutes')
//            })
//         });
//     }]);
// </file>
// </example>

    angular.module('mng-model')
        .factory('mng-model.MDVJourneyLeg', MDVJourneyLeg);

    MDVJourneyLeg.$inject = ['mng-util.MDVLog', 'mng-model.MDVUtil'];

    function MDVJourneyLeg(MDVLog, MDVModelUtil) {
        var namespace = 'mng-model.MDVJourneyLeg',
            log = MDVLog.register(namespace),
            VERSION = 2,
            Constructor;

        log.debug('initialize');

        Constructor = function(props, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var _private = {
                mergeInfoLists : mergeInfoLists,
                prepareProperties : prepareProperties,
                selectProperties : selectProperties,
                updatePropertyVersion : updatePropertyVersion,
                raw : (props && props.raw) ? props.raw : {},
                $class : namespace,
                $version : VERSION,
                standardProperties : [
                    'coords',
                    'distance',
                    'duration',
                    'isRealtimeControlled',
                    'pathDescription',
                    'standby',
                    'vehicleAccess'
                ]
            };

            // assure raw is loaded correctly, before it is removed from props
            _private.props = prepareProperties(props);

            // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate === true) {
                this._private = _private;
            }

            this.adultSingleTicket = adultSingleTicket;
            this.allTickets = allTickets;
            this.arrivalDelay = arrivalDelay;
            this.arrivalTime = arrivalTime;
            this.arrivalTimeEstimated = arrivalTimeEstimated;
            this.arrivalTimePlanned = arrivalTimePlanned;
            this.bookings = bookings;
            this.coords = coords;
            this.departureDelay = departureDelay;
            this.departureTime = departureTime;
            this.departureTimeEstimated = departureTimeEstimated;
            this.departureTimePlanned = departureTimePlanned;
            this.destination = destination;
            this.distance = distance;
            this.duration = duration;
            this.equals = equals;
            this.fares = fares;
            this.hasRealtime = hasRealtime;
            this.isRealtimeControlled = isRealtimeControlled;
            this.hints = hints;
            this.id = id;
            this.infos = infos;
            this.isPublicTransportation = isPublicTransportation;
            this.isAstTransportation = isAstTransportation;
            this.isWalk = isWalk;
            this.locationSequence = locationSequence;
            this.pathDescription = pathDescription;
            this.properties = properties;
            this.raw = raw;
            this.origin = origin;
            this.standby = standby;
            this.tickets = tickets;
            this.transportation = transportation;
            this.toJSON = toJSON;
            this.totalDuration = totalDuration;
            this.vehicleAccess = vehicleAccess;

            this.pushTicket = pushTicket;
            this.pushBooking = pushBooking;

            // ////////////////////////////////


            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name adultSingleTicket
             * @returns {MDVTicket} the ticket for one adult single person.
             *
             * @description
             * Get the adult single ticket for one person.
             */
            function adultSingleTicket() {
                var ticketList = allTickets(),
                    i,
                    l;

                for (i = 0, l = ticketList.length; i < l; i += 1) {
                    if ((ticketList[i].person() === 'ADULT') && (ticketList[i].type() === 'SINGLE')) {
                        return ticketList[i];
                    }
                }

                return null;
            }

            function pushTicket(ticketElem, replaceOld) {
                if (replaceOld || !_private.props.tickets) {
                    _private.props.tickets = [];
                }
                _private.props.tickets.push(ticketElem);
            }

            function pushBooking(booking, replaceOld) {
                if (replaceOld || !_private.props.bookings) {
                    _private.props.bookings = [];
                }
                _private.props.bookings.push(booking);
            }


            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name raw
             * @returns {Object} raw object the data of this model is from
             *
             * @description
             * Get the original response object the data of this model is from.
             */
            function raw() {
                return _private.raw || {};
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name arrivalDelay
             * @returns {Number} delay in seconds
             *
             * @description
             * Get the arrival delay of the leg.
             */
            function arrivalDelay() {
                var dest = this.destination();

                if (!dest) {
                    return null;
                }
                return dest.arrivalDelay();
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name arrivalTimeEstimated
             * @returns {Object} Momentjs object, when the journey ends.
             *
             * @description
             * Get the real time arrival date/ time of the journey.
             */
            function arrivalTimeEstimated() {
                var dest = this.destination();

                if (!dest) {
                    return null;
                }
                return dest.arrivalTimeEstimated();
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name arrivalTimePlanned
             * @returns {Object} Momentjs object, when the journey ends.
             *
             * @description
             * Get the scheduled arrival date/ time of the journey.
             */
            function arrivalTimePlanned() {
                var dest = this.destination();

                if (!dest) {
                    return null;
                }
                return dest.arrivalTimePlanned();
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name bookings
             * @returns {Object[]} Array of booking objects
             *
             * @description
             * Get all the bookings objects assigned to this leg.
             */
            function bookings() {
                return _private.props.bookings || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name arrivalTime
             * @returns {Object} Momentjs object when this leg arrives.
             *
             * @description
             * Get the arrival time of the leg.
             */
            function arrivalTime() {
                var dest = this.destination();

                if (!dest) {
                    return null;
                }
                return dest.arrivalTime();
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name departureDelay
             * @returns  {Number} delay in seconds
             *
             * @description
             * Get the departure delay of the leg.
             */
            function departureDelay() {
                var orig = this.origin();

                if (!orig) {
                    return null;
                }
                return orig.departureDelay();
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name departureTimeEstimated
             * @returns {Object} Momentjs object, when the journey starts.
             *
             * @description
             * Get the real-time departure date/ time of the journey.
             */
            function departureTimeEstimated() {
                var orig = this.origin();

                if (!orig) {
                    return null;
                }
                return orig.departureTimeEstimated();
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name departureTimePlanned
             * @returns {Object} Momentjs object, when the journey starts.
             *
             * @description
             * Get the scheduled departure date/ time of the journey.
             */
            function departureTimePlanned() {
                var orig = this.origin();

                if (!orig) {
                    return null;
                }
                return orig.departureTimePlanned();
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name departureTime
             * @returns {Object} Momentjs object when this leg departs.
             *
             * @description
             * Get the departure time of the leg.
             */
            function departureTime() {
                var orig = this.origin();

                if (!orig) {
                    return null;
                }
                return orig.departureTime();
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name destination
             * @returns {MDVJourneyLocation} {@link mng-model.object:MDVJourneyLocation Location} object
             * the leg ends at.
             *
             * @description
             * Get the destination point of the leg.
             */
            function destination() {
                return _private.props.destination || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name distance
             * @returns {Number} Distance of the leg in meters.
             *
             * @description
             * Get the distance of the leg.
             */
            function distance() {
                if (this.isPublicTransportation()) {
                    log.warn('distance is not defined for public legs.');
                }
                return _private.props.distance || 0;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name duration
             * @returns {Number} Seconds the leg's transportation lasts.
             *
             * @description
             * Get the duration the leg lasts. This duration differs from the totalDuration() value,
             * as this duration only describes the actual duration the transportation lasts. If
             * there is some time between the transportation and the next leg (e.g. for
             * transfer-legs), this time is not included in the duration. Use totalDuration()
             * instead, or add the waiting time (available with standby() ) to get the overall
             * duration of this leg.
             */
            function duration() {
                return _private.props.duration || 0;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name equals
             * @param {MDVJourneyLeg} leg object that should be compared with this leg.
             * @param {Boolean} [tolerant=false] Flag to allow origins and destinations without or
             * with different time values (true) or not (false).
             * @returns {Boolean} true: leg is the same, false otherwise.
             *
             * @description
             * Check if a given leg object equals this leg. Two legs are the same if they
             * have the same transportation and the same times and locations for origin and destination.
             */
            function equals(leg, tolerant) {
                if (!leg) {
                    return false;
                }

                var orig = this.origin(),
                    dest = this.destination(),
                    trans = transportation.call(this);

                if ((!orig && leg.origin()) || (orig && !leg.origin()) ||
                        !orig.equals(leg.origin(), tolerant)) {
                    return false;
                }
                if ((!dest && leg.destination()) || (dest && !leg.destination()) ||
                        !dest.equals(leg.destination(), tolerant)) {
                    return false;
                }
                if ((!trans && leg.transportation()) || (trans && !leg.transportation()) ||
                        !trans.equals(leg.transportation())) {
                    return false;
                }
                return true;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name fares
             * @returns {MDVFare[]} List of fare objects.
             *
             * @description
             * Get the fares that are applied to this leg. Please note, that legs can share fare
             * objects.
             */
            function fares() {
                return _private.props.fares || {
                    tickets : allTickets(),
                    zones : []
                };
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name hasRealtime
             * @returns {Boolean} Whether this leg provides realtime (true), or not (false).
             *
             * @description
             * Check whether this leg provides realtime or not.
             */
            function hasRealtime() {
                return this.origin() && this.origin().hasRealtime() &&
                    this.destination() && this.destination().hasRealtime();
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name isRealtimeControlled
             * @returns {Boolean} Whether this leg has a real-time controlled transportation (true),
             * or not (false).
             *
             * @description
             * Check whether this leg provides realtime or not.
             */
            function isRealtimeControlled() {
                return _private.props.isRealtimeControlled || false;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name hints
             * @returns {MDVMessage[]} List of hints the leg has.
             *
             * @description
             * Get the hints the leg has. Hints are messages that are added in the DIVA system for
             * static information like
             *
             * *Manly Ferry gates cloes two minutes before departure*.
             *
             * **Note:** *Do not mix up hints() with infos()!*
             */
            function hints() {
                return _private.props.hints || [];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name id
             * @returns {String} Unique ID only this leg has
             *
             * @description
             * Get a unique id of this leg.
             */
            function id() {
                var uniqueId = '';

                if (this.origin()) {
                    uniqueId += this.origin().id() + '#' +
                        this.origin().timePlanned()
                            .format('YYYY/MM/DD#hh:mm') + '#';
                }
                if (this.destination()) {
                    uniqueId += this.destination().id() + '#'+
                        this.destination().timePlanned()
                            .format('YYYY/MM/DD#hh:mm') + '#';
                }
                if (this.transportation()) {
                    uniqueId += this.transportation().id();
                }
                return uniqueId;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name infos
             * @returns {Object[]} List of all additional information the leg and its origin and
             * destination have.
             *
             * @description
             * Get the list of additional information the leg and its origin and destination have.
             * Infos are messages that are added by ICS/EMS that provide either disruption alerts or
             * other messages that are added dynamically (also advertisements or general messages
             * regarding the journey planner page). Example:
             *
             * *This train departs on platform 3 today*
             *
             * **Note:** *Do not mix up hints() with infos()!*
             */
            function infos() {
                var res = [],
                    orig = this.origin(),
                    dest = this.destination(),
                    trans = this.transportation(),
                    leg_infos = _private.props.infos;

                if (trans) {
                    res = res.concat(trans.infos() || []);
                }
                if (orig) {
                    res = mergeInfoLists(res, orig.infos());
                }
                if (dest) {
                    res = mergeInfoLists(res, dest.infos());
                }
                if (leg_infos) {
                    res = mergeInfoLists(res, leg_infos);
                }

                return res;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name isAstTransportation
             * @returns {Boolean} true: Leg is ast transportation, false: public or individual
             * transportation.
             *
             * @description
             * Determine whether this leg is travelled with ast transportation.
             */
            function isAstTransportation() {
                var bookgs = this.bookings(),
                    booking,
                    i, l;

                for (i=0, l=bookgs.length; i<l; i += 1) {
                    booking = bookgs[i];
                    if ((booking.file) && (booking.file.type() === 'INTERN')) {
                        return true;
                    }
                }
                return false;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name isPublicTransportation
             * @returns {Boolean} true: Leg is public transportation, false: individual
             * transportation.
             *
             * @description
             * Determine whether this leg is travelled with public or individual transportation.
             */
            function isPublicTransportation() {
                var transport = this.transportation();

                return transport && transport.isPublicTransportation();
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name isWalk
             * @returns {Boolean} true: Leg is walking leg, false: public transportation or
             * individual transportation other than walking.
             *
             * @description
             * Determine whether this leg describes a walking part.
             */
            function isWalk() {
                var transport = this.transportation();

                return transport && transport.isWalk();
            }

            _private.getStop = function(loc) {
                return (loc.type() === loc.LOCATIONTYPES.STOP_POINT)? loc.parent() : loc;
            };

            _private.isSameStop = function(seqLocation, odvLocation) {
                var seqStop = _private.getStop(seqLocation),
                    odvStop = _private.getStop(odvLocation);

                // allow tolerant comparison, as tops might be parents and therefore just
                // MDVLocations
                return seqStop.equals(odvStop, true);
            };
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name locationSequence
             * @param {Boolean} [ignoreOrigDest=false] true: cut out origin and destination if they
             * are part of the location sequence. false: keeep sequence as it is provided.
             * @param {Boolean} onlyWithTime get only the stops that have departure/arrival time.
             * @returns {MDVLocation[]} {@link mng-model.object:MDVLocation Locations} the leg passes.
             *
             * @description
             * Get the stops the leg passes.
             */
            function locationSequence(ignoreOrigDest, onlyWithTime) {
                if (!ignoreOrigDest ||
                        !_private.props.locationSequence ||
                        !_private.props.locationSequence.length) {
                    // default
                    return _private.props.locationSequence || [];
                }
                // cut out origin or destination
                var start = 0,
                    end = _private.props.locationSequence.length,
                    res = [],
                    toReturn = [],
                    i,
                    locSeq;

                if (_private.isSameStop(_private.props.locationSequence[start], origin())) {
                    start += 1;
                }
                if (_private.isSameStop(_private.props.locationSequence[end - 1], destination())) {
                    end -= 1;
                }

                res = _private.props.locationSequence.slice(start, end);
                if (onlyWithTime) {
                    for (i=0; i<res.length; i += 1) {
                        locSeq = res[i];
                        if (locSeq.departureTime() || locSeq.arrivalTime()) {
                            toReturn.push(locSeq);
                        }
                    }
                } else {
                    return res;
                }

                return toReturn;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name coords
             * @returns {Number[]} List of coordinates the leg has. Example:
             * [[-33.4, 149.61081],[-33.41452, 149.61067]]
             *
             * @description
             * Get the coodinates the leg has.
             */
            function coords() {
                return _private.props.coords || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name pathDescription
             * @returns {Object[]} List of turn instructions.
             *
             * @description
             * Get a list of direction instructions for individual transportation.
             */
            function pathDescription() {
                return _private.props.pathDescription || [];
            }

            function vehicleAccess() {
                var propertiesObj = this.properties();

                return propertiesObj.vehicleAccess || [];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name properties
             * @returns {Object} Additional properties that are bound to this leg
             *
             * @description
             * Get additional properties of this leg.
             */
            function properties() {
                return _private.props.properties || {};
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name duration
             * @returns {Number} Seconds the leg's wait time lasts.
             *
             * @description
             * Get the duration the leg's wait time lasts. This time describes the gap between the
             * overall duration and the duration the leg takes in total.
             */
            function standby() {
                return _private.props.standby || 0;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name allTickets
             * @returns {MDVTicket[]} list of all tickets assigned to this leg
             *
             * @description
             * Get all tickets assigned to this leg. Note that tickets are assigned multiple times
             * to the legs, whenever a ticket is valid for more than one leg. Use tickets() to
             * get specific tickets that start/end at this leg
             */
            function allTickets() {
                return _private.props.tickets || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name tickets
             * @param {Boolean} [endOnly=false] Only show tickets with a range that ends at this
             * leg. Default: only tickets with a range that starts at this leg
             * @returns {MDVTicket[]} list of all tickets starting/ending to this leg
             *
             * @description
             * Get all tickets that start/ end at this leg. To get all tickets that are used for
             * this leg, use allTickets().
             */
            function tickets(endOnly) {
                var i,
                    l,
                    result = [],
                    curr_range;

                if (!_private.props.tickets || (!this.legIndex && this.legIndex !== 0)) {
                    _private.props.tickets = [];
                }
                for (i = 0, l = _private.props.tickets.length; i < l; i += 1) {
                    curr_range = _private.props.tickets[i].legRange();
                    if (endOnly) {
                        if (curr_range[curr_range.length - 1] === this.legIndex) {
                            result.push(_private.props.tickets[i]);
                        }
                    } else if (curr_range[0] === this.legIndex) {
                        result.push(_private.props.tickets[i]);
                    }
                }

                return result;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name totalDuration
             * @returns {Number} Seconds the leg lasts.
             *
             * @description
             * Get the complete duration the leg lasts. This includes the execution duration
             * (available with duration() ) and the standby duration (available with standby() ).
             */
            function totalDuration() {
                return this.standby() + this.duration();
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name toJSON
             * @returns {Object} object with all necessary properties to reconstruct this object.
             *
             * @description
             * Get all properties of this object to reconstruct it later on. This method should be
             * used for persisting favorites or logging purposes. The returned object also provides
             * an version number, which allows the program to determine which interface version was
             * used for this formatting.
             */
            function toJSON() {
                var serialized = MDVModelUtil.getStandardJSON
                        .call(this, _private.$class, _private.$version, _private.standardProperties);

                MDVModelUtil.setValue
                    .call(this, 'destination', serialized, function(value) {
                        return value.toJSON();
                    });
                MDVModelUtil.setValue
                    .call(this, 'fares', serialized, function(value) {
                        return {
                            tickets : MDVModelUtil.toJSONArray(value.tickets),
                            zones : value.zones
                        };
                    });
                MDVModelUtil.setValue
                    .call(this, 'hints', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });
                MDVModelUtil.setValue
                    .call(this, 'infos', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });
                MDVModelUtil.setValue
                    .call(this, 'locationSequence', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });
                MDVModelUtil.setValue
                    .call(this, 'properties', serialized);
                MDVModelUtil.setValue
                    .call(this, 'origin', serialized, function(value) {
                        return value.toJSON();
                    });
                MDVModelUtil.setValue
                    .call(this, 'transportation', serialized, function(value) {
                        return value.toJSON();
                    });

                return serialized;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name transportation
             * @returns {MDVTransportation} line the leg uses.
             *
             * @description
             * Get the transportation the leg uses.
             */
            function transportation() {
                return _private.props.transportation || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourneyLeg
             * @name origin
             * @returns {MDVJourneyLocation} {@link mng-model.object:MDVJourneyLocation Location} object
             * the leg starts at.
             *
             * @description
             * Get the starting point of the leg.
             */
            function origin() {
                return _private.props.origin || null;
            }

            // ////////////////////////////////

            function prepareProperties(propertiesObj) {
                if (!propertiesObj) {
                    propertiesObj = {};
                }
                propertiesObj = _private.updatePropertyVersion(propertiesObj);

                // schema check
                // if (validateActive) {
                //     MDVValidator.check(properties, 'location').then(function(result) {
                //         if (result !== true) {
                //             log.error(result, true);
                //         }
                //     });
                // }

                return _private.selectProperties(propertiesObj);
            }

            function selectProperties(propertiesObj) {
                // set standard values
                var prepProps = MDVModelUtil.getStandardJSON
                    .call(propertiesObj, _private.$class, _private.$version,
                                                                    _private.standardProperties);

                // set complex properties

                MDVModelUtil.setValue
                    .call(propertiesObj, 'destination', prepProps, function(value) {
                        return MDVModelUtil.parseModel(value);
                    });
                MDVModelUtil.setValue
                    .call(propertiesObj, 'fares', prepProps, function(value) {
                        return {
                            zones : value.zones,
                            tickets : MDVModelUtil.parseModels(value.tickets)
                        };
                    });
                MDVModelUtil.setValue
                    .call(propertiesObj, 'hints', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });
                MDVModelUtil.setValue
                    .call(propertiesObj, 'infos', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });
                MDVModelUtil.setValue
                    .call(propertiesObj, 'legs', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });
                MDVModelUtil.setValue
                    .call(propertiesObj, 'locationSequence', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });
                MDVModelUtil.setValue
                    .call(propertiesObj, 'properties', prepProps, function(value) {
                        // ensure properties is pure JSON
                        return JSON.parse(JSON.stringify(value));
                    });
                MDVModelUtil.setValue
                    .call(propertiesObj, 'origin', prepProps, function(value) {
                        return MDVModelUtil.parseModel(value);
                    });
                MDVModelUtil.setValue
                    .call(propertiesObj, 'transportation', prepProps, function(value) {
                        return MDVModelUtil.parseModel(value);
                    });

                return prepProps;
            }

            function updatePropertyVersion(propertiesObj) {
                if (propertiesObj.hasOwnProperty('VERSION')) {
                    log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                        'please delete all old versions to avoid data loss or incorrect behavior');
                    return {};
                }
                // version check
                if (propertiesObj.$version && propertiesObj.$version !== _private.$version) {
                    if (propertiesObj.$version > VERSION) {
                        log.error('unknown version: ' + propertiesObj.$version +
                            '. Highest available version: ' + _private.$version);

                        return {};
                    }
                    // convert values to current version
                    // if (propertiesObj.$version === 2) {
                    //     propertiesObj.xy = propertiesObj.oldValue;
                    // }

                    // all other unsupported/ unknown versions
                    if (propertiesObj.$version === 1) {
                        log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                            'please delete all old versions to avoid data loss or incorrect behavior');
                        return {};
                    } else {
                        // all others
                        log.error('unknown version: ' + propertiesObj.$version +
                            '. Lowest available version: 1');

                        return {};
                    }
                }
                return propertiesObj;
            }

            function mergeInfoLists(dst, src) {
                var i, j, k, l,
                    isDuplicate,
                    res = [];

                for (i = 0, l = src.length; i < l; i += 1) {
                    isDuplicate = false;
                    for (j = 0, k = dst.length; j < k; j += 1) {
                        if (dst[j].equals(src[i])) {
                            isDuplicate = true;
                        }
                    }
                    if (!isDuplicate) {
                        res.push(src[i]);
                    }
                }

                return dst.concat(res);
            }

            return this;
        };

        return Constructor;

    }
}());

(function() {
    'use strict';

    /**
     * @constructor
     * @ngdoc object
     * @name mng-model.object:MDVJourney
     * @requires mng-util.service:MDVLog
     * @requires mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-model.service:MDVUtil
     *
     * @description
     * The `MDVJourney` object is an abstract description of a journey from a specific origin to a
     * specific destination.
     * As this object provides an uniform interface, services and controllers can interact with it in
     * an uniform way, no matter where the information about this journey comes from - as long as
     * the information is parsed to this object.
     *
     * ## General usage
     * To create a `MDVJourney` object, the constructor needs to be called with a set of
     * properties that describe the object.
     *
     * ```js
     *   // creation of a new MDVJourney
     *   var mdv_journey = new MDVJourney({
     *      legs : [new MDVJourneyLeg({...})]
     *   });
     * ```
     *
     * Every `MDVJourney` has getter methods to access its properties. Please refer to the
     * properties documentation as well as the method documentation for a detailed description
     * (including an example) of the according attribute.
     *
     * ```js
     *   // get origin of the MDVJourney
     *   console.log(mdv_journey.origin().name());  // Name of origin, defined in MDVJourneyLeg
     * ```
     *
     * ## Persistence
     * In order to persist this object and recreate it anytime in the future, you should use the
     * persist function. This function returns you all individual parameters needed, including a
     * version number that states in which format the data was persisted.
     *
     * This object ran through the following versions:
     * ### Version 2
     * Introduced in mng-model version 0.9.4 (04. October 2016)
     *<table>
     * <tr>     <th>key</th>       <th>type</th>  <th>default</th>      <th>example</th></tr>
     * <tr><td>$version</td>      <td>Number</td> <td>2</td>     <td></td></tr>
     * <tr><td>$class</td>      <td>String</td> <td>'mng-model.MDVJourney'</td> <td></td></tr>
     * <tr><td></td>   <td></td> <td></td>    <td></td></tr>
     * <tr><td>fare</td>       <td>Object</td> <td>{tickets: null, zones:null}</td>
     * <td>See MDVTicket version 2, {isNeutralZone: false, network: 'nsw', legRange: [1, 2], zones:
     * ['13', ['23', '24']]}</td></tr>
     * <tr><td>infos</td>   <td>Object[]</td> <td>[]</td>    <td>see MDVMessage version 2</td></tr>
     * <tr><td>isAdditional</td>  <td>Boolean</td> <td>false</td>  <td>true</td></tr>
     * <tr><td>legs</td>  <td>Object[]</td> <td>[]</td>  <td>see MDVJourneyLegs version 2</td></tr>
     * <tr><td>properties</td> <td>Object</td> <td>{}</td>  <td>set of key value components</td></tr>
     * <tr><td>rating</td> <td>Number</td> <td>0</td>  <td>1</td></tr>
     * <tr><td>vias</td> <td>Object[]</td> <td>[]</td>  <td>see MDVLocation version 2</td></tr>
     * </table>
     *
     * ### Version 1
     * **Note:** *Version 1 of this object is not supported any more.*
     *
     */
    angular.module('mng-model')
        .factory('mng-model.MDVJourney', MDVJourney);

    MDVJourney.$inject = ['mng-util.MDVLog', 'mng-comm.itd.MDVEFAFormatter', 'mng-model.MDVUtil'];

    function MDVJourney(MDVLog, MDVEFAFormatter, MDVModelUtil) {
        var namespace = 'mng-model.MDVJourney',
            log = MDVLog.register(namespace),
            VERSION = 2;

        log.debug('initialize');

        return function(props, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var context = this,
                _private = {
                    calcDuration : calcDuration,
                    fares : fares,
                    sumUp : sumUp,
                    getJourneyLocation : getJourneyLocation,
                    prepareProperties : prepareProperties,
                    selectProperties : selectProperties,
                    updatePropertyVersion : updatePropertyVersion,
                    raw : (props && props.raw) ? props.raw : {},
                    $class : namespace,
                    $version : VERSION,
                    standardProperties : [
                        'isAdditional',
                        'rating',
                        'numberOfTransfers',
                        'distance',
                        'duration'
                    ]
                };

            // assure raw is loaded correctly, before it is removed from props
            _private.props = prepareProperties(props);

            // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate === true) {
                this._private = _private;
            }
            this.adultSingleTicket = adultSingleTicket;
            this.adultOtherSingleTicket = adultOtherSingleTicket;
            this.allTickets = allTickets;
            this.allZones = allZones;
            this.arrivalDelay = arrivalDelay;
            this.arrivalTimeEstimated = arrivalTimeEstimated;
            this.arrivalTimePlanned = arrivalTimePlanned;
            this.arrivalTime = arrivalTime;
            this.coords = coords;
            this.departureDelay = departureDelay;
            this.departureTimeEstimated = departureTimeEstimated;
            this.departureTimePlanned = departureTimePlanned;
            this.departureTime = departureTime;
            this.destination = destination;
            this.bookings = bookings;
            this.distance = distance;
            this.itDistance = itDistance;
            this.ptDistance = ptDistance;
            this.duration = duration;
            this.itDuration = itDuration;
            this.ptDuration = ptDuration;
            this.infos = infos;
            this.isAdditional = isAdditional;
            this.isMonomodal = isMonomodal;
            this.isMultimodal = isMultimodal;
            this.isWalkOnly = isWalkOnly;
            this.equals = equals;
            this.numberOfTransfers = numberOfTransfers;
            this.legs = legs;
            this.properties = properties;
            this.origin = origin;
            this.raw = raw;
            this.rating = rating;
            this.systemMessages = systemMessages;
            this.tickets = tickets;
            this.toJSON = toJSON;
            this.vias = vias;

            // ////////////////////////////////

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name raw
             * @returns {Object} raw object the data of this model is from
             *
             * @description
             * Get the original response object the data of this model is from.
             */
            function raw() {
                return _private.raw;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name adultSingleTicket
             * @param {String} [name] Optional ticket name to be more specific about the singleTicket desired.
             * @returns {MDVTicket} the ticket for one adult single person.
             *
             * @description
             * Get the adult single ticket for one person.
             */
            function adultSingleTicket(names) {
                // EinzelTicket OrtsbusTicket darf nicht in der Darstellüng für den PriceLevel oder Price Anzeige verwendet werden
                // Array kann man erweitern mit den allen TicketsIds, die man bei der Filtrierung vermeiden soll.
                var exclusionSingleTicketsIDs = ['02611_91_VVS_1_']; //
                var ticketList = this.allTickets(),
                i,
                l,
                ticket,
                singleTickets = [];

                for (i = 0, l =ticketList.length; i < l; i += 1) {
                    if (((ticketList[i].person() === 'ADULT') && (ticketList[i].type() === 'SINGLE'))) {
                        singleTickets.push(ticketList[i]);
                    }
                }

                if (singleTickets.length > 0) {
                    for (i = 0, l = singleTickets.length; i < l; i += 1) {
                        if (names) {
                            if (names.indexOf(singleTickets[i].name()) > -1) {
                                ticket = singleTickets[i];
                            }
                        } else {
                            // return cheapest ticket
                            /* if (!ticket) {
                                ticket = singleTickets[i];
                            } else {
                                if (singleTickets[i].price() < ticket.price()) {
                                    ticket = singleTickets[i];
                                }
                            } */
                            // if (!exclusionSingleTicketsIDs.includes(singleTickets[0].id())) {
                            //     ticket = singleTickets[0]; // Es soll im Prinzip immer der Einzelfahrschein Erwachsener sein. Der wird von EFA-Fares immer als erster Fahrschein in der Liste übergeben.
                            // }
                            var ticket = singleTickets.find(function(el) {
                                return !exclusionSingleTicketsIDs.includes(el.id());
                            });
                        }
                    }
                }

                return ticket;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name adultOtherSingleTicket
             * @param {String} [name] Optional ticket name to be more specific about the singleTicket desired.
             * @returns {MDVTicket} the ticket for one adult/other single person.
             *
             * @description
             * Get the adult/other single ticket for one person.
             */
            function adultOtherSingleTicket(names) {
                var ticketList = this.allTickets(),
                i,
                l,
                ticket,
                singleTickets = [];

                for (i = 0, l =ticketList.length; i < l; i += 1) {
                    if (((ticketList[i].person() === 'ADULT' || ticketList[i].person() === 'OTHER') && (ticketList[i].type() === 'SINGLE'))) {
                        singleTickets.push(ticketList[i]);
                    }
                }
                if (singleTickets.length > 0) {
                    for (i = 0, l = singleTickets.length; i < l; i += 1) {
                        if (names) {
                            if (names.indexOf(singleTickets[i].name()) > -1) {
                                ticket = singleTickets[i];
                                if (ticket.name() === 'optimierter Luftlinientarif') {
                                    return ticket;
                                } else if (ticket.name() === 'Luftlinientarif') {
                                    return ticket;
                                }
                            }
                        } else {
                            // return cheapest ticket
                            if (!ticket) {
                                ticket = singleTickets[i];
                            } else {
                                if (singleTickets[i].price() < ticket.price()) {
                                    ticket = singleTickets[i];
                                }
                            }
                        }
                    }
                }
                return ticket;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name allTickets
             * @returns {MDVTicket[]} list of all tickets assigned to this journey
             *
             * @description
             * Get all tickets assigned to this journey. Note that this list includes all different
             * types of ticket for all different type of legs.
             */
            function allTickets() {
                return _private.fares(false).tickets;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name allZones
             * @returns {Object[]} list of all zones passed by this journey
             *
             * @description
             * Get all zones that are passed by this journey. Note that this list includes all
             * different zone types for all different legs.
             */
            function allZones() {
                return _private.fares(false).zones;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name arrivalDelay
             * @returns {Number|null} seconds the arrival is delayed. null if no real-time is
             * available.
             *
             * @description
             * Get the delay of the journey's arrival. The return value depends on real-time
             * availability. If real-time is available, the difference of arrivalTimeEstimated and
             * arrivalTimePlanned is returned, null otherwise.
             */
            function arrivalDelay() {
                var loc = _private.getJourneyLocation(false, true);

                if (loc) {
                    return loc.arrivalDelay();
                }
                return null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name arrivalTimeEstimated
             * @returns {Object} Momentjs object, when the journey ends.
             *
             * @description
             * Get the real time arrival date/ time of the journey.
             */
            function arrivalTimeEstimated() {
                var loc = this.destination();

                if (loc) {
                    return loc.arrivalTimeEstimated();
                }
                return null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name arrivalTimePlanned
             * @returns {Object} Momentjs object, when the journey ends.
             *
             * @description
             * Get the scheduled arrival date/ time of the journey.
             */
            function arrivalTimePlanned() {
                var loc = this.destination();

                if (loc) {
                    return loc.arrivalTimePlanned();
                }
                return null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name arrivalTime
             * @returns {Object} Momentjs object, when the journey ends.
             *
             * @description
             * Get the arrival date/ time of the journey.
             */
            function arrivalTime() {
                var loc = this.destination();

                if (loc) {
                    return loc.arrivalTime();
                }
                return null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name coords
             * @returns {Number[]} List of coordinates the journey has. Example:
             * [[-33.4, 149.61081],[-33.41452, 149.61067]]
             *
             * @description
             * Get the coodinates the journey has.
             */
            function coords() {
                var legList = this.legs(),
                    res = [],
                    i, l;

                for (i = 0, l = legList.length; i < l; i += 1) {
                    res = res.concat(legList[i].coords());
                }

                return res;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name departureDelay
             * @returns {Number|null} seconds the departure is delayed. null if no real-time
             * available.
             *
             * @description
             * Get the delay of the journey's departure. The return value depends on real-time
             * availability. If real-time is available, the difference of departureTimeEstimated and
             * departureTimePlanned is returned, null otherwise.
             */
            function departureDelay() {
                var loc = _private.getJourneyLocation(true, true);

                if (loc) {
                    return loc.departureDelay();
                }
                return null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name departureTimeEstimated
             * @returns {Object} Momentjs object, when the journey starts.
             *
             * @description
             * Get the real-time departure date/ time of the journey.
             */
            function departureTimeEstimated() {
                var loc = this.origin();

                if (loc) {
                    return loc.departureTimeEstimated();
                }
                return null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name departureTimePlanned
             * @returns {Object} Momentjs object, when the journey starts.
             *
             * @description
             * Get the scheduled departure date/ time of the journey.
             */
            function departureTimePlanned() {
                var loc = this.origin();

                if (loc) {
                    return loc.departureTimePlanned();
                }
                return null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name departureTime
             * @returns {Object} Momentjs object, when the journey starts.
             *
             * @description
             * Get the departure date/ time of the journey.
             */
            function departureTime() {
                var loc = this.origin();

                if (loc) {
                    return loc.departureTime();
                }
                return null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name destination
             * @returns {MDVJourneyLocation} {@link mng-model.object:MDVJourneyLocation Location} object
             * where the journey ends.
             *
             * @description
             * Get the destination point of the journey.
             */
            function destination() {
                return _private.getJourneyLocation(false, false);
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name distance
             * @returns {Number} Distance of the journey in meters.
             *
             * @description
             * Get the distance of the journey.
             */
            function distance() {
                if (_private.props.distance) {
                    return _private.props.distance;
                }
                log.warn('distance not available for public transportation');
                return 0;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name equals
             * @param {MDVJourney} journey object that should be compared with this journey.
             * @returns {Boolean} true: journey is the same, false otherwise.
             *
             * @description
             * Check if a given journey object equals this journey. Two journeys are the same if they
             * have the same legs.
             */
            function equals(journey) {
                if (!journey) {
                    return false;
                }
                var legList = this.legs(),
                    other_legs = journey.legs(),
                    i,
                    l;

                if (legList.length !== other_legs.length) {
                    return false;
                }
                // compare legs themself
                for (i = 0, l = legList.length; i < l; i += 1) {
                    if (!legList[i].equals(other_legs[i])) {
                        return false;
                    }
                }
                return true;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name isAdditional
             * @returns {Boolean} true: this journey is additional and not requested directly. false
             * otherwise
             *
             * @description
             * Determine whether this journey is a direct response to the requested journey, or an
             * additional journey provided by the back-end, as it might be a good alternative to the
             * other journeys.
             */
            function isAdditional() {
                return _private.props.isAdditional || false;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name isMonomodal
             * @returns {Boolean} true: this journey consists of one non-pt leg. false
             * otherwise
             *
             * @description
             * Determine whether this journey is a monomodal journey or not.
             */
            function isMonomodal() {
                var legList = this.legs();

                // 99 is only available in combination with pt legs
                if (legList.length === 1 && legList[0].transportation() &&
                        legList[0].transportation().productClass() >= 100) {
                    return true;
                }
                return false;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name isMultimodal
             * @returns {Boolean} true: this journey is not monomodal. false otherwise
             *
             * @description
             * Determine whether this journey is a multimodal journey or not.
             */
            function isMultimodal() {
                return !this.isMonomodal();
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name isWalkOnly
             * @returns {Boolean} true: this journey is only a walk alternative. false otherwise
             *
             * @description
             * Determine whether this journey is a walk alternative provided by the back-end, as it
             * might be a good alternative to the other journeys.
             */
            function isWalkOnly() {
                var legList = this.legs(),
                    i, l,
                    walkOnly = true;

                if (!legList.length) {
                    return false;
                }
                // check if every leg is a walk leg
                for (i = 0, l = legList.length; i < l; i += 1) {
                    if (!legList[i].isWalk()) {
                        walkOnly = false;
                    }
                }

                return walkOnly;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name itDistance
             * @returns {Number} Distance of the individual transport part of the journey in meters.
             *
             * @description
             * Get the distance of the individual transport part of the journey.
             */
            function itDistance() {
                if (!_private.props.itDistance) {
                    _private.props.itDistance = _private.sumUp('distance', false);
                }
                return _private.props.itDistance;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name ptDistance
             * @returns {Number} Distance of the public transport part of the journey in meters.
             *
             * @description
             * Get the distance of the public transport part of the journey.
             */
            function ptDistance() {
                log.warn('distance not available for public transportation');
                return 0;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name bookings
             * @returns {Object} Array of booking objects
             *
             * @description
             * Get the all bookings objects.
             */
            function bookings() {
                return _private.props.bookings || [];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name infos
             * @returns {Object[]} List of additional information the trip has.
             *
             * @description
             * Get the list of all legs infos.
             */
            function infos() {
                var res = [],
                    legList = legs(),
                    i;

                for (i = 0; i < legList.length; i += 1) {
                    res = res.concat(legList[i].infos());
                }
                return res;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name ptDuration
             * @returns {Number} seconds the public transport parts of the journey last.
             *
             * @description
             * Get the duration time of all public transport parts of the journey in seconds format.
             */
            function ptDuration() {
                if (!_private.props.ptDuration) {
                    _private.props.ptDuration = _private.sumUp('totalDuration', true);
                }
                return _private.props.ptDuration;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name itDuration
             * @returns {Number} Seconds the individual transport parts of the journey last.
             *
             * @description
             * Get the duration time of all individual transport parts of the journey in seconds format.
             */
            function itDuration() {
                if (!_private.props.itDuration) {
                    _private.props.itDuration = _private.sumUp('totalDuration', false);
                }
                return _private.props.itDuration;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name rating
             * @returns {Number} Rating Value to compare the reliability of journeys. Default: 0.
             *
             * @description
             * Get Rating of the journey.
             */
            function rating() {
                return _private.props.rating || 0;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name systemMessages
             * @returns {MDVMessage[]} List of messages that came up during the calculation of the
             * trip.
             *
             * @description
             * Get all messages that came up during the calculation of the trip.
             */
            function systemMessages() {
                return _private.props.systemMessages || [];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name duration
             * @returns {Number} Seconds the journey lasts.
             *
             * @description
             * Get the duration time of the journey in seconds format.
             */
            function duration() {
                if (!_private.props.duration) {
                    _private.props.duration = _private.calcDuration();
                }
                return _private.props.duration;

            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name numberOfTransfers
             * @returns {Number} Amount of interchanges during this journey.
             *
             * @description
             * Get the amount of interchanges the journey has.
             */
            function numberOfTransfers() {
                var legList = this.legs(),
                    curr_transportation,
                    i,
                    l,
                    transferCount = 0,
                    efaTransferCount;

                for (i = 0, l = legList.length; i < l; i += 1) {
                    curr_transportation = legList[i].transportation();
                    if (curr_transportation && curr_transportation.productName() ===
                                                            MDVEFAFormatter.translate('TRANSFER')) {
                        transferCount += 1;
                    }
                }

                if (_private.props.hasOwnProperty('numberOfTransfers')) {
                    efaTransferCount = _private.props.numberOfTransfers;
                }
                // this check is needed to allow the modules to insert it's own transfer legs and
                // to take care about the transferCount value. If backend knows more about the
                // journey as the modules, the value of the backend is taken into account.
                if (efaTransferCount > transferCount) {
                    return efaTransferCount;
                }
                return transferCount;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name legs
             * @returns {MDVJourneyLeg[]} List of partial journeys the journey is split up to.
             *
             * @description
             * Get the different partial journeys the journey is split to.
             */
            function legs() {
                return _private.props.legs || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name origin
             * @returns {MDVJourneyLocation} {@link mng-model.object:MDVJourneyLocation Location} object
             * where the journey starts.
             *
             * @description
             * Get the starting point of the journey.
             */
            function origin() {
                return _private.getJourneyLocation(true, false);
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name properties
             * @returns {Object} Additional properties that are bound to this journey
             *
             * @description
             * Get additional properties of this trip.
             */
            function properties() {
                return _private.props.properties || {};
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name toJSON
             * @returns {Object} object with all necessary properties to reconstruct this object.
             *
             * @description
             * Get all properties of this object to reconstruct it later on. This method should be
             * used for persisting favorites or logging purposes. The returned object also provides
             * an version number, which allows the program to determine which interface version was
             * used for this formatting.
             */
            function toJSON() {
                var serialized = MDVModelUtil.getStandardJSON
                        .call(this, _private.$class, _private.$version, _private.standardProperties);

                MDVModelUtil.setValue
                    .call(this, 'fare', serialized, function(value) {
                        return {
                            tickets : MDVModelUtil.toJSONArray(value.tickets),
                            zones : value.zones
                        };
                    });

                MDVModelUtil.setValue
                    .call(this, 'infos', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });

                MDVModelUtil.setValue
                    .call(this, 'legs', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });

                MDVModelUtil.setValue
                    .call(this, 'properties', serialized);

                MDVModelUtil.setValue
                    .call(this, 'systemMessages', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });

                MDVModelUtil.setValue
                    .call(this, 'vias', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });


                return serialized;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name tickets
             * @returns {MDVTicket[]} list of all tickets starting/ending to this leg
             *
             * @description
             * Get all tickets that are applied to the whole trip. To get all tickets that are
             * available for this trip, use allTickets().
             */
            function tickets() {
                var ticketList = this.allTickets(),
                    i,
                    l,
                    result = [],
                    curr_range;

                for (i = 0, l =ticketList.length; i < l; i += 1) {
                    curr_range = ticketList[i].legRange();
                    if (curr_range[0] === 0 &&
                            curr_range[curr_range.length - 1] === legs().length - 1) {
                        // only push tickets that start at the first and end with the last element
                        result.push(ticketList[i]);
                    }
                }

                return result;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVJourney
             * @name vias
             * @returns {MDVJourneyLocation[]} List of {@link mng-model.object:MDVJourneyLocation
             * location} objects the journey is forced to pass.
             *
             * @description
             * Get the list of via points that are set for the journey.
             */
            function vias() {
                return _private.props.vias || [];
            }


            // ////////////////////////////////
            function fares() {
                return _private.props.fare || {
                    tickets : [],
                    zones : []
                };
            }
            function calcDuration() {
                return context.arrivalTime().diff(context.departureTime(), 'seconds');
            }
            function sumUp(type, isPublic) {
                var i,
                    l,
                    legList = context.legs(),
                    sum = 0;

                for (i = 0, l = legList.length; i < l; i += 1) {
                    if (legList[i].isPublicTransportation() === isPublic) {
                        sum += legList[i][type]();
                    }
                }
                return sum;
            }

            function getJourneyLocation(first, ptOnly) {
                var curr_leg,
                    leg_index,
                    legList = context.legs();

                if (legList.length > 0) {
                    if (first) {
                        leg_index = 0;
                        curr_leg = legList[leg_index];
                        if (ptOnly) {
                            while (leg_index < legList.length &&
                                    !curr_leg.isPublicTransportation()) {
                                leg_index += 1;
                                curr_leg = legList[leg_index];
                            }
                        }
                        if (curr_leg) {
                            return curr_leg.origin();
                        }
                    } else {
                        leg_index = legList.length - 1;
                        curr_leg = legList[leg_index];
                        if (ptOnly) {
                            while (leg_index >= 0 && !curr_leg.isPublicTransportation()) {
                                leg_index -= 1;
                                curr_leg = legList[leg_index];
                            }
                        }
                        if (curr_leg) {
                            return curr_leg.destination();
                        }
                    }
                }
                return null;
            }

            function prepareProperties(propertiesObj) {
                if (!propertiesObj) {
                    propertiesObj = {};
                }
                propertiesObj = _private.updatePropertyVersion(propertiesObj);

                // schema check
                // if (validateActive) {
                //     MDVValidator.check(properties, 'location').then(function(result) {
                //         if (result !== true) {
                //             log.error(result, true);
                //         }
                //     });
                // }

                return _private.selectProperties(propertiesObj);
            }

            function selectProperties(propertiesObj) {
                // set standard values
                var prepProps = MDVModelUtil.getStandardJSON
                        .call(propertiesObj, _private.$class, _private.$version, _private.standardProperties);

                // set complex properties
                MDVModelUtil.setValue
                    .call(propertiesObj, 'fare', prepProps, function(value) {
                        return {
                            zones : value.zones,
                            tickets : MDVModelUtil.parseModels(value.tickets)
                        };
                    });

                MDVModelUtil.setValue
                    .call(propertiesObj, 'infos', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });

                MDVModelUtil.setValue
                    .call(propertiesObj, 'legs', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });

                MDVModelUtil.setValue
                    .call(propertiesObj, 'properties', prepProps, function(value) {
                        // ensure properties is pure JSON
                        return JSON.parse(JSON.stringify(value));
                    });

                MDVModelUtil.setValue
                    .call(propertiesObj, 'systemMessages', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });

                MDVModelUtil.setValue
                    .call(propertiesObj, 'vias', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });

                return prepProps;
            }

            function updatePropertyVersion(propertiesObj) {
                if (propertiesObj.hasOwnProperty('VERSION')) {
                    log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                        'please delete all old versions to avoid data loss or incorrect behavior');
                    return {};
                }
                // version check
                if (propertiesObj.$version && propertiesObj.$version !== _private.$version) {
                    if (propertiesObj.$version > VERSION) {
                        log.error('unknown version: ' + propertiesObj.$version +
                            '. Highest available version: ' + _private.$version);

                        return {};
                    }
                    // convert values to current version
                    // if (propertiesObj.$version === 2) {
                    //     propertiesObj.xy = propertiesObj.oldValue;
                    // }

                    // all other unsupported/ unknown versions
                    if (propertiesObj.$version === 1) {
                        log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                            'please delete all old versions to avoid data loss or incorrect behavior');
                        return {};
                    } else {
                        // all others
                        log.error('unknown version: ' + propertiesObj.$version +
                            '. Lowest available version: 1');

                        return {};
                    }
                }
                return propertiesObj;
            }

            return this;
        };
    }
}());

(function() {
    'use strict';
    /**
     * @constructor
     * @ngdoc object
     * @name mng-model.object:MDVFile
     * @requires downloadJs
     * @requires mng-util.service:MDVLog
     * @requires mng-model.service:MDVUtil
     *
     * @description
     * The `MDVFile` object is used to display, download or open a presentation file.
     * It can store a base64 stream and help to display it or download it using the javascript
     * library named {@link http://danml.com/download.html downloadJs}.
     *
     * ## General usage
     * To create a `MDVFile` object, the constructor needs to be called with a set of
     * properties that describe the object.
     *
     * ```js
     *   // creation of a new MDVFile
     *   var mdv_file = new MDVFile({
     *       input : 'line_99',
     *       src : '/files/download/file_name.pdf',
     *       size : 13,
     *       stream : 'JVBERi0xLjQKJcfsj6IKMTAgMCBvYmoKPDwvTGVuZ3Ro...'
     *   });
     * ```
     *
     * Every `MDVFile` has getter methods to access its properties. Please refer to the
     * the method documentation for a detailed description of the according attribute.
     *
     * ```js
     *   // get the Size of the MDVFile
     *   console.log(mdv_file.size());  // '890'
     * ```
     *
     * ## Persistence
     * In order to persist this object and recreate it anytime in the future, you should use the
     * persist function. This function returns you all individual parameters needed, including a
     * version number that states in which format the data was persisted.
     *
     * This object ran through the following versions:
     * ### Version 2
     * Introduced in mng-model version 0.9.4 (04. October 2016)
     *<table>
     * <tr>     <th>key</th>       <th>type</th>  <th>default</th>      <th>example</th></tr>
     * <tr><td>$version</td>      <td>Number</td> <td>2</td>     <td></td></tr>
     * <tr><td>$class</td>      <td>String</td> <td>'mng-model.MDVLocation'</td> <td></td></tr>
     * <tr><td></td>   <td></td> <td></td>    <td></td></tr>
     * <tr><td>input</td>       <td>String</td> <td>''</td>   <td>'T2'</td></tr>
     * <tr><td>extension</td>   <td>String</td> <td>'pdf'</td>    <td>'pdf</td></tr>
     * <tr><td>url</td>         <td>String</td> <td>''</td>  <td>'/download.pdf'</td></tr>
     * <tr><td>size</td>        <td>Number</td> <td>0</td>  <td>345</td></tr>
     * <tr><td>stream</td>     <td>String</td> <td>''</td>  <td>'xyeutfahkljatadufh4376gfj'</td></tr>
     * </table>
     *
     * ### Version 1
     * **Note:** *Version 1 of this object is not supported any more.*
     *
     */

//       * Please refer to the example below for further details.
//       *
//       * @example
//  <example module="MDVFileExample">
//  <file name="index.html">
//      <div ng-controller="MDVFileController">
//          <table style="text-align:left !important;">
//              <tr><th style="width:15em;">function</th><th>value</th></tr>
//              <tr><td>MDVFile.input()</td><td>{{file.input()}}</td></tr>
//              <tr><td>MDVFile.size()</td><td>{{file.size()}}</td></tr>
//              <tr><td>MDVFile.url()</td><td>{{file.url()}}</td></tr>
//              <tr><td>MDVFile.extension()</td><td>{{file.extension()}}</td></tr>
//              <tr><td>MDVFile.base64Stream()</td><td>{{file.base64Stream()}}</td></tr>
//              <tr><td>MDVFile.htmlBase64Stream()</td><td>{{file.htmlBase64Stream()}}</td></tr>
//          </table>
//
//      </div>
//  </file>
//
//  <file name="script.js">
//    angular.module('MDVFileExample', ['downloadJs', 'mng-model'])
//      .controller('MDVFileController', ['$scope', 'mng-model.MDVFile',
//      function ($scope, MDVFile) {
//          $scope.downloadFile = function(){
//              $scope.file.downloadFile();
//          };
//
//          $scope.file = new MDVFile({
//              input : 'line_99',
//              size : 13,
//              src : '/files/download/file_name.pdf',
//              stream : 'JVBERi0xLjQKJcfsj6I..'
//          });
//      }]);
//  </file>
//  </example>
//

    angular.module('mng-model')
        .factory('mng-model.MDVFile', MDVFile);

    MDVFile.$inject = ['$sce', '$window', '$injector', 'mng-util.MDVLog', 'mng-model.MDVUtil'];

    function MDVFile($sce, $window, $injector, MDVLog, MDVModelUtil) {
        var namespace = 'mng-model.MDVFile',
            log = MDVLog.register(namespace),
            VERSION = 2,
            downloadJs,
            Constructor;

        if ($injector.has('downloadJs')) {
            downloadJs = $injector.get('downloadJs');
        }

        log.debug('initialize');

        Constructor = function(props, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var _private = {
                extensionRegEx : /(?:\.([^.]+))?$/,
                prepareProperties : prepareProperties,
                selectProperties : selectProperties,
                updatePropertyVersion : updatePropertyVersion,
                raw : (props && props.raw) ? props.raw : {},
                standardProperties : [
                    'input',
                    'extension',
                    'url',
                    'size',
                    'stream',
                    'type'
                ],
                $version : VERSION,
                $class : namespace
            };

            // assure raw is loaded correctly, before it is removed from props
            _private.props = prepareProperties(props);

            // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate === true) {
                this._private = _private;
            }

            // public
            this.blobFileUrl = blobFileUrl;
            this.base64Stream = base64Stream;
            this.downloadFile = downloadFile;
            this.extension = extension;
            this.htmlBase64Stream = htmlBase64Stream;
            this.input = input;
            this.raw = raw;
            this.type = type;
            this.size = size;
            this.stream = base64Stream;
            this.toJSON = toJSON;
            this.url = url;


            // ////////////////////////////////

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVFile
             * @name blobFileUrl
             * @returns {Object} An object that can be passed to $sce.getTrustedResourceUrl(value)
             * to obtain the original value.
             *
             * @description
             * This function generate a temporary file and return his URL.
             */
            function blobFileUrl() {
                var file = b64toBlob(base64Stream(), 'application/pdf'),
                    fileURL = URL.createObjectURL(file);

                function b64toBlob(b64Data, contentType, sliceSize) {
                    var byteCharacters = atob(b64Data),
                        byteArrays = [],
                        byteNumbers,
                        byteArray,
                        slice,
                        offset,
                        blob,
                        i,
                        l;

                    contentType = contentType || '';
                    sliceSize = sliceSize || 512;

                    for (offset = 0, l = byteCharacters.length; offset < l; offset += sliceSize) {
                        slice = byteCharacters.slice(offset, offset + sliceSize);
                        byteNumbers = new Array(slice.length);
                        for (i = 0; i < slice.length; i+=1) {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }
                        byteArray = new $window.Uint8Array(byteNumbers);
                        byteArrays.push(byteArray);
                    }

                    blob = new Blob(byteArrays, {'type' : contentType});
                    return blob;
                }
                return $sce.trustAsResourceUrl(fileURL);
            }


            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVFile
             * @name input
             * @returns {String} input the file name giving by the request.
             * it can be a line name/ location id...
             *
             * @description
             * Get the file name.
             */
            function input() {
                return _private.props.input || '';
            }

            function type() {
                return _private.props.type || '';
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVFile
             * @name raw
             * @returns {Object} raw object the data of this model is from
             *
             * @description
             * Get the original response object the data of this model is from.
             */
            function raw() {
                return _private.props.raw || {};
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVFile
             * @name extension
             * @returns {String} extension file extension.
             *
             * @description
             * Extract the file extension from the url.
             */
            function extension() {
                var srcURL = _private.props.url,
                    result = _private.extensionRegEx.exec(srcURL)[1];

                return result || 'pdf';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVFile
             * @name url
             * @returns {String} url file url.
             *
             * @description
             * Get the file url.
             */
            function url() {
                return _private.props.url || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVFile
             * @name size
             * @returns {Integer} size file size.
             *
             * @description
             * Get the file size in Bytes.
             */
            function size() {
                return _private.props.size || 0;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVFile
             * @name base64Stream
             * @returns {String} stream the file as base64 stream.
             *
             * @description
             * Get the file in base64 stream.
             */
            function base64Stream() {
                return _private.props.stream || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVFile
             * @name htmlBase64Stream
             * @returns {String} stream the file as base64 stream.
             *
             * @description
             * Get a modified base64 stream ready to bind in html object element.
             */
            function htmlBase64Stream() {
                var b4Stream = base64Stream();

                if (!b4Stream) {
                    return null;
                }
                return 'data:application/pdf;base64,'.concat(b4Stream);
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVFile
             * @name downloadFile
             *
             * @description
             * Generate the file using his base64 stream and firing the downloadJs method of
             * {@link http://danml.com/download.html downloadJs}.
             */
            function downloadFile() {
                if (!downloadJs) {
                    log.error('downloadJs not available (see http://danml.com/download.html).');
                    return;
                }

                var fileUrl = url(),
                    content = htmlBase64Stream(),
                    ext = extension(),
                    fileName = '.'.concat(ext),
                    appType = 'application/'.concat(ext),
                    prefix = input();

                if (prefix) {
                    fileName = prefix + fileName;
                } else {
                    fileName = 'download' + fileName;
                }

                if (content) {
                    fireDownload(content, fileName, appType);
                } else {
                    $window.open(fileUrl);
                }

                function fireDownload(c, f, t) {
                    downloadJs(c, f, t);
                }
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVFile
             * @name toJSON
             * @returns {Object} object with all necessary properties to reconstruct this object.
             *
             * @description
             * Get all properties of this object to reconstruct it later on. This method should be
             * used for persisting favorites or logging purposes. The returned object also provides
             * an version number, which allows the program to determine which interface version was
             * used for this formatting.
             */
            function toJSON() {
                var serialized = MDVModelUtil.getStandardJSON
                        .call(this, _private.$class, _private.$version, _private.standardProperties);

                return serialized;
            }

            // ////////////////////////////////

            function prepareProperties(properties) {
                if (!properties) {
                    properties = {};
                }
                properties = _private.updatePropertyVersion(properties);

                // schema check
                // if (validateActive) {
                //     MDVValidator.check(properties, 'location').then(function(result) {
                //         if (result !== true) {
                //             log.error(result, true);
                //         }
                //     });
                // }

                return _private.selectProperties(properties);
            }

            function selectProperties(properties) {
                // set standard values
                var prepProps = MDVModelUtil.getStandardJSON
                        .call(properties, _private.$class, _private.$version, _private.standardProperties);

                return prepProps;
            }

            function updatePropertyVersion(properties) {
                if (properties.hasOwnProperty('VERSION')) {
                    log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                        'please delete all old versions to avoid data loss or incorrect behavior');
                    return {};
                }
                // version check
                if (properties.$version && properties.$version !== _private.$version) {
                    if (properties.$version > VERSION) {
                        log.error('unknown version: ' + properties.$version +
                            '. Highest available version: ' + _private.$version);

                        return {};
                    }
                    // convert values to current version
                    // if (properties.$version === 2) {
                    //     properties.xy = properties.oldValue;
                    // }

                    // all other unsupported/ unknown versions
                    if (properties.$version === 1) {
                        log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                            'please delete all old versions to avoid data loss or incorrect behavior');
                        return {};
                    } else {
                        // all others
                        log.error('unknown version: ' + properties.$version +
                            '. Lowest available version: 1');

                        return {};
                    }
                }
                return properties;
            }

        };
        return Constructor;
    }
}());

(function() {
    'use strict';

    /**
     * @constructor
     * @ngdoc object
     * @name mng-model.object:MDVDeparture
     * @requires mng-util.service:MDVLog
     * @requires mng-model.service:MDVUtil
     *
     * @description
     * The `MDVDeparture` object is an abstract description of a departure at a specific stop
     * location.
     * As this object provides an uniform interface, services and controllers can interact with it in
     * an uniform way, no matter where the information about this departure comes from - as long as
     * the information is parsed to this object.
     *
     * ## General usage
     * To create a `MDVDeparture` object, the constructor needs to be called with a set of
     * properties that describe the object.
     *
     * ```js
     *   // creation of a new MDVDeparture
     *   var mdv_departure = new MDVDeparture({
     *      dateTimeSchedule : moment().add(5, 'minutes'),
     *      transportation : new MDVTransportation({
     *          name: 'NSW TrainLink Train 243',
     *          id : 'nsw:01243: :H:sj2',
     *      }),
     *      location : new MDVLocation({
     *          name : 'Central Station',
     *          id : '10101100'
     *      })
     *   });
     * ```
     *
     * Every `MDVDeparture` has getter methods to access its properties. Please refer to the
     * properties documentation as well as the method documentation for a detailed description
     * (including an example) of the according attribute.
     *
     * ```js
     *   // get location of the MDVDeparture
     *   console.log(mdv_departure.location().name());  // 'Central Station'
     * ```
     * Please refer to the example below for further details.
     *
     * @example
<example module="MDVDepartureExample">
<file name="index.html">
    <div ng-controller="DepartureController">
        My next departure is <span am-time-ago="departure.dateTime()"></span> at
        {{departure.dateTime() | amDateFormat : 'hh:mm'}} from {{departure.location().name()}} with
        line {{departure.transportation().name()}}.
    </div>
</file>
<file name="script.js">
  angular.module('MDVDepartureExample', ['angularMoment', 'mng-model'])
    .controller('DepartureController', ['$scope', 'moment', 'mng-model.MDVLocation',
        'mng-model.MDVDeparture', 'mng-model.MDVTransportation',
    function ($scope, moment, MDVLocation, MDVDeparture, MDVTransportation) {
        $scope.departure = new MDVDeparture({
            dateTimeSchedule : moment().add(5, 'minutes'),
            transportation : new MDVTransportation({
                name: 'NSW TrainLink Train 243',
                id : 'nsw:01243: :H:sj2',
            }),
            location : new MDVLocation({
                name : 'Central Station',
                id : '10101100'
            })
        });
    }]);
</file>
</example>
     */

    /**
     * @ngdoc property
     * @name mng-model.object:MDVDeparture#dateTime
     * @propertyOf mng-model.object:MDVDeparture
     *
     * @description
     * **moment-object** *moment().add(5, 'minutes')*
     *
     * Moment object that describes the actual date and time the departure is at. This time can
     * differ from **dateTimeSchedule** when real-time information is available and the real
     * departure time differs from the scheduled one. If no real-time information is available, the
     * dateTime property is the same as **dateTimeSchedule**.
     */
    /**
     * @ngdoc property
     * @name mng-model.object:MDVDeparture#dateTimeSchedule
     * @propertyOf mng-model.object:MDVDeparture
     *
     * @description
     * *required*
     *
     * **moment-object** *moment().add(5, 'minutes')*
     *
     * Moment object that describes the date and time the departure is scheduled at. This time can
     * differ from **dateTime** when real-time information is available and the real departure time
     * differs from the scheduled one. If no real-time information is available, the
     * dateTimeSchedule and the **dateTime** property are the same.
     */
    /**
     * @ngdoc property
     * @name mng-model.object:MDVDeparture#location
     * @propertyOf mng-model.object:MDVDeparture
     *
     * @description
     * *required*
     *
     * **MDVLocation** *new MDVLocation({...})*
     *
     * Location the departure is at.
     */
    /**
     * @ngdoc property
     * @name mng-model.object:MDVDeparture#transportation
     * @propertyOf mng-model.object:MDVDeparture
     *
     * @description
     * *required*
     *
     * **MDVTransportation** *new MDVTransportation({...})*
     *
     * Object that describes the line that is departing.
     */
    /**
     * @ngdoc property
     * @name mng-model.object:MDVDeparture#notification
     * @propertyOf mng-model.object:MDVDeparture
     *
     * @description
     * **Object[]** *[]*
     *
     * Notifications that are available for this departure. This might be additional information
     * like accessibility information, or reasons for delays.
     */
    angular.module('mng-model')
        .factory('mng-model.MDVDeparture', MDVDeparture);

    MDVDeparture.$inject = ['mng-util.MDVLog', 'mng-model.MDVUtil'];

    function MDVDeparture(MDVLog, MDVModelUtil) {
        var namespace = 'mng-model.MDVDeparture',
            log = MDVLog.register(namespace),
            VERSION = 2,
            Constructor;

        log.debug('initialize');

        Constructor = function(props, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var _private = {
                mergeInfoLists : mergeInfoLists,
                prepareProperties : prepareProperties,
                selectProperties : selectProperties,
                updatePropertyVersion : updatePropertyVersion,
                raw : (props && props.raw) ? props.raw : {},
                standardProperties : [
                    'isRealtimeControlled',
                    'isCancelled'
                ],
                $version : VERSION,
                $class : namespace
            };

            // assure raw is loaded correctly, before it is removed from props
            _private.props = prepareProperties(props);

            // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate === true) {
                this._private = _private;
            }

            // public
            this.dateTime = dateTime;
            this.dateTimeEstimated = dateTimeEstimated;
            this.dateTimePlanned = dateTimePlanned;
            this.delay = delay;
            this.equals = equals;
            this.hasRealtime = hasRealtime;
            this.hints = hints;
            this.infos = infos;
            this.isDelayed = isDelayed;
            this.isRealtimeControlled = isRealtimeControlled;
            this.isCancelled = isCancelled;
            this.location = location;
            this.transportation = transportation;
            this.onwardStopSeq = onwardStopSeq;
            this.prevStopSeq = prevStopSeq;
            this.properties = getProperties;
            this.raw = raw;
            this.toJSON = toJSON;


            // ////////////////////////////////

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name raw
             * @returns {Object} raw object the data of this model is from
             *
             * @description
             * Get the original response object the data of this model is from.
             */
            function raw() {
                return _private.raw || {};
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name dateTime
             * @returns {moment} moment object for the actual departure time
             *
             * @description
             * Get the actual date and time of the departure. This time can differ to the
             * **dateTimePlanned** value, as real-time information is also included. If no real-time
             * is available, the results are equal.
             */
            function dateTime() {
                if (hasRealtime.call(this)) {
                    return _private.props.dateTimeEstimated;
                }
                return dateTimePlanned.call(this);
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name dateTimePlanned
             * @returns {moment} moment object for the scheduled departure time
             *
             * @description
             * Get the scheduled date and time of the departure. This time can differ to the
             * **dateTime** value, when real-time information is available.
             */
            function dateTimePlanned() {
                return _private.props.dateTimePlanned || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name dateTimeEstimated
             * @returns {moment} moment object for the estimated departure time
             *
             * @description
             * Get the estimated date and time of the departure. This time can differ to the
             * **dateTimePlanned** value, as real-time information is included. If no real-time is
             * available, null is returned.
             */
            function dateTimeEstimated() {
                return _private.props.dateTimeEstimated || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name delay
             * @returns {Number|null} delay in minutes, or null if no real-time is available. "null" is
             * used as -1, 0 or Number.MAX_VALUE are valid delay information.
             *
             * @description
             * Get the difference between scheduled time and actual departure time. If no real-time
             * information is available, this method returns null.
             */
            function delay() {
                if (!hasRealtime.call(this)) {
                    return null;
                }
                return (dateTimeEstimated.call(this) - dateTimePlanned.call(this)) / 1000;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name equals
             * @param {MDVDeparture} departure object that should be compared with this departure.
             * @returns {Boolean} true: departure is the same, false otherwise.
             *
             * @description
             * Check if a given departure object equals this departure.
             * Two departures are the same if they share the same location, time and transportation.
             */
            function equals(departure) {
                if (!departure) {
                    return false;
                }
                if (!this.location().equals(departure.location())) {
                    return false;
                }
                if (!this.dateTime().isSame(departure.dateTime())) {
                    return false;
                }
                if (!this.transportation().equals(departure.transportation())) {
                    return false;
                }
                return true;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name hasRealtime
             * @returns {Boolean} true: real-time available, false otherwise
             *
             * @description
             * Determine whether real-time information is available or not.
             */
            function hasRealtime() {
                return Boolean(_private.props.hasOwnProperty('dateTimeEstimated') &&
                            _private.props.dateTimeEstimated);
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name isDelayed
             * @returns {Boolean|null} true: departure is delayed , false: departure is not delayed.
             * null if no realtime information is available and therefore the information, whether
             * the departure is delayed or not, is missing.
             *
             * @description
             * Determine whether this departure is delayed (actual departure time is later than the
             * scheduled one), or not.
             */
            function isDelayed() {
                if (!hasRealtime.call(this)) {
                    return null;
                }
                return delay.call(this) > 0;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name isRealtimeControlled
             * @returns {Boolean} Whether this Departure has a real-time controlled transportation (true),
             * or not (false).
             *
             * @description
             * Check whether this Departure provides realtime or not.
             */
            function isRealtimeControlled() {
                return _private.props.isRealtimeControlled || false;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name isCancelled
             * @returns {Boolean|string[]} true: Departure is cancelled, string[]: cancellation
             * reasons if available, false: Departure drives as planned.
             *
             * @description
             * Determine whether this Departure is cancelled or not.
             */
            function isCancelled() {
                return _private.props.isCancelled || false;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name location
             * @returns {MDVLocation} location of the departure
             *
             * @description
             * Get the location of this departure.
             */
            function location() {
                return _private.props.location || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name toJSON
             * @returns {Object} object with all necessary properties to reconstruct this object.
             *
             * @description
             * Get all properties of this object to reconstruct it later on. This method should be
             * used for persisting favorites or logging purposes. The returned object also provides
             * an version number, which allows the program to determine which interface version was
             * used for this formatting.
             */
            function toJSON() {
                var serialized = MDVModelUtil.getStandardJSON
                        .call(this, _private.$class, _private.$version, _private.standardProperties);

                MDVModelUtil.setValue
                    .call(this, 'dateTimeEstimated', serialized, function(value) {
                        return value.format();
                    });
                MDVModelUtil.setValue
                    .call(this, 'dateTimePlanned', serialized, function(value) {
                        return value.format();
                    });
                MDVModelUtil.setValue
                    .call(this, 'hints', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });
                MDVModelUtil.setValue
                    .call(this, 'infos', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });
                MDVModelUtil.setValue
                    .call(this, 'location', serialized, function(value) {
                        return value.toJSON();
                    });
                MDVModelUtil.setValue
                    .call(this, 'onwardStopSeq', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });
                MDVModelUtil.setValue
                    .call(this, 'prevStopSeq', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });
                MDVModelUtil.setValue
                    .call(this, 'transportation', serialized, function(value) {
                        return value.toJSON();
                    });

                MDVModelUtil.setValue
                    .call(this, 'properties', serialized, function(value) {
                        // assure properties are pure json
                        return JSON.parse(JSON.stringify(value));
                    });

                return serialized;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name transportation
             * @returns {MDVTransportation} line the departure is about
             *
             * @description
             * Get the serving line that departs. This object also contains the destination/ direction
             * and all information for the line, like number, mot a.s.o. See {{@link
             * mng-model.object:MDVTransportation MDVTransportation}} for further details.
             */
            function transportation() {
                return _private.props.transportation || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name hints
             * @returns {MDVMessage[]} list of MDVMessage about this departure
             *
             * @description
             * Get a list of static information about this departure, like accessibility information.
             */
            function hints() {
                return _private.props.hints || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name infos
             * @returns {MDVMessage[]} list of MDVMessage about this departure
             *
             * @description
             * Get a list of additional information about this departure. This list can contain
             * low priority information, but also critical messages that inform the user why the
             * departure is delayed.
             */
            function infos() {
                var res = [];

                if (_private.props.location && _private.props.location.infos) {
                    res = res.concat(_private.props.location.infos() || []);
                }
                if (_private.props.infos) {
                    res = mergeInfoLists(res, _private.props.infos);
                }

                return res;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name onwardStopSeq
             * @returns {MDVLocation[]} list of MDVLocations that will be the next stops of this
             * departure
             *
             * @description
             * Get a list of all stops that will be stopped on the ondward journey of this departure.
             */
            function onwardStopSeq() {
                return _private.props.onwardStopSeq || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name prevStopSeq
             * @returns {MDVLocation[]} list of MDVLocations that were the last stops of this
             * departure
             *
             * @description
             * Get a list of all stops that this transportation already stopped at before it arrived
             * the departure's location.
             */
            function prevStopSeq() {
                return _private.props.prevStopSeq || [];
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVDeparture
             * @name properties
             * @returns {Object} Additional properties that are bound to this departure
             *
             * @description
             * Get additional properties of this departure.
             */
            function getProperties() {
                return _private.props.properties || {};
            }


            // ////////////////////////////////

            function prepareProperties(properties) {
                if (!properties) {
                    properties = {};
                }
                properties = _private.updatePropertyVersion(properties);

                return _private.selectProperties(properties);
            }

            function selectProperties(properties) {
                // set standard values
                var prepProps = MDVModelUtil.getStandardJSON
                        .call(properties, _private.$class, _private.$version,
                                                                    _private.standardProperties);

                prepProps = MDVModelUtil.setJSONValue.call(properties, 'properties', prepProps);

                MDVModelUtil.setValue
                    .call(properties, 'dateTimeEstimated', prepProps, function(value) {
                        return MDVModelUtil.parseMoment(value);
                    });
                MDVModelUtil.setValue
                    .call(properties, 'dateTimePlanned', prepProps, function(value) {
                        return MDVModelUtil.parseMoment(value);
                    });
                MDVModelUtil.setValue
                    .call(properties, 'infos', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });
                MDVModelUtil.setValue
                    .call(properties, 'hints', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });
                MDVModelUtil.setValue
                    .call(properties, 'location', prepProps, function(value) {
                        return MDVModelUtil.parseModel(value);
                    });
                MDVModelUtil.setValue
                    .call(properties, 'onwardStopSeq', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });
                MDVModelUtil.setValue
                    .call(properties, 'prevStopSeq', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });
                MDVModelUtil.setValue
                    .call(properties, 'transportation', prepProps, function(value) {
                        return MDVModelUtil.parseModel(value);
                    });

                return prepProps;
            }

            function updatePropertyVersion(properties) {
                if (properties.hasOwnProperty('VERSION')) {
                    log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                        'please delete all old versions to avoid data loss or incorrect behavior');
                    return {};
                }
                // version check
                if (properties.$version && properties.$version !== _private.$version) {
                    if (properties.$version > VERSION) {
                        log.error('unknown version: ' + properties.$version +
                            '. Highest available version: ' + _private.$version);

                        return {};
                    }
                    // convert values to current version
                    // if (properties.$version === 2) {
                    //     properties.xy = properties.oldValue;
                    // }

                    // all other unsupported/ unknown versions
                    if (properties.$version === 1) {
                        log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                            'please delete all old versions to avoid data loss or incorrect behavior');
                        return {};
                    } else {
                        // all others
                        log.error('unknown version: ' + properties.$version +
                            '. Lowest available version: 1');

                        return {};
                    }
                }
                return properties;
            }

            function mergeInfoLists(dst, src) {
                var i, j, k, l,
                    isDuplicate,
                    res = [];

                for (i = 0, l = src.length; i < l; i += 1) {
                    isDuplicate = false;
                    for (j = 0, k = dst.length; j < k; j += 1) {
                        if (dst[j].equals(src[i])) {
                            isDuplicate = true;
                        }
                    }
                    if (!isDuplicate) {
                        res.push(src[i]);
                    }
                }

                return dst.concat(res);
            }


            return this;
        };

        return Constructor;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @constructor
     * @ngdoc object
     * @name mng-model.object:MDVAssignedLocation
     * @requires mng-util.service:MDVLog
     * @requires mng-model.object:MDVLocation
     *
     * @description
     * The `MDVAssignedLocation` object is an extension of a {@link mng-model.object:MDVLocation
     * MDVLocation} to provide additional information.
     *
     * ## General usage
     * To create a `MDVAssignedLocation` object, the constructor needs to be called with a set of
     * properties that describe the object.
     *
     * ```js
     *   // creation of a new MDVAssignedLocation
     *   var assigned_location = new MDVAssignedLocation({
     *      id : '10102027',
     *      coord : [-33.79931, 151.28432],
     *      name : 'Manly Wharf',
     *      distance : 50,
     *      duration : 1000,
     *      connectingMode : 1
     *   });
     * ```
     *
     * Every `MDVAssignedLocation` has getter methods to access its properties. Please refer to the
     * method documentation for a detailed description
     * of the according attribute. Only `MDVAssignedLocation` specific properties
     * are described. All other properties are described in the {@link mng-model.object:MDVLocation
     * MDVLocation} documentation.
     *
     * ```js
     *   // get the distance from a verified location to the assigned location
     *   console.log(assigned_location.distance());  // 50
     * ```
     *
     * ## Persistence
     * In order to persist this object and recreate it anytime in the future, you should use the
     * persist function. This function returns you all individual parameters needed, including a
     * version number that states in which format the data was persisted.
     *
     * This object ran through the following versions:
     * ### Version 2
     * Introduced in mng-model version 0.8.2 (04. October 2016)
     *
     * **NOTE:** *This table only includes all additional properties the persisted location has.
     * It also includes all properties a {@link mng-model.object:MDVLocation MDVLocation} with the
     * same version number provides.*
     *
     *<table>
     * <tr>     <th>key</th>       <th>type</th>  <th>default</th>      <th>example</th></tr>
     * <tr><td>$version</td>      <td>Number</td> <td>2</td>     <td></td></tr>
     * <tr><td>$class</td>      <td>String</td> <td>'mng-model.MDVAssignedLocation'</td> <td></td></tr>
     * <tr><td></td>   <td></td> <td></td>    <td></td></tr>
     * <tr><td>assignedLocation</td><td>String</td> <td>''</td>   <td>ID of the location this
     * location is assigned to</td></tr>
     * <tr><td>connectingMode</td>  <td>String</td> <td>''</td>    <td>'100'</td></tr>
     * <tr><td>distance</td>        <td>Number</td> <td>0</td>  <td>132</td></tr>
     * <tr><td>duration</td>        <td>Number</td> <td>0</td>  <td>60</td></tr>
     * </table>
     *
     * ### Version 1
     * **Note:** *Version 1 of locations is still supported by the modules, but data loss and
     * unexpected behavior can occur. It is hardly recommended to delete all instances with
     * version 1 or older (instances without version attribute or with VERSION instead of $version).
     * Using these old versions will log a warning to the console.*
     *
     */
//      * Please refer to the example below for further details.
//      *
//      * @example
// <example module="MDVAssignedLocationExample">
// <file name="index.html">
//   <div ng-controller="SearchLocationController" style="min-height:45em;">
//         <div>Properties the MDVAssignedLocation is initialized with:</div>
//         <textarea style="width:100%;height:20em;" ng-model="locationParameters" ng-change="onInputChange()"></textarea>
//         <div ng-show="hint">{{hint}}</div>
//         <div ng-show="location">
//           <div>Result:</div>
//           <table style="text-align:left !important;">
//             <tr><th style="width:15em;">function</th><th>value</th></tr>
//             <tr><td colspan="2"><b>Standard MDVLocation parameters:</b></td></tr>
//             <tr><td>MDVAssignedLocation.buildingNumber()</td><td>{{location.buildingNumber()}}</td></tr>
//             <tr><td>MDVAssignedLocation.coordLatLng()</td><td>{{location.coordLatLng()}}</td></tr>
//             <tr><td>MDVAssignedLocation.coordString()</td><td>{{location.coordString()}}</td></tr>
//             <tr><td>MDVAssignedLocation.description()</td><td>{{location.description()}}</td></tr>
//             <tr><td>MDVAssignedLocation.id()</td><td>{{location.id()}}</td></tr>
//             <tr><td>MDVAssignedLocation.hasCoords()</td><td>{{location.hasCoords()}}</td></tr>
//             <tr><td>MDVAssignedLocation.modes()</td><td>{{location.modes()}}</td></tr>
//             <tr><td>MDVAssignedLocation.name()</td><td>{{location.name()}}</td></tr>
//             <tr><td>MDVAssignedLocation.type()</td><td>{{location.type()}}</td></tr>
//             <tr><td colspan="2"><b>Additional parameters:</b></td></tr>
//             <tr><td>MDVAssignedLocation.distance()</td><td>{{location.distance()}}</td></tr>
//             <tr><td>MDVAssignedLocation.duration()</td><td>{{location.duration()}}</td></tr>
//             <tr><td>MDVAssignedLocation.connectingMode()</td><td>{{location.connectingMode()}}</td></tr>
//           </table>
//         </div>
//     </div>
// </file>
// <file name="script.js">
//   angular.module('MDVAssignedLocationExample', ['mng-model'])
//     .controller('SearchLocationController', ['$scope', 'mng-model.MDVAssignedLocation',
//     function ($scope, MDVAssignedLocation) {
//         var example = {
//               "description" : "25 Brentwood Dr, Clarence Town",
//               "id" : "streetID:38920:25:95317004:-1:Brentwood Dr:Clarence Town:Brentwood Dr:nsw",
//               "type" : "singlehouse",
//               "name" : "Brentwood Dr",
//               "buildingNumber" : "25",
//               "coord" : [151.75752,-32.59597],
//               "distance" : 234,
//               "duration" : 120,
//               "connectingMode" : "2"
//             };

//         // format json
//         $scope.locationParameters = JSON.stringify(example)
//             .replace(/,"/g, ',\n"')
//             .replace('{', '{\n')
//             .replace('}', '\n}');

//         $scope.onInputChange = function () {
//             var params = {};
//             // validate json
//             try {
//                 params = JSON.parse($scope.locationParameters);
//                 // create MDVAssignedLocation element
//                 $scope.location = new MDVAssignedLocation(params);
//                 $scope.hint = '';
//             } catch (e) {
//                 if (e.description) {
//                     $scope.hint = e.description + ((e.data && e.data.reason) ? ': ' + e.data.reason : '');
//                 } else {
//                     $scope.hint = 'Invalid JSON format';
//                 }
//                 $scope.location = null;
//             }
//         };
//         // initial run
//         $scope.onInputChange();
//     }]);
// </file>
// </example>
    angular.module('mng-model')
        .factory('mng-model.MDVAssignedLocation', MDVAssignedLocation);

    MDVAssignedLocation.$inject = ['mng-util.MDVLog', 'mng-model.MDVUtil', 'mng-model.MDVLocation'];

    function MDVAssignedLocation(MDVLog, MDVModelUtil, MDVLocation) {
        var namespace = 'mng-model.MDVAssignedLocation',
            log = MDVLog.register(namespace);

        log.debug('initialize');

        return function(properties, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var _private,
                location;

            location = new MDVLocation(properties, true);
            _private = location._private;

            _private.$class = namespace;
            _private.originalToJSON = location.toJSON;

            // add additional properties
            _private.prepareOwnProperties = prepareOwnProperties;
            _private.selectProperties = selectProperties;
            _private.updatePropertyVersion = updatePropertyVersion;

            _private.prepareOwnProperties(properties);

            // keep private functions in global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate !== true) {
                location._private = undefined;
            }

            // override methods
            location.toJSON = toJSON.bind(location);

            // additional public methods
            location.assignedLocation = assignedLocation;
            location.connectingMode = connectingMode;
            location.distance = distance;
            location.duration = duration;

            // ////////////////////////////////

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVAssignedLocation
             * @name assignedLocation
             * @returns {String} ID of the location, this
             * {@link mng-model.object:MDVAssignedLocation assigned location} is bound to.
             * Empty string if no ID is available.
             *
             * @description
             * Get the id of the location this location is assigned to.
             */
            function assignedLocation() {
                return _private.props.assignedLocation || '';
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVAssignedLocation
             * @name connectingMode
             * @returns {String} product class of the connecting mode.
             *
             * @description
             * Get the product class of the transportation used to travel from the verified
             * location to the this assigned location.
             */
            function connectingMode() {
                return _private.props.connectingMode || '';
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVAssignedLocation
             * @name distance
             * @returns {Number|null} distance in meter or null, if no distance is available.
             *
             * @description
             * Get the distance in meter between the verified location and the assigned location.
             */
            function distance() {
                return _private.props.distance || null;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVAssignedLocation
             * @name duration
             * @returns {Number|null} duration in seconds or null, if no duration is available.
             *
             * @description
             * Get the duration in seconds between the verified location and the assigned location.
             */
            function duration() {
                return _private.props.duration || null;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVAssignedLocation
             * @name toJSON
             * @returns {Object} object with all necessary properties to reconstruct this object.
             *
             * @description
             * Get all properties of this object to reconstruct it later on. This method should be
             * used for persisting favorites or logging purposes. The returned object also provides
             * an version number, which allows the program to determine which interface version was
             * used for this formatting.
             *
             * **Note:** *This method is overridden in this class to extend the default
             * toJSON-output of a {@link mng-model.object:MDVLocation MDVLocation} with specific
             * properties that are available in this class.*
             */
            function toJSON() {
                var serialized = _private.originalToJSON.call(this);

                serialized = MDVModelUtil.setJSONValue.call(this, 'assignedLocation', serialized);
                serialized = MDVModelUtil.setJSONValue.call(this, 'connectingMode', serialized);
                serialized = MDVModelUtil.setJSONValue.call(this, 'distance', serialized);
                serialized = MDVModelUtil.setJSONValue.call(this, 'duration', serialized);

                return serialized;
            }

            // ////////////////////////////////

            function prepareOwnProperties(props) {
                if (!props) {
                    props = {};
                }
                props = _private.updatePropertyVersion(props);

                _private.selectProperties(props);
            }

            function selectProperties(props) {
                MDVModelUtil.setJSONValue.call(props, 'assignedLocation', location._private.props);
                MDVModelUtil.setJSONValue.call(props, 'connectingMode', location._private.props);
                MDVModelUtil.setJSONValue.call(props, 'distance', location._private.props);
                MDVModelUtil.setJSONValue.call(props, 'duration', location._private.props);
            }

            function updatePropertyVersion(props) {
                return props;
            }

            return location;
        };
    }
}());

(function() {
    'use strict';

    /**
     * @constructor
     * @ngdoc object
     * @name mng-model.object:MDVArrival
     * @requires mng-util.service:MDVLog
     * @requires mng-model.service:MDVUtil
     *
     * @description
     * The `MDVArrival` object is an abstract description of an arrival to a specific stop
     * location.
     * As this object provides an uniform interface, services and controllers can interact with it in
     * an uniform way, no matter where the information about this arrival comes from - as long as
     * the information is parsed to this object.
     *
     * ## General usage
     * To create a `MDVArrival` object, the constructor needs to be called with a set of
     * properties that describe the object.
     *
     * ```js
     *   // creation of a new MDVArrival
     *   var mdv_arrival = new MDVArrival({
     *      dateTimeSchedule : moment().add(5, 'minutes'),
     *      transportation : new MDVTransportation({
     *          name: 'NSW TrainLink Train 243',
     *          id : 'nsw:01243: :H:sj2',
     *      }),
     *      location : new MDVLocation({
     *          name : 'Central Station',
     *          id : '10101100'
     *      })
     *   });
     * ```
     *
     * Every `MDVArrival` has getter methods to access its properties. Please refer to the
     * properties documentation as well as the method documentation for a detailed description
     * (including an example) of the according attribute.
     *
     * ```js
     *   // get location of the MDVArrival
     *   console.log(mdv_arrival.location().name());  // 'Central Station'
     * ```
     * Please refer to the example below for further details.
     *
     * @example
<example module="MDVArrivalExample">
<file name="index.html">
    <div ng-controller="ArrivalController">
        My next arrival is <span am-time-ago="arrival.dateTime()"></span> at
        {{arrival.dateTime() | amDateFormat : 'hh:mm'}} from {{arrival.location().name()}} with
        line {{arrival.transportation().name()}}.
    </div>
</file>
<file name="script.js">
  angular.module('MDVArrivalExample', ['angularMoment', 'mng-model'])
    .controller('ArrivalController', ['$scope', 'moment', 'mng-model.MDVLocation',
        'mng-model.MDVArrival', 'mng-model.MDVTransportation',
    function ($scope, moment, MDVLocation, MDVArrival, MDVTransportation) {
        $scope.arrival = new MDVArrival({
            dateTimeSchedule : moment().add(5, 'minutes'),
            transportation : new MDVTransportation({
                name: 'NSW TrainLink Train 243',
                id : 'nsw:01243: :H:sj2',
            }),
            location : new MDVLocation({
                name : 'Central Station',
                id : '10101100'
            })
        });
    }]);
</file>
</example>
     */

    /**
     * @ngdoc property
     * @name mng-model.object:MDVArrival#dateTime
     * @propertyOf mng-model.object:MDVArrival
     *
     * @description
     * **moment-object** *moment().add(5, 'minutes')*
     *
     * Moment object that describes the actual date and time the arrival is at. This time can
     * differ from **dateTimeSchedule** when real-time information is available and the real
     * arrival time differs from the scheduled one. If no real-time information is available, the
     * dateTime property is the same as **dateTimeSchedule**.
     */
    /**
     * @ngdoc property
     * @name mng-model.object:MDVArrival#dateTimeSchedule
     * @propertyOf mng-model.object:MDVArrival
     *
     * @description
     * *required*
     *
     * **moment-object** *moment().add(5, 'minutes')*
     *
     * Moment object that describes the date and time the arrival is scheduled at. This time can
     * differ from **dateTime** when real-time information is available and the real arrival time
     * differs from the scheduled one. If no real-time information is available, the
     * dateTimeSchedule and the **dateTime** property are the same.
     */
    /**
     * @ngdoc property
     * @name mng-model.object:MDVArrival#location
     * @propertyOf mng-model.object:MDVArrival
     *
     * @description
     * *required*
     *
     * **MDVLocation** *new MDVLocation({...})*
     *
     * Location the arrival is at.
     */
    /**
     * @ngdoc property
     * @name mng-model.object:MDVArrival#transportation
     * @propertyOf mng-model.object:MDVArrival
     *
     * @description
     * *required*
     *
     * **MDVTransportation** *new MDVTransportation({...})*
     *
     * Object that describes the line that is departing.
     */
    /**
     * @ngdoc property
     * @name mng-model.object:MDVArrival#notification
     * @propertyOf mng-model.object:MDVArrival
     *
     * @description
     * **Object[]** *[]*
     *
     * Notifications that are available for this arrival. This might be additional information
     * like accessibility information, or reasons for delays.
     */

    angular.module('mng-model')
        .factory('mng-model.MDVArrival', MDVArrival);

    MDVArrival.$inject = ['mng-util.MDVLog', 'mng-model.MDVUtil'];

    function MDVArrival(MDVLog, MDVModelUtil) {
        var namespace = 'mng-model.MDVArrival',
            log = MDVLog.register(namespace),
            VERSION = 2,
            Constructor;

        log.debug('initialize');

        Constructor = function(props, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var _private = {
                mergeInfoLists : mergeInfoLists,
                prepareProperties : prepareProperties,
                selectProperties : selectProperties,
                updatePropertyVersion : updatePropertyVersion,
                raw : (props && props.raw) ? props.raw : {},
                standardProperties : [
                    'isRealtimeControlled',
                    'isCancelled'
                ],
                $version : VERSION,
                $class : namespace
            };

            // assure raw is loaded correctly, before it is removed from props
            _private.props = prepareProperties(props);

            // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate === true) {
                this._private = _private;
            }

            // public
            this.dateTime = dateTime;
            this.dateTimeEstimated = dateTimeEstimated;
            this.dateTimePlanned = dateTimePlanned;
            this.delay = delay;
            this.equals = equals;
            this.hasRealtime = hasRealtime;
            this.hints = hints;
            this.infos = infos;
            this.isDelayed = isDelayed;
            this.isRealtimeControlled = isRealtimeControlled;
            this.isCancelled = isCancelled;
            this.location = location;
            this.raw = raw;
            this.onwardStopSeq = onwardStopSeq;
            this.prevStopSeq = prevStopSeq;
            this.properties = getProperties;
            this.transportation = transportation;
            this.toJSON = toJSON;

            // ////////////////////////////////

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name raw
             * @returns {Object} raw object the data of this model is from
             *
             * @description
             * Get the original response object the data of this model is from.
             */
            function raw() {
                return _private.raw;
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name dateTime
             * @returns {moment} moment object for the actual arrival time
             *
             * @description
             * Get the actual date and time of the arrival. This time can differ to the
             * **dateTimePlanned** value, as real-time information is also included. If no real-time
             * is available, the results are equal.
             */
            function dateTime() {
                if (isRealtimeControlled.call(this)) {
                    return dateTimeEstimated.call(this);
                }
                return dateTimePlanned.call(this);
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name dateTimePlanned
             * @returns {moment} moment object for the scheduled departure time
             *
             * @description
             * Get the scheduled date and time of the departure. This time can differ to the
             * **dateTime** value, when real-time information is available.
             */
            function dateTimePlanned() {
                return _private.props.dateTimePlanned || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name dateTimeEstimated
             * @returns {moment} moment object for the estimated departure time
             *
             * @description
             * Get the estimated date and time of the departure. This time can differ to the
             * **dateTimePlanned** value, as real-time information is included. If no real-time is
             * available, null is returned.
             */
            function dateTimeEstimated() {
                return _private.props.dateTimeEstimated || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name delay
             * @returns {Number|null} delay in minutes, or null if no real-time is available. "null" is
             * used as -1, 0 or Number.MAX_VALUE are valid delay information.
             *
             * @description
             * Get the difference between scheduled time and actual arrival time. If no real-time
             * information is available, this method returns null.
             */
            function delay() {
                if (!hasRealtime.call(this)) {
                    return null;
                }
                return (dateTimeEstimated.call(this) - dateTimePlanned.call(this)) / 1000;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name equals
             * @param {MDVArrival} arrival object that should be compared with this arrival.
             * @returns {Boolean} true: arrival is the same, false otherwise.
             *
             * @description
             * Check if a given arrival object equals this arrival.
             * Two arrivals are the same if they share the same location, time and transportation.
             */
            function equals(arrival) {
                if (!arrival) {
                    return false;
                }
                if (!this.location().equals(arrival.location())) {
                    return false;
                }
                if (!this.dateTime().isSame(arrival.dateTime())) {
                    return false;
                }
                if (!this.transportation().equals(arrival.transportation())) {
                    return false;
                }
                return true;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name hasRealtime
             * @returns {Boolean} true: real-time available, false otherwise
             *
             * @description
             * Determine whether real-time information is available or not.
             */
            function hasRealtime() {
                return Boolean(_private.props.hasOwnProperty('dateTimeEstimated') &&
                            _private.props.dateTimeEstimated);
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name isDelayed
             * @returns {Boolean} true: arrival is delayed , false otherwise
             *
             * @description
             * Determine whether this arrival is delayed (actual arrival time is later than the
             * scheduled one), or not.
             */
            function isDelayed() {
                if (!hasRealtime.call(this)) {
                    return null;
                }
                return (dateTimeEstimated.call(this) - dateTimePlanned.call(this)) <= 0;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name isRealtimeControlled
             * @returns {Boolean} Whether this Arrival has a real-time controlled transportation (true),
             * or not (false).
             *
             * @description
             * Check whether this Arrival provides realtime or not.
             */
            function isRealtimeControlled() {
                return _private.props.isRealtimeControlled || false;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name isCancelled
             * @returns {Boolean|string[]} true: Arrival is cancelled, string[]: cancellation reasons
             * if available, false: Arrival drives as planned.
             *
             * @description
             * Determine whether this Arrival is cancelled or not.
             */
            function isCancelled() {
                return _private.props.isCancelled || false;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name location
             * @returns {MDVLocation} location of the arrival
             *
             * @description
             * Get the location of this arrival.
             */
            function location() {
                return _private.props.location || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name toJSON
             * @returns {Object} object with all necessary properties to reconstruct this object.
             *
             * @description
             * Get all properties of this object to reconstruct it later on. This method should be
             * used for persisting favorites or logging purposes. The returned object also provides
             * an version number, which allows the program to determine which interface version was
             * used for this formatting.
             */
            function toJSON() {
                var serialized = MDVModelUtil.getStandardJSON
                        .call(this, _private.$class, _private.$version, _private.standardProperties);

                MDVModelUtil.setValue
                    .call(this, 'dateTimeEstimated', serialized, function(value) {
                        return value.format();
                    });
                MDVModelUtil.setValue
                    .call(this, 'dateTimePlanned', serialized, function(value) {
                        return value.format();
                    });
                MDVModelUtil.setValue
                    .call(this, 'hints', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });
                MDVModelUtil.setValue
                    .call(this, 'infos', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });
                MDVModelUtil.setValue
                    .call(this, 'location', serialized, function(value) {
                        return value.toJSON();
                    });
                MDVModelUtil.setValue
                    .call(this, 'onwardStopSeq', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });
                MDVModelUtil.setValue
                    .call(this, 'prevStopSeq', serialized, function(value) {
                        return MDVModelUtil.toJSONArray(value);
                    });
                MDVModelUtil.setValue
                    .call(this, 'transportation', serialized, function(value) {
                        return value.toJSON();
                    });

                MDVModelUtil.setValue
                    .call(this, 'properties', serialized, function(value) {
                        // assure properties are pure json
                        return JSON.parse(JSON.stringify(value));
                    });

                return serialized;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name transportation
             * @returns {MDVTransportation} line the arrival is about
             *
             * @description
             * Get the serving line that departs. This object also contains the destination/ direction
             * and all information for the line, like number, mot a.s.o. See {{@link
             * mng-model.object:MDVTransportation MDVTransportation}} for further details.
             */
            function transportation() {
                return _private.props.transportation || null;
            }
            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name hints
             * @returns {MDVMessage[]} list of MDVMessage about this arrival
             *
             * @description
             * Get a list of static information about this arrival, like accessibility information.
             */
            function hints() {
                return _private.props.hints || [];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name infos
             * @returns {MDVMessage[]} list of MDVMessage about this arrival
             *
             * @description
             * Get a list of additional information about this arrival. This list can contain
             * low priority information, but also critical messages that inform the user why the
             * arrival is delayed.
             */
            function infos() {
                var res = [];

                if (_private.props.location && _private.props.location.infos) {
                    res = res.concat(_private.props.location.infos() || []);
                }
                if (_private.props.infos) {
                    res = mergeInfoLists(res, _private.props.infos);
                }

                return res;
            }


            function onwardStopSeq() {
                return _private.props.onwardStopSeq || [];
            }


            function prevStopSeq() {
                return _private.props.prevStopSeq || [];
            }

            /**
             * @public
             * @ngdoc method
             * @methodOf mng-model.object:MDVArrival
             * @name properties
             * @returns {Object} Additional properties that are bound to this arrival
             *
             * @description
             * Get additional properties of this arrival.
             */
            function getProperties() {
                return _private.props.properties || {};
            }


            // ////////////////////////////////

            function prepareProperties(properties) {
                if (!properties) {
                    properties = {};
                }
                properties = _private.updatePropertyVersion(properties);

                return _private.selectProperties(properties);
            }

            function selectProperties(properties) {
                // set standard values
                var prepProps = MDVModelUtil.getStandardJSON
                        .call(properties, _private.$class, _private.$version,
                                                                    _private.standardProperties);

                prepProps = MDVModelUtil.setJSONValue.call(properties, 'properties', prepProps);

                MDVModelUtil.setValue
                    .call(properties, 'dateTimeEstimated', prepProps, function(value) {
                        return MDVModelUtil.parseMoment(value);
                    });
                MDVModelUtil.setValue
                    .call(properties, 'dateTimePlanned', prepProps, function(value) {
                        return MDVModelUtil.parseMoment(value);
                    });
                MDVModelUtil.setValue
                    .call(properties, 'hints', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });
                MDVModelUtil.setValue
                    .call(properties, 'infos', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });
                MDVModelUtil.setValue
                    .call(properties, 'location', prepProps, function(value) {
                        return MDVModelUtil.parseModel(value);
                    });
                MDVModelUtil.setValue
                    .call(properties, 'onwardStopSeq', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });
                MDVModelUtil.setValue
                    .call(properties, 'prevStopSeq', prepProps, function(value) {
                        return MDVModelUtil.parseModels(value);
                    });
                MDVModelUtil.setValue
                    .call(properties, 'transportation', prepProps, function(value) {
                        return MDVModelUtil.parseModel(value);
                    });

                return prepProps;
            }

            function updatePropertyVersion(properties) {
                if (properties.hasOwnProperty('VERSION')) {
                    log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                        'please delete all old versions to avoid data loss or incorrect behavior');
                    return {};
                }
                // version check
                if (properties.$version && properties.$version !== _private.$version) {
                    if (properties.$version > VERSION) {
                        log.error('unknown version: ' + properties.$version +
                            '. Highest available version: ' + _private.$version);

                        return {};
                    }
                    // convert values to current version
                    // if (properties.$version === 2) {
                    //     properties.xy = properties.oldValue;
                    // }

                    // all other unsupported/ unknown versions
                    if (properties.$version === 1) {
                        log.warn('invalid version. Version 1 is no longer supported by the modules.' +
                            'please delete all old versions to avoid data loss or incorrect behavior');
                        return {};
                    } else {
                        // all others
                        log.error('unknown version: ' + properties.$version +
                            '. Lowest available version: 1');

                        return {};
                    }
                }
                return properties;
            }

            function mergeInfoLists(dst, src) {
                var i, j, k, l,
                    isDuplicate,
                    res = [];

                for (i = 0, l = src.length; i < l; i += 1) {
                    isDuplicate = false;
                    for (j = 0, k = dst.length; j < k; j += 1) {
                        if (dst[j].equals(src[i])) {
                            isDuplicate = true;
                        }
                    }
                    if (!isDuplicate) {
                        res.push(src[i]);
                    }
                }

                return dst.concat(res);
            }

            return this;
        };

        return Constructor;
    }
}());

(function(window) {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc overview
     * @name mng-leaflet
     * @module mng-leaflet
     *
     * @description
     * # mng-leaflet (Leaflet module)
     * The mng-leaflet module contains leaflet plugins.
     *
     * ## General usage
     * ```js
     * // inject mng-leaflet-components only
     * angular.module('your.module', ['mng-leaflet']);
     * ```
     *
     * ## components
     * The following list gives a short overview of the available components within this module.
     * For further details, please refer to the components themselves.
     *
     * ### MNGLeaflet
     * This is the core module that allows you to integrate a native Leaflet map to your application
     *
     * ### MNGVector
     * This component adds Vector tiles to a map instance.
     *
     * ### MDVLeafletCoord
     * Add stop or poi markers to the map and dynamically update them whenever the map is moved.

     * ### MDVLeafletVELOC
     * Add vehicle position markers to the map and dynamically update them whenever the map is
     * moved and within a certain interval.
     */
    angular.module('mng-leaflet', ['mng-util', 'mng-comm', 'mng-config'])
        .constant('L', window.L)
        .constant('ML', window.ML);
}(window));

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc directive
     * @name mng-leaflet.directive:MngVector
     * @requires L
     * @requires ML
     * @requires mng-util.service:MDVLog
     * @requires mng-config.service:MDVConfig
     * @requires mng-leaflet.service:MDVLeafletData
     *
     * @description
     * The `MngVector` directive provides an angular connection of the native MENTZ plugin to create
     * vector tiles.
     *
     * # Usage
     * To use this directive, add it to a mng-leaflet tag.
     *
     * Example:
     * ```xml
     * <mng-leaflet mng-vector id="myMap" width="1000px" height="600px"></mng-leaflet>
     * ```
     *
     * # Configuration
     * This directive uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-leaflet.MNGVector`.
     *
     * The configuration is split up in two parts. One part, called `tileConfig` describes the
     * configuration of the basic vector tiles, the other part, called `textConfig`, describes the
     * configuration of the text overlay.
     *
     * ## {Object} tileConfig
     * The tileConfig option describes the configuration of the basic vector tiles without texts.
     * See the documentation of the native LLBase/TileLayer/ML.TileLayerIndoor plugin for further
     * details.
     *
     * ### {String} url
     * Url the tile data is fetched from
     *
     * ### {Number} tileSize
     * Size of the quadratic vector tiles (usually 256)
     *
     * ### {Number} minZoom
     * Minimal zoom where the vector tiles should start at.
     *
     * ### {Number} maxZoom
     * Maximal zoom where the vector tiles should end at.
     *
     * ### {Number} indoor_minZoom
     * Minimal zoom where the vector tiles should be rendered with indoor information.
     *
     * ### {String} attribution
     * Attribution of the layer
     *
     * ## {Object} textConfig
     * This configuration deals with the rendering of the texts for the vector tiles.
     * See the documentation of the native LLBase/VectorLayer/ML.TextLayerIndoor plugin for further
     * details.
     *
     * ### {String} url
     * Url the text data is fetched from
     *
     * ### {Number} minZoom
     * Minimal zoom where the text should start at.
     *
     * ### {Number} maxZoom
     * Maximal zoom where the text should end at.
     *
     * ## Example:
     * ```js
     *   // configuration object
     *   ...
     *   "MNGVector" : {
     *      tileConfig : {
     *          url : 'http://an-w7.m.mdv/wms/',
     *          tileSize : 256,
     *          minZoom : 17,
     *          maxZoom : 21,
     *          indoor_minZoom : 18,
     *          attribution : 'Map data <a href="http://www.openstreetmap.org/copyright">&copy; ' +
     *              'OpenStreetMap contributors</a>'
     *      },
     *      textConfig : {
     *          url : 'http://an-w7.m.mdv/wms/',
     *          minZoom : 17,
     *          maxZoom : 21
     *      }
     *  },
     *   ...
     * ```
     */
    angular.module('mng-leaflet').directive('mngVector', Vector);
    Vector.$inject = ['L', 'ML', 'mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-leaflet.MDVLeafletData'];

    function Vector(L, ML, MDVLog, MDVConfig, MDVLeafletData) {
        var log = MDVLog.register('mng-leaflet.mngVectorMapDirective');

        log.debug('initialize');

        return {
            restrict : 'A',
            scope : false,
            link : function(scope, elem, attr) {

                if (!attr || !attr.id) {
                    return log.error('tried to initialize VectorMap without map instance/id');
                }

                // read in options
                MDVConfig.ready(function() {
                    var options = MDVConfig.getValue('mng-leaflet.MNGVector');

                    log.debug('initialize vector map');

                    if (!options.tileConfig || !options.tileConfig.url || !options.textConfig) {
                        return log.error('tried to initialize VectorMap without or with an invalid' +
                            ' tileConfig option. Please check mng-leaflet.MNGVector.');
                    }

                    MDVLeafletData.get(attr.id)
                        .then(function(map) {
                            // Vector Kacheln
                            map.addLayer(new ML.TileLayerIndoor(options.tileConfig.url, options.tileConfig));
                            map.addLayer(new ML.TextLayerIndoor(options.textConfig));
                        });

                });

            }
        };
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc directive
     * @name mng-leaflet.directive:MngLeaflet
     * @requires L
     * @requires ML
     * @requires mng-util.service:MDVLog
     * @requires mng-config.service:MDVConfig
     * @requires mng-leaflet.service:MDVLeafletData
     *
     * @description
     * The `MngLeaflet` directive provides an angular connection of the native leaflet plugin.
     *
     * # Usage
     * To use this directive, add it to your DOM. You also need to specify an id, width and height
     * attribute, like it is needed with the native leaflet plugin.
     *
     * Example:
     * ```xml
     * <mng-leaflet id="myMap" width="1000px" height="600px"></mng-leaflet>
     * ```
     *
     * # Configuration
     * This directive uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-leaflet.MNGLeaflet`.
     *
     * ## basic structure
     * Depending on the "id"-attribute the directive is called, the directive tries to fetch the
     * id-specific configuration. If no configuration for the specific id is found, it falls back to
     * "default". Each of those specific configurations describe a configuration that is passed to
     * leaflet (with options like zoom or center, see the {@link
     * http://leafletjs.com/reference-1.1.0.html#map-option official leaflet documentation} for more
     * details).
     * Next to this configuration the following options can be passed in the configuration:
     *
     * ### {Object[]} layerOptions
     * For every element in this array, a new layer is created (with the element used as option) and
     * added to the map. See the {@link http://leafletjs.com/reference-1.1.0.html#tilelayer official
     * leaflet documentation} for more details.
     *
     * ## Example:
     * ```js
     *   // configuration object
     *   ...
     *   "MNGLeaflet" : {
     *      default : {
     *          center : [48.1388859, 11.5646553],  // munich
     *          zoom : 14,
     *          layerOptions : [{
     *              url : 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
     *              attribution : '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
     *              maxZoom : 16,
     *              minZoom : 5
     *          }]
     *      }
     *  }
     *   ...
     * ```
     */
    angular.module('mng-leaflet')
        .directive('mngLeaflet', Leaflet);

    Leaflet.$inject = ['L', 'ML', 'mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-leaflet.MDVLeafletData', '$interval'];

    function Leaflet(L, ML, MDVLog, MDVConfig, MDVLeafletData, $interval) {
        var log = MDVLog.register('mng-leaflet.mngLeaflet directive');

        log.debug('initialize');

        function isDefined(value) {
            return angular.isDefined(value) && value !== null;
        }

        function getOptions(attrs) {
            var options = MDVConfig.getValue('mng-leaflet.MNGLeaflet');
            if (options) {
                if (options[attrs.id]) {
                    return options[attrs.id];
                } else {
                    return options.default;
                }
            }
        }

        function updateWidth(element, attrs) {
            if (isNaN(attrs.width)) {
                element.css('width', attrs.width);
            } else {
                element.css('width', attrs.width + 'px');
            }
        }

        function updateHeight(element, attrs) {
            if (isNaN(attrs.height)) {
                element.css('height', attrs.height);
            } else {
                element.css('height', attrs.height + 'px');
            }
        }

        function handleMapSize(scope, element, attrs, map) {
            // If the width attribute defined update css
            // Then watch if bound property changes and update css
            if (isDefined(attrs.width)) {
                updateWidth(element, attrs);

                // take care about map resizing/ initial update
                scope.$watch(
                    function() {
                        return element[0].getAttribute('width');
                    },
                    function() {
                        updateWidth(element, attrs);
                        map.invalidateSize();
                    });
            }

            // If the height attribute defined update css
            // Then watch if bound property changes and update css
            if (isDefined(attrs.height)) {
                updateHeight(element, attrs);

                // take care about map resizing/ initial update
                scope.$watch(
                    function() {
                        return element[0].getAttribute('height');
                    },
                    function() {
                        updateHeight(element, attrs);
                        map.invalidateSize();
                    });
            }
        }

        function addTrafficLayer(map, options, scope) {
            options.layerOptions.forEach(function(layer) {
                if (layer.id === 'traffic') {
                    var mlLayer = ML.tileLayer(layer.url, layer);
                    mlLayer.addTo(map);
                    startInterval(scope, mlLayer, layer.url);
                }
            });
        }
        function deleteTrafficLayer(map) {
            map.eachLayer(function(layer){
                if (layer.options.id == 'traffic') {
                    layer.removeFrom(map);
                }
            });
        }

        function handleMapLayers(scope, map, options) {
            if (window.localStorage['VRN_MAP_FILTER']) {
                var filterObject = JSON.parse(window.localStorage['VRN_MAP_FILTER']);
                var showTraffic = filterObject.traffic;
            }
            if (options && options.layerOptions) {
                if (options.layerOptions.defaultLayer && options.layerOptions.mapLayers) {
                    L.initLayers(map, options.layerOptions);
                } else if (options.layerOptions.length) {
                    // VRN fallback, should be removed
                    options.layerOptions.forEach(function(layer) {
                        if (showTraffic) {
                            var mlLayer = ML.tileLayer(layer.url, layer);
                            if (ML && ML.tileLayer) {
                                mlLayer.addTo(map);
                                if (layer.id === 'traffic') {
                                    startInterval(scope, mlLayer, layer.url);
                                }
                            } else {
                                L.tileLayer(layer.url, layer).addTo(map);
                            }
                        } else {
                            if (layer.id !== 'traffic') {
                                if (ML && ML.tileLayer) {
                                    ML.tileLayer(layer.url, layer).addTo(map);
                                } else {
                                    L.tileLayer(layer.url, layer).addTo(map);
                                }
                            }
                        }
                    });
                }
            } else {
                // fallback to osm if no options are provided to at least show anything
                L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
                    attribution : '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                }).addTo(map);
            }
        }

        function startInterval(scope, layer, url) {
            scope.interval = $interval(function() {
                var time = moment().format('YYYY-MM-DD HH:SS');
                console.log('time', time);
                var updatedUrl = url+'&' + time;
                layer.setUrl([updatedUrl]);
            }, 60000);
        }

        function stopInterval(scope) {
            $interval.cancel(scope.interval);
        }

        function link(scope, element, attrs) {
            var map,
                options;

            scope.addTraffic = function(){
                addTrafficLayer(map, options, scope);
            };
            scope.$on('addTraffic',function(event, data){
                scope.addTraffic()
            });
            scope.deleteTraffic = function(){
                deleteTrafficLayer(map);
                stopInterval(scope);
            };
            scope.$on('deleteTraffic',function(event, data){
                scope.deleteTraffic()
            });

            // read in options
            MDVConfig.ready(function() {
                options = getOptions(attrs);

                if (!options || !options.center || (!options.zoom && options.zoom !== 0)) {
                    log.error('no options set for mng-leaflet.MNGLeaflet. please check your ' +
                        'config and at least set a center and a zoom for a default map.');
                    return;
                }

                scope.mapId = attrs.id;

                // Create the Leaflet Map Object with the options
                map = new L.Map(element[0], options);

                handleMapLayers(scope, map, options);

                handleMapSize(scope, element, attrs, map);

                // Resolve the map object to the promises
                map.whenReady(function() {
                    MDVLeafletData.add(attrs.id, map);

                    // remove map id from registry if scope (and map) is destroyed
                    scope.$on('$destroy', function () {
                        MDVLeafletData.remove(attrs.id);
                    });
                });
            });

        }

        return {
            restrict : 'E',
            // removed as options should be passed via normal MDVConfig structure
            // scope : {
            //     mapOptions : '='
            // },
            scope: { opt: '='},
            replace : true,
            template : '<div class="mng-leaflet-map"></div>',
            link : link
        };
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-leaflet.service:MDVLeafletVELOC
     * @requires $timeout
     * @requires L
     * @requires mng-util.service:MDVLog
     * @requires mng-config.service:MDVConfig
     * @requires mng-comm.service:MDVUtil
     * @requires mng-comm.service:MDVLivePositionsRequester
     * @requires mng-leaflet.service:MDVLeafletTiler
     *
     * @description
     * The `MDVLeafletVELOC` service is used to dynamically add dynamic vehicle markers to a map
     * instance. It takes care about adding and removing markers whenever the map is moved in order
     * display only markers that are visible to the user. It also takes care about a perioic update
     * of the vehicle data to assure the markers are up to date.
     *
     * # Usage
     * This factory can be instantiated with two properties:
     *
     * ## map
     * The first property describes a native leaflet map instance the veloc data should be bound to.
     *
     * ## options
     * This factory allows you to pass multiple options in order to customize the way the data is
     * added. This object can contain the following properties:
     *
     * ### {Object} requestOptions (required)
     * Options that are used for the MDVLocationRequester.searchArea() call.
     *
     * ### {Number} updateInterval (default: 10 000)
     * Defines the interval the vehicle positions should be updated with, in milliseconds. As this
     * update includes a request to the backend, the interval should not be set lower than 10
     * seconds (default).
     *
     * ### {Object} tilerOptions
     * Options that are passed to the MDVLeafletTiler factory. Usually the factory accepts all
     * options that are also accepted by the by the native MENTZ plugin
     * LLBase/TileLayer/ML.RequestTiler.
     * Please refer to {@link mng-leaflet.MDVLeafletTiler MDVLeafletTiler} for further details.
     *
     * ### {Boolean} delayInit (default: false)
     * The service is enabled after initialization per default. To disable this functionality, the
     * flag can be set to `true`. The MDVLeafletVELOC object needs to be enabled manually then (by
     * calling the `enable()` method).
     *
     */
    angular.module('mng-leaflet')
        .factory('mng-leaflet.MDVLeafletVELOC', MDVLeafletVELOC);

    MDVLeafletVELOC.$inject = ['$timeout', 'L', 'mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-comm.MDVUtil', 'mng-leaflet.MDVLeafletTiler', 'mng-comm.MDVLivePositionsRequester'];

    function MDVLeafletVELOC($timeout, L, MDVLog, MDVConfig, MDVCommUtil, MDVLeafletTiler,
            MDVLivePositionsRequester) {
        var log = MDVLog.register('mng-leaflet.MDVLeafletVELOC'),
            Constructor;

        log.debug('initialize');

        Constructor = function(map, options, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            var _private = {
                currTimeout : null,
                map : map,
                fixOptions : options || {},
                initialized : false,
                markerLayer : options.layer || L.featureGroup(),
                options : MDVConfig.getValue('mng-leaflet.MDVLeafletVELOC.options')
            };

            // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate === true) {
                this._private = _private;
            }

            if (!_private.fixOptions.updateInterval) {
                _private.fixOptions.updateInterval = 10000;  // 10 seconds
            }


            this.enable = enable;
            this.disable = disable;
            this.update = update;
            this.getOptions = getOptions;
            this.setGetMarkerOptions = setGetMarkerOptions;
            this.setFilterFunction = setFilterFunction;
            this.setModifyMarker = setModifyMarker;

            _private.filterFunction = _private.fixOptions.filterFunction || function(list) {
                return list;
            };
            _private.getMarkerOptions = _private.fixOptions.getMarkerOptions || function() {
                return {};
            };
            _private.modifyMarker = _private.fixOptions.modifyMarker || function(marker) {
                return marker;
            };


            _private.start = function() {
                if (!_private.enabled || _private.active) {
                    return;
                }
                _private.active = true;
                _private.map.addLayer(_private.markerLayer);
                _private.map.on('moveend', _private.update);
                _private.update();
            };
            _private.stop = function() {
                if (_private.enabled || !_private.active) {
                    return;
                }
                _private.active = false;
                _private.map.off('moveend', _private.update);
                _private.map.removeLayer(_private.markerLayer);
            };

            // ///////////////////////////////////

            function enable() {
                if (_private.enabled) {
                    return;
                }
                if (!_private.initialized && _private.fixOptions.delayInit) {
                    log.debug('initialize ' + options.label + ' tiler instance');
                    _private.initTilerInstance();
                }
                _private.enabled = true;
                _private.start();
            }
            function disable() {
                if (!_private.enabled) {
                    return;
                }
                _private.enabled = false;
                _private.stop();
            }

            function getOptions() {
                return _private.options;
            }

            function update() {
                return _private.update();
            }

            _private.update = function() {
                if (!_private.initialized || !_private.enabled || !_private.isCorrectZoom()) {
                    return;
                }
                return _private.request();
            };

            function setModifyMarker(func) {
                _private.modifyMarker = func;
            }

            function setGetMarkerOptions(func) {
                _private.getMarkerOptions = func;
            }
            function setFilterFunction(func) {
                _private.filterFunction = func;
            }


            _private.request = function() {
                if (_private.currTimeout) {
                    $timeout.cancel(_private.currTimeout);
                    _private.currTimeout = null;
                }

                _private.currTimeout = $timeout(function() {
                    update();
                }, _private.fixOptions.updateInterval, false);

                // assure VELOC is always requested
                _private.tilerInstance.clearCache();

                return _private.tilerInstance.update(_private.map.getBounds(), _private.map.getZoom())
                    .then(_private.update_map, function() {
                        $timeout.cancel(_private.currTimeout);
                        _private.currTimeout = null;
                    }, _private.update_map);
                    // function() {
                    //     _private.update_map();
                    //     // TODO is timeout in callback a good idea? if the request takes longer than
                    //     // expected it may delay the whole update cycle. On the other hand it assures,
                    //     // that the requests are not mixed up/ sent multiple times
                    //     _private.currTimeout = $timeout(function() {
                    //         update();
                    //     }, _private.fixOptions.updateInterval, false);
                    // });
            };

            _private.update_map = function() {
                var list = _private.tilerInstance.getResults(),
                    i,
                    l,
                    curr_marker;

                list = _private.filterFunction(list);

                _private.markerLayer.clearLayers();

                for (i = 0, l = list.length; i < l; i += 1) {
                    if (_private.passFilterOptions(list[i])) {
                        var coord = (list[i].origin().coord() || list[i].destination().coord());

                        curr_marker = L.marker(coord, _private.getMarkerOptions(list[i]), 'veloc');
                        _private.modifyMarker(curr_marker, list[i]);
                        _private.markerLayer.addLayer(curr_marker);
                    }
                }
            };

            _private.passFilterOptions = function(transportation) {
                var showVehiculesWithoutDelay = true,
                    minVehiculeDelay = 0;

                if (!_private.options || !_private.options.filter || !_private.options.filter.enable) {
                    return true;
                }

                if (_private.options && _private.options.filter.hasOwnProperty('showVehiculesWithoutDelay')) {
                    showVehiculesWithoutDelay = _private.options.filter.showVehiculesWithoutDelay;
                }

                if (_private.options && _private.options.filter.hasOwnProperty('minVehiculeDelay')) {
                    minVehiculeDelay = _private.options.filter.minVehiculeDelay;
                }

                if (!showVehiculesWithoutDelay && (transportation.properties().delay===0)) {
                    return false;
                }

                if ((minVehiculeDelay > 0) && ((transportation.properties().delay / 60) < minVehiculeDelay)) {
                    return false;
                }

                return true;
            };


            _private.isCorrectZoom = function() {
                var zoom = _private.map.getZoom();

                if (!_private.fixOptions.minZoom && !_private.fixOptions.maxZoom) {
                    // all zooms enabled
                    return true;
                }

                if (_private.fixOptions.minZoom && !_private.fixOptions.maxZoom) {
                    // min zoom only
                    if (zoom >= _private.fixOptions.minZoom) {
                        return true;
                    }
                }

                if (_private.fixOptions.maxZoom && !_private.fixOptions.minZoom) {
                    // max zoom only
                    if (zoom <= _private.fixOptions.maxZoom) {
                        return true;
                    }
                }

                if (_private.fixOptions.maxZoom && _private.fixOptions.minZoom) {
                    // both
                    if (zoom >= _private.fixOptions.minZoom && zoom <= _private.fixOptions.maxZoom) {
                        return true;
                    }
                }
                return false;
            };

            _private.zoomlevelcheck = function() {
                if (_private.isCorrectZoom()) {
                    // log.debug('automatic start');
                    _private.start();
                } else {
                    // log.debug('automatic stop');
                    _private.stop();
                }
            };

            _private.createRequestFunction = function() {
                return function(bounds) {
                    return MDVLivePositionsRequester.search(bounds.getNorthWest(),
                        bounds.getSouthEast(), _private.options);
                };
            };

            _private.initTilerInstance = function() {
                _private.fixOptions.tilerOptions.useTiling = false;
                _private.tilerInstance = new MDVLeafletTiler(_private.fixOptions.tilerOptions);
                _private.tilerInstance.setRequestFunction(_private.createRequestFunction());
                _private.map.on('zoomend', _private.zoomlevelcheck);
                _private.initialized = true;
            };

            if (!_private.fixOptions.delayInit) {
                _private.initTilerInstance();
            }
            return this;
        };

        return Constructor;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-leaflet.service:MDVLeafletTrafficMessages
     * @requires L
     * @requires mng-util.service:MDVLog
     * @requires mng-util.service:MDVException
     * @requires mng-comm.service:MDVLocationRequester
     * @requires mng-leaflet.service:MDVLeafletTiler
     *
     * @description
     * The `MDVLeafletTrafficMessages` service is used to dynamically add static traffic-messages-pois markers to a map
     * instance. It takes care about adding and removing markers whenever the map is moved in order
     * display only markers that are visible to the user.
     *
     * # Usage
     * This factory can be instantiated with two properties:
     *
     * ## map
     * The first property describes a native leaflet map instance the coord data should be bound to.
     *
     * ## options
     * This factory allows you to pass multiple options in order to customize the way the data is
     * added. This object can contain the following properties:
     *
     * ### {Object} requestOptions (required)
     * Options that are used for the MDVLocationRequester.searchArea() call.
     *
     * ### {Object} tilerOptions
     * Options that are passed to the MDVLeafletTiler factory. Usually the factory accepts all
     * options that are also accepted by the by the native MENTZ plugin
     * LLBase/TileLayer/ML.RequestTiler.
     * Please refer to {@link mng-leaflet.MDVLeafletTiler MDVLeafletTiler} for further details.
     *
     * ### {Boolean} delayInit (default: false)
     * The service is enabled after initialization per default. To disable this functionality, the
     * flag can be set to `true`. The MDVLeafletTrafficMessages object needs to be enabled manually then (by
     * calling the `enable()` method).
     *
     * ### {Boolean} hardReload (default: false)
     * Flag to remove all markers before the new ones are added. This is used to draw markers in a
     * different way after an update. Per default all markers that were added are not removed unless
     * they are out of bounds.
     *
     */
    angular.module('mng-leaflet')
        .factory('mng-leaflet.MDVLeafletTrafficMessages', MDVLeafletTrafficMessages);

    MDVLeafletTrafficMessages.$inject = ['L', 'mng-util.MDVLog', 'mng-util.MDVException',
        'mng-leaflet.MDVLeafletTiler', 'mng-comm.MDVLocationRequester', 'mng-comm.MDVMessageRequester'];

    function MDVLeafletTrafficMessages(L, MDVLog, MDVException, MDVLeafletTiler, MDVLocationRequester, MDVMessageRequester) {
        var log = MDVLog.register('mng-leaflet.MDVLeafletTrafficMessages'),
            Constructor;

        log.debug('initialize');

        Constructor = function(mapInstance, options, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            // options.map = mapInstance;
            var _private = {
                map : mapInstance,
                fixOptions : options || {},
                initialized : false,
                markerLayer : (options && options.layer) ? options.layer : L.featureGroup()
            };
            options.tilerOptions.map = mapInstance;

            // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate === true) {
                this._private = _private;
            }

            this.enable = enable;
            this.disable = disable;
            this.reload = reload;
            this.update = update;
            this.getMarkerLayer = getMarkerLayer;
            this.setFilterFunction = setFilterFunction;
            this.setGetMarkerOptions = setGetMarkerOptions;
            this.setModifyMarker = setModifyMarker;
            this.setClearLayerFunction = setClearLayerFunction;
            this.setAddMarkerFunction = setAddMarkerFunction;
            this.setUpdateCompleteFunction = setUpdateCompleteFunction;

            // ///////////////////////////////////

            /**
             * @public
             * @name enable
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletTrafficMessages
             *
             * @description
             * Enable the service. Whenever the service enabled it listens to the map moveend event
             * and takes care about fetching the necessary information and adds it to the map.
             * The service can be paused using the `disable` method.
             */
            function enable() {
                if (_private.enabled) {
                    return;
                }
                if (!_private.initialized && _private.fixOptions.delayInit) {
                    _private.initTilerInstance();
                }
                _private.enabled = true;
                _private.start();
            }
            /**
             * @public
             * @name disable
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletTrafficMessages
             *
             * @description
             * Disable the service. If the service is disabled it does not fetch data and the map
             * is not updated. This method can be used to temporarily pause the service as the map
             * displays other data. The service can continue using the `enable` method.
             */
            function disable() {
                if (!_private.enabled) {
                    return;
                }
                _private.enabled = false;
                _private.stop();
            }


            /**
             * @public
             * @name reload
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletTrafficMessages
             *
             * @description
             * Refresh current view. Useful for dynamic coord information.
             */
            function reload() {
                if (_private.tilerInstance) {
                    _private.tilerInstance.reload();
                }
            }

            /**
             * @public
             * @name getMarkerLayer
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletTrafficMessages
             * @returns {L.FeatureLayer} layer where are all markers are drawn to
             *
             * @description
             * Get the layer where all markers are drawn to.
             */
            function getMarkerLayer() {
                return _private.markerLayer;
            }

            /**
             * @public
             * @name update
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletTrafficMessages
             *
             * @description
             * Trigger the update method manually. Usually, this method does not need to be called
             * as it is triggered internally with every single map moveend event. It may be needed
             * to apply a new filter or to update data that changes dynamically.
             */
            function update() {
                _private.update();
            }

            /**
             * @public
             * @name setFilterFunction
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletTrafficMessages
             * @param {Function} func Filter function that should be applied. This function is
             * supposed to accept a list of data and to return a filtered list of data.
             *
             * @description
             * Set a function that is used to filter the fetched data. Whenever new data is added
             * this filter function is called to allow another context to remove data that is
             * currently not needed.
             *
             * If this filter function is not set, a default filter function is used, that returns
             * the identity of the list to be filtered (= no filtering).
             */
            function setFilterFunction(func) {
                _private.filterFunction = func;
            }

            /**
             * @public
             * @name setClearLayerFunction
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletTrafficMessages
             * @param {Function} func Filter function that should be applied. This function is
             * supposed to accept a layer where all data is added to, and a list of new data that
             * should be added to the layer.
             *
             * @description
             * Set a function that is used to remove all unneeded elements. As the passed layer
             * probably contains elements that are passed in the second parameter, these elements
             * do not need to be removed from the layer (as they would be added in the next step
             * again).
             *
             * If this filter function is not set, all elements of the passed layer are deleted.
             * This may not be expected/wanted behavior and can be overridden by this function.
             */
            function setClearLayerFunction(func) {
                _private.clearLayerFunction = func;
            }

            /**
             * @public
             * @name setAddMarkerFunction
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletTrafficMessages
             * @param {Function} func Filter function that should be applied. This function is
             * supposed to accept a leaflet element and a layer where the element should be added to.
             *
             * @description
             * Set a function that is used to add one element to a given layer.
             *
             * If this filter function is not set, the layer.addLayer method is called with the passed
             * element. This should be usable in most of the cases, but may be overridden if some
             * other functionality like clustering is needed.
             */
            function setAddMarkerFunction(func) {
                _private.addMarkerFunction = func;
            }

            /**
             * @public
             * @name setUpdateCompleteFunction
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletTrafficMessages
             * @param {Function} func Filter function that should be applied. This function is
             * supposed to accept the layer where all elements are added to.
             *
             * @description
             * Set a function that is used to react whenever the update is done completely.
             *
             * If this filter function is not set, nothing happens on completing the update. This
             * method can be used to add some zoom logic or cluster handling.
             */
            function setUpdateCompleteFunction(func) {
                _private.updateCompleteFunction = func;
            }

            /**
             * @public
             * @name setGetMarkerOptions
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletTrafficMessages
             * @param {Function} func Option function that should be applied. This function is
             * supposed to accept a data element and to return an object that can be passed to the
             * native L.marker() function.
             *
             * @description
             * Set a function that is used to apply specific marker options for specific data
             * elements.
             *
             * If this function is not set, an empty marker option object is applied to the
             * L.marker() call.
             */
            function setGetMarkerOptions(func) {
                _private.getMarkerOptions = func;
            }

            /**
             * @public
             * @name setModifyMarker
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletTrafficMessages
             * @param {Function} func Modification function that should be applied. This function is
             * supposed to accept a leaflet marker object and to return it again. As second argument
             * the data element the marker is created of is passed.
             *
             * @description
             * Modify a marker object to your needs. Usually this method is used to append a
             * customized popup to a marker.
             *
             * If this function is not set, the marker object is not modified.
             */
            function setModifyMarker(func) {
                _private.modifyMarker = func;
            }

            function removeDuplicates(arr) {
                var res = [];
                angular.forEach(arr, function(val, key) {
                    var exist = false;
                    angular.forEach(res, function(val2, key) {
                        if(angular.equals(val.coord()[0], val2.coord()[0])) {
                            exist = true;
                        }
                    });
                    if (exist == false) {
                        res.push(val)
                    }
                });
                return res;
            }
            // ///////////////////////////////////
            _private.filterFunction = _private.fixOptions.filterFunction || function(list) {
                return list;
            };

            _private.clearLayerFunction = _private.fixOptions.clearLayerFunction || function(layer) {
                return layer.clearLayers();
            };

            _private.addMarkerFunction = _private.fixOptions.addMarkerFunction || function(location, layer) {
                var curr_marker = L.marker(location.coord(), _private.getMarkerOptions(location))
                        .addTo(layer);
                _private.modifyMarker(curr_marker, location);
            };

            _private.updateCompleteFunction = _private.fixOptions.updateCompleteFunction || function() {
                return true;
            };

            _private.getMarkerOptions = _private.fixOptions.getMarkerOptions || function() {
                return {};
            };
            _private.modifyMarker = _private.fixOptions.modifyMarker || function(marker) {
                return marker;
            };

            _private.update = function() {
                if (!_private.initialized || !_private.enabled || !_private.isCorrectZoom()) {
                    return;
                }
                log.debug('update request sent');
                _private.request();
            };

            _private.start = function() {
                if (!_private.enabled || _private.active) {
                    return;
                }
                _private.active = true;
                _private.map.addLayer(_private.markerLayer);
                // _private.map.on('moveend', _private.update);
                _private.update();
            };
            _private.stop = function() {
                if (_private.enabled || !_private.active) {
                    return;
                }
                _private.active = false;
                _private.map.off('moveend', _private.update);
                _private.map.removeLayer(_private.markerLayer);
            };

            _private.isCorrectZoom = function() {
                var zoom = _private.map.getZoom();

                if (!_private.fixOptions.minZoom && !_private.fixOptions.maxZoom) {
                    // all zooms enabled
                    return true;
                }

                if (_private.fixOptions.minZoom && !_private.fixOptions.maxZoom) {
                    // min zoom only
                    if (zoom >= _private.fixOptions.minZoom) {
                        return true;
                    }
                }

                if (_private.fixOptions.maxZoom && !_private.fixOptions.minZoom) {
                    // max zoom only
                    if (zoom <= _private.fixOptions.maxZoom) {
                        return true;
                    }
                }

                if (_private.fixOptions.maxZoom && _private.fixOptions.minZoom) {
                    // both
                    if (zoom >= _private.fixOptions.minZoom && zoom <= _private.fixOptions.maxZoom) {
                        return true;
                    }
                }
                return false;
            };

            _private.zoomlevelcheck = function() {
                if (_private.isCorrectZoom()) {
                    // log.debug('automatic start');
                    _private.start();
                } else {
                    // log.debug('automatic stop');
                    _private.stop();
                }
            };

            _private.request = function() {
                _private.tilerInstance.update(_private.map.getBounds(), _private.map.getZoom());
            };

            _private.update_map = function() {
                if (!_private.enabled || !_private.active) {
                    return;
                }

                var list = _private.tilerInstance.getResults(),
                    i,
                    l;
                list = list.filter(function(el) {
                    return el.type() !== 'unknown';
                });
                var result = removeDuplicates(list);
                // list = _private.filterFunction(list, _private.markerLayer);
                _private.clearLayerFunction(_private.markerLayer, result);

                for (i = 0, l = result.length; i < l; i += 1) {
                    _private.addMarkerFunction(result[i], _private.markerLayer);
                }
                _private.updateCompleteFunction(_private.markerLayer);
            };

            // _private.getRequestOptions = function() {
            //     var reqOptions = angular.copy(_private.fixOptions.requestOptions || {});

            //     if (_private.fixOptions.type && !reqOptions.types) {
            //         //// fallback to type
            //         reqOptions.types = _private.fixOptions.type.split('#');
            //     }
            //     console.log('reqOptions', reqOptions);
            //     return reqOptions;
            // };

            _private.createRequestFunction = function() {
                return function(bounds) {
                    return MDVMessageRequester.search()
                    .then(function (res) {
                        // console.log('addinfo result', res);
                        return res;
                    }).catch(function(err) {
                        console.log('err', err);
                    });
                }
            };

            _private.initTilerInstance = function() {
                _private.tilerInstance = new MDVLeafletTiler(options || {});
                _private.tilerInstance.setRequestFunction(_private.createRequestFunction());
                _private.initialized = true;
                _private.tilerInstance.getUpdateNotification()
                    .then(_private.update_map, null, _private.update_map);
            };

            if (!_private.fixOptions.delayInit) {
                _private.initTilerInstance();
                this.enable();
            }

            _private.map.on('zoomend', _private.zoomlevelcheck);

            return this;
        };
        return Constructor;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-leaflet.service:MDVLeafletTiler
     * @requires $q
     * @requires L
     * @requires ML
     * @requires mng-util.service:MDVLog
     *
     * @description
     * The `MDVLeafletTiler` service is used internally and provides an interface to the MENTZ
     * native plugin called LLBase/TileLayer/ML.TileLayer. Usually it is not necessary to use this
     * service directly in your application (use {@link mng-leaflet.service:MDVLeafletCoord
     * MDVLeafletCoord} or {@link mng-leaflet.service:MDVLeafletVELOC MDVLeafletVELOC} instead).
     *
     * # Options
     * The factory can be initalized with all options that are accepted by the native MENTZ plugin
     * LLBase/TileLayer/ML.RequestTiler.
     *
     * **Note:** *if coordFormat is not set in the options, it is set to 'EPSG:4326' per default.
     * This is done to assure that most of the applications work, although no options are passed*
     *
     */
    angular.module('mng-leaflet')
        .factory('mng-leaflet.MDVLeafletTiler', MDVLeafletTiler);

    MDVLeafletTiler.$inject = ['$q', 'L', 'ML', 'mng-util.MDVLog'];

    function MDVLeafletTiler($q, L, ML, MDVLog) {
        var log = MDVLog.register('mng-leaflet.MDVLeafletTiler'),
            Constructor;

        log.debug('initialize');

        Constructor = function(options, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {

            var _private = {
                results : [],
                requestTilerInstance : null,
                updateNotification : $q.defer()
            };

            if (!options) {
                options = {};
            }

            if (!options.tilerOptions) {
                options.tilerOptions = {}
            }
            if (!options.tilerOptions.coordFormat) {
                // force coordFormat to wgs84 if not specified.
                options.tilerOptions.coordFormat = 'EPSG:4326';
            }

            _private.requestTilerInstance = new ML.RequestTiler(options);
            // _private.requestTilerInstance = new ML.RequestTiler(options.tilerOptions);

            // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate === true) {
                this._private = _private;
            }

            this.getResults = getResults;
            this.reload = reload;
            this.update = update;
            this.clearCache = clearCache;
            this.setRequestFunction = setRequestFunction;
            this.getUpdateNotification = function() {
                return _private.updateNotification.promise;
            };

            /**
             * @public
             * @name setRequestFunction
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletTiler
             * @param {Function} func Function that can be used for requesting the data for a
             * a single tile. This function needs a `bound` parameter that specifies the
             * LatLng-Bound. As return value a promise is expected that is resolved with a data
             * object, which describes the content of the tile. This data object is not interpreted
             * by this service, but rather stored and cached.
             *
             * @description
             * Set a function that is used for requesting data for a specific tile.
             */
            function setRequestFunction(func) {
                _private.requestFunction = func;
            }

            /**
             * @public
             * @name getResults
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletTiler
             * @returns {Object[]} Reference to the list of rendered results.
             *
             * @description
             * Get a reference to the results that are valid for the current boundingBox and zoom.
             */
            function getResults() {
                return _private.results;
            }

            /**
             * @public
             * @name reload
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletTiler
             *
             * @description
             * Reload the current view. Useful for tile information that is not static.
             */
            function reload() {
                if (!_private.lastUpdate) {
                    // 'reload without previous update - do nothing';
                    return;
                }
                _private.requestTilerInstance.clear_cache();
                update(_private.lastUpdate.boundingBox, _private.lastUpdate.zoom);
            }

            /**
             * @public
             * @name getResults
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletTiler
             * @param {Object[]} boundingBox LatLng boundingbox the result array should be updated
             * with. This bounding-box does not need to fit to a tile pattern and can be a usual
             * leaflet map.getBounds() call.
             * @param {Number} zoom Zoom level
             * @returns {Promise} Returns a {@link https://docs.angularjs.org/api/ng/service/$q
             * `Promise`} that will be resolved whenever all data for the requested bounding box is
             * loaded. The resolved value describes a list of data objects like it is also added to
             * the result list.
             *
             * @description
             * Update the result array that can be fetched with getResults() for a certain bounding
             * box and zoom level.
             */
            function update(boundingBox, zoom) {
                // store for reload
                _private.lastUpdate = {
                    boundingBox : boundingBox,
                    zoom : zoom
                };

                _private.requestTilerInstance.request_tiles(boundingBox, zoom);

                return _private.updateNotification.promise;
            }

            function clearCache() {
                _private.requestTilerInstance.clear_cache();
            }

            // ///////////////////////////////////
            _private.requestFunction = function() {
                var def = $q.defer();

                def.reject('no request function set');
                return def.promise;
            };

            _private.requestTilerInstance.tile_query_func = function(bounds, callback) {
                _private.requestFunction(bounds)
                    .then(function(result) {
                        callback.call(_private.requestTilerInstance, result);
                    })
                    .catch(function(e) {
                        log.error(e, true);
                        callback([]);
                    });
            };
            _private.requestTilerInstance.is_set_request_needed = function() {
                return false;
            };

            _private.requestTilerInstance.on(L.mdv.events.req.TILES_LOADED, function(data) {
                _private.results.length = 0;

                if (data && data.response && data.response.length) {
                    data.response.forEach(function(response) {
                        if (response && response.obj && response.obj.response) {
                            response.obj.response.forEach(function(dataElem) {
                                _private.results.push(dataElem);
                            });
                        }
                    });
                }
                _private.updateNotification.notify(_private.results);
            });
        };

        return Constructor;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-leaflet.service:MDVLeafletData
     * @requires $q
     * @requires mng-util.service:MDVLog
     *
     * @description
     * The `MDVLeafletData` service is used to manage multiple map instances in your application.
     * Usually the map instances are added by the MNGLeaflet directive, so this service is used to
     * get these instances whenever they are ready.
     *
     * # Usage
     * This service provides a `get` method to get a specific map by it's id:
     *
     * Example:
     * ```js
     *
     *  MDVLeafletData.get('myMap')
     *      .then(function(map) {
     *          // map variable is a normal L.Map instance like it is known from plain leafletjs.
     *          map.setZoom(10);
     *      });
     * ```
     *
     * Please note that the get method returns a promise that is resolved with the map instance
     * whenever it is initialized. Within the callback the map can be modified/used like a native
     * L.map instance is used.
     *
     */
    angular.module('mng-leaflet')
        .factory('mng-leaflet.MDVLeafletData', MDVLeafletData);

    MDVLeafletData.$inject = ['$q', 'mng-util.MDVLog'];

    function MDVLeafletData($q, MDVLog) {
        var log = MDVLog.register('MDVLeafletData'),
            maps = {},
            _private = {},
            dataService = {
                // add a map instance for a certain id
                add : add,
                // remove a map instance of a certain id
                remove : remove,
                // get a map instance for a certain id
                get : get
            },
            deferreds = {};

        log.debug('initialize');

        /**
         * @public
         * @name remove
         * @ngdoc method
         * @methodOf mng-leaflet.service:MDVLeafletData
         * @param {String} id Map id that was used to fetch the map instance.
         * @returns {Boolean} Flag whether the instance was successfully removed (true) or not (false).
         *
         * @description
         * Remove a leaflet map instance.
         * This method should not be used outside of the modules, as this is already done by the
         * MNGLeaflet directive.
         *
         */
        function remove(id) {
            if (!id) {
                return false;
            }
            if (maps.hasOwnProperty(id)) {
                log.warn('tried to remove not existing map: ' + id);
            }
            delete maps[id];

            _private.resolveDeferreds(id);

            return true;
        }
        /**
         * @public
         * @name add
         * @ngdoc method
         * @methodOf mng-leaflet.service:MDVLeafletData
         * @param {String} id Map id that can be used to fetch the map instance later on.
         * @param {Object} map Native leaflet map instance.
         * @returns {Boolean} Flag whether the instance was successfully added (true) or not (false).
         *
         * @description
         * Add a leaflet map instance to fetch it later on using the `get` method.
         * This method should not be used outside of the modules, as this is already done by the
         * MNGLeaflet directive.
         *
         */
        function add(id, map) {
            if (!id || !map) {
                return false;
            }
            if (maps.hasOwnProperty(id)) {
                log.warn('override existing map: ' + id);
            }
            maps[id] = map;

            _private.resolveDeferreds(id);

            return true;
        }

        /**
         * @public
         * @name add
         * @ngdoc method
         * @methodOf mng-leaflet.service:MDVLeafletData
         * @param {String} id Id of the map that is requested.
         * @returns {Promise} Returns a {@link https://docs.angularjs.org/api/ng/service/$q
         * `Promise`} that will be resolved to a leaflet map instance
         *
         * @description
         * Get a leaflet map instance that is initialized by the MNGLeaflet directive.
         * The promise is resolved, whenever the map instance is initialized and the map is ready.
         */
        function get(id) {
            var deferred = $q.defer();

            if (maps.hasOwnProperty(id)) {
                deferred.resolve(maps[id]);
            } else {
                // map not yet available. wait for it
                if (!deferreds.hasOwnProperty(id)) {
                    deferreds[id] = [];
                }
                deferreds[id].push(deferred);
            }

            return deferred.promise;
        }

        _private.resolveDeferreds = function(id) {
            if (!deferreds.hasOwnProperty(id) || !deferreds[id].length) {
                return;
            }

            deferreds[id].forEach(function(deferred) {
                deferred.resolve(maps[id]);
            });

            delete deferreds[id];
        };

        return dataService;
    }

}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-leaflet.service:MDVLeafletCoord
     * @requires L
     * @requires mng-util.service:MDVLog
     * @requires mng-util.service:MDVException
     * @requires mng-comm.service:MDVLocationRequester
     * @requires mng-leaflet.service:MDVLeafletTiler
     *
     * @description
     * The `MDVLeafletCoord` service is used to dynamically add static stop or poi markers to a map
     * instance. It takes care about adding and removing markers whenever the map is moved in order
     * display only markers that are visible to the user.
     *
     * # Usage
     * This factory can be instantiated with two properties:
     *
     * ## map
     * The first property describes a native leaflet map instance the coord data should be bound to.
     *
     * ## options
     * This factory allows you to pass multiple options in order to customize the way the data is
     * added. This object can contain the following properties:
     *
     * ### {Object} requestOptions (required)
     * Options that are used for the MDVLocationRequester.searchArea() call.
     *
     * ### {Object} tilerOptions
     * Options that are passed to the MDVLeafletTiler factory. Usually the factory accepts all
     * options that are also accepted by the by the native MENTZ plugin
     * LLBase/TileLayer/ML.RequestTiler.
     * Please refer to {@link mng-leaflet.MDVLeafletTiler MDVLeafletTiler} for further details.
     *
     * ### {Boolean} delayInit (default: false)
     * The service is enabled after initialization per default. To disable this functionality, the
     * flag can be set to `true`. The MDVLeafletCoord object needs to be enabled manually then (by
     * calling the `enable()` method).
     *
     * ### {Boolean} hardReload (default: false)
     * Flag to remove all markers before the new ones are added. This is used to draw markers in a
     * different way after an update. Per default all markers that were added are not removed unless
     * they are out of bounds.
     *
     */
    angular.module('mng-leaflet')
        .factory('mng-leaflet.MDVLeafletCoord', MDVLeafletCoord);

    MDVLeafletCoord.$inject = ['L', 'mng-util.MDVLog', 'mng-util.MDVException',
        'mng-leaflet.MDVLeafletTiler', 'mng-comm.MDVLocationRequester'];

    function MDVLeafletCoord(L, MDVLog, MDVException, MDVLeafletTiler, MDVLocationRequester) {
        var log = MDVLog.register('mng-leaflet.MDVLeafletCoord'),
            Constructor;

        log.debug('initialize');

        Constructor = function(mapInstance, options, /* FOR MODULE INTERNAL USAGE ONLY */ includePrivate) {
            // options.map = mapInstance;
            var _private = {
                map : mapInstance,
                fixOptions : options || {},
                initialized : false,
                markerLayer : (options && options.layer) ? options.layer : L.featureGroup()
            };
            options.tilerOptions.map = mapInstance;
            // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            if (includePrivate === true) {
                this._private = _private;
            }

            this.enable = enable;
            this.disable = disable;
            this.reload = reload;
            this.update = update;
            this.getMarkerLayer = getMarkerLayer;
            this.setFilterFunction = setFilterFunction;
            this.setGetMarkerOptions = setGetMarkerOptions;
            this.setModifyMarker = setModifyMarker;
            this.setClearLayerFunction = setClearLayerFunction;
            this.setAddMarkerFunction = setAddMarkerFunction;
            this.setUpdateCompleteFunction = setUpdateCompleteFunction;

            // ///////////////////////////////////

            /**
             * @public
             * @name enable
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletCoord
             *
             * @description
             * Enable the service. Whenever the service enabled it listens to the map moveend event
             * and takes care about fetching the necessary information and adds it to the map.
             * The service can be paused using the `disable` method.
             */
            function enable() {
                if (_private.enabled) {
                    return;
                }
                if (!_private.initialized && _private.fixOptions.delayInit) {
                    _private.initTilerInstance();
                }
                _private.enabled = true;
                _private.start();
            }
            /**
             * @public
             * @name disable
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletCoord
             *
             * @description
             * Disable the service. If the service is disabled it does not fetch data and the map
             * is not updated. This method can be used to temporarily pause the service as the map
             * displays other data. The service can continue using the `enable` method.
             */
            function disable() {
                if (!_private.enabled) {
                    return;
                }
                _private.enabled = false;
                _private.stop();
            }


            /**
             * @public
             * @name reload
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletCoord
             *
             * @description
             * Refresh current view. Useful for dynamic coord information.
             */
            function reload() {
                if (_private.tilerInstance) {
                    _private.tilerInstance.reload();
                }
            }

            /**
             * @public
             * @name getMarkerLayer
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletCoord
             * @returns {L.FeatureLayer} layer where are all markers are drawn to
             *
             * @description
             * Get the layer where all markers are drawn to.
             */
            function getMarkerLayer() {
                return _private.markerLayer;
            }

            /**
             * @public
             * @name update
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletCoord
             *
             * @description
             * Trigger the update method manually. Usually, this method does not need to be called
             * as it is triggered internally with every single map moveend event. It may be needed
             * to apply a new filter or to update data that changes dynamically.
             */
            function update() {
                _private.update();
            }

            /**
             * @public
             * @name setFilterFunction
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletCoord
             * @param {Function} func Filter function that should be applied. This function is
             * supposed to accept a list of data and to return a filtered list of data.
             *
             * @description
             * Set a function that is used to filter the fetched data. Whenever new data is added
             * this filter function is called to allow another context to remove data that is
             * currently not needed.
             *
             * If this filter function is not set, a default filter function is used, that returns
             * the identity of the list to be filtered (= no filtering).
             */
            function setFilterFunction(func) {
                _private.filterFunction = func;
            }

            /**
             * @public
             * @name setClearLayerFunction
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletCoord
             * @param {Function} func Filter function that should be applied. This function is
             * supposed to accept a layer where all data is added to, and a list of new data that
             * should be added to the layer.
             *
             * @description
             * Set a function that is used to remove all unneeded elements. As the passed layer
             * probably contains elements that are passed in the second parameter, these elements
             * do not need to be removed from the layer (as they would be added in the next step
             * again).
             *
             * If this filter function is not set, all elements of the passed layer are deleted.
             * This may not be expected/wanted behavior and can be overridden by this function.
             */
            function setClearLayerFunction(func) {
                _private.clearLayerFunction = func;
            }

            /**
             * @public
             * @name setAddMarkerFunction
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletCoord
             * @param {Function} func Filter function that should be applied. This function is
             * supposed to accept a leaflet element and a layer where the element should be added to.
             *
             * @description
             * Set a function that is used to add one element to a given layer.
             *
             * If this filter function is not set, the layer.addLayer method is called with the passed
             * element. This should be usable in most of the cases, but may be overridden if some
             * other functionality like clustering is needed.
             */
            function setAddMarkerFunction(func) {
                _private.addMarkerFunction = func;
            }

            /**
             * @public
             * @name setUpdateCompleteFunction
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletCoord
             * @param {Function} func Filter function that should be applied. This function is
             * supposed to accept the layer where all elements are added to.
             *
             * @description
             * Set a function that is used to react whenever the update is done completely.
             *
             * If this filter function is not set, nothing happens on completing the update. This
             * method can be used to add some zoom logic or cluster handling.
             */
            function setUpdateCompleteFunction(func) {
                _private.updateCompleteFunction = func;
            }

            /**
             * @public
             * @name setGetMarkerOptions
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletCoord
             * @param {Function} func Option function that should be applied. This function is
             * supposed to accept a data element and to return an object that can be passed to the
             * native L.marker() function.
             *
             * @description
             * Set a function that is used to apply specific marker options for specific data
             * elements.
             *
             * If this function is not set, an empty marker option object is applied to the
             * L.marker() call.
             */
            function setGetMarkerOptions(func) {
                _private.getMarkerOptions = func;
            }

            /**
             * @public
             * @name setModifyMarker
             * @ngdoc method
             * @methodOf mng-leaflet.service:MDVLeafletCoord
             * @param {Function} func Modification function that should be applied. This function is
             * supposed to accept a leaflet marker object and to return it again. As second argument
             * the data element the marker is created of is passed.
             *
             * @description
             * Modify a marker object to your needs. Usually this method is used to append a
             * customized popup to a marker.
             *
             * If this function is not set, the marker object is not modified.
             */
            function setModifyMarker(func) {
                _private.modifyMarker = func;
            }

            // ///////////////////////////////////
            _private.filterFunction = _private.fixOptions.filterFunction || function(list) {
                return list;
            };

            _private.clearLayerFunction = _private.fixOptions.clearLayerFunction || function(layer) {
                return layer.clearLayers();
            };

            _private.addMarkerFunction = _private.fixOptions.addMarkerFunction || function(location, layer) {
                var curr_marker = L.marker(location.coord(), _private.getMarkerOptions(location))
                        .addTo(layer);

                _private.modifyMarker(curr_marker, location);
            };

            _private.updateCompleteFunction = _private.fixOptions.updateCompleteFunction || function() {
                return true;
            };

            _private.getMarkerOptions = _private.fixOptions.getMarkerOptions || function() {
                return {};
            };
            _private.modifyMarker = _private.fixOptions.modifyMarker || function(marker) {
                return marker;
            };

            _private.update = function() {
                if (!_private.initialized || !_private.enabled || !_private.isCorrectZoom()) {
                    return;
                }
                log.debug('update request sent');
                _private.request();
            };

            _private.start = function() {
                if (!_private.enabled || _private.active) {
                    return;
                }
                _private.active = true;
                _private.map.addLayer(_private.markerLayer);
                _private.map.on('moveend', _private.update);
                _private.update();
            };
            _private.stop = function() {
                if (_private.enabled || !_private.active) {
                    return;
                }
                _private.active = false;
                _private.map.off('moveend', _private.update);
                _private.map.removeLayer(_private.markerLayer);
            };

            _private.isCorrectZoom = function() {
                var zoom = _private.map.getZoom();

                if (!_private.fixOptions.minZoom && !_private.fixOptions.maxZoom) {
                    // all zooms enabled
                    return true;
                }

                if (_private.fixOptions.minZoom && !_private.fixOptions.maxZoom) {
                    // min zoom only
                    if (zoom >= _private.fixOptions.minZoom) {
                        return true;
                    }
                }

                if (_private.fixOptions.maxZoom && !_private.fixOptions.minZoom) {
                    // max zoom only
                    if (zoom <= _private.fixOptions.maxZoom) {
                        return true;
                    }
                }

                if (_private.fixOptions.maxZoom && _private.fixOptions.minZoom) {
                    // both
                    if (zoom >= _private.fixOptions.minZoom && zoom <= _private.fixOptions.maxZoom) {
                        return true;
                    }
                }
                return false;
            };

            _private.zoomlevelcheck = function() {
                if (_private.isCorrectZoom()) {
                    // log.debug('automatic start');
                    _private.start();
                } else {
                    // log.debug('automatic stop');
                    _private.stop();
                }
            };

            _private.request = function() {
                _private.tilerInstance.update(_private.map.getBounds(), _private.map.getZoom());
            };

            _private.update_map = function() {
                if (!_private.enabled || !_private.active) {
                    return;
                }

                var list = _private.tilerInstance.getResults(),
                    i,
                    l;

                list = _private.filterFunction(list, _private.markerLayer);

                _private.clearLayerFunction(_private.markerLayer, list);

                for (i = 0, l = list.length; i < l; i += 1) {
                    _private.addMarkerFunction(list[i], _private.markerLayer);
                }
                _private.updateCompleteFunction(_private.markerLayer);
            };

            _private.getRequestOptions = function() {
                var reqOptions = angular.copy(_private.fixOptions.requestOptions || {});

                if (_private.fixOptions.type && !reqOptions.types) {
                    // fallback to type
                    reqOptions.types = _private.fixOptions.type.split('#');
                }
                return reqOptions;
            };

            _private.createRequestFunction = function() {
                return function(bounds) {
                    return MDVLocationRequester.searchArea(bounds.getNorthWest(),
                        bounds.getSouthEast(), _private.getRequestOptions());
                };
            };

            _private.initTilerInstance = function() {
                // _private.tilerInstance = new MDVLeafletTiler(_private.fixOptions.tilerOptions || {}); // was
                _private.tilerInstance = new MDVLeafletTiler(options || {}); // is
                _private.tilerInstance.setRequestFunction(_private.createRequestFunction());
                _private.initialized = true;
                _private.tilerInstance.getUpdateNotification()
                    .then(_private.update_map, null, _private.update_map);
            };

            if (!_private.fixOptions.delayInit) {
                _private.initTilerInstance();
                this.enable();
            }

            _private.map.on('zoomend', _private.zoomlevelcheck);

            return this;
        };

        return Constructor;
    }
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc overview
     * @name mng-config
     * @module mng-config
     * @requires mng-util
     *
     * @description
     * # mng-config (configuration handling)
     * This module fetches and provides all configuration that is needed for all
     * mng-modudes.
     *
     * ## General usage
     * ```js
     * // inject mng-config - components only
     * angular.module('your.module', ['mng-config']);
     * ```
     *
     * ## services
     * The following list gives a short overview of the available components within this module.
     * For further details, please refer to the components themselves.
     *
     * ### {@link mng-config.service:MDVConfig MDVConfig}
     * The `MDVConfig` service ensures that all configuration can be shared between controllers and
     * services.
     *
     * ### {@link mng-config.service:MDVConfigFetcher MDVConfigFetcher}
     * The `MDVConfigFetcher` service loads the configuration on startup and fills the {@link
     * mng-config.service:MDVConfig MDVConfig} object with the configured values to ensure that
     * these values are available for every service.
     *
     * *The current implementation uses a simple object within the MDVConfigFetcher, for future
     * implementations the configuration should be fetched from a single configuration file or from
     * a server*
      */
    angular.module('mng-config', ['mng-util']);
}());

(function() {
    'use strict';

    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-config.service:MDVConfigFetcher
     * @requires $injector
     * @requires mng-util.service:MDVLog
     * @requires mng-config.service:MDVConfig
     * @requires mng-util.object:MDVException
     *
     * @description
     * The `MDVConfigFetcher` service loads the configuration on startup and fills the {@link
     * mng-config.service:MDVConfig MDVConfig} service with the configured values to ensure that
     * these values are available for every service.
     *
     * ```js
     *  angular.module('yourModule')
     *     .constant('mng_config', {
     *          // your configuration here
     *          mng-comm : {
     *              // details of every service's configuration can be found in every service
     *              // documentation
     *          }
     *     })
     *     .run(['mng-config.MDVConfigFetcher', function (MDVConfigFetcher) {
     *          // this assures that the config is loaded from the constants before any other module
     *          // calls the MDVConfig service.
     *          MDVConfigFetcher.loadConfig('mng_config');
     *     }]);
     * ```
     */
    angular.module('mng-config')
        .factory('mng-config.MDVConfigFetcher', MDVConfigFetcher);

    MDVConfigFetcher.$inject = ['$injector', '$http', 'mng-util.MDVLog',
                                'mng-config.MDVConfig', 'mng-util.MDVException'];

    function MDVConfigFetcher($injector, $http, MDVLog, MDVConfig, MDVException) {
        var log = MDVLog.register('mng-config.MDVConfigFetcher'),
            fetcher = {
                loadConfig : loadConfig,
                requestConfig : requestConfig
            };

        log.debug('initialize');
    //    /**
    //     * @ngdoc method
    //     * @name fill_config
    //     * @description
    //     * Fill in a given set of key-value options in the configuration.
    //     * @private
    //     * @methodOf mng-config.service:MDVConfigFetcher
    //     * @param {Object} params set of key-value pairs that should be added to configuration.
    //     */
        function fill_config(params, hardReplace) {
            log.debug('update config with new values');
            if (hardReplace) {
                MDVConfig.reset();
            }
            angular.forEach(params, function(value, key) {
                MDVConfig.setValue(key, value);
            });
            MDVConfig.triggerDone();
        }
        /**
         * @public
         * @ngdoc method
         * @name loadConfig
         * @methodOf mng-config.service:MDVConfigFetcher
         * @param {String} constKey The key of the constant the configuration is stored at.
         * @param {Boolean} [hardReplace=false] Replace the old configuration completely, instead of
         * merging the values to the existing configuration.
         *
         * @description
         * Fill the MDVConfig service with parameters that are provided via an angular constant.
         */
        function loadConfig(constKey, hardReplace) {
            var configuration;

            // load configuration from constant if available
            if ($injector.has(constKey)) {
                configuration = $injector.get(constKey);
                // fill with default values
                fill_config(configuration, hardReplace);
            } else {
                throw new MDVException(MDVException.keys.MNG__PROGRAMM.NO_CONFIG, {
                    constantKey : constKey
                });
            }
        }
        /**
         * @public
         * @ngdoc method
         * @name requestConfig
         * @methodOf mng-config.service:MDVConfigFetcher
         * @param {String} url Http link that is resolved to a configuration json file
         * @param {Boolean} [hardReplace=false] Replace the old configuration completely, instead of
         * merging the values to the existing configuration.
         *
         * @description
         * Fill the MDVConfig service with parameters that are provided via an external resource.
         */
        function requestConfig(url, hardReplace) {
            // load configuration from constant if available
            $http.get(url)
                .then(function(response) {
                    if (!response || !response.data) {
                        throw new MDVException(MDVException.keys.MNG__PROGRAMM.NO_CONFIG, {
                            url : url,
                            error : 'no response data'
                        });
                    }
                    // fill with default values
                    fill_config(response.data, hardReplace);
                })
                .catch(function(error) {
                    throw new MDVException(MDVException.keys.MNG__PROGRAMM.NO_CONFIG, {
                        url : url,
                        error : error
                    });
                });
        }

        return fetcher;
    }
}());


(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-config.service:MDVConfig
     * @requires mng-util.service:MDVLog
     * @requires mng-util.service:MDVUtil

     * @description
     * The `MDVConfig` service ensures that all configuration can be shared between controllers and
     * services. On startup this service is configured by the {@link
     * mng-config.service:MDVConfigFetcher MDVConfigFetcher}. Please refer to the {@link
     * mng-config.service:MDVConfigFetcher MDVConfigFetcher} documentation for further details.
     *
     * This service can be configured by the `setValue` method, or can provide
     * configuration with the `getValue` method. This also allows to change the configuration
     * dynamically during runtime.
     * Usually the initial startup of the {@link mng-config.service:MDVConfigFetcher
     * MDVConfigFetcher} should be sufficient and the most effective way.
     *
     * @example
<example module="MDVConfigExample">
<file name="index.html">
  <div ng-controller="ConfigController">
    {{config_value}}
  </div>
</file>
<file name="script.js">
  angular.module('MDVConfigExample', ['mng-config'])
    .controller('ConfigController', ['$scope', 'mng-config.MDVConfig',
        function ($scope, MDVConfig) {
            // sets internal config structure:
            // {
            //     "test" : {
            //         "subkey" : "myConfigValue"
            //     }
            // }
            MDVConfig.setValue('test', {
                'subkey' : 'myConfigValue'
            });
            // retrieve configuration value again
            $scope.config_value = MDVConfig.getValue('test.subkey');
        }]);
</file>
</example>
     */
    angular.module('mng-config')
        .factory('mng-config.MDVConfig', MDVConfig);

    MDVConfig.$inject = ['$q', 'mng-util.MDVLog', 'mng-util.MDVUtil'];

    function MDVConfig($q, MDVLog, MDVUtil) {
        var log = MDVLog.register('mng-config.MDVConfig'),
            _private = {
                conf : {},
                ready : false
            },
            conf_obj = {
                getValue : getValue,
                isReady : isReady,
                setValue : setValue,
                ready : ready,
                reset : reset,
                triggerDone : triggerDone
            };

        log.debug('initialize');

        conf_obj._private = _private;

        // ////////////////////////////////
        /**
         * @public
         * @ngdoc method
         * @name isReady
         * @methodOf mng-config.service:MDVConfig
         * @returns {Boolean} Whether config is ready or not.
         *
         * @description
         * Check whether config is ready and populated with values, or not.
         */
        function isReady() {
            return _private.ready;
        }

        /**
         * @public
         * @ngdoc method
         * @name getValue
         * @methodOf mng-config.service:MDVConfig
         *
         * @description
         * Get a deep copy of a configuration value by a given key.
         *
         * @param {String} key Configuration key. The key can be a simple name, or a set of
         * hierarchical names separated by a dot. See {@link mng-util.service:MDVUtil
         * MDVUtil}-getSubValue() for further details.
         * @param {Object=} [options={}] Override with individual options instead of the default
         * configuration. These options need to provide the same structure as the default
         * configuration.
         * @returns {Object} Configuration value for the given key, null if key is not found or
         * invalid. Please note that the return value is a deep copy of the configuration value.
         */
        function getValue(key, options) {
            if (!key) {
                log.warn('no config-key passed');
                return null;
            }
            if (!_private.ready) {
                log.error('config object is not filled or not marked as ready. please refer to ' +
                      'the documentation and assure that the configuration is filled on startup ' +
                      'of your application.');
                return null;
            }
            var value;

            // check given options first. if they provide the given value, use this one
            if (options) {
                value = MDVUtil.getSubValue(key, options);
            }
            // if given options do not provide the given value, use default config
            if (!value) {
                value = MDVUtil.getSubValue(key, _private.conf);
            }
            // always return a deep copy of the value to avoid references
            return MDVUtil.copy(value);
        }
        /**
         * @public
         * @ngdoc method
         * @name ready
         * @methodOf mng-config.service:MDVConfig
         * @param {Function} callback Callback function that is bound to the ready promise or called
         * directly, if config is already ready.
         * @param {Boolean} [getPermanent=false] get a permanent watch that triggers all 'change
         * done' via notify instead of resolve. This can be used to be permanent up to date whenever
         * a trigger is sent. The usual way is to get one notification whenever the configuration
         * is ready.
         * @returns {Promise} Promise that is resolved whenever the configuration is triggered as
         * 'done'
         *
         * @description
         * Get a ready deferred that is resolved when the configuration is changed and triggered as
         * 'change done'.
         */
        function ready(callback, getPermanent) {
            var promise;

            if (getPermanent) {
                if (!_private.permanentReadyDeferred) {
                    _private.permanentReadyDeferred = $q.defer();
                }
                promise = _private.permanentReadyDeferred.promise;
                if (callback) {
                    promise.then(callback);
                }
                return promise;
            }
            if (!_private.readyDeferred) {
                _private.readyDeferred = $q.defer();
            }
            if (_private.ready) {
                if (callback) {
                    callback();
                }
                _private.readyDeferred.resolve();
            } else if (callback) {
                _private.readyDeferred.promise.then(callback);
            }
            return _private.readyDeferred.promise;
        }
        /**
         * @public
         * @ngdoc method
         * @name reset
         * @methodOf mng-config.service:MDVConfig
         *
         * @description
         * Remove all config values that were set.
         */
        function reset() {
            _private.conf = {};
            _private.ready = false;
        }
        /**
         * @public
         * @ngdoc method
         * @name setValue
         * @methodOf mng-config.service:MDVConfig
         *
         * @description
         * Set a configuration value for a given key.
         *
         * @param {String} key Configuration key. The key can be a simple name, or a set of
         * hierarchical names separated by a dot. See {@link mng-util.service:MDVUtil
         * MDVUtil}-getSubValue() for further details.
         *
         * @param {Object} value - Configuration value that should be assigned to the key.
         * @returns {Boolean} Whether the configuration is successfull set or not.
         */
        function setValue(key, value) {
            if (!key || (!value && value !== 0)) {
                log.debug('set: wrong key/ value pair given: ' + key + '/' + value);
                return false;
            }
            return setPartialValue(_private.conf, key.split('.'), value);
        }
        /**
         * @public
         * @ngdoc method
         * @name triggerDone
         * @methodOf mng-config.service:MDVConfig
         *
         * @description
         * Notify the MDVConfig service that the current updates on the configuration are done.
         * This method triggers the ready nofiy callbacks.
         *
         * @param {Object} message Object the ready deferred is resolved with.
         */
        function triggerDone(message) {
            if (!_private.ready && _private.readyDeferred) {
                // only resolve if deferred is available and not yet resolved
                _private.readyDeferred.resolve(message);
            }
            _private.ready = true;
            if (_private.permanentReadyDeferred) {
                _private.permanentReadyDeferred.notify(message);
            }
        }

        function setPartialValue(obj, keys, value) {
            var key = keys.shift();

            if (keys.length === 0) {
                // last key value
                if (obj.hasOwnProperty(key) && obj[key] !== value) {
                    log.warn('set: override existing configuration. old value: ' + obj[key] +
                                                                       ', new value: ' + value);
                }
                obj[key] = value;
                return true;
            }
            if (!obj.hasOwnProperty(key)) {
                log.warn('set: path not yet available: ' + key + ', created new path.');
                obj[key] = {};
            }
            return setPartialValue(obj[key], keys, value);
        }

        return conf_obj;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.xmljson.service:MDVEFAUtil
     * @requires moment
     * @requires mng-util.service:MDVLog
     * @requires mng-model.MDVMessage
     *
     * @description
     * The `MDVEFAUtil` offers a collection of EFA communication-specific utility functions that do
     * not care about formatting (this is handled in the {@link mng-comm.itd.service:MDVEFAFormatter
     * MDVEFAFormatter}).
     */
    angular.module('mng-comm.itd.xmljson')
        .factory('mng-comm.itd.xmljson.MDVEFAUtil', MDVEFAUtil);

    MDVEFAUtil.$inject = ['moment', 'mng-util.MDVLog', 'mng-model.MDVMessage'];

    function MDVEFAUtil(moment, MDVLog, MDVMessage) {
        var log = MDVLog.register('mng-comm.itd.xmljson.MDVEFAUtil'),
            timeParamName = /Time$/,
            util = {
                getAttr : getAttr,
                getOptionsHash : getOptionsHash,
                parseInfos : parseInfos,
                parseHints : parseHints,
                removeDuplicatesInfos : removeDuplicatesInfos
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name getAttr
         * @methodOf mng-comm.itd.xmljson.service:MDVEFAUtil
         *
         * @description
         * Get a generic Attribute with a specific key value
         *
         * @param {Object} genAttrs EFA generic Attributes object
         * @param {String} genAttrs.key Key that should be compared to the given key
         * @param {String} genAttrs.value Value that should be returned if the key matches
         * @param {String} key Key that should be searched for
         * @returns {String|null} Value for the key, or null if key has no matches
         */
        function getAttr(genAttrs, key) {
            var value = null;

            if (!genAttrs || !genAttrs.length || !key) {
                return value;
            }
            angular.forEach(genAttrs, function(attr) {
                if (!value && attr.name === key) {
                    value = attr.value;
                }
            });
            return value;
        }

        function getOptionsHash(options) {
            var key,
                params = [];

            for (key in options) {
                if (options.hasOwnProperty(key)) {
                    params.push(key + '=' + options[key]);
                }
            }
            return params.sort().join('&');
        }


        function parseParamList(parsed, data) {
            var list = data.paramList,
                i,
                l,
                curr,
                value;

            if (!list || list.length === 0) {
                return parsed;
            }

            for (i = 0, l = list.length; i < l; i += 1) {
                curr = list[i];
                if (!parsed.properties.hasOwnProperty(curr.type)) {
                    parsed.properties[curr.type] = {};
                }
                if (curr.name.match(timeParamName)) {
                    value = moment(curr.value, 'DD/MM/YY HH:mm');
                    if (!value.isValid()) {
                        // fallback to normal value
                        value = curr.value;
                    }
                } else {
                    // normal value
                    value = curr.value;
                }
                parsed.properties[curr.type][curr.name] = value;
            }

            return parsed;
        }
        function parseInfo(curr_info) {
            var parsed_info = {
                url : curr_info.infoLinkURL,
                urlText : curr_info.infoLinkText,
                smsText: curr_info.infoText,
                additionalLinks: curr_info.additionalLinks,
                properties : {}
            };

            if (curr_info.infoText) {
                if (curr_info.infoText.subject) {
                    parsed_info.title = curr_info.infoText.subject;
                }
                if (curr_info.infoText.subtitle) {
                    parsed_info.subtitle = curr_info.infoText.subtitle;
                }
                if (curr_info.infoText.additionalText) {
                    parsed_info.text = curr_info.infoText.additionalText;
                }
                if (curr_info.infoText.content) {
                    parsed_info.content = curr_info.infoText.content;
                }
            }
            parsed_info = parseParamList(parsed_info, curr_info);

            if (parsed_info.properties &&
                    parsed_info.properties.system &&
                    parsed_info.properties.system.infoID) {
                parsed_info.id = parsed_info.properties.system.infoID;
            }
            return new MDVMessage(parsed_info);
        }
        function removeDuplicatesInfos(parsed_infos) {
            var uniqueIds = [],
                res = [],
                i, l;

            // remove duplicates
            for (i = 0, l = parsed_infos.length; i < l; i += 1) {
                if (uniqueIds.indexOf(parsed_infos[i].id()) === -1) {
                    uniqueIds.push(parsed_infos[i].id());
                    res.push(parsed_infos[i]);
                }
            }
            return res;
        }

        function parseInfos(infos, mode) {
            var parsed_infos = [],
                parsed_info,
                i,
                l;

            if (!infos) {
                return parsed_infos;
            }
            if (infos.info) {
                infos = [infos.info];
            }
            for (i = 0, l = infos.length; i < l; i += 1) {
                parsed_info = parseInfo(infos[i]);
                if (mode === 'location') {
                    if (parsed_info.properties().addInfoParam &&
                        parsed_info.properties().addInfoParam.infoType === 'stopInfo') {

                        parsed_infos.push(parsed_info);
                    }
                } else if (mode === 'transportation') {
                    if (parsed_info.properties().addInfoParam &&
                        parsed_info.properties().addInfoParam.infoType === 'lineInfo') {

                        parsed_infos.push(parsed_info);
                    }
                } else {
                    parsed_infos.push(parsed_info);
                }
            }

            return removeDuplicatesInfos(parsed_infos);
        }

        function parseHint(curr_hint) {
            return new MDVMessage({
                content : curr_hint.infoText
            });
        }

        function parseHints(hints) {
            var parsed_infos = [],
                i,
                l;

            if (!hints) {
                return parsed_infos;
            }
            if (hints.hint) {
                hints = [hints.hint];
            }
            for (i = 0, l = hints.length; i < l; i += 1) {
                parsed_infos.push(parseHint(hints[i]));
            }
            return parsed_infos;
        }

        return util;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.1
     * @ngdoc service
     * @name mng-comm.itd.json.service:MDVEFAUtil
     * @requires mng-util.service:MDVLog
     * @requires mng-model.object:MDVMessage
     *
     * @description
     * The `MDVEFAUtil` offers a collection of EFA communication-specific utility functions that do
     * not care about formatting (this is handled in the {@link mng-comm.itd.service:MDVEFAFormatter
     * MDVEFAFormatter}).
     */
    angular.module('mng-comm.itd.json')
        .factory('mng-comm.itd.json.MDVEFAUtil', MDVEFAUtil);

    MDVEFAUtil.$inject = ['moment', 'mng-util.MDVLog', 'mng-comm.itd.MDVEFAFormatter',
        'mng-model.MDVMessage'];

    function MDVEFAUtil(moment, MDVLog, MDVEFAFormatter, MDVMessage) {
        var log = MDVLog.register('mng-comm-itd-json.MDVEFAUtil'),
            _private = {},
            util = {
                getOptionsHash : getOptionsHash,
                parseInfos : parseInfos,
                parseHints : parseHints,
                parseSystemMessages : parseSystemMessages
            };

        log.debug('initialize');

        util._private = _private;

        // ////////////////////////////////

        function getOptionsHash(options) {
            var key,
                params = [];

            for (key in options) {
                if (options.hasOwnProperty(key)) {
                    params.push(key + '=' + options[key]);
                }
            }
            return params.sort().join('&');
        }

        _private.getConcernedIds = function(info, counter) {
            var idList = [],
                stopPlatformMap,
                stopId;

            if (!info || !info.properties) {
                return idList;
            }

            if (!counter) {
                counter = 0;

                // initial call -> also parse stopIDglobalID
                if (info.properties.hasOwnProperty('stopIDglobalID')) {
                    info = _private.parseStopIDglobalID(info);

                    stopPlatformMap = info.properties.stopIDglobalID || {};

                    for (stopId in stopPlatformMap) {
                        if (stopPlatformMap.hasOwnProperty(stopId)) {
                            idList.push(stopId);
                            idList.concat.apply(idList, stopPlatformMap[stopId]);
                        }
                    }
                }
            }

            if (info.properties.hasOwnProperty('concernedStop' + counter)) {
                idList.push(info.properties['concernedStop' + counter]);
            } else {
                return idList;
            }
            return idList.concat(_private.getConcernedIds(info, counter + 1));
        };

        _private.getLocationIds = function(location) {
            var idList = [];

            if (!location) {
                return idList;
            }

            idList.push(location.id());
            return idList.concat(_private.getLocationIds(location.parent()));
        };

        _private.buildConcernedStopMap = function(infos) {

            _private.concernedStopMap = {};

            infos.forEach(function(info) {
                var idList = _private.getConcernedIds(info);

                idList.forEach(function(id) {
                    if (_private.concernedStopMap.hasOwnProperty(id)) {
                        _private.concernedStopMap[id].push(info.id);
                    } else {
                        _private.concernedStopMap[id] = [info.id];
                    }
                });
            });
        };

        _private.isConcernedStop = function(location, info) {
            var locIds = _private.getLocationIds(location),
                concernedIds,
                i,
                j,
                k,
                l;

            for (i = 0, l = locIds.length; i < l; i += 1) {
                if (_private.concernedStopMap.hasOwnProperty(locIds[i])) {
                    concernedIds = _private.concernedStopMap[locIds[i]];

                    for (j = 0, k = concernedIds.length; j < k; j += 1) {
                        if (info.id === concernedIds[j]) {
                            return true;
                        }
                    }
                }
            }

            return false;
        };

        _private.parseStopIDglobalID = function(info) {
            if (info.properties && info.properties.stopIDglobalID &&
                    (typeof info.properties.stopIDglobalID === 'string' ||
                        info.properties.stopIDglobalID instanceof String)) {
                info.properties.stopIDglobalID =
                    MDVEFAFormatter.getStopGlobalMap(info.properties.stopIDglobalID);
            }
            return info;
        };

        _private.parseInfo = function(info) {
            if (info.hasOwnProperty('timeStamps')) {
                info.timestamps = info.timeStamps;
                delete info.timeStamps;
            }

            // parse stopIDglobalID if provided as string
            info = _private.parseStopIDglobalID(info);

            // convert availability to array (EFA {} <-> [] modules)
            // if (info.timestamps && info.timestamps.availability) {
            //     info.timestamps.availability = [info.timestamps.availability];
            // }
            return new MDVMessage(info);
        };

        function parseInfos(infos, origin, destination) {
            var parsed_leg_infos = [],
                parsed_orig_infos = [],
                parsed_dest_infos = [],
                parsed_infos = [],
                i,
                l;

            if (!infos) {
                return parsed_infos;
            }

            _private.buildConcernedStopMap(infos);

            for (i = 0, l = infos.length; i < l; i += 1) {
                if (infos[i].properties &&
                        ((infos[i].properties.hasOwnProperty('infoType') &&
                            infos[i].properties.infoType === 'stopInfo') ||
                            infos[i].properties.hasOwnProperty('stopIDglobalID'))) {
                    if (origin && _private.isConcernedStop(origin, infos[i])) {
                        parsed_orig_infos.push(_private.parseInfo(infos[i]));
                    } else if (destination && _private.isConcernedStop(destination, infos[i])) {
                        parsed_dest_infos.push(_private.parseInfo(infos[i]));
                    } else {
                        parsed_leg_infos.push(_private.parseInfo(infos[i]));
                    }
                } else {
                    parsed_leg_infos.push(_private.parseInfo(infos[i]));
                }
            }

            _private.concernedStopMap = {};

            if (origin && destination) {
                return parsed_leg_infos;
            } else if (origin) {
                return parsed_orig_infos;
            } else if (destination) {
                return parsed_dest_infos;
            }

            return parsed_leg_infos;
        }

        function parseHint(curr_hint) {
            return new MDVMessage(curr_hint);
        }

        function parseHints(hints) {
            var parsed_infos = [],
                i,
                l;

            if (!hints) {
                return parsed_infos;
            }
            if (hints.hint) {
                hints = [hints.hint];
            }
            for (i = 0, l = hints.length; i < l; i += 1) {
                parsed_infos.push(parseHint(hints[i]));
            }
            return parsed_infos;
        }

        function parseSystemMessages(messageList) {
            var result = [],
                i, l, curr, data;

            if (!messageList) {
                return result;
            }

            for (i = 0, l = messageList.length; i < l; i += 1) {
                curr = messageList[i];

                data = new MDVMessage({
                    id : curr.code,
                    content : curr.error || curr.text,
                    type : curr.type,
                    properties : {
                        module : curr.module
                    }
                });
                if (data) {
                    result.push(data);
                }
            }

            return result;
        }

        return util;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.service:MDVUtil
     * @requires $injector
     * @requires mng-util.service:MDVLog
     * @requires mng-util.service:MDVException
     * @requires mng-config.service:MDVConfig
     * @requires mng-model.object:MDVLocation
     *
     * @description
     * The `MDVUtil` service provides some helper functions that are needed by the mng-comm
     * components.
     *
     */
    angular.module('mng-comm')
        .factory('mng-comm.MDVUtil', MDVUtil);

    MDVUtil.$inject = ['$injector', 'mng-util.MDVLog', 'mng-util.MDVException',
        'mng-config.MDVConfig', 'mng-model.MDVLocation'];

    function MDVUtil($injector, MDVLog, MDVException, MDVConfig, MDVLocation) {
        var log = MDVLog.register('mng-comm.MDVUtil'),
            _private = {},
            util = {
                gatherOptions : gatherOptions,
                getSubservice : getSubservice,
                getDirectSubservice : getDirectSubservice,
                isNewResult : isNewResult,
                mergeObjects : mergeObjects,
                mergeObjectsAndKeepReference : mergeObjectsAndKeepReference,
                resetOptions : resetOptions,
                updateLocation : updateLocation
            };

        log.debug('initialize');

        // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
        // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
        MDVConfig.ready(function() {
            if (MDVConfig.getValue('mng-comm.MDVUtil.privateMode') === true) {
                util._private = _private;
            }
        });

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name gatherOptions
         * @methodOf mng-comm.service:MDVUtil
         * @param {Object} config Object that describes which option groups should be used for the
         * returned configuration object.
         * @returns {Object} Object that contains all configured default options, that are defined
         * in the config parameter.
         * **Note:** *This object may contain references to other configuration objects, that are
         * effected whenever this object is modified.*
         *
         * @description
         * Generate an option object that can be used for two-way data-binding the objects to input
         * fields in the DOM.
         */
        function gatherOptions(config) {
            var options = {},
                key;

            if (!config) {
                return options;
            }
            for (key in config) {
                if (config.hasOwnProperty(key)) {
                    options[key] = _private.getOptions(key, config[key]);
                }
            }
            return options;
        }
        /**
         * @public
         * @ngdoc method
         * @name getSubservice
         * @methodOf mng-comm.service:MDVUtil
         * @param {String[]} sources List of service names that can be accessed by the $injector.
         * @param {Number} [prio=0] Index of the current service within the sources array
         * @param {Function=} serviceCheck Function that checks a given service instance if it is
         * a valid service to use it as subservice. This function is supposed to check, if the
         * passed service has all needed functionality that is needed by the main service.
         * @param {Object} exceptionKeys Set of exceptions that contain, 'NO_SERVICE' and
         * 'SERVICE_FAILED' properties.
         * @returns {Object} subservice element that can be used for further process.
         *
         * @description
         * Get a specific service that is defined by name in the sources array.
         */
        function getSubservice(sources, prio, serviceCheck, exceptionKeys) {
            var source,
                service;

            if (!sources || sources.length === 0) {
                throw new MDVException(exceptionKeys.NO_SERVICE, {
                    reason : 'no subservice list defined in configuration.'
                });
            }
            if (prio && prio >= sources.length) {
                // no subservice defined for given prio
                throw new MDVException(exceptionKeys.SERVICE_FAILED);
            }

            source = sources[prio || 0];

            service = getDirectSubservice(source);

            if (!service) {
                throw new MDVException(exceptionKeys.NO_SERVICE, {
                    reason : 'configured service "' + source + '" could not be fetched with the $injector.'
                });
            }

            if (serviceCheck && !serviceCheck(service)) {
                throw new MDVException(exceptionKeys.NO_SERVICE, {
                    reason : 'configured service does not match interface definition of this service'
                });
            }
            return service;
        }
        /**
         * @public
         * @ngdoc method
         * @name getDirectSubservice
         * @methodOf mng-comm.service:MDVUtil
         * @param {String} name Service name that can be accessed by the $injector. This name can
         * contain a certain prefix (like 'mng-comm.itd.json.MDVEFADM') or be blank ('MDVEFADM').
         * If it is passed without prefix, the prefix is guessed, starting with 'mng-comm.itd.json.'.
         * @returns {Object} subservice element that can be used for further process or null if no
         * subservice can be found.
         *
         * @description
         * Get a specific service that is defined by name.
         */
        function getDirectSubservice(name) {
            var i, l,
                prefixes = ['mng-comm.itd.json.', 'mng-comm.itd.xmljson.'];

            // direct approach
            if ($injector.has(name)) {
                return $injector.get(name);
            }

            // check name with prefixes
            for (i = 0, l = prefixes.length; i < l; i += 1) {
                if ($injector.has(prefixes[i] + name)) {
                    return $injector.get(prefixes[i] + name);
                }
            }

            return null;
        }

        /**
         * @public
         * @ngdoc method
         * @name isNewResult
         * @methodOf mng-comm.service:MDVUtil
         * @param {Object[]} list of mng-model - objects
         * @param {Object} elem Element that should be checked. Needs to be a mng-model that provides
         * an 'equals' method.
         * @returns {Boolean} true: element is not within the passed list, false: element is within
         * the list.
         *
         * @description
         * Check whether a given mng-model - object is within a given list, or not.
         */
        function isNewResult(list, elem) {
            var i,
                l;

            if (!elem) {
                return false;
            }

            for (i = 0, l = list.length; i < l; i += 1) {
                if (list[i].equals(elem)) {
                    return false;
                }
            }
            return true;
        }

        /**
         * @public
         * @ngdoc method
         * @methodOf mng-util.service:MDVUtil
         * @name mergeObjects
         * @param {Object} object_a Basic object
         * @param {Object} object_b Additional object that overrides all keys of the basic object
         * if available.
         * @returns {Object} merged object
         *
         * @description
         * Merge two objects to a new object. This method differs to angular.merge/ angular.extend,
         * as it cares about keeping object elements within the single objects (like moment objects)
         * extend is not doing the work & merge is destroying the moment obj.
         * Think of this moment like doing the following line of code without destroying moment:
         * return angular.merge({}, object_a, object_b);
         */
        function mergeObjects(object_a, object_b) {
            // TODO was there a problem with moment? can mergeObjectsAndKeepReference be used
            // instead? This solution lacks of a pretty flat copy and no tests...
            var resultObject = angular.copy(object_a),
                subkey,
                key;

            for (key in object_b) {
                if (object_b.hasOwnProperty(key) && resultObject.hasOwnProperty(key)) {
                    // merge
                    for (subkey in object_b[key]) {
                        if (object_b[key].hasOwnProperty(subkey)) {
                            // override
                            resultObject[key][subkey] = angular.copy(object_b[key][subkey]);
                            // deeper copy here, if needed
                        }
                    }
                } else if (!resultObject.hasOwnProperty(key)) {
                    // copy
                    resultObject[key] = angular.copy(object_b[key]);
                }
            }
            return resultObject;
        }

        /**
         * @public
         * @ngdoc method
         * @name resetOptions
         * @methodOf mng-comm.service:MDVUtil
         * @param {Object} config Object that describes which option groups should be used for the
         * returned configuration object.
         * @param {Object} options Object that shoud be resetted.
         * @returns {Object} null
         * @description
         * Reset the values of a giving Options object to the default ones.
         * **Note** the options object will keep the refrence also after resetting his values to
         * default.
         */
        function resetOptions(config, options) {
            if (!config || !options) {
                return false;
            }
            var key,
                defaultOptions;

            // reset config to get default options
            for (key in config) {
                if (config.hasOwnProperty(key) && config[key] === true) {
                    config[key] = false;
                }
            }
            defaultOptions = util.gatherOptions(config);
            // special case for via
            if (options && options.hasOwnProperty('via') && options.via.hasOwnProperty('optionsList')) {
                options.via.optionsList = [];
            }
            util.mergeObjectsAndKeepReference(options, defaultOptions, false);
        }


        /**
         * @public
         * @ngdoc method
         * @name updateLocation
         * @methodOf mng-comm.service:MDVUtil
         * @param {MDVLocation} old_location {@link mng-model.object:MDVLocation MDVLocation} object
         * that should be updated.
         * @param {MDVLocation|null} new_location {@link mng-model.object:MDVLocation MDVLocation}
         * object that should be used for update. If null is passed, the old location is resetted.
         * @returns {Boolean} Whether the update of the {@link mng-model.object:MDVLocation
         * MDVLocation} worked or not.
         *
         * @description
         * Update the properties of an {@link mng-model.object:MDVLocation MDVLocation} by
         * properties of another {@link mng-model.object:MDVLocation MDVLocation} or reset it
         * completely.
         */
        function updateLocation(old_location, new_location) {
            var key,
                new_props;

            if (!old_location || !(old_location instanceof MDVLocation) ||
                    (new_location && !(new_location instanceof MDVLocation))) {
                return false;
            }
            old_location.reset();

            if (new_location) {
                new_props = new_location.toJSON();

                for (key in new_props) {
                    if (new_props.hasOwnProperty(key)) {
                        old_location._updateProperty(key, new_props[key]);
                    }
                }
            }
            return true;
        }

        // ////////////////////////////////

        _private.getOptions = function(name, config) {
            var is_bool_config = typeof config === 'boolean',
                global = false,
                modus = '', // default
                service;
            // options;

            if (!name || (!is_bool_config && !config)) {
                return {};
            }
            service = _private.getOptionService(name, config);
            if (is_bool_config) {
                return service.get(config, modus);
            }
            // complex configuration
            if (config.hasOwnProperty('global')) {
                global = config['global']; // avoid collision with reserved word
            }
            if (config.hasOwnProperty('modus')) {
                modus = config.modus;
            }
            return _private.getComplexOptions(name, service, modus, global);
            // provide override parameters
            // global flag needs to be false!
            // if (config.hasOwnProperty('overrides')) {
            //     return mergeOptions(options, config.overrides);
            // }
        };

        _private.getComplexOptions = function(name, service, modus, global) {
            if (modus.constructor === Array) {
                // multiple option modi
                if (modus.length === 0) {
                    return service.get(global, '');
                }
                if (modus.length === 1) {
                    return service.get(global, modus[0]);
                }
                if (global) {
                    throw new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'global options cannot use multiple modi on startup: ' + name
                    });
                }
                if (!_private.isAllowedMultiModiName(name)) {
                    throw new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'multiple modi are not allowed for: ' + name
                    });
                }
                return _private.getMultipleModi(service, global, modus);
            }
            return service.get(global, modus);
        };

        _private.isAllowedMultiModiName = function(name) {
            return name === 'individualTransport';
        };

        _private.getMultipleModi = function(service, global, modi) {
            var options = {},
                curr_key,
                i,
                l;

            for (i = 0, l = modi.length; i < l; i += 1) {
                if (i === 0) {
                    curr_key = 'to';
                } else if (i === 1) {
                    curr_key = 'from';
                } else {
                    log.error('via modus not yet implemented. Only lists with two modi are allowed.');
                }
                options[curr_key] = service.get(global, modi[i]);
            }
            return options;
        };

        _private.getOptionService = function(name, config) {
            var service_name = name;

            // use configured name if available
            if (config.service) {
                service_name = config.service;
            }
            if (!$injector.has(service_name)) {
                // retry with standard name convention
                if ($injector.has('mng-comm.MDV' + name + 'Options')) {
                    service_name = 'mng-comm.MDV' + name + 'Options';
                } else {
                    // invalid name
                    throw new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'no option service found for configured name: ' + service_name
                    });
                }

            }
            return $injector.get(service_name);
        };

        /**
         * @public
         * @ngdoc method
         * @methodOf mng-util.service:MDVUtil
         * @name mergeObjectsAndKeepReference
         * @param {Object} object_a Basic object
         * @param {Object} object_b Additional object that overrides all keys of the basic object
         * if available.
         * @param {Boolean} remove indicating whether the properties in a that doesn't exist in object_b
         * should be removed or not
         *
         * @description
         * Merge two objects to a new object.
         * It works as follow : check if the extended object is an Array, object or a primitive Value.
         * 1) in case its an array : iterate over a and call the same method with the values of the array.
         * 2) in case its an object : iterate over the properties of a and call the same method with the
         * values of the properties.
         * 3) in case a is a primitive value : return the value of b.
         */
        function mergeObjectsAndKeepReference(object_a, object_b, remove) {
            remove = remove === undefined ? false : remove;
            var a_traversed = [],
                b_traversed = [];

            function _extend(a, b) {
                // if (a_traversed.indexOf(a) == -1 && b_traversed.indexOf(b) == -1){
                var i, x;

                a_traversed.push(a);
                b_traversed.push(b);
                if (a instanceof Array) {
                    for (i = 0; i < b.length; i += 1) {
                        if (a[i]) {
                            // If element exists, keep going recursive so we don't lose the references
                            a[i] = _extend(a[i], b[i]);
                        } else {
                            // Object doesn't exist, no reference to lose
                            a[i] = b[i];
                        }
                    }
                    if (remove && b.length < a.length) {
                        // Do we have fewer elements in the new object?
                        a.splice(b.length, a.length - b.length);
                    }
                } else if (a instanceof Object && typeof b !== 'string') {
                    for (x in b) {
                        if (a.hasOwnProperty(x)) {
                            a[x] = _extend(a[x], b[x]);
                        } else {
                            a[x] = b[x];
                        }
                    }
                    if (remove) {
                        for (x in a) {
                            if (!b.hasOwnProperty(x)) {
                                delete a[x];
                            }
                        }
                    }
                } else {
                    return b;
                }
                return a;
            }

            _extend(object_a, object_b);
        }

        return util;
    }
}());

(function() {
    'use strict';
    /**
    * @version 0.9.4
    * @constructor
    * @ngdoc object
    * @name mng-comm.object:MDVOptions
    * @requires mng-util.service:MDVLog
    * @requires mng-config.service:MDVConfig
    * @requires mng-util.object:MDVException
    *
    * @description
    * The `MDVOptions` factory provides all general functionality an MDVOptions-Service needs to
    * provide to allow global and local options.
    * This factory is for internal usage only.
    * The documentation of this Factory is used to describe the general usage of MDVOptions.
    *
    * # General usage
    * MDVOptions are options that can be modified on higher level via Controllers or Directives.
    * The basic idea of the options is, that every service that needs such options, creates its own
    * option set on startup and provides a reference to these options. Whenever this reference is
    * modified, the options of the service get modified.
    * Which options should be available to the higher levels in this way can be defined in the
    * configuration.
    *
    * Before the overall workflow is described, an overview of already existing option groups is
    * given.
    *
    * **Note:** *MDVOptions are not set by setter functions, but by data binding and reference*
    *
    *
    * # Workflow
    * 1. Define option group defaults in configuration
    * 2. Assign option groups to services/ factories in configuration
    * 3. Options are created for every service/ factory on initialization
    * 4. Bind options from service/ factory for modification
    *
    * ## 1. Configuration of option group defaults
    * As described, all configuration parameters are grouped to allow an easier configuration.
    * Each group provides default parameters that are used when no other configuration is done.
    * Whenever an option group is requested, these options are set initially.
    *
    * If no configuration is provided, the default configuration is used. Partial configuration is
    * possible.
    *
    * ```js
    *   // configuration object
    *   ...
    *   'mng-comm' : {
    *      ...
    *      MDVOptions: {
    *        // change dateTime from default (departure now) to arrival at 15:22 on March 17 2016
    *        dateTime : {
    *            dateTime: '2016-03-17T15:22:11+01:00',
    *            isDeparture : false
    *        }
    *        // leave all other options with default
    *      },
    *      ...
    *   },
    *   ...
    * ```
    *
    * Each option group can contain multiple default parameters, defined by a special mode. Whereas
    * the configuration above (and all default configurations of option groups) use a single set of
    * default parameters, multiple modes can be assigned to an option group.
    *
    * ```js
    *   // configuration object
    *   ...
    *   individualTransport : {
    *       '' : {                 // default that is used when no modus is specified
    *          type : 'bike'        // override default configuration of type 'walk'
    *       },
    *       'toDest' :{             // modus called 'toDest': walk 5 minutes, avoid elevation
    *          minutes : 5,         // override default configuration of 15 minutes
    *          avoidElevation : true  // override default configuration to avoid elevation
    *       }
    *    },
    *   ...
    * ```
    *
    * ## 2. Configuration of services/ factories
    * Every service/ factory that provides configurable options can refer to option groups in two
    * ways:
    * - **local**
    * The set of options is for the service/ factory only. These options are not affected by
    * changes of other service/ factory and do not affect options of other services/ factories
    * whenever they are changed.
    * - **global**
    * The set of options is for general usage. These options change whenever the options of another
    * service/ factory changes, as long as the changed service/ factory also refers to the global
    * version of the option.
    *
    * The configuration for services/ factories can be done in a short and in a long version.
    * The idea behind the long version is to allow more functionality in the future, like different
    * modes of default options or providing option services that are not implemented in the
    * mng-modules.
    *
    * ```js
    *   // configuration object
    *   ...
    *   'mng-comm' : {
    *      ...
    *      MDVJourneys: {
    *         ...
    *         // short version
    *         options: {
    *            dateTime: true,             // global dateTime options
    *            productRestrictions : false,     // local productRestrictions options
    *            individualTransport : true,    // global individualTransport options
    *            publicTransport : true        // global publicTransport options
    *         },
    *         // alternative, using a long version for individualTransport
    *         options: {
    *            dateTime: true,             // global dateTime options
    *            productRestrictions : false,     // local productRestrictions options
    *            individualTransport : {
    *                global : false,          // local mode is needed to use modus
    *                modus : 'toDest'         // use default parameters of modus 'toDest'
    *            },
    *            publicTransport : true        // global publicTransport options
    *         },
    *         ...
    *      },
    *   ...
    * ```
    * Which option group is used for every single service, is described in the regarding service
    * documentation. If no configuration is provided, the default configuration is used.
    * Partial configuration is possible.
    *
    *
    * ## 3. Options creation
    * Whenever a service/ factory with options is instantiated, the options object is created. This
    * is done by reading in both configurations (defined in 1. and 2.) and creating global
    * references or local copies of the configured values.
    *
    * As result of this progress each service/ factory contains its own options reference with the
    * configured default settings.
    *
    *
    * ## 4. Data Binding
    * Each service/ factory provides a method (usually `getOptions()`) to get a reference to the
    * internal options object.
    * This object can be used to bind some inputs to specific values of the options. By this
    * data binding all changes done by the input fields affect the options in the service/ factory
    * and all changes on the options within the service/ factory affect the input field.
    *
    * ```html
    *   ...
    *   <!-- Assume departureInstance is a departure object created and bound to the scope by a
    *       controller that controls the scope this input field is in-->
    *   <input type="checkbox" ng-model="departureInstance.options().dateTime.isDeparture" />
    *   ...
    * ```
    * If the options are bound **locally**, the changes only affect the regarding service/ factory,
    * if they are bound **globally**, all options in the other services/ factories are affected,
    * too.
    *
    *
    *
    * # Option Groups
    * Configurable options are combined to serveral groups to allow easier configuration. Each
    * group cares about a specific set of options.
    *
    *
    * ## accessibility
    * The accessibility options allow modification of the public transporation part of the journey
    * with respect to personal limitations.
    *
    * <table><tr><th>name</th><th>type</th><th>default</th><th>description</th></tr>
    * <tr><td>accessibleVehiclesOnly</td><td>Boolean</td><td>false</td><td>Determine whether the
    * public transportation modes should be limited to vehicles that allow access with a wheelchair
    * without any further help.</td></tr>
    * <tr><td>elevators</td><td>Boolean</td><td>true</td><td>Determine whether elevators should
    * be used for accessing the platform or not.</td></tr>
    * <tr><td>escalators</td><td>Boolean</td><td>true</td><td>Determine whether escalators should
    * be used for accessing the platform or not.</td></tr>
    * <tr><td>lowFloorVehiclesOnly</td><td>Boolean</td><td>false</td><td>Determine whether the
    * public transportation modes should be limited to vehicles that allow a low floor access only
    * (access without stairs), or not.</td></tr>
    * <tr><td>stairs</td><td>Boolean</td><td>true</td><td>Determine whether stairs should be used
    * for accessing the platform or not.</td></tr>
    * </table>
    *
    *
    * ## dateTime
    * Options that care about the date and time.
    * <table><tr><th>name</th><th>type</th><th>default</th><th>description</th></tr>
    * <tr><td>date</td><td>String</td><td>'now'</td>
    * <td>Describes the initial date that should be provided for the user. if the current date and
    * current time should be used, use 'now'. The date needs to be provided in ISO8601 format or
    * in the format specified by 'dateFormat'.</td></tr>
    * <tr><td>dateFormat</td><td>String</td><td>''</td><td>Describe the string format the date is
    * provided. Use <a href="http://momentjs.com/docs/#/parsing/string-format/">momentjs formats
    * </a> to do so.</td></tr>
    * <tr><td>time</td><td>String</td><td>'now'</td>
    * <td>Describes the initial date that should be provided for the user. if the current date and
    * current time should be used, use 'now'. The date needs to be provided in ISO8601 format or
    * in the format specified by 'timeFormat'.</td></tr>
    * <tr><td>timeFormat</td><td>String</td><td>''</td><td>Describe the string format the time is
    * provided. Use <a href="http://momentjs.com/docs/#/parsing/string-format/">momentjs formats
    * </a> to do so.</td></tr>
    * <tr><td>isDeparture</td><td>Boolean</td><td>true</td>
    * <td>Define whether the given dateTime option should be treated as departure or as arrival
    * time. true: treat dateTime as departure, false: treat it as arrival.</td></tr>
    * <tr><td>useRealtime</td><td>Boolean</td><td>true</td>
    * <td>Define whether to request realtime data from the server or not. If realtime is requested
    * and the server is not able to provide realtime information, it does not make any difference
    * if this parameter is enabled, or not.</td></tr>
    * </table>
    *
    *
    * ## departures
    * Options that can be passed to a departure monitor request to limit it by certain destinations
    * <table><tr><th>name</th><th>type</th><th>default</th><th>description</th></tr>
    * <tr><td>isDeparture</td><td>Boolean</td><td>true</td>
    * <td>Define whether the localities that are reachable with the departures or that were reached
    * by the arrivals should be returned</td></tr>
    * <tr><td>limitStops</td><td>MDVLocation[]</td><td>[]</td><td>list of stops that should be
    * destinations of the provided departures</td></tr>
    * <tr><td>limitLocalities</td><td>MDVLocation[]</td><td>[]</td><td>list of localities the
    * returned departures should serve</td></tr>
    * </table>
    *
    * ## destinations
    * Options that are used to request destinations that are reachable with one leg from a certain stop
    * <table><tr><th>name</th><th>type</th><th>default</th><th>description</th></tr>
    * <tr><td>includeStops</td><td>Boolean</td><td>true</td><td>Flag whether reachable stops should
    * be returned or not.</td></tr>
    * <tr><td>includeLocalities</td><td>Boolean</td><td>false</td><td>Flag whether reachable
    * localities should be returned or not.</td></tr>
    * <tr><td>isDeparture</td><td>Boolean</td><td>true</td>
    * <td>Define whether the localities that are reachable with the departures or that were reached
    * by the arrivals should be returned</td></tr>
    * <tr><td>limitResult</td><td>Number</td><td>0</td><td>Maximum of results that should be
    * returned. If set to 0, no limitation is set</td></tr>
    * <tr><td>limitTime</td><td>Number</td><td>0</td><td>Duration in which the next departures/
    * arrivals should be taken into account, defined in minutes. If set to 0, no time limit is used
    * </td></tr>
    * <tr><td>limitLocality</td><td>String</td><td>''</td><td>Locality id in which the reachable
    * locations should be returned in. All other locations outside of this locality are ignored
    * </td></tr>
    * <tr><td>limitAccessible</td><td>Boolean</td><td>false</td><td>Only return locations that can
    * be reached in an accessible way
    * </td></tr>
    * </table>
    *
    *
    * ## fare
    * The fare options affect the public transport parts of the journey, as they may limit the
    * modes regarding to fare options.
    *
    * <table><tr><th>name</th><th>type</th><th>default</th><th>description</th></tr>
    * <tr><td>avoidZones</td><td>Array</td><td>[]</td><td>Set of fare zones that should not be
    * taken into account when using public transportation. Per default, all zones are active, if
    * zones are passed in this array (per string), these zones are excluded from routing.</td></tr>
    * </table>
    *
    *
    * ## individualTransport
    * The individual transport options describe the part of the journey that is done individually,
    * without the use of the public transport. This affects the way to and from stops that are used
    * for public transportation.
    *
    * **Note:** *individual transport options can be separated in two different option groups, to
    * allow different settings for each part (to station, from station). To use this functionality,
    * pass an array with two modes to the 'mode' parameter of the option group definition.
    * Example:*
    *
    * ```js
    * ...
    * individualTransport : {
    *    global : false,  // available in local mode only
    *    modus: ['', 'toDest']  // use default for 'to stop' and 'toDest'-mode for 'from stop'
    * },
    * ...
    * ```
    * *The different options can be accessed via the `to` and `from` property.*
    *
    *  ```js
    *  var s = new YourService();  // options are bound via initialization of the service
    *  s.getOptions().individualTransport.to.minutes  // get minutes from origin to stop
    *  s.getOptions().individualTransport.from.minutes  // get minutes from stop to destination
    *  ```
    *
    * <table>
    * <tr><th>name</th><th>type</th><th>default</th><th>description</th></tr>
    * <tr><td>avoidElevation</td><td>Boolean</td><td>false</td><td>Avoid paths that include a high
    * elevation and accept longer paths with lower elevation</td></tr>
    * <tr><td>cycleSpeed</td><td>Number</td><td>14</td><td>Average speed in kilometers per hour the
    * cycling parts should be calculated with</td></tr>
    * <tr><td>minutes</td><td>Number</td><td>15</td><td>Time in minutes that should be used for
    * each single way to and from a stop</td></tr>
    * <tr><td>type</td><td>String</td><td>'walk'</td><td>Type how the way to and from a stop should
    * be performed. Valid options are:
    * <ul>
    * <li>'walk' (go by feet),</li>
    * <li>'bike' (go by bike, but do not take bike on train),</li>
    * <li>'bikeOnTrain' (go by bike, but take bike on train),</li>
    * <li>'bikeAndRide' (go by bike to stations that is marked as bike&ride stations),</li>
    * <li>'taxi' (go by taxi),</li>
    * <li>'kissAndRide' (go by car to the station, but do not leave the car at the station),</li>
    * <li>'parkAndRide' (go by car to stations that are marked as park&ride stations),</li>
    * <li>'car' (go by private car and do not care about parking)</li>
    * </ul></td></tr>
    * <tr><td>walkSpeed</td><td>String</td><td>'normal'</td><td>Speed the walking parts of the
    * journey should be calculated with. Valid options are:
    * <ul>
    * <li>'slow',</li>
    * <li>'normal',</li>
    * <li>'fast'</li>
    * </td></tr>
    * </table>
    *
    *
    * ## information
    * The information options describe filter and reduction options for information messages, like
    * disruption, line blocking or banner information.
    *
    * <table>
    * <tr><th>name</th><th>type</th><th>default</th><th>description</th></tr>
    * <tr><td><b>include</b></td><td>Object</td><td></td><td>Main object that includes all reduction
    * properties. Whenever a property is set to false, it is not returned in the response.</td></tr>
    * <tr><td>allLines</td><td>Boolean</td><td>false</td><td>Include a list of all lines that are
    * affected by all messages</td></tr>
    * <tr><td>allStops</td><td>Boolean</td><td>false</td><td>Include a list of all stops that are
    * affected by all messages</td></tr>
    * <tr><td>allPlaces</td><td>Boolean</td><td>false</td><td>Include a list of all places that are
    * affected by all messages</td></tr>
    * <tr><td>creationTime</td><td>Boolean</td><td>true</td><td>Include information about the
    * time of every message's creation</td></tr>
    * <tr><td>expirationTime</td><td>Boolean</td><td>true</td><td>Include information about the
    * time of every message's expiration</td></tr>
    * <tr><td>lines</td><td>Boolean</td><td>true</td><td>Include a list of all lines, that are
    * affected by a single message, for each message</td></tr>
    * <tr><td>modificationTime</td><td>Boolean</td><td>true</td><td>Include information about the
    * last time a message was modified</td></tr>
    * <tr><td>properties</td><td>Boolean</td><td>true</td><td>Include additional information for
    * every message</td></tr>
    * <tr><td>publicationPeriod</td><td>Boolean</td><td>true</td><td>Include information about the
    * period when every message is supposed to be public.</td></tr>
    * <tr><td>source</td><td>Boolean</td><td>false</td><td>Include information, where the message
    * comes from</td></tr>
    * <tr><td>stops</td><td>Boolean</td><td>true</td><td>Include a list of all stops, that are
    * affected by a single message, for each message</td></tr>
    * <tr><td>validityPeriod</td><td>Boolean</td><td>true</td><td>Include information about the
    * period when message is valid.</td></tr>

    * <tr><td></td><td></td><td></td><td></td></tr>
    * <tr><td><b>filter</b></td><td>Object</td><td></td><td>Main object that includes all filter options
    * to reduce the amount of messages that are returned</td></tr>
    * <tr><td>date</td><td>moment, 'now', null</td><td>null</td><td>Filter all messages that are
    * valid on the given date. Instead of passing a single date, an array of dates can be passed.
    * Messages that are valid on one of the passed dates are returned.</td></tr>
    * <tr><td>iconIds</td><td>Number[]</td><td>[]</td><td>Filter messages that affect certain lines
    * with a given iconId (=EFA productId), like 'Intercity Trains Network'.</td></tr>
    * <tr><td>ids</td><td>String[]</td><td>[]</td><td>Filter all messages that have a certain id.</td></tr>
    * <tr><td>informationTypes</td><td>String[]</td><td>[]</td><td>Filter all messages that describe
    * a certain type. Valid options are:
    * <ul>
    * <li>'areaBlocking'</li>
    * <li>'areaDisplacement'</li>
    * <li>'areaInfo'</li>
    * <li>'bannerInfo'</li>
    * <li>'clearance'</li>
    * <li>'generalInfo'</li>
    * <li>'indexInfo'</li>
    * <li>'interchangeInfo'</li>
    * <li>'interchangeMessage'</li>
    * <li>'lineBlocking'</li>
    * <li>'lineInfo'</li>
    * <li>'routeBlocking'</li>
    * <li>'routeInfo'</li>
    * <li>'stopBlocking'</li>
    * <li>'stopInfo'</li>
    * <li>'trafficSituation'</li>
    * <li>'tripMessage'</li>
    * </ul></td></tr>
    * <tr><td>lineNames</td><td>String[]</td><td>[]</td><td>Filter messages that affect certain lines
    * with a name.</td></tr>
    * <tr><td>priorities</td><td>String[]</td><td>[]</td><td>Filter all messages that have a certain
    * priority. Valid options are:
    * <ul>
    * <li>'veryLow'</li>
    * <li>'low'</li>
    * <li>'normal'</li>
    * <li>'high'</li>
    * <li>'veryHigh'</li>
    * </ul></td></tr>
    * <tr><td>productClasses</td><td>Number[]</td><td>[]</td><td>Filter all messages that affect
    * lines with certain product classes (e.g. messages that are for trains/ busses only).</td></tr>
    * <tr><td>stopIds</td><td>String[]</td><td>[]</td><td>Filter messages that affect certain stops
    * with a given id.</td></tr>
    * <tr><td>validity</td><td>Object</td><td></td><td>Filter all messages by validity. To do so,
    * from and to value have to be set.</td></tr>
    * <tr><td>validity.from</td><td>moment, 'now', null</td><td>null</td><td>Start date of the validity
    * period</td></tr>
    * <tr><td>validity.to</td><td>moment, 'now', null</td><td>null</td><td>End date of the validity
    * period</td></tr>
    * <tr><td>validity.timeEnabled</td><td>Boolean</td><td>false</td><td>True: enable time sharp
    * period. False: validity range is provided by date only.</td></tr>
    * </table>
    *
    *
    * ## lineRestrictions
    * The line restrictions limit the public transportation modes in addition to the mode
    * restriction options with respect to the transport association.
    *
    * <table><tr><th>name</th><th>type</th><th>default</th><th>description</th></tr>
    * <tr><td>restriction</td><td>Number</td><td>0</td><td>Restriction to public transportation
    * modes with respect to the transport association. Valid options are:
    * <ul>
    * <li>0 (no restriction, all lines),</li>
    * <li>1 (all lines, without high speed intercity trains),</li>
    * <li>2 (only lines, that are within the transport association, without extra fares),</li>
    * <li>3 (lines that are within the transport association and local transport lines)</li>
    * </ul></td></tr>
    * </table>
    *
    *
    * ## pdfOutput
    * These options modify the PDF output provided by the back-end.
    *
    * <table>
    * <tr><th>name</th><th>type</th><th>default</th><th>description</th></tr>
    * <tr><td>elevationProfile</td><td>Boolean</td><td>false</td><td>Allow the output to add an
    * elevation profile to the footpath routing PDF, or not.</td></tr>
    * <tr><td>elevationSummary</td><td>Boolean</td><td>false</td><td>Allow the output to add a
    * summary of the elevation data to the footpath routing PDF, or not.</td></tr>
    * </table>
    *
    *
    * ## productRestrictions
    * Options that allow the user to toggle specific means of transport for a single request on or
    * off. Please note that (some of) these values may be misused in the DIVA system, so the keys
    * that are used do not necessary fit the actual mode of transport.
    *
    * Each of the modes describe a boolean value that describes whether the mode should be active
    * (true) or restricted (false).
    *
    * The following list describes how the modes are usually mapped in the EFA system:
    * <table>
    * <tr><th>name</th><th>type</th><th>default</th><th>EFA mot value</th></tr>
    * <tr><td>train</td><td>Boolean</td><td>true</td><td>0</td></tr>
    * <tr><td>commuter</td><td>Boolean</td><td>true</td><td>1</td></tr>
    * <tr><td>subway</td><td>Boolean</td><td>true</td><td>2</td></tr>
    * <tr><td>lightRail</td><td>Boolean</td><td>true</td><td>3</td></tr>
    * <tr><td>tram</td><td>Boolean</td><td>true</td><td>4</td></tr>
    * <tr><td>bus</td><td>Boolean</td><td>true</td><td>5</td></tr>
    * <tr><td>regionalBus</td><td>Boolean</td><td>true</td><td>6</td></tr>
    * <tr><td>coach</td><td>Boolean</td><td>true</td><td>7</td></tr>
    * <tr><td>cableCar</td><td>Boolean</td><td>true</td><td>8</td></tr>
    * <tr><td>ferry</td><td>Boolean</td><td>true</td><td>9</td></tr>
    * <tr><td>demandTaxi</td><td>Boolean</td><td>true</td><td>10</td></tr>
    * <tr><td>other</td><td>Boolean</td><td>true</td><td>11</td></tr>
    * <tr><td>plain</td><td>Boolean</td><td>true</td><td>12</td></tr>
    * <tr><td>localTrain</td><td>Boolean</td><td>true</td><td>13</td></tr>
    * <tr><td>nationalTrain</td><td>Boolean</td><td>true</td><td>14</td></tr>
    * <tr><td>internationalTrain</td><td>Boolean</td><td>true</td><td>15</td></tr>
    * <tr><td>highspeedTrain</td><td>Boolean</td><td>true</td><td>16</td></tr>
    * <tr><td>railReplacement</td><td>Boolean</td><td>true</td><td>17</td></tr>
    * <tr><td>railShuttle</td><td>Boolean</td><td>true</td><td>18</td></tr>
    * <tr><td>citizenBus</td><td>Boolean</td><td>true</td><td>19</td></tr>
    * </table>
    *
    *
    * ## publicTransport
    * The public transport options describe the part of the journey that is done with public
    * transportation services. This affects the way from one stop to another stop using public
    * transportation.
    *
    * <table>
    * <tr><th>name</th><th>type</th><th>default</th><th>description</th></tr>
    * <tr><td>allowNearbyStops</td><td>Boolean</td><td>false</td><td>Determine whether nearby
    * stops should be considered as an routing option although they require an initial footpath from
    * the origin stop. Walks to nearby stops are only suggested, if they fit to the usual routing
    * criteria.</td></tr>
    * <tr><td>bikeTakeAlong</td><td>Boolean</td><td>false</td><td>Determine whether only public
    * transportation modes with the option to take a bike along should be used or not.</td></tr>
    * <tr><td>maxInterchanges</td><td>(positive) Number</td><td>9</td><td>Maximum of interchanges
    * that should be allowed for the journey with public transportations. Default is 9, the maximum
    * of interchanges that are allowed by the EFA back-end. This ensures, that there is actually no
    * limitation on interchanges.</td></tr>
    * <tr><td>routingOptimization</td><td>String</td><td>'time'</td><td>Define the way how the
    * public transportation part should be optimized. Valid options are:
    * <ul>
    * <li>'comfortable' (short walking paths, rails prior buses),</li>
    * <li>'economic' (no expensive modes, no modes with extra fares),</li>
    * <li>'cost' (least costs for transportation, determined by a custom cost algorithm on the
    * server),</li>
    * <li>'costex' (least costs),</li>
    * <li>'interchange' (as few interchanges as possible),</li>
    * <li>'time' (as fast as possible),</li>
    * <li>'walking' (connections with least walking parts),</li>
    * <li>'nighttrain' (connections with longest time in a sleeping wagon, to avoid arrivals at 4am
    * and prefer arrivals at 6am to get more sleep),</li>
    * <li>'reliable' (connections with enough interchange time, no connections with unsafe
    * forecast),</li>
    * </ul></td></tr>
    * </table>
    *
    *
    * ## sharing
    * The sharing options allow alternative journeys that use sharing providers. The use of these
    * options needs to be activated (enabled=true), before the providers can be selected.
    *
    * <table><tr><th>name</th><th>type</th><th>default</th><th>description</th></tr>
    * <tr><td>enabled</td><td>Boolean</td><td>false</td><td>Determine whether to allow sharing
    * provider alternatives or not. If this option is enabled, longer computation time is needed.
    * </td></tr>
    * <tr><td>callabike</td><td>Boolean</td><td>false</td><td>Allow provider CallABike</td></tr>
    * <tr><td>car2go</td><td>Boolean</td><td>false</td><td>Allow provider Car2Go</td></tr>
    * <tr><td>flinkster</td><td>Boolean</td><td>false</td><td>Allow provider Flinkster</td></tr>
    * <tr><td>nextbike</td><td>Boolean</td><td>false</td><td>Allow provider NextBike</td></tr>
    * <tr><td>stadtmobil</td><td>Boolean</td><td>false</td><td>Allow provider Stadtmobil</td></tr>
    * </table>
    *
    *
    * ## via
    * The via options allow to calculate journeys that travel via/not via one or multiple verified
    * stops.
    * <table><tr><th>name</th><th>type</th><th>default</th><th>description</th></tr>
    * <tr><td>optionsList</td><td>Object[]</td><td>[]</td>
    *   <td>List for every via location that is configured. The first list element applies to the
    * first via, the second to the second via, and so on.<br/>
    * The configuration object for each via can contain the following parameters:
    * <ul>
    * <li>dwellTime (Number, default: 10): time to stay on the via stop.</li>
    * <li>enabled (Boolean, default: true): flag to determine the modus of the via. True: normal
    * via point the journey goes through, false: via point the journey avoids, although this may
    * result in a longer journey.
    * </li>
    * </ul>
    * </td></tr>
    * </table>
    */
    angular.module('mng-comm')
        .factory('mng-comm.MDVOptions', MDVOptions);

    MDVOptions.$inject = ['mng-util.MDVLog', 'mng-config.MDVConfig', 'mng-util.MDVException'];


    function MDVOptions(MDVLog, MDVConfig, MDVException) {
        return function(name, option_options) {
            var log = MDVLog.register('mng-comm.MDV' + name + 'Options'),
                _private = {
                    option_key : 'mng-comm.MDVOptions.' + name,
                    optionModusActiveSignalWord : 'optionModusActive',
                    globals : null
                },
                optionObject = {
                    get : get
                };

            log.debug('initialize');

            // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
            // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
            MDVConfig.ready(function() {
                if (MDVConfig.getValue('mng-comm.MDVOptions.privateMode') === true) {
                    optionObject._private = _private;
                }
            });

            // ////////////////////////////////

            function get(global, modus) {
                if (!MDVConfig.isReady()) {
                    throw new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'Configuration has not yet loaded correctly. Cannot start ' +
                            'requests without a valid configuration.'
                    });
                }
                if (global && modus) {
                    throw new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'global options cannot use a modus: ' + name
                    });
                }
                if (global) {
                    // return global options
                    if (!_private.globals) {
                        _private.globals = _private.getOptionsDeepCopy('');
                    }
                    return _private.globals;
                }
                return _private.getOptionsDeepCopy(modus);
            }

            // ////////////////////////////////

            _private.getDefault = function() {
                var customOptions = MDVConfig.getValue(_private.option_key),
                    key;

                if (!customOptions) {
                    log.info('do not override default options for key ' + _private.option_key);
                    // no adjustments to default options, return default
                    return _private.mergeWithDefaults({});
                }
                if (_private.isComplexOption(customOptions)) {
                    // complex modus options
                    for (key in customOptions) {
                        if (customOptions.hasOwnProperty(key)) {
                            if (key !== _private.optionModusActiveSignalWord) {
                                customOptions[key] = _private.mergeWithDefaults(customOptions[key]);
                            }
                        }
                    }
                    // get copy of already modified options
                    return angular.merge({}, customOptions);
                }
                // normal options, return merge
                return _private.mergeWithDefaults(customOptions);
            };

            // main method to get an options copy for a specific modus
            _private.getOptionsDeepCopy = function(modus) {
                if (modus) {
                    if (!_private.isComplexOption(_private.defaultOptions)) {
                        log.error('cannot get modus ' + modus + ' from default options for ' +
                            name + '. Fallback to default options.');
                        return _private.getOptionsDeepCopy();
                    }
                    if (!_private.defaultOptions.hasOwnProperty(modus)) {
                        log.error('cannot get modus ' + modus + ' from options for ' + name +
                            '. Fallback to default options.');
                        return _private.getOptionsDeepCopy('');
                    }
                    // valid modus, return modus
                    return angular.merge({}, _private.defaultOptions[modus]);
                }
                if (modus === '') {
                    if (!_private.isComplexOption(_private.defaultOptions)) {
                        return _private.getOptionsDeepCopy();
                    }
                    // valid default, return default modus
                    return angular.merge({}, _private.defaultOptions['']);
                }
                // return plain default object
                return angular.merge({}, _private.defaultOptions);
            };

            _private.isComplexOption = function(options) {
                return options.hasOwnProperty('') ||
                    options.hasOwnProperty(_private.optionModusActiveSignalWord);
            };

            // Methods to fill in default data
            _private.mergeWithDefaults = function(custom) {
                // possible futur changes: no deep copy
                return angular.merge({}, option_options.defaultOptions, custom);
            };

            // fill default options
            _private.defaultOptions = _private.getDefault();

            return optionObject;
        };
    }

    // create all boring option services with the following default options
    var option_names = {
            accessibility : {
                defaultOptions : {
                    accessibleVehiclesOnly : false,
                    elevators : true,
                    escalators : true,
                    lowFloorVehiclesOnly : false,
                    stairs : true,
                    showAccessibility : false,
                    stepFree : false,
                    visuallyImpaired : false
                }
            },
            dateTime : {
                defaultOptions : {
                    date : 'now',
                    dateFormat : '',
                    time : 'now',
                    timeFormat : '',
                    useRealTime : true,
                    isDeparture : true
                }
            },
            departures : {
                defaultOptions : {
                    isDeparture : true,
                    limitStops : [],
                    limitLocalities : []
                }
            },
            destinations : {
                defaultOptions : {
                    includeStops : true,
                    includeLocalities : false,
                    isDeparture : true,
                    limitResult : 0,
                    limitTime : 0,
                    limitLocality : null,
                    limitAccessible : false
                }
            },
            fare : {
                defaultOptions : {
                    avoidZones : []
                }
            },
            individualTransport : {
                defaultOptions : {
                    avoidElevation : false,
                    cycleSpeed : 14,
                    minutes : 15,
                    type : 'walk',
                    walkSpeed : 'normal'
                }
            },

            information : {
                defaultOptions : {
                    include : {
                        allLines : false,
                        allStops : false,
                        allPlaces : false,
                        creationTime : true,
                        expirationTime : true,
                        lines : true,
                        modificationTime : true,
                        properties : true,
                        publicationPeriod : true,
                        source : false,  // ?
                        stops : true,
                        validityPeriod : true
                    },
                    filter : {
                        // commented as not able to write as default
                        // date : [moment('2016-08-20T02:00:59Z'), 'now', moment('2016-09-01T02:00:59Z')],
                        // validity : {
                        //     from : moment('2016-08-24T02:00:59Z'),
                        //     to : moment('2016-08-28T02:00:59Z'),
                        //     timeEnabled : false
                        // },
                        iconIds : [],  // [1],
                        ids : [],  // ['2882'],
                        informationTypes : [],  // ['lineBlocking'],
                        lineNames : [],  // ['T2']
                        priorities : [],  // ['normal'],
                        productClasses : [],  // [1],
                        stopIds : []  // ['10001010'],
                    }
                }
            },
            lineRestrictions : {
                defaultOptions : {
                    restriction : 0
                }
            },
            pdfOutput : {
                defaultOptions : {
                    elevationProfile : false,
                    elevationSummary : false
                }
            },
            personalSchedule : {
                defaultOptions : {
                    date : 'now',
                    dateFormat : '',
                    days : null,
                    outwardFrom : '07:00',
                    outwardTo : '09:00',
                    enableReturnTrip : false,
                    returnFrom : '17:00',
                    returnTo : '19:00',
                    timeFormat : 'HH:mm',
                    useRealtime : true
                }
            },
            productRestrictions : {
                defaultOptions : {
                    train : true,
                    commuter : true,
                    subway : true,
                    lightRail : true,
                    tram : true,
                    bus : true,
                    regionalBus : true,
                    coach : true,
                    cableCar : true,
                    ferry : true,
                    demandTaxi : true,
                    other : true,
                    plain : true,
                    localTrain : true,
                    nationalTrain : true,
                    internationalTrain : true,
                    highspeedTrain : true,
                    railReplacement : true,
                    railShuttle : true,
                    citizenBus : true
                }
            },
            publicTransport : {
                defaultOptions : {
                    allowNearbyStops : false,
                    bikeTakeAlong : false,
                    maxInterchanges : 9,
                    routingOptimization : 'time'
                }
            },
            sharing : {
                defaultOptions : {
                    enabled : false,
                    callabike : false,
                    car2go : false,
                    flinkster : false,
                    nextbike : false,
                    stadtmobil : false
                }
            },
            via : {}
        },
        key,
        app = angular.module('mng-comm');

    /* jshint loopfunc: true */
    for (key in option_names) {
        if (option_names.hasOwnProperty(key)) {
            app.factory('mng-comm.MDV' + key + 'Options',
                ['mng-comm.MDVOptions', (function(opt_name, opt_options) {
                    return function(MDVOptionsFactory) {
                        return new MDVOptionsFactory(opt_name, opt_options);
                    };
                }(key, option_names[key]))]);
        }
    }
    /* jshint loopfunc: false */

}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.service:MDVLocationRequester
     * @requires $q
     * @requires $filter
     * @requires $injector
     * @requires mng-config.service:MDVConfig
     * @requires mng-util.service:MDVLog
     * @requires mng-util.object:MDVException
     *
     * @description
     * The `MDVLocationRequester` service is a basic MDV service that provides a list of
     * {@link mng-model.object:MDVLocation MDVLocation} - suggestions for a given input name.
     *
     * This service depends on sub-services that provide a specific interface. Which sub-service is
     * used and how this sub-service is configured is defined in the
     * {@link mng-config.service:MDVConfig Configuration}. The sub-service is responsible for
     * fetching the suggestions and parsing them to the {@link mng-model.object:MDVLocation
     * MDVLocation} format.
     * This service cares about caching results and providing a fix interface how the suggestions
     * are returned.
     *
     * The `MDVLocationRequester` API is based on the
     * {@link https://docs.angularjs.org/api/ng/service/$q deferred/ promise APIs} exposed by the $q
     * service. While for simple usage patterns this doesn't matter, for advanced usage it is
     * important to familiarize yourself with these APIs and the guarantees they provide.
     *
     * # General usage
     * The `MDVLocationRequester` service is an object which provides a single function -
     * `search(input)` - that is used for resolving a given name to a promise.
     *
     * ```js
     *   // Simple search request
     *   MDVLocationRequester
     *      .search('main')
     *      .then(function successCallback(response) {
     *          // this callback will be called asynchronously
     *          // when the response is available
     *     }, function errorCallback(response) {
     *          // called asynchronously if an error occurs
     *          // or server returns response with an error status.
     *     });
     * ```
     *
     * # Caching
     * To enable caching, set the configuration `cache` property to `true` (to use default
     * cache).
     *
     * Note that even if the response is served from cache, delivery of the data is asynchronous in
     * the same way that real requests are.
     *
     * # Sub-services
     * As `MDVLocationRequester` does not resolve the input itself, it uses a defined interface for
     * sub-services. These services provide a `search(input)` function that resolves the given input
     * to a plain list of {@link mng-model.object:MDVLocation MDVLocations}. Each service uses a
     * different kind of source for this resolution.
     * Each sub-service needs to implement the following interface structure to assure that it can
     * be attached to this service.
     *
     * ```js
     *   subservice.search = function (input) {  // {String|Number[]} name, coordinate
     *      // returns deferred that is resolved to a list of MDVLocations.
     *   }
     * ```
     *
     * See the {@link mng-comm.itd.xmljson.service:MDVEFAStopfinder MDVEFAStopfinder} service that
     * provides suggestions from an EFA interface.
     *
     * # Customization
     * The provided suggestion list can be customized in two ways, by the use of sub-services and by
     * the use of filters. The implementation of your custom sub-service is the best way to control
     * the suggestion-output. But this is also the way that takes the most effort, as you need to
     * provide your own back-end and your own services that care about requesting and parsing.
     *
     * The best way to customize the suggestion output is to use an already existing sub-service,
     * like the {@link mng-comm.itd.xmljson.service:MDVEFAStopfinder MDVEFAStopfinder} and customize
     * the output by the use of filters.
     * These filters can be configured in the MDVLocationRequester configuration and are called
     * sequentially, starting with the first position of the filter-array. This affects a
     * step-by-step filtering, like 'first sort by type, then by name, and after sorting append the
     * favorite locations on top of the list'.
     *
     * Filters can be used for three major operations: adding/ removing/ sorting the suggestion
     * list. As the suggestion list is passed to the regarding filter as an array, the list can be
     * customized by normal array operations.
     *
     * **Note:** *Filters can be added either in the DOM when assigning the suggestion list by the
     * ng-repeat directive or in the code. Adding these filters in the code ensures that the DOM
     * does not need to be modified each time a suggestion list is added.*
     *
     * ## Adding locations
     * To add locations at the beginning of the suggestion list, use JavaScript's {@link
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/unshift
     * unshift} method for arrays.
     * ```js
     * // add filter to the MDVLocationRequester configuration:
     * // filters : ['mdvAddFavorites']
     *
     * // filter definition
     * angular.module('mng-odv')
     *     .filter('mdvAddFavorites', mdvAddFavorites);
     *
     * mdvAddFavorites.$inject = ['mng-model.MDVLocation'];
     *
     * function mdvAddFavorites(MDVLocation) {
     *     return function (loc_list) {
     *         loc_list.unshift(new MDVLocation({
     *           id : 'locationId',
     *           name : 'my favorite location'
     *         }))
     *         return loc_list;
     *     };
     * }
     * ```
     *
     * ## Removing locations
     * To remove locations from the suggestion list, use JavaScript's {@link
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/splice
     * splice} method for arrays.
     *
     * ```js
     * // add filter to the MDVLocationRequester configuration:
     * // filters : ['mdvRemoveLowQualityLocations']
     *
     * // filter definition
     *  angular.module('mng-odv')
     *      .filter('mdvRemoveLowQualityLocations',  mdvRemoveLowQualityLocations);
     *
     *  function mdvRemoveLowQualityLocations() {
     *      return function (loc_list) {
     *          var i;
     *          for (i = loc_list.length - 1; i >= 0; i -= 1) {
     *              if (loc_list[i].quality() < 300) {
     *                  loc_list.splice(i, 1);
     *              }
     *          }
     *          return loc_list;
     *      };
     *  }
     * ```
     *
     * ## Sorting locations
     * The order of the array can also be modified by a filter. This can be done manually or by the
     * usage of AngularJs's built in {@link https://docs.angularjs.org/api/ng/filter/orderBy
     * orderBy} filter.
     *
     * ```js
     * // add filter to the MDVLocationRequester configuration:
     * // filters : ['mdvSortSugByDescription']
     *
     * // filter definition
     *  angular.module('mng-odv')
     *       .filter('mdvSortSugByDescription',  mdvSortSugByDescription);
     *
     *  mdvSortSugByDescription.$inject = ['$filter'];
     *
     *  function mdvSortSugByDescription($filter) {
     *      return function (loc_list) {
     *          return $filter('orderBy')(loc_list, 'description()');
     *      };
     *  }
     * ```
     *
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm.MDVLocationRequester` and interprets the following sub-keys:
     *
     * ## {Boolean} cache
     * Enables/ disables caching
     *
     * - true: cache all responses and return the cached values whenever the name is requested
     * again.
     *
     * - false: always send new requests whenever a name is provided.
     *
     * ## {String[]} subservices
     *
     * Service the auto-suggest object should use to get the list of stops. Right now, only the
     * sub-service-key 'mng-comm.itd.xmljson.MDVEFAStopfinder' is supported. In the future more
     * MDVLocationRequester sources should be implemented, like Google Places. The array describes a
     * fall back procedure. If the first element in the array does not provide an appropriate
     * response, the next sub-service is used to get a better result.
     *
     * The sub-service key needs to be exactly the name the service is assigned to. To resolve the
     * given name, AngularJs's {@link https://docs.angularjs.org/api/auto/service/$injector
     * $injector} service is used.
     *
     * ## {String[]} filters
     *
     * The resulting list can be modified by configured filters. The list is sequentially passed to
     * the filters, starting with the first position of the filters-array.
     * The filter key needs to be exactly the name the filter is assigned to. To resolve the given
     * name, AngularJs's {@link https://docs.angularjs.org/api/ng/filter/filter $filter} filter is
     * used. Please refer to the `Customization` section for more information about using filters.
     *
     *
     * ## Example:
     * ```js
     *   // configuration object
     *   ...
     *   "MDVLocationRequester" : {
     *      "cache": true,  // enable caching
     *      "subservices" : ["mng-comm.itd.xmljson.MDVEFAStopfinder"] // only use EFA sub-service,
     *      "filters" : ["mdvMockDataMatcher"]  // filter list by mdvMockDataMatcher-filter
     *   },
     *   ...
     * ```
     *
     * @example
<example module="MDVLocationRequesterExample">
<file name="index.html">
  <div ng-controller="SuggestController">
    <label>
        <input id="sug-input" ng-model="sugValue" placeholder="type name"/>
    </label>

    <div ng-show="result && result.length > 0">
        Suggestions found for input "{{sugValue}}":
       <ul id="sug-list"><li ng-repeat="point in result track by $index">{{point.name()}}</li></ul>
    </div>
  </div>
</file>
<file name="controller.js">
  // mng-comm.itd needs to be included to find mng-comm.itd.xmljson.MDVEFAStopfinder
  angular.module('MDVLocationRequesterExample', ['angularMoment', 'mng-comm', 'mng-comm.itd.xmljson'])
    .controller('SuggestController', SuggestController);


  // mng-config.MDVConfig normally needs not to be injected as the configuration is loaded by the
  // mng-config.MDVConfigFetcher
  SuggestController.$inject = ['$scope', 'mng-comm.MDVLocationRequester', 'mng-config.MDVConfig'];

  function SuggestController($scope, MDVLocationRequester, MDVConfig) {
      // input field
      $scope.sugValue = 'town';
      $scope.result = [];

      // set configuration. this is normally done by loading the Config with the
      // mng-config.MDVConfigFetcher
      MDVConfig.setValue('mng-comm.MDVLocationRequester', {
          'cache' : true,
          'subservices' : ['mng-comm.itd.xmljson.MDVEFAStopfinder'],
          'filter' : []
      });
      MDVConfig.setValue('mng-comm-itd.MDVEFARequester', {
          'url' : '/mngnsw'
      });
      MDVConfig.setValue('mng-comm-itd-xmljson.MDVEFAStopfinder', {
            url: '/XML_STOPFINDER_REQUEST?',
            defaultParams: {
                outputFormat: 'json',
                coordOutputFormat: 'EPSG:4326',
                anyObjFilter_sf: 2,
                odvSuggestMacro: 'beg',
                locationServerActive: 1,
                prMinQu: 1,
                type_sf: 'any',
                w_prefStModesAm: [3, 1],
                w_regPrefAl: 1
            }
      });

      // search for locations each time the input field value changes
      $scope.$watch('sugValue', function () {
          MDVLocationRequester.search($scope.sugValue)
              .then(function (data) {
                  // received list. append it to scope
                  $scope.result = data.response;
              })
              .catch(function (error) {
                  // something went wrong
                  $scope.result = [];
              })
      });
  };
</file>
</example>
     *
     */
     // <file name="protractor.js" >
     //   it('should init with "main" and empty list', function() {
     //     expect(element(by.id('sug-input')).getText()).toBe('main');
     //     // expect(element(by.id('sug-list')).children().length.toBe(0);
     //   });
     //   it('should update', function() {
     //     element(by.model('sugValue')).clear();
     //     element(by.model('sugValue')).sendKeys('town');
     //     expect(element(by.id('sug-input')).getText()).toBe('town');
     //   });
     // </file>
    angular.module('mng-comm')
        .factory('mng-comm.MDVLocationRequester', MDVLocationRequester);

    MDVLocationRequester.$inject = ['$filter', '$injector', 'mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-config.MDVConfig', 'mng-util.MDVException', 'mng-model.MDVLocation',
        'mng-model.MDVTransportation', 'mng-comm.MDVUtil'];

    function MDVLocationRequester($filter, $injector, MDVLog, MDVUtil, MDVConfig, MDVException,
            MDVLocation, MDVTransportation, MDVCommUtil) {
        var _private = {
                namespace : 'mng-comm.MDVLocationRequester',
                // cache for resolved requests
                cache : {},
                options : {},
                ready : false,
                // cache for current requests
                runningRequestCache : {}
            },
            log = MDVLog.register(_private.namespace),
            sf = {
                clearCache : clearCache,
                search : search,
                searchArea : searchArea,
                searchById : searchById,
                searchDestinations : searchDestinations
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @name clearCache
         * @ngdoc method
         * @methodOf mng-comm.service:MDVLocationRequester
         *
         * @description
         * Clear the temporary cache of the LocationRequester service, to force new requests to be
         * requested again.
         */
        function clearCache() {
            _private.cache = {};
            _private.runningRequestCache = {};
        }
        /**
         * @public
         * @name search
         * @ngdoc method
         * @methodOf mng-comm.service:MDVLocationRequester
         * @param {String|Number[]} input Name that should be resolved to a suggestion list. It is
         * also possible to pass a coordinate (Format: [lat, lng]). Please refer to the
         * options.coordFormat for further detail on the coordinate input. The provided
         * input is directly passed to the sub-service's implementation of `search(input)`.
         * @param {Object=} [options={}] Options object to change the service to request in its
         * default way.
         * @param {String=} options.coordFormat format-code the given coordinate is passed with. If
         * no coordFormat is passed, the plugin assumes that the coordinate format is EPSG:4326
         * (WGS84).
         * @returns {Promise} Returns a {@link https://docs.angularjs.org/api/ng/service/$q
         * `Promise`} that will be resolved to response object when the suggestion list is available
         * or an error occurred. The response has the following parameters:
         * - input: {Object[]} list of inputs that were used for requesting the response.
         * - response: {@link mng-model.object:MDVLocation MDVLocations[]} list of MDVLocation objects
         * where each of the locations describe a single suggestion.
         *
         * @description
         * Resolve a input to a list of {@link mng-model.object:MDVLocation MDVLocations} by the use
         * of a configured sub-service. If configured, the response is cached and reused whenever
         * the same name is provided again. If no cached value is available, the sub-service is
         * called.
         */
        function search(input, options) {
            if (!input) {
                return MDVUtil.getRejectedDeferred(
                                         new MDVException(MDVException.keys.MNG_COMM__LS.NO_INPUT));
            }
            if (!MDVConfig.isReady()) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                            'without a valid configuration.'
                    }));
            }
            var func = _private.getSearchFunction(input, options);

            if (!func) {
                return MDVUtil.getRejectedDeferred(
                                    new MDVException(MDVException.keys.MNG_COMM__LS.INVALID_INPUT));
            }
            if (_private.hasCache(options, input)) {
                return MDVUtil.getResolvedDeferred(
                      _private.modifyResponse(_private.getCache([input, options]), [options, input]));
            }

            return _private.sendRequest([MDVUtil.copy(options), input], func);
        }

        /**
         * @public
         * @name searchArea
         * @ngdoc method
         * @methodOf mng-comm.service:MDVLocationRequester
         * @param {Number[]} inputa Coordinate to define the center coord (if inputb is a radius) or
         * to define the top left corner of a passed bounding box (if inputb is also a coordinate).
         * @param {Number|Number[]} inputb Coordinate or radius
         * @param {Object=} [options={}] Options object to change the service to request in its
         * default way.
         * @param {String=} options.coordFormat format-code the given coordinate is passed with. If
         * no coordFormat is passed, the plugin assumes that the coordinate format is EPSG:4326
         * (WGS84).
         * @param {String[]=} options.types List of types that should be requested in this
         * area. Valid options are:
         * <ul>
         * <li>'aoi', area of interest</li>
         * <li>'gis_area'</li>
         * <li>'gis_point'</li>
         * <li>'platform'</li>
         * <li>'poi', point of interest</li>
         * <li>'stop' (default)</li>
         * </ul>
         * @returns {Promise} Returns a {@link https://docs.angularjs.org/api/ng/service/$q
         * `Promise`} that will be resolved to response object when the suggestion list is available
         * or an error occurred. The response has the following parameters:
         * - input: {Object[]} list of inputs that were used for requesting the response.
         * - response: {@link mng-model.object:MDVLocation MDVLocations[]} list of MDVLocation objects
         * where each of the locations describe a single suggestion.
         *
         * @description
         * Resolve a given area to a list of {@link mng-model.object:MDVLocation MDVLocations} by
         * the use of a configured sub-service. If configured, the response is cached and reused
         * whenever the same area is provided again. If no cached value is available, the
         * sub-service is called.
         */
        function searchArea(inputa, inputb, options) {
            if (!inputa || !inputb) {
                return MDVUtil.getRejectedDeferred(
                                         new MDVException(MDVException.keys.MNG_COMM__LS.NO_INPUT));
            }
            if (!MDVConfig.isReady()) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'Configuration has not yet loaded correctly. Cannot start ' +
                            'requests without a valid configuration.'
                    }));
            }
            var func = _private.getSearchAreaFunction(inputa, inputb, options);

            if (!func) {
                return MDVUtil.getRejectedDeferred(
                                    new MDVException(MDVException.keys.MNG_COMM__LS.INVALID_INPUT));
            }
            if (_private.hasCache(options, inputa, inputb)) {
                return MDVUtil.getResolvedDeferred(_private.modifyResponse(
                            _private.getCache([inputa, inputb, options]), [options, inputa, inputb]));
            }
            // valid input and not cached -> send request
            return _private.sendRequest([MDVUtil.copy(options), inputa, inputb], func);
        }

        /**
         * @public
         * @name searchById
         * @ngdoc method
         * @methodOf mng-comm.service:MDVLocationRequester
         * @param {String=} id the location id that should be used to fetch additional sharing
         * informations.
         * @param {Object=} [options={}] Options object to change the service to request in its
         * default way.
         *
         * @returns {Promise} Returns a {@link https://docs.angularjs.org/api/ng/service/$q
         * `Promise`} that will be resolved to response object when the suggestion list is available
         * or an error occurred. The response has the following parameters:
         * - input: {Object[]} list of inputs that were used for requesting the response.
         * - response: {@link mng-model.object:MDVLocation MDVLocations[]} list of MDVLocation objects
         * where each of the locations describe a single suggestion.
         *
         * @description
         * Fetch additional sharing informations for a giving location id.
         */
        function searchById(id, options) {
            if (!id) {
                return MDVUtil.getRejectedDeferred(
                                         new MDVException(MDVException.keys.MNG_COMM__LS.NO_INPUT));
            }
            if (!MDVConfig.isReady()) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                            'without a valid configuration.'
                    }));
            }
            var func = _private.getSearchByIdFunction(id, options);

            if (!func) {
                return MDVUtil.getRejectedDeferred(
                                    new MDVException(MDVException.keys.MNG_COMM__LS.INVALID_INPUT));
            }
            if (_private.hasCache(options, id)) {
                return MDVUtil.getResolvedDeferred(
                      _private.modifyResponse(_private.getCache([id, options]), [options, id]));
            }

            return _private.sendRequest([MDVUtil.copy(options), id], func);
        }

        /**
         * @public
         * @name searchDestinations
         * @ngdoc method
         * @methodOf mng-comm.service:MDVLocationRequester
         * @param {MDVLocation} location from which all destinations should be available with one
         * single transportation
         * @param {Object=} [options={}] Options object to change the service to request in its
         * default way.
         *
         * @returns {Promise} Returns a {@link https://docs.angularjs.org/api/ng/service/$q
         * `Promise`} that will be resolved to response object when the destinations are available
         * or an error occurred. The response has the following parameters:
         * - input: {Object[]} list of inputs that were used for requesting the response.
         * - response: {Object} an object with two lists. one list, with the key 'stops', describes
         * all stops that are in reach of the specific location, a second list, with the key
         * 'localities' describes all localities that are in reach of the specific location. Both
         * lists contain {@link mng-model.object:MDVLocation MDVLocations MDVLocations}.
         *
         * @description
         * Get all stops and localities that are in reach of a certain location.
         */
        function searchDestinations(location, options) {
            if (!location) {
                return MDVUtil.getRejectedDeferred(
                                         new MDVException(MDVException.keys.MNG_COMM__LS.NO_INPUT));
            }
            if (!MDVConfig.isReady()) {
                return MDVUtil.getRejectedDeferred(
                    new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                            'without a valid configuration.'
                    }));
            }

            return _private.sendRequest([MDVUtil.copy(options), location], 'searchForDestinations');
        }

        // ////////////////////////////////

        _private.getDefaultConfigOption = function(key) {
            var defConfig = {
                subservices : ['mng-comm.itd.json.MDVEFAStopfinder', 'mng-comm.itd.json.MDVEFACoord',
                    'mng-comm.itd.json.MDVEFAStopSequence', 'mng-comm.itd.json.MDVEFADestForStop'],
                cache : false
            };

            if (!key) {
                return defConfig;
            }
            if (defConfig.hasOwnProperty(key)) {
                return defConfig[key];
            }
            return null;
        };

        _private.getConfigOption = function(key) {
            var configVal = MDVConfig.getValue(_private.namespace + '.' + key);

            if (!configVal) {
                return _private.getDefaultConfigOption(key);
            }
            return configVal;
        };

        _private.isCacheActive = function() {
            if (_private.getConfigOption('cache') === false) {
                return false;
            }
            // true, or not defined (-> default to true)
            return true;
        };

        _private.addCache = function(arglist, response) {
            var cacheKey;

            if (_private.isCacheActive() && arglist && arglist.length > 0 && response) {
                cacheKey = _private.getCacheKey(arglist);
                if (_private.cache.hasOwnProperty(cacheKey)) {
                    log.info('cache element overridden by new response');
                }
                _private.cache[cacheKey] = response;
            }
        };

        _private.getCache = function(arglist) {
            if (!_private.isCacheActive()) {
                return [];
            }
            var cacheKey = _private.getCacheKey(arglist);

            if (cacheKey && _private.cache.hasOwnProperty(cacheKey)) {
                return _private.cache[cacheKey];
            }
            return [];
        };

        _private.getCacheKey = function(arglist) {
            if (!arglist || arglist.length === 0) {
                return null;
            }
            return JSON.stringify(arglist);
        };

        _private.getSearchAreaFunction = function(inputa, inputb) {
            if (!MDVUtil.isValidCoordinate(inputa)) {
                return null;
            }
            if (typeof inputb === 'number') {
                return 'searchByRadius';
            }
            if (MDVUtil.isValidCoordinate(inputb)) {
                return 'searchByBoundingBox';
            }
            return null;
        };

        _private.getSearchByIdFunction = function() {
            return 'searchBySharingRefId';
        };

        _private.getSearchFunction = function(input) {
            if (typeof input === 'string' || input instanceof String) {
                return 'searchByName';
            }
            if (MDVUtil.isValidCoordinate(input)) {
                return 'searchByCoordinate';
            }
            if (input instanceof MDVLocation) {
                return 'searchForStructure';
            }
            if (input instanceof MDVTransportation) {
                return 'searchForStopOvers';
            }
            return null;
        };

        _private.hasCache = function(options, input, inputb) {
            if (!_private.isCacheActive()) {
                return false;
            }
            var cacheKey;

            if (inputb) {
                cacheKey = _private.getCacheKey([input, inputb, options]);
            } else {
                cacheKey = _private.getCacheKey([input, options]);
            }

            return Boolean(cacheKey) && _private.cache.hasOwnProperty(cacheKey);
        };

        _private.isValidSubservice = function(subservice, function_name) {
            return subservice && subservice.hasOwnProperty(function_name);
        };

        _private.modifyResponse = function(response, arglist) {
            var filtered_list = angular.extend([], response),
                filters = MDVConfig.getValue('mng-comm.MDVLocationRequester.filters', arglist[0]) || [],
                filter,
                i,
                l;

            for (i = 0, l = filters.length; i < l; i += 1) {
                filter = $filter(filters[i]);
                if (filter) {
                    filtered_list = filter(filtered_list);
                }
            }

            return {
                input : arglist,
                response : filtered_list
            };
        };

        _private.getSubserviceConfig = function() {
            return _private.getConfigOption('subservices');
        };

        _private.isRunningRequest = function(function_name, arglist) {
            return Boolean(_private.getRunningRequest(function_name, arglist));
        };
        _private.getRunningRequestKey = function(function_name, arglist) {
            var list = [function_name].concat(arglist);

            return _private.getCacheKey(list);
        };
        _private.getRunningRequest = function(function_name, arglist) {
            var key = _private.getRunningRequestKey(function_name, arglist);

            if (_private.runningRequestCache.hasOwnProperty(key)) {
                return _private.runningRequestCache[key];
            }
            return null;
        };
        _private.setRunningRequest = function(function_name, arglist, deferred) {
            var key = _private.getRunningRequestKey(function_name, arglist);

            _private.runningRequestCache[key] = deferred;
        };
        _private.removeRunningRequest = function(function_name, arglist) {
            var key = _private.getRunningRequestKey(function_name, arglist);

            delete _private.runningRequestCache[key];
        };

        _private.sendRequest = function(arglist, function_name, prio) {
            if (!arglist || arglist.length < 1) {
                return MDVUtil.getRejectedDeferred(
                                         new MDVException(MDVException.keys.MNG_COMM__LS.NO_INPUT));
            }
            if (_private.isRunningRequest(function_name, arglist)) {
                return _private.getRunningRequest(function_name, arglist);
            }
            var subservices = _private.getSubserviceConfig(),
                argumentList = angular.copy(arglist),
                subservice,
                requestDeferred;

            // rearrange argumentList, otherwise problem with search/searchArea mixup
            argumentList.push(argumentList.shift());

            try {
                subservice = MDVCommUtil.getSubservice(subservices, prio, null,
                    MDVException.keys.MNG_COMM__LS);
            } catch (e) {
                if (prio) {
                    throw e;
                }
                return MDVUtil.getRejectedDeferred(e);
            }

            // extra check as multiple subservice types are possible
            if (!_private.isValidSubservice(subservice, function_name)) {
                return _private.sendRequest(arglist, function_name, prio ? prio + 1 : 1);
            }

            requestDeferred = subservice[function_name].apply(undefined, argumentList)
                .then(function(response) {
                    if (!response) {
                        // resend request with lower priority
                        throw new MDVException(MDVException.keys.MNG_COMM__LS.SERVICE_FAILED, {
                            args : arglist,
                            service : subservice.name,
                            reason : 'no results'
                        });
                    }
                    _private.addCache(arglist, response);
                    _private.removeRunningRequest(function_name, arglist);

                    return _private.modifyResponse(response, arglist);
                })
                .catch(function() {
                    _private.removeRunningRequest(function_name, arglist);
                    // resend request with lower priority
                    return _private.sendRequest(arglist, function_name, prio ? prio + 1 : 1);
                });

            _private.setRunningRequest(function_name, arglist, requestDeferred);

            return requestDeferred;
        };

        // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
        // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
        MDVConfig.ready(function() {
            if (_private.getConfigOption('privateMode') === true) {
                sf._private = _private;
            }
        });

        return sf;
    }
}());

(function() {
    'use strict';
    /**
     * @ngdoc overview
     * @name mng-comm.itd
     * @module mng-comm.itd
     * @requires mng-config
     * @requires mng-util
     *
     * @description
     * # mng-comm.itd (main EFA communication module)
     * This module provides the communication to the EFA interface and the
     * corresponding parser methods to convert the EFA responses to the abstract model.
     *
     * ## General usage
     * ```js
     * // inject mng-comm.itd - components only
     * angular.module('your.module', ['mng-comm.itd']);
     * ```
     *
     * The following list gives a short overview of the available components within this module.
     * For further details, please refer to the components themselves.
     *
     * ## general EFA services
     * These services are used by the other components of this module to ensure a unique handling of
     * specific use cases.
     *
     * ### {@link mng-comm.itd.service:MDVEFAFormatter MDVEFAFormatter}
     * The `MDVEFAFormatter` provides a collection of utility functions for converting EFA input to
     * normalized input.
     *
     * ### {@link mng-comm.itd.service:MDVEFARequester MDVEFARequester}
     * The `MDVEFARequester` combines all EFA Requests to one single interface to ensure that the
     * EFA communication can be controlled/ monitored in a single part of code. This is done by
     * deriving from this Service and calling its request method.
     *
     */
    angular.module('mng-comm.itd', ['mng-config', 'mng-util']);
}());

/* eslint max-lines: ["warn", 1000]*/
(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.service:MDVEFAOptionsParser
     * @requires moment
     * @requires mng-util.service:MDVLog
     * @requires mng-util.service:MDVUtil
     *
     * @description
     * The `MDVEFAOptionsParser` takes care of parsing abstract {@link mng-comm.object:MDVOptions
     * MDVOptions} to a set of EFA parameters. This assures that the EFA services are completely
     * encapsulated as the top layer services do not need to know about the specific EFA
     * terminology.
     *
     * The following table states how every abstract {@link mng-comm.object:MDVOptions MDVOption}
     * is translated to be accepted by EFA.
     *
     * Array values are usually sent as multiple parameters with the same key, but with the
     * different values as single value.
     *
     * example=['x1', 'x2'] =>  'example=x1&example=x2'
     *
     * <table>
     * <tr>    <th>group</th>       <th>abstract option</th>  <th>efa parameter</th>      <th></th></tr>
     * <tr><td><b>accessibility</b></td> <td></td> <td>imparedOptionsActive=1</td> <td>whenever an option
     * is activated</td></tr>
     * <tr><td></td>   <td>accessibleVehiclesOnly</td> <td>wheelchair=1</td>    <td></td></tr>
     * <tr><td></td>   <td>escalators=false</td> <td>noEscalators=1</td>    <td></td></tr>
     * <tr><td></td>   <td>elevators=false</td> <td>noElevators=1</td>    <td></td></tr>
     * <tr><td></td> <td>stairs=false</td> <td>noSolidStairs=1</td> <td></td></tr>
     * <tr><td></td> <td>lowFloorVehiclesOnly</td> <td>lowPlatformVhcl=1</td> <td></td></tr>
     * <tr><td></td>   <td></td> <td></td>    <td></td></tr>
     *
     * <tr><td><b>dateTime</b></td>    <td></td> <td></td>    <td></td></tr>
     * <tr><td></td>   <td>date</td> <td>itdDate</td> <td>minds dateTime.dateFormat</td></tr>
     * <tr><td></td>         <td>time</td> <td>itdTime</td> <td>minds dateTime.timeFormat</td></tr>
     * <tr><td></td><td>isDeparture=false</td><td>itdDateTimeDepArr=arr,itdTripDateTimeDepArr=arr</td>
     * <td></td></tr>
     * <tr><td></td> <td>useRealTime/useRealtime</td> <td>useRealTime</td> <td></td></tr>
     * <tr><td></td>   <td></td> <td></td>    <td></td></tr>
     *
     * <tr><td><b>fare</b></td>    <td></td> <td></td>    <td></td></tr>
     * <tr><td></td>   <td>avoidZones</td> <td>ptOptionsActive=1; avoidTariffZoneActive=1;
     * avoidTariffZone=options.avoidZones;</td>    <td>avoidTariffZone = [] is resolved to a
     * multiple get parameter with one zone each</td></tr>
     * <tr><td></td>   <td></td> <td></td>    <td></td></tr>
     *
     * <tr><td><b>individualTransport</b></td> <td></td> <td>itOptionsActive=1</td>    <td>whenever an option
     * is activated</td></tr>
     * <tr><td></td> <td>avoidElevation=false</td> <td>useElevationData=1</td> <td></td></tr>
     * <tr><td></td> <td>cycleSpeed</td> <td>cycleSpeed</td> <td></td></tr>
     * <tr><td></td>   <td>minutes</td> <td>trIT<modus>MOTvalue</td> <td>see modus of "type"</td></tr>
     * <tr><td></td>   <td>type</td> <td>trIT<modus>MOT=x</td> <td>depends on modus. Modus can be
     * either Dep or Arr, or defaults to '', which effects both.</td></tr>
     * <tr><td></td> <td>walkSpeed</td> <td>changeSpeed</td> <td></td></tr>
     * <tr><td></td> <td></td> <td></td> <td></td></tr>
     *
     * <tr><td><b>information</b></td> <td></td> <td>filterPublicationStatus=current</td>
     * <td>every time</td></tr>
     * <tr><td>information.include</td> <td></td> <td></td> <td></td></tr>
     * <tr><td></td> <td>allLines</td> <td>filterShowLineList=x</td> <td>x=1 if true, 0 otherwise</td></tr>
     * <tr><td></td> <td>allPlaces</td> <td>filterShowPlaceList</td> <td>x=1 if true, 0 otherwise</td></tr>
     * <tr><td></td> <td>allStops</td> <td>filterShowStopList</td> <td>x=1 if true, 0 otherwise</td></tr>
     * <tr><td></td> <td></td> <td>AIXMLReduction=[x]</td> <td>x=set of strings described below
     * this row, whenever the corresponding value is set false</td></tr>
     * <tr><td></td> <td>creationTime=false</td> <td>removeCreationTime</td> <td></td></tr>
     * <tr><td></td> <td>expirationTime=false</td> <td>removeExpirationTime</td> <td></td></tr>
     * <tr><td></td> <td>lines=false</td> <td>removeLines</td> <td></td></tr>
     * <tr><td></td> <td>modificationTime=false</td> <td>removeLastModificationTime</td> <td></td></tr>
     * <tr><td></td> <td>properties=false</td> <td>removeGenericParams</td> <td></td></tr>
     * <tr><td></td> <td>publicationPeriod=false</td> <td>removePublication</td> <td></td></tr>
     * <tr><td></td> <td>source=false</td> <td>removeSourceSystem</td> <td></td></tr>
     * <tr><td></td> <td>stops=false</td> <td>removeStops</td> <td></td></tr>
     * <tr><td></td> <td>validityPeriod=false</td> <td>removeValidity</td> <td></td></tr>
     * <tr><td>information.filter</td> <td></td> <td></td> <td></td></tr>
     * <tr><td></td> <td>date</td> <td>filterDateValid</td> <td></td></tr>
     * <tr><td></td> <td>validity</td> <td></td> <td>only used if from and to value are set</td></tr>
     * <tr><td></td> <td>validity.from</td> <td>filterValidIntervalStart</td> <td></td></tr>
     * <tr><td></td> <td>validity.to</td> <td>filterValidIntervalEnd</td> <td></td></tr>
     * <tr><td></td> <td>iconIds</td> <td>filterProductID</td> <td>only if iconIds is a list</td></tr>
     * <tr><td></td> <td>informationTypes</td> <td>filterInfoType</td> <td>only if informationTypes is a list</td></tr>
     * <tr><td></td> <td>informationSubTypes</td> <td>filterMessageSubtype</td> <td></td></tr>
     * <tr><td></td> <td>lineNames</td> <td>filterPublicLineName</td> <td>only if lineNames is a list</td></tr>
     * <tr><td></td> <td>priorities</td> <td>filterPriority</td> <td>only if priorities is a list</td></tr>
     * <tr><td></td> <td>productClasses</td> <td>filterMOTType</td> <td>only if productClasses is a list</td></tr>
     * <tr><td></td> <td>stopIds</td> <td>itdLPxx_selStop</td> <td>only if stopIds is a list</td></tr>
     * <tr><td></td> <td>lineIds</td> <td>filterPNLineDir</td> <td>only if lineId is a list</td></tr>
     * <tr><td></td> <td></td> <td></td> <td></td></tr>
     *
     * <tr><td><b>lineRestrictions</b></td> <td></td> <td>ptOptionsActive=1</td>    <td>whenever an option
     * is activated</td></tr>
     * <tr><td></td> <td>restriction=0</td> <td>lineRestriction=400</td> <td>restriction value + 400</td></tr>
     * <tr><td></td> <td></td> <td></td> <td></td></tr>
     *
     * <tr><td><b>pdfOutput</b></td> <td></td> <td>outputOptionsActive=1;descWithElev=1;</td>    <td>whenever an option
     * is activated</td></tr>
     * <tr><td></td> <td>elevationProfile=false</td> <td>noElevationProfile=1</td> <td></td></tr>
     * <tr><td></td> <td>elevationSummary=false</td> <td>noElevationSummary=1</td> <td></td></tr>
     * <tr><td></td> <td></td> <td></td> <td></td></tr>
     *
     * <tr><td><b>personalSchedule</b></td> <td></td> <td>outputOptionsActive=1;descWithElev=1;</td>    <td>whenever an option
     * is activated</td></tr>
     * <tr><td></td> <td>date='now'</td> <td>noElevationProfile=1</td> <td></td></tr>
     * <tr><td></td> <td>days=null</td> <td>noElevationSummary=1</td> <td></td></tr>
     * <tr><td></td> <td>enableReturnTrip=false</td> <td>noElevationSummary=1</td> <td></td></tr>
     * <tr><td></td> <td>outwardFrom='07:00'</td> <td>noElevationSummary=1</td> <td></td></tr>
     * <tr><td></td> <td>outwardTo='09:00'</td> <td>noElevationSummary=1</td> <td></td></tr>
     * <tr><td></td> <td>returnFrom='17:00'</td> <td>noElevationSummary=1</td> <td></td></tr>
     * <tr><td></td> <td>returnTo='19:00'</td> <td>noElevationSummary=1</td> <td></td></tr>
     * <tr><td></td> <td></td> <td></td> <td></td></tr>
     *
     * </table>
     *
     */
    angular.module('mng-comm.itd')
        .factory('mng-comm.itd.MDVEFAOptionsParser', MDVEFAOptionsParser);

    MDVEFAOptionsParser.$inject = ['moment', 'mng-util.MDVLog', 'mng-util.MDVUtil'];

    function MDVEFAOptionsParser(moment, MDVLog, MDVUtil) {
        var log = MDVLog.register('mng-comm.itd.MDVEFAOptionsParser'),
            ops = {
                parse : parse,
                _handleDate : handleDate,
                _handleTime : handleTime,
                _parse_accessibility : _parse_accessibility,
                _parse_dateTime : _parse_dateTime,
                _parse_departures : _parse_departures,
                _parse_destinations : _parse_destinations,
                _parse_fare : _parse_fare,
                _parse_individualTransport : _parse_individualTransport,
                _parse_information : _parse_information,
                _parse_lineRestrictions : _parse_linerestrictions,
                _parse_pdfOutput : _parse_pdfOutput,
                _parse_personalSchedule : _parse_personalSchedule,
                _parse_productRestrictions : _parse_productRestrictions,
                _parse_publicTransport : _parse_publicTransport,
                _parse_sharing : _parse_sharing,
                _parse_via : _parse_via,
            },
            keyMotMap = {
                train : 0,
                commuter : 1,
                subway : 2,
                lightRail : 3,
                tram : 4,
                bus : 5,
                regionalBus : 6,
                coach : 7,
                cableCar : 8,
                ferry : 9,
                demandTaxi : 10,
                other : 11,
                plain : 12,
                localTrain : 13,
                nationalTrain : 14,
                internationalTrain : 15,
                highspeedTrain : 16,
                railReplacement : 17,
                railShuttle : 18,
                citizenBus : 19
            },
            itTypeMotMap = {
                'walk' : 100,
                'bikeAndRide' : 101,
                'bikeOnTrain' : 102,
                'kissAndRide' : 103,
                'parkAndRide' : 104,
                'taxi' : 105,
                'car' : 106,
                'bike' : 107
            },
            optTypeMap = {
                comfortable : 'comfortable',
                economic : 'economic',
                cost : 'leastcost',
                costex : 'leastcostex',
                interchange : 'leastinterchange',
                time : 'leasttime',
                walking : 'leastwalking',
                nighttrain : 'nighttrain',
                reliable : 'reliable'
            },
            reductionMap = {
                creationTime : 'removeCreationTime',
                expirationTime : 'removeExpirationTime',
                lines : 'removeLines',
                modificationTime : 'removeLastModificationTime',
                properties : 'removeGenericParams',
                publicationPeriod : 'removePublication',
                source : 'removeSourceSystem',
                stops : 'removeStops',
                validityPeriod : 'removeValidity'
            },
            changeSpeedRegEx = /^(slow|normal|fast)$/;

        log.debug('initialize');

        // ////////////////////////////////
        function parse(options) {
            var result = {},
                key,
                parseFunc;

            if (!options) {
                return result;
            }

            // use passed efaParams as basic object to ensure the other options can override the
            // values if needed.
            result = MDVUtil.copy(options.efaParams || {});

            for (key in options) {
                if (options.hasOwnProperty(key) && key !== 'efaParams') {
                    parseFunc = '_parse_' + key;

                    if (this.hasOwnProperty(parseFunc)) {
                        result = this[parseFunc](result, options[key]);
                    } else {
                        log.warn('unknown and ignored MDVOptions for mng-comm-itd-xmljson: ' + key);
                    }
                }
            }

            return result;
        }

        function handleDate(date, dateFormat) {
            return handleDateTime({
                date : date,
                dateFormat : dateFormat
            }, 'date');
        }
        function handleTime(time, timeFormat) {
            return handleDateTime({
                time : time,
                timeFormat : timeFormat
            }, 'time');
        }

        function handleDateTime(options, dateTime) {
            var dateVal = options[dateTime],
                format = options[dateTime + 'Format'],
                outputFormat = (dateTime === 'date')? 'YYYYMMDD' : 'HHmm',
                result;

            if (!dateVal || dateVal === 'now') {
                // use EFA default if no date or 'now' is passed
                return null;
            }
            if (dateVal instanceof Date) {
                result = moment(dateVal);
            }
            if (!result) {
                // date is no moment object
                result = format ? moment(dateVal, format) : moment(dateVal);
            } // else: date is already a moment object, no need to check dateFormat

            if (result.isValid && !result.isValid()) {
                // give it a very last try without format
                result = moment(dateVal);
            }

            if (result.isValid()) {
                return result.format(outputFormat);
            } // else fallback to now
            return null;
        }

        function _parse_dateTime(dest, options) {
            var currVal;

            currVal = handleDateTime(options, 'date');
            if (currVal) {
                dest.itdDate = currVal;
            }
            currVal = handleDateTime(options, 'time');
            if (currVal) {
                dest.itdTime = currVal;
            }

            if (isBoolFalse(options.isDeparture)) {
                dest.itdDateTimeDepArr = 'arr';
                dest.itdTripDateTimeDepArr = 'arr';
            }  // else ignore as it's 'departure' per default

            // check if we want to search for the First/Last Journey
            if (isBoolFalse(!options.isFirstLast)) {
                dest.calcMonoTrip = 0;
                dest.calcNumberOfTrips = 1;
                dest.noAlt = 1;
            }
            if (options.hasOwnProperty('useRealTime')) {
                dest.useRealtime = (options.useRealTime)? 1 : 0;
            } else if (options.hasOwnProperty('useRealtime')) {
                dest.useRealtime = (options.useRealtime)? 1 : 0;
            }

            return dest;
        }

        function parseDestLimit(list, globalOnly) {
            var i, l, curr,
                result = [];

            for (i = 0, l = list.length; i < l; i += 1) {
                curr = list[i];
                if (curr.properties().stopId) {
                    if (globalOnly) {
                        result.push(curr.id());
                    }
                } else if (!globalOnly) {
                    result.push(curr.id());
                }
            }
            return result;
        }

        function _parse_departures(dest, options) {
            var curr;

            if (isBoolFalse(options.isDeparture)) {
                dest.routeFilterPrevious = 1;
            }

            if (options.limitStops && options.limitStops.length) {
                curr = parseDestLimit(options.limitStops, false);
                if (curr && curr.length) {
                    dest.destStopFilter = curr;
                }
            }
            if (options.limitStops && options.limitStops.length) {
                curr = parseDestLimit(options.limitStops, true);
                if (curr && curr.length) {
                    dest.destGlobalStopFilter = curr;
                }
            }
            if (options.limitLocalities && options.limitLocalities.length) {
                curr = parseDestLimit(options.limitLocalities, false);

                if (curr && curr.length) {
                    dest.destLocalityFilter = curr;
                }
            }

            return dest;
        }

        function _parse_destinations(dest, options) {
            if (isBoolFalse(options.includeStops)) {
                dest.includeStops = 0;
            }

            if (isBoolFalse(options.includeLocalities)) {
                dest.includePlaces = 0;
            } else {
                dest.includePlaces = 1;
            }

            if (isBoolFalse(options.isDeparture)) {
                dest.destType = 'ORIGINS';
            }

            if (options.limitAccessible) {
                dest.accessible = 1;
            }

            if (options.limitResult) {
                dest.max = options.limitResult;
            }

            if (options.limitTime) {
                dest.searchWindow = options.limitTime;
            }

            if (options.limitLocality) {
                dest.destLocalityFilter = options.limitLocality;
            }

            return dest;
        }

        function _parse_personalSchedule(dest, options) {
            dest.itdTime_arrFrom = handleTime(options.outwardFrom, options.timeFormat);
            dest.itdTime_arrTo = handleTime(options.outwardTo, options.timeFormat);
            if (options.enableReturnTrip) {
                dest.itdTime_depFrom = handleTime(options.returnFrom, options.timeFormat);
                dest.itdTime_depTo = handleTime(options.returnTo, options.timeFormat);
            }
            if (options.days) {
                switch (options.days) {
                case 'mon-fr':
                    dest.psParamWeekday = '8:MO-FR';
                    break;
                case 'sa':
                    dest.psParamWeekday = '6:SAMSTAG';
                    break;
                case 'so':
                    dest.psParamWeekday = '10:SONNTAG';
                    break;
                default:
                    dest.psParamSampleDate = handleDateTime(options, 'date');
                }
            } else {
                dest.psParamSampleDate = handleDateTime(options, 'date');
            }

            if (!dest.psParamSampleDate && !dest.psParamWeekday) {
                dest.psParamSampleDate = moment().format('YYYYMMDD');
            }

            dest.useRealtime = 1;
            if (!options.enableReturnTrip) {
                dest.psParamOneWay = 1;
            }

            return dest;
        }

        function _parse_productRestrictions(dest, options) {
            var key,
                motList;

            if (options.velocMode) {
                // veloc parsing
                motList = [];
                for (key in options) {
                    if (options.hasOwnProperty(key) && key !== 'velocMode') {
                        if (options[key] === true) {
                            motList.push(keyMotMap[key]);
                        }
                    }
                }
                if (motList.length > 0) {
                    dest.MOTCode = motList.toString();
                }
            } else {
                // normal productRestrictions
                for (key in options) {
                    if (options.hasOwnProperty(key) && isBoolFalse(options[key])) {
                        dest.excludedMeans = 'checkbox';
                        if (keyMotMap.hasOwnProperty(key)) {
                            dest['exclMOT_' + keyMotMap[key]] = 1;
                        } else {
                            log.error('invalid key for keyMotMap: ' + key);
                        }
                    }
                }
            }
            return dest;
        }

        function _parse_individualTransport(dest, options) {
            if (options.hasOwnProperty('from') && options.hasOwnProperty('to')) {
                dest = parseSingleIndividual(dest, options.from, 'Arr');
                return parseSingleIndividual(dest, options.to, 'Dep');
            }
            return parseSingleIndividual(dest, options);
        }

        function handleWalkSpeed(dest, options) {
            if (options.walkSpeed) {
                if ((typeof options.walkSpeed === 'string' ||
                        options.walkSpeed instanceof String) &&
                            options.walkSpeed.match(changeSpeedRegEx)) {
                    dest.changeSpeed = options.walkSpeed;
                } else {
                    log.warn('invalid walkSpeed parameter passed (' + options.walkSpeed + '). ' +
                        'Valid values: "slow", "normal" and "fast". Used default.');
                }
            }
            return dest;
        }

        function parseSingleIndividual(dest, options, modus) {
            if (!modus) {
                modus = '';
            }
            dest.itOptionsActive = 1;

            if (options.type && itTypeMotMap.hasOwnProperty(options.type)) {
                dest['trIT' + modus + 'MOT'] = itTypeMotMap[options.type];
            }
            if (options.minutes) {
                dest['trIT' + modus + 'MOTvalue'] = options.minutes;
            }
            dest = handleWalkSpeed(dest, options);
            if (options.cycleSpeed) {
                dest.cycleSpeed = options.cycleSpeed;
            }
            if (options.avoidElevation) {
                dest.useElevationData = 1;
            }
            return dest;
        }

        function _parse_publicTransport(dest, options) {
            dest.ptOptionsActive = 1;

            if (options.routingOptimization &&
                    optTypeMap.hasOwnProperty(options.routingOptimization)) {
                dest.routeType = optTypeMap[options.routingOptimization];
            }
            if (options.bikeTakeAlong) {
                dest.bikeTakeAlong = 1;
            }
            if (options.maxInterchanges || options.maxInterchanges === 0) {
                if (options.maxInterchanges <= 0) {
                    dest.maxChanges = 0;
                } else if (options.maxInterchanges > 9) {
                    dest.maxChanges = 9;
                } else if (options.maxInterchanges !== 9) {
                    // correct value, add it to options
                    dest.maxChanges = options.maxInterchanges;
                } // else maxInterchanges === 9 -> do nothing as it is default
            }
            if (!isBoolFalse(options.allowNearbyStops)) {
                dest.useProxFootSearch = 1;
            }
            return dest;
        }

        function _parse_fare(dest, options) {
            if (options.avoidZones && options.avoidZones.length) {
                dest.ptOptionsActive = 1;
                dest.avoidTariffZoneActive = 1;
                dest.avoidTariffZone = options.avoidZones;
            }
            return dest;
        }

        function _parse_accessibility(dest, options) {
            var accessibilityProfileArray = ['wheelchair', 'buggy', 'blind' ];
            if (isBoolFalse(options.stairs)) {
                dest.imparedOptionsActive = 1;
                dest.noSolidStairs = 1;
            }
            if (isBoolFalse(options.escalators)) {
                dest.imparedOptionsActive = 1;
                dest.noEscalators = 1;
            }
            if (isBoolFalse(options.elevators)) {
                dest.imparedOptionsActive = 1;
                dest.noElevators = 1;
            }
            if (options.lowFloorVehiclesOnly) {
                dest.imparedOptionsActive = 1;
                dest.lowPlatformVhcl = 1;
            }
            if (options.accessibleVehiclesOnly) {
                dest.imparedOptionsActive = 1;
                // dest.wheelchair = 1;
                dest.noSolidStairs = 1;
                dest.noEscalators = 1;
                dest.startEndAtAccessAreas = 1;
            }
            if (options.showAccessibility) {
                dest.imparedOptionsActive = 1;
                dest.showInterchanges = 1;
            }
            if (options.profileOptimisation) {
                if (typeof options.profileOptimisation === 'string' && accessibilityProfileArray.includes(options.profileOptimisation)) {
                    switch(options.profileOptimisation) {
                        case '':
                            break;
                        case 'wheelchair':
                            dest.stepVehicleMaxHeight = 50;
                            dest.noSolidStairs = 1;
                            dest.noEscalators = 1;
                            break;
                        case 'buggy':
                            dest.stepVehicleMaxHeight = 100;
                            dest.noSolidStairs = 1;
                            dest.noEscalators = 1;
                            break;
                        case 'blind':
                            dest.needTactileGuidance = 1;
                            break;
                        default:
                    }
                    dest.accessProfile = 1;
                } else {
                    log.warn('invalid accessability profile parameter passed (' + options.profileOptimisation + '). ' +
                        'Valid values: "wheelchair", "buggy" and "blind". Used default.');
                }
            }
            if (typeof options.testStrictMode !== undefined) {
                dest.strictMode = +options.testStrictMode;
            }
            if (typeof options.testTactileGuidance !== undefined) {
                if (options.testTactileGuidance) {
                    dest.accessProfile = 1;
                    dest.needTactileGuidance = 1;
                }
            }
            if (typeof options.testSufficientPlatformWidth !== undefined) {
                if (options.testSufficientPlatformWidth) {
                    dest.accessProfile = 1;
                }
                dest.wheelchairSpaceStop = +options.testSufficientPlatformWidth;
            }
            if (options.testStepVehicleMaxHeight && options.testStepVehicleMaxHeight.on) {
                if (+options.testStepVehicleMaxHeight.value) {
                    dest.stepVehicleMaxHeight = +options.testStepVehicleMaxHeight.value;
                    dest.accessProfile = 1;

                }
            }
            if (options.testStepFromStreet && options.testStepFromStreet.on) {
                if (+options.testStepFromStreet.value) {
                    dest.stepMaxHeight = +options.testStepFromStreet.value;
                    dest.accessProfile = 1;
                }
            }
            return dest;
        }

        function _parse_linerestrictions(dest, options) {
            if (options.restriction !== 0) {
                dest.ptOptionsActive = 1;
                dest.lineRestriction = options.restriction + 400;
            }
            return dest;
        }

        function _parse_sharing(dest, options) {
            if (!options.enabled) {
                return dest;
            }
            dest.computationType = 'multimodal';
            if (options.callabike) {
                dest.callabike = true;
            }
            if (options.nextbike) {
                dest.nextbike = true;
            }
            if (options.car2go) {
                dest.car2go = true;
            }
            if (options.flinkster) {
                dest.flinkster = true;
            }
            if (options.stadtmobil) {
                dest.stadtmobil = true;
            }
            return dest;
        }

        function _parse_pdfOutput(dest, options) {
            if (isBoolFalse(options.elevationProfile)) {
                dest.outputOptionsActive = 1;
                dest.descWithElev = 1;
                dest.noElevationProfile = 1;
            }
            if (isBoolFalse(options.elevationSummary)) {
                dest.outputOptionsActive = 1;
                dest.descWithElev = 1;
                dest.noElevationSummary = 1;
            }
            return dest;
        }

        function _parse_via(dest, options) {
            if (options.optionsList && options.optionsList.length>0) {
                var optionItem,
                    keySuffix,
                    obj,
                    i,
                    l,
                    isOnlyOneItem = (options.optionsList.length === 1);

                for (i = 0, l = options.optionsList.length; i < l; i += 1) {
                    optionItem = options.optionsList[i];
                    keySuffix = (optionItem.enabled?'_via':'_notVia').concat(isOnlyOneItem?'':i+1);
                    obj = {};

                    if (optionItem.name) {
                        obj['name'.concat(keySuffix)] = optionItem.name;
                        obj['type'.concat(keySuffix)] = optionItem.type;
                        obj.dwellTimeMinutes = optionItem.dwellTime;

                        angular.extend(dest, obj);
                    }
                }
                if (!isOnlyOneItem) {
                    dest.computationType = 'SEQUENCEEX';
                }
            }
            return dest;
        }

        function _parse_inclusion_options(dest, options) {
            var key,
                reductionList = [];

            for (key in options) {
                if (options.hasOwnProperty(key)) {
                    if (reductionMap.hasOwnProperty(key) && !options[key]) {
                        // do not include elements
                        reductionList.push(reductionMap[key]);
                    } else if (key === 'allLines') {
                        dest.filterShowLineList = (options[key] === true) ? 1 : 0;
                    } else if (key === 'allStops') {
                        dest.filterShowStopList = (options[key] === true) ? 1 : 0;
                    } else if (key === 'allPlaces') {
                        dest.filterShowPlaceList = (options[key] === true) ? 1 : 0;
                    } // else: include them (nothing to do for it)
                }
            }
            if (reductionList.length > 0) {
                dest.AIXMLReduction = reductionList;
            }

            return dest;
        }

        function isArrayProperty(object, key) {
            return object[key] &&
                    object[key].constructor === Array &&
                    object[key].length > 0;
        }

        function getDateValues(timevalues) {
            var result = [],
                curr,
                i, l;

            for (i = 0, l = timevalues.length; i < l; i += 1) {
                curr = getTimeValue(timevalues[i]);

                if (curr) {
                    result.push(curr);
                }
            }

            return result;
        }
        function getTimeValue(timeval, includeTime) {
            if (!timeval) {
                return null;
            }
            if (timeval.constructor === Array) {
                return getDateValues(timeval, includeTime);
            }

            var format = includeTime? 'DD_MM_YYYY_HH_mm' : 'DD_MM_YYYY';

            if (timeval === 'now') {
                return moment().format(format);
            }
            timeval = moment(timeval);
            if (timeval.isValid && timeval.isValid()) {
                return timeval.format(format);
            }
            return null;
        }

        function lineId2PNLineDir(id) {
            if (!id) {
                return null;
            }
            // split id in parts: partial net, diva line, supplement, direction, project
            var parts = id.split(':'),
                interestingParts = [];

            // select pn, line and direction
            interestingParts.push(parts[0]);
            interestingParts.push(parts[1]);
            interestingParts.push(parts[3]);

            return interestingParts.join(':');
        }

        function parsePNLineDirs(idList) {
            var result = [],
                curr, i, l;

            for (i = 0, l = idList.length; i < l; i += 1) {
                curr = lineId2PNLineDir(idList[i]);
                if (curr) {
                    result.push(curr);
                }
            }
            return result;
        }
        function _parse_filter_validity_option(dest, options) {
            var from, to;

            if (options.validity) {
                from = getTimeValue(options.validity.from, options.validity.timeEnabled);
                to = getTimeValue(options.validity.to, options.validity.timeEnabled);
            }

            if (from && to) {
                dest.filterValidIntervalStart = from;
                dest.filterValidIntervalEnd = to;
            }

            return dest;
        }
        function _parse_filter_options(dest, options) {
            var date = getTimeValue(options.date);

            if (date) {
                dest.filterDateValid = date;
            }

            dest = _parse_filter_validity_option(dest, options);

            if (isArrayProperty(options, 'iconIds')) {
                dest.filterProductID = options.iconIds;
            }
            if (isArrayProperty(options, 'ids')) {
                dest.filterInfoID = options.ids;
            }
            if (isArrayProperty(options, 'informationTypes')) {
                dest.filterInfoType = options.informationTypes;
            }
            if (isArrayProperty(options, 'informationSubTypes')) {
                dest.filterMessageSubtype = options.informationSubTypes;
            }
            if (isArrayProperty(options, 'lineNames')) {
                dest.filterPublicLineName = options.lineNames;
            }
            if (isArrayProperty(options, 'priorities')) {
                dest.filterPriority = options.priorities;
            }
            if (isArrayProperty(options, 'productClasses')) {
                dest.filterMOTType = options.productClasses;
            }
            if (isArrayProperty(options, 'stopIds')) {
                dest.itdLPxx_selStop = options.stopIds;
            }
            if (isArrayProperty(options, 'lineIds')) {
                dest.filterPNLineDir = parsePNLineDirs(options.lineIds);
            }
            return dest;
        }

        function _parse_information(dest, options) {
            // only request recent information, ignore 'historical' ones
            dest.filterPublicationStatus = 'current';

            if (options.include) {
                dest = _parse_inclusion_options(dest, options.include);
            }
            if (options.filter) {
                dest = _parse_filter_options(dest, options.filter);
            }
            return dest;
        }

        function isBoolFalse(value) {
            return !value && typeof value === 'boolean';
        }

        return ops;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.service:MDVEFARequester
     * @requires mng-util.service:MDVLog
     * @requires mng-config.service:MDVConfig
     * @requires mng-util.object:MDVException
     *
     * @description
     * The `MDVEFARequester`-factory combines all EFA Requests to a single interface to ensure
     * the EFA communication can be controlled/ monitored at one single part of code. This is done
     * by deriving from this service and calling its request method.
     *
     * # General usage
     * To derive from this service, a new instance needs to be registered by a constructor call.
     * The constructor needs two keys as parameters:
     *
     * - **{String} module**: Request module-key the deriving class is about. This module key is used to
     * fetch the corresponding configuration from the {@link mng-config.service:MDVConfig MDVConfig}
     * service. This configuration is used to create an individual requester instance that is
     * returned. If no configuration is available, null is returned.
     *
     * - **{String} subtype**: Request subtype-key the deriving class is about. This subtype key is
     * used to fetch the corresponding configuration from the {@link mng-config.service:MDVConfig
     * MDVConfig} service. This configuration is used to create an individual requester instance
     * that is returned. If no configuration is available, null is returned.
     *
     * This instance can be used to send the requests by passing additional request parameters.
     *
     * ```js
     * // create a new requester instance with the configuration from 'mng-comm-itd-xmljson.MDVEFADM'
     * var request_service = new MDVEFARequester('mng-comm-itd-xmljson', 'MDVEFADM');
     * // send a "DM"-request
     * request_service.request({
     *    // "DM" dynamic parameters
     *    name_dm : 'town',
     *    type_dm : 'any'
     *  }).then(function successCallback(response) {
     *      // this callback will be called asynchronously
     *      // when the response is available
     *  });
     * ```
     *
     * # Mocking
     * This general request service also takes care of mocking requests. Whenever configured,
     * matching dynamical request strings (or all request strings when a 'default'-mock is
     * configured) are resolved by the provided mock file instead of sending a request to the
     * backend.
     *
     * # Configuration
     * This service uses the {@link mng-config.service:MDVConfig MDVConfig} service to load its
     * configuration during runtime. It uses the configuration defined with the key
     * `mng-comm-itd.MDVEFARequester` and additional configurations for the module, and the service
     * the requester-object is initialized with.
     *
     * ## mng-comm-itd.MDVEFARequester
     * The following configuration values can be set for the MDVEFARequester service:
     *
     * ### {String} url
     * URL all EFA requests are sent to.
     *
     * ### {Boolean} mockEnabled *(optional, default: false)*
     * Enable/Disable mocking for all EFA sub-requests at once. Should be set to true in DEV-mode,
     * productive systems should set this parameter to false to avoid any inadvertant side effects.
     * - true: mocks enabled. Every sub-request is allowed to mock.
     * - false: no mocks are used and every request is sent normally.
     * **Note:** *This flag cannot be changed dynamically. This flag needs to be defined on startup.
     * This behavior prevents productive systems from any inadvertant side effects and unnecessary
     * configuration checks*
     *
     * ## additional module parameters
     * These parameters can be set for a complete module group (like mng-comm-itd-xmljson)
     *
     * ### {Object} defaultParams *(optional, default: {})*
     * Set of default parameters that should be sent with every EFA request, regardless of the type.
     * This set should contain global parameters like coordOutputFormat only. Request
     * specific parameters should be added in the regarding request rubric.
     *
     * ## additional service parameters
     * Next to the MDVEFARequester configuration and the module configuration, an additional
     * configuration for every deriving service can be defined with the following parameters:
     *
     * ### {String} url
     * This parameter describes the sub-url that is appended to the `MDVEFARequester` url.
     *
     * ### {Object} defaultParams *(optional, default: {})*
     * A set of default parameters that are sent with the derived service only. These parameters
     * extend (and override) the defaultParams defined in the module.
     * It needs to contain correct EFA-formatted key-value pairs.
     *
     * ### {Boolean} mockEnabled *(optional, default: false)*
     * Flag to enable/disable mocking for this deriving service. This flag is only read when the
     * `mockEnabled`-flag is set `true`.
     * - true: mocks enabled for this single deriving service.
     * - false: no mocks are used and every request is sent normally for this deriving service.
     *
     * ### {String} mockDir *(Optional unless `mockEnabled` is set `true`)*
     * This parameter describes the directory where all mocks for the deriving service are in.
     * The directory path can contain a '%s' placeholder that is replaced by the specific filename
     * that is provided in the `mocks`-object.
     *
     * ### {Object} mocks *(Optional unless `mockEnabled` is set `true`)*
     * Each key-value pair describes a single mock file. The key describes the dynamic part of the
     * specific deriving service (e.g. `name_sf=town`). To provide a global mock for all kind of
     * dynamic values, use the `default`-key.
     * The value describes the replacement string that should be inserted in the `mockDir`
     * value.
     *
     * # Example
     *
     * The following code describes the configuration for the example above.
     *
     * ```js
     *   // configuration object
     *   ...
     *   "mng-comm.itd" : {
     *       MDVEFARequester : {
     *           url: '/virtualEFAdir',
     *           mockEnabled: false
     *       }
     *   },
     *   'mng-comm-itd-xmljson' : {
     *       defaultParams: {
     *           outputFormat: 'json',
     *           coordOutputFormat: 'EPSG:4326'
     *       },
     *       MDVEFADM: {
     *           url: '/XML_DM_REQUEST?',
     *           defaultParams: {
     *               mode: 'direct',
     *               type_dm: 'any'
     *           },
     *           mockEnabled : true,
     *           mockDir : '/app/mocks/%.mock.json',
     *           mocks : {
     *              'default' : 'defaultFile'
     *           }
     *       },
     *    ...
     *   },
     * ```
     *
     * Whenever the request function of the `request_service` is called, a request is sent with
     * the predefined parameters (followed by the dynamical ones)
     *
     * ```js
     * /virtualEFAdir/XML_DM_REQUEST?outputFormat=json&coordOutputFormat=EPSG:4326&mode=direct&type_dm=any
     * ```
     * As `mockEnabled` is set to `false` in the `MDVEFARequester` configuration, the mocking
     * configuration in the `MDVEFADM` service has no effect. If `mockEnabled` would be set `true`
     * every request sent with the `request_service` would be loaded with the static response stored
     * as json file at '/app/mocks/defaultFile.mock.json'.
     *
     */


    angular.module('mng-comm.itd')
        .factory('mng-comm.itd.MDVEFARequester', MDVEFARequester);

    MDVEFARequester.$inject = ['$http', '$window', 'mng-util.MDVLog', 'mng-util.MDVUtil',
        'mng-config.MDVConfig', 'mng-util.MDVException'];

    function MDVEFARequester($http, $window, MDVLog, MDVUtil, MDVConfig, MDVException) {
        var configNotReadyException = new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                reason : 'Configuration has not yet loaded correctly. Cannot start requests ' +
                    'without a valid configuration.'
            }),
            recentRequests = [],
            req = requesterFunction;

        MDVConfig.ready(function() {
            if (!MDVConfig.getValue('mng-comm-itd.MDVEFARequester.avoidGlobalProperty')) {
                // enable access to recent request outside of the modules
                // this is neccessary to provide a simple bookmark that resends the last requests.
                if (!$window.mentzAngular) {
                    $window.mentzAngular = {};
                }
                $window.mentzAngular.getRecentRequests = function() {
                    return MDVUtil.copy(recentRequests);
                };
            }
        });

        function requesterFunction(type, subtype, defOptions) {
            var log = MDVLog.register('mng-comm.itd.MDVEFARequester/' + type + '/' + subtype),
                _private = {
                    namespace : type,
                    className : subtype,
                    fullName : type + '.' + subtype,
                    ready : false
                };

            log.debug('initialized');

            if (!_private.namespace) {
                log.error('tried to instanciate Request Module without namespace');
                return null;
            }
            if (!_private.className) {
                log.error('tried to instanciate Request Module without subtype');
                return null;
            }

            _private.updateOptions = function() {
                var requesterConfig = MDVConfig.getValue('mng-comm-itd.MDVEFARequester') || {},
                    namespaceConfig = {
                        defaultParams : MDVConfig.getValue(_private.namespace + '.defaultParams') || {}
                    },
                    mainConfig = MDVConfig.getValue(_private.fullName) || {};

                _private.options = angular.merge({}, defOptions || {}, mainConfig);
                _private.namespaceDefParams = angular.merge({}, namespaceConfig.defaultParams);
                _private.requesterOptions = MDVUtil.copy(requesterConfig);
            };

            _private.updateAndListen = function() {
                _private.ready = true;
                _private.updateOptions();
                // update options each time, the config is ready again
                MDVConfig.ready(null, true).then(function() {
                    _private.updateOptions();
                }, null, function() {
                    _private.updateOptions();
                });
            };

            // update options, whenever MDVConfig is ready
            MDVConfig.ready(_private.updateAndListen);

            // check if the basic information is available and log warnings if they are not
            _private.isReady = function() {
                var reasons = [];

                if (!_private.ready) {
                    reasons.push(configNotReadyException);

                    return reasons;
                }

                if (!_private.options.url) {
                    reasons.push(new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'No specific URL for EFA ' + _private.fullName +
                            ' defined. Please check your configuration.'
                    }));

                    if (!_private.requesterOptions.url) {
                        reasons.push(new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                            reason : 'No URL for EFA defined. Please check your configuration.'
                        }));
                    }
                }
                return reasons;
            };

            _private.getHttpMethod = function() {
                var httpMethod;

                if (_private.options.requestType) {
                    httpMethod = _private.options.requestType;
                } else {
                    httpMethod = _private.requesterOptions.requestType;
                }
                if (!httpMethod) {
                    log.debug('no requestType is defined. Fallback to $http.get');
                    httpMethod = 'get';
                }
                if (!$http.hasOwnProperty(httpMethod) || typeof $http[httpMethod] !== 'function') {
                    log.warn('configured requestType is not available: ' + httpMethod +
                        '. Fallback to $http.get');
                    httpMethod = 'get';
                }
                return httpMethod;
            };


        //    /**
        //     * @private
        //     * @ngdoc method
        //     * @name getComplexParams
        //     * @description
        //     * Check if the config is complex and return the desired one
        //     * @methodOf mng-comm.itd.service:MDVEFARequester
        //     * @param {object} params object contains all parameters fetched from config.
        //     * @param String key is an optional key for the desired parmeters
        //     * @returns {object} params object of params.
        //     */
            _private.getComplexParams = function(params, key) {
                if (!params) {
                    return {};
                }
                if (key && params.hasOwnProperty(key)) {
                    return params[key];
                }
                // fallback to default
                if (params.hasOwnProperty('')) {
                    return params[''];
                }
                return params;
            };

            _private.getRequestParams = function(params, defParamKey) {
                var final_params = {},
                    key,
                    def_params;

                // use namespace default parameters as base
                for (key in _private.namespaceDefParams) {
                    if (_private.namespaceDefParams.hasOwnProperty(key)) {
                        final_params[key] = _private.namespaceDefParams[key];
                    }
                }
                // override namespace default parameters with request default parameters
                def_params = _private.getComplexParams(_private.options.defaultParams, defParamKey);
                for (key in def_params) {
                    if (def_params.hasOwnProperty(key)) {
                        final_params[key] = def_params[key];
                    }
                }
                // override default parameters with dynamic parameters
                for (key in params) {
                    if (params.hasOwnProperty(key)) {
                        final_params[key] = params[key];
                    }
                }
                return final_params;
            };
            _private.getBaseUrl = function() {
                var mainUrl = _private.options.mainUrl || 'url';

                if (!_private.requesterOptions.hasOwnProperty(mainUrl)) {
                    log.warn('unknown mainUrl configuration. Fallback to default url');
                    mainUrl = 'url';
                }
                return _private.requesterOptions[mainUrl];
            };

            _private.getMainUrl = function() {
                var base = _private.getBaseUrl();

                base += _private.options.url || '';

                if (base.slice(-1) === '?') {
                    return base.slice(0, -1);
                }

                return base;
            };

            _private.formatReqParam = function(key, value) {
                var result;

                if (value.constructor === Array) {
                    result = '';
                    angular.forEach(value, function(elem) {
                        result += '&' + key + '=' + elem;
                    });
                    return result;
                }
                return '&' + key + '=' + value;
            };

            _private.formatReqParamList = function(params) {
                var result = 'default';

                if (params) {
                    result = '?';
                    angular.forEach(params, function(value, key) {
                        if (key && (value || value === 0)) {
                            result += _private.formatReqParam(key, value);
                        }
                    });
                }
                return result;
            };

            _private.getRequestUrl = function(params, defParamKey) {
                var final_params = _private.getRequestParams(params, defParamKey);

                return _private.getMainUrl() +     // http://efa.customer.de:8123/virDir/TYPE_REQUEST
                        _private.formatReqParamList(final_params); // &name_orig=A&name_dest=B
            };

            // build your own request url - debug purpose only
            _private.getMockUrl = function(mock_params) {
                var mockDir = _private.options.mockDir,
                    params = _private.formatReqParamList(mock_params),
                    mockFile = _private.options.mocks[params];

                if (!mockDir) {
                    throw new MDVException(MDVException.keys.MNG__PROGRAMM.INVALID_CONFIG, {
                        reason : 'mockDir not defined for ' + _private.fullName
                    });
                }
                if (!mockFile) {
                    mockFile = _private.options.mocks.default;
                }

                if (!mockFile) {
                    return null;
                }

                return mockDir.replace('%s', mockFile);
            };

            _private.trackRequest = function(response) {
                if (!response || !response.config) {
                    return;
                }
                recentRequests.push(response.config.url + '?' +
                    response.config.paramSerializer(response.config.params));
            };

            _private.on_success = function(response, requestVersion) {
                if (!response.data) {
                    log.warn('request successful, but no data');
                    return {};
                }
                if (response.data.version && requestVersion) {
                    // rapid json response
                    if (response.data.error && response.data.error.versions) {
                        log.error(response.data.error, true);
                        throw new MDVException(MDVException.keys.MNG__REQUESTS.REQUEST_FAILED, {
                            reason : 'modules do not work with EFA version ' +
                                response.data.error.versions.controller + ', ' +
                                response.data.error.message + '. Requested version: ' +
                                requestVersion + '.',
                            error : response.data.error
                        });
                    }

                    if (response.data.version !== requestVersion) {
                        // should never happen, but who knows...
                        throw new MDVException(MDVException.keys.MNG__REQUESTS.REQUEST_FAILED, {
                            reason : 'invalid response version',
                            requestVersion : requestVersion,
                            responseVersion : response.data.version
                        });
                    }
                }

                log.debug('request successful');
                return response.data;
            };
            _private.on_error = function(error) {
                if (!error) {
                    error = {};
                }
                throw new MDVException(MDVException.keys.MNG__REQUESTS.REQUEST_FAILED, {
                    reason : error.data,
                    status : error.status,
                    statusText : error.statusText
                });
            };

            _private.handleMock = function(params, defParamKey) {
                var that = this,
                    url;

                if (!_private.requesterOptions.mockEnabled || !_private.options.mockEnabled) {
                    return null;
                }

                // fill in mock data url
                url = _private.getMockUrl(params);
                if (!url) {
                    log.warn('no valid mock url configuration. send normal request instead');
                    return null;
                }

                log.info('use ' + url + ' to mock request: ' +
                    _private.getRequestUrl(params, defParamKey, true));

                return $http.get(url)
                    .then(function(response) {
                        return _private.on_success.call(that, response);
                        // use this line to check for versions when using mock files
                        // return _private.on_success.call(this, response, params.version);
                    })
                    .catch(_private.on_error.bind(this));
            };

            _private.getCacheOption = function() {
                return _private.options.cache || false;
            };

            return {
                isReady : _private.isReady,

                /**
                 * @public
                 * @ngdoc method
                 * @methodOf mng-comm.itd.service:MDVEFARequester
                 * @name request
                 *
                 * @description
                 * Basic request function. Sends the http request with all default parameters + the
                 * given dynamic ones. Catches Errors that are caused due to the basic http request
                 * and resolves the deferred with the response-data without basic http-data like
                 * status-code or http-instance.
                 *
                 * @param {Object} params Key-Value pairs of parameters that should be appended
                 * to the default request url
                 * @param {String} defParamKey optional key for configured def parameters
                 * @param {Object} requestConfig configuration object for $http request
                 * @returns {Promise} Promise that is resolved to the request-response.
                 */
                request : function(params, defParamKey, requestConfig) {
                    if (!_private.ready) {
                        return MDVUtil.getRejectedDeferred(configNotReadyException);
                    }
                    var that = this,
                        url,
                        req_params,
                        version = params.version,
                        httptype,
                        reasons,
                        mock = _private.handleMock.call(this, params, defParamKey);

                    if (mock) {
                        return mock;
                    }

                    reasons = _private.isReady();
                    if (reasons.length > 0) {
                        return MDVUtil.getRejectedDeferred(reasons[0]);
                    }

                    httptype = _private.getHttpMethod();

                    url = _private.getMainUrl();

                    if ((httptype === 'post') || (httptype === 'patch')) {
                        // ignore req_params, as given params is object that should be posted
                        return $http[httptype](url, params, requestConfig)
                            .then(function(response) {
                                return _private.on_success.call(that, response, version);
                            })
                            .catch(_private.on_error.bind(this));
                    }
                    // EFAF-9488
                    // new endpoint expects the lineId (passed to this function as param) to be in the body
                    if (httptype === 'delete') {
                        return $http[httptype](url, {data: params, headers: requestConfig.headers})
                            .then(function(response) {
                                return _private.on_success.call(that, response, version);
                            })
                            .catch(_private.on_error.bind(this));
                    }

                    req_params = _private.getRequestParams(params, defParamKey);

                    log.debug('request parameters for ' + url + ' :');
                    log.debug(req_params, true);

                    if (!requestConfig) {
                        requestConfig = {};
                    }
                    requestConfig.params = req_params;
                    requestConfig.cache = _private.getCacheOption();

                    return $http[httptype](url, requestConfig)
                        .then(function(response) {
                            _private.trackRequest(response);

                            return _private.on_success(response, version);
                        })
                        .catch(_private.on_error.bind(this));
                }
            };
        }

        return req;
    }
}());

(function() {
    'use strict';
    /**
     * @version 0.9.4
     * @ngdoc service
     * @name mng-comm.itd.service:MDVEFAFormatter
     * @requires mng-util.service:MDVLog
     * @requires mng-util.service:MDVUtil
     * @requires mng-util.object:MDVException
     *
     * @description
     * The `MDVEFAFormatter` provides a collection of utility functions for converting EFA input to
     * normalized input.
     *
     * The provided functions are only used by services of the {@link mng-comm.itd  mng-comm.itd}
     * module as they are specialized for formatting EFA response values or formatting
     * normalized values to EFA http parameter formats.
     */
    angular.module('mng-comm.itd')
        .factory('mng-comm.itd.MDVEFAFormatter', MDVEFAFormatter);

    MDVEFAFormatter.$inject = ['moment', 'mng-util.MDVLog', 'mng-config.MDVConfig',
        'mng-util.MDVUtil', 'mng-util.MDVException'];

    function MDVEFAFormatter(moment, MDVLog, MDVConfig, MDVUtil, MDVException) {
        var log = MDVLog.register('mng-comm.itd.MDVEFAFormatter'),
            _private = {

            },
            formatter = {
                // Coordinates
                str2latlng : str2latlng,
                str2latlngPath : str2latlngPath,
                stringPaths2LatLngArray : stringPaths2LatLngArray,
                latlng2string : latlng2string,
                // Date
                dateTime2moment : dateTime2moment,
                date2moment : date2moment,
                moment2efaDate : moment2efaDate,
                moment2efaTime : moment2efaTime,
                strDuration2Minutes : strDuration2Minutes,
                // General
                translate : translate,
                parseGenAttrs : parseGenAttrs,
                getStopGlobalMap : getStopGlobalMap,
                combineWalkLegs : combineWalkLegs
            },
            defaultTrans = {
                // MOTs
                TRAIN : 'train',
                COMMUTER : 'commuter',
                SUBWAY : 'subway',
                LIGHTRAIL : 'light rail',
                TRAM : 'tram',
                BUS : 'bus',
                REGIONALBUS : 'regional bus',
                COACH : 'coach',
                CABLECAR : 'cable car',
                FERRY : 'ferry',
                DEMANDTAXI : 'taxi on demand',
                OTHER : 'other',
                PLAIN : 'plain',
                LOCALTRAIN : 'local train',
                NATIONALTRAIN : 'national train',
                INTERNATIONALTRAIN : 'international train',
                HIGHSPEEDTRAIN : 'highspeed train',
                RAILREPLACEMENT : 'rail replacement',
                RAILSHUTTLE : 'rail shuttle',
                CITIZENBUS : 'citizen bus',
                // MODES
                WAIT : 'wait',
                TRANSFER : 'transfer',
                STAYSEATED : 'stay seated',
                SAVECONNECTION : 'save connection',
                FOOTPATH : 'footpath',
                BIKEANDRIDE : 'bike&ride',
                BIKE : 'bike',
                CAR : 'car',
                TAXI : 'taxi',
                // PLACEHOLDER
                UNKNOWN_POINT : 'unknown point',
                MID : ' Middle',
                END : ' End',
                SOUTH : ' South',
                WEST : ' West',
                NORTH : ' North',
                EAST : ' East',
                SPACER : ' '
            };

        log.debug('initialize');

        // ////////////////////////////////

        /**
         * @public
         * @ngdoc method
         * @name str2latlng
         * @methodOf mng-comm.itd.service:MDVEFAFormatter
         *
         * @description
         * Convert a coordinate string to a coordinate array.
         *
         * @param {String} coord_str String that should be converted. Format: "lng,lat".
         * The string can provide an optional z-value: "lng,lat,z".
         * @returns {Number[]} Coordinate object with the parsed values [lat, lng (, z)]. Please
         * note the reversed order of latitude and longitude.
         */
        function str2latlng(coord_str) {
            if (!coord_str || coord_str.constructor !== String || coord_str.indexOf(',') < 0) {
                log.warn('str2latlng : invalid coord string for conversion ' +
                    (coord_str && coord_str.constructor));
                return [];
            }
            var coord_elems = coord_str.split(','),
                result = [];

            if (coord_elems.length > 3) {
                log.warn('str2latlng : too many coord values in given coord string');
                return result;
            }
            try {
                result.push(Number(coord_elems[1]));
                result.push(Number(coord_elems[0]));
                if (coord_elems.length === 3) {
                    result.push(Number(coord_elems[2]));
                }
            } catch (e) {
                log.warn('str2latlng : coords could not be parsed - ' + e.message);
                if (result.length < 2) {
                    return [];
                }
            }
            return result;
        }
        /**
         * @ngdoc method
         * @name str2latlngPath
         * @description
         * Convert a string of path coordinates to an array of coordinate objects.
         * @public
         * @methodOf mng-comm.itd.service:MDVEFAFormatter
         * @param {String} coord_path_str String that should be converted. The coordinates
         * need to be separated by a space. Format: "lng1,lat1 lng2,lat2".
         * @returns {Object[]} List of coordinate objects
         * @see MDVEFAFormatter.str2latlng
         */
        function str2latlngPath(coord_path_str) {
            if (!coord_path_str ||
                    coord_path_str.constructor !== String ||
                    coord_path_str.indexOf(' ') < 0) {
                log.warn('str2latlngPath : invalid coord path string for conversion');
                return [];
            }
            var coord_path_elems = coord_path_str.split(' '),
                result = [];

            angular.forEach(coord_path_elems, function(coord_str) {
                var coord = str2latlng(coord_str);

                if (coord.length >= 2) {
                    result.push(coord);
                }
            });
            return result;
        }
        /**
         * @ngdoc method
         * @name stringPath2LatLngArray
         * @description
         * Convert an array of string paths to an array of latlng paths.
         * @public
         * @methodOf mng-comm.itd.service:MDVEFAFormatter
         * @param {Array} stringPaths path strings that should be converted
         * @return {Array} latlng paths
         * @see MDVEFAFormatter.str2latlngPath
         */
        function stringPaths2LatLngArray(stringPaths) {
            var paths = [];

            angular.forEach(stringPaths, function(path) {
                var latlngpath = formatter.str2latlngPath(path);

                if (latlngpath) {
                    paths.push(latlngpath);
                }
            });
            return paths;
        }

        _private.getCoordFormat = function(format) {
            if (format) {
                return format;
            }
            // return 'EPSG:4326';
            return 'WGS84[dd.ddddd]';
        };
        /**
         * @public
         * @ngdoc method
         * @methodOf mng-comm.itd.service:MDVEFAFormatter
         * @name latlng2string
         * @param {Number[]} input Coordinate in [lat, lng] or {"lat": lat, "lng": lng} format
         * @param {String=} format coordinate format the input is passed with. Defaults to
         * 'WGS84[DD.DDDDD]'
         * @return {String} coordinate string that can be passed to the EFA
         *
         * @description
         * Convert a given input coordinate to a EFA coordiante string.
         */
        function latlng2string(input, format) {
            if (!input) {
                return '';
            }
            if (input.lat && input.lng) {
                // leaflet latlng object
                return input.lng + ':' + input.lat + ':' + _private.getCoordFormat(format);
            }
            if (input.constructor === Array && input.length >= 2) {
                // coordinate array
                return input[1] + ':' + input[0] + ':' + _private.getCoordFormat(format);
            }
            return '';
        }

        /**
         * @public
         * @ngdoc method
         * @methodOf mng-comm.itd.service:MDVEFAFormatter
         * @name dateTime2moment
         * @param {Object} dateTime EFA dateTime Object containing date and time, or
         * year, month, day, hour and minute
         * @returns {moment} moment object
         *
         * @description
         * Convert an EFA dateTime Object to a moment object.
         */
        function dateTime2moment(dateTime) {
            var date = null;

            if (!dateTime) {
                return date;
            }
            if (dateTime.date && dateTime.time) {
                // 29.03.2016-15:10
                date = moment(dateTime.date + '-' + dateTime.time, 'DD.MM.YYYY-hh:mm');
            } else {
                date = moment(dateTime.year + '-' + dateTime.month + '-' + dateTime.day + '-' +
                    dateTime.hour + ':' + dateTime.minute, 'YYYY-MM-DD-hh:mm');
            }
            if (!date.isValid()) {
                throw new MDVException(MDVException.keys.MNG__REQUESTS.INVALID_DATA, {
                    data : dateTime,
                    expected : 'object with date=DD.MM.YYYY and time=hh:mm properties, or object ' +
                        'with year=YYYY, month=MM, day=DD, hour=hh, minute=mm properties'
                });
            }
            return date;
        }

        /**
         * @public
         * @ngdoc method
         * @methodOf mng-comm.itd.service:MDVEFAFormatter
         * @name date2moment
         * @param {String} dateStr EFA date
         * @param {String} [dateFormat='YYYYMMDD'] EFA date format
         * @param {Boolean} [tolerant=false] True: Ignore invalid dateStr and return null if it
         * can not be parsed. False: throw error if invalid dateStr is passed (default)
         * @returns {moment} moment object
         *
         * @description
         * Convert an EFA date String to a moment object.
         */
        function date2moment(dateStr, dateFormat, tolerant) {
            if (!dateFormat) {
                dateFormat = 'YYYYMMDD';
            }
            if (!dateStr) {
                return null;
            }
            var date = moment(dateStr, dateFormat);

            if (!date.isValid()) {
                if (tolerant) {
                    date = null;
                } else {
                    throw new MDVException(MDVException.keys.MNG__REQUESTS.INVALID_DATA, {
                        data : dateStr,
                        expected : 'YYYYMMDD'
                    });
                }
            }

            return date;
        }
        /**
         * @public
         * @ngdoc method
         * @methodOf mng-comm.itd.service:MDVEFAFormatter
         * @name moment2efaDate
         * @param {moment} momentElem object
         * @returns {string} A formated date-string that can be interpreted by the EFA
         *
         * @description
         * Converts a given moment object to a valid EFA-date formatted string.
         */
        function moment2efaDate(momentElem) {
            return momentElem.format('YYYYMMDD');
        }
        /**
         * @public
         * @ngdoc method
         * @methodOf mng-comm.itd.service:MDVEFAFormatter
         * @name moment2efaTime
         * @param {moment} momentElem object
         * @returns {string} A formated time-string that can be interpreted by the EFA
         *
         * @description
         * Converts a given moment object to a valid EFA-time formatted string.
         */
        function moment2efaTime(momentElem) {
            return momentElem.format('HHmm');
        }
        /**
         * @public
         * @ngdoc method
         * @methodOf mng-comm.itd.service:MDVEFAFormatter
         * @name strDuration2Minutes
         * @param {String} durString Duration
         * @returns {Integer} minutes
         *
         * @description
         * Convert a given duration string (format hh:mm) to a minute integer
         */
        function strDuration2Minutes(durString) {
            var parts = durString.split(':'),
                mins = 0;

            if (parts.length === 2) {
                // hours and minutes
                mins += parseInt(parts[0], 10) * 60;
                mins += parseInt(parts[1], 10);
            } else if (parts.length === 1) {
                // minutes only
                mins = parseInt(parts[0], 10);
            } else {
                log.error('invalid durString to parse! ' + durString);
            }
            return mins;
        }

        function getConfigTranslation() {
            if (MDVConfig.isReady()) {
                return MDVConfig.getValue('mng-translations');
            }
            return {};
        }

        /**
         * @public
         * @ngdoc method
         * @methodOf mng-comm.itd.service:MDVEFAFormatter
         * @name translate
         * @param {String} value Value to translate
         * @param {String} [limitation=null] provide a limitation to avoid running through all
         * translation maps
         * @returns {String} translated value
         *
         * @description
         * Translate a given EFA value (like product class or placeholders) to an abstract token.
         */
        function translate(value, limitation) {
            var efaTranslationMap = {
                    transportation : {
                        '0' : 'TRAIN',
                        '1' : 'COMMUTER',
                        '2' : 'SUBWAY',
                        '3' : 'LIGHTRAIL',
                        '4' : 'TRAM',
                        '5' : 'BUS',
                        '6' : 'REGIONALBUS',
                        '7' : 'COACH',
                        '8' : 'CABLECAR',
                        '9' : 'FERRY',
                        '10' : 'DEMANDTAXI',
                        '11' : 'OTHER',
                        '12' : 'PLAIN',
                        '13' : 'LOCALTRAIN',
                        '14' : 'NATIONALTRAIN',
                        '15' : 'INTERNATIONALTRAIN',
                        '16' : 'HIGHSPEEDTRAIN',
                        '17' : 'RAILREPLACEMENT',
                        '18' : 'RAILSHUTTLE',
                        '19' : 'CITIZENBUS',
                        // MODES
                        '97' : 'STAYSEATED',
                        '98' : 'SAVECONNECTION',
                        '99' : 'TRANSFER',
                        '100' : 'FOOTPATH',
                        '101' : 'BIKE',
                        '102' : 'BIKE',
                        '103' : 'CAR',
                        '104' : 'CAR',
                        '105' : 'TAXI',
                        '106' : 'CAR',
                        '107' : 'BIKE'
                    },
                    placeholder : {
                        '$UNKNOWN_POINT$' : 'UNKNOWN_POINT',
                        '$MID$' : 'MID',
                        '$END$' : 'END',
                        '$S$' : 'SOUTH',
                        '$W$' : 'WEST',
                        '$N$' : 'NORTH',
                        '$E$' : 'EAST',
                        '##' : 'SPACER',
                        '$' : 'SPACER'
                    }
                },
                translations = angular.extend({}, defaultTrans, getConfigTranslation()),
                key,
                translationKey;

            if (limitation && efaTranslationMap.hasOwnProperty(limitation)) {
                translationKey = efaTranslationMap[limitation][value] || value;
            } else {
                // go through all translations
                for (key in efaTranslationMap) {
                    if (efaTranslationMap.hasOwnProperty(key) && !translationKey) {
                        if (efaTranslationMap[key].hasOwnProperty(value)) {
                            translationKey = efaTranslationMap[key][value] || value;
                        }
                    }
                }
            }
            if (!translationKey) {
                translationKey = value;
            }

            if (!translations.hasOwnProperty(translationKey)) {
                return translationKey;
            }
            return translations[translationKey];
        }

        function getPropertyName(name) {
            var efaTranslationMap = {
                // coordinfo properties
                'STOP_NAME_WITH_PLACE' : 'alternativeName',
                'STOP_MAJOR_MEANS' : 'mainMode',
                'STOP_MEANS_LIST' : 'modes'
            };

            return efaTranslationMap[name] || name;
        }

        /**
         * @public
         * @ngdoc method
         * @methodOf mng-comm.itd.service:MDVEFAFormatter
         * @name parseGenAttrs
         * @param {Object[]} attr_list attributes from EFA
         * @returns {Object} key value pairs
         *
         * @description
         * Convert a set of generic attributes from efa to a readable key-value object.
         */
        function parseGenAttrs(attr_list) {
            var attrs = {},
                curr, i, l, name, value;

            if (!attr_list || attr_list.length === 0) {
                return attrs;
            }
            for (i = 0, l = attr_list.length; i < l; i += 1) {
                curr = attr_list[i];
                if (curr.name && curr.value) {
                    name = getPropertyName(curr.name);

                    if (attrs.hasOwnProperty(name)) {
                        // key already set, add an array with all values
                        value = attrs[name];

                        if (value.constructor === Array) {
                            value.push(curr.value);
                        } else {
                            value = [value, curr.value];
                        }
                        attrs[name] = value;
                    } else {
                        // new value, nothing special here
                        attrs[name] = curr.value;
                    }
                }
            }
            return attrs;
        }

        /**
         * @public
         * @ngdoc method
         * @methodOf mng-comm.itd.service:MDVEFAFormatter
         * @name parseGenAttrs
         * @param {String} stopIDglobalID stopIdglobalId value provided by EFA (like
         * "10101100:2000343,2000342,2000341#10101100:2000342" or "10101100#10101100")
         * @returns {Object} key value pairs
         *
         * @description
         * Convert the stopIdglobalId string (like "10101100:2000343,2000342,2000341#10101100:2000342"
         * or "10101100#10101100") provided by EFA to a readable object.
         */
        function getStopGlobalMap(stopIDglobalID) {
            var stops = stopIDglobalID.split('#'),
                globals,
                key,
                i,
                l,
                result = {};

            for (i = 0, l = stops.length; i < l; i += 1) {
                globals = stops[i].split(':');
                if (globals.length === 1) {
                    result[globals[0]] = [];
                } else if (globals.length === 2) {
                    key = globals[0];
                    result[key] = globals[1].split(',');
                } else {
                    log.warn('invalid stopIDglobalID value');
                }
            }

            return result;
        }

        /**
         * @public
         * @ngdoc method
         * @methodOf mng-comm.itd.service:MDVEFAFormatter
         * @name combineWalkLegs
         * @param {MDVJourneyLeg[]} legs list of legs that may contain walk legs that should be combined
         * @param {JourneyLegConstructor} JourneyLegConstructor constructor function to create a new
         * JourneyLeg instance. This needs to be done to avoid a dependency from mng-comm.itd to
         * mng-model.
         * @returns {MDVJourneyLeg[]} legs without follow up walk legs
         *
         * @description
         * Combine follow up walk legs to one walk leg.
         */
        function combineWalkLegs(legs, JourneyLegConstructor) {
             if (legs.length <= 1) {
                return legs;
            }

            // origin walk
            if (legs[0].transportation().productClass() === 100 &&
                    legs[1].transportation().productClass() === 99) {
                // replace the first two items by one combined leg
                legs.splice(0, 2, combineWalks(legs[0], legs[1], legs[0].efaIndex));
                adjustFares(legs);
                adjustLegIndex(legs);
            }

            if (legs.length <= 1) {
                return legs;
            }
            // destination walk
            if (legs[legs.length - 1].transportation().productClass() === 100 &&
                    legs[legs.length - 2].transportation().productClass() === 99) {
                // replace the last two items by one combined leg
                legs.splice(legs.length - 2, 2, combineWalks(legs[legs.length - 2],
                                            legs[legs.length - 1], legs[legs.length - 1].efaIndex));
            }

            // Maybe needed for vias as footpaths are also split up there. maybe passing the via
            // index is much easier. also mind the fare index then!!
            // for (i = 0, l = legs.length; i < l; i += 1) {
            //     current = legs[i];
            //     if (current.isWalk()) {
            //         if (i + 1 >= l || !legs[i + 1].isWalk()) {
            //             // do not combine. add combined or current
            //             if (combined) {
            //                 legList.push(combined);
            //                 combined = null;
            //             } else {
            //                 legList.push(current);
            //             }
            //         } else {
            //             // second walk leg -> combine it
            //             combined = combineWalks(combined || current, legs[i + 1]);
            //         }
            //     } else {
            //         // no walking leg -> keep it without combining
            //         legList.push(current);
            //     }
            // }
            function combine(key, prev, next) {
                return (prev[key] || 0) + (next[key] || 0);
            }

            function combineWalks(prev, next, efaIndex) {

                var prevRaw = prev.toJSON(),
                    nextRaw = next.toJSON(),
                    newRaw = MDVUtil.copy(prevRaw),
                    leg;

                newRaw.coords = (prevRaw.coords || []).concat(nextRaw.coords || []);
                if (prevRaw.pathDescription) {
                    nextRaw.pathDescription = MDVUtil.copy(
                        prepareNextPathDescription(prevRaw.pathDescription, nextRaw.pathDescription || []));
                    newRaw.pathDescription = prevRaw.pathDescription.concat(nextRaw.pathDescription || []);
                } else {
                    newRaw.pathDescription = nextRaw.pathDescription || [];
                }

                // force new to be 100 as one of the walks is 100
                newRaw.transportation.product.class = 100;
                newRaw.transportation.product.iconId = 100;
                newRaw.transportation.iconId = 100;
                newRaw.transportation.name = translate('FOOTPATH');
                newRaw.transportation.product.name = translate('FOOTPATH');
                newRaw.transportation.destination = nextRaw.transportation.destination;
                newRaw.transportation.id = newRaw.transportation.product.name + '#' +
                    newRaw.transportation.origin.id + '#' + newRaw.transportation.destination.id;

                newRaw.distance = combine('distance', prevRaw, nextRaw);
                newRaw.duration = combine('duration', prevRaw, nextRaw);
                newRaw.standby = combine('standby', prevRaw, nextRaw);
                newRaw.destination = nextRaw.destination;
                newRaw.tickets = [];

                leg = new JourneyLegConstructor(newRaw);
                leg.efaIndex = efaIndex;
                return leg;
            }

            function prepareNextPathDescription(prev, next) {
                if (!prev || prev.length === 0) {
                    return next;
                }
                var i,
                    l,
                    cumDistance = prev[prev.length - 1].cumDistance,
                    cumDuration = prev[prev.length - 1].cumDuration;

                for (i = 0, l = next.length; i < l; i += 1) {
                    next[i].cumDistance += cumDistance;
                    next[i].cumDuration += cumDuration;
                }

                return next;
            }

            function adjustFares(faresLegs) {
                var i,
                    j,
                    k,
                    l,
                    tickets;

                for (i = 0, l = faresLegs.length; i < l; i += 1) {
                    tickets = faresLegs[i].allTickets();
                    for (j = 0, k = tickets.length; j < k; j += 1) {
                        if (!tickets[j].modified) {
                            tickets[j]._decreaseRange();
                            tickets[j].modified = true;
                        }
                    }
                }
            }
            function adjustLegIndex(faresLegs) {
                var i,
                    l;

                for (i = 0, l = faresLegs.length; i < l; i += 1) {
                    faresLegs[i].legIndex -= 1;
                }
            }

            // log.debug(angular.copy(legs), true);
            // avoiding 2 footpazj legs
            legs.map(function(leg, i) {
                if (i < legs.length - 1){
                    if (legs[i].transportation().productClass() === 100 && legs[i+1].transportation().productClass() === 99) {
                        legs[i+1].waitingTime = legs[i].duration() + legs[i+1].duration();
                        legs[i+1].movedFootpathDuration = legs[i].duration();
                        legs[i+1].movedAnEstimatedTime = legs[i].departureTimeEstimated();
                        legs[i+1].movedAnPlannedTime = legs[i].departureTimePlanned();
                        legs[i+1].movedDepDelay = legs[i].departureDelay();
                        legs[i+1].movedIsRealtime = legs[i].isRealtimeControlled();
                        legs.splice(i, 1);
                    }
                    else if (legs[i].transportation().productClass() === 99 && legs[i+1].transportation().productClass() === 100) {
                        legs[i].waitingTime = legs[i+1].duration() + legs[i].duration();
                        legs[i].movedFootpathDuration = legs[i+1].duration();
                        legs[i].movedAnEstimatedTime = legs[i+1].departureTimeEstimated();
                        legs[i].movedAnPlannedTime = legs[i+1].departureTimePlanned();
                        legs[i].movedDepDelay = legs[i].departureDelay();
                        legs[i].movedIsRealtime = legs[i].isRealtimeControlled();
                        legs.splice(i+1, 1);
                    }
                }
                return leg;
            });
            return legs;
        }


        // append private functions to global object. FOR MODULE INTERNAL USAGE ONLY. the
        // explicit 'true'-check is used to avoid accidentally added parameters to have affect.
        MDVConfig.ready(function() {
            if (MDVConfig.getValue('mng-comm.itd.MDVEFAFormatter.privateMode') === true) {
                formatter._private = _private;
            }
        });


        return formatter;
    }
}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSTTBController', VVSTTBController);

    VVSTTBController.$inject = ['$scope'];

    function VVSTTBController($scope) {
        var self = this,
            _private = {};

        _private.initController = function() {
            $scope.inputLocationsValues = {};
            $scope.inputLocations = {};

            $scope.inputLinesValues = {};
            $scope.inputLines = {};
        };

        _private.initController();

    }

}());

(function() {
    'use strict';


    /**
     * The `VVSTripController` is the controller for the hole Trip page.
     * He is responsible for submitting the journey planner form, or trigger the
     * `next`/`before` commands...
     **/
    angular
        .module('vvs')
        .controller('VVSTripController', VVSTripController);

    VVSTripController.$inject = ['$rootScope', '$scope', '$state', '$q', '$window', 'VVSConst',
                                'mng-comm.MDVJourneys', 'mng-comm.MDVLocationRequester',
                                'mng-favorite.MDVOdvFavorite', 'mng-favorite.MDVOptionsFavorite',
                                'VVSDeepLinking', 'VVSGoogleDeepLinking', 'mng-common.MDVUriParams'];

    function VVSTripController($rootScope, $scope, $state, $q, $window, VVSConst, MDVJourneys, MDVLocationRequester,
            MDVOdvFavorite, MDVOptionsFavorite, VVSDeepLinking, VVSGoogleDeepLinking, MDVUriParams) {

        var self = this;

        self.triggerToggleViaClick = triggerToggleViaClick;
        self.triggerFireSearchClick = triggerFireSearchClick;
        self.triggerSwitchClick = triggerSwitchClick;
        self.resetSearchOptions = resetSearchOptions;

        // reset journey options
        function resetSearchOptions() {
            $scope.journeyObj.service.resetOptions();
        }

        // show/hide the via odv input
        function triggerToggleViaClick() {
            $scope.showVia = !$scope.showVia;
            $scope.SEARCH_OPTIONS.via.optionsListItem.enabled = $scope.showVia;
            if (!$scope.showVia) {
                $scope.inputLocations.via = null;
            }
        }

        // switch 'orig' and 'dest' values
        function triggerSwitchClick() {
            var tmp = ($scope.inputLocations.orig || $scope.inputLocationsValues.orig);

            $scope.inputLocations.orig = ($scope.inputLocations.dest || $scope.inputLocationsValues.dest);
            $scope.inputLocations.dest = tmp;
        }

        // fire journey search
        function triggerFireSearchClick() {
            var userInputs = {},
                promises = [],
                key;

            hideAlerts();

            userInputs.orig = angular.copy($scope.inputLocations.orig || $scope.inputLocationsValues.orig);
            userInputs.dest = angular.copy($scope.inputLocations.dest || $scope.inputLocationsValues.dest);
            userInputs.via = angular.copy($scope.inputLocations.via || $scope.inputLocationsValues.via);

            for (key in userInputs) {
                if (userInputs.hasOwnProperty(key) && (typeof userInputs[key] === 'string') && (userInputs[key].length>0)) {
                    promises.push(verifyOdv(key));
                }
            }

            if (!userInputs.orig) {
                $scope.tripMissingOrigAlert = true;
                $scope.isDeepLink = false;
                return false;
            }

            if (!userInputs.dest) {
                $scope.tripMissingDestAlert = true;
                $scope.isDeepLink = false;
                return false;
            }

            // if odv is string
            function verifyOdv(usage) {
                var d = $q.defer();

                MDVLocationRequester.search(userInputs[usage])
                    .then(function(result) {
                        if (result.response.length>0) {
                            $scope.inputLocations[usage] = userInputs[usage] = result.response[0];
                            d.resolve();
                        }

                        else if (result.response.length === 0 && (typeof userInputs.orig === 'string' || typeof userInputs.dest === 'string')) {
                            $scope.validationCheckAlert = true;
                        }
                    });
                return d.promise;
            }

            if (promises.length === 0) {
                // we dont need to verify odvs
                fireSearch();
            } else {
                // we have to verify odvs
                $q.all(promises).then(function() {
                    fireSearch();
                });
            }


            function fireSearch() {
                // check if origin and destination are the same
                if (userInputs.orig.id() === userInputs.dest.id()) {
                    $scope.tripSameInputsAlert = true;
                    $scope.isDeepLink = false;
                    return false;
                }

                // check if a via stop was giving
                if (userInputs.via && userInputs.via.id()) {
                    var newViaObj = angular.copy($scope.SEARCH_OPTIONS.via.optionsListItem);

                    newViaObj.name = userInputs.via.id();
                    // add giving via to the trip options
                    $scope.SEARCH_OPTIONS.via.optionsList = [newViaObj];
                } else {
                    $scope.SEARCH_OPTIONS.via.optionsList = [];
                }

                // add the new origin/destination to the journey service
                $scope.journeyObj.service.updateOrigin(userInputs.orig);
                $scope.journeyObj.service.updateDestination(userInputs.dest);

                // before firing the search => clear old results
                $scope.journeyObj.service.clearResults();

                // calcOneDirection logic
                var params = {},
                    dateDiff = moment($scope.SEARCH_OPTIONS.dateTime.date, VVSConst.datePickerFormat).diff(moment(), 'days'),
                    timeDiff = moment($scope.SEARCH_OPTIONS.dateTime.time, VVSConst.timePickerFormat).diff(moment(), 'minutes');

                if ((dateDiff === 0) && (timeDiff === 0)) {
                    params.efaParams = {
                        calcOneDirection : 1
                    };
                }

                // fire search function -> results will be auto. bounded under journeyObj.service.getResults()
                $scope.journeyObj.service.search(params)
                    .then(function(journeys) {
                        // if we have results => save user inputs
                        if (journeys.length>0) {

                            // add searched odv to DB
                            MDVOdvFavorite.set(userInputs.orig,
                                               userInputs.dest,
                                               userInputs.via?[userInputs.via]:[]);
                            // add search options to db
                            MDVOptionsFavorite.set(angular.copy($scope.SEARCH_OPTIONS));

                            // go to results view
                            $state.go('vvs.trip.result');
                            $scope.isDeepLink = false;
                        } else {
                            $scope.isDeepLink = false;
                            $scope.tripNoResultsAlert = true;
                        }
                    })
                    .catch(function(err) {
                        $scope.isDeepLink = false;

                        if ($scope.SEARCH_OPTIONS.publicTransport.bikeTakeAlong) {
                            $scope.takeBikeAlert = true;
                        } else if (err && (err.data) && (err.data.data) && (err.data.data.length>0)) {
                            $scope.errorMessages = err.data.data;
                        } else {
                            $scope.requestFailed = true;
                        }
                    });
            }
        }

        /* *****************************************************
        ****************      PRIVATE METHODS     *************
        *******************************************************/
        function initTripControllerData() {
            $scope.journeyObj = {
                service : new MDVJourneys(),
                firstJourneys : [],
                lastJourneys : []
            };

            $rootScope.journeyObj = $scope.journeyObj;

            // function to show/hide the via odv input
            $scope.showVia = false;
            $scope.isDeepLink = false;

            // initialize the buffer that will be filled with selected mdvLocations
            $scope.inputLocations = {};
            $scope.inputLocationsValues = {};
            $scope.journeyObj.service.reset();

            // bind options to scope variable
            $scope.SEARCH_OPTIONS = $scope.journeyObj.service.getOptions();
            $scope.DEFAULT_SEARCH_OPTIONS = angular.copy($scope.journeyObj.service.getOptions());

            // get options favorites
            MDVOptionsFavorite.get().then(function(res) {
                if (res && res.length>0) {
                    MDVOptionsFavorite.updateOptionsReference($scope.SEARCH_OPTIONS, res[0]);
                }
            });

            var deeplinkOptions = VVSDeepLinking.generateOptionsFromDeeplink();
            var googleDeeplinkOptions = VVSGoogleDeepLinking.generateOptionsFromDeeplink();
            if (deeplinkOptions) {
                MDVOptionsFavorite.updateOptionsReference($scope.SEARCH_OPTIONS, deeplinkOptions);
                $scope.inputLocations.orig = deeplinkOptions.odvs.orig;
                $scope.inputLocations.dest = deeplinkOptions.odvs.dest;

                if (deeplinkOptions.via && deeplinkOptions.via.optionsList && deeplinkOptions.via.optionsList.length>0) {
                    $scope.inputLocations.via = deeplinkOptions.via.optionsList[0].name;
                }
                if ($scope.inputLocations.orig || $scope.inputLocations.dest) {
                    $scope.isDeepLink = true;
                    self.triggerFireSearchClick();
                }
            }
            if (googleDeeplinkOptions) {
                MDVOptionsFavorite.updateOptionsReference($scope.SEARCH_OPTIONS, googleDeeplinkOptions);
                $scope.inputLocations.orig = googleDeeplinkOptions.odvs.from;
                $scope.inputLocations.dest = googleDeeplinkOptions.odvs.to;

                // if (deeplinkOptions.via && deeplinkOptions.via.optionsList && deeplinkOptions.via.optionsList.length>0) {
                //     $scope.inputLocations.via = deeplinkOptions.via.optionsList[0].name;
                // }
                if ($scope.inputLocations.orig || $scope.inputLocations.dest) {
                    $scope.isDeepLink = true;
                    self.triggerFireSearchClick();
                }
            }
        }

        // init the controller data
        initTripControllerData();

        initDebugParams();

        function initDebugParams() {
            var debug = MDVUriParams.get('debug');

            if (debug) {
                if ([1, true, '1', 'true'].indexOf(debug) > -1) {
                    $scope.debugObj = {
                        isDebugModeActive : true,
                        addParam : function(name, value) {
                            if (!$scope.SEARCH_OPTIONS.efaParams) {
                                $scope.SEARCH_OPTIONS.efaParams = {};
                            }
                            this.params.push({
                                new : false,
                                name : name,
                                value : value
                            });
                            $scope.SEARCH_OPTIONS.efaParams[name] = value;
                        },
                        removeParam : function(name) {
                            var idx = -1;

                            this.params.forEach(function(param, i) {
                                if (param.name === name) {
                                    idx = i;
                                }
                            });

                            if (idx > -1) {
                                this.params.splice(idx, 1);
                                delete $scope.SEARCH_OPTIONS.efaParams[name];
                            }
                        },


                        params : [
                            {
                                new : true,
                                name : '',
                                value : ''
                            }
                        ]
                    };
                }
            }
        }

        function hideAlerts() {
            $scope.tripMissingInputAlert = false;
            $scope.tripSameInputsAlert = false;
            $scope.tripNoResultsAlert = false;
            $scope.requestFailed = false;
            $scope.validationCheckAlert = false;
            $scope.errorMessages = null;
        }
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSSTTController', VVSSTTController);

    VVSSTTController.$inject = ['$scope'];

    function VVSSTTController($scope) {
        var self = this,
            _private = {};

        _private.initController = function() {
            $scope.inputLocationsValues = {};
            $scope.inputLocations = {};

            $scope.inputLinesValues = {};
            $scope.inputLines = {};

            $scope.tabIndex = 0;
        };

        _private.initController();

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSPersonalizationController', VVSPersonalizationController);

    VVSPersonalizationController.$inject = [];

    function VVSPersonalizationController() {

    }

}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .controller('VVSModalsDateTimeMobileController', VVSModalsDateTimeMobileController);

    VVSModalsDateTimeMobileController.$inject = ['$scope', '$filter', 'VVSConst', 'VVSBrowserUtilities'];

    function VVSModalsDateTimeMobileController($scope, $filter, VVSConst, VVSBrowserUtilities) {
        var self = this,
            day = moment($scope.SEARCH_OPTIONS.dateTime.date).toDate();

        $scope.isSpecialBrowser = (VVSBrowserUtilities.getMobileOperatingSystem() === 'Windows') || (VVSBrowserUtilities.getBrowserName() === 'Firefox');

        function initDatetime() {
            if (!$scope.isSpecialBrowser) {
                $scope.SEARCH_OPTIONS.dateTime.dateTime = new Date(day.getUTCFullYear(), day.getUTCMonth(),
                    day.getUTCDate(), day.getHours(), day.getMinutes());
            } else {
                $scope.SEARCH_OPTIONS.dateTime.dateTime = $filter('VVSMobileDateTimeFormatter')($scope.SEARCH_OPTIONS.dateTime);
            }
        }
        initDatetime();


        self.updateDateTime = function() {
            var date = moment($scope.SEARCH_OPTIONS.dateTime.dateTime, VVSConst.dateFormat),
                time = moment($scope.SEARCH_OPTIONS.dateTime.dateTime, VVSConst.dateFormat + ' ' + VVSConst.timeFormat);

            if (date.isValid()) {
                $scope.SEARCH_OPTIONS.dateTime.date = date;
            } else {
                initDatetime();
            }
            if (time.isValid()) {
                $scope.SEARCH_OPTIONS.dateTime.time = time;
            } else {
                initDatetime();
            }
        };


        self.addMinutes = function(minutes) {
            var day = new Date(),
                dateTime = new Date(day.getUTCFullYear(), day.getUTCMonth(),
                day.getUTCDate(), day.getHours(), day.getMinutes() + minutes);

            if ($scope.isSpecialBrowser) {
                $scope.SEARCH_OPTIONS.dateTime.dateTime = moment(dateTime).format(VVSConst.dateFormat + ' ' + VVSConst.timeFormat);
            } else {
                $scope.SEARCH_OPTIONS.dateTime.dateTime = dateTime;
            }
        };

    }




    angular
        .module('vvs')
        .controller('VVSModalsNetworkController', VVSModalsNetworkController);

    VVSModalsNetworkController.$inject = ['$scope'];

    function VVSModalsNetworkController($scope) {
        var self = this;

        $scope.modalInstance.opened.then(function() {
            self.load = true;
        });

        $scope.modalInstance.closed.then(function() {
            $scope.modalInstance = false;
        });
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .filter('VVSCoordFilter', VVSCoordFilter);

    function VVSCoordFilter() {
        var motKeyMap = {
            0 : 'train',
            1 : 'commuter',
            2 : 'subway',
            3 : 'bus',
            4 : 'tram',
            5 : 'bus',
            6 : 'regionalBus',
            7 : 'coach',
            8 : 'cableCar',
            9 : 'ferry',
            10 : 'demandTaxi',
            11 : 'other',
            12 : 'plain',
            13 : 'localTrain',
            14 : 'nationalTrain',
            15 : 'internationalTrain',
            16 : 'highspeedTrain',
            17 : 'railReplacement',
            18 : 'railShuttle',
            19 : 'citizenBus'
        };


        function isStopMatch(elem, stopoptions) {
            var modes = elem.productClasses(),
                i, l, key;

            if (elem.type() !== elem.LOCATIONTYPES.STOP) {
                return false;
            }

            for (i = 0, l = modes.length; i < l; i += 1) {
                key = motKeyMap[modes[i]];
                if (key && stopoptions[key]) {
                    return true;
                }
            }

            return false;
        }

        function getPoiHierarchyKey(val) {
            if (Array.isArray(val)) {
                if (val.length > 0) {
                    if (val.length === 1) {
                        return val[0];
                    } else {
                        var i, l;

                        for (i=0, l=val.length; i<l; i++) {
                            if (val[i].length === 1) {
                                return val[i];
                            }
                        }
                    }
                }
            }
            return val;
        }

        function isPOIMatch(elem, poioptions) {
            var category = getPoiHierarchyKey(elem.properties().POI_HIERARCHY_KEY),
                type = elem.type();

            if ([   elem.LOCATIONTYPES.POI_AREA,
                    elem.LOCATIONTYPES.POI,
                    elem.LOCATIONTYPES.SHARING
                ].indexOf(type) === -1) {
                return false;
            }

            if (type === 'sharingProvider') {
                category = 'M';
            }

            if (!category) {
                return false;
            }
            return poioptions[category];
        }

        return function(list, options) {
            if (!list || list.length <= 0) {
                return [];
            }
            var i,
                l,
                curr_elem,
                result = [];

            if (!options.stops) {
                options.stops = {};
            }
            if (!options.pois) {
                options.pois = {};
            }

            for (i = 0, l = list.length; i < l; i += 1) {
                curr_elem = list[i];
                if (isStopMatch(curr_elem, options.stops)) {
                    result.push(curr_elem);
                }
                if (isPOIMatch(curr_elem, options.pois)) {
                    result.push(curr_elem);
                }
            }
            return result;

        };
    }
}());

(function() {
    'use strict';


    angular
        .module('vvs')
        .directive('vvsMap', vvsMap);

    vvsMap.$inject = ['VVSConst'];

    function vvsMap(VVSConst) {
        var baseUrlPrefix = VVSConst.baseUrl ? VVSConst.baseUrl : '';

        return {
            restrict : 'E',
            replace : true,
            scope : {
                'usage': '=',
                'mode': '=',
                'trip': '=',
                'line': '=',
                'leg': '=',
                'location': '=',
                'zoomLevel': '=',
                'date': '='
            },
            templateUrl : baseUrlPrefix + 'map/map.html',
            controller : 'VVSMapController',
            controllerAs : 'VVSMapCtrl'
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSMapController', VVSMapController);

    VVSMapController.$inject = ['$rootScope', '$scope', '$state', '$element', '$attrs', '$compile', '$filter',
        '$timeout', 'L', 'ML', 'VVSConst', 'mng-common.MDVCurrentPosition', 'mng-leaflet.MDVLeafletData',
        'mng-leaflet.MDVLeafletCoord', 'mng-leaflet.MDVLeafletVELOC', 'mng-model.MDVLocation',
        'mng-comm.MDVTransportationRequester', 'mng-comm.MDVDownload', 'mng-comm.MDVLocationRequester',
        'mng-comm.MDVLivePositionsRequester', 'mng-favorite.MDVLocationFavorite',
        'VVSPdfViewer'];

    function VVSMapController($rootScope, $scope, $state, $element, $attrs, $compile, $filter, $timeout, L, ML, VVSConst,
            MDVCurrentPosition, LeafletData,
            MDVLeafletCoord, MDVLeafletVELOC, MDVLocation, MDVTransportationRequester,
            MDVDownload, MDVLocationRequester, MDVLivePositionsRequester, MDVLocationFavorite,
            VVSPdfViewer) {

        var self = this,
            mode,
            zoomlevel,
            trip,
            line,
            date,
            leg,
            location,
            baseUrl,
            coordStopService,
            coordPoiService,
            livePositionsService,
            livePositionsMarkerCache,
            livePositionsRealTimeMarkerCache,
            stopsMarkerCache,
            poisMarkerCache,
            stopNameDisableValue = true;


        self.toggleStopName = false;
        self.toggleStopNameDisabled = false;
        self.mapInstance = null;
        self.networkMapInstance = null;
        self.coordStopMarkers = [];

        self.triggerZoomInClick = triggerZoomInClick;
        self.triggerZoomOutClick = triggerZoomOutClick;
        self.triggerGetCurrentPositionClick = triggerGetCurrentPositionClick;
        self.triggerSwitchLayerClick = triggerSwitchLayerClick;
        self.triggerPrintMapClick = triggerPrintMapClick;
        self.triggerToggleStopName = triggerToggleStopName;
        self.triggerLivePositionUpdate = triggerLivePositionUpdate;

        $scope.markerSet = [];


        angular.element(document).find('body')
            .on('click', function() {
                if ($scope.mapTypePopoverIsOpen) {
                    $scope.mapTypePopoverIsOpen = false;
                }
            });

        $attrs.$observe('loadOn', function(load) {
            load = $scope.$eval(load);
            if (load) {
                initMapController();
            }
        });


        // ///////////////////////////////////////////////////////////////

        function bindTooltipToElem(elem, str) {
            if (!elem || !str) {
                return;
            }
            elem.bindTooltip(str, {
                permanent : true,
                direction : 'auto',
                offset : L.point(0, 10),
                opacity : 0.8,
                className : 'vvsMapMarkerTooltip'
            });
        }

        // ///////////////////////////////////////////////////////////////////
        function getPopupByLocation(loc, trans, type, marker, hideDm) {
            var html;

            if (loc) {
                $scope.loc = loc;
                $scope.marker = marker;
                $scope.hideDm = hideDm;
                html = $compile('<vvs-map-popover hide-dm="hideDm" location="loc" usage="usage" ' +
                    'marker="marker" type="' + (type||loc.type()) +
                    '"></vvs-map-popover>')($scope);

            } else if (trans) {
                $scope.trans = trans;
                html = $compile('<vvs-map-popover trans="trans" usage="usage" type="' + type +
                    '"></vvs-map-popover>')($scope);
            }
            return html[0];
        }


        // getLocationFromCoordsByUsage
        function getLocationFromCoordsByUsage(legElem, usage) {
            if (usage === 'orig') {
                return new MDVLocation({
                    id : legElem.origin().id(),
                    name : legElem.origin().name(),
                    coord : legElem.coords()[0]
                });
            } else if (usage === 'dest') {
                return new MDVLocation({
                    id : legElem.destination().id(),
                    name : legElem.destination().name(),
                    coord : legElem.coords()[legElem.coords().length-1]
                });
            }
        }
        // end getLocationFromCoordsByUsage

        // createMarker
        function createMarker(coord, options, layer) {
            if (coord && coord.length) {
                return L.marker(coord, options)
                    .addTo(layer);
            }
        }
        // end createMarker
        function getIconUrl (extraCase, transportation) {
            var productIconId = transportation.productIconId();
            var number = transportation.number();
            var result;
            switch(extraCase) {
                case 'isRider':
                    result = VVSConst.iconProductIconIdMapper[productIconId+'_'+number];
                    break;
                default:
                    result = VVSConst.iconProductIconIdMapper[productIconId];
                    break;
            }
            return result;
        };

        // getMarkerOptions
        function getMarkerOptions(transportation) {
            var mtSubcode = transportation.properties().mtSubcode;
            var number = transportation.number();
            var isRider = (number === 'VVS-Rider');
            var opts = {
                // TODO use iconcache here...
                icon : L.icon({
                    iconUrl : VVSConst.baseUrl.concat('assets/images/icons/')
                        .concat(isRider ? getIconUrl('isRider', transportation) : getIconUrl(undefined, transportation))
                        .concat(mtSubcode ? mtSubcode : '')
                        .concat('.svg'),
                    iconSize : [20, 20],
                    zIndexOffset : 999
                    // iconAnchor: [10, 20]
                })
            };
            return opts;
        }
        // end getMarkerOptions

        function initMapController() {
            var key, i, l, obj;

            mode = angular.copy($scope.mode);
            trip = angular.copy($scope.trip);
            line = angular.copy($scope.line);
            date = angular.copy($scope.date);
            leg = angular.copy($scope.leg);
            location = angular.copy($scope.location);
            zoomlevel = angular.copy($scope.zoomLevel);

            baseUrl = VVSConst.baseUrl;

            LeafletData.get('vvsNetworkMapContainer')
                .then(function(map) {
                    var usage = angular.copy($scope.usage),
                        net = ML.netplanOverlay({
                            url : '/app/vvs.components/assets/files/json.tubemap.vvs.json'
                        });

                    self.networkMapInstance = map;

                    self.networkMapInstance.switchLayer('net');


                    // ///////////////////////  handle network map popovers  ////////////////////////////

                    function bindNetworkPopup(e, loc) {
                        var popup = getPopupByLocation(loc, null, null, null, true);

                        e.polygon.bindPopup(popup, {
                            autoPan : true,
                            keepInView : true,
                            closeButton : true,
                            className : 'vvs-map-popup vvs-click'
                        });

                        e.polygon.openPopup();
                    }

                    self.networkMapInstance.addLayer(net
                        .on(L.mdv.events.netplan.STATION_CLICKED, function(e) {
                            var loc = new MDVLocation({
                                id : e.station.id,
                                name : e.station.name,
                                type : 'stop'
                            });

                            if (usage) {
                                var d = {};

                                d[usage] = loc;
                                $state.go('vvs.trip.init', d, {notify: true});
                            } else {
                                //bindNetworkPopup(e, loc);
                            }
                        })
                        .on(L.mdv.events.netplan.STATION_MOUSEOVER, function(e) {
                            if (self.networkMapInstance.getZoom() === 0) {
                                return;
                            }

                            var loc = new MDVLocation({
                                id : e.station.id,
                                name : e.station.name,
                                type : 'stop'
                            });

                            bindNetworkPopup(e, loc);
                        })
                        .on(L.mdv.events.netplan.STATION_MOUSEOUT, function(e) {
                            //e.polygon.closePopup();
                        })
                    );

                    if (usage) {
                        self.networkMapInstance.fitBounds(net.getBounds());
                        self.networkMapInstance.invalidateSize();
                    }
                });

            LeafletData.get('vvsMapContainer')
                .then(function(map) {
                    self.mapInstance = map;

                    self.mapInstance.setView(getMapCenter(map), zoomlevel || 3);

                    self.mapInstance.invalidateSize();

                    self.mapInstance.attributionControl.setPrefix(false);
                    self.mapInstance.attributionControl.setPosition('bottomleft');

                    coordStopService = new MDVLeafletCoord(map, {
                        type : 'stop',
                        minZoom : 4,
                        delayInit : true,
                        tilerOptions : {
                            tileSize : 250
                        }
                    });
                    coordPoiService = new MDVLeafletCoord(map, {
                        type : 'aoi#callabike',
                        minZoom : 4,
                        delayInit : true,
                        tilerOptions : {
                            tileSize : 250
                        }
                    });
                    livePositionsService = new MDVLeafletVELOC(map, {
                        // minZoom : 0,
                        minZoom : 2,
                        delayInit : true,
                        updateInterval : 10000,  // 10 sec
                        tilerOptions : {
                            tileSize : 100
                        }
                    });
                    livePositionsMarkerCache = {};
                    livePositionsRealTimeMarkerCache = {};
                    stopsMarkerCache = {};
                    poisMarkerCache = {};
                    // sharingMarkerCache = {};


                    // init stop, poi, sharing options
                    $scope.MAP_OPTIONS = {
                        stops : {
                            enable : true,
                            regionalBus : true,
                            commuter : true,
                            subway : true,
                            bus : true
                        },
                        pois : {
                            enable : false,
                            A : false,
                            B : false,
                            C : false,
                            D : false,
                            E : false,
                            F : false,
                            G : false,
                            H : false,
                            I : false,
                            J : false,
                            K : false,
                            L : false,
                            M : false
                        },
                        positions : livePositionsService.getOptions(),
                        layers : {
                            type : 'gis',
                            lines : false
                        }
                    };

                    //  //////////////////////////////////////////////////////////////////////////////
                    resetAllServices();

                    //  //////////////////////////////////////////////////////////////////////////////
                    if (!mode) {
                        $scope.MAP_OPTIONS.layers.lines = true;
                        triggerSwitchLayerClick();
                        coordStopService.enable();
                    }

                    //  //////////////////////////////////////////////////////////////////////////////
                    function resetAllServices() {
                        livePositionsService.disable();
                        coordStopService.disable();
                        coordPoiService.disable();
                    }

                    $scope.$on('$destroy', function() {
                        resetAllServices();
                    });
                    //  //////////////////////////////////////////////////////////////////////////////
                    if (mode === 'trip') {
                        drawTrip();
                        // stopNameDisableValue = false;
                    } else if (mode === 'line') {
                        drawLine();
                        stopNameDisableValue = false;
                    } else if (mode === 'leg') {
                        drawLine();
                        stopNameDisableValue = false;
                    } else if (mode === 'location') {
                        drawLocation();
                        stopNameDisableValue = false;
                    }
                    else {

                    }


                    function drawTrip() {
                        if (!trip) {
                            return;
                        }

                        var layer = L.featureGroup(),
                            // transportations = [],
                            legs = trip.legs();

                        // last point
                        legs.forEach(function(legElem, index) {
                            drawLeg(legElem, layer);
                            // transportations.push(leg.transportation());
                        });

                        // draw destination marker for last leg
                        if (legs.length) {
                            $scope.destMarker = createMarker(getLocationFromCoordsByUsage(legs[legs.length - 1], 'dest').coord(),
                            getMarkerOptions(legs[legs.length - 1].transportation()), layer);
                            $scope.destMarker.tooltipName = legs[legs.length - 1].destination().name();
                            $scope.destMarker.desttype = true;
                            $scope.markerSet.push($scope.destMarker);
                            createMarker(getLocationFromCoordsByUsage(legs[legs.length - 1], 'dest').coord(),
                                    getMarkerOptions(legs[legs.length - 1].transportation()), layer);
                        }

                        map.addLayer(layer);
                        if (!location) {
                            $timeout(function() {
                                // zoom to elements
                                self.mapInstance.fitBounds(layer.getBounds());
                            }, 1000);
                        }

                        // TODO needed?
                        // self.tripLayer = layer;
                        // startLiveLinePositionsService(transportations);
                    }

                    // only draw origin and polyline of the passed leg
                    // ORIGIN
                    function drawLeg(legElem, layer) {
                        var origin = getLocationFromCoordsByUsage(legElem, 'orig');

                        createPolyline(legElem.coords(),
                            getPolylineOptions(legElem.transportation()), layer);
                        $scope.originMarker = createMarker(origin.coord(), getMarkerOptions(legElem.transportation()), layer);
                        if (origin.coord() && origin.coord().length) {
                            $scope.originMarker.tooltipName = legElem.origin().name();
                            $scope.originMarker.origintype = true;
                            $scope.markerSet.push($scope.originMarker);
                        }
                        createMarker(origin.coord(), getMarkerOptions(legElem.transportation()), layer);
                    }

                    function createPolyline(coords, options, layer) {
                        if (coords && coords.length) {
                            L.polyline(coords, options)
                                .addTo(layer);
                        }
                    }


                    function drawLine() {
                        if (!leg && !line) {
                            return;
                        }
                        var transportation = leg? leg.transportation() : line,
                            layer = L.featureGroup(),
                            opts;

                        if (date && date._isAMomentObject) {
                            opts = {
                                efaParams : {
                                    filterDate : date.format('YYYYMMDD')
                                }
                            };
                        }

                        MDVTransportationRequester.search(transportation, opts)
                            .then(function(res) {
                                if (res && res.response && res.response.length > 0) {
                                    var lineToDraw = res.response[0],
                                        lines = lineToDraw.coords(),
                                        polylineOptions = getPolylineOptions(lineToDraw);
                                    // draw all coordinates of the line
                                    lines.forEach(function(lineElem) {
                                        createPolyline(lineElem, polylineOptions, layer);
                                    });

                                    // add stopover markers
                                    lineToDraw.locationSequence().forEach(function(locSeqElem) {
                                        var marker = createMarker(locSeqElem.coord(), getMarkerOptions(lineToDraw), layer);
                                        marker.off('mouseover'); // TODO
                                        marker.off('click');
                                        marker.on('mouseover', function() {
                                            bindPopupToMarker(this);
                                            return false;
                                        });
                                        marker.on('click', function() {
                                            bindPopupToMarker(this);
                                            return false;
                                        });

                                        function bindPopupToMarker(markerElem) {
                                            marker.popup = getPopupByLocation(locSeqElem, null, 'stop', markerElem);
                                            marker.bindPopup(marker.popup, {
                                                autoPan : true,
                                                keepInView : true,
                                                closeButton : true,
                                                className : 'vvs-map-popup vvs-poi'
                                            });
                                            marker.openPopup();
                                        }

                                    });

                                    map.addLayer(layer);

                                    $timeout(function() {
                                        // zoom to elements
                                        map.fitBounds(layer.getBounds());
                                    }, 1000);

                                    // TODO needed?
                                    // self.lineLayer = layer;
                                }
                            })
                            .catch(function(e) {
                                console.log(e);
                            });

                        startLiveLinePositionsService([transportation]);
                    }


                    function drawLocation() {
                        if (!location) {
                            return;
                        }

                        var marker = L.marker(location.coord());

                        marker.addTo(map);

                        // TODO needed?
                        // self.locationMarker = marker;
                    }

                    function startLiveLinePositionsService(transportations) {
                        var params = {
                                LineID : []
                            },
                            j, m;

                        self.liveLinePositionsServiceStarted = true;

                        for (j=0, m=transportations.length; j<m; j+=1) {
                            params.LineID.push(transportations[j].id());
                        }
                        $scope.MAP_OPTIONS.positions.productRestrictions.train = true;
                        $scope.MAP_OPTIONS.positions.productRestrictions.commuter = true;
                        $scope.MAP_OPTIONS.positions.productRestrictions.lightRail = true;
                        $scope.MAP_OPTIONS.positions.productRestrictions.bus = true;
                        $scope.MAP_OPTIONS.positions.filter.showVehiculesWithoutDelay = true;
                        $scope.MAP_OPTIONS.positions.enable = true;
                        $scope.MAP_OPTIONS.positions.filter.enable = false;
                        $scope.MAP_OPTIONS.positions.transportations = transportations;

                        livePositionsService.enable();
                    }

                    function getPolylineColor(transportation) {
                        var number = transportation.number();
                        var productIconId = transportation.productIconId();
                        var isRider = (number === 'VVS-Rider');
                        var extraCase = isRider ? 'isRider' : undefined;
                        var result;
                        switch(extraCase) {
                            case 'isRider':
                                result =  VVSConst.lineColorMapper[productIconId+'_'+number];
                                break;
                            default:
                                result = VVSConst.lineColorMapper[productIconId];
                                break;
                        }
                        return result;
                    }

                    function getPolylineOptions(transportation) {
                        transportation.productIconId()
                        var opts = {
                            color : getPolylineColor(transportation)
                        };

                        return opts;
                    }

                    function getMapCenter(map) {
                        if (location) {
                            return location.coord();
                        } else if (leg) {
                            return leg.origin().coord();
                        } else if (trip) {
                            return trip.origin().coord();
                        }


                        MDVLocationFavorite.get(null, 'center')
                            .then(function(res) {
                                if (res.length>0) {
                                    var centerLatLng = new L.LatLng(res[res.length-1].coord()[0], res[res.length-1].coord()[1]);

                                    map.panTo(centerLatLng);
                                }
                            });
                        return [48.784171, 9.178921];
                    }


                    // //////////////////////////////////////////////////////////////////

                    self.mapInstance.on('moveend', function() {
                        saveNewCenter();
                    });

                    function saveNewCenter() {
                        var center = self.mapInstance.getCenter(),
                            formattedCenter = [center.lat, center.lng],
                            locationCenter = new MDVLocation({
                                id : 'center_' + Date.now(),
                                coord : formattedCenter
                            });
                        MDVLocationFavorite.set(locationCenter, 'center');
                    }

                    // //////////////////     on zoom end event     ////////////////////

                    self.mapInstance.on('zoomend', function() {
                        if(self.mapInstance.getZoom()<4) {
                            coordStopService.disable();
                        } else {
                            if (!mode) {
                                coordStopService.enable();
                            }
                        }
                        updateOptions();
                        if ($scope.MAP_OPTIONS.positions.enable) {
                            updateVELOCOptions();
                        }
                    });
                    updateOptions();
                    function updateOptions() {
                        //updateStopNameOptions();
                    }

                    function updateStopNameOptions() {
                        if (self.mapInstance.getZoom() < 4) {
                            self.toggleStopNameDisabled = stopNameDisableValue;
                        } else {
                            self.toggleStopNameDisabled = false;
                        }
                        triggerToggleStopName();
                    }

                    function updateVELOCOptions() {
                        var curZoomLevel = self.mapInstance.getZoom();

                        if ($scope.MAP_OPTIONS.positions.changed) {
                            return;
                        }

                        if (!self.liveLinePositionsServiceStarted) {
                            $scope.MAP_OPTIONS.positions.productRestrictions.train = false;
                            $scope.MAP_OPTIONS.positions.productRestrictions.commuter = false;
                            $scope.MAP_OPTIONS.positions.productRestrictions.lightRail = false;
                            $scope.MAP_OPTIONS.positions.productRestrictions.bus = false;
                            $scope.MAP_OPTIONS.positions.filter.showVehiculesWithoutDelay = false;
                        }

                        if (curZoomLevel<2) {
                            $scope.MAP_OPTIONS.positions.productRestrictions.train = true;
                            $scope.MAP_OPTIONS.positions.productRestrictions.commuter = true;
                        } else if (curZoomLevel<3) {
                            $scope.MAP_OPTIONS.positions.productRestrictions.train = true;
                            $scope.MAP_OPTIONS.positions.productRestrictions.commuter = true;
                            $scope.MAP_OPTIONS.positions.productRestrictions.lightRail = true;
                        } else {
                            $scope.MAP_OPTIONS.positions.productRestrictions.train = true;
                            $scope.MAP_OPTIONS.positions.productRestrictions.commuter = true;
                            $scope.MAP_OPTIONS.positions.productRestrictions.lightRail = true;
                            $scope.MAP_OPTIONS.positions.productRestrictions.bus = true;
                            $scope.MAP_OPTIONS.positions.filter.showVehiculesWithoutDelay = true;
                        }
                    }

                    // //////////////////////////    contextmenu   ////////////////////////

                    self.mapInstance.on('contextmenu', function(e) {
                        verifyMapPoint(e);
                    });

                    function verifyMapPoint(e) {
                        if (!e || !e.latlng) {
                            return;
                        }

                        MDVLocationRequester.search([e.latlng.lat, e.latlng.lng], {
                            efaParams : {
                                suggestApp : null
                            }
                        }).then(function(res) {
                            if (res.response.length>0) {
                                // TODO really remove previous marker after requesting the new one?
                                // might be better to remove it on click/ start of the request to
                                // signalize the user that something is happening
                                if (self.clickedMarker) {
                                    map.removeLayer(self.clickedMarker);
                                }

                                var opts = {
                                        icon : L.icon({
                                            iconUrl : baseUrl.concat('/assets/images/icons/marker-punktverifizierung.svg'),
                                            iconSize : [40, 40],
                                            popupAnchor : [0, -15]
                                        })
                                    },
                                    marker = L.marker(res.response[0].coord(), opts),
                                    popup = getPopupByLocation(res.response[0]);

                                marker.addTo(map);

                                marker.bindPopup(popup, {
                                    autoPan : true,
                                    keepInView : true,
                                    closeButton : true,
                                    className : 'vvs-map-popup vvs-click'
                                });
                                marker.openPopup();

                                self.clickedMarker = marker;
                            }
                        })
                        .catch(function(error) {
                            console.log(error);
                        });

                    }

                    // ///////////////////////  init live positions icons  ///////////////////////////
                    for (key in VVSConst.iconProductClassMapper) {
                        if (VVSConst.iconProductClassMapper.hasOwnProperty(key)) {
                            livePositionsMarkerCache[key] = L.icon({
                                iconUrl : baseUrl.concat('assets/images/icons/map/positions/' +
                                    VVSConst.iconProductClassMapper[key] + '.svg'),
                                iconSize : [20, 20],
                                popupAnchor : [0, -15]
                            });
                        }
                    }
                    for (key in VVSConst.iconProductClassMapper) {
                        if (VVSConst.iconProductClassMapper.hasOwnProperty(key)) {
                            livePositionsRealTimeMarkerCache[key] = L.icon({
                                iconUrl : baseUrl.concat('assets/images/icons/map/positions/' +
                                    VVSConst.iconProductClassMapper[key] + '-echtzeit.svg'),
                                iconSize : [20, 20],
                                popupAnchor : [0, -15]
                            });
                        }
                    }

                    // ///////////////////////  init stops icons  ////////////////////////////
                    stopsMarkerCache[MDVLocation.LOCATIONTYPES.STOP] = L.icon({
                        iconUrl : baseUrl.concat('assets/images/icons/haltestelle-farbe.svg'),
                        iconSize : [20, 20],
                        popupAnchor : [0, -15]
                    });
                    stopsMarkerCache[MDVLocation.LOCATIONTYPES.ADDRESS] = L.icon({
                        iconUrl : baseUrl.concat('assets/images/icons/address.svg'),
                        iconSize : [20, 20],
                        popupAnchor : [0, -15]
                    });

                    stopsMarkerCache[MDVLocation.LOCATIONTYPES.POI] = L.icon({
                        iconUrl : baseUrl.concat('assets/images/icons/poi.svg'),
                        iconSize : [20, 20],
                        popupAnchor : [0, -15]
                    });


                    // ///////////////////////  init poi icons  ////////////////////////////
                    for (i = 0, l = VVSConst.poiCategories.length; i < l; i += 1) {
                        obj = VVSConst.poiCategories[i];

                        poisMarkerCache[obj.key] = L.icon({
                            iconUrl : baseUrl.concat('assets/images/icons/map/poi/' + obj.icon + '.svg'),
                            iconSize : [40, 40],
                            popupAnchor : [0, -15]
                        });
                    }

                    // //////////////////   Overwrite current position functions  ///////////////////////

                    self.getCurrentLocationMarker = function(locationElem) {
                        var marker = L.marker(locationElem.coord(), {
                            icon : L.icon({
                                iconUrl : baseUrl.concat('assets/images/icons/map/standort-pfeil-rot.svg'),
                                iconSize : [20, 20],
                                popupAnchor : [0, -15]
                            }),
                            zoomToElem : true,
                            zIndexOffset : 700
                        });

                        marker.raw = locationElem;

                        marker.on('click', function() {
                            marker.popup = getPopupByLocation(locationElem, null, 'currentPosition');
                            marker.bindPopup(marker.popup, {
                                autoPan : true,
                                keepInView : true,
                                closeButton : true,
                                className : 'vvs-map-popup vvs-current-position'
                            });
                            marker.openPopup();
                        });

                        return marker;
                    };

                    // //////////////////   Overwrite Stop functions  ///////////////////////
                    coordStopService.setGetMarkerOptions(function(elem) {
                        return {
                            icon : stopsMarkerCache[elem.type()],
                            showPopupOnMouseOver : true
                            // zIndexOffset : -999
                        };
                    });
                    coordStopService.setFilterFunction(function(list) {
                        self.coordStopMarkers = [];
                        return $filter('VVSCoordFilter')(list, $scope.MAP_OPTIONS);
                    });
                    coordStopService.setModifyMarker(function(marker, elem) {
                        marker.raw = elem;

                        //marker.off('mouseover'); // TODO
                        //marker.off('click');

                        marker.on('mouseover', function() {
                            bindPopupToMarker(this);
                            return false;
                        });
                        marker.on('click', function() {
                            bindPopupToMarker(this);
                            return false;
                        });

                        function bindPopupToMarker(markerElem) {
                            marker.popup = getPopupByLocation(elem);
                            marker.bindPopup(marker.popup, {
                                autoPan : true,
                                keepInView : true,
                                closeButton : true,
                                className : 'vvs-map-popup vvs-stop'
                            });
                            marker.openPopup();
                        }

                        bindTooltipToElem(marker, elem.name());
                        if (self.toggleStopName) {
                            marker.openTooltip();
                        } else if (marker.getTooltip()) {
                            marker.closeTooltip();
                        }

                        self.coordStopMarkers.push(marker);
                    });

                    self.stopLayer = coordStopService.getMarkerLayer();

                    function getPoiHierarchyKey(val) {
                        if (Array.isArray(val)) {
                            if (val.length > 0) {
                                if (val.length === 1) {
                                    return val[0];
                                } else {
                                    var i, l;

                                    for (i=0, l=val.length; i<l; i++) {
                                        if (val[i].length === 1) {
                                            return val[i];
                                        }
                                    }
                                }
                            }
                        }
                        return val;
                    }


                    // //////////////////   Overwrite Poi functions  ///////////////////////
                    coordPoiService.setGetMarkerOptions(function(elem) {
                        var icon,
                            hierarchyKey;

                        hierarchyKey = '';
                        if (elem.properties().hasOwnProperty('POI_HIERARCHY_KEY')) {
                            hierarchyKey = getPoiHierarchyKey(elem.properties().POI_HIERARCHY_KEY);
                        } else if (elem.type() === 'sharingProvider') {
                            hierarchyKey = 'M';
                        }

                        if (poisMarkerCache.hasOwnProperty(hierarchyKey)) {
                            icon = poisMarkerCache[hierarchyKey];
                        } else {
                            icon = stopsMarkerCache[elem.LOCATIONTYPES.POI];
                        }
                        return {
                            icon : icon,
                            zIndexOffset : 100
                        };
                    });
                    coordPoiService.setFilterFunction(function(list) {
                        return $filter('VVSCoordFilter')(list, $scope.MAP_OPTIONS);
                    });
                    coordPoiService.setModifyMarker(function(marker, elem) {
                        marker.raw = elem;
                        marker.on('click', function() {
                            marker.popup = getPopupByLocation(elem);
                            marker.bindPopup(marker.popup, {
                                autoPan : true,
                                keepInView : true,
                                closeButton : true,
                                className : 'vvs-map-popup vvs-poi'
                            });
                            marker.openPopup();
                        });
                    });
                    self.poiLayer = coordStopService.getMarkerLayer();

                   /* Overwrite live positions functions  */
                    livePositionsService.setGetMarkerOptions(function(elem) {
                        var delay = elem.properties().delay,
                        realTime = elem.properties().realtimeAvailable,
                        icon;

                        if (realTime && delay>=0) {
                            icon = livePositionsRealTimeMarkerCache[elem.productClass()];
                        }
                        else {
                            icon = livePositionsMarkerCache[elem.productClass()];
                        }

                        return {
                            icon : icon,
                            zIndexOffset : 500
                        };
                    });
                    livePositionsService.setModifyMarker(function(marker, elem) {
                        marker.raw = elem;
                        var delay = elem.properties().delay;

                        if (delay>0) {
                            marker.bindTooltip('+ '+
                                    $filter('VVSTravelledDurationFormatter')(elem.properties().delay, true), {
                                        permanent : true,
                                        direction : 'right',
                                        offset : L.point(5, -4),
                                        opacity : 0.85,
                                        interactive : true,
                                        className : 'vvsMapMarkerTooltip late'
                                    });
                        }

                        marker.on('mouseover', function() {
                            marker.popup = getPopupByLocation(null, elem, 'livePosition');
                            marker.bindPopup(marker.popup, {
                                autoPan : true,
                                keepInView : true,
                                closeButton : true,
                                className : 'vvs-map-popup vvs-live-positions'
                            });
                            marker.openPopup();
                        });
                    });


                    // ////////////////////  WATCHER  ////////////////////////////
                    $scope.$watch('MAP_OPTIONS.positions', function(newVal) {
                        // updateOptions();
                        if (newVal.enable) {
                            livePositionsService.enable();
                        } else {
                            livePositionsService.disable();
                        }
                    }, true);

                    $scope.$watch('MAP_OPTIONS.positions.filter.showVehiculesWithoutDelay', function() {
                        livePositionsService.update();
                    }, true);

                    $scope.$watch('MAP_OPTIONS.stops', function(newVal, oldVal) {
                        if (newVal === oldVal) {
                            return;
                        }
                        coordStopService.enable();
                        coordStopService.update();
                    }, true);

                    $scope.$watch('MAP_OPTIONS.pois', function() {
                        coordPoiService.enable();
                        coordPoiService.update();
                    }, true);
                })
                .catch(function(e) {
                    console.log(e);
                });
        }


        // //////////////////////////// Public Functions //////////////////////////

        function triggerZoomInClick() {
            if ($scope.networkMapActive) {
                self.networkMapInstance.setZoom(self.networkMapInstance.getZoom()+1);
            }
            else {
                self.mapInstance.setZoom(self.mapInstance.getZoom()+1);
            }
        }

        function triggerZoomOutClick() {
            if ($scope.networkMapActive) {
                self.networkMapInstance.setZoom(self.networkMapInstance.getZoom()-1);
            }
            else {
                self.mapInstance.setZoom(self.mapInstance.getZoom()-1);
            }
        }

        function triggerGetCurrentPositionClick() {
            MDVCurrentPosition.get()
                .then(function(loc) {
                    self.mapInstance.addLayer(self.getCurrentLocationMarker(loc));
                })
                .catch(function(err) {
                    console.log(err);
                });
        }

        function handleNetworkMap(id) {
            $scope.networkMapActive = id === 'network';

            // TODO disable all other features here?

            // return true if network map is active, false if not.
            return $scope.networkMapActive;
        }

        function triggerSwitchLayerClick(id) {
            $scope.mapTypePopoverIsOpen = false;

            if (handleNetworkMap(id)) {
                // do nothing with other maps if network is active
                return;
            }

            if (!id) {
                id = $scope.MAP_OPTIONS.layers.type;
            }
            var overlays = [];

            if ($scope.MAP_OPTIONS.layers.lines) {
                overlays.push('vlp');
            } else {
                overlays.push('orthoOverlay');
            }

            try {
                self.mapInstance.switchLayer(id, overlays);
            } catch (e) {
                self.mapInstance.switchLayer('gis', overlays);
            }
        }

        function triggerPrintMapClick() {
            if (mode === 'line' && line) {
                var efaParams;

                if (date && date._isAMomentObject) {
                    efaParams = {
                        dateDay : date.format("YYYYMMDD")
                    }
                }
                MDVDownload.search(MDVDownload.requestTypes.ROUTE_OPTION_PLAN, {
                    lineId : line.id(),
                    efaParams : efaParams
                })
                .then(function(res) {
                    if (res.response) {
                        VVSPdfViewer.show(res.response);
                    }
                })
                .catch(function(err) {
                    console.log(err);
                });
            } else if (mode === 'leg' && leg) {
                MDVDownload.search(MDVDownload.requestTypes.ROUTE_OPTION_PLAN, {
                    lineId : leg.transportation().id()
                })
                .then(function(res) {
                    if (res.response) {
                        VVSPdfViewer.show(res.response);
                    }
                })
                .catch(function(err) {
                    console.log(err);
                });
            } else if (mode === 'trip' && trip && leg && location) {
                MDVDownload.search(MDVDownload.requestTypes.MAPROUTE, {
                    journey : trip,
                    leg : leg,
                    location : location,
                    efaParams : {
                        serverInfo : 1
                    }
                }).then(function(res) {
                    if (res.response) {
                        VVSPdfViewer.show(res.response);
                    }
                })
                .catch(function(err) {
                    console.log(err);
                });
            } else if (mode === 'trip' && trip) {
                MDVDownload.search(MDVDownload.requestTypes.MAPROUTE, {
                    journey : trip,
                    efaParams : {
                        serverInfo : '1'
                    }
                })
                .then(function(res) {
                    if (res.response) {
                        VVSPdfViewer.show(res.response);
                    }
                })
                .catch(function(err) {
                    console.log(err);
                });
            }
        }

        function triggerToggleStopName() {
            $scope.markerSet.forEach(function(marker) {

                if (self.toggleStopName) {
                    bindTooltipToElem(marker, marker.tooltipName);
                }
                else if (marker.getTooltip()) {
                    marker.closeTooltip();
                }
            });


            if (!self.coordStopMarkers) {
                return;
            }

            function toggleStopName(marker) {
                if (self.toggleStopName) {
                    marker.openTooltip();
                } else {
                    marker.closeTooltip();
                }
            }

            angular.forEach(self.coordStopMarkers, function(item) {
                toggleStopName(item);
            });
        }

        function triggerLivePositionUpdate() {
            livePositionsService.update();
        }

    }
  }());

(function() {
  'use strict';

  angular
      .module('vvs')
      .controller('VVSLivemapController', VVSLivemapController);

  VVSLivemapController.$inject = ['$scope'];

  function VVSLivemapController($scope) {
      $scope.gotoFullscreen = function() {
        var map = document.querySelector('.iframe-map');
            // self.isFS = true;
            map.requestFullscreen().then(function() {
                console.log('element has entered fullscreen mode successfully');
            })
            .catch(function(err) {
                console.log(err.message);
            });
      };

  }

}());
(function() {
    'use strict';


    angular
        .module('vvs')
        .filter('VVSInfoTimeTableChangeFilter', VVSInfoTimeTableChangeFilter);

    VVSInfoTimeTableChangeFilter.$inject = ['$filter', 'VVSConst'];

    function VVSInfoTimeTableChangeFilter($filter, VVSConst) {
        return function(infos) {
            var toReturn = {},
                groupedByValidityFrom = $filter('VVSInfoGroupByValidityFrom')(angular.copy(infos));

            for (var key in groupedByValidityFrom) {
                if (groupedByValidityFrom.hasOwnProperty(key)) {
                    var infosVF = groupedByValidityFrom[key],
                        groupedByProductIconId = $filter('VVSInfoGroupByProductIconId')(angular.copy(infosVF)),
                        sortedKeys = Object.keys(VVSConst.iconProductIconIdGrouping);

                    for (var i=0; i<sortedKeys.length; i++) {
                        var key2 = sortedKeys[i];

                        if (groupedByProductIconId.hasOwnProperty(key2)) {
                            var infosPC = groupedByProductIconId[key2],
                                sortedByLineNumber = $filter('VVSInfoSortByLineNumber')(angular.copy(infosPC));

                            if (!toReturn.hasOwnProperty(key)) {
                                toReturn[key] = [];
                            }
                            toReturn[key] = toReturn[key].concat(sortedByLineNumber);
                        }
                    }

                }
            }

            return toReturn;
        };
    }


    angular
        .module('vvs')
        .filter('VVSInfoDisruptionFilter', VVSInfoDisruptionFilter);

    VVSInfoDisruptionFilter.$inject = ['$filter', 'VVSConst'];

    function VVSInfoDisruptionFilter($filter, VVSConst) {
        return function(infos) {
            if (infos.length<2) {
                return infos;
            }

            var result = [],
                groupedInfos = $filter('VVSInfoTimeTableChangeFilter')(angular.copy(infos));

            for (var key in groupedInfos) {
                if (groupedInfos.hasOwnProperty(key)) {
                    result = result.concat(groupedInfos[key]);
                }
            }
            return result;
        };
    }


    angular
        .module('vvs')
        .filter('VVSInfoSpecialTrafficFilter', VVSInfoSpecialTrafficFilter);

    VVSInfoSpecialTrafficFilter.$inject = ['$filter'];

    function VVSInfoSpecialTrafficFilter($filter) {
        return function(infos) {
            return infos.sort(function(a, b) {
                return a.validityFrom() > b.validityFrom();
            });
        };
    }


    angular
        .module('vvs')
        .filter('VVSInfoEscalatorElevatorFilter', VVSInfoEscalatorElevatorFilter);

    VVSInfoEscalatorElevatorFilter.$inject = ['$filter'];

    function VVSInfoEscalatorElevatorFilter($filter) {
        return function(infos) {
            return infos.sort(function(a, b) {
                var aTitle = a.title().replace('Haltestelle ', '').toUpperCase(),
                    bTitle = b.title().replace('Haltestelle ', '').toUpperCase();
                return (aTitle < bTitle) ? -1 : (aTitle > bTitle) ? 1 : 0;
            });
        };
    }



    angular
        .module('vvs')
        .filter('VVSInfoGroupByValidityFrom', VVSInfoGroupByValidityFrom);

    VVSInfoGroupByValidityFrom.$inject = [];

    function VVSInfoGroupByValidityFrom() {
        return function(infos) {
            var actualInfos = [],
                futureInfos = [];

            for (var i = 0; i < infos.length; i++) {
                var info = infos[i],
                    now = Date.now();

                if (now < info.validityFrom()) {
                    futureInfos.push(info);
                } else {
                    actualInfos.push(info);
                }
            }

            return {
                actual: actualInfos,
                future: futureInfos
            };
        };
    }

    angular
        .module('vvs')
        .filter('VVSInfoGroupByProductIconId', VVSInfoGroupByProductIconId);

    VVSInfoGroupByProductIconId.$inject = ['$filter', 'VVSConst'];

    function VVSInfoGroupByProductIconId($filter, VVSConst) {
        return function(infos) {
            var mapping = VVSConst.iconProductIconIdGrouping,
                result = {};

            for (var i = 0; i < infos.length; i++) {
                var info = infos[i],
                    found = false;
                if (info.affectedLines().length > 0) {
                    for (var j = 0; j < info.affectedLines().length; j++) {
                        var affectedLine = info.affectedLines()[j];

                        for (var key in mapping) {
                            if (mapping.hasOwnProperty(key)) {
                                if (mapping[key].indexOf(affectedLine.productIconId()) > -1) {
                                    if (!result.hasOwnProperty(key)) {
                                        result[key] = [];
                                    }
                                    result[key].push(info);
                                    found = true;
                                    break;
                                }
                            }
                        }
                        if (found) {
                            break;
                        }
                    }
                }
            }



            return result;
        };
    }



    angular
        .module('vvs')
        .filter('VVSInfoSortByLineNumber', VVSInfoSortByLineNumber);

    VVSInfoSortByLineNumber.$inject = [];

    function VVSInfoSortByLineNumber() {
        return function(infosArr) {

            infosArr.sort(function(a, b) {
                var aLine = (a.affectedLines().length > 0) ? a.affectedLines()[0] : null,
                    bLine = (b.affectedLines().length > 0) ? b.affectedLines()[0] : null,
                    aNumber = parseInt(aLine.number()),
                    bNumber = parseInt(bLine.number());

                if (isNaN(aNumber)) {
                    return 1;
                }

                if (isNaN(bNumber)) {
                    return -1;
                }

                if (isNaN(aNumber) && isNaN(bNumber)) {
                    return 0;
                }


                return aNumber<bNumber ? -1 : aNumber>bNumber ? 1 : 0;
            });

            return infosArr;
        };
    }



    angular
        .module('vvs')
        .filter('VVSInfoFilterByLineProductIconId', VVSInfoFilterByLineProductIconId);

    VVSInfoFilterByLineProductIconId.$inject = ['VVSConst'];

    function VVSInfoFilterByLineProductIconId(VVSConst) {
        return function(infosArr, key) {
            var mapping = VVSConst.iconProductIconIdGrouping,
                result = [];

            if (!mapping.hasOwnProperty(key)) {
                return [];
            }
            for (var i = 0; i < infosArr.length; i++) {
                var info = infosArr[i];

                if (info.affectedLines().length > 0) {
                    for (var j = 0; j < info.affectedLines().length; j++) {
                        var affectedLine = info.affectedLines()[j];

                        if (mapping[key].indexOf(affectedLine.productIconId()) > -1) {
                            result.push(info);
                            break;
                        }
                    }
                }
            }

            return result;
        }
    }


    angular
        .module('vvs')
        .filter('VVSInfoFilterByLineName', VVSInfoFilterByLineName);

    VVSInfoFilterByLineName.$inject = [];

    function VVSInfoFilterByLineName() {
        return function(infos, str) {
            var result = {};

            for (var k in infos) {
                if (infos.hasOwnProperty(k)) {
                    var infosArr = infos[k];

                    for (var i = 0; i < infosArr.length; i++) {
                        var info = infosArr[i];

                        if (info.affectedLines().length > 0) {
                            for (var j = 0; j < info.affectedLines().length; j++) {
                                var affectedLine = info.affectedLines()[j],
                                    number = affectedLine.number().replace(/ /g, '').toLowerCase(),
                                    match = str.replace(/ /g, '').toLowerCase();

                                if (number.match(new RegExp(match))) {
                                    if (!result.hasOwnProperty(k)) {
                                        result[k] = [];
                                    }
                                    result[k].push(info);
                                    break;
                                }
                            }
                        }
                    }
                }
            }
            return result;
        }
    }


    angular
        .module('vvs')
        .filter('VVSInfoCleanLocationName', VVSInfoCleanLocationName);

    VVSInfoCleanLocationName.$inject = [];

    function VVSInfoCleanLocationName() {
        return function(name) {
            if (name && (name.indexOf('_poiID') > -1)) {
                return name.substring(0, name.indexOf('_poiID'))
            }
            return name;
        };
    }


    angular
        .module('vvs')
        .filter('VVSInfoSpecialTraficLogo', VVSInfoSpecialTraficLogo);

    VVSInfoSpecialTraficLogo.$inject = [];

    function VVSInfoSpecialTraficLogo() {
        return function(html) {
            if (!html) {
                return;
            }
            var td = "<td class=\"AddInfoLines\" valign=\"top\">",
                ubahnReg = new RegExp(td + 'Stadtbahnlinie', 'g'),
                sbahnReg = new RegExp(td + 'S-Bahn-Linie', 'g'),
                busReg = new RegExp(td + 'Bus-Linie', 'g');

            html = html.replace(ubahnReg, td + '<svg class="icon icon-ubahn"><use xlink:href="images/icons/symbol-defs.svg#icon-ubahn"/></svg>');
            html = html.replace(sbahnReg, td + '<svg class="icon icon-sbahn"><use xlink:href="images/icons/symbol-defs.svg#icon-sbahn"/></svg>');
            html = html.replace(busReg, td + '<svg class="icon icon-bus"><use xlink:href="images/icons/symbol-defs.svg#icon-bus"/></svg>');

            return html;
        };
    }


}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSInfoController', VVSInfoController);

    VVSInfoController.$inject = [];

    function VVSInfoController() {

    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .filter('VVSDMGroupedDepArrs', VVSDMGroupedDepArrs);

    VVSDMGroupedDepArrs.$inject = ['VVSConst'];

    function VVSDMGroupedDepArrs(VVSConst) {
        return function(depArrs) {
            var grouping = VVSConst.iconProductIconIdGrouping,
                groupedDepArrs = {},
                mots,
                key,
                i;

            for (i = 0; i < depArrs.length; i += 1) {
                for (key in grouping) {
                    if (grouping.hasOwnProperty(key)) {
                        mots = grouping[key];
                        if (mots.indexOf(depArrs[i].transportation().productIconId()) > -1) {
                            if (!groupedDepArrs.hasOwnProperty(key)) {
                                groupedDepArrs[key] = [];
                            }
                            if (!isDuplikateLine(groupedDepArrs[key], depArrs[i])) {
                                groupedDepArrs[key].push(depArrs[i]);
                            }
                            break;
                        }
                    }
                }
            }

            var orderedDepArrs = {};

            for (key in grouping) {
                if (grouping.hasOwnProperty(key)) {
                    if (groupedDepArrs.hasOwnProperty(key)) {
                        orderedDepArrs[key] = groupedDepArrs[key];
                    }
                }
            }
            return orderedDepArrs;
        };

        function isDuplikateLine(depArrs, depArr) {
            var i;

            for (i = 0; i < depArrs.length; i += 1) {
                if (depArrs[i].transportation().id() === depArr.transportation().id()) {
                    return true;
                }
            }
            return false;
        }
    }


    angular
        .module('vvs')
        .filter('VVSDMOrderLines', VVSDMOrderLines);

    function VVSDMOrderLines() {
        return function(lines) {
            var res = angular.copy(lines);

            res.sort(function(a, b) {
                if (a.transportation().number() < b.transportation().number()) {
                    return -1;
                } else if (a.transportation().number() > b.transportation().number()) {
                    return 1;
                }
                return 0;
            });
            return res;
        };
    }


    angular
        .module('vvs')
        .filter('VVSDMLinesFilter', VVSDMLinesFilter);

    function VVSDMLinesFilter() {
        return function(lines, filterLinesObj) {
            if (!lines || !filterLinesObj) {
                return lines;
            }

            var categoryKey,
                lineKey;

            for (var i = 0; i < lines.length; i++) {
                for (categoryKey in filterLinesObj) {
                    if (filterLinesObj.hasOwnProperty(categoryKey)) {
                        for (lineKey in filterLinesObj[categoryKey].lines) {
                            if (filterLinesObj[categoryKey].lines.hasOwnProperty(lineKey)) {
                                if (lineKey === lines[i].transportation().id()) {
                                    lines[i].hideInDmList = !filterLinesObj[categoryKey].lines[lineKey].enabled;
                                    break;
                                }
                            }
                        }
                    }
                }
            }

            return lines;
        };
    }

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSDMController', VVSDMController);

    VVSDMController.$inject = ['$scope', '$state', 'mng-comm.MDVDepartures', 'mng-comm.MDVArrivals',
        'mng-comm.MDVLocationRequester', 'mng-model.MDVLocation',
        'mng-favorite.MDVOptionsFavorite', 'VVSDeepLinking', 'mng-common.MDVUriParams', '$location'];

    function VVSDMController($scope, $state, MDVDepartures, MDVArrivals,
            MDVLocationRequester, MDVLocation, MDVOptionsFavorite, VVSDeepLinking, MDVUriParams, $location) {
        var url = window.location.href;

        $scope.$on('DM', function(events, args){
            $scope.inputLocations = {};
            var locationSearch = $location.search();
            delete locationSearch.deeplink;
            MDVUriParams.clear('deeplink');
            $scope.tabIndex = args;
        });

        var self = this;

        self.triggerFocus = triggerFocus;

        var _private = {
            efaParams : null
        };

        function triggerFocus() {
        }

        $scope.goToMap = function() {
            window.open('https://www.vvs.de/karten-plaene/haltestellenkarten/', '_blank');
        }

        $scope.triggerROPResetClick = function() {
            // $state.go('vvs.stops.rop', {}, {
            $state.go('vvs.stops.ropstops', {}, {
                reload : true
            });
        }

        $scope.$watch('SEARCH_OPTIONS.dateTime.isDeparture', function(newVal, oldVal) {
            if (oldVal === newVal) {
                return;
            }

            if (newVal) {
                $scope.dmObj.service = new MDVDepartures();
                $scope.SEARCH_OPTIONS = $scope.dmObj.service.getOptions();
            } else {
                $scope.dmObj.service = new MDVArrivals();
                $scope.SEARCH_OPTIONS = $scope.dmObj.service.getOptions();
            }
        }, true);

        // $scope.$watch('tabIndex', function(newVal, oldVal) {
        //     console.log('check changing of tabIndex', newVal);
        // });

        $scope.showHistory = true;

        $scope.triggerFireDMClick = function(isDeepLink) {
            var userInputs = {},
                promises = [],
                key;

            $scope.dmAlert = false;

            userInputs.dm = angular.copy($scope.inputLocations.dm || $scope.inputLocationsValues.dm);

            if (!userInputs.dm) {
                $scope.dmAlert = true;
                return false;
            }

            for (key in userInputs) {
                if (userInputs.hasOwnProperty(key) && (typeof userInputs[key] === 'string')) {
                    promises.push(verifyOdv(key).promise);
                } else if ((typeof userInputs[key] === 'object') &&
                            (userInputs[key].type() !== MDVLocation.LOCATIONTYPES.STOP)) {
                    userInputs[key] = userInputs[key].id();
                    promises.push(verifyOdv(key).promise);
                }
            }

            // console.log('assignedStops', $scope.inputLocations.dm.assignedStops());
            // if ($scope.inputLocations.dm.assignedStops().length > 1) {
            //     $scope.showHistory = false;
            // }

            function verifyOdv(usage) {
                return MDVLocationRequester.search(userInputs[usage], {efaParams: _private.efaParams})
                        .then(function(result) {
                            if (result.response.length>0) {
                                $scope.inputLocations[usage] = angular.copy(result.response[0]);
                                userInputs[usage] = angular.copy(result.response[0]);
                            }
                            tryFireSearch();
                        }, function() {
                            tryFireSearch();
                        });
            }

            if (promises.length === 0) {
                fireSearch();
            }

            function tryFireSearch() {
                promises.pop();
                if (promises.length === 0) {
                    fireSearch();
                }
            }

            function fireSearch() {
                console.log('fire search');
                var assignedStops = userInputs.dm.assignedStops();

                if (isDeepLink) {
                    // $state.go('vvs.dm.lines');
                    $state.go('vvs.stops.lines');
                } else {
                    if (assignedStops.length <= 1) {
                        MDVLocationRequester.search(userInputs.dm.id(), {efaParams: _private.efaParams})
                            .then(function(result) {
                                if (result.response.length>0) {
                                    $scope.inputLocations.dm = angular.copy(result.response[0]);
                                    userInputs.dm = angular.copy(result.response[0]);

                                    assignedStops = userInputs.dm.assignedStops();
                                    if (assignedStops.length<=1) {
                                        $state.go('vvs.stops.lines');
                                        // $state.go('vvs.dm.lines');
                                    }
                                }
                            });
                    }
                }

            }
        };

        $scope.triggerSelectAssignedStopClick = function(location, all) {
            if (all) {
                $scope.dmObj.service.getOptions().efaParams = {deleteAssignedStops : 0};
            } else {
                $scope.dmObj.service.getOptions().efaParams = {deleteAssignedStops : 1};
            }
            $scope.inputLocations.dm = angular.copy(location);
            $scope.showHistory = true;
            $state.go('vvs.stops.lines');
            // $state.go('vvs.dm.lines');
        };


        function initController() {
            $scope.dmObj = {
                service : new MDVDepartures(),
                linesFilter : {},
                depArrs : []
            };
            $scope.dmObj.service.reset();

            $scope.SEARCH_OPTIONS = $scope.dmObj.service.getOptions();

            $scope.inputLocations = {};
            $scope.inputLocationsValues = {};



            if (url.includes('DM')) {
                $scope.tabIndex = 0;
            } else if (url.includes('STT')) {
                $scope.tabIndex = 1;
            } else if (url.includes('ROP')) {
                $scope.tabIndex = 2;
            }
            else if (url.includes('_MAP_')) { // überlegen warum from 'livemap' hängt bei map
                $scope.tabIndex = 3;
            }

            var deeplinkOptions = VVSDeepLinking.generateOptionsFromDeeplink();


            if (deeplinkOptions) {
                _private.efaParams = deeplinkOptions.efaParams;
                MDVOptionsFavorite.updateOptionsReference($scope.SEARCH_OPTIONS, deeplinkOptions);
                $scope.inputLocations.dm = deeplinkOptions.odvs.dm;
                // $scope.inputLocations.stt = deeplinkOptions.odvs.stt;
                if ($scope.inputLocations.dm) {
                    $scope.triggerFireDMClick(true);
                }
            }


        }
        initController();

    }

}());

(function() {
    'use strict';

    angular.module('vvs')
        .factory('VVSCommonService', VVSCommonService);

    VVSCommonService.$inject = ['$window', '$state'];

    function VVSCommonService($window, $state) {
        return {
            getTabIndex : getTabIndex
        }
        function getTabIndex() {
            // verbindungen = 'vvs.trip.init'
            // Haltestellen = 'vvs.stops.init'
            // Linien = 'vvs.stops.init'
            var url = $window.location.href;
            console.log('url', url );
            console.log('$state cur name', $state.current);
            return url;
        }
    };

}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSCommonFooterController', VVSCommonFooterController);

    VVSCommonFooterController.$inject = ['$scope', '$http', '$anchorScroll', 'VVSCommonService'];

    function VVSCommonFooterController($scope, $http, $anchorScroll, VVSCommonService) {
        var self = this;

        $scope.onStopsTabClick = function() {
            console.log('stops click');
        }

        $http.get('/mngvvs/XML_REQUEST?outputFormat=json&serverInfo=1&version=10.2.2.48')
            .then(function(response) {
                if (response && response.data) {
                    var data = response.data;

                    if (data.parameters) {
                        var params = data.parameters,
                            i, l;

                        for (var i=0, l=params.length; i<l; i++) {
                            var param = params[i];

                            if (param.name === 'serverID') {
                                self.serverID = param.value;
                            }
                        }
                    }

                }
            });

        self.gotoTop = function() {
            $anchorScroll('vvs_body');
        };
    }
}());

(function() {
    'use strict';

    angular.module('vvs')
        .factory('VVSBrowserUtilities', VVSBrowserUtilities);

    VVSBrowserUtilities.$inject = ['$window'];

    function VVSBrowserUtilities($window) {


        return {
            isIEBrowser : isIEBrowser,
            getMobileOperatingSystem : getMobileOperatingSystem,
            getBrowserName : getBrowserName,
            supportPlugin : supportPlugin
        };

        function supportPlugin(pluginName) {
            if (!window || !window.navigator || !window.navigator.plugins) {
                return false;
            }

            for (var i=0; i<window.navigator.plugins.length; i++) {
                if (window.navigator.plugins[i].name === pluginName) {
                    return true;
                }
            }

            return false;
        }

        function isIEBrowser() {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
        }


        function getMobileOperatingSystem() {
            var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;

              // Windows Phone must come first because its UA also contains "Android"
            if (/windows phone/i.test(userAgent)) {
                return "Windows";
            }

            if (/android/i.test(userAgent)) {
                return "Android";
            }

            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }

            return "unknown";
        }


        function getBrowserName() {
            var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;

            if (/Chrome/i.test(userAgent)) {
                return "Chrome";
            }

            if (/Firefox/i.test(userAgent)) {
                return "Firefox";
            }

        }

    }


}());

(function() {
    'use strict';

    angular
        .module('external', ['ui.router', 'ct.ui.router.extras.sticky', 'pascalprecht.translate', 'angularMoment', 'angular.filter', 'base64', 'piwik']);

    angular
        .module('angular-mdv', ['mng', 'vvs', 'external']);

})();

(function() {
    'use strict';

    /**
     * A state corresponds to a "place" in the application in terms of the overall UI and navigation.
     * A state describes (via the controller / template / view properties) what the UI looks like
     * and does at that place. States often have things in common, and the primary way of factoring
     * out these commonalities in this model is via the state hierarchy, i.e. parent/child states aka nested states.
     * The $stateProvider provides interfaces to declare these states for your app.
     **/

    angular
        .module('angular-mdv')
        .config(['VVSConst', '$stateProvider', '$urlRouterProvider', '$locationProvider', '$stickyStateProvider',
                function(VVSConst, $stateProvider, $urlRouterProvider, $locationProvider, $stickyStateProvider) {
            var baseUrlPrefix = VVSConst.baseUrl ? VVSConst.baseUrl : '';

            $stateProvider.state('vvs', {
                url: '',
                redirectTo: 'vvs.trip.init',
                templateUrl: baseUrlPrefix.concat('main.html')
            });

            // ############################### TRIP ########################### //

            $stateProvider
                .state('vvs.trip', {
                    id : 'trip',
                    url: '/XSLT_TRIP_REQUEST2',
                    sticky: true,
                    dsr: true,
                    redirectTo: 'vvs.trip.init',
                    views: {
                        'trip' : {
                            templateUrl: baseUrlPrefix.concat('trip/main.html'),
                            controller: 'VVSTripController',
                            controllerAs: 'tripCtrl'
                        }
                    }
                });

            $stateProvider
                .state('vvs.trip.init', {
                    piwikTitle : 'VVS Auskunft: Verbindungen',
                    id : 'trip',
                    reset : true,
                    url: '@init',
                    templateUrl: baseUrlPrefix.concat('trip/init/main.html'),
                    controller: 'VVSTripInitController',
                    controllerAs: 'tripInitCtrl',
                    params: {
                        orig : {
                            value : {}
                        },
                        dest : {
                            value : {}
                        },
                        via : {
                            value : {}
                        }
                    }
                });

            $stateProvider
                .state('vvs.trip.result', {
                    piwikTitle : 'VVS Auskunft: Fahrtempfehlung',
                    id : 'trip',
                    url: '@result',
                    templateUrl: baseUrlPrefix.concat('trip/result/main.html'),
                    controller: 'VVSTripResultController',
                    controllerAs: 'tripResultCtrl'
                });

            $stateProvider
                .state('vvs.trip.details', {
                    piwikTitle : 'VVS Auskunft: Fahrtdetails',
                    id : 'trip',
                    url : '@details',
                    templateUrl: baseUrlPrefix.concat('trip/result/details/main.html'),
                    controller: 'VVSTripDetailsController',
                    controllerAs: 'tripDetailsCtrl',
                    params : {
                        index: {
                            value: 0
                        },
                        isFirst: {
                            value: false
                        },
                        isLast: {
                            value: false
                        }
                    }
                });

            $stateProvider
                .state('vvs.trip.print', {
                    piwikTitle : 'VVS Auskunft: Druckansicht Fahrtempfehlung Übersicht',
                    id : 'trip',
                    url: '@print',
                    templateUrl: baseUrlPrefix.concat('trip/result/print/main.html'),
                    controller: 'VVSTripResultPrintController',
                    controllerAs: 'tripPrintCtrl',
                    params : {
                        trips : {
                            value : []
                        },
                        SEARCH_OPTIONS : {
                            value : {}
                        }
                    }
                });

            // ############################### DM ########################### //
            // $stateProvider
            //     .state('vvs.dm', {
            //         id : 'dm',
            //         url: '/XSLT_DM_REQUEST',
            //         sticky: true,
            //         dsr: true,
            //         views: {
            //             'dm': {
            //                 templateUrl: baseUrlPrefix.concat('dm/main.html'),
            //                 controller: 'VVSDMController'
            //             }
            //         }
            //     });


            $stateProvider
                .state('vvs.dm.init', {
                    piwikTitle : 'VVS Auskunft: Abfahrt / Ankunft',
                    id : 'dm',
                    reset : true,
                    url : '@init',
                    templateUrl: baseUrlPrefix.concat('dm/init/main.html'),
                    controller: 'VVSDMInitController',
                    params: {
                        dm : {
                            value : {}
                        }
                    }
                });

            $stateProvider
                .state('vvs.dm.lines', {
                    piwikTitle : 'VVS Auskunft: Abfahrt / Ankunft Ergebnis',
                    id : 'dm',
                    url: '@lines',
                    templateUrl: baseUrlPrefix.concat('dm/lines/main.html'),
                    controller: 'VVSDMLinesController'
                });

            // ############################### STOPS ########################### //
            $stateProvider
                .state('vvs.stops', {
                    id : 'stops',
                    url: '/',
                    // url: '/XSLT_DM_REQUEST',
                    sticky: true,
                    dsr: true,
                    redirectTo: 'vvs.stops.init',
                    views: {
                        'stops': {
                            templateUrl: baseUrlPrefix.concat('dm/main.html'),
                            controller: 'VVSDMController'
                        }
                    }
                });
                // Abfahrt - Init - Form
            $stateProvider
                .state('vvs.stops.init', {
                    piwikTitle : 'DM FORM',
                    id : 'stops',
                    url: 'XSLT_DM_REQUEST@init',
                    // url: '@init',
                    sticky: true,
                    dsr: true,
                    templateUrl: baseUrlPrefix.concat('dm/init/dm.html'),
                    controller: 'VVSDMInitController',
                    params: {
                        stops : {
                            value : {}
                        }
                    }
                });
                // Abfahrt Result
            $stateProvider
            .state('vvs.stops.lines', {
                piwikTitle : 'VVS Auskunft: Abfahrt / Ankunft Ergebnis',
                id : 'stops',
                url: 'XSLT_DM_REQUEST@lines',
                // url: '@lines',
                templateUrl: baseUrlPrefix.concat('dm/lines/main.html'),
                controller: 'VVSDMLinesController'
            });

            // stt
            $stateProvider
                .state('vvs.stops.stt', {
                    id : 'stops',
                    url: '/',
                    sticky: true,
                    dsr: true,
                    redirectTo: 'vvs.stops.sttinit',
                    views: {
                        'stt': {
                            templateUrl: baseUrlPrefix.concat('stt/main.html'),
                            controller: 'VVSSTTController'
                        }
                    }
                });

            $stateProvider
                .state('vvs.stops.sttinit', {
                    piwikTitle : 'VVS Auskunft: Aushangfahrplan',
                    id : 'stops',
                    reset : true,
                    url: 'XSLT_STT_REQUEST@init',
                    templateUrl: baseUrlPrefix.concat('stt/init/stops.html'),
                    controller: 'VVSSTTInitController',
                    params: {
                        stops : {
                            value : {}
                        }
                    }
                });
            $stateProvider
                .state('vvs.stops.sttlines', {
                    piwikTitle : 'VVS Auskunft: Aushangfahrplan Ergebnisse nach Linien',
                    id : 'stops',
                    reset : true,
                    url: 'XSLT_STT_REQUEST@lines',
                    templateUrl: baseUrlPrefix.concat('stt/stops/lines/main.html')
                });

            //rop - stadtplanauschnitt
            $stateProvider
                .state('vvs.stops.rop', {
                    id : 'stops',
                    url: '/',
                    sticky: true,
                    dsr: true,
                    redirectTo: 'vvs.stops.ropstops',
                    views: {
                        'stops': {
                            templateUrl: baseUrlPrefix.concat('rop/main.html')
                        }
                    }
                });
            $stateProvider
                .state('vvs.stops.ropstops', {
                    id : 'stops',
                    url: 'XSLT_ROP_REQUEST@stops',
                    sticky: true,
                    dsr: true,
                    reset: true,
                    templateUrl: baseUrlPrefix.concat('rop/stops/main.html'),
                    controller: 'VVSROPStopController',
                    params: {
                        rop : {
                            value : {}
                        }
                    }
                });
            // stops - map
            $stateProvider
                .state('vvs.stops.test', {
                    id : 'stops',
                    url: 'XSLT_MAP_REQUEST',
                    sticky: true,
                    dsr: true,
                    templateUrl: baseUrlPrefix.concat('map/stopsmap.html'),
                });

            // ############################### LINES ########################### //
            $stateProvider
                .state('vvs.lines', {
                    id : 'lines',
                    url: '/',
                    sticky: true,
                    dsr: true,
                    redirectTo: 'vvs.lines.rop',
                    views: {
                        'lines': {
                            templateUrl: baseUrlPrefix.concat('rop/lines/tabs.html'),
                            controller: 'VVSROPLineController'
                        }
                    }
                });

            $stateProvider
                .state('vvs.lines.rop', {
                    piwikTitle : 'LINIEN FORM',
                    id : 'lines',
                    url: 'XSLT_ROP_REQUEST',
                    // url: '@init',
                    templateUrl: baseUrlPrefix.concat('rop/lines/main.html'),
                    controller: 'VVSROPLineController',
                    controllerAs: 'VVSROPLineCtrl',
                    // redirectTo: 'vvs.lines.rop.init',
                    params: {
                        rop : {
                            value : {}
                        }
                    }
                });
            $stateProvider
                .state('vvs.lines.ttb', {
                    piwikTitle : 'VVS Auskunft: Linien',
                    id : 'lines',
                    url: 'XSLT_TTB_REQUEST@init',
                    templateUrl: baseUrlPrefix.concat('ttb/lines/main.html'),
                    controller: 'VVSTTBInitController'
                });

                $stateProvider
                .state('vvs.lines.lfp', {
                    piwikTitle : 'VVS Auskunft: Linien',
                    id : 'lines',
                    url: 'XSLT_TTB_REQUEST@init&lfp=true',
                    templateUrl: baseUrlPrefix.concat('ttb/lines/main.html'),
                    controller: 'VVSTTBInitController',
                    params: {
                        lfp : true
                    }
                });

        $stateProvider
            .state('vvs.lines.ropresult', {
                piwikTitle : 'VVS Auskunft: Linien RESULT',
                id : 'lines',
                url: 'XSLT_ROP_REQUEST@result',
                templateUrl: baseUrlPrefix.concat('rop/lines/result.html'),
                controller: 'VVSROPLineController',
                controllerAs: 'VVSROPLineCtrl'
            });


            // $stateProvider
            //     .state('vvs.lines.ropp', {
            //         piwikTitle : 'VVS Auskunft: Linien',
            //         id : 'lines',
            //         url: 'XSLT_ROP_REQUEST@init',
            //         templateUrl: baseUrlPrefix.concat('rop/lines/mainn.html'),
            //         controller: 'VVSROPLineController',
            //         controllerAs: 'VVSROPLineCtrl',
            //         params: {
            //             rop : {
            //                 value : {}
            //             }
            //         }
            //     });
            // $stateProvider
            //     .state('vvs.lines.rop.map', {
            //         piwikTitle : 'VVS Auskunft: Linien',
            //         id : 'lines',
            //         url: 'XSLT_ROP_REQUEST@map',
            //         templateUrl: baseUrlPrefix.concat('rop/lines/init.html'),
            //         controller: 'VVSROPLineController',
            //         controllerAs: 'VVSROPLineCtrl'
            //     });

            // LIVEMAP
            $stateProvider
                .state('vvs.livemap', {
                    id : 'livemap',
                    url: '/XSLT_LIVEMAP_REQUEST',
                    sticky: true,
                    dsr: true,
                    views: {
                        'livemap': {
                            templateUrl: baseUrlPrefix.concat('map/livemap.html'),
                            controller: 'VVSLivemapController'
                        }
                    }
                });

            $stateProvider
                .state('vvs.livemap.init', {
                    piwikTitle : 'VVS Auskunft: Meldungen Überischt',
                    id : 'livemap',
                    url : '@init',
                    templateUrl: baseUrlPrefix.concat('info/init/main.html'),
                    controller: 'VVSInfoInitController'
                });



            // ############################### Info ########################### //
            // $stateProvider
            //     .state('vvs.info', {
            //         id : 'info',
            //         url: '/XSLT_INFO_REQUEST',
            //         sticky: true,
            //         dsr: true,
            //         views: {
            //             'info': {
            //                 templateUrl: baseUrlPrefix.concat('info/main.html'),
            //                 controller: 'VVSInfoController'
            //             }
            //         }
            //     });

            // $stateProvider
            //     .state('vvs.info.init', {
            //         piwikTitle : 'VVS Auskunft: Meldungen Überischt',
            //         id : 'info',
            //         url : '@init',
            //         templateUrl: baseUrlPrefix.concat('info/init/main.html'),
            //         controller: 'VVSInfoInitController'
            //     });

            // $stateProvider
            //     .state('vvs.info.disruption', {
            //         piwikTitle : 'VVS Auskunft: Störungen Übersicht',
            //         id : 'info',
            //         url : '@disruption',
            //         templateUrl: baseUrlPrefix.concat('info/disruption/main.html'),
            //         controller: 'VVSInfoDisruptionController'
            //     });

            // $stateProvider
            //     .state('vvs.info.disruptionDetails', {
            //         piwikTitle : 'VVS Auskunft: Störungen Details',
            //         id : 'info',
            //         url : '@disruptionDetails',
            //         templateUrl: baseUrlPrefix.concat('info/disruption/details.html'),
            //         controller: 'VVSInfoDisruptionDetailsController',
            //         params : {
            //             info: {
            //                 value: {}
            //             }
            //         }
            //     });

            // $stateProvider
            //     .state('vvs.info.general', {
            //         piwikTitle : 'VVS Auskunft: Allgemeine Informationen',
            //         id : 'info',
            //         url : '@general',
            //         templateUrl: baseUrlPrefix.concat('info/general/main.html'),
            //         controller: 'VVSInfoGeneralController'
            //     });

            // $stateProvider
            //     .state('vvs.info.generalDetails', {
            //         piwikTitle : 'VVS Auskunft: Allgemeine Informationen Details',
            //         id : 'info',
            //         url : '@generalDetails',
            //         templateUrl: baseUrlPrefix.concat('info/general/details.html'),
            //         controller: 'VVSInfoGeneralDetailsController',
            //         params : {
            //             info: {
            //                 value: {}
            //             }
            //         }
            //     });

            // $stateProvider
            //     .state('vvs.info.timetableChange', {
            //         piwikTitle : 'VVS Auskunft: Fahrplanänderungen Übersicht',
            //         id : 'info',
            //         url : '@timetableChange',
            //         templateUrl: baseUrlPrefix.concat('info/timetableChange/main.html'),
            //         controller: 'VVSInfoTimetableChangeController'
            //     });

            // $stateProvider
            //     .state('vvs.info.timetableChangeDetails', {
            //         piwikTitle : 'VVS Auskunft: Fahrplanänderungen Details',
            //         id : 'info',
            //         url : '@timetableChangeDetails',
            //         templateUrl: baseUrlPrefix.concat('info/timetableChange/details.html'),
            //         controller: 'VVSInfoTimetableChangeDetailsController',
            //         params : {
            //             info: {
            //                 value: {}
            //             }
            //         }
            //     });

            // $stateProvider
            //     .state('vvs.info.specialTraffic', {
            //         piwikTitle : 'VVS Auskunft: Sonderverkehre Übersicht',
            //         id : 'info',
            //         url : '@specialTraffic',
            //         templateUrl: baseUrlPrefix.concat('info/specialTraffic/main.html'),
            //         controller: 'VVSInfoSpecialTrafficController'
            //     });

            // $stateProvider
            //     .state('vvs.info.specialTrafficDetails', {
            //         piwikTitle : 'VVS Auskunft: Sonderverkehre Details',
            //         id : 'info',
            //         url : '@specialTrafficDetails',
            //         templateUrl: baseUrlPrefix.concat('info/specialTraffic/details.html'),
            //         controller: 'VVSInfoSpecialTrafficDetailsController',
            //         params : {
            //             info: {
            //                 value: {}
            //             }
            //         }
            //     });

            // $stateProvider
            //     .state('vvs.info.escalatorElevator', {
            //         piwikTitle : 'VVS Auskunft: Aufzüge und Zugänge',
            //         id : 'info',
            //         url : '@escalatorElevator',
            //         templateUrl: baseUrlPrefix.concat('info/escalatorElevator/main.html'),
            //         controller: 'VVSInfoEscalatorElevatorController'
            //     });


            // $stateProvider
            //     .state('vvs.info.news', {
            //         piwikTitle : 'VVS Auskunft: News Übersicht',
            //         id : 'info',
            //         url : '@news',
            //         templateUrl: baseUrlPrefix.concat('info/news/main.html'),
            //         controller: 'VVSInfoNewsController'
            //     });

            // $stateProvider
            //     .state('vvs.info.newsDetails', {
            //         piwikTitle : 'VVS Auskunft: News Details',
            //         id : 'info',
            //         url : '@newsDetails',
            //         templateUrl: baseUrlPrefix.concat('info/news/details.html'),
            //         controller: 'VVSInfoNewsDetailsController',
            //         params : {
            //             info: {
            //                 value: {}
            //             }
            //         }
            //     });


            // ############################### ROP ########################### //
            $stateProvider
                .state('vvs.rop', {
                    id : 'rop',
                    sticky: true,
                    dsr: true,
                    url: '/XSLT_ROP_REQUEST',
                    views: {
                        'rop': {
                            templateUrl: baseUrlPrefix.concat('rop/main.html')
                        }
                    }
                });

            $stateProvider
                .state('vvs.rop.lines', {
                    piwikTitle : 'VVS Auskunft: Linien',
                    id : 'rop',
                    url : '@lines',
                    templateUrl: baseUrlPrefix.concat('rop/lines/main.html'),
                    controller: 'VVSROPLineController',
                    controllerAs: 'VVSROPLineCtrl',
                    params: {
                        rop : {
                            value : {}
                        }
                    }
                });

            $stateProvider
                .state('vvs.rop.stops', {
                    piwikTitle : 'VVS Auskunft: Stadtplanausschnitt',
                    id : 'rop',
                    url : '@stops',
                    templateUrl: baseUrlPrefix.concat('rop/stops/main.html'),
                    controller: 'VVSROPStopController',
                    params: {
                        rop : {
                            value : {}
                        }
                    }
                });


            // ############################### STT ########################### //
            $stateProvider
                .state('vvs.stt', {
                    id : 'stt',
                    url: '/XSLT_STT_REQUEST',
                    sticky: true,
                    dsr: true,
                    redirectTo: 'vvs.stt.init',
                    views: {
                        'stt': {
                            templateUrl: baseUrlPrefix.concat('stt/main.html'),
                            controller: 'VVSSTTController'
                        }
                    }
                });

            $stateProvider
                .state('vvs.stt.init', {
                    piwikTitle : 'VVS Auskunft: Aushangfahrplan',
                    id : 'stt',
                    reset : true,
                    url: '@init',
                    templateUrl: baseUrlPrefix.concat('stt/init/main.html'),
                    controller: 'VVSSTTInitController',
                    params: {
                        stt : {
                            value : {}
                        }
                    }
                });

            $stateProvider
                .state('vvs.stt.lines', {
                    piwikTitle : 'VVS Auskunft: Aushangfahrplan Ergebnisse nach Linien',
                    id : 'stt',
                    url: '@lines',
                    templateUrl: baseUrlPrefix.concat('stt/stops/lines/main.html')
                });

            $stateProvider
                .state('vvs.stt.stops', {
                    piwikTitle : 'VVS Auskunft: Aushangfahrplan Ergebnislisse nach Haltestellen',
                    id : 'stt',
                    url: '@stops',
                    templateUrl: baseUrlPrefix.concat('stt/lines/stops/main.html')
                });


            // ######################## Personalization ###################### //
            $stateProvider
                .state('vvs.personalization', {
                    id : 'personalization',
                    url: '/XSLT_PERSONALIZATION_REQUEST',
                    sticky: true,
                    dsr: true,
                    redirectTo: 'vvs.personalization.init',
                    views: {
                        'personalization': {
                            templateUrl: baseUrlPrefix.concat('personalization/main.html'),
                            controller: 'VVSPersonalizationController'
                        }
                    }
                });

            $stateProvider
                .state('vvs.personalization.init', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Service einrichten',
                    id : 'personalization',
                    url: '@init',
                    templateUrl: baseUrlPrefix.concat('personalization/init/main.html'),
                    controller: 'VVSPersonalizationInitController'
                });

            $stateProvider
                .state('vvs.personalization.login', {
                    piwikTitle : 'VVS Benachrichtigungsservice',
                    id : 'personalization',
                    url: '@login',
                    templateUrl: baseUrlPrefix.concat('personalization/login/main.html'),
                    controller: 'VVSPersonalizationLoginController'
                });

            $stateProvider
                .state('vvs.personalization.logout', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Ausloggen',
                    id : 'personalization',
                    url: '@logout',
                    controller: 'VVSPersonalizationLogoutController'
                });

            $stateProvider
                .state('vvs.personalization.registration', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Registrierung',
                    id : 'personalization',
                    url: '@registration',
                    templateUrl: baseUrlPrefix.concat('personalization/registration/main.html'),
                    controller: 'VVSPersonalizationRegistrationController'
                });

            $stateProvider
                .state('vvs.personalization.verification', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Email Verifikation',
                    id : 'personalization',
                    url: '@verification',
                    templateUrl: baseUrlPrefix.concat('personalization/verification/main.html'),
                    controller: 'VVSPersonalizationVerificationController'
                });

            $stateProvider
                .state('vvs.personalization.confirmregistration', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Registrierung Bestätigung',
                    id : 'personalization',
                    url: '@registration',
                    templateUrl: baseUrlPrefix.concat('personalization/registration/confirm.html'),
                    controller: 'VVSPersonalizationRegistrationController'
                });

            $stateProvider
                .state('vvs.personalization.profile', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Persönliche Daten ändern',
                    id : 'personalization',
                    url: '@profile',
                    templateUrl: baseUrlPrefix.concat('personalization/profile/main.html'),
                    controller: 'VVSPersonalizationProfileController'
                });
                //email ändern
            $stateProvider
                .state('vvs.personalization.email', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Persönliche Daten - Email ändern',
                    id : 'personalization',
                    url: '@profile',
                    templateUrl: baseUrlPrefix.concat('personalization/profile/main-email.html'),
                    controller: 'VVSPersonalizationProfileController'
                });
                // Passwort ändern
            $stateProvider
                .state('vvs.personalization.password', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Persönliche Daten - Paawort ändern',
                    id : 'personalization',
                    url: '@profile',
                    templateUrl: baseUrlPrefix.concat('personalization/profile/main-password.html'),
                    controller: 'VVSPersonalizationProfileController'
                });

            $stateProvider
                .state('vvs.personalization.forgottenFirst', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Passwort vergessen Benutzername',
                    id : 'personalization',
                    url: '@forgottenFirst',
                    templateUrl: baseUrlPrefix.concat('personalization/forgotten/main1.html'),
                    controller: 'VVSPersonalizationForgottenFirstController'
                });

                // set and confirm neww password
            $stateProvider
                .state('vvs.personalization.forgottenReset', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Passwort vergessen Benutzername neu eingeben',
                    id : 'personalization',
                    url: '@forgottenReset',
                    templateUrl: baseUrlPrefix.concat('personalization/forgotten/confirm-password.html'),
                    controller: 'VVSPersonalizationForgottenFirstController'
                });

            $stateProvider
                .state('vvs.personalization.confirmforgottenFirst', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Passwort vergessen Benutzername Bestätigung',
                    id : 'personalization',
                    url: '@forgottenFirst',
                    templateUrl: baseUrlPrefix.concat('personalization/forgotten/confirm1.html')
                });



            $stateProvider
                .state('vvs.personalization.forgottenSecond', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Passwort vergessen Name und E-Mail',
                    id : 'personalization',
                    url: '@forgottenSecond',
                    templateUrl: baseUrlPrefix.concat('personalization/forgotten/main2.html'),
                    controller: 'VVSPersonalizationForgottenSecondController'
                });

            $stateProvider
                .state('vvs.personalization.confirmforgottenSecond', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Passwort vergessen Name und E-Mail Bestätigung',
                    id : 'personalization',
                    url: '@forgottenSecond',
                    templateUrl: baseUrlPrefix.concat('personalization/forgotten/confirm2.html')
                });


            $stateProvider
                .state('vvs.personalization.stops', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Haltestellenabos verwalten',
                    id : 'personalization',
                    url: '@stops',
                    templateUrl: baseUrlPrefix.concat('personalization/stops/main.html'),
                    controller: 'VVSPersonalizationStopsController'
                });

            $stateProvider
                .state('vvs.personalization.lines', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Linienabos verwalten',
                    id : 'personalization',
                    url: '@lines',
                    templateUrl: baseUrlPrefix.concat('personalization/lines/main.html'),
                    controller: 'VVSPersonalizationLinesController'
                });

            // s-bahn lines
            $stateProvider
            .state('vvs.personalization.sbahnLines', {
                piwikTitle : 'VVS Benachrichtigungsservice: S-Bahn Linienabos verwalten',
                id : 'personalization',
                url: '@sbahnLines',
                templateUrl: baseUrlPrefix.concat('personalization/lines/sbahn.html'),
                controller: 'VVSPersonalizationLinesController'
                // controller: 'VVSPersonalizationInitController',
            });

            // r-bahn lines
            $stateProvider
            .state('vvs.personalization.rbahnLines', {
                piwikTitle : 'VVS Benachrichtigungsservice: R-Bahn Linienabos verwalten',
                id : 'personalization',
                url: '@rbahnLines',
                templateUrl: baseUrlPrefix.concat('personalization/lines/rbahn.html'),
                controller: 'VVSPersonalizationLinesController'
            });

            // U-Bahn - Stadt-/Zahnradbahn lines
            $stateProvider
            .state('vvs.personalization.ubahnLines', {
                piwikTitle : 'VVS Benachrichtigungsservice: Stadt-/Zahnradbahn Linienabos verwalten',
                id : 'personalization',
                url: '@ubahnLines',
                templateUrl: baseUrlPrefix.concat('personalization/lines/ubahn.html'),
                controller: 'VVSPersonalizationLinesController'
            });

            // Bus lines
            $stateProvider
            .state('vvs.personalization.busLines', {
                piwikTitle : 'VVS Benachrichtigungsservice: Bus Linienabos verwalten',
                id : 'personalization',
                url: '@busLines',
                templateUrl: baseUrlPrefix.concat('personalization/lines/bus.html'),
                controller: 'VVSPersonalizationLinesController'
            });

            $stateProvider
                .state('vvs.personalization.trips', {
                    piwikTitle : 'VVS Benachrichtigungsservice: Fahrten verwalten',
                    id : 'personalization',
                    url: '@trips',
                    templateUrl: baseUrlPrefix.concat('personalization/trips/main.html'),
                    controller: 'VVSPersonalizationTripsController'
                });

            // ############################### TTB ########################### //
            $stateProvider
                .state('vvs.ttb', {
                    id : 'ttb',
                    url: '/XSLT_TTB_REQUEST',
                    sticky: true,
                    dsr: true,
                    redirectTo: 'vvs.ttb.init',
                    views: {
                        'ttb': {
                            templateUrl: baseUrlPrefix.concat('ttb/main.html'),
                            controller: 'VVSTTBController'
                        }
                    }
                });


            $stateProvider
                .state('vvs.ttb.init', {
                    piwikTitle : 'VVS Auskunft: Fahrplanbuchseiten',
                    id : 'ttb',
                    reset : true,
                    // url: '@init',
                    // url: '@init&lfp=:lfp',
                    templateUrl: baseUrlPrefix.concat('ttb/init/main.html'),
                    controller: 'VVSTTBInitController',
                    params: {
                        ttb : {
                            value : {}
                        }
                    }
                });


            $stateProvider
                .state('vvs.ttb.lines', {
                    piwikTitle : 'VVS Auskunft: Fahrplanbuchseiten Ergebnisse nach Linien',
                    id : 'ttb',
                    url: '@lines&lfp=:lfp',
                    templateUrl: baseUrlPrefix.concat('ttb/stops/lines/main.html')
                });


            // ############################### MAP ########################### //
            $stateProvider
                .state('vvs.map', {
                    piwikTitle : 'VVS Auskunft: Karte',
                    id : 'map',
                    url: '/XSLT_MAP_REQUEST?',
                    redirectTo: 'vvs.map.init',
                    views: {
                        'map': {
                            templateUrl: baseUrlPrefix.concat('map/main.html')
                        }
                    }
                });
            $stateProvider
                .state('vvs.map.init', {
                    piwikTitle : 'VVS Auskunft: Karte',
                    id : 'map',
                    url: '@init',
                    views: {
                        'map': {
                            templateUrl: baseUrlPrefix.concat('map/main.html')
                        }
                    }
                });


            // $locationProvider.html5Mode(true);

            // if the url does not match any of the previous states, a redirect to the following state will take a place.
            $urlRouterProvider.otherwise('/XSLT_TRIP_REQUEST2@init');

            // $stickyStateProvider.enableDebug(true);
        }]);

})();

(function() {
    'use strict';

    /**
     * Using moment date formatter, this filter get a defined format from the configuration and
     * return a formatted date as String.
     * The giving date should be a moment date!
     **/
    angular
        .module('vvs')
        .filter('VVSDateFormatter', VVSDateFormatter);

    VVSDateFormatter.$inject = ['moment', 'VVSConst']

    function VVSDateFormatter(moment, VVSConst) {
        return function(date) {
            if (!date) {
                return "";
            }
            var formattedDate = moment(date).format(VVSConst.dateFormat);
            return formattedDate;
        };
    }


    angular
        .module('vvs')
        .filter('VVSDatePickerFormatter', VVSDatePickerFormatter);

    VVSDatePickerFormatter.$inject = ['moment', 'VVSConst']

    function VVSDatePickerFormatter(moment, VVSConst) {
        return function(date) {
            if (!date) {
                return "";
            }

            if (date._isAMomentObject) {
                return date.toDate();
            } else if (date instanceof Date) {
                return date;
            } else if (typeof date === "string") {
                if (date === "now") {
                    return moment().toDate();
                }
            }
            return moment(date, VVSConst.dateFormat).toDate();
        };
    }


    angular
        .module('vvs')
        .filter('VVSSummaryDateFormatter', VVSSummaryDateFormatter);

    VVSSummaryDateFormatter.$inject = ['moment', 'VVSConst'];

    function VVSSummaryDateFormatter(moment, VVSConst) {
        return function(date) {
            if (!date) {
                return '';
            }

            if (typeof date === 'string') {
                date = moment(date);
            }

            if (date._isAMomentObject) {
                return date.format(VVSConst.dateSummaryFormat);
            } else {
                return moment(date, VVSConst.dateFormat).format(VVSConst.dateSummaryFormat);
            }
        };
    }


    angular
        .module('vvs')
        .filter('VVSSummaryDateTimeFormatter', VVSSummaryDateTimeFormatter);

    VVSSummaryDateTimeFormatter.$inject = ['moment', 'VVSConst'];

    function VVSSummaryDateTimeFormatter(moment, VVSConst) {
        return function(date) {
            if (!date) {
                return '';
            }

            if (typeof date === 'string') {
                date = moment(date);
            }
            return date.format(VVSConst.dateTimeSummaryFormat);
        };
    }



    /**
     * Using moment time formatter, this filter get a defined format from the configuration and
     * return a formatted time as String.
     * The giving date should be a moment date!
     **/
    angular
        .module('vvs')
        .filter('VVSTimeFormatter', VVSTimeFormatter);

    VVSTimeFormatter.$inject = ['moment', 'VVSConst']

    function VVSTimeFormatter(moment, VVSConst) {
        return function(time) {
            if (!time) {
                return "";
            }
            if (time._isAMomentObject) {
                return time.format(VVSConst.timeFormat);
            } else if (time instanceof Date) {
                return moment(time).format(VVSConst.timeFormat);
            } else if (typeof time === "string") {
                if (time === "now") {
                    return moment().format(VVSConst.timeFormat);
                }
                return time;
            }
            return time;
        };
    }


    /**
     * Using 'moment-duration-format' module, this filter transform a number of seconds into
     * a formatted duration.
     **/
    angular
        .module('vvs')
        .filter('VVSDurationFormatter', VVSDurationFormatter);

    VVSDurationFormatter.$inject = ['moment', 'VVSConst']

    function VVSDurationFormatter(moment, VVSConst) {
        return function(seconds) {
            if (!seconds) {
                seconds = 60;
            }
            if (seconds < 60) {
                seconds = 60;
            }
            var formattedDuration = moment.duration(seconds, 'seconds').format(VVSConst.timeFormat, {
                trim : false
            });

            return formattedDuration;
        };
    }

    angular
        .module('vvs')
        .filter('VVSFootLegDurationFormatter', VVSFootLegDurationFormatter);

    VVSFootLegDurationFormatter.$inject = ['moment', '$sce']

    function VVSFootLegDurationFormatter(moment, $sce) {
        return function(seconds) {
            if (!seconds) {
                return '';
            }
            var minutes = moment.duration(seconds, 'seconds').asMinutes();

            if (minutes === 1) {
                return $sce.trustAsHtml('ca. 1 Minute');
            } else if (minutes > 1) {
                return $sce.trustAsHtml('ca. '.concat(minutes).concat(' Minuten'));
            }
        };
    }


    angular
        .module('vvs')
        .filter('VVSPlatformNameCleaner', VVSPlatformNameCleaner);

    function VVSPlatformNameCleaner() {
        return function(platformName) {
            if (!platformName) {
                return "";
            }

            var strs = ["Gleis", "gleis", "Gleis ", "gleis", "Bstg.", "Bstg. ", "Pos.", "Pos. "];
            for (var i = 0; i < strs.length; i++) {
                platformName = platformName.replace(strs[i], "");
            }

            return platformName;
        };
    }


    angular
        .module('vvs')
        .filter('VVSIdCleaner', VVSIdCleaner);

    function VVSIdCleaner() {
        return function(id) {
            if (!id) {
                return "";
            }

            return id.replace(/ /g, '');
        };
    }

    angular
        .module('vvs')
        .filter('VVSZonesCleaner', VVSZonesCleaner);

    function VVSZonesCleaner() {
        return function(zoneObj) {
            if (angular.isArray(zoneObj)) {
                return zoneObj.join('/');
            }

            return zoneObj;
        };
    }



    angular
        .module('vvs')
        .filter('VVSPoiNameFormatter', VVSPoiNameFormatter);

    function VVSPoiNameFormatter() {
        return function(poi) {
            if (!poi || (typeof poi === "string")) {
                return;
            }

            var res = "";
            if (poi.hasOwnProperty("parent") && poi.parent()) {
                res = poi.parent().name() + ", ";
            }
            if (poi.hasOwnProperty("name") && poi.name()) {
                return res + poi.name();
            }

            if (poi.description) {
                return poi.description;
            }

            return res;
        };
    }


    /**
     * To have the same location format in all views, we use this Filter to build the desired name of location.
     **/
    angular
        .module('vvs')
        .filter('VVSLocationNameFormatter', VVSLocationNameFormatter);

    function VVSLocationNameFormatter() {
        return function(location) {
            if (!location || (typeof location === "string")) {
                return location;
            }
            /*
            if (location.type() === 'platform') {
                if (location.parent() && location.parent().name() && (location.name() !== location.parent().name())){
                    return location.parent().name() + ', ' + location.name();
                } else if (location.parent() && location.parent().parent() && location.parent().parent().name() && (location.name() !== location.parent().parent().name())) {
                    return location.parent().parent().name() + ', ' + location.name();
                }
            }
            */
           if (location.parent()) {
            var stop = location.parent().properties().stopId;
           }

            var name = location.name(),
                parentName = location.parent()?location.parent().name():null;

            name = name.replace('$UNKNOWN_POINT$', 'Punkt auf Karte');

            if (parentName) {
                if (!name.startsWith(parentName)) {
                    name = parentName + ', ' + name;
                }
            }

            return name;
        };
    }

    angular
        .module('vvs')
        .filter('VVSLineNameFormatter', VVSLineNameFormatter);

    VVSLineNameFormatter.$inject = ['$filter']

    function VVSLineNameFormatter($filter) {
        return function(line, plain) {
            if (!line || (typeof line === "string")) {
                return line;
            }

            var periodFrom = line.periodFrom(),
                periodTo = line.periodTo(),
                period = '';

            if (!periodFrom || !periodTo) {
                if (line.properties().validity) {
                    periodFrom = moment(line.properties().validity.from);
                    periodTo = moment(line.properties().validity.to);
                }
            }

            if (periodFrom && periodTo) {
                if (periodTo.diff(periodFrom, 'days') === 0) {
                    period = '  gültig am ' + periodFrom.format('DD.MM.YYYY');
                } else if (periodTo.year() === 2500) {
                    period = '  gültig ab ' + periodFrom.format('DD.MM.YYYY');
                } else {
                    period = '  gültig von ' + periodFrom.format('DD.MM.YYYY') + ' bis ' + periodTo.format('DD.MM.YYYY');
                }
            }

            // if (line.properties().timetablePeriod) {
            //     period = period + ' - ' + line.properties().timetablePeriod; deleted 'Fahrplan' in description
            // }
            var number = line.number() || line.disassembledName();

            if (plain) {
                return number.concat(" -> ").concat(line.routeDescription()).concat(period);
            }
            return '<strong>' + number.concat(" -> ").concat(line.routeDescription()) + '</strong>' + '<small>' + ' ' + period + '</small>';
        };
    }


    /**
     * Displaying LineList
     **/
    angular
        .module('vvs')
        .filter('VVSLineListFormatter', VVSLineListFormatter);

        VVSLineListFormatter.$inject = ['$filter']

    function VVSLineListFormatter($filter) {
        return function(line, plain) {
            if (!line || (typeof line === "string")) {
                return line;
            }

            var periodFrom = line.periodFrom(),
                periodTo = line.periodTo(),
                period = '';

            if (!periodFrom || !periodTo) {
                if (line.properties().validity) {
                    periodFrom = moment(line.properties().validity.from);
                    periodTo = moment(line.properties().validity.to);
                }
            }

            if (periodFrom && periodTo) {
                if (periodTo.diff(periodFrom, 'days') === 0) {
                    period = ' gültig am ' + periodFrom.format('DD.MM.YYYY');
                } else if (periodTo.year() === 2500) {
                    period = ' gültig ab ' + periodFrom.format('DD.MM.YYYY');
                } else {
                    period = ' gültig von ' + periodFrom.format('DD.MM.YYYY') + ' bis ' + periodTo.format('DD.MM.YYYY');
                }
            }

            if (line.properties().timetablePeriod) {
                period = period + ' - ' + line.properties().timetablePeriod;
            }
            var number = line.number() || line.disassembledName();

            if (plain) {
                return number.concat(" -> ").concat(line.routeDescription());
                // return number.concat(" -> ").concat(line.routeDescription()).concat(period);
            }
            return '<strong>' + number + '</strong>' + '  ' + line.routeDescription();
            // return '<strong>' + number + '</strong>' + '  ' + line.routeDescription() + '<small>' + period + '</small>';
        };
    }

    /**
     * Format the location name displayed on suggestion List
     **/
    angular
        .module('vvs')
        .filter('VVSLocationSuggestFormatter', VVSLocationSuggestFormatter);

    VVSLocationSuggestFormatter.$inject = ['$sce']

    function VVSLocationSuggestFormatter($sce) {
        return function(location, returnAsString) {
            if (returnAsString) {
                return location.disassembledName().concat(location.buildingNumber() ? (" " + location.buildingNumber()) : "")
                    .concat(location.parent() ? " "+ location.parent().name() : "");
            }
            return $sce.trustAsHtml(location.disassembledName().concat(location.disassembledName().endsWith(location.buildingNumber()) ? " " : "" + location.buildingNumber())
                    .concat('<br/><span class="textsmall">')
                    .concat(location.parent() ? location.parent().name() : "")
                    .concat("</span>")
            );
        };
    }


    angular
        .module('vvs')
        .filter('VVSLocationSuggestIcon', VVSLocationSuggestIcon);

    VVSLocationSuggestIcon.$inject = ['$sce', 'VVSConst']

    function VVSLocationSuggestIcon($sce, VVSConst) {
        return function(location) {
            var iconName = VVSConst.iconTypeMapper[location.type()],
                tmpl =  '<svg class="icon icon-'+iconName+'" name="'+iconName+'">' +
                            '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="app/vvs.components/assets/images/icons/symbol-defs.svg#icon-'+iconName+'"></use>' +
                        '</svg>';

            return $sce.trustAsHtml(tmpl);
        };
    }


    angular
        .module('vvs')
        .filter('VVSHintFormatter', VVSHintFormatter);

    VVSHintFormatter.$inject = ['$sce'];

    function VVSHintFormatter($sce) {
        return function(hint) {
            if (!hint) {
                return;
            }

            var html = hint.content();

            if (html.indexOf('Tel.') > -1) {
                var telNbr = html;

                telNbr = telNbr.substring(telNbr.indexOf('Tel.')+5, html.length);
                if (telNbr.indexOf(',')>-1) {
                    telNbr = telNbr.substring(0, telNbr.indexOf(','));
                } else if (telNbr.indexOf('.')>-1) {
                    telNbr = telNbr.substring(0, telNbr.indexOf('.'));
                }

                if (telNbr) {
                    var cleanTelNbr = telNbr.replace(/ /g, '');

                    html = html.replace(telNbr, function($0)
                    { return '<a href="tel:'+cleanTelNbr+'" class="vvs-book-taxi">'+telNbr+'</a>'});
                }
            }


            return $sce.trustAsHtml(html);
        };
    }

    angular
        .module('vvs')
        .filter('VVSSafeHTML', VVSSafeHTML);

    VVSSafeHTML.$inject = ['$sce'];

    function VVSSafeHTML($sce) {
        return function(html) {
            return $sce.trustAsHtml(html);
        };
    }

    angular
        .module('vvs')
        .filter('VVSLineSuggestFormatter', VVSLineSuggestFormatter);

    VVSLineSuggestFormatter.$inject = ['$sce', '$filter']

    function VVSLineSuggestFormatter($sce, $filter) {
        return function(line) {
            var period = ' - ';

            if (line.properties().timetablePeriod) {
                period += line.properties().timetablePeriod;
            } else {
                if (line.periodFrom()) {
                    period += ($filter('VVSDateFormatter')(line.periodFrom()));
                }
                if (line.periodTo()) {
                    period += ($filter('VVSDateFormatter')(line.periodTo()));
                }
            }

            return $sce.trustAsHtml(line.number().concat(' ')
                .concat('<span>')
                .concat(line.routeDescription())
                .concat(period)
                .concat('</span>'));
        };
    }


    angular
        .module('vvs')
        .filter('VVSLineSelectionFormatter', VVSLineSelectionFormatter);

    VVSLineSelectionFormatter.$inject = ['$sce', '$filter']

    function VVSLineSelectionFormatter($sce, $filter) {
        return function(line) {
            // <strong>42</strong> Schlossplatz - Gablenberg - Hbf - <strong>Erwin-Schoettle-Platz</strong> (Fahrplan 2015)
            var period = "";
            if (line.properties().timetablePeriod) {
                period = " (" + (line.properties().timetablePeriod) + ")";
            }


            return $sce.trustAsHtml("<strong>".concat(line.number()).concat("</strong> ").concat(line.routeDescription()).concat(period));
        };
    }


    /**
     * humanize the duration: seconds => h [hrs] m [min]
     * @TODO use translationProvider for 'Std' and 'Min.'
     **/
    angular
        .module('vvs')
        .filter('VVSTravelledDurationFormatter', VVSTravelledDurationFormatter);

    VVSTravelledDurationFormatter.$inject = ['moment', '$sce']

    function VVSTravelledDurationFormatter(moment, $sce) {
        return function(seconds, withoutUn) {
            if (!seconds) {
                seconds = 60;
            }
            if (seconds < 60) {
                seconds = 60;
            }
            if (withoutUn) {
                return $sce.trustAsHtml(moment.duration(seconds, 'seconds').format("m"));
            }
            return $sce.trustAsHtml(moment.duration(seconds, 'seconds').format("h [Std] m [Min.]"));
        };
    }

    angular
        .module('vvs')
        .filter('VVSDurationDetailsFormatter', VVSDurationDetailsFormatter);

    VVSDurationDetailsFormatter.$inject = ['moment', '$sce']

    function VVSDurationDetailsFormatter(moment, $sce) {
        return function(seconds) {
            if (seconds == 0) {
                return "";
            }
            return $sce.trustAsHtml(moment.duration(seconds, 'seconds').format("h [std] m [min]"));
        };
    }


    angular
        .module('vvs')
        .filter('VVSPriceFormatter', VVSPriceFormatter);

    function VVSPriceFormatter() {
        return function(price) {
            price = parseFloat(price);
            if (!price) {
                return null;
            }
            return price.toLocaleString(undefined, { minimumFractionDigits: 2 });
        };
    }


    angular
        .module('vvs')
        .filter('VVSDistanceFormatter', VVSDistanceFormatter);

    function VVSDistanceFormatter() {
        return function(distanceInM, isKm) {
            if (!distanceInM) {
                return;
            }
            if (typeof distanceInM === 'string') {
                distanceInM = parseFloat(distanceInM);
            }
            if (isKm) {
                distanceInM = distanceInM * 1000;
            }
            if (distanceInM > 999) {
                return (distanceInM / 1000).toLocaleString(undefined, {maximumFractionDigits:1}).concat(" Km");
            }
            return distanceInM.toLocaleString().concat(" m");
        };
    }


    angular
        .module('vvs')
        .filter('VVSDelayFormatter', VVSDelayFormatter);

    VVSDelayFormatter.$inject = ['moment', '$sce']

    function VVSDelayFormatter(moment, $sce) {
        return function(delayInSec) {
            if (delayInSec == 0) {
                return "";
            }
            return $sce.trustAsHtml("+".concat(moment.duration(delayInSec, 'seconds').format("h [Std] m [Min.]")));
        };
    }


    angular
        .module('vvs')
        .filter('VVSMobileDateTimeFormatter', VVSMobileDateTimeFormatter);

    VVSMobileDateTimeFormatter.$inject = ['moment'];

    function VVSMobileDateTimeFormatter(moment) {
        return function(dateTime) {
            var toReturn = '';

            if (dateTime && dateTime.date) {
                if (dateTime.date === 'now') {
                    toReturn = moment().format('DD.MM.YYYY');
                } else {
                    toReturn = moment(dateTime.date).format('DD.MM.YYYY');
                }
            }

            if (dateTime && dateTime.time) {
                if (dateTime.time === 'now') {
                    toReturn += ' '.concat(moment().format('HH:mm'));
                } else {
                    if (dateTime.time instanceof Date) {
                        toReturn += ' '.concat(moment(dateTime.time).format('HH:mm'));
                    } else if (dateTime.time._isAMomentObject) {
                        toReturn += ' '.concat(dateTime.time.format('HH:mm'));
                    } else {
                        toReturn += ' '.concat(dateTime.time);
                    }

                }
            }

            return toReturn;
        };
    }


    angular
        .module('vvs')
        .filter('VVSStopIdFormatter', VVSStopIdFormatter);

    function VVSStopIdFormatter() {
        return function(location) {
            var stopId = location.properties().stopId;
            if (!stopId) {
                return null;
            }
            return (parseInt(stopId) - 5000000);
        };
    }

    angular
        .module('vvs')
        .filter('VVSCheckArithmeticSequence', VVSCheckArithmeticSequence);

    // check if the number is bitmaske od arithmetik sequence 2 6 10 14 18
    function VVSCheckArithmeticSequence() {
        return function(number) {
            for (var i = 1; i< 20; i++) {
                var conseqNr = 4*i - 2;
                if (number === conseqNr) {
                    return true;
                }
            }
            return false;
        };
    }


    angular
        .module('vvs')
        .filter('VVSProductClassMapper', VVSProductClassMapper);

    VVSProductClassMapper.$inject = ['VVSConst'];

    function VVSProductClassMapper(VVSConst) {
        return function(productClass) {
            return VVSConst.iconMotKeyMapper[productClass];
        };
    }

    angular
        .module('vvs')
        .filter('VVSMTSubcodeMapper', VVSMTSubcodeMapper);

    VVSMTSubcodeMapper.$inject = ['VVSConst'];

    function VVSMTSubcodeMapper(VVSConst) {
        return function(transportation) {
            var productClass = transportation.productIconId();
            var mtSubcode = transportation.properties().mtSubcode;
            if (productClass === 8 && mtSubcode) {
                return VVSConst.iconProductIconIdMapper[mtSubcode];
            }
            return VVSConst.iconProductIconIdMapper[productClass];
        };
    }


    angular
        .module('vvs')
        .filter('VVSIconMapper', VVSIconMapper);

        VVSIconMapper.$inject = ['VVSConst'];

    function VVSIconMapper(VVSConst) {
        return function(transportation) {
            var productClass = transportation.productIconId();
            var mtSubcode = transportation.properties().mtSubcode;
            var number = transportation.number();
            var isRider = (number === 'VVS-Rider');
            if (isRider) {
                return VVSConst.iconProductIconIdMapper[productClass+'_'+number];
            }
            if (productClass === 8 && mtSubcode) {
                return VVSConst.iconProductIconIdMapper[mtSubcode];
            }
            return VVSConst.iconProductIconIdMapper[productClass];
        };
    }

    angular
        .module('vvs')
        .filter('VVSProductIconIdMapper', VVSProductIconIdMapper);

    VVSProductIconIdMapper.$inject = ['VVSConst'];

    function VVSProductIconIdMapper(VVSConst) {
        return function(productClass) {
            return VVSConst.iconProductIconIdMapper[productClass];
        };
    }

    angular
        .module('vvs')
        .filter('VVSDMLocationClassMapping', VVSDMLocationClassMapping);

    VVSDMLocationClassMapping.$inject = ['VVSConst'];

    function VVSDMLocationClassMapping(VVSConst) {
        return function(type) {
            return VVSConst.iconTypeMapper[type];
        };
    }


    angular
        .module('vvs')
        .filter('VVSUniqueProductClasses', VVSUniqueProductClasses);

    VVSUniqueProductClasses.$inject = ['VVSConst'];

    function VVSUniqueProductClasses(VVSConst) {
        return function(productClasses) {
            if (!productClasses) {
                return [];
            }
            var productClassGrouping = VVSConst.iconProductClassGrouping,
                res = [];

            for (var i = 0; i < productClasses.length; i++) {
                for (var key in productClassGrouping) {
                    if (productClassGrouping.hasOwnProperty(key)) {
                        if (productClassGrouping[key].indexOf(productClasses[i]) > -1) {
                            var mot = productClassGrouping[key][0];
                            if (res.indexOf(mot) == -1) {
                                res.push(mot);
                            }
                            break;
                        }
                    }
                }
            }
            return res;
        };
    }

    /********for Perlschnur******/
    angular
        .module('vvs')
        .filter('VVSUniqueProductClassesPerlschnur', VVSUniqueProductClassesPerlschnur);

    VVSUniqueProductClassesPerlschnur.$inject = ['VVSConst'];

    function VVSUniqueProductClassesPerlschnur(VVSConst) {
    return function(productClasses) {
        if (!productClasses) {
            return [];
        }
        var productClassGrouping = VVSConst.iconProductClassGrouping,
            res = [];
        if (productClasses && productClasses[0]) {
            for (var i = 0; i < productClasses[0].length; i++) {
                for (var key in productClassGrouping) {
                    // debugger;
                    if (productClassGrouping.hasOwnProperty(key)) {
                        if (productClassGrouping[key].indexOf(productClasses[0][i]) !== -1) {
                            var mot = productClassGrouping[key][0];
                            if (res.indexOf(mot) == -1) {
                                res.push(mot);
                            }
                            break;
                        }
                    }
                }
            }
        }
        return res;
    };
    }



}());

(function() {
    'use strict';

    /**
     * The `VVSInclude` directive have the same functionality like the ngInclude
     * directive (https://docs.angularjs.org/api/ng/directive/ngInclude) with the
     * advantage that we can pass data to this directive using the `include-data`
     * attribute
     */
    angular
        .module('vvs')
        .directive('vvsInclude', vvsInclude);

    vvsInclude.$inject = ['VVSConst'];

    function vvsInclude(VVSConst) {
        // get the base url from the application constant
        var baseUrlPrefix = VVSConst.baseUrl ? VVSConst.baseUrl : '';
        return {
            restrict: 'E',
            replace: false,
            scope: true,
            templateUrl: function(elem, attrs) {
                // check the template name giving as value for `vvs-src` attribute
                if (attrs.vvsSrc) {
                    return baseUrlPrefix + attrs.vvsSrc;
                }
            }
        }
    }

    angular
        .module('vvs')
        .directive('vvsCountdown', vvsCountdown);

    vvsCountdown.$inject = ['$interval'];

    function vvsCountdown($interval) {
        return {
            restrict : 'E',
            replace : false,
            scope : {
                'date' : '='
            },
            link : function(scope, elem, attrs) {
                var elemToHide = angular.element(elem).find('vvs-countdown-hide'),
                    elemToShow = angular.element(elem).find('vvs-countdown-show'),
                    now = moment(),
                    date = moment(scope.date),
                    diff = moment().diff(date, 'seconds'),
                    tickInterval;


                if (!date.isValid() || (diff>0)) {
                    elemToHide.css('display', 'none');
                    elemToShow.css('display', 'block');
                    return;
                }

                if (diff<0) {
                    tickInterval = $interval(decrementDiff, 1000);
                } else {
                    decrementDiff();
                }

                function decrementDiff() {
                    diff = moment().diff(date, 'seconds');
                    if (diff>0) {
                        $interval.cancel(tickInterval);
                        elemToHide.css('display', 'none');
                        elemToShow.css('display', 'block');
                    }
                }
            }
        }
    }

    angular
        .module('vvs')
        .directive('vvsEnter', vvsEnter);

    vvsEnter.$inject = [];

    function vvsEnter() {
        return function(scope, element, attrs) {
            element.bind('keydown keypress', function(event) {
                if (event.which === 13) {
                    scope.$apply(function() {
                        scope.$eval(attrs.vvsEnter, {'event': event});
                    });

                    event.preventDefault();
                }
            });
        };
    }


    angular
        .module('vvs')
        .directive('vvsLoadSvg', vvsLoadSvg);

    vvsLoadSvg.$inject = ['$http', '$compile', 'VVSConst'];

    function vvsLoadSvg($http, $compile, VVSConst) {

        var baseUrlPrefix = VVSConst.baseUrl ? VVSConst.baseUrl : '';
        return {
            restrict: 'A',
            replace: true,
            scope: true,
            link : function(scope, elem, attrs){

                $http({
                    method: "GET",
                    url: baseUrlPrefix + "assets/images/icons/symbol-defs.svg"
                })
                .then(function successCallback(res) {
                    var html = $compile(res.data)(scope);

                    elem.append(html)
                }, function errorCallback(error) {
                    console.log(error);
                });
            }
        }
    }


    angular
        .module('vvs')
        .directive('vvsSvgInclude', vvsSvgInclude);

    vvsSvgInclude.$inject = ['VVSConst', '$http'];

    function vvsSvgInclude(VVSConst, $http) {
        // get the base url from the application constant
        var baseUrlPrefix = VVSConst.baseUrl ? VVSConst.baseUrl : '';
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            link: function(scope){
                $http({
                    url: baseUrlPrefix +"/assets/images/icons/symbol-defs.svg",
                    method: "GET"
                }).success(function(data, status, headers, config) {
                    var div = document.createElement("div");
                    div.innerHTML = data;
                    document.body.insertBefore(div, document.body.childNodes[0]);
                });
            }
        }
    }


    angular
        .module('vvs')
        .directive('vvsInterchange', vvsInterchange);

    vvsInterchange.$inject = ['VVSConst', 'mng-comm.MDVInterchangeRequester'];

    function vvsInterchange(VVSConst, MDVInterchangeRequester) {
        var baseUrlPrefix = VVSConst.baseUrl ? VVSConst.baseUrl : '',
            iconProductClassGrouping = VVSConst.iconProductClassGrouping,
            iconInterchangeMapper = VVSConst.iconInterchangeMapper,
            svgIcons = 'assets/images/icons/symbol-defs.svg',
            icon;

        return {
            restrict : 'E',
            replace : false,
            scope : {
                'leg' : '=',
                'prev' : '=',
                'next' : '=',
                'mode' : '='
            },
            template :  '<div class="subinfo" style="cursor: pointer; padding-left:8px;" ng-if="VVSInterchangeCtrl.renderTeamplate" ng-click="onInterchangeClick()">' +
                            '<span ng-if="VVSInterchangeCtrl.info_1">{{"Aktuell sind noch keine Daten zu barrierefreien Zu- und Umstiegen an dieser Haltestelle vorhanden."|translate}}</span>' +
                            '<span ng-if="VVSInterchangeCtrl.info_2">{{"Stufenlos erreichbar" | translate}}</span>' +
                            '<span ng-if="VVSInterchangeCtrl.info_3">{{"Stufenloser Ausgang" | translate}}</span>' +
                            '<span ng-if="VVSInterchangeCtrl.info_4">{{"Ebenerdig erreichbar" | translate}}</span>' +
                            '<span ng-if="VVSInterchangeCtrl.info_5">{{"Ebenerdiger Ausgang" | translate}}</span>' +
                            '<span ng-if="VVSInterchangeCtrl.info_6">{{"Erreichbar mit" | translate}} </span>' +
                            '<span ng-if="VVSInterchangeCtrl.info_7">{{"Ausgang möglich über" | translate}} </span>' +
                            '<span ng-if="VVSInterchangeCtrl.info_8">{{"Nicht stufenlos erreichbar" | translate}}</span>' +
                            '<span ng-if="VVSInterchangeCtrl.info_9">{{"Kein stufenloser Ausgang" | translate}}</span>' +
                            '<span ng-repeat="iconObj in VVSInterchangeCtrl.icons">' +
                                '<svg class="icon icon-interchange"><use xlink:href="" ng-attr-xlink:href="{{iconObj.url}}"></use></svg>' +
                            '</span>' +
                        '</div>',
            controller : function($scope) {
                var self = this,
                    availableInterchanges = Object.keys(iconInterchangeMapper),
                    iconNames = [];

                function intersect(a, b) {
                  return a.filter(Set.prototype.has, new Set(b));
                }

                self.renderTeamplate = false;

                $scope.onInterchangeClick = function() {
                    if ($scope.mode === 'orig') {
                        $scope.coords = $scope.leg.origin().parent().coord();
                        $scope.globalID = $scope.leg.origin().parent().id();
                    }
                    else if ($scope.mode === 'dest') {
                        $scope.coords = $scope.leg.destination().parent().coord();
                        $scope.globalID = $scope.leg.destination().parent().id();
                    }
                    else if ($scope.mode === 'transfer') {
                        $scope.coords = $scope.leg.origin().parent().coord();
                        $scope.globalID = $scope.leg.origin().parent().id();
                        // return window.open('https://livekarte.vvs.de/stops/', '_blank');
                        // it leg - how should be link?
                    }
                    var link = 'https://livekarte.vvs.de/stops/'+$scope.globalID+'@'+$scope.coords[0]+','+$scope.coords[1]+','+'z18';
                    window.open(link,'_blank');
                }



                self.icons = [];

                if ($scope.mode === 'transfer') {
                    if ($scope.prev) {
                        var ppc = $scope.prev.transportation().productClass();
                    } else {
                        var ppc = $scope.leg.transportation().productClass();
                    }
                    // var ppc = $scope.prev.transportation().productClass(),
                    var npc = $scope.next.transportation().productClass();

                    if ((ppc === npc) && (iconProductClassGrouping['Bus'].indexOf(ppc) > -1)) {
                        return;
                    }
                } else {
                    var pc = $scope.leg.transportation().productClass();

                    if (iconProductClassGrouping['Bus'].indexOf(pc) > -1) {
                        return;
                    } else if (iconProductClassGrouping['Fußweg'].indexOf(pc) > -1) {
                        if (!$scope.next) {
                            return;
                        }
                    }
                }

                var orig,
                    dest;

                if ($scope.mode === 'transfer') {
                    orig = $scope.leg.origin();
                    dest = $scope.leg.destination();
                } else if ($scope.mode === 'orig') {
                    dest = $scope.leg.origin();
                } else if ($scope.mode === 'dest') {
                    orig = $scope.leg.destination();
                }

                MDVInterchangeRequester.search(orig, dest)
                    .then(function(res) {
                        var interchanges = res.response;

                        if (interchanges.length === 0) {
                            // haltestelle nicht modelliert
                            if ($scope.mode === 'transfer') {
                                self.info_2 = true;
                            } else if ($scope.mode === 'orig') {
                                self.info_2 = true;
                            } else if ($scope.mode === 'dest') {
                                self.info_3 = true;
                            }
                        } else {
                            // haltestelle modelliert
                            var i, l, j, m,
                                hasLavel = false;

                            for (i=0, l=interchanges.length; i<l; i++) {
                                var interchange = interchanges[i];

                                if (JSON.stringify(interchange) === JSON.stringify(["LEVEL"])) {
                                    // ebenerdig erreichbar
                                    if ($scope.mode === 'transfer') {
                                        self.info_4 = true;
                                    } else if ($scope.mode === 'orig') {
                                        self.info_4 = true;
                                    } else if ($scope.mode === 'dest') {
                                        self.info_5 = true;
                                    }
                                    iconNames.push('LEVEL');
                                    hasLavel = true;
                                    break;
                                }
                            }

                            if (!hasLavel) {
                                // ebenerdig nicht erreichbar
                                for (i=0, l=interchanges.length; i<l; i++) {
                                    var interchange = interchanges[i];

                                    // clean interchanges array
                                    interchange = intersect(availableInterchanges, interchange);

                                    for (j=0, m=interchange.length; j<m; j++) {
                                        if (iconNames.indexOf(interchange[j]) === -1) {
                                            iconNames.push(interchange[j]);
                                        }
                                    }
                                }

                                var escIdx = iconNames.indexOf('ESCALATOR'),
                                    eleIdx = iconNames.indexOf('ELEVATOR'),
                                    rampIdx = iconNames.indexOf('RAMP'),
                                    levelIdx = iconNames.indexOf('LEVEL');

                                if (eleIdx > -1) {
                                    if (rampIdx > -1) {
                                        iconNames.splice(rampIdx, 1);
                                    }
                                    levelIdx = iconNames.indexOf('LEVEL');
                                    if (levelIdx > -1) {
                                        iconNames.splice(levelIdx, 1);
                                    }
                                } else if (escIdx > -1) {
                                    if (rampIdx > -1) {
                                        iconNames.splice(rampIdx, 1);
                                    }
                                    levelIdx = iconNames.indexOf('LEVEL');
                                    if (levelIdx > -1) {
                                        iconNames.splice(levelIdx, 1);
                                    }
                                }

                                if ((eleIdx === -1) && (escIdx === -1)) {
                                    // kein stufenloser Ausgang
                                    var hasStepless = false;

                                    for (i=0, l=interchanges.length; i<l; i++) {
                                        var interchange = interchanges[i];

                                        if ((interchange.indexOf('LEVEL') > -1) || (interchange.indexOf('RAMP') > -1)) {
                                            if (interchange.indexOf('STAIRS') === -1) {
                                                hasStepless = true;
                                            }
                                        }
                                    }
                                    if (!hasStepless) {
                                        if ($scope.mode === 'transfer') {
                                            self.info_8 = true;
                                        } else if ($scope.mode === 'orig') {
                                            self.info_8 = true;
                                        } else if ($scope.mode === 'dest') {
                                            self.info_9 = true;
                                        }
                                        iconNames = [];
                                    } else {
                                        levelIdx = iconNames.indexOf('LEVEL');
                                        if (levelIdx > -1) {
                                            iconNames.splice(levelIdx, 1);
                                        }
                                    }
                                }

                                if (iconNames.length>0) {
                                    if ($scope.mode === 'transfer') {
                                        self.info_6 = true;
                                    } else if ($scope.mode === 'orig') {
                                        self.info_6 = true;
                                    } else if ($scope.mode === 'dest') {
                                        self.info_7 = true;
                                    }
                                }
                            }
                        }


                        for (i=0, l=iconNames.length; i<l; i++) {
                            var iconName = iconNames[i];

                            if (iconInterchangeMapper.hasOwnProperty(iconName)) {
                                self.icons.push({
                                    class : 'icon icon-'.concat(iconInterchangeMapper[iconName]),
                                    url : baseUrlPrefix.concat(svgIcons).concat('#icon-').concat(iconInterchangeMapper[iconName])
                                });
                            }
                            self.renderTeamplate = true;
                        }

                        self.renderTeamplate = true;
                    })
                    .catch(function(e) {
                        self.info_1 = true;
                        self.renderTeamplate = true;
                    });
            },
            controllerAs: 'VVSInterchangeCtrl'
        }
    }


    /**
     * To avoid writing the same code block consistently, we created the `vvs-icon` element directive.
     * The `vvs-icon` directive can be called with two attributes:
     * 1) `name`: (for example: bildung, essen, ...)
     * 2) `type`: (for example: stop, loc, poi...)
     **/
    angular
        .module('vvs')
        .directive('vvsIcon', vvsIcon);

    vvsIcon.$inject = ['VVSConst'];

    function vvsIcon(VVSConst) {
        var baseUrlPrefix = VVSConst.baseUrl ? VVSConst.baseUrl : '',
            svgIcons = 'assets/images/icons/symbol-defs.svg',
            iconTypeMapper = VVSConst.iconTypeMapper,
            iconProductIconIdMapper = VVSConst.iconProductIconIdMapper,
            iconProductClassMapper = VVSConst.iconProductClassMapper,

            icon;
        return {
            restrict: 'E',
            replace: true,
            scope: {
                'type': '@type',
                'name': '@name',
                'productClass': '@productClass',
                'productIconId': '@productIconId',
                'mtSubcode': '@mtSubcode',
                'trNumber': '@trNumber'
            },
            template:   '<svg class="{{VVSIconCtrl.iconClass}}"><use xlink:href="" ng-attr-xlink:href="{{VVSIconCtrl.iconUrl}}"></use></svg> ',
            // template:   '<svg class="{{VVSIconCtrl.iconClass}}"><use xlink:href="" ng-attr-xlink:href="{{VVSIconCtrl.iconUrl}}"></use></svg> ',
            controller: function($scope) {
                var self = this;
                var isRider = $scope.trNumber === 'VVS-Rider';

                if (!$scope.name && $scope.type && iconTypeMapper) {
                    $scope.name = iconTypeMapper[$scope.type];
                }

                if ($scope.productClass && iconProductClassMapper) {
                    $scope.name = iconProductClassMapper[$scope.productClass];
                }

                if ($scope.productIconId && iconProductIconIdMapper) {
                    if ($scope.productIconId && iconProductIconIdMapper && isRider) {
                        $scope.name = iconProductIconIdMapper[$scope.productIconId+'_'+$scope.trNumber];
                    } else $scope.name = iconProductIconIdMapper[$scope.productIconId];
                }

                var mtSubcode = $scope.mtSubcode;

                if ($scope.name === 'ruftaxi' && mtSubcode === '801') {
                    self.iconUrl = baseUrlPrefix.concat(svgIcons).concat('#icon-').concat($scope.name).concat('-').concat(mtSubcode);
                } else {
                    self.iconUrl = baseUrlPrefix.concat(svgIcons).concat('#icon-').concat($scope.name);
                }
                self.iconClass = 'icon icon-'.concat($scope.name);
            },
            controllerAs: 'VVSIconCtrl'
        };
    }


    /**
     * Binding select to a non-string value via ngModel parsing / formatting
     * see https://code.angularjs.org/1.4.7/docs/api/ng/directive/select
     **/
    angular
        .module('vvs')
        .directive('convertToNumber', function() {
            return {
                require: 'ngModel',
                link: function(scope, element, attrs, ngModel) {
                    ngModel.$parsers.push(function(val) {
                        return val ? parseInt(val, 10) : null;
                    });
                    ngModel.$formatters.push(function(val) {
                        return val ? '' + val : null;
                    });
                }
            };
        });

    angular
        .module('vvs')
        .directive('vvsLocationNameFormatter', function($filter) {
            return {
                require: 'ngModel',
                link: function(scope, element, attrs, ngModel) {
                    ngModel.$formatters.push(function(val) {
                        return $filter('VVSLocationNameFormatter')(val);
                    });
                }
            };
        });

    angular
        .module('vvs')
        .directive('vvsLineNameFormatter', function($filter) {
            return {
                require: 'ngModel',
                link: function(scope, element, attrs, ngModel) {
                    ngModel.$formatters.push(function(val) {
                        return $filter('VVSLineNameFormatter')(val, true);
                    });
                }
            };
        });

    angular
        .module('vvs')
        .directive('vvsLineListFormatter', function($filter) {
            return {
                require: 'ngModel',
                link: function(scope, element, attrs, ngModel) {
                    ngModel.$formatters.push(function(val) {
                        return $filter('VVSLineListFormatter')(val, true);
                    });
                }
            };
        });


    angular
        .module('vvs')
        .directive('vvsScrollToElement', vvsScrollToElement);

    vvsScrollToElement.$inject = ['$location', '$anchorScroll'];

    function vvsScrollToElement($location, $anchorScroll) {
        return {
                scope: true,
                restrict : 'A',
                link: function(scope, elem, attrs) {
                    var element = attrs.element;

                    angular.element(elem).on('click', function(e) {
                        $location.hash(element);
                        $anchorScroll();
                        e.preventDefault();
                    });
                }
            };
    }



    angular
        .module('vvs')
        .directive('vvsComparePassword', vvsComparePassword);

    vvsComparePassword.$inject = [];

    function vvsComparePassword(VVSOffCanvas) {
        return {
            require: "ngModel",
            restrict: 'A',
            scope: {
                otherModelValue: "=vvsComparePassword"
            },
            link: function(scope, elem, attrs, ngModel){
                ngModel.$validators.vvsComparePassword = function(modelValue) {
                    return (modelValue === scope.otherModelValue);
                };

                scope.$watch("otherModelValue", function() {
                    ngModel.$validate();
                });
            }
        };
    }


    angular
        .module('vvs')
        .directive('vvsResetField', vvsResetField);

    vvsResetField.$inject = ['$compile', '$timeout'];

    function vvsResetField($compile, $timeout) {
        return {
            require: 'ngModel',
            scope: {},
            link: function(scope, el, attrs, ctrl) {
              // limit to input element of specific types
              var inputTypes = /text|search|tel|url|email|password/i;
              if (el[0].nodeName !== "INPUT")
                throw new Error("resetField is limited to input elements");


              // compiled reset icon template
              var template = $compile('<span ng-show="enabled" ng-mousedown="reset()" class="vvs-reset-field">X</span>')(scope);
              el.after(template);

              scope.reset = function() {
                ctrl.$setViewValue(null);
                ctrl.$render();
                /*$timeout(function() {
                    el[0].focus();
                }, 0, false);*/
              };

              el.bind('input', function() {
                scope.enabled = !ctrl.$isEmpty(el.val());
              })
              .bind('focus', function() {
                scope.enabled = !ctrl.$isEmpty(el.val());
                scope.$apply();
              })
              .bind('change', function() {
                scope.enabled = !ctrl.$isEmpty(el.val());
                scope.$apply();
              })
              .bind('blur', function() {
                scope.enabled = false;
                scope.$apply();
              });
            }
        }
    }


    angular
        .module('vvs')
        .directive('vvsTripComposition', vvsTripComposition);

        vvsTripComposition.$inject = ['mng-comm.MDVTripCompositionRequester'];

    function vvsTripComposition(MDVTripCompositionRequester) {

        return {
            restrict : 'E',
            replace : true,
            scope : {
                leg: '@',
            },
            templateUrl :  'app/vvs.components/trip/result/list/trip-composition.html',
            controller : function($scope, $timeout, $q) {
                var defer = $q.defer();
                var leg = JSON.parse($scope.leg);
                var vh = $scope.vhIndex;

                function getDate(str) {
                    return str.substring(0, 10).replaceAll('-', '');
                }

                function getTime(str) {
                    return str.substring(11, 19).replaceAll(':', '');
                }
                var options = {
                    'origin_1': leg.origin.id,
                    'destination_1': leg.destination.id,
                    'line_1': leg.transportation.id,
                    'tripCode_1': leg.transportation.properties.tripCode,
                    'departureDate_1': getDate(leg.origin.departureTimePlanned), // get only date - 20220823
                    'arrivalDate_1': getDate(leg.destination.arrivalTimePlanned), // get only date - 20220823
                    'departureTime_1': getTime(leg.origin.departureTimePlanned), // 125100 die exakte Zeit übernehmen hhmmss
                    'arrivalTime_1': getTime(leg.destination.arrivalTimePlanned), // 125100 die exakte Zeit übernehmen hhmmss,
                    'inclCoupledVehicles': 1,
                    'outputFormat': 'rapidJSON'
                }

                 MDVTripCompositionRequester.search(options)
                    .then(function(res) {
                        $scope.res = res.response;
                        $timeout(function() {
                            $scope.parts = $scope.res[0].parts;
                            if ($scope.parts) {
                                $scope.vehicles = $scope.parts[0].coupledTrips[0].vehicles;
                                $scope.vhIndex = ($scope.vehicles.length);
                                console.log('$scope.vehicles', $scope.vehicles);
                                console.log('$scope.vhIndex', typeof $scope.vhIndex);
                            }
                        });
                    })
                    .catch(function(e) {
                        console.log('error', e);
                    });

            }
        }
    }

    // FORMATIONS statt TRIP-COMPOSITION Request
    angular
        .module('vvs')
        .directive('vvsFormations', vvsFormations);

        vvsFormations.$inject = ['mng-comm.MDVFormationsRequester'];

    function vvsFormations(MDVFormationsRequester) {

        return {
            restrict : 'E',
            replace : true,
            scope : {
                leg: '@',
            },
            templateUrl :  'app/vvs.components/trip/result/list/formations.html',
            controller : function($scope, $timeout, $q) {
                var defer = $q.defer(); // we create deferred object, which will finish later
                var leg = JSON.parse($scope.leg);

                function getDate(str) {
                    return str.substring(0, 10).replaceAll('-', '');
                }

                var options = {
                    'line': leg.transportation.id + ':'+leg.transportation.properties.tripCode,
                    'date': getDate(leg.origin.departureTimePlanned), // get only date - 20220823
                    'outputFormat': 'rapidJSON'
                }

                MDVFormationsRequester.search(options)
                    .then(function(res) {
                        var response = res.response;
                        $timeout(function() {
                            if (response && response[0] && response[0].sections) {
                                var sections = response[0].sections;
                                if (sections && sections[0].groups && sections[0].groups[0].vehicles) {
                                    $scope.vehicles = sections[0].groups[0].vehicles;
                                }
                                $scope.vhIndex = ($scope.vehicles.length);
                            }
                        });
                    })
                    .catch(function(e) {
                        console.log('error', e);
                    });
                    defer.promise;

            }
        }
    }
}());

(function() {
    'use strict';

    angular
        .module('vvs')
        .controller('VVSController', VVSController);

    VVSController.$inject = ['$rootScope', '$scope', 'VVSConst', '$mdSidenav', 'mng-favorite.MDVOptionsFavorite', '$state', '$location', 'mng-common.MDVUriParams'];

    function VVSController($rootScope, $scope, VVSConst, $mdSidenav, MDVOptionsFavorite, $state, $location, MDVUriParams) {

        $rootScope.sharedData = {
            mobileMenuIsOpen : false,
            appIsLoading : false,
            tabResetIndex: 0
        };

        $rootScope.toggleMobileMenu = function() {
            $mdSidenav('mobileMenu').toggle();
        };

        // var testString = "vvsOptIn=7; _pk_id.4.fa7a=6a022703c3d4464d.1689862253.; _pk_ses.4.fa7a=1";

        var cookieStr = document.cookie;
        cookieStr.split(';').map(function(el) {
        // testString.split(';').map(function(el) {
            if (el.startsWith('vvsOptIn')) {
                $scope.vvsOptIn = el.split('=')[1];
            }
        });
        console.log('vvsOptIn cookie value', $scope.vvsOptIn);
        $scope.enableMatomo = ($scope.vvsOptIn == 7) || ($scope.vvsOptIn == 3);
        console.log('enableMatomo?', $scope.enableMatomo);

        $scope.url = window.location.href;

        $rootScope.triggerResetOptionsClick = function() {
            var opts = {
                dropDB : true
            };

            MDVOptionsFavorite.remove(null, opts).then(function() {
                if ($rootScope.journeyObj && $rootScope.journeyObj.service) {
                    $rootScope.journeyObj.service.resetOptions();
                }
            });
        };

        $rootScope.onStopsTabClick = function() {
            $scope.tabIndex = 0;
            $rootScope.$broadcast('DM', $scope.tabIndex);
            // $state.go('vvs.stops.init');
        }

        $rootScope.onLinesTabClick = function() {
            $scope.tabIndex = 0;
            $rootScope.$broadcast('LINES', $scope.tabIndex);
        }
    }
}());

(function() {
  'use strict';

  angular
    .module('vvs')
    .constant('VVSConst',
	    {
	    	'baseUrl' : 'app/vvs.components/',
	    	'language' : {
	    		'default' : 'de',
	    		'available' : ['de', 'en']
	    	},
            'placeHolderUrls' : [
                '/responsiveEfa-1.json'
            ],
	    	'iconTypeMapper' : {
	    		'stop' : 'haltestelle',
	    		'street' : 'adresse',
	    		'district' : 'ort',
                'suburb' : 'ort',
	    		'poi' : 'poi',
	    		'address' : 'adresse',
	    		'any' : 'adresse',
                'unknown' : 'adresse',
                'platform' : 'haltestelle'
	    	},
            'iconInterchangeMapper' : {
                'RAMP' : 'rampe',
                'ESCALATOR' : 'roltreppe',
                'ELEVATOR' : 'aufzug',
                'LEVEL' : 'ebenerdig'
            },
            'iconProductClassMapper' : {
                0 : 'rbahn',
                1 : 'sbahn',
                2 : 'ubahn',
                3 : 'ubahn',
                4 : 'bus',
                5 : 'bus',
                6 : 'bus',
                7 : 'bus',
                8 : 'ruftaxi',
                9 : 'seilbahn',
                10 : 'ruftaxi',
                11 : 'bus',
                12 : '',
                13 : 'rbahn',
                999 : 'zacke'
            },
            'iconProductClassGrouping' : {
                'S-Bahn' : [1],
                'R-Bahn' : [0, 13],
                'U-Bahn' : [2, 3],
                'Bus' : [4, 5, 6, 7, 11],
                'Ruftaxi' : [8, 10, 105],
                'Rad' : [107],
                'Zacke' : [999],
                'Seilbahn' : [9],
                'Fußweg' : [97, 98, 99, 100]
            },
	    	'iconProductIconIdMapper' : {
	    		0 : 'rbahn',
                1 : 'ubahn',
                2 : 'sbahn',
                3 : 'bus',
                4 : 'tram',
                5 : 'bus',
                6 : 'rbahn',
                7 : 'seilbahn',
                8 : 'ruftaxi',
                '8_VVS-Rider': 'rider', // VVS-Rider
                9 : 'seilbahn', //'zacke',
                10 : 'shiff',
                11 : 'zacke', //'seilbahn',
                12 : 'seilbahn',
                13 : 'rbahn',
                14 : 'plane',
                15 : 'sbahn',
                16 : 'schorndorf',
                17 : '',
                18 : '',
                19 : '',
                20 : 'sbahn',
                97: 'fussweg',
                98 : 'fussweg',
                99 : 'fussweg',
                100 : 'fussweg',
                101 : 'B&R',
                102 : 'radfahrer',
                103 : 'K&R',
                104 : 'P&R',
                105 : 'ruftaxi',
                106 : 'car',
                107 : 'radfahrer',
                801: 'ruftaxi801'
	    	},
            'iconProductIconIdGrouping' : {
                'S-Bahn' : [2, 15, 20],
                'R-Bahn' : [0, 6],
                'U-Bahn' : [1],
                'Bus' : [3, 5],
                'Ruftaxi' : [8, 16, 105],
                'Rad' : [102, 107],
                'Zacke' : [11],
                'Seilbahn' : [7, 9, 12]
            },
            'lineColorMapper' : {
                0 : '#8f908f',
                1 : '#14a3ff',
                2 : '#58af41',
                3 : '#ed1c24',
                4 : '#58af41',
                5 : '#ed1c24',
                6 : '#8f908f',
                7 : '#58af41',
                8 : '#183F8A',
                '8_VVS-Rider': '#f25b28',
                9 : '#FDCC00',
                10 : '#58af41',
                11 : '#FDCC00',
                12 : '#FDCC00',
                13 : '',
                14 : '#58af41',
                15 : '#58af41',
                16 : '#BF2138',
                17 : '',
                18 : '',
                19 : '',
                20 : '#58af41',
                99 : '#ff9c6b',
                100 : '#ff9c6b',
                101 : '#58af41',
                102 : '',
                103 : '#58af41',
                104 : '',
                105 : '#183F8A',
                106 : 'ff9c6b',
                107 : '#ff9c6b'
            },
	    	'iconAddInfoSubtypeMapper' : {
	    		'summary' : {
	    			'lineInfo#disruption#lines' : 'stoerung',
                    'stopInfo#disruption#stops' : 'stoerung',
		    		'lineInfo#disruption#strike' : 'stoerung',
                    // EFAF-7928 VVS mng: Meldungen vom typ routeBlocking werden nicht angezeigt
                    // --> make selection less restrict (also for dm, details and modal)
                    //'lineInfo#lineInfo#specialTraffic' : 'stoerung',
                    'routeBlocking': 'stoerung',
                    'routeBlocking#disruption#lines': 'stoerung',
                    'bannerInfo' : 'stoerung',
                    'stopBlocking#infoType#stopBlocking': 'meldungen',
		    		'lineInfo#timetableChange#lines' : 'meldungen',
		    		'stopInfo#timetableChange#stops' : 'meldungen',
		    		'routeInfo' : 'meldungen',
		    		'DIVA#Ruftaxihinweis' : 'meldungen',
		    		'KiK#Störungsmeldung' : 'kik'
	    		},
                'dm' : {
                    'lineInfo#disruption#lines' : 'stoerung',
                    'stopInfo#disruption#stops' : 'stoerung',
                    'lineInfo#disruption#strike' : 'stoerung',
                    'routeBlocking': 'stoerung',
                    'routeBlocking#disruption#lines': 'stoerung',
                    //'lineInfo#lineInfo#specialTraffic' : 'stoerung',
                    'bannerInfo' : 'stoerung',
                    'stopBlocking#infoType#stopBlocking': 'meldungen',
                    'lineInfo#timetableChange#lines' : 'meldungen',
                    'stopInfo#timetableChange#stops' : 'meldungen',
                    'routeInfo' : 'meldungen',
                    'DIVA#Ruftaxihinweis' : 'meldungen',
                    'KiK#Störungsmeldung' : 'kik'
                },
                'details' : {
                    'lineInfo#disruption#lines' : 'stoerung',
                    'stopInfo#disruption#stops' : 'stoerung',
                    'lineInfo#disruption#strike' : 'stoerung',
                    'routeBlocking': 'stoerung',
                    'routeBlocking#disruption#lines': 'stoerung',
                    //'lineInfo#lineInfo#specialTraffic' : 'stoerung',
                    'bannerInfo' : 'stoerung',
                    'stopBlocking#infoType#stopBlocking': 'meldungen',
                    'lineInfo#timetableChange#lines' : 'meldungen',
                    'stopInfo#timetableChange#stops' : 'meldungen',
                    'routeInfo' : 'meldungen',
                    'DIVA#Ruftaxihinweis' : 'meldungen',
                    'KiK#Störungsmeldung' : 'kik',
                    'stopInfo#stopInfo#escalator_elevator' : 'meldungen'
                },
                'modal' : {
                    'lineInfo#disruption#lines' : 'stoerung',
                    'stopInfo#disruption#stops' : 'stoerung',
                    'lineInfo#disruption#strike' : 'stoerung',
                    'routeBlocking': 'stoerung',
                    'routeBlocking#disruption#lines': 'stoerung',
                    //'lineInfo#lineInfo#specialTraffic' : 'stoerung',
                    'bannerInfo' : 'stoerung',
                    'lineInfo#timetableChange#lines' : 'meldungen',
                    'stopInfo#timetableChange#stops' : 'meldungen',
                    'stopBlocking#infoType#stopBlocking': 'meldungen',
                    'routeInfo' : 'meldungen',
                    'DIVA#Ruftaxihinweis' : 'meldungen',
                    'KiK#Störungsmeldung' : 'kik',
                    'stopInfo#stopInfo#escalator_elevator' : 'aufzug'
                }
	    	},
	    	'datePickerFormat' : 'DD.MM.YYYY',
	    	'timePickerFormat' : 'HH:mm',
	    	'dateFormat' : 'DD.MM.YYYY', // moment Format
            'dateSummaryFormat' : 'dd, DD.MM.YYYY',
            'dateTimeSummaryFormat' : 'dd, DD.MM.YYYY HH:mm',
	    	'timeFormat' : 'HH:mm', // moment Format
	    	'tariffZones' : [1, 2, 3, 4, 5, 6, 7, 8],
                            // [10, 20, 30, 31, 32, 34, 36, 37, 38, 39, 40, 41,
	    					//  42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53,
	    					//  54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65,
	    					//  66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 77, 78,
	    					//  81, 88, 91, 98],
	    	'poiCategories' : [
	    		{
	    			'description' : 'Bildung',
	    			'icon' : 'bildung',
	    			'key' : 'B'
	    		},
	    		{
	    			'description' : 'Essen & Trinken',
	    			'icon' : 'essen',
	    			'key' : 'K'
	    		},
	    		{
	    			'description' : 'Freizeit',
	    			'icon' : 'freizeit',
	    			'key' : 'C'
	    		},
	    		{
	    			'description' : 'Hotels, Unterkünfte',
	    			'icon' : 'hotels',
	    			'key' : 'D'
	    		},
	    		{
	    			'description' : 'Information und Service',
	    			'icon' : 'info',
	    			'key' : 'A'
	    		},
	    		{
	    			'description' : 'Kirchen, Friedhöfe',
	    			'icon' : 'kirche',
	    			'key' : 'E'
	    		},
	    		{
	    			'description' : 'Krankenhäuser, Kliniken',
	    			'icon' : 'klinik',
	    			'key' : 'F'
	    		},
	    		{
	    			'description' : 'Kultur',
	    			'icon' : 'kultur',
	    			'key' : 'G'
	    		},
	    		{
	    			'description' : 'Rund ums Rad',
	    			'icon' : 'rundumsrad',
	    			'key' : 'M'
	    		},
	    		{
	    			'description' : 'Sehenswürdigkeiten',
	    			'icon' : 'sights',
	    			'key' : 'H'
	    		},
	    		{
	    			'description' : 'Senioren- und Pflegeeinrichtungen',
	    			'icon' : 'senioren',
	    			'key' : 'L'
	    		},
	    		{
	    			'description' : 'Sportstätten',
	    			'icon' : 'sport',
	    			'key' : 'I'
	    		},
	    		{
	    			'description' : 'Verbände, Vereine',
	    			'icon' : 'vereine',
	    			'key' : 'J'
	    		}
	    	],
            'ticketsMapping' : {
                'OrtsbusTicket Erw.' : {
                    ids : ['026111']
                },
                'EinzelTicket OrtsbusTicket' : {
                    ids : ['02611']
                },
                'EinzelTicket Erwachsene' : {
                    ids : ['1', '2', '3', '4', '5', '6', '7', '501', '025111',
                     '020111', '020112', '020113', '020114', '020115', '020116', '020119', '02011'],
                },
                'EinzelTicket Erwachsene (HandyTicket)' : {
                    ids : ['15', '16', '17', '18', '19', '20', '21', '020151', '020152', '020153', '020154', '020155', '020156', '020159', '02015'],
                    mobile : true,
                    desktopVersion : 'EinzelTicket Erwachsene'
                },
                'EinzelTicket Kind' : {
                    ids : ['8', '9', '10', '11', '12', '13', '14', '020211', '020212', '020213', '020214', '020215', '020216', '020219', '02021']
                },
                'EinzelTicket Kind (HandyTicket)' : {
                    ids : ['22', '23', '24', '25', '26', '27', '28', '020251', '020252', '020253', '020254', '020255', '020256', '020259', '02025'],
                    mobile : true,
                    desktopVersion : 'EinzelTicket Kind'
                },
                '4er-Ticket Kind' : {
                    ids : ['03021_1_VVS_1_'],
                    mobile : true,
                    desktopVersion : 'EinzelTicket Kind'
                },
                'SchülerAusflugsTicket TagesTicket' : {
                    ids : ['0530_1_VVS_1_'],
                    mobile : true,
                    desktopVersion : 'EinzelTicket Kind'
                },
                'EinzelTagesTicket Online' : {
                    ids : ['05025'],
                    mobile : true,
                },
                'KurzstreckenTicket' : {
                    ids : ['29', '010110', '01011_Bus']
                },
                'KurzstreckenTicket_Bahn' : {
                    ids : ['01011_Bahn']
                },
                'EinzelTagesTicket Ludwigsburg' : {
                    ids : ['504', '050801']
                },
                'StadtTicket GruppenTagestTicket Ludwigsburg' : {
                    ids : ['505', '050601']
                },
                'StadtTicket GruppenTagesTicket' : {
                    ids : ['0506']
                },
                'EinzelTagesTicket Esslingen' : {
                    ids : ['050803']
                },
                'GruppenTagesTicket Esslingen' : {
                    ids : ['050603']
                },
                'Einzelticket Sondertarif Marbach' : {
                    ids : ['503', '025121']
                },
                /*'Einzelticket Sondertarif Herrenberg' : {
                    ids : ['501', '025111']
                },*/
                /*'4er-Ticket Sondertarif Herrenberg' : {
                    ids : ['502', '035111']
                },*/
                /*'EinzelTagesTicket Sondertarif Herrenberg' : {
                    ids : ['506', '050802']
                },*/
                'StadtTicket GruppenTagesTicket Herrenberg' : {
                    ids : ['507', '050602']
                },
                'StadtTicket GruppenTagesTicket Marbach' : {
                    ids : ['050604']
                },
                'StadtTicket GruppenTagesTicket Böblingen/Sindelfin' : {
                    ids : ['050605']
                },
                'StadtTicket GruppenTagesTicket Asperg' : {
                    ids : ['050606']
                },
                'StadtTicket GruppenTagesTicket Ditzingen' : {
                    ids : ['050607']
                },
                'StadtTicket GruppenTagesTicket Filderstadt' : {
                    ids : ['050608']
                },
                'StadtTicket GruppenTagesTicket Kernen' : {
                    ids : ['050609']
                },
                'StadtTicket GruppenTagesTicket Kirchheim(T)/Dettin' : {
                    ids : ['050610']
                },
                'StadtTicket GruppenTagesTicket Kornwestheim' : {
                    ids : ['050611']
                },
                'StadtTicket GruppenTagesTicket Leinfelden-Echterdi' : {
                    ids : ['050612']
                },
                'StadtTicket GruppenTagesTicket Leonberg' : {
                    ids : ['050613']
                },
                'StadtTicket GruppenTagesTicket Plochingen' : {
                    ids : ['050614']
                },
                'StadtTicket GruppenTagesTicket Reichenbach (F)' : {
                    ids : ['050615']
                },
                'StadtTicket GruppenTagesTicket Renningen' : {
                    ids : ['050616']
                },
                'StadtTicket GruppenTagesTicket Remseck (N)' : {
                    ids : ['050617']
                },
                'StadtTicket GruppenTagesTicket Tamm' : {
                    ids : ['050618']
                },
                'StadtTicket GruppenTagesTicket Fellbach' : {
                    ids : ['050619']
                },
                'StadtTicket GruppenTagesTicket Ostfildern' : {
                    ids : ['050620']
                },
                'StadtTicket GruppenTagesTicket Backnang' : {
                    ids : ['050622']
                },
                'StadtTicket GruppenTagesTicket Besigheim' : {
                    ids : ['050623']
                },
                'StadtTicket GruppenTagesTicket Bietigheim-Bissinge' : {
                    ids : ['050624']
                },
                'StadtTicket GruppenTagesTicket Markgröningen' : {
                    ids : ['050625']
                },
                'StadtTicket GruppenTagesTicket Waiblingen' : {
                    ids : ['050626']
                },
                'StadtTicket GruppenTagesTicket Weilheim(T)/Neidlin' : {
                    ids : ['050627']
                },
                'StadtTicket GruppenTagesTicket Wendlingen' : {
                    ids : ['050628']
                },
                'StadtTicket GruppenTagesTicket Winnenden' : {
                    ids : ['050629']
                },
                'StadtTicket GruppenTagesTicket Göppingen' : {
                    ids : ['050630']
                },
                'StadtTicket GruppenTagesTicket Eislingen (F)' : {
                    ids : ['050631']
                },
                'StadtTicket GruppenTagesTicket Heiningen' : {
                    ids : ['050632']
                },
                'StadtTicket GruppenTagesTicket Schlierbach' : {
                    ids : ['050633']
                },
                'StadtTicket GruppenTagesTicket Bad Boll' : {
                    ids : ['050634']
                },
                'StadtTicket GruppenTagesTicket Uhingen' : {
                    ids : ['050635']
                },
                'StadtTicket GruppenTagesTicket Albershausen' : {
                    ids : ['050636']
                },
                'StadtTicket GruppenTagesTicket Ebersbach (F)' : {
                    ids : ['050637']
                },
                'StadtTicket GruppenTagesTicket Süßen' : {
                    ids : ['050638']
                },
                'StadtTicket GruppenTagesTicket Nürtingen' : {
                    ids : ['050639']
                },
                'StadtTicket GruppenTagesTicket Rutesheim' : {
                    ids : ['050640']
                },
                'StadtTicket GruppenTagesTicket Korb' : {
                    ids : ['050641']
                },
                'StadtTicket GruppenTagesTicket Vaihingen (E)' : {
                    ids : ['050642']
                },
                'StadtTicket GruppenTagesTicket Möglingen' : {
                    ids : ['050643']
                },
                'StadtTicket GruppenTagesTicket Wernau (N)' : {
                    ids : ['050644']
                },
                'StadtTicket GruppenTagesTicket Urbach' : {
                    ids : ['050645']
                },
                'StadtTicket GruppenTagesTicket Lichtenwald' : {
                    ids : ['050646']
                },
                'StadtTicket GruppenTagesTicket Sachsenheim' : {
                    ids : ['050647']
                },
                'StadtTicket GruppenTagesTicket Aichtal' : {
                    ids : ['050648']
                },
                'StadtTicket GruppenTagesTicket Plüderhausen' : {
                    ids : ['050649']
                },
                'StadtTicket EinzelTagesTicket' : {
                    ids : ['0508']
                },
                'StadtTicket EinzelTagesTicket Ludwigsburg' : {
                    ids : ['050801']
                },
                'StadtTicket EinzelTagesTicket Herrenberg' : {
                    ids : ['050802']
                },
                'StadtTicket EinzelTagesTicket Marbach' : {
                    ids : ['050804']
                },
                'StadtTicket EinzelTagesTicket Böblingen/Sindelfing' : {
                    ids : ['050805']
                },
                'StadtTicket EinzelTagesTicket Asperg' : {
                    ids : ['050806']
                },
                'StadtTicket EinzelTagesTicket Ditzingen' : {
                    ids : ['050807']
                },
                'StadtTicket EinzelTagesTicket Filderstadt' : {
                    ids : ['050808']
                },
                'StadtTicket EinzelTagesTicket Kernen' : {
                    ids : ['050809']
                },
                'StadtTicket EinzelTagesTicket Kirchheim(T)/Detting' : {
                    ids : ['050810']
                },
                'StadtTicket EinzelTagesTicket Kornwestheim' : {
                    ids : ['050811']
                },
                'StadtTicket EinzelTagesTicket Leinfelden-Echterdin' : {
                    ids : ['050812']
                },
                'StadtTicket EinzelTagesTicket Leonberg' : {
                    ids : ['050813']
                },
                'StadtTicket EinzelTagesTicket Plochingen' : {
                    ids : ['050814']
                },
                'StadtTicket EinzelTagesTicket Reichenbach (F)' : {
                    ids : ['050815']
                },
                'StadtTicket EinzelTagesTicket Renningen' : {
                    ids : ['050816']
                },
                'StadtTicket EinzelTagesTicket Remseck (N)' : {
                    ids : ['050817']
                },
                'StadtTicket EinzelTagesTicket Tamm' : {
                    ids : ['050818']
                },
                'StadtTicket EinzelTagesTicket Fellbach' : {
                    ids : ['050819']
                },
                'StadtTicket EinzelTagesTicket Ostfildern' : {
                    ids : ['050820']
                },
                'StadtTicket EinzelTagesTicket Backnang' : {
                    ids : ['050822']
                },
                'StadtTicket EinzelTagesTicket Besigheim' : {
                    ids : ['050823']
                },
                'StadtTicket EinzelTagesTicket Bietigheim-Bissingen' : {
                    ids : ['050824']
                },
                'StadtTicket EinzelTagesTicket Markgröningen' : {
                    ids : ['050825']
                },
                'StadtTicket EinzelTagesTicket Waiblingen' : {
                    ids : ['050826']
                },
                'StadtTicket EinzelTagesTicket Weilheim(T)/Neidling' : {
                    ids : ['050827']
                },
                'StadtTicket EinzelTagesTicket Wendlingen' : {
                    ids : ['050828']
                },
                'StadtTicket EinzelTagesTicket Winnenden' : {
                    ids : ['050829']
                },
                'StadtTicket EinzelTagesTicket Göppingen' : {
                    ids : ['050830']
                },
                'StadtTicket EinzelTagesTicket Eislingen (F)' : {
                    ids : ['050831']
                },
                'StadtTicket EinzelTagesTicket Heiningen' : {
                    ids : ['050832']
                },
                'StadtTicket EinzelTagesTicket Schlierbach' : {
                    ids : ['050833']
                },
                'StadtTicket EinzelTagesTicket Bad Boll' : {
                    ids : ['050834']
                },
                'StadtTicket EinzelTagesTicket Uhingen' : {
                    ids : ['050835']
                },
                'StadtTicket EinzelTagesTicket Albershausen' : {
                    ids : ['050836']
                },
                'StadtTicket EinzelTagesTicket Ebersbach (F)' : {
                    ids : ['050837']
                },
                'StadtTicket EinzelTagesTicket Süßen' : {
                    ids : ['050838']
                },
                'StadtTicket EinzelTagesTicket Nürtingen' : {
                    ids : ['050839']
                },
                'StadtTicket EinzelTagesTicket Rutesheim' : {
                    ids : ['050840']
                },
                'StadtTicket EinzelTagesTicket Korb' : {
                    ids : ['050841']
                },
                'StadtTicket EinzelTagesTicket Vaihingen (E)' : {
                    ids : ['050842']
                },
                'StadtTicket EinzelTagesTicket Möglingen' : {
                    ids : ['050843']
                },
                'StadtTicket EinzelTagesTicket Wernau (N)' : {
                    ids : ['050844']
                },
                'StadtTicket EinzelTagesTicket Urbach' : {
                    ids : ['050845']
                },
                'StadtTicket EinzelTagesTicket Lichtenwald' : {
                    ids : ['050846']
                },
                'StadtTicket EinzelTagesTicket Sachsenheim' : {
                    ids : ['050847']
                },
                'StadtTicket EinzelTagesTicket Aichtal' : {
                    ids : ['050848']
                },
                'StadtTicket EinzelTagesTicket Plüderhausen' : {
                    ids : ['050849']
                },
                'StadtTicket MonatsTicket Jedermann' : {
                // StadtTicket MonatsTicket
                    ids : ['1221']
                },
                '10er-TagesTicket' : {
                    ids : ['0522']
                },
                'SchülerAusf.Ticket TagesTicket' : {
                    ids : ['0530']
                },
                '9-Uhr-FirmenTicketPlus' : {
                    ids : ['15141_1_VVS_1_']
                },
                '9-Uhr-FirmenTicketPlus 10 % Rabatt' : {
                    ids : ['15651_1_VVS_1_']
                },
                '9-Uhr-FirmenTicketPlus 5 % Rabatt' : {
                    ids : ['15641_1_VVS_1_']
                },
                '9-Uhr-MonatsTicket' : {
                    ids : ['41015_1_VVS_1_']
                },
                '9-Uhr-JahresTicketPlus' : {
                    ids : ['42455_1_VVS_1_', '42455']
                },
                'Abo-SofortTicket 9-Uhr-Abo pers.' : {
                    ids : ['41645_1_VVS_1_']
                },
                'Abo-SofortTicket 9-Uhr-AboPlus' : {
                    ids : ['41655_1_VVS_1_']
                },
                // 'Abo-SofortTicket Jedermann pers.' : {
                //     ids : ['12641_1_VVS_1_']
                // },
                // 'Abo-SofortTicket Jedermann Plus' : {
                //     ids : ['12651_1_VVS_1_']
                // },
                'Abo-Sofort Jedermann pers.' : {
                    ids : ['12641']
                },
                'Abo-Sofort Jedermann Plus' : {
                    ids : ['12651']
                },
                'Feinstaubticket' : {
                    ids : ['167', '168', '169', '170', '171', '172', 'Dumm15', 'Dumm16', 'Dumm17', 'Dumm18', 'Dumm19', 'Dumm20', 'Dumm21'],
                    desktop : true
                },
                'Feinstaubticket (HandyTicket)' : {
                    ids : ['173', '174', '175', '176', '177', '178', '179', 'Dumm22', 'Dumm23', 'Dumm24', 'Dumm25', 'Dumm26', 'Dumm27', 'Dumm28'],
                    mobile : true,
                    desktopVersion : 'Feinstaubticket'
                },
                'EinzelTagesTicket' : {
                    ids : ['180', '181', '182', '050241', '050242', '050243', '050244', '050249', '506', '050802', '05021'],
                    mobile : true
                },
                'EinzelTagesTicket (HandyTicket)' : {
                    ids : ['44', '45', '46', '050251', '050252', '050253', '050254', '050259'],
                    desktop : true,
                    urlName : 'EinzelTagesTicket'
                },
                'EinzelZuschlag 1. Klasse' : {
                    ids : ['09031'],
                    desktop : true,
                },
                '3-TageTicket' : {
                    ids : ['51030'],
                    desktop : true,
                },
                'Zusatz MonatsTicket Senior Netz' : {
                    ids : ['52019'],
                    desktop : true,
                },
                'KombiTicket' : {
                    ids : ['53000'],
                    desktop : true,
                },
                'StuttCard' : {
                    ids : ['53003'],
                    desktop : true,
                },
                'SchülerAustauschTicket' : {
                    ids : ['53010'],
                    desktop : true,
                },
                'SchnupperTicket' : {
                    ids : ['53061'],
                    desktop : true,
                },
                'DienstTicket' : {
                    ids : ['99000'],
                    desktop : true,
                },
                '1.-Klasse-Zusatzticket Ba-Wü' : {
                    ids : ['999'],
                    desktop : true,
                },
                'ID-Teilnahmeberechtigung' : {
                    ids : ['99999'],
                    desktop : true,
                },
                'GruppenTagesTicket' : {
                    ids : ['47', '48', '49', '050141', '050142', '050143', '050144', '050149', '507', '050602', '05011'],
                    mobile : true
                },
                'GruppenTagesTicket (HandyTicket)' : {
                    ids : ['050151', '050152', '050153', '050154', '050159'],
                    desktop : true,
                    mobile : true
                },
                'GruppenTagesTicket Online' : {
                    ids : ['05015_1_VVS_5_', '50151', '50152', '50153', '50154', '50159', '05015'],
                    desktop : true,
                    mobile : true
                },
                'Deutschlandticket Firmen-Abo' : {
                    ids : ['165199'],
                    desktop : true,
                    mobile : true,
                    takeBackendName: true
                },
                'Deutschland-Ticket' : {
                    ids : ['160199', '1601'],
                    desktop : true,
                    mobile : true,
                    takeBackendName: true
                },
                'Deutschlandticket Zuschlag 1. Klasse Baden-Württemberg' : {
                    ids : ['160399'],
                    desktop : true,
                    mobile : true,
                    takeBackendName: true
                },
                'Deutschlandticket Zuschlag TicketPlus' : {
                    ids : ['160299'],
                    desktop : true,
                    mobile : true,
                    takeBackendName: true
                },
                'Deutschland-Ticket Firmen-Abo' : {
                    ids : ['1651'],
                    desktop : true,
                    mobile : true,
                    takeBackendName: true
                },
                'Abo-Sofort Deutschland-Ticket' : {
                    ids : ['1611'],
                    desktop : true,
                    mobile : true,
                },
                'Abo-Sofort TicketPlus' : {
                    ids : ['1612'],
                    desktop : true,
                    mobile : true,
                },
                'Abo-Sofort 1. Klasse Ba-Wü' : {
                    ids : ['1613'],
                    desktop : true,
                    mobile : true,
                },
                'Zuschlag TicketPlus' : {
                    ids : ['1602'],
                    desktop : true,
                },
                'Zuschlag 1. Klasse Ba-Wü' : {
                    ids : ['1603', '1653'],
                    desktop : true,
                },
                'Zuschlag FirmenTicketPlus' : {
                    ids : ['1652'],
                    desktop : true,
                },
                'Monatszuschlag 1. Kl.' : {
                    ids : ['1901'],
                    desktop : true,
                },
                'Wochenzuschlag 1. Kl.' : {
                    ids : ['1902'],
                    desktop : true,
                },
                'Monatszuschlag 1. Kl. Plus' : {
                    ids : ['1905'],
                    desktop : true,
                },
                'Zuschlag 1. Kl. FiTi' : {
                    ids : ['1914'],
                    desktop : true,
                },
                'Zuschlag 1. Kl. FiTi 5 %' : {
                    ids : ['1915'],
                    desktop : true,
                },
                'Zuschlag 1. Kl. FiTi 10 %' : {
                    ids : ['1916'],
                    desktop : true,
                },
                'Zuschlag 1. Kl. Abo-Sofort' : {
                    ids : ['1924'],
                    desktop : true,
                },
                'Zuschlag 1. Kl. Abo-SofortPlus' : {
                    ids : ['1925'],
                    desktop : true,
                },
                'Zuschlag 1. Kl. FiTi Plus' : {
                    ids : ['1934'],
                    desktop : true,
                },
                'Zuschlag 1. Kl. FiTi Plus 5 %' : {
                    ids : ['1935'],
                    desktop : true,
                },
                'Zuschlag 1. Kl. FiTi Plus 10 %' : {
                    ids : ['1936'],
                    desktop : true,
                },
                'Jahreszuschlag 1. Kl.' : {
                    ids : ['1944', '1954'],
                    desktop : true,
                },
                'Jahreszuschlag 1. Kl. Plus' : {
                    ids : ['1945', '1955'],
                    desktop : true,
                },
                'MonatsTicket Ausbildung' : {
                    ids : ['21013'],
                    desktop : true,
                },
                'JugendTicketBW (VVS Scool-Abo)' : {
                    ids : ['21023'],
                    desktop : true,
                },
                'JugendTicketBW (VVS Azubi-Abo)' : {
                    ids : ['21033'],
                    desktop : true,
                },
                'JugendTicketBW (VVS)' : {
                    ids : ['21043', '21053', '21063'],
                    desktop : true,
                },
                'AusbildungsTicket U 27' : {
                    ids : ['21073'],
                    desktop : true,
                },
                'Abo-AusbildungsTicket 27' : {
                    ids : ['21083'],
                    desktop : true,
                },
                'AusbildungsTicket 27' : {
                    ids : ['21093'],
                    desktop : true,
                },
                'Abo-Sofort Azubi-Abo' : {
                    ids : ['21133'],
                    desktop : true,
                },
                'Abo-Sofort JTBW (VVS)' : {
                    ids : ['21143', '21153', '21163'],
                    desktop : true,
                },
                'Abo-Sofort AusbildungsTicket 27' : {
                    ids : ['21183'],
                    desktop : true,
                },
                'WochenTicket Jedermann' : {
                // 'WochenTicket Jedermann' : {
                    ids : ['50', '51', '52', '53', '54', '55', '56', '110211', '110212', '110213', '110214', '110215', '110216', '110219', '11021'],
                    mobile : true,
                    desktop : true,
                    shoppingName: 'WochenTicket' // für den Tikcetname in getTicketShopUrl
                },
                'MonatsTicket Jedermann' : {
                // 'MonatsTicket Jedermann' : {
                    ids : ['57', '58', '59', '60', '61', '62', '63', '120111',
                     '120112', '120113', '120114', '120115', '120116', '120119', '508', '122102', '12011'],
                    desktop : true,
                    mobile : true,
                    urlName : 'MonatsTicket Jedermann'
                },
                'JahresTicket Jedermann' : {
                // 'JahresTicket Jedermann' : {
                    ids : ['13441', '13541'],
                    desktop : true,
                    mobile : true,
                },
                'JahresTicketPlus Jedermann' : {
                // 'JahresTicketPlus Jedermann' : {
                    ids : ['13451', '13551'],
                    desktop : true,
                    mobile : true,
                },
                '9-Uhr-UmweltTicket' : {
                    ids : ['131', '132', '133', '134', '135', '136', '137', '410151', '410152', '410153', '410154', '410155', '410156', '410159'],
                    desktop : true,
                    mobile : true,
                    shoppingName : '9-Uhr-UmweltTicket (MonatsTicket)'
                },
                '9-Euro-Ticket' : {
                    ids : ['12019'],
                    desktop : true,
                },
                'MonatsTicket SozialTicket GP' : {
                    ids : ['1203'],
                    desktop : true,
                    shoppingName : 'MonatsTicket SozialTicket Göppingen'
                },
                'MonatsTicket Jedermann Bonus' : {
                    ids : ['12031', '12032'],
                    desktop : true,
                    shoppingName : 'MonatsTicket Jedermann Bonuscard'
                },
                '9-Uhr-FirmenTicket' : {
                    ids : ['15041'],
                    desktop : true,
                    mobile : true,
                },
                '9-Uhr-FiTiPlus' : {
                    ids : ['15141'],
                    desktop : true,
                    mobile : true,
                },
                '9-Uhr-FiTi 5 %' : {
                    ids : ['15541'],
                    desktop : true,
                    mobile : true,
                },
                '9-Uhr-FiTi 10 %' : {
                    ids : ['15551'],
                    desktop : true,
                    mobile : true,
                },
                '9-Uhr-FiTiPlus 5 %' : {
                    ids : ['15641'],
                    desktop : true,
                },
                '9-Uhr-FiTiPlus 10 %' : {
                    ids : ['15651'],
                    desktop : true,
                },
                '9-Uhr-JahresTicket' : {
                    ids : ['42445_1_VVS_1_'],
                    desktop : true,
                    mobile : true,
                },
                '9-Uhr-FirmenTicket 10 % Rabatt' : {
                    ids : ['15551_1_VVS_1_'],
                    desktop : true,
                    mobile : true,
                },
                '9-Uhr-FirmenTicket 5 % Rabatt' : {
                    ids : ['15541_1_VVS_1_'],
                    desktop : true,
                    mobile : true,
                },
                'StudiTicket' : {
                    ids : ['138', '226339', '22633']
                },
                'Anschluss-StudiTicket' : {
                    ids : ['22643']
                },
                'SemesterBerechtigung' : {
                    ids : ['22733']
                },
                'MonatsTicket Senior' : {
                    ids : ['31014']
                },
                'MonatsTicket Senior Bonus' : {
                    ids : ['31034']
                },
                'Abo-Sofort Senior' : {
                    ids : ['31144']
                },
                'VVS-JugendTicketBW' : {
                    ids : ['321']
                },
                'JahresTicket Senior' : {
                    ids : ['32444', '32544']
                },
                'MonatsTicket 9-Uhr' : {
                    ids : ['41015']
                },
                'MonatsTicket 9-Uhr Bonus' : {
                    ids : ['41035']
                },
                'Abo-Sofort 9-Uhr-Abo pers.' : {
                    ids : ['41645']
                },
                'Abo-Sofort 9-Uhr-AboPlus' : {
                    ids : ['41655']
                },
                'JahresTicket 9-Uhr' : {
                    ids : ['42445']
                },
                '9-Uhr-Abo' : {
                    ids : ['42545']
                },
                '9-Uhr-AboPlus' : {
                    ids : ['42555']
                },
                'MonatsTicket 14-Uhr-Junior' : {
                    ids : ['45016']
                },
                'MonatsTicket 14-Uhr-Junior Bonus' : {
                    ids : ['45036']
                },
                'Abo-Sofort 14-Uhr-Junior' : {
                    ids : ['45146']
                },
                'JahresTicket 14-Uhr-Junior' : {
                    ids : ['46446', '46546']
                },
                '4er-Ticket Erwachsene (4 Fahrten)' : {
                    ids : ['30', '31', '32', '33', '34', '35', '36', '030111', '030112', '030113', '030114', '030115', '030116', '030119', '502', '035111', '03011']
                },
                '4er-Ticket Kind (4 Fahrten)' : {
                    ids : ['37', '38', '39', '40', '41', '42', '43', '030211', '030212', '030213', '030214', '030215', '030216', '030219', '03021']
                },
                '10er-TagesTicket Online' : {
                    ids : ['0522_1_VVS_1_']
                },
                'JahresTicket (persönlich)' : {
                    ids : ['64', '65', '66', '67', '68', '69', '70', '134411', '134412', '134413', '134414', '134415', '134416', '134419']
                },
                'JahresTicketPlus' : {
                    ids : ['71', '72', '73', '74', '75', '76', '77', '134511', '134512', '134513', '134514', '134515', '134516', '134519']
                },
                'FirmenTicket' : {
                    ids : ['14041', '14141']
                },
                'FirmenTicket (persönliches JahresTicket)' : {
                    ids : ['89', '90', '91', '92', '93', '94', '95', '140411', '140412', '140413', '140414', '140415', '140416', '140419']
                },
                'FirmenTicket (JahresTicketPlus)' : {
                    ids : ['103', '104', '105', '106', '107', '108', '109', '141411', '141412', '141413', '141414', '141415', '141416', '141419']
                },
                'FirmenTicket mit Zuschuss (persönliches JahresTicket)' : {
                    ids : ['139', '140', '141', '142', '143', '144', '145', 'Dumm01', 'Dumm02', 'Dumm03', 'Dumm04', 'Dumm05', 'Dumm06', 'Dumm07']
                },
                'FirmenTicket mit Zuschuss (JahresTicketPlus)' : {
                    ids : ['153', '154', '155', '156', '157', '158', '159', 'Dumm08', 'Dumm09', 'Dumm10', 'Dumm11', 'Dumm12', 'Dumm13', 'Dumm14']
                },
                'MonatsTicket für Schüler / Auszubildende / Studenten' : {
                    ids : ['78', '79', '80', '81', '82', '83', '84', '210131', '210132', '210133', '210134', '210135', '210136', '210137']
                },
                // 'FirmenTicketPlus' : {
                //     ids : ['14141_1_VVS_1_']
                // },
                'FirmenTicket 5 %' : {
                    ids : ['14541', '14641']
                },
                'FirmenTicket 10 %' : {
                    ids : ['14551', '14651']
                },
                'FirmenTicket 5 % Rabatt (persönlich) Abbuchung' : {
                    ids : ['96', '97', '98', '99', '100', '101', '102', '145411', '145412', '145413', '145414', '145415', '145416', '145419']
                },
                'FirmenTicket 5 % Rabatt (übertragbar) Abbuchung' : {
                    ids : ['110', '111', '112', '113', '114', '115', '116', '146411', '146412', '146413', '146414', '146415', '146416', '146419']
                },
                'FirmenTicket 10 % Rabatt (persönlich) Abbuchung' : {
                    ids : ['146', '147', '148', '149', '150', '151', '152', '145511', '145512', '145513', '145514', '145515', '145516', '145519']
                },
                'FirmenTicket 10 % Rabatt (übertragbar) Abbuchung' : {
                    ids : ['160', '161', '162', '163', '164', '165', '166', '146511', '146512', '146513', '146514', '146515', '146516', '146519']
                },
                'SeniorenTicket (MonatsTicket)' : {
                    ids : ['85', '86', '310143', '310149']
                },
                'SeniorenTicket (JahresTicket)' : {
                    ids : ['88', '324449']
                },
                'StadtTicket MonatsTicket' : {
                    ids : ['1221_102_VVS_1_']
                }
            }
	    }
    );
})();

(function() {
  'use strict';

  angular
    .module('angular-mdv')
    .run(['$state', '$rootScope', '$window', '$location', 'amMoment', 'Piwik', 'mng-config.MDVConfigFetcher',
        'mng-util.MDVLog', 'mng-common.MDVUriParams', '$anchorScroll',
        function($state, $rootScope, $window, $location, amMoment, Piwik, MDVConfigFetcher, MDVLog, MDVUriParams, $anchorScroll) {
            MDVConfigFetcher.loadConfig('mng_config');
            MDVLog.enable(0);

            $rootScope.$state = $state;


            amMoment.changeTimezone('Europe/Berlin');

            var locationSearch;

            if ($window.localStorage['deployment_27_11_2020'] !== 'true') {
                $window.localStorage.clear();
                $window.localStorage['deployment_27_11_2020'] = true;
            }

            // IE not supporting 'startsWith'
            if (!String.prototype.startsWith) {
              String.prototype.startsWith = function(searchString, position) {
                position = position || 0;
                return this.indexOf(searchString, position) === position;
              };
            }

            $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
                if (toState.redirectTo) {
                    event.preventDefault();
                    $state.go(toState.redirectTo, toParams, {
                        location : 'replace'
                    });
                }
                //save location.search so we can add it back after transition is done
                locationSearch = $location.search();
            });

            $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
                {
                    Piwik.setDocumentTitle(toState.piwikTitle);
                    Piwik.setCustomUrl($window.location.hash);
                    Piwik.trackPageView();
                }

                if (!fromState.hasOwnProperty('id') || !toState.hasOwnProperty('id')) {
                    return;
                }

                if (!locationSearch) {
                    locationSearch = {};
                }

                if (fromState.id === toState.id) {
                    if (toState.reset) {
                        delete locationSearch.deeplink;
                        MDVUriParams.clear('deeplink');
                    } else {
                        // restore all query string parameters back to $location.search
                        locationSearch;
                    }
                } else {
                    delete locationSearch.deeplink;
                    MDVUriParams.clear('deeplink');
                }
                $location.search(locationSearch);
            });


            $rootScope.$on('$locationChangeSuccess', function() {
                $anchorScroll('vvs_body');
            });

    }]);
})();

/* global moment :false, download :false */

(function() {
    'use strict';

    angular
        .module('angular-mdv')
        .constant('moment', moment)
        .constant('downloadJs', download)
        .constant('L', L)
        .constant('angularMomentConfig', {
            'timezone': 'Europe/Berlin'
        })


    /**
     * The configuration is now an object loaded as a Constant on application start.
     **/
    .constant('mng_config', {
        'mng-translations': {
            // MOTs
            TRAIN: 'train',
            COMMUTER: 'commuter',
            SUBWAY: 'subway',
            LIGHTRAIL: 'light rail',
            TRAM: 'tram',
            BUS: 'bus',
            REGIONALBUS: 'regional bus',
            COACH: 'coach',
            CABLECAR: 'cable car',
            FERRY: 'ferry',
            DEMANDTAXI: 'taxi on demand',
            OTHER: 'other',
            PLAIN: 'plain',
            LOCALTRAIN: 'local train',
            NATIONALTRAIN: 'national train',
            INTERNATIONALTRAIN: 'international train',
            HIGHSPEEDTRAIN: 'highspeed train',
            RAILREPLACEMENT: 'rail replacement',
            RAILSHUTTLE: 'rail shuttle',
            CITIZENBUS: 'citicen bus',
            // MODES
            WAIT: 'wait',
            INTERCHANGE: 'interchange',
            STAYSEATED: 'stay seated',
            SAVECONNECTION: 'save connection',
            FOOTPATH: 'footpath',
            BIKEANDRIDE: 'bike&ride',
            BIKE: 'bike',
            CAR: 'car',
            TAXI: 'taxi',
            // PLACEHOLDER
            UNKNOWN_POINT: 'unknown point',
            MID: ' Middle',
            END: ' End',
            SOUTH: ' South',
            WEST: ' West',
            NORTH: ' North',
            EAST: ' East',
            SPACER: ' '
        },
        'mng-persistence': {
            databases: {
                favorites: {
                    location: {
                        name: 'mdv_location_favorites',
                        limit: 10,
                        containUsage: true
                    },
                    transportation: {
                        name: 'mdv_transportation_favorites',
                        limit: 10,
                        containUsage: true
                    },
                    odv: {
                        name: 'mdv_odv_favorites',
                        limit: 10
                    },
                    options: {
                        name: 'mdv_options_favorites',
                        limit: 1
                    },
                    user: {
                        name: 'mdv_user_favorites',
                        limit: 1
                    }
                }
            },
            options: {
                createDb: {
                    auto_compaction: true,
                    adapter: 'localstorage'
                },
                getDoc: {
                    attachments: true
                },
                getAllDocs: {
                    include_docs: true
                },
                getDbChanges: {
                    since: 'now',
                    live: true
                },
                queryDb: {
                    include_docs: true
                }
            }
        },
        'mng-comm': {
            MDVJourneyRequester : {
                subservices : ['mng-comm.itd.json.MDVEFATrip', 'mng-comm.itd.json.MDVEFAMoveTrip'],
                rejectEmptyResponses : true
            },
            MDVDepartureRequester : {
                rejectEmptyResponses : true
            },
            MDVLivePositionsRequester : {
                subservices : ['mng-comm.itd.json.MDVEFALivePositions']
            },
            MDVJourneys: {
                options: {
                    accessibility: true,
                    dateTime: true,
                    productRestrictions: true,
                    individualTransport: {
                        global: false, // available in local mode only
                        modus: ['', '']
                    },
                    publicTransport: true,
                    via: true,
                    fare: true,
                    sharing: true,
                    pdfOutput: true
                }
            },
            MDVDownloads : {
                MapRoute : {
                    subservices : ['mng-comm.itd.json.MDVEFAMapRoute']
                },
                ROP : {
                    subservices : ['mng-comm.itd.json.MDVEFAROP']
                },
                STT : {
                    subservices : ['mng-comm.itd.json.MDVEFASTT']
                },
                TTB : {
                    subservices : ['mng-comm.itd.json.MDVEFATTB']
                },
                PS : {
                    options: {
                        personalSchedule: true,
                        accessibility: true,
                        productRestrictions: true,
                        individualTransport: true,
                        publicTransport: true,
                        via: true,
                        lineRestrictions: true,
                        sharing: true
                    }
                },
                PrintTrip : {
                    subservices : ['mng-comm.itd.json.MDVEFAPrintTrip']
                }
            },
            MDVOptions: {
                individualTransport: {
                    minutes: 15,
                    type: 'walk',
                    walkSpeed: 'normal',
                    cycleSpeed: 14,
                    avoidElevation: true
                },
                productRestrictions: {
                    'other': true
                },
                dateTime: {
                    //dateFormat: 'DD.MM.YYYY',
                    //timeFormat: 'HH:mm',
                    timeCut: ['01:00', '04:00'],
                    timeCutInterval: 1,
                    useRealTime: true
                },
                personalSchedule: {
                    dateFormat: 'DD.MM.YYYY',
                    timeFormat: 'HH:mm'
                },
                pdfOutput: {
                    elevationSummary: true,
                    elevationProfile: false
                },
                accessibility: {
                    showAccessibility: false
                },
                sharing: {
                    enabled: false,
                    car2go: false,
                    callabike: false
                },
                via: {
                    optionsList: [],
                    optionsListItem: {
                        type: 'any',
                        dwellTime: '0',
                        enabled: true
                    }
                }
            }
        },
        'mng-comm-itd': {
            MDVEFARequester: {
                url: '/mngvvs',
                pushUrl : '/mngperso',
                // jsonp : true,
                mockEnabled: false
            },
            MDVPush : {
                mainUrl : 'pushUrl'
            },
            ServerMapping : {
                urlMapping : {
                    'efatest_' : 'http://efa-test.dc.vvs.de',
                    'efa01.dc.vvs.de_': 'https://www3.vvs.de',
                    'efa02.dc.vvs.de_': 'https://www3.vvs.de',
                    'efa03.dc.vvs.de_': 'https://www3.vvs.de',
                    'efa04.dc.vvs.de_': 'https://www3.vvs.de',
                    'efa05.dc.vvs.de_' : 'https://www3.vvs.de',
                    'efa06.dc.vvs.de_' : 'https://www3.vvs.de',
                    'efa07.dc.vvs.de_' : 'https://www3.vvs.de',
                    'efa08.dc.vvs.de_' : 'https://www3.vvs.de',
                    'efa09.dc.vvs.de_' : 'https://www3.vvs.de',
                    'efa10.dc.vvs.de_' : 'https://www3.vvs.de',
                    'efa11.dc.vvs.de_' : 'https://www3.vvs.de',
                    'efa12.dc.vvs.de_' : 'https://www3.vvs.de',
                    'diva4-vvs.m.mdv' : 'http://diva4-vvs.m.mdv:8080'
                },
                prefixMapping : {
                    PRINT_TRIP : 'vvs',
                    STT : '',
                    PS : 'vvs',
                    SM : 'Download/EnvMaps',
                    SM_ME : 'Download/EnvMaps',
                    RM : 'vvs',
                    RM_ID : 'vvs',
                    CM : '',
                    CM_ID : ''
                }
            }
        },
        'mng-comm-itd-json': {
            defaultParams: {
                outputFormat: 'rapidJSON',
                serverInfo : 1,
                coordOutputFormat: 'EPSG:4326',
                SpEncId: 0
            },
            MDVEFAServingLines : {
                defaultParams: {
                    lsShowTrainsExplicit: 1,
                    command: 'direct',
                    net: 'vvs'
                }
            },
            MDVEFALineList : {
                defaultParams: {
                lineListSubnetwork: 'vvs',
                reqType: 'Default',
                // reqType: 'stt',
                mergeLV: 1,
                mergeProj: 1,
                mergeDir: 1,
                llBranchCodesMacro: true,
                lineListBranchCode: [10]
                }
            },
            MDVEFALivePositions : {
                defaultParams : {
                    CoordSystem : 'WGS84'
                }
            },
            MDVEFADM: {
                defaultParams: {
                    deleteAssignedStops: 1,
                    mode: 'direct',
                    type_dm: 'any',
                    limit: '40',
                    macroWebDep: true
                },
                mocks: {
                    'default': 'default'
                },
                mockDir: '/app/mdv.components/mng-comm.itd.json/src/dm/mocks/%s.mock.json',
                mockEnabled: false,
                grouped: {
                    departures: false,
                    arrivals: false,
                    lines: false
                }
            },
            MDVEFAStopfinder: {
                defaultParams: {
                    '': {
                        suggestApp: 'vvs'
                    },
                    'poi': {}
                },
                mocks: {
                    'default': 'fullhit', // 'default',
                    '&name_sf=o': 'origin',
                    '&name_sf=d': 'destination'
                },
                mockDir: '/app/mdv.components/mng-comm.itd.json/src/stopfinder/mocks/%s.mock.json',
                mockEnabled: false
            },
            MDVEFATrip: {
                url: '/XML_TRIP_REQUEST2?',
                defaultParams: {
                    deleteAssignedStops: 0,
                    searchLimitMinutes: 360,
                    deleteITPTWalk: 0,
                    useRealtime: 1,
                    useLocalityMainStop: 0,
                    computationType : 'sequence',
                    macroWebTrip: true
                },
                parser : {
                    combineWalkLegs : true,
                    keepRaw : true
                },
                mocks: {
                    'default': 'test'
                },
                mockDir: '/app/mdv.components/mng-comm.itd.json/src/trip/mocks/%s.mock.json',
                mockEnabled: false
            },
            MDVEFAGeoObject: {
                defaultParams : {
                    stFaZon : 1,
                    spTZO : 1,
                    vSL: 1
                }
            },
            MDVEFAAddInfo: {
                mocks: {
                    'default': 'default.nsw'
                },
                mockDir: '/app/mdv.components/mng-comm.itd.json/src/addinfo/mocks/%s.mock.json',
                mockEnabled: false
            },
            MDVEFACoord: {
                mocks: {
                    'default': 'default.nsw'
                },
                mockDir: '/app/mdv.components/mng-comm.itd.json/src/coord/mocks/%s.mock.json',
                mockEnabled: false
            },
            MDVEFATTB: {
                url: '/XML_TTB_REQUEST?',
                defaultParams: {
                    // base64: 1,
                    command: 'direct'
                },
                cache: true
            },
            MDVEFAROP: {
                url: '/XML_ROP_REQUEST?',
                defaultParams: {
                    // base64: 1
                },
                cache: true
            },
            MDVEFASTT: {
                url: '/XML_STT_REQUEST?',
                defaultParams: {
                    // base64: 1,
                    mode: 'direct',
                    allStopInfo: 1

                },
                cache: true
            },
            MDVEFAPS: {
                url: '/XML_PS_REQUEST2?',
                defaultParams: {
                    // base64: 1
                },
                cache: true
            }
        },
        'mng-comm-model': {
            'MDVMessage': {
                textMapping: {
                    'content' : 'htmlText'
                }
            }
        },
        'mng-leaflet' : {
            MDVLeafletVELOC : {
                options : {
                    productRestrictions  : {
                        train  : true,
                        commuter  : true,
                        subway  : false,
                        lightRail  : true,
                        tram  : false,
                        bus  : true,
                        regionalBus  : false,
                        coach  : false,
                        cableCar  : false,
                        ferry  : false,
                        demandTaxi  : false,
                        other  : false,
                        plain  : false,
                        localTrain  : false,
                        nationalTrain  : false,
                        internationalTrain  : false,
                        highspeedTrain  : false,
                        railReplacement  : false,
                        railShuttle  : false,
                        citizenBus  : false
                    },
                    filter : {
                        enable : true,
                        showVehiculesWithoutDelay : true,
                        minVehiculeDelay : 0
                    }
                }
            },
            MNGLeaflet : {
                vvsNetworkMapContainer : {
                    zoomControl : false,
                    center : [3328, 4736],
                    //center : [0, 0],
                    zoom : 0,
                    // maxZoom : 6,
                    // attributionControl : true,
                    layerOptions : {
                        defaultLayer : 'net',
                        mapLayers : [{
                            id: 'net',
                            settings: {
                                "layers": [
                                    {
                                        "subLayer": [{
                                            "url": "http://map.vvs.de/maps/VVS/VVS-Netzplan/netzplan/web2019/zoomlevel{z}/columns{colMin}-{colMax}/column{x}/rows{rowMin}-{rowMax}/{y}_{x}_{z}.png",
                                            "tileSize": [256],
                                            "tilingOrigin": [
                                                [0, 0]
                                            ],
                                            "bounds": [[
                                                [6656, 0],
                                                [0, 9472]
                                            ]],
                                            "minZoom": 0,
                                            "maxZoom": 4,
                                            "id": "netplan",
                                            "switchGroup": {
                                                "id": "netplan",
                                                "mandatory": true
                                            },
                                            "caption": "Netzplan",
                                            "attribution": null
                                        }]
                                    }
                                ],
                                "crs": {
                                    "code": "Simple",
                                    "transform": [
                                        1,
                                        0,
                                        1,
                                        0
                                    ],
                                    "scales": [
                                        16,
                                        8,
                                        4,
                                        2,
                                        1
                                    ]
                                },
                                "caption": "Netzplan"
                            }
                        }]
                    }
                },
                default : {
                    zoomControl : false,
                    center : [48.784171, 9.178921],
                    zoom : 3,
                    maxZoom : 6,
                    attributionControl : true,
                    layerOptions : {
                        defaultLayer : 'gis',
                        defaultAllowedOverlays : ['orthoOverlay'],
                        mapLayers: [
                            {
                                id: 'ortho',
                                settings: {
                                    "layers": [{
                                        "subLayer": [{
                                            "url": ["https://map.vvs.de/maps/VVS/Luftbilder/Bild/zoomlevel{z}/columns{colMin}-{colMax}/column{x}/rows{rowMin}-{rowMax}/{y}_{x}_{z}.jpg"],
                                            "tileSize": [256],
                                            "tilingOrigin": [
                                                [599000, 3000000]
                                            ],
                                            "minZoom": 0,
                                            "maxZoom": 7,
                                            "bounds": [
                                                [
                                                    [789000, 3454000],
                                                    [720000, 3574000]
                                                ]
                                            ]
                                        }],
                                        "id": "ortho",
                                        "switchGroup": {
                                            "id": "ortho",
                                            "mandatory": true
                                        },
                                        "caption": "VVS-Luftbilder",
                                        "attribution": "©  Landeshauptstadt Stuttgart, Stadtmessungsamt"
                                    }, {
                                        "subLayer": [{
                                            "url": ["https://map.vvs.de/maps/VVS/Luftbilder/Text/zoomlevel{z}/columns{colMin}-{colMax}/column{x}/rows{rowMin}-{rowMax}/{y}_{x}_{z}.png"],
                                            "tileSize": [256],
                                            "tilingOrigin": [
                                                [599000, 3000000]
                                            ],
                                            "minZoom": 0,
                                            "maxZoom": 7,
                                            "bounds": [
                                                [
                                                    [789000, 3454000],
                                                    [720000, 3574000]
                                                ]
                                            ]
                                        }],
                                        "caption": "captions",
                                        "id": "orthoOverlay",
                                        "requires": ["ortho"],
                                        "switchGroup": {
                                            "id": "orthoOverlay",
                                            "mandatory": false
                                        }
                                    }, {
                                        "subLayer": [{
                                            "url": ["https://map.vvs.de/maps/VVS/Map/VLP_Overlay/Ortho/zoomlevel{z}/columns{colMin}-{colMax}/column{x}/rows{rowMin}-{rowMax}/{y}_{x}_{z}.png"],
                                            "tileSize": [256],
                                            "tilingOrigin": [
                                                [599000, 3000000]
                                            ],
                                            "minZoom": 0,
                                            "maxZoom": 7,
                                            "bounds": [
                                                [
                                                    [789000, 3454000],
                                                    [720000, 3574000]
                                                ]
                                            ]
                                        }],
                                        "id": "orthovlp",
                                        "switchGroup": {
                                            "id": "vlp",
                                            "mandatory": false
                                        },
                                        "caption": "Liniennetz",
                                        "attribution": "© PTV AG / HERE, LGL Baden-Württemberg"
                                    }],
                                    "crs": {
                                        "code": "NBWT",
                                        "transform": [1, 0, 1, 0],
                                        "baseCrs": {
                                            "code": "EPSG:31467",
                                            "transform": [1, 0, -1, 6160000],
                                            "projDef": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +datum=potsdam +units=m +no_defs",
                                            "calcLenType": "Pythagoras"
                                        },
                                        "scales": [
                                            70.5555419921875,
                                            35.27777099609375,
                                            17.638885498046875,
                                            7.055547366352202,
                                            3.527773683176101,
                                            1.9999965184937611,
                                            0.8000008361576882,
                                            0.4000004180788441
                                        ]
                                    },
                                    "caption": "VVS-Luftbilder"
                                }
                            },
                            {
                                id: 'top',
                                settings: {
                                    "layers": [{
                                        "subLayer": [{
                                            "url": ["https://map.vvs.de/maps/VVS/Stadtkarte/tiles/zoomlevel{z}/columns{colMin}-{colMax}/column{x}/rows{rowMin}-{rowMax}/{y}_{x}_{z}.png"],
                                            "tileSize": [256],
                                            "tilingOrigin": [
                                                [700000, 3300000]
                                            ],
                                            "minZoom": 0,
                                            "maxZoom": 5,
                                            "bounds": [
                                                [
                                                    [800000, 3454000],
                                                    [710000, 3575000]
                                                ]
                                            ]
                                        }],
                                        "id": "topkarte",
                                        "switchGroup": {
                                            "id": "topkarte",
                                            "mandatory": true
                                        },
                                        "caption": "Topkarte",
                                        "attribution": ""
                                    }],
                                    "crs": {
                                        "code": "NBWT",
                                        "transform": [1, 0, 1, 0],
                                        "baseCrs": {
                                            "code": "EPSG:31467",
                                            "transform": [1, 0, -1, 6160000],
                                            "projDef": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +datum=potsdam +units=m +no_defs",
                                            "calcLenType": "Pythagoras"
                                        },
                                        "scales": [
                                            35.27772177419355,
                                            17.638831967213115,
                                            10,
                                            4.999981831395349,
                                            2.4999908945221447,
                                            1.25
                                        ]
                                    },
                                    "caption": "Topkarte"
                                }
                            }, {
                                id: 'gis',
                                settings: {
                                    "layers": [{
                                        "subLayer": [{
                                            "url": ["https://map.vvs.de/maps/VVS/Map/tiles/zoomlevel{z}/columns{colMin}-{colMax}/column{x}/rows{rowMin}-{rowMax}/{y}_{x}_{z}.png"],
                                            "tileSize": [256],
                                            "tilingOrigin": [
                                                [599000, 3000000]
                                            ],
                                            "minZoom": 0,
                                            "maxZoom": 7,
                                            "bounds": [
                                                [
                                                    [797684, 3000000],
                                                    [599000, 3577991]
                                                ]
                                            ]
                                        }],
                                        "id": "gis_osm",
                                        "switchGroup": {
                                            "id": "GIS OSM",
                                            "mandatory": true
                                        },
                                        "caption": "gis_osm",
                                        "attribution": "© PTV AG / HERE, OpenStreetMap-Mitwirkende"
                                    }],
                                    "crs": {
                                        "code": "NBWT",
                                        "transform": [1, 0, 1, 0],
                                        "baseCrs": {
                                            "code": "EPSG:31467",
                                            "transform": [1, 0, -1, 6160000],
                                            "projDef": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +datum=potsdam +units=m +no_defs",
                                            "calcLenType": "Pythagoras"
                                        },
                                        "scales": [
                                            70.5555419921875,
                                            35.27777099609375,
                                            17.638885498046875,
                                            8.819439338235295,
                                            3.527773683176101,
                                            1.7638868415880504,
                                            0.8819430790405034,
                                            0.4000004180788441
                                        ]
                                    },
                                    "caption": "GIS OSM"
                                }

                            }, {
                                id: 'osm',
                                settings: {
                                    "layers": [{
                                        "subLayer": [{
                                            "url": ["https://map.vvs.de/maps/VVS/OSM/zoomlevel{z}/columns{colMin}-{colMax}/column{x}/rows{rowMin}-{rowMax}/{y}_{x}_{z}.png"],
                                            "tileSize": [256],
                                            "tilingOrigin": [
                                                [599000, 3000000]
                                            ],
                                            "minZoom": 0,
                                            "maxZoom": 7,
                                            "bounds": [
                                                [
                                                    [797684, 3000000],
                                                    [599000, 3577991]
                                                ]
                                            ]
                                        }],
                                        "id": "osm",
                                        "switchGroup": {
                                            "id": "OSM",
                                            "mandatory": true
                                        },
                                        "caption": "osm",
                                        "attribution": "© PTV AG / HERE, OpenStreetMap-Mitwirkende"
                                    }],
                                    "crs": {
                                        "code": "NBWT",
                                        "transform": [1, 0, 1, 0],
                                        "baseCrs": {
                                            "code": "EPSG:31467",
                                            "transform": [1, 0, -1, 6160000],
                                            "projDef": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +datum=potsdam +units=m +no_defs",
                                            "calcLenType": "Pythagoras"
                                        },
                                        "scales": [
                                            70.5555419921875,
                                            35.27777099609375,
                                            17.638885498046875,
                                            8.819439338235295,
                                            3.527773683176101,
                                            1.7638868415880504,
                                            0.8819430790405034,
                                            0.4000004180788441
                                        ]
                                    },
                                    "caption": "OSM"
                                }

                            },
                            {
                                id: 'gis',
                                settings: {
                                    "layers": [{
                                        "subLayer": [{
                                            "url": ["https://map.vvs.de/maps/VVS/Map/VLP_Overlay/GISKarte/zoomlevel{z}/columns{colMin}-{colMax}/column{x}/rows{rowMin}-{rowMax}/{y}_{x}_{z}.png"],
                                            "tileSize": [256],
                                            "tilingOrigin": [
                                                [599000, 3000000]
                                            ],
                                            "minZoom": 0,
                                            "maxZoom": 7,
                                            "bounds": [
                                                [
                                                    [797684, 3000000],
                                                    [599000, 3577991]
                                                ]
                                            ]
                                        }],
                                        "id": "gisvlp",
                                        "switchGroup": {
                                            "id": "vlp",
                                            "mandatory": false
                                        },
                                        "caption": "Liniennetz",
                                        "attribution": ""
                                    }],
                                    "crs": {
                                        "code": "NBWT",
                                        "transform": [1, 0, 1, 0],
                                        "baseCrs": {
                                            "code": "EPSG:31467",
                                            "transform": [1, 0, -1, 6160000],
                                            "projDef": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +datum=potsdam +units=m +no_defs",
                                            "calcLenType": "Pythagoras"
                                        },
                                        "scales": [
                                            70.5555419921875,
                                            35.27777099609375,
                                            17.638885498046875,
                                            8.819439338235295,
                                            3.527773683176101,
                                            1.7638868415880504,
                                            0.8819430790405034,
                                            0.4000004180788441
                                        ]
                                    },
                                    "caption": "Liniennetz"
                                },
                                overlay: 1
                            }
                        ]
                    }
                }
            }
        }
    });

}());

(function() {
    'use strict';

    /*****************************   log config   ***************************/
    angular
        .module('angular-mdv')
        .config(logConfig);

    /** @ngInject */
    function logConfig($logProvider, $qProvider) {
        // Enable log
        $logProvider.debugEnabled(true);
        $qProvider.errorOnUnhandledRejections(false)
    }

    angular
        .module('angular-mdv')
        .config(httpConfig);

    function httpConfig($httpProvider) {
         var interceptor = ['$rootScope', '$q', function ($rootScope, $q) {

            return {

                responseError : function(rejection) {
                        //debugger;
                        return $q.reject(rejection);
                    }
            };
        }];

        $httpProvider.interceptors.push(interceptor);
    }


    /*****************************   md config   ***************************/
    angular
        .module('angular-mdv')
        .config(mdConfig);

    function mdConfig($mdThemingProvider) {
        $mdThemingProvider.definePalette('VVSPalette', {
            '50': '6e6e6e',
            '100': '6e6e6e',
            '200': '6e6e6e',
            '300': '6e6e6e',
            '400': '6e6e6e',
            '500': '6e6e6e',
            '600': '6e6e6e',
            '700': '6e6e6e',
            '800': '6e6e6e',
            '900': '6e6e6e',
            'A100': '6e6e6e',
            'A200': '6e6e6e',
            'A400': '6e6e6e',
            'A700': '6e6e6e',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': ['50', '100',
             '200', '300', '400', 'A100'],
            'contrastLightColors': 'dark'
          });

          $mdThemingProvider.theme('default')
            .primaryPalette('VVSPalette')
            .accentPalette('VVSPalette');
    }


    /************************  translation config   ************************/
    angular
        .module('angular-mdv')
        .config(['$translateProvider', '$translatePartialLoaderProvider', '$windowProvider', '$mdDateLocaleProvider', 'VVSConst', translationConfig]);

    function translationConfig($translateProvider, $translatePartialLoaderProvider, $windowProvider, $mdDateLocaleProvider, VVSConst) {
        // get browser language
        var browserLanguage = $windowProvider.$get().navigator.language || $windowProvider.$get().navigator.userLanguage,
            // set default language to browser language if language is available
            defaultLanguage = (VVSConst.language.available.indexOf(browserLanguage) > -1) ? browserLanguage : VVSConst.language.default;

        // use the default language
        $translateProvider.preferredLanguage(defaultLanguage);

        $translateProvider.useSanitizeValueStrategy('escapeParameters');
        // add translations used in all views
        $translatePartialLoaderProvider.addPart('common');

        // configure translation provider
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'translation/{lang}.json'
        });

        var localeData = moment.localeData();

        $mdDateLocaleProvider.months      = localeData._months;
        $mdDateLocaleProvider.shortMonths = moment.monthsShort();
        $mdDateLocaleProvider.days        = localeData._weekdays;
        $mdDateLocaleProvider.shortDays   = localeData._weekdaysMin;
        $mdDateLocaleProvider.firstDayOfWeek = localeData._week.dow;
    }

}());

(function() {
    'use strict';

    /**
     * @ngdoc overview
     * @name mdv
     * @module mdv
     * @requires mng-comm
     * @requires mng-comm.itd
     * @requires mng-comm.itd.xmljson
     * @requires mng-config
     * @requires mng-event
     * @requires mng-model
     * @requires mng-util
     * @requires mng-odv
     *
     * @description
     * # mdv (mdv core module)
     * The mdv module combines all available mdv-components for AngularJS. In order to use all these
     * components you can include this core module without any further inclusion needed.
     * If only some parts of the mdv-components is used, each single component can also be included
     * on its own. As many mdv-components depend on other mdv-components (e.g. mng-logger), it is
     * recommended to use this core module.
     *
     * ## General usage
     * ```js
     * // inject all mdv-components at once
     * angular.module('your.module', ['mdv']);
     * ```
     * ## mdv-components
     * The following list gives a short overview of the available mdv-components. For further
     * details, please refer to the components themselves.
     *
     * ### {@link mng-comm}
     * Main communication module. This module describes an abstract interface to all back-end
     * communication. It offers a unique interface that combines all different back-end request
     * services and cares about caching.
     *
     * ### {@link mng-comm.itd}
     * EFA communication module. This module provides the communication to the EFA interface and the
     * formatter utilities that are useful for every kind of EFA communication.
     *
     * ### {@link mng-config}
     * This module cares about fetching and providing configurations that are needed for all
     * mdv-components.
     *
     * ### {@link mng-model}
     * This module defines the basic model objects. All communication services need to parse their
     * gathered information into this model to ensure a unique handling in the upper levels in the
     * interface architecture. As the model describes a fix interface the upper levels do not need
     * to handle back-end-specific characteristics and can rely on the fix interface that is
     * defined.
     *
     * ### {@link mng-odv}
     * This module provides a simple ODV (origin, destination, via) interface where these points can
     * be inserted in input directives with lists that are filled with suggestion locations while
     * typing.
     *
     * ### {@link mng-util}
     * Whereas each module can provide its own utility service, the mng-util module provides utility
     * functions that are needed within multiple modules. This ensures that utility functions can
     * be maintained at a single part in the code instead of maintaining them in each single module.
     * This module also contains the services for exception handling and logging.

     * ### {@link mng-common}
     * The mng-common module contains some common components that can be used from different
     * application modules.
     *
     * ### {@link mng-leaflet}
     * The mng-common module contains common leaflet plugins.
     *
     * ### {@link mng-personalization}
     * The mng-personalization module contains push service communication.
     *
     */
    angular.module('mng', ['mng-comm', 'mng-comm.itd', 'mng-comm.itd.json',
          'mng-config', 'mng-model', 'mng-util', 'mng-common', 'mng-favorite', 'mng-leaflet',
          'mng-personalization']);
}());

angular.module("angular-mdv").run(["$templateCache", function($templateCache) {$templateCache.put("app/vvs.components/main.html","<div>\r\n    <!--<div ui-view></div>-->\r\n    <div ng-show=\"$state.includes(\'vvs.trip\')\" ui-view=\"trip\"></div>\r\n    <div ng-show=\"$state.includes(\'vvs.dm\')\" ui-view=\"dm\"></div>\r\n    <div ng-show=\"$state.includes(\'vvs.stops\')\" ui-view=\"stops\"></div>\r\n    <div ng-show=\"$state.includes(\'vvs.stops\')\" ui-view=\"map\"></div>\r\n    <div ng-show=\"$state.includes(\'vvs.lines\')\" ui-view=\"lines\"></div>\r\n    <div ng-show=\"$state.includes(\'vvs.rop\')\" ui-view=\"rop\"></div>\r\n    <div ng-show=\"$state.includes(\'vvs.stt\')\" ui-view=\"stt\"></div>\r\n    <div ng-show=\"$state.includes(\'vvs.ttb\')\" ui-view=\"ttb\"></div>\r\n    <div ng-show=\"$state.includes(\'vvs.map\')\" ui-view=\"map\"></div>\r\n    <div ng-show=\"$state.includes(\'vvs.personalization\')\" ui-view=\"personalization\"></div>\r\n    <div ng-show=\"$state.includes(\'vvs.info\')\" ui-view=\"info\"></div>\r\n    <div ng-show=\"$state.includes(\'vvs.livemap\')\" ui-view=\"livemap\"></div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/footer.html","<div class=\"container\" ng-controller=\"VVSCommonFooterController as VVSCommonFooterCtrl\">\r\n    <div class=\"col-xs-12 ctblock col-xs-12 nopadding-xs\">\r\n        <footer class=\"visible-md visible-lg spacertop\">\r\n            <ul>\r\n                <li><a ng-attr-href=\"{{(sharedData.currentLanguage===\'en\') && \'http://en.vvs.de/footer/imprint/\' || \'http://www.vvs.de/impressum/\'}}\">{{\'Impressum\' | translate}}</a></li>\r\n                <li><a href=\"http://www.vvs.de/datenschutz/\">{{\'Datenschutz\' | translate}}</a></li>\r\n                <li ng-if=\"VVSCommonFooterCtrl.serverID\">\r\n                    {{VVSCommonFooterCtrl.serverID}}\r\n                </li>\r\n            </ul>\r\n        </footer>\r\n    </div>\r\n    <!-- material-scrolltop button -->\r\n    <div ng-click=\"VVSCommonFooterCtrl.gotoTop()\" class=\"btt-btn vvs-back-to-top\"><vvs-icon name=\"up\"></vvs-icon>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/header.html","<nav class=\"navbar navbar-inverse\">\r\n    <div class=\"container\">\r\n        <div class=\"navbar-header upper hidden-xs hidden-sm\">\r\n            <div class=\"navbar-header-title\">\r\n                <h1 class=\"hidden-xs\"></h1>\r\n                <!-- <h1 class=\"hidden-xs\">{{\'VVS Fahrplanauskunft\' | translate}}</h1> -->\r\n            </div>\r\n            <div class=\"navbar-header-menu\">\r\n                <!-- <a href=\"javascript:void(0)\" class=\"menu-list-item\" ui-sref=\"vvs.personalization.login\" ui-sref-opts=\"{reload: true, notify: true}\"> -->\r\n                <a href=\"javascript:void(0)\" target=\"_blank\"\r\n                ng-attr-href=\"{{(sharedData.currentLanguage===\'en\') &amp;&amp; \'https://www.vvs.de/fahrplan/meldungen-und-benachrichtigungsservice\' || \'https://www.vvs.de/fahrplan/meldungen-und-benachrichtigungsservice\'}}\" class=\"menu-list-item hidden-xs\" tabindex=\"-1\" href=\"https://www.vvs.de/\">\r\n                    {{\'Meldungen\'|translate}}\r\n                </a>\r\n                <a href=\"javascript:void(0)\" class=\"menu-list-item\" ui-sref=\"vvs.personalization.login\" ui-sref-opts=\"{reload: true, notify: true}\">\r\n                    {{\'Benachrichtigungsservice\' | translate}}\r\n                </a>\r\n                <a href=\"javascript:void(0)\" target=\"_blank\" ng-attr-href=\"{{(sharedData.currentLanguage===\'en\') &amp;&amp; \'https://en.vvs.de/home/\' || \'https://www.vvs.de/\'}}\" class=\"menu-list-item hidden-xs\" tabindex=\"-1\" href=\"https://www.vvs.de/\">\r\n                    VVS Homepage</a>\r\n                <a href=\"javascript:void(0)\">\r\n                    <vvs-language-switcher mode=\"web\"></vvs-language-switcher>\r\n                </a>\r\n            </div>\r\n        </div>\r\n        <!-- <div class=\"navbar-header bottom\" style=\"background-color: darkseagreen;\">bottom content</div> -->\r\n        <div class=\"navbar-header\">\r\n            <button type=\"button\" class=\"offcanvas-toggle visible-xs\" ng-click=\"toggleMobileMenu()\">\r\n            <!-- <button type=\"button\" class=\"offcanvas-toggle visible-xs visible-sm\" ng-click=\"toggleMobileMenu()\"> -->\r\n                <span class=\"sr-only\">{{\'Toggle navigation\' | translate}}</span>\r\n                <vvs-icon name=\"toggle\"></vvs-icon>\r\n            </button>\r\n            <h1 class=\"visible-xs\">\r\n                <!-- <span ng-show=\"(\'vvs.trip.init\'|isState)\" ng-click=\"triggerResetOptionsClick()\">{{\'Verbindungen\' | translate}}</span> -->\r\n                <!-- <span ng-show=\"(\'vvs.trip.result\'|isState)\">{{\'Fahrtempfehlung\' | translate}}</span> -->\r\n                <span ng-show=\"(\'vvs.trip.details\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.trip.result\" class=\"back\">{{\'Fahrtdetails\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.dm.init\'|isState)\">{{\'Abfahrt / Ankunft\' | translate}}</span>\r\n                <!-- <span ng-show=\"(\'vvs.stops.init\'|isState)\">{{\'Haltestelle\' | translate}}</span> -->\r\n                <span ng-show=\"(\'vvs.dm.lines\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.dm.init\" class=\"back\">{{\'Haltestellen Abfahrten\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.rop.lines\'|isState)\">{{\'Linien\' | translate}}</span>\r\n                <span ng-show=\"(\'vvs.info.init\'|isState)\">{{\'1Meldungen\' | translate}}</span>\r\n                <!-- <span ng-show=\"(\'vvs.info.disruption\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.info.init\" class=\"back\">{{\'Störungen\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.info.disruptionDetails\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.info.disruption\" class=\"back\">{{\'Störungsdetails\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.info.timetableChange\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.info.init\" class=\"back\">{{\'Fahrplanänderungen\' | translate}}</a>\r\n                    </span>\r\n                <span ng-show=\"(\'vvs.info.timetableChangeDetails\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.info.timetableChange\" class=\"back\">{{\'Fahrplanänderungen\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.info.specialTraffic\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.info.init\" class=\"back\">{{\'Sonderverkehre\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.info.specialTrafficDetails\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.info.specialTraffic\" class=\"back\">{{\'Sonderverkehrsdetails\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.info.escalatorElevator\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.info.init\" class=\"back\">{{\'Aufzüge und Zugänge\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.info.general\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.info.init\" class=\"back\">{{\'Allgemeine Informationen\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.info.generalDetails\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.info.general\" class=\"back\">{{\'Details der Allgemeine Information\' | translate}}</a>\r\n                </span> -->\r\n\r\n                <span ng-show=\"(\'vvs.map\'|isState)\">{{\'Karte\' | translate}}</span>\r\n                <span ng-show=\"(\'vvs.stt.init\'|isState)\">{{\'Aushangfahrplan\' | translate}}</span>\r\n                <span ng-show=\"(\'vvs.stt.lines\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.stt.init\" class=\"back\">{{\'Aushangfahrplan\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.stt.stops\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.stt.init\" class=\"back\">{{\'Aushangfahrplan\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.ttb.init\'|isState)\">{{\'Fahrplanbuchseiten\' | translate}}</span>\r\n                <span ng-show=\"(\'vvs.ttb.lines\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.ttb.init\" class=\"back\">{{\'Fahrplanbuchseiten\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.rop.stops\'|isState)\">{{\'Stadtplanausschnitt\' | translate}}</span>\r\n                <span ng-show=\"(\'vvs.personalization.init\'|isState)\">{{\'Serivce Einrichten\' | translate}}</span>\r\n                <!-- <span ng-show=\"(\'vvs.personalization.login\'|isState)\">{{\'Login\' | translate}}</span> -->\r\n                <span ng-show=\"(\'vvs.personalization.registration\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.personalization.login\" class=\"back\">{{\'Registrierung\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.personalization.forgottenFirst\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.personalization.login\" class=\"back\">{{\'Passwort zurücksetzen\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.personalization.forgottenSecond\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.personalization.forgottenFirst\" class=\"back\">{{\'Passwort zurücksetzen\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.personalization.lines\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.personalization.init\" class=\"back\">{{\'Linienabo\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.personalization.stops\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.personalization.init\" class=\"back\">{{\'Haltestellenabo\' | translate}}</a>\r\n                </span>\r\n                <span ng-show=\"(\'vvs.personalization.profile\'|isState)\">\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.personalization.init\" class=\"back\">{{\'Persönliche Daten ändern\' | translate}}</a>\r\n                </span>\r\n            </h1>\r\n            <!-- <div class=\"menu-wrap navbar-header menu hidden-sm hidden-xs\"> -->\r\n            <div class=\"menu-wrap navbar-header menu hidden-xs\">\r\n                <div class=\"menu-left\">\r\n                    <a href=\"javascript:void(0)\" class=\"\"  ui-sref=\"vvs.trip.init\" ui-sref-opts=\"{reload: true, notify: true}\"\r\n                    ng-class=\"{\'active\':((\'vvs.trip.init\'|isState)||(\'vvs.trip.result\'|isState)||(\'vvs.trip.details\'|isState))}\" tabindex=\"-1\" ng-click=\"triggerResetOptionsClick()\">\r\n                    {{\'Verbindungen\'|translate}}</a>\r\n                    <a href=\"javascript:void(0)\" class=\"\"  ui-sref=\"vvs.stops\" ui-sref-opts=\"{reload: true, notify: true}\"\r\n                    ng-class=\"{\'active\':((\'vvs.stops.init\'|isState) || (\'vvs.stops\'| isState) || (\'vvs.stops.lines\' | isState) || (\'vvs.stops.stt\' | isState)\r\n                    || (\'vvs.stops.sttinit\' | isState) || (\'vvs.stops.rop\' | isState) || (\'vvs.stops.ropstops\' | isState) || (\'vvs.stops.test\' | isState))}\" tabindex=\"-1\" ng-click=\"onStopsTabClick()\">\r\n                    {{\'Haltestelle\'|translate}}</a>\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.lines\" ui-sref-opts=\"{reload: true, notify: true}\" ng-click=\"onLinesTabClick()\"\r\n                    ng-class=\"{\'active\':(\'vvs.lines\'|isState) || (\'vvs.lines.rop\' | isState) || (\'vvs.lines.ttb\' | isState) || (\'vvs.lines.lfp\' | isState) || (\'vvs.lines.stt\' | isState)|| (\'vvs.lines.rop.init\' | isState) || (\'vvs.lines.ropresult\' | isState)}\" tabindex=\"-1\">\r\n                    {{\'Linien\'|translate}}</a>\r\n                    <!-- <a href=\"javascript:void(0)\" ui-sref=\"vvs.map\" ui-sref-opts=\"{reload: true, notify: true}\" -->\r\n                    <a href=\"javascript:void(0)\" ui-sref=\"vvs.livemap\" ui-sref-opts=\"{reload: true, notify: true}\" tabindex=\"-1\"\r\n                    ng-class=\"{\'active\':(\'vvs.livemap\'|isState)} \">\r\n                        {{\'Live Karte\'|translate}}\r\n                    </a>\r\n                </div>\r\n                <div class=\"menu-right visible-md visible-lg visible-xl\">\r\n                    <a ng-attr-href=\"{{(sharedData.currentLanguage===\'en\') && \'https://en.vvs.de/home/\' || \'https://www.vvs.de/\'}}\" title=\"{{\'Home\'|translate}}\" class=\"logo\" tabindex=\"-1\">\r\n                        <vvs-icon name=\"vvs-logo\"></vvs-icon>\r\n                    </a>\r\n                </div>\r\n            </div>\r\n            <div class=\"menu-right visible-xs visible-sm mobile-logo\">\r\n                <a ng-attr-href=\"{{(sharedData.currentLanguage===\'en\') && \'https://en.vvs.de/home/\' || \'https://www.vvs.de/\'}}\" title=\"{{\'Home\'|translate}}\" class=\"logo\" tabindex=\"-1\">\r\n                    <vvs-icon name=\"vvs-logo\"></vvs-icon>\r\n                </a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</nav>\r\n\r\n");
$templateCache.put("app/vvs.components/common/media.html","<div class=\"media wrap-xs\" ng-style=\"(\'vvs.stops.map\'| isState) && { \'padding-top\': \'0px\' }\">\r\n    <div class=\"col-sm-6 small-padding-right pl-0\" ng-class=\"{\'col-sm-offset-3\': sharedData.currentLanguage===\'en\'}\">\r\n        <div class=\"card media-card\">\r\n            <p class=\"card-title\">{{\'Rund um die Fahrplanauskunft\'|translate}}</p>\r\n            <img class=\"card-img-top\" src=\"app/vvs.components/assets/images/infos.png\" alt=\"Infos\">\r\n            <div class=\"card-body\">\r\n                <p class=\"card-text p-t1\">{{\'Hier finden Sie Tipps und Infos zu Fahrplanauskunft und Tickets:\' | translate}}</p>\r\n\r\n            </div>\r\n            <div class=\"card-footer\">\r\n                <a ng-attr-href=\"{{(sharedData.currentLanguage===\'en\') && \'https://en.vvs.de/vvs-app\' || \'https://www.vvs.de/fahrplan/\'}}\" class=\"media-link\" target=\"blank\">> {{\'Fahrplan\'|translate}}</a>\r\n                <a ng-attr-href=\"{{(sharedData.currentLanguage===\'en\') && \' https://en.vvs.de/tickets\' || \'https://www.vvs.de/tickets/\'}}\" class=\"media-link\" target=\"blank\">> {{\'Tickets\'|translate}}</a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-sm-6 small-padding-left pr-0\" ng-style=\"(sharedData.currentLanguage===\'en\') && { \'display\': \'none\' }\">\r\n        <div class=\"card media-card\">\r\n            <p class=\"card-title\">{{\'Kundenservice\'|translate}}</p>\r\n            <img class=\"card-img-top\" src=\"app/vvs.components/assets/images/service.png\" alt=\"Kundenservice\">\r\n            <div class=\"card-body\">\r\n                <p class=\"card-text p-t1\">{{\'Sie können uns ganz einfach erreichen:\'|translate}}</p>\r\n            </div>\r\n            <div class=\"card-footer\">\r\n                <a href=\"https://www.vvs.de/service/kontaktformulare/kontaktformular-anfragen-auskunft/\" class=\"media-link\" target=\"blank\">> {{\'Anfragen / Auskunft\'|translate}}</a>\r\n                <a href=\"https://www.vvs.de/service/kontaktformulare/kontaktformular-kritik-hinweise-vorschlaege/\" class=\"media-link\" target=\"blank\">> {{\'Kritik / Hinweise / Vorschläge\'|translate}}</a>\r\n\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/navigation-mobile.html","<section layout=\"row\" flex>\r\n    <md-sidenav class=\"md-sidenav-left visible-xs\" md-component-id=\"mobileMenu\" md-disable-backdrop md-whiteframe=\"4\" md-swipe-left=\"toggleMobileMenu()\" md-swipe-right=\"toggleMobileMenu()\">\r\n        <div class=\"col-xs-11 col-sm-11 col-md-3 sidebar-offcanvas nopadding visible-xs visible-sm\">\r\n            <md-content layout-padding>\r\n                <div class=\"header-top-raw\">\r\n                    <div class=\"col-xs-2 text-left nopadding logo\">\r\n                        <!-- <h2>{{\'MENÜ\' | translate}}</h2> -->\r\n                        <!-- <button type=\"button\" class=\"btn btn-default btn-close\" ng-click=\"toggleMobileMenu()\">\r\n                            <span class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></span>\r\n                        </button> -->\r\n                        <button type=\"button\" class=\"close btn btn-default btn-close\" aria-label=\"Close\" ng-click=\"toggleMobileMenu()\">\r\n                            <span aria-hidden=\"true\">&times;</span>\r\n                          </button>\r\n                    </div>\r\n                    <div class=\"col-xs-8\"></div>\r\n                    <div class=\"col-xs-2 text-center nopadding\">\r\n                        <div class=\"menu-right visible-xs visible-sm mobile-logo\">\r\n                            <a ng-attr-href=\"{{(sharedData.currentLanguage===\'en\') && \'https://en.vvs.de/home/\' || \'https://www.vvs.de/\'}}\" title=\"{{\'Home\'|translate}}\" class=\"logo\" tabindex=\"-1\">\r\n                                <vvs-icon name=\"vvs-logo\"></vvs-icon>\r\n                            </a>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-xs-12 nopadding\">\r\n                    <div class=\"list-group\">\r\n                        <a href=\"javascript:void(0)\"\r\n                         class=\"list-group-item uppercase\"\r\n                         ui-sref=\"vvs.trip.init\"\r\n                         ui-sref-opts=\"{reload: true, notify: true}\"\r\n                         ng-click=\"toggleMobileMenu(); triggerResetOptionsClick()\">\r\n                            <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'Verbindungen\' | translate}}\r\n                        </a>\r\n                        <a href=\"javascript:void(0)\"\r\n                         class=\"list-group-item uppercase\"\r\n                         ui-sref=\"vvs.stops\"\r\n                         ui-sref-opts=\"{reload: true, notify: true}\"\r\n                         ng-click=\"toggleMobileMenu()\">\r\n                            <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'Haltestelle\' | translate}}\r\n                        </a>\r\n                        <a href=\"javascript:void(0)\"\r\n                         class=\"list-group-item uppercase\"\r\n                         ui-sref=\"vvs.lines\"\r\n                         ui-sref-opts=\"{reload: true, notify: true}\"\r\n                         ng-click=\"toggleMobileMenu()\">\r\n                            <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'Linien\' | translate}}\r\n                        </a>\r\n                        <a class=\"list-group-item uppercase\" ng-attr-href=\"https://livekarte.vvs.de/\" target=\"_blank\">\r\n                            <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'Live Karte\' | translate}}\r\n                        </a>\r\n                    </div>\r\n                    <!-- <h2>{{\'Mehr Auskunft\' | translate}}</h2> -->\r\n                    <div class=\"list-group list-group-additionlist\">\r\n\r\n                        <a ng-attr-href=\"{{(sharedData.currentLanguage===\'en\') && \'https://www.vvs.de/fahrplan/meldungen-und-benachrichtigungsservice\' || \'https://www.vvs.de/fahrplan/meldungen-und-benachrichtigungsservice\'}}\" target=\"_blank\" class=\"list-group-item\" ng-click=\"toggleMobileMenu()\">\r\n                            <vvs-icon name=\"abschicken\"></vvs-icon> {{\'Meldungen\'|translate}}\r\n                        </a>\r\n                        <a href=\"javascript:void(0)\" class=\"list-group-item\" ui-sref=\"vvs.personalization.login\" ui-sref-opts=\"{reload: true, notify: true}\" ng-click=\"toggleMobileMenu()\">\r\n                            <span><vvs-icon name=\"abschicken\"></vvs-icon></span>  {{\'Benachrichtigungsservice\' | translate}}\r\n                        </a>\r\n\r\n                        <a ng-attr-href=\"{{(sharedData.currentLanguage===\'en\') && \'http://en.vvs.de/home/\' || \'http://www.vvs.de/\'}}\" target=\"_blank\" class=\"list-group-item\" ng-click=\"toggleMobileMenu()\">\r\n                            <vvs-icon name=\"abschicken\"></vvs-icon> {{\'VVS Homepage\'|translate}}\r\n                        </a>\r\n                        <a href=\"javascript:void(0)\" target=\"_blank\" class=\"list-group-item\">\r\n                            <vvs-language-switcher mode=\"mobile\"></vvs-language-switcher>\r\n                        </a>\r\n                        <!--<a href=\"http://www2.vvs.de/bcl/XSLT_TRIP_REQUEST2?language={{sharedData.currentLanguage}}\" target=\"_blank\" class=\"list-group-item\" ng-click=\"toggleMobileMenu()\">\r\n                            <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'EFA für Sehbehinderte\' | translate}}\r\n                        </a>-->\r\n                        <br>\r\n                        <!--<vvs-feedback></vvs-feedback>-->\r\n                        <!-- <a href=\"https://www.vvs.de/service/kontaktformulare/\" target=\"_blank\" class=\"list-group-item\" >\r\n                            <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'Problem melden\'|translate}}\r\n                        </a> -->\r\n                    </div>\r\n                    <!-- <div class=\"sidebar-footer\">\r\n                        <a ng-attr-href=\"{{(sharedData.currentLanguage===\'en\') && \'http://en.vvs.de/footer/imprint/\' || \'http://www.vvs.de/impressum/\'}}\" target=\"_blank\" class=\"col-xs-12\" ng-click=\"toggleMobileMenu()\">\r\n                            <vvs-icon name=\"abschicken\"></vvs-icon> {{\'Impressum\' | translate}}\r\n                        </a>\r\n                        <a href=\"http://www.vvs.de/datenschutz/\" target=\"_blank\" class=\"col-xs-12\" ng-click=\"toggleMobileMenu()\">\r\n                            <vvs-icon name=\"abschicken\"></vvs-icon> {{\'Datenschutz\' | translate}}\r\n                        </a>\r\n                        <a ng-attr-href=\"{{(sharedData.currentLanguage===\'en\') && \'http://en.vvs.de/home/\' || \'http://www.vvs.de/\'}}\" target=\"_blank\" class=\"col-xs-12\" ng-click=\"toggleMobileMenu()\">\r\n                            <vvs-icon name=\"abschicken\"></vvs-icon> {{\'VVS Homepage\'|translate}}\r\n                        </a>\r\n                        <vvs-language-switcher mode=\"mobile\"></vvs-language-switcher>\r\n                    </div> -->\r\n                </div>\r\n            </md-content>\r\n        </div>\r\n    </md-sidenav>\r\n</section>\r\n\r\n\r\n");
$templateCache.put("app/vvs.components/common/navigation-web.html","<div class=\"col-xs-12\">\r\n    <div class=\"btn-group btn-group-justified mainnav\" role=\"group\" aria-label=\"navigation\">\r\n        <div class=\"btn-group\" role=\"group\">\r\n            <button type=\"button\" class=\"btn btn-default\" ui-sref=\"vvs.trip.init\" ui-sref-opts=\"{reload: true, notify: true}\" ng-class=\"{\'active\':((\'vvs.trip.init\'|isState)||(\'vvs.trip.result\'|isState)||(\'vvs.trip.details\'|isState))}\" tabindex=\"-1\" ng-click=\"triggerResetOptionsClick()\">\r\n                <vvs-icon name=\"verbindungen\"></vvs-icon><span>{{\'Verbindungen\'|translate}}</span>\r\n            </button>\r\n        </div>\r\n        <div class=\"btn-group\" role=\"group\">\r\n            <button type=\"button\" class=\"btn btn-default\" ui-sref=\"vvs.dm.init\" ui-sref-opts=\"{reload: true, notify: true}\" ng-class=\"{\'active\':((\'vvs.dm.init\'|isState)||(\'vvs.dm.stops\'|isState)||(\'vvs.dm.lines\'|isState))}\" tabindex=\"-1\">\r\n                <vvs-icon name=\"haltestellen\"></vvs-icon><span>{{\'Abfahrt/Ankunft\'|translate}}</span>\r\n            </button>\r\n        </div>\r\n        <div class=\"btn-group\" role=\"group\">\r\n            <button type=\"button\" class=\"btn btn-default\" ui-sref=\"vvs.rop.lines\" ui-sref-opts=\"{reload: true, notify: true}\" ng-class=\"{\'active\':(\'vvs.rop.lines\'|isState)}\" tabindex=\"-1\">\r\n                <vvs-icon name=\"linien\"></vvs-icon><span>{{\'Linien\'|translate}}</span>\r\n            </button>\r\n        </div>\r\n        <!-- <div class=\"btn-group\" role=\"group\">\r\n            <button type=\"button\" class=\"btn btn-default\" ui-sref=\"vvs.info.init\" ui-sref-opts=\"{reload: true, notify: true}\" ng-class=\"{\'active\':((\'vvs.info.init\'|isState)||(\'vvs.info.disruption\'|isState)||(\'vvs.info.disruptionDetails\'|isState)||(\'vvs.info.timetableChange\'|isState)||(\'vvs.info.timetableChangeDetails\'|isState)||(\'vvs.info.specialTraffic\'|isState)||(\'vvs.info.specialTrafficDetails\'|isState)||(\'vvs.info.escalatorElevator\'|isState))}\" tabindex=\"-1\">\r\n                <vvs-icon name=\"meldungen\"></vvs-icon><span>{{\'1Meldungen\'|translate}}</span>\r\n            </button>\r\n        </div> -->\r\n        <div class=\"btn-group\" role=\"group\">\r\n            <button type=\"button\" class=\"btn btn-default\" ui-sref=\"vvs.map\" ui-sref-opts=\"{reload: true, notify: true}\" ng-class=\"{\'active\':(\'vvs.map\'|isState)}\" tabindex=\"-1\">\r\n                <vvs-icon name=\"karte\"></vvs-icon><span>{{\'Karte\'|translate}}</span>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/right-content.html","<div class=\"col-xs-12 col-sm-12 col-md-3 context\">\r\n\r\n    <div class=\"col-xs-12 spacertop spacerbottom hidden-xs hidden-sm\">\r\n        <h2>{{\'Mehr Auskunft\' | translate}}</h2>\r\n        <div class=\"list-group nomargin\">\r\n            <a href=\"javascript:void(0)\" class=\"list-group-item\" ui-sref=\"vvs.stt.init\" ui-sref-opts=\"{reload: true, notify: true}\">\r\n                <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'Aushangfahrplan\' | translate}}\r\n            </a>\r\n            <a href=\"javascript:void(0)\" class=\"list-group-item\" ui-sref=\"vvs.ttb.init({lfp: false})\" ui-sref-opts=\"{reload: true, notify: true, lfp: false}\">\r\n                <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'Fahrplanbuchseiten\' | translate}}\r\n            </a>\r\n            <a href=\"javascript:void(0)\" class=\"list-group-item\" ui-sref=\"vvs.ttb.init({lfp: true})\" ui-sref-opts=\"{reload: true, notify: true, lfp: true}\">\r\n                <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'Linienfahrplan\' | translate}}\r\n            </a>\r\n            <a href=\"javascript:void(0)\" class=\"list-group-item\" ui-sref=\"vvs.rop.stops\" ui-sref-opts=\"{reload: true, notify: true}\">\r\n                <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'Stadtplanausschnitt\' | translate}}\r\n            </a>\r\n            <a href=\"http://www.efa-bw.de/nvbw/XSLT_TRIP_REQUEST2?language={{sharedData.currentLanguage}}\" class=\"list-group-item\" target=\"_blank\">\r\n                <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'EFA Baden-Württemberg\' | translate}}\r\n            </a>\r\n            <a href=\"javascript:void(0)\" class=\"list-group-item\" ui-sref=\"vvs.personalization.login\" ui-sref-opts=\"{reload: true, notify: true}\">\r\n                <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'Benachrichtigungsservice\' | translate}}\r\n                <!-- <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'Mein VVS-Konto\' | translate}} -->\r\n            </a>\r\n            <!--<a href=\"http://www2.vvs.de/bcl/XSLT_TRIP_REQUEST2?language={{sharedData.currentLanguage}}\" target=\"_blank\" class=\"list-group-item\">\r\n                <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'EFA für Sehbehinderte\' | translate}}\r\n            </a>-->\r\n            <br>\r\n            <!--<vvs-feedback></vvs-feedback>-->\r\n            <a href=\"https://www.vvs.de/service/kontaktformulare/\" target=\"_blank\" class=\"list-group-item\" >\r\n                <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'Problem melden\'|translate}}\r\n            </a>\r\n        </div>\r\n    </div>\r\n    <vvs-logout></vvs-logout>\r\n\r\n    <div class=\"col-xs-12 spacertop spacerbottom ctblock nopadding-xs padding-md hidden-xs hidden-sm\" ng-if=\"(\'vvs.trip.details\'|isState)\">\r\n        <button class=\"btn btn-default btn-block\" type=\"button\" vvs-modal vvs-modal-template=\"modals/signs.html\">\r\n            <div class=\"pull-left text-left left-text-color\"> {{\'Zeichenerklärung\' | translate}}</div>\r\n            <div class=\"pull-right text-right\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n\r\n    <vvs-place-holder></vvs-place-holder>\r\n\r\n    <div class=\"buttonlist col-xs-12 nopadding-xs padding-md spacertop\" role=\"group\" ng-if=\"(\'vvs.trip.details\'|isState)\">\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.trip.result\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Verbindungen Übersicht\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12 teaser spacertop\">\r\n        <div class=\"col-xs-6 col-sm-3 col-md-6 text-center teaser-item\">\r\n            <a href=\"https://radroutenplaner.vvs.de/\" target=\"_blank\">\r\n            <!-- <a href=\"http://efa.vvs.de/bike/XSLT_TRIP_REQUEST2?language={{sharedData.currentLanguage}}\" target=\"_blank\"> -->\r\n                <vvs-icon name=\"rrp\"></vvs-icon>\r\n                <br> {{\'Radrouten\'|translate}}\r\n            </a>\r\n        </div>\r\n        <div class=\"col-xs-6 col-sm-3 col-md-6 text-center teaser-item\">\r\n            <a href=\"https://www.vvs.de/rundum-mobil/\" target=\"_blank\">\r\n                <vvs-icon name=\"rundummobil\"></vvs-icon>\r\n                <br> {{\'Rundum mobil\'|translate}}\r\n            </a>\r\n        </div>\r\n        <vvs-dev-tools></vvs-dev-tools>\r\n        <!--<div class=\"col-xs-6 col-sm-3 col-md-6 text-center teaser-item hidden-xs\">\r\n            <a href=\"http://www.vvs.de/no_cache/service/auskuenfte-fuer-website-desktop/\" target=\"_blank\">\r\n                <vvs-icon name=\"efaaufhp\"></vvs-icon>\r\n                <br> {{\'Entwicklertools\'|translate}}\r\n            </a>\r\n        </div>-->\r\n        <!-- <div class=\"col-xs-6 col-sm-3 col-md-6 text-center teaser-item hidden-xs\">\r\n            <a href=\"http://www.vvs.de/tickets/ticketberater/\" target=\"_blank\">\r\n                <vvs-icon name=\"ticketberater\"></vvs-icon>\r\n                <br> {{\'Ticketberater\'|translate}}\r\n            </a>\r\n        </div> -->\r\n    </div>\r\n\r\n\r\n    <div class=\"col-xs-12 teaser\">\r\n        <div class=\"col-xs-4 col-sm-4 col-md-6 text-center teaser-item\">\r\n            <a href=\"http://www.facebook.com/VVS\" target=\"_blank\">\r\n                <vvs-icon name=\"facebook\"></vvs-icon>\r\n                <br> {{\'Facebook\'|translate}}\r\n            </a>\r\n        </div>\r\n        <div class=\"col-xs-4 col-sm-4 col-md-6 text-center teaser-item\">\r\n            <a href=\"http://twitter.com/VVS#\" target=\"_blank\">\r\n                <vvs-icon name=\"twitter\"></vvs-icon>\r\n                <br> {{\'Twitter\'|translate}}\r\n            </a>\r\n        </div>\r\n        <div class=\"col-xs-4 col-sm-4 col-md-6 text-center teaser-item\">\r\n            <a href=\"https://www.youtube.com/user/vvs\" target=\"_blank\">\r\n                <vvs-icon name=\"youtube\"></vvs-icon>\r\n                <br> {{\'Youtube\'|translate}}\r\n            </a>\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/vvs.components/dm/main.html","<!-- DM Tabs -->\r\n<div>\r\n    <!-- Abfahrt(dm) / Aushangfahrplan(stt) / Stadtplanaussicht / Haltestellenkarte / specialTraffic / timetableChange -->\r\n    <div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n        <div class=\"content-wrap\">\r\n        <h1 class=\"function-header tabs wrap-xs\">{{\'Haltestelle\' | translate}}</h1>\r\n        <div ng-cloak=\"\" class=\"tabsdemoCenterTabs\" ng-app=\"MyApp\">\r\n            <md-content>\r\n              <md-tabs md-disable-animation md-dynamic-height=\"\" md-center-tabs md-selected=\"tabIndex\" class=\"md-primary\">\r\n                <!-- abfahrt -->\r\n                <md-tab label=\"{{\'Abfahrt\'|translate}}\" ui-sref=\"vvs.stops.init\" md-selected=\"tabIndex\">\r\n                </md-tab>\r\n                <md-tab label=\"{{\'Aushang&shy;fahrplan\'|translate}}\" ui-sref=\"vvs.stops.stt\">\r\n                </md-tab>\r\n                <md-tab label=\"{{\'Stadtplan&shy;ausschnitt\'|translate}}\" ui-sref=\"vvs.stops.rop\">\r\n                </md-tab>\r\n                <md-tab label=\"{{\'Haltestellen&shy;karte\'|translate}}\" ui-sref=\"vvs.stops.test\">\r\n                <!-- <md-tab label=\"{{\'Haltestellen&shy;karte\'|translate}}\" ui-sref=\"vvs.stops.map\" md-on-select=\"goToMap()\"> -->\r\n                </md-tab>\r\n              </md-tabs>\r\n            </md-content>\r\n        </div>\r\n        <div ui-view></div>\r\n        <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<style>\r\n   md-tab-content.md-left:not(.md-active) * {\r\n        transform: translateY(100%);\r\n        transition: none;\r\n    }\r\n    md-tabs {\r\n        transition:none !important;\r\n    }\r\n\r\n    md-pagination-wrapper.md-center-tabs {\r\n        position: relative;\r\n        justify-content: space-between;\r\n    }\r\n    md-tabs.md-primary>md-tabs-wrapper {\r\n        background-color: #fff;\r\n    }\r\n\r\n    @media (min-width: 960px) {\r\n        .tabsdemoCenterTabs md-tab-item {\r\n            min-width: 160px;\r\n        }\r\n        md-tabs [role=\"tabpanel\"] {\r\n            transition: none;\r\n        }\r\n\r\n        md-tabs md-ink-bar {\r\n            transition: none;\r\n        }\r\n    }\r\n</style>");
$templateCache.put("app/vvs.components/dm/map.html","<div class=\"row mt1\">\r\n    <div class=\"ctblock col-xs-12 spacerbottomlarge\">\r\n        <div class=\"ctblock buttonlist col-xs-12 nopadding-sm\" role=\"group\" >\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" onclick=\"window.location.href=\'https://www.vvs.de/karten-plaene/haltestellenkarten/\'\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    {{\'Haltestellenkarte\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" onclick=\"window.location.href=\'https://www.vvs.de/karten-plaene/haltestellenkarten-barrierefrei/\'\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    {{\'Haltestellenkarte barrierefrei\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/vvs.components/info/main.html","<div>\r\n    <!-- init / disruption / escalatorElevator / news / specialTraffic / timetableChange -->\r\n    <div ui-view></div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/map/livemap.html","<div class=\"wrap\">\r\n    <h1 class=\"function-header tabs wrap-xs\">{{\'Livekarte\' | translate}}</h1>\r\n    <div class=\"wrap-livemap\">\r\n        <iframe class=\"iframe-map\" src=\"https://livekarte.vvs.de/@48.78127,9.16769,z16.206803257701015\" style=\"width:100%;height:100%;border: none;\"></iframe>\r\n        <div  class=\"vvs-fullscreen hidden-xs\">\r\n        <h2>\r\n            <button ng-click=\"gotoFullscreen()\">\r\n                <span class=\"material-icons\">{{\'Vollbild anzeigen\'|translate}}</span>\r\n                <span>\r\n                    <img src=\"app/vvs.components/assets/images/icons/fullscreen.svg\" alt=\"VVS\" height=\"20\" width=\"20\">\r\n                </span>\r\n            </button>\r\n        </h2>\r\n    </div>\r\n    </div>\r\n    <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n</div>");
$templateCache.put("app/vvs.components/map/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <h1 class=\"function-header tabs\">{{\'Live Karte\'|translate}}</h1>\r\n    <vvs-map load-on=\"{{true}}\"></vvs-map>\r\n    <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/map/map.html","<div id=\"map-wrapper\">\r\n    <div class=\"mapholder\">\r\n        <!-- either normal map or network map is shown (depending on $scope.networkMapActive).\r\n            as both handle different CRS configuration it is very cumbersome to put both map types\r\n            within one map container -->\r\n        <!-- map container -->\r\n        <mng-leaflet data-ng-hide=\"networkMapActive\" id=\"vvsMapContainer\" style=\"min-width: 100%; display: block; width: 100%;\" ng-style=\"VVSMapCtrl.isFS && {\'height\':\'100vh\'} || !VVSMapCtrl.isFS && {\'height\':\'50vh\'}\"></mng-leaflet>\r\n        <!-- network map container -->\r\n        <mng-leaflet data-ng-show=\"networkMapActive\" id=\"vvsNetworkMapContainer\" style=\"min-width: 100%; display: block; height: 75vh; width: 100%;\"></mng-leaflet>\r\n\r\n        <!-- include map config Modal -->\r\n        <!-- <button data-ng-hide=\"networkMapActive\" type=\"button\" class=\"btn btn-default btn-map btn-settings\" vvs-modal vvs-modal-template=\"map/config/modal.html\" ng-if=\"(\'vvs.map.init\'|isState)\" title=\"{{\'Karteneinstellungen anzeigen\'|translate}}\">\r\n            <vvs-icon name=\"karte-einstellungen\"></vvs-icon>\r\n        </button> -->\r\n        <!-- include mapType popover -->\r\n        <button type=\"button overlays\" class=\"btn btn-default btn-map btn-kartenansicht popup-window\" popover-placement=\"top\" uib-popover-template=\"\'mapTypePopoverTemplate\'\" popover-trigger=\"outsideClick\" popover-is-open=\"mapTypePopoverIsOpen\" title=\"{{\'Kartentyp auswählen\'|translate}}\">\r\n            <vvs-icon name=\"kartenansicht\"></vvs-icon>\r\n        </button>\r\n        <vvs-include vvs-src=\"map/popovers/mapType.html\"></vvs-include>\r\n        <!-- include map print button -->\r\n        <button type=\"button\" class=\"btn btn-default btn-map btn-print visible-md visible-lg\" ng-if=\"!(\'vvs.map\'|isState) && !(\'vvs.trip.init\'|isState) && !(\'vvs.dm.init\'|isState) && !(\'vvs.rop.stops\'|isState) && !(\'vvs.ttb.stops.init\'|isState)\" ng-click=\"VVSMapCtrl.triggerPrintMapClick()\" title=\"{{\'Als PDF generieren\'|translate}}\">\r\n            <vvs-icon name=\"print\"></vvs-icon>\r\n        </button>\r\n        <!-- include map buttons -->\r\n        <div class=\"mapbuttons\">\r\n            <!-- current position button -->\r\n            <button data-ng-hide=\"networkMapActive\" type=\"button\" class=\"btn btn-default btn-map btn-standort\" ng-click=\"VVSMapCtrl.triggerGetCurrentPositionClick()\" title=\"{{\'Aktuelle Position anzeigen\'|translate}}\">\r\n                <vvs-icon name=\"standort\"></vvs-icon>\r\n            </button>\r\n            <!-- zoom in button -->\r\n            <button type=\"button\" class=\"btn btn-default btn-map btn-plus btn-attach\" ng-click=\"VVSMapCtrl.triggerZoomInClick()\" title=\"{{\'Einzoomen\'|translate}}\">\r\n                <vvs-icon name=\"plus\"></vvs-icon>\r\n            </button>\r\n            <!-- zoom out button -->\r\n            <button type=\"button\" class=\"btn btn-default btn-map btn-minus\" ng-click=\"VVSMapCtrl.triggerZoomOutClick()\" title=\"{{\'Auszoomen\'|translate}}\">\r\n                <vvs-icon name=\"minus\"></vvs-icon>\r\n            </button>\r\n        </div>\r\n    </div>\r\n    <ul class=\"list-group aftermap list-toggle\" style=\"width: 100%; margin-left:0;\">\r\n        <li class=\"list-group-item no-icon\">{{\'Haltestellennamen An/Aus\'|translate}}\r\n            <md-switch aria-label=\"Haltestellennamen An/Aus\" ng-disabled=\"VVSMapCtrl.toggleStopNameDisabled\" ng-model=\"VVSMapCtrl.toggleStopName\" ng-change=\"VVSMapCtrl.triggerToggleStopName()\"></md-switch>\r\n        </li>\r\n    </ul>\r\n    <!-- <div  class=\"vvs-fullscreen hidden-xs\">\r\n        <h2>\r\n            <button ng-click=\"VVSMapCtrl.gotoFullscreen()\">\r\n                <span class=\"material-icons\">{{\'Vollbild anzeigen\'|translate}}</span>\r\n                <span>\r\n                    <img src=\"app/vvs.components/assets/images/icons/fullscreen.svg\" alt=\"VVS\" height=\"20\" width=\"20\">\r\n                </span>\r\n            </button>\r\n        </h2>\r\n    </div> -->\r\n</div>\r\n\r\n\r\n");
$templateCache.put("app/vvs.components/map/stopsmap.html","    <!-- <div class=\"wrap-stopmap\">\r\n        <iframe class=\"iframe-map\" src=\"https://www.vvs.de/karten-plaene/haltestellenkarten/\" style=\"width:100%;height:100%;border: none;\"></iframe>\r\n    </div> -->\r\n    <div class=\"ctblock col-xs-12 hidden-xs spacerbottomlarge\">\r\n        <div class=\"ctblock buttonlist col-xs-12 nopadding-sm\" role=\"group\" aria-label=\"Linienauswahl\">\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" onclick=\"window.open(\'https://www.vvs.de/karten-plaene/haltestellenkarten/\', \'_blank\')\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    {{\'Haltestellenkarte\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n        </div>\r\n    </div>\r\n");
$templateCache.put("app/vvs.components/modals/date-time-mobile.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Datum & Zeit\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\" ng-controller=\"VVSModalsDateTimeMobileController as ctrl\">\r\n        <div class=\"holder\">\r\n\r\n            <div class=\"btn-group btn-group-justified spacertopmedium\" role=\"group\" aria-label=\"...\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button type=\"button\" class=\"btn btn-default md-raised md-button md-ink-ripple\" ng-class=\"{\'active\':SEARCH_OPTIONS.dateTime.isDeparture}\" ng-click=\"SEARCH_OPTIONS.dateTime.isDeparture=true\">{{\'Abfahrt\' | translate}}</button>\r\n                </div>\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button type=\"button\" class=\"btn btn-default md-raised md-button md-ink-ripple\" ng-class=\"{\'active\':!SEARCH_OPTIONS.dateTime.isDeparture}\" ng-click=\"SEARCH_OPTIONS.dateTime.isDeparture=false\">{{\'Ankunft\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n\r\n            <!--<ul id=\"tabs\" class=\"nav nav-tabs spacertopmedium\" data-tabs=\"tabs\">\r\n                <li ng-class=\"{\'active\':SEARCH_OPTIONS.dateTime.isDeparture}\">\r\n                    <a href=\"javascript:void(0)\" data-toggle=\"tab\" ng-click=\"SEARCH_OPTIONS.dateTime.isDeparture=true\">\r\n                        {{\'Abfahrt\' | translate}}\r\n                    </a>\r\n                </li>\r\n                <li ng-class=\"{\'active\':!SEARCH_OPTIONS.dateTime.isDeparture}\">\r\n                    <a href=\"javascript:void(0)\" data-toggle=\"tab\" ng-click=\"SEARCH_OPTIONS.dateTime.isDeparture=false\">\r\n                        {{\'Ankunft\' | translate}}\r\n                    </a>\r\n                </li>\r\n            </ul>-->\r\n\r\n\r\n            <div class=\"tab-content spacertopmedium spacerbottommedium time\">\r\n                <div class=\"tab-pane row active\" id=\"abfahrt\">\r\n                    <div class=\"btn-group btn-group-justified spacerbottommedium col-xs-12\" role=\"group\" aria-label=\"Zeitpunkt\">\r\n                        <div class=\"btn-group\" role=\"group\">\r\n                            <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.addMinutes(0)\">{{\'Jetzt\' | translate}}</button>\r\n                        </div>\r\n                        <div class=\"btn-group\" role=\"group\">\r\n                            <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.addMinutes(10)\">{{\'in 10 min\' | translate}}</button>\r\n                        </div>\r\n                        <div class=\"btn-group\" role=\"group\">\r\n                            <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.addMinutes(30)\">{{\'in 30 min\' | translate}}</button>\r\n                        </div>\r\n                        <div class=\"btn-group\" role=\"group\">\r\n                            <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.addMinutes(60)\">{{\'in 60 min\' | translate}}</button>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"holder infocus spacerbottommedium\">\r\n                        <input ng-if=\"!isSpecialBrowser\" type=\"datetime-local\" ng-model=\"SEARCH_OPTIONS.dateTime.dateTime\" aria-describedby=\"date-addon-modal\" class=\"form-control text-right\">\r\n                        <input ng-if=\"isSpecialBrowser\" type=\"text\" ng-model=\"SEARCH_OPTIONS.dateTime.dateTime\" aria-describedby=\"date-addon-modal\" class=\"form-control text-right\">\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"btn-group btn-group-justified highlight\" role=\"group\" aria-label=\"...\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"dismissModal(); ctrl.updateDateTime()\">{{\'Übernehmen\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/modals/network.html","<div ng-controller=\"VVSModalsNetworkController as VVSModalsNetworkCtrl\">\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Punkt auf Karte wählen\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n\r\n        <vvs-map ng-if=\"VVSModalsNetworkCtrl.load\" load-on=\"{{VVSModalsNetworkCtrl.load}}\" usage=\"usage\"></vvs-map>\r\n\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/modals/ps.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Persönlicher Fahrplan\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <div class=\"modal-block spacertop spacerbottom\">\r\n            <p>{{\'Sie werden auf die Fahrplanauskunft umgeleitet. Der bisherige persönliche Fahrplan wurde inhaltlich verbessert. Bitte wählen sie die Funktionen „Früher“ und „Später“ und anschließend die Druckfunktion.\'|translate}}</p>\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"ohne Echtzeit berechnen\" role=\"group\">\r\n                <div class=\"btn-group \" role=\"group\">\r\n                    <button class=\"btn btn-default\" ui-sref=\"vvs.trip.init\" ng-click=\"dismissModal()\" type=\"button\">{{\'OK\'|translate}}</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/modals/realtime.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Echtzeit\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <h2 ng-if=\"SEARCH_OPTIONS.dateTime.useRealTime\">{{\'Soll die Verbindung wirklich ohne Echtzeit berechnet werden?\' | translate}}</h2>\r\n        <h2 ng-if=\"!SEARCH_OPTIONS.dateTime.useRealTime\">{{\'Soll die Verbindung wieder mit Echtzeit berechnet werden?\' | translate}}</h2>\r\n        <div class=\"modal-block spacerbottomlarge\">\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"ohne Echtzeit berechnen\" role=\"group\">\r\n                <div class=\"btn-group \" role=\"group\">\r\n                <button class=\"btn btn-default\" type=\"button\" ng-click=\"triggerToggleRealTimeSearch();dismissModal()\">\r\n                    <span ng-if=\"SEARCH_OPTIONS.dateTime.useRealTime\">{{\'ohne Echtzeit berechnen\' | translate}}</span>\r\n                    <span ng-if=\"!SEARCH_OPTIONS.dateTime.useRealTime\">{{\'mit Echtzeit berechnen\' | translate}}</span>\r\n                </button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/vvs.components/modals/refresh.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Aktualisieren\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <h2>{{\'Neue Anfrage berechnen\' | translate}}</h2>\r\n        <div class=\"modal-block spacerbottomlarge\">\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit angefragter Uhrzeit\" role=\"group\">\r\n                <div class=\"btn-group \" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"triggerRefreshWithSameTimeClick(); dismissModal()\">{{\'mit angefragter Uhrzeit\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n            <br>\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"triggerRefreshWithCurrentTimeClick(); dismissModal()\">{{\'mit aktueller Uhrzeit\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/modals/signs.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Zeichenerklärung\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <div class=\"modal-block spacertoplarge\">\r\n            <table class=\"table legend\">\r\n                <colgroup>\r\n                    <col width=\"5%\">\r\n                    <col width=\"95%\">\r\n                </colgroup>\r\n                <tr>\r\n                    <td>\r\n                        <vvs-icon name=\"haltestelle\"></vvs-icon>\r\n                    </td>\r\n                    <td>{{\'Haltestelleninformation\' | translate}}</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>\r\n                        <vvs-icon name=\"poi\"></vvs-icon>\r\n                    </td>\r\n                    <td>{{\'Informationen zu wichtigen Punkten\' | translate}}</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>\r\n                        <vvs-icon name=\"adresse\"></vvs-icon>\r\n                    </td>\r\n                    <td>{{\'Adresse\' | translate}}</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>\r\n                        <vvs-icon name=\"meldung-rot\"></vvs-icon>\r\n                    </td>\r\n                    <td>{{\'Informationen zur Betriebslage\' | translate}}</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>\r\n                        <vvs-icon name=\"pdf\"></vvs-icon>\r\n                    </td>\r\n                    <td>{{\'PDF-Druckversion\' | translate}}</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>\r\n                        <vvs-icon name=\"steigung\"></vvs-icon>\r\n                    </td>\r\n                    <td>{{\'bergauf (Höhenmeter)\' | translate}}</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>\r\n                        <vvs-icon name=\"senkung\"></vvs-icon>\r\n                    </td>\r\n                    <td>{{\'bergab (Höhenmeter)\' | translate}}</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>\r\n                        <vvs-icon name=\"echtzeit\"></vvs-icon>\r\n                    </td>\r\n                    <td>{{\'Fahrt mit Echtzeitinformation\' | translate}}</td>\r\n                </tr>\r\n                <tr>\r\n                    <td><strong>{{\'k.A.\' | translate}}</strong></td>\r\n                    <td>{{\'keine Angaben zum Fahrpreis möglich, da eine Fahrtverbindung mit der Einstellung „über” (Umwegfahrt) angefordert wurde, ein Fahrziel außerhalb des VVS-Tarifgebiets liegt oder die Fahrtverbindung teils eine Ruftaxirelation enthält\' | translate}}</td>\r\n                </tr>\r\n            </table>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/personalization/main.html","<div>\r\n    <!-- include login / registration / forgotten password / stops / lines / profile ...-->\r\n    <div ui-view></div>\r\n</div>\r\n\r\n<style>\r\n    a.link {\r\n        font-size: 1.3rem !important;\r\n    }\r\n    .checkbox-wrap {\r\n        display: block;\r\n        position: relative;\r\n        padding-left: 24px;\r\n        cursor: pointer;\r\n        -webkit-user-select: none;\r\n        -moz-user-select: none;\r\n        -ms-user-select: none;\r\n        user-select: none;\r\n    }\r\n    /* Hide the browser\'s default checkbox */\r\n    .checkbox-wrap input {\r\n        position: absolute;\r\n        opacity: 0;\r\n        cursor: pointer;\r\n        height: 0;\r\n        width: 0;\r\n    }\r\n\r\n    /* Create a custom checkbox */\r\n    .checkmark {\r\n        position: absolute;\r\n        top: 2px;\r\n        left: 0;\r\n        height: 15px;\r\n        width: 15px;\r\n        background-color: #fff;\r\n        margin-bottom: 12px;\r\n        border: 1px solid lightgrey;\r\n    }\r\n    .checkbox-wrap input:checked  ~ .checkmark {\r\n        background-color: #337ab7;\r\n    }\r\n    /* Create the checkmark/indicator (hidden when not checked) */\r\n    .checkmark:after {\r\n        content: \"\";\r\n        position: absolute;\r\n        display: none;\r\n    }\r\n    /* Show the checkmark when checked */\r\n        .checkbox-wrap input:checked ~ .checkmark:after {\r\n        display: block;\r\n    }\r\n    /* Style the checkmark/indicator */\r\n    .checkbox-wrap .checkmark:after {\r\n        left: 5px;\r\n        top: 0px;\r\n        width: 5px;\r\n        height: 10px;\r\n        border: solid white;\r\n        border-width: 0 2px 3px 0;\r\n        -webkit-transform: rotate(45deg);\r\n        -ms-transform: rotate(45deg);\r\n        transform: rotate(45deg);\r\n    }\r\n\r\n    /* styles for s-bahn, rbahn, bubahn, bus - general*/\r\n    .line-description {\r\n        display: flex;\r\n    }\r\n    .line-description svg {\r\n        margin: 0 10px;\r\n    }\r\n    .ctblock {\r\n        margin-bottom: 0;\r\n    }\r\n    md-switch.ng-pristine.ng-untouched.ng-valid.ng-not-empty.md-checked {\r\n        margin-right: 13px !important;\r\n    }\r\n    md-switch:last-of-type {\r\n        margin-right: 13px !important;\r\n    }\r\n    table.monitor.bs #allLines {\r\n        margin-left: 14px !important;\r\n    }\r\n    td.allLine_left {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    input {\r\n        width: 100% !important;\r\n        padding: 10px !important;\r\n        font-size: 1.2rem;\r\n    }\r\n    input:focus {\r\n        outline: none;\r\n    }\r\n    /* tab background */\r\n    table.table.monitor.bs.border-bottom tbody {\r\n        background:#f7f7f7;\r\n    }\r\n\r\n    /* nav block styles */\r\n    .nav-wrap {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        padding: 0 0 1rem 0;\r\n    }\r\n    /* .nav-wrap h2 {\r\n        margin-bottom: 0;\r\n    } */\r\n\r\n    .nav-wrap .nav {\r\n        display: flex;\r\n    }\r\n</style>\r\n");
$templateCache.put("app/vvs.components/rop/main.html","<div>\r\n    <div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n        <h1 class=\"function-header tabs wrap-xs\">{{\'Linien\' | translate}}</h1>\r\n        <div ng-cloak=\"\" class=\"tabsdemoCenterTabs\" ng-app=\"MyApp\">\r\n            <md-content>\r\n              <md-tabs md-disable-animation md-dynamic-height=\"\" class=\"md-primary\" md-center-tabs=\"\" md-selected=\"tabIndex\">\r\n                <md-tab label=\"{{\'Karten&shy;ansicht\'|translate}}\" ui-sref=\"vvs.lines.rop\" >\r\n                    <!-- <vvs-include vvs-src=\"dm/init/dm.html\"></vvs-include> -->\r\n                </md-tab>\r\n                <md-tab label=\"{{\'Fahrplan&shy;tabelle1\'|translate}}\" ui-sref=\"#\">\r\n                </md-tab>\r\n                <md-tab label=\"{{\'Linien&shy;fahrplan\'|translate}}\" ui-sref=\"#\">\r\n                </md-tab>\r\n              </md-tabs>\r\n            </md-content>\r\n          </div>\r\n          <div ui-view></div>\r\n          <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n        </div>\r\n</div>\r\n{{\'Linienfahrplan\'|translate}}\r\n\r\n<style>\r\n    md-tabs-template {\r\n        transition: none;\r\n    }\r\n\r\n    md-pagination-wrapper.md-center-tabs {\r\n        position: relative;\r\n        justify-content: space-between;\r\n    }\r\n    md-tabs.md-primary>md-tabs-wrapper {\r\n        background-color: #fff;\r\n    }\r\n\r\n    @media (min-width: 960px) {\r\n    .tabsdemoCenterTabs md-tab-item {\r\n        min-width: 160px;\r\n    }\r\n    }\r\n</style>\r\n\r\n\r\n");
$templateCache.put("app/vvs.components/stt/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <h2 class=\"function-header hidden-xs hidden-sm\">{{\'Aushangfahrplan\' | translate}}</h2>\r\n    <div ui-view></div>\r\n</div>");
$templateCache.put("app/vvs.components/trip/debug.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content debug-box\" ng-if=\"debugObj.isDebugModeActive\">\r\n    <div class=\"alert alert-danger\" style=\"display: flow-root;\">\r\n        <h3>{{\'DEBUG MODUS : EFA Params.\'|translate}}</h3>\r\n\r\n        <!--<pre>{{debugObj|json:4}}</pre>-->\r\n        <div class=\"col-xs-12 col-sm-12 col-md-12 content form-group\" ng-repeat=\"param in debugObj.params\">\r\n            <div class=\"col-xs-12 col-sm-12 col-md-4\">\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"Param. name\" ng-model=\"param.name\" value=\"param.name\" ng-disabled=\"!param.new\" />\r\n            </div>\r\n            <div class=\"col-xs-12 col-sm-12 col-md-4\">\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"Param. value\" ng-model=\"param.value\" value=\"param.value\" ng-disabled=\"!param.new\"/>\r\n            </div>\r\n            <div class=\"col-xs-12 col-sm-12 col-md-4\">\r\n                <button ng-if=\"param.new\" type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"debugObj.addParam(param.name, param.value)\">{{\'Einfügen\'|translate}}</button>\r\n                <button ng-if=\"!param.new\" type=\"button\" class=\"btn btn-danger btn-block\" ng-click=\"debugObj.removeParam(param.name)\">{{\'Entfernen\'|translate}}</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/vvs.components/trip/main.html","<div>\r\n\r\n    <vvs-include vvs-src=\"trip/debug.html\" ng-if=\"debugObj.isDebugModeActive\"></vvs-include>\r\n\r\n    <!-- include trip.init / trip.result / trip.details / trip.print -->\r\n    <div ui-view></div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/ttb/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div ui-view></div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/alerts/main.html","<div class=\"alert alert-danger\" role=\"alert\">\r\n    <p>{{text|translate}}</p>\r\n    <p ng-repeat=\"msg in messages\" ng-if=\"$first\">{{msg.content()|translate}}</p>\r\n    <p ng-bind-html=\"html|VVSSafeHTML\"></p>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/assigned-stops/main.html","<div ng-show=\"VVSAssignedStopsCtrl.location.assignedStops().length>1\">\r\n    <h2 ng-if=\"VVSAssignedStopsCtrl.usage != \'pers\'\">{{\'Zugeordnete Haltestellen\' | translate}}</h2>\r\n    <div class=\"col-xs-12 ctblock nopadding-xs padding-md bticonlist spacerbottom\">\r\n        <button ng-if=\"VVSAssignedStopsCtrl.usage != \'pers\'\" type=\"button\" class=\"btn btn-default btn-block btn-label\" ng-repeat=\"assignedStop in VVSAssignedStopsCtrl.location.assignedStops() track by $index\" ng-click=\"triggerSelectAssignedStopClick(assignedStop)\">\r\n            <div class=\"pull-left text-left verlauf hideme\" ng-bind-html=\"assignedStop|VVSLocationSuggestFormatter\"></div>\r\n            <div class=\"pull-right text-right zhs send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n            <div class=\"pull-right text-right\">\r\n                <vvs-icon ng-repeat=\"productClass in assignedStop.productClasses()|VVSUniqueProductClasses track by $index\" product-class=\"{{productClass}}\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n        <div class=\"assigned-wrap\" ng-if =\"showAssignedBlock\">\r\n            <div class=\"assigned-top\">\r\n                <h2 style=\"margin-top:20px\" ng-show=\"VVSAssignedStopsCtrl.usage === \'pers\' \">{{\'Zugeordnete Haltestellen abonnieren\' | translate}}</h2>\r\n                <button type=\"button\" class=\"close\" aria-label=\"Close\">\r\n                    <span ng-click=\"closeAssignedStops()\"  aria-hidden=\"true\">&times;</span>\r\n                </button>\r\n            </div>\r\n            <button ng-if=\"VVSAssignedStopsCtrl.usage === \'pers\'\" type=\"button\" class=\"btn btn-default btn-block btn-label\" ng-repeat=\"assignedStop in VVSAssignedStopsCtrl.location.assignedStops() track by $index\">\r\n            <div class=\"pull-left text-left verlauf hideme\" ng-bind-html=\"assignedStop|VVSLocationSuggestFormatter\"></div>\r\n\r\n            <div class=\"pull-right text-right\">\r\n                <md-switch ng-model=\"assignedStop.abo\"\r\n                ng-change=\"triggerSelectAssignedStopClick(assignedStop, assignedStop.abo)\"></md-switch>\r\n            </div>\r\n            </button>\r\n\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n\r\n\r\n");
$templateCache.put("app/vvs.components/common/book-taxi/main.html","<div class=\"subinfo spacertoplarge\" ng-repeat=\"booking in leg.bookings()\">\r\n	<vvs-icon name=\"ruftaxi-frei\"></vvs-icon> <vvs-icon name=\"abschicken\"></vvs-icon> <a href=\"{{booking.file.url()}}\" class=\"vvs-book-taxi\" target=\"_blank\">{{\'Ruftaxi buchen\'|translate}}</a>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/book-ast/availability-modal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"VVSASTAvailabilityCtrl.dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Verfügbarkeit Überprüfen\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <div class=\"modal-block spacertop spacerbottom\">\r\n\r\n            <form name=\"availabilityForm\" ng-submit=\"VVSASTAvailabilityCtrl.submitAvailabilityForm()\" novalidate>\r\n                <div>\r\n                    <div>\r\n                        <vvs-alert ng-if=\"VVSASTAvailabilityCtrl.invalidAvailabilityInputsAlert\" text=\"\'Bitte überprüfen Sie Ihre Eingabe!\'\"></vvs-alert>\r\n\r\n                        <header class=\"spacertoplarge\">\r\n                            <h1 style=\"color:#000;\">{{\'Person\'|translate}}</h1>\r\n                        </header>\r\n                        <div class=\"form-group spacertop\">\r\n                            <div class=\"form-group\">\r\n                                <div ng-class=\"{ \'has-error\' : availabilityForm.FirstName.$invalid }\" ng-hide=\"VVSASTAvailabilityCtrl.isCallCenter\">\r\n                                    <label for=\"name\" class=\"nopadding-xs\">{{\'Vorname*\'|translate}}</label>\r\n                                    <input tabindex=\"14\" type=\"text\" class=\"form-control capitalize\" id=\"name\" name=\"FirstName\" aria-label=\"Vorname\" ng-model=\"user.FirstName\" ng-required=\"!VVSASTAvailabilityCtrl.isCallCenter\">\r\n                                </div>\r\n                                <br>\r\n                                <div ng-class=\"{ \'has-error\' : availabilityForm.LastName.$invalid }\">\r\n                                    <label for=\"surname\" class=\"nopadding-xs\">{{\'Nachname*\'|translate}}</label>\r\n                                    <input tabindex=\"15\" type=\"text\" class=\"form-control capitalize\" id=\"surname\" name=\"Name\" aria-label=\"Nachname\" ng-model=\"user.LastName\" required>\r\n                                </div>\r\n                                <br>\r\n                                <div ng-class=\"{ \'has-error\' : availabilityForm.Email.$invalid }\">\r\n                                    <label for=\"email\" class=\"nopadding-xs\">{{\'E-Mail*\'|translate}}</label>\r\n                                    <input tabindex=\"16\" type=\"email\" class=\"form-control\" id=\"email\" name=\"Email\" aria-label=\"E-Mail\" ng-model=\"user.Email\" required>\r\n                                </div>\r\n                                <br>\r\n                                <div ng-class=\"{ \'has-error\' : availabilityForm.Phone.$invalid }\">\r\n                                    <label for=\"Phone\" class=\"nopadding-xs\">{{\'Buchungsname/kürzel\'|translate}}</label>\r\n                                    <input tabindex=\"17\" type=\"text\" class=\"form-control capitalize\" name=\"Phone\" id=\"phone\" aria-label=\"Buchungsname/kürzel\" ng-model=\"user.Phone\">\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <header class=\"spacertoplarge\">\r\n                        <h1 style=\"color:#000;\">{{\'Booking\'|translate}}</h1>\r\n                    </header>\r\n                    <div class=\"form-group spacertop\" ng-init=\"user.PassengerNumber=1;\">\r\n                        <div class=\"form-group\">\r\n                            <div ng-class=\"{ \'has-error\' : availabilityForm.PassengerNumber.$invalid }\">\r\n                                <label for=\"passenger_number\" class=\"nopadding-xs\">{{\'Anzahl Fahrgäste*\'|translate}}</label>\r\n                                <input tabindex=\"18\" value=\"1\" type=\"number\" class=\"form-control capitalize\" id=\"passenger_number\" name=\"PassengerNumber\" aria-label=\"Anzahl Fahrgäste\" ng-model=\"user.PassengerNumber\" min=\"1\" max=\"10\" required>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"form-group\" ng-if=\"user.PassengerNumber>0\" ng-init=\"user.WheelChairNumber=0;\">\r\n                            <div ng-class=\"{ \'has-error\' : availabilityForm.WheelChairNumber.$invalid }\">\r\n                                <label for=\"passenger_number\" class=\"nopadding-xs\">{{\'Anzahl Fahrgäste mit Rollstuhl/Kinderwagen/besonderer Stellplatzbedarf*\'|translate}}</label>\r\n                                <input tabindex=\"19\" value=\"0\" type=\"number\" class=\"form-control capitalize\" id=\"wheelchair_number\" name=\"WheelChairNumber\" aria-label=\"Anzahl Fahrgäste mit Rollstuhl/Kinderwagen\" ng-model=\"user.WheelChairNumber\" min=\"0\" max=\"{{user.PassengerNumber}}\" required>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n        <div class=\"col-xs-12 col-sm-6\">\r\n            <a href=\"javascript:void(0)\" ng-click=\"VVSASTAvailabilityCtrl.dismissModal()\">\r\n                <button type=\"button\" class=\"btn btn-default btn-block ng-binding\">\r\n                    {{\'Abbrechen\'|translate}}\r\n                </button>\r\n            </a>\r\n        </div>\r\n        <div class=\"col-xs-12 col-sm-6\">\r\n            <a href=\"javascript:void(0)\" ng-click=\"VVSASTAvailabilityCtrl.submitAvailabilityForm()\">\r\n                <button type=\"button\" class=\"btn btn-primary btn-block ng-binding\">\r\n                    {{\'Verfügbarkeit überprüfen\'|translate}}\r\n                </button>\r\n            </a>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/book-ast/login-modal.html","<div ng-controller=\"VVSASTLoginController as VVSASTLoginCtrl\">\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Benachrichtigungsservice und Buchung von AST Verkehren\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <div class=\"modal-block spacertop spacerbottom\">\r\n\r\n            <form name=\"loginForm\" ng-submit=\"VVSASTLoginCtrl.submitLoginForm()\" novalidate>\r\n                <div>\r\n                    <div>\r\n                        <vvs-alert ng-if=\"VVSASTLoginCtrl.invalidLoginInputsAlert\" text=\"\'Die eingegebene E-Mail-Adresse oder das Passwort ist falsch!\'\"></vvs-alert>\r\n                        <p class=\"info\"> {{\'Mit dem kostenfreien Benachrichtigungsservice bieten wir Ihnen eine komfortable Möglichkeit, sich automatisch über alle Fahrplanänderungen und uns bekannte aktuelle Störungen auf beliebigen Linien per E-Mail informieren zu lassen. Alternativ bieten wir diesen Service als Push-Dienst in der kostenfreien\'|translate}} <a class=\"special\" href=\"https://www.vvs.de/vvs-app\" target=\"_blank\">{{\'VVS-APP\'|translate}}</a> {{\'für Smartphones (Android / iPhone). Darüber hinaus ist die Buchung und Verwaltung von Fahrten mit dem Bedarfsbus des\'|translate}} <a class=\"special\" href=\"http://www.reallabor-schorndorf.de/\" target=\"_blank\">{{\'Reallabors Schorndorf\'|translate}}</a> {{\'möglich\'|translate}}.\r\n                            <br>\r\n                            <br> {{\'Wenn Sie noch keinen Zugang haben, können Sie sich für den Benachrichtigungsservice\'|translate}} <a class=\"special\" target=\"_blank\" ui-sref=\"vvs.personalization.registration\">{{\'registrieren\'|translate}}</a>.\r\n                            <br>\r\n                            {{\'In Teilen des VVS ist es möglich Online AST Verkehre über die kostenfreie VVS-APP buchen zu können.\'|translate}}\r\n                            <br>\r\n                            {{\'Alle Angebote sind für Sie kostenlos.\'|translate}}.</p>\r\n                        <div class=\"form-group spacertop\">\r\n                            <div ng-class=\"{ \'has-error\' : loginForm.Username.$invalid && !loginForm.Username.$pristine }\">\r\n                                <label for=\"nickname\" class=\"nopadding-xs\">{{\'Benutzername\'|translate}}</label>\r\n                                <input tabindex=\"10\" type=\"text\" class=\"form-control\" name=\"Username\" id=\"nickname\" aria-label=\"Benutzername\" ng-model=\"user.Username\" ng-minlength=\"6\" required>\r\n                            </div>\r\n                            <br>\r\n                            <div ng-class=\"{ \'has-error\' : loginForm.Password.$invalid && !loginForm.Password.$pristine }\">\r\n                                <label for=\"passwort\" class=\"nopadding-xs\">{{\'Passwort\'|translate}}</label>\r\n                                <input tabindex=\"11\" type=\"password\" class=\"form-control\" name=\"Password\" id=\"passwort\" aria-label=\"Passwort\" ng-model=\"user.Password\" ng-minlength=\"6\" ng-maxlength=\"15\" required>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"spacerbottomlarge\" role=\"group\" aria-label=\"login\">\r\n                        <div>\r\n                            <button tabindex=\"25\" type=\"submit\" class=\"btn btn-primary btn-block\" ng-disabled=\"loginForm.$invalid\">{{\'Login\'|translate}}</button>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"spacertop\" role=\"group\" aria-label=\"login\">\r\n                        <div>\r\n                            <a class=\"special\" target=\"_blank\" ui-sref=\"vvs.personalization.registration\">\r\n                                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                {{\'Registrierung\'|translate}}\r\n                            </a>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/book-ast/main.html","<div class=\"subinfo spacertoplarge\">\r\n    <div ng-if=\"!(leg.properties().reservationDetails) && !(leg.properties().bookingDetails)\" class=\"spacerbottom\">\r\n        <div>\r\n            <span>{{\'Genauere Bererchnung der Abfahrtszeit bei Verfügbarkeitsprüfung.\'|translate}}</br></br></span>\r\n        </div>\r\n        <div ng-if=\"VVSBookAstCtrl.isLoggedIn\">\r\n            <vvs-icon name=\"fragezeichen\"></vvs-icon> <vvs-icon name=\"abschicken\"></vvs-icon> <a href=\"javascript:void(0)\" class=\"vvs-book-taxi\" ng-click=\"VVSBookAstCtrl.openAvailabilityModal()\">{{\'Verfügbarkeit überprüfen\'|translate}}</a>\r\n        </div>\r\n        <div ng-if=\"!VVSBookAstCtrl.isLoggedIn\">\r\n            <vvs-icon name=\"fragezeichen\"></vvs-icon> <vvs-icon name=\"abschicken\"></vvs-icon> <a href=\"javascript:void(0)\" class=\"vvs-book-taxi\" vvs-modal vvs-modal-size=\"sm\" vvs-modal-template=\"common/book-ast/login-modal.html\">{{\'Einloggen und Verfügbarkeit überprüfen\'|translate}}</a>\r\n        </div>\r\n    </div>\r\n\r\n\r\n\r\n    <div ng-if=\"VVSBookAstCtrl.isLoggedIn\">\r\n        <div class=\"alert alert-danger\" ng-if=\"leg.properties().reservationDetails\">\r\n            <p>{{\'Die Fahrt wurde für\'}} <strong>{{VVSBookAstCtrl.isLoggedIn.username()}}</strong> {{\'erfolgreich reserviert und unter\'}} <u><a href=\"javascript:void(0)\" ui-sref=\"vvs.personalization.trips\">{{\'Meine reservierte Fahrten\'|translate}}</a></u> {{\'gespeichert\'|translate}}.</p>\r\n\r\n            <vvs-countdown date=\"leg.properties().reservationDetails.expiresAfter\">\r\n                <vvs-countdown-show style=\"display: none;\">\r\n                    <div class=\"alert alert-danger\" role=\"alert\">\r\n                        <p>{{\'Die Fahrt kann nicht mehr gebucht werden!\'|translate}}</p>\r\n                    </div>\r\n                </vvs-countdown-show>\r\n                <vvs-countdown-hide>\r\n                    <p>{{\'Die Fahrt muss\'|translate}} <strong am-time-ago=\"leg.properties().reservationDetails.expiresAfter\">{{leg.properties().reservationDetails.expiresAfter}}</strong> {{\'gebucht werden\'}}.</p>\r\n                    <p><vvs-icon name=\"fragezeichen\"></vvs-icon> <vvs-icon name=\"abschicken\"></vvs-icon> <a href=\"javascript:void(0)\" class=\"vvs-book-taxi\" ng-click=\"VVSBookAstCtrl.book(leg.properties().reservationDetails.reservationCode, leg.properties().reservationDetails.savedTripId)\">{{\'Fahrt buchen\'|translate}}</a></p>\r\n                </vvs-countdown-hide>\r\n            </vvs-countdown>\r\n            <!--<pre>{{leg.properties().reservationDetails|json:4}}</pre>-->\r\n        </div>\r\n        <div class=\"alert alert-danger\" ng-if=\"leg.properties().bookingDetails\">\r\n            <p>{{\'Die Fahrt wurde für\'}} <strong>{{VVSBookAstCtrl.isLoggedIn.username()}}</strong> {{\'erfolgreich gebucht und unter\'}} <u><a href=\"javascript:void(0)\" ui-sref=\"vvs.personalization.trips\">{{\'Meine gebuchte Fahrten\'|translate}}</a></u> {{\'gespeichert\'|translate}}.</p>\r\n            <p>\r\n                {{\'Bitte beachten Sie, dass die genaue Abfahrtzeit und der genaue Abholort sich geringfügig verschieben können. Informieren Sie sich daher kurz vor Fahrtantritt in Ihrem persönlichen Profil über genaue Abfahrtszeit und Abholort Ihres Bedarfsbusses.\'|translate}}\r\n            </p>\r\n            <!--<pre>{{VVSBookAstCtrl.bookingSuccess|json:4}}</pre>-->\r\n        </div>\r\n\r\n        <div class=\"alert alert-danger\" ng-if=\"VVSBookAstCtrl.savingError\">\r\n            <p>{{\'Ein Fehler ist aufgetreten bei dem Speichern von der Fahrt!\'}}</p>\r\n            <!--<pre>{{VVSBookAstCtrl.reservationError|json:4}}</pre>-->\r\n        </div>\r\n        <div class=\"alert alert-danger\" ng-if=\"VVSBookAstCtrl.reservationError\">\r\n            <p>{{VVSBookAstCtrl.reservationError | translate}}</p>\r\n        </div>\r\n        <div class=\"alert alert-danger\" ng-if=\"VVSBookAstCtrl.bookingError\">\r\n            <p>{{\'Ein Fehler ist aufgetreten bei der Buchung, bitte überprüfen Sie ob Sie diese Fahrt schon gebucht haben!\'}}</p>\r\n            <!--<pre>{{VVSBookAstCtrl.bookingError|json:4}}</pre>-->\r\n        </div>\r\n\r\n    </div>\r\n    <div class=\"alert alert-danger\" ng-if=\"!VVSBookAstCtrl.isLoggedIn\">\r\n        <p>{{\'Bitte loggen Sie sich ein um die Verfügbarkeit des Bedarfsbus zu prüfen und danach Ihre persönliche Fahrt zu buchen.\'|translate}}</p>\r\n    </div>\r\n\r\n    <!--<div ng-if=\"VVSBookAstCtrl.astTrip\">\r\n        <pre>{{VVSBookAstCtrl.astTrip|json:4}}</pre>\r\n    </div>-->\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/dev-tools/main.html","<div class=\"col-xs-6 col-sm-3 col-md-6 text-center teaser-item hidden-xs\">\r\n    <a href=\"javascript:void(0)\" vvs-modal vvs-modal-size=\"fullscreen\" vvs-modal-template=\"common/dev-tools/modal.html\">\r\n        <vvs-icon name=\"efaaufhp\"></vvs-icon>\r\n        <br> {{\'Auskunft selbstgemacht\'|translate}}\r\n    </a>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/dev-tools/modal.html","<div class=\"vvs-devtools-modal\" ng-controller=\"VVSDevToolsController\">\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Entwicklertools\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <div class=\"modal-block spacertop spacerbottom\">\r\n            <iframe width=\"100%\" height=\"100%\" src=\"https://www.vvs.de/services/efaaufhp/\" frameborder=\"0\"></iframe>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/feedback/main.html","<a href=\"javascript:void(0)\" class=\"list-group-item\" vvs-modal vvs-modal-size=\"sm\" vvs-modal-template=\"common/feedback/modal.html\">\r\n    <span><vvs-icon name=\"abschicken\"></vvs-icon></span> {{\'Problem melden\'|translate}}\r\n</a>\r\n");
$templateCache.put("app/vvs.components/common/feedback/modal.html","<div ng-controller=\"VVSFeedbackController as VVSFeedbackCtrl\">\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Ihre Meldung\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <div class=\"modal-block spacertop spacerbottom\">\r\n\r\n            <vvs-alert ng-if=\"VVSFeedbackCtrl.feedbackSuccess\" text=\"\'Ihre Meldung wurde erfolgreich gesendet!\'\"></vvs-alert>\r\n\r\n            <p>{{\'Es ist ein Problem aufgetreten? Ein Link funktioniert nicht oder Sie haben eine Fehlermeldung erhalten? Bitte informieren Sie uns über das Problem. Vielen Dank für Ihre Mithilfe!\'|translate}}</p>\r\n            <form name=\"VVSFeedbackCtrl.feedbackForm\" ng-submit=\"VVSFeedbackCtrl.submitFeedbackForm()\" novalidate>\r\n                <div class=\"infocus spacerbottommedium spacertop\">\r\n                    <label class=\"nopadding-xs\" for=\"meldung-text\">{{\'Ihre Meldung\'|translate}}</label>\r\n                    <textarea id=\"meldung-text\" class=\"form-control\" rows=\"5\" ng-model=\"VVSFeedbackCtrl.form.Feedback\" required></textarea>\r\n                    <br>\r\n                    <label class=\"nopadding-xs\" for=\"meldung-email\">{{\'E-Mail\'|translate}}</label>\r\n                    <input id=\"meldung-email\" class=\"form-control\" type=\"email\" ng-model=\"VVSFeedbackCtrl.form.Email\" required>\r\n                </div>\r\n                <div class=\"btn-group btn-group-justified highlight\" aria-label=\"Meldung\" role=\"group\">\r\n                    <div class=\"btn-group \" role=\"group\">\r\n                        <button class=\"btn btn-default\" type=\"submit\" ng-disabled=\"VVSFeedbackCtrl.feedbackForm.$invalid\">{{\'Senden\'|translate}}</button>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/history/line.html","<div class=\"buttonlist col-xs-12 nopadding-xs ctblock\" ng-if=\"VVSHistoryCtrl.favorites.length>0\">\r\n    <h2 class=\"padding-xs nopadding-md history-title\">{{\'Verlauf\'|translate}}</h2>\r\n    <div class=\"rightbt\">\r\n        <a href=\"javascript:void(0)\" vvs-modal vvs-modal-template=\"common/history/modal.html\" vvs-modal-size=\"sm\" title=\"{{\'Verlauf löschen\'|translate}}\">\r\n            <vvs-icon name=\"loeschen\"></vvs-icon>\r\n        </a>\r\n    </div>\r\n    <button type=\"button\" class=\"btn btn-default btn-block btn-autoheight\" ng-repeat=\"favorite in VVSHistoryCtrl.favorites | orderBy:\'-persistence.modified\'\" ng-click=\"VVSHistoryCtrl.triggerHistoryItemClick(favorite)\">\r\n        <div class=\"sendholder\">\r\n            <div class=\"pull-left text-left\">\r\n                <vvs-icon product-icon-id=\"{{favorite.productIconId()}}\" class=\"icon\"></vvs-icon> <span ng-bind-html=\"favorite | VVSLineNameFormatter\"></span>\r\n            </div>\r\n        </div>\r\n    </button>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/history/location.html","<div class=\"ctblock col-xs-12 nopadding-xs spacerbottomlarge ctblockReset\" ng-if=\"VVSHistoryCtrl.favorites.length>0\">\r\n    <h2 class=\"padding-xs nopadding-md history-title\">{{\'Verlauf\' | translate}}</h2>\r\n    <div class=\"rightbt\">\r\n        <a href=\"javascript:void(0)\" vvs-modal vvs-modal-template=\"common/history/modal.html\" vvs-modal-size=\"sm\" title=\"{{\'Verlauf löschen\'|translate}}\">\r\n            <vvs-icon name=\"loeschen\"></vvs-icon>\r\n        </a>\r\n    </div>\r\n    <button type=\"button\" class=\"btn btn-default btn-block nopadding\"  ng-repeat=\"favorite in VVSHistoryCtrl.favorites | orderBy:\'-persistence.modified\'\" ng-click=\"VVSHistoryCtrl.triggerHistoryItemClick(favorite)\">\r\n        <div class=\"pull-left text-left\">\r\n            <vvs-icon type=\"{{favorite.type()}}\" class=\"verlauf\"></vvs-icon>\r\n        </div>\r\n        <div class=\"pull-left text-left verlauf hideme\">\r\n            <div ng-bind-html=\"favorite|VVSLocationSuggestFormatter\"></div>\r\n        </div>\r\n    </button>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/history/modal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Verlauf\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\" ng-init=\"switcher=VVSHistoryCtrl.historyMode+\'_\'+VVSHistoryCtrl.historyUsage\">\r\n        <h2 ng-if=\"switcher===\'odv_odv\'\">{{\'Verbindungen löschen?\' | translate}}</h2>\r\n        <h2 ng-if=\"switcher===\'location_dm\'\">{{\'Abfahrt/Ankunft löschen?\' | translate}}</h2>\r\n        <h2 ng-if=\"switcher===\'location_rop\'\">{{\'Haltestellen für Stadtplanausschnitt löschen?\' | translate}}</h2>\r\n        <h2 ng-if=\"switcher===\'line_rop\'\">{{\'Linien für Stadtplanausschnitt löschen?\' | translate}}</h2>\r\n        <h2 ng-if=\"switcher===\'location_ttb\'\">{{\'Haltestellen für Fahrplanbuchseiten löschen?\' | translate}}</h2>\r\n        <h2 ng-if=\"switcher===\'line_ttb\'\">{{\'Linien für Fahrplanbuchseiten löschen?\' | translate}}</h2>\r\n        <h2 ng-if=\"switcher===\'location_stt\'\">{{\'Haltestellen für Aushangfahrplan löschen?\' | translate}}</h2>\r\n        <h2 ng-if=\"switcher===\'line_stt\'\">{{\'Linien für Aushangfahrplan löschen?\' | translate}}</h2>\r\n        <h2 ng-if=\"switcher===\'location_pers\'\">{{\'Abonnierte Haltestellen löschen?\' | translate}}</h2>\r\n        <h2 ng-if=\"switcher===\'line_pers\'\">{{\'Abonnierte Linien löschen?\' | translate}}</h2>\r\n        <div class=\"modal-block spacerbottomlarge\">\r\n            <div class=\"btn-group btn-group-justified highlight\" role=\"group\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" ng-click=\"VVSHistoryCtrl.triggerClearFavoritesClick(); dismissModal()\" type=\"button\">{{\'OK\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/history/odv.html","<div class=\"ctblock col-xs-12 nopadding-xs ctblockReset\" ng-if=\"VVSHistoryCtrl.favorites.length>0\">\r\n    <h2 class=\"padding-xs nopadding-md history-title\">{{\'Verlauf\' | translate}}</h2>\r\n    <div class=\"rightbt\">\r\n        <a href=\"javascript:void(0)\" vvs-modal vvs-modal-template=\"common/history/modal.html\" vvs-modal-size=\"sm\" title=\"{{\'Verlauf löschen\'|translate}}\">\r\n            <vvs-icon name=\"loeschen\"></vvs-icon>\r\n        </a>\r\n    </div>\r\n    <button type=\"button\" class=\"btn btn-default btn-block nopadding\" ng-repeat=\"odvFavorite in VVSHistoryCtrl.favorites | orderBy:\'-persistence.modified\'\" ng-click=\"VVSHistoryCtrl.triggerHistoryItemClick(odvFavorite)\" ng-class=\"{\'btn-lg\':odvFavorite.vias().length>0}\">\r\n        <div class=\"pull-left text-left\">\r\n            <vvs-icon name=\"{{odvFavorite.vias().length>0?\'von-nach2\':\'von-nach\'}}\"></vvs-icon>\r\n        </div>\r\n        <div class=\"pull-left text-left verlauf hideme\">\r\n            {{odvFavorite.origin() | VVSLocationNameFormatter}}\r\n            <span ng-repeat=\"via in odvFavorite.vias()\"><br>{{via | VVSLocationNameFormatter}}</span>\r\n            <br>{{odvFavorite.destination() | VVSLocationNameFormatter}}\r\n        </div>\r\n    </button>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/infos/details.html","<div class=\"subinfo\">\r\n    <a href=\"javascript:void(0)\" ng-show=\"!VVSInfosCtrl.hideInfo\" vvs-modal vvs-modal-template=\"common/infos/modal.html\" title=\"{{\'Wichtige Informationen anzeigen\'|translate}}\">\r\n        <vvs-icon ng-repeat=\"iconName in VVSInfosCtrl.iconNames track by $index\" name=\"{{iconName}}\"></vvs-icon>\r\n        <span class=\"hidden-xs\" ng-repeat=\"info in VVSInfosCtrl.infos\">\r\n            <span ng-if=\"info.properties().infoType == \'stopBlocking\'\">{{info.title()}}:</span>\r\n            {{info.subtitle()}}</br>\r\n        </span>\r\n    </a>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/infos/dm.html","<a href=\"javascript:void(0)\" ng-show=\"!VVSInfosCtrl.hideInfo\" vvs-modal vvs-modal-template=\"common/infos/modal.html\" title=\"{{\'Wichtige Informationen anzeigen\'|translate}}\">\r\n    <vvs-icon ng-repeat=\"iconName in VVSInfosCtrl.iconNames\" name=\"{{iconName}}\" ng-show=\"!VVSInfosCtrl.hideInfo\"></vvs-icon>\r\n</a>\r\n");
$templateCache.put("app/vvs.components/common/infos/modal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Meldungen\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\" ng-controller=\"VVSModalsInfosController as VVSModalsInfosCtrl\">\r\n        <div class=\"panel-group spacertoplarge accordion\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\" ng-if=\"VVSModalsInfosCtrl.sortedGroupedInfos\">\r\n            <div class=\"panel panel-default\" ng-repeat=\"(key, infos) in VVSModalsInfosCtrl.sortedGroupedInfos track by $index\" ng-init=\"collapseInfo[$index]=$first\">\r\n                <div class=\"panel-heading\" role=\"tab\" id=\"headingOne\">\r\n                    <h2 class=\"panel-title\">\r\n                        <a role=\"button\" class=\"collapse-toggle\" ng-click=\"collapseInfo[$index]=!collapseInfo[$index]\">\r\n                            <span ng-if=\"key==\'stoerung\'\"><vvs-icon name=\"stoerungsmeldung\"></vvs-icon> {{\'Störungen\' | translate}}</span>\r\n                            <span ng-if=\"key==\'meldungen\'\"><vvs-icon name=\"stoerungsmeldung\"></vvs-icon> {{\'Fahrplanänderungen\'|translate}}</span>\r\n                            <span ng-if=\"key==\'aufzug\'\"><vvs-icon name=\"aufzugsmeldung-vvs\"></vvs-icon> {{\'Aufzugs- / Rolltreppenzustände\'|translate}}</span>\r\n                            <span ng-if=\"key==\'other\'\"> {{\'Sonstige Informationen\' | translate}}</span>\r\n\r\n                        </a>\r\n                    </h2>\r\n                </div>\r\n                <div class=\"panel-collapse collapse\" role=\"tabpanel\" aria-labelledby=\"headingOne\" uib-collapse=\"!collapseInfo[$index]\">\r\n                    <div class=\"panel-body\" ng-repeat=\"info in infos track by $index\">\r\n\r\n                        <div ng-repeat=\"(productIconId, lines) in info.affectedLines()|groupBy:\'productIconId()\'\">\r\n                            <h2 class=\"hicon {{productIconId|VVSProductIconIdMapper}}\"> <span ng-repeat=\"line in lines|unique:\'number()\'\">{{line.number()}}<span ng-if=\"!$last\">, </span></span></h2>\r\n                        </div>\r\n\r\n                        <div ng-if=\"info.affectedStops().length>0\">\r\n                            <h2 class=\"hicon haltestelle\"><span ng-repeat=\"location in info.affectedStops()|unique:\'id()\'\">{{location|VVSLocationNameFormatter}}<span ng-if=\"!$last\">, </span></span></h2>\r\n                        </div>\r\n\r\n\r\n                        <p>\r\n                            <span ng-if=\"info.validityFrom()\">{{\'von\'|translate}} <strong>{{info.validityFrom()|VVSDateFormatter}}</strong> </span>\r\n                            <span ng-if=\"info.validityTo()\">{{\'bis\'|translate}}\r\n                            <strong ng-switch on=\"info.validityTo()|VVSDateFormatter\"><span ng-switch-when=\"31.12.2500\">{{\'auf Weiteres\'|translate}}</span><span ng-switch-default>{{info.validityTo()|VVSDateFormatter}}</span></strong></span>\r\n                            <br> {{info.subtitle()}}\r\n                        </p>\r\n                        <p>\r\n                            <a data-toggle=\"collapse\" class=\"readmore collapse-toggle\" ng-class=\"{\'collapsed\':!readMore[$index]}\" ng-click=\"readMore[$index]=!readMore[$index]\" aria-expanded=\"false\"  data-target=\"#readMore_{{$index}}\">\r\n                                <span ng-if=\"!readMore[$index]\">{{\'Mehr Details\'|translate}}</span>\r\n                                <span ng-if=\"readMore[$index]\">{{\'Weniger Details\'|translate}}</span>\r\n                            </a>\r\n                        </p>\r\n                        <div class=\"collapse vvs-animated-infos\" id=\"readMore_{{$index}}\" uib-collapse=\"!readMore[$index]\">\r\n                            <p ng-bind-html=\"info.content()|VVSSafeHTML\"></p>\r\n                            <p ng-if=\"info.creation()\">{{\'Stand\'|translate}} {{info.creation()|VVSDateFormatter}} {{info.creation()|VVSTimeFormatter}}</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"arrow\">\r\n                    <vvs-icon name=\"up\" ng-show=\"collapseInfo[$index]\"></vvs-icon>\r\n                    <vvs-icon name=\"down\" ng-show=\"!collapseInfo[$index]\"></vvs-icon>\r\n                </div>\r\n            </div>\r\n\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/vvs.components/common/infos/summary.html","<div class=\"info nopadding-xs\">\r\n    <button type=\"button\" class=\"btn btn-link\" ng-class=\"{\'no-click\':VVSInfosCtrl.hideInfo}\" vvs-modal vvs-modal-ignore=\"VVSInfosCtrl.hideInfo\" vvs-modal-template=\"common/infos/modal.html\" title=\"{{\'Wichtige Informationen anzeigen\'|translate}}\">\r\n        <vvs-icon ng-repeat=\"iconName in VVSInfosCtrl.iconNames\" name=\"{{iconName}}\" ng-show=\"!VVSInfosCtrl.hideInfo\"></vvs-icon>\r\n    </button>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/language-switcher/mobile.html","<a href=\"javascript:void(0)\" class=\"col-xs-12\" ng-repeat=\"lang in tsctrl.availableLanguages\" ng-if=\"currentLanguage!==lang\" ng-switch=\"lang\" ng-click=\"tsctrl.switchLanguage(lang)\">\r\n    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n    <span ng-switch-when=\"de\">{{\'Deutsch\'|translate}}</span>\r\n    <span ng-switch-when=\"en\">{{\'English\'|translate}}</span>\r\n</a>\r\n");
$templateCache.put("app/vvs.components/common/language-switcher/web.html","<a href=\"javascript:void(0)\" class=\"lang-link hidden-xs\" ng-repeat=\"lang in tsctrl.availableLanguages\" ng-if=\"currentLanguage!==lang\" ng-switch=\"lang\" ng-click=\"tsctrl.switchLanguage(lang)\" tabindex=\"-1\">\r\n    <span ng-switch-when=\"de\" title=\"{{\'german version\'|translate}}\">{{\'Deutsch\'|translate}}</span>\r\n    <span ng-switch-when=\"en\" title=\"{{\'englische Version\'|translate}}\">{{\'English\'|translate}}</span>\r\n</a>\r\n");
$templateCache.put("app/vvs.components/common/logout/main.html","<div class=\"ctblock col-xs-12 nopadding-xs spacertop spacerbottom\" role=\"group\" aria-label=\"logout\" ng-show=\"!(\'vvs.personalization.login\'|isState)\">\r\n    <div class=\"col-xs-12\">\r\n        <div class=\"box\">\r\n            <!-- <h2>{{\'Mein VVS-Konto\'|translate}}</h2> -->\r\n            <h2> {{\'Benachrichtigungsservice\' | translate}}</h2>\r\n            <div ng-show=\"loggedInUser\">\r\n                <p>{{\'Sie sind angemeldet als\'|translate}}:\r\n                    <br> {{loggedInUser.username()}}</p>\r\n                <button type=\"button\" class=\"btn btn-secondary btn-block\" ng-click=\"triggerLogoutClick()\">{{\'Logout\'|translate}}</button>\r\n                <!--<p>\r\n                    <a href=\"javascript:void(0)\" title=\"{{\'Meine fahrten\'|translate}}\" ui-sref=\"vvs.personalization.trips\">\r\n                        <vvs-icon name=\"abschicken\"></vvs-icon>{{\'Meine Fahrten\'|translate}}\r\n                    </a>\r\n                </p>-->\r\n                <p>\r\n                    <a href=\"javascript:void(0)\" title=\"{{\'Service einrichten\'|translate}}\" ui-sref=\"vvs.personalization.init\">\r\n                        <vvs-icon name=\"abschicken\"></vvs-icon>{{\'Service einrichten\'|translate}}\r\n                    </a>\r\n                </p>\r\n                <p>\r\n                    <a href=\"javascript:void(0)\" title=\"{{\'Persönliche Daten ändern\'|translate}}\" ui-sref=\"vvs.personalization.profile\">\r\n                        <vvs-icon name=\"abschicken\"></vvs-icon>{{\'Persönliche Daten ändern\'|translate}}\r\n                    </a>\r\n                </p>\r\n            </div>\r\n            <div ng-show=\"!loggedInUser\">\r\n                <form name=\"loginForm\" novalidate>\r\n                    <vvs-alert ng-if=\"invalidLoginInputsAlert\" text=\"\'Die eingegebene E-Mail-Adresse oder das Passwort ist falsch!\'\"></vvs-alert>\r\n                    <p>\r\n                        <input type=\"text\" class=\"form-control\" placeholder=\"{{\'E-Mail\'|translate}}\" name=\"Username\" id=\"nickname\" aria-label=\"E-Mail\" ng-model=\"loggedOutUser.Username\" ng-minlength=\"6\" required/>\r\n                        <input type=\"password\" class=\"form-control\" placeholder=\"{{\'Passwort\'|translate}}\" name=\"Password\" id=\"passwort\" aria-label=\"Passwort\" ng-model=\"loggedOutUser.Password\" ng-minlength=\"6\" ng-maxlength=\"15\" required/>\r\n                    </p>\r\n                    <button type=\"button\" class=\"btn btn-secondary btn-block\" ng-click=\"triggerLoginClick()\" ng-disabled=\"loginForm.$invalid\">{{\'Login\'|translate}}</button>\r\n                </form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/nav-block/main.html","<div class=\"nav-wrap\">\r\n    <h2 class=\"nopadding-xs padding-wrap\">{{title |translate}}</h2>\r\n    <div class=\"nav\">\r\n        <li><a href=\"javascript:window.history.back();\" class=\"link\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\'zurück\'|translate}}</a></li>\r\n        <li><a class=\"link\" href=\"#!/XSLT_PERSONALIZATION_REQUEST@profile\" title=\"Persönliche Daten ändern\" ui-sref=\"vvs.personalization.profile\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\"Pers. Daten\"|translate}}</a></li>\r\n        <li><a ng-click=\"triggerLogoutClick()\" href=\"javascript:void(0)\" class=\"link\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\'Abmelden\'|translate}}</a></li>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/pdf/main.html","<div class=\"vvs-pdf-viewer\" ng-init=\"fileUrl = file.url()\">\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <div ng-if=\"fileUrl\">\r\n            <div class=\"linklist separator-top\">\r\n                <strong>\r\n                    <a href=\"{{fileUrl}}\" title=\"{{file.input()}}\" target=\"_blank\">\r\n                        <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                        <span ng-switch on=\"file.type()\">\r\n                            <span ng-switch-when=\"PS\">{{\'Fahrtempfehlung\' | translate}}</span>\r\n                            <span ng-switch-when=\"STT\">{{\'Aushangfahrplan\' | translate}} für -> <span ng-bind-html=\"line | VVSLineNameFormatter\"></span></span>\r\n                            <span ng-switch-when=\"TTB\" ng-if=\"lfp===\'false\'\">{{\'Fahrplantabelle\' | translate}} für -> <span ng-bind-html=\"line | VVSLineNameFormatter\"></span></span>\r\n                            <span ng-switch-when=\"TTB\" ng-if=\"lfp===\'true\'\">{{\'Linienfahrplan\' | translate}} für -> <span ng-bind-html=\"line | VVSLineNameFormatter\"></span></span>\r\n                            <span ng-switch-when=\"ROP\">{{\'Stadtplanausschnitt\' | translate}}</span>\r\n                            <span ng-switch-when=\"SM\">{{\'Haltestellenkarte\' | translate}}</span>\r\n                            <span ng-switch-when=\"SM_ME\">{{\'Haltestellenkarte f. Mobilitätseingeschränkte\' | translate}}</span>\r\n                            <span ng-switch-when=\"ROP_STOP\">{{\'Stadtplanausschnitt\' | translate}} für {{file.input()}}</span>\r\n                            <span ng-switch-when=\"ROP_LINE\">{{\'Linienverlaufsplan\' | translate}}</span>\r\n                            <span ng-switch-default>{{file.type()}}</span>\r\n                        </span>\r\n                         ({{file.extension()}} | {{file.size()}} kb)\r\n                    </a>\r\n                </strong>\r\n            </div>\r\n        </div>\r\n        <div ng-if=\"!fileUrl\">\r\n            <vvs-alert text=\"\'Es ist ein Fehler aufgetreten! Die Datei konnte nicht erstellt werden!\'\"></vvs-alert>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/pdf-viewer/modal.html","<div class=\"vvs-pdf-viewer\" ng-init=\"fileUrl = file.url()\">\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">\r\n            <span ng-switch on=\"file.type()\">\r\n                <span ng-switch-when=\"PS\">{{\'Fahrtempfehlung\' | translate}}</span>\r\n                <span ng-switch-when=\"STT\">{{\'Aushangfahrplan\' | translate}}</span>\r\n                <span ng-switch-when=\"TTB\" ng-if=\"isLFP===\'false\'\">{{\'Fahrplanbuchseite\' | translate}}</span>\r\n                <span ng-switch-when=\"TTB\" ng-if=\"isLFP===\'true\'\">{{\'Linienfahrplan\' | translate}}</span>\r\n                <span ng-switch-when=\"ROP_STOP\">{{\'Stadtplanausschnitt\' | translate}}</span>\r\n                <span ng-switch-when=\"SM\">{{\'Haltestellenkarte\' | translate}}</span>\r\n                <span ng-switch-when=\"SM_ME\">{{\'Haltestellenkarte f. Mobilitätseingeschränkte\' | translate}}</span>\r\n                <span ng-switch-when=\"ROP_LINE\">{{\'Linienverlaufsplan\' | translate}}</span>\r\n                <span ng-switch-when=\"ROP\">{{\'Stadtplanausschnitt\' | translate}}</span>\r\n                <span ng-switch-default>{{file.type()}}</span>\r\n            </span>\r\n        </h4>\r\n    </div>\r\n\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <div ng-if=\"fileUrl\">\r\n        <!-- <div ng-if=\"(file.type()===\'ROP\') || (file.type()===\'ROP_STOP\') || (file.type()===\'ROP_LINE\')\"> -->\r\n            <!-- <vvs-alert text=\"\'Diese Funktion ist zur Zeit wegen einer Datenumstellung nicht erreichbar!\'\"></vvs-alert>\r\n        </div> -->\r\n        <!-- <div ng-if=\"fileUrl && (file.type()!=\'ROP\') && (file.type()!=\'ROP_STOP\') && (file.type()!=\'ROP_LINE\')\"> -->\r\n\r\n            <h2>{{\'Das Ergebnis Ihrer Anfrage ist jetzt abrufbar:\'|translate}}</h2>\r\n            <div class=\"linklist separator-top\">\r\n                <strong>\r\n                    <a href=\"{{fileUrl}}\" title=\"{{file.input()}}\" target=\"_blank\">\r\n                        <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                        <span ng-switch on=\"file.type()\">\r\n                            <span ng-switch-when=\"PS\">{{\'Fahrtempfehlung\' | translate}}</span>\r\n                            <span ng-switch-when=\"STT\">{{\'Aushangfahrplan\' | translate}}</span>\r\n                            <span ng-switch-when=\"TTB\" ng-if=\"isLFP===\'false\'\">{{\'Fahrplanbuchseite\' | translate}}</span>\r\n                            <span ng-switch-when=\"TTB\" ng-if=\"isLFP===\'true\'\">{{\'Linienfahrplan\' | translate}}</span>\r\n                            <span ng-switch-when=\"ROP\">{{\'Stadtplanausschnitt\' | translate}}</span>\r\n                            <span ng-switch-when=\"SM\">{{\'Haltestellenkarte\' | translate}}</span>\r\n                            <span ng-switch-when=\"SM_ME\">{{\'Haltestellenkarte f. Mobilitätseingeschränkte\' | translate}}</span>\r\n                            <span ng-switch-when=\"ROP_STOP\">{{\'Stadtplanausschnitt\' | translate}}</span>\r\n                            <span ng-switch-when=\"ROP_LINE\">{{\'Linienverlaufsplan\' | translate}}</span>\r\n                            <span ng-switch-default>{{file.type()}}</span>\r\n                        </span>\r\n                         ({{file.extension()}} | {{file.size()}} kb)\r\n                    </a>\r\n                </strong>\r\n            </div>\r\n        </div>\r\n        <div ng-if=\"!fileUrl\">\r\n            <vvs-alert text=\"\'Es ist ein Fehler aufgetreten! Die Datei konnte nicht erstellt werden!\'\"></vvs-alert>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/perlschnur/main.html","<table class=\"table trip perlschnur\" ng-init=\"showLineView = false;\">\r\n    <tbody>\r\n        <tr ng-show=\"showLineView === false\" ng-repeat=\"groupedLocationSequence in VVSPerlschnurCtrl.groupedLocationSequences track by $index\" ng-init=\"$parentFirst=$first; $parentLast=$last\" ng-class=\"{\'notusedstops\': (!VVSPerlschnurCtrl.hasUsedStops(groupedLocationSequence.locations) && !VVSPerlschnurCtrl.showNotUsedStops)}\">\r\n            <td class=\"tarifzonen\" ng-class=\"{\'even\': ($index % 2 == 0), \'odd\': ($index % 2 != 0)}\" title=\"{{\'Tarifzone\'|translate}}\">\r\n                <span>{{groupedLocationSequence.zone}}</span>\r\n            </td>\r\n            <td>\r\n                <table class=\"ps-inner\">\r\n                    <tbody>\r\n                        <tr ng-repeat=\"location in groupedLocationSequence.locations\" ng-class=\"{\'notusedstops\': (!location.properties().usedstop && !VVSPerlschnurCtrl.showNotUsedStops)}\">\r\n                            <td ng-class=\"\r\n                            {\r\n                                \'ps-begin\':($parentFirst && $first),\r\n                                \'ps-stop\':((!$parentFirst && !$first) || ($parentFirst && !$first) || (!$parentFirst && $first)),\r\n                                \'ps-end\':($last && $parentLast),\r\n                                \'current-stop\': currentSt.startsWith(location.parent().properties().stopId),\r\n                                {{productIconId|VVSProductIconIdMapper}}:currentSt.startsWith(location.parent().properties().stopId)\r\n                            }\"\r\n                            class=\"{{location.lpClass}}\"></td>\r\n                            <td class=\"verkehrsmittel\">\r\n                                <!-- {{currentSt.startsWith(location.parent().properties().stopId)}} -->\r\n                                {{location|VVSLocationNameFormatter}}</br>\r\n                                <vvs-icon ng-repeat=\"productClass in (location.productClasses()|VVSUniqueProductClassesPerlschnur)\" product-class=\"{{productClass}}\"></vvs-icon>\r\n                            </td>\r\n                            <td>\r\n                                <vvs-occ perlschnur=\"location\"></vvs-occ>\r\n                            </td>\r\n                            <td class=\"time\">\r\n                                <span ng-if=\"!location.cancelled\">\r\n                                    <vvs-real-time-icon ng-if=\"(location.arrivalTime() || location.departureTime())\" mode=\"\'location\'\" location=\"location\" usage=\"\'dep\'\"></vvs-real-time-icon>\r\n                                    <span ng-if=\"location.departureTime()\" ng-class=\"{\'late\': (location.departureDelay()>0)}\">{{\'ab\'|translate}} {{location.departureTime()|VVSTimeFormatter}}</span>\r\n\r\n\r\n                                    <span ng-if=\"location.arrivalTime() && !location.departureTime()\" ng-class=\"{\'late\': (location.arrivalDelay()>0)}\">{{\'an\'|translate}} {{location.arrivalTime()|VVSTimeFormatter}}</span>\r\n\r\n\r\n                                    <span ng-if=\"(!location.arrivalTime() && !location.departureTime() && (location.lpDelay>=0))\" ng-class=\"{\'late\': (location.lpDelay>0)}\"><vvs-icon name=\"echtzeit\"></vvs-icon> +{{location.lpDelay|VVSTravelledDurationFormatter}}</span>\r\n                                    <span ng-if=\"delay>=0 && currentSt.startsWith(location.parent().properties().stopId)\" ng-class=\"{\'late\': (delay>0)}\"><vvs-icon name=\"echtzeit\"></vvs-icon> {{delay | VVSDelayFormatter}}</span>\r\n                                </span>\r\n                                <span class=\"cancelled\" ng-if=\"location.cancelled\">Ausfall</span>\r\n                            </td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n            </td>\r\n        </tr>\r\n        <tr ng-repeat=\"group in resultSequences track by $index\" ng-show=\"showLineView === true\" ng-init=\"$parentFirst=$first; $parentLast=$last\" >\r\n        <!-- <tr ng-repeat=\"group in resultSeqtoShow track by $index\" ng-show=\"showLineView === true\" ng-init=\"$parentFirst=$first; $parentLast=$last\" > -->\r\n            <td class=\"tarifzonen\" ng-class=\"{\'even\': ($index % 2 == 0), \'odd\': ($index % 2 != 0)}\" title=\"{{\'Tarifzone\'|translate}}\">\r\n                <span>{{group.zone}}</span>\r\n            </td>\r\n            <td>\r\n                <table class=\"ps-inner\">\r\n                    <tbody>\r\n                        <!-- after Click auf Linienverlauf -->\r\n                        <tr ng-show=\"showLineView === true\" ng-repeat=\"location in group.locations\">\r\n                            <td ng-class=\"\r\n                            {\r\n                                \'ps-begin\':($parentFirst && $first),\r\n                                \'ps-stop\':((!$parentFirst && !$first) || ($parentFirst && !$first) || (!$parentFirst && $first)),\r\n                                \'ps-end\':($last && $parentLast),\r\n                                \'current-stop\': currentSt.startsWith(location.parent().properties().stopId),\r\n                                {{productIconId|VVSProductIconIdMapper}}:currentSt.startsWith(location.parent().properties().stopId)\r\n                            }\"\r\n                            class=\"{{location.lpClass}}\"></td>\r\n                            <td class=\"verkehrsmittel\">\r\n                                {{location|VVSLocationNameFormatter}}</br>\r\n                                <vvs-icon ng-repeat=\"productClass in (location.productClasses()| VVSUniqueProductClassesPerlschnur)\" product-class=\"{{productClass}}\"></vvs-icon>\r\n                            </td>\r\n                            <td>\r\n                                <vvs-occ perlschnur=\"location\"></vvs-occ>\r\n                            </td>\r\n                            <td class=\"time\">\r\n                                <span ng-if=\"!location.cancelled\">\r\n                                    <vvs-real-time-icon ng-if=\"(location.arrivalTime() || location.departureTime())\" mode=\"\'location\'\" location=\"location\" usage=\"\'dep\'\"></vvs-real-time-icon>\r\n\r\n                                    <!-- <span ng-if=\"location.departureTime()\" ng-class=\"{\'late\': (location.departureDelay()>0)}\">{{\'ab\'|translate}} {{(location.departureTime()|VVSTimeFormatter)}}</span> -->\r\n\r\n                                    <span ng-if=\"location.departureTime() || location.addedDepartureTime\" ng-class=\"{\'late\': (location.departureDelay()>0) || (location.addedDepartureDelay>0)}\">{{\'ab\'|translate}} {{(location.departureTime()|VVSTimeFormatter) || (location.addedDepartureTime | VVSTimeFormatter)}}</span>\r\n\r\n\r\n                                    <span ng-if=\"location.arrivalTime() && !location.departureTime() || location.addedArrivalTime\" ng-class=\"{\'late\': (location.arrivalDelay()>0) || (location.addedArrivalDelay > 0)}\">{{\'an\'|translate}} {{(location.arrivalTime()| VVSTimeFormatter) || (location.addedArrivalTime | VVSTimeFormatter)}}</span>\r\n\r\n\r\n                                    <span ng-if=\"(!location.arrivalTime() && !location.departureTime() && (location.lpDelay>=0))\" ng-class=\"{\'late\': (location.lpDelay>0)}\"><vvs-icon name=\"echtzeit\"></vvs-icon> +{{location.lpDelay|VVSTravelledDurationFormatter}}</span>\r\n                                    <span ng-if=\"delay>=0 && currentSt.startsWith(location.parent().properties().stopId)\" ng-class=\"{\'late\': (delay>0)}\"><vvs-icon name=\"echtzeit\"></vvs-icon> {{delay | VVSDelayFormatter}}</span>\r\n                                </span>\r\n                                <span class=\"cancelled\" ng-if=\"location.cancelled\">Ausfall</span>\r\n                            </td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n            </td>\r\n        </tr>\r\n        <tr ng-show=\"VVSPerlschnurCtrl.isLegMode\">\r\n            <td></td>\r\n            <td>\r\n                <table class=\"ps-inner\">\r\n                    <tbody>\r\n                        <tr class=\"more\">\r\n                            <td class=\"ps-more\"></td>\r\n                            <td>\r\n                                <a href=\"javascript:void(0)\" ng-click=\"VVSPerlschnurCtrl.showNotUsedStops=true; VVSPerlschnurCtrl.isLegMode=false; showLineView = true;\" title=\"{{\'Linienverlauf anzeigen\'|translate}}\" class=\"getallstops\">\r\n                                    <vvs-icon name=\"abschicken\"></vvs-icon> {{\'Linienverlauf\'|translate}} {{VVSPerlschnurCtrl.transportation.number()}} {{\'anzeigen\'|translate}}\r\n                                </a>\r\n                            </td>\r\n                            <td class=\"time\"></td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n            </td>\r\n        </tr>\r\n    </tbody>\r\n</table>\r\n\r\n");
$templateCache.put("app/vvs.components/common/place-holder/main.html","<div ng-class=\"{\'col-xs-12 promo spacertop spacerbottom\':VVSPlaceHolderCtrl.images.length>0}\">\r\n    <a ng-repeat=\"image in VVSPlaceHolderCtrl.images\" href=\"{{image.banner_link}}\" target=\"_blank\">\r\n        <img ng-src=\"{{image.image_url}}\"/>\r\n    </a>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/poi/main.html","<a href=\"javascript:void(0)\" vvs-modal vvs-modal-template=\"common/poi/modal.html\" title=\"{{\'POI aus der Liste wählen\'|translate}}\" tabindex=\"-1\">\r\n    <vvs-icon name=\"poi\"></vvs-icon>\r\n</a>\r\n");
$templateCache.put("app/vvs.components/common/poi/modal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'POI wählen\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\" ng-controller=\"VVSPoiController\">\r\n        <h2>{{\'Wichtige Ziele\' | translate}}</h2>\r\n        <div class=\"drilldown\">\r\n            <!-- required -->\r\n            <div class=\"drilldown-container\">\r\n                <!-- required -->\r\n                <ul class=\"drilldown-root\" ng-class=\"{\'noicon\':showBackBtn}\">\r\n                    <!-- back button -->\r\n                    <li class=\"drilldown-back\" ng-show=\"showBackBtn\">\r\n                        <a href=\"javascript:void(0)\">\r\n                            <button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"triggerMenuClick(prevHierarchy, true)\">\r\n                                <div class=\"pull-left text-left send\">\r\n                                    <vvs-icon name=\"zurueck\"></vvs-icon>\r\n                                </div>\r\n                                <div class=\"pull-left text-left\">\r\n                                    <div class=\"maintext\">{{\'Zurück\' | translate}}</div>\r\n                                </div>\r\n                            </button>\r\n                        </a>\r\n                    </li>\r\n                    <!-- repeat -->\r\n                    <li ng-repeat=\"poiCategory in poiCategories\" ng-class=\"{\'vvs-animated-back\':backClicked, \'vvs-animated-slide\':animate, \'first\': $first}\">\r\n                        <a href=\"javascript:void(0)\" ng-click=\"(poiCategory.id().indexOf(\'poiID\')===0)?assignPoiByUsage(poiCategory):triggerMenuClick(poiCategory.id())\">\r\n                            <button type=\"button\" class=\"btn btn-default btn-block\" ng-class=\"{\'nopadding\':!showBackBtn}\">\r\n                                <div class=\"pull-left text-left\" ng-show=\"poiCategory.icon\">\r\n                                    <vvs-icon name=\"{{poiCategory.icon}}\"></vvs-icon>\r\n                                </div>\r\n                                <div class=\"pull-left text-left\">\r\n                                    <div class=\"maintext\">{{poiCategory | VVSPoiNameFormatter | translate}}</div>\r\n                                </div>\r\n                                <div class=\"pull-right text-right send\" ng-hide=\"poiCategory.id().indexOf(\'poiID\') === 0\">\r\n                                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                </div>\r\n                            </button>\r\n                        </a>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/common/realtime-icon/main.html","<span class=\"echtzeit vvs-real-time\" title=\"{{\'Echtzeit\'|translate}}\">\r\n    <vvs-icon name=\"echtzeit\" ng-if=\"hasRealtime\"></vvs-icon>\r\n</span>\r\n");
$templateCache.put("app/vvs.components/common/vm/main.html","<div class=\"vm-wrap\" ng-style=\"highVMCount && {\'display\': \'inline-block\'}\">\r\n    <span class=\"trippart\" ng-repeat=\"(key, value) in vmView\">\r\n        <vvs-icon product-icon-id=\"{{key}}\"></vvs-icon>\r\n        <span class=\"vm-font vm-item\">\r\n            <ng-content ng-repeat=\"el in value\">\r\n                <ng-content ng-if=\"!$last\">\r\n                    {{el}},\r\n                 </ng-content>\r\n                 <ng-content ng-if=\"$last\">\r\n                     {{el}}\r\n                 </ng-content>\r\n            </ng-content>\r\n        </span>\r\n    </span>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/dm/init/dm.html","<form ng-submit=\"triggerFireDMClick()\" novalidate>\r\n    <div class=\"input-wrap-xs infocus col-xs-12 pl-0 pr-0 wrap-xs\">\r\n        <!-- alerts -->\r\n        <vvs-alert ng-if=\"errorMessages.length>0\" messages=\"errorMessages\"></vvs-alert>\r\n        <vvs-alert ng-if=\"dmAlert\" text=\"\'Bitte geben Sie einen Ort, Haltestelle, Adresse oder POI für die Abfahrt/Ankunft ein!\'\"></vvs-alert>\r\n        <!-- odv from -->\r\n        <vvs-location-odv usage=\"dm\"></vvs-location-odv>\r\n        <vvs-include vvs-src=\"odv/controls/main.html\"></vvs-include>\r\n      </div>\r\n      <!-- include mobile date picker-->\r\n      <vvs-include vvs-src=\"odv/date/mobile.html\"></vvs-include>\r\n\r\n      <div class=\"ctblock col-xs-12 nopadding-xs padding-sm  spacerbottomlarge\" role=\"group\" aria-label=\"anfordern\">\r\n          <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n              <button type=\"submit\" class=\"search-btn btn btn-primary btn-block\">{{\'Suchen\' | translate}}</button>\r\n          </div>\r\n      </div>\r\n      <!-- include assigned stops box -->\r\n      <vvs-assigned-stops location=\"inputLocations.dm\" usage=\"\'dm\'\" ng-if=\"inputLocations.dm.assignedStops().length>1\"></vvs-assigned-stops>\r\n\r\n      <!-- include history box -->\r\n      <ng-container ng-hide=\"inputLocations.dm.assignedStops().length > 1\" >\r\n          <vvs-history mode=\"location\" usage=\"dm\"></vvs-history>\r\n      </ng-container>\r\n</form>");
$templateCache.put("app/vvs.components/dm/init/main.html","\r\n    <div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n\r\n\r\n          <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n    </div>\r\n\r\n\r\n<style>\r\n    md-pagination-wrapper.md-center-tabs {\r\n        position: relative;\r\n        justify-content: space-between;\r\n    }\r\n    md-tabs.md-primary>md-tabs-wrapper {\r\n        background-color: #fff;\r\n    }\r\n\r\n    @media (min-width: 960px) {\r\n    .tabsdemoCenterTabs md-tab-item {\r\n        min-width: 160px;\r\n    }\r\n    }\r\n</style>\r\n");
$templateCache.put("app/vvs.components/dm/lines/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content dm-stopsxs-12 nopadding-xs\">\r\n    <div class=\"col-xs-12 nopadding-xs\">\r\n        <vvs-alert ng-if=\"errorMessages.length>0\" messages=\"errorMessages\"></vvs-alert>\r\n        <div class=\"infoarea clearfix\">\r\n            <div class=\"col-xs-12\">\r\n                <div class=\"pull-left text-left\">\r\n                    <p>{{inputLocations.dm|VVSLocationNameFormatter}}\r\n                        <br> {{SEARCH_OPTIONS.dateTime.date | VVSSummaryDateFormatter}}, {{SEARCH_OPTIONS.dateTime.isDeparture?(\"Abfahrt\"|translate):(\"Ankunft\"|translate)}} <span class=\"time\">{{SEARCH_OPTIONS.dateTime.time|VVSTimeFormatter}} {{\'Uhr\'|translate}}</span></p>\r\n                </div>\r\n                <!-- <div class=\"pull-right text-right\">\r\n                    <a href=\"javascript:void(0)\" vvs-modal vvs-modal-template=\"dm/modals/stop.html\" vvs-modal-size=\"sm\" title=\"{{\'Haltestelleninformation\'}}\">\r\n                        <vvs-icon type=\"{{inputLocations.dm.type()}}\"></vvs-icon>\r\n                    </a>\r\n                </div> -->\r\n            </div>\r\n            <div class=\"col-sm-12 col-xs-12 flexStyle vm\" style=\"justify-content: left;\">\r\n                <!-- verkehrsmittel -->\r\n                <div class=\"trip-list col-sm-7 col-xs-12 nopadding-md\">\r\n                    <span class=\"trippart\" ng-repeat=\"(key, value) in sortedResult\" ng-if=\"value.length>0\">\r\n                        <ng-content>\r\n                            <vvs-icon product-icon-id=\"{{value[0][\'productId\']}}\"></vvs-icon>\r\n                        </ng-content>\r\n                        <span ng-repeat=\"el in value\">\r\n                            <ng-content ng-if=\"!$last\">\r\n                                <span>{{el.number}},</span>\r\n                            </ng-content>\r\n                            <ng-content ng-if=\"$last\">\r\n                                <span>{{el.number}}</span>\r\n                            </ng-content>\r\n                        </span>\r\n                    </span>\r\n                </div>\r\n                <div class=\"col-sm-5 col-xs-12 nopadding-xs change-trip-buttons\">\r\n                    <div class=\"btn-group flex flexalignRight\" role=\"group\" aria-label=\"...\">\r\n                        <div class=\"btn-group\" role=\"group\">\r\n                            <button type=\"button\" class=\"btn btn-link\" vvs-modal vvs-modal-template=\"dm/modals/filter.html\" vvs-modal-size=\"md\" title=\"{{\'Suchoptionen ändern\'|translate}}\">\r\n                            <!-- <button type=\"button\" class=\"btn btn-link\" vvs-modal vvs-modal-template=\"dm/modals/linefilter.html\" vvs-modal-size=\"md\" title=\"{{\'Suchoptionen ändern\'|translate}}\"> -->\r\n                                <vvs-icon name=\"aendern\"></vvs-icon> <span class=\"xs-none\">{{\'Linienfilter\' | translate}}</span>\r\n                            </button>\r\n                        </div>\r\n                        <div class=\"btn-group\" role=\"group\">\r\n                            <button type=\"button\" class=\"btn btn-link\" vvs-modal vvs-modal-template=\"dm/modals/refresh.html\" vvs-modal-size=\"sm\" title=\"{{\'Uhrzeit aktualisieren\'|translate}}\">\r\n                                <vvs-icon name=\"aktualisieren\"></vvs-icon> <span class=\"xs-none\">{{\'Aktualisieren\' | translate}}</span>\r\n                            </button>\r\n                        </div>\r\n                        <div class=\"btn-group\" role=\"group\">\r\n                            <button type=\"button\" class=\"btn btn-link\" ng-click=\"triggerDMChangeClick()\" title=\"{{\'Neue Abfahrten berechnen\'|translate}}\">\r\n                                <vvs-icon name=\"neuefahrt\"></vvs-icon> <span class=\"xs-none\">{{\'Neu\'|translate}}</span>\r\n                            </button>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"clearfix change-trip-time padding\">\r\n            <div class=\"pull-left text-left\">\r\n                <button type=\"button\" class=\"btn btn-link\" ng-click=\"triggerDMPreviousClick()\" ng-if=\"!SEARCH_OPTIONS.dateTime.isDeparture\" title=\"{{\'frühere Ankünfte berechnen\'|translate}}\">\r\n                    <span class=\"pull-left text-left\"><vvs-icon name=\"up\"></vvs-icon> {{\'Früher\' | translate}} </span>\r\n                </button>\r\n            </div>\r\n            <div class=\"pull-right text-right\">\r\n                <button type=\"button\" class=\"btn btn-link\" ng-click=\"triggerDMNextClick()\" ng-if=\"SEARCH_OPTIONS.dateTime.isDeparture\" title=\"{{\'spätere Abfahrten berechnen\'|translate}}\">\r\n                    <span class=\"pull-right text-right\"> {{\'Später\' | translate}} <vvs-icon name=\"down\"></vvs-icon></span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n        <table class=\"table monitor nomargin\">\r\n            <colgroup>\r\n                <col width=\"3%\">\r\n                <col width=\"16%\">\r\n                <col width=\"20%\">\r\n                <col width=\"36%\">\r\n                <col width=\"11%\">\r\n                <col width=\"9%\">\r\n                <col width=\"5%\">\r\n            </colgroup>\r\n            <thead>\r\n                <tr class=\"visible-md visible-lg\">\r\n                    <th></th>\r\n                    <th>{{\'Uhrzeit\' | translate}}</th>\r\n                    <th>{{\'Linie\' | translate}}</th>\r\n                    <th><span ng-if=\"!SEARCH_OPTIONS.dateTime.isDeparture\">{{\'aus\'|translate}} </span>{{\'Richtung\' | translate}}</th>\r\n                    <!-- <th>{{\'Auslastung\'}}</th> -->\r\n                    <th class=\"text-center\">{{\'Gleis / Steig\' | translate}}</th>\r\n                    <th class=\"text-center\"></th>\r\n                    <th></th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-repeat=\"depArr in dmObj.depArrs|VVSDMLinesFilter:dmObj.linesFilter\" ng-hide=\"depArr.hideInDmList\">\r\n                <!-- <tr ng-repeat=\"depArr in dmObj.depArrs|VVSDMLinesFilter:dmObj.linesFilter\" ng-hide=\"depArr.hideInDmList\" ng-if=\"depArr.isAbonated\"> -->\r\n                    <td>\r\n                        <vvs-real-time-icon mode=\"\'depArr\'\" dep-arr=\"depArr\"></vvs-real-time-icon>\r\n                    </td>\r\n                    <td>\r\n                        {{depArr.dateTimePlanned()|VVSTimeFormatter}}\r\n                        <br ng-if=\"depArr.delay()>0\">\r\n                        <span class=\"late\" ng-if=\"depArr.delay()>0\">{{depArr.dateTimeEstimated()|VVSTimeFormatter}}</span>\r\n                        <span class=\"late\" ng-if=\"depArr.isCancelled()\"><br>{{\'Ausf.\'|translate}}</span>\r\n                    </td>\r\n                    <td>\r\n                        <span title=\"{{depArr.transportation().name()}}\">\r\n                            <vvs-icon product-icon-id=\"{{depArr.transportation().productIconId()}}\"></vvs-icon> <strong>{{depArr.transportation().number()}}</strong>\r\n                        </span>\r\n                    </td>\r\n                    <td>\r\n                        <p ng-if=\"SEARCH_OPTIONS.dateTime.isDeparture\" class=\"hideme\" title=\"{{depArr.transportation().routeDescription()}}\">{{depArr.transportation().destination() | VVSLocationNameFormatter}}</p>\r\n                        <p ng-if=\"!SEARCH_OPTIONS.dateTime.isDeparture\" class=\"hideme\" title=\"{{depArr.transportation().routeDescription()}}\">{{depArr.transportation().origin() | VVSLocationNameFormatter}}</p>\r\n\r\n                        <div ng-if=\"depArr.transportation().productName() === \'Ruftaxi\'\" class=\"hints\">\r\n                            <vvs-icon name=\"meldungen\"></vvs-icon>\r\n                            <div class=\"subinfo\" ng-repeat=\"hint in depArr.hints()\">\r\n                                <span ng-bind-html=\"hint|VVSHintFormatter\"></span>\r\n                            </div>\r\n                        </div>\r\n                    </td>\r\n                    <!-- <td>\r\n                        <vvs-occ dm=\"depArr.location().properties()\"></vvs-occ>\r\n                    </td> -->\r\n                    <td class=\"text-center\">\r\n                        <span ng-if=\"depArr.location().type()===\'platform\'\">{{depArr.location().disassembledName(true)}}</span>\r\n                    </td>\r\n                    <td class=\"text-center\">\r\n                        <a href=\"javascript:void(0)\" vvs-modal vvs-modal-template=\"dm/modals/lines.html\" title=\"{{\'Linienverlauf anzeigen\'|translate}}\">\r\n                            <vvs-icon name=\"linien\"></vvs-icon>\r\n                        </a>\r\n                    </td>\r\n                    <td class=\"meldung\">\r\n                        <vvs-infos mode=\"dm\" dep-arr=\"depArr\"></vvs-infos>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n        <!-- <div class=\"clearfix change-trip-time\">\r\n            <div class=\"pull-left text-left\">\r\n                <button type=\"button\" class=\"btn btn-link\" ng-click=\"triggerDMPreviousClick()\" ng-if=\"!SEARCH_OPTIONS.dateTime.isDeparture\" title=\"{{\'frühere Ankünfte berechnen\'|translate}}\">\r\n                    <span class=\"pull-left text-left\"><vvs-icon name=\"up\"></vvs-icon> {{\'Früher\' | translate}} </span>\r\n                </button>\r\n            </div>\r\n            <div class=\"pull-right text-right\">\r\n                <button type=\"button\" class=\"btn btn-link\" ng-click=\"triggerDMNextClick()\" ng-if=\"SEARCH_OPTIONS.dateTime.isDeparture\" title=\"{{\'spätere Abfahrten berechnen\'|translate}}\">\r\n                    <span class=\"pull-right text-right\"> {{\'Später\' | translate}} <vvs-icon name=\"down\"></vvs-icon></span>\r\n                </button>\r\n            </div>\r\n        </div> -->\r\n        <!-- <button type=\"button\" class=\"btn btn-default btn-block btn-label padding mb15\" vvs-modal vvs-modal-template=\"dm/modals/filter.html\" title=\"{{\'Linienfilter öffnen\'|translate}}\">\r\n            <a href=\"javascript:void()\">\r\n                <div class=\"pull-left text-left\">\r\n                    {{\'Linien auswählen\' | translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </a>\r\n        </button> -->\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/dm/modals/filter.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Linienauswahl\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\" ng-controller=\"VVSDMModalsFilterController\" ng-init=\"groupedLines=(dmObj.depArrs|VVSDMGroupedDepArrs)\">\r\n        <ul class=\"list-group list-toggle nomargin spacertoplarge\">\r\n            <li class=\"list-group-item list-group-header header-standalone\">{{\'Alle Linien\'|translate}}\r\n                <md-switch aria-label=\"Alle Linien\" ng-model=\"allLines\" ng-change=\"triggerSwitchAllLines(allLines)\"></md-switch>\r\n            </li>\r\n        </ul>\r\n        <ul class=\"list-group list-toggle\" ng-class=\"{\'nomargin\' : !$last}\" ng-repeat=\"(key, lines) in groupedLines\" ng-init=\"ordredLines=(lines|VVSDMOrderLines)\">\r\n            <li class=\"list-group-item list-group-header noborder\">\r\n                <strong>{{key}}</strong>\r\n                <md-switch aria-label=\"{{dmObj.linesFilter[key]}}\" ng-model=\"dmObj.linesFilter[key].enabled\" ng-change=\"triggerSwitchLinesCategory(key)\"></switch>\r\n            </li>\r\n            <li class=\"list-group-item\" ng-repeat=\"line in ordredLines\">\r\n                <vvs-icon product-icon-id=\"{{line.transportation().productIconId()}}\"></vvs-icon> <strong>{{line.transportation().number()}}</strong> {{line.transportation().destination() | VVSLocationNameFormatter}} <md-switch aria-label=\"{{dmObj.linesFilter[key].lines[line.transportation().id()]}}\" ng-model=\"dmObj.linesFilter[key].lines[line.transportation().id()].enabled\" ng-change=\"triggerSwitchLine(key)\" class=\"vvs-orange\"></switch>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/dm/modals/linefilter.html","<div>\r\n  <div class=\"modal-header\">\r\n      <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n      </button>\r\n      <h4 class=\"modal-title\" id=\"modal-label\">\r\n          {{\'Linienauswahl\' | translate}}\r\n      </h4>\r\n  </div>\r\n  <div\r\n      class=\"modal-body nopadding-xs ctblock drilldown\"\r\n      ng-controller=\"VVSDMModalsLineFilterController as ctrl\"\r\n  >\r\n      <ul  class=\"drilldown-root\">\r\n        <li>\r\n          <ul class=\"list-group list-toggle attached nomargin\">\r\n              <li class=\"list-group-item no-icon\">{{\'Alle Linien\' | translate}}\r\n                  <md-switch aria-label=\"Alle Linien\" ng-model=\"filter.allLines\" ng-change=\"triggerSelectAllLInes()\"></md-switch>\r\n              </li>\r\n          </ul>\r\n        </li>\r\n      </ul>\r\n      <div ng-repeat=\"(key, value) in filteredRes\">\r\n        <p>{{ key }}</p>\r\n        <ul class=\"list-group list-toggle attached nomargin\" ng-repeat=\"dep in value\">\r\n            <li class=\"list-group-item no-icon\">\r\n              <span>{{ dep.transportation().number() }}</span>\r\n              <span>{{ dep.transportation().destination().name() }}</span>\r\n              <md-switch aria-label=\"Alle Linien\" ng-model=\"dep.isAbonated\" ng-change=\"triggerSelectLine(dep)\"></md-switch>\r\n            </li>\r\n        </ul>\r\n      </div>\r\n  </div>\r\n</div>");
$templateCache.put("app/vvs.components/dm/modals/lines.html","<div>\r\n    <div class=\"modal-header high\" ng-controller=\"VVSDMModalsLinesController as VVSDMModalsLinesCtrl\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title {{depArr.transportation().productIconId()|VVSProductIconIdMapper}}\" id=\"modal-label\">{{depArr.transportation().number()}} {{\'Richtung\'|translate}} {{depArr.transportation().destination() | VVSLocationNameFormatter}}<br>{{\'Aktuelle Uhrzeit\'|translate}} <strong>{{VVSDMModalsLinesCtrl.currentDate | VVSTimeFormatter}}</strong></h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <div class=\"trip-container spacertoplarge\" ng-init=\"tabIndex=0\">\r\n            <md-tabs md-dynamic-height md-border-bottom class=\"nav nav-tabs\">\r\n                <md-tab ng-click=\"tabIndex=0\">\r\n                    <md-tab-label>\r\n                        <vvs-icon name=\"perlschnur\"></vvs-icon> {{\'Perlschnur\' | translate}}\r\n                    </md-tab-label>\r\n                    <md-tab-body>\r\n                        <vvs-perlschnur transportation=\"depArr.transportation()\" date=\"SEARCH_OPTIONS.dateTime.date\"></vvs-perlschnur>\r\n                    </md-tab-body>\r\n                </md-tab>\r\n                <md-tab ng-click=\"tabIndex=1\">\r\n                    <md-label>\r\n                        <vvs-icon name=\"karte\"></vvs-icon> {{\'Karte\' | translate}}\r\n                    </md-label>\r\n                    <md-tab-body>\r\n                        <vvs-map mode=\"\'line\'\" line=\"depArr.transportation()\" location=\"depArr.location()\" date=\"SEARCH_OPTIONS.dateTime.date\" zoom-level=\"1\" load-on=\"{{tabIndex==1}}\"></vvs-map>\r\n                    </md-tab-body>\r\n                </md-tab>\r\n            </md-tabs>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/dm/modals/refresh.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Aktualisieren\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\" ng-controller=\"VVSDMModalsRefreshController\">\r\n        <h2>{{\'Neue Anfrage berechnen\' | translate}}</h2>\r\n        <div class=\"modal-block spacerbottomlarge\">\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit angefragter Uhrzeit\" role=\"group\">\r\n                <div class=\"btn-group \" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"triggerRefreshWithSameTimeClick(); dismissModal()\">{{\'mit angefragter Uhrzeit\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n            <br>\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"triggerRefreshWithCurrentTimeClick(); dismissModal()\">{{\'mit aktueller Uhrzeit\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/dm/modals/stop.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title {{inputLocations.dm.type()|VVSDMLocationClassMapping}}\"> {{inputLocations.dm | VVSLocationNameFormatter}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\" ng-controller=\"VVSDMModalsStopController\" ng-init=\"groupedLines=(dmObj.depArrs|VVSDMGroupedDepArrs)\">\r\n        <h2 class=\"hicon {{lines[0].transportation().productIconId()|VVSProductIconIdMapper}}\" ng-repeat=\"(key, lines) in groupedLines\" ng-init=\"ordredLines=(lines|VVSDMOrderLines)\"> <span ng-repeat=\"line in ordredLines|unique:\'transportation().number()\'\">{{line.transportation().number()}}<span ng-if=\"!$last\">, </span></span></h2>\r\n        <div class=\"linklist separator-top\">\r\n            <a href=\"javascript:void(0)\" title=\"{{\'Stadtplanausschnitt\'|translate}}\" ng-click=\"triggerDownloadROPClick(inputLocations.dm)\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon> {{\'Stadtplanausschnitt\'|translate}}\r\n            </a>\r\n\r\n            <div ng-repeat=\"file in inputLocations.dm.downloads()\" ng-switch on=\"file.type()\">\r\n                <a ng-switch-when=\"SM\" href=\"javascript:void(0)\" title=\"{{\'Haltestellenkarte\'|translate}}\" ng-click=\"triggerDownloadSMClick(file)\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon> {{\'Haltestellenkarte\'|translate}}\r\n                </a>\r\n                <a ng-switch-when=\"SM_ME\" href=\"javascript:void(0)\" title=\"{{\'Haltestellenkarte f. Mobilitätseingeschränkte\'|translate}}\" ng-click=\"triggerDownloadSMMEClick(file)\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon> {{\'Haltestellenkarte f. Mobilitätseingeschränkte\'|translate}}\r\n                </a>\r\n            </div>\r\n            <a href=\"javascript:void(0)\" ng-click=\"openStopInformation(inputLocations.dm)\" title=\"{{\'Haltestelleninformationen\'|translate}}\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon> {{\'Haltestelleninformationen\'|translate}}\r\n            </a>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/info/disruption/details.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\" ng-if=\"info\">\r\n    <div class=\"ctblock col-xs-12 spacertop\">\r\n        <div ng-repeat=\"(productIconId, lines) in info.affectedLines()|groupBy:\'productIconId()\'\">\r\n            <h2 class=\"hicon {{productIconId|VVSProductIconIdMapper}} meldungen\"> <span ng-repeat=\"line in lines|unique:\'number()\'\">{{line.number()}}<span ng-if=\"!$last\">, </span></span></h2>\r\n        </div>\r\n        <p class=\"info spacerbottomlarge\" ng-init=\"formattedValidityFrom=(info.validityFrom()|VVSDateFormatter);formattedValidityTo=(info.validityTo()|VVSDateFormatter);\" ng-switch on=\"formattedValidityTo\">\r\n            <span ng-if=\"formattedValidityFrom!=formattedValidityTo\">{{\'Vom\'|translate}} {{formattedValidityFrom}} {{\'bis\'|translate}} <span ng-switch-when=\"31.12.2500\">{{\'auf Weiteres\'|translate}}</span><span ng-switch-default>{{formattedValidityTo}}</span></span>\r\n            </br>\r\n            <strong ng-if=\"info.subtitle()\">{{info.subtitle()}}</br></br></strong>\r\n            <span ng-bind-html=\"info.content()|VVSSafeHTML\"></span>\r\n        </p>\r\n        <p class=\"info\">\r\n            <p class=\"info\" ng-if=\"info.type()!==\'routeBlocking\'\"\r\n                ng-init=\"efaRealised = (info.properties().RealisedInEFAUnplanned === \'1\') || (info.properties().RealisedInEFAUnplanned === \'true\')\"\r\n            >\r\n                <span ng-if=\"!efaRealised\">{{\'Nicht\'|translate}} </span>{{\'In EFA erfasst\'|translate}}</br>\r\n            </p>\r\n            <span ng-if=\"info.creation()\">{{\'Stand\'|translate}} {{info.creation()|VVSDateFormatter}} {{info.creation()|VVSTimeFormatter}}</br></br></span>\r\n        </p>\r\n    </div>\r\n    <div class=\"ctblock buttonlist col-xs-12 nopadding-xs\" role=\"group\">\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.disruption\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Störungen Übersicht\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.init\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Meldungen\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/info/disruption/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 nopadding-xs spacerbottomlarge spacertoplarge\">\r\n        <div class=\"ctblock buttonlist col-xs-12 nopadding-xs\" role=\"group\" aria-label=\"Störungen\">\r\n            <vvs-alert ng-if=\"infos.length==0\" text=\"\'Es liegen aktuell keine Störungen vor. Wir wünschen eine gute Fahrt.\'\"></vvs-alert>\r\n            <button type=\"button\" class=\"btn btn-block btn-larger btn-notice\" ng-repeat=\"info in infos track by $index\" ui-sref=\"vvs.info.disruptionDetails({info: info})\">\r\n                <div class=\"pull-left text-left\">\r\n                    <div ng-class=\"{\'state-normal\': (info.priority()===\'normal\'), \'state-alert\': (info.priority()!==\'normal\')}\"></div>\r\n                </div>\r\n                <div class=\"pull-left text-left middle-text\" ng-init=\"formattedValidityFrom=(info.validityFrom()|VVSDateFormatter);formattedValidityTo=(info.validityTo()|VVSDateFormatter);\" ng-switch on=\"formattedValidityTo\">\r\n                    <div ng-repeat=\"(productIconId, lines) in info.affectedLines()|groupBy:\'productIconId()\'\">\r\n                        <vvs-icon product-icon-id=\"{{productIconId}}\"></vvs-icon> <span ng-repeat=\"line in lines|unique:\'number()\'\">{{line.number()}}<span ng-if=\"!$last\">, </span></span>\r\n                    </div>\r\n                    <span class=\"textsmall\" ng-if=\"formattedValidityFrom!=formattedValidityTo\">{{\'Vom\'|translate}} {{formattedValidityFrom}} {{\'bis\'|translate}} <span ng-switch-when=\"31.12.2500\">{{\'auf Weiteres\'|translate}}</span><span ng-switch-default>{{formattedValidityTo}}</span></span>\r\n                    <span class=\"textsmall\" ng-if=\"formattedValidityFrom==formattedValidityTo\">{{\'Am\'|translate}} {{formattedValidityFrom}}</span>\r\n                    <br>\r\n                    <div class=\"hideme\">\r\n                        <span class=\"textsmall\">{{info.subtitle()}}</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n            <p class=\"info spacertoplarge\"><strong>{{\'Sie vermissen hier die Information zu einer Störung?\'|translate}}</strong>\r\n                <br> {{\'Leider sind nicht immer alle Störungen erfasst. Mehr Informationen hierzu\'|translate}} <a style=\"text-decoration:underline;\" href=\"http://www.vvs.de/aktuelles/verkehrsmeldungen/allgemeine-informationen/\">{{\'finden Sie hier\'|translate}}</a>.\r\n            </p>\r\n        </div>\r\n    </div>\r\n    <div class=\"ctblock buttonlist col-xs-12 nopadding-xs\" role=\"group\">\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.init\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Meldungen\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n    <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/info/escalatorElevator/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <vvs-alert ng-if=\"infos.length==0\" text=\"\'Es liegen aktuell keine Meldungen vor. Wir wünschen eine gute Fahrt.\'\"></vvs-alert>\r\n\r\n        <p class=\"info spacerbottom\">{{\'Hier finden Sie eine Übersicht der Meldungen der DB Station&Service AG zum Betriebszustand der Aufzüge und der Rolltreppen bei S- und R-Bahn.\'|translate}}</p>\r\n\r\n        <div class=\"ctblock\" ng-repeat=\"info in infos track by $index\">\r\n            <p class=\"info nomargin\" ng-init=\"formattedValidityFrom=(info.validityFrom()|VVSDateFormatter);formattedValidityTo=(info.validityTo()|VVSDateFormatter);\" ng-switch on=\"formattedValidityTo\">\r\n                <span ng-if=\"formattedValidityFrom!=formattedValidityTo\">{{\'Vom\'|translate}} {{formattedValidityFrom}} {{\'bis\'|translate}} <span ng-switch-when=\"31.12.2500\">{{\'auf Weiteres\'|translate}}</span><span ng-switch-default>{{formattedValidityTo}}</span></span>\r\n            </p>\r\n\r\n            <!--<p class=\"info nomargin\" ng-if=\"(info.validityTo()|VVSDateFormatter)==\'31.12.2500\'\">{{\'Am\'|translate}} {{info.validityFrom()|VVSDateFormatter}}</p>-->\r\n            <h2 class=\"nopadding meldungen nomargin\">{{info.title()}}</h2>\r\n            <p class=\"info nomargin\" ng-bind-html=\"info.content()|VVSSafeHTML\">\r\n\r\n            </p>\r\n            <p class=\"small\">{{\'Stand\'|translate}} {{info.creation()|VVSDateFormatter}} {{info.creation()|VVSTimeFormatter}}</p>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"ctblock buttonlist col-xs-12 nopadding-xs\" role=\"group\">\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.init\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Meldungen\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/info/general/details.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\" ng-if=\"info\">\r\n    <div class=\"ctblock col-xs-12 spacertop\">\r\n        <div ng-repeat=\"(productIconId, lines) in info.affectedLines()|groupBy:\'productIconId()\'\">\r\n            <h2 class=\"hicon {{productIconId|VVSProductIconIdMapper}} meldungen\"> <span ng-repeat=\"line in lines|unique:\'number()\'\">{{line.number()}}<span ng-if=\"!$last\">, </span></span></h2>\r\n        </div>\r\n        <p class=\"info spacerbottomlarge\" ng-init=\"formattedValidityFrom=(info.validityFrom()|VVSDateFormatter);formattedValidityTo=(info.validityTo()|VVSDateFormatter);\" ng-switch on=\"formattedValidityTo\">\r\n            <span ng-if=\"formattedValidityFrom!=formattedValidityTo\">{{\'Vom\'|translate}} {{formattedValidityFrom}} {{\'bis\'|translate}} <span ng-switch-when=\"31.12.2500\">{{\'auf Weiteres\'|translate}}</span><span ng-switch-default>{{formattedValidityTo}}</span></span>\r\n            </br>\r\n            <strong ng-if=\"info.subtitle()\">{{info.subtitle()}}</br></br></strong>\r\n            <span ng-bind-html=\"info.content()|VVSSafeHTML\"></span>\r\n\r\n        </p>\r\n        <p class=\"info\">\r\n            <p class=\"info\"\r\n                ng-init=\"efaRealised = (info.properties().RealisedInEFAUnplanned === \'1\') || (info.properties().RealisedInEFAUnplanned === \'true\')\"\r\n            >\r\n                <span ng-if=\"!efaRealised\">{{\'Nicht\'|translate}} </span>{{\'In EFA erfasst\'|translate}}</br>\r\n            </p>\r\n            <span ng-if=\"info.creation()\">{{\'Stand\'|translate}} {{info.creation()|VVSDateFormatter}} {{info.creation()|VVSTimeFormatter}}</span>\r\n        </p>\r\n    </div>\r\n    <div class=\"ctblock buttonlist col-xs-12 nopadding-xs padding-md\" role=\"group\">\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.general\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Allgemeine Informationen\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.init\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Meldungen\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/info/general/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 nopadding-xs spacerbottomlarge spacertoplarge\">\r\n        <div class=\"ctblock buttonlist col-xs-12 nopadding-xs padding-md\" role=\"group\" aria-label=\"Störungen\">\r\n            <vvs-alert ng-if=\"infos.length==0\" text=\"\'Es liegen aktuell keine Meldungen vor. Wir wünschen eine gute Fahrt.\'\"></vvs-alert>\r\n            <button type=\"button\" class=\"btn btn-block btn-larger btn-notice\" ng-repeat=\"info in infos track by $index\" ui-sref=\"vvs.info.generalDetails({info: info})\">\r\n                <div class=\"pull-left text-left\">\r\n                    <div ng-class=\"{\'state-normal\': (info.priority()===\'normal\'), \'state-alert\': (info.priority()!==\'normal\')}\"></div>\r\n                </div>\r\n                <div class=\"pull-left text-left middle-text\" ng-init=\"formattedValidityFrom=(info.validityFrom()|VVSDateFormatter);formattedValidityTo=(info.validityTo()|VVSDateFormatter);\" ng-switch on=\"formattedValidityTo\">\r\n                    <div ng-repeat=\"(productIconId, lines) in info.affectedLines()|groupBy:\'productIconId()\'\">\r\n                        <vvs-icon product-icon-id=\"{{productIconId}}\"></vvs-icon> <span ng-repeat=\"line in lines|unique:\'number()\'\">{{line.number()}}<span ng-if=\"!$last\">, </span></span>\r\n                    </div>\r\n                    <span class=\"textsmall\" ng-if=\"formattedValidityFrom!=formattedValidityTo\">{{\'Vom\'|translate}} {{formattedValidityFrom}} {{\'bis\'|translate}} <span ng-switch-when=\"31.12.2500\">{{\'auf Weiteres\'|translate}}</span><span ng-switch-default>{{formattedValidityTo}}</span></span>\r\n                    <span class=\"textsmall\" ng-if=\"formattedValidityFrom==formattedValidityTo\">{{\'Am\'|translate}} {{formattedValidityFrom}}</span>\r\n                    <br>\r\n                    <div class=\"hideme\">\r\n                        <span class=\"textsmall\">{{info.subtitle()}}</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n        </div>\r\n    </div>\r\n    <div class=\"ctblock buttonlist col-xs-12 nopadding-xs padding-md\" role=\"group\">\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.init\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Meldungen\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n    <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/info/init/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <!-- Nur Mobil sichtbar-->\r\n    <h2 class=\"function-header visible-xs padding-wrap\">{{\'Meldungen\'|translate}}</h2>\r\n    <div class=\"ctblock col-xs-12 nopadding-xs visible-xs spacerbottomlarge\">\r\n        <div class=\"ctblock buttonlist col-xs-12 nopadding-xs\" role=\"group\" aria-label=\"Linienauswahl\">\r\n            <!--<button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.news\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    <vvs-icon name=\"aktuelles\"></vvs-icon> {{\'Aktuelles\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>-->\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" onclick=\"window.location.href=\'https://www.vvs.de/fahrplan/mobilefahrplanauskunft/benachrichtigungsservice/\'\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    <vvs-icon name=\"fragezeichen\"></vvs-icon>\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.general\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    <vvs-icon name=\"aktuelles\"></vvs-icon> {{\'Allgemeine Meldungen\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.disruption\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    <vvs-icon name=\"stoerungsmeldung\"></vvs-icon> {{\'Störungen\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.timetableChange\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    <vvs-icon name=\"fpaenderungen\"></vvs-icon> {{\'Fahrplanänderungen\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.escalatorElevator\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    <vvs-icon name=\"aufzugsmeldung-vvs\"></vvs-icon> {{\'Aufzüge und Zugänge\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.specialTraffic\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    <vvs-icon name=\"sonderverkehre\"></vvs-icon> {{\'Sonderverkehre\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n        </div>\r\n    </div>\r\n    <!-- Nur auf Desktop sichtbar-->\r\n    <h2 class=\"function-header hidden-xs padding-wrap\">{{\'Meldungen\'|translate}}</h2>\r\n    <div class=\"ctblock col-xs-12 hidden-xs spacerbottomlarge\">\r\n        <div class=\"ctblock buttonlist col-xs-12 nopadding-sm\" role=\"group\" aria-label=\"Linienauswahl\">\r\n            <!--<button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.news\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    <vvs-icon name=\"aktuelles\"></vvs-icon> {{\'Aktuelles\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>-->\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" onclick=\"window.location.href=\'https://www.vvs.de/fahrplan/mobilefahrplanauskunft/benachrichtigungsservice/\'\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    <vvs-icon name=\"fragezeichen\"></vvs-icon>\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.general\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    <vvs-icon name=\"aktuelles\"></vvs-icon> {{\'Allgemeine Meldungen\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.disruption\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    <vvs-icon name=\"stoerungsmeldung\"></vvs-icon> {{\'Störungen\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.timetableChange\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    <vvs-icon name=\"fpaenderungen\"></vvs-icon> {{\'Fahrplanänderungen\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.escalatorElevator\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    <vvs-icon name=\"aufzugsmeldung-vvs\"></vvs-icon> {{\'Aufzüge und Zugänge\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.specialTraffic\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    <vvs-icon name=\"sonderverkehre\"></vvs-icon> {{\'Sonderverkehre\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n        </div>\r\n    </div>\r\n    <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/info/news/details.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <h2 class=\"function-header hidden-xs hidden-sm spacertoplarge\">{{info.title}}</h2>\r\n        <p class=\"info\">\r\n            <img ng-repeat=\"img in info.images\" src=\"{{img}}\" width=\"100%\"/>\r\n            <img ng-if=\"info.images.length===0\" ng-repeat=\"img in info.teaserimages\" src=\"{{img}}\"/>\r\n        </p>\r\n        <p class=\"info\">\r\n            {{info.teaser}}\r\n        </p>\r\n    </div>\r\n    <div class=\"col-xs-12\">\r\n        <p class=\"info\" ng-bind-html=\"info.content|VVSSafeHTML\"></p>\r\n    </div>\r\n    <div class=\"ctblock buttonlist col-xs-12 nopadding-xs padding-md\" role=\"group\">\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.news\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Aktuelles Übersicht\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.init\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Meldungen\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n    <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/info/news/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock buttonlist col-xs-12 nopadding-xs padding-md spacerbottomlarge spacertoplarge\" role=\"group\" aria-label=\"Störungen\">\r\n        <button type=\"button\" class=\"btn btn-block btn-larger btn-notice nopadding\" ng-repeat=\"info in infos track by $index\" ui-sref=\"vvs.info.newsDetails({info: info})\">\r\n            <div class=\"pull-left text-left middle-text\">\r\n                <div><span>{{info.title}}</span></div>\r\n                <div class=\"hideme\">\r\n                    <span class=\"textsmall\">{{info.teaser}}</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n    <div class=\"ctblock buttonlist col-xs-12 nopadding-xs padding-md\" role=\"group\">\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.init\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Meldungen\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n    <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/info/specialTraffic/details.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\" ng-if=\"info\">\r\n    <div class=\"ctblock col-xs-12 spacertop\">\r\n        <h2 class=\"nopadding meldungen\">{{info.title()}}</h2>\r\n        <p class=\"info\" ng-init=\"formattedValidityFrom=(info.validityFrom()|VVSDateFormatter);formattedValidityTo=(info.validityTo()|VVSDateFormatter);\" ng-switch on=\"formattedValidityTo\">\r\n            <span ng-if=\"formattedValidityFrom!=formattedValidityTo\">{{\'Vom\'|translate}} {{formattedValidityFrom}} {{\'bis\'|translate}} <span ng-switch-when=\"31.12.2500\">{{\'auf Weiteres\'|translate}}</span><span ng-switch-default>{{formattedValidityTo}}</span></span>\r\n            <span ng-if=\"formattedValidityFrom==formattedValidityTo\">{{\'Am\'|translate}} {{formattedValidityFrom}}</span>\r\n            <br>\r\n            {{info.urlText()}} {{info.properties().location|VVSInfoCleanLocationName}}</span>\r\n            <span ng-if=\"info.properties().combiTicket===\'1\'\">\r\n                <br/>\r\n                <br/>\r\n                <a href=\"http://www.vvs.de/no_cache/tickets/sondertickets/kombiticket/\" target=\"_blank\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon> {{\'Kombiticket\'|translate}}\r\n                </a>\r\n            </span>\r\n        </p>\r\n    </div>\r\n    <div class=\"col-xs-12\">\r\n        <p class=\"info spacerbottomlarge\" ng-bind-html=\"info.content()|VVSInfoSpecialTraficLogo|VVSSafeHTML\"></p>\r\n        <!--<p class=\"info\">\r\n            <span ng-if=\"info.properties().RealisedInEFA!==\'1\'\">{{\'Nicht\'|translate}} </span>{{\'In EFA erfasst\'|translate}}</br>\r\n        </p>-->\r\n        <p class=\"info\">{{\'Stand\'|translate}} {{info.creation()|VVSDateFormatter}} {{info.creation()|VVSTimeFormatter}}</p>\r\n    </div>\r\n    <div class=\"ctblock buttonlist col-xs-12 nopadding-xs padding-md\" role=\"group\">\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.specialTraffic\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Sonderverkehre Übersicht\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.init\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Meldungen\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/info/specialTraffic/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock buttonlist col-xs-12 nopadding-xs padding-md spacerbottomlarge spacertoplarge\" role=\"group\" aria-label=\"Störungen\">\r\n        <vvs-alert ng-if=\"infos.length==0\" text=\"\'Es liegen aktuell keine Meldungen vor. Wir wünschen eine gute Fahrt.\'\"></vvs-alert>\r\n        <button type=\"button\" class=\"btn btn-block btn-larger btn-notice nopadding\" ng-repeat=\"info in infos track by $index\" ui-sref=\"vvs.info.specialTrafficDetails({info: info})\">\r\n            <div class=\"pull-left text-left middle-text\" ng-init=\"formattedValidityFrom=(info.validityFrom()|VVSDateFormatter);formattedValidityTo=(info.validityTo()|VVSDateFormatter);\" ng-switch on=\"formattedValidityTo\">\r\n                <div><span>{{info.title()}}</span></div>\r\n                <span class=\"textsmall\" ng-if=\"formattedValidityFrom!=formattedValidityTo\">{{\'Vom\'|translate}} {{formattedValidityFrom}} {{\'bis\'|translate}} <span ng-switch-when=\"31.12.2500\">{{\'auf Weiteres\'|translate}}</span><span ng-switch-default>{{formattedValidityTo}}</span></span>\r\n                <span class=\"textsmall\" ng-if=\"formattedValidityFrom==formattedValidityTo\">{{\'Am\'|translate}} {{formattedValidityFrom}}</span>\r\n                <br>\r\n                <div class=\"hideme\">\r\n                    <span class=\"textsmall\">{{info.urlText()}} {{info.properties().location|VVSInfoCleanLocationName}}</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n    <div class=\"ctblock buttonlist col-xs-12 nopadding-xs padding-md\" role=\"group\">\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.init\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Meldungen\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/info/timetableChange/details.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\" ng-if=\"info\">\r\n\r\n    <div class=\"ctblock col-xs-12 spacertop\">\r\n        <div ng-repeat=\"(productIconId, lines) in info.affectedLines()|groupBy:\'productIconId()\'\">\r\n            <h2 class=\"hicon {{productIconId|VVSProductIconIdMapper}} meldungen\"> <span ng-repeat=\"line in lines|unique:\'number()\'\">{{line.number()}}<span ng-if=\"!$last\">, </span></span></h2>\r\n        </div>\r\n        <p class=\"info spacerbottomlarge\">\r\n            <span>\r\n                <span ng-if=\"info.validityFrom()\">{{\'von\'|translate}} <span>{{info.validityFrom()|VVSDateFormatter}}</span> </span>\r\n                <span ng-if=\"info.validityTo()\">{{\'bis\'|translate}}\r\n                <span ng-switch on=\"info.validityTo()|VVSDateFormatter\"><span ng-switch-when=\"31.12.2500\">{{\'auf Weiteres\'|translate}}</span><span ng-switch-default>{{info.validityTo()|VVSDateFormatter}}</span></span></span>\r\n                </br>\r\n            </span>\r\n            <strong ng-if=\"info.subtitle()\">{{info.subtitle()}}</br></br></strong>\r\n            <span ng-bind-html=\"info.content()|VVSSafeHTML\"></span>\r\n        </p>\r\n        <p class=\"info\" ng-if=\"info.properties().attachments\">\r\n            <p class=\"info\" ng-repeat=\"att in info.properties().attachments\">\r\n                <a class=\"special\" href=\"{{att.path}}\" target=\"_blank\">{{att.linkText}}</a>\r\n            </p>\r\n        </p>\r\n        <p class=\"info\">\r\n            <p class=\"info\">\r\n                <span ng-if=\"info.properties().RealisedInEFA !== \'1\'\">{{\'Nicht\'|translate}} </span>{{\'In EFA erfasst\'|translate}}</br>\r\n            </p>\r\n            <span ng-if=\"info.creation()\">{{\'Stand\'|translate}} {{info.creation()|VVSDateFormatter}} {{info.creation()|VVSTimeFormatter}}</span>\r\n        </p>\r\n    </div>\r\n    <div class=\"ctblock buttonlist col-xs-12 nopadding-xs padding-md\" role=\"group\">\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.timetableChange\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Fahrplanänderungen Übersicht\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.init\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Meldungen\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/info/timetableChange/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 filterbox spacertop\">\r\n        <h2 class=\"nopadding\">{{\'Verkehrsmittel auswählen\'|translate}}</h2>\r\n\r\n        <button class=\"btn btn-default\" type=\"button\" ng-class=\"{\'active\' : filterObj[\'All\']}\" ng-click=\"triggerFilterBtnClick(\'All\')\">\r\n            {{\'Alle\'|translate}}\r\n        </button>\r\n        <button class=\"btn btn-default\" type=\"button\" ng-class=\"{\'active\' : filterObj[\'S-Bahn\']}\" ng-click=\"triggerFilterBtnClick(\'S-Bahn\')\">\r\n            <vvs-icon name=\"sbahn\"></vvs-icon>\r\n        </button>\r\n        <button class=\"btn btn-default\" type=\"button\" ng-class=\"{\'active\' : filterObj[\'R-Bahn\']}\" ng-click=\"triggerFilterBtnClick(\'R-Bahn\')\">\r\n            <vvs-icon name=\"rbahn\"></vvs-icon>\r\n        </button>\r\n        <button class=\"btn btn-default\" type=\"button\" ng-class=\"{\'active\' : filterObj[\'U-Bahn\']}\" ng-click=\"triggerFilterBtnClick(\'U-Bahn\')\">\r\n            <vvs-icon name=\"ubahn\"></vvs-icon>\r\n        </button>\r\n        <button class=\"btn btn-default\" type=\"button\" ng-class=\"{\'active\' : filterObj[\'Zacke\']}\" ng-click=\"triggerFilterBtnClick(\'Zacke\')\">\r\n            <vvs-icon name=\"zacke\"></vvs-icon>\r\n        </button>\r\n        <button class=\"btn btn-default\" type=\"button\" ng-class=\"{\'active\' : filterObj[\'Seilbahn\']}\" ng-click=\"triggerFilterBtnClick(\'Seilbahn\')\">\r\n            <vvs-icon name=\"seilbahn\"></vvs-icon>\r\n        </button>\r\n        <button class=\"btn btn-default\" type=\"button\" ng-class=\"{\'active\' : filterObj[\'Bus\']}\" ng-click=\"triggerFilterBtnClick(\'Bus\')\">\r\n            <vvs-icon name=\"bus\"></vvs-icon>\r\n        </button>\r\n        <button class=\"btn btn-default\" type=\"button\" ng-class=\"{\'active\' : filterObj[\'Ruftaxi\']}\" ng-click=\"triggerFilterBtnClick(\'Ruftaxi\')\">\r\n            <vvs-icon name=\"ruftaxi\"></vvs-icon>\r\n        </button>\r\n    </div>\r\n    <div class=\"infocus col-xs-12 spacerbottomlarge\">\r\n        <div class=\"form-group spacertop spacerbottomlarge\">\r\n            <input type=\"text\" class=\"form-control\" id=\"linie\" aria-label=\"Suche\" ng-model=\"filterByLineName\" placeholder=\"Linie suchen\">\r\n        </div>\r\n        <div class=\"col-xs-12 col-sm-6 col-sm-offset-3 nopadding\">\r\n            <button type=\"submit\" class=\"search-btn btn btn-primary btn-block\" ng-click=\"triggerFilterByLineNameClick()\">{{\'Suchen\'|translate}}</button>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12 trip-container nopadding padding-md\" ng-init=\"tabIndex=0\">\r\n\r\n        <md-tabs md-dynamic-height md-border-bottom class=\"nav nav-tabs\">\r\n            <md-tab>\r\n                <md-tab-label>\r\n                    {{\'Aktuell\'|translate}}\r\n                </md-tab-label>\r\n                <md-tab-body>\r\n                    <div class=\"tab-content spacerbottomlarge\">\r\n                        <div class=\"clearfix\" id=\"grafik\">\r\n                            <div class=\"ctblock buttonlist col-xs-12 nopadding-xs padding-md spacerbottomlarge spacertop\" role=\"group\" aria-label=\"Fahrplanänderungen aktuell\">\r\n                                <vvs-alert ng-if=\"infos.actual.length==0\" text=\"\'Es liegen aktuell keine Fahrplanänderungen vor. Wir wünschen eine gute Fahrt.\'\"></vvs-alert>\r\n                                <button type=\"button\" class=\"btn btn-block btn-larger btn-notice\" ng-repeat=\"info in infos.actual track by $index\" ng-click=\"openDetailsView(info)\">\r\n                                    <div class=\"pull-left text-left\">\r\n                                        <div ng-class=\"{\'state-normal\': (info.priority()===\'normal\'), \'state-alert\': (info.priority()!==\'normal\')}\"></div>\r\n                                    </div>\r\n                                    <div class=\"pull-left text-left middle-text\">\r\n                                        <div>\r\n                                            <span ng-repeat=\"(productIconId, lines) in info.affectedLines()|groupBy:\'productIconId()\'\">\r\n                                                <vvs-icon product-icon-id=\"{{productIconId}}\"></vvs-icon><span ng-repeat=\"line in lines|unique:\'number()\'\" style=\"margin-right:0px\">{{line.number()}}<span ng-if=\"!$last\" style=\"margin-right:0px\">, </span></span>\r\n                                            </span>\r\n                                        </div>\r\n\r\n                                        <span class=\"textsmall\">\r\n                                            <span ng-if=\"info.validityFrom()\" class=\"nomargin\">{{\'von\'|translate}} <strong>{{info.validityFrom()|VVSDateFormatter}}</strong> </span>\r\n                                            <span ng-if=\"info.validityTo()\">{{\'bis\'|translate}}\r\n                                            <strong ng-switch on=\"info.validityTo()|VVSDateFormatter\"><span ng-switch-when=\"31.12.2500\">{{\'auf Weiteres\'|translate}}</span><span ng-switch-default>{{info.validityTo()|VVSDateFormatter}}</span></strong></span>\r\n                                        </span>\r\n                                        <br>\r\n                                        <div class=\"hideme\">\r\n                                            <span class=\"textsmall\">{{info.subtitle()}}</span>\r\n                                        </div>\r\n                                    </div>\r\n                                    <div class=\"pull-right text-right send\">\r\n                                        <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                    </div>\r\n                                </button>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                </md-tab-body>\r\n            </md-tab>\r\n            <md-tab>\r\n                <md-label>\r\n                    {{\'Demnächst\'|translate}}\r\n                </md-label>\r\n                <md-tab-body>\r\n                    <div class=\"tab-content spacerbottomlarge\">\r\n                        <div class=\"clearfix\" id=\"liste\">\r\n                            <div class=\"ctblock buttonlist col-xs-12 nopadding-xs padding-md spacerbottomlarge spacertop\" role=\"group\" aria-label=\"Fahrplanänderungen demnächst\">\r\n                                <vvs-alert ng-if=\"!infos.future.length\" text=\"\'Es liegen demnächst keine Fahrplanänderungen vor. Wir wünschen eine gute Fahrt.\'\"></vvs-alert>\r\n                                <button type=\"button\" class=\"btn btn-block btn-larger btn-notice\" ng-repeat=\"info in infos.future track by $index\" ng-click=\"openDetailsView(info)\">\r\n                                    <div class=\"pull-left text-left\">\r\n                                        <div ng-class=\"{\'state-normal\': (info.priority()===\'normal\'), \'state-alert\': (info.priority()!==\'normal\')}\"></div>\r\n                                    </div>\r\n                                    <div class=\"pull-left text-left middle-text\">\r\n                                        <div>\r\n                                            <span ng-repeat=\"(productIconId, lines) in info.affectedLines()|groupBy:\'productIconId()\'\">\r\n                                                <vvs-icon product-icon-id=\"{{productIconId}}\"></vvs-icon><span ng-repeat=\"line in lines|unique:\'number()\'\" style=\"margin-right:0px\">{{line.number()}}<span ng-if=\"!$last\" style=\"margin-right:0px\">, </span></span>\r\n                                            </span>\r\n                                        </div>\r\n\r\n                                        <span class=\"textsmall\">\r\n                                            <span ng-if=\"info.validityFrom()\" class=\"nomargin\">{{\'von\'|translate}} <strong>{{info.validityFrom()|VVSDateFormatter}}</strong> </span>\r\n                                            <span ng-if=\"info.validityTo()\">{{\'bis\'|translate}}\r\n                                            <strong ng-switch on=\"info.validityTo()|VVSDateFormatter\"><span ng-switch-when=\"31.12.2500\">{{\'auf Weiteres\'|translate}}</span><span ng-switch-default>{{info.validityTo()|VVSDateFormatter}}</span></strong></span>\r\n                                        </span>\r\n                                        <br>\r\n                                        <div class=\"hideme\">\r\n                                            <span class=\"textsmall\">{{info.subtitle()}}</span>\r\n                                        </div>\r\n                                    </div>\r\n                                    <div class=\"pull-right text-right send\">\r\n                                        <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                    </div>\r\n                                </button>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </md-tab-body>\r\n            </md-tab>\r\n        </md-tabs>\r\n    </div>\r\n    <div class=\"ctblock buttonlist col-xs-12 nopadding-xs padding-md\" role=\"group\">\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.info.init\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Meldungen\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n    <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/info/timetableChange/modal.html","<div class=\"sharing-modal\">\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Teilen\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <h2>{{\'Teilen Sie die Fahrplanänderungen mit Kollegen, Freunden und der Familie\' | translate}}</h2>\r\n        <div class=\"modal-block spacerbottomlarge\">\r\n            \r\n            <div class=\"btn-group btn-group-justified sharing-buttons\" role=\"group\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <a href=\"mailto:?subject=Fahplanänderung&body={{info.url()}}\">\r\n                        <button type=\"button\" class=\"btn btn-default\" title=\"{{\'Über E-Mail teilen\'|translate}}\">\r\n                            <vvs-icon name=\"teilen\"></vvs-icon>\r\n                        </button>\r\n                    </a>\r\n                </div>        \r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <a href=\"https://www.facebook.com/sharer/sharer.php?u={{info.url()}}\" target=\"_blank\">\r\n                        <button type=\"button\" class=\"btn btn-default\" title=\"{{\'Auf Facebook teilen\'|translate}}\">\r\n                            <vvs-icon name=\"facebook\"></vvs-icon>\r\n                        </button>\r\n                    </a>\r\n                </div>\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <a href=\"https://twitter.com/intent/tweet?text={{info.url()}}\" target=\"_blank\">\r\n                        <button type=\"button\" class=\"btn btn-default\" title=\"{{\'Auf Twitter teilen\'|translate}}\">\r\n                            <vvs-icon name=\"twitter\"></vvs-icon>\r\n                        </button>\r\n                    </a>\r\n                </div>\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <a href=\"https://wa.me?text={{info.url()}}\" target=\"_blank\">\r\n                        <button type=\"button\" class=\"btn btn-default\" title=\"{{\'Auf WhatsApp teilen\'|translate}}\">\r\n                            <vvs-icon name=\"whatsapp\"></vvs-icon>\r\n                        </button>\r\n                    </a>\r\n                </div>\r\n            </div>\r\n\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/vvs.components/map/config/modal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Einstellungen Karte\'|translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\" ng-controller=\"VVSMapConfigController as VVSMapConfigCtrl\">\r\n        <div class=\"drilldown\">\r\n            <!-- required -->\r\n            <div class=\"drilldown-container\">\r\n                <!-- required -->\r\n                <ul class=\"drilldown-root\" style=\"margin-top: 4.8rem;\" ng-hide=\"animate\" ng-class=\"{\'vvs-animated-slide vvs-animated-back\': animate==false, \'vvs-animated-slide\': animate}\">\r\n                    <!-- required, but not necessarily UL -->\r\n                    <li>\r\n                        <a href=\"javascript:void(0)\" ng-click=\"animate=true; animateStops=true;\">\r\n                            <button type=\"button\" class=\"btn btn-default btn-block nopadding\">\r\n                                <div class=\"pull-left text-left\">\r\n                                    <div class=\"maintext\">{{\'Haltestellen\'|translate}}</div>\r\n                                </div>\r\n                                <div class=\"pull-right text-right send\">\r\n                                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                </div>\r\n                            </button>\r\n                        </a>\r\n                    </li>\r\n                    <li>\r\n                        <a href=\"javascript:void(0)\" ng-click=\"animate=true; animateLines=true;\">\r\n                            <button type=\"button\" class=\"btn btn-default btn-block nopadding\">\r\n                                <div class=\"pull-left text-left\">\r\n                                    <div class=\"maintext\">{{\'Linien\'|translate}}</div>\r\n                                </div>\r\n                                <div class=\"pull-right text-right send\">\r\n                                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                </div>\r\n                            </button>\r\n                        </a>\r\n                    </li>\r\n                    <li>\r\n                        <a href=\"javascript:void(0)\" ng-click=\"animate=true; animateLivePositions=true;\">\r\n                            <button type=\"button\" class=\"btn btn-default btn-block nopadding\">\r\n                                <div class=\"pull-left text-left\">\r\n                                    <div class=\"maintext\">{{\'Fahrzeugpositionen\'|translate}}</div>\r\n                                </div>\r\n                                <div class=\"pull-right text-right send\">\r\n                                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                </div>\r\n                            </button>\r\n                        </a>\r\n                    </li>\r\n                    <li>\r\n                        <a href=\"javascript:void(0)\" ng-click=\"animate=true; animatePois=true;\">\r\n                            <button type=\"button\" class=\"btn btn-default btn-block nopadding\">\r\n                                <div class=\"pull-left text-left\">\r\n                                    <div class=\"maintext\">{{\'Wichtige Punkte\'|translate}}</div>\r\n                                </div>\r\n                                <div class=\"pull-right text-right send\">\r\n                                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                </div>\r\n                            </button>\r\n                        </a>\r\n                    </li>\r\n                    <!--\r\n                    <li>\r\n                        <a href=\"javascript:void(0)\" ng-click=\"animate=true; animateCarBikeSharing=true;\">\r\n                            <button type=\"button\" class=\"btn btn-default btn-block nopadding\">\r\n                                <div class=\"pull-left text-left\">\r\n                                    <div class=\"maintext\">Bike Sharing &amp; Car Sharing</div>\r\n                                </div>\r\n                                <div class=\"pull-right text-right send\">\r\n                                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                </div>\r\n                            </button>\r\n                        </a>\r\n                    </li>\r\n                    <li>\r\n                        <a href=\"javascript:void(0)\" ng-click=\"animate=true; animateParkAndRide=true;\">\r\n                            <button type=\"button\" class=\"btn btn-default btn-block nopadding\">\r\n                                <div class=\"pull-left text-left\">\r\n                                    <div class=\"maintext\">Park &amp; Ride</div>\r\n                                </div>\r\n                                <div class=\"pull-right text-right send\">\r\n                                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                </div>\r\n                            </button>\r\n                        </a>\r\n                    </li>\r\n                    -->\r\n                </ul>\r\n                <ul class=\"drilldown-root\" ng-show=\"animate\">\r\n                    <li>\r\n                        <ul class=\"drilldown-sub noicon vvs-animated-slide\" ng-show=\"animateStops\" ng-class=\"{\'vvs-animated-back\':!animate}\">\r\n                            <!-- required for deeper (non-root) levels -->\r\n                            <li class=\"drilldown-back spacertoplarge\">\r\n                                <a href=\"javascript:void(0)\">\r\n                                    <button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"animate=false; animateStops=false\">\r\n                                        <div class=\"pull-left text-left send\">\r\n                                            <vvs-icon name=\"zurueck\"></vvs-icon>\r\n                                        </div>\r\n                                        <div class=\"pull-left text-left\">\r\n                                            <div class=\"maintext\">{{\'Zurück\'|translate}}</div>\r\n                                        </div>\r\n                                    </button>\r\n                                </a>\r\n                            </li>\r\n                            <!-- required to be able to go back -->\r\n                            <li>\r\n                                <ul class=\"list-group list-toggle\">\r\n                                    <li class=\"list-group-item list-group-header noborder\">\r\n                                        <h2>{{\'Haltestellen\'|translate}}</h2>\r\n                                        <md-switch aria-label=\"Haltestellen\" ng-model=\"MAP_OPTIONS.stops.enable\" ng-change=\"VVSMapConfigCtrl.triggerShowStopsChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"rbahn\"></vvs-icon> {{\'R-Bahn\'|translate}}\r\n                                        <md-switch aria-label=\"R-Bahn\" ng-model=\"MAP_OPTIONS.stops.regionalBus\" ng-change=\"VVSMapConfigCtrl.triggerStopTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"sbahn\"></vvs-icon> {{\'S-Bahn\'|translate}}\r\n                                        <md-switch aria-label=\"S-Bahn\" ng-model=\"MAP_OPTIONS.stops.subway\" ng-change=\"VVSMapConfigCtrl.triggerStopTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"ubahn\"></vvs-icon> {{\'Stadt-/Zahnradbahn\'|translate}}\r\n                                        <md-switch aria-label=\"Stadt-/Zahnradbahn\" ng-model=\"MAP_OPTIONS.stops.commuter\" ng-change=\"VVSMapConfigCtrl.triggerStopTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"bus\"></vvs-icon> {{\'Bus\'|translate}}\r\n                                        <md-switch aria-label=\"Bus\" ng-model=\"MAP_OPTIONS.stops.bus\" ng-change=\"VVSMapConfigCtrl.triggerStopTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                </ul>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n                    <li>\r\n                        <ul class=\"drilldown-sub noicon vvs-animated-slide\" ng-show=\"animateLines\" ng-class=\"{\'vvs-animated-back\':!animate}\">\r\n                            <!-- required for deeper (non-root) levels -->\r\n                            <li class=\"drilldown-back spacertoplarge\">\r\n                                <a href=\"javascript:void(0)\">\r\n                                    <button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"animate=false; animateLines=false\">\r\n                                        <div class=\"pull-left text-left send\">\r\n                                            <vvs-icon name=\"zurueck\"></vvs-icon>\r\n                                        </div>\r\n                                        <div class=\"pull-left text-left\">\r\n                                            <div class=\"maintext\">{{\'Zurück\'|translate}}</div>\r\n                                        </div>\r\n                                    </button>\r\n                                </a>\r\n                            </li>\r\n                            <!-- required to be able to go back -->\r\n                            <li>\r\n                                <ul class=\"list-group list-toggle nomargin\">\r\n                                    <li class=\"list-group-item no-icon\">{{\'Linienverlauf anzeigen\'|translate}}\r\n                                        <md-switch aria-label=\"Linienverlauf anzeigen\"\r\n                                            ng-model=\"MAP_OPTIONS.layers.lines\"\r\n                                            ng-change=\"VVSMapCtrl.triggerSwitchLayerClick()\"\r\n                                           ></md-switch>\r\n                                    </li>\r\n                                </ul>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n                    <li>\r\n                        <ul class=\"drilldown-sub noicon vvs-animated-slide\" ng-show=\"animateLivePositions\" ng-class=\"{\'vvs-animated-back\':!animate}\">\r\n                            <!-- required for deeper (non-root) levels -->\r\n                            <li class=\"drilldown-back spacertoplarge\">\r\n                                <a href=\"javascript:void(0)\">\r\n                                    <button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"animate=false; animateLivePositions=false\">\r\n                                        <div class=\"pull-left text-left send\">\r\n                                            <vvs-icon name=\"zurueck\"></vvs-icon>\r\n                                        </div>\r\n                                        <div class=\"pull-left text-left\">\r\n                                            <div class=\"maintext\">{{\'Zurück\'|translate}}</div>\r\n                                        </div>\r\n                                    </button>\r\n                                </a>\r\n                            </li>\r\n                            <!-- required to be able to go back -->\r\n                            <li>\r\n                                <ul class=\"list-group list-toggle nomargin\">\r\n                                    <li class=\"list-group-item list-group-header noborder\">\r\n                                        <h2>{{\'Fahrzeugpositionen\'|translate}}</h2>\r\n                                        <md-switch aria-label=\"Fahrzeugpositionen\" ng-model=\"MAP_OPTIONS.positions.enable\" ng-change=\"VVSMapConfigCtrl.triggerShowPositionsChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"rbahn\"></vvs-icon> {{\'R-Bahn\'|translate}}\r\n                                        <md-switch aria-label=\"R-Bahn\" ng-model=\"MAP_OPTIONS.positions.productRestrictions.train\" ng-change=\"VVSMapConfigCtrl.triggerPositionsTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"sbahn\"></vvs-icon> {{\'S-Bahn\'|translate}}\r\n                                        <md-switch aria-label=\"S-Bahn\" ng-model=\"MAP_OPTIONS.positions.productRestrictions.commuter\" ng-change=\"VVSMapConfigCtrl.triggerPositionsTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"ubahn\"></vvs-icon> {{\'Stadt-/Zahnradbahn\'|translate}}\r\n                                        <md-switch aria-label=\"Stadt-/Zahnradbahn\" ng-model=\"MAP_OPTIONS.positions.productRestrictions.lightRail\" ng-change=\"VVSMapConfigCtrl.triggerPositionsTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"bus\"></vvs-icon> {{\'Bus\'|translate}}\r\n                                        <md-switch aria-label=\"Bus\" ng-model=\"MAP_OPTIONS.positions.productRestrictions.bus\" ng-change=\"VVSMapConfigCtrl.triggerPositionsTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                </ul>\r\n                                <h2>{{\'Fahrten\'|translate}}</h2>\r\n                                <ul class=\"list-group list-toggle nomargin\">\r\n                                    <li class=\"list-group-item no-icon\">{{\'Fahrten ohne Echtzeit anzeigen\'|translate}}\r\n                                        <md-switch aria-label=\"Fahrten ohne Echtzeit anzeigen\" ng-model=\"MAP_OPTIONS.positions.filter.showVehiculesWithoutDelay\"></md-switch>\r\n                                    </li>\r\n                                </ul>\r\n                                <div class=\"visible-xs\">\r\n                                    <div class=\"holder infocus spacerbottommedium spacertop\">\r\n                                        <label class=\"nopadding-xs\">{{\'Nur Fahrten mit Verspätung ab\'|translate}} : {{MAP_OPTIONS.positions.filter.minVehiculeDelay}} ({{\'Minuten\'|translate}})</label>\r\n                                        <md-slider flex min=\"0\" max=\"60\" ng-model=\"MAP_OPTIONS.positions.filter.minVehiculeDelay\"></md-slider>\r\n                                    </div>\r\n                                </div>\r\n                                <div class=\"hidden-xs\">\r\n                                    <div class=\"holder infocus spacerbottommedium spacertop\">\r\n                                        <label class=\"nopadding-xs\">{{\'Nur Fahrten mit Verspätung ab\'|translate}} : {{MAP_OPTIONS.positions.filter.minVehiculeDelay}} ({{\'Minuten\'|translate}})</label>\r\n                                        <md-slider flex min=\"0\" max=\"60\" ng-model=\"MAP_OPTIONS.positions.filter.minVehiculeDelay\"></md-slider>\r\n                                    </div>\r\n                                    <div class=\"holder spacerbottomlarge\">\r\n                                        <div class=\"btn-group btn-group-justified highlight\" role=\"group\" aria-label=\"Übernehmen\">\r\n                                            <div class=\"btn-group\" role=\"group\">\r\n                                                <button type=\"button\" class=\"btn btn-default\" ng-click=\"VVSMapCtrl.triggerLivePositionUpdate();dismissModal()\">{{\'Übernehmen\'|translate}}</button>\r\n                                            </div>\r\n                                        </div>\r\n                                    </div>\r\n                                </div>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n                    <li>\r\n                        <ul class=\"drilldown-sub noicon vvs-animated-slide\" ng-show=\"animatePois\" ng-class=\"{\'vvs-animated-back\':!animate}\">\r\n                            <!-- required for deeper (non-root) levels -->\r\n                            <li class=\"drilldown-back spacertoplarge\">\r\n                                <a href=\"javascript:void(0)\">\r\n                                    <button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"animate=false; animatePois=false\">\r\n                                        <div class=\"pull-left text-left send\">\r\n                                            <vvs-icon name=\"zurueck\"></vvs-icon>\r\n                                        </div>\r\n                                        <div class=\"pull-left text-left\">\r\n                                            <div class=\"maintext\">{{\'Zurück\'|translate}}</div>\r\n                                        </div>\r\n                                    </button>\r\n                                </a>\r\n                            </li>\r\n                            <!-- required to be able to go back -->\r\n                            <li>\r\n                                <ul class=\"list-group list-toggle\">\r\n                                    <li class=\"list-group-item list-group-header noborder\">\r\n                                        <h2>{{\'Alle wichtigen Punkte\'|translate}}</h2>\r\n                                        <md-switch aria-label=\"Alle wichtigen Punkt\" ng-model=\"MAP_OPTIONS.pois.enable\" ng-change=\"VVSMapConfigCtrl.triggerShowPoisChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"bildung\"></vvs-icon> {{\'Bildung\'|translate}}\r\n                                        <md-switch aria-label=\"Bildung\" ng-model=\"MAP_OPTIONS.pois.B\" ng-change=\"VVSMapConfigCtrl.triggerPoisTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"essen\"></vvs-icon> {{\'Essen und Trinken\'|translate}}\r\n                                        <md-switch aria-label=\"Essen und Trinken\" ng-model=\"MAP_OPTIONS.pois.K\" ng-change=\"VVSMapConfigCtrl.triggerPoisTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"freizeit\"></vvs-icon> {{\'Badespaß\'|translate}}\r\n                                        <md-switch aria-label=\"Freizeit\" ng-model=\"MAP_OPTIONS.pois.C\" ng-change=\"VVSMapConfigCtrl.triggerPoisTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"hotels\"></vvs-icon> {{\'Hotels, Unterkünfte\'|translate}}\r\n                                        <md-switch aria-label=\"Hotels, Unterkünfte\" ng-model=\"MAP_OPTIONS.pois.D\" ng-change=\"VVSMapConfigCtrl.triggerPoisTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"info\"></vvs-icon> {{\'Information und Service\'|translate}}\r\n                                        <md-switch aria-label=\"Information und Service\" ng-model=\"MAP_OPTIONS.pois.A\" ng-change=\"VVSMapConfigCtrl.triggerPoisTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"kirche\"></vvs-icon> {{\'Kirchen, Friedhöfe\'|translate}}\r\n                                        <md-switch aria-label=\"Kirchen, Friedhöfe\" ng-model=\"MAP_OPTIONS.pois.E\" ng-change=\"VVSMapConfigCtrl.triggerPoisTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"klinik\"></vvs-icon> {{\'Krankenhäuser, Kliniken\'|translate}}\r\n                                        <md-switch aria-label=\"Krankenhäuser, Kliniken\" ng-model=\"MAP_OPTIONS.pois.F\" ng-change=\"VVSMapConfigCtrl.triggerPoisTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"kultur\"></vvs-icon> {{\'Kultur\'|translate}}\r\n                                        <md-switch aria-label=\"Kultur\" ng-model=\"MAP_OPTIONS.pois.G\" ng-change=\"VVSMapConfigCtrl.triggerPoisTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"rundumsrad\"></vvs-icon> {{\'Rund ums Rad\'|translate}}\r\n                                        <md-switch aria-label=\"Rund ums Rad\" ng-model=\"MAP_OPTIONS.pois.M\" ng-change=\"VVSMapConfigCtrl.triggerPoisTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"erlebnis\"></vvs-icon> {{\'Erlebnis\'|translate}}\r\n                                        <md-switch aria-label=\"Erlebnis\" ng-model=\"MAP_OPTIONS.pois.N\" ng-change=\"VVSMapConfigCtrl.triggerPoisTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"sights\"></vvs-icon> {{\'Sehenswürdigkeiten\'|translate}}\r\n                                        <md-switch aria-label=\"Sehenswürdigkeiten\" ng-model=\"MAP_OPTIONS.pois.H\" ng-change=\"VVSMapConfigCtrl.triggerPoisTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"senioren\"></vvs-icon> {{\'Senioren- und Pflegeeinrichtungen\'|translate}}\r\n                                        <md-switch aria-label=\"Senioren- und Pflegeeinrichtungen\" ng-model=\"MAP_OPTIONS.pois.L\" ng-change=\"VVSMapConfigCtrl.triggerPoisTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"sport\"></vvs-icon> {{\'Sportstätten\'|translate}}\r\n                                        <md-switch aria-label=\"Sportstätten\" ng-model=\"MAP_OPTIONS.pois.I\" ng-change=\"VVSMapConfigCtrl.triggerPoisTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"vereine\"></vvs-icon> {{\'Verbände, Vereine\'|translate}}\r\n                                        <md-switch aria-label=\"Verbände, Vereine\" ng-model=\"MAP_OPTIONS.pois.J\" ng-change=\"VVSMapConfigCtrl.triggerPoisTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                </ul>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n                    <li>\r\n                        <ul class=\"drilldown-sub noicon vvs-animated-slide\" ng-show=\"animateCarBikeSharing\" ng-class=\"{\'vvs-animated-back\':!animate}\">\r\n                            <!-- required for deeper (non-root) levels -->\r\n                            <li class=\"drilldown-back spacertoplarge\">\r\n                                <a href=\"javascript:void(0)\">\r\n                                    <button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"animate=false; animateCarBikeSharing=false\">\r\n                                        <div class=\"pull-left text-left send\">\r\n                                            <vvs-icon name=\"zurueck\"></vvs-icon>\r\n                                        </div>\r\n                                        <div class=\"pull-left text-left\">\r\n                                            <div class=\"maintext\">{{\'Zurück\'|translate}}</div>\r\n                                        </div>\r\n                                    </button>\r\n                                </a>\r\n                            </li>\r\n                            <!-- required to be able to go back -->\r\n                            <li>\r\n                                <h2>{{\'Sharing\'|translate}}</h2>\r\n                                <div class=\"ctblock nopadding-xs\">\r\n                                    <button type=\"button\" class=\"btn btn-default btn-block\">\r\n                                        <div class=\"pull-left text-left left-text-color\">\r\n                                            {{\'Sharing Angebote nutzen, wie gehts?\'|translate}}\r\n                                        </div>\r\n                                        <div class=\"pull-right text-right\">\r\n                                            <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                        </div>\r\n                                    </button>\r\n                                </div>\r\n                                <ul class=\"list-group list-toggle\">\r\n                                    <li class=\"list-group-item list-group-header noborder\">\r\n                                        <h2>{{\'Alle Bike Sharing &amp; Car Sharing Angebote\'|translate}}</h2>\r\n                                        <md-switch aria-label=\"Alle Bike Sharing &amp; Car Sharing Angebote\" ng-model=\"MAP_OPTIONS.sharing.enable\" ng-change=\"VVSMapConfigCtrl.triggerShowSharingChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"callabike\"></vvs-icon> {{\'Call A Bike\'|translate}}\r\n                                        <md-switch aria-label=\"Call A Bike\" ng-model=\"MAP_OPTIONS.sharing.callabike\" ng-change=\"VVSMapConfigCtrl.triggerSharingTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"nextbike\"></vvs-icon> {{\'Nextbike\'|translate}}\r\n                                        <md-switch aria-label=\"Nextbike\" ng-model=\"MAP_OPTIONS.sharing.nextbike\" ng-change=\"VVSMapConfigCtrl.triggerSharingTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"car2go\"></vvs-icon> {{\'Car 2 Go\'|translate}}\r\n                                        <md-switch aria-label=\"Car 2 Go\" ng-model=\"MAP_OPTIONS.sharing.car2go\" ng-change=\"VVSMapConfigCtrl.triggerSharingTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"flinkster\"></vvs-icon> {{\'Flinkster\'|translate}}\r\n                                        <md-switch aria-label=\"Flinkster\" ng-model=\"MAP_OPTIONS.sharing.flinkster\" ng-change=\"VVSMapConfigCtrl.triggerSharingTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                    <li class=\"list-group-item\">\r\n                                        <vvs-icon name=\"stadtmobil\"></vvs-icon> {{\'Stadtmobil\'|translate}}\r\n                                        <md-switch aria-label=\"Stadtmobil\" ng-model=\"MAP_OPTIONS.sharing.stadtmobil\" ng-change=\"VVSMapConfigCtrl.triggerSharingTypesChange()\"></md-switch>\r\n                                    </li>\r\n                                </ul>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n                    <li>\r\n                        <ul class=\"drilldown-sub noicon vvs-animated-slide\" ng-show=\"animateParkAndRide\" ng-class=\"{\'vvs-animated-back\':!animate}\">\r\n                            <!-- required for deeper (non-root) levels -->\r\n                            <li class=\"drilldown-back spacertoplarge spacerbottomlarge\">\r\n                                <a href=\"javascript:void(0)\">\r\n                                    <button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"animate=false; animateParkAndRide=false\">\r\n                                        <div class=\"pull-left text-left send\">\r\n                                            <vvs-icon name=\"zurueck\"></vvs-icon>\r\n                                        </div>\r\n                                        <div class=\"pull-left text-left\">\r\n                                            <div class=\"maintext\">{{\'Zurück\'|translate}}</div>\r\n                                        </div>\r\n                                    </button>\r\n                                </a>\r\n                            </li>\r\n                            <!-- required to be able to go back -->\r\n                            <li>\r\n                                <ul class=\"list-group list-toggle\">\r\n                                    <!--<li class=\"list-group-item list-group-header noborder\"><h2>Park &amp; Ride Parkplätze anzeigen</h2> <md-switch aria-label=\"Alle ÖV\" ng-model=\"test\"></md-switch></li>-->\r\n                                    <li class=\"list-group-item no-icon\">{{\'Park &amp; Ride Parkplätze anzeigen\'|translate}}\r\n                                        <md-switch aria-label=\"Park &amp; Ride Parkplätze anzeigen\" ng-model=\"MAP_OPTIONS.parkandride.sowParkAndRide\"></md-switch>\r\n                                    </li>\r\n                                </ul>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/map/popovers/currentPosition.html","<div class=\"popup-content\">\r\n    <div class=\"popover-content\">\r\n\r\n            <h2 class=\"wicon\"><vvs-icon name=\"standort\"></vvs-icon> {{\'Aktuelle Position\'|translate}}</h2>\r\n            <div class=\"infobox\">\r\n                <p>{{location|VVSLocationNameFormatter}}</p>\r\n            </div>\r\n            <div class=\"innerpopup\">\r\n                <div ng-if=\"(usage===\'orig\')||(usage===\'dest\')||(\'vvs.map\'|isState)\">\r\n                    <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit angefragter Uhrzeit\" role=\"group\">\r\n                        <div class=\"btn-group \" role=\"group\">\r\n                            <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'orig\')\">{{\'als Start übernehmen\' | translate}}</button>\r\n                        </div>\r\n                    </div>\r\n                    <br>\r\n                </div>\r\n                <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\" ng-if=\"(usage===\'orig\')||(usage===\'dest\')||(\'vvs.map\'|isState)\">\r\n                    <div class=\"btn-group\" role=\"group\">\r\n                        <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'dest\')\">{{\'als Ziel übernehmen\' | translate}}</button>\r\n                    </div>\r\n                </div>\r\n                <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\" ng-if=\"usage===\'dm\'\">\r\n                    <div class=\"btn-group\" role=\"group\">\r\n                        <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'dm\')\">{{\'als Abfahrt/Ankunft übernehmen\' | translate}}</button>\r\n                    </div>\r\n                </div>\r\n                <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\" ng-if=\"usage===\'rop\'\">\r\n                    <div class=\"btn-group\" role=\"group\">\r\n                        <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'rop\')\">{{\'Stadtplanausschnitt anzeigen\' | translate}}</button>\r\n                    </div>\r\n                </div>\r\n                <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\" ng-if=\"usage===\'ttb\'\">\r\n                    <div class=\"btn-group\" role=\"group\">\r\n                        <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'ttb\')\">{{\'Fahrplanbuchseite anzeigen\' | translate}}</button>\r\n                    </div>\r\n                </div>\r\n                <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\" ng-if=\"usage===\'stt\'\">\r\n                    <div class=\"btn-group\" role=\"group\">\r\n                        <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'stt\')\">{{\'Aushangfahrplan anzeigen\' | translate}}</button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/map/popovers/livePosition.html","<div class=\"popup-content\">\r\n    <div class=\"popover-content\">\r\n        <h2 class=\"wicon\"><vvs-icon product-class=\"{{trans.productClass()}}\"></vvs-icon> {{trans.name()}} - {{trans.destination()|VVSLocationNameFormatter}} <span class=\"late\" ng-if=\"trans.properties().delay>0\">(+{{trans.properties().delay|VVSTravelledDurationFormatter}})</span></h2>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/map/popovers/mapType.html","<script type=\"text/ng-template\" id=\"mapTypePopoverTemplate\">\r\n    <div class=\"popup-content\">\r\n        <div class=\"innerpopup noheadline\">\r\n            <md-radio-group ng-model=\"MAP_OPTIONS.layers.type\" ng-change=\"VVSMapCtrl.triggerSwitchLayerClick(MAP_OPTIONS.layers.type)\">\r\n                <ul class=\"list-group nomargin popupradiolist\">\r\n                    <li class=\"list-group-item list-radio\" ng-show=\"((\'vvs.trip.init\'|isState)||(\'vvs.map\'|isState))\">\r\n                        <div class=\"radio\">\r\n                            <md-radio-button value=\"network\">{{\'Netzplan\' | translate}}</md-radio-button>\r\n                        </div>\r\n                    </li>\r\n                    <li class=\"list-group-item list-radio\">\r\n                        <div class=\"radio\">\r\n                            <md-radio-button value=\"gis\" checked>{{\'Karte\' | translate}}</md-radio-button>\r\n                        </div>\r\n                    </li>\r\n                    <li class=\"list-group-item list-radio\">\r\n                        <div class=\"radio\">\r\n                            <md-radio-button value=\"top\">{{\'Topkarte\' | translate}}</md-radio-button>\r\n                        </div>\r\n                    </li>\r\n                    <!--<li class=\"list-group-item list-radio\">\r\n                        <div class=\"radio\">\r\n                            <md-radio-button value=\"osm\">{{\'OSM\' | translate}}</md-radio-button>\r\n                        </div>\r\n                    </li>-->\r\n                    <li class=\"list-group-item list-radio\">\r\n                        <div class=\"radio\">\r\n                            <md-radio-button value=\"ortho\">{{\'Luftbild\' | translate}}</md-radio-button>\r\n                        </div>\r\n                    </li>\r\n                </ul>\r\n            </md-radio-group>\r\n        </div>\r\n    </div>\r\n</script>\r\n");
$templateCache.put("app/vvs.components/map/popovers/poi.html","<div class=\"popup-content fade bottom in\">\r\n    <div class=\"popover-content\">\r\n        <h2 class=\"wicon\"><vvs-icon name=\"{{getPoiIconName()}}\"></vvs-icon> {{location|VVSLocationNameFormatter}}</h2>\r\n        <div class=\"infobox\">\r\n            <div ng-repeat=\"(key, value) in location.properties()\">\r\n                <p ng-if=\"key==\'POI_ADDRESS\'\">{{value}}</p>\r\n                <p ng-if=\"key==\'CAB_AVAILABLE_BIKES\'\">{{\'Aktuell verfügbare Räder\'|translate}}: {{value}}</p>\r\n                <p ng-if=\"key==\'CAB_FREE_SLOTS\'\">{{\'Aktuell freie Stellplätze\'|translate}}: {{value}}</p>\r\n                <p ng-if=\"key==\'LINK\'\"><a href=\"{{value}}\" title=\"{{value|translate}}\" target=\"_blank\">{{value}}</a></p>\r\n            </div>\r\n        </div>\r\n        <div class=\"innerpopup\">\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit angefragter Uhrzeit\" role=\"group\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'orig\')\">{{\'als Start übernehmen\'|translate}}</button>\r\n                </div>\r\n            </div>\r\n            <br>\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'dest\')\">{{\'als Ziel übernehmen\'|translate}}</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/vvs.components/map/popovers/stop.html","<div class=\"popup-content fade bottom in\"z>\r\n    <div class=\"popover-content\">\r\n        <h2 class=\"wicon\"><vvs-icon name=\"haltestelle\"></vvs-icon> {{location|VVSLocationNameFormatter}}</h2>\r\n        <div ng-if=\"!hideDm\">\r\n            <table class=\"table trip\" ng-show=\"departures\">\r\n                <thead>\r\n                    <tr>\r\n                        <th>{{\'Uhrzeit\' | translate}}</th>\r\n                        <th>{{\'Linie\' | translate}}</th>\r\n                        <th>{{\'in Richtung\' | translate}}</th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody ng-init=\"getDepartures()\">\r\n                    <tr ng-repeat=\"dep in departures\">\r\n                        <td>{{dep.dateTimePlanned() | VVSTimeFormatter}}\r\n                            <vvs-real-time-icon mode=\"\'depArr\'\" dep-arr=\"dep\"></vvs-real-time-icon>\r\n                            <span class=\"late\" ng-if=\"dep.delay()>0\"></br>{{dep.dateTimeEstimated()|VVSTimeFormatter}}</span>\r\n                            <span class=\"late\" ng-if=\"dep.isCancelled()\"><br>{{\'Ausf.\'|translate}}</span>\r\n                        </td>\r\n                        <td>{{dep.transportation().number()}}</td>\r\n                        <td>{{dep.transportation().destination() | VVSLocationNameFormatter}}</td>\r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n            <p>{{\'Haltestellennummer\' | translate}}: {{location.id()}}</p>\r\n        </div>\r\n        <div ng-if=\"(usage===\'orig\')||(usage===\'dest\')||(usage===\'dm\')||(usage===\'rop\')||(usage===\'ttb\')||(usage===\'stt\')||(\'vvs.map\'|isState)\">\r\n            <div ng-if=\"(usage===\'orig\')||(usage===\'dest\')||(\'vvs.map\'|isState)\">\r\n                <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit angefragter Uhrzeit\" role=\"group\">\r\n                    <div class=\"btn-group \" role=\"group\">\r\n                        <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'orig\')\">{{\'als Start übernehmen\' | translate}}</button>\r\n                    </div>\r\n                </div>\r\n                <br>\r\n            </div>\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\" ng-if=\"(usage===\'orig\')||(usage===\'dest\')||(\'vvs.map\'|isState)\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'dest\')\">{{\'als Ziel übernehmen\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\" ng-if=\"usage===\'dm\'\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'dm\')\">{{\'als Abfahrt/Ankunft übernehmen\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\" ng-if=\"usage===\'rop\'\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'rop\')\">{{\'Stadtplanausschnitt anzeigen\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\" ng-if=\"usage===\'ttb\'\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'ttb\')\">{{\'Fahrplanbuchseite anzeigen\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\" ng-if=\"usage===\'stt\'\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'stt\')\">{{\'Aushangfahrplan anzeigen\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/map/popovers/unknown.html","<div class=\"popup-content\">\r\n    <div class=\"popover-content\">\r\n        <h2 class=\"wicon\"><vvs-icon type=\"{{location.type()}}\"></vvs-icon> {{location|VVSLocationNameFormatter}}</h2>\r\n        <div class=\"innerpopup\">\r\n            <div ng-if=\"(usage===\'orig\')||(usage===\'dest\')||(\'vvs.map\'|isState)\">\r\n                <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit angefragter Uhrzeit\" role=\"group\">\r\n                    <div class=\"btn-group \" role=\"group\">\r\n                        <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'orig\')\">{{\'als Start übernehmen\' | translate}}</button>\r\n                    </div>\r\n                </div>\r\n                <br>\r\n            </div>\r\n\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\" ng-if=\"(usage===\'orig\')||(usage===\'dest\')||(\'vvs.map\'|isState)\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'dest\')\">{{\'als Ziel übernehmen\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\" ng-if=\"usage===\'dm\'\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'dm\')\">{{\'als Abfahrt/Ankunft übernehmen\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\" ng-if=\"usage===\'rop\'\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'rop\')\">{{\'Stadtplanausschnitt anzeigen\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\" ng-if=\"usage===\'ttb\'\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'ttb\')\">{{\'Fahrplanbuchseite anzeigen\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\" ng-if=\"usage===\'stt\'\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"assignPopoverLocation(location, \'stt\')\">{{\'Aushangfahrplan anzeigen\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/vvs.components/odv/controls/departure-arrival.html","<div class=\"col-xs-4 nopadding-xs vvs-dep-arr-container\">\r\n    <label>&nbsp;</label>\r\n    <div class=\"btn-group btn-group-justified\" role=\"group\" aria-label=\"...\">\r\n        <div class=\"btn-group\" role=\"group\">\r\n            <button type=\"button\" class=\"btn btn-default md-raised md-button md-ink-ripple\" ng-class=\"{\'active\':SEARCH_OPTIONS.dateTime.isDeparture}\" ng-click=\"SEARCH_OPTIONS.dateTime.isDeparture=true\">{{\'Abfahrt\' | translate}}</button>\r\n        </div>\r\n        <div class=\"btn-group\" role=\"group\">\r\n            <button type=\"button\" class=\"btn btn-default md-raised md-button md-ink-ripple\" ng-class=\"{\'active\':!SEARCH_OPTIONS.dateTime.isDeparture}\" ng-click=\"SEARCH_OPTIONS.dateTime.isDeparture=false\">{{\'Ankunft\' | translate}}</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/odv/controls/main.html","<div class=\"ctblock col-xs-12 nopadding-xs spacertop spacerbottom\" role=\"group\" aria-label=\"Einstellungen\">\r\n    <!-- Nur NICHT mobil sichtbar, da es ja kein Modal geben soll -->\r\n    <div class=\"holder traveltime nopadding-xs hidden-xs\">\r\n        <div class=\"ctblock col-xs-12 nopadding-xs\">\r\n\r\n            <!-- include departure/arrival controls -->\r\n            <vvs-include vvs-src=\"odv/controls/departure-arrival.html\"></vvs-include>\r\n\r\n            <!-- include datePicker -->\r\n            <vvs-include vvs-src=\"odv/date/web.html\"></vvs-include>\r\n\r\n            <!-- include timePicker-->\r\n            <vvs-include vvs-src=\"odv/time/web.html\"></vvs-include>\r\n        </div>\r\n    </div>\r\n    <!--/.holder-->\r\n</div>\r\n");
$templateCache.put("app/vvs.components/odv/controls/switch-via.html","<div class=\"form-group text-center nomargin switches visible-sm\" ng-switch on=\"showVia\">\r\n    <button type=\"button\" class=\"btn btn-default btn-via\" ng-switch-when=\"false\" ng-click=\"tripCtrl.triggerToggleViaClick()\" title=\"{{\'Zwischenhaltestelle einblenden\'|translate}}\" tabindex=\"-1\">+</button>\r\n    <button type=\"button\" class=\"btn btn-default btn-via\" ng-switch-when=\"true\" ng-click=\"tripCtrl.triggerToggleViaClick()\" title=\"{{\'Zwischenhaltestelle ausblenden\'|translate}}\" tabindex=\"-1\">-</button>\r\n    <button type=\"button\" class=\"btn btn-default btn-switch\" ng-click=\"tripCtrl.triggerSwitchClick()\" title=\"{{\'Start und Ziel tauschen\'|translate}}\" tabindex=\"-1\">\r\n        <vvs-icon name=\"switch\"></vvs-icon>\r\n    </button>\r\n</div>\r\n<div class=\"form-group text-center switches hidden-sm\" ng-switch on=\"showVia\">\r\n    <button type=\"button\" class=\"btn btn-default btn-via\" ng-switch-when=\"false\" ng-click=\"tripCtrl.triggerToggleViaClick()\" title=\"{{\'Zwischenhaltestelle einblenden\'|translate}}\" tabindex=\"-1\">+</button>\r\n    <button type=\"button\" class=\"btn btn-default btn-via\" ng-switch-when=\"true\" ng-click=\"tripCtrl.triggerToggleViaClick()\" title=\"{{\'Zwischenhaltestelle ausblenden\'|translate}}\" tabindex=\"-1\">-</button>\r\n    <button type=\"button\" class=\"btn btn-default btn-switch\" ng-click=\"tripCtrl.triggerSwitchClick()\" title=\"{{\'Start und Ziel tauschen\'|translate}}\" tabindex=\"-1\">\r\n        <vvs-icon name=\"switch\"></vvs-icon>\r\n    </button>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/odv/controls/via-controls.html","<div>\r\n    <div class=\"input-group select attached\">\r\n        <span class=\"input-group-addon\" id=\"date-addon-desktop-an\">{{\'Aufenthalt\' | translate}}</span>\r\n        <select class=\"form-control text-right\" ng-model=\"SEARCH_OPTIONS.via.optionsListItem.dwellTime\" convert-to-number>\r\n            <option value=\"0\">{{\'0 Minuten\' | translate}}</option>\r\n            <option value=\"1\">{{\'1 Minute\' | translate}}</option>\r\n            <option value=\"2\">{{\'2 Minuten\' | translate}}</option>\r\n            <option value=\"3\">{{\'3 Minuten\' | translate}}</option>\r\n            <option value=\"4\">{{\'4 Minuten\' | translate}}</option>\r\n            <option value=\"5\">{{\'5 Minuten\' | translate}}</option>\r\n            <option value=\"10\">{{\'10 Minuten\' | translate}}</option>\r\n            <option value=\"15\">{{\'15 Minuten\' | translate}}</option>\r\n            <option value=\"20\">{{\'20 Minuten\' | translate}}</option>\r\n            <option value=\"30\">{{\'30 Minuten\' | translate}}</option>\r\n            <option value=\"45\">{{\'45 Minuten\' | translate}}</option>\r\n            <option value=\"60\">{{\'60 Minuten\' | translate}}</option>\r\n        </select>\r\n    </div>\r\n    <ul class=\"list-group list-toggle attached spacerbottom pl-0\">\r\n        <li class=\"list-group-item list-group-header header-standalone\">{{\'Umstieg und Durchfahrt an Haltest. ausschließen\' | translate}}\r\n            <md-switch aria-label=\"Umstieg und Durchfahrt an Haltest. ausschließen\" ng-model=\"SEARCH_OPTIONS.via.optionsListItem.enabled\" ng-true-value=\"false\" ng-false-value=\"true\"></md-switch>\r\n        </li>\r\n    </ul>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/odv/date/mobile.html","<div class=\"datePickerField ctblock col-xs-12 nopadding-xs visible-xs spacerbottomlarge\" ng-controller=\"VVSOdvDatePickerMobileController\">\r\n    <div class=\"input-group clickthrough visible-xs-table\" vvs-modal vvs-modal-template=\"modals/date-time-mobile.html\" vvs-modal-size=\"lg\">\r\n        <span class=\"input-group-addon\" id=\"zeit-addon\">{{\'Zeit\' | translate}}</span>\r\n        <input type=\"text\" class=\"form-control text-right\" value=\"{{SEARCH_OPTIONS.dateTime | VVSMobileDateTimeFormatter}}\" aria-describedby=\"zeit-addon\">\r\n        <span class=\"input-group-btn\">\r\n            <button class=\"btn btn-default\" type=\"button\" vvs-modal vvs-modal-template=\"modals/date-time-mobile.html\" vvs-modal-size=\"lg\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </button>\r\n        </span>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/odv/date/web.html","<div class=\"col-xs-5\" ng-controller=\"VVSOdvDatePickerWebController as ctrl\" ng-click=\"ctrl.isOpen=true\">\r\n    <label>{{\'Datum\'|translate}}</label>\r\n    <div class=\"input-group date-widget hasdatepicker\">\r\n        <md-datepicker class=\"form-control text-center\" ng-model=\"SEARCH_OPTIONS.dateTime.date\" md-placeholder=\"{{\'jetzt\'|translate}}\" md-is-open=\"ctrl.isOpen\" ng-click=\"ctrl.isOpen=true\" ng-change=\"ctrl.dateChanged()\" tabindex=\"-1\" md-hide-icons=\"triangle\"></md-datepicker>\r\n        <div class=\"controls\">\r\n            <button type=\"button\" class=\"dateup btn btn-link\" ng-click=\"ctrl.incDay()\" title=\"{{\'vorher\'|translate}}\" tabindex=\"-1\">\r\n                <vvs-icon name=\"up\"></vvs-icon>\r\n            </button>\r\n            <button type=\"button\" class=\"datedown btn btn-link\" ng-click=\"ctrl.decDay()\" title=\"{{\'nachher\'|translate}}\" tabindex=\"-1\">\r\n                <vvs-icon name=\"down\"></vvs-icon>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/odv/time/web.html","<div class=\"col-xs-3 nopadding-xs\">\r\n    <label>{{\'Uhrzeit\' | translate}}</label>\r\n    <input type=\"text\" class=\"form-control text-center\" vvs-time-picker ng-model=\"VVSOdvTimePickerCtrl.timeModel\" value=\"{{VVSOdvTimePickerCtrl.timeModel|VVSTimeFormatter}}\" ng-blur=\"VVSOdvTimePickerCtrl.timeChanged()\" ng-keydown=\"VVSOdvTimePickerCtrl.triggerKeyDown($event)\" maxlength=\"5\" required />\r\n</div>\r\n");
$templateCache.put("app/vvs.components/personalization/forgotten/confirm-password.html","\r\n\r\n\r\n<div class=\"col-xs-12 col-sm-12 col-md-12 content spacertoplarge\">\r\n    <form name=\"resetPasswordForm\" ng-submit=\"submitResetPasswordForm()\" novalidate>\r\n        <div class=\"col-xs-12 col-md-8 col-md-offset-2\">\r\n            <!-- <div class=\"ctblock col-xs-12 nopadding-xs infocus\" role=\"group\"> -->\r\n            <!-- <div class=\"ctblock col-xs-12 spacertoplarge\"> -->\r\n                <h2 class=\"function-header nopadding-xs\">{{\'Ein neues Passwort setzen\'|translate}}</h2>\r\n                <!-- <vvs-alert ng-if=\"invalidPasswordResettingInputsAlert\" text=\"\'Dieser Benutzername exisitiert nicht!\'\"></vvs-alert> -->\r\n            </div>\r\n            <div class=\"col-xs-12 col-md-8 col-md-offset-2\">\r\n                <div ng-class=\"{ \'has-error\' : resetPasswordForm.NewPassword.$invalid && !resetPasswordForm.NewPassword.$pristine }\">\r\n                    <label for=\"passwort\" class=\"nopadding-xs\">{{\'Passwort (mind. 6, max. 10 Zeichen)*\'|translate}}</label>\r\n                    <!-- required? -->\r\n                    <input ng-focus=\"resetPasswordForm.NewPassword = \'\';resetPasswordForm.confirmPassword=\'\' \" tabindex=\"11\" type=\"password\" class=\"form-control\" id=\"passwort\" name=\"NewPassword\" aria-label=\"Passwort\" ng-model=\"user.NewPassword\" ng-minlength=\"6\" ng-maxlength=\"15\">\r\n                </div>\r\n                <br>\r\n                <div ng-class=\"{ \'has-error\' : resetPasswordForm.confirmPassword.$invalid && !resetPasswordForm.confirmPassword.$pristine }\">\r\n                    <label for=\"passwort-again\" class=\"nopadding-xs\">{{\'Passwort bestätigen*\'|translate}}</label>\r\n                    <input tabindex=\"13\" type=\"password\" class=\"form-control\" id=\"passwort-again\" name=\"confirmPassword\" aria-label=\"Passwort bestätigen\" ng-model=\"user.confirmPassword\" ng-minlength=\"6\" ng-maxlength=\"15\" vvs-compare-password=\"user.NewPassword\">\r\n                </div>\r\n            </div>\r\n            <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacertoplarge\" role=\"group\" aria-label=\"save\">\r\n                <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                    <button style=\"margin-bottom: 10px;\" tabindex=\"25\" type=\"submit\" class=\"btn btn-primary btn-block\" ng-disabled=\"resetPasswordForm.$invalid\">{{\'Ein neues Passwort setzen \'|translate}}</button>\r\n                </div>\r\n            </div>\r\n    </form>\r\n\r\n\r\n</div>\r\n\r\n<style>\r\n\r\n     a.link {\r\n        font-size: 1.2rem;\r\n    }\r\n    .head-wrap {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .head-wrap ul.nav {\r\n        display: flex;\r\n        margin-bottom: 2.4rem;\r\n    }\r\n\r\n    input[type=password]:focus {\r\n        background: #efefef !important;\r\n        border:1px solid lightgrey;\r\n        border-radius:4px;\r\n    }\r\n</style>\r\n");
$templateCache.put("app/vvs.components/personalization/forgotten/confirm1.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <h2 class=\"function-header nopadding-xs\">{{\'Passwort vergessen\'|translate}}</h2>\r\n        <p class=\"info\">\r\n            <strong>{{\'Passwort wiederherstellen\'|translate}}</strong>\r\n        </p>\r\n        <p class=\"info\">{{\'Ihr Passwort wurde zurückgesetzt. Sie erhalten per E-Mail ein neues Passwort.\'|translate}}</p>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/personalization/forgotten/confirm2.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <h2 class=\"function-header nopadding-xs\">{{\'Passwort vergessen\'|translate}}</h2>\r\n        <p class=\"info\">{{\'Vielen Dank für Ihre Anfrage. \'|translate}}</p>\r\n        <p class=\"info\">{{\'Sie erhalten eine E-Mail mit Ihrem Benutzernamen sowie weiteren Informationen, um ein neues Passwort zu vergeben.\r\n            Ihre Anfrage muss manuell bearbeitet werden. Bitte haben Sie noch ein wenig Geduld\'|translate}}\r\n        </p>\r\n        <p class=\"info\">\r\n            {{\'Ihr VVS\'|translate}}\r\n        </p>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/personalization/forgotten/main1.html","<form name=\"forgottenForm\" ng-submit=\"submitForgottenForm()\" novalidate>\r\n    <div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n        <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n            <h2 class=\"function-header back nopadding-xs\">{{\'Passwort vergessen\'|translate}}<span><a href=\"javascript:void(0)\" ui-sref=\"vvs.personalization.login\">{{\'zurück\'|translate}}</a></span></h2>\r\n            <vvs-alert ng-if=\"invalidPasswordResettingInputsAlert\" text=\"\'Eine E-Mail mit den weiteren Instruktionen wurde verschickt.\'\"></vvs-alert>\r\n            <p class=\"info\">{{ \"Bitte geben Sie unten Ihre E-Mail-Adresse ein, um einen Link für die Zurücksetzung des Passworts zu erhalten.\"|translate}}</p>\r\n            <!-- <p class=\"info\">{{ \"Bitte geben Sie Ihre E-Mail Adresse ein. Danach erhalten Sie  eine E-Mail mit Ihrem neuen Passwort.\"|translate}}</p> -->\r\n        </div>\r\n        <div class=\"ctblock infocus col-xs-12 pl-0 pr-0\">\r\n            <div class=\"form-group\" ng-class=\"{ \'has-error\' : forgottenForm.Username.$invalid && !forgottenForm.Username.$pristine }\">\r\n                <label for=\"nickname\" class=\"nopadding-xs\">{{\'E-Mail*\'|translate}}</label>\r\n                <input tabindex=\"15\" type=\"email\" autofocus class=\"form-control\" name=\"Username\" id=\"nickname\" aria-label=\"Email\" ng-model=\"user.Username\" ng-minlength=\"6\" required>\r\n            </div>\r\n            <p class=\"info\">{{ \"Wenn es ein zugehöriges Konto zu dieser Adresse gibt, erhalten Sie eine E-Mail mit einem Link zum Zurücksetzen des Passworts.\"|translate}}</p>\r\n            <br>\r\n            <!-- <p class=\"info\">\r\n                {{\'Falls Sie Ihren Benutzernamen und Ihr Passwort vergessen haben, füllen Sie bitte folgendes\'|translate}} <a class=\"special\" href=\"javascript:void(0)\" ui-sref=\"vvs.personalization.forgottenSecond\">{{\'Formular\'|translate}}</a> {{\'aus.\'|translate}}\r\n            </p> -->\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"login\">\r\n            <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                <button tabindex=\"25\" type=\"submit\" ng-disabled=\"forgottenForm.$invalid\" class=\"btn btn-primary btn-block\">{{\'Anfordern\'|translate}}</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</form>\r\n\r\n<style>\r\n    p.info {\r\n        max-width: 90%;\r\n        font-size: 1.4rem;\r\n        line-height: 1.8rem;\r\n    }\r\n/*     h2.function-header {\r\n        font-weight: 700;\r\n    } */\r\n</style>\r\n\r\n");
$templateCache.put("app/vvs.components/personalization/forgotten/main2.html","<form name=\"forgottenForm\" ng-submit=\"submitForgottenForm()\" novalidate>\r\n    <div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n        <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n            <h2 class=\"function-header back nopadding-xs\">{{\'Passwort vergessen\'|translate}}<span><a href=\"javascript:void(0)\" ui-sref=\"vvs.personalization.login\">{{\'zurück\'|translate}}</a></span></h2>\r\n            <vvs-alert ng-if=\"invalidPasswordResettingInputsAlert\" text=\"\'Diese E-Mail-Adresse exisitiert nicht!\'\"></vvs-alert>\r\n            <p class=\"info\">{{\'Falls Sie Ihren Benutzernamen und Ihr Passwort vergessen haben, füllen Sie bitte folgendes Formular, soweit möglich, vollständig aus.\'|translate}}</p>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs\" role=\"group\">\r\n            <div class=\"col-xs-12 col-md-6 \">\r\n                <div class=\"form-group\">\r\n                    <div ng-class=\"{ \'has-error\' : forgottenForm.FirstName.$invalid && !forgottenForm.FirstName.$pristine }\">\r\n                        <label for=\"name\" class=\"nopadding-xs\">{{\'Vorname\'|translate}}</label>\r\n                        <input tabindex=\"10\" type=\"text\" class=\"form-control capitalize\" id=\"name\" name=\"FirstName\" aria-label=\"Vorname\" ng-model=\"user.FirstName\">\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : forgottenForm.Name.$invalid && !forgottenForm.Name.$pristine }\">\r\n                        <label for=\"surname\" class=\"nopadding-xs\">{{\'Nachname\'|translate}}</label>\r\n                        <input tabindex=\"11\" type=\"text\" class=\"form-control capitalize\" id=\"surname\" name=\"Name\" aria-label=\"Nachname\" ng-model=\"user.Name\">\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-md-6 \">\r\n                <div class=\"form-group\" ng-class=\"{ \'has-error\' : forgottenForm.Email.$invalid && !forgottenForm.Email.$pristine }\">\r\n                    <label for=\"email\" class=\"nopadding-xs\">{{\'E-Mail\'|translate}}*</label>\r\n                    <input tabindex=\"12\" type=\"email\" class=\"form-control\" id=\"email\" aria-label=\"E-Mail\" name=\"Email\" ng-model=\"user.Email\" required>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 spacerbottom\">\r\n            <p class=\"info\">{{\'* Pflichtfeld\'|translate}}</p>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"login\">\r\n            <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                <button tabindex=\"25\" type=\"submit\" class=\"btn btn-primary btn-block\" ng-disabled=\"forgottenForm.$invalid\">{{\'Anfordern\'|translate}}</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/vvs.components/personalization/init/main.html","<form name=\"profileForm\" ng-submit=\"submitProfileForm()\" novalidate>\r\n<!-- <form name=\"profileForm\" ng-submit=\"submitProfileForm()\" novalidate ng-if=\"profile\"> -->\r\n    <div class=\"col-xs-12 col-sm-12 col-md-12 content personalisation\">\r\n        <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n            <div class=\"head-wrap\">\r\n                <h2 class=\"nopadding-xs mt-0\">{{\'Service einrichten\'|translate}}\r\n                    <!-- <span><a href=\"javascript:void(0)\" ui-sref=\"vvs.personalization.login\">{{\'zurück\'|translate}}</a></span> -->\r\n                </h2>\r\n                <ul class=\"nav\">\r\n                    <li><a class=\"link\" href=\"#!/XSLT_PERSONALIZATION_REQUEST@profile\" title=\"Persönliche Daten ändern\" ui-sref=\"vvs.personalization.profile\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\"Pers. Daten\"|translate}}</a></li>\r\n                    <li><a ng-click=\"triggerLogoutClick()\" href=\"javascript:void(0)\" class=\"link\" ui-sref=\"vvs.personalization.login\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\'Abmelden\'|translate}}</a></li>\r\n                    <!-- <li><a href=\"#!/XSLT_PERSONALIZATION_REQUEST@login\" ui-sref=\"vvs.personalization.login\" class=\"link\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\'zurück\'|translate}}</a></li> -->\r\n                </ul>\r\n            </div>\r\n            <vvs-alert ng-if=\"profileChangedAlert\" text=\"\'Ihre Daten wurden erfolgreich aktualisiert.\'\"></vvs-alert>\r\n            <p class=\"info\">{{\'Mit dem Benachrichtigungsservice werden Sie informiert, wenn uns Informationen über geplante Fahrplanänderungen oder aktuelle Störungen für von Ihnen ausgewählte Linien oder Haltestellen vorliegen. Die aktuellen Informationen werden Ihnen per E-Mail zugesandt.\'|translate}} </p>\r\n            <!-- <p class=\"info\">{{\'Mit dem Benachrichtigungsservice werden Sie informiert, wenn uns Informationen über geplante Fahrplanänderungen oder aktuelle Störungen für von Ihnen ausgewählte Linien oder Haltestellen vorliegen. Die aktuellen Informationen werden Ihnen per E-Mail zugesandt. Da sich dieser Informationsservice derzeit noch im Aufbau befindet, können Meldungen über Störungen leider nur zu den Bürozeiten veröffentlicht werden. Wir arbeiten daran, den Service weiter auszubauen.\'|translate}} </p> -->\r\n            <br>\r\n            <p>\r\n                <a href=\"https://www.vvs.de/verkehrsmeldungen/allgemeine-informationen/\" target=\"blank\" title=\"Allgemeine Informationen\" class=\"link padding-md ng-binding\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon> {{ \'Allgemeine Informationen\'| translate}}\r\n                </a>\r\n            </p>\r\n        </div>\r\n        <br>\r\n        <!-- Benachrichtigungsservice de/aktivieren -->\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-md spacerbottom\">\r\n            <ul class=\"list-group list-toggle border pl-0\">\r\n                <li class=\"list-group-item no-icon\">{{\'Benachrichtigungsservice de/aktivieren\'|translate}}\r\n                    <md-switch aria-label=\"Benachrichtigung per E-Mail aktivieren / deaktivieren\" ng-model=\"notification.Active\" ng-change=\"submitProfileForm()\" name=\"Notification\"></md-switch>\r\n                    <!-- <md-switch aria-label=\"Benachrichtigung per E-Mail aktivieren / deaktivieren\" ng-model=\"notification.Active\" ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\" ng-change=\"submitProfileForm()\" name=\"Notification\"></md-switch> -->\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        <br>\r\n        <!--  Allgemeine Informationen -->\r\n        <h2 class=\"ng-binding\">{{ \'Allgemeine Informationen\'| translate}}</h2>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-md spacerbottom\">\r\n            <ul class=\"list-group list-toggle border spacerbottom pl-0\">\r\n                <li class=\"list-group-item no-icon\">{{\'Fahrplanwechsel, Streik etc.\'|translate}}\r\n                    <!-- <md-switch aria-label=\"Fahrplanwechsel, Streik etc.\" ng-model=\"notification.GenericMessages\" ng-true-value=\"\'true\'\" ng-false-value=\"\'false\'\" ng-change=\"submitProfileForm()\" name=\"Notification\"></md-switch> -->\r\n                    <md-switch ng-disabled=\"!notification.Active\" aria-label=\"Fahrplanwechsel, Streik etc.\" ng-model=\"notification.GenericMessages\" ng-change=\"submitProfileForm()\" name=\"Notification\"></md-switch>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12\">\r\n            <div class=\"col-xs-12 col-md-12 nopadding-xs\">\r\n                <!-- SWITCH BLOCK -->\r\n                <div class=\"col-xs-12 col-md-12 nopadding-xs\">\r\n                    <div class=\"spacerbottom\" ng-class=\"{ notClicable : !notification.Active}\">\r\n                        <h2 class=\"nopadding-xs lines-title\">{{\'Linienmeldungen\'|translate}}</h2>\r\n                        <span class=\"tooltip\">i\r\n                            <span class=\"tooltiptext\">{{\'Auswahl und Verwaltung von Linien zur Information über geplante Fahrplanänderungen und Störungen.\'|translate}}</span>\r\n                        </span>\r\n                        <div class=\"lines-block s-bahn\" ng-click=\"getLineList(sbahnCodeArr)\">\r\n                            <div class=\"lines-wrap\">\r\n                                <svg class=\"icon icon-sbahn\" product-icon-id=\"2\"><use xlink:href=\"app/vvs.components/assets/images/icons/symbol-defs.svg#icon-sbahn\" ></use></svg>\r\n                                <span>{{\'S-Bahn\'|translate}}</span>\r\n                            </div>\r\n                            <p>\r\n                                <span style=\"margin-right:10px;\" ng-if=\"selectedSbahnLines.length === 0\"> Keine </span>\r\n                                <span style=\"margin-right:10px;\" ng-if=\"allSbahnLinesSubscribed\">Alle</span>\r\n                                <span style=\"margin-right:10px;\" ng-if=\"!allSbahnLinesSubscribed && selectedSbahnLines.length > 0\">{{ selectedSbahnLines.length > 70 ? selectedSbahnLines.substring(0, 69) + \"...\" : selectedSbahnLines }} </span>\r\n                                <a href=\"javascript:void(0)\" title=\"{{\'S-Bahn\'|translate}}\">\r\n                                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                </a>\r\n                            </p>\r\n                        </div>\r\n                        <!-- r-bahn -->\r\n                        <div class=\"lines-block s-bahn\" ng-click=\"getLineList(rbahnCodeArr)\">\r\n                                <div class=\"lines-wrap\">\r\n                                    <svg class=\"icon icon-rbahn\" product-icon-id=\"6\"><use xlink:href=\"app/vvs.components/assets/images/icons/symbol-defs.svg#icon-rbahn\" ></use></svg>\r\n                                    <span>{{\'R-Bahn\'|translate}}</span>\r\n                                </div>\r\n                                <p>\r\n                                    <span style=\"margin-right:10px;\" ng-if=\"selectedRbahnLines.length === 0\"> Keine </span>\r\n                                    <span style=\"margin-right:10px;\" ng-if=\"allRbahnLinesSubscribed\">Alle</span>\r\n                                    <span style=\"margin-right:10px;\" ng-if=\"!allRbahnLinesSubscribed &&  selectedRbahnLines.length > 0\">{{ selectedRbahnLines.length > 70 ? selectedRbahnLines.substring(0, 69) + \"...\" : selectedRbahnLines }} </span>\r\n                                    <a href=\"javascript:void(0)\" title=\"{{\'R-Bahn\'|translate}}\">\r\n                                        <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                    </a>\r\n                                </p>\r\n                        </div>\r\n                        <!-- u-bahn -->\r\n                        <div class=\"lines-block s-bahn\" ng-click=\"getLineList(ubahnCodeArr)\">\r\n                            <div class=\"lines-wrap\">\r\n                                <svg class=\"icon icon-ubahn\" product-icon-id=\"1\"><use xlink:href=\"app/vvs.components/assets/images/icons/symbol-defs.svg#icon-ubahn\" ></use></svg>\r\n                                <span>{{\'Stadtbahn\'|translate}}</span>\r\n                            </div>\r\n                            <p>\r\n                                <span style=\"margin-right:10px;\" ng-if=\"selectedUbahnLines.length === 0\"> Keine </span>\r\n                                <span style=\"margin-right:10px;\" ng-if=\"allUbahnLinesSubscribed\">Alle</span>\r\n                                <span style=\"margin-right:10px;\" ng-if=\"!allUbahnLinesSubscribed && selectedUbahnLines.length > 0\">{{ selectedUbahnLines.length > 70 ? selectedUbahnLines.substring(0, 69) + \"...\" : selectedUbahnLines }} </span>\r\n                                <a href=\"javascript:void(0)\" title=\"{{\'U-Bahn\'|translate}}\">\r\n                                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                </a>\r\n                            </p>\r\n                        </div>\r\n                        <!-- bus -->\r\n                        <div class=\"lines-block bus\" ng-click=\"getLineList(busCodeArr)\">\r\n                            <div class=\"lines-wrap\">\r\n                                <svg class=\"icon icon-bus\" product-icon-id=\"3\"><use xlink:href=\"app/vvs.components/assets/images/icons/symbol-defs.svg#icon-bus\" ></use></svg>\r\n                                <span>{{\'Bus\'|translate}}</span>\r\n                            </div>\r\n                            <p>\r\n                                <span style=\"margin-right:10px;\" ng-if=\"selectedBusLines.length === 0\"> Keine </span>\r\n                                <span style=\"margin-right:10px;\" ng-if=\"allBusLinesSubscribed\">Alle</span>\r\n                                <span style=\"margin-right:10px;\" ng-if=\"!allBusLinesSubscribed &&  selectedBusLines.length > 0\">{{ selectedBusLines.length > 70 ? selectedBusLines.substring(0, 69) + \"...\" : selectedBusLines }} </span>\r\n                                <a href=\"javascript:void(0)\" title=\"{{\'busLines\'|translate}}\">\r\n                                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                </a>\r\n                            </p>\r\n                        </div>\r\n                    </div>\r\n        </div>\r\n        <div class=\"col-xs-12 col-md-12 nopadding-xs\">\r\n            <div class=\"spacerbottom\" ng-keydown=\"triggerKeyDown($event)\">\r\n\r\n\r\n                <h2 class=\"nopadding-xs lines-title\">{{\'Haltestelle hinzufügen\'|translate}}</h2>\r\n                <span class=\"tooltip\">i\r\n                    <span class=\"tooltiptext\">{{\'Auswahl und Verwaltung von Haltestellen zur Information über geplante Fahrplanänderungen und Störungen.\'|translate}}</span>\r\n                </span>\r\n                <vvs-alert ng-if=\"persAlert\" text=\"\'Bitte geben Sie einen Ort, Haltestelle, Adresse oder POI ein\'\"></vvs-alert>\r\n                <vvs-alert ng-if=\"persError\" text=\"\'Es ist ein Fehler aufgetreten\'\"></vvs-alert>\r\n                <vvs-alert ng-if=\"alreadySubscribed\" text=\"\'Sie haben diese Haltestelle schon abonniert\'\"></vvs-alert>\r\n                <input ng-disabled=\"!notification.Active\" vvs-location-name-formatter class=\"form-control\" ng-model=\"filter.searchValue\" ng-focus=\"triggerFocus()\"\r\n                ng-change=\"triggerChange()\"\r\n                ng-keydown=\"triggerKeyDown($event)\" ng-mousedown=\"triggerFocus()\" ng-model-options=\"modelOptions\"\r\n                tabindex=\"0\" type=\"text\"  placeholder=\"{{\'Haltestelle hinzufügen\'|translate}}\">\r\n\r\n                <md-content class=\"suggestion-wrapper\" ng-if=\"locations.length\">\r\n                    <md-virtual-repeat-container id=\"vertical-container\" class=\"ctblock col-xs-12 nopadding-xs\" ng-style=\"{height: resultHeight}\"\r\n                    ng-if=\"locations.length>0\">\r\n                      <div md-virtual-repeat=\"item in locations\" class=\"btn btn-default btn-block nopadding repeated-item\" flex ng-click=\"triggerStopSelect(item)\" ng-attr-autofocus=\"$first\">\r\n                        <div class=\"pull-left text-left\" ng-bind-html=\"item | VVSLocationSuggestIcon\">\r\n                        </div>\r\n                        <div class=\"pull-left text-left hideme\" ng-bind-html=\"item | VVSLocationSuggestFormatter\">\r\n\r\n                        </div>\r\n                      </div>\r\n                    </md-virtual-repeat-container>\r\n                </md-content>\r\n                <!-- Zugeordnete Haltestelle -> include assigned stops box -->\r\n                <div class=\"assign\" ng-show=\"inputLocations.dm.assignedStops().length>1\" ng-hide=\"!hideAsStops\">\r\n                    <vvs-assigned-stops location=\"inputLocations.dm\" usage=\"\'pers\'\" ng-if=\"inputLocations.dm.assignedStops().length>1\"></vvs-assigned-stops>\r\n                </div>\r\n                <!-- Zugeordnete Haltestelle -->\r\n\r\n                <!-- added stops  -->\r\n                <div style=\"margin-top:20px\" class=\"col-xs-12 nopadding-xs\">\r\n                    <table class=\"table monitor bs border-bottom\">\r\n                        <colgroup>\r\n                            <col width=\"4%\">\r\n                            <col width=\"86%\">\r\n                            <col width=\"10%\">\r\n                        </colgroup>\r\n                        <tbody>\r\n                            <tr ng-if=\"stops.length==0\">\r\n                                <td colspan=\"3\">{{\'Keine Haltestellen abonniert.\'|translate}}</td>\r\n                            </tr>\r\n                            <tr ng-repeat=\"stop in stops track by $index\">\r\n                                <td>{{$index+1}}</td>\r\n                                <td>\r\n                                    <vvs-icon name=\"haltestelle\"></vvs-icon> {{stop.Name}}\r\n                                </td>\r\n                                <td class=\"text-right\">\r\n                                    <a href=\"javascript:void(0)\" title=\"{{\'Löschen\'|translate}}\" ng-click=\"removeStop(stop.Id)\">\r\n                                        <vvs-icon name=\"loeschen\"></vvs-icon>\r\n                                    </a>\r\n                                </td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </div>\r\n\r\n            </div>\r\n\r\n    </div>\r\n    <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n</form>\r\n\r\n<style>\r\n\r\n    .assign {\r\n         transition: all ease 0.2s;\r\n    }\r\n    .assign.ng-hide {\r\n        transition: all ease 0.2s;\r\n        opacity: 0;\r\n        transform: scale(0.97);\r\n    }\r\n    .assign.ng-show {\r\n        transition: all ease 0.2s;\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n\r\n    h2.lines-title {\r\n        display: inline-block;\r\n    }\r\n    .lines-wrap .icon {\r\n        margin-right: 10px;\r\n    }\r\n    .lines-wrap {\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    .lines-block {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        padding: 10px;\r\n        border: 1px solid #efefef;\r\n        width: 100%;\r\n        font-size: 1.2rem;\r\n    }\r\n    .lines-block p {\r\n        margin: 0;\r\n    }\r\n    a.link {\r\n        font-size: 1.3rem;\r\n    }\r\n    .head-wrap {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .head-wrap ul.nav {\r\n        display: flex;\r\n        margin-bottom: 2.4rem;\r\n    }\r\n\r\n    @media screen and (max-width: 576px) {\r\n        .head-wrap ul.nav {\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n\r\n\r\n     /* TOOLTIP*/\r\n     span.tooltip {\r\n        top: 0px;\r\n        line-height: 15px;\r\n        position: relative;\r\n        text-align: center;\r\n        width: 15px;\r\n        height: 15px;\r\n        display: inline-block;\r\n        color: #fff;\r\n        background: #337ab7;\r\n        border: 1px solid #fff;\r\n        border-radius: 50%;\r\n        opacity: 100;\r\n        z-index: 1000;\r\n    }\r\n\r\n        .tooltip .tooltiptext {\r\n            visibility: hidden;\r\n            width: 250px;\r\n            background-color: #efefef;\r\n            color: #000;\r\n            text-align: center;\r\n            border-radius: 6px;\r\n            padding: 5px 0;\r\n            position: absolute;\r\n            z-index: 1;\r\n            bottom: 150%;\r\n            left: -18px;\r\n            border: 1px solid darkgrey;\r\n            margin-left: -101px;\r\n        }\r\n\r\n        .tooltip .tooltiptext::after {\r\n            content: \"\";\r\n            position: absolute;\r\n            top: 100%;\r\n            left: 50%;\r\n            margin-left: -5px;\r\n            border-width: 5px;\r\n            border-style: solid;\r\n            border-color: black transparent transparent transparent;\r\n        }\r\n        .tooltip:hover {\r\n            cursor: pointer;\r\n        }\r\n\r\n        .tooltip:hover .tooltiptext {\r\n            visibility: visible;\r\n        }\r\n        .lines-block:hover,\r\n        .lines-block:focus{\r\n            background: #e8e8e8b8;\r\n            cursor: pointer;\r\n            outline-color: transparent;\r\n        }\r\n        .form-control {\r\n            background: #f7f7f7;;\r\n        }\r\n        .form-control:focus {\r\n            border: 1px solid #e8e8e8;\r\n        }\r\n        .assigned-wrap button {\r\n            background: rgb(239, 239, 239);\r\n            display: flex;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n            border: none;\r\n            border: 1px solid lightgrey;\r\n            border-radius: 10px;\r\n            margin-bottom: 4px;\r\n        }\r\n        .assigned-wrap button:hover {\r\n            border: 1px solid lightgrey;\r\n        }\r\n        .assigned-top {\r\n            display: flex;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n        }\r\n        .assigned-wrap button.close {\r\n            justify-content: center;\r\n            align-items: center;\r\n            background: none;\r\n            border: none !important;\r\n        }\r\n        .assigned-wrap .close span:focus {\r\n            outline-color: none !important;\r\n            border: none !important;\r\n        }\r\n        .assigned-wrap button.close span {\r\n            width: 30px;\r\n            height: 30px;\r\n            background: lightgray;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            opacity: 0.6;\r\n            transition: 0.3s;\r\n        }\r\n        .assigned-wrap button.close span:hover {\r\n            border: 1px solid lightslategray;\r\n            opacity: 1;\r\n            border-radius: 3px;\r\n        }\r\n        .notClicable {\r\n            background: #eee;\r\n            pointer-events: none;\r\n        }\r\n</style>\r\n");
$templateCache.put("app/vvs.components/personalization/login/main.html","<form name=\"loginForm\" ng-submit=\"submitLoginForm()\" novalidate>\r\n    <div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n        <div class=\"input-wrap infocus col-xs-12 spacerbottom pl-0 pr-0\">\r\n            <vvs-alert ng-if=\"invalidLoginInputsAlert\" text=\"\'Die eingegebene E-Mail-Adresse oder das Passwort ist falsch!\'\"></vvs-alert>\r\n            <vvs-alert ng-if=\"logoutAlert\" text=\"\'Sie haben sich erfolgreich abgemeldet\'\"></vvs-alert>\r\n            <vvs-alert ng-if=\"profileIsActivated\" text=\"\'Ihre E-Mail-Adresse wurde erfolgreich verifiziert. Sie können sich nun anmelden.\'\"></vvs-alert>\r\n            <!-- <vvs-alert ng-if=\"passwordIsSentFirst\" text=\"\'Bitte überprüfen Sie Ihr E-Mail-Postfach. Um die Zurücksetzung abzuschließen, klicken Sie bitte auf den Link, der in der Nachricht angegeben ist.\'\"></vvs-alert> -->\r\n            <vvs-alert ng-if=\"passwordIsSentFirst\" text=\"\'Eine E-Mail mit den weiteren Instruktionen wurde verschickt.\'\"></vvs-alert>\r\n            <vvs-alert ng-if=\"passwordIsSentSecond\" text=\"\'Ihr Passwort wurde zurückgesetzt. Sie können sich nun anmelden.\'\"></vvs-alert>\r\n            <!-- <vvs-alert ng-if=\"passwordIsSentFirst\" text=\"\'Ihr Passwort wurde zurückgesetzt. Sie erhalten per E-Mail ein neues Passwort.\'\"></vvs-alert> -->\r\n            <h2 class=\"function-header back wrap-xs ng-binding\">{{\'Anmeldung\'|translate}}</h2>\r\n\r\n            <p class=\"info wrap-xs\"> {{\'Mit dem kostenfreien Benachrichtigungsservice bieten wir Ihnen eine komfortable Möglichkeit, sich automatisch über alle Fahrplanänderungen und uns bekannte aktuelle Störungen auf beliebigen Linien per E-Mail informieren zu lassen. Alternativ bieten wir diesen Service als Push-Dienst in der kostenfreien\'|translate}} <a class=\"special\" href=\"https://www.vvs.de/vvs-app\" target=\"_blank\">{{\'VVS-APP\'|translate}}</a> {{\'für Smartphones (Android / iPhone).\'|translate}}\r\n                <br>\r\n                <br> {{\'Wenn Sie noch keinen Zugang haben, können Sie sich für den Benachrichtigungsservice\'|translate}} <a href=\"javascript:void(0)\">{{\'registrieren\'|translate}}</a>. {{\'Das Angebot ist für Sie kostenlos\'|translate}}.</p>\r\n\r\n            <div class=\"form-group spacertop\">\r\n                <div ng-class=\"{ \'has-error\' : loginForm.Username.$invalid && !loginForm.Username.$pristine }\" class=\"col-xs-12 col-md-6\">\r\n                    <label for=\"nickname\" class=\"nopadding-xs\">{{\'E-Mail\'|translate}}</label>\r\n                    <input tabindex=\"15\" type=\"email\" class=\"form-control\" name=\"Username\" id=\"nickname\" aria-label=\"Email\" ng-model=\"user.Username\" required>\r\n                </div>\r\n                <!-- <div ng-class=\"{ \'has-error\' : loginForm.Username.$invalid && !loginForm.Username.$pristine }\" class=\"col-xs-12 col-md-6\">\r\n                    <label for=\"nickname\" class=\"nopadding-xs\">{{\'Benutzername\'|translate}}</label>\r\n                    <input value=\"user.Username\" tabindex=\"10\" type=\"text\" class=\"form-control\" name=\"Username\" id=\"nickname\"\r\n                            aria-label=\"Benutzername\" ng-model=\"user.Username\"  ng-minlength=\"6\" required/>\r\n                </div> -->\r\n                <div ng-class=\"{ \'has-error\' : loginForm.Password.$invalid && !loginForm.Password.$pristine }\" class=\"col-xs-12 col-md-6 mt\">\r\n                    <label for=\"password\" class=\"nopadding-xs\">{{\'Passwort\'|translate}}</label>\r\n                    <input tabindex=\"16\" type=\"password\" class=\"form-control\" name=\"Password\" id=\"password\"\r\n                           aria-label=\"Passwort\" ng-model=\"user.Password\" ng-minlength=\"6\" ng-maxlength=\"15\" required/>\r\n                </div>\r\n                <div class=\"col-xs-6 col-md-6 pull-left\">\r\n                    <br>\r\n                    <label class=\"fwn checkbox-wrap\" for=\"rememberMe\">{{\'Angemeldet bleiben\'|translate}}\r\n                        <input ng-init=\"localStorage.checkbox = true\" type=\"checkbox\" value=\"isRememberMe\" id=\"rememberMe\" ng-model=\"user.isRemembered\" autofocus ng-checked=\"localStorage.checkbox\" />\r\n                        <span class=\"checkmark\"></span>\r\n                    </label>\r\n                </div>\r\n                <div class=\"col-xs-6 col-md-6 pull-right text-xs-right\">\r\n                    <br>\r\n                    <span class=\'link\'>\r\n                        <a  ui-sref=\"vvs.personalization.forgottenFirst\" class=\"ng-binding\">{{\'Passwort vergessen\'|translate}}?</a>\r\n                    </span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge ctblockReset\" role=\"group\" aria-label=\"login\">\r\n            <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                <!-- <button tabindex=\"25\"  type=\"submit\" class=\"btn btn-primary btn-block\" ng-disabled=\"loginForm.$invalid\">{{\'Anmelden\'|translate}}</button> -->\r\n                <button tabindex=\"17\" ng-click=\"isRememberMe()\" type=\"submit\" class=\"btn btn-primary btn-block login_btn\" ng-disabled=\"loginForm.$invalid\">{{\'Anmelden\'|translate}}</button>\r\n            </div>\r\n        </div>\r\n        <div class=\"buttonlist col-xs-12 pl-0 pr-0\" role=\"group\" aria-label=\"Benachrichtigungsservice\">\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.personalization.registration\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    {{\'Registrierung\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n            <!-- <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.personalization.forgottenFirst\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    {{\'Passwort vergessen\'|translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button> -->\r\n        </div>\r\n        <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n    </div>\r\n</form>\r\n\r\n<style>\r\n\r\n    label {\r\n        font-weight: bold;\r\n    }\r\n    .link {\r\n        font-size: 1.4rem; /*  14px */\r\n    }\r\n    .fwn {\r\n        font-weight: normal;\r\n    }\r\n\r\n    @media (max-width: 960px) {\r\n      .text-xs-right {\r\n        text-align: right;\r\n       }\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n        .mt {\r\n         margin-top: 1.5rem;\r\n        }\r\n    }\r\n    .login_btn {\r\n        margin-bottom: 1.5rem;\r\n    }\r\n\r\n    /* .pull-right {\r\n        text-align: right;\r\n    } */\r\n</style>\r\n");
$templateCache.put("app/vvs.components/personalization/lines/bus.html","<div ng-controller=\"VVSPersonalizationInitController\" class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <!-- <md-progress-linear md-mode=\"indeterminate\"></md-progress-linear> -->\r\n    <!-- <div class=\"loader\"></div> -->\r\n\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <vvs-nav-block title=\"Linienabos verwalten\"></vvs-nav-block>\r\n        <vvs-alert ng-if=\"persAlert\" text=\"\'Bitte geben Sie eine Linie ein!\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"persError\" text=\"\'Es ist ein Fehler aufgetreten!\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"alreadySubscribed\" text=\"\'Sie sind für diese Linie schon abonniert!\'\"></vvs-alert>\r\n    </div>\r\n    <div class=\"col-xs-12 input-wrap-xs\" ng-show=\"isLoading\">\r\n        <div class=\"progress col-xs-12 input-wrap-xs infocus\">\r\n            <div class=\"progress-value\">Bitte warten...</div>\r\n        </div>\r\n    </div>\r\n    <div class=\"input-wrap-xs infocus col-xs-12 pl-0 pr-0\">\r\n        <div class=\"form-group spacerbottomlarge\">\r\n            <input type=\"text\" ng-change=\"filterData(filter.searchValue)\" ng-model=\"filter.searchValue\"\r\n                placeholder=\"{{ \'Bus Linie suchen\'|translate}}\">\r\n        </div>\r\n    </div>\r\n    <div class=\"col-xs-12 nopadding-xs padding-md\">\r\n        <table class=\"table monitor bs border-bottom\">\r\n            <colgroup>\r\n                <col width=\"90%\">\r\n                <col width=\"10%\">\r\n            </colgroup>\r\n            <thead>\r\n                <tr>\r\n                    <td class=\"allLine_left\">\r\n                        <span>\r\n                            <vvs-icon id=\"allLines\" style=\"margin-left:.8rem;\" product-icon-id=\"3\"></vvs-icon>\r\n                            <strong>{{ \'Bus\' | translate }}</strong>\r\n                        </span>\r\n                        <span>\r\n                            {{\'Alle Linien abonnieren\'|translate}}\r\n                            <!-- <span style=\"color: darkred; font-size: 0.9rem;\">Nicht enpfohlen</span> -->\r\n                        </span>\r\n                    </td>\r\n                    <td class=\"text-right\">\r\n                        <md-switch ng-model=\"switchAll.flagBus\"\r\n                            ng-change=\"switchSubscribeAllLines(switchAll.flagBus, \'bus\')\"></md-switch>\r\n                    </td>\r\n                </tr>\r\n                <!-- delete all lines TO DO-->\r\n                <!-- <tr>\r\n                    <td class=\"allLine_left\">\r\n                        <span>\r\n                            <vvs-icon id=\"allLines\" style=\"margin-left:.8rem;\" product-icon-id=\"3\"></vvs-icon><strong>{{ \'Bus\' | translate }}</strong>\r\n                        </span>\r\n                        <span>\r\n                            {{\'Alle Bus Linien löschen\'|translate}}\r\n                        </span>\r\n                    </td>\r\n                    <td class=\"text-right\">\r\n                        <md-switch ng-model=\"switchModel.deleteAllBusFlag\" ng-true-value=\" \'1\' \" ng-false-value=\" \'0\' \"\r\n                        ng-change=\"removeAllLines(\'bus\')\"></md-switch>\r\n                    </td>\r\n                </tr> -->\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-if=\"bus.length==0\">\r\n                    <td colspan=\"3\">{{\'Keine Linien vorhanden.\'|translate}}</td>\r\n                </tr>\r\n                <tr ng-if=\"line.productIconId() === 3 || line.productIconId() === 13\"\r\n                    ng-repeat=\"line in filter.searchValue ? filteredBusData : busLines track by $index\">\r\n                    <td>\r\n                        <vvs-icon product-icon-id=\"{{line.productIconId()}}\"></vvs-icon>{{ \'Bus\' | translate }}\r\n                        <span ng-bind-html=\"line | VVSLineListFormatter\"></span>\r\n                    </td>\r\n                    <td class=\"text-right\">\r\n                        <md-switch ng-model=\"line.isAbonated\"\r\n                            ng-change=\"switchSubscribeLine(\'bus\', line, line.isAbonated)\"></md-switch>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n\r\n\r\n<style>\r\n    .progress {\r\n        background: #ff6600;\r\n        justify-content: flex-start;\r\n        /* border-radius: 100px; */\r\n        align-items: center;\r\n        position: relative;\r\n        padding: 0 5px;\r\n        display: flex;\r\n        height: 40px;\r\n        width: 100%;\r\n        border-radius: 25px;\r\n    }\r\n\r\n    .progress-value {\r\n        text-transform: uppercase;\r\n        font-weight: 700;\r\n        text-align: center;\r\n        animation: load 3s normal forwards;\r\n        box-shadow: 0 10px 40px -10px #fff;\r\n        border-radius: 100px;\r\n        background: #fff;\r\n        height: 30px;\r\n        line-height: 30px;\r\n        width: 0;\r\n        color: #000;\r\n        letter-spacing: 1px;\r\n    }\r\n\r\n    @keyframes load {\r\n        0% {\r\n            width: 0;\r\n        }\r\n\r\n        100% {\r\n            width: 100%;\r\n        }\r\n    }\r\n</style>");
$templateCache.put("app/vvs.components/personalization/lines/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <h2 class=\"nopadding-xs\">{{\'Linienabos verwalten\'|translate}}</h2>\r\n        <vvs-alert ng-if=\"persAlert\" text=\"\'Bitte geben Sie eine Linie ein!\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"persError\" text=\"\'Es ist ein Fehler aufgetreten!\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"alreadySubscribed\" text=\"\'Sie sind für diese Linie schon abonniert!\'\"></vvs-alert>\r\n    </div>\r\n    <div class=\"input-wrap-xs infocus col-xs-12 pl-0 pr-0\">\r\n        <div class=\"form-group spacerbottomlarge\">\r\n            <vvs-line-odv usage=\"pers\"></vvs-line-odv>\r\n        </div>\r\n    </div>\r\n    <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"search\">\r\n        <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n            <button type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"triggerSubscribeToLineClick()\">{{\'Anfordern\'|translate}}</button>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-xs-12 nopadding-xs padding-md\">\r\n        <table class=\"table monitor bs border-bottom\">\r\n            <colgroup>\r\n                <col width=\"90%\">\r\n                <col width=\"10%\">\r\n            </colgroup>\r\n            <thead>\r\n                <tr class=\"visible-md visible-lg\">\r\n                    <th>{{\'Abonnierte Linien\'|translate}}</th>\r\n                    <th class=\"text-right\">\r\n                        <a href=\"javascript:void(0)\" title=\"{{\'Alle löschen\'|translate}}\" ng-click=\"removeAllLines()\">\r\n                            <vvs-icon name=\"loeschen\"></vvs-icon>\r\n                        </a>\r\n                    </th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-if=\"lines.length==0\">\r\n                    <td colspan=\"3\">{{\'Keine Linien vorhanden.\'|translate}}</td>\r\n                </tr>\r\n                <tr ng-repeat=\"line in lines track by $index\">\r\n                    <td>\r\n                        <vvs-icon product-icon-id=\"{{line.Symbol}}\"></vvs-icon> {{line.Name}} - {{line.Description}}\r\n                    </td>\r\n                    <td class=\"text-right\">\r\n                        <a href=\"javascript:void(0)\" title=\"{{\'Löschen\'|translate}}\">\r\n                            <vvs-icon name=\"loeschen\" ng-click=\"removeLine(line.Id, true)\"></vvs-icon>\r\n                        </a>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n    <!-- include history box -->\r\n    <vvs-history mode=\"line\" usage=\"pers\"></vvs-history>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/personalization/lines/rbahn.html","<div ng-controller=\"VVSPersonalizationInitController\" class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <vvs-nav-block title=\"Linienabos verwalten\"></vvs-nav-block>\r\n        <vvs-alert ng-if=\"persAlert\" text=\"\'Bitte geben Sie eine Linie ein!\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"persError\" text=\"\'Es ist ein Fehler aufgetreten!\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"alreadySubscribed\" text=\"\'Sie sind für diese Linie schon abonniert!\'\"></vvs-alert>\r\n    </div>\r\n    <div class=\"col-xs-12 input-wrap-xs\" ng-show=\"isLoading\">\r\n        <div class=\"progress col-xs-12 input-wrap-xs infocus\">\r\n            <div class=\"progress-value\">Bitte warten...</div>\r\n        </div>\r\n    </div>\r\n    <div class=\"input-wrap-xs infocus col-xs-12 pl-0 pr-0\">\r\n        <div class=\"form-group spacerbottomlarge\">\r\n           <input type=\"text\" ng-change=\"filterData(filter.searchValue)\" ng-model=\"filter.searchValue\" placeholder=\"{{ \'R-Bahn Linie suchen\'|translate}}\">\r\n        </div>\r\n    </div>\r\n    <div class=\"col-xs-12 nopadding-xs padding-md\">\r\n        <table class=\"table monitor bs border-bottom\">\r\n            <colgroup>\r\n                <col width=\"90%\">\r\n                <col width=\"10%\">\r\n            </colgroup>\r\n            <thead>\r\n                <tr>\r\n                    <td class=\"allLine_left\">\r\n                        <span>\r\n                            <vvs-icon id=\"allLines\" style=\"margin-left:.8rem;\" product-icon-id=\"6\"></vvs-icon><strong>R-Bahn</strong>\r\n                        </span>\r\n                        <span>\r\n                            {{\'Alle Linien abonnieren\'|translate}}\r\n                        </span>\r\n                    </td>\r\n                     <!-- subscribe all lines  -->\r\n                     <td class=\"text-right\">\r\n                        <md-switch ng-model=\"switchAll.flagRbahn\"\r\n                        ng-change=\"switchSubscribeAllLines(switchAll.flagRbahn, \'rbahn\')\"></md-switch>\r\n                    </td>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-if=\"rbahnLines.length==0\">\r\n                    <td colspan=\"3\">{{\'Keine Linien vorhanden.\'|translate}}</td>\r\n                </tr>\r\n                <tr ng-if=\"line.productIconId() === 6\" ng-repeat=\"line in filter.searchValue ? filteredRbahnData : rbahnLines track by $index\">\r\n                    <td>\r\n                        <vvs-icon product-icon-id=\"6\"></vvs-icon>{{ \'R-Bahn\' | translate }}\r\n                        <span ng-bind-html=\"line | VVSLineListFormatter\"></span>\r\n                    </td>\r\n                    <td class=\"text-right\">\r\n                        <md-switch ng-model=\"line.isAbonated\" ng-change=\"switchSubscribeLine(\'rbahn\', line, line.isAbonated)\"></md-switch>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n\r\n</div>\r\n\r\n<style>\r\n    .progress {\r\n        background: #ff6600;\r\n        justify-content: flex-start;\r\n        /* border-radius: 100px; */\r\n        align-items: center;\r\n        position: relative;\r\n        padding: 0 5px;\r\n        display: flex;\r\n        height: 40px;\r\n        width: 100%;\r\n        border-radius: 25px;\r\n    }\r\n\r\n    .progress-value {\r\n        text-transform: uppercase;\r\n        font-weight: 700;\r\n        text-align: center;\r\n        animation: load 3s normal forwards;\r\n        box-shadow: 0 10px 40px -10px #fff;\r\n        border-radius: 100px;\r\n        background: #fff;\r\n        height: 30px;\r\n        line-height: 30px;\r\n        width: 0;\r\n        color: #000;\r\n        letter-spacing: 1px;\r\n    }\r\n\r\n    @keyframes load {\r\n        0% {\r\n            width: 0;\r\n        }\r\n\r\n        100% {\r\n            width: 100%;\r\n        }\r\n    }\r\n</style>");
$templateCache.put("app/vvs.components/personalization/lines/sbahn.html","<div ng-controller=\"VVSPersonalizationInitController\" class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <!-- <h2 class=\"function-header nopadding-xs\">{{\'Linienabos verwalten\'|translate}}</h2> -->\r\n        <vvs-nav-block title=\"Linienabos verwalten\"></vvs-nav-block>\r\n        <!-- <vvs-assigned-stops></vvs-assigned-stops> -->\r\n        <vvs-alert ng-if=\"persAlert\" text=\"\'Bitte geben Sie eine Linie ein!\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"persError\" text=\"\'Es ist ein Fehler aufgetreten!\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"alreadySubscribed\" text=\"\'Sie sind für diese Linie schon abonniert!\'\"></vvs-alert>\r\n    </div>\r\n    <div class=\"input-wrap-xs infocus col-xs-12 pl-0 pr-0\">\r\n        <div class=\"form-group spacerbottomlarge\">\r\n           <input type=\"text\" ng-change=\"filterData(filter.searchValue)\" ng-model=\"filter.searchValue\" placeholder=\"{{ \'S-Bahn Linie suchen\'|translate}}\">\r\n        </div>\r\n    </div>\r\n        <!-- ABONIERTE LINIEN MIT DEM MD-SWITCH -->\r\n    <div class=\"col-xs-12 nopadding-xs padding-md\">\r\n        <table class=\"table monitor bs border-bottom\">\r\n            <colgroup>\r\n                <col width=\"90%\">\r\n                <col width=\"10%\">\r\n            </colgroup>\r\n            <thead>\r\n                 <!-- subscribe all sbahn lines -->\r\n                <tr>\r\n                    <td class=\"allLine_left\">\r\n                        <span>\r\n                            <vvs-icon id=\"allLines\" style=\"margin-left:.8rem;\" product-icon-id=\"2\"></vvs-icon><strong>S-Bahn</strong>\r\n                        </span>\r\n                        <span>\r\n                            {{\'Alle Linien abonnieren\'|translate}}\r\n                        </span>\r\n                    </td>\r\n                    <td class=\"text-right\">\r\n                        <md-switch ng-model=\"switchAll.flagSbahn\"\r\n                        ng-change=\"switchSubscribeAllLines(switchAll.flagSbahn, \'sbahn\')\"></md-switch>\r\n                    </td>\r\n                </tr>\r\n                <!-- delete all sbahn lines  -->\r\n                <!-- <tr>\r\n                    <td class=\"allLine_left\">\r\n                        <span>\r\n                            <vvs-icon id=\"allLines\" style=\"margin-left:.8rem;\" product-icon-id=\"2\"></vvs-icon><strong>S-Bahn</strong>\r\n                        </span>\r\n                        <span>\r\n                            {{\'Alle S-Bahn Linien löschen\'|translate}}\r\n                        </span>\r\n                    </td>\r\n                    <td class=\"text-right\">\r\n                        <md-switch ng-model=\"switchModel.deleteAllSbahnFlag\" ng-true-value=\" \'1\' \" ng-false-value=\" \'0\' \"\r\n                        ng-change=\"removeAllLines(\'sbahn\')\"></md-switch>\r\n                    </td>\r\n                </tr> -->\r\n            </thead>\r\n\r\n            <tbody>\r\n                <tr ng-if=\"sbahnLines.length==0\">\r\n                    <td colspan=\"3\">{{\'Keine Linien vorhanden.\'|translate}}</td>\r\n                </tr>\r\n                <tr ng-if=\"line.productIconId() === 2\" ng-repeat=\"line in filter.searchValue ? filteredSbahnData : sbahnLines track by $index\">\r\n                    <td>\r\n                        <vvs-icon product-icon-id=\"2\"></vvs-icon>{{ \'S-Bahn\' | translate }}\r\n                        <span ng-bind-html=\"line | VVSLineListFormatter\"></span>\r\n                    </td>\r\n\r\n                    <td class=\"text-right\">\r\n                        <md-switch ng-model=\"line.isAbonated\" ng-change=\"switchSubscribeLine(\'sbahn\', line, line.isAbonated)\"></md-switch>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/vvs.components/personalization/lines/ubahn.html","<div ng-controller=\"VVSPersonalizationInitController\" class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <vvs-nav-block title=\"Linienabos verwalten\"></vvs-nav-block>\r\n        <vvs-alert ng-if=\"persAlert\" text=\"\'Bitte geben Sie eine Linie ein!\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"persError\" text=\"\'Es ist ein Fehler aufgetreten!\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"alreadySubscribed\" text=\"\'Sie sind für diese Linie schon abonniert!\'\"></vvs-alert>\r\n    </div>\r\n    <div class=\"input-wrap-xs infocus col-xs-12 pl-0 pr-0\">\r\n        <div class=\"form-group spacerbottomlarge\">\r\n           <input type=\"text\" ng-change=\"filterData(filter.searchValue)\" ng-model=\"filter.searchValue\" placeholder=\"{{ \'Stadtbahn Linie suchen\'|translate}}\">\r\n        </div>\r\n    </div>\r\n    <div class=\"col-xs-12 nopadding-xs padding-md\">\r\n        <table class=\"table monitor bs border-bottom\">\r\n            <colgroup>\r\n                <col width=\"90%\">\r\n                <col width=\"10%\">\r\n            </colgroup>\r\n            <thead>\r\n                <tr>\r\n                    <td class=\"allLine_left\">\r\n                        <span>\r\n                            <vvs-icon id=\"allLines\" style=\"margin-left:.8rem;\" product-icon-id=\"1\"></vvs-icon><strong>Stadtbahn</strong>\r\n                        </span>\r\n                        <span>\r\n                            {{\'Alle Linien abonnieren\'|translate}}\r\n                        </span>\r\n                    </td>\r\n                    <td class=\"text-right\">\r\n                        <md-switch ng-model=\"switchAll.flagUbahn\"\r\n                        ng-change=\"switchSubscribeAllLines(switchAll.flagUbahn, \'ubahn\')\"></md-switch>\r\n                    </td>\r\n                </tr>\r\n            </thead>\r\n\r\n            <tbody>\r\n                <tr ng-if=\"ubahnLines.length==0\">\r\n                    <td colspan=\"3\">{{\'Keine Linien vorhanden.\'|translate}}</td>\r\n                </tr>\r\n                <tr ng-if=\"line.productIconId() === 1 || line.productIconId() === 11 || line.productIconId() === 9\" ng-repeat=\"line in filter.searchValue ? filteredUbahnData : ubahnLines track by $index\">\r\n                    <td>\r\n                        <vvs-icon product-icon-id=\"{{line.productIconId()}}\"></vvs-icon>\r\n                        <span ng-if=\"line.productIconId() === 11\">{{ \'Zahnradbahn\' | translate }}</span>\r\n                        <span ng-if=\"line.productIconId() === 9\">{{ \'Seilbahn\' | translate }}</span>\r\n                        <span ng-if=\"line.productIconId() != 9 && line.productIconId() != 11\">{{ \'Stadtbahn\' | translate }}</span>\r\n                        <span ng-bind-html=\"line | VVSLineListFormatter\"></span>\r\n                    </td>\r\n                    <td class=\"text-right\">\r\n                        <md-switch ng-model=\"line.isAbonated\" ng-change=\"switchSubscribeLine(\'ubahn\', line, line.isAbonated)\"></md-switch>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/vvs.components/personalization/profile/main-email.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <div class=\"head-wrap\">\r\n            <h2 class=\"function-header nopadding-xs\">{{\'E-Mail-Adresse ändern\'|translate}}</h2>\r\n            <ul class=\"nav\">\r\n                <li><a href=\"#!/XSLT_PERSONALIZATION_REQUEST@profile\" ui-sref=\"vvs.personalization.profile\" class=\"link\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\'zurück\'|translate}}</a></li>\r\n                <li><a class=\"link\" href=\"#!/XSLT_PERSONALIZATION_REQUEST@profile\" title=\"Persönliche Daten ändern\" ui-sref=\"vvs.personalization.profile\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\"Pers. Daten\"|translate}}</a></li>\r\n                <li><a ng-click=\"triggerLogoutClick()\" href=\"javascript:void(0)\" class=\"link\" ui-sref=\"vvs.personalization.login\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\'Abmelden\'|translate}}</a></li>\r\n            </ul>\r\n        </div>\r\n        <vvs-alert ng-if=\"personalDataChangedError\" text=\"\'Es ist ein Fehler aufgetreten.\'\"></vvs-alert>\r\n        <!-- <vvs-alert ng-if=\"personalDataChangedAlert\" text=\"\'Die Daten wurden aktualisiert.\'\"></vvs-alert> -->\r\n        <vvs-alert ng-if=\"emailChangedAlert\" text=\"\'Ihre Änderungen wurden gespeichert. Sie erhalten eine Bestätigunsemail. Bitte verwenden Sie beim nächsten Anmelden die neue E-Mail-Adresse.\'\"></vvs-alert>\r\n    </div>\r\n\r\n    <form name=\"personalDataForm\" ng-submit=\"submitPersonalDataForm()\" novalidate>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs infocus\" role=\"group\">\r\n            <div class=\"padding-md padding-xs padding-lg\">\r\n                <p><span class=\"email\">{{\'E-Mail\'|translate}}: <span ng-model=\"personalData.Username\">{{ personalData.Username }}</span></span></p>\r\n            </div>\r\n            <div class=\"col-xs-12 col-md-6\" style=\"display: none;\">\r\n                <div class=\"form-group\">\r\n                    <!-- old email  -->\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.Username.$invalid && !personalDataForm.Username.$pristine }\">\r\n                        <label for=\"nickname-old\" class=\"nopadding-xs\">{{\'Aktuelle E-Mail\'|translate}}</label>\r\n                        <input tabindex=\"10\" type=\"text\" class=\"form-control\" id=\"nickname-old\" name=\"Username\" aria-label=\"Aktuelle E-Mail\" value=\"personalData.Username\" ng-model=\"personalData.Username\" disabled>\r\n                    </div>\r\n                   <!--  <div ng-class=\"{ \'has-error\' : personalDataForm.Username.$invalid && !personalDataForm.Username.$pristine }\">\r\n                        <label for=\"nickname\" class=\"nopadding-xs\">{{\'E-Mail\'|translate}}</label>\r\n                        <input tabindex=\"10\" type=\"text\" class=\"form-control vvs-disabled\" id=\"nickname\" name=\"Username\" aria-label=\"Benutzername\" ng-model=\"personalData.Username\" ng-minlength=\"6\" disabled>\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.Password.$invalid && !personalDataForm.Password.$pristine }\">\r\n                        <label for=\"passwort-old\" class=\"nopadding-xs\">{{\'Altes Passwort*\'|translate}}</label>\r\n                        <input tabindex=\"11\" type=\"password\" class=\"form-control\" id=\"oldpasswort\" name=\"Password\" aria-label=\"Altes Passwort\" ng-model=\"personalData.Password\" ng-minlength=\"6\" ng-maxlength=\"15\">\r\n                    </div> -->\r\n                   <!--  <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.NewPassword.$invalid && !personalDataForm.NewPassword.$pristine }\">\r\n                        <label for=\"passwort\" class=\"nopadding-xs\">{{\'Passwort (mind. 6, max. 10 Zeichen)*\'|translate}}</label>\r\n                        <input tabindex=\"12\" type=\"password\" class=\"form-control\" id=\"passwort\" name=\"NewPassword\" aria-label=\"Passwort\" ng-model=\"personalData.NewPassword\" ng-minlength=\"6\" ng-maxlength=\"15\">\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.confirmPassword.$invalid && !personalDataForm.confirmPassword.$pristine }\">\r\n                        <label for=\"passwort-again\" class=\"nopadding-xs\">{{\'Passwort wiederholen*\'|translate}}</label>\r\n                        <input tabindex=\"13\" type=\"password\" class=\"form-control\" id=\"passwort-again\" name=\"confirmPassword\" aria-label=\"Passwort wiederholen\" ng-model=\"personalData.confirmPassword\" ng-minlength=\"6\" ng-maxlength=\"15\" vvs-compare-password=\"personalData.NewPassword\">\r\n                    </div> -->\r\n                </div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-md-6\">\r\n                <div class=\"form-group\">\r\n                    <!-- new email  -->\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.NewUsername.$invalid && !personalDataForm.NewUsername.$pristine }\">\r\n                        <label for=\"nickname\" class=\"nopadding-xs\">{{\'Neue E-Mail\'|translate}}</label>\r\n                        <input tabindex=\"10\" type=\"text\" class=\"form-control\" id=\"nickname\" name=\"NewUsername\" aria-label=\"Neue E-Mail\" ng-model=\"personalData.NewUsername\" ng-minlength=\"6\">\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-md-6 \">\r\n                <div class=\"form-group\">\r\n                        <!-- repeat new email -->\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.ConfirmUsername.$invalid && !personalDataForm.ConfirmUsername.$pristine }\">\r\n                        <label for=\"nickname-again\" class=\"nopadding-xs\">{{\'Neue E-Mail wiederholen\'|translate}}</label>\r\n                        <input tabindex=\"10\" type=\"text\" class=\"form-control\" id=\"nickname-again\" name=\"ConfirmUsername\" aria-label=\"Neue E-Mail wiederholen\" ng-model=\"personalData.ConfirmUsername\" ng-minlength=\"6\">\r\n                    </div>\r\n\r\n                    <!-- <div ng-class=\"{ \'has-error\' : personalDataForm.FirstName.$invalid && !personalDataForm.FirstName.$pristine }\">\r\n                        <label for=\"name\" class=\"nopadding-xs\">{{\'Vorname*\'|translate}}</label>\r\n                        <input tabindex=\"14\" type=\"text\" class=\"form-control capitalize\" id=\"name\" name=\"FirstName\" aria-label=\"Vorname\" ng-model=\"personalData.FirstName\" required>\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.LastName.$invalid && !personalDataForm.LastName.$pristine }\">\r\n                        <label for=\"surname\" class=\"nopadding-xs\">{{\'Nachname*\'|translate}}</label>\r\n                        <input tabindex=\"15\" type=\"text\" class=\"form-control capitalize\" id=\"surname\" name=\"Name\" aria-label=\"Nachname\" ng-model=\"personalData.LastName\" required>\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.Email.$invalid && !personalDataForm.Email.$pristine }\">\r\n                        <label for=\"email\" class=\"nopadding-xs\">{{\'E-Mail* **\'|translate}}</label>\r\n                        <input tabindex=\"16\" type=\"email\" class=\"form-control vvs-disabled\" id=\"email\" name=\"Email\" aria-label=\"E-Mail\" ng-model=\"personalData.Email\" required disabled>\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.Phone.$invalid && !personalDataForm.Phone.$pristine }\">\r\n                        <label for=\"name\" class=\"nopadding-xs\">{{\'Telefonnummer\'|translate}}</label>\r\n                        <input tabindex=\"17\" type=\"text\" class=\"form-control capitalize\" name=\"Phone\" id=\"name\" aria-label=\"Vorname\" ng-model=\"personalData.Phone\">\r\n                    </div> -->\r\n                </div>\r\n            </div>\r\n        </div>\r\n    <!--     <div class=\"ctblock col-xs-12 spacerbottom\">\r\n            <p class=\"info\">{{\'* Pflichtfeld\'|translate}}\r\n                <br> {{\'** Zum Ändern der Mailadresse bitte Nachricht an\'|translate}} <a class=\"special\" href=\"mailto:efa-service@vvs.de\">efa-service@vvs.de</a> {{\'schicken.\'|translate}}\r\n            </p>\r\n        </div> -->\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"save\">\r\n            <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                <button style=\"margin-bottom: 10px;\" tabindex=\"25\" type=\"submit\" class=\"btn btn-primary btn-block\" ng-disabled=\"personalDataForm.$invalid\">{{\'Änderung speichern\'|translate}}</button>\r\n            </div>\r\n        </div>\r\n        <div class=\"padding-md padding-xs padding-lg\">\r\n            <p style=\"font-size: 1.2rem;\">{{ \'Wenn Sie sich das nächste Mal anmelden, verwenden Sie die neue E-Mail Adresse\'| translate }}</p>\r\n        </div>\r\n    </form>\r\n\r\n</div>\r\n\r\n<style>\r\n\r\n     a.link {\r\n        font-size: 1.2rem;\r\n    }\r\n    .head-wrap {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .head-wrap ul.nav {\r\n        display: flex;\r\n        margin-bottom: 2.4rem;\r\n    }\r\n    span.email {\r\n        font-size: 1.3rem;\r\n    }\r\n</style>\r\n");
$templateCache.put("app/vvs.components/personalization/profile/main-oldversion copy.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <div class=\"head-wrap\">\r\n            <h2 class=\"function-header nopadding-xs\">{{\'Persönliche Daten ändern\'|translate}}</h2>\r\n            <ul class=\"nav\">\r\n                <li><a href=\"#!/XSLT_PERSONALIZATION_REQUEST@init\" ui-sref=\"vvs.personalisation.init\" class=\"link\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\'zurück\'|translate}}</a></li>\r\n                <li><a class=\"link\" href=\"#!/XSLT_PERSONALIZATION_REQUEST@profile\" title=\"Persönliche Daten ändern\" ui-sref=\"vvs.personalization.profile\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\"Pers. Daten\"|translate}}</a></li>\r\n                <li><a ng-click=\"triggerLogoutClick()\" href=\"javascript:void(0)\" class=\"link\" ui-sref=\"vvs.personalization.login\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\'Abmelden\'|translate}}</a></li>\r\n            </ul>\r\n        </div>\r\n\r\n        <vvs-alert ng-if=\"personalDataChangedError\" text=\"\'Es ist ein Fehler aufgetreten.\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"personalDataChangedAlert\" text=\"\'Die Daten wurden aktualisiert.\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"passwordChangedAlert\" text=\"\'Passwort wurde aktualisiert.\'\"></vvs-alert>\r\n    </div>\r\n\r\n    <form name=\"personalDataForm\" ng-submit=\"submitPersonalDataForm()\" novalidate>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs infocus\" role=\"group\">\r\n            <div class=\"col-xs-12 col-md-6 \">\r\n                <div class=\"form-group\">\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.Username.$invalid && !personalDataForm.Username.$pristine }\">\r\n                        <label for=\"nickname\" class=\"nopadding-xs\">{{\'E-Mail\'|translate}}</label>\r\n                        <input tabindex=\"10\" type=\"text\" class=\"form-control vvs-disabled\" id=\"nickname\" name=\"Username\" aria-label=\"Benutzername\" ng-model=\"personalData.Username\" ng-minlength=\"6\" disabled>\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.Password.$invalid && !personalDataForm.Password.$pristine }\">\r\n                        <label for=\"passwort-old\" class=\"nopadding-xs\">{{\'Altes Passwort*\'|translate}}</label>\r\n                        <input tabindex=\"11\" type=\"password\" class=\"form-control\" id=\"oldpasswort\" name=\"Password\" aria-label=\"Altes Passwort\" ng-model=\"personalData.Password\" ng-minlength=\"6\" ng-maxlength=\"15\">\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.NewPassword.$invalid && !personalDataForm.NewPassword.$pristine }\">\r\n                        <label for=\"passwort\" class=\"nopadding-xs\">{{\'Passwort (mind. 6, max. 10 Zeichen)*\'|translate}}</label>\r\n                        <input tabindex=\"12\" type=\"password\" class=\"form-control\" id=\"passwort\" name=\"NewPassword\" aria-label=\"Passwort\" ng-model=\"personalData.NewPassword\" ng-minlength=\"6\" ng-maxlength=\"15\">\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.confirmPassword.$invalid && !personalDataForm.confirmPassword.$pristine }\">\r\n                        <label for=\"passwort-again\" class=\"nopadding-xs\">{{\'Passwort wiederholen*\'|translate}}</label>\r\n                        <input tabindex=\"13\" type=\"password\" class=\"form-control\" id=\"passwort-again\" name=\"confirmPassword\" aria-label=\"Passwort wiederholen\" ng-model=\"personalData.confirmPassword\" ng-minlength=\"6\" ng-maxlength=\"15\" vvs-compare-password=\"personalData.NewPassword\">\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-md-6 \">\r\n                <div class=\"form-group\">\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.FirstName.$invalid && !personalDataForm.FirstName.$pristine }\">\r\n                        <label for=\"name\" class=\"nopadding-xs\">{{\'Vorname*\'|translate}}</label>\r\n                        <input tabindex=\"14\" type=\"text\" class=\"form-control capitalize\" id=\"name\" name=\"FirstName\" aria-label=\"Vorname\" ng-model=\"personalData.FirstName\" required>\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.LastName.$invalid && !personalDataForm.LastName.$pristine }\">\r\n                        <label for=\"surname\" class=\"nopadding-xs\">{{\'Nachname*\'|translate}}</label>\r\n                        <input tabindex=\"15\" type=\"text\" class=\"form-control capitalize\" id=\"surname\" name=\"Name\" aria-label=\"Nachname\" ng-model=\"personalData.LastName\" required>\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.Email.$invalid && !personalDataForm.Email.$pristine }\">\r\n                        <label for=\"email\" class=\"nopadding-xs\">{{\'E-Mail* **\'|translate}}</label>\r\n                        <input tabindex=\"16\" type=\"email\" class=\"form-control vvs-disabled\" id=\"email\" name=\"Email\" aria-label=\"E-Mail\" ng-model=\"personalData.Email\" required disabled>\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.Phone.$invalid && !personalDataForm.Phone.$pristine }\">\r\n                        <label for=\"name\" class=\"nopadding-xs\">{{\'Telefonnummer\'|translate}}</label>\r\n                        <input tabindex=\"17\" type=\"text\" class=\"form-control capitalize\" name=\"Phone\" id=\"name\" aria-label=\"Vorname\" ng-model=\"personalData.Phone\">\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 spacerbottom\">\r\n            <p class=\"info\">{{\'* Pflichtfeld\'|translate}}\r\n                <br> {{\'** Zum Ändern der Mailadresse bitte Nachricht an\'|translate}} <a class=\"special\" href=\"mailto:efa-service@vvs.de\">efa-service@vvs.de</a> {{\'schicken.\'|translate}}\r\n            </p>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"save\">\r\n            <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                <button tabindex=\"25\" type=\"submit\" class=\"btn btn-primary btn-block\" ng-disabled=\"personalDataForm.$invalid\">{{\'Speichern\'|translate}}</button>\r\n            </div>\r\n        </div>\r\n    </form>\r\n\r\n    <form name=\"deleteProfileForm\" novalidate>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-md spacertoplarge\">\r\n            <ul class=\"list-group list-toggle border nomargin\">\r\n                <li class=\"list-group-item no-icon\">{{\'Mein Profil löschen\'|translate}}\r\n                    <md-switch aria-label=\"Mein Profil löschen\" ng-model=\"deleteProfileData.deleteProfile\" name=\"deleteProfile\" required></md-switch>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 spacerbottom\">\r\n            <p class=\"info\">{{\'Bitte bestätigen Sie, dass Sie ihr Profil löschen möchten!\'|translate}}</p>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"delete\">\r\n            <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                <!--<button tabindex=\"30\" type=\"submit\" class=\"btn btn-primary btn-block\" ng-disabled=\"(deleteProfileForm.$invalid) && (!deleteProfileData.deleteProfile)\">{{\'Löschen\'|translate}}</button>-->\r\n                <button tabindex=\"30\" vvs-modal vvs-modal-size=\"sm\" vvs-modal-template=\"personalization/profile/modal.html\" class=\"btn btn-primary btn-block\" ng-disabled=\"(deleteProfileForm.$invalid) && (!deleteProfileData.deleteProfile)\">{{\'Löschen\'|translate}}</button>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</div>\r\n\r\n<style>\r\n     a.link {\r\n        font-size: 1.2rem;\r\n    }\r\n    .head-wrap {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .head-wrap ul.nav {\r\n        display: flex;\r\n        margin-bottom: 2.4rem;\r\n    }\r\n</style>\r\n");
$templateCache.put("app/vvs.components/personalization/profile/main-password.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <div class=\"head-wrap\">\r\n            <h2 class=\"function-header nopadding-xs\">{{\'Passwort ändern\'|translate}}</h2>\r\n            <ul class=\"nav\">\r\n                <li><a href=\"#!/XSLT_PERSONALIZATION_REQUEST@profile\" ui-sref=\"vvs.personalization.profile\" class=\"link\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\'zurück\'|translate}}</a></li>\r\n                <li><a class=\"link\" href=\"#!/XSLT_PERSONALIZATION_REQUEST@profile\" title=\"Persönliche Daten ändern\" ui-sref=\"vvs.personalization.profile\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\"Pers. Daten\"|translate}}</a></li>\r\n                <li><a ng-click=\"triggerLogoutClick()\" href=\"javascript:void(0)\" class=\"link\" ui-sref=\"vvs.personalization.login\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\'Abmelden\'|translate}}</a></li>\r\n            </ul>\r\n        </div>\r\n        <vvs-alert ng-if=\"personalDataChangedError\" text=\"\'Eingabe stimmt nicht mit dem aktuellen Passwort überein. \'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"personalDataChangedAlert\" text=\"\'Ihre Änderungen wurden gespeichert. Bitte verwenden Sie beim nächsten Anmelden Ihr neues Passwort.\'\"></vvs-alert>\r\n        <!-- <vvs-alert ng-if=\"passwordChangedAlert\" text=\"\'Passwort wurde aktualisiert.\'\"></vvs-alert> -->\r\n    </div>\r\n\r\n    <form name=\"personalDataForm\" ng-submit=\"submitPersonalDataForm()\" novalidate>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs infocus\" role=\"group\">\r\n            <div class=\"col-xs-12 col-md-6 \">\r\n                <div class=\"form-group\">\r\n                   <!--  <div ng-class=\"{ \'has-error\' : personalDataForm.NewUsername.$invalid && !personalDataForm.NewUsername.$pristine }\">\r\n                        <label for=\"nickname\" class=\"nopadding-xs\">{{\'Neue E-Mail\'|translate}}</label>\r\n                        <input tabindex=\"10\" type=\"text\" class=\"form-control\" id=\"nickname\" name=\"NewUsername\" aria-label=\"Neue E-Mail\" ng-model=\"personalData.NewUsername\" ng-minlength=\"6\">\r\n                    </div> -->\r\n                  <!--   <div ng-class=\"{ \'has-error\' : personalDataForm.Username.$invalid && !personalDataForm.Username.$pristine }\">\r\n                        <label for=\"nickname\" class=\"nopadding-xs\">{{\'E-Mail\'|translate}}</label>\r\n                        <input tabindex=\"10\" type=\"text\" class=\"form-control vvs-disabled\" id=\"nickname\" name=\"Username\" aria-label=\"Benutzername\" ng-model=\"personalData.Username\" ng-minlength=\"6\" disabled>\r\n                    </div>\r\n                    <br> -->\r\n                    <div ng-class=\"{ \'has-error\' : (personalDataForm.Password.$invalid && !personalDataForm.Password.$pristine) }\">\r\n                    <!-- <div ng-class=\"{ \'has-error\' : (personalDataForm.Password.$invalid && !personalDataForm.Password.$pristine) || personalDataChangedError }\"> -->\r\n                        <label for=\"passwort-old\" class=\"nopadding-xs\">{{\'Aktuelles Passwort*\'|translate}}</label>\r\n                        <input tabindex=\"11\" type=\"password\" class=\"form-control\" id=\"oldpasswort\" name=\"Password\" aria-label=\"Aktuelles Passwort\" ng-model=\"personalData.Password\" ng-minlength=\"6\" ng-maxlength=\"15\">\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.NewPassword.$invalid && !personalDataForm.NewPassword.$pristine }\">\r\n                        <label for=\"passwort\" class=\"nopadding-xs\">{{\'Neues Passwort\'|translate}}</label>\r\n                        <span class=\"tooltip\">i\r\n                            <span class=\"tooltiptext\">mind. 6, max. 10 Zeichen</span>\r\n                        </span>\r\n                        <!-- <label for=\"passwort\" class=\"nopadding-xs\">{{\'Passwort (mind. 6, max. 10 Zeichen)*\'|translate}}</label> -->\r\n                        <input tabindex=\"12\" type=\"password\" class=\"form-control\" id=\"passwort\" name=\"NewPassword\" aria-label=\"Passwort\" ng-model=\"personalData.NewPassword\" ng-minlength=\"6\" ng-maxlength=\"10\">\r\n                    </div>\r\n           <!--          <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.confirmPassword.$invalid && !personalDataForm.confirmPassword.$pristine }\">\r\n                        <label for=\"passwort-again\" class=\"nopadding-xs\">{{\'Passwort wiederholen*\'|translate}}</label>\r\n                        <input tabindex=\"13\" type=\"password\" class=\"form-control\" id=\"passwort-again\" name=\"confirmPassword\" aria-label=\"Passwort wiederholen\" ng-model=\"personalData.confirmPassword\" ng-minlength=\"6\" ng-maxlength=\"15\" vvs-compare-password=\"personalData.NewPassword\">\r\n                    </div> -->\r\n                </div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-md-6 \">\r\n                <div class=\"form-group\">\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.confirmPassword.$invalid && !personalDataForm.confirmPassword.$pristine }\">\r\n                        <label for=\"passwort-again\" class=\"nopadding-xs\">{{\'Neues Passwort wiederholen*\'|translate}}</label>\r\n                        <input tabindex=\"13\" type=\"password\" class=\"form-control\" id=\"passwort-again\" name=\"confirmPassword\" aria-label=\"Passwort wiederholen\" ng-model=\"personalData.confirmPassword\" ng-minlength=\"6\" ng-maxlength=\"15\" vvs-compare-password=\"personalData.NewPassword\">\r\n                    </div>\r\n                  <!--   <div ng-class=\"{ \'has-error\' : personalDataForm.ConfirmUsername.$invalid && !personalDataForm.ConfirmUsername.$pristine }\">\r\n                        <label for=\"nickname-again\" class=\"nopadding-xs\">{{\'Neue E-Mail wiederholen\'|translate}}</label>\r\n                        <input tabindex=\"10\" type=\"text\" class=\"form-control\" id=\"nickname-again\" name=\"ConfirmUsername\" aria-label=\"Neue E-Mail wiederholen\" ng-model=\"personalData.ConfirmUsername\" ng-minlength=\"6\">\r\n                    </div> -->\r\n\r\n\r\n                    <!-- <div ng-class=\"{ \'has-error\' : personalDataForm.FirstName.$invalid && !personalDataForm.FirstName.$pristine }\">\r\n                        <label for=\"name\" class=\"nopadding-xs\">{{\'Vorname*\'|translate}}</label>\r\n                        <input tabindex=\"14\" type=\"text\" class=\"form-control capitalize\" id=\"name\" name=\"FirstName\" aria-label=\"Vorname\" ng-model=\"personalData.FirstName\" required>\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.LastName.$invalid && !personalDataForm.LastName.$pristine }\">\r\n                        <label for=\"surname\" class=\"nopadding-xs\">{{\'Nachname*\'|translate}}</label>\r\n                        <input tabindex=\"15\" type=\"text\" class=\"form-control capitalize\" id=\"surname\" name=\"Name\" aria-label=\"Nachname\" ng-model=\"personalData.LastName\" required>\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.Email.$invalid && !personalDataForm.Email.$pristine }\">\r\n                        <label for=\"email\" class=\"nopadding-xs\">{{\'E-Mail* **\'|translate}}</label>\r\n                        <input tabindex=\"16\" type=\"email\" class=\"form-control vvs-disabled\" id=\"email\" name=\"Email\" aria-label=\"E-Mail\" ng-model=\"personalData.Email\" required disabled>\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : personalDataForm.Phone.$invalid && !personalDataForm.Phone.$pristine }\">\r\n                        <label for=\"name\" class=\"nopadding-xs\">{{\'Telefonnummer\'|translate}}</label>\r\n                        <input tabindex=\"17\" type=\"text\" class=\"form-control capitalize\" name=\"Phone\" id=\"name\" aria-label=\"Vorname\" ng-model=\"personalData.Phone\">\r\n                    </div> -->\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 spacerbottom\">\r\n            <p class=\"info\">{{\'* Pflichtfeld\'|translate}}\r\n            </p>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"save\">\r\n            <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                <button style=\"margin-bottom: 10px;\" tabindex=\"25\" type=\"submit\" class=\"btn btn-primary btn-block\" ng-disabled=\"personalDataForm.$invalid\">{{\'Änderung speichern\'|translate}}</button>\r\n            </div>\r\n        </div>\r\n        <br>\r\n        <div class=\"padding-md padding-xs padding-lg\">\r\n            <p style=\"font-size: 1.3rem;\">{{ \'Wenn Sie sich das nächste Mal anmelden, verwenden Sie das neue Passwort\'| translate }}</p>\r\n        </div>\r\n    </form>\r\n\r\n</div>\r\n\r\n<style>\r\n     a.link {\r\n        font-size: 1.2rem;\r\n    }\r\n    .head-wrap {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .head-wrap ul.nav {\r\n        display: flex;\r\n        margin-bottom: 2.4rem;\r\n    }\r\n    /* TOOLTIP*/\r\n    span.tooltip {\r\n        position: relative;\r\n        text-align: center;\r\n        font-style: italic;\r\n        width: 15px;\r\n        height: 15px;\r\n        display: inline-block;\r\n        color: #fff;\r\n        background: #337ab7;\r\n        border: 1px solid #fff;\r\n        border-radius: 50%;\r\n        opacity: 100;\r\n}\r\n\r\n        .tooltip .tooltiptext {\r\n            visibility: hidden;\r\n            width: 200px;\r\n            background-color: #efefef;\r\n            color: #000;\r\n            text-align: center;\r\n            border-radius: 6px;\r\n            padding: 5px 0;\r\n            position: absolute;\r\n            z-index: 1;\r\n            bottom: 150%;\r\n            left: 50%;\r\n            border: 1px solid darkgrey;\r\n            margin-left: -101px;\r\n        }\r\n\r\n        .tooltip .tooltiptext::after {\r\n            content: \"\";\r\n            position: absolute;\r\n            top: 100%;\r\n            left: 50%;\r\n            margin-left: -5px;\r\n            border-width: 5px;\r\n            border-style: solid;\r\n            border-color: black transparent transparent transparent;\r\n        }\r\n        .tooltip:hover {\r\n            cursor: pointer;\r\n        }\r\n\r\n        .tooltip:hover .tooltiptext {\r\n            visibility: visible;\r\n        }\r\n        @media only screen and (max-width: 768px) {\r\n            .head-wrap {\r\n                display: flex;\r\n                flex-direction: column-reverse;\r\n                align-items: unset;\r\n            }\r\n            .tooltip .tooltiptext {\r\n                width: 200px;\r\n                background-color: #efefef;\r\n                color: #000;\r\n                text-align: center;\r\n                border-radius: 6px;\r\n                padding: 18px 0;\r\n                position: absolute;\r\n                z-index: 1;\r\n                bottom: 150%;\r\n                left: 0;\r\n                top: -12px;\r\n                border: 1px solid darkgrey;\r\n                margin-left: 19px;\r\n                line-height: 0;\r\n            }\r\n\r\n            .tooltip .tooltiptext::after {\r\n                content: \"\";\r\n                position: absolute;\r\n                top: 50%;\r\n                left: -6px;\r\n                margin-top: -5px;\r\n                border-width: 5px;\r\n                border-style: solid;\r\n                border-color: transparent #00000078 transparent transparent;\r\n            }\r\n        }\r\n</style>\r\n");
$templateCache.put("app/vvs.components/personalization/profile/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <div class=\"head-wrap\">\r\n            <h2 class=\"function-header nopadding-xs\">{{\'Persönliche Daten ändern\'|translate}}</h2>\r\n            <ul class=\"nav\">\r\n                <li><a href=\"javascript:window.history.back();\" class=\"link\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\'zurück\'|translate}}</a></li>\r\n                <li><a class=\"link\" href=\"#!/XSLT_PERSONALIZATION_REQUEST@profile\" title=\"Persönliche Daten ändern\" ui-sref=\"vvs.personalization.profile\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\"Pers. Daten\"|translate}}</a></li>\r\n                <li><a ng-click=\"triggerLogoutClick()\" href=\"javascript:void(0)\" class=\"link\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\'Abmelden\'|translate}}</a></li>\r\n            </ul>\r\n        </div>\r\n\r\n        <vvs-alert ng-if=\"personalDataChangedError\" text=\"\'Es ist ein Fehler aufgetreten.\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"personalDataChangedAlert\" text=\"\'Die Daten wurden aktualisiert.\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"passwordChangedAlert\" text=\"\'Passwort wurde aktualisiert.\'\"></vvs-alert>\r\n    </div>\r\n    <div class=\"ctblock col-xs-12 content-wrap\">\r\n        <div>\r\n            <p>\r\n                <span class=\"content-left\">{{\'E-Mail\'|translate}}: <span>{{ name }}</span></span>\r\n                <!-- <a href=\"#!/XSLT_PERSONALIZATION_REQUEST@profile\" ui-sref=\"#\" class=\"link\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\'ändern\'|translate}}</a> -->\r\n            </p>\r\n            <!-- <p><span class=\"content-left\">{{\'E-Mail\'|translate}}: <span ng-model=\"personalData.Username\">{{ personalData.Username }}</span></span>  <a href=\"#!/XSLT_PERSONALIZATION_REQUEST@profile\" ui-sref=\"vvs.personalization.email\" class=\"link\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\'ändern\'|translate}}</a></p> -->\r\n        </div>\r\n        <div>\r\n            <p><span class=\"content-left\">{{\'Passwort\'|translate}}: <span> ******** </span></span>  <a href=\"#!/XSLT_PERSONALIZATION_REQUEST@profile\" ui-sref=\"vvs.personalization.password\" class=\"link\"><vvs-icon name=\"abschicken\"></vvs-icon>{{\'ändern\'|translate}}</a></p>\r\n        </div>\r\n    </div>\r\n    <form name=\"deleteProfileForm\" novalidate>\r\n        <p>\r\n            <a href=\"https://www.vvs.de/verkehrsmeldungen/allgemeine-informationen/\" target=\"blank\" title=\"Account löschen\" class=\"link padding-md ng-binding\"\r\n            vvs-modal vvs-modal-size=\"sm\" vvs-modal-template=\"personalization/profile/modal.html\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon> {{ \'Account löschen\'| translate}}\r\n            </a>\r\n        </p>\r\n    </form>\r\n\r\n</div>\r\n\r\n<style>\r\n     a.link {\r\n        font-size: 1.2rem;\r\n    }\r\n    .head-wrap {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .head-wrap ul.nav {\r\n        display: flex;\r\n        margin-bottom: 2.4rem;\r\n    }\r\n    .content-wrap span {\r\n        display: inline-block;\r\n    }\r\n    span.content-left {\r\n        font-size: 1.2rem;\r\n        width: 40%;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n        .head-wrap {\r\n            flex-direction: column-reverse;\r\n            align-items: flex-start;\r\n        }\r\n        .nav>li>a {\r\n            padding-left: 0;\r\n        }\r\n        form {\r\n            padding-left: 15px;\r\n        }\r\n    }\r\n</style>\r\n");
$templateCache.put("app/vvs.components/personalization/profile/modal-old.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Mein Profil löschen\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <div class=\"modal-block spacertop spacerbottom\">\r\n\r\n            <form name=\"loginForm\" ng-submit=\"submitDeleteProfileForm(loginForm.Username, loginForm.Password)\" novalidate>\r\n                <div>\r\n                    <div>\r\n                        <vvs-alert ng-if=\"invalidLoginInputsAlert\" text=\"\'Die eingegebene E-Mail-Adresse oder das Passwort ist falsch!\'\"></vvs-alert>\r\n                        <div class=\"form-group spacertop\">\r\n                            <div ng-class=\"{ \'has-error\' : loginForm.Username.$invalid && !loginForm.Username.$pristine }\">\r\n                                <label for=\"nickname\" class=\"nopadding-xs\">{{\'Benutzername\'|translate}}</label>\r\n                                <input tabindex=\"10\" type=\"text\" class=\"form-control\" name=\"Username\" id=\"nickname\" aria-label=\"Benutzername\" ng-model=\"user.Username\" ng-minlength=\"6\" required>\r\n                            </div>\r\n                            <br>\r\n                            <div ng-class=\"{ \'has-error\' : loginForm.Password.$invalid && !loginForm.Password.$pristine }\">\r\n                                <label for=\"passwort\" class=\"nopadding-xs\">{{\'Passwort\'|translate}}</label>\r\n                                <input tabindex=\"11\" type=\"password\" class=\"form-control\" name=\"Password\" id=\"passwort\" aria-label=\"Passwort\" ng-model=\"user.Password\" ng-minlength=\"6\" ng-maxlength=\"15\" required>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"spacerbottomlarge\" role=\"group\" aria-label=\"login\">\r\n                        <div>\r\n                            <button tabindex=\"25\" type=\"submit\" class=\"btn btn-primary btn-block\" ng-disabled=\"loginForm.$invalid\">{{\'Löschen\'|translate}}</button>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/personalization/profile/modal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Account löschen\' | translate}}</h4>\r\n    </div>\r\n    <vvs-alert ng-if=\"falsePassword === true\" text=\"\'Eingabe stimmt nicht mit dem aktuellen Passwort überein. \'\"></vvs-alert>\r\n    <div class=\"set-pass\" ng-show=\"setPass\" ng-hide=\"!setPass\">\r\n        <div class=\"head-wrap modal-block\">\r\n            <h2 class=\"function-header nopadding-xs\">{{\'Passwort eingeben\'|translate}}</h2>\r\n            <form name=\"personalDataForm\" novalidate>\r\n                <div class=\"ctblock col-xs-12 nopadding-xs infocus\" role=\"group\">\r\n                        <div class=\"form-group ctblock\">\r\n                            <div ng-class=\"{ \'has-error\' : personalDataForm.Password.$invalid && !personalDataForm.Password.$pristine }\">\r\n                                <input ng-focus=\"resetInput()\" tabindex=\"11\" type=\"password\" class=\"form-control\" id=\"oldpasswort\" name=\"Password\" aria-label=\"Aktuelles Passwort\" ng-model=\"personalData.Password\" ng-minlength=\"6\" ng-maxlength=\"15\">\r\n                            </div>\r\n                        </div>\r\n                </div>\r\n                <br>\r\n                <div class=\"spacerbottom\">\r\n                    <div ng-click=\"submitDeleteProfileForm(personalData.Password)\">\r\n                    <!-- <div ng-click=\"submitDeleteProfileForm(loginForm.Username, loginForm.Password)\"> -->\r\n                        <button style=\"width: 100%;margin-top:1rem;font-size: 1.5rem;\" class=\"modal-header modal-title\" type=\"submit\">{{\'Account endgültig löschen\' | translate}}</button>\r\n                    </div>\r\n             </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n    <br>\r\n    <h3 ng-hide=\"setPass\" class=\"function-header\">{{\'Account endgültig löschen\' | translate}}</h3>\r\n    <div class=\"modal-block spacerbottom\">\r\n        <div ng-hide=\"setPass\" class=\"modal-header\">\r\n            <span ng-click=\"setPass=true\" class=\"modal-title\" id=\"modal-label\">{{\'Ja\' | translate}}</span>\r\n        </div>\r\n        <br>\r\n        <div class=\"modal-header\" ng-click=\"dismissModal()\">\r\n            <span class=\"modal-title\" id=\"modal-label\">{{\'Nein\' | translate}}</span>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<style>\r\n    .head-wrap {\r\n        flex-direction: column;\r\n    }\r\n    .head-wrap h2 {\r\n        text-align: center;\r\n        width: 100%;\r\n    }\r\n    .set-pass {\r\n        -webkit-transition: all linear 0.5s;\r\n    transition: all linear 0.5s;\r\n    }\r\n    .set-pass.ng-hide {\r\n        -webkit-transition: all linear 0.4s;\r\n    transition: all ease 0.5s;\r\n        opacity: 0;\r\n        transform: scale(0.95);\r\n    }\r\n    .set-pass.ng-show {\r\n        -webkit-transition: all ease 0.4s;\r\n    transition: all linear 0.5s;\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n    button.modal-header.modal-title:hover {\r\n        background: lightgrey;\r\n        border: 1px solid grey;\r\n    }\r\n    button:focus {\r\n        outline: none;\r\n        width: 100%;\r\n    }\r\n    form {\r\n        width: 100%;\r\n    }\r\n    form input {\r\n        width: 100%;\r\n    }\r\n    span#modal-label:focus {\r\n        outline: none;\r\n    }\r\n    h3.function-header.ng-binding {\r\n        margin: 1.6rem;\r\n    }\r\n    h4 {\r\n        text-align: left;\r\n    }\r\n    .modal-header {\r\n        height: 4.8rem;\r\n        border: 1px solid #d2d2d2;\r\n    }\r\n    .modal-block .modal-header {\r\n        text-align: center;\r\n        font-size: 1.4rem;\r\n    }\r\n    .modal-block .modal-header {\r\n        padding: 0;\r\n    }\r\n    .modal-block .modal-header:focus {\r\n        outline: none;\r\n    }\r\n    .modal-block .modal-header > span {\r\n        display: inline-block;\r\n        width: 100%;\r\n        padding: 1.5rem;\r\n    }\r\n</style>\r\n");
$templateCache.put("app/vvs.components/personalization/registration/confirm.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <h2 class=\"function-header nopadding-xs\">{{\'Sie sind fast fertig\'|translate}}!</h2>\r\n        <!-- <h2 class=\"function-header nopadding-xs\">{{\'Registrierung erfolgreich\'|translate}}</h2> -->\r\n        <p class=\"info\">{{\'Bitte überprüfen Sie Ihren Posteingang auf eine Email von no-reply@vvs.de.\'|translate}}</p>\r\n        <p class=\"info\">{{\'Um die Registrierung abzuschließen, klicken Sie auf den Link, der in der Nachricht angegeben ist.\'|translate}}</p>\r\n\r\n        <button ng-click=\"resendActivationCode()\" class=\"btn btn-block reactivate\"> > {{\'Verifizierungsmail erneut senden\'|translate}}</button>\r\n    </div>\r\n    <vvs-alert ng-if=\"reactivationLink\" text=\"\'Die Verifizierungsmail wurde erneut versendet.\'\"></vvs-alert>\r\n</div>\r\n\r\n<style>\r\n    button.btn.btn-block.reactivate.ng-binding {\r\n        width: auto;\r\n        color: #337ab7;\r\n        text-align: left;\r\n        height: auto;\r\n        background: none;\r\n    }\r\n    .btn.btn-block.reactivate:focus {\r\n        border-color: transparent;\r\n    }\r\n</style>\r\n\r\n\r\n\r\n");
$templateCache.put("app/vvs.components/personalization/registration/main.html","<form name=\"registrationForm\" ng-submit=\"submitRegistrationForm()\" novalidate>\r\n    <div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n        <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n            <h2 class=\"back nopadding-xs\">{{\'Registrierung\'|translate }} / {{ \'Account erstellen\'|translate }}<span><a href=\"javascript:void(0)\" ui-sref=\"vvs.personalization.login\">{{\'zurück\'|translate}}</a></span></h2>\r\n            <vvs-alert ng-if=\"personalizationMessage\" text=\"personalizationMessage\"></vvs-alert>\r\n            <vvs-alert ng-if=\"personalizationServiceFailedAlert\" text=\"\'Dienst nicht verfügbar.\'\"></vvs-alert>\r\n            <vvs-alert ng-if=\"profileIsDeleted\" text=\"\'Ihr Account wurde erfolgreich gelöscht.\'\"></vvs-alert>\r\n        </div>\r\n\r\n        <div class=\"ctblock col-xs-12 nopadding-xs infocus content-wrap\" role=\"group\" style=\"display: flex\">\r\n            <div class=\"col-xs-12 col-md-6 left-block\">\r\n                    <div class=\"form-group\">\r\n                       <div ng-class=\"{ \'has-error\' : registrationForm.Username.$invalid && !registrationForm.Username.$pristine }\">\r\n                        <label for=\"nickname\" class=\"nopadding-xs\">{{\'E-Mail*\'|translate}}</label>\r\n                        <input tabindex=\"10\" type=\"email\" class=\"form-control\" name=\"Username\" id=\"nickname\" aria-label=\"Email\" ng-model=\"user.Username\" required>\r\n                    </div>\r\n                    <!-- <div ng-class=\"{ \'has-error\' : registrationForm.Username.$invalid && !registrationForm.Username.$pristine }\">\r\n                        <label for=\"nickname\" class=\"nopadding-xs\">{{\'Benutzername (mind. 6 Zeichen)*\'|translate}}</label>\r\n                        <input tabindex=\"10\" type=\"text\" class=\"form-control\" name=\"Username\" id=\"nickname\" aria-label=\"Benutzername\" ng-model=\"user.Username\" ng-minlength=\"6\" required>\r\n                    </div> -->\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : registrationForm.Password.$invalid && !registrationForm.Password.$pristine }\">\r\n                        <label for=\"passwort\" class=\"nopadding-xs\">{{\'Passwort (mind. 6, max. 10 Zeichen)*\'|translate}}</label>\r\n                        <input tabindex=\"11\" type=\"password\" class=\"form-control\" name=\"Password\" id=\"passwort\" aria-label=\"Passwort\" ng-model=\"user.Password\" required ng-minlength=\"6\" ng-maxlength=\"15\">\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : registrationForm.confirmPassword.$invalid && !registrationForm.confirmPassword.$pristine }\">\r\n                        <label for=\"passwort-again\" class=\"nopadding-xs\">{{\'Passwort wiederholen*\'|translate}}</label>\r\n                        <input tabindex=\"12\" type=\"password\" class=\"form-control\" name=\"confirmPassword\" id=\"passwort-again\" aria-label=\"Passwort wiederholen\" ng-model=\"user.confirmPassword\" required ng-minlength=\"6\" ng-maxlength=\"15\" vvs-compare-password=\"user.Password\">\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-md-6 \">\r\n                <div class=\"form-group right-block\">\r\n                    <h2 class=\"pl-25\">{{\'Diese Features erhalten Sie dadurch\'|translate}}</h2>\r\n                    <ul>\r\n                        <li>\r\n                            <p>{{\'Benachrichtigungen für ausgewählte Linien\'|translate}}</p>\r\n                        </li>\r\n                        <li>\r\n                            <p>{{\'Benachrichtigungen für Haltestellen (Aufzüge, Rolltreppen)\'|translate}}</p>\r\n                        </li>\r\n                    </ul>\r\n                    <!-- <div ng-class=\"{ \'has-error\' : registrationForm.FirstName.$invalid && !registrationForm.FirstName.$pristine }\">\r\n                        <label for=\"name\" class=\"nopadding-xs\">{{\'Vorname*\'|translate}}</label>\r\n                        <input tabindex=\"13\" type=\"text\" class=\"form-control capitalize\" name=\"FirstName\" id=\"name\" aria-label=\"Vorname\" ng-model=\"user.Profile.FirstName\" required>\r\n                    </div>\r\n                    <br>\r\n                    <div ng-class=\"{ \'has-error\' : registrationForm.Name.$invalid && !registrationForm.Name.$pristine }\">\r\n                        <label for=\"surname\" class=\"nopadding-xs\">{{\'Nachname*\'|translate}}</label>\r\n                        <input tabindex=\"14\" type=\"text\" class=\"form-control capitalize\" name=\"Name\" id=\"surname\" aria-label=\"Nachname\" ng-model=\"user.Profile.LastName\" required>\r\n                    </div> -->\r\n                    <br>\r\n                    <!-- <div ng-class=\"{ \'has-error\' : registrationForm.Email.$invalid && !registrationForm.Email.$pristine }\">\r\n                        <label for=\"email\" class=\"nopadding-xs\">{{\'E-Mail*\'|translate}}</label>\r\n                        <input tabindex=\"15\" type=\"email\" class=\"form-control\" name=\"Email\" id=\"email\" aria-label=\"E-Mail\" ng-model=\"user.Profile.Email\" required>\r\n                    </div> -->\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 spacerbottom\">\r\n            <p class=\"info\">{{\'* Pflichtfelder\'|translate}}\r\n                <br>\r\n                <!-- <br> {{\'Der Service ist für Sie kostenlos.\'|translate}}\r\n                <br> {{\'Ihre Daten werden selbstverständlich vertraulich behandelt und nicht an Dritte weitergegeben.\'|translate}}</p> -->\r\n        </div>\r\n<!--         <div class=\"ctblock col-xs-12 nopadding-xs padding-md spacerbottom\">\r\n            <ul class=\"list-group list-toggle border\">\r\n                <***!--<li class=\"list-group-item no-icon\">{{\'Benachrichtigung per E-Mail\'|translate}}\r\n                    <md-switch aria-label=\"Benachrichtigung per E-Mail\" ng-model=\"user.Notification\" ng-true-value=\"1\" ng-false-value=\"0\"></md-switch>\r\n                </li>--***>\r\n                <li class=\"list-group-item no-icon\">{{\'Ich habe die\'|translate}} <a href=\"javascript:void(0)\" vvs-modal vvs-modal-template=\"personalization/registration/modal.html\">{{\'Nutzungsbedingungen\'|translate}}</a> {{\'durchgelesen und akzeptiere diese.\'|translate}}\r\n                    <md-switch aria-label=\"Nutzungsbedingungen\" ng-model=\"user.agreed\" required></md-switch>\r\n                </li>\r\n            </ul>\r\n        </div> -->\r\n        <div class=\"ctblock col-xs-12 padding-md spacerbottom\">\r\n            <!-- <li class=\"list-group-item no-icon\">{{\'Ich habe die\'|translate}} <a href=\"javascript:void(0)\" vvs-modal vvs-modal-template=\"personalization/registration/modal.html\">{{\'Nutzungsbedingungen\'|translate}}</a> {{\'durchgelesen und akzeptiere diese.\'|translate}}\r\n                <md-switch aria-label=\"Nutzungsbedingungen\" ng-model=\"user.agreed\" required></md-switch>\r\n            </li> -->\r\n            <label class=\"fwn checkbox-wrap\" for=\"agb\">{{\'Ja, ich bin mit den \'|translate}}<a style=\"padding:0 3px\" href=\"javascript:void(0)\" vvs-modal vvs-modal-template=\"personalization/registration/modal.html\">{{ \'AGBs\'|translate}}</a>{{ \' einverstanden.\'|translate}}\r\n                <input type=\"checkbox\" ng-model=\"user.agreed\" id=\"agb\" required />\r\n                <span class=\"checkmark\"></span>\r\n            </label>\r\n    </div>\r\n    <div class=\"ctblock col-xs-12 padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"login\">\r\n        <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n            <button tabindex=\"25\" type=\"submit\" class=\"btn btn-primary btn-block\" ng-disabled=\"registrationForm.$invalid\">{{\'Kostenfrei registrieren\'|translate}}</button>\r\n        </div>\r\n    </div>\r\n    <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n</div>\r\n</form>\r\n\r\n\r\n<style>\r\n    .right-block {\r\n        border: 1px solid #9e9e9e;\r\n        margin-top: 24px;\r\n        height:calc( 100% - 39px);\r\n    }\r\n    .pl25 {\r\n        padding-left: 25px;\r\n    }\r\n    .fwn {\r\n        font-weight: normal;\r\n    }\r\n\r\n    ul {\r\n        padding-top: 10px;\r\n        font-size: 1.2rem;\r\n        margin-left: -10px;\r\n    }\r\n\r\n\r\n    @media (max-width: 768px) {\r\n        .left-block {\r\n            order:1;\r\n        }\r\n        .right-block {\r\n            margin-top: 20px;\r\n            /* order: 2; */\r\n        }\r\n        .content-wrap {\r\n            flex-direction: column;\r\n        }\r\n        .function-header {\r\n            margin-bottom: 0;\r\n        }\r\n\r\n\r\n    }\r\n\r\n</style>\r\n");
$templateCache.put("app/vvs.components/personalization/registration/modal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Nutzungsbedingungen VVS Benachrichtigungsservice\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <div class=\"modal-block spacertop spacerbottom\">\r\n            <p>{{\'Die Nutzung des Dienstes setzt voraus, dass Sie den Nutzungsbedingungen zustimmen. Bitte lesen Sie diese sorgfältig durch.\'|translate}}\r\n                <br>\r\n                <br> {{\'Die Verwendung des VVS Benachrichtigungsservice ist kostenlos. Voraussetzung zur Nutzung ist die Hinterlegung einer gültigen E-Mail-Adresse.\'|translate}}\r\n                <br>\r\n                <!-- <br> {{\'Der für Sie kostenfreie SMS-Benachrichtigungsservice ist für den VVS mit erheblichen Kosten verbunden. Haben Sie bitte Verständnis, dass Sie als Benutzer dieses Dienstes (betrifft nicht die E-Mail-Benachrichtigung) sich mindestens einmal pro Halbjahr (6 Monate) einloggen und Ihre Daten überprüfen müssen. Dazu bekommen Sie jeweils nach 5 Monaten eine Mail von uns mit einem entsprechenden Hinweis. Danach haben Sie 1 Monat Zeit, sich einzuloggen. Falls Sie sich innerhalb dieses Zeitraumes nicht einloggen, wird Ihr Account auf inaktiv gestellt und Sie bekommen keine SMS mehr zugestellt. Falls Sie unseren Service dann noch weiternutzen möchten, können Sie sich jederzeit wieder einloggen.\'|translate}} -->\r\n                <!-- <br> -->\r\n                <br> {{\'Verwenden Sie unsere Dienste nicht in missbräuchlicher Art und Weise. Sie sind beispielsweise nicht berechtigt, in den Dienst einzugreifen oder in anderer Weise als über die von der VVS bereitgestellte Benutzeroberfläche und gemäß unseren Vorgaben auf die Dienste zuzugreifen. Sie dürfen unsere Dienste nur in dem gesetzlich zulässigen Rahmen nutzen. Wir können die Bereitstellung unserer Dienste an Sie aussetzen oder einstellen, wenn Sie gegen unsere Nutzungsbedingungen oder Richtlinien verstoßen oder wenn wir ein mutmaßliches Fehlverhalten untersuchen.\'|translate}}\r\n                <br>\r\n                <br> {{\'Ihr VVS-Team.\'|translate}}\r\n            </p>\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"ohne Echtzeit berechnen\" role=\"group\">\r\n                <div class=\"btn-group \" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"(user.agreed=true);dismissModal();\">{{\'OK\'|translate}}</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/personalization/stops/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <h2 class=\"function-header nopadding-xs\">{{\'Haltestellenabos verwalten\'|translate}}</h2>\r\n        <vvs-alert ng-if=\"persAlert\" text=\"\'Bitte geben Sie einen Ort, Haltestelle, Adresse oder POI ein\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"persError\" text=\"\'Es ist ein Fehler aufgetreten\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"alreadySubscribed\" text=\"\'Sie sind für diese Haltestelle schon abonniert!\'\"></vvs-alert>\r\n    </div>\r\n    <div class=\"input-wrap-xs infocus col-xs-12 pl-0 pr-0\">\r\n        <div class=\"form-group spacerbottomlarge\">\r\n            <vvs-location-odv usage=\"pers\"></vvs-location-odv>\r\n        </div>\r\n    </div>\r\n    <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"search\">\r\n        <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n            <button type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"triggerSubscribeToStopClick()\">{{\'Anfordern\'|translate}}</button>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-xs-12 col-sm-12 col-md-10 col-md-offset-1 content\">\r\n        <table class=\"table monitor bs border-bottom\">\r\n            <colgroup>\r\n                <col width=\"4%\">\r\n                <col width=\"86%\">\r\n                <col width=\"10%\">\r\n            </colgroup>\r\n            <thead>\r\n                <tr class=\"visible-md visible-lg\">\r\n                    <th>{{\'Nr.\'|translate}}</th>\r\n                    <th>{{\'Abonnierte Haltestellen (Start / Ziel)\'|translate}}</th>\r\n                    <th class=\"text-right\">\r\n                        <vvs-icon name=\"loeschen\"></vvs-icon>\r\n                    </th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr ng-if=\"stops.length==0\">\r\n                    <td colspan=\"3\">{{\'Keine Haltestellen abonniert.\'|translate}}</td>\r\n                </tr>\r\n                <tr ng-repeat=\"stop in stops track by $index\">\r\n                    <td>{{$index+1}}</td>\r\n                    <td>\r\n                        <vvs-icon name=\"haltestelle\"></vvs-icon> {{stop.Name}}\r\n                    </td>\r\n                    <td class=\"text-right\">\r\n                        <a href=\"javascript:void(0)\" title=\"{{\'Löschen\'|translate}}\" ng-click=\"removeStop(stop.Id)\">\r\n                            <vvs-icon name=\"loeschen\"></vvs-icon>\r\n                        </a>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n\r\n    <!-- include history box -->\r\n    <vvs-history mode=\"location\" usage=\"pers\"></vvs-history>\r\n\r\n\r\n    <div class=\"ctblock buttonlist col-xs-12 nopadding-xs\" role=\"group\" aria-label=\"Linienauswahl\">\r\n        <button type=\"button\" class=\"btn btn-default btn-block\" ui-sref=\"vvs.personalization.lines\">\r\n            <div class=\"pull-left text-left hideme\">\r\n                {{\'Linienabos verwalten\'|translate}}\r\n            </div>\r\n            <div class=\"pull-right text-right send\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button>\r\n    </div>\r\n    <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/personalization/trips/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content personalization trips\">\r\n    <div class=\"ctblock col-xs-12 spacertoplarge\">\r\n        <h2 class=\"function-header nopadding-xs\">{{\'Meine Fahrten verwalten\'|translate}}</h2>\r\n        <vvs-alert ng-if=\"persError\" text=\"\'Es ist ein Fehler aufgetreten\'\"></vvs-alert>\r\n\r\n        <vvs-alert ng-if=\"bookSuccess\" text=\"\'Die Fahrt wurde erfolgreich gebucht\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"updateSuccess\" text=\"\'Die Fahrt wurde erfolgreich aktualisiert! Es befinden sich keine Änderungen!\'\"></vvs-alert>\r\n\r\n        <vvs-alert ng-if=\"departureUpdated\" text=\"\'Die Fahrt wurde erfolgreich aktualisiert! Bitte beachten Sie : Die Abfahrtzeit wurde geändert!\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"arrivalUpdated\" text=\"\'Die Fahrt wurde erfolgreich aktualisiert! Bitte beachten Sie Die Ankunftszeit wurde geändert!\'\"></vvs-alert>\r\n\r\n        <vvs-alert ng-if=\"cancelSuccess\" text=\"\'Die Fahrt wurde erfolgreich storniert\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"saveSuccess\" text=\"\'Die Fahrt wurde erfolgreich gespeichert\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"deleteSuccess\" text=\"\'Die Fahrt wurde erfolgreich gelöscht\'\"></vvs-alert>\r\n\r\n        <vvs-alert ng-if=\"bookError\" text=\"\'Die Fahrt konnte nicht gebucht werden, bitte überprüfen Sie ob Sie diese Fahrt schon gebucht haben\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"updateError\" text=\"\'Die Fahrt konnte nicht aktualisiert werden\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"cancelError\" text=\"\'Die Fahrt konnte nicht storniert werden\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"saveError\" text=\"\'Die Fahrt konnte nicht gespeichert werden\'\"></vvs-alert>\r\n        <vvs-alert ng-if=\"deleteError\" text=\"\'Die Fahrt konnte nicht gelöscht werden\'\"></vvs-alert>\r\n\r\n        <vvs-alert ng-if=\"filterError\" text=\"\'Es wurde für Ihren Filter keine Fahrt gefunden!\'\" html=\"filterErrorMsg\"></vvs-alert>\r\n        <h2 ng-if=\"filterError\"><u><a href=\"javascript:void(0)\" ng-click=\"resetFilter()\">{{\'Zurücksetzen\'|translate}}</a></u></h2>\r\n    </div>\r\n\r\n    <div ng-if=\"tripsObjects.length && false\">\r\n        <div class=\"ctblock col-xs-12 nopadding-xs infocus\" role=\"group\">\r\n            <!--<div class=\"col-xs-12 col-md-6 \">\r\n                <div class=\"form-group\">\r\n                    <div>\r\n                        <label for=\"email\" class=\"nopadding-xs\">{{\'E-Mail\'|translate}}</label>\r\n                        <input type=\"text\" class=\"form-control\" id=\"email\" ng-model=\"filter.email\">\r\n                    </div>\r\n                    <br>\r\n                </div>\r\n            </div>-->\r\n            <div class=\"col-xs-12 col-md-6 \">\r\n                <div class=\"form-group\">\r\n                    <div>\r\n                        <label for=\"name\" class=\"nopadding-xs\">{{\'Name\'|translate}}</label>\r\n                        <input type=\"text\" class=\"form-control\" id=\"name\" ng-model=\"filter.name\">\r\n                    </div>\r\n                    <br>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"col-xs-12 col-md-6 \">\r\n                <div class=\"form-group\">\r\n                    <div>\r\n                        <label for=\"departureDate\" class=\"nopadding-xs\">{{\'Abfahrtsdatum\'|translate}}</label>\r\n                        <input type=\"date\" class=\"form-control\" id=\"departureDate\" data-date-format=\"DD.MM.YYYY\" placeholder=\"tt.mm.jjjjj\" ng-model=\"filter.departureDate\">\r\n                    </div>\r\n                    <br>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\">\r\n            <div class=\"col-xs-12 col-md-6\">\r\n                <button class=\"btn btn-primary btn-block\" ng-click=\"fireFilter()\">{{\'Filtern\'|translate}}</button>\r\n            </div>\r\n            <div class=\"col-xs-12 col-md-6\">\r\n                <button class=\"btn btn-default btn-block\" ng-click=\"resetFilter()\">{{\'Zurücksetzen\'|translate}}</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12 nopadding-xs padding-md\">\r\n        <table class=\"table monitor bs border-bottom\" ng-init=\"isCollapsed=false;\">\r\n            <colgroup>\r\n                <col width=\"10%\">\r\n                <col width=\"20%\">\r\n                <col width=\"30%\">\r\n                <col width=\"40%\">\r\n            </colgroup>\r\n            <thead>\r\n                <th>{{\'Name\'|translate}}</th>\r\n                <th>{{\'Zustand\'|translate}}</th>\r\n                <th>{{\'Stornieren/Buchen\'|translate}}</th>\r\n            </thead>\r\n            <tbody ng-if=\"tripsObjects.length==0\">\r\n                <tr>\r\n                    <td colspan=\"3\">{{\'Keine Fahrten vorhanden.\'|translate}}</td>\r\n                </tr>\r\n            </tbody>\r\n            <tbody ng-repeat=\"persTripObj in tripsObjects track by $index\" ng-init=\"trip = persTripObj.Trip\">\r\n                <tr>\r\n                    <td>\r\n                        <div>\r\n                            <strong>{{\'Abfahrt am\'|translate}} {{trip.departureTime()|VVSDateFormatter}}</strong>\r\n                            <br>\r\n                            {{trip.origin().name()}} - {{trip.destination().name()}}\r\n                        </div>\r\n                        <div style=\"text-align: center;\">\r\n                            <a href=\"javascript:void(0)\" ng-click=\"isCollapsed = !isCollapsed\">\r\n                                <vvs-icon ng-if=\"isCollapsed\" name=\"up\"></vvs-icon>\r\n                                <vvs-icon ng-if=\"!isCollapsed\" name=\"down\"></vvs-icon>\r\n                            </a>\r\n                        </div>\r\n                    </td>\r\n                    <td>\r\n                        <div ng-repeat=\"leg in trip.legs() track by $index\" style=\"min-height: 80px;\" ng-if=\"leg.properties().reservationDetails || leg.properties().bookingDetails || leg.properties().cancelationDetails\">\r\n                            <div class=\"modified\" ng-if=\"leg.properties().reservationDetails\">\r\n                                {{\'reserviert\'|translate}} ({{\'am\'|translate}} {{leg.properties().reservationDetails.reservationTimestamp|VVSSummaryDateTimeFormatter}}) <br>\r\n                                <vvs-countdown date=\"leg.properties().reservationDetails.expiresAfter\">\r\n                                    <vvs-countdown-show style=\"display: none;\">\r\n                                        (<small><strong>{{\'Die Fahrt kann nicht mehr gebucht werden!\'|translate}}</strong></small>)\r\n                                    </vvs-countdown-show>\r\n                                    <vvs-countdown-hide>\r\n                                        (<small><strong>{{\'buchbar bis\'}} {{leg.properties().reservationDetails.expiresAfter|VVSSummaryDateTimeFormatter}}</strong></small>)\r\n                                    </vvs-countdown-hide>\r\n                                </vvs-countdown>\r\n\r\n                            </div>\r\n                            <div class=\"success\" ng-if=\"leg.properties().bookingDetails\">\r\n                                {{\'gebucht\'|translate}} ({{\'am\'|translate}} {{leg.properties().bookingDetails.bookingTimestamp|VVSSummaryDateTimeFormatter}})\r\n                                <br>\r\n                                <u>{{\'Überprüfen Sie die endgültigen Zeiten und Haltepunkte ab\'|translate}} {{leg.properties().bookingDetails.frozenAfter|VVSSummaryDateTimeFormatter}}</u>\r\n                                <br>\r\n                                <div ng-init=\"isFrozen=isFrozen(leg.properties().bookingDetails.frozenAfter)\">\r\n                                    <span ng-if=\"!isFrozen\">{{\'Vorläufige Abfahrtszeit.\'|translate}}</span>\r\n                                    <span ng-if=\"isFrozen\">{{\'Endgültige Abfahrtszeit.\'|translate}}</span>\r\n                                </div>\r\n\r\n                            </div>\r\n                            <div class=\"error\" ng-if=\"leg.properties().cancelationDetails\">\r\n                                {{\'storniert\'|translate}} ({{\'am\'|translate}} {{leg.properties().cancelationDetails.cancelationTimestamp|VVSSummaryDateTimeFormatter}})\r\n                            </div>\r\n                            <div class=\"linklist spacertop separator-top\" ng-if=\"(leg.properties().reservationDetails.CustomerDetail) || (leg.properties().bookingDetails.CustomerDetail) || (leg.properties().cancelationDetails.CustomerDetail)\" ng-init=\"customerDetail = (leg.properties().reservationDetails.CustomerDetail || leg.properties().bookingDetails.CustomerDetail || leg.properties().cancelationDetails.CustomerDetail)\">\r\n                                <a href=\"javascript:void(0)\" title=\"Name\">\r\n                                    <vvs-icon name=\"abschicken\"></vvs-icon> {{customerDetail.Name}}\r\n                                </a>\r\n                                <br/>\r\n                                <a href=\"mailto:{{customerDetail.EMailAddress}}\" title=\"Email\">\r\n                                    <vvs-icon name=\"abschicken\"></vvs-icon> {{customerDetail.EMailAddress}}\r\n                                </a>\r\n                                <br/>\r\n                                <a href=\"tel:{{customerDetail.MobilePhone}}\" title=\"Telefon\">\r\n                                    <vvs-icon name=\"abschicken\"></vvs-icon> {{customerDetail.MobilePhone}}\r\n                                </a>\r\n                            </div>\r\n                        </div>\r\n                    </td>\r\n                    <td>\r\n                        <div class=\"buttons col-xs-12 col-sm-12 col-md-12 buttons\">\r\n                            <div class=\"btn-group col-xs-6 col-sm-6 col-md-3\" role=\"group\">\r\n                                <button type=\"button\" class=\"btn btn-default black\" ng-click=\"update(persTripObj)\" title=\"{{\'Diese Fahrt aktualisieren\'|translate}}\">\r\n                                    <vvs-icon name=\"aktualisieren\"></vvs-icon>\r\n                                </button>\r\n                            </div>\r\n\r\n                            <div class=\"btn-group col-xs-6 col-sm-6 col-md-3\" role=\"group\">\r\n                                <button type=\"button\" class=\"btn btn-default black\" ng-click=\"triggerAddToIcsCalendarClick(trip)\" title=\"{{\'Diese Fahrt im Kalendar eintragen\'|translate}}\">\r\n                                    <vvs-icon name=\"kalender\"></vvs-icon>\r\n                                </button>\r\n                            </div>\r\n\r\n                            <div class=\"btn-group col-xs-6 col-sm-6 col-md-3\" role=\"group\">\r\n                                <button type=\"button\" class=\"btn btn-default black\" ng-click=\"triggerCreateJourneyPdf(trip)\" title=\"{{\'Als PDF generieren\'|translate}}\">\r\n                                    <vvs-icon name=\"pdf\"></vvs-icon>\r\n                                </button>\r\n                            </div>\r\n                            <div class=\"btn-group col-xs-6 col-sm-6 col-md-3\" role=\"group\">\r\n                                <button type=\"button\" class=\"btn btn-default black\" ng-click=\"delete(persTripObj, true)\" title=\"{{\'Fahrt löschen\'|translate}}\">\r\n                                    <vvs-icon name=\"loeschen\"></vvs-icon>\r\n                                </button>\r\n                            </div>\r\n\r\n                            <div class=\"btn-group col-xs-12 col-sm-12 col-md-12 spacertop\" role=\"group\">\r\n                                <div ng-repeat=\"leg in trip.legs() track by $index\" class=\"col-xs-12 col-sm-12 col-md-12\" ng-if=\"leg.properties().reservationDetails || leg.properties().bookingDetails || leg.properties().cancelationDetails\">\r\n\r\n                                    <vvs-countdown ng-if=\"leg.properties().reservationDetails\" date=\"leg.properties().reservationDetails.expiresAfter\">\r\n                                        <vvs-countdown-show style=\"display: none;\">\r\n                                            <button type=\"button\" class=\"btn btn-danger btn-block white\" ng-click=\"delete(persTripObj)\"><vvs-icon name=\"loeschen\"></vvs-icon> {{\'Löschen\'|translate}}</button>\r\n                                        </vvs-countdown-show>\r\n                                        <vvs-countdown-hide>\r\n                                            <button type=\"button\" class=\"btn btn-success btn-block white\" ng-click=\"book(persTripObj)\" ng-if=\"leg.properties().reservationDetails\"><vvs-icon name=\"basket\"></vvs-icon> {{\'Buchen\'|translate}}</button>\r\n                                        </vvs-countdown-hide>\r\n                                    </vvs-countdown>\r\n\r\n                                    <button type=\"button\" class=\"btn btn-modified btn-block white\" ng-click=\"cancel(persTripObj)\" ng-if=\"leg.properties().bookingDetails\"><vvs-icon name=\"loeschen\"></vvs-icon> {{\'Stornieren\'|translate}}</button>\r\n                                    <button type=\"button\" class=\"btn btn-danger btn-block white\" ng-click=\"delete(persTripObj)\" ng-if=\"leg.properties().cancelationDetails\"><vvs-icon name=\"loeschen\"></vvs-icon> {{\'Löschen\'|translate}}</button>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n                <tr uib-collapse=\"!isCollapsed\">\r\n                    <td colspan=\"3\" class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n                        <div class=\"spacertop col-xs-12 trip-container trip-single padding-md\">\r\n                            <div class=\"trip-wrap-graphic\">\r\n                                <div class=\"trip-graphic\">\r\n                                    <strong>{{\'Abfahrt am\'|translate}} {{trip.departureTime()|VVSDateFormatter}}</strong>\r\n                                    <vvs-trip-details-leg ng-repeat=\"leg in trip.legs() track by $index\" leg-index=\"$index\" is-first-leg=\"$first\" is-last-leg=\"$last\"></vvs-trip-details-leg>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/personalization/verification/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"input-wrap infocus col-xs-12 spacerbottom pl-0 pr-0\">\r\n        <p class=\"info\" ng-if=\"success\">\r\n            {{\'Ihre E-Mail-Adresse wurde erfolgreich verifiziert\'|translate}}\r\n            <br>\r\n            <a class=\"special input-wrap\" href=\"javascript:void(0)\" ui-sref=\"vvs.personalization.login\"><vvs-icon name=\"abschicken\"></vvs-icon> {{\'Einloggen\'|translate}}</a>\r\n        </p>\r\n        <p class=\"info\" ng-if=\"!success\">\r\n            {{\'Dieser Aktivierungslink ist ungültig!\'|translate}}\r\n        </p>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/rop/lines/init.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content spacertoplarge\">\r\n    <div class=\"modal-header high\">\r\n        <!-- <h4 class=\"modal-title {{VVSROPLineModalCtrl.selectedLine.productIconId()|VVSProductIconIdMapper}}\" id=\"modal-label\">{{VVSROPLineModalCtrl.selectedLine.number()}} {{\'Richtung\'|translate}} {{VVSROPLineModalCtrl.selectedLine.destination() | VVSLocationNameFormatter}}<br>{{\'Aktuelle Uhrzeit\'|translate}} <strong><time>{{VVSROPLineModalCtrl.currentDate | VVSTimeFormatter}}</time></strong></h4> -->\r\n        <h4 class=\"modal-title {{selectedLine.productIconId()|VVSProductIconIdMapper}}\" id=\"modal-label\">{{selectedLine.number()}}\r\n            {{\'Richtung\'|translate}} {{selectedLine.destination() | VVSLocationNameFormatter}}\r\n            <br>\r\n            {{\'Aktuelle Uhrzeit\'|translate}} <strong><time>{{currentDate | VVSTimeFormatter}}</time></strong></h4>\r\n    </div>\r\n</div>");
$templateCache.put("app/vvs.components/rop/lines/lines.html","<div ng-controller=\"VVSROPLineModalController as VVSROPLineModalCtrl\">\r\n    <div class=\"modal-header high col-md-8\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title {{VVSROPLineModalCtrl.selectedLine.productIconId()|VVSProductIconIdMapper}}\" id=\"modal-label\">{{VVSROPLineModalCtrl.selectedLine.number()}} {{\'Richtung\'|translate}} {{VVSROPLineModalCtrl.selectedLine.destination() | VVSLocationNameFormatter}}<br>{{\'Aktuelle Uhrzeit\'|translate}} <strong><time>{{VVSROPLineModalCtrl.currentDate | VVSTimeFormatter}}</time></strong></h4>\r\n    </div>\r\n    <!-- <div class=\"modal-body nopadding-xs ctblock\">\r\n        <div class=\"trip-container spacertoplarge\" ng-init=\"tabIndex=0\">\r\n\r\n            <md-tabs md-dynamic-height md-border-bottom class=\"nav nav-tabs\">\r\n                <md-tab ng-click=\"tabIndex=0\">\r\n                    <md-tab-label>\r\n                        <vvs-icon name=\"perlschnur\"></vvs-icon> {{\'Perlschnur\' | translate}}\r\n                    </md-tab-label>\r\n                    <md-tab-body>\r\n                        <vvs-perlschnur transportation=\"VVSROPLineModalCtrl.selectedLine\"></vvs-perlschnur>\r\n                    </md-tab-body>\r\n                </md-tab>\r\n                <md-tab ng-click=\"tabIndex=1\">\r\n                    <md-label>\r\n                        <vvs-icon name=\"karte\"></vvs-icon> {{\'Karte\' | translate}}\r\n                    </md-label>\r\n                    <md-tab-body>\r\n                        <vvs-map mode=\"\'line\'\" line=\"VVSROPLineModalCtrl.selectedLine\" zoom-level=\"1\" load-on=\"{{tabIndex==1}}\"></vvs-map>\r\n                    </md-tab-body>\r\n                </md-tab>\r\n            </md-tabs>\r\n\r\n        </div>\r\n    </div> -->\r\n</div>\r\n");
$templateCache.put("app/vvs.components/rop/lines/main.html","<form novalidate>\r\n    <div class=\"col-xs-12 col-sm-12 col-md-12 content spacertoplarge\">\r\n        <div class=\"input-wrap-xs infocus col-xs-12 pr-0 pl-0\">\r\n            <div class=\"form-group spacerbottomlarge\">\r\n                <vvs-alert ng-if=\"VVSROPLineCtrl.ropAlert\" text=\"\'Bitte geben Sie eine Linie ein!\'\"></vvs-alert>\r\n                <vvs-line-odv usage=\"rop\"></vvs-line-odv>\r\n            </div>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge ctblockreset\" role=\"group\" aria-label=\"suchen\">\r\n            <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                <button id=\"vvs_rop_lines_submit\" type=\"submit\" ng-click=\"triggerROPClick()\" class=\"search-btn btn btn-primary btn-block\">{{\'Suchen\'|translate}}</button>\r\n            </div>\r\n        </div>\r\n        <vvs-history mode=\"line\" usage=\"rop\"></vvs-history>\r\n    </div>\r\n</form>\r\n\r\n\r\n");
$templateCache.put("app/vvs.components/rop/lines/mainn.html","<form novalidate>\r\n    <div class=\"col-xs-12 col-sm-12 col-md-12 content spacertoplarge\">\r\n        <div class=\"input-wrap-xs infocus col-xs-12 pl-0 pr-0\">\r\n            <div class=\"form-group spacerbottomlarge\">\r\n                <vvs-alert ng-if=\"VVSROPLineCtrl.ropAlert\" text=\"\'Bitte geben Sie eine Linie ein!\'\"></vvs-alert>\r\n                <vvs-line-odv usage=\"rop\"></vvs-line-odv>\r\n            </div>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"suchen\">\r\n            <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                <button id=\"vvs_rop_lines_submit\" type=\"submit\" vvs-modal vvs-modal-template=\"rop/lines/modal.html\" class=\"search-btn btn btn-primary btn-block\">{{\'Suchen\'|translate}}</button>\r\n            </div>\r\n        </div>\r\n        <vvs-history mode=\"line\" usage=\"rop\"></vvs-history>\r\n    </div>\r\n</form>\r\n\r\n");
$templateCache.put("app/vvs.components/rop/lines/modal.html","<div ng-controller=\"VVSROPLineModalController as VVSROPLineModalCtrl\">\r\n    <div class=\"modal-header high\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title {{VVSROPLineModalCtrl.selectedLine.productIconId()|VVSProductIconIdMapper}}\" id=\"modal-label\">{{VVSROPLineModalCtrl.selectedLine.number()}} {{\'Richtung\'|translate}} {{VVSROPLineModalCtrl.selectedLine.destination() | VVSLocationNameFormatter}}<br>{{\'Aktuelle Uhrzeit\'|translate}} <strong><time>{{VVSROPLineModalCtrl.currentDate | VVSTimeFormatter}}</time></strong></h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <div class=\"trip-container spacertoplarge\" ng-init=\"tabIndex=0\">\r\n\r\n            <md-tabs md-dynamic-height md-border-bottom class=\"nav nav-tabs\">\r\n                <md-tab ng-click=\"tabIndex=0\">\r\n                    <md-tab-label>\r\n                        <vvs-icon name=\"perlschnur\"></vvs-icon> {{\'Perlschnur\' | translate}}\r\n                    </md-tab-label>\r\n                    <md-tab-body>\r\n                        <vvs-perlschnur transportation=\"VVSROPLineModalCtrl.selectedLine\"></vvs-perlschnur>\r\n                    </md-tab-body>\r\n                </md-tab>\r\n                <md-tab ng-click=\"tabIndex=1\">\r\n                    <md-label>\r\n                        <vvs-icon name=\"karte\"></vvs-icon> {{\'Karte\' | translate}}\r\n                    </md-label>\r\n                    <md-tab-body>\r\n                        <vvs-map mode=\"\'line\'\" line=\"VVSROPLineModalCtrl.selectedLine\" zoom-level=\"1\" load-on=\"{{tabIndex==1}}\"></vvs-map>\r\n                    </md-tab-body>\r\n                </md-tab>\r\n            </md-tabs>\r\n\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/rop/lines/result.html","<div class=\"row modal-header mapViewLines\" style=\"position: relative;\">\r\n    <div class=\"high col-md-4\">\r\n        <h4 class=\"modal-title {{selectedLine.productIconId()| VVSProductIconIdMapper}}\" id=\"modal-label\">\r\n            {{selectedLine.number()}} {{\'Richtung\'|translate}} {{selectedLine.destination() | VVSLocationNameFormatter}}\r\n        </h4>\r\n        <p>{{\'Aktuelle Uhrzeit\'|translate}} <strong><time>{{currentDate | VVSTimeFormatter}}</time></strong></p>\r\n    </div>\r\n    <div class=\"change-trip-buttons\" style=\"position: absolute; bottom: 1rem; right: 15px;\">\r\n        <div class=\"btn-group flexalignRight\" role=\"group\" aria-label=\"...\">\r\n            <div class=\"btn-group\" role=\"group\">\r\n                <button type=\"button\" class=\"btn btn-link\" ng-click=\"triggerROPResetClick()\">\r\n                    <vvs-icon name=\"neuefahrt\"></vvs-icon> {{\'Neu\'|translate}}\r\n                </button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"modal-body nopadding-xs ctblock\">\r\n    <div class=\"trip-container\" ng-init=\"tabIndex=0\">\r\n        <div class=\"perlschnur_btns btns-wrap flexStyle\">\r\n            <ng-container ng-if=\"showMap\">\r\n                <button class=\"switchBtn\" ng-click=\"btnClick()\">\r\n                    <span>\r\n                        <vvs-icon name=\"perlschnur\"></vvs-icon> {{\'Perlschnur\' | translate}}\r\n                    </span>\r\n                </button>\r\n            </ng-container>\r\n            <ng-container ng-if=\"!showMap\">\r\n                <button class=\"switchBtn\" ng-click=\"btnClick()\">\r\n                    <span>\r\n                        <vvs-icon name=\"karte\"></vvs-icon> {{\'Karte\' | translate}}\r\n                    </span>\r\n                </button>\r\n            </ng-container>\r\n        </div>\r\n        <ng-container ng-if=\"showMap\">\r\n            <vvs-map mode=\"\'line\'\" line=\"selectedLine\" zoom-level=\"1\" load-on=\"{{true}}\"></vvs-map>\r\n        </ng-container>\r\n        <ng-container ng-if=\"!showMap\">\r\n            <vvs-perlschnur transportation=\"selectedLine\"></vvs-perlschnur>\r\n        </ng-container>\r\n\r\n        <!-- <md-tabs md-dynamic-height md-border-bottom class=\"nav nav-tabs\">\r\n            <md-tab ng-click=\"tabIndex=0\">\r\n                <md-tab-label>\r\n                    <vvs-icon name=\"perlschnur\"></vvs-icon> {{\'Perlschnur\' | translate}}\r\n                </md-tab-label>\r\n                <md-tab-body>\r\n                    <vvs-perlschnur transportation=\"selectedLine\"></vvs-perlschnur>\r\n                </md-tab-body>\r\n            </md-tab>\r\n            <md-tab ng-click=\"tabIndex=1\">\r\n                <md-label>\r\n                    <vvs-icon name=\"karte\"></vvs-icon> {{\'Karte\' | translate}}\r\n                </md-label>\r\n                <md-tab-body>\r\n                    <vvs-map mode=\"\'line\'\" line=\"selectedLine\" zoom-level=\"1\" load-on=\"{{tabIndex==1}}\"></vvs-map>\r\n                </md-tab-body>\r\n            </md-tab>\r\n        </md-tabs> -->\r\n\r\n    </div>\r\n</div>\r\n\r\n<!-- <style>\r\n    .switchBtn {\r\n        width: 150px;\r\n        height: 40px;\r\n    }\r\n</style> -->");
$templateCache.put("app/vvs.components/rop/lines/tabs.html","<!-- tabs von linien -->\r\n<div>\r\n    <div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n        <h1 class=\"function-header tabs wrap-xs\">{{\'Linien\' | translate}}</h1>\r\n        <div ng-cloak=\"\" class=\"tabsdemoCenterTabs\" ng-app=\"MyApp\">\r\n            <md-content>\r\n              <md-tabs md-disable-animation md-dynamic-height=\"\" class=\"md-primary\" md-center-tabs=\"\" md-selected=\"tabIndex\">\r\n                <md-tab label=\"{{\'Karten&shy;ansicht\'|translate}}\" ui-sref=\"vvs.lines.rop\" md-selected=\"tabIndex\">\r\n                </md-tab>\r\n                <md-tab label=\"{{\'Fahrplan&shy;tabelle\'|translate}}\" ui-sref=\"vvs.lines.ttb\">\r\n                </md-tab>\r\n                <md-tab label=\"{{\'Linien&shy;fahrplan\'|translate}}\" ui-sref=\"vvs.lines.lfp\">\r\n                </md-tab>\r\n              </md-tabs>\r\n            </md-content>\r\n          </div>\r\n          <div ui-view></div>\r\n          <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n        </div>\r\n</div>\r\n\r\n<style>\r\n    md-tabs-template {\r\n        transition: none;\r\n    }\r\n\r\n    md-pagination-wrapper.md-center-tabs {\r\n        position: relative;\r\n        justify-content: space-between;\r\n    }\r\n    md-tabs.md-primary>md-tabs-wrapper {\r\n        background-color: #fff;\r\n    }\r\n\r\n    @media (min-width: 960px) {\r\n    .tabsdemoCenterTabs md-tab-item {\r\n        min-width: 160px;\r\n    }\r\n    }\r\n</style>\r\n\r\n\r\n");
$templateCache.put("app/vvs.components/rop/lines/ttb.html","<form novalidate>\r\n    <!-- lines.init.page -->\r\n    <div class=\"col-xs-12 col-sm-12 col-md-12 content spacertoplarge\">\r\n        <div class=\"input-wrap-xs infocus col-xs-12 pl-0 pr-0\">\r\n            <div class=\"form-group spacerbottomlarge\">\r\n                <vvs-alert ng-if=\"VVSROPLineCtrl.ropAlert\" text=\"\'Bitte geben Sie eine Linie ein!\'\"></vvs-alert>\r\n                <vvs-line-odv usage=\"rop\"></vvs-line-odv>\r\n            </div>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"suchen\">\r\n            <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                <button id=\"vvs_rop_lines_submit\" type=\"submit\" ng-click=\"triggerROPClick()\" class=\"search-btn btn btn-primary btn-block\">{{\'Suchen\'|translate}}</button>\r\n            </div>\r\n        </div>\r\n        <vvs-history mode=\"line\" usage=\"rop\"></vvs-history>\r\n    </div>\r\n\r\n</form>\r\n\r\n\r\n");
$templateCache.put("app/vvs.components/rop/stops/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div ng-if=\"pdfError\">\r\n        <vvs-alert text=\"\'Es ist ein Fehler aufgetreten! Die Datei konnte nicht erstellt werden!\'\"></vvs-alert>\r\n    </div>\r\n    <form ng-submit=\"triggerFireROPClick()\" novalidate>\r\n        <div class=\"input-wrap-xs infocus col-xs-12 pl-0 pr-0 wrap-xs\">\r\n            <div class=\"form-group spacerbottomlarge\">\r\n                <!-- alerts -->\r\n                <vvs-alert ng-if=\"ropAlert\" text=\"\'Bitte geben Sie einen Ort, Haltestelle, Adresse oder POI für den Stadtplanausschnitt ein!\'\"></vvs-alert>\r\n                <!-- odv from -->\r\n                <vvs-location-odv usage=\"rop\"></vvs-location-odv>\r\n            </div>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"suchen\">\r\n            <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                <button type=\"submit\" class=\"search-btn btn btn-primary btn-block\">{{\'PDF herunterladen\' | translate}}</button>\r\n            </div>\r\n        </div>\r\n        <vvs-history mode=\"location\" usage=\"rop\"></vvs-history>\r\n    </form>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/stt/init/lines.html","<div class=\"trip-container\">\r\n    STT INIT\r\n    <md-tabs md-selected=\"tabIndex\" md-dynamic-height md-border-bottom class=\"nav nav-tabs\">\r\n        <md-tab>\r\n            <md-tab-label>\r\n                <vvs-icon name=\"haltestelle\"></vvs-icon> {{\'Haltestelle\' | translate}}\r\n            </md-tab-label>\r\n            <md-tab-body>\r\n                <vvs-include vvs-src=\"stt/stops/main.html\"></vvs-include>\r\n            </md-tab-body>\r\n        </md-tab>\r\n        <md-tab>\r\n            <md-label>\r\n                <vvs-icon name=\"linien\"></vvs-icon> {{\'Linie\' | translate}}\r\n            </md-label>\r\n            <md-tab-body>\r\n                <vvs-include vvs-src=\"stt/lines/main.html\"></vvs-include>\r\n            </md-tab-body>\r\n        </md-tab>\r\n    </md-tabs>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/stt/init/main.html","<div class=\"trip-container padding-md\">\r\n    <md-tabs md-selected=\"tabIndex\" md-dynamic-height md-border-bottom class=\"nav nav-tabs\">\r\n        <md-tab>\r\n            <md-tab-label>\r\n                <vvs-icon name=\"haltestelle\"></vvs-icon> {{\'Haltestelle\' | translate}}\r\n            </md-tab-label>\r\n            <md-tab-body>\r\n                <vvs-include vvs-src=\"stt/stops/main.html\"></vvs-include>\r\n            </md-tab-body>\r\n        </md-tab>\r\n        <md-tab>\r\n            <md-label>\r\n                <vvs-icon name=\"linien\"></vvs-icon> {{\'Linie\' | translate}}\r\n            </md-label>\r\n            <md-tab-body>\r\n                <vvs-include vvs-src=\"stt/lines/main.html\"></vvs-include>\r\n            </md-tab-body>\r\n        </md-tab>\r\n    </md-tabs>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/stt/init/stops.html","<div class=\"trip-container\">\r\n    <vvs-include vvs-src=\"stt/stops/main.html\"></vvs-include>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/stt/lines/main.html","<div class=\"tab-pane clearfix\" id=\"list\" ng-controller=\"VVSSTTLinesController as VVSSTTLinesCtrl\">\r\n    <form ng-submit=\"VVSSTTLinesCtrl.triggerFireSTTClick()\" novalidate>\r\n        <div class=\"infocus col-xs-12 pl-0 pr-0\">\r\n            <div class=\"form-group spacertoplarge spacerbottomlarge\">\r\n                <vvs-alert ng-if=\"VVSSTTLinesCtrl.sttAlert\" text=\"\'Bitte geben Sie eine Linie ein!\'\"></vvs-alert>\r\n                <vvs-line-odv usage=\"stt\"></vvs-line-odv>\r\n            </div>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"suchen\">\r\n            <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                <button type=\"submit\" class=\"search-btn btn btn-primary btn-block\">{{\'Suchen\'|translate}}</button>\r\n            </div>\r\n        </div>\r\n        <vvs-history mode=\"line\" usage=\"stt\"></vvs-history>\r\n    </form>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/stt/modals/refresh.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Aktualisieren\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\" ng-controller=\"VVSSTTModalsRefreshController\">\r\n        <h2>{{\'Neue Anfrage berechnen\' | translate}}</h2>\r\n        <div class=\"modal-block spacerbottomlarge\">\r\n            <!-- <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit angefragter Uhrzeit\" role=\"group\">\r\n                <div class=\"btn-group \" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"triggerRefreshWithSameTimeClick(); dismissModal()\">{{\'mit angefragter Uhrzeit\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n            <br> -->\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"mit aktueller Uhrzeit\" role=\"group\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"triggerRefreshWithCurrentTimeClick(); dismissModal()\">{{\'mit aktueller Uhrzeit\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>");
$templateCache.put("app/vvs.components/stt/stops/main.html","<div class=\"tab-pane clearfix\" id=\"grafik\" ng-controller=\"VVSSTTStopsController as VVSSTTStopsCtrl\">\r\n    <form ng-submit=\"VVSSTTStopsCtrl.triggerFireSTTClick()\" novalidate>\r\n        <div class=\"infocus col-xs-12 spacerbottom pl-0 pr-0 wrap-xs\">\r\n            <!-- alerts -->\r\n            <vvs-alert ng-if=\"VVSSTTStopsCtrl.sttAlert\" text=\"\'Bitte geben Sie einen Ort, Haltestelle, Adresse oder POI für den Aushangfahrplan ein!\'\"></vvs-alert>\r\n            <!-- odv from -->\r\n            <vvs-location-odv usage=\"stt\"></vvs-location-odv>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"suchen\">\r\n            <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                <button type=\"submit\" class=\"search-btn btn btn-primary btn-block\">{{\'Suchen\'|translate}}</button>\r\n            </div>\r\n        </div>\r\n\r\n        <!-- include assigned stops box -->\r\n        <vvs-assigned-stops location=\"inputLocations.stt\" usage=\"\'stt\'\" ng-if=\"inputLocations.stt.assignedStops().length>1\"></vvs-assigned-stops>\r\n        <!-- include history box -->\r\n        <ng-container ng-hide=\"inputLocations.stt.assignedStops().length > 1\">\r\n            <vvs-history mode=\"location\" usage=\"stt\"></vvs-history>\r\n        </ng-container>\r\n    </form>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/directives/acc.html","<div class=\"vvs-access\">\r\n    <div class=\"vvs-access-title\">Zugänglichkeit</div>\r\n    <ul class=\"vvs-access-icons\">\r\n        <li class=\"icon-item\" ng-if=\"attributes | VVSCheckArithmeticSequence\">\r\n            <img\r\n                class=\"acc-img\"\r\n                src=\"app/vvs.components/assets/images/icons/accessibility/acc_guiding_elements.svg\"\r\n                alt=\"acc_guiding_elements\"\r\n            />\r\n        </li>\r\n        <li class=\"icon-item\" ng-if=\"widthAvail >= 2500\">\r\n            <img\r\n                class=\"acc-img\"\r\n                src=\"app/vvs.components/assets/images/icons/accessibility/acc_maneuvering_area.svg\"\r\n                alt=\"acc_maneuvering_area\"\r\n            />\r\n        </li>\r\n        <li class=\"icon-item\" ng-if=\"stepFromStreet === 0\">\r\n            <img\r\n                class=\"acc-img\"\r\n                src=\"app/vvs.components/assets/images/icons/accessibility/acc_stop_accessibility.svg\"\r\n                alt=\"acc_stop_accessibility\"\r\n            />\r\n        </li>\r\n        <li class=\"icon-item\" ng-if=\"barrierFreeAccess\">\r\n            <img\r\n                class=\"acc-img\"\r\n                src=\"app/vvs.components/assets/images/icons/accessibility/acc_barrierfree_access.svg\"\r\n                alt=\"acc_barrierfree_access\"\r\n            />\r\n        </li>\r\n    </ul>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/init/main.html","<form name=\"tripForm\" novalidate vvs-enter=\"tripCtrl.triggerFireSearchClick()\">\r\n    <div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n        <div class=\"content-wrap\">\r\n            <div ng-hide=\"isDeepLink\">\r\n                <div class=\"input-wrap wrap-xs infocus col-xs-12\">\r\n                    <h2 class=\"function-header tabs p0\">{{\'Verbindungen\'|translate}}</h2>\r\n                    <vvs-alert ng-if=\"errorMessages.length>0\" messages=\"errorMessages\"></vvs-alert>\r\n                    <vvs-alert ng-if=\"tripMissingInputAlert\" text=\"\'Bitte Start und Ziel eingeben!\'\"></vvs-alert>\r\n                    <vvs-alert ng-if=\"tripMissingOrigAlert\" text=\"\'Bitte Start eingeben!\'\"></vvs-alert>\r\n                    <vvs-alert ng-if=\"tripMissingDestAlert\" text=\"\'Bitte Ziel eingeben!\'\"></vvs-alert>\r\n                    <vvs-alert ng-if=\"tripSameInputsAlert\" text=\"\'Start und Ziel liegen zu nahe nebeneinander, um eine Fahrt zu berechnen!\'\"></vvs-alert>\r\n                    <vvs-alert ng-if=\"tripNoResultsAlert\" text=\"\'Leider konnte mit den gewählten Fahrtoptionen keine Verbindung gefunden werden! Erhöhen Sie die Fußwegzeit und versuchen Sie es erneut!\'\"></vvs-alert>\r\n                    <vvs-alert ng-if=\"validationCheckAlert\" text=\"\'Leider konnte keine Verbindungsempfehlung berechnet werden! Überprüfen Sie Start/Ziel Eingabe und versuchen Sie es erneut!\'\"></vvs-alert>\r\n                    <vvs-alert ng-if=\"requestFailed\" text=\"\'Unsere Server sind leider im Moment nicht erreichbar. Bitte versuchen Sie es in einigen Augenblicken erneut.\'\"></vvs-alert>\r\n                    <vvs-alert ng-if=\"takeBikeAlert\" html=\"\'Leider konnte keine Verbindungsempfehlung berechnet werden. Bitte beachten Sie unsere Hinweise zur <a href=\\\'http://www.vvs.de/fahrradmitnahme/\\\' target=\\\'_blank\\\'>Fahrradmitnahme</a>. Fahrradrouten können Sie auch in unserem <a href=\\\'https://radroutenplaner.vvs.de/\\\' target=\\\'_blank\\\'>Radroutenplaner</a> planen.\'\"></vvs-alert>\r\n\r\n                    <!-- odv from -->\r\n                    <vvs-location-odv usage=\"orig\"></vvs-location-odv>\r\n                    <!-- include switch/via buttons -->\r\n                    <vvs-include vvs-src=\"odv/controls/switch-via.html\"></vvs-include>\r\n                    <!-- odv to -->\r\n                    <vvs-location-odv usage=\"dest\"></vvs-location-odv>\r\n                    <!-- odv via -->\r\n                    <vvs-include vvs-src=\"odv/suggestion/location/odv-via.html\"></vvs-include>\r\n                    <!-- include \'Abfahrt&Ankunft/Datepicker/Timepicker\'-->\r\n                    <vvs-include vvs-src=\"odv/controls/main.html\"></vvs-include>\r\n                </div>\r\n\r\n                <!-- include mobile date picker-->\r\n                <vvs-include vvs-src=\"odv/date/mobile.html\"></vvs-include>\r\n\r\n                <div class=\"ctblock col-xs-12 nopadding-xs spacerbottomlarge\" role=\"group\" aria-label=\"suchen\">\r\n                    <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                        <button type=\"button\" class=\"search-btn btn btn-primary btn-block\" ng-click=\"tripCtrl.triggerFireSearchClick()\">{{\'Suchen\' | translate}}</button>\r\n                    </div>\r\n                </div>\r\n                <div class=\"ctblock col-xs-12 nopadding-xs\" role=\"group\">\r\n                    <!-- include meansOfTransport button -->\r\n                    <vvs-include vvs-src=\"trip/options/means-of-transport/main.html\"></vvs-include>\r\n                    <!-- include settings button -->\r\n                    <vvs-include vvs-src=\"trip/options/settings/main.html\"></vvs-include>\r\n                </div>\r\n                <!-- include history box -->\r\n                <vvs-history mode=\"odv\" usage=\"odv\"></vvs-history>\r\n            </div>\r\n            <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n        </div>\r\n    </div>\r\n</form>\r\n");
$templateCache.put("app/vvs.components/trip/modals/calendar.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Kalendereintrag\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <h2>{{\'Gewählte Verbindung im Kalender eintragen\' | translate}}</h2>\r\n        <div class=\"modal-block spacerbottomlarge\">\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"Eintragen\" role=\"group\">\r\n                <div class=\"btn-group \" role=\"group\">\r\n                    <button class=\"btn btn-default\" ng-click=\"triggerAddToIcsCalendarClick(trip); dismissModal();\" type=\"button\">{{\'Eintragen\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/modals/print.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'PDF herunterladen\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <h2>{{\'Sie können die gewählte Verbindung als druckfähiges PDF herunterladen.\' | translate}}</h2>\r\n        <div class=\"modal-block spacerbottomlarge\">\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"Eintragen\" role=\"group\">\r\n                <div class=\"btn-group \" role=\"group\">\r\n                    <button class=\"btn btn-default\" ng-click=\"triggerCreateJourneyPdf(trip); dismissModal();\" type=\"button\">{{\'Herunterladen\' | translate}}</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <div class=\"wrap-xs\">\r\n        <h1 class=\"function-header\">{{\'Fahrtempfehlung\'|translate}}</h1>\r\n    </div>\r\n\r\n    <!-- trip results summary -->\r\n    <vvs-include vvs-src=\"trip/result/summary/main.html\"></vvs-include>\r\n\r\n    <vvs-include vvs-src=\"trip/result/messages/no-realtime.html\" ng-if=\"!SEARCH_OPTIONS.dateTime.useRealTime\"></vvs-include>\r\n\r\n\r\n    <div class=\"trip-container col-xs-12 nopadding\" ng-if=\"journeyObj.service.getResults().length > 0\">\r\n        <p class=\"printlink visible-md visible-lg\">\r\n            <a href=\"javascript:void(0)\" ng-click=\"triggerTripPrintClick()\" title=\"{{\'Fahrten drucken\'|translate}}\">\r\n                <vvs-icon name=\"print\"></vvs-icon> {{\'Fahrten drucken\'|translate}}\r\n            </a>\r\n        </p>\r\n\r\n        <div class=\"btn-group btn-group-justified change-trip-time spacerbottom spacertop\" role=\"group\" aria-label=\"...\">\r\n            <div class=\"btn-group\" role=\"group\">\r\n                <button type=\"button\" class=\"btn btn-link\" ng-click=\"triggerPreviousClick()\" title=\"{{\'Frühere Optionen anzeigen\'|translate}}\">\r\n                    <span class=\"pull-left text-left\">\r\n                        <vvs-icon name=\"up\"></vvs-icon>	{{\'Früher\'|translate}}\r\n                    </span>\r\n                </button>\r\n            </div>\r\n            <div class=\"btn-group\" role=\"group\">\r\n                <button type=\"button\" class=\"btn btn-link\" ng-click=\"triggerNextClick()\" title=\"{{\'Spätere Optionen anzeigen\'|translate}}\">\r\n                    <span class=\"pull-right text-right\">\r\n                    {{\'Später\'|translate}} <vvs-icon name=\"down\"></vvs-icon>\r\n                    </span>\r\n                </button>\r\n            </div>\r\n        </div>\r\n        <md-tabs md-dynamic-height md-border-bottom class=\"nav nav-tabs listGrafikTrip\">\r\n            <md-tab>\r\n                <md-tab-label>\r\n                    <vvs-icon name=\'liste\'></vvs-icon> {{\'Liste\'|translate}}\r\n                </md-tab-label>\r\n                <md-tab-body>\r\n                    <vvs-include vvs-src=\"trip/result/list/main.html\"></vvs-include>\r\n                </md-tab-body>\r\n            </md-tab>\r\n            <md-tab style=\"min-width: 100px;\">\r\n                <md-label>\r\n                    <vvs-icon name=\'grafik\'></vvs-icon> {{\'Grafik\'|translate}}\r\n                </md-label>\r\n                <md-tab-body>\r\n                    <vvs-include vvs-src=\"trip/result/graph/main.html\"></vvs-include>\r\n                </md-tab-body>\r\n            </md-tab>\r\n        </md-tabs>\r\n    </div>\r\n    <!-- include settings summary -->\r\n    <vvs-include vvs-src=\"trip/result/settings/main.html\"></vvs-include>\r\n    <vvs-include vvs-src=\"common/media.html\" ng-if=\"!(\'vvs.trip.print\'|isState)\"></vvs-include>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/tickets/main.html","<div class=\"buy nopadding-xs\">\r\n    <div class=\"btn-group highlight\" role=\"group\">\r\n        <vvs-modal vvs-modal-template=\"trip/tickets/modal.html\"></vvs-modal>\r\n        <div ng-if=\"!isGoe && !isHNV\">\r\n            <button type=\"button\" class=\"btn btn-default ticketsModal\" ng-if=\"!trip.adultSingleTicket()\" vvs-modal vvs-modal-template=\"trip/tickets/modal.html\" title=\"{{\'keine Angabe\'|translate}}\">{{\'k.A\'|translate}}</button>\r\n            <button type=\"button\" class=\"btn btn-default ticketsModal\" ng-if=\"trip.adultSingleTicket()\" vvs-modal vvs-modal-template=\"trip/tickets/modal.html\" title=\"{{\'Liste der Fahrpreise anzeigen\'|translate}}\">{{trip.adultSingleTicket().price()|VVSPriceFormatter}} €</button>\r\n        </div>\r\n        <div ng-if=\"isGoe\">\r\n            <a href=\"javascript:void(0)\" class=\"filsland\" vvs-modal vvs-modal-template=\"trip/tickets/modal.html\"></a>\r\n        </div>\r\n        <div ng-if=\"isHNV\">\r\n            <button type=\"button\" class=\"btn btn-default ticketsModal\" vvs-modal vvs-modal-template=\"trip/tickets/modal.html\" title=\"{{\'keine Angabe\'|translate}}\">{{\'k.A\'|translate}}</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/tickets/modal.html","<div id=\"vvsTicketsModal\" ng-init=\"collapseMobileTickets=false\">\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Ticketkauf\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\" ng-controller=\"VVSTripTicketsModalsController\" ng-class=\"{\'is-goe\': isGoe}\">\r\n        <div class=\"infoarea clearfix spacertoplarge\">\r\n            <div class=\"col-xs-12 spacerbottom\">\r\n                <div class=\"pull-left text-left\">\r\n                    <vvs-icon name=\"{{trip.vias().length>0?\'von-nach2\':\'von-nach\'}}\"></vvs-icon>\r\n                </div>\r\n                <div class=\"pull-left text-left\">\r\n                    <p>\r\n                        {{trip.origin() | VVSLocationNameFormatter}}\r\n                        <br ng-show=\"trip.vias().length>0\">{{trip.vias()[0] | VVSLocationNameFormatter}}\r\n                        <br>{{trip.destination() | VVSLocationNameFormatter}}\r\n                    </p>\r\n                </div>\r\n            </div>\r\n            <div class=\"vvsGoeLogoContainer\" style=\"display:none;\">\r\n                <a href=\"https://www.filsland.de/\" class=\"filsland big\" target=\"_blank\">\r\n\r\n                </a>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"infoarea col-xs-12 padding-xs modaltext\" ng-if=\"!trip.adultSingleTicket()\">\r\n            <p>\r\n                {{\'Keine Angaben zum Fahrpreis möglich, da eine Fahrtverbindung mit der Einstellung \"über\" (Umwegfahrt) angefordert wurde, ein Fahrziel außerhalb des VVS-Tarifgebiets liegt, die Fahrtverbindung teils eine Ruftaxirelation enthält oder die Verbindung eine reine IV-Strecke (Fußweg / Radweg) ist.\'|translate}}\r\n            </p>\r\n        </div>\r\n\r\n        <div ng-if=\"trip.adultSingleTicket()\">\r\n\r\n            <div class=\"col-xs-12 ambassadors separator-bottom hidden-xs\" ng-if=\"!isGoe\">\r\n                <ul class=\"ambassadorList\">\r\n                    <li>\r\n                        <a class=\"ambEntry ambEntry7\" target=\"_blank\" href=\"https://www.vvs.de/preisvergleichsrechner/\">\r\n                            <span>{{\'Preisvergleich\' | translate}}</span>\r\n                        </a>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n\r\n            <div class=\"col-xs-12 modaltext\">\r\n                <p>\r\n                    <div ng-if=\"!isGoe\" class=\"not_goe\">\r\n                        <span ng-if=\"trip.adultSingleTicket().priceLevel()==1\">{{\'Zu zahlende Zone\' | translate}}: </span>\r\n                        <span ng-if=\"trip.adultSingleTicket().priceLevel()>1\">{{\'Zu zahlende Zonen\' | translate}}: </span>\r\n                        <strong>\r\n                            <span ng-if=\"trip.adultSingleTicket().priceLevel()!==\'0\'\">{{trip.adultSingleTicket().priceLevel()}}</span>\r\n                            <span ng-if=\"trip.adultSingleTicket().priceLevel()===\'0\'\">{{\'Kurzstrecke\'}}</span>\r\n                        </strong>\r\n                        <br>\r\n                        <span class=\"hidden-xs\" ng-init=\"timeTicket = getTimeTicket(trip)\">{{\'Anzahl der zu zahlenden Zonen bei Zeittickets\' | translate}}: <strong>{{timeTicket.priceLevel()}}</strong><br>\r\n                        </span>\r\n                            <span ng-if=\"trip.allZones()[0].zones.length==1\">{{\'Befahrene Zone\' | translate}}:</span>\r\n                            <span ng-if=\"trip.allZones()[0].zones.length>1\">{{\'Befahrene Zonen\' | translate}}:</span>\r\n                            <span ng-repeat=\"zone in zones track by $index\">\r\n                                <strong>{{zone|VVSZonesCleaner}}</strong>\r\n                                <span ng-hide=\"$last\">, </span>\r\n                            </span>\r\n                    </div>\r\n                    <div ng-if=\"isGoe\">\r\n                        {{\'Zonen/Preisstufen\' | translate}}: <strong><span ng-if=\"trip.adultSingleTicket().priceLevel()!==\'0\'\">{{trip.adultSingleTicket().priceLevel()}}</span><span ng-if=\"trip.adultSingleTicket().priceLevel()===\'0\'\">{{\'Kurzstrecke\'}}</span></strong>\r\n                    </div>\r\n                </p>\r\n            </div>\r\n            <!-- <div class=\"col-xs-4 modaltext no-print\">\r\n                <a href=\"javascript:void(0)\" class=\"download-tickets\" onClick=\"window.print();dismissModal();\">\r\n                    <button type=\"button\" class=\"btn btn-default\" title=\"{{\'Herunterladen\'|translate}}\">\r\n                        <vvs-icon name=\"pdf\"></vvs-icon> <span>{{\'Herunterladen\' | translate}}</span>\r\n                    </button>\r\n                </a>\r\n            </div> -->\r\n            <table class=\"table prices\">\r\n                <colgroup>\r\n                    <col width=\"63%\">\r\n                    <col width=\"37%\">\r\n                </colgroup>\r\n                <tbody>\r\n                    <tr class=\"hidden-xs\" ng-repeat=\"ticket in allTickets\" ng-init=\"shopUrl=getTicketShopUrl(ticket, \'desktop\')\" ng-if =\"!monthWeekTickets.includes(ticket.name())\">\r\n                        <td>\r\n                            <span ng-if=\"!isGoe\">{{ticket|VVSTicketNameFormatterUpdate}}</span>\r\n                            <span ng-if=\"isGoe\">{{ticket|VVSTicketGoeNameFormatter}}</span>\r\n                            <span ng-if=\"isGoe\">\r\n                                <span ng-if=\"ticket.priceLevel()==\'\'\">{{\'(Schiene)\'|translate}}</span>\r\n                                <span ng-if=\"(ticket.priceLevel()!=\'\') && (ticket.priceLevel()>399)\">{{\'(Schiene)\'|translate}}</span>\r\n                                <span ng-if=\"(ticket.priceLevel()!=\'\') && (ticket.priceLevel()<400)\">{{\'(Bus + Schiene)\'|translate}}</span>\r\n                            </span>\r\n                        </td>\r\n                        <td class=\"price\" ng-if=\"!shopUrl\">{{ticket.price() | VVSPriceFormatter}} €</td>\r\n                        <td class=\"price\" ng-if=\"shopUrl\">\r\n                            <a href=\"{{shopUrl}}\" target=\"_blank\">\r\n                                <vvs-icon name=\"basket\"></vvs-icon>{{ticket.price() | VVSPriceFormatter}} €\r\n                            </a>\r\n                        </td>\r\n                    </tr>\r\n\r\n                    <table class=\"table prices mobil\" ng-repeat=\"ticket in allTickets\" ng-init=\"shopUrl=getTicketShopUrl(ticket, \'mobile\'); desktopTicket=getDesktopVersion(ticket)\" ng-if =\"!monthWeekTickets.includes(ticket.name())\">\r\n                        <tr class=\"visible-xs\" ng-if=\"shopUrl\">\r\n                            <td>\r\n                                <span ng-if=\"!isGoe\">{{ticket|VVSTicketNameFormatterUpdate}}</span>\r\n                                <span ng-if=\"isGoe\">{{ticket|VVSTicketGoeNameFormatter}}</span>\r\n                                <span ng-if=\"isGoe\">\r\n                                    <span ng-if=\"ticket.priceLevel()==\'\'\">{{\'(Schiene)\'|translate}}</span>\r\n                                    <span ng-if=\"(ticket.priceLevel()!=\'\') && (ticket.priceLevel()>399)\">{{\'(Schiene)\'|translate}}</span>\r\n                                    <span ng-if=\"(ticket.priceLevel()!=\'\') && (ticket.priceLevel()<400)\">{{\'(Bus + Schiene)\'|translate}}</span>\r\n                                </span>\r\n                            </td>\r\n                            <td class=\"price\" ng-if=\"!shopUrl\">{{ticket.price() | VVSPriceFormatter}} €</td>\r\n                            <td class=\"price\" ng-if=\"shopUrl\">\r\n                                <a href=\"{{shopUrl}}\" target=\"_blank\">\r\n                                    <vvs-icon name=\"basket\" ng-if=\"ticket.name()!=\'EinzelTicket Mobil\'\"></vvs-icon><span>{{ticket.price() | VVSPriceFormatter}} €</span>\r\n                                </a>\r\n                            </td>\r\n                        </tr>\r\n                        <tr class=\"visible-xs\" ng-if=\"desktopTicket && !isGoe\">\r\n                            <td colspan=\"2\" class=\"info-text\">\r\n                                <vvs-icon name=\"fpaenderungen\"></vvs-icon> {{\'Preis beim Kauf am Automat / im Bus\' | translate}} {{desktopTicket.price() | VVSPriceFormatter}} €\r\n                            </td>\r\n                        </tr>\r\n                    </table>\r\n                </tbody>\r\n            </table>\r\n\r\n\r\n            <button type=\"button\" class=\"rest-tickets btn btn-default btn-block btn-label collapse-toggle collapsed visible-xs\" data-toggle=\"collapse\" data-target=\"#moretickets-collapse\" aria-expanded=\"false\" aria-controls=\"moretickets-collapse\" ng-click=\"collapseMobileTickets=(!collapseMobileTickets)\" ng-hide=\"isGoe\">\r\n                <div class=\"pull-left text-left\">\r\n                    {{\'Weitere Tickets\' | translate}}\r\n                </div>\r\n                <div class=\"pull-right text-right closed\" ng-hide=\"collapseMobileTickets\">\r\n                    <vvs-icon name=\"down\"></vvs-icon>\r\n                </div>\r\n                <div class=\"pull-right text-right open\" ng-hide=\"!collapseMobileTickets\">\r\n                    <vvs-icon name=\"up\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n\r\n            <div class=\"vvs-animated-mobile-tickets\" ng-class={\'visible-xs\':isGoe} id=\"moretickets-collapse\" uib-collapse=\"!collapseMobileTickets\">\r\n                <table class=\"table prices spacerbottomlarge\">\r\n                    <colgroup>\r\n                        <col width=\"63%\">\r\n                        <col width=\"37%\">\r\n                    </colgroup>\r\n                    <tbody>\r\n                        <tr ng-repeat=\"ticket in allTickets\" ng-init=\"shopUrl=getTicketShopUrl(ticket, \'mobile\')\" ng-if=\"!shopUrl\">\r\n                            <td>\r\n                                <span ng-if=\"!isGoe\">{{ticket|VVSTicketNameFormatterUpdate}}</span>\r\n                                <span ng-if=\"isGoe\">{{ticket|VVSTicketGoeNameFormatter}}</span>\r\n                                <span ng-if=\"isGoe\">\r\n                                    <span ng-if=\"ticket.priceLevel()==\'\'\">{{\'(Schiene)\'|translate}}</span>\r\n                                    <span ng-if=\"(ticket.priceLevel()!=\'\') && (ticket.priceLevel()>399)\">{{\'(Schiene)\'|translate}}</span>\r\n                                    <span ng-if=\"(ticket.priceLevel()!=\'\') && (ticket.priceLevel()<400)\">{{\'(Bus + Schiene)\'|translate}}</span>\r\n                                </span>\r\n                            </td>\r\n                            <td class=\"price\">{{ticket.price() | VVSPriceFormatter}} €</td>\r\n                        </tr>\r\n\r\n                    </tbody>\r\n                </table>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/ttb/init/main.html","<div class=\"trip-container padding-md\">\r\n    <h2 ng-if=\"lfp=== \'false\' \" class=\"function-header hidden-xs hidden-sm\">{{\'Fahrplanbuchseiten\' | translate}}</h2>\r\n    <h2 ng-if=\"lfp=== \'true\' \" class=\"function-header hidden-xs hidden-sm\">{{\'Linienfahrplan\' | translate}}</h2>\r\n\r\n    <md-tabs md-selected=\"tabIndex\" md-dynamic-height md-border-bottom class=\"nav nav-tabs\">\r\n        <md-tab>\r\n            <md-tab-label>\r\n                <vvs-icon name=\"linien\"></vvs-icon> {{\'Linie\' | translate}}\r\n            </md-tab-label>\r\n            <md-tab-body>\r\n                <vvs-include vvs-src=\"ttb/lines/main.html\"></vvs-include>\r\n            </md-tab-body>\r\n        </md-tab>\r\n        <ng-container ng-if=\"lfp=== \'false\' \">\r\n            <md-tab>\r\n                <md-label>\r\n                    <vvs-icon name=\"haltestelle\"></vvs-icon> {{\'Haltestelle\' | translate}}\r\n                </md-label>\r\n                <md-tab-body>\r\n                    <vvs-include vvs-src=\"ttb/stops/main.html\"></vvs-include>\r\n                </md-tab-body>\r\n            </md-tab>\r\n        </ng-container>\r\n    </md-tabs>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/ttb/lines/main.html","<div class=\"tab-pane clearfix\" id=\"list\" ng-controller=\"VVSTTBLinesController as VVSTTBLinesCtrl\">\r\n    <form ng-submit=\"VVSTTBLinesCtrl.triggerFireTTBClick()\" novalidate>\r\n        <div ng-if=\"pdfError\">\r\n            <vvs-alert text=\"\'Es ist ein Fehler aufgetreten! Die Datei konnte nicht erstellt werden!\'\"></vvs-alert>\r\n        </div>\r\n        <ng-container>\r\n            <div class=\"infocus col-xs-12 pl-0 pr-0\">\r\n                <div class=\"form-group spacertoplarge spacerbottomlarge\">\r\n\r\n                    <vvs-alert ng-if=\"VVSTTBLinesCtrl.ttbAlert\" text=\"\'Bitte geben Sie eine Linie ein!\'\"></vvs-alert>\r\n\r\n                    <vvs-line-odv usage=\"ttb\"></vvs-line-odv>\r\n\r\n                </div>\r\n            </div>\r\n            <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"suchen\">\r\n                <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                    <button type=\"submit\" class=\"search-btn btn btn-primary btn-block\">{{\'PDF herunterladen\'|translate}}</button>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n        <vvs-history mode=\"line\" usage=\"ttb\"></vvs-history>\r\n    </form>\r\n\r\n</div>\r\n");
$templateCache.put("app/vvs.components/ttb/stops/main.html","<div class=\"tab-pane clearfix\" id=\"grafik\" ng-controller=\"VVSTTBStopsController as VVSTTBStopsCtrl\">\r\n    <form ng-submit=\"VVSTTBStopsCtrl.triggerFireTTBClick()\" novalidate>\r\n        <!--<div ng-show=\"$state.includes(\'vvs.ttb\')\" ui-view=\"ttb\"></div>-->\r\n        <!--<div ui-view></div>-->\r\n        <div class=\"input-wrap infocus col-xs-12 spacerbottom pl-0 pr-0\">\r\n            <!-- alerts -->\r\n            <vvs-alert ng-if=\"VVSTTBStopsCtrl.ttbAlert\" text=\"\'Bitte geben Sie einen Ort, Haltestelle, Adresse oder POI für die Fahplanbuchseite ein!\'\"></vvs-alert>\r\n            <!-- odv from -->\r\n            <vvs-location-odv usage=\"ttb\"></vvs-location-odv>\r\n        </div>\r\n        <div class=\"ctblock col-xs-12 nopadding-xs padding-sm spacerbottomlarge\" role=\"group\" aria-label=\"suchen\">\r\n            <div class=\"col-xs-12 col-sm-6 col-sm-offset-3\">\r\n                <button type=\"submit\" class=\"search-btn btn btn-primary btn-block\">{{\'Suchen\'|translate}}</button>\r\n            </div>\r\n        </div>\r\n\r\n        <!-- include assigned stops box -->\r\n        <vvs-assigned-stops location=\"inputLocations.ttb\" usage=\"\'ttb\'\" ng-if=\"inputLocations.ttb.assignedStops().length>1\"></vvs-assigned-stops>\r\n\r\n        <!-- include history box -->\r\n        <ng-container ng-hide=\"inputLocations.ttb.assignedStops().length > 1\">\r\n            <vvs-history mode=\"location\" usage=\"ttb\"></vvs-history>\r\n        </ng-container>\r\n    </form>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/odv/suggestion/line/odv.html","<!--<md-autocomplete\r\n    ng-focus=\"ctrl.triggerFocus()\"\r\n    ng-model=\"inputLines[usage]\"\r\n    ng-class=\"form-control\"\r\n    md-no-cache=\"ctrl.noCache\"\r\n    md-selected-item=\"inputLines[usage]\"\r\n    md-search-text-change=\"ctrl.querySearch(inputLinesValues[usage])\"\r\n    md-search-text=\"inputLinesValues[usage]\"\r\n    md-selected-item-change=\"ctrl.selectedItemChange(item)\"\r\n    md-items=\"item in ctrl.querySearch(inputLinesValues[usage])\"\r\n    md-item-text=\"(item|VVSLineNameFormatter)\"\r\n    md-min-length=\"0\"\r\n    placeholder=\"{{\'Linien\'|translate}}\"\r\n    md-menu-class=\"suggestion-wrapper ctblock col-xs-12 nopadding-xs\"\r\n    md-clear-button=\"true\"\r\n    md-dropdown-items=\"100\">\r\n    <div class=\"suggestion-wrapper\">\r\n        <div class=\"ctblock col-xs-12 nopadding-xs vvs-suggestion-container\">\r\n            <md-item-template>\r\n                <a class=\"btn-default btn-block nopadding {{item.className}}\">\r\n                    <div class=\"pull-left text-left\">\r\n                        <vvs-icon product-icon-id=\"{{item.productIconId()}}\"></vvs-icon>\r\n                        <span ng-bind-html=\"item | VVSLineSuggestFormatter\"></span>\r\n                    </div>\r\n                </a>\r\n            </md-item-template>\r\n        </div>\r\n    </div>\r\n</md-autocomplete>\r\n-->\r\n<!-- <div class=\"reset icons\">\r\n    <a href=\"javascript:void(0)\" tabindex=\"-1\" ng-click=\"inputLines[usage] = \'\'\">\r\n        <vvs-icon name=\"neuefahrt\"></vvs-icon>\r\n    </a>\r\n</div> -->\r\n<div ng-keydown=\"ctrl.triggerKeyDown($event)\">\r\n<input\r\n    vvs-line-name-formatter\r\n    ng-model=\"inputLines[usage]\"\r\n    ng-focus=\"ctrl.triggerFocus()\"\r\n    ng-change=\"ctrl.triggerChange()\"\r\n    ng-keydown=\"ctrl.triggerKeyDown($event)\"\r\n    ng-model-options=\"{debounce: 250}\"\r\n    tabindex=\"0\"\r\n    type=\"text\"\r\n    class=\"form-control\"\r\n    placeholder=\"{{\'Linien\'|translate}}\"\r\n    >\r\n\r\n\r\n<div class=\"suggestion-wrapper\" ng-if=\"ctrl.lines.length\">\r\n    <md-list class=\"ctblock col-xs-12 nopadding-xs\">\r\n        <button type=\"button\" ng-repeat=\"item in ctrl.lines\" class=\"btn btn-default btn-block btn-autoheight\" ng-click=\"ctrl.triggerSelect(item)\">\r\n            <div class=\"pull-left text-left\">\r\n                <vvs-icon product-icon-id=\"{{item.productIconId()}}\"></vvs-icon>\r\n                <span ng-bind-html=\"item | VVSLineNameFormatter\"></span>\r\n            </div>\r\n        </button>\r\n    </md-list>\r\n</div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/odv/suggestion/location/auto-complete.html","<!--<md-autocomplete\r\n    ng-focus=\"ctrl.triggerFocus()\"\r\n    ng-model=\"inputLocations[usage]\"\r\n    ng-class=\"form-control\"\r\n    md-no-cache=\"ctrl.noCache\"\r\n    md-selected-item=\"inputLocations[usage]\"\r\n    md-search-text=\"inputLocationsValues[usage]\"\r\n    md-selected-item-change=\"ctrl.selectedItemChange(item)\"\r\n    md-items=\"item in ctrl.querySearch(inputLocationsValues[usage])\"\r\n    md-item-text=\"(item|VVSLocationNameFormatter)\"\r\n    md-min-length=\"0\"\r\n    placeholder=\"{{((usage===\'via\')||(usage===\'pers\'))?(\'Haltestelle\'|translate):(\'Ort, Haltestelle, Adresse, POI\'|translate)}}\"\r\n    md-menu-class=\"suggestion-wrapper ctblock col-xs-12 nopadding-xs\"\r\n    md-clear-button=\"true\"\r\n    md-dropdown-items=\"100\"\r\n    tabindex=\"0\">\r\n    <md-item-template>\r\n        <a class=\"btn-default btn-block nopadding {{item.className}}\">\r\n            <div class=\"pull-left text-left\">\r\n                <vvs-icon type=\"{{item.type()}}\"></vvs-icon>\r\n            </div>\r\n            <div class=\"pull-left text-left hideme\" ng-bind-html=\"item | VVSLocationSuggestFormatter\">\r\n\r\n            </div>\r\n        </a>\r\n    </md-item-template>\r\n</md-autocomplete>\r\n-->\r\n\r\n\r\n<div ng-keydown=\"ctrl.triggerKeyDown($event)\">\r\n    <input\r\n        vvs-location-name-formatter\r\n        ng-model=\"inputLocations[usage]\"\r\n        ng-focus=\"ctrl.triggerFocus()\"\r\n        ng-change=\"ctrl.triggerChange()\"\r\n        ng-keydown=\"ctrl.triggerKeyDown($event)\"\r\n        ng-mousedown=\"ctrl.triggerFocus()\"\r\n        ng-model-options=\"ctrl.modelOptions\"\r\n        class=\"form-control\"\r\n        tabindex=\"0\"\r\n        type=\"text\"\r\n        placeholder=\"{{((usage===\'via\')||(usage===\'pers\'))?(\'Haltestelle\'|translate):(\'Ort, Haltestelle, Adresse, POI\'|translate)}}\"\r\n        >\r\n    <!--<div class=\"suggestion-wrapper\" ng-show=\"ctrl.locations.length\">\r\n        <md-list class=\"ctblock col-xs-12 nopadding-xs\">\r\n            <button type=\"button\" ng-repeat=\"item in ctrl.locations\" class=\"btn btn-default btn-block nopadding\" ng-click=\"ctrl.triggerSelect(item)\">\r\n                <div class=\"pull-left text-left\">\r\n                    <vvs-icon type=\"{{item.type()}}\"></vvs-icon>\r\n                </div>\r\n                <div class=\"pull-left text-left hideme\" ng-bind-html=\"item | VVSLocationSuggestFormatter\">\r\n\r\n                </div>\r\n            </button>\r\n        </md-list>\r\n    </div>-->\r\n\r\n    <md-content class=\"suggestion-wrapper\" ng-if=\"ctrl.locations.length\" style=\"height: auto;\">\r\n        <md-virtual-repeat-container id=\"vertical-container\" class=\"ctblock col-xs-12 nopadding-xs\" ng-style=\"{height: ctrl.resultHeight}\" ng-if=\"ctrl.locations.length>0\">\r\n          <div md-virtual-repeat=\"item in ctrl.locations\" class=\"btn btn-default btn-block nopadding repeated-item\" flex ng-click=\"ctrl.triggerSelect(item)\" ng-attr-autofocus=\"$first\">\r\n            <div class=\"pull-left text-left\" ng-bind-html=\"item | VVSLocationSuggestIcon\">\r\n\r\n            </div>\r\n            <div class=\"pull-left text-left hideme\" ng-bind-html=\"item | VVSLocationSuggestFormatter\">\r\n\r\n            </div>\r\n          </div>\r\n        </md-virtual-repeat-container>\r\n    </md-content>\r\n</div>\r\n\r\n\r\n\r\n");
$templateCache.put("app/vvs.components/odv/suggestion/location/odv-via.html","<div class=\"ctblock col-xs-12 nopadding-xs vvs-via-odv\" ng-show=\"showVia\" role=\"group\">\r\n    <!-- include odv via -->\r\n    <vvs-location-odv usage=\"via\"></vvs-location-odv>\r\n    <!-- include controls -->\r\n    <vvs-include vvs-src=\"odv/controls/via-controls.html\"></vvs-include>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/odv/suggestion/location/odv.html","<vvs-alert ng-if=\"currentPositionAlert\" text=\"\'Ihr Standort konnte leider nicht bestimmt werden!\'\"></vvs-alert>\r\n<vvs-alert ng-if=\"requestFailed\" text=\"\'Unsere Server sind leider im Moment nicht erreichbar. Bitte versuchen Sie es in einigen Augenblicken erneut.\'\"></vvs-alert>\r\n<div class=\"form-group\" ng-class=\"{\'spacertoplarge nomarginbottom\':usage===\'via\', \'nomarginbottom\':(usage===\'dm\')}\" ng-show=\"usage\" ng-switch on=\"usage\">\r\n    <label for=\"odv_input_{{usage}}\" class=\"nopadding-xs\" ng-switch-when=\"orig\">{{\'Start\'|translate}}</label>\r\n    <label for=\"odv_input_{{usage}}\" class=\"nopadding-xs\" ng-switch-when=\"dest\">{{\'Ziel\'|translate}}</label>\r\n    <label for=\"odv_input_{{usage}}\" class=\"nopadding-xs\" ng-switch-when=\"via\">{{\'Via / Nicht Via\'|translate}}</label>\r\n    <label for=\"odv_input_{{usage}}\" class=\"nopadding-xs\" ng-switch-default>&nbsp;</label>\r\n    <div class=\"icons\">\r\n        <!-- <a class=\"hidden-xs\" href=\"javascript:void(0)\" tabindex=\"-1\" ng-click=\"resetODV()\">\r\n            <vvs-icon name=\"neuefahrt\"></vvs-icon>\r\n        </a> -->\r\n        <a href=\"javascript:void(0)\" ng-click=\"ctrl.triggerOdvCurrentPositionClick()\" title=\"{{\'Aktuelle Position\'|translate}}\" tabindex=\"-1\">\r\n            <vvs-icon name=\"standort\"></vvs-icon>\r\n        </a>\r\n        <a href=\"javascript:void(0)\" vvs-modal vvs-modal-template=\"modals/network.html\" vvs-modal-size=\"lg\" title=\"{{\'Punkt auf Karte wählen\'|translate}}\" tabindex=\"-1\">\r\n            <vvs-icon name=\"karte\"></vvs-icon>\r\n        </a>\r\n        <!--<vvs-poi></vvs-poi>-->\r\n    </div>\r\n    <vvs-location-auto-complete usage=\"usage\"></vvs-location-auto-complete>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/stt/lines/stops/main.html","<div ng-controller=\"VVSSTTLinesStopsController as VVSSTTLinesStopsCtrl\">\r\n    <div class=\"infoarea clearfix margin-md\">\r\n        <div class=\"col-xs-12\">\r\n            <div class=\"pull-left text-left\">\r\n                <p>{{\'Suchergebnis für\'|translate}} {{\'Linie\'|translate}}:\r\n                    <br>\r\n                    <span ng-bind-html=\"inputLines.stt | VVSLineSelectionFormatter\"></span></p>\r\n            </div>\r\n        </div>\r\n        <div class=\"col-xs-12 nopadding-xs change-trip-buttons\">\r\n            <div class=\"btn-group\" role=\"group\" aria-label=\"...\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button type=\"button\" class=\"btn btn-link\" ng-click=\"VVSSTTLinesStopsCtrl.triggerSTTResetClick()\">\r\n                        <vvs-icon name=\"aendern\"></vvs-icon> {{\'Neu\'|translate}}\r\n                    </button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div ng-if=\"VVSSTTLinesStopsCtrl.stopSelections.length>0\">\r\n        <h2>{{\'Haltestellen\'|translate}}</h2>\r\n        <div class=\"ctblock buttonlist col-xs-12 nopadding-xs\" role=\"group\" aria-label=\"Linienauswahl\">\r\n            <button type=\"button\" class=\"btn btn-default btn-block\" ng-repeat=\"stopSelection in VVSSTTLinesStopsCtrl.stopSelections\" ng-click=\"VVSSTTLinesStopsCtrl.triggerFireSTTDownloadClick(stopSelection)\">\r\n                <div class=\"pull-left text-left hideme\">\r\n                    <vvs-icon name=\"haltestelle\"></vvs-icon> <strong>{{stopSelection|VVSLocationNameFormatter}}</strong>\r\n                </div>\r\n                <div class=\"pull-right text-right send\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                </div>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/stt/stops/lines/main.html","<div class=\"stt-lines\" ng-controller=\"VVSSTTStopsLinesController as VVSSTTStopsLinesCtrl\">\r\n    <div ng-if=\"pdfError\">\r\n        <vvs-alert text=\"\'Es ist ein Fehler aufgetreten! Die Datei konnte nicht erstellt werden!\'\"></vvs-alert>\r\n    </div>\r\n    <ng-container ng-if=\"VVSSTTStopsLinesCtrl.lineSelections\">\r\n        <div class=\"infoarea clearfix\" style=\"position: relative;\" >\r\n            <div class=\"col-xs-12\">\r\n                <div class=\"pull-left text-left\">\r\n                    <p> {{inputLocations.stt | VVSLocationNameFormatter}}\r\n                     <br> {{currentDate | VVSSummaryDateFormatter}}, <span class=\"time\">{{SEARCH_OPTIONS.dateTime.time|VVSTimeFormatter}} {{\'Uhr\'|translate}}</span\r\n                    </p>\r\n                </div>\r\n                <div class=\"btn-group pull-right\" role=\"group\" style=\"position: absolute; bottom: 0; right: 0;\">\r\n                    <button type=\"button\" class=\"btn btn-link stt-stops-new\" ng-click=\"VVSSTTStopsLinesCtrl.triggerSTTResetClick()\">\r\n                        <vvs-icon name=\"neuefahrt\" style=\"height: 1.4rem; width: 1.4rem; margin-right: 5px;\"></vvs-icon><span class=\"xs-none\">{{\'Neu\'|translate}}</span>\r\n                    </button>\r\n                </div>\r\n            </div>\r\n            <div class=\"col-md-12 flex stt-infoarea\">\r\n                <div class=\"col-md-12 p0 col-xs-12\">\r\n                    <!-- <vvs-vm stt=\"true\" source=\"VVSSTTStopsLinesCtrl.lineSelections\"></vvs-vm> -->\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <div ng-if=\"VVSSTTStopsLinesCtrl.lineSelections.length>0\">\r\n            <h2 class=\"stt-lines-result\">{{\'Linien\'|translate}}</h2>\r\n            <div class=\"ctblock buttonlist col-xs-12 nopadding-xs\" role=\"group\" aria-label=\"Linienauswahl\">\r\n                <button type=\"button\" class=\"btn btn-default btn-block btn-autoheight\" ng-repeat=\"line in VVSSTTStopsLinesCtrl.lineSelections\" ng-model=\"line\" ng-click=\"VVSSTTStopsLinesCtrl.triggerFireSTTDownloadClick(line)\">\r\n                    <div class=\"pdfholder\">\r\n                        <div class=\"pull-left text-left\">\r\n                            <vvs-icon product-icon-id=\"{{line.productIconId()}}\"></vvs-icon> <span ng-bind-html=\"line | VVSLineNameFormatter\"></span>\r\n                        </div>\r\n                    </div>\r\n                </button>\r\n            </div>\r\n        </div>\r\n\r\n    </ng-container>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/stt/stops/lines/pdf.html","<div>\r\n    PDF\r\n</div>");
$templateCache.put("app/vvs.components/trip/options/means-of-transport/main.html","<div class=\"means-of-transport col-xs-12 col-md-6 blocks small-padding-right pl-0\">\r\n    <div class=\"input-group clickthrough\" vvs-modal vvs-modal-template=\"trip/options/means-of-transport/modal.html\" title=\"{{\'Verkehrsmittel auswählen\'|translate}}\">\r\n        <span class=\"input-group-addon\" id=\"verkehrsmittel-addon\">\r\n            <vvs-icon name=\"multimodal\"></vvs-icon>\r\n        </span>\r\n        <vvs-trip-options-means-of-transport-status></vvs-trip-options-means-of-transport-status>\r\n        <span class=\"input-group-btn\">\r\n            <button class=\"btn btn-default\" type=\"button\" vvs-modal vvs-modal-template=\"trip/options/means-of-transport/modal.html\" title=\"{{\'Verkehrsmittel auswählen\'|translate}}\" tabindex=\"-1\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </button>\r\n        </span>\r\n    </div>\r\n    <vvs-trip-options-means-of-transport-description></vvs-trip-options-means-of-transport-description>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/options/means-of-transport/modal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Verkehrsmittel\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\" ng-controller=\"VVSTripOptionsMeansOfTransportModalController as ctrl\">\r\n        <button class=\"btn btn-default spacertop btn-block btn-label\" type=\"button\" id=\"multi-modal-settings-reset\" ng-click=\"ctrl.triggerResetOptionsClick();dismissModal();\">\r\n            <div class=\"pull-left text-left\"> {{\'Einstellungen zurücksetzen\' | translate}} </div>\r\n        </button>\r\n        <!-- <button class=\"btn btn-default spacertop btn-block btn-label\" type=\"button\" id=\"multi-modal-settings-reset\" vvs-modal vvs-modal-template=\"trip/options/settings/modal.html\" title=\"{{\'Fahroptionen\'|translate}}\" tabindex=\"-1\" ng-click=\"dismissModal()\">\r\n            <div class=\"pull-left text-left\"> {{\'1111Fahroptionen\' | translate}} </div>\r\n            <div class=\"pull-right text-right\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button> -->\r\n        <ul class=\"list-group list-toggle\">\r\n            <li class=\"list-group-item list-group-header\">{{\'Alle ÖV\' | translate}}\r\n                <md-switch aria-label=\"Alle ÖV\" ng-model=\"ctrl.enableAllPT\" ng-change=\"ctrl.triggerEnableAllPTChange()\"></md-switch>\r\n            </li>\r\n            <li class=\"list-group-item\">\r\n                <vvs-icon name=\"rbahn\"></vvs-icon> {{\'R-Bahn\' | translate}}\r\n                <md-switch aria-label=\"R-Bahn\" ng-model=\"SEARCH_OPTIONS.productRestrictions.train\" ng-change=\"ctrl.initPtSwitcher()\"></md-switch>\r\n            </li>\r\n            <li class=\"list-group-item\">\r\n                <vvs-icon name=\"sbahn\"></vvs-icon> {{\'S-Bahn\' | translate}}\r\n                <md-switch aria-label=\"S-Bahn\" ng-model=\"SEARCH_OPTIONS.productRestrictions.commuter\" ng-change=\"ctrl.initPtSwitcher()\"></md-switch>\r\n            </li>\r\n            <li class=\"list-group-item\">\r\n                <vvs-icon name=\"ubahn\"></vvs-icon> {{\'Stadt-/Zahnradbahn\' | translate}}\r\n                <md-switch aria-label=\"Stadt-/Zahnradbahn\" ng-model=\"SEARCH_OPTIONS.productRestrictions.lightRail\" ng-change=\"ctrl.initPtSwitcher()\"></md-switch>\r\n            </li>\r\n            <li class=\"list-group-item\">\r\n                <vvs-icon name=\"bus\"></vvs-icon> {{\'Bus\' | translate}}\r\n                <md-switch aria-label=\"Bus\" ng-model=\"SEARCH_OPTIONS.productRestrictions.bus\" ng-change=\"ctrl.initPtSwitcher()\"></md-switch>\r\n            </li>\r\n            <!--\r\n            <li class=\"list-group-item\">\r\n                <vvs-icon name=\"bus\"></vvs-icon> {{\'Nachtbus\' | translate}}\r\n                <md-switch aria-label=\"Nachtbus\" ng-model=\"SEARCH_OPTIONS.productRestrictions.coach\" ng-change=\"ctrl.initPtSwitcher()\"></md-switch>\r\n            </li>\r\n            -->\r\n            <li class=\"list-group-item\">\r\n                <vvs-icon name=\"ruftaxi\"></vvs-icon> {{\'Ruftaxi\' | translate}}\r\n                <md-switch aria-label=\"Ruftaxi\" ng-model=\"SEARCH_OPTIONS.productRestrictions.demandTaxi\" ng-change=\"ctrl.initPtSwitcher()\"></md-switch>\r\n            </li>\r\n        </ul>\r\n        <!--\r\n        <ul class=\"list-group list-toggle nomargin\">\r\n            <li class=\"list-group-item list-group-header header-standalone\">{{\'Ergänzende Verkehrsmittel\' | translate}}\r\n                <md-switch aria-label=\"\"  ng-model=\"SEARCH_OPTIONS.sharing.enabled\" ng-change=\"ctrl.switchMultimodal()\"></md-switch>\r\n            </li>\r\n        </ul>\r\n\r\n        <div class=\"vvs-animated-multimodal-options-container\" ng-if=\"SEARCH_OPTIONS.sharing.enabled\">\r\n            <h2>{{\'Eigene\' | translate}}</h2>\r\n            <ul class=\"list-group list-toggle nomargin\">\r\n                <li class=\"list-group-item\">\r\n                    <vvs-icon name=\"fahrrad\"></vvs-icon> {{\'Rad (inkl. Mitnahme)\' | translate}}\r\n                    <md-switch aria-label=\"\"  ng-model=\"SEARCH_OPTIONS.publicTransport.bikeTakeAlong\" ng-change=\"SEARCH_OPTIONS.individualTransport.type = SEARCH_OPTIONS.publicTransport.bikeTakeAlong ? \'bikeOnTrain\' : \'walk\'\"></md-switch>\r\n                </li>\r\n                <li class=\"list-group-item\">\r\n                    <vvs-icon name=\"auto\"></vvs-icon> {{\'Auto\' | translate}}\r\n                    <md-switch aria-label=\"\"  ng-model=\"SEARCH_OPTIONS.individualTransport.car\"></md-switch>\r\n                </li>\r\n            </ul>\r\n            <ul class=\"list-group list-toggle nomargin\">\r\n                <li class=\"list-group-item list-group-header\">{{\'Park & Ride / Bike & Ride\' | translate}}\r\n                    <md-switch aria-label=\"\"  class=\"vvs-orange\"></md-switch>\r\n                </li>\r\n                <li class=\"list-group-item list-radio\">\r\n                    <div class=\"radio\">\r\n                        <label>\r\n                            <input type=\"radio\" name=\"optionsParkBikeRide\" id=\"pr-stop-start\" value=\"haltestelle-start\" checked>{{\'Haltestelle nahe am\' | translate}} <strong>{{\'Start\' | translate}}</strong></label>\r\n                    </div>\r\n                </li>\r\n                <li class=\"list-group-item list-radio\">\r\n                    <div class=\"radio\">\r\n                        <label>\r\n                            <input type=\"radio\" name=\"optionsParkBikeRide\" id=\"pr-stop-destination\" value=\"haltestelle-ziel\">{{\'Haltestelle nah am\' | translate}} <strong>{{\'Ziel\' | translate}}</strong></label>\r\n                    </div>\r\n                </li>\r\n            </ul>\r\n            <h2>{{\'Sharing\' | translate}}</h2>\r\n            <div class=\"ctblock nopadding-xs\">\r\n                <button type=\"button\" class=\"btn btn-default btn-block\">\r\n                    <div class=\"pull-left text-left\">\r\n                        {{\'Sharing angebote nutzen, wie gehts?\' | translate}}\r\n                    </div>\r\n                    <div class=\"pull-right text-right\">\r\n                        <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                    </div>\r\n                </button>\r\n            </div>\r\n            <h2>{{\'Bike Sharing\' | translate}}</h2>\r\n            <ul class=\"list-group list-toggle nomargin\">\r\n                <li class=\"list-group-item\">\r\n                    <vvs-icon name=\"callabike\"></vvs-icon> {{\'Call A Bike\' | translate}}\r\n                    <md-switch aria-label=\"\"  ng-model=\"SEARCH_OPTIONS.sharing.callabike\"></md-switch>\r\n                </li>\r\n                <li class=\"list-group-item\">\r\n                    <vvs-icon name=\"nextbike\"></vvs-icon> {{\'Nextbike\' | translate}}\r\n                    <md-switch aria-label=\"\"  ng-model=\"SEARCH_OPTIONS.sharing.nextbike\"></md-switch>\r\n                </li>\r\n            </ul>\r\n            <h2>{{\'Car Sharing\' | translate}}</h2>\r\n            <ul class=\"list-group list-toggle\">\r\n                <li class=\"list-group-item\">\r\n                    <vvs-icon name=\"car2go\"></vvs-icon> {{\'Car 2 Go\' | translate}}\r\n                    <md-switch aria-label=\"\"  ng-model=\"SEARCH_OPTIONS.sharing.car2go\"></md-switch>\r\n                </li>\r\n                <li class=\"list-group-item\">\r\n                    <vvs-icon name=\"flinkster\"></vvs-icon> {{\'Flinkster\' | translate}}\r\n                    <md-switch aria-label=\"\"  ng-model=\"SEARCH_OPTIONS.sharing.flinkster\"></md-switch>\r\n                </li>\r\n                <li class=\"list-group-item\">\r\n                    <vvs-icon name=\"stadtmobil\"></vvs-icon> {{\'Stadtmobil\' | translate}}\r\n                    <md-switch aria-label=\"\"  ng-model=\"SEARCH_OPTIONS.sharing.stadtmobil\"></md-switch>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        -->\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/options/settings/main.html","<div class=\"trip-options-settings col-xs-12 col-md-6 small-padding-left pr-0\">\r\n    <div class=\"input-group clickthrough attached notattached-md\" vvs-modal vvs-modal-template=\"trip/options/settings/modal.html\" title=\"{{\'Fahroptionen\'|translate}}\">\r\n        <span class=\"input-group-addon\" id=\"einstellungen-addon\">\r\n            <vvs-icon name=\"karte-einstellungen\"></vvs-icon>\r\n        </span>\r\n        <vvs-trip-options-settings-status></vvs-trip-options-settings-status>\r\n        <span class=\"input-group-btn\">\r\n            <button class=\"btn btn-default\" type=\"button\" vvs-modal vvs-modal-template=\"trip/options/settings/modal.html\" title=\"{{\'Fahroptionen\'|translate}}\" tabindex=\"-1\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </button>\r\n        </span>\r\n    </div>\r\n    <vvs-trip-options-settings-description></vvs-trip-options-settings-description>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/options/settings/modal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Einstellungen\' | translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock trip-options-wrap\" ng-controller=\"VVSTripOptionsSettingsModalController as ctrl\">\r\n        <button class=\"btn btn-default spacertop btn-block btn-label\" type=\"button\" id=\"multi-modal-settings-reset\" ng-click=\"ctrl.triggerResetOptionsClick();dismissModal();\">\r\n            <div class=\"pull-left text-left\"> {{\'Einstellungen zurücksetzen\' | translate}} </div>\r\n        </button>\r\n\r\n        <!-- <button class=\"btn btn-default spacertop btn-block btn-label\" type=\"button\" id=\"multi-modal-settings-reset\" vvs-modal vvs-modal-template=\"trip/options/means-of-transport/modal.html\" title=\"{{\'Verkehrsmittel auswählen\'|translate}}\" tabindex=\"-1\" ng-click=\"dismissModal()\">\r\n            <div class=\"pull-left text-left\"> {{\'Verkehrsmittel auswählen\' | translate}} </div>\r\n            <div class=\"pull-right text-right\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </div>\r\n        </button> -->\r\n\r\n        <div class=\"drilldown\">\r\n            <!-- required -->\r\n            <div class=\"drilldown-container\">\r\n                <!-- required -->\r\n                <ul class=\"drilldown-root\" ng-hide=\"animate\" ng-class=\"{\'vvs-animated-slide vvs-animated-back\': (animate===false), \'vvs-animated-slide\': animate}\">\r\n                    <!-- required, but not necessarily UL -->\r\n                    <li>\r\n                        <h2>{{\'Verbindungsoptionen\' | translate}}</h2>\r\n                    </li>\r\n                    <li>\r\n                        <a href=\"javascript:void(0)\" ng-click=\"animate=true; animateSearchSettings=true;\">\r\n                            <div class=\"input-group clickthrough\" ng-switch=\"SEARCH_OPTIONS.publicTransport.routingOptimization\">\r\n                                <span class=\"input-group-addon\" id=\"verbindungsoptionen-addon\">\r\n                                    {{\'Verbindungsoptionen\' | translate}}\r\n                                </span>\r\n                                <input type=\"text\" class=\"form-control text-right\" ng-switch-when=\"time\" value=\"{{\'zeitkuerzeste\'|translate}}\" aria-describedby=\"verbindungsoptionen-addon\">\r\n                                <input type=\"text\" class=\"form-control text-right\" ng-switch-when=\"interchange\" value=\"{{\'mit wenig Umstiegen\'|translate}}\" aria-describedby=\"verbindungsoptionen-addon\">\r\n                                <input type=\"text\" class=\"form-control text-right\" ng-switch-when=\"walking\" value=\"{{\'mit kurzem Fußweg\'|translate}}\" aria-describedby=\"verbindungsoptionen-addon\">\r\n                                <input type=\"text\" class=\"form-control text-right\" ng-switch-when=\"costex\" value=\"{{\'preisguenstigste\'|translate}}\" aria-describedby=\"verbindungsoptionen-addon\">\r\n                                <span class=\"input-group-btn\">\r\n                                    <button class=\"btn btn-default\" type=\"button\">\r\n                                    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                    </button>\r\n                                </span>\r\n                            </div>\r\n                        </a>\r\n                    </li>\r\n                    <li class=\"attached\">\r\n                        <a href=\"javascript:void(0)\" ng-click=\"animate=true; animateTariffSettings=true\">\r\n                            <div class=\"input-group clickthrough attached\">\r\n                                <span class=\"input-group-addon\" id=\"tarifzonen-addon\">\r\n                            {{\'Tarifzonen\' | translate}}\r\n                        </span>\r\n                                <input type=\"text\" class=\"form-control text-right\" ng-if=\"SEARCH_OPTIONS.fare.avoidZones.length==0\" value=\"{{\'alle\'|translate}}\" aria-describedby=\"tarifzonen-addon\">\r\n                                <input type=\"text\" class=\"form-control text-right\" ng-if=\"SEARCH_OPTIONS.fare.avoidZones.length==ctrl.tariffZones.length\" value=\"{{\'keine\'|translate}}\" aria-describedby=\"tarifzonen-addon\">\r\n                                <input type=\"text\" class=\"form-control text-right\" ng-if=\"(SEARCH_OPTIONS.fare.avoidZones.length>0)&&(SEARCH_OPTIONS.fare.avoidZones.length<ctrl.tariffZones.length)\" value=\"ohne {{SEARCH_OPTIONS.fare.avoidZones}}\" aria-describedby=\"tarifzonen-addon\">\r\n                                <span class=\"input-group-btn\">\r\n                            <button class=\"btn btn-default\" type=\"button\" >\r\n                            <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                            </button>\r\n                        </span>\r\n                            </div>\r\n                        </a>\r\n                    </li>\r\n                    <li>\r\n                        <ul class=\"list-group list-toggle attached nomargin\">\r\n                            <li class=\"list-group-item no-icon\">{{\'Fahrradmitnahme\' | translate}}\r\n                                <md-switch aria-label=\"Fahrradmitnahme\" ng-model=\"SEARCH_OPTIONS.publicTransport.bikeTakeAlong\"></md-switch>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n\r\n\r\n                    <li>\r\n                        <h2>{{\'Fußwege\' | translate}}</h2>\r\n                    </li>\r\n                    <li>\r\n                        <a href=\"javascript:void(0)\" ng-click=\"animate=true; animateWalkingSettings=true\">\r\n                            <div class=\"input-group clickthrough\" ng-switch=\"SEARCH_OPTIONS.individualTransport.to.walkSpeed\">\r\n                                <span class=\"input-group-addon\" id=\"verbindungsoptionen-addon\">\r\n                                    {{\'Gehgeschwindigkeit\' | translate}}\r\n                                </span>\r\n                                <input type=\"text\" class=\"form-control text-right\" ng-switch-when=\"normal\" value=\"{{\'normal (5 km/h)\'|translate}}\" aria-describedby=\"gehgeschwindigkeit-addon\">\r\n                                <input type=\"text\" class=\"form-control text-right\" ng-switch-when=\"fast\" value=\"{{\'schnell (8 km/h)\'|translate}}\" aria-describedby=\"gehgeschwindigkeit-addon\">\r\n                                <input type=\"text\" class=\"form-control text-right\" ng-switch-when=\"slow\" value=\"{{\'langsam / mit schwerem Gepaeck (2 km/h)\'|translate}}\" aria-describedby=\"gehgeschwindigkeit-addon\">\r\n                                <span class=\"input-group-btn\">\r\n                                <button class=\"btn btn-default\" type=\"button\">\r\n                                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                                </button>\r\n                            </span>\r\n                            </div>\r\n                        </a>\r\n                    </li>\r\n                    <li class=\"attached\">\r\n                        <a href=\"javascript:void(0)\" ng-click=\"animate=true; animateWalkingTimeSettings=true\">\r\n                            <div class=\"input-group clickthrough attached\">\r\n                                <span class=\"input-group-addon\" id=\"tarifzonen-addon\">\r\n                            {{\'Fußwegzeit\' | translate}}\r\n                        </span>\r\n                                <input type=\"text\" class=\"form-control text-right\" value=\"{{SEARCH_OPTIONS.individualTransport.from.minutes}}/{{SEARCH_OPTIONS.individualTransport.to.minutes}}\" aria-describedby=\"fußwegzeit-addon\">\r\n                                <span class=\"input-group-btn\">\r\n                            <button class=\"btn btn-default\" type=\"button\" >\r\n                            <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                            </button>\r\n                        </span>\r\n                            </div>\r\n                        </a>\r\n                    </li>\r\n                    <li>\r\n                        <ul class=\"list-group list-toggle attached nomargin\">\r\n                            <li class=\"list-group-item no-icon\">{{\'Steigungen vermeiden\' | translate}}\r\n                                <md-switch aria-label=\"Steigungen vermeiden\" ng-model=\"SEARCH_OPTIONS.individualTransport.to.avoidElevation\" ng-change=\"ctrl.triggerAvoidElevationChange()\"></md-switch>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n                    <li>\r\n                        <ul class=\"list-group list-toggle attached nomargin\">\r\n                            <li class=\"list-group-item no-icon\">{{\'Höhenprofil für Fußwege im Ausdruck anzeigen\' | translate}}\r\n                                <md-switch aria-label=\"Höhenprofil für Fußwege im Ausdruck anzeigen\" ng-model=\"SEARCH_OPTIONS.pdfOutput.elevationProfile\"></md-switch>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n\r\n\r\n\r\n                    <li>\r\n                        <h2 class=\"modal-accessibility_header\">{{\'Barrierefrei\' | translate}}\r\n                            <a href=\"javascript:void(0)\" ng-click=\"onAccessClick()\">\r\n                            <!-- <a href=\"javascript:void(0)\" ng-click=\"window.open(\'https://www.vvs.de/barrierefrei\',\'_blank\');\"> -->\r\n                                <vvs-icon ng-click=\"\" class=\"modal-header_icon\" name=\"fragezeichen\"></vvs-icon>\r\n                            </a>\r\n                            <!-- <span>\r\n                            </span> -->\r\n                        </h2>\r\n                    </li>\r\n\r\n                    <!-- STUFENLOS UNTERWEGS -visuallyImpaired -->\r\n                    <li>\r\n                        <ul class=\"list-group list-toggle attached nomargin\">\r\n                            <li class=\"list-group-item no-icon\">{{\'Stufenlos unterwegs\' | translate}}\r\n                                <md-switch ng-change=\"ctrl.triggerStepFree()\" aria-label=\"Stufenlos unterwegs\" ng-model=\"SEARCH_OPTIONS.accessibility.stepFree\"></md-switch>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n                    <!-- Seheingeschränkt unterwegs ->  visuallyImpaired -->\r\n                    <li>\r\n                        <ul class=\"list-group list-toggle attached nomargin\">\r\n                            <li class=\"list-group-item no-icon\">{{\'Seheingeschränkt unterwegs\' | translate}}\r\n                                <md-switch ng-change=\"ctrl.triggerVisuallyImpaired()\" aria-label=\"Seheingeschränkt unterwegs\" ng-model=\"SEARCH_OPTIONS.accessibility.visuallyImpaired\"></md-switch>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n                    <br>\r\n                    <li>\r\n                        <ul class=\"list-group list-toggle attached nomargin\">\r\n                            <li class=\"list-group-item no-icon\">{{\'Zugangsinformationen anzeigen\' | translate}}\r\n                            <!-- <li class=\"list-group-item no-icon\">{{\'Hinweise zur barrierefreien Zugänglichkeit anzeigen\' | translate}} -->\r\n                                <md-switch ng-model=\"SEARCH_OPTIONS.accessibility.showAccessibility\"></md-switch>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n                    <!-- Testphase zu entfernen-->\r\n                    <!-- <li>\r\n                        <h2>{{\'Testphase\' | translate}}</h2>\r\n                    </li> -->\r\n                    <!-- <li>\r\n                        <ul class=\"list-group list-toggle attached nomargin\">\r\n                            <li class=\"list-group-item no-icon\">{{\'Stufe von der Straße zur Einstiegsposition\' | translate}}\r\n                                <md-switch aria-label=\"Stufe von der Straße zur Einstiegsposition\" ng-model=\"SEARCH_OPTIONS.accessibility.testStepFromStreet.on\"></md-switch>\r\n                                <ng-content ng-if=\"SEARCH_OPTIONS.accessibility.testStepFromStreet.on\">\r\n                                    <br>\r\n                                    <input type=\"text\" placeholder=\"add stepMaxHeight\" ng-model=\"SEARCH_OPTIONS.accessibility.testStepFromStreet.value\" maxlength=\"3\" ng-keypress=\"ctrl.validateFieldMaxHeight($event)\">\r\n                                    <p ng-if=\"ctrl.errorMaxHeight\" style=\"color: red;\">only numbers accepted</p>\r\n                                </ng-content>\r\n                            </li>\r\n                        </ul>\r\n                    </li> -->\r\n                    <!-- <li>\r\n                        kann man eingeben\r\n                        <ul class=\"list-group list-toggle attached nomargin\" ng-init=\"accessProfileWarning = false;\">\r\n                            <li class=\"list-group-item no-icon\">{{\'Höhe über Straße/Schienenoberkante\' | translate}}\r\n                                <md-switch aria-label=\"Höhe über Straße/Schienenoberkante\" ng-model=\"SEARCH_OPTIONS.accessibility.testStepVehicleMaxHeight.on\"></md-switch>\r\n                                <ng-content ng-if=\"SEARCH_OPTIONS.accessibility.testStepVehicleMaxHeight.on\">\r\n                                    <br>\r\n                                    <input type=\"text\" placeholder=\"add stepVehicleMaxHeight\" ng-model=\"SEARCH_OPTIONS.accessibility.testStepVehicleMaxHeight.value\" maxlength=\"3\" ng-keypress=\"ctrl.validateFieldMaxHeight($event)\">\r\n                                    <p ng-if=\"ctrl.errorMaxHeight\" style=\"color: red;\">only numbers accepted</p>\r\n                                </ng-content>\r\n                            </li>\r\n                        </ul>\r\n                    </li> -->\r\n                    <!-- <li>\r\n                        <ul class=\"list-group list-toggle attached nomargin\">\r\n                            <li class=\"list-group-item no-icon\">{{\'Ausreichende Breite des Bahn-/Bussteigs\' | translate}}\r\n                                <md-switch aria-label=\"ausreichende Breite des Bahn-/Bussteigs\" ng-model=\"SEARCH_OPTIONS.accessibility.testSufficientPlatformWidth\"></md-switch>\r\n                            </li>\r\n                        </ul>\r\n                    </li> -->\r\n                    <!-- <li>\r\n                        <ul class=\"list-group list-toggle attached nomargin\">\r\n                            <li class=\"list-group-item no-icon\">{{\'Bodenindikatoren beim Einstieg \' | translate}}\r\n                                <md-switch aria-label=\"Bodenindikatoren beim Einstieg \" ng-model=\"SEARCH_OPTIONS.accessibility.testTactileGuidance\"></md-switch>\r\n                            </li>\r\n                        </ul>\r\n                    </li> -->\r\n                    <!-- <li>\r\n                        <ul class=\"list-group list-toggle attached nomargin\">\r\n                            <li class=\"list-group-item no-icon\">{{\'Strikter Modus \' | translate}}\r\n                                <md-switch aria-label=\"Strikter Modus\" ng-model=\"SEARCH_OPTIONS.accessibility.testStrictMode\"></md-switch>\r\n                            </li>\r\n                        </ul>\r\n                    </li> -->\r\n                    <!-- END Testphase-->\r\n                    <li>\r\n                        <h2>{{\'Weitere\' | translate}}</h2></li>\r\n                    <li>\r\n                        <button type=\"button\" class=\"btn btn-default btn-block spacerbottomlarge\" ui-sref=\"vvs.personalization.login\" ui-sref-opts=\"{reload: true, notify: true}\">\r\n                            <div class=\"pull-left text-left left-text-color\">\r\n                                {{\'Benachrichtigungsservice\' | translate}}\r\n                                <!-- {{\'Mein VVS-Konto\' | translate}} -->\r\n                            </div>\r\n                            <div class=\"pull-right text-right\">\r\n                                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n                            </div>\r\n                        </button>\r\n                    </li>\r\n                </ul>\r\n                <ul class=\"drilldown-root\" ng-show=\"animate\" ng-class=\"{\'vvs-animated-slide vvs-animated-back\': (animate===false), \'vvs-animated-slide\': animate}\">\r\n                    <li ng-show=\"animateSearchSettings\">\r\n                        <ul class=\"drilldown-sub noicon vvs-animated-slide\">\r\n                            <!-- required for deeper (non-root) levels -->\r\n                            <h2>{{\'Verbindungsoptionen\' | translate}}</h2>\r\n                            <li class=\"drilldown-back\">\r\n                                <a href=\"javascript:void(0)\">\r\n                                    <button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"animate=false; animateSearchSettings=false\">\r\n                                        <div class=\"pull-left text-left send\">\r\n                                            <vvs-icon name=\"zurueck\"></vvs-icon>\r\n                                        </div>\r\n                                        <div class=\"pull-left text-left\">\r\n                                            <div class=\"maintext\">{{\'Zurück\' | translate}}</div>\r\n                                        </div>\r\n                                    </button>\r\n                                </a>\r\n                            </li>\r\n                            <!-- required to be able to go back -->\r\n                            <li>\r\n                                <md-radio-group ng-model=\"SEARCH_OPTIONS.publicTransport.routingOptimization\">\r\n                                    <ul class=\"list-group nomargin\">\r\n                                        <li class=\"list-group-item list-radio\">\r\n                                            <div class=\"radio\">\r\n                                                <md-radio-button value=\"time\">{{\'zeitkürzeste\' | translate}}</md-radio-button>\r\n                                            </div>\r\n                                        </li>\r\n                                        <li class=\"list-group-item list-radio\">\r\n                                            <div class=\"radio\">\r\n                                                <md-radio-button value=\"interchange\">{{\'mit wenig Umstiegen\' | translate}}</md-radio-button>\r\n                                            </div>\r\n                                        </li>\r\n                                        <li class=\"list-group-item list-radio\">\r\n                                            <div class=\"radio\">\r\n                                                <md-radio-button value=\"walking\">{{\'mit kurzem Fußweg\' | translate}}</md-radio-button>\r\n                                            </div>\r\n                                        </li>\r\n                                        <li class=\"list-group-item list-radio\">\r\n                                            <div class=\"radio\">\r\n                                                <md-radio-button value=\"costex\">{{\'preisgünstigste\' | translate}}</md-radio-button>\r\n                                            </div>\r\n                                        </li>\r\n                                    </ul>\r\n                                </md-radio-group>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n                    <li ng-show=\"animateTariffSettings\">\r\n                        <ul class=\"drilldown-sub noicon vvs-animated-slide\" ng-class=\"{\'vvs-animated-back\':!animate}\">\r\n                            <!-- required for deeper (non-root) levels -->\r\n                            <h2>{{\'Tarifzonen berücksichtigen\' | translate}}</h2>\r\n                            <li class=\"drilldown-back\">\r\n                                <a href=\"javascript:void(0)\">\r\n                                    <button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"animate=false; animateTariffSettings=false\">\r\n                                        <div class=\"pull-left text-left send\">\r\n                                            <vvs-icon name=\"zurueck\"></vvs-icon>\r\n                                        </div>\r\n                                        <div class=\"pull-left text-left\">\r\n                                            <div class=\"maintext\">{{\'Zurück\' | translate}}</div>\r\n                                        </div>\r\n                                    </button>\r\n                                </a>\r\n                            </li>\r\n                            <!-- required to be able to go back -->\r\n                            <div class=\"zonesHolder\">\r\n                                <li>\r\n                                    <md-radio-group ng-model=\"ctrl.tariffZoneRadio\" ng-change=\"ctrl.triggerTariffZoneChange()\">\r\n                                        <ul class=\"list-group nomargin\">\r\n                                            <li class=\"list-group-item list-radio\">\r\n                                                <div class=\"radio\">\r\n                                                    <md-radio-button value=\"t_alle\">{{\'alle\' | translate}}</md-radio-button>\r\n                                                </div>\r\n                                            </li>\r\n                                            <li class=\"list-group-item list-radio\">\r\n                                                <div class=\"radio\">\r\n                                                    <md-radio-button value=\"t_keine\">{{\'keine\' | translate}}</md-radio-button>\r\n                                                </div>\r\n                                            </li>\r\n                                            <li>\r\n                                                <div class=\"zones\">\r\n                                                    <div class=\"zone\" ng-repeat=\"tariffZone in ctrl.tariffZones\" ng-class=\"{\'active\': SEARCH_OPTIONS.fare.avoidZones.indexOf(tariffZone)===-1}\" ng-click=\"ctrl.triggerTariffzoneClick(tariffZone)\">\r\n                                                        {{tariffZone}}\r\n                                                    </div>\r\n                                                </div>\r\n                                            </li>\r\n                                        </ul>\r\n                                    </md-radio-group>\r\n                                </li>\r\n                            </div>\r\n                            <!-- end zonesHolder-->\r\n                        </ul>\r\n                    </li>\r\n                    <li ng-show=\"animateWalkingSettings\">\r\n                        <ul class=\"drilldown-sub noicon vvs-animated-slide\" ng-class=\"{\'vvs-animated-back\':!animate}\">\r\n                            <!-- required for deeper (non-root) levels -->\r\n                            <h2>{{\'Gehgeschwindigkeit\' | translate}}*</h2>\r\n                            <li class=\"drilldown-back\">\r\n                                <a href=\"javascript:void(0)\">\r\n                                    <button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"animate=false; animateWalkingSettings=false\">\r\n                                        <div class=\"pull-left text-left send\">\r\n                                            <vvs-icon name=\"zurueck\"></vvs-icon>\r\n                                        </div>\r\n                                        <div class=\"pull-left text-left\">\r\n                                            <div class=\"maintext\">{{\'Zurück\' | translate}}</div>\r\n                                        </div>\r\n                                    </button>\r\n                                </a>\r\n                            </li>\r\n                            <!-- required to be able to go back -->\r\n                            <li>\r\n                                <md-radio-group ng-model=\"SEARCH_OPTIONS.individualTransport.to.walkSpeed\" ng-change=\"ctrl.triggerIndividualTransportChange()\">\r\n                                    <ul class=\"list-group nomargin\">\r\n                                        <li class=\"list-group-item list-radio\">\r\n                                            <div class=\"radio\">\r\n                                                <md-radio-button value=\"normal\">{{\'normal (5 km/h)\' | translate}}</md-radio-button>\r\n                                            </div>\r\n                                        </li>\r\n                                        <li class=\"list-group-item list-radio\">\r\n                                            <div class=\"radio\">\r\n                                                <md-radio-button value=\"fast\">{{\'schnell (8 km/h)\' | translate}}</md-radio-button>\r\n                                            </div>\r\n                                        </li>\r\n                                        <li class=\"list-group-item list-radio\">\r\n                                            <div class=\"radio\">\r\n                                                <md-radio-button value=\"slow\">{{\'langsam / mit schwerem Gepaeck (2 km/h)\' | translate}}</md-radio-button>\r\n                                            </div>\r\n                                        </li>\r\n                                    </ul>\r\n                                </md-radio-group>\r\n                                <p><strong>*{{\'Wichtiger Hinweis\' | translate}}</strong>\r\n                                    <br> {{\'Diese Einstellung beeinflusst sowohl die Fußwegzeit beim Umsteigen als auch beim Weg vom Start zur Haltestelle bzw. von der Haltestelle zum Ziel.\' | translate}}\r\n                                </p>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n\r\n                    <!-- content block -->\r\n                    <li ng-show=\"animateAccessabilityProfileSettings\">\r\n                        <ul class=\"drilldown-sub noicon vvs-animated-slide\" ng-class=\"{\'vvs-animated-back\':!animate}\">\r\n                            <!-- required for deeper (non-root) levels -->\r\n                            <h2>{{\'Profile\' | translate}}*</h2>\r\n                            <li class=\"drilldown-back\">\r\n                                <a href=\"javascript:void(0)\">\r\n                                    <button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"animate=false; animateAccessabilityProfileSettings=false\">\r\n                                        <div class=\"pull-left text-left send\">\r\n                                            <vvs-icon name=\"zurueck\"></vvs-icon>\r\n                                        </div>\r\n                                        <div class=\"pull-left text-left\">\r\n                                            <div class=\"maintext\">{{\'Zurück\' | translate}}</div>\r\n                                        </div>\r\n                                    </button>\r\n                                </a>\r\n                            </li>\r\n                            <!-- required to be able to go back -->\r\n\r\n                        </ul>\r\n                    </li>\r\n\r\n                    <!-- content block -->\r\n                    <li ng-show=\"animateWalkingTimeSettings\">\r\n                        <ul class=\"drilldown-sub noicon vvs-animated-slide\" ng-class=\"{\'vvs-animated-back\':!animate}\">\r\n                            <!-- required for deeper (non-root) levels -->\r\n                            <h2>{{\'Maximal gewünschte Fußwegzeit\' | translate}}*</h2>\r\n                            <li class=\"drilldown-back\">\r\n                                <a href=\"javascript:void(0)\">\r\n                                    <button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"animate=false; animateWalkingTimeSettings=false\">\r\n                                        <div class=\"pull-left text-left send\">\r\n                                            <vvs-icon name=\"zurueck\"></vvs-icon>\r\n                                        </div>\r\n                                        <div class=\"pull-left text-left\">\r\n                                            <div class=\"maintext\">{{\'Zurück\' | translate}}</div>\r\n                                        </div>\r\n                                    </button>\r\n                                </a>\r\n                            </li>\r\n                            <!-- required to be able to go back -->\r\n                            <li>\r\n                                <div class=\"visible-xs\">\r\n                                    <div class=\"holder infocus spacerbottommedium spacertop\">\r\n                                        <label class=\"nopadding-xs\">{{SEARCH_OPTIONS.individualTransport.to.minutes}} {{\'Minuten zur Start-Haltestelle\'| translate}}</label>\r\n                                        <md-slider flex min=\"0\" max=\"60\" ng-model=\"SEARCH_OPTIONS.individualTransport.to.minutes\" convert-to-number></md-slider>\r\n                                    </div>\r\n                                    <div class=\"holder infocus\">\r\n                                        <label class=\"nopadding-xs\">{{SEARCH_OPTIONS.individualTransport.from.minutes}} {{\'Minuten von der Ziel-Haltestelle\'| translate}}</label>\r\n                                        <md-slider flex min=\"0\" max=\"60\" ng-model=\"SEARCH_OPTIONS.individualTransport.from.minutes\" convert-to-number></md-slider>\r\n                                    </div>\r\n                                </div>\r\n                                <div class=\"hidden-xs\">\r\n                                    <div class=\"holder infocus spacerbottommedium spacertop\">\r\n                                        <label class=\"nopadding-xs\">{{SEARCH_OPTIONS.individualTransport.to.minutes}} {{\'Minuten zur Start-Haltestelle\' | translate}}</label>\r\n                                        <md-slider flex min=\"0\" max=\"60\" ng-model=\"SEARCH_OPTIONS.individualTransport.to.minutes\" convert-to-number></md-slider>\r\n\r\n                                    </div>\r\n                                    <div class=\"holder infocus spacerbottommedium\">\r\n                                        <label class=\"nopadding-xs\" for=\"ziel-haltestelle\">{{SEARCH_OPTIONS.individualTransport.from.minutes}} {{\'Minuten von der Ziel-Haltestelle\' | translate}}</label>\r\n                                        <md-slider flex min=\"0\" max=\"60\" ng-model=\"SEARCH_OPTIONS.individualTransport.from.minutes\" convert-to-number></md-slider>\r\n                                    </div>\r\n                                </div>\r\n                                <p>*<strong>{{\'Wichtiger Hinweis\' | translate}}</strong>\r\n                                    <br> {{\'Diese Zeit bezieht sich nicht auf die Fußwege bei Umstiegen! Diese können Sie mit dem Punkt \"Gehgeschwindigkeit\" beeinflussen.\' | translate}}\r\n                                </p>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/details/main.html","<div class=\"col-xs-12 col-sm-12 col-md-12 content\">\r\n    <h2 class=\"function-header back hidden-xs hidden-sm\">{{\'Fahrtdetails\' | translate}}\r\n        <span>\r\n            <a href=\"javascript:void(0)\" ui-sref=\"vvs.trip.result\" title=\"{{\'Verbindungen Übersicht\'|translate}}\">{{\'zurück zur Übersicht\'|translate}}</a>\r\n        </span>\r\n    </h2>\r\n    <!-- trip results summary -->\r\n    <vvs-include vvs-src=\"trip/result/summary/main.html\"></vvs-include>\r\n\r\n\r\n    <vvs-include vvs-src=\"trip/result/details/pagination/main.html\"></vvs-include>\r\n\r\n\r\n    <vvs-include vvs-src=\"trip/result/details/buttons/main.html\"></vvs-include>\r\n\r\n\r\n    <div class=\"col-xs-12 trip-container trip-single padding-md\">\r\n        <div class=\"trip-wrap-graphic\">\r\n            <div class=\"trip-graphic\">\r\n                <strong ng-if=\"showNewDateInfo()\">{{\'Abfahrt am\'|translate}} {{trip.departureTime()|VVSDateFormatter}}</strong>\r\n                <vvs-trip-details-leg ng-repeat=\"leg in trip.legs() track by $index\" leg-index=\"$index\" is-first-leg=\"$first\" is-last-leg=\"$last\"></vvs-trip-details-leg>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-xs-12 trip-container trip-single padding-md\" ng-if=\"debugObj.isDebugModeActive\">\r\n        <pre>{{trip.raw()|json:4}}</pre>\r\n    </div>\r\n\r\n    <div class=\"col-xs-12 legende\">\r\n        <vvs-recommended-stop mode=\"\'footer\'\" trip=\"trip\" origin=\"inputLocations[\'orig\']\" destination=\"inputLocations[\'dest\']\"></vvs-recommended-stop>\r\n    </div>\r\n\r\n    <!-- include settings summary -->\r\n    <vvs-include vvs-src=\"trip/result/settings/main.html\"></vvs-include>\r\n</div>\r\n<!--/.col-xs-12.col-sm-9-->\r\n\r\n<style>\r\n    .moveLeg-wrap {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: flex-end;\r\n    }\r\n\r\n</style>\r\n");
$templateCache.put("app/vvs.components/trip/result/graph/it-leg.html","<div class=\"trippart\">\r\n    <div class=\"duration {{getDurationClass(leg, trip)}} fuss\">\r\n        <vvs-icon name=\"fussweg\"></vvs-icon>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/graph/item.html","<div ng-controller=\"VVSTripResultGraphItemController\" class=\"trip-graphic\" style=\"margin-top: {{getGraphicTripMargin($index, journeyObj.service.getResults())}}\">\r\n    <div class=\"etd\" ng-class=\"{\'late\': trip.departureDelay()>0}\">{{trip.origin().departureTime() | VVSTimeFormatter}}</div>\r\n    <div class=\"date\" ng-if=\"showNewDateInfo()\">{{\'Abfahrt am\'|translate}} {{trip.departureTime()|VVSDateFormatter}}</div>\r\n    <div class=\"travelled\">{{trip.duration() | VVSTravelledDurationFormatter}}</div>\r\n    <a href=\"javascript:void(0)\" ui-sref=\"vvs.trip.details({index: $index, isFirst: isFirst, isLast: isLast})\" title=\"{{\'Fahrtdetails anzeigen\'|translate}}\">\r\n        <div ng-repeat=\"leg in trip.legs() track by $index\" ng-if=\"leg.transportation().productClass()!=99\">\r\n            <vvs-graphic-leg mot-key=\"{{leg.transportation().productClass()}}\"></vvs-graphic-leg>\r\n        </div>\r\n    </a>\r\n    <div class=\"eta\" ng-class=\"{\'late\': trip.arrivalDelay()>0}\">{{trip.destination().arrivalTime() | VVSTimeFormatter}}</div>\r\n\r\n    <vvs-infos mode=\"summary\" trip=\"trip\"></vvs-infos>\r\n\r\n    <div class=\"map nopadding-xs hidden-xs\">\r\n        <button type=\"button\" class=\"btn btn-link\" vvs-modal vvs-modal-template=\"trip/result/list/map.html\" title=\"{{\'Fahrt auf der Karte anzeigen\'|translate}}\">\r\n            <vvs-icon name=\"karte\"></vvs-icon>\r\n        </button>\r\n    </div>\r\n\r\n    <vvs-trip-tickets trip=\"trip\"></vvs-trip-tickets>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/graph/main.html","<div class=\"tab-pane active\" id=\"grafik\" ng-Controller=\"VVSTripGraphicController\">\r\n    <div class=\"trip-wrap-graphic\">\r\n        <vvs-include vvs-src=\"trip/result/graph/item.html\" ng-repeat=\"trip in journeyObj.service.getResults() track by $index\"></vvs-include>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/graph/pt-leg.html","<div>\r\n    <div class=\"tripstop top {{iconName}}\">\r\n        <vvs-icon name=\"umstiegspunkt\"></vvs-icon>\r\n    </div>\r\n    <div class=\"trippart\">\r\n        <div class=\"duration {{getDurationClass(leg, trip)}} {{iconName}}\"></div>\r\n        <div class=\"vehicle clearfix\">\r\n            <span class=\"number\">{{leg.transportation().number()}}</span>\r\n            <vvs-icon product-icon-id=\"{{leg.transportation().productIconId()}}\"></vvs-icon>\r\n            <vvs-real-time-icon mode=\"\'leg\'\" leg=\"leg\"></vvs-real-time-icon>\r\n        </div>\r\n        <div class=\"duration {{getDurationClass(leg, trip)}} {{iconName}}\"></div>\r\n    </div>\r\n    <div class=\"tripstop bottom {{iconName}}\" ng-show=\"showBottomTripStop($index)\">\r\n        <vvs-icon name=\"umstiegspunkt\"></vvs-icon>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/list/formations.html","<div ng-show=\"vhIndex\" class=\"formations\">\r\n    <ul style=\"list-style-type: none; margin-bottom: 0;\">\r\n        <li ng-if=\"vhIndex === 1\">\r\n          <!-- kurzzug -->\r\n          <img src=\"app/vvs.components/assets/images/icons/trip-composition/kurzzug.svg\" alt=\"kurzzug\">\r\n        </li>\r\n        <li ng-if=\"vhIndex === 2\">\r\n          <!-- vollzug -->\r\n          <img src=\"app/vvs.components/assets/images/icons/trip-composition/vollzug.svg\" alt=\"vollzug\">\r\n        </li>\r\n        <li ng-if=\"vhIndex === 3\">\r\n          <!-- langzug -->\r\n          <img src=\"app/vvs.components/assets/images/icons/trip-composition/langzug.svg\" alt=\"langzug\">\r\n        </li>\r\n        <li ng-if=\"vhIndex === 4\">\r\n          <!-- 4x -->\r\n          <img src=\"app/vvs.components/assets/images/icons/trip-composition/DS-4X.svg\" alt=\"4x\">\r\n        </li>\r\n        <li ng-if=\"vhIndex === 5\">\r\n          <!-- 5x -->\r\n          <img src=\"app/vvs.components/assets/images/icons/trip-composition/DS-5X.svg\" alt=\"5x\">\r\n        </li>\r\n      </ul>\r\n</div>");
$templateCache.put("app/vvs.components/trip/result/list/item.html","<div ng-controller=\"VVSTripResultListItemController\" ng-class=\"{\'alert alert-danger\': (debugObj.isDebugModeActive && trip.properties().realtimeExplanationIdx && !trip.properties().explainedByIdx)}\">\r\n    <div class=\"trip clearfix padding-xs\" ng-if=\"showNewDateInfo()\">\r\n        <div class=\"tripinfos col-xs-12 nopadding-xs text-center\">\r\n            {{\'Abfahrt am\'|translate}} {{trip.departureTime()|VVSSummaryDateFormatter}}\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"trip clearfix padding-xs\">\r\n        <div class=\"tripinfos col-xs-8 col-sm-8 nopadding-xs\">\r\n            <button type=\"button\" class=\"btn btn-link nopadding-xs clearfix\" ui-sref=\"vvs.trip.details({index: $index, isFirst: isFirst, isLast: isLast})\" title=\"{{\'Fahrtdetails anzeigen\'|translate}}\">\r\n                <div class=\"trip-time\">\r\n                    <span class=\"etd\" ng-class=\"{\'late\': trip.departureDelay()>0}\">{{trip.departureTime() | VVSTimeFormatter}}</span>\r\n                    <span class=\"seperator\"> - </span>\r\n                    <span class=\"eta\" ng-class=\"{\'late\': trip.arrivalDelay()>0}\">{{trip.arrivalTime() | VVSTimeFormatter}}</span>\r\n                    <vvs-real-time-icon mode=\"\'trip\'\" trip=\"trip\"></vvs-real-time-icon>\r\n                    <span class=\"travelled\">{{trip.duration() | VVSDurationFormatter}}</span>\r\n                </div>\r\n                <div class=\"trip-list\">\r\n                    <span class=\"trippart\" ng-repeat=\"leg in trip.legs()\" ng-if=\"[97, 98, 99].indexOf(leg.transportation().productClass())===-1\">\r\n                        <vvs-icon product-icon-id=\"{{leg.transportation().productIconId()}}\" mt-subcode=\"{{leg.transportation().properties().mtSubcode}}\" tr-number=\"{{leg.transportation().number()}}\"></vvs-icon>\r\n                        <span>{{leg.transportation().number()}}</span>\r\n                    </span>\r\n                </div>\r\n            </button>\r\n        </div>\r\n        <div class=\"col-xs-4 col-sm-4 text-right nopadding-xs trip-actions\">\r\n            <vvs-occ trip=\"trip\"></vvs-occ>\r\n            <vvs-infos mode=\"summary\" trip=\"trip\"></vvs-infos>\r\n\r\n            <div class=\"map nopadding-xs hidden-xs\">\r\n                <button type=\"button\" class=\"btn btn-link\" vvs-modal vvs-modal-template=\"trip/result/list/map.html\" title=\"{{\'Fahrt auf der Karte anzeigen\'|translate}}\">\r\n                    <vvs-icon name=\"karte\"></vvs-icon>\r\n                </button>\r\n            </div>\r\n\r\n            <vvs-trip-tickets trip=\"trip\"></vvs-trip-tickets>\r\n\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/list/main.html","<div class=\"tab-pane\" id=\"liste\" ng-controller=\"VVSTripResultListController\">\r\n    <div class=\"trip-wrap-list\">\r\n        <vvs-include vvs-src=\"trip/result/list/item.html\" ng-repeat=\"trip in journeyObj.service.getResults() track by $index\" class=\"vvs-trip-list-item\"></vvs-include>\r\n    </div>\r\n    <button type=\"button\" class=\"firstlast-trip btn btn-default btn-block btn-label collapse-toggle collapsed\" ng-click=\"(collapseFirstAndLastJourney=!collapseFirstAndLastJourney);(triggerShowFirstAndLastTripClick())\" data-toggle=\"collapse\" data-target=\"#firstlasttrip-collapse\" aria-expanded=\"false\" aria-controls=\"firstlasttrip-collapse\" ng-show=\"journeyObj.service.getResults().length > 0\" title=\"{{\'Erste und Letzte Fahrt berechnen\'|translate}}\">\r\n        <div class=\"pull-left text-left\">\r\n            {{\'Erste und letzte Fahrt\'|translate}}\r\n        </div>\r\n        <div class=\"pull-right text-right closed\" ng-hide=\"collapseFirstAndLastJourney\">\r\n            <vvs-icon name=\"down\"></vvs-icon>\r\n        </div>\r\n        <div class=\"pull-right text-right open\" ng-hide=\"!collapseFirstAndLastJourney\">\r\n            <vvs-icon name=\"up\"></vvs-icon>\r\n        </div>\r\n    </button>\r\n    <div class=\"collapse\" id=\"firstlasttrip-collapse\" uib-collapse=\"!collapseFirstAndLastJourney\" ng-if=\"journeyObj.firstJourneys || journeyObj.lastJourneys\">\r\n        <div class=\"trip-wrap-list\">\r\n            <vvs-include vvs-src=\"trip/result/list/item.html\" ng-repeat=\"trip in journeyObj.firstJourneys\" class=\"vvs-trip-list-item\" ng-init=\"isFirst = true\"></vvs-include>\r\n            <vvs-include vvs-src=\"trip/result/list/item.html\" ng-repeat=\"trip in journeyObj.lastJourneys\" class=\"vvs-trip-list-item\" ng-init=\"isLast = true\"></vvs-include>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/list/map.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">\r\n            <span ng-if=\"!isFirst && !isLast\">{{\'Fahrt\'|translate}} {{$index+1}}</span>\r\n            <span ng-if=\"isFirst\">{{\'Erste Fahrt\'|translate}}</span>\r\n            <span ng-if=\"isLast\">{{\'Letzte Fahrt\'|translate}}</span>\r\n        </h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <div class=\"modal-body nopadding-xs ctblock\">\r\n            <vvs-map mode=\"\'trip\'\" trip=\"trip\" load-on=\"{{true}}\"></vvs-map>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/list/occ.html","<div class=\"vvs-occ\" ng-style=\"dm && {\'justify-content\': \'center\'}\">\r\n    <ng-container ng-if=\"trip || dm || perlschnur\">\r\n        <div class=\"vvs-occupancy\">\r\n             <img ng-if=\"occupancyLow\" class=\"occupancy-img\" src=\"app/vvs.components/assets/images/occupancy_low.svg\" alt=\"occupancyLow\">\r\n             <img ng-if=\"occupancyMedium\" class=\"occupancy-img\" src=\"app/vvs.components/assets/images/occupancy_medium.svg\" alt=\"occupancyMedium\">\r\n             <img ng-if=\"occupancyHigh\" class=\"occupancy-img\" src=\"app/vvs.components/assets/images/occupancy_high.svg\" alt=\"occupancyHigh\">\r\n         </div>\r\n    </ng-container>\r\n    <ng-container ng-if=\"leg\">\r\n        <div class=\"vvs-occupancy vvs-occupancy-details\">\r\n            <div class=\"vvs-occ-block\" ng-if=\"occupancyLow\">\r\n                <button uib-tooltip=\"Niedrige Auslastung\" tooltip-placement=\"left\">\r\n                    <img class=\"occupancy-img\" src=\"app/vvs.components/assets/images/occupancy_low.svg\" alt=\"occupancyLow\">\r\n                  </button>\r\n            </div>\r\n            <div class=\"vvs-occ-block\" ng-if=\"occupancyMedium\">\r\n                <button uib-tooltip=\"Mittlere Auslastung\" tooltip-placement=\"left\">\r\n                    <img class=\"occupancy-img\" src=\"app/vvs.components/assets/images/occupancy_medium.svg\" alt=\"occupancyMedium\">\r\n                </button>\r\n            </div>\r\n            <div class=\"vvs-occ-block\" ng-if=\"occupancyHigh\">\r\n                <button uib-tooltip=\"Höhe Auslastung\" tooltip-placement=\"left\">\r\n                    <img class=\"occupancy-img\" src=\"app/vvs.components/assets/images/occupancy_high.svg\" alt=\"occupancyHigh\">\r\n                </button>\r\n            </div>\r\n         </div>\r\n    </ng-container>\r\n</div>");
$templateCache.put("app/vvs.components/trip/result/list/trip-composition.html","<div ng-show=\"vhIndex\" class=\"trip-composition-wrapper\">\r\n    <ul style=\"list-style-type: none;\">\r\n        <li ng-if=\"vhIndex === 1\">\r\n          <img src=\"app/vvs.components/assets/images/icons/trip-composition/kurzzug.svg\" alt=\"kurzzug\">\r\n        </li>\r\n        <li ng-if=\"vhIndex === 2\">\r\n          <img src=\"app/vvs.components/assets/images/icons/trip-composition/vollzug.svg\" alt=\"vollzug\">\r\n        </li>\r\n        <li ng-if=\"vhIndex === 3\">\r\n          <img src=\"app/vvs.components/assets/images/icons/trip-composition/langzug.svg\" alt=\"langzug\">\r\n        </li>\r\n        <li ng-if=\"vhIndex === 4\">\r\n          <img src=\"app/vvs.components/assets/images/icons/trip-composition/DS-4X.svg\" alt=\"langzug\">\r\n        </li>\r\n        <li ng-if=\"vhIndex === 5\">\r\n          <img src=\"app/vvs.components/assets/images/icons/trip-composition/DS-5X.svg\" alt=\"langzug\">\r\n        </li>\r\n      </ul>\r\n</div>");
$templateCache.put("app/vvs.components/trip/result/messages/no-realtime.html","<div class=\"ctblock hint col-xs-12 clearfix text-center spacertop\">\r\n    <p><strong>{{\'Hinweis\'|translate}}</strong> {{\'Verbindungen wurden ohne Echtzeit berechnet\'|translate}}.</p>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/print/main.html","<div id=\"vvs_print_view\" class=\"col-xs-12\">\r\n    <div class=\"holder\">\r\n        <header>\r\n            <h1>{{\'Fahrtempfehlung\'|translate}}</h1>\r\n            <div class=\"logo\"><img src=\"/app/vvs.components/assets/images/vvs_logo_sw.png\" alt=\"VVS\" height=\"41\" width=\"43\"></div>\r\n        </header>\r\n        <div class=\"selection col-xs-12\">\r\n            <h2>{{\'Wählen Sie die gewünschten Fahrten\'|translate}}</h2>\r\n            <div class=\"col-xs-12 nopadding\">\r\n                <div class=\"options\">\r\n                    <div ng-repeat=\"trip in trips\">\r\n\r\n                        <md-checkbox id=\"tripPrintSwitchers_{{$index}}\" ng-model=\"tripPrintSwitchers[$index]\" ng-change=\"switchTripPrint()\">\r\n                            {{$index+1}}. {{\'Fahrt\'|translate}}\r\n                        </md-checkbox>\r\n                    </div>\r\n                    <div>\r\n                        <md-checkbox id=\"allPrintSwitcher\" ng-model=\"allPrintSwitcher\" ng-change=\"switchAllPrintSwitcher(allPrintSwitcher)\">\r\n                            {{\'Alle Fahrten\'|translate}}\r\n                        </md-checkbox>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"selection col-xs-12\">\r\n            <h2>{{\'Alternativ auch als PDF Download\'|translate}}</h2>\r\n            <p>{{\'Hier können Sie die Fahrtempfehlung auch als PDF herunterladen. Dazu können Sie zwischen zwei Darstellungsoptionen wählen\'|translate}}:</p>\r\n            <div class=\"options spacerbottom\">\r\n                <md-radio-group ng-model=\"printType\">\r\n                    <md-radio-button value=\"overview\">{{\'Übersicht\' | translate}}</md-radio-button>\r\n                    <md-radio-button value=\"detail\">{{\'Detail\' | translate}}</md-radio-button>\r\n                </md-radio-group>\r\n            </div>\r\n            <p>\r\n                <a href=\"javascript:void(0)\" title=\"{{\'PDF Download\'|translate}}\" ng-click=\"triggerDownloadClick()\"><vvs-icon name=\"abschicken\"></vvs-icon> {{\'PDF Download\'|translate}}</a>\r\n            </p>\r\n        </div>\r\n\r\n        <div class=\"col-xs-12 nopadding spacertop spacerbottomlarge\">\r\n            <button type=\"button\" ui-sref=\"vvs.trip.result\" class=\"btn btn-default btn-sm print\">{{\'Abbrechen\'|translate}}</button>\r\n            <button class=\"btn btn-primary btn-sm print\" ng-click=\"triggerFirePrintTripsClick()\" type=\"button\">{{\'Drucken\'|translate}}</button>\r\n        </div>\r\n        <h2 class=\"trip col-xs-12\">{{orig | VVSLocationNameFormatter}} <img src=\"/app/vvs.components/assets/images/icons/pfeil-fahrten-drucken.svg\" height=\"12\" width=\"20\"> {{dest | VVSLocationNameFormatter}}</h2>\r\n        <div ng-repeat=\"trip in trips track by $index\" class=\"vvsTripPrint\" ng-show=\"tripPrintSwitchers[$index]\">\r\n            <p class=\"tripinfo\" ng-if=\"SEARCH_OPTIONS.dateTime.isDeparture\"><strong>{{\'Hinfahrt\'|translate}}</strong> {{trip.departureTimePlanned() | VVSDateFormatter}}, {{\'ab\'|translate}} {{trip.departureTimePlanned() | VVSTimeFormatter}} {{\'Uhr\'|translate}}</p>\r\n            <p class=\"tripinfo\" ng-if=\"!SEARCH_OPTIONS.dateTime.isDeparture\"><strong>{{\'Ankunft\'|translate}}</strong> {{trip.arrivalTimePlanned() | VVSDateFormatter}}, {{\'an\'|translate}} {{trip.arrivalTimePlanned() | VVSTimeFormatter}} {{\'Uhr\'|translate}}</p>\r\n            <!-- overview -->\r\n            <table class=\"print overview\" ng-if=\"printType==\'overview\'\">\r\n                <colgroup>\r\n                    <col width=\"24%\">\r\n                    <col width=\"19%\">\r\n                </colgroup>\r\n                <tr>\r\n                    <th>{{\'Haltestelle\'|translate}}</th>\r\n                    <th>{{\'Zeit / Linie\'|translate}}</th>\r\n                </tr>\r\n                <tr ng-repeat=\"leg in trip.legs()\" ng-if=\"leg.transportation().productClass() != 99\">\r\n                    <td>\r\n                        <strong>{{\'ab\'|translate}}</strong> {{leg.origin() | VVSLocationNameFormatter}}\r\n                        <br>\r\n                        <strong>{{\'an\'|translate}}</strong> {{leg.destination() | VVSLocationNameFormatter}}\r\n                    </td>\r\n                    <td>\r\n                        <table class=\"inner\">\r\n                            <colgroup>\r\n                                <col width=\"11%\">\r\n                                <col width=\"24%\">\r\n                                <col width=\"65%\">\r\n                            </colgroup>\r\n                            <tr>\r\n                                <td>\r\n                                    <vvs-real-time-icon mode=\"\'leg\'\" leg=\"leg\"></vvs-real-time-icon>\r\n                                </td>\r\n                                <td>{{leg.departureTime() | VVSTimeFormatter}}</td>\r\n                                <td rowspan=\"2\" ng-switch on=\"leg.transportation().productClass()\">\r\n                                    <div ng-switch-when=\"100\">\r\n                                        <strong>{{\'Fußweg\'|translate}} </strong> {{leg.totalDuration() | VVSFootLegDurationFormatter}}\r\n                                    </div>\r\n                                    <div ng-switch-default>\r\n                                        <strong>{{leg.transportation().number()}}</strong> {{leg.transportation().destination() | VVSLocationNameFormatter}}\r\n                                    </div>\r\n                                    <div class=\"subinfo\" ng-repeat=\"hint in leg.hints()\"><span ng-bind-html=\"hint|VVSHintFormatter\"></span></div>\r\n                                </td>\r\n                            </tr>\r\n                            <tr>\r\n                                <td></td>\r\n                                <td>{{leg.arrivalTime() | VVSTimeFormatter}}</td>\r\n                            </tr>\r\n                        </table>\r\n                    </td>\r\n                </tr>\r\n            </table>\r\n            <table class=\"print overview\" ng-if=\"printType==\'overview\'\">\r\n                <colgroup>\r\n                    <col width=\"24%\">\r\n                    <col width=\"19%\">\r\n                </colgroup>\r\n                <tr>\r\n                    <td>\r\n                        <strong>{{\'Dauer\'|translate}}</strong>\r\n                        <br>\r\n                        <strong>{{\'Umsteigen\'|translate}}</strong>\r\n                        <br>\r\n                        <strong>{{\'Preis / Zonen\'|translate}}</strong>\r\n                    </td>\r\n                    <td>\r\n                        {{trip.duration() | VVSDurationFormatter}}\r\n                        <br> {{trip.numberOfTransfers()}}x\r\n                        <div ng-if=\"trip.adultSingleTicket()\">\r\n                            {{trip.adultSingleTicket().price() | VVSPriceFormatter}} € /\r\n                            <span>\r\n                                <span ng-if=\"trip.adultSingleTicket().priceLevel()!==\'0\'\">\r\n                                    <span ng-if=\"trip.adultSingleTicket().priceLevel()==\'1\'\">1 {{\'Zone\'|translate}}</span>\r\n                                    <span ng-if=\"trip.adultSingleTicket().priceLevel()!=\'1\'\">{{trip.adultSingleTicket().priceLevel()}} {{\'Zonen\' | translate}}</span>\r\n                                </span>\r\n                                <span ng-if=\"trip.adultSingleTicket().priceLevel()===\'0\'\">{{\'Kurzstrecke\'}}</span>\r\n                            </span>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </table>\r\n            <!-- details -->\r\n            <table class=\"print\" ng-if=\"printType==\'detail\'\">\r\n                <colgroup>\r\n                    <col width=\"8%\">\r\n                    <col width=\"14%\">\r\n                    <col width=\"20%\">\r\n                    <col width=\"28%\">\r\n                    <col width=\"8%\">\r\n                    <col width=\"8%\">\r\n                    <col width=\"14%\">\r\n                </colgroup>\r\n                <tr>\r\n                    <th class=\"border\">{{\'Fahrt\'|translate}}</th>\r\n                    <th>{{\'Uhrzeit\'|translate}}</th>\r\n                    <th>{{\'Haltestelle\'|translate}}</th>\r\n                    <th>{{\'Linie\'|translate}}</th>\r\n                    <th>{{\'Gleis\'|translate}}</th>\r\n                    <th>{{\'Dauer\'|translate}}</th>\r\n                    <th>{{\'Preis / Zonen\'|translate}}</th>\r\n                </tr>\r\n                <tr ng-repeat=\"leg in trip.legs()\" ng-if=\"leg.transportation().productClass() != 99\">\r\n                    <td class=\"border\"><span ng-if=\"$first\">{{$index+1}}</span></td>\r\n                    <td><strong>{{\'ab\'|translate}}</strong> {{leg.departureTime() | VVSTimeFormatter}}\r\n                        <vvs-real-time-icon mode=\"\'leg\'\" leg=\"leg\" usage=\"\'dep\'\"></vvs-real-time-icon>\r\n                        <br>\r\n                        <strong>{{\'an\'|translate}}</strong> {{leg.arrivalTime() | VVSTimeFormatter}}\r\n                        <vvs-real-time-icon mode=\"\'leg\'\" leg=\"leg\" usage=\"\'arr\'\"></vvs-real-time-icon>\r\n                    </td>\r\n                    <td>{{leg.origin() | VVSLocationNameFormatter}}\r\n                        <br>{{leg.destination() | VVSLocationNameFormatter}}</td>\r\n                    <td>\r\n                        <span ng-if=\"leg.transportation().productClass()!=100\"><strong>{{leg.transportation().number()}} </strong> {{leg.transportation().destination() | VVSLocationNameFormatter}}</span>\r\n                        <span ng-if=\"leg.transportation().productClass()==100\"><strong>{{\'Fußweg\'|translate}} </strong> {{leg.totalDuration() | VVSFootLegDurationFormatter}}</span>\r\n                        <div class=\"subinfo\" ng-repeat=\"hint in leg.hints()\"><span ng-bind-html=\"hint|VVSHintFormatter\"></span></div>\r\n                    </td>\r\n                    <td ng-if=\"leg.transportation().productClass()!=100\">\r\n                        <span ng-if=\"leg.origin().type()===\'platform\'\">{{leg.origin().disassembledName(true)}}</span>\r\n                        <br/>\r\n                        <span ng-if=\"leg.destination().type()===\'platform\'\">{{leg.destination().disassembledName(true)}}</span>\r\n                    </td>\r\n                    <td ng-if=\"leg.transportation().productClass()==100\"></td>\r\n                    <td><span ng-if=\"$first\">{{trip.duration() | VVSDurationFormatter}}</span></td>\r\n                    <td>\r\n                        <div ng-if=\"($first) && (trip.adultSingleTicket())\">\r\n                            {{trip.adultSingleTicket().price() | VVSPriceFormatter}} €\r\n                            <br/>\r\n                            <!-- <span ng-if=\"trip.allZones()[0].zones.length==1\">1 {{\'Zone\'|translate}}</span>\r\n                            <span ng-if=\"trip.allZones()[0].zones.length!=1\">{{trip.allZones()[0].zones.length}} {{\'Zonen\'|translate}}</span> -->\r\n                            <span>\r\n                                <span ng-if=\"trip.adultSingleTicket().priceLevel()!==\'0\'\">\r\n                                    <span ng-if=\"trip.adultSingleTicket().priceLevel()==\'1\'\">1 {{\'Zone\'|translate}}</span>\r\n                                    <span ng-if=\"trip.adultSingleTicket().priceLevel()!=\'1\'\">{{trip.adultSingleTicket().priceLevel()}} {{\'Zonen\' | translate}}</span>\r\n                                </span>\r\n                                <span ng-if=\"trip.adultSingleTicket().priceLevel()===\'0\'\">{{\'Kurzstrecke\'}}</span>\r\n                            </span>\r\n                        </div>\r\n                    </td>\r\n                </tr>\r\n            </table>\r\n            <p>\r\n                <vvs-icon name=\"echtzeit\"></vvs-icon> {{\'Echtzeitinformation\'|translate}}</p>\r\n            <div ng-if=\"trip.infos().length > 0\" class=\"infos\">\r\n                <h3>{{\'Aktuelle Informationen\'|translate}}</h3>\r\n                <span ng-repeat=\"info in trip.infos() track by $index\">{{info.urlText()}}</span>\r\n            </div>\r\n        </div>\r\n        <div class=\"disclaimer\">\r\n            <h3>{{\'Alle Angaben sind ohne Gewähr.\'|translate}}</h3>\r\n            <p>{{\'Bitte prüfen Sie die Übereinstimmung des vorgeschlagenen Weges mit der Gültigkeit Ihres Tickets. Beachten Sie, dass Fahrtempfehlungen auch für Verbindungen außerhalb des VVS-Verkehrsgebietes gegeben werden.\'|translate}}</p>\r\n            <p>{{\'Fahrplanauskunft EFA mobil: Unterwegs können Sie sich mit Mobiltelefonen mit aktuellem Browser unter mobil.vvs.de informieren. Unter vvs.de/m erfahren Sie mehr dazu. Gute Fahrt mit den Verbundverkehrsmitteln\'|translate}}</p>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/settings/main.html","<div class=\"settings-block clearfix\" ng-controller=\"VVSTripResultSettingsController\">\r\n    <div class=\"col-xs-12\">\r\n        <h2 class=\"nopadding-xs\">{{\'Ihre Einstellungen\' | translate}}</h2>\r\n    </div>\r\n    <div class=\"col-xs-6 col-md-3\">\r\n        <p>{{\'Barrierefrei\' | translate}}</p>\r\n    </div>\r\n    <div class=\"col-xs-6 col-md-9\">\r\n        <!-- to save the structure in case of deactivation \'accessability\' params -->\r\n       <p ng-if=\"\r\n        !SEARCH_OPTIONS.accessibility.showAccessibility &&\r\n        !SEARCH_OPTIONS.accessibility.accessibleVehiclesOnly &&\r\n        !SEARCH_OPTIONS.accessibility.stepFree &&\r\n        !SEARCH_OPTIONS.accessibility.visuallyImpaired\"\r\n        >\r\n        &nbsp;\r\n        </p>\r\n        <a id=\"vvs_trip_settings\"></a>\r\n        <p>\r\n            <span ng-if=\"SEARCH_OPTIONS.accessibility.showAccessibility\">{{\'Zugangsinformationen anzeigen\'|translate}}<span\r\n                ng-if=\"SEARCH_OPTIONS.accessibility.accessibleVehiclesOnly || SEARCH_OPTIONS.accessibility.stepFree || SEARCH_OPTIONS.accessibility.visuallyImpaired\">, </span>\r\n            </span>\r\n            <span ng-if=\"SEARCH_OPTIONS.accessibility.accessibleVehiclesOnly\">{{\'Barrierefreie nutzen\'|translate}}<span\r\n                ng-if=\"SEARCH_OPTIONS.accessibility.stepFree || SEARCH_OPTIONS.accessibility.visuallyImpaired\">, </span>\r\n            </span>\r\n            <span ng-if=\"SEARCH_OPTIONS.accessibility.stepFree\">{{\'Stufenlos unterwegs\'|translate}}<span\r\n                ng-if=\"SEARCH_OPTIONS.accessibility.visuallyImpaired\">, </span>\r\n            </span>\r\n            <span ng-if=\"SEARCH_OPTIONS.accessibility.visuallyImpaired\">{{\'Seheingeschränkt unterwegs\'|translate}}</span>\r\n        </p>\r\n    </div>\r\n    <div class=\"col-xs-6 col-md-3\">\r\n        <p>{{\'Verbindungen\' | translate}}</p>\r\n    </div>\r\n    <div class=\"col-xs-6 col-md-9\">\r\n        <a id=\"vvs_trip_settings\"></a>\r\n        <p>\r\n            <span ng-switch=\"SEARCH_OPTIONS.publicTransport.routingOptimization\">\r\n                <span ng-switch-when=\"time\">{{\'zeitkürzeste Verbindung\'|translate}}</span>\r\n                <span ng-switch-when=\"interchange\">{{\'Verbindung mit wenig Umstiegen\'|translate}}</span>\r\n                <span ng-switch-when=\"walking\">{{\'Verbindung mit kurzem Fußweg\'|translate}}</span>\r\n                <span ng-switch-when=\"costex\">{{\'preisgünstigste Verbindung\'|translate}}</span>\r\n            </span>\r\n        </p>\r\n    </div>\r\n    <div class=\"col-xs-6 col-md-3\">\r\n        <p>{{\'Verkehrsmittel\' | translate}}</p>\r\n    </div>\r\n    <div class=\"col-xs-6 col-md-9\">\r\n        <p>\r\n            <span ng-if=\"!SEARCH_OPTIONS.productRestrictions.train || !SEARCH_OPTIONS.productRestrictions.commuter || !SEARCH_OPTIONS.productRestrictions.lightRail || !SEARCH_OPTIONS.productRestrictions.bus || !SEARCH_OPTIONS.productRestrictions.coach || !SEARCH_OPTIONS.productRestrictions.demandTaxi\">{{\'ohne\'|translate}} : </span>\r\n            <span ng-if=\"SEARCH_OPTIONS.productRestrictions.train && SEARCH_OPTIONS.productRestrictions.commuter && SEARCH_OPTIONS.productRestrictions.lightRail && SEARCH_OPTIONS.productRestrictions.bus && SEARCH_OPTIONS.productRestrictions.coach && SEARCH_OPTIONS.productRestrictions.demandTaxi\">{{\'Alle\'|translate}}</span>\r\n            <span ng-if=\"!SEARCH_OPTIONS.productRestrictions.train\">{{\'R-Bahn\'|translate}}</span>\r\n            <span ng-if=\"!SEARCH_OPTIONS.productRestrictions.commuter\">\r\n                <span ng-if=\"!SEARCH_OPTIONS.productRestrictions.train\">, </span>\r\n                {{\'S-Bahn\'|translate}}\r\n            </span>\r\n            <span ng-if=\"!SEARCH_OPTIONS.productRestrictions.lightRail\">\r\n                <span ng-if=\"!SEARCH_OPTIONS.productRestrictions.train || !SEARCH_OPTIONS.productRestrictions.commuter\">, </span>\r\n                {{\'Stadt-/Zahnradbahn\'}}\r\n            </span>\r\n            <span ng-if=\"!SEARCH_OPTIONS.productRestrictions.bus\">\r\n                <span ng-if=\"!SEARCH_OPTIONS.productRestrictions.train || !SEARCH_OPTIONS.productRestrictions.commuter || !SEARCH_OPTIONS.productRestrictions.lightRail\">, </span>\r\n                {{\'Bus\'|translate}}\r\n            </span>\r\n            <span ng-if=\"!SEARCH_OPTIONS.productRestrictions.coach\">\r\n                <span ng-if=\"!SEARCH_OPTIONS.productRestrictions.train || !SEARCH_OPTIONS.productRestrictions.commuter || !SEARCH_OPTIONS.productRestrictions.lightRail || !SEARCH_OPTIONS.productRestrictions.bus\">, </span>\r\n                {{\'Nachtbus\' | translate}}\r\n            </span>\r\n            <span ng-if=\"!SEARCH_OPTIONS.productRestrictions.demandTaxi\">\r\n                <span ng-if=\"!SEARCH_OPTIONS.productRestrictions.train || !SEARCH_OPTIONS.productRestrictions.commuter || !SEARCH_OPTIONS.productRestrictions.lightRail || !SEARCH_OPTIONS.productRestrictions.bus || !SEARCH_OPTIONS.productRestrictions.coach\">, </span>\r\n                {{\'Ruftaxi\' | translate}}\r\n            </span>\r\n        </p>\r\n    </div>\r\n    <div class=\"col-xs-6 col-md-3\">\r\n        <p>{{\'Gehgeschwindigkeit\' | translate}}</p>\r\n    </div>\r\n    <div class=\"col-xs-6 col-md-9\">\r\n        <p>\r\n            <span ng-switch=\"SEARCH_OPTIONS.individualTransport.to.walkSpeed\">\r\n                <span ng-switch-when=\"normal\">{{\'normal (5 km/h)\'|translate}}</span>\r\n                <span ng-switch-when=\"fast\">{{\'schnell (8 km/h)\'|translate}}</span>\r\n                <span ng-switch-when=\"slow\">{{\'langsam / mit schwerem Gepäck (2 km/h)\'|translate}}</span>\r\n            </span>\r\n        </p>\r\n    </div>\r\n    <div class=\"col-xs-6 col-md-3\">\r\n        <p>{{\'Fußwegzeit am Start/Ziel\' | translate}}</p>\r\n    </div>\r\n    <div class=\"col-xs-6 col-md-9\">\r\n        <p>\r\n            {{SEARCH_OPTIONS.individualTransport.to.minutes}}/{{SEARCH_OPTIONS.individualTransport.from.minutes}} {{\'min\'|translate}}\r\n        </p>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/summary/main.html","<div class=\"trips-header\" ng-controller=\"VVSTripResultSummaryController\">\r\n    <div class=\"tripsbox clearfix\">\r\n        <div class=\"col-xs-12 nopadding-xs trip-data\">\r\n            <div class=\"fixed-icon\">\r\n                <vvs-icon name=\"{{inputLocations[\'via\']?\'von-nach2\':\'von-nach\'}}\"></vvs-icon>\r\n            </div>\r\n            <div class=\"pull-left text-left hidemetext\">\r\n                <span>{{inputLocations[\'orig\'] | VVSLocationNameFormatter}}</span>\r\n                <span ng-if=\"inputLocations[\'via\']\">{{inputLocations[\'via\'] | VVSLocationNameFormatter}}</span>\r\n                <span>{{inputLocations[\'dest\'] | VVSLocationNameFormatter}}</span>\r\n            </div>\r\n            <div class=\"trip-metadata\">\r\n                <p>\r\n                    <span>{{ date | VVSSummaryDateFormatter }}</span>,\r\n                    {{SEARCH_OPTIONS.dateTime.isDeparture?(\"Abfahrt\"|translate):(\"Ankunft\"|translate)}} <span class=\"time\">{{SEARCH_OPTIONS.dateTime.time | VVSTimeFormatter}}</span\r\n                </p>\r\n            </div>\r\n        </div>\r\n        <div class=\"nopadding-xs\">\r\n            <div class=\"col-xs-12 col-lg-5 nopadding-xs\">\r\n                <div class=\"trip-metadata special\">\r\n                    <p>{{\'Ihre Einstellungen\'|translate}}: <vvs-trip-result-summary-options-status></vvs-trip-result-summary-options-status></p>\r\n                </div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-lg-7 nopadding-xs change-trip-buttons\">\r\n                <div class=\"btn-group\" role=\"group\" aria-label=\"...\">\r\n                    <div class=\"btn-group\" role=\"group\">\r\n                        <button type=\"button\" class=\"btn btn-link\" ng-click=\"triggerChangeTripRequestClick()\" title=\"{{\'Fahrt ändern\'|translate}}\">\r\n                            <vvs-icon name=\"aendern\"></vvs-icon><span class=\"hidden-xs\"> {{\'Ändern\'|translate}}</span>\r\n                        </button>\r\n                    </div>\r\n                    <div class=\"btn-group\" role=\"group\">\r\n                        <button type=\"button\" class=\"btn btn-link realtime-btn\" vvs-modal vvs-modal-template=\"modals/realtime.html\" vvs-modal-size=\"sm\" ng-class=\"{\'late\' : SEARCH_OPTIONS.dateTime.useRealTime}\" title=\"{{\'Echtzeit ein/ausschalten\'|translate}}\">\r\n                            <vvs-icon name=\"echtzeit\"></vvs-icon><span class=\"hidden-xs\"> {{\'Echtzeit\'|translate}}</span>\r\n                        </button>\r\n                    </div>\r\n                    <div class=\"btn-group\" role=\"group\">\r\n                        <button type=\"button\" class=\"btn btn-link\" vvs-modal vvs-modal-template=\"modals/refresh.html\" vvs-modal-size=\"sm\" title=\"{{\'Uhrzeit aktualisieren\'|translate}}\">\r\n                            <vvs-icon name=\"aktualisieren\"></vvs-icon><span class=\"hidden-xs\"> {{\'Aktualisieren\'|translate}}</span>\r\n                        </button>\r\n                    </div>\r\n                    <div class=\"btn-group\" role=\"group\">\r\n                        <button type=\"button\" class=\"btn btn-link\" ng-click=\"triggerResetTripRequestClick()\" title=\"{{\'Neue Fahrt berechnen\'|translate}}\">\r\n                            <vvs-icon name=\"neuefahrt\"></vvs-icon><span class=\"hidden-xs\"> {{\'Neu\'|translate}}</span>\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n  </div>\r\n");
$templateCache.put("app/vvs.components/ttb/stops/lines/main.html","<div ng-controller=\"VVSTTBStopsLinesController as VVSTTBStopsLinesCtrl\">\r\n    <div class=\"infoarea clearfix\">\r\n        <div class=\"col-xs-12\">\r\n            <div class=\"pull-left text-left\">\r\n                <p>{{\'Suchergebnis für\'|translate}} <strong>{{\'Haltestelle\'|translate}}</strong>:\r\n                    <br>\r\n                    {{inputLocations.ttb | VVSLocationNameFormatter}}</p>\r\n            </div>\r\n        </div>\r\n        <div class=\"col-xs-12 nopadding-xs change-trip-buttons \">\r\n            <div class=\"btn-group\" role=\"group\" aria-label=\"...\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button type=\"button\" class=\"btn btn-link\" ng-click=\"VVSTTBStopsLinesCtrl.triggerTTBResetClick()\">\r\n                        <vvs-icon name=\"aendern\"></vvs-icon> {{\'Neu\'|translate}}\r\n                    </button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div ng-if=\"VVSTTBStopsLinesCtrl.lineSelections.length>0\">\r\n        <h2>{{\'Linien\'|translate}}</h2>\r\n        <div class=\"ctblock buttonlist col-xs-12 nopadding-xs\" role=\"group\" aria-label=\"Linienauswahl\">\r\n            <button type=\"button\" class=\"btn btn-default btn-block btn-autoheight\" ng-repeat=\"line in VVSTTBStopsLinesCtrl.lineSelections\" ng-click=\"VVSTTBStopsLinesCtrl.triggerFireTTBDownloadClick(line)\">\r\n                <div class=\"sendholder\">\r\n                    <div class=\"pull-left text-left\">\r\n                        <vvs-icon product-icon-id=\"{{line.productIconId()}}\"></vvs-icon> <span ng-bind-html=\"line | VVSLineNameFormatter\"></span>\r\n                    </div>\r\n                </div>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/options/means-of-transport/description/main.html","<div class=\"info-text spacertop spacerbottom\">\r\n    <span ng-if=\"!SEARCH_OPTIONS.productRestrictions.train || !SEARCH_OPTIONS.productRestrictions.commuter || !SEARCH_OPTIONS.productRestrictions.lightRail || !SEARCH_OPTIONS.productRestrictions.bus || !SEARCH_OPTIONS.productRestrictions.coach || !SEARCH_OPTIONS.productRestrictions.demandTaxi\">\r\n        {{\'ohne\'|translate}}:\r\n    </span>\r\n    <span ng-if=\"!SEARCH_OPTIONS.productRestrictions.train\">{{\'R-Bahn\'|translate}}</span><span ng-if=\"!SEARCH_OPTIONS.productRestrictions.commuter\"><span ng-if=\"!SEARCH_OPTIONS.productRestrictions.train\">, </span>{{\'S-Bahn\'|translate}}</span><span ng-if=\"!SEARCH_OPTIONS.productRestrictions.lightRail\"><span ng-if=\"!SEARCH_OPTIONS.productRestrictions.train || !SEARCH_OPTIONS.productRestrictions.commuter\">, </span>{{\'Stadt-/Zahnradbahn\'|translate}}</span><span ng-if=\"!SEARCH_OPTIONS.productRestrictions.bus\"><span ng-if=\"!SEARCH_OPTIONS.productRestrictions.train || !SEARCH_OPTIONS.productRestrictions.commuter || !SEARCH_OPTIONS.productRestrictions.lightRail\">, </span>{{\'Bus\'|translate}}</span><span ng-if=\"!SEARCH_OPTIONS.productRestrictions.coach\"><span ng-if=\"!SEARCH_OPTIONS.productRestrictions.train || !SEARCH_OPTIONS.productRestrictions.commuter || !SEARCH_OPTIONS.productRestrictions.lightRail || !SEARCH_OPTIONS.productRestrictions.bus\">,&nbsp;</span>{{\'Nachtbus\' | translate}}</span><span ng-if=\"!SEARCH_OPTIONS.productRestrictions.demandTaxi\"><span ng-if=\"!SEARCH_OPTIONS.productRestrictions.train || !SEARCH_OPTIONS.productRestrictions.commuter || !SEARCH_OPTIONS.productRestrictions.lightRail || !SEARCH_OPTIONS.productRestrictions.bus || !SEARCH_OPTIONS.productRestrictions.coach\">, </span>{{\'Ruftaxi\' | translate}}</span>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/options/means-of-transport/status/main.html","<input type=\"text\" class=\"form-control text-right\" ng-class=\"{\'modified\':isChanged}\" ng-attr-placeholder=\"{{changeMOTText}}\" aria-describedby=\"verkehrsmittel-addon\" tabindex=\"-1\"/>\r\n");
$templateCache.put("app/vvs.components/trip/options/settings/description/main.html","<!-- START SEITE - ZUSAMMENFASSUNG -->\r\n<div class=\"info-text spacertop spacerbottom\">\r\n    <!-- showAccessibility -->\r\n    <span ng-if=\"DEFAULT_SEARCH_OPTIONS.accessibility.showAccessibility!=SEARCH_OPTIONS.accessibility.showAccessibility\">Zugangsinformationen anzeigen<span\r\n        ng-if=\"SEARCH_OPTIONS.accessibility.accessibleVehiclesOnly || SEARCH_OPTIONS.accessibility.stepFree || SEARCH_OPTIONS.accessibility.visuallyImpaired || SEARCH_OPTIONS.publicTransport.bikeTakeAlong\">,</span>\r\n    </span>\r\n    <!-- accessibleVehiclesOnly - Barrierefreie nutzen -->\r\n    <span ng-if=\"DEFAULT_SEARCH_OPTIONS.accessibility.accessibleVehiclesOnly!=SEARCH_OPTIONS.accessibility.accessibleVehiclesOnly\">\r\n        <span ng-if=\"!SEARCH_OPTIONS.accessibility.accessibleVehiclesOnly\">{{\'Barrierefreie nicht nutzen\'|translate}}</span>\r\n        <span ng-if=\"SEARCH_OPTIONS.accessibility.accessibleVehiclesOnly\">{{\'Barrierefreie nutzen\'|translate}}</span>\r\n    </span>\r\n    <!-- Stufenlos unterwegs -->\r\n    <span ng-if=\"DEFAULT_SEARCH_OPTIONS.accessibility.stepFree!=SEARCH_OPTIONS.accessibility.stepFree\">\r\n        <span ng-if=\"SEARCH_OPTIONS.accessibility.stepFree\">{{\'Stufenlos unterwegs\'|translate}},</span>\r\n        <!-- <span ng-if=\"SEARCH_OPTIONS.accessibility.visuallyImpaired\">,</span> -->\r\n    </span>\r\n    <span ng-if=\"DEFAULT_SEARCH_OPTIONS.accessibility.visuallyImpaired!=SEARCH_OPTIONS.accessibility.visuallyImpaired\">\r\n        <!-- <span ng-if=\"!SEARCH_OPTIONS.accessibility.stepFree\">{{\'Barrierefreie nicht nutzen\'|translate}}</span> -->\r\n        <span ng-if=\"SEARCH_OPTIONS.accessibility.visuallyImpaired\">{{\'Seheingeschränkt unterwegs\'|translate}},</span>\r\n    </span>\r\n    <span ng-if=\"\r\n        (DEFAULT_SEARCH_OPTIONS.publicTransport.routingOptimization!=SEARCH_OPTIONS.publicTransport.routingOptimization) ||\r\n        (SEARCH_OPTIONS.publicTransport.bikeTakeAlong) ||\r\n        (DEFAULT_SEARCH_OPTIONS.individualTransport.to.walkSpeed!=SEARCH_OPTIONS.individualTransport.to.walkSpeed) ||\r\n        (DEFAULT_SEARCH_OPTIONS.individualTransport.to.minutes!=SEARCH_OPTIONS.individualTransport.to.minutes) ||\r\n        (DEFAULT_SEARCH_OPTIONS.individualTransport.from.minutes!=SEARCH_OPTIONS.individualTransport.from.minutes) ||\r\n        (DEFAULT_SEARCH_OPTIONS.individualTransport.to.avoidElevation!=SEARCH_OPTIONS.individualTransport.to.avoidElevation) ||\r\n        (DEFAULT_SEARCH_OPTIONS.pdfOutput.elevationProfile!=SEARCH_OPTIONS.pdfOutput.elevationProfile)\">\r\n        <!-- , -->\r\n    </span>\r\n    <span ng-if=\"DEFAULT_SEARCH_OPTIONS.publicTransport.routingOptimization!=SEARCH_OPTIONS.publicTransport.routingOptimization\"\r\n    ng-switch=\"SEARCH_OPTIONS.publicTransport.routingOptimization\">\r\n    <span ng-switch-when=\"time\">{{\'zeitkürzeste Verbindung\'|translate}}</span>\r\n    <span ng-switch-when=\"interchange\">{{\'Verbindung mit wenig Umstiegen\'|translate}}</span>\r\n    <span ng-switch-when=\"walking\">{{\'Verbindung mit kurzem Fußweg\'|translate}}</span>\r\n    <span ng-switch-when=\"costex\">{{\'preisgünstigste Verbindung\'|translate}}</span>\r\n    </span>\r\n    <span ng-if=\"(SEARCH_OPTIONS.fare.avoidZones.length>0) && (SEARCH_OPTIONS.fare.avoidZones.length<tariffZones.length)\">\r\n        <span ng-if=\"(DEFAULT_SEARCH_OPTIONS.publicTransport.routingOptimization!=SEARCH_OPTIONS.publicTransport.routingOptimization) ||\r\n            (SEARCH_OPTIONS.publicTransport.bikeTakeAlong) ||\r\n            (DEFAULT_SEARCH_OPTIONS.individualTransport.to.walkSpeed!=SEARCH_OPTIONS.individualTransport.to.walkSpeed) ||\r\n            (DEFAULT_SEARCH_OPTIONS.individualTransport.to.minutes!=SEARCH_OPTIONS.individualTransport.to.minutes) ||\r\n            (DEFAULT_SEARCH_OPTIONS.individualTransport.from.minutes!=SEARCH_OPTIONS.individualTransport.from.minutes) ||\r\n            (DEFAULT_SEARCH_OPTIONS.individualTransport.to.avoidElevation!=SEARCH_OPTIONS.individualTransport.to.avoidElevation) ||\r\n                (DEFAULT_SEARCH_OPTIONS.pdfOutput.elevationProfile!=SEARCH_OPTIONS.pdfOutput.elevationProfile)\">,\r\n        </span>\r\n        {{\'ohne\'|translate}}\r\n        <span ng-if=\"SEARCH_OPTIONS.fare.avoidZones.length==1\">{{\'Tarifzone\'|translate}} </span>\r\n        <span ng-if=\"SEARCH_OPTIONS.fare.avoidZones.length>1\">{{\'Tarifzonen\'|translate}} </span>\r\n        <span ng-repeat=\"zone in SEARCH_OPTIONS.fare.avoidZones\">{{zone}}\r\n        <span ng-if=\"!$last\">, </span>\r\n    </span>\r\n    </span>\r\n    <span ng-if=\"SEARCH_OPTIONS.fare.avoidZones.length==tariffZones.length\">\r\n        <span ng-if=\"(DEFAULT_SEARCH_OPTIONS.publicTransport.routingOptimization!=SEARCH_OPTIONS.publicTransport.routingOptimization) ||\r\n        (SEARCH_OPTIONS.publicTransport.bikeTakeAlong) ||\r\n            (DEFAULT_SEARCH_OPTIONS.individualTransport.to.walkSpeed!=SEARCH_OPTIONS.individualTransport.to.walkSpeed) ||\r\n            (DEFAULT_SEARCH_OPTIONS.individualTransport.to.minutes!=SEARCH_OPTIONS.individualTransport.to.minutes) ||\r\n            (DEFAULT_SEARCH_OPTIONS.individualTransport.from.minutes!=SEARCH_OPTIONS.individualTransport.from.minutes) ||\r\n            (DEFAULT_SEARCH_OPTIONS.individualTransport.to.avoidElevation!=SEARCH_OPTIONS.individualTransport.to.avoidElevation) ||\r\n                (DEFAULT_SEARCH_OPTIONS.pdfOutput.elevationProfile!=SEARCH_OPTIONS.pdfOutput.elevationProfile) ||\r\n                (DEFAULT_SEARCH_OPTIONS.accessibility.showAccessibility!=SEARCH_OPTIONS.accessibility.showAccessibility)\">,\r\n        </span>\r\n        {{\'Keine Tarifzone\'|translate}}\r\n    </span>\r\n    <span ng-if=\"SEARCH_OPTIONS.publicTransport.bikeTakeAlong\">\r\n        <span ng-if=\"DEFAULT_SEARCH_OPTIONS.publicTransport.routingOptimization!=SEARCH_OPTIONS.publicTransport.routingOptimization\">, </span>\r\n            {{\'Fahrradmitnahme\'|translate}}\r\n    </span>\r\n    <span ng-if=\"DEFAULT_SEARCH_OPTIONS.individualTransport.to.walkSpeed!=SEARCH_OPTIONS.individualTransport.to.walkSpeed\" ng-switch=\"SEARCH_OPTIONS.individualTransport.to.walkSpeed\">\r\n            <span ng-if=\"(DEFAULT_SEARCH_OPTIONS.publicTransport.routingOptimization!=SEARCH_OPTIONS.publicTransport.routingOptimization) || (SEARCH_OPTIONS.publicTransport.bikeTakeAlong)\">, </span>\r\n            <span ng-switch-when=\"normal\">{{\'normale Gehgeschwindigkeit\'|translate}}</span>\r\n            <span ng-switch-when=\"fast\">{{\'schnelle Gehgeschwindigkeit\'|translate}}</span>\r\n            <span ng-switch-when=\"slow\">{{\'langsame Gehgeschwindigkeit\'|translate}}</span>\r\n    </span>\r\n    <span ng-if=\"DEFAULT_SEARCH_OPTIONS.individualTransport.to.minutes!=SEARCH_OPTIONS.individualTransport.to.minutes\">\r\n        <span ng-if=\"(DEFAULT_SEARCH_OPTIONS.publicTransport.routingOptimization!=SEARCH_OPTIONS.publicTransport.routingOptimization) || (SEARCH_OPTIONS.publicTransport.bikeTakeAlong) || (DEFAULT_SEARCH_OPTIONS.individualTransport.to.walkSpeed!=SEARCH_OPTIONS.individualTransport.to.walkSpeed)\">, </span>\r\n        {{SEARCH_OPTIONS.individualTransport.to.minutes}} {{\'Minuten zur Start-Haltestelle\'}}\r\n    </span>\r\n    <span ng-if=\"DEFAULT_SEARCH_OPTIONS.individualTransport.from.minutes!=SEARCH_OPTIONS.individualTransport.from.minutes\">\r\n        <span ng-if=\"(DEFAULT_SEARCH_OPTIONS.publicTransport.routingOptimization!=SEARCH_OPTIONS.publicTransport.routingOptimization)\r\n        || (SEARCH_OPTIONS.publicTransport.bikeTakeAlong)\r\n        || (DEFAULT_SEARCH_OPTIONS.individualTransport.to.walkSpeed!=SEARCH_OPTIONS.individualTransport.to.walkSpeed)\r\n        || (DEFAULT_SEARCH_OPTIONS.individualTransport.to.minutes!=SEARCH_OPTIONS.individualTransport.to.minutes)\">,\r\n        </span>{{SEARCH_OPTIONS.individualTransport.from.minutes}} {{\'Minuten von der Ziel-Haltestelle\'}}\r\n    </span>\r\n    <span ng-if=\"DEFAULT_SEARCH_OPTIONS.individualTransport.to.avoidElevation!=SEARCH_OPTIONS.individualTransport.to.avoidElevation\">\r\n        <span ng-if=\"(DEFAULT_SEARCH_OPTIONS.publicTransport.routingOptimization!=SEARCH_OPTIONS.publicTransport.routingOptimization)\r\n        || (SEARCH_OPTIONS.publicTransport.bikeTakeAlong) || (DEFAULT_SEARCH_OPTIONS.individualTransport.to.walkSpeed!=SEARCH_OPTIONS.individualTransport.to.walkSpeed)\r\n        || (DEFAULT_SEARCH_OPTIONS.individualTransport.to.minutes!=SEARCH_OPTIONS.individualTransport.to.minutes)\r\n        || (DEFAULT_SEARCH_OPTIONS.individualTransport.from.minutes!=SEARCH_OPTIONS.individualTransport.from.minutes)\">,\r\n        </span>\r\n        {{\'Steigungen nicht vermeiden\'|translate}}\r\n    </span>\r\n    <span ng-if=\"SEARCH_OPTIONS.pdfOutput.elevationProfile\">\r\n        <span ng-if=\"(DEFAULT_SEARCH_OPTIONS.publicTransport.routingOptimization!=SEARCH_OPTIONS.publicTransport.routingOptimization)\r\n        || (SEARCH_OPTIONS.publicTransport.bikeTakeAlong) || (DEFAULT_SEARCH_OPTIONS.individualTransport.to.walkSpeed!=SEARCH_OPTIONS.individualTransport.to.walkSpeed)\r\n        || (DEFAULT_SEARCH_OPTIONS.individualTransport.to.minutes!=SEARCH_OPTIONS.individualTransport.to.minutes)\r\n        || (DEFAULT_SEARCH_OPTIONS.individualTransport.from.minutes!=SEARCH_OPTIONS.individualTransport.from.minutes)\r\n        || (DEFAULT_SEARCH_OPTIONS.individualTransport.to.avoidElevation!=SEARCH_OPTIONS.individualTransport.to.avoidElevation)\">,\r\n        </span>\r\n        {{\'Höhenprofil anzeigen\'|translate}}\r\n    </span>\r\n                <!-- Profile update -->\r\n\r\n            </div>\r\n");
$templateCache.put("app/vvs.components/trip/options/settings/status/main.html","<input type=\"text\" class=\"form-control text-right\" ng-class=\"{\'modified\':isChanged}\" ng-attr-placeholder=\"{{changeSettingText}}\" aria-describedby=\"einstellungen-addon\" tabindex=\"-1\"/>\r\n");
$templateCache.put("app/vvs.components/trip/result/details/buttons/main.html","<div class=\"col-xs-12 spacerbottomlarge ctblock nopadding-xs padding-md\" ng-controller=\"VVSTripResultDetailsButtonsController\">\r\n    <div class=\"btn-group btn-group-justified actionbuttons\" role=\"group\" aria-label=\"aktionbuttons\">\r\n\r\n        <div class=\"btn-group\" role=\"group\">\r\n            <button type=\"button\" class=\"btn btn-default\" vvs-modal vvs-modal-template=\"trip/result/details/buttons/map.html\" title=\"{{\'Fahrt auf der Karte anzeigen\'|translate}}\">\r\n                <vvs-icon name=\"karte\"></vvs-icon>\r\n            </button>\r\n        </div>\r\n\r\n        <div class=\"btn-group\" role=\"group\">\r\n            <button type=\"button\" class=\"btn btn-default\" vvs-modal vvs-modal-template=\"trip/modals/calendar.html\" vvs-modal-size=\"sm\" title=\"{{\'Diese Fahrt im Kalendar eintragen\'|translate}}\">\r\n                <vvs-icon name=\"kalender\"></vvs-icon>\r\n            </button>\r\n        </div>\r\n        <div class=\"btn-group\" role=\"group\">\r\n            <a href=\"{{mailToUrl}}\">\r\n                <button type=\"button\" class=\"btn btn-default\" title=\"{{\'Verbindung versenden\'|translate}}\">\r\n                    <vvs-icon name=\"teilen\"></vvs-icon>\r\n                </button>\r\n            </a>\r\n        </div>\r\n        <!--<div class=\"btn-group\" role=\"group\">\r\n            <button type=\"button\" class=\"btn btn-default\">\r\n                <vvs-icon name=\"alarm\"></vvs-icon>\r\n            </button>\r\n        </div>-->\r\n        <div class=\"btn-group\" role=\"group\">\r\n            <button type=\"button\" class=\"btn btn-default\" vvs-modal vvs-modal-template=\"trip/modals/print.html\" vvs-modal-size=\"sm\" title=\"{{\'Als PDF generieren\'|translate}}\">\r\n                <vvs-icon name=\"pdf\"></vvs-icon>\r\n            </button>\r\n        </div>\r\n        <div class=\"btn-group\" role=\"group\">\r\n            <button type=\"button\" class=\"btn btn-default\" ng-click=\"triggerReturnClick(trip)\" title=\"{{\'Rückfahrt berechnen\'|translate}}\">\r\n                <vvs-icon name=\"rueckfahrt\"></vvs-icon>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/details/buttons/map.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">\r\n            <span ng-if=\"!isFirst && !isLast\">{{\'Fahrt\'|translate}} {{tripIndex+1}}</span>\r\n            <span ng-if=\"isFirst\">{{\'Erste Fahrt\'|translate}}</span>\r\n            <span ng-if=\"isLast\">{{\'Letzte Fahrt\'|translate}}</span>\r\n        </h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <div class=\"modal-body nopadding-xs ctblock\">\r\n            <vvs-map mode=\"\'trip\'\" trip=\"trip\" load-on=\"{{true}}\"></vvs-map>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/details/pagination/main.html","<div class=\"col-xs-12 spacertop ctblock nopadding-xs\" ng-controller=\"VVSTripResultDetailsPaginationController\">\r\n    <div class=\"col-xs-7 col-sm-2 trip-switch\">\r\n        <div class=\"col-xs-2 col-sm-2 nopadding-xs\">\r\n            <a href=\"javascript:void(0)\" title=\"{{\'Vorherige Fahrt\'|translate}}\" ng-click=\"previousTrip()\">\r\n                <vvs-icon name=\"zurueck\"></vvs-icon>\r\n            </a>\r\n        </div>\r\n        <div class=\"col-xs-4 col-sm-8 text-center nopadding-xs\">\r\n            <p>\r\n                <strong ng-if=\"isFirst\">{{\'Erste Fahrt\'|translate}}</strong>\r\n                <strong ng-if=\"isLast\">{{\'Letzte Fahrt\'|translate}}</strong>\r\n                <strong ng-if=\"isMiddle\">{{\'Fahrt\'|translate}} {{tripIndex+1}}</strong>\r\n                <br> {{trip.duration() | VVSTravelledDurationFormatter}}</p>\r\n        </div>\r\n        <div class=\"col-xs-2 col-sm-2 nopadding-xs text-right\">\r\n            <a href=\"javascript:void(0)\" title=\"{{\'Nächste Fahrt\'|translate}}\" ng-click=\"nextTrip()\">\r\n                <vvs-icon name=\"abschicken\"></vvs-icon>\r\n            </a>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-xs-5 col-sm-2 col-sm-offset-8 text-right buy\">\r\n        <vvs-trip-tickets trip=\"trip\"></vvs-trip-tickets>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/details/leg/it/main.html","<div ng-controller=\"VVSTripResultDetailsLegItController\" ng-class=\"{\'vvs-moved-leg\' : leg.properties().legMoved}\" ng-init=\"previousLeg = getPreviousLeg(); nextLeg = getNextLeg();\">\r\n\r\n    <div class=\"{{leg.origin().type()|VVSDMLocationClassMapping}} clearfix\" ng-class=\"{\'tripstart\' : isFirstLeg, \'tripstop\':!isFirstLeg}\">\r\n        <!-- Links von der Linie -->\r\n        <div class=\"leftofline\">\r\n            <div></div>\r\n        </div>\r\n        <!-- Die Linie -->\r\n        <div class=\"centerofline\">\r\n            <a href=\"javascript:void(0)\" ng-click=\"openModal()\">\r\n                <vvs-icon type=\"{{leg.origin().type()}}\"></vvs-icon>\r\n            </a>\r\n        </div>\r\n        <!-- Rechts von der Linie -->\r\n        <div class=\"rightofline\">\r\n            <div>\r\n                <vvs-trip-result-leg-location usage=\"orig\"></vvs-trip-result-leg-location>\r\n            </div>\r\n            <div class=\"partinfo\">\r\n                <vvs-infos mode=\"details\" leg=\"leg\"></vvs-infos>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"trippart novehicle clearfix\">\r\n        <div class=\"leftofline\">\r\n        </div>\r\n        <div class=\"centerofline duration fuss\">\r\n        </div>\r\n        <div class=\"rightofline\">\r\n            <div ng-if=\"isLastLeg || isFirstLeg\">\r\n                <vvs-interchange ng-if=\"SEARCH_OPTIONS.accessibility.showAccessibility\" leg=\"leg\" prev=\"previousLeg\" next=\"nextLeg\" mode=\"\'dest\'\"></vvs-interchange>\r\n            </div>\r\n            <div class=\"fuss\">\r\n                <vvs-icon name=\"fussweg\"></vvs-icon>\r\n                <span ng-if=\"leg.duration()>0\">{{leg.duration() | VVSDurationDetailsFormatter}}</span><span ng-if=\"leg.distance()>0\"><span ng-if=\"leg.duration()>0\">,</span> {{leg.distance() | VVSDistanceFormatter}}</span><vvs-walking-path-description pathdescription=\"leg.pathDescription()\" ng-if=\"leg.pathDescription().length>0\"></vvs-walking-path-description>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n\r\n\r\n    <div class=\"{{leg.destination().type()|VVSDMLocationClassMapping}} clearfix\" ng-class=\"{\'tripend\' : isLastLeg}\" ng-if=\"isLastLeg\">\r\n        <!-- Links von der Linie -->\r\n        <div class=\"leftofline\">\r\n            <div></div>\r\n        </div>\r\n        <!-- Die Linie -->\r\n        <div class=\"centerofline\">\r\n            <a href=\"javascript:void(0)\" ng-click=\"openModal()\">\r\n                <vvs-icon type=\"{{leg.destination().type()}}\"></vvs-icon>\r\n            </a>\r\n        </div>\r\n        <!-- Rechts von der Linie -->\r\n        <div class=\"rightofline\">\r\n            <div>\r\n                <vvs-trip-result-leg-location usage=\"dest\"></vvs-trip-result-leg-location>\r\n            </div>\r\n            <div class=\"partinfo\">\r\n                <vvs-infos mode=\"details\" location=\"leg.destination()\"></vvs-infos>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/details/leg/line/modal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title {{leg.transportation().productIconId()|VVSProductIconIdMapper}}\" id=\"modal-label\">{{leg.transportation().number()}} {{\'Richtung\'|translate}} {{leg.transportation().destination() | VVSLocationNameFormatter}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\" ng-controller=\"VVSModalsLineController\">\r\n        <div class=\"trip-container spacertoplarge modal-stop-container modal-trip-result-details\" ng-init=\"tabIndex=0\">\r\n            <md-tabs md-dynamic-height md-border-bottom class=\"nav nav-tabs\">\r\n                <md-tab ng-click=\"tabIndex=0\">\r\n                    <md-tab-label>\r\n                        <vvs-icon name=\"perlschnur\"></vvs-icon> <span style=\"margin-left: 5px;\">{{\'Perlschnur\' | translate}}</span>\r\n                    </md-tab-label>\r\n                    <md-tab-body>\r\n                        <vvs-perlschnur leg=\"leg\" date=\"leg.departureTime()\"></vvs-perlschnur>\r\n                    </md-tab-body>\r\n                </md-tab>\r\n                <md-tab ng-click=\"tabIndex=1\">\r\n                    <md-label>\r\n                        <vvs-icon name=\"karte\"></vvs-icon> <span style=\"margin-left: 5px;\">{{\'Karte\' | translate}}</span>\r\n                    </md-label>\r\n                    <md-tab-body>\r\n                        <vvs-map mode=\"\'leg\'\" leg=\"leg\" load-on=\"{{tabIndex==1}}\"></vvs-map>\r\n                    </md-tab-body>\r\n                </md-tab>\r\n            </md-tabs>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/details/leg/pt/main.html","<div ng-controller=\"VVSTripResultDetailsLegPtController as VVSTripResultDetailsLegPtCtrl\" ng-class=\"{\'vvs-moved-leg\' : leg.properties().legMoved}\"\r\n    ng-init=\"prevPreviousLeg = getPrevPreviousLeg(); previousLeg = getPreviousLeg(); nextLeg = getNextLeg(); nextNextLeg = getNextNextLeg();\r\n     nextLegisTransfer = trip.legs()[legIndex+1].transportation().productIconId() === 99\">\r\n    <div class=\"clearfix\" ng-class=\"{\'tripstart\' : isFirstLeg, \'tripstop\' : !isFirstLeg}\">\r\n        <div class=\"leftofline leftonline-position\">\r\n            <div style=\"cursor: pointer;\" ng-if=\"((previousLeg.transportation().productClass()==\'99\') && (previousLeg.origin().parent().id()==previousLeg.destination().parent().id()) && !isSpecialCase)\"\r\n            ng-style=\"{padding: setPadding(leg, legIndex)}\">\r\n            <!-- ng-style=\"{padding: setPadding(leg, legIndex), marginTop: setMargin(legIndex)}\"> -->\r\n                <vvs-move-leg trip=\"trip\" transfer-leg-index=\"legIndex-1\"></vvs-move-leg>\r\n            </div>\r\n            <div class=\"etd dep-time\" title=\"{{\'Echtzeit\'|translate}}\">\r\n                <vvs-real-time-icon mode=\"\'leg\'\" leg=\"leg\" usage=\"\'dep\'\"></vvs-real-time-icon> {{\'ab\'|translate}} {{leg.departureTimePlanned() | VVSTimeFormatter}}\r\n            </div>\r\n            <ng-container class=\"cont\">\r\n                <div class=\"etd late\" ng-if=\"leg.departureDelay() > 0\"> {{leg.departureTimeEstimated() | VVSTimeFormatter}} </div>\r\n                <vvs-formations leg=\"{{leg}}\"></vvs-formations>\r\n                <vvs-occ leg=\"leg\"></vvs-occ>\r\n            </ng-container>\r\n        </div>\r\n        <div class=\"centerofline\">\r\n            <a href=\"javascript:void(0)\">\r\n                <vvs-icon type=\"{{leg.origin().type()}}\"></vvs-icon>\r\n            </a>\r\n        </div>\r\n        <div class=\"rightofline\">\r\n            <vvs-trip-result-leg-location usage=\"orig\"></vvs-trip-result-leg-location>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"trippart clearfix\">\r\n        <div class=\"leftofline bottom top\">\r\n            <!-- <div class=\"etd\" title=\"{{\'Echtzeit\'|translate}}\">\r\n                <vvs-real-time-icon mode=\"\'leg\'\" leg=\"leg\" usage=\"\'dep\'\"></vvs-real-time-icon> {{\'ab\'|translate}} {{leg.departureTimePlanned() | VVSTimeFormatter}}\r\n            </div>\r\n            <div class=\"etd late\" ng-if=\"leg.departureDelay() > 0\"> {{leg.departureTimeEstimated() | VVSTimeFormatter}} </div> -->\r\n            <!-- <vvs-trip-composition leg=\"{{leg}}\"></vvs-trip-composition>\r\n            <vvs-occ leg=\"leg\"></vvs-occ> -->\r\n        </div>\r\n        <div class=\"centerofline duration {{leg.transportation()| VVSIconMapper}}\">\r\n        </div>\r\n        <div class=\"rightofline bottom\">\r\n            <div class=\"partinfo\" ng-if=\"leg.origin().type()===\'platform\'\">\r\n                {{leg.origin().disassembledName(true)}}\r\n            </div>\r\n            <div ng-if=\"(previousLeg.transportation().productClass()==\'99\')\">\r\n                <vvs-interchange ng-if=\"SEARCH_OPTIONS.accessibility.showAccessibility\" leg=\"previousLeg\" prev=\"prevPreviousLeg\" next=\"leg\" mode=\"\'transfer\'\"></vvs-interchange>\r\n            </div>\r\n            <!-- first leg -->\r\n            <div ng-if=\"(isFirstLeg) || (previousLeg.transportation().productClass()==\'100\')\">\r\n                <vvs-interchange ng-if=\"SEARCH_OPTIONS.accessibility.showAccessibility\" leg=\"leg\" prev=\"previousLeg\" next=\"nextLeg\" mode=\"\'orig\'\"></vvs-interchange>\r\n            </div>\r\n            <!-- directive with leg attr - origin -->\r\n            <!-- <div class=\"vvs-accessebility-container\" ng-if=\"SEARCH_OPTIONS.accessibility.showAccessibility\">\r\n                <vvs-access-icons data=\"{{leg.origin()}}\"></vvs-access-icons>\r\n            </div> -->\r\n        </div>\r\n    </div>\r\n\r\n    <!-- mot icon  -->\r\n    <div class=\"trippart vehicle clearfix\" ng-init=\"mtsubCode = leg.transportation().properties().mtSubcode\">\r\n        <div class=\"leftofline\">\r\n           <!-- VH Icon -->\r\n        </div>\r\n        <div class=\"centerofline duration {{leg.transportation() | VVSIconMapper}}\">\r\n            <a href=\"javascript:void(0)\" vvs-modal vvs-modal-ignore=\"leg.isAstTransportation()\" vvs-modal-template=\"trip/result/details/leg/line/modal.html\" title=\"{{\'Linienverlauf anzeigen\'|translate}}\">\r\n                <vvs-icon product-icon-id=\"{{leg.transportation().productIconId()}}\" mt-subcode=\"{{leg.transportation().properties().mtSubcode}}\" tr-number=\"{{leg.transportation().number()}}\"></vvs-icon>\r\n            </a>\r\n            </svg>\r\n        </div>\r\n        <div class=\"rightofline\">\r\n            <div class=\"info\">\r\n                <a href=\"javascript:void(0)\" vvs-modal vvs-modal-ignore=\"leg.isAstTransportation()\" vvs-modal-template=\"trip/result/details/leg/line/modal.html\" title=\"{{\'Linienverlauf anzeigen\'|translate}}\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon> {{leg.transportation().number()}} {{leg.transportation().destination() | VVSLocationNameFormatter}}\r\n                </a>\r\n            </div>\r\n            <div class=\"subinfo\" style=\"padding-left: 8px;\" ng-repeat=\"hint in leg.hints()\"><span ng-bind-html=\"hint|VVSHintFormatter\"></span></div>\r\n            <div class=\"subinfo spacertoplarge\" ng-repeat=\"booking in leg.bookings()\" ng-switch=\"booking.file.type()\">\r\n                <vvs-book-taxi leg=\"leg\" ng-switch-when=\"HTTP\"></vvs-book-taxi>\r\n\r\n                <!--<vvs-book-ast trip=\"trip\" ng-if=\"!(\'vvs.personalization.trips\'|isState) && (leg.isAstTransportation())\" ng-switch-when=\"INTERN\"></vvs-book-ast>-->\r\n            </div>\r\n\r\n            <div class=\"subinfo spacertop\">\r\n                <vvs-infos mode=\"details\" leg=\"leg\"></vvs-infos>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"trippart clearfix\" ng-init=\"delay = leg.arrivalDelay() > 0\">\r\n        <!-- <div class=\"leftofline bottom\"> -->\r\n        <div class=\"leftofline bottom leftbottomlastleg\" style=\"position: relative; z-index: 100;\"\r\n            ng-style=\"{top: setTop(leg, legIndex)}\">\r\n            <ng-container ng-if=\"!isLastLeg\">\r\n            <!-- <ng-container ng-if=\"!isLastLeg && !nextLegisTransfer\"> -->\r\n                <div class=\"eta\" title=\"{{\'Echtzeit\'|translate}}\">\r\n                    <vvs-real-time-icon mode=\"\'leg\'\" leg=\"leg\" usage=\"\'arr\'\"></vvs-real-time-icon> {{\'an\'|translate}} {{leg.arrivalTimePlanned() | VVSTimeFormatter}}\r\n                </div>\r\n                <!-- <div class=\"eta late\" ng-if=\"true\"> {{leg.arrivalTimeEstimated() | VVSTimeFormatter}} </div> -->\r\n                <div class=\"eta late\" ng-if=\"leg.arrivalDelay() > 0\"> {{leg.arrivalTimeEstimated() | VVSTimeFormatter}} </div>\r\n            </ng-container>\r\n        </div>\r\n        <div class=\"centerofline duration {{leg.transportation()| VVSIconMapper}}\">\r\n        </div>\r\n        <div class=\"rightofline bottom\">\r\n            <div class=\"partinfo\" ng-if=\"leg.destination().type()===\'platform\'\">\r\n                {{leg.destination().disassembledName(true)}}\r\n            </div>\r\n            <div class=\"partinfo\">\r\n                <!--<vvs-infos mode=\"details\" location=\"leg.destination()\"></vvs-infos>-->\r\n            </div>\r\n            <div ng-if=\"isLastLeg\">\r\n                <vvs-interchange ng-if=\"SEARCH_OPTIONS.accessibility.showAccessibility\" leg=\"leg\" prev=\"previousLeg\" next=\"nextLeg\" mode=\"\'dest\'\"></vvs-interchange>\r\n            </div>\r\n            <!-- <div class=\"vvs-accessebility-container\" ng-if=\"SEARCH_OPTIONS.accessibility.showAccessibility\"> -->\r\n                <!-- als param destination -->\r\n                <!-- <vvs-access-icons data=\"{{leg.destination()}}\"></vvs-access-icons> -->\r\n            <!-- </div> -->\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"tripstop clearfix\" ng-if=\"isLastLeg\">\r\n        <div class=\"leftofline bottom leftbottomlastleg\" ng-class=\"{\'with-delay\': (leg.arrivalDelay() > 0)}\">\r\n            <div class=\"eta\" title=\"{{\'Echtzeit\'|translate}}\">\r\n                <vvs-real-time-icon mode=\"\'leg\'\" leg=\"leg\" usage=\"\'arr\'\"></vvs-real-time-icon> {{\'an\'|translate}} {{leg.arrivalTimePlanned() | VVSTimeFormatter}}\r\n            </div>\r\n            <div class=\"eta late\" ng-if=\"leg.arrivalDelay() > 0\"> {{leg.arrivalTimeEstimated() | VVSTimeFormatter}} </div>\r\n        </div>\r\n        <div class=\"centerofline\">\r\n            <a href=\"javascript:void(0)\" ng-click=\"openModal()\">\r\n                <vvs-icon type=\"{{leg.destination().type()}}\"></vvs-icon>\r\n            </a>\r\n        </div>\r\n        <div class=\"rightofline\">\r\n            <vvs-trip-result-leg-location usage=\"dest\"></vvs-trip-result-leg-location>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n");
$templateCache.put("app/vvs.components/trip/result/details/leg/transfer/main.html","<div ng-controller=\"VVSTripResultDetailsLegTransferController as VVSTripResultDetailsLegTransferCtrl\" ng-switch=\"leg.transportation().productClass()\" ng-init=\"previousLeg = getPreviousLeg(); nextLeg = getNextLeg();\">\r\n    <div class=\"{{leg.origin().type()|VVSDMLocationClassMapping}} tripstop clearfix\" ng-if=\"(leg.origin().parent().id()!==leg.destination().parent().id()) || (leg.transportation().productClass()!==99) || isSpecialCase\">\r\n        <div class=\"leftofline\">\r\n            <div></div>\r\n        </div>\r\n        <div class=\"centerofline\">\r\n            <a href=\"javascript:void(0)\" ng-click=\"openModal()\">\r\n                <vvs-icon type=\"{{leg.origin().type()}}\"></vvs-icon>\r\n            </a>\r\n        </div>\r\n        <div class=\"rightofline\">\r\n            <vvs-trip-result-leg-location usage=\"orig\"></vvs-trip-result-leg-location>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"trippart clearfix\" ng-switch-when=\"99\" ng-if=\"(leg.origin().parent().id() !== leg.destination().parent().id()) || isSpecialCase\">\r\n        <div class=\"leftofline\">\r\n            <vvs-move-leg transfer-leg-index=\"legIndex\"></vvs-move-leg>\r\n        </div>\r\n        <div class=\"centerofline duration fuss\">\r\n\r\n        </div>\r\n        <div class=\"rightofline\">\r\n            <div>\r\n\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n\r\n    <div class=\"trippart clearfix\" ng-switch-when=\"98\">\r\n        <div class=\"leftofline\">\r\n            <vvs-move-leg transfer-leg-index=\"legIndex\"></vvs-move-leg>\r\n        </div>\r\n        <div class=\"centerofline duration stay\">\r\n        </div>\r\n        <div class=\"rightofline\">\r\n            <div class=\"stay\" title=\"{{\'Weiterfahrt\'|translate}}\">\r\n                <vvs-icon name=\"fussweg\"></vvs-icon> {{\'Anschluss wird in der Regel abgewartet\'|translate}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"trippart clearfix\" ng-switch-when=\"97\">\r\n        <div class=\"leftofline\">\r\n            <div></div>\r\n        </div>\r\n        <div class=\"centerofline duration fuss\">\r\n        </div>\r\n        <div class=\"rightofline\">\r\n            <div class=\"stay\" title=\"{{\'Weiterfahrt\'|translate}}\">\r\n                <vvs-icon name=\"sitzenbleiben\"></vvs-icon> {{\'Weiterfahrt im selben Fahrzeug möglich\'|translate}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/details/leg/it/pathdescription/main.html","<span ng-show=\"showDesc\">, <span ng-if=\"upVal\"><vvs-icon name=\"steigung\"></vvs-icon> {{upVal}} m </span><span ng-if=\"downVal\"><vvs-icon name=\"senkung\"></vvs-icon> {{downVal}} m</span></span>\r\n");
$templateCache.put("app/vvs.components/trip/result/details/leg/location/address/main.html","<a href=\"javascript:void(0)\" vvs-modal vvs-modal-template=\"trip/result/details/leg/location/address/modal.html\" title=\"{{\'Umgebungskarte dieser Adresse anzeigen\'|translate}}\">\r\n    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n    <span>{{location | VVSLocationNameFormatter}}</span> <vvs-recommended-stop is-first-leg=\"isFirstLeg\" trip=\"trip\" is-last-leg=\"isLastLeg\" origin=\"inputLocations[\'orig\']\" destination=\"inputLocations[\'dest\']\" leg=\"leg\" usage=\"usage\"></vvs-recommended-stop>\r\n</a>\r\n");
$templateCache.put("app/vvs.components/trip/result/details/leg/location/address/modal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title {{location.type()|VVSDMLocationClassMapping}}\" id=\"modal-label\"> {{location | VVSLocationNameFormatter}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\">\r\n        <vvs-map mode=\"\'trip\'\" trip=\"trip\" leg=\"leg\" location=\"location\" load-on=\"{{true}}\"></vvs-map>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/details/leg/location/stop/main.html","<a href=\"javascript:void(0)\" vvs-modal vvs-modal-ignore=\"location.id()<=99999\" vvs-modal-template=\"trip/result/details/leg/location/stop/modal.html\" title=\"{{\'Fahrtoptionen von dieser Haltestelle anzeigen\'|translate}}\">\r\n    <vvs-icon name=\"abschicken\"></vvs-icon>\r\n    <span>{{location | VVSLocationNameFormatter}}</span> <vvs-recommended-stop trip=\"trip\" is-first-leg=\"isFirstLeg\" is-last-leg=\"isLastLeg\" origin=\"inputLocations[\'orig\']\" destination=\"inputLocations[\'dest\']\" leg=\"leg\" usage=\"usage\"></vvs-recommended-stop>\r\n\r\n    <span ng-if=\"(location.properties().pointType==\'Gleis\')||(location.properties().pointType==\'Bstg\')\">{{location.disassembledName()}}</span>\r\n    <!--<span ng-if=\"(inputLocations.orig.id()!==trip.origin().id())&&(legIndex==0)\"> #)</span>-->\r\n</a>\r\n\r\n");
$templateCache.put("app/vvs.components/trip/result/details/leg/location/stop/modal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title stop\" id=\"modal-label\">{{location | VVSLocationNameFormatter}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\" ng-controller=\"VVSModalsStopController\">\r\n        <div class=\"modal-body nopadding-xs ctblock\">\r\n            <div class=\"linklist\">\r\n                <a href=\"javascript:void(0)\" ng-click=\"triggerSTTClick(leg.transportation().id(), location.id())\" ng-if=\"leg.transportation().properties().isSTT\" title=\"{{\'als PDF generieren\'|translate}}\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon> {{\'Aushangfahrplan\'|translate}}\r\n                </a>\r\n                <a href=\"javascript:void(0)\" ng-click=\"triggerROPClick(location.id())\" title=\"{{\'als PDF generieren\'|translate}}\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon> {{\'Stadtplanausschnitt\'|translate}}\r\n                </a>\r\n                <div ng-repeat=\"file in location.downloads()\" ng-switch on=\"file.type()\">\r\n                    <a ng-switch-when=\"SM\" href=\"javascript:void(0)\" ng-click=\"triggerDownloadSMClick(file)\" title=\"{{\'als PDF generieren\'|translate}}\">\r\n                        <vvs-icon name=\"abschicken\"></vvs-icon> {{\'Haltestellenkarte\'|translate}}\r\n                    </a>\r\n                    <a ng-switch-when=\"SM_ME\" href=\"javascript:void(0)\" ng-click=\"triggerDownloadSMMEClick(file)\" title=\"{{\'als PDF generieren\'|translate}}\">\r\n                        <vvs-icon name=\"abschicken\"></vvs-icon> {{\'Haltestellenkarte f. Mobilitätseingeschränkte\'|translate}}\r\n                    </a>\r\n                </div>\r\n                <a href=\"javascript:void(0)\" ng-click=\"openStopInformation(location)\" title=\"{{\'Haltestelleninformationen\'|translate}}\">\r\n                    <vvs-icon name=\"abschicken\"></vvs-icon> {{\'Haltestelleninformationen\'|translate}}\r\n                </a>\r\n            </div>\r\n            <div class=\"trip-container modal-stop-container modal-trip-result-details\" ng-init=\"tabIndex=0\">\r\n                <md-tabs md-dynamic-height md-border-bottom class=\"nav nav-tabs\">\r\n                    <md-tab ng-click=\"tabIndex=0\">\r\n                        <md-tab-label>\r\n                            <vvs-icon name=\"liste\"></vvs-icon><span style=\"margin-left: 5px;\">{{\'Abfahrten\'|translate}}</span>\r\n                        </md-tab-label>\r\n                        <md-tab-body>\r\n                            <table class=\"table trip\" ng-init=\"getDepartures(location)\">\r\n                                <thead>\r\n                                    <tr>\r\n                                        <th>{{\'Uhrzeit\'|translate}}</th>\r\n                                        <th>{{\'heute\'|translate}}</th>\r\n                                        <th>{{\'Linie\'|translate}}</th>\r\n                                        <th>{{\'in Richtung\'|translate}}</th>\r\n                                    </tr>\r\n                                </thead>\r\n                                <tbody>\r\n                                    <tr ng-repeat=\"dep in departures\">\r\n                                        <td>{{dep.dateTimePlanned() | VVSTimeFormatter}}\r\n                                            <vvs-real-time-icon mode=\"\'depArr\'\" dep-arr=\"dep\"></vvs-real-time-icon>\r\n                                        </td>\r\n                                        <td><span class=\"late\" ng-if=\"dep.isDelayed()\">{{dep.dateTime()|VVSTimeFormatter}}</span></td>\r\n                                        <td>{{dep.transportation().number()}}</td>\r\n                                        <td>{{dep.transportation().destination() | VVSLocationNameFormatter}}</td>\r\n                                    </tr>\r\n                                </tbody>\r\n                            </table>\r\n                            <div class=\"modal-block\">\r\n                                <p>{{\'Haltestellennummer\'|translate}}: {{location.id()}}</p>\r\n                            </div>\r\n                        </md-tab-body>\r\n                    </md-tab>\r\n                    <md-tab ng-click=\"tabIndex=1\">\r\n                        <md-label>\r\n                            <vvs-icon name=\"karte\"></vvs-icon><span style=\"margin-left: 5px;\">{{\'Karte\'|translate}}</span>\r\n                        </md-label>\r\n                        <md-tab-body>\r\n                            <vvs-map mode=\"\'trip\'\" trip=\"trip\" leg=\"leg\" location=\"location\" load-on=\"{{tabIndex===1}}\"></vvs-map>\r\n                        </md-tab-body>\r\n                    </md-tab>\r\n                </md-tabs>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/details/leg/transfer/moveleg/main.html","<div>\r\n    <a href=\"javascript:void(0)\" title=\"{{\'Umsteigezeit anpassen\'|translate}}\" vvs-modal vvs-modal-template=\"trip/result/details/leg/transfer/moveleg/modal.html\" vvs-modal-size=\"sm\">\r\n        <!-- <vvs-icon name=\"aendern\"></vvs-icon> <span ng-class=\"{\'vvs-moved-leg\' : trip.legs()[transferLegIndex].properties().legMoved}\">{{trip.legs()[transferLegIndex+1].departureTimeEstimated().diff(trip.legs()[transferLegIndex-1].arrivalTimeEstimated(), \'seconds\') | VVSDurationDetailsFormatter}}</span> -->\r\n        <vvs-icon name=\"aendern\"></vvs-icon>\r\n        <span ng-class=\"{\'vvs-moved-leg\' : trip.legs()[transferLegIndex].properties().legMoved}\">{{trip.legs()[transferLegIndex].duration() | VVSDurationDetailsFormatter}}</span>\r\n    </a>\r\n</div>\r\n");
$templateCache.put("app/vvs.components/trip/result/details/leg/transfer/moveleg/modal.html","<div>\r\n    <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" ng-click=\"dismissModal()\" title=\"{{\'Schließen\'|translate}}\"><span aria-hidden=\"true\">&times;</span></button>\r\n        <h4 class=\"modal-title\" id=\"modal-label\">{{\'Zeit für den Umstieg anpassen\'|translate}}</h4>\r\n    </div>\r\n    <div class=\"modal-body nopadding-xs ctblock\" ng-controller=\"VVSMoveLegModalController\">\r\n\r\n        <div ng-if=\"transferLeg.origin().parent().id()!==transferLeg.destination().parent().id()\">\r\n            <h2>{{\'Zwischen den Haltestellen\'|translate}}</h2>\r\n            <div class=\"modal-block infoarea spacerbottomlarge\">\r\n                <p>\r\n                    <vvs-icon name=\"haltestelle\"></vvs-icon>\r\n                    {{transferLeg.origin()|VVSLocationNameFormatter}}\r\n                </p>\r\n                <p>\r\n                    <vvs-icon name=\"haltestelle\"></vvs-icon>\r\n                    {{transferLeg.destination()|VVSLocationNameFormatter}}\r\n                </p>\r\n            </div>\r\n        </div>\r\n\r\n        <div ng-if=\"transferLeg.origin().parent().id()==transferLeg.destination().parent().id()\">\r\n            <h2>{{\'An der Haltestelle\'|translate}}</h2>\r\n            <div class=\"modal-block infoarea spacerbottomlarge\">\r\n                <p>\r\n                    <vvs-icon name=\"haltestelle\"></vvs-icon>\r\n                    {{transferLeg.destination()|VVSLocationNameFormatter}}\r\n                </p>\r\n            </div>\r\n        </div>\r\n\r\n\r\n\r\n        <h2>{{\'Umsteigezeit verlängern durch\' | translate}}</h2>\r\n        <div class=\"modal-block spacerbottomlarge\">\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"früheren Reisebeginn\" role=\"group\">\r\n                <div class=\"btn-group \" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"moveLeg(true); dismissModal();\">{{\'Früheren Reisebeginn\'|translate}}</button>\r\n                </div>\r\n            </div>\r\n            <br>\r\n            <div class=\"btn-group btn-group-justified highlight\" aria-label=\"späteres Ankommen am Ziel\" role=\"group\">\r\n                <div class=\"btn-group\" role=\"group\">\r\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"moveLeg(false); dismissModal();\">{{\'Späteres Ankommen am Ziel\'|translate}}</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <div ng-if=\"trip.previousJourney\">\r\n            <h2>{{\'Ursprüngliche Fahrt\'|translate}}</h2>\r\n            <div class=\"modal-block spacerbottomlarge\">\r\n                <div class=\"btn-group btn-group-justified highlight\" role=\"group\">\r\n                    <div class=\"btn-group \" role=\"group\">\r\n                        <button class=\"btn btn-default\" type=\"button\" ng-click=\"revertMoveLeg(); dismissModal();\">{{\'Wiederherstellen\'|translate}}</button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n");}]);